/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1456);
	module.exports = __webpack_require__(851);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(85);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1156)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(1152)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(859)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1253);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1252);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(229);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(229);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(643);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(644);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(246);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(106);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(17);
	
	var _actions = __webpack_require__(183);
	
	var _Root = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// let URL = 'http://35.164.227.24:4000/api';
	var URL = 'https://beta.iesdev.com/api';
	// let URL = 'http://localhost:4000/api';
	var instance = _axios2.default.create({ baseURL: URL });
	var unauthedInstance = _axios2.default.create({ baseURL: URL });
	
	if (true) {
	  URL = 'https://beta.iesdev.com/api';
	}
	
	instance.interceptors.request.use(function (config) {
	  console.log('\n(' + config.method.toUpperCase() + ') ' + config.url + ' ' + (config.params ? JSON.stringify(config.params) : JSON.stringify(config.data)));
	  return config;
	}, function (error) {
	  console.log(error);
	  return Promise.reject(error);
	});
	
	instance.interceptors.response.use(function (response) {
	  // Do something with response data
	  return response;
	}, function (error) {
	  // Do something with response error
	  if (error.response.status === 403 || error.response.status === 401) {
	    _Root.store.dispatch((0, _actions.logout)());
	    _reactRouter.browserHistory.push('/login');
	  }
	  console.log("Sigh");
	  return Promise.reject(error);
	});
	
	var BlitzAPI = function () {
	  function BlitzAPI() {
	    _classCallCheck(this, BlitzAPI);
	  }
	
	  _createClass(BlitzAPI, [{
	    key: 'setToken',
	    value: function setToken(token) {
	      console.log('Set token');
	      instance.defaults.headers.common['Authorization'] = 'Token ' + token;
	    }
	  }, {
	    key: 'post',
	    value: function post(params) {
	      return instance.post('/example', params);
	    }
	  }, {
	    key: 'put',
	    value: function put(params) {
	      return instance.put('/example', params);
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(userId) {
	      return instance.get('/users/' + userId);
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers(params) {
	      return instance.get('/users', { params: params });
	    }
	  }, {
	    key: 'postUser',
	    value: function postUser(params) {
	      return instance.post('/users', params);
	    }
	  }, {
	    key: 'patchUser',
	    value: function patchUser(params) {
	      return instance.patch('/users', params);
	    }
	  }, {
	    key: 'patchAnyUser',
	    value: function patchAnyUser(userId, params) {
	      return instance.patch('/users/' + userId, params);
	    }
	  }, {
	    key: 'postLogin',
	    value: function postLogin(params) {
	      return unauthedInstance.post('/users/login', params);
	    }
	  }, {
	    key: 'getEntry',
	    value: function getEntry(entryId) {
	      return instance.get('/entries/' + entryId);
	    }
	  }, {
	    key: 'deleteEntry',
	    value: function deleteEntry(entryId) {
	      return instance.delete('/entries/' + entryId);
	    }
	  }, {
	    key: 'parseEntryFromUrl',
	    value: function parseEntryFromUrl(params) {
	      return instance.get('/entries/preview', { params: params });
	    }
	  }, {
	    key: 'getEntries',
	    value: function getEntries() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return instance.get('/entries/', { params: params });
	    }
	  }, {
	    key: 'postEntry',
	    value: function postEntry(params) {
	      return instance.post('/entries/', params);
	    }
	  }, {
	    key: 'patchEntry',
	    value: function patchEntry(entryId, params) {
	      return instance.patch('/entries/' + entryId, params);
	    }
	  }, {
	    key: 'postEntryImage',
	    value: function postEntryImage(params) {
	      return instance.post('/entries/image/', params);
	    }
	  }, {
	    key: 'getSources',
	    value: function getSources() {
	      return instance.get('/sources/');
	    }
	  }, {
	    key: 'getSource',
	    value: function getSource(sourceId) {
	      return instance.get('/sources/' + sourceId);
	    }
	  }, {
	    key: 'postSource',
	    value: function postSource(params) {
	      return instance.post('/sources/', params);
	    }
	  }, {
	    key: 'patchSource',
	    value: function patchSource(sourceId, params) {
	      return instance.patch('/sources/' + sourceId, params);
	    }
	  }, {
	    key: 'deleteSource',
	    value: function deleteSource(sourceId) {
	      return instance.delete('/sources/' + sourceId);
	    }
	  }, {
	    key: 'sendPushNotification',
	    value: function sendPushNotification(params) {
	      return instance.post('/notifications/', params);
	    }
	  }, {
	    key: 'getChatRooms',
	    value: function getChatRooms() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return instance.get('/chatchannels', { params: params });
	    }
	  }, {
	    key: 'getChatRoom',
	    value: function getChatRoom(chatRoomId) {
	      return instance.get('/chatchannels/' + chatRoomId);
	    }
	
	    // Tags
	
	  }, {
	    key: 'getTags',
	    value: function getTags(params) {
	      return instance.get('/tags', { params: params });
	    }
	  }, {
	    key: 'getTag',
	    value: function getTag(tagId) {
	      return instance.get('/tags/' + tagId);
	    }
	  }, {
	    key: 'postTag',
	    value: function postTag(params) {
	      return instance.post('/tags', params);
	    }
	  }, {
	    key: 'patchTag',
	    value: function patchTag(tagId, params) {
	      return instance.patch('/tags/' + tagId, params);
	    }
	  }, {
	    key: 'deleteTag',
	    value: function deleteTag(tagId) {
	      return instance.delete('/tags/' + tagId);
	    }
	  }, {
	    key: 'postEntryTag',
	    value: function postEntryTag(params) {
	      return instance.post('/entrytags', params);
	    }
	  }, {
	    key: 'deleteEntryTag',
	    value: function deleteEntryTag(params) {
	      return instance.delete('/entrytags', { params: params });
	    }
	
	    // Beta Users
	
	  }, {
	    key: 'postCheckActivated',
	    value: function postCheckActivated(params) {
	      return instance.post('/beta/activate', params);
	    }
	  }, {
	    key: 'postAddBetaUser',
	    value: function postAddBetaUser(params) {
	      return instance.post('/beta/add', params);
	    }
	  }, {
	    key: 'getTotalBetaUsers',
	    value: function getTotalBetaUsers() {
	      return instance.get('/beta/total');
	    }
	  }, {
	    key: 'getStatsOverview',
	    value: function getStatsOverview() {
	      return instance.get('/tracking/app/overall');
	    }
	  }, {
	    key: 'getStatsFilterable',
	    value: function getStatsFilterable(params) {
	      return instance.get('/tracking/app/filterable_stats', { params: params });
	    }
	  }, {
	    key: 'getStatsUsers',
	    value: function getStatsUsers(params) {
	      return instance.get('/tracking/app/users/', { params: params });
	    }
	
	    // Chatrooms
	
	  }, {
	    key: 'postChatRoom',
	    value: function postChatRoom(params) {
	      return instance.post('/chatchannels', params);
	    }
	  }, {
	    key: 'reparseChatRoom',
	    value: function reparseChatRoom(chatRoomId) {
	      return instance.post('/chatchannels/' + chatRoomId + '/reparse');
	    }
	  }, {
	    key: 'patchChatRoom',
	    value: function patchChatRoom(channelId) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return instance.patch('/chatchannels/' + channelId, params);
	    }
	  }, {
	    key: 'deleteChatRoom',
	    value: function deleteChatRoom(channelId) {
	      return instance.delete('/chatchannels/' + channelId);
	    }
	  }, {
	    key: 'getTwitterEmbed',
	    value: function getTwitterEmbed(params) {
	      return instance.get('/tweet_embed', { params: params });
	    }
	  }, {
	    key: 'getToast',
	    value: function getToast(params) {
	      return instance.get('/beta/toast', { params: params });
	    }
	  }, {
	    key: 'getSurvey',
	    value: function getSurvey(params) {
	      return instance.get('/beta/survey', { params: params });
	    }
	  }, {
	    key: 'postToast',
	    value: function postToast(params) {
	      return instance.post('/beta/toast', params);
	    }
	  }, {
	    key: 'postSurvey',
	    value: function postSurvey(params) {
	      return instance.post('/beta/survey', params);
	    }
	  }]);
	
	  return BlitzAPI;
	}();
	
	exports.default = new BlitzAPI();

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(1188);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(1189);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(1190);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(1191);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(624);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(118);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(625);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(1192);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(1193);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(626);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(1195);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(1196);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(1198);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(1197);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(224);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(157);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(1199);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(158);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(1201);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(1202);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(1205);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(225);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(628);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(1206);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(1207);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(1208);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(1211);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(1212);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(1213);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(629);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(226);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(1220);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(1221);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(630);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(631);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(632);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(633);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(634);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(1224);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(636);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(1223);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(635);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(637);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(1228);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(1229);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(1230);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(1231);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(1232);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(639);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(1233);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(640);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(1234);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(1235);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(1236);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(1237);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(1238);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(53);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(1239);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(1241);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(227);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(228);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(1242);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(641);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(1243);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(1244);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(1245);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(1246);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(1250);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(135);
	module.exports.easing = __webpack_require__(890);
	module.exports.canvas = __webpack_require__(889);
	module.exports.options = __webpack_require__(891);


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(73);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(272);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(102);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1441);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(711);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1437);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1452);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1438);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1439);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(713);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1440);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(273);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1450);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(718);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1443);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1444);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1448);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(715);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splice = __webpack_require__(1557);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(1554);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(1556);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(1552);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(1553);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	var _keys = __webpack_require__(1555);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys2.default,
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 19 */
15,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1345);


/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(166);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlockTree = __webpack_require__(429);
	var ContentState = __webpack_require__(188);
	var EditorBidiService = __webpack_require__(953);
	var Immutable = __webpack_require__(16);
	var SelectionState = __webpack_require__(86);
	
	var OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Stack = Immutable.Stack;
	
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent,
	        decorator = config.decorator;
	
	    var recordConfig = _extends({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	
	    return new EditorState(map);
	  };
	
	  EditorState.prototype.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  EditorState.prototype.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  EditorState.prototype.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  EditorState.prototype.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  EditorState.prototype.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  EditorState.prototype.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  EditorState.prototype.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  EditorState.prototype.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  EditorState.prototype.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  };
	
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	
	
	  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	  };
	
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	
	
	  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  EditorState.prototype.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  };
	
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  };
	
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	    return updateSelection(editorState, selection, true);
	  };
	
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  };
	
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  };
	
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var forceSelection = changeType !== 'insert-characters';
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	    // Don't discard inline style overrides for the following change types:
	    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];
	
	    if (overrideChangeTypes.indexOf(changeType) === -1) {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	
	    return EditorState.set(editorState, editorStateChanges);
	  };
	
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  };
	
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  };
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  EditorState.prototype.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
	  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
	  var prevBlockMap = contentState.getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
	  }).map(function (block) {
	    return BlockTree.generate(content, block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
	    return k === fromKey;
	  }).skip(1).skipUntil(function (block, _) {
	    return block.getLength();
	  }).first();
	
	  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	
	module.exports = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers.merge(this[scope] || (this[scope] = {}), values);
		}
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 26 */
[1642, 61],
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1414);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(702);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1415);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONST_VAR = {
	  SORT_DESC: 'desc',
	  SORT_ASC: 'asc',
	  AWAIT_BEFORE_CELL_EDIT: 1,
	  SIZE_PER_PAGE: 10,
	  NEXT_PAGE: '>',
	  NEXT_PAGE_TITLE: 'next page',
	  LAST_PAGE: '>>',
	  LAST_PAGE_TITLE: 'last page',
	  PRE_PAGE: '<',
	  PRE_PAGE_TITLE: 'previous page',
	  FIRST_PAGE: '<<',
	  FIRST_PAGE_TITLE: 'first page',
	  PAGE_START_INDEX: 1,
	  ROW_SELECT_BG_COLOR: '',
	  ROW_SELECT_NONE: 'none',
	  ROW_SELECT_SINGLE: 'radio',
	  ROW_SELECT_MULTI: 'checkbox',
	  CELL_EDIT_NONE: 'none',
	  CELL_EDIT_CLICK: 'click',
	  CELL_EDIT_DBCLICK: 'dbclick',
	  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
	  PAGINATION_SIZE: 5,
	  PAGINATION_POS_TOP: 'top',
	  PAGINATION_POS_BOTTOM: 'bottom',
	  PAGINATION_POS_BOTH: 'both',
	  TOOLBAR_POS_TOP: 'top',
	  TOOLBAR_POS_BOTTOM: 'bottom',
	  TOOLBAR_POS_BOTH: 'both',
	  NO_DATA_TEXT: 'There is no data to display',
	  SHOW_ONLY_SELECT: 'Show Selected Only',
	  SHOW_ALL: 'Show All',
	  EXPORT_CSV_TEXT: 'Export to CSV',
	  INSERT_BTN_TEXT: 'New',
	  DELETE_BTN_TEXT: 'Delete',
	  SAVE_BTN_TEXT: 'Save',
	  CLOSE_BTN_TEXT: 'Close',
	  FILTER_DELAY: 500,
	  SCROLL_TOP: 'Top',
	  SCROLL_BOTTOM: 'Bottom',
	  FILTER_TYPE: {
	    TEXT: 'TextFilter',
	    REGEX: 'RegexFilter',
	    SELECT: 'SelectFilter',
	    NUMBER: 'NumberFilter',
	    DATE: 'DateFilter',
	    CUSTOM: 'CustomFilter',
	    ARRAY: 'ArrayFilter'
	  },
	  FILTER_COND_EQ: 'eq',
	  FILTER_COND_LIKE: 'like',
	  EXPAND_BY_ROW: 'row',
	  EXPAND_BY_COL: 'column',
	  REMOTE_SORT: 'sort',
	  REMOTE_PAGE: 'pagination',
	  REMOTE_CELL_EDIT: 'cellEdit',
	  REMOTE_INSERT_ROW: 'insertRow',
	  REMOTE_DROP_ROW: 'dropRow',
	  REMOTE_FILTER: 'filter',
	  REMOTE_SEARCH: 'search',
	  REMOTE_EXPORT_CSV: 'exportCSV',
	  INSERT_FAIL_INDICATOR: 'Validation errors, please check!',
	  DEFAULT_CSV_SEPARATOR: ',',
	  CSV_STRING_TYPE: 'string',
	  CSV_NUMBER_TYPE: 'number',
	  AUTO_COLLAPSE_WHEN_SORT: false,
	  AUTO_COLLAPSE_WHEN_SEARCH: false,
	  AUTO_COLLAPSE_WHEN_FILTER: false
	};
	
	CONST_VAR.REMOTE = {};
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_SORT] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_PAGE] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_CELL_EDIT] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_INSERT_ROW] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_DROP_ROW] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_FILTER] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_SEARCH] = false;
	CONST_VAR.REMOTE[CONST_VAR.REMOTE_EXPORT_CSV] = false;
	
	var _default = CONST_VAR;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CONST_VAR, 'CONST_VAR', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');
	}();
	
	;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var DOMProperty = __webpack_require__(100);
	var ReactDOMComponentFlags = __webpack_require__(673);
	
	var invariant = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 30 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.formPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.propTypes = exports.SubmissionError = exports.FormSection = exports.Form = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = undefined;
	
	var _defaultShouldAsyncValidate = __webpack_require__(738);
	
	Object.defineProperty(exports, 'defaultShouldAsyncValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldAsyncValidate).default;
	  }
	});
	
	var _defaultShouldValidate = __webpack_require__(739);
	
	Object.defineProperty(exports, 'defaultShouldValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldValidate).default;
	  }
	});
	
	var _Form = __webpack_require__(1500);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormSection = __webpack_require__(1501);
	
	Object.defineProperty(exports, 'FormSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSection).default;
	  }
	});
	
	var _SubmissionError = __webpack_require__(735);
	
	Object.defineProperty(exports, 'SubmissionError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SubmissionError).default;
	  }
	});
	
	var _propTypes = __webpack_require__(1536);
	
	Object.defineProperty(exports, 'propTypes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_propTypes).default;
	  }
	});
	Object.defineProperty(exports, 'fieldInputPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldInputPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldMetaPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldMetaPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldPropTypes;
	  }
	});
	Object.defineProperty(exports, 'formPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.formPropTypes;
	  }
	});
	
	var _Field = __webpack_require__(1497);
	
	Object.defineProperty(exports, 'Field', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Field).default;
	  }
	});
	
	var _Fields = __webpack_require__(1499);
	
	Object.defineProperty(exports, 'Fields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fields).default;
	  }
	});
	
	var _FieldArray = __webpack_require__(1498);
	
	Object.defineProperty(exports, 'FieldArray', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FieldArray).default;
	  }
	});
	
	var _formValueSelector = __webpack_require__(1515);
	
	Object.defineProperty(exports, 'formValueSelector', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValueSelector).default;
	  }
	});
	
	var _formValues = __webpack_require__(1516);
	
	Object.defineProperty(exports, 'formValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValues).default;
	  }
	});
	
	var _getFormNames = __webpack_require__(1521);
	
	Object.defineProperty(exports, 'getFormNames', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormNames).default;
	  }
	});
	
	var _getFormValues = __webpack_require__(1525);
	
	Object.defineProperty(exports, 'getFormValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormValues).default;
	  }
	});
	
	var _getFormInitialValues = __webpack_require__(1519);
	
	Object.defineProperty(exports, 'getFormInitialValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormInitialValues).default;
	  }
	});
	
	var _getFormSyncErrors = __webpack_require__(1523);
	
	Object.defineProperty(exports, 'getFormSyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncErrors).default;
	  }
	});
	
	var _getFormMeta = __webpack_require__(1520);
	
	Object.defineProperty(exports, 'getFormMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormMeta).default;
	  }
	});
	
	var _getFormAsyncErrors = __webpack_require__(1518);
	
	Object.defineProperty(exports, 'getFormAsyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormAsyncErrors).default;
	  }
	});
	
	var _getFormSyncWarnings = __webpack_require__(1524);
	
	Object.defineProperty(exports, 'getFormSyncWarnings', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncWarnings).default;
	  }
	});
	
	var _getFormSubmitErrors = __webpack_require__(1522);
	
	Object.defineProperty(exports, 'getFormSubmitErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSubmitErrors).default;
	  }
	});
	
	var _isDirty = __webpack_require__(1530);
	
	Object.defineProperty(exports, 'isDirty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isDirty).default;
	  }
	});
	
	var _isInvalid = __webpack_require__(1531);
	
	Object.defineProperty(exports, 'isInvalid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isInvalid).default;
	  }
	});
	
	var _isPristine = __webpack_require__(1532);
	
	Object.defineProperty(exports, 'isPristine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isPristine).default;
	  }
	});
	
	var _isValid = __webpack_require__(1535);
	
	Object.defineProperty(exports, 'isValid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isValid).default;
	  }
	});
	
	var _isSubmitting = __webpack_require__(1534);
	
	Object.defineProperty(exports, 'isSubmitting', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isSubmitting).default;
	  }
	});
	
	var _hasSubmitSucceeded = __webpack_require__(1529);
	
	Object.defineProperty(exports, 'hasSubmitSucceeded', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitSucceeded).default;
	  }
	});
	
	var _hasSubmitFailed = __webpack_require__(1528);
	
	Object.defineProperty(exports, 'hasSubmitFailed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitFailed).default;
	  }
	});
	
	var _reduxForm = __webpack_require__(1538);
	
	Object.defineProperty(exports, 'reduxForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reduxForm).default;
	  }
	});
	
	var _reducer = __webpack_require__(1537);
	
	Object.defineProperty(exports, 'reducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	
	var _values = __webpack_require__(1560);
	
	Object.defineProperty(exports, 'values', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_values).default;
	  }
	});
	
	var _actions = __webpack_require__(736);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actionTypes2 = __webpack_require__(279);
	
	var _actionTypes = _interopRequireWildcard(_actionTypes2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = _actionTypes;
	var arrayInsert = exports.arrayInsert = _actions2.default.arrayInsert;
	var arrayMove = exports.arrayMove = _actions2.default.arrayMove;
	var arrayPop = exports.arrayPop = _actions2.default.arrayPop;
	var arrayPush = exports.arrayPush = _actions2.default.arrayPush;
	var arrayRemove = exports.arrayRemove = _actions2.default.arrayRemove;
	var arrayRemoveAll = exports.arrayRemoveAll = _actions2.default.arrayRemoveAll;
	var arrayShift = exports.arrayShift = _actions2.default.arrayShift;
	var arraySplice = exports.arraySplice = _actions2.default.arraySplice;
	var arraySwap = exports.arraySwap = _actions2.default.arraySwap;
	var arrayUnshift = exports.arrayUnshift = _actions2.default.arrayUnshift;
	var autofill = exports.autofill = _actions2.default.autofill;
	var blur = exports.blur = _actions2.default.blur;
	var change = exports.change = _actions2.default.change;
	var clearSubmitErrors = exports.clearSubmitErrors = _actions2.default.clearSubmitErrors;
	var destroy = exports.destroy = _actions2.default.destroy;
	var focus = exports.focus = _actions2.default.focus;
	var initialize = exports.initialize = _actions2.default.initialize;
	var registerField = exports.registerField = _actions2.default.registerField;
	var reset = exports.reset = _actions2.default.reset;
	var setSubmitFailed = exports.setSubmitFailed = _actions2.default.setSubmitFailed;
	var setSubmitSucceeded = exports.setSubmitSucceeded = _actions2.default.setSubmitSucceeded;
	var startAsyncValidation = exports.startAsyncValidation = _actions2.default.startAsyncValidation;
	var startSubmit = exports.startSubmit = _actions2.default.startSubmit;
	var stopAsyncValidation = exports.stopAsyncValidation = _actions2.default.stopAsyncValidation;
	var stopSubmit = exports.stopSubmit = _actions2.default.stopSubmit;
	var submit = exports.submit = _actions2.default.submit;
	var touch = exports.touch = _actions2.default.touch;
	var unregisterField = exports.unregisterField = _actions2.default.unregisterField;
	var untouch = exports.untouch = _actions2.default.untouch;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.handleFormErrors = handleFormErrors;
	exports.formatTopImage = formatTopImage;
	exports.slugify = slugify;
	exports.normalizeQuotes = normalizeQuotes;
	exports.generateEntrySlug = generateEntrySlug;
	
	var _reduxForm = __webpack_require__(31);
	
	var _stopword = __webpack_require__(761);
	
	var _stopword2 = _interopRequireDefault(_stopword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleFormErrors(error) {
	  if (error.response) {
	    throw new _reduxForm.SubmissionError(error.response.data.errors);
	  } else {
	    console.log(error);
	  }
	}
	
	function formatTopImage(value) {
	  if (!value) {
	    return '';
	  }
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	    return value.original.url;
	  }
	  return value;
	}
	
	function slugify(text) {
	  if (!text) {
	    return '';
	  }
	  var stripped = _stopword2.default.removeStopwords(text.split(' ')).join(' ');
	  return stripped.toString().substring(0, 60).toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
	  .replace(/[^\w-]+/g, '') // Remove all non-word chars
	  .replace(/--+/g, '-') // Replace multiple - with single -
	  .replace(/^-+/, '') // Trim - from start of text
	  .replace(/-+$/, ''); // Trim - from end of text
	}
	
	function normalizeQuotes(val) {
	  var s = val.replace(/\u201c/g, '"');
	  s = s.replace(/\u201d/g, '"');
	  return s;
	}
	
	function generateEntrySlug(entry, isAmp) {
	  var full = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!entry.is_blitz) return entry.url;
	  return entry.type === 'article' ? (full ? 'https://blitzesports.com' : '') + '/' + entry.esport + (isAmp ? '/amp' : '') + '/article/' + entry.id + '/' + slugify(entry.title) : (full ? 'https://blitzesports.com' : '') + '/' + entry.esport + (isAmp ? '/amp' : '') + '/video/' + entry.id + '/' + slugify(entry.title);
	}

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(37);
	var ContentStateInlineStyle = __webpack_require__(938);
	var DraftFeatureFlags = __webpack_require__(67);
	var Immutable = __webpack_require__(16);
	
	var applyEntityToContentState = __webpack_require__(957);
	var getCharacterRemovalRange = __webpack_require__(978);
	var getContentStateFragment = __webpack_require__(141);
	var insertFragmentIntoContentState = __webpack_require__(983);
	var insertTextIntoContentState = __webpack_require__(984);
	var invariant = __webpack_require__(19);
	var modifyBlockForContentState = __webpack_require__(995);
	var removeEntitiesAtEdges = __webpack_require__(450);
	var removeRangeFromContentState = __webpack_require__(997);
	var splitBlockInContentState = __webpack_require__(999);
	
	var OrderedSet = Immutable.OrderedSet;
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    var startKey = void 0,
	        endKey = void 0,
	        startBlock = void 0,
	        endBlock = void 0;
	    if (rangeToRemove.getIsBackward()) {
	      rangeToRemove = rangeToRemove.merge({
	        anchorKey: rangeToRemove.getFocusKey(),
	        anchorOffset: rangeToRemove.getFocusOffset(),
	        focusKey: rangeToRemove.getAnchorKey(),
	        focusOffset: rangeToRemove.getAnchorOffset(),
	        isBackward: false
	      });
	    }
	    startKey = rangeToRemove.getAnchorKey();
	    endKey = rangeToRemove.getFocusKey();
	    startBlock = contentState.getBlockForKey(startKey);
	    endBlock = contentState.getBlockForKey(endKey);
	    var startOffset = rangeToRemove.getStartOffset();
	    var endOffset = rangeToRemove.getEndOffset();
	
	    var startEntityKey = startBlock.getEntityAt(startOffset);
	    var endEntityKey = endBlock.getEntityAt(endOffset - 1);
	
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (startKey === endKey) {
	      if (startEntityKey && startEntityKey === endEntityKey) {
	        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
	      }
	    }
	    var adjustedRemovalRange = rangeToRemove;
	    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
	      // Adjust the selection to properly delete segemented and immutable
	      // entities
	      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
	    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ type: blockType, depth: 0 });
	    });
	  },
	
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: blockData });
	    });
	  },
	
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: block.getData().merge(blockData) });
	    });
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(16),
	    Map = _require.Map,
	    OrderedSet = _require.OrderedSet,
	    Record = _require.Record;
	
	// Immutable.map is typed such that the value for every key in the map
	// must be the same type
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = function (_CharacterMetadataRec) {
	  _inherits(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
	  }
	
	  CharacterMetadata.prototype.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  CharacterMetadata.prototype.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
	    return this.getStyle().includes(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  };
	
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    var defaultConfig = {
	      style: EMPTY_SET,
	      entity: null
	    };
	
	    // Fill in unspecified properties, if necessary.
	    var configMap = Map(defaultConfig).merge(config);
	
	    var existing = pool.get(configMap);
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(285);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlockNode
	 * @format
	 * 
	 *
	 * This file is a fork of ContentBlock adding support for nesting references by
	 * providing links to children, parent, prevSibling, and nextSibling.
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(37);
	var Immutable = __webpack_require__(16);
	
	var findRangesImmutable = __webpack_require__(110);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  parent: null,
	  characterList: List(),
	  data: Map(),
	  depth: 0,
	  key: '',
	  text: '',
	  type: 'unstyled',
	  children: List(),
	  prevSibling: null,
	  nextSibling: null
	};
	
	var haveEqualStyle = function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	};
	
	var haveEqualEntity = function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	};
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlockNode = function (_Record) {
	  _inherits(ContentBlockNode, _Record);
	
	  function ContentBlockNode() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;
	
	    _classCallCheck(this, ContentBlockNode);
	
	    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
	  }
	
	  ContentBlockNode.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlockNode.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlockNode.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlockNode.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlockNode.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlockNode.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
	    return this.get('children');
	  };
	
	  ContentBlockNode.prototype.getParentKey = function getParentKey() {
	    return this.get('parent');
	  };
	
	  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
	    return this.get('prevSibling');
	  };
	
	  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
	    return this.get('nextSibling');
	  };
	
	  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlockNode;
	}(Record(defaultRecord));
	
	module.exports = ContentBlockNode;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 * @format
	 * 
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(936);
	var BlockMapBuilder = __webpack_require__(109);
	var CharacterMetadata = __webpack_require__(37);
	var CompositeDraftDecorator = __webpack_require__(937);
	var ContentBlock = __webpack_require__(75);
	var ContentState = __webpack_require__(188);
	var DefaultDraftBlockRenderMap = __webpack_require__(189);
	var DefaultDraftInlineStyle = __webpack_require__(430);
	var DraftEditor = __webpack_require__(939);
	var DraftEditorBlock = __webpack_require__(431);
	var DraftEntity = __webpack_require__(139);
	var DraftModifier = __webpack_require__(35);
	var DraftEntityInstance = __webpack_require__(432);
	var EditorState = __webpack_require__(23);
	var KeyBindingUtil = __webpack_require__(190);
	var RichTextEditorUtil = __webpack_require__(435);
	var SelectionState = __webpack_require__(86);
	
	var convertFromDraftStateToRaw = __webpack_require__(958);
	var convertFromHTMLToContentBlocks = __webpack_require__(436);
	var convertFromRawToDraftState = __webpack_require__(959);
	var generateRandomKey = __webpack_require__(58);
	var getDefaultKeyBinding = __webpack_require__(437);
	var getVisibleSelectionRect = __webpack_require__(982);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CONVERT_HTML_OPTIONS = exports.EDITOR_IMAGE_OPTIONS = exports.CHAT_TYPE_OPTIONS = exports.SOURCE_TYPE_OPTIONS = exports.ESPORT_TABLE_TYPE_OPTIONS = exports.SOURCE_TABLE_TYPE_OPTIONS = exports.ENTRY_TABLE_TYPE_OPTIONS = exports.ENTRY_TYPE_OPTIONS = exports.BLITZ_ENTRY_TYPE_OPTIONS = exports.SPOILER_OPTIONS = exports.ESPORT_TYPE_OPTIONS = exports.GAME_OPTIONS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _urijs = __webpack_require__(765);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is for the push notes ONLY (All sends to all)
	var GAME_OPTIONS = exports.GAME_OPTIONS = [['all', 'All'], ['lol', 'League of Legends'], ['csgo', 'CS:GO'], ['ow', 'Overwatch'], ['pubg', 'PUBG']];
	
	// This is for generic usage.
	var ESPORT_TYPE_OPTIONS = exports.ESPORT_TYPE_OPTIONS = [['', 'None'], ['lol', 'League of Legends'], ['csgo', 'CS:GO'], ['ow', 'Overwatch'], ['pubg', 'PUBG']];
	
	var SPOILER_OPTIONS = exports.SPOILER_OPTIONS = [['all', 'All'], [true, 'On'], [false, 'Off']];
	
	var BLITZ_ENTRY_TYPE_OPTIONS = exports.BLITZ_ENTRY_TYPE_OPTIONS = [['article', 'Article'], ['youtube', 'Video'], ['guide', 'Guide']];
	
	var ENTRY_TYPE_OPTIONS = exports.ENTRY_TYPE_OPTIONS = [['article', 'Article'], ['youtube', 'Youtube'], ['feed', 'BlitzFeed']];
	
	var ENTRY_TABLE_TYPE_OPTIONS = exports.ENTRY_TABLE_TYPE_OPTIONS = ['article', 'youtube', 'feed'];
	
	var SOURCE_TABLE_TYPE_OPTIONS = exports.SOURCE_TABLE_TYPE_OPTIONS = ['', 'rss'];
	
	var ESPORT_TABLE_TYPE_OPTIONS = exports.ESPORT_TABLE_TYPE_OPTIONS = ['', 'lol', 'csgo', 'ow', 'pubg'];
	
	var SOURCE_TYPE_OPTIONS = exports.SOURCE_TYPE_OPTIONS = [['', 'None'], ['rss', 'RSS Feed']];
	
	var CHAT_TYPE_OPTIONS = exports.CHAT_TYPE_OPTIONS = [['', 'None'], ['raffle', 'Raffle'], ['entry', 'Entry'], ['match', 'Match']];
	
	var EDITOR_IMAGE_OPTIONS = exports.EDITOR_IMAGE_OPTIONS = [{ value: 'regular', label: 'Regular' }, { value: 'full-width', label: 'Full Width' }, { value: 'left', label: 'Float Left' }, { value: 'right', label: 'Float Right' }];
	
	var CONVERT_HTML_OPTIONS = exports.CONVERT_HTML_OPTIONS = {
	  blockToHTML: function blockToHTML(block) {
	    if (block.type === 'atomic') {
	      return _react2.default.createElement('div', { style: { clear: 'both' } });
	    } else if (block.type === 'unstyled' && block.text === '') {
	      return {
	        start: '',
	        end: ''
	      };
	    } else if (block.type === 'code-block') {
	      return block.text;
	      // return <div dangerouslySetInnerHTML={{ __html: block.text }} />
	    }
	    // return <p style={{ clear: 'both' }} />;
	  },
	  entityToHTML: function entityToHTML(entity, originalText) {
	    if (entity.type === 'LINK') {
	      // https://github.com/HubSpot/draft-convert/issues/47
	      return _react2.default.createElement('a', { href: entity.data.url, target: '_blank', rel: 'noopener noreferrer' });
	    } else if (entity.type === 'image') {
	      var extraClasses = entity.data.extraClasses || '';
	      var _entity$data = entity.data,
	          src = _entity$data.src,
	          caption = _entity$data.caption,
	          style = _entity$data.style,
	          alt = _entity$data.alt,
	          size = _entity$data.size,
	          width = _entity$data.width;
	
	
	      var figureClass = void 0;
	      switch (style) {
	        case 'full-width':
	          figureClass = 'figure-full';
	          break;
	        case 'left':
	          figureClass = 'figure-left';
	          break;
	        case 'right':
	          figureClass = 'figure-right';
	          break;
	        default:
	          figureClass = '';
	      }
	
	      var cleanedWidth = void 0;
	
	      if (width <= 0) {
	        cleanedWidth = 0;
	      } else if (width && width < 50) {
	        cleanedWidth = 50;
	      } else {
	        cleanedWidth = width;
	      }
	
	      return _react2.default.createElement(
	        'figure',
	        { className: figureClass + ' ' + extraClasses, style: cleanedWidth ? { width: cleanedWidth + 'px' } : {} },
	        _react2.default.createElement('img', { src: src, alt: alt, 'data-img-width': size && size.width, 'data-img-height': size && size.height }),
	        caption && _react2.default.createElement(
	          'figcaption',
	          null,
	          caption
	        )
	      );
	    } else if (entity.type === 'youtube') {
	      var _src = entity.data.src;
	
	      var urlData = (0, _urijs2.default)(_src);
	      var v = void 0;
	      if (urlData.domain() === 'youtu.be') {
	        v = urlData.path().slice(1, -1);
	      } else if (urlData.domain() === 'youtube.com' && urlData.hasQuery('v')) {
	        v = urlData.query(true).v;
	      }
	      return _react2.default.createElement(
	        'figure',
	        { className: 'figure-video' },
	        _react2.default.createElement('iframe', {
	          type: 'text/html',
	          src: 'https://www.youtube.com/embed/' + v,
	          frameBorder: '0',
	          allowFullScreen: true
	        })
	      );
	    } else if (entity.type === 'tweet') {
	      var tweet = entity.data.tweet;
	      // const tweetId = urlList[urlList.length - 1];
	
	      return tweet.html;
	    }
	    return originalText;
	  }
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var color = __webpack_require__(301);
	var helpers = __webpack_require__(14);
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = color(origin);
					if (c0.valid) {
						c1 = color(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers.extend(Element.prototype, {
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers.clone(me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers.inherits;
	
	module.exports = Element;


/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  renderReactSortCaret: function renderReactSortCaret(order, isBootstrap4) {
	    var orderClass = void 0;
	    if (isBootstrap4) {
	      orderClass = (0, _classnames2.default)('fa', {
	        'fa-sort-asc': order === _Const2.default.SORT_ASC,
	        'fa-sort-desc': order === _Const2.default.SORT_DESC
	      });
	      return _react2.default.createElement('span', { className: orderClass, style: { margin: '10px 5px' } });
	    } else {
	      orderClass = (0, _classnames2.default)('order', {
	        'dropup': order === _Const2.default.SORT_ASC
	      });
	      return _react2.default.createElement(
	        'span',
	        { className: orderClass },
	        _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 5px' } })
	      );
	    }
	  },
	  isFunction: function isFunction(obj) {
	    return obj && typeof obj === 'function';
	  },
	  getScrollBarWidth: function getScrollBarWidth() {
	    var inner = document.createElement('p');
	    inner.style.width = '100%';
	    inner.style.height = '200px';
	
	    var outer = document.createElement('div');
	    outer.style.position = 'absolute';
	    outer.style.top = '0px';
	    outer.style.left = '0px';
	    outer.style.visibility = 'hidden';
	    outer.style.width = '200px';
	    outer.style.height = '150px';
	    outer.style.overflow = 'hidden';
	    outer.appendChild(inner);
	
	    document.body.appendChild(outer);
	    var w1 = inner.getBoundingClientRect().width;
	    outer.style.overflow = 'scroll';
	    var w2 = inner.getBoundingClientRect().width;
	
	    if (w1 === w2) w2 = outer.clientWidth;
	
	    document.body.removeChild(outer);
	
	    return w1 - w2;
	  },
	  canUseDOM: function canUseDOM() {
	    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
	  },
	
	
	  // We calculate an offset here in order to properly fetch the indexed data,
	  // despite the page start index not always being 1
	  getNormalizedPage: function getNormalizedPage(pageStartIndex, page) {
	    pageStartIndex = this.getFirstPage(pageStartIndex);
	    if (page === undefined) page = pageStartIndex;
	    var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
	    return page + offset;
	  },
	  getFirstPage: function getFirstPage(pageStartIndex) {
	    return pageStartIndex !== undefined ? pageStartIndex : _Const2.default.PAGE_START_INDEX;
	  },
	  isBootstrap4: function isBootstrap4(version) {
	    return version === '4';
	  },
	  isSelectRowDefined: function isSelectRowDefined(mode) {
	    return mode === _Const2.default.ROW_SELECT_SINGLE || mode === _Const2.default.ROW_SELECT_MULTI;
	  },
	  renderColGroup: function renderColGroup(columns, selectRow) {
	    var expandColumnOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var version = arguments[3];
	
	    var selectRowHeader = null;
	    var expandRowHeader = null;
	    var isBootstrap4 = this.isBootstrap4(version);
	    var isSelectRowDefined = this.isSelectRowDefined(selectRow.mode);
	    var columnWidth = isBootstrap4 ? '38px' : '30px';
	    if (isSelectRowDefined) {
	      var style = {
	        width: selectRow.columnWidth || columnWidth,
	        minWidth: selectRow.columnWidth || columnWidth
	      };
	      if (!selectRow.hideSelectColumn) {
	        selectRowHeader = _react2.default.createElement('col', { key: 'select-col', style: style });
	      }
	    }
	    if (expandColumnOptions.expandColumnVisible) {
	      var _style = {
	        width: expandColumnOptions.columnWidth || columnWidth,
	        minWidth: expandColumnOptions.columnWidth || columnWidth
	      };
	      expandRowHeader = _react2.default.createElement('col', { key: 'expand-col', style: _style });
	    }
	    var theader = columns.map(function (column, i) {
	      var style = {
	        display: column.hidden ? 'none' : null
	      };
	      if (column.width) {
	        var width = !isNaN(column.width) ? column.width + 'px' : column.width;
	        style.width = width;
	        /** add min-wdth to fix user assign column width
	        not eq offsetWidth in large column table **/
	        style.minWidth = width;
	      }
	      return _react2.default.createElement('col', { style: style, key: i });
	    });
	
	    return _react2.default.createElement(
	      'colgroup',
	      null,
	      expandColumnOptions.expandColumnVisible && expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
	      selectRowHeader,
	      expandColumnOptions.expandColumnVisible && !expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
	      theader
	    );
	  }
	}; /* eslint react/display-name: 0 */
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/util.js');
	}();
	
	;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var CallbackQueue = __webpack_require__(671);
	var PooledClass = __webpack_require__(83);
	var ReactFeatureFlags = __webpack_require__(679);
	var ReactReconciler = __webpack_require__(84);
	var Transaction = __webpack_require__(170);
	
	var invariant = __webpack_require__(15);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(1005);
	var VersionRange = __webpack_require__(1006);
	
	var mapObject = __webpack_require__(1019);
	var memoizeStringOnly = __webpack_require__(1020);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ },
/* 52 */
[1640, 477],
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 54 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(239)('wks');
	var uid = __webpack_require__(160);
	var Symbol = __webpack_require__(71).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LinkContainer = exports.IndexLinkContainer = undefined;
	
	var _IndexLinkContainer2 = __webpack_require__(1434);
	
	var _IndexLinkContainer3 = _interopRequireDefault(_IndexLinkContainer2);
	
	var _LinkContainer2 = __webpack_require__(707);
	
	var _LinkContainer3 = _interopRequireDefault(_LinkContainer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IndexLinkContainer = _IndexLinkContainer3.default;
	exports.LinkContainer = _LinkContainer3.default;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(903);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = void 0;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var PooledClass = __webpack_require__(83);
	
	var emptyFunction = __webpack_require__(61);
	var warning = __webpack_require__(26);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasicFormInput = function (_Component) {
	  _inherits(BasicFormInput, _Component);
	
	  function BasicFormInput() {
	    _classCallCheck(this, BasicFormInput);
	
	    return _possibleConstructorReturn(this, (BasicFormInput.__proto__ || Object.getPrototypeOf(BasicFormInput)).apply(this, arguments));
	  }
	
	  _createClass(BasicFormInput, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          placeholder = _props.placeholder,
	          label = _props.label,
	          input = _props.input,
	          controlId = _props.controlId,
	          type = _props.type,
	          meta = _props.meta,
	          readOnly = _props.readOnly;
	
	      return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        {
	          controlId: controlId || '',
	          style: { marginBottom: '10px' },
	          validationState: meta.error && meta.touched && 'error' || null
	        },
	        _react2.default.createElement(
	          _reactBootstrap.ControlLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl, Object.assign({
	          readOnly: readOnly,
	          type: type,
	          value: input.value,
	          onChange: input.onChange,
	          placeholder: placeholder || ''
	        }, input)),
	        meta.error && meta.touched && _react2.default.createElement(
	          _reactBootstrap.HelpBlock,
	          null,
	          meta.error
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null)
	      );
	    }
	  }]);
	
	  return BasicFormInput;
	}(_react.Component);
	
	exports.default = BasicFormInput;
	
	
	BasicFormInput.propTypes = {
	  label: _propTypes2.default.string,
	  controlId: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  input: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  type: _propTypes2.default.string
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userIsLoggedIn = userIsLoggedIn;
	exports.isLoggedIn = isLoggedIn;
	exports.getSourceOptions = getSourceOptions;
	exports.getUserOptions = getUserOptions;
	exports.slugify = slugify;
	exports.generateEntrySlug = generateEntrySlug;
	
	var _stopword = __webpack_require__(761);
	
	var _stopword2 = _interopRequireDefault(_stopword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function userIsLoggedIn(s) {
	  return function (nextState, replace) {
	    if (s.getState().user.profile.token === null) {
	      replace('/login?next=' + nextState.pathname);
	    }
	  };
	}
	
	function isLoggedIn(state) {
	  return state.user.profile.token !== null;
	}
	
	function getSourceOptions(response) {
	  var empty = [['', 'Null']];
	  return empty.concat(response.data.data.map(function (source) {
	    return [source.id, source.name];
	  }));
	}
	
	function getUserOptions(response) {
	  var empty = [['', 'Null']];
	  return empty.concat(response.data.data.map(function (user) {
	    return [user.id, user.name];
	  }));
	}
	
	function slugify(text) {
	  var stripped = _stopword2.default.removeStopwords(text.split(' ')).join(' ');
	  return stripped.toString().substring(0, 60).toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
	  .replace(/[^\w-]+/g, '') // Remove all non-word chars
	  .replace(/--+/g, '-') // Replace multiple - with single -
	  .replace(/^-+/, '') // Trim - from start of text
	  .replace(/-+$/, ''); // Trim - from end of text
	}
	
	function generateEntrySlug(entry, isAmp) {
	  var full = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!entry.is_blitz) return entry.url;
	  return entry.type === 'article' ? (full ? 'https://blitzesports.com' : '') + '/' + entry.esport + (isAmp ? '/amp' : '') + '/article/' + entry.id + '/' + slugify(entry.title) : (full ? 'https://blitzesports.com' : '') + '/' + entry.esport + (isAmp ? '/amp' : '') + '/video/' + entry.id + '/' + slugify(entry.title);
	}

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {};
	module.exports.Arc = __webpack_require__(885);
	module.exports.Line = __webpack_require__(886);
	module.exports.Point = __webpack_require__(887);
	module.exports.Rectangle = __webpack_require__(888);


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(949);
	
	module.exports = DraftFeatureFlags;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizePerPageDropDown = exports.ButtonGroup = exports.SearchField = exports.ClearSearchButton = exports.ExportCSVButton = exports.ShowSelectedOnlyButton = exports.DeleteButton = exports.InsertButton = exports.InsertModalFooter = exports.InsertModalBody = exports.InsertModalHeader = exports.TableHeaderColumn = exports.BootstrapTable = undefined;
	
	var _BootstrapTable = __webpack_require__(1163);
	
	var _BootstrapTable2 = _interopRequireDefault(_BootstrapTable);
	
	var _TableHeaderColumn = __webpack_require__(613);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	var _InsertModalHeader = __webpack_require__(621);
	
	var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);
	
	var _InsertModalBody = __webpack_require__(619);
	
	var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);
	
	var _InsertModalFooter = __webpack_require__(620);
	
	var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);
	
	var _InsertButton = __webpack_require__(618);
	
	var _InsertButton2 = _interopRequireDefault(_InsertButton);
	
	var _DeleteButton = __webpack_require__(616);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _ExportCSVButton = __webpack_require__(617);
	
	var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);
	
	var _ShowSelectedOnlyButton = __webpack_require__(623);
	
	var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);
	
	var _ClearSearchButton = __webpack_require__(615);
	
	var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);
	
	var _SearchField = __webpack_require__(622);
	
	var _SearchField2 = _interopRequireDefault(_SearchField);
	
	var _ButtonGroup = __webpack_require__(1185);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _SizePerPageDropDown = __webpack_require__(614);
	
	var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof window !== 'undefined') {
	  window.BootstrapTable = _BootstrapTable2.default;
	  window.TableHeaderColumn = _TableHeaderColumn2.default;
	  window.InsertModalHeader = _InsertModalHeader2.default;
	  window.InsertModalBody = _InsertModalBody2.default;
	  window.InsertModalFooter = _InsertModalFooter2.default;
	  window.InsertButton = _InsertButton2.default;
	  window.DeleteButton = _DeleteButton2.default;
	  window.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
	  window.ExportCSVButton = _ExportCSVButton2.default;
	  window.ClearSearchButton = _ClearSearchButton2.default;
	  window.SearchField = _SearchField2.default;
	  window.ButtonGroup = _ButtonGroup2.default;
	  window.SizePerPageDropDown = _SizePerPageDropDown2.default;
	}
	exports.BootstrapTable = _BootstrapTable2.default;
	exports.TableHeaderColumn = _TableHeaderColumn2.default;
	exports.InsertModalHeader = _InsertModalHeader2.default;
	exports.InsertModalBody = _InsertModalBody2.default;
	exports.InsertModalFooter = _InsertModalFooter2.default;
	exports.InsertButton = _InsertButton2.default;
	exports.DeleteButton = _DeleteButton2.default;
	exports.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
	exports.ExportCSVButton = _ExportCSVButton2.default;
	exports.ClearSearchButton = _ClearSearchButton2.default;
	exports.SearchField = _SearchField2.default;
	exports.ButtonGroup = _ButtonGroup2.default;
	exports.SizePerPageDropDown = _SizePerPageDropDown2.default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();
	
	;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(71);
	var core = __webpack_require__(54);
	var ctx = __webpack_require__(231);
	var hide = __webpack_require__(94);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 71 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 74 */
49,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(37);
	var Immutable = __webpack_require__(16);
	
	var findRangesImmutable = __webpack_require__(110);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlock = function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock(config) {
	    _classCallCheck(this, ContentBlock);
	
	    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
	  }
	
	  ContentBlock.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlock.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlock.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlock.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlock.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlock.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlock.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	
	
	  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	
	
	  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(19);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1059),
	    getValue = __webpack_require__(1095);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(219),
	    isLength = __webpack_require__(220);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 80 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(92);
	var IE8_DOM_DEFINE = __webpack_require__(646);
	var toPrimitive = __webpack_require__(242);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(93) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(647);
	var defined = __webpack_require__(232);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 83 */
[1644, 21, 15],
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1365);
	var ReactInstrumentation = __webpack_require__(43);
	
	var warning = __webpack_require__(26);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	var ReactBaseClasses = __webpack_require__(728);
	var ReactChildren = __webpack_require__(1483);
	var ReactDOMFactories = __webpack_require__(1484);
	var ReactElement = __webpack_require__(104);
	var ReactPropTypes = __webpack_require__(1485);
	var ReactVersion = __webpack_require__(1486);
	
	var createReactClass = __webpack_require__(1487);
	var onlyChild = __webpack_require__(1491);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(16);
	
	var Record = Immutable.Record;
	
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
	  }
	
	  SelectionState.prototype.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  SelectionState.prototype.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  SelectionState.prototype.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  SelectionState.prototype.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  };
	
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	
	
	  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionEnd && selectionStart <= end;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  SelectionState.prototype.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  SelectionState.prototype.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  SelectionState.prototype.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  SelectionState.prototype.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  SelectionState.prototype.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ },
/* 87 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(68);
	
	var _Actions = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 89 */
[1637, 113, 1092, 1121],
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1261), __esModule: true };

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(95);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(119)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(81);
	var createDesc = __webpack_require__(123);
	module.exports = __webpack_require__(93) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 96 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	module.exports = exports["default"];

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM2.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1323);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(251);
	var setInnerHTML = __webpack_require__(172);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(259);
	var setTextContent = __webpack_require__(694);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(20);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.props.disableOnClickOutside) return;
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	var ReactCurrentOwner = __webpack_require__(62);
	
	var warning = __webpack_require__(177);
	var canDefineProperty = __webpack_require__(732);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(730);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 105 */
15,
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(769);

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSelect = function (_Component) {
	  _inherits(FormSelect, _Component);
	
	  function FormSelect() {
	    _classCallCheck(this, FormSelect);
	
	    return _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).apply(this, arguments));
	  }
	
	  _createClass(FormSelect, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          input = _props.input,
	          controlId = _props.controlId,
	          options = _props.options,
	          meta = _props.meta;
	
	      return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        { controlId: controlId || '', style: { marginBottom: '10px' } },
	        _react2.default.createElement(
	          _reactBootstrap.ControlLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.FormControl,
	          Object.assign({
	            componentClass: 'select',
	            onChange: input.onChange
	          }, input),
	          options && options.length && options.map(function (option, index) {
	            return _react2.default.createElement(
	              'option',
	              { value: option[0], key: index },
	              option[1]
	            );
	          })
	        ),
	        meta.error && _react2.default.createElement(
	          _reactBootstrap.HelpBlock,
	          null,
	          meta.error
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null)
	      );
	    }
	  }]);
	
	  return FormSelect;
	}(_react.Component);
	
	exports.default = FormSelect;
	
	
	FormSelect.propTypes = {
	  label: _propTypes2.default.string,
	  controlId: _propTypes2.default.string,
	  input: _propTypes2.default.object,
	  options: _propTypes2.default.array,
	  meta: _propTypes2.default.any
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	module.exports = {
		/**
		 * Namespace to hold generators for different types of ticks
		 * @namespace Chart.Ticks.generators
		 */
		generators: {
			/**
			 * Interface for the options provided to the numeric tick generator
			 * @interface INumericTickGenerationOptions
			 */
			/**
			 * The maximum number of ticks to display
			 * @name INumericTickGenerationOptions#maxTicks
			 * @type Number
			 */
			/**
			 * The distance between each tick.
			 * @name INumericTickGenerationOptions#stepSize
			 * @type Number
			 * @optional
			 */
			/**
			 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
			 * @name INumericTickGenerationOptions#min
			 * @type Number
			 * @optional
			 */
			/**
			 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
			 * @name INumericTickGenerationOptions#max
			 * @type Number
			 * @optional
			 */
	
			/**
			 * Generate a set of linear ticks
			 * @method Chart.Ticks.generators.linear
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			linear: function(generationOptions, dataRange) {
				var ticks = [];
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				if (generationOptions.stepSize && generationOptions.stepSize > 0) {
					spacing = generationOptions.stepSize;
				} else {
					var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
					spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
				}
				var niceMin = Math.floor(dataRange.min / spacing) * spacing;
				var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
				// If min, max and stepSize is set and they make an evenly spaced scale use it.
				if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
					// If very close to our whole number, use it.
					if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
						niceMin = generationOptions.min;
						niceMax = generationOptions.max;
					}
				}
	
				var numSpaces = (niceMax - niceMin) / spacing;
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
				return ticks;
			},
	
			/**
			 * Generate a set of logarithmic ticks
			 * @method Chart.Ticks.generators.logarithmic
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			logarithmic: function(generationOptions, dataRange) {
				var ticks = [];
				var valueOrDefault = helpers.valueOrDefault;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
				var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
				var endExp = Math.floor(helpers.log10(dataRange.max));
				var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
				var exp, significand;
	
				if (tickVal === 0) {
					exp = Math.floor(helpers.log10(dataRange.minNotZero));
					significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
					ticks.push(tickVal);
					tickVal = significand * Math.pow(10, exp);
				} else {
					exp = Math.floor(helpers.log10(tickVal));
					significand = Math.floor(tickVal / Math.pow(10, exp));
				}
	
				do {
					ticks.push(tickVal);
	
					++significand;
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
				var lastTick = valueOrDefault(generationOptions.max, tickVal);
				ticks.push(lastTick);
	
				return ticks;
			}
		},
	
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {String|Array} the label to display
			 */
			values: function(value) {
				return helpers.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {Number} the value to be formatted
			 * @param index {Number} the position of the tickValue parameter in the ticks array
			 * @param ticks {Array<Number>} the list of ticks being converted
			 * @return {String} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(16);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    if (!areEqualFn(value, nextValue)) {
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventHandled
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Utility method for determining whether or not the value returned
	 * from a handler indicates that it was handled.
	 */
	function isEventHandled(value) {
	  return value === 'handled' || value === true;
	}
	
	module.exports = isEventHandled;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ },
/* 113 */
[1636, 52],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(90);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 116 */
[1641, 89, 478, 79],
/* 117 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(91);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(651);
	var enumBugKeys = __webpack_require__(233);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 122 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(96);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var EventPluginRegistry = __webpack_require__(252);
	var EventPluginUtils = __webpack_require__(253);
	var ReactErrorUtils = __webpack_require__(257);
	
	var accumulateInto = __webpack_require__(688);
	var forEachAccumulated = __webpack_require__(689);
	var invariant = __webpack_require__(15);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(125);
	var EventPluginUtils = __webpack_require__(253);
	
	var accumulateInto = __webpack_require__(688);
	var forEachAccumulated = __webpack_require__(689);
	var warning = __webpack_require__(26);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(60);
	
	var getEventTarget = __webpack_require__(262);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(2);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 130 */
21,
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + '.' + name : name;
	};
	exports.default = formatName;

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
	var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(752);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1570);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1569);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1568);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(751);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(753);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1027);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpinLoader = function (_Component) {
	  _inherits(SpinLoader, _Component);
	
	  function SpinLoader() {
	    _classCallCheck(this, SpinLoader);
	
	    return _possibleConstructorReturn(this, (SpinLoader.__proto__ || Object.getPrototypeOf(SpinLoader)).apply(this, arguments));
	  }
	
	  _createClass(SpinLoader, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sk-fading-circle', style: style },
	        _react2.default.createElement('div', { className: 'sk-circle1 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle2 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle3 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle4 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle5 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle6 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle7 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle8 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle9 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle10 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle11 sk-circle' }),
	        _react2.default.createElement('div', { className: 'sk-circle12 sk-circle' })
	      );
	    }
	  }]);
	
	  return SpinLoader;
	}(_react.Component);
	
	SpinLoader.propTypes = {
	  style: _propTypes2.default.object
	};
	SpinLoader.defaultProps = {
	  style: {}
	};
	
	exports.default = SpinLoader;

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {Number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @function
		 */
		isArray: Array.isArray ? Array.isArray : function(value) {
			return Object.prototype.toString.call(value) === '[object Array]';
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {Number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {Function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {Object|Array} loopable - The object or array to be iterated.
		 * @param {Function} fn - The function to call for each item.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see http://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {Boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @param {Object} [options] - Merging options:
		 * @param {Function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {Object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @returns {Object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {Object} target - The target object in which all objects are merged into.
		 * @param {Object} arg1 - Object containing additional properties to merge in target.
		 * @param {Object} argN - Additional objects containing properties to merge in target.
		 * @returns {Object} The `target` object.
		 */
		extend: function(target) {
			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments[i], setFn);
			}
			return target;
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};
	
	module.exports = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ },
/* 136 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (r1, r2) {
	  if (r1.offset === r2.offset) {
	    return r2.length - r1.length;
	  }
	  return r1.offset - r2.offset;
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = splitReactElement;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(173);
	
	var _server2 = _interopRequireDefault(_server);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://w3c.github.io/html/syntax.html#writing-html-documents-elements
	var VOID_TAGS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
	
	function splitReactElement(element) {
	  if (VOID_TAGS.indexOf(element.type) !== -1) {
	    return _server2.default.renderToStaticMarkup(element);
	  }
	
	  var tags = _server2.default.renderToStaticMarkup(_react2.default.cloneElement(element, {}, '\r')).split('\r');
	
	  (0, _invariant2.default)(tags.length > 1, 'convertToHTML: Element of type ' + element.type + ' must render children');
	
	  (0, _invariant2.default)(tags.length < 3, 'convertToHTML: Element of type ' + element.type + ' cannot use carriage return character');
	
	  return {
	    start: tags[0],
	    end: tags[1]
	  };
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var detectNewline = __webpack_require__(931);
	
	var DEFAULT = '\n';
	
	/**
	 * Detect the dominant newline character of a string
	 * @param {String} text
	 * @return {String}
	 */
	function getNewLine(text) {
	  return detectNewline(text) || DEFAULT;
	}
	
	module.exports = getNewLine;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @format
	 * 
	 */
	
	var DraftEntityInstance = __webpack_require__(432);
	var Immutable = __webpack_require__(16);
	
	var invariant = __webpack_require__(19);
	
	var Map = Immutable.Map;
	
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * Temporary utility for generating the warnings
	 */
	function logWarning(oldMethodCall, newMethodCall) {
	  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
	}
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getLastCreatedEntityKey' instead.
	   * ---
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
	    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
	    return DraftEntity.__getLastCreatedEntityKey();
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.createEntity' instead.
	   * ---
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    logWarning('DraftEntity.create', 'contentState.createEntity');
	    return DraftEntity.__create(type, mutability, data);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.addEntity' instead.
	   * ---
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    logWarning('DraftEntity.add', 'contentState.addEntity');
	    return DraftEntity.__add(instance);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getEntity' instead.
	   * ---
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    logWarning('DraftEntity.get', 'contentState.getEntity');
	    return DraftEntity.__get(key);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.mergeEntityData' instead.
	   * ---
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
	    return DraftEntity.__mergeData(key, toMerge);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.replaceEntityData' instead.
	   * ---
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
	    return DraftEntity.__replaceData(key, newData);
	  },
	
	  // ***********************************WARNING******************************
	  // --- the above public API will be deprecated in the next version of Draft!
	  // The methods below this line are private - don't call them directly.
	
	  /**
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
	    return '' + instanceKey;
	  },
	
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  __create: function __create(type, mutability, data) {
	    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  __add: function __add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  __get: function __get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  __mergeData: function __mergeData(key, toMerge) {
	    var instance = DraftEntity.__get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  __replaceData: function __replaceData(key, newData) {
	    var instance = DraftEntity.__get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ },
/* 140 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
	        blockKey = _offsetKey$split[0],
	        decoratorKey = _offsetKey$split[1],
	        leafKey = _offsetKey$split[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @format
	 * 
	 */
	
	'use strict';
	
	var randomizeBlockMapKeys = __webpack_require__(449);
	var removeEntitiesAtEdges = __webpack_require__(450);
	
	var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block;
	  }));
	};
	
	module.exports = getContentStateFragment;

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1106),
	    listCacheDelete = __webpack_require__(1107),
	    listCacheGet = __webpack_require__(1108),
	    listCacheHas = __webpack_require__(1109),
	    listCacheSet = __webpack_require__(1110);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(115);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(475);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1056),
	    isObjectLike = __webpack_require__(79);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1064),
	    baseMatchesProperty = __webpack_require__(1065),
	    identity = __webpack_require__(153),
	    isArray = __webpack_require__(47),
	    property = __webpack_require__(1143);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(153),
	    overRest = __webpack_require__(1122),
	    setToString = __webpack_require__(1125);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1104);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1055),
	    isObjectLike = __webpack_require__(79);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(466),
	    baseKeys = __webpack_require__(1061),
	    isArrayLike = __webpack_require__(78);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(145),
	    copyArray = __webpack_require__(474),
	    isArray = __webpack_require__(47),
	    isSymbol = __webpack_require__(90),
	    stringToPath = __webpack_require__(483),
	    toKey = __webpack_require__(114),
	    toString = __webpack_require__(487);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(656);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(97);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(247);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(164);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(165);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(167);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(625);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1200);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(627);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(1247);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(665);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(644);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 160 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = style;
	
	var _camelizeStyle = __webpack_require__(661);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _hyphenateStyle = __webpack_require__(1313);
	
	var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
	var _getComputedStyle2 = __webpack_require__(1308);
	
	var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
	var _removeStyle = __webpack_require__(1309);
	
	var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
	var _properties = __webpack_require__(660);
	
	var _isTransform = __webpack_require__(1310);
	
	var _isTransform2 = _interopRequireDefault(_isTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	    if (!value && value !== 0) {
	      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
	    } else if ((0, _isTransform2.default)(key)) {
	      transforms += key + '(' + value + ') ';
	    } else {
	      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ': ' + transforms + ';';
	  }
	
	  node.style.cssText += ';' + css;
	}
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(166);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 165 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1321);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var EventPluginRegistry = __webpack_require__(252);
	var ReactEventEmitterMixin = __webpack_require__(1358);
	var ViewportMetrics = __webpack_require__(687);
	
	var getVendorPrefixedEventName = __webpack_require__(1389);
	var isEventSupported = __webpack_require__(264);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(128);
	var ViewportMetrics = __webpack_require__(687);
	
	var getEventModifierState = __webpack_require__(261);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	var DOMNamespaces = __webpack_require__(251);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(259);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1353);


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1461);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _defaultArrowRenderer = __webpack_require__(725);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(726);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(276);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(277);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(723);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(724);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					className: className,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(174);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(721);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1458);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(722);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(724);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(723);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(277);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(725);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(726);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(276);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = arrayMove;
	exports.omit = omit;
	exports.closest = closest;
	exports.limit = limit;
	exports.getElementMargin = getElementMargin;
	exports.provideDisplayName = provideDisplayName;
	function arrayMove(arr, previousIndex, newIndex) {
	  var array = arr.slice(0);
	  if (newIndex >= array.length) {
	    var k = newIndex - array.length;
	    while (k-- + 1) {
	      array.push(undefined);
	    }
	  }
	  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
	  return array;
	}
	
	function omit(obj) {
	  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keysToOmit[_key - 1] = arguments[_key];
	  }
	
	  return Object.keys(obj).reduce(function (acc, key) {
	    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
	    return acc;
	  }, {});
	}
	
	var events = exports.events = {
	  start: ['touchstart', 'mousedown'],
	  move: ['touchmove', 'mousemove'],
	  end: ['touchend', 'touchcancel', 'mouseup']
	};
	
	var vendorPrefix = exports.vendorPrefix = function () {
	  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
	  // fix for:
	  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  //    window.getComputedStyle() returns null inside an iframe with display: none
	  // in this case return an array with a fake mozilla style in it.
	  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
	  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
	
	  switch (pre) {
	    case 'ms':
	      return 'ms';
	    default:
	      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
	  }
	}();
	
	function closest(el, fn) {
	  while (el) {
	    if (fn(el)) return el;
	    el = el.parentNode;
	  }
	}
	
	function limit(min, max, value) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	function getCSSPixelValue(stringValue) {
	  if (stringValue.substr(-2) === 'px') {
	    return parseFloat(stringValue);
	  }
	  return 0;
	}
	
	function getElementMargin(element) {
	  var style = window.getComputedStyle(element);
	
	  return {
	    top: getCSSPixelValue(style.marginTop),
	    right: getCSSPixelValue(style.marginRight),
	    bottom: getCSSPixelValue(style.marginBottom),
	    left: getCSSPixelValue(style.marginLeft)
	  };
	}
	
	function provideDisplayName(prefix, Component) {
	  var componentName = Component.displayName || Component.name;
	
	  return componentName ? prefix + '(' + componentName + ')' : prefix;
	}

/***/ },
/* 177 */
[1642, 733],
/* 178 */
30,
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var Emitter = __webpack_require__(1579);
	
	if (!Object.create) {
	  Object.create = __webpack_require__(1595);
	}
	
	var SCEmitter = function () {
	  Emitter.call(this);
	};
	
	SCEmitter.prototype = Object.create(Emitter.prototype);
	
	SCEmitter.prototype.emit = function (event) {
	  if (event == 'error') {
	
	    // To work with sc-domain.
	    // See https://github.com/SocketCluster/sc-domain
	    var domainErrorArgs = ['__domainError'];
	    if (arguments[1] !== undefined) {
	      domainErrorArgs.push(arguments[1]);
	    }
	
	    Emitter.prototype.emit.apply(this, domainErrorArgs);
	
	    if (this.domain) {
	      // Emit the error on the domain if it has one.
	      // See https://github.com/joyent/node/blob/ef4344311e19a4f73c031508252b21712b22fe8a/lib/events.js#L78-85
	
	      var err = arguments[1];
	
	      if (!err) {
	        err = new Error('Uncaught, unspecified "error" event.');
	      }
	      err.domainEmitter = this;
	      err.domain = this.domain;
	      err.domainThrown = false;
	      this.domain.emit('error', err);
	    }
	  }
	  Emitter.prototype.emit.apply(this, arguments);
	};
	
	module.exports.SCEmitter = SCEmitter;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var decycle = __webpack_require__(1596);
	
	var isStrict = (function () { return !this; })();
	
	function AuthTokenExpiredError(message, expiry) {
	  this.name = 'AuthTokenExpiredError';
	  this.message = message;
	  this.expiry = expiry;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	AuthTokenExpiredError.prototype = Object.create(Error.prototype);
	
	
	function AuthTokenInvalidError(message) {
	  this.name = 'AuthTokenInvalidError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	AuthTokenInvalidError.prototype = Object.create(Error.prototype);
	
	
	function AuthTokenNotBeforeError(message, date) {
	  this.name = 'AuthTokenNotBeforeError';
	  this.message = message;
	  this.date = date;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	AuthTokenNotBeforeError.prototype = Object.create(Error.prototype);
	
	
	// For any other auth token error.
	function AuthTokenError(message) {
	  this.name = 'AuthTokenError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	AuthTokenError.prototype = Object.create(Error.prototype);
	
	
	function SilentMiddlewareBlockedError(message, type) {
	  this.name = 'SilentMiddlewareBlockedError';
	  this.message = message;
	  this.type = type;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	SilentMiddlewareBlockedError.prototype = Object.create(Error.prototype);
	
	
	function InvalidActionError(message) {
	  this.name = 'InvalidActionError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	InvalidActionError.prototype = Object.create(Error.prototype);
	
	function InvalidArgumentsError(message) {
	  this.name = 'InvalidArgumentsError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	InvalidArgumentsError.prototype = Object.create(Error.prototype);
	
	function InvalidOptionsError(message) {
	  this.name = 'InvalidOptionsError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	InvalidOptionsError.prototype = Object.create(Error.prototype);
	
	
	function InvalidMessageError(message) {
	  this.name = 'InvalidMessageError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	InvalidMessageError.prototype = Object.create(Error.prototype);
	
	
	function SocketProtocolError(message, code) {
	  this.name = 'SocketProtocolError';
	  this.message = message;
	  this.code = code;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	SocketProtocolError.prototype = Object.create(Error.prototype);
	
	
	function ServerProtocolError(message) {
	  this.name = 'ServerProtocolError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	ServerProtocolError.prototype = Object.create(Error.prototype);
	
	function HTTPServerError(message) {
	  this.name = 'HTTPServerError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	HTTPServerError.prototype = Object.create(Error.prototype);
	
	
	function ResourceLimitError(message) {
	  this.name = 'ResourceLimitError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	ResourceLimitError.prototype = Object.create(Error.prototype);
	
	
	function TimeoutError(message) {
	  this.name = 'TimeoutError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	TimeoutError.prototype = Object.create(Error.prototype);
	
	
	function BadConnectionError(message, type) {
	  this.name = 'BadConnectionError';
	  this.message = message;
	  this.type = type;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	BadConnectionError.prototype = Object.create(Error.prototype);
	
	
	function BrokerError(message) {
	  this.name = 'BrokerError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	BrokerError.prototype = Object.create(Error.prototype);
	
	
	function ProcessExitError(message, code) {
	  this.name = 'ProcessExitError';
	  this.message = message;
	  this.code = code;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	ProcessExitError.prototype = Object.create(Error.prototype);
	
	
	function UnknownError(message) {
	  this.name = 'UnknownError';
	  this.message = message;
	  if (Error.captureStackTrace && !isStrict) {
	    Error.captureStackTrace(this, arguments.callee);
	  } else {
	    this.stack = (new Error()).stack;
	  }
	}
	UnknownError.prototype = Object.create(Error.prototype);
	
	
	// Expose all error types
	
	module.exports = {
	  AuthTokenExpiredError: AuthTokenExpiredError,
	  AuthTokenInvalidError: AuthTokenInvalidError,
	  AuthTokenNotBeforeError: AuthTokenNotBeforeError,
	  AuthTokenError: AuthTokenError,
	  SilentMiddlewareBlockedError: SilentMiddlewareBlockedError,
	  InvalidActionError: InvalidActionError,
	  InvalidArgumentsError: InvalidArgumentsError,
	  InvalidOptionsError: InvalidOptionsError,
	  InvalidMessageError: InvalidMessageError,
	  SocketProtocolError: SocketProtocolError,
	  ServerProtocolError: ServerProtocolError,
	  HTTPServerError: HTTPServerError,
	  ResourceLimitError: ResourceLimitError,
	  TimeoutError: TimeoutError,
	  BadConnectionError: BadConnectionError,
	  BrokerError: BrokerError,
	  ProcessExitError: ProcessExitError,
	  UnknownError: UnknownError
	};
	
	module.exports.socketProtocolErrorStatuses = {
	  1001: 'Socket was disconnected',
	  1002: 'A WebSocket protocol error was encountered',
	  1003: 'Server terminated socket because it received invalid data',
	  1005: 'Socket closed without status code',
	  1006: 'Socket hung up',
	  1007: 'Message format was incorrect',
	  1008: 'Encountered a policy violation',
	  1009: 'Message was too big to process',
	  1010: 'Client ended the connection because the server did not comply with extension requirements',
	  1011: 'Server encountered an unexpected fatal condition',
	  4000: 'Server ping timed out',
	  4001: 'Client pong timed out',
	  4002: 'Server failed to sign auth token',
	  4003: 'Failed to complete handshake',
	  4004: 'Client failed to save auth token',
	  4005: 'Did not receive #handshake from client before timeout',
	  4006: 'Failed to bind socket to message broker',
	  4007: 'Client connection establishment timed out'
	};
	
	module.exports.socketProtocolIgnoreStatuses = {
	  1000: 'Socket closed normally',
	  1001: 'Socket hung up'
	};
	
	// Properties related to error domains cannot be serialized.
	var unserializableErrorProperties = {
	  domain: 1,
	  domainEmitter: 1,
	  domainThrown: 1
	};
	
	module.exports.dehydrateError = function (error, includeStackTrace) {
	  var dehydratedError;
	
	  if (error && typeof error == 'object') {
	    dehydratedError = {
	      message: error.message
	    };
	    if (includeStackTrace) {
	      dehydratedError.stack = error.stack;
	    }
	    for (var i in error) {
	      if (!unserializableErrorProperties[i]) {
	        dehydratedError[i] = error[i];
	      }
	    }
	  } else if (typeof error == 'function') {
	    dehydratedError = '[function ' + (error.name || 'anonymous') + ']';
	  } else {
	    dehydratedError = error;
	  }
	
	  return decycle(dehydratedError);
	};
	
	module.exports.hydrateError = function (error) {
	  var hydratedError = null;
	  if (error != null) {
	    if (typeof error == 'object') {
	      hydratedError = new Error(error.message);
	      for (var i in error) {
	        if (error.hasOwnProperty(i)) {
	          hydratedError[i] = error[i];
	        }
	      }
	    } else {
	      hydratedError = error;
	    }
	  }
	  return hydratedError;
	};
	
	module.exports.decycle = decycle;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomFromSeed = __webpack_require__(1612);
	
	var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
	var alphabet;
	var previousSeed;
	
	var shuffled;
	
	function reset() {
	    shuffled = false;
	}
	
	function setCharacters(_alphabet_) {
	    if (!_alphabet_) {
	        if (alphabet !== ORIGINAL) {
	            alphabet = ORIGINAL;
	            reset();
	        }
	        return;
	    }
	
	    if (_alphabet_ === alphabet) {
	        return;
	    }
	
	    if (_alphabet_.length !== ORIGINAL.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
	    }
	
	    var unique = _alphabet_.split('').filter(function(item, ind, arr){
	       return ind !== arr.lastIndexOf(item);
	    });
	
	    if (unique.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
	    }
	
	    alphabet = _alphabet_;
	    reset();
	}
	
	function characters(_alphabet_) {
	    setCharacters(_alphabet_);
	    return alphabet;
	}
	
	function setSeed(seed) {
	    randomFromSeed.seed(seed);
	    if (previousSeed !== seed) {
	        reset();
	        previousSeed = seed;
	    }
	}
	
	function shuffle() {
	    if (!alphabet) {
	        setCharacters(ORIGINAL);
	    }
	
	    var sourceArray = alphabet.split('');
	    var targetArray = [];
	    var r = randomFromSeed.nextValue();
	    var characterIndex;
	
	    while (sourceArray.length > 0) {
	        r = randomFromSeed.nextValue();
	        characterIndex = Math.floor(r * sourceArray.length);
	        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
	    }
	    return targetArray.join('');
	}
	
	function getShuffled() {
	    if (shuffled) {
	        return shuffled;
	    }
	    shuffled = shuffle();
	    return shuffled;
	}
	
	/**
	 * lookup shuffled letter
	 * @param index
	 * @returns {string}
	 */
	function lookup(index) {
	    var alphabetShuffled = getShuffled();
	    return alphabetShuffled[index];
	}
	
	module.exports = {
	    characters: characters,
	    seed: setSeed,
	    lookup: lookup,
	    shuffled: getShuffled
	};


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(40);
	var normalizeHeaderName = __webpack_require__(783);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(281);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(281);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateProfile = updateProfile;
	exports.logout = logout;
	exports.login = login;
	
	var _actionTypes = __webpack_require__(287);
	
	var ActionTypes = _interopRequireWildcard(_actionTypes);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateProfile(params) {
	  return {
	    type: ActionTypes.UPDATE_PROFILE,
	    params: params
	  };
	}
	
	function filterProfile(response) {
	  return {
	    fake_username: response.data.user.fake_username,
	    username: response.data.user.username,
	    name: response.data.user.name,
	    email: response.data.user.email,
	    admin: response.data.user.admin,
	    token: response.data.token
	  };
	}
	
	function logout() {
	  return {
	    type: ActionTypes.LOGOUT
	  };
	}
	
	function login(userObj) {
	  return function (dispatch) {
	    return _BlitzAPI2.default.postLogin(userObj).then(function (response) {
	      var profile = filterProfile(response.data);
	      dispatch(updateProfile(profile));
	    });
	  };
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _SpinLoader = __webpack_require__(134);
	
	var _SpinLoader2 = _interopRequireDefault(_SpinLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileToUrl = function (_Component) {
	  _inherits(FileToUrl, _Component);
	
	  function FileToUrl(props) {
	    _classCallCheck(this, FileToUrl);
	
	    var _this = _possibleConstructorReturn(this, (FileToUrl.__proto__ || Object.getPrototypeOf(FileToUrl)).call(this, props));
	
	    _this.state = {
	      url: '',
	      loading: false
	    };
	    _this.onFileUpload = _this.onFileUpload.bind(_this);
	    return _this;
	  }
	
	  _createClass(FileToUrl, [{
	    key: 'onFileUpload',
	    value: function onFileUpload(e) {
	      var _this2 = this;
	
	      var onUrlChange = this.props.onUrlChange;
	
	
	      var formData = new FormData();
	      if (e.target.files[0]) {
	        formData.append('file', e.target.files[0]);
	        this.setState({ loading: true });
	        _BlitzAPI2.default.postEntryImage(formData).then(function (response) {
	          _this2.setState({
	            loading: false,
	            url: response.data.image_url
	          });
	          return onUrlChange(response.data.image_url);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          url = _state.url;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'file-url-component' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'temp-file' },
	            'Upload File'
	          ),
	          _react2.default.createElement('input', {
	            type: 'file', name: 'temp-file',
	            onChange: this.onFileUpload
	          }),
	          _react2.default.createElement('input', {
	            type: 'url', name: 'temp-url',
	            value: url
	          })
	        ),
	        loading && _react2.default.createElement(_SpinLoader2.default, null)
	      );
	    }
	  }]);
	
	  return FileToUrl;
	}(_react.Component);
	
	exports.default = FileToUrl;
	
	
	FileToUrl.propTypes = {
	  onUrlChange: _propTypes2.default.func
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormTextArea = function (_Component) {
	  _inherits(FormTextArea, _Component);
	
	  function FormTextArea() {
	    _classCallCheck(this, FormTextArea);
	
	    return _possibleConstructorReturn(this, (FormTextArea.__proto__ || Object.getPrototypeOf(FormTextArea)).apply(this, arguments));
	  }
	
	  _createClass(FormTextArea, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          placeholder = _props.placeholder,
	          label = _props.label,
	          input = _props.input,
	          controlId = _props.controlId,
	          disabled = _props.disabled,
	          meta = _props.meta;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        { controlId: controlId || '' },
	        _react2.default.createElement(
	          _reactBootstrap.ControlLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl, Object.assign({
	          componentClass: 'textarea',
	          value: input.value,
	          onChange: input.onChange,
	          placeholder: placeholder || '',
	          disabled: disabled
	        }, input)),
	        meta.error && _react2.default.createElement(
	          _reactBootstrap.HelpBlock,
	          null,
	          meta.error
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null)
	      );
	    }
	  }]);
	
	  return FormTextArea;
	}(_react.Component);
	
	exports.default = FormTextArea;
	
	
	FormTextArea.propTypes = {
	  label: _propTypes2.default.string,
	  controlId: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  input: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleButton = function (_Component) {
	  _inherits(StyleButton, _Component);
	
	  function StyleButton(props) {
	    _classCallCheck(this, StyleButton);
	
	    var _this = _possibleConstructorReturn(this, (StyleButton.__proto__ || Object.getPrototypeOf(StyleButton)).call(this, props));
	
	    _this.onToggle = function (e) {
	      e.preventDefault();
	      props.onToggle(props.style);
	    };
	    return _this;
	  }
	
	  _createClass(StyleButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          icon = _props.icon,
	          label = _props.label;
	
	      var className = 'entry-editor-styleButton';
	      if (active) {
	        className += ' entry-editor-activeButton';
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: className, onMouseDown: this.onToggle },
	        icon ? _react2.default.createElement('img', { className: 'fit-parent', src: icon, role: 'presentation' }) : label
	      );
	    }
	  }]);
	
	  return StyleButton;
	}(_react.Component);
	
	exports.default = StyleButton;
	
	
	StyleButton.propTypes = {
	  active: _propTypes2.default.bool,
	  label: _propTypes2.default.string.isRequired,
	  onToggle: _propTypes2.default.func.isRequired,
	  icon: _propTypes2.default.string,
	  style: _propTypes2.default.string
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__version = exports.parseHTML = exports.convertFromHTML = exports.convertToHTML = undefined;
	
	var _convertToHTML = __webpack_require__(913);
	
	var _convertToHTML2 = _interopRequireDefault(_convertToHTML);
	
	var _convertFromHTML = __webpack_require__(912);
	
	var _convertFromHTML2 = _interopRequireDefault(_convertFromHTML);
	
	var _parseHTML = __webpack_require__(422);
	
	var _parseHTML2 = _interopRequireDefault(_parseHTML);
	
	var _package = __webpack_require__(1039);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.convertToHTML = _convertToHTML2.default;
	exports.convertFromHTML = _convertFromHTML2.default;
	exports.parseHTML = _parseHTML2.default;
	exports.__version = _package.version;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(109);
	var CharacterMetadata = __webpack_require__(37);
	var ContentBlock = __webpack_require__(75);
	var ContentBlockNode = __webpack_require__(41);
	var DraftEntity = __webpack_require__(139);
	var DraftFeatureFlags = __webpack_require__(67);
	var Immutable = __webpack_require__(16);
	var SelectionState = __webpack_require__(86);
	
	var generateRandomKey = __webpack_require__(58);
	var sanitizeDraftText = __webpack_require__(194);
	
	var List = Immutable.List,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var defaultRecord = {
	  entityMap: null,
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
	  }
	
	  ContentState.prototype.getEntityMap = function getEntityMap() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity;
	  };
	
	  ContentState.prototype.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  ContentState.prototype.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  ContentState.prototype.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__getLastCreatedEntityKey();
	  };
	
	  ContentState.prototype.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || blockMap.first().getLength() > 0;
	  };
	
	  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__create(type, mutability, data);
	    return this;
	  };
	
	  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__mergeData(key, toMerge);
	    return this;
	  };
	
	  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__replaceData(key, newData);
	    return this;
	  };
	
	  ContentState.prototype.addEntity = function addEntity(instance) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__add(instance);
	    return this;
	  };
	
	  ContentState.prototype.getEntity = function getEntity(key) {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__get(key);
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray(
	  // TODO: update flow type when we completely deprecate the old entity API
	  blocks, entityMap) {
	    // TODO: remove this when we completely deprecate the old entity API
	    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
	    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
	    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      entityMap: entityMap || DraftEntity,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
	
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlockNodeRecord({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(16),
	    Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(87);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	var DefaultDraftBlockRenderMap = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  blockquote: {
	    element: 'blockquote'
	  },
	  atomic: {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  unstyled: {
	    element: 'div',
	    aliasedElements: ['p']
	  }
	});
	
	module.exports = DefaultDraftBlockRenderMap;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(51);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(443);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	  while (searchNode && searchNode !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	    if (key != null) {
	      return key;
	    }
	    searchNode = searchNode.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ },
/* 192 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
	        return null;
	      }
	      return filterKey(contentState.getEntityMap(), entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(contentState.getEntityMap(), entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityMap, entityKey) {
	  if (entityKey) {
	    var entity = entityMap.__get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ },
/* 193 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ },
/* 194 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * @format
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ },
/* 195 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(1012);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    var ownerDocument = node.ownerDocument;
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	
	};
	
	module.exports = Style;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(19);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ },
/* 198 */
[1633, 1017],
/* 199 */
61,
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(1009);
	var getUnboundedScrollPosition = __webpack_require__(1013);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(88);
	
	var _DOMUtils = __webpack_require__(143);
	
	var _DOMStateStorage = __webpack_require__(459);
	
	var _PathUtils = __webpack_require__(68);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1030);
	
	var _PathUtils = __webpack_require__(68);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(142);
	
	var _LocationUtils = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 205 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77),
	    root = __webpack_require__(52);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1111),
	    mapCacheDelete = __webpack_require__(1112),
	    mapCacheGet = __webpack_require__(1113),
	    mapCacheHas = __webpack_require__(1114),
	    mapCacheSet = __webpack_require__(1115);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(207),
	    setCacheAdd = __webpack_require__(1123),
	    setCacheHas = __webpack_require__(1124);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(144),
	    stackClear = __webpack_require__(1127),
	    stackDelete = __webpack_require__(1128),
	    stackGet = __webpack_require__(1129),
	    stackHas = __webpack_require__(1130),
	    stackSet = __webpack_require__(1131);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(467),
	    isFlattenable = __webpack_require__(1103);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 213 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(47),
	    isSymbol = __webpack_require__(90);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 215 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 216 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(78),
	    isObjectLike = __webpack_require__(79);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(52),
	    stubFalse = __webpack_require__(1146);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isObject = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 220 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1060),
	    baseUnary = __webpack_require__(211),
	    nodeUtil = __webpack_require__(1120);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(147),
	    baseForOwn = __webpack_require__(471),
	    baseIteratee = __webpack_require__(149);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 223 */
61,
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(163);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(665);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(642);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(1214);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(1215);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(1216);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(1217);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(1218);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(1219);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(167);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1255);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1254);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 230 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1264);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 232 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 233 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 234 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(92);
	var dPs = __webpack_require__(1279);
	var enumBugKeys = __webpack_require__(233);
	var IE_PROTO = __webpack_require__(238)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(645)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(1270).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 236 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(81).f;
	var has = __webpack_require__(80);
	var TAG = __webpack_require__(55)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(239)('keys');
	var uid = __webpack_require__(160);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(71);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 240 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(232);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(95);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(71);
	var core = __webpack_require__(54);
	var LIBRARY = __webpack_require__(234);
	var wksExt = __webpack_require__(244);
	var defineProperty = __webpack_require__(81).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(55);


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 247 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(166);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(99);
	var Danger = __webpack_require__(1337);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactInstrumentation = __webpack_require__(43);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(259);
	var setInnerHTML = __webpack_require__(172);
	var setTextContent = __webpack_require__(694);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 251 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactErrorUtils = __webpack_require__(257);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 254 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactPropTypesSecret = __webpack_require__(1363);
	var propTypesFactory = __webpack_require__(608);
	
	var React = __webpack_require__(85);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactInstanceMap = __webpack_require__(127);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(50);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 259 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 261 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var ReactCompositeComponent = __webpack_require__(1344);
	var ReactEmptyComponent = __webpack_require__(678);
	var ReactHostComponent = __webpack_require__(680);
	
	var getNextDebugID = __webpack_require__(1489);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 265 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var emptyFunction = __webpack_require__(61);
	var warning = __webpack_require__(26);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 268 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 270 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _getRouteParams = __webpack_require__(1447);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(271);
	
	var _RouteUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports);
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports);
	        global.sAlertStore = mod.exports;
	    }
	})(this, function (exports) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    function _toConsumableArray(arr) {
	        if (Array.isArray(arr)) {
	            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	                arr2[i] = arr[i];
	            }
	
	            return arr2;
	        } else {
	            return Array.from(arr);
	        }
	    }
	
	    // custom simple store based on a awesome Redux library https://github.com/rackt/redux
	
	    var createSAlertStore = function createSAlertStore(reducer) {
	        var state = void 0;
	        var listeners = [];
	        var getState = function getState() {
	            return state;
	        };
	        var dispatch = function dispatch(action) {
	            state = reducer(state, action);
	            listeners.forEach(function (listener) {
	                return listener();
	            });
	        };
	        var subscribe = function subscribe(listener) {
	            listeners.push(listener);
	            return function () {
	                listeners = listeners.filter(function (l) {
	                    return l !== listener;
	                });
	            };
	        };
	        dispatch({});
	        return {
	            getState: getState, dispatch: dispatch, subscribe: subscribe
	        };
	    };
	
	    var insert = function insert(state, action) {
	        return [].concat(_toConsumableArray(state), [action.data]);
	    };
	
	    var remove = function remove(state, action) {
	        var elemToRemoveArray = state.slice().filter(function (item) {
	            return item.id === action.data.id;
	        });
	        if (Array.isArray(elemToRemoveArray)) {
	            var elemToRemoveIndex = state.indexOf(elemToRemoveArray[0]);
	            return [].concat(_toConsumableArray(state.slice(0, elemToRemoveIndex)), _toConsumableArray(state.slice(elemToRemoveIndex + 1)));
	        }
	        return state;
	    };
	
	    var alertsReducer = function alertsReducer() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case 'INSERT':
	                return insert(state, action);
	            case 'REMOVE':
	                return remove(state, action);
	            case 'REMOVEALL':
	                return [];
	            default:
	                return state;
	        }
	    };
	
	    var sAlertStore = createSAlertStore(alertsReducer);
	
	    exports.default = sAlertStore;
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports);
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports);
	        global.sAlertTools = mod.exports;
	    }
	})(this, function (exports) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    var actualGlobalConfig = void 0;
	
	    var sAlertTools = {
	        randomId: function randomId() {
	            return Math.random().toString(36).split('.')[1];
	        },
	        returnFirstDefined: function returnFirstDefined() {
	            var value = void 0;
	            var i = void 0;
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            for (i = 0; i < args.length; i++) {
	                if (typeof args[i] !== 'undefined') {
	                    value = args[i];
	                    break;
	                }
	            }
	            return value;
	        },
	        styleToObj: function styleToObj(input) {
	            var result = {},
	                i = void 0,
	                entry = void 0,
	                attributes = input && input.split(';').filter(Boolean);
	
	            for (i = 0; i < attributes.length; i++) {
	                entry = attributes[i].split(':');
	                result[entry.splice(0, 1)[0].trim()] = entry.join(':').trim();
	            }
	            return result;
	        },
	        setGlobalConfig: function setGlobalConfig(config) {
	            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
	                actualGlobalConfig = config;
	            }
	        },
	        getGlobalConfig: function getGlobalConfig() {
	            return actualGlobalConfig;
	        }
	    };
	
	    exports.default = sAlertTools;
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(727);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1460);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 278 */
246,
/* 279 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefix = exports.prefix = '@@redux-form/';
	
	var ARRAY_INSERT = exports.ARRAY_INSERT = prefix + 'ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = prefix + 'ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = prefix + 'ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = prefix + 'ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = prefix + 'ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = prefix + 'AUTOFILL';
	var BLUR = exports.BLUR = prefix + 'BLUR';
	var CHANGE = exports.CHANGE = prefix + 'CHANGE';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
	var CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
	var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
	var DESTROY = exports.DESTROY = prefix + 'DESTROY';
	var FOCUS = exports.FOCUS = prefix + 'FOCUS';
	var INITIALIZE = exports.INITIALIZE = prefix + 'INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = prefix + 'REGISTER_FIELD';
	var RESET = exports.RESET = prefix + 'RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = prefix + 'START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = prefix + 'STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = prefix + 'SUBMIT';
	var TOUCH = exports.TOUCH = prefix + 'TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = prefix + 'UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(1527);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form, getFormState) {
	    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + '.error');
	        if (error) {
	          return false;
	        }
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields');
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	exports.default = createIsValid;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var settle = __webpack_require__(775);
	var buildURL = __webpack_require__(778);
	var parseHeaders = __webpack_require__(784);
	var isURLSameOrigin = __webpack_require__(782);
	var createError = __webpack_require__(284);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(777);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(780);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(774);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactRouterRedux = __webpack_require__(709);
	
	var _reduxPersist = __webpack_require__(748);
	
	var _Container = __webpack_require__(788);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _DashboardHome = __webpack_require__(799);
	
	var _DashboardHome2 = _interopRequireDefault(_DashboardHome);
	
	var _Login = __webpack_require__(789);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _EntryListBlitz = __webpack_require__(802);
	
	var _EntryListBlitz2 = _interopRequireDefault(_EntryListBlitz);
	
	var _EntryListExternal = __webpack_require__(803);
	
	var _EntryListExternal2 = _interopRequireDefault(_EntryListExternal);
	
	var _SourceList = __webpack_require__(832);
	
	var _SourceList2 = _interopRequireDefault(_SourceList);
	
	var _SourceCreate = __webpack_require__(830);
	
	var _SourceCreate2 = _interopRequireDefault(_SourceCreate);
	
	var _SourceEdit = __webpack_require__(831);
	
	var _SourceEdit2 = _interopRequireDefault(_SourceEdit);
	
	var _PushNotifications = __webpack_require__(828);
	
	var _PushNotifications2 = _interopRequireDefault(_PushNotifications);
	
	var _BlitzEditor = __webpack_require__(294);
	
	var _BlitzEditor2 = _interopRequireDefault(_BlitzEditor);
	
	var _BlitzEntryCreate = __webpack_require__(808);
	
	var _BlitzEntryCreate2 = _interopRequireDefault(_BlitzEntryCreate);
	
	var _BlitzEntryEdit = __webpack_require__(809);
	
	var _BlitzEntryEdit2 = _interopRequireDefault(_BlitzEntryEdit);
	
	var _ExternalEntryCreate = __webpack_require__(816);
	
	var _ExternalEntryCreate2 = _interopRequireDefault(_ExternalEntryCreate);
	
	var _ExternalEntryEdit = __webpack_require__(817);
	
	var _ExternalEntryEdit2 = _interopRequireDefault(_ExternalEntryEdit);
	
	var _ChatRoomList = __webpack_require__(797);
	
	var _ChatRoomList2 = _interopRequireDefault(_ChatRoomList);
	
	var _ChatRoomEdit = __webpack_require__(796);
	
	var _ChatRoomEdit2 = _interopRequireDefault(_ChatRoomEdit);
	
	var _ChatRoomCreate = __webpack_require__(795);
	
	var _ChatRoomCreate2 = _interopRequireDefault(_ChatRoomCreate);
	
	var _AppTrackingDashboard = __webpack_require__(842);
	
	var _AppTrackingDashboard2 = _interopRequireDefault(_AppTrackingDashboard);
	
	var _AppTrackingList = __webpack_require__(844);
	
	var _AppTrackingList2 = _interopRequireDefault(_AppTrackingList);
	
	var _AppTrackingFilter = __webpack_require__(843);
	
	var _AppTrackingFilter2 = _interopRequireDefault(_AppTrackingFilter);
	
	var _EntrySchedule = __webpack_require__(806);
	
	var _EntrySchedule2 = _interopRequireDefault(_EntrySchedule);
	
	var _ChampionTips = __webpack_require__(839);
	
	var _ChampionTips2 = _interopRequireDefault(_ChampionTips);
	
	var _Alert = __webpack_require__(791);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _ChampionTipsItem = __webpack_require__(841);
	
	var _ChampionTipsItem2 = _interopRequireDefault(_ChampionTipsItem);
	
	var _TagEdit = __webpack_require__(836);
	
	var _TagEdit2 = _interopRequireDefault(_TagEdit);
	
	var _TagCreate = __webpack_require__(835);
	
	var _TagCreate2 = _interopRequireDefault(_TagCreate);
	
	var _TagList = __webpack_require__(837);
	
	var _TagList2 = _interopRequireDefault(_TagList);
	
	var _UserList = __webpack_require__(848);
	
	var _UserList2 = _interopRequireDefault(_UserList);
	
	var _UserCreate = __webpack_require__(846);
	
	var _UserCreate2 = _interopRequireDefault(_UserCreate);
	
	var _UserEdit = __webpack_require__(847);
	
	var _UserEdit2 = _interopRequireDefault(_UserEdit);
	
	var _StatsQueryHome = __webpack_require__(834);
	
	var _StatsQueryHome2 = _interopRequireDefault(_StatsQueryHome);
	
	var _BetaCreate = __webpack_require__(794);
	
	var _BetaCreate2 = _interopRequireDefault(_BetaCreate);
	
	var _configureStore = __webpack_require__(850);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _utils = __webpack_require__(65);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import DashboardContainer from './cms/dashboard/DashboardContainer';
	
	
	var store = exports.store = (0, _configureStore2.default)();
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	var Root = function (_Component) {
	  _inherits(Root, _Component);
	
	  function Root() {
	    _classCallCheck(this, Root);
	
	    var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this));
	
	    _this.state = { rehydrated: false };
	    return _this;
	  }
	
	  _createClass(Root, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _reduxPersist.persistStore)(store, { blacklist: ['routing'] }, function () {
	        _this2.setState({ rehydrated: true });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.rehydrated) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading...'
	        );
	      }
	      var redux = store.getState();
	      if (redux.user && redux.user.profile.token) {
	        _BlitzAPI2.default.setToken(redux.user.profile.token);
	      }
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(
	          _reactRouter.Router,
	          { history: history },
	          _react2.default.createElement(_reactRouter.Route, { path: '/login', component: _Login2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: '/editor', component: _BlitzEditor2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/', component: _Container2.default, onEnter: (0, _utils.userIsLoggedIn)(store) },
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/entries/external' }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/blitz', component: _EntryListBlitz2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/blitz/create/:type', component: _BlitzEntryCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/blitz/:entryId', component: _BlitzEntryEdit2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/external', component: _EntryListExternal2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/external/create', component: _ExternalEntryCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/external/:entryId', component: _ExternalEntryEdit2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/entries/scheduled', component: _EntrySchedule2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/sources', component: _SourceList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/sources/create', component: _SourceCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/sources/:sourceId', component: _SourceEdit2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/chatrooms', component: _ChatRoomList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/chatrooms/create', component: _ChatRoomCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/chatrooms/:chatRoomId', component: _ChatRoomEdit2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/tags', component: _TagList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/tags/create', component: _TagCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/tags/:tagId', component: _TagEdit2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/pushnotifications/create', component: _PushNotifications2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/users', component: _UserList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/users/create', component: _UserCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/users/:userId', component: _UserEdit2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/stats', component: _StatsQueryHome2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/betausers', component: _BetaCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/tracking', component: _AppTrackingDashboard2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/trackingfilter', component: _AppTrackingFilter2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/trackingusers', component: _AppTrackingList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/championtips', component: _ChampionTips2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/BlitzAlert', component: _Alert2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/championtips/:id', component: _ChampionTipsItem2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/dashboard', component: _DashboardHome2.default })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Root;
	}(_react.Component);
	
	exports.default = Root;

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UPDATE_PROFILE = exports.UPDATE_PROFILE = 'user/UPDATE_PROFILE';
	var LOGOUT = exports.LOGOUT = 'user/LOGOUT';
	var LOGIN = exports.LOGIN = 'user/LOGIN';
	var AUTHORIZE = exports.AUTHORIZE = 'user/AUTHORIZE';

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _FormSelect = __webpack_require__(107);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _constants = __webpack_require__(44);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatRoomForm = function (_Component) {
	  _inherits(ChatRoomForm, _Component);
	
	  function ChatRoomForm(props) {
	    _classCallCheck(this, ChatRoomForm);
	
	    var _this = _possibleConstructorReturn(this, (ChatRoomForm.__proto__ || Object.getPrototypeOf(ChatRoomForm)).call(this, props));
	
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    _this.reparseChatRoom = _this.reparseChatRoom.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatRoomForm, [{
	    key: 'onDeleteClick',
	    value: function onDeleteClick() {
	      var chatRoomId = this.props.chatRoomId;
	
	
	      if (confirm('Delete this chatroom?')) {
	        _BlitzAPI2.default.deleteChatRoom(chatRoomId).then(function () {
	          return _reactRouter.browserHistory.push('/chatrooms');
	        });
	      }
	    }
	  }, {
	    key: 'reparseChatRoom',
	    value: function reparseChatRoom() {
	      var chatRoomId = this.props.chatRoomId;
	
	
	      _BlitzAPI2.default.reparseChatRoom(chatRoomId).then(function () {
	        return _reactRouter.browserHistory.push('/chatrooms');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          chatRoomId = _props.chatRoomId;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'button', onClick: this.reparseChatRoom },
	          'Reparse chatroom'
	        ),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'text',
	          name: 'name',
	          placeholder: 'Chatroom Name',
	          component: _BasicFormInput2.default,
	          controlId: 'chatroomName',
	          label: 'Chatroom Name'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'object_type',
	          placeholder: 'Object type',
	          component: _FormSelect2.default,
	          controlId: 'objectType',
	          label: 'Object Type',
	          options: _constants.CHAT_TYPE_OPTIONS
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'object_id',
	          type: 'number',
	          placeholder: 'Object ID',
	          component: _BasicFormInput2.default,
	          controlId: 'objectId',
	          label: 'Object ID'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'esport',
	          placeholder: 'Esport',
	          component: _FormSelect2.default,
	          controlId: 'esport',
	          label: 'Esport',
	          options: _constants.ESPORT_TYPE_OPTIONS
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'submit' },
	          'Submit'
	        ),
	        chatRoomId ? _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            type: 'button',
	            bsStyle: 'danger',
	            className: 'pull-right',
	            onClick: this.onDeleteClick
	          },
	          'Delete'
	        ) : null
	      );
	    }
	  }]);
	
	  return ChatRoomForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('chatroom');
	function mapStateToProps(state) {
	  return {
	    chatRoomId: selector(state, 'id')
	  };
	}
	
	ChatRoomForm = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({ form: 'chatroom', enableReinitialize: true })(ChatRoomForm));
	
	ChatRoomForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  chatRoomId: _propTypes2.default.number
	};
	
	exports.default = ChatRoomForm;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeDataFormat = typeDataFormat;
	exports.esportDataFormat = esportDataFormat;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function typeDataFormat(cell, row) {
	  var icon = '';
	  switch (row.type) {
	    case 'youtube':
	      icon = 'video.png';
	      break;
	    case 'article':
	      icon = 'article.png';
	      break;
	    case 'feed':
	      icon = 'blitzfeed.png';
	      break;
	    case 'guide':
	      icon = 'guide.png';
	      break;
	    default:
	      icon = '';
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'entry-item-type-icon' },
	    _react2.default.createElement('img', { className: 'fit-height', role: 'presentation', src: '/assets/img/icons/' + icon })
	  );
	}
	
	function esportDataFormat(cell, row) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'entry-item-esport-icon' },
	    _react2.default.createElement('img', { className: 'fit-height', role: 'presentation', src: '/assets/img/icons/' + row.esport + '.png' })
	  );
	}

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactSelect = __webpack_require__(175);
	
	var _draftJs = __webpack_require__(42);
	
	var _draftConvert = __webpack_require__(187);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(457);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _FormSelect = __webpack_require__(107);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormDateTime = __webpack_require__(292);
	
	var _FormDateTime2 = _interopRequireDefault(_FormDateTime);
	
	var _FormTextArea = __webpack_require__(185);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	var _constants = __webpack_require__(44);
	
	var _utils = __webpack_require__(32);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _RebrandlyAPI = __webpack_require__(787);
	
	var _RebrandlyAPI2 = _interopRequireDefault(_RebrandlyAPI);
	
	var _utils2 = __webpack_require__(65);
	
	var _FileToUrl = __webpack_require__(184);
	
	var _FileToUrl2 = _interopRequireDefault(_FileToUrl);
	
	var _TwitterField = __webpack_require__(814);
	
	var _TwitterField2 = _interopRequireDefault(_TwitterField);
	
	var _TwitterPublished = __webpack_require__(815);
	
	var _TwitterPublished2 = _interopRequireDefault(_TwitterPublished);
	
	var _FacebookPublished = __webpack_require__(810);
	
	var _FacebookPublished2 = _interopRequireDefault(_FacebookPublished);
	
	var _PublishingField = __webpack_require__(813);
	
	var _PublishingField2 = _interopRequireDefault(_PublishingField);
	
	var _PublishSchedule = __webpack_require__(812);
	
	var _PublishSchedule2 = _interopRequireDefault(_PublishSchedule);
	
	var _BlitzEditor = __webpack_require__(294);
	
	var _BlitzEditor2 = _interopRequireDefault(_BlitzEditor);
	
	var _SpinLoader = __webpack_require__(134);
	
	var _SpinLoader2 = _interopRequireDefault(_SpinLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getTagOptions = function getTagOptions(input) {
	  return _BlitzAPI2.default.getTags({ name: input }).then(function (resp) {
	    return resp.data.data.map(function (tag) {
	      return { value: tag.id, label: tag.name };
	    });
	  }).then(function (data) {
	    return { options: data };
	  });
	};
	
	function validate(values) {
	  var errors = {};
	  if (values.twitter_publish) {
	    errors.twitter_message = values.twitter_message ? undefined : 'Twitter is Enabled. Require Twitter Message';
	  }
	  if (values.fb_publish) {
	    errors.fb_message = values.fb_message ? undefined : 'Facebook is Enabled. Require Facebook Message';
	  }
	  errors.title = values.title ? undefined : 'Required';
	  return errors;
	}
	
	function onSubmitFail(errors) {
	  var value = JSON.stringify(errors, null, 2);
	  alert(value);
	}
	
	var BlitzEntryForm = function (_Component) {
	  _inherits(BlitzEntryForm, _Component);
	
	  function BlitzEntryForm(props) {
	    _classCallCheck(this, BlitzEntryForm);
	
	    var _this = _possibleConstructorReturn(this, (BlitzEntryForm.__proto__ || Object.getPrototypeOf(BlitzEntryForm)).call(this, props));
	
	    var tags = props.tags && props.tags.map(function (tag) {
	      return { label: tag.name, value: tag.id };
	    });
	    var router = _this.props.router;
	
	    _this.state = {
	      step: Number(router.location.query.step) === 2 ? 2 : 1,
	      sources: 11,
	      useEditor: false,
	      showOutput: false,
	      type: 'article',
	      authors: null,
	      tags: tags,
	      loadRebrandly: false,
	      loadParseUrl: false
	    };
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    _this.onEditorDataChange = _this.onEditorDataChange.bind(_this);
	    _this.toggleEditorButton = _this.toggleEditorButton.bind(_this);
	    _this.toggleOutputButton = _this.toggleOutputButton.bind(_this);
	    _this.createTag = _this.createTag.bind(_this);
	    _this.copy = _this.copy.bind(_this);
	    _this.setStep = _this.setStep.bind(_this);
	    _this.routerWillLeave = _this.routerWillLeave.bind(_this);
	    // console.log("---------init", props.initialValues);
	    // console.log("---------entry", props.entry);
	    // console.log("---------", Object.is(props.initialValues, props.entry));
	    // if (!Object.is(props.initialValues, props.entry)) {
	    //
	    // }
	    // console.log("initialize shit!!!!")
	    return _this;
	  }
	
	  _createClass(BlitzEntryForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          router = _props.router,
	          routes = _props.routes;
	
	      router.setRouteLeaveHook(routes[1], this.routerWillLeave);
	
	      _BlitzAPI2.default.getSources().then(function (response) {
	        var sourceOptions = (0, _utils2.getSourceOptions)(response);
	        _this2.setState({
	          sources: sourceOptions
	        });
	      });
	      _BlitzAPI2.default.getUsers().then(function (response) {
	        var userOptions = (0, _utils2.getUserOptions)(response);
	        _this2.setState({
	          authors: userOptions
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.tags !== nextProps.tags) {
	        var tags = nextProps.tags && nextProps.tags.map(function (tag) {
	          return { label: tag.name, value: tag.id };
	        }) || [];
	        this.setState({ tags: tags });
	      }
	    }
	  }, {
	    key: 'onDeleteClick',
	    value: function onDeleteClick() {
	      var entry_id = this.props.entry_id;
	
	
	      if (confirm('Delete this entry?')) {
	        _BlitzAPI2.default.deleteEntry(entry_id).then(function () {
	          return _reactRouter.browserHistory.push('/entries/blitz');
	        });
	      }
	    }
	  }, {
	    key: 'onEditorDataChange',
	    value: function onEditorDataChange(event, newValue, previousValue) {
	      var change = this.props.change;
	
	      var editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(newValue));
	      var contentState = editorState.getCurrentContent();
	      var html = (0, _draftConvert.convertToHTML)(_constants.CONVERT_HTML_OPTIONS)(contentState);
	
	      change('content', html);
	    }
	  }, {
	    key: 'createTag',
	    value: function createTag(val) {
	      var entry_id = this.props.entry_id;
	      var tags = this.state.tags;
	
	      if (tags && tags.length > val.length) {
	        var deleted = tags.filter(function (x) {
	          return !new Set(val).has(x);
	        })[0];
	        _BlitzAPI2.default.deleteEntryTag({ entry_id: entry_id, tag_id: deleted.value });
	      } else {
	        var newItem = val.filter(function (x) {
	          return !new Set(tags).has(x);
	        })[0];
	        if (!Number.isInteger(newItem.value)) {
	          _BlitzAPI2.default.postTag({ tag: { name: newItem.label } }).then(function (resp) {
	            return _BlitzAPI2.default.postEntryTag({ entry_id: entry_id, tag_id: resp.data.data.id });
	          });
	        } else {
	          _BlitzAPI2.default.postEntryTag({ entry_id: entry_id, tag_id: newItem.value });
	        }
	      }
	
	      this.setState({ tags: val });
	    }
	  }, {
	    key: 'toggleEditorButton',
	    value: function toggleEditorButton() {
	      var useEditor = this.state.useEditor;
	
	      this.setState({ useEditor: !useEditor });
	    }
	  }, {
	    key: 'toggleOutputButton',
	    value: function toggleOutputButton() {
	      var showOutput = this.state.showOutput;
	
	      this.setState({ showOutput: !showOutput });
	    }
	  }, {
	    key: 'copy',
	    value: function copy(time) {
	      var change = this.props.change;
	
	      change('publish_date', time);
	      change('twitter_publish_date', time);
	      change('fb_publish_date', time);
	    }
	  }, {
	    key: 'generateLink',
	    value: function generateLink(resp, slashtag, title) {
	      var _this3 = this;
	
	      this.setState({ loadRebrandly: true });
	      return _RebrandlyAPI2.default.postLinks({
	        destination: (0, _utils.generateEntrySlug)(resp.data.data, false, true),
	        domain: { fullName: 'blitz.gg' },
	        slashtag: slashtag,
	        title: title
	      }).then(function (response) {
	        _this3.setState({ loadRebrandly: false });
	        _this3.props.change('short_url', response.data.shortUrl);
	      }).catch(function () {
	        _this3.setState({ loadRebrandly: false });
	        throw new _reduxForm.SubmissionError({
	          slash_tag: 'Tag Taken. Try another one.'
	        });
	      });
	    }
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave() {
	      var useEditor = this.state.useEditor;
	
	      if (useEditor) {
	        return 'Are you sure you want to leave without saving?';
	      }
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(index) {
	      window.scrollTo(0, 0);
	      this.setState({
	        step: index
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          onSubmit = _props2.onSubmit,
	          submitting = _props2.submitting,
	          published = _props2.published,
	          type = _props2.type,
	          entry_id = _props2.entry_id,
	          change = _props2.change,
	          top_image = _props2.top_image,
	          cover_image = _props2.cover_image,
	          title = _props2.title,
	          slash_tag = _props2.slash_tag,
	          twitter_publish = _props2.twitter_publish,
	          twitter_publish_date = _props2.twitter_publish_date,
	          fb_publish = _props2.fb_publish,
	          fb_publish_date = _props2.fb_publish_date,
	          fb_link = _props2.fb_link,
	          fb_message = _props2.fb_message,
	          twitter_message = _props2.twitter_message,
	          twitter_image_url = _props2.twitter_image_url,
	          twitter_id = _props2.twitter_id,
	          fb_id = _props2.fb_id;
	      var _state = this.state,
	          tags = _state.tags,
	          sources = _state.sources,
	          authors = _state.authors,
	          useEditor = _state.useEditor,
	          loadRebrandly = _state.loadRebrandly,
	          loadParseUrl = _state.loadParseUrl,
	          step = _state.step;
	
	      if (!(sources && authors)) {
	        return _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        );
	      }
	      if (useEditor) {
	        return _react2.default.createElement(_BlitzEditor2.default, {
	          toggleEditorButton: this.toggleEditorButton,
	          save: handleSubmit(function (v) {
	            return onSubmit(v).then(function (resp) {
	              return _reactRouter.browserHistory.push('/entries/blitz/' + resp.data.data.id);
	            });
	          }),
	          preview: handleSubmit(function (v) {
	            return onSubmit(v).then(function (r) {
	              window.open((0, _utils.generateEntrySlug)(r.data.data, false, true));
	              return r;
	            }).then(function (r) {
	              return _reactRouter.browserHistory.replace('/entries/blitz/' + r.data.data.id);
	            });
	          })
	        });
	      }
	      return _react2.default.createElement(
	        'form',
	        {
	          onSubmit: handleSubmit(function (v) {
	            return onSubmit(Object.assign(v, { published: true })).then(function () {
	              return _reactRouter.browserHistory.push('/entries/blitz');
	            });
	          }),
	          className: 'create-form-blitz'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'create-form-blitz-content ' + (this.props.entry_id ? 'create-form-blitz-content-edit' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'create-form-blitz-step clearfix' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)('create-form-blitz-step-item', '' + (step === 1 ? 'create-form-blitz-step-active' : null)), onClick: function onClick() {
	                  return _this4.setStep(1);
	                }
	              },
	              'Step 1: Edit'
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)('create-form-blitz-step-item', '' + (step === 2 ? 'create-form-blitz-step-active' : null)), onClick: function onClick() {
	                  return _this4.setStep(2);
	                }
	              },
	              'Step 2: Publish'
	            )
	          ),
	          step === 1 ? _react2.default.createElement(
	            'div',
	            { className: 'create-form-blitz-step1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section' },
	              type === 'youtube' && _react2.default.createElement(
	                'div',
	                { className: 'form-section' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-section-header' },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'form-section-title' },
	                    'Import from YouTube'
	                  ),
	                  _react2.default.createElement(
	                    'h6',
	                    { className: 'form-section-caption' },
	                    'Enter the YouTube URL to import metadata from a YouTube link.'
	                  )
	                ),
	                _react2.default.createElement(_reduxForm.Field, {
	                  type: 'url',
	                  name: 'url',
	                  placeholder: 'Entry URL',
	                  component: _BasicFormInput2.default,
	                  controlId: 'entryURL',
	                  label: 'Entry URL'
	                }),
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    className: 'button-primary create-form-button-editor clearfix',
	                    type: 'button',
	                    disabled: this.props.loadParseUrl,
	                    onClick: function onClick() {
	                      return _this4.props.parseEntryFromUrl(_this4.props.url);
	                    }
	                  },
	                  'Parse from URL'
	                ),
	                loadParseUrl && _react2.default.createElement(_SpinLoader2.default, null)
	              ),
	              _react2.default.createElement(_reduxForm.Field, {
	                type: 'text',
	                name: 'title',
	                placeholder: 'Title',
	                component: _BasicFormInput2.default,
	                controlId: 'entryTitle',
	                label: 'Entry Title',
	                normalize: _utils.normalizeQuotes
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'description',
	                component: _FormTextArea2.default,
	                label: 'Description',
	                normalize: _utils.normalizeQuotes
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'share_description',
	                component: _FormTextArea2.default,
	                label: 'Share Description (FB/Twitter) (Optional)',
	                normalize: _utils.normalizeQuotes
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section create-form-editor' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Start Writing'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'form-section-caption' },
	                  'Click the button below to write or edit your content.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { className: 'button-primary create-form-button-editor clearfix', onClick: this.toggleEditorButton, type: 'button' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'button-caption' },
	                  'Open Editor'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'button-icon' },
	                  _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/open_editor.png', alt: 'editor button' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section create-form-image' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Set Cover Image'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'form-section-caption' },
	                  'Upload a cover image or paste an image URL.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'create-form-image-content clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'create-form-image-item clearfix' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    label: 'Cover Image',
	                    name: 'cover_image',
	                    component: _BasicFormInput2.default,
	                    controlId: 'coverImage',
	                    format: _utils.formatTopImage
	                  }),
	                  _react2.default.createElement(_FileToUrl2.default, { onUrlChange: function onUrlChange(newUrl) {
	                      return change('cover_image', newUrl);
	                    } }),
	                  (0, _utils.formatTopImage)(cover_image) && _react2.default.createElement('img', { className: 'create-form-image-thumbnail', src: (0, _utils.formatTopImage)(cover_image), role: 'presentation' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'create-form-image-item clearfix' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    label: 'Share Image - For FB/Twitter Previews',
	                    name: 'top_image',
	                    component: _BasicFormInput2.default,
	                    controlId: 'topImage',
	                    format: _utils.formatTopImage
	                  }),
	                  _react2.default.createElement(_FileToUrl2.default, { onUrlChange: function onUrlChange(newUrl) {
	                      return change('top_image', newUrl);
	                    } }),
	                  (0, _utils.formatTopImage)(top_image) && _react2.default.createElement('img', { className: 'create-form-image-thumbnail', src: (0, _utils.formatTopImage)(top_image), role: 'presentation' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Metadata'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-section-content-row form-section-metadata-row clearfix' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    label: 'Author',
	                    name: 'author_id',
	                    component: _FormSelect2.default,
	                    options: authors
	                  }),
	                  _react2.default.createElement(_reduxForm.Field, {
	                    label: 'Esport',
	                    name: 'esport',
	                    component: _FormSelect2.default,
	                    options: _constants.ESPORT_TYPE_OPTIONS
	                  }),
	                  _react2.default.createElement(_reduxForm.Field, {
	                    label: 'Type',
	                    name: 'type',
	                    component: _FormSelect2.default,
	                    options: _constants.BLITZ_ENTRY_TYPE_OPTIONS
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-section-content-row form-section-metadata-row clearfix' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    type: 'text',
	                    name: 'related_match',
	                    component: _BasicFormInput2.default,
	                    controlId: 'relatedMatch',
	                    label: 'Related Match ID'
	                  }),
	                  _react2.default.createElement(_reduxForm.Field, {
	                    type: 'text',
	                    name: 'related_tournament',
	                    component: _BasicFormInput2.default,
	                    controlId: 'relatedTournament',
	                    label: 'Related Tournament ID'
	                  })
	                )
	              )
	            )
	          ) : null,
	          step === 2 ? _react2.default.createElement(
	            'div',
	            { className: 'create-form-blitz-step2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section form-section-finishing-touch' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header clearfix' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Finishing Touch'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-content clearfix' },
	                entry_id ? _react2.default.createElement(
	                  'div',
	                  { className: 'form-tag' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    'Tags'
	                  ),
	                  _react2.default.createElement(_reactSelect.AsyncCreatable, {
	                    loadOptions: getTagOptions,
	                    ignoreCase: false,
	                    onChange: this.createTag,
	                    value: tags,
	                    multi: true
	                  })
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-custom-link clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-custom-link-content clearfix' },
	                    _react2.default.createElement(_reduxForm.Field, {
	                      type: 'text',
	                      name: 'slash_tag',
	                      placeholder: 'short-url (optional)',
	                      component: _BasicFormInput2.default,
	                      controlId: 'entrySlashTag',
	                      label: 'Rebrandly URL Shortener'
	                    }),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        className: 'button-secondary form-custom-link-action',
	                        disabled: loadRebrandly,
	                        onClick: handleSubmit(function (v) {
	                          return onSubmit(v).then(function (resp) {
	                            _this4.generateLink(resp, slash_tag, title);
	                            return resp;
	                          }).then(function (resp) {
	                            return _reactRouter.browserHistory.push('/entries/blitz/' + resp.data.data.id + '?step=2');
	                          });
	                        }),
	                        type: 'button'
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'button-caption' },
	                        'Generate Link'
	                      )
	                    ),
	                    loadRebrandly && _react2.default.createElement(_SpinLoader2.default, { style: { marginTop: '38px' } })
	                  ),
	                  _react2.default.createElement(_reduxForm.Field, {
	                    type: 'url',
	                    name: 'short_url',
	                    readOnly: true,
	                    component: _BasicFormInput2.default,
	                    controlId: 'entryShortURL'
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-publish-date clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-publish-date clearfix' },
	                    _react2.default.createElement(_reduxForm.Field, {
	                      label: 'Publish Date',
	                      name: 'publish_date',
	                      component: _FormDateTime2.default,
	                      format: function format(value) {
	                        return value && (0, _moment2.default)(value);
	                      },
	                      controlId: 'entryPublishDate'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-show-rss' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    type: 'checkbox',
	                    name: 'show_rss',
	                    placeholder: 'Show on RSS Feed',
	                    component: _BasicFormInput2.default,
	                    controlId: 'show_rss',
	                    label: 'Show on RSS',
	                    normalize: function normalize(v) {
	                      return !!v;
	                    }
	                  })
	                ),
	                _react2.default.createElement('hr', null),
	                type === 'youtube' && _react2.default.createElement(
	                  'div',
	                  { className: 'form-show-rss' },
	                  _react2.default.createElement(_reduxForm.Field, {
	                    type: 'checkbox',
	                    name: 'yt_publish',
	                    normalize: function normalize(v) {
	                      return !!v;
	                    },
	                    placeholder: 'Re-List on Youtube',
	                    component: _BasicFormInput2.default,
	                    controlId: 'show_youtube',
	                    label: 'Automatically Publish Video on Youtube - This will run 3 minutes after the publish date so Corylulu can post to Reddit.'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section form-section-website clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header clearfix' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Website'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-section-published-state clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-section-published-icon' },
	                    _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/check.png', role: 'presentation' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-section-published-caption' },
	                    'Published'
	                  )
	                )
	              ),
	              _react2.default.createElement(_PublishingField2.default, Object.assign({}, this.props, { dateFieldName: 'publish_date', publishFieldName: 'show_web', copy: this.copy }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section form-section-app clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header clearfix' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'App'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-section-published-state clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-section-published-icon' },
	                    _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/check.png', role: 'presentation' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-section-published-caption' },
	                    'Published'
	                  )
	                )
	              ),
	              _react2.default.createElement(_PublishingField2.default, Object.assign({}, this.props, { dateFieldName: 'publish_date', publishFieldName: 'show_mobile', copy: this.copy }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section form-section-twitter clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header clearfix' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Twitter'
	                )
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'form-section-caption' },
	                'Auto Tweet this entry at the Publish Time.'
	              ),
	              _react2.default.createElement('br', null),
	              twitter_id ? _react2.default.createElement(_TwitterPublished2.default, { image: twitter_image_url, date: twitter_publish_date, message: twitter_message }) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_PublishingField2.default, Object.assign({}, this.props, { dateFieldName: 'twitter_publish_date', publishFieldName: 'twitter_publish', copy: this.copy })),
	                _react2.default.createElement(_TwitterField2.default, Object.assign({ formatTopImage: _utils.formatTopImage }, this.props, { twitter_publish: twitter_publish })),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'form-section-caption' },
	                  '[Optional] The image that should be shared on Twitter. URL\'s should go directly in the tweet.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section form-section-facebook clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-header clearfix' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-section-title' },
	                  'Facebook'
	                )
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'form-section-caption' },
	                'Auto Post this entry to Facebook at the Publish Time.'
	              ),
	              _react2.default.createElement('br', null),
	              fb_id ? _react2.default.createElement(_FacebookPublished2.default, { date: fb_publish_date, message: fb_message, link: fb_link }) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_PublishingField2.default, Object.assign({}, this.props, { dateFieldName: 'fb_publish_date', publishFieldName: 'fb_publish', copy: this.copy })),
	                _react2.default.createElement(_reduxForm.Field, { name: 'fb_message', component: _FormTextArea2.default, required: fb_publish, label: 'Message' }),
	                _react2.default.createElement(_reduxForm.Field, { name: 'fb_link', component: _BasicFormInput2.default, label: 'Link' }),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'form-section-caption' },
	                  '[Optional] The link that should be previewed on the facebook post. Paste a URL here.'
	                )
	              )
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'create-entry-sidebar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'create-entry-action' },
	            step === 2 ? _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                type: 'submit',
	                className: 'button-primary button-full create-entry-publish',
	                disabled: submitting
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'button-icon' },
	                _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/publish.png', role: 'presentation' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'button-caption' },
	                'Publish'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              {
	                className: 'button-primary button-full create-entry-next', onClick: function onClick() {
	                  return _this4.setStep(2);
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'button-caption' },
	                'Next Step'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'button-icon' },
	                _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/arrow_right.png', role: 'presentation' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                className: 'button-secondary button-full create-entry-draft',
	                onClick: handleSubmit(function (v) {
	                  return onSubmit(Object.assign(v, { published: false })).then(function () {
	                    return _reactRouter.browserHistory.push('/entries/blitz');
	                  });
	                }),
	                disabled: submitting
	              },
	              published ? 'Unpublish' : 'Save as Draft'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                disabled: submitting,
	                onClick: handleSubmit(function (v) {
	                  return onSubmit(v).then(function (r) {
	                    window.open((0, _utils.generateEntrySlug)(r.data.data, false, true));
	                    return r;
	                  }).then(function (r) {
	                    return _reactRouter.browserHistory.push('/entries/blitz/' + r.data.data.id);
	                  });
	                }),
	                className: 'button-secondary button-full create-entry-preview'
	              },
	              'Preview'
	            ),
	            entry_id ? _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                type: 'button',
	                onClick: this.onDeleteClick,
	                className: 'button-secondary button-full create-entry-delete',
	                bsStyle: 'danger'
	              },
	              'Delete'
	            ) : null
	          ),
	          _react2.default.createElement(_PublishSchedule2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return BlitzEntryForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state) {
	  return {
	    entry_id: selector(state, 'id'),
	    tags: selector(state, 'tags'),
	    type: selector(state, 'type') || 'article',
	    published: selector(state, 'published'),
	    cover_image: selector(state, 'cover_image'),
	    top_image: selector(state, 'top_image'),
	    title: selector(state, 'title'),
	    slash_tag: selector(state, 'slash_tag'),
	    url: selector(state, 'url'),
	    twitter_image_url: selector(state, 'twitter_image_url'),
	    twitter_message: selector(state, 'twitter_message'),
	    twitter_publish: selector(state, 'twitter_publish'),
	    twitter_publish_date: selector(state, 'twitter_publish_date'),
	    fb_publish: selector(state, 'fb_publish'),
	    fb_publish_date: selector(state, 'fb_publish_date'),
	    twitter_id: selector(state, 'twitter_id'),
	    fb_message: selector(state, 'fb_message'),
	    fb_id: selector(state, 'fb_id'),
	    fb_link: selector(state, 'fb_link')
	  };
	}
	
	BlitzEntryForm = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({
	  form: 'generic-entry',
	  validate: validate,
	  enableReinitialize: true,
	  destroyOnUnmount: false,
	  onSubmitFail: onSubmitFail
	})(BlitzEntryForm));
	
	BlitzEntryForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  entry_id: _propTypes2.default.number,
	  change: _propTypes2.default.func,
	  tags: _propTypes2.default.array,
	  url: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  submitting: _propTypes2.default.bool,
	  published: _propTypes2.default.bool,
	  router: _propTypes2.default.object,
	  routes: _propTypes2.default.array,
	  loadParseUrl: _propTypes2.default.bool,
	  parseEntryFromUrl: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRouter.withRouter)(BlitzEntryForm);

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactSelect = __webpack_require__(175);
	
	var _draftJs = __webpack_require__(42);
	
	var _draftConvert = __webpack_require__(187);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	__webpack_require__(457);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _FormSelect = __webpack_require__(107);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormDateTime = __webpack_require__(292);
	
	var _FormDateTime2 = _interopRequireDefault(_FormDateTime);
	
	var _FormEditor = __webpack_require__(295);
	
	var _FormEditor2 = _interopRequireDefault(_FormEditor);
	
	var _FormTextArea = __webpack_require__(185);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	var _constants = __webpack_require__(44);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(65);
	
	var _utils2 = __webpack_require__(32);
	
	var _FileToUrl = __webpack_require__(184);
	
	var _FileToUrl2 = _interopRequireDefault(_FileToUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getTagOptions = function getTagOptions(input) {
	  return _BlitzAPI2.default.getTags({ name: input }).then(function (resp) {
	    return resp.data.data.map(function (tag) {
	      return { value: tag.id, label: tag.name };
	    });
	  }).then(function (data) {
	    return { options: data };
	  });
	};
	
	var ExternalEntryForm = function (_Component) {
	  _inherits(ExternalEntryForm, _Component);
	
	  function ExternalEntryForm(props) {
	    _classCallCheck(this, ExternalEntryForm);
	
	    var _this = _possibleConstructorReturn(this, (ExternalEntryForm.__proto__ || Object.getPrototypeOf(ExternalEntryForm)).call(this, props));
	
	    var tags = props.tags && props.tags.map(function (tag) {
	      return { label: tag.name, value: tag.id };
	    });
	
	    _this.state = {
	      sources: 11,
	      useEditor: false,
	      showOutput: false,
	      authors: null,
	      tags: tags,
	      type: 'article'
	    };
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    _this.onEditorDataChange = _this.onEditorDataChange.bind(_this);
	    _this.toggleEditorButton = _this.toggleEditorButton.bind(_this);
	    _this.toggleOutputButton = _this.toggleOutputButton.bind(_this);
	    _this.createTag = _this.createTag.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExternalEntryForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getSources().then(function (response) {
	        var sourceOptions = (0, _utils.getSourceOptions)(response);
	        _this2.setState({
	          sources: sourceOptions
	        });
	      });
	      _BlitzAPI2.default.getUsers().then(function (response) {
	        var userOptions = (0, _utils.getUserOptions)(response);
	        _this2.setState({
	          authors: userOptions
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.tags !== nextProps.tags) {
	        var tags = nextProps.tags && nextProps.tags.map(function (tag) {
	          return { label: tag.name, value: tag.id };
	        }) || [];
	        this.setState({ tags: tags });
	      }
	    }
	  }, {
	    key: 'onDeleteClick',
	    value: function onDeleteClick() {
	      if (confirm('Delete this entry?')) {
	        _BlitzAPI2.default.deleteEntry(this.props.entry_id).then(function () {
	          return _reactRouter.browserHistory.push('/entries/external');
	        });
	      }
	    }
	  }, {
	    key: 'onEditorDataChange',
	    value: function onEditorDataChange(event, newValue, previousValue) {
	      var editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(newValue));
	      var contentState = editorState.getCurrentContent();
	      var html = (0, _draftConvert.convertToHTML)(_constants.CONVERT_HTML_OPTIONS)(contentState);
	
	      this.props.change('content', html);
	    }
	  }, {
	    key: 'createTag',
	    value: function createTag(val) {
	      var entry_id = this.props.entry_id;
	      var tags = this.state.tags;
	
	      if (tags && tags.length > val.length) {
	        var deleted = tags.filter(function (x) {
	          return !new Set(val).has(x);
	        })[0];
	        _BlitzAPI2.default.deleteEntryTag({ entry_id: entry_id, tag_id: deleted.value });
	      } else {
	        var newItem = val.filter(function (x) {
	          return !new Set(tags).has(x);
	        })[0];
	        if (!Number.isInteger(newItem.value)) {
	          _BlitzAPI2.default.postTag({ tag: { name: newItem.label } }).then(function (resp) {
	            return _BlitzAPI2.default.postEntryTag({ entry_id: entry_id, tag_id: resp.data.data.id });
	          });
	        } else {
	          _BlitzAPI2.default.postEntryTag({ entry_id: entry_id, tag_id: newItem.value });
	        }
	      }
	
	      this.setState({ tags: val });
	    }
	  }, {
	    key: 'toggleEditorButton',
	    value: function toggleEditorButton() {
	      this.setState({ useEditor: !this.state.useEditor });
	    }
	  }, {
	    key: 'toggleOutputButton',
	    value: function toggleOutputButton() {
	      this.setState({ showOutput: !this.state.showOutput });
	    }
	  }, {
	    key: 'onTypeChange',
	    value: function onTypeChange(e, field) {
	      var change = this.props.change;
	
	      change(field, e.target.value);
	      this.setState({
	        type: e.target.value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          onSubmit = _props.onSubmit,
	          submitting = _props.submitting,
	          published = _props.published,
	          url = _props.url,
	          type = _props.type,
	          change = _props.change,
	          top_image = _props.top_image,
	          cover_image = _props.cover_image,
	          entry_id = _props.entry_id;
	      var _state = this.state,
	          tags = _state.tags,
	          sources = _state.sources,
	          authors = _state.authors;
	
	      if (!(sources && authors)) {
	        return _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        );
	      }
	
	      return _react2.default.createElement(
	        'form',
	        {
	          onSubmit: handleSubmit(function (v) {
	            return onSubmit(Object.assign(v, { published: true })).then(function () {
	              return _reactRouter.browserHistory.push('/entries/external');
	            });
	          }),
	          className: 'create-form-blitz'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'create-form-blitz-content ' + (entry_id ? 'create-form-blitz-content-edit' : '') },
	          _react2.default.createElement(_reduxForm.Field, {
	            label: 'Entry Type',
	            name: 'type',
	            component: function component() {
	              return _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { className: 'create-form-type clearfix' },
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onTypeChange(e, 'type');
	                    },
	                    name: 'type', value: 'article', checked: type === 'article' // eslint-disable-line camelcase
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Article'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onTypeChange(e, 'type');
	                    },
	                    name: 'type', value: 'youtube', checked: type === 'youtube' // eslint-disable-line camelcase
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Video'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onTypeChange(e, 'type');
	                    },
	                    name: 'type', value: 'feed', checked: type === 'feed' // eslint-disable-line camelcase
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Blitzfeed'
	                  )
	                )
	              );
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section form-section-import' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-header' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-section-title' },
	                'Import from a URL'
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'form-section-caption' },
	                'Enter the URL of the external content to automatically fill out metadata.'
	              )
	            ),
	            _react2.default.createElement(_reduxForm.Field, {
	              type: 'url',
	              name: 'url',
	              placeholder: 'Entry URL',
	              component: _BasicFormInput2.default,
	              controlId: 'entryURL',
	              label: 'Entry URL'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(_reduxForm.Field, {
	              type: 'text',
	              name: 'title',
	              placeholder: 'Title',
	              component: _BasicFormInput2.default,
	              controlId: 'entryTitle',
	              label: 'Entry Title',
	              normalize: _utils2.normalizeQuotes
	            }),
	            this.state.type !== 'feed' ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'description',
	              component: _FormTextArea2.default,
	              label: 'Description',
	              normalize: _utils2.normalizeQuotes
	            }) : null,
	            this.state.type !== 'feed' ? _react2.default.createElement(_reduxForm.Field, {
	              name: 'share_description',
	              component: _FormTextArea2.default,
	              label: 'Share Description (FB/Twitter) (Optional)',
	              normalize: _utils2.normalizeQuotes
	            }) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section create-form-editor ' + (type !== 'feed' ? 'form-section-hidden' : '') },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-header' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-section-title' },
	                'Start Writing'
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'form-section-caption' },
	                'Click the button below to write or edit your content.'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { className: 'button-primary create-form-button-editor', onClick: this.toggleEditorButton, type: 'button' },
	              'Toggle Editor'
	            ),
	            this.state.useEditor ?
	            // TOGGLE THE EDITOR BASED ON THE BTUTON
	            _react2.default.createElement(
	              'div',
	              { className: 'create-form-editor-content ' + (this.state.showOutput ? 'create-form-editor-output-active' : '') },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'data',
	                component: _FormEditor2.default,
	                onChange: this.onEditorDataChange
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'content',
	                component: _FormTextArea2.default,
	                disabled: this.state.useEditor
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'create-form-editor-output', onClick: this.toggleOutputButton },
	                this.state.showOutput ? 'Hide code output' : 'Show code output'
	              )
	            ) : _react2.default.createElement(_reduxForm.Field, {
	              name: 'data',
	              component: _FormTextArea2.default,
	              className: 'create-form-editor-placeholder'
	            })
	          ),
	          this.state.type !== 'feed' ? _react2.default.createElement(
	            'div',
	            { className: 'form-section create-form-image' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-header' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-section-title' },
	                'Set Cover Image'
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'form-section-caption' },
	                'Upload a cover image or paste an image URL.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'create-form-image-content clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'create-form-image-item clearfix' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  label: 'Cover Image',
	                  name: 'cover_image',
	                  component: _BasicFormInput2.default,
	                  controlId: 'coverImage',
	                  format: _utils2.formatTopImage
	                }),
	                _react2.default.createElement(_FileToUrl2.default, { onUrlChange: function onUrlChange(newUrl) {
	                    return change('cover_image', newUrl);
	                  } }),
	                (0, _utils2.formatTopImage)(cover_image) && _react2.default.createElement('img', { className: 'create-form-image-thumbnail', src: (0, _utils2.formatTopImage)(cover_image), role: 'presentation' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'create-form-image-item clearfix' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  label: 'Share Image',
	                  name: 'top_image',
	                  component: _BasicFormInput2.default,
	                  controlId: 'topImage',
	                  format: _utils2.formatTopImage
	                }),
	                _react2.default.createElement(_FileToUrl2.default, { onUrlChange: function onUrlChange(newUrl) {
	                    return change('top_image', newUrl);
	                  } }),
	                (0, _utils2.formatTopImage)(top_image) && _react2.default.createElement('img', { className: 'create-form-image-thumbnail', src: (0, _utils2.formatTopImage)(top_image), role: 'presentation' })
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section form-metadata-external' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-header' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-section-title' },
	                'Metadata'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-content-row clearfix' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  label: 'Publish Date',
	                  name: 'publish_date',
	                  component: _FormDateTime2.default,
	                  format: function format(value) {
	                    return value && (0, _moment2.default)(value);
	                  },
	                  controlId: 'entryPublishDate'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-section-content-row form-section-metadata-row clearfix' },
	                _react2.default.createElement(_reduxForm.Field, {
	                  label: 'Source',
	                  name: 'source_id',
	                  component: _FormSelect2.default,
	                  options: sources
	                }),
	                _react2.default.createElement(_reduxForm.Field, {
	                  label: 'Esport',
	                  name: 'esport',
	                  component: _FormSelect2.default,
	                  options: _constants.ESPORT_TYPE_OPTIONS
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-header' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-section-title' },
	                'Extras'
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'form-section-caption' },
	                'You can set extra information here - these are not required for you to publish.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-content-row form-section-extras-row clearfix' },
	              _react2.default.createElement(_reduxForm.Field, {
	                type: 'checkbox',
	                name: 'show_mobile',
	                placeholder: 'Show on Mobile App',
	                component: _BasicFormInput2.default,
	                normalize: function normalize(v) {
	                  return !!v;
	                },
	                controlId: 'show_mobile',
	                label: 'Show on Mobile App'
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                type: 'checkbox',
	                name: 'show_web',
	                normalize: function normalize(v) {
	                  return !!v;
	                },
	                placeholder: 'Show on Web',
	                component: _BasicFormInput2.default,
	                controlId: 'show_web',
	                label: 'Show on Web'
	              })
	            ),
	            entry_id ? _react2.default.createElement(
	              'div',
	              { className: 'create-entry-tags' },
	              _react2.default.createElement(
	                'label',
	                { className: 'control-label' },
	                'Tags'
	              ),
	              _react2.default.createElement(_reactSelect.AsyncCreatable, {
	                loadOptions: getTagOptions,
	                ignoreCase: false,
	                onChange: this.createTag,
	                value: tags,
	                multi: true
	              })
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'create-entry-sidebar' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              type: 'submit',
	              className: 'button-primary button-full create-entry-publish',
	              disabled: submitting
	            },
	            published ? 'Save' : 'Publish'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary button-full create-entry-draft',
	              onClick: handleSubmit(function (v) {
	                return onSubmit(Object.assign(v, { published: false })).then(function () {
	                  return _reactRouter.browserHistory.push('/entries/external');
	                });
	              }),
	              disabled: submitting
	            },
	            published ? 'Unpublish' : 'Save as Draft'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary button-full create-entry-draft',
	              disabled: submitting,
	              onClick: handleSubmit(function (v) {
	                return onSubmit(v).then(function (resp) {
	                  return _reactRouter.browserHistory.push('/entries/external/' + resp.data.data.id);
	                });
	              })
	            },
	            'Save and Continue'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              disabled: submitting,
	              onClick: function onClick() {
	                return window.open(url);
	              },
	              className: 'button-secondary button-full create-entry-preview'
	            },
	            'Preview'
	          ),
	          entry_id ? _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              type: 'button',
	              onClick: this.onDeleteClick,
	              className: 'button-secondary button-full create-entry-delete',
	              bsStyle: 'danger'
	            },
	            'Delete'
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return ExternalEntryForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state) {
	  return {
	    entry_id: selector(state, 'id'),
	    tags: selector(state, 'tags'),
	    type: selector(state, 'type') || 'article',
	    url: selector(state, 'url'),
	    published: selector(state, 'published'),
	    cover_image: selector(state, 'cover_image'),
	    top_image: selector(state, 'top_image')
	  };
	}
	
	ExternalEntryForm = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({ form: 'generic-entry', enableReinitialize: true })(ExternalEntryForm));
	
	ExternalEntryForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  entry_id: _propTypes2.default.number,
	  change: _propTypes2.default.func,
	  tags: _propTypes2.default.array,
	  url: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  published: _propTypes2.default.bool,
	  submitting: _propTypes2.default.bool
	};
	
	exports.default = ExternalEntryForm;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatetime = __webpack_require__(668);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	__webpack_require__(456);
	
	__webpack_require__(1026);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormDateTime = function (_Component) {
	  _inherits(FormDateTime, _Component);
	
	  function FormDateTime(props) {
	    _classCallCheck(this, FormDateTime);
	
	    var _this = _possibleConstructorReturn(this, (FormDateTime.__proto__ || Object.getPrototypeOf(FormDateTime)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(FormDateTime, [{
	    key: 'onChange',
	    value: function onChange(time) {
	      console.log(time);
	      return this.props.input.onChange(time.toISOString());
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(time) {
	      return this.onChange(time);
	    }
	  }, {
	    key: 'onNext',
	    value: function onNext(hour, min) {
	      var now = (0, _moment2.default)();
	      var a = (0, _moment2.default)().hour(10).minute(30);
	      var b = (0, _moment2.default)().add(1, 'd').hour(hour).minute(min);
	      this.onClick(a.isBefore(now) ? b : a);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          label = _props.label,
	          input = _props.input,
	          controlId = _props.controlId;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        { controlId: controlId || '' },
	        _react2.default.createElement(
	          _reactBootstrap.ControlLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { flexDirection: 'row', display: 'flex' } },
	          _react2.default.createElement(_reactDatetime2.default, { value: input.value, dateFormat: true, onChange: this.onChange }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary form-datetime-option-button',
	              type: 'button', onClick: function onClick() {
	                return _this2.onClick((0, _moment2.default)());
	              }
	            },
	            'Now'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary form-datetime-option-button',
	              type: 'button',
	              onClick: function onClick() {
	                return _this2.onNext(10, 0);
	              }
	            },
	            '10:00 AM'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary form-datetime-option-button',
	              type: 'button',
	              onClick: function onClick() {
	                return _this2.onNext(10, 30);
	              }
	            },
	            '10:30 AM'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary form-datetime-option-button',
	              type: 'button',
	              onClick: function onClick() {
	                return _this2.onNext(11, 0);
	              }
	            },
	            '11:00 AM'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'button-secondary form-datetime-option-button',
	              type: 'button',
	              onClick: function onClick() {
	                return _this2.onNext(11, 30);
	              }
	            },
	            '11:30 AM'
	          )
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null)
	      );
	    }
	  }]);
	
	  return FormDateTime;
	}(_react.Component);
	
	exports.default = FormDateTime;
	
	
	FormDateTime.propTypes = {
	  label: _propTypes2.default.string,
	  controlId: _propTypes2.default.string,
	  input: _propTypes2.default.object,
	  copy: _propTypes2.default.func
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactDatetime = __webpack_require__(668);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableDatetimeEditor = function (_Component) {
	  _inherits(TableDatetimeEditor, _Component);
	
	  function TableDatetimeEditor(props) {
	    _classCallCheck(this, TableDatetimeEditor);
	
	    var _this = _possibleConstructorReturn(this, (TableDatetimeEditor.__proto__ || Object.getPrototypeOf(TableDatetimeEditor)).call(this, props));
	
	    _this.updateData = _this.updateData.bind(_this);
	    _this.state = { datetime: props.defaultValue };
	    _this.onButtonClick = _this.onButtonClick.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(TableDatetimeEditor, [{
	    key: 'onButtonClick',
	    value: function onButtonClick() {
	      var time = (0, _moment2.default)().toISOString();
	      this.setState({ datetime: time });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(time) {
	      var output = typeof time === 'string' ? time : time.toISOString();
	      this.setState({ datetime: output });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(e) {
	      var _this2 = this;
	
	      var currentTarget = e.currentTarget;
	      console.log(currentTarget);
	
	      setTimeout(function () {
	        if (!currentTarget.contains(document.activeElement)) {
	          console.log('component officially blurred');
	          _this2.updateData();
	        }
	      }, 0);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {}
	  }, {
	    key: 'updateData',
	    value: function updateData() {
	      this.props.onUpdate(this.state.datetime);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { tabIndex: '-1', onBlur: this.onBlur },
	        _react2.default.createElement(_reactDatetime2.default, { value: this.state.datetime, onChange: this.onChange }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { onClick: this.onButtonClick },
	          'Now'
	        )
	      );
	    }
	  }]);
	
	  return TableDatetimeEditor;
	}(_react.Component);
	
	exports.default = TableDatetimeEditor;
	
	
	TableDatetimeEditor.propTypes = {
	  onUpdate: _propTypes2.default.func,
	  defaultValue: _propTypes2.default.string
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reduxForm = __webpack_require__(31);
	
	var _draftJs = __webpack_require__(42);
	
	var _draftConvert = __webpack_require__(187);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _constants = __webpack_require__(44);
	
	var _FormEditor = __webpack_require__(295);
	
	var _FormEditor2 = _interopRequireDefault(_FormEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlitzEditor = function (_Component) {
	  _inherits(BlitzEditor, _Component);
	
	  function BlitzEditor(props) {
	    _classCallCheck(this, BlitzEditor);
	
	    var _this = _possibleConstructorReturn(this, (BlitzEditor.__proto__ || Object.getPrototypeOf(BlitzEditor)).call(this, props));
	
	    _this.state = {
	      showCode: false
	    };
	
	    _this.onEditorDataChange = _this.onEditorDataChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(BlitzEditor, [{
	    key: 'onEditorDataChange',
	    value: function onEditorDataChange(event, newValue, previousValue) {
	      var change = this.props.change;
	
	      var editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(newValue));
	      var contentState = editorState.getCurrentContent();
	      var html = (0, _draftConvert.convertToHTML)(_constants.CONVERT_HTML_OPTIONS)(contentState);
	
	      change('content', html);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          content = _props.content,
	          toggleEditorButton = _props.toggleEditorButton,
	          save = _props.save,
	          title = _props.title,
	          description = _props.description,
	          preview = _props.preview;
	      var showCode = this.state.showCode;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'blitz-editor' },
	        _react2.default.createElement(
	          'div',
	          { className: 'blitz-editor-header clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'blitz-editor-header-logo' },
	            _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/logo.png', role: 'presentation' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'blitz-editor-header-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'blitz-editor-header-title' },
	              title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'blitz-editor-header-action clearfix' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                className: 'blitz-editor-header-save button-primary',
	                onClick: function onClick() {
	                  toggleEditorButton();
	                  save();
	                }
	              },
	              'Save'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { className: 'blitz-editor-header-preview button-secondary', onClick: preview },
	              'Preview'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blitz-editor-content' },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'data',
	            component: _FormEditor2.default,
	            onChange: this.onEditorDataChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blitz-editor-output' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'blitz-editor-output-toggle button-secondary',
	              onClick: function onClick() {
	                return _this2.setState({ showCode: !showCode });
	              }
	            },
	            'Toggle Code Output'
	          ),
	          showCode && _react2.default.createElement(
	            'div',
	            { className: 'blitz-editor-output-dock' },
	            _react2.default.createElement(
	              'div',
	              { className: 'blitz-editor-output-dock-header' },
	              'Code Output'
	            ),
	            _react2.default.createElement(
	              'pre',
	              { className: 'blitz-editor-output-dock-content' },
	              content
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BlitzEditor;
	}(_react.Component);
	
	BlitzEditor.propTypes = {
	  change: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  preview: _propTypes2.default.func,
	  content: _propTypes2.default.string,
	  toggleEditorButton: _propTypes2.default.func,
	  save: _propTypes2.default.func
	};
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state) {
	  return {
	    entry_id: selector(state, 'id'),
	    title: selector(state, 'title'),
	    description: selector(state, 'description'),
	    content: selector(state, 'content')
	  };
	}
	
	BlitzEditor = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({
	  form: 'generic-entry',
	  enableReinitialize: true,
	  destroyOnUnmount: false
	})(BlitzEditor));
	
	exports.default = BlitzEditor;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _docsSoap = __webpack_require__(907);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(16);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _draftJs = __webpack_require__(42);
	
	var _draftJs2 = _interopRequireDefault(_draftJs);
	
	var _browserImageSize = __webpack_require__(299);
	
	var _browserImageSize2 = _interopRequireDefault(_browserImageSize);
	
	var _draftJsCode = __webpack_require__(927);
	
	var _draftJsCode2 = _interopRequireDefault(_draftJsCode);
	
	var _BlockStyleControls = __webpack_require__(818);
	
	var _BlockStyleControls2 = _interopRequireDefault(_BlockStyleControls);
	
	var _HeadingStyleControls = __webpack_require__(826);
	
	var _HeadingStyleControls2 = _interopRequireDefault(_HeadingStyleControls);
	
	var _InlineStyleControls = __webpack_require__(827);
	
	var _InlineStyleControls2 = _interopRequireDefault(_InlineStyleControls);
	
	var _EditorLink = __webpack_require__(822);
	
	var _EditorLink2 = _interopRequireDefault(_EditorLink);
	
	var _EditorImageControls = __webpack_require__(821);
	
	var _EditorImageControls2 = _interopRequireDefault(_EditorImageControls);
	
	var _EditorYoutubeEmbedControls = __webpack_require__(825);
	
	var _EditorYoutubeEmbedControls2 = _interopRequireDefault(_EditorYoutubeEmbedControls);
	
	var _EditorTweetEmbedControls = __webpack_require__(824);
	
	var _EditorTweetEmbedControls2 = _interopRequireDefault(_EditorTweetEmbedControls);
	
	var _EditorImage = __webpack_require__(820);
	
	var _EditorImage2 = _interopRequireDefault(_EditorImage);
	
	var _EditorHTML = __webpack_require__(819);
	
	var _EditorHTML2 = _interopRequireDefault(_EditorHTML);
	
	var _EditorLinkDisplay = __webpack_require__(823);
	
	var _EditorLinkDisplay2 = _interopRequireDefault(_EditorLinkDisplay);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	__webpack_require__(1028);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getBlockStyle(block) {
	  switch (block.getType()) {
	    case 'blockquote':
	      return 'entry-editor-blockquote';
	    default:
	      return null;
	  }
	}
	
	var blockRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(_immutable2.default.Map({
	  atomic: {
	    element: 'div'
	  },
	  'code-block': {
	    element: 'div'
	  }
	}));
	
	var styleMap = {
	  CODE: {
	    backgroundColor: 'rgba(0, 0, 0, 0.05)',
	    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
	    fontSize: 16,
	    padding: 2
	  }
	};
	
	function findLinkEntities(contentBlock, callback, contentState) {
	  contentBlock.findEntityRanges(function (character) {
	    var entityKey = character.getEntity();
	    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
	  }, callback);
	}
	
	var FormEditor = function (_Component) {
	  _inherits(FormEditor, _Component);
	
	  function FormEditor(props) {
	    _classCallCheck(this, FormEditor);
	
	    var _this = _possibleConstructorReturn(this, (FormEditor.__proto__ || Object.getPrototypeOf(FormEditor)).call(this, props));
	
	    _this.onTab = _this.onTab.bind(_this);
	    _this.handleKeyCommand = _this.handleKeyCommand.bind(_this);
	    _this.toggleBlockType = _this.toggleBlockType.bind(_this);
	    _this.toggleInlineStyle = _this.toggleInlineStyle.bind(_this);
	    _this.onLinkCreate = _this.onLinkCreate.bind(_this);
	    _this.onLinkRemove = _this.onLinkRemove.bind(_this);
	    _this.onImageAdd = _this.onImageAdd.bind(_this);
	    _this.onYoutubeAdd = _this.onYoutubeAdd.bind(_this);
	    _this.onTweetAdd = _this.onTweetAdd.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.handleDrop = _this.handleDrop.bind(_this);
	    _this.handleReturn = _this.handleReturn.bind(_this);
	    _this.keyBindingFn = _this.keyBindingFn.bind(_this);
	    _this.handleBeforeInput = _this.handleBeforeInput.bind(_this);
	    _this.handlePastedText = _this.handlePastedText.bind(_this);
	    _this.blockRenderer = _this.blockRenderer.bind(_this);
	    _this.setReadOnly = _this.setReadOnly.bind(_this);
	    _this.resetSelection = _this.resetSelection.bind(_this);
	    _this.setSelection = _this.setSelection.bind(_this);
	    _this.handleDroppedFiles = _this.handleDroppedFiles.bind(_this);
	    _this.decorator = new _draftJs.CompositeDecorator([{
	      strategy: findLinkEntities,
	      component: _EditorLinkDisplay2.default
	    }]);
	
	    var editorState = void 0;
	
	    if (_this.props.input.value) {
	      editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(_this.props.input.value), _this.decorator);
	    } else {
	      editorState = _draftJs.EditorState.createEmpty(_this.decorator);
	    }
	
	    _this.state = {
	      editorState: editorState,
	      readOnly: false
	    };
	
	    // Take the input value and convert into the component state. Then onComponent Blur,
	    // update the original value.
	    return _this;
	  }
	
	  _createClass(FormEditor, [{
	    key: 'onBlur',
	    value: function onBlur() {
	      var contentState = this.state.editorState.getCurrentContent();
	      this.props.input.onChange((0, _draftJs.convertToRaw)(contentState));
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(editorState, cb) {
	      this.setState({ editorState: editorState }, cb);
	    }
	  }, {
	    key: 'onTab',
	    value: function onTab(e) {
	      var maxDepth = 4;
	      this.props.input.onChange(_draftJs.RichUtils.onTab(e, this.props.input.value, maxDepth));
	    }
	  }, {
	    key: 'onLinkCreate',
	    value: function onLinkCreate(urlValue) {
	      var _this2 = this;
	
	      var editorState = this.state.editorState;
	
	      var selection = editorState.getSelection();
	      var entityKey = _draftJs.Entity.create('LINK', 'MUTABLE', { url: urlValue });
	      var newState = _draftJs.RichUtils.toggleLink(editorState, selection, entityKey);
	      this.setState({ editorState: newState }, function () {
	        return setTimeout(function () {
	          return _this2.editorRef.focus();
	        }, 0);
	      });
	    }
	  }, {
	    key: 'onLinkRemove',
	    value: function onLinkRemove() {
	      var editorState = this.state.editorState;
	
	      var selection = editorState.getSelection();
	      var newState = _draftJs.RichUtils.toggleLink(editorState, selection, null);
	      this.onChange(newState);
	    }
	  }, {
	    key: 'onImageAdd',
	    value: function onImageAdd(url, caption, style, alt, size) {
	      var editorState = this.state.editorState;
	
	      var contentState = editorState.getCurrentContent();
	      var contentStateWithEntity = contentState.createEntity('image', 'IMMUTABLE', { src: url, caption: caption, style: style, alt: alt, size: size });
	      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
	      var newEditorState = _draftJs.EditorState.set(editorState, { currentContent: contentStateWithEntity });
	
	      this.setState({
	        editorState: _draftJs.AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' '),
	        showURLInput: false,
	        urlValue: ''
	      });
	    }
	  }, {
	    key: 'onYoutubeAdd',
	    value: function onYoutubeAdd(url) {
	      var editorState = this.state.editorState;
	
	      var contentState = editorState.getCurrentContent();
	      var contentStateWithEntity = contentState.createEntity('youtube', 'IMMUTABLE', { src: url });
	      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
	      var newEditorState = _draftJs.EditorState.set(editorState, { currentContent: contentStateWithEntity });
	
	      this.setState({
	        editorState: _draftJs.AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' '),
	        showURLInput: false,
	        urlValue: ''
	      });
	    }
	  }, {
	    key: 'onTweetAdd',
	    value: function onTweetAdd(url) {
	      var _this3 = this;
	
	      var editorState = this.state.editorState;
	
	      var contentState = editorState.getCurrentContent();
	      _BlitzAPI2.default.getTwitterEmbed({ url: url }).then(function (resp) {
	        var contentStateWithEntity = contentState.createEntity('tweet', 'IMMUTABLE', { src: url, tweet: resp.data });
	        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
	        var newEditorState = _draftJs.EditorState.set(editorState, { currentContent: contentStateWithEntity });
	
	        _this3.setState({
	          editorState: _draftJs.AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' '),
	          showURLInput: false,
	          urlValue: ''
	        });
	      });
	    }
	  }, {
	    key: 'resetSelection',
	    value: function resetSelection() {
	      var editorState = this.state.editorState;
	
	
	      this.onChange(_draftJs.EditorState.moveFocusToEnd(editorState));
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(selection) {
	      var editorState = this.state.editorState;
	
	      this.onChange(_draftJs.EditorState.forceSelection(editorState, selection));
	    }
	  }, {
	    key: 'blockRenderer',
	    value: function blockRenderer(block) {
	      var editorState = this.state.editorState;
	
	      if (block.getType() === 'atomic') {
	        return {
	          component: _EditorImage2.default,
	          props: {
	            editorState: editorState,
	            onEditorChange: this.onChange,
	            selection: editorState.getSelection(),
	            setReadOnly: this.setReadOnly,
	            resetSelection: this.resetSelection,
	            setSelection: this.setSelection
	          }
	        };
	      }
	
	      if (block.getType() === 'code-block') {
	        return {
	          component: _EditorHTML2.default,
	          editable: true
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'setReadOnly',
	    value: function setReadOnly(bool) {
	      this.setState({ readOnly: bool });
	    }
	  }, {
	    key: 'handleReturn',
	    value: function handleReturn(e) {
	      var editorState = this.state.editorState;
	
	      if (e.shiftKey) {
	        console.log('Here in shift key');
	        // Look at the jumping here.
	        this.setState({ editorState: _draftJs.RichUtils.insertSoftNewline(editorState) });
	        return 'handled';
	      }
	      return 'not-handled';
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(selection, dataTransfer, isInternal) {
	      var editorState = this.state.editorState;
	
	      var currentSelection = editorState.getSelection();
	      var contentState = editorState.getCurrentContent();
	      var contentBlock = contentState.getBlockForKey(currentSelection.getFocusKey());
	
	      if (contentBlock) {
	        var blockEntityType = contentBlock.getEntityAt(0);
	        if (!blockEntityType) {
	          return 'handled';
	        }
	        var entity = contentState.getEntity(blockEntityType);
	        if (entity.type === 'image') {
	          this.setState({
	            editorState: _draftJs.AtomicBlockUtils.moveAtomicBlock(editorState, contentBlock, selection)
	          });
	          return 'handled';
	        }
	        return 'not-handled';
	      }
	      return 'not-handled';
	    }
	  }, {
	    key: 'handleKeyCommand',
	    value: function handleKeyCommand(command) {
	      var editorState = this.state.editorState;
	
	      var newState = void 0;
	
	      if (_draftJsCode2.default.hasSelectionInBlock(editorState)) {
	        newState = _draftJsCode2.default.handleKeyCommand(editorState, command);
	      }
	
	      if (!newState) {
	        newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
	      }
	
	      if (newState) {
	        this.onChange(newState);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleBeforeInput',
	    value: function handleBeforeInput(chars) {
	      switch (chars) {
	        case '\u201D':
	        case '\u201C':
	          var editorState = this.state.editorState;
	
	          var selection = editorState.getSelection();
	          var contentState = editorState.getCurrentContent();
	          var newContent = void 0;
	          if (selection.size === 0) {
	            newContent = _draftJs.Modifier.insertText(contentState, selection, '"');
	          } else {
	            newContent = _draftJs.Modifier.replaceText(contentState, selection, '"');
	          }
	          this.onChange(_draftJs.EditorState.push(editorState, newContent, 'insert-characters'));
	          return 'handled';
	        default:
	          return 'not-handled';
	      }
	    }
	  }, {
	    key: 'handlePastedText',
	    value: function handlePastedText(text, html, edState) {
	      if (html && (html.includes('\u201D') || html.includes('\u201C'))) {
	        var newHtml = html.replace('\u201D', '"').replace('\u201C', '"');
	        // Clean the HTML
	
	        var clean = (0, _docsSoap.docsSoap)(newHtml);
	        var editorState = this.state.editorState;
	
	        var selection = editorState.getSelection();
	        var contentState = editorState.getCurrentContent();
	
	        // Convert HTML to ContentState
	        var blocksFromHTML = (0, _draftJs.convertFromHTML)(clean);
	        var tempContentState = _draftJs.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
	
	        // create new content
	        var newContent = _draftJs.Modifier.replaceWithFragment(contentState, selection, tempContentState.getBlockMap());
	
	        this.onChange(_draftJs.EditorState.push(editorState, newContent, 'insert-fragment'));
	      } else if (html) {
	        // Clean the HTML
	
	        var _clean = (0, _docsSoap.docsSoap)(html);
	        var _editorState = this.state.editorState;
	
	        var _selection = _editorState.getSelection();
	        var _contentState = _editorState.getCurrentContent();
	
	        // Convert HTML to ContentState
	        var _blocksFromHTML = (0, _draftJs.convertFromHTML)(_clean);
	        var _tempContentState = _draftJs.ContentState.createFromBlockArray(_blocksFromHTML.contentBlocks, _blocksFromHTML.entityMap);
	
	        // create new content
	        var _newContent = _draftJs.Modifier.replaceWithFragment(_contentState, _selection, _tempContentState.getBlockMap());
	
	        this.onChange(_draftJs.EditorState.push(_editorState, _newContent, 'insert-fragment'));
	      } else if (text.includes('\u201D') || text.includes('\u201C')) {
	        var newText = text.replace('\u201D', '"').replace('\u201C', '"');
	        var _editorState2 = this.state.editorState;
	
	        var _selection2 = _editorState2.getSelection();
	        var _contentState2 = _editorState2.getCurrentContent();
	        var _newContent2 = void 0;
	        if (_selection2.size === 0) {
	          _newContent2 = _draftJs.Modifier.insertText(_contentState2, _selection2, newText);
	        } else {
	          _newContent2 = _draftJs.Modifier.replaceText(_contentState2, _selection2, newText);
	        }
	        this.onChange(_draftJs.EditorState.push(_editorState2, _newContent2, 'insert-characters'));
	
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleDroppedFiles',
	    value: function handleDroppedFiles(selection, files) {
	      var _this4 = this;
	
	      var editorState = this.state.editorState;
	
	      this.onChange(_draftJs.EditorState.forceSelection(editorState, selection), function () {
	        files.map(function (f) {
	          var formData = new FormData();
	          formData.append('file', f);
	          return _BlitzAPI2.default.postEntryImage(formData).then(function (response) {
	            var url = response.data.image_url;
	            (0, _browserImageSize2.default)(url).then(function (size) {
	              return _this4.onImageAdd(url, '', 'regular', '', size);
	            });
	          });
	        });
	      });
	    }
	  }, {
	    key: 'toggleBlockType',
	    value: function toggleBlockType(blockType) {
	      this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, blockType));
	    }
	  }, {
	    key: 'keyBindingFn',
	    value: function keyBindingFn(e) {
	      var editorState = this.state.editorState;
	
	      var command = void 0;
	
	      if (_draftJsCode2.default.hasSelectionInBlock(editorState)) {
	        command = _draftJsCode2.default.getKeyBinding(e);
	      }
	      if (command) {
	        return command;
	      }
	
	      return _draftJs2.default.getDefaultKeyBinding(e);
	    }
	  }, {
	    key: 'toggleInlineStyle',
	    value: function toggleInlineStyle(inlineStyle) {
	      this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          label = _props.label,
	          controlId = _props.controlId;
	      var _state = this.state,
	          editorState = _state.editorState,
	          readOnly = _state.readOnly;
	
	
	      var className = 'entry-editor-editor';
	      var contentState = editorState.getCurrentContent();
	      if (!contentState.hasText()) {
	        if (contentState.getBlockMap().first().getType() !== 'unstyled') {
	          className += ' entry-editor-hidePlaceholder';
	        }
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        { controlId: controlId || '', onBlur: this.onBlur },
	        _react2.default.createElement(
	          _reactBootstrap.ControlLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-editor-root' },
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-editor-controls-container' },
	            _react2.default.createElement(_InlineStyleControls2.default, {
	              editorState: editorState,
	              onToggle: this.toggleInlineStyle
	            }),
	            _react2.default.createElement(_HeadingStyleControls2.default, {
	              editorState: editorState,
	              onToggle: this.toggleBlockType
	            }),
	            _react2.default.createElement(_BlockStyleControls2.default, {
	              editorState: editorState,
	              onToggle: this.toggleBlockType
	            }),
	            _react2.default.createElement(_EditorLink2.default, {
	              editorState: editorState,
	              container: this,
	              onLinkCreate: this.onLinkCreate,
	              onLinkRemove: this.onLinkRemove
	            }),
	            _react2.default.createElement(_EditorImageControls2.default, {
	              editorState: editorState,
	              container: this,
	              onImageAdd: this.onImageAdd
	            }),
	            _react2.default.createElement(_EditorYoutubeEmbedControls2.default, {
	              container: this,
	              onYoutubeAdd: this.onYoutubeAdd
	            }),
	            _react2.default.createElement(_EditorTweetEmbedControls2.default, {
	              container: this,
	              onTweetAdd: this.onTweetAdd
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: className },
	            _react2.default.createElement(_draftJs.Editor, {
	              blockStyleFn: getBlockStyle,
	              blockRenderMap: blockRenderMap,
	              blockRendererFn: this.blockRenderer,
	              customStyleMap: styleMap,
	              editorState: editorState,
	              handleKeyCommand: this.handleKeyCommand,
	              keyBindingFn: this.keyBindingFn,
	              onTab: this.onTab,
	              ref: function ref(editor) {
	                _this5.editorRef = editor;
	              },
	              spellCheck: true,
	              handleDrop: this.handleDrop,
	              onChange: this.onChange,
	              handleReturn: this.handleReturn,
	              handleDroppedFiles: this.handleDroppedFiles,
	              placeholder: 'Start Writing...',
	              handleBeforeInput: this.handleBeforeInput,
	              handlePastedText: this.handlePastedText,
	              readOnly: readOnly
	            })
	          )
	        ),
	        _react2.default.createElement(_reactBootstrap.FormControl.Feedback, null)
	      );
	    }
	  }]);
	
	  return FormEditor;
	}(_react.Component);
	
	exports.default = FormEditor;
	
	
	FormEditor.propTypes = {
	  label: _propTypes2.default.string,
	  controlId: _propTypes2.default.string,
	  input: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  options: _propTypes2.default.array
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _FormSelect = __webpack_require__(107);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _constants = __webpack_require__(44);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SourceForm = function (_Component) {
	  _inherits(SourceForm, _Component);
	
	  function SourceForm(props) {
	    _classCallCheck(this, SourceForm);
	
	    var _this = _possibleConstructorReturn(this, (SourceForm.__proto__ || Object.getPrototypeOf(SourceForm)).call(this, props));
	
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(SourceForm, [{
	    key: 'onDeleteClick',
	    value: function onDeleteClick() {
	      if (confirm('Delete this source?')) {
	        _BlitzAPI2.default.deleteSource(this.props.source_id).then(function () {
	          return _reactRouter.browserHistory.push('/sources');
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          onSubmit = _props.onSubmit;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(onSubmit) },
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'text',
	          name: 'name',
	          placeholder: 'Source Name',
	          component: _BasicFormInput2.default,
	          controlId: 'sourceName',
	          label: 'Source Name'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          label: 'Source Type',
	          name: 'type',
	          component: _FormSelect2.default,
	          options: _constants.SOURCE_TYPE_OPTIONS
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'url',
	          name: 'url',
	          placeholder: 'Source URL',
	          component: _BasicFormInput2.default,
	          controlId: 'sourceURL',
	          label: 'Source URL'
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'submit' },
	          'Submit'
	        ),
	        this.props.source_id ? _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            type: 'button',
	            bsStyle: 'danger',
	            className: 'pull-right',
	            onClick: this.onDeleteClick
	          },
	          'Delete'
	        ) : null
	      );
	    }
	  }]);
	
	  return SourceForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('source');
	function mapStateToProps(state) {
	  return {
	    source_id: selector(state, 'id')
	  };
	}
	
	SourceForm = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({ form: 'source', enableReinitialize: true })(SourceForm));
	
	SourceForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  source_id: _propTypes2.default.number
	};
	
	exports.default = SourceForm;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagForm = function (_Component) {
	  _inherits(TagForm, _Component);
	
	  function TagForm(props) {
	    _classCallCheck(this, TagForm);
	
	    var _this = _possibleConstructorReturn(this, (TagForm.__proto__ || Object.getPrototypeOf(TagForm)).call(this, props));
	
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagForm, [{
	    key: 'onDeleteClick',
	    value: function onDeleteClick() {
	      var tagId = this.props.tagId;
	
	      if (confirm('Delete this tag?')) {
	        _BlitzAPI2.default.deleteTag(tagId).then(function () {
	          return _reactRouter.browserHistory.push('/tags');
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          onSubmit = _props.onSubmit,
	          tagId = _props.tagId;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(onSubmit) },
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'text',
	          name: 'name',
	          placeholder: 'Tag Name',
	          component: _BasicFormInput2.default,
	          controlId: 'tagName',
	          label: 'Tag Name'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          component: _BasicFormInput2.default,
	          placeholder: 'Priority',
	          type: 'number',
	          name: 'priority',
	          label: 'Priority (Lower is higher priority)',
	          controlId: 'priority'
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'submit' },
	          'Submit'
	        ),
	        tagId ? _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            type: 'button',
	            bsStyle: 'danger',
	            className: 'pull-right',
	            onClick: this.onDeleteClick
	          },
	          'Delete'
	        ) : null
	      );
	    }
	  }]);
	
	  return TagForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('tag');
	function mapStateToProps(state) {
	  return {
	    tagId: selector(state, 'id')
	  };
	}
	
	TagForm = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({ form: 'tag', enableReinitialize: true })(TagForm));
	
	TagForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  tagId: _propTypes2.default.number
	};
	
	exports.default = TagForm;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserForm = function (_Component) {
	  _inherits(UserForm, _Component);
	
	  function UserForm(props) {
	    _classCallCheck(this, UserForm);
	
	    var _this = _possibleConstructorReturn(this, (UserForm.__proto__ || Object.getPrototypeOf(UserForm)).call(this, props));
	
	    _this.onDeleteClick = _this.onDeleteClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserForm, [{
	    key: 'onDeleteClick',
	    value: function onDeleteClick() {
	      if (confirm('Delete this chatroom?')) {
	        _BlitzAPI2.default.deleteUser(this.props.userId).then(function () {
	          return _reactRouter.browserHistory.push('/users');
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          userId = _props.userId;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'text',
	          name: 'name',
	          placeholder: 'Name',
	          component: _BasicFormInput2.default,
	          controlId: 'chatroomName',
	          label: 'Name'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'username',
	          placeholder: 'Username',
	          component: _BasicFormInput2.default,
	          controlId: 'username',
	          label: 'Username'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'email',
	          type: 'email',
	          placeholder: 'Email',
	          component: _BasicFormInput2.default,
	          controlId: 'email',
	          label: 'Email'
	        }),
	        !userId && _react2.default.createElement(_reduxForm.Field, {
	          name: 'password',
	          type: 'password',
	          component: _BasicFormInput2.default,
	          controlId: 'password',
	          label: 'Password'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'image_url',
	          type: 'url',
	          placeholder: 'Image URL',
	          component: _BasicFormInput2.default,
	          controlId: 'image',
	          label: 'Profile Picture URL'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          name: 'bio',
	          type: 'text',
	          placeholder: 'Biography',
	          component: _BasicFormInput2.default,
	          controlId: 'bio',
	          label: 'Biography'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'checkbox',
	          name: 'admin',
	          placeholder: 'Admin',
	          component: _BasicFormInput2.default,
	          normalize: function normalize(v) {
	            return !!v;
	          },
	          controlId: 'admin',
	          label: 'Is Admin level user (Blitz)'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'checkbox',
	          name: 'staff',
	          placeholder: 'Staff level access',
	          component: _BasicFormInput2.default,
	          normalize: function normalize(v) {
	            return !!v;
	          },
	          controlId: 'staff',
	          label: 'Staff (Editor privileges)'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'checkbox',
	          name: 'contributor',
	          placeholder: 'Contributor',
	          component: _BasicFormInput2.default,
	          normalize: function normalize(v) {
	            return !!v;
	          },
	          controlId: 'contibutor',
	          label: 'Contributor'
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'checkbox',
	          name: 'banned',
	          component: _BasicFormInput2.default,
	          normalize: function normalize(v) {
	            return !!v;
	          },
	          controlId: 'banned',
	          label: 'BANNED -> Check if you want to chat ban the user'
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'submit' },
	          'Submit'
	        )
	      );
	    }
	  }]);
	
	  return UserForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('user');
	function mapStateToProps(state) {
	  return {
	    userId: selector(state, 'id')
	  };
	}
	
	UserForm = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({ form: 'user', enableReinitialize: true })(UserForm));
	
	UserForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  userId: _propTypes2.default.number
	};
	
	exports.default = UserForm;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Get an image's width and height
	 * @param {(File|blob|string)} File, blob, or URL string
	 * @returns {Promise} resolved with object containing image width and height
	 */
	module.exports = function browserImageSize (image) {
	  /* istanbul ignore next */
	  var DOMURL = __webpack_require__(854)
	
	  return new Promise(function (resolve, reject) {
	    var url = typeof image === 'string' ? image : DOMURL.create(image)
	    if (!url) throw new Error('Must use a valid image')
	
	    var img = document.createElement('img')
	    img.onload = function onload () {
	      if (typeof image !== 'string')
	        DOMURL.revoke(url)
	      resolve({width: img.width, height: img.height})
	    }
	
	    img.onerror = function onerror (err) {
	      if (typeof image !== 'string')
	        DOMURL.revoke(url)
	      reject(err)
	    }
	
	    img.src = url
	  })
	}


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(853)
	var ieee754 = __webpack_require__(1037)
	var isArray = __webpack_require__(1038)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(857);
	var string = __webpack_require__(855);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(4)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {Point} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param chart {chart} the chart
	 * @param handler {Function} the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;
	
		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}
	
			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param items {ChartElement[]} elements to filter
	 * @param position {Point} the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param chart {Chart} the chart to look at elements from
	 * @param position {Point} the point to be nearest to
	 * @param intersect {Boolean} if true, only consider items that intersect the position
	 * @param distanceMetric {Function} function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
	
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {String} axis the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];
	
				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	module.exports = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);
	
				// We have multiple items at the same distance from the event. Now sort by smallest
				if (nearestItems.length > 1) {
					nearestItems.sort(function(a, b) {
						var sizeA = a.getArea();
						var sizeB = b.getArea();
						var ret = sizeA - sizeB;
	
						if (ret === 0) {
							// if equal sort by dataset index
							ret = a._datasetIndex - b._datasetIndex;
						}
	
						return ret;
					});
				}
	
				// Return only 1 item
				return nearestItems.slice(0, 1);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	var basic = __webpack_require__(892);
	var dom = __webpack_require__(893);
	
	// @TODO Make possible to select another platform at build time.
	var implementation = dom._enabled ? dom : basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	module.exports = helpers.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {Object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {Boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {String} type - The ({@link IEvent}) type to listen for
		 * @param {Function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart -Chart from which to remove the listener
		 * @param {String} type - The ({@link IEvent}) type to remove
		 * @param {Function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	/**
	 * @interface IPlatform
	 * Allows abstracting platform dependencies away from the chart
	 * @borrows Chart.platform.acquireContext as acquireContext
	 * @borrows Chart.platform.releaseContext as releaseContext
	 * @borrows Chart.platform.addEventListener as addEventListener
	 * @borrows Chart.platform.removeEventListener as removeEventListener
	 */
	
	/**
	 * @interface IEvent
	 * @prop {String} type - The event type name, possible values are:
	 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
	 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
	 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
	 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
	 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
	 */


/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (html) {
	  var doc = void 0;
	  if (typeof DOMParser !== 'undefined') {
	    var parser = new DOMParser();
	    doc = parser.parseFromString(html, 'text/html');
	  } else {
	    doc = document.implementation.createHTMLDocument('');
	    doc.documentElement.innerHTML = html;
	  }
	  return doc.body;
	};

/***/ },
/* 420 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (newFn, rest) {
	  return function () {
	    var newResult = newFn.apply(undefined, arguments);
	    if (newResult !== undefined && newResult !== null) {
	      return newResult;
	    }
	
	    return rest.apply(undefined, arguments);
	  };
	};

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getElementHTML;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(173);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _splitReactElement = __webpack_require__(137);
	
	var _splitReactElement2 = _interopRequireDefault(_splitReactElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasChildren(element) {
	  return _react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) > 0;
	}
	
	function getElementHTML(element) {
	  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (element === undefined || element === null) {
	    return element;
	  }
	
	  if (typeof element === 'string') {
	    return element;
	  }
	
	  if (_react2.default.isValidElement(element)) {
	    if (hasChildren(element)) {
	      return _server2.default.renderToStaticMarkup(element);
	    }
	
	    var tags = (0, _splitReactElement2.default)(element);
	
	    if (text !== null) {
	      var start = tags.start,
	          end = tags.end;
	
	      return start + text + end;
	    }
	
	    return tags;
	  }
	
	  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(element, 'start') && Object.prototype.hasOwnProperty.call(element, 'end'), 'convertToHTML: received conversion data without either an HTML string, ReactElement or an object with start/end tags');
	
	  if (text !== null) {
	    var _start = element.start,
	        _end = element.end;
	
	    return _start + text + _end;
	  }
	
	  return element;
	}

/***/ },
/* 422 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseHTML;
	var fallback = function fallback(html) {
	  var doc = document.implementation.createHTMLDocument('');
	  doc.documentElement.innerHTML = html;
	  return doc;
	};
	
	function parseHTML(html) {
	  var doc = void 0;
	  if (typeof DOMParser !== 'undefined') {
	    var parser = new DOMParser();
	    doc = parser.parseFromString(html, 'text/html');
	    if (doc === null || doc.body === null) {
	      doc = fallback(html);
	    }
	  } else {
	    doc = fallback(html);
	  }
	  return doc.body;
	}

/***/ },
/* 423 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateMutation;
	function updateMutation(mutation, originalOffset, originalLength, newLength, prefixLength, suffixLength) {
	  // three cases we can reasonably adjust - disjoint mutations that
	  // happen later on where the offset will need to be changed,
	  // mutations that completely contain the new one where we can adjust
	  // the length, and mutations that occur partially within the new one.
	  var lengthDiff = newLength - originalLength;
	
	  var mutationAfterChange = originalOffset + originalLength <= mutation.offset;
	  if (mutationAfterChange) {
	    return Object.assign({}, mutation, {
	      offset: mutation.offset + lengthDiff
	    });
	  }
	
	  var mutationContainsChange = originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length;
	  if (mutationContainsChange) {
	    return Object.assign({}, mutation, {
	      length: mutation.length + lengthDiff
	    });
	  }
	
	  var mutationWithinPrefixChange = mutation.offset >= originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && prefixLength > 0;
	  if (mutationWithinPrefixChange) {
	    return Object.assign({}, mutation, {
	      offset: mutation.offset + prefixLength
	    });
	  }
	
	  var mutationContainsPrefix = mutation.offset < originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && mutation.offset + mutation.length > originalOffset && prefixLength > 0;
	  if (mutationContainsPrefix) {
	    return [Object.assign({}, mutation, {
	      length: originalOffset - mutation.offset
	    }), Object.assign({}, mutation, {
	      offset: originalOffset + prefixLength,
	      length: mutation.offset - originalOffset + mutation.length
	    })];
	  }
	
	  var mutationContainsSuffix = mutation.offset >= originalOffset && mutation.offset + mutation.length > originalOffset + originalLength && originalOffset + originalLength > mutation.offset && suffixLength > 0;
	  if (mutationContainsSuffix) {
	    return [Object.assign({}, mutation, {
	      offset: mutation.offset + prefixLength,
	      length: originalOffset + originalLength - mutation.offset
	    }), Object.assign({}, mutation, {
	      offset: originalOffset + originalLength + prefixLength + suffixLength,
	      length: mutation.offset + mutation.length - (originalOffset + originalLength)
	    })];
	  }
	
	  return mutation;
	}

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var detectIndent = __webpack_require__(427);
	
	var DEFAULT_INDENTATION = '    ';
	
	/**
	 * Detect indentation in a text
	 * @param {String} text
	 * @return {String}
	 */
	function getIndentation(text) {
	  var result = detectIndent(text);
	  return result.indent || DEFAULT_INDENTATION;
	}
	
	module.exports = getIndentation;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var Immutable = __webpack_require__(428);
	var getNewLine = __webpack_require__(138);
	
	var LineAnchor = Immutable.Record({
	  // Index of the current line
	  line: Number(0),
	
	  // Offset in current line
	  offset: Number(0)
	});
	
	LineAnchor.prototype.getLine = function() {
	  return this.get('line');
	};
	
	LineAnchor.prototype.getOffset = function() {
	  return this.get('offset');
	};
	
	/**
	 * Return an anchor of a cursor in a block as a {line,offset} object
	 *
	 * @param {String} text
	 * @param {Number} offset
	 * @param {String} sep (optional)
	 * @return {LineAnchor}
	 */
	function getLineAnchorForOffset(text, offset, sep) {
	  sep = sep || getNewLine(text);
	
	  var lineIndex = 0;
	  var nextLineIndex = 0;
	  var lastLineIndex = 0;
	
	  while (nextLineIndex >= 0 && nextLineIndex < offset) {
	    lineIndex++;
	
	    lastLineIndex = nextLineIndex;
	    nextLineIndex = text.indexOf(sep, nextLineIndex + sep.length);
	  }
	
	  return new LineAnchor({
	    line: lineIndex - 1,
	    offset: offset - lastLineIndex
	  });
	}
	
	module.exports = getLineAnchorForOffset;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var Immutable = __webpack_require__(428);
	var getNewLine = __webpack_require__(138);
	
	/**
	 * Return a list of line in this text
	 * @param {String} text
	 * @param {String} sep (optional)
	 * @return {List<String>}
	 */
	function getLines(text, sep) {
	  sep = sep || getNewLine(text);
	  return Immutable.List(text.split(sep));
	}
	
	module.exports = getLines;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable guard-for-in */
	'use strict';
	var repeating = __webpack_require__(935);
	
	// detect either spaces or tabs but not both to properly handle tabs
	// for indentation and spaces for alignment
	var INDENT_RE = /^(?:( )+|\t+)/;
	
	function getMostUsed(indents) {
		var result = 0;
		var maxUsed = 0;
		var maxWeight = 0;
	
		for (var n in indents) {
			var indent = indents[n];
			var u = indent[0];
			var w = indent[1];
	
			if (u > maxUsed || u === maxUsed && w > maxWeight) {
				maxUsed = u;
				maxWeight = w;
				result = Number(n);
			}
		}
	
		return result;
	}
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		// used to see if tabs or spaces are the most used
		var tabs = 0;
		var spaces = 0;
	
		// remember the size of previous line's indentation
		var prev = 0;
	
		// remember how many indents/unindents as occurred for a given size
		// and how much lines follow a given indentation
		//
		// indents = {
		//    3: [1, 0],
		//    4: [1, 5],
		//    5: [1, 0],
		//   12: [1, 0],
		// }
		var indents = {};
	
		// pointer to the array of last used indent
		var current;
	
		// whether the last action was an indent (opposed to an unindent)
		var isIndent;
	
		str.split(/\n/g).forEach(function (line) {
			if (!line) {
				// ignore empty lines
				return;
			}
	
			var indent;
			var matches = line.match(INDENT_RE);
	
			if (!matches) {
				indent = 0;
			} else {
				indent = matches[0].length;
	
				if (matches[1]) {
					spaces++;
				} else {
					tabs++;
				}
			}
	
			var diff = indent - prev;
			prev = indent;
	
			if (diff) {
				// an indent or unindent has been detected
	
				isIndent = diff > 0;
	
				current = indents[isIndent ? diff : -diff];
	
				if (current) {
					current[0]++;
				} else {
					current = indents[diff] = [1, 0];
				}
			} else if (current) {
				// if the last action was an indent, increment the weight
				current[1] += Number(isIndent);
			}
		});
	
		var amount = getMostUsed(indents);
	
		var type;
		var actual;
		if (!amount) {
			type = null;
			actual = '';
		} else if (spaces >= tabs) {
			type = 'space';
			actual = repeating(' ', amount);
		} else {
			type = 'tab';
			actual = repeating('\t', amount);
		}
	
		return {
			amount: amount,
			type: type,
			indent: actual
		};
	};


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(199);
	var findRangesImmutable = __webpack_require__(110);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat,
	    Record = Immutable.Record;
	
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(contentState, block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ },
/* 430 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorLeaf = __webpack_require__(945);
	var DraftOffsetKey = __webpack_require__(140);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(20);
	var Scroll = __webpack_require__(452);
	var Style = __webpack_require__(196);
	var UnicodeBidi = __webpack_require__(453);
	var UnicodeBidiDirection = __webpack_require__(197);
	
	var cx = __webpack_require__(87);
	var getElementPosition = __webpack_require__(1010);
	var getScrollPosition = __webpack_require__(200);
	var getViewportDimensions = __webpack_require__(1014);
	var invariant = __webpack_require__(19);
	var nullthrows = __webpack_require__(46);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	};
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	
	var DraftEditorBlock = function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  };
	
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	
	
	  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = ReactDOM.findDOMNode(this);
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta = void 0;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          block: block,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : null,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      var decoratorKey = leafSet.get('decoratorKey');
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	      // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	
	      return React.createElement(
	        DecoratorComponent,
	        _extends({}, decoratorProps, {
	          contentState: _this2.props.contentState,
	          decoratedText: decoratedText,
	          dir: dir,
	          key: decoratorOffsetKey,
	          entityKey: block.getEntityAt(leafSet.get('start')),
	          offsetKey: decoratorOffsetKey }),
	        leaves
	      );
	    }).toArray();
	  };
	
	  DraftEditorBlock.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        offsetKey = _props.offsetKey;
	
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	
	    return React.createElement(
	      'div',
	      { 'data-offset-key': offsetKey, className: className },
	      this._renderChildren()
	    );
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	module.exports = DraftEditorBlock;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * @legacyServerCallableInstance
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(16);
	
	var Record = Immutable.Record;
	
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = function (_DraftEntityInstanceR) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
	  }
	
	  DraftEntityInstance.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  DraftEntityInstance.prototype.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  DraftEntityInstance.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(1002);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'\u2018\u2019]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ },
/* 434 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	var SelectionState = __webpack_require__(86);
	
	var adjustBlockDepthForContentState = __webpack_require__(955);
	var nullthrows = __webpack_require__(46);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    var contentState = editorState.getCurrentContent();
	    var entityMap = contentState.getEntityMap();
	    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && entityMap.__get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        // they may have custom editor commands; ignore those
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
	      var withoutAtomicBlock = content.merge({
	        blockMap: blockMap,
	        selectionAfter: selection
	      });
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).reverse().skipWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of the first styled block, or
	   * an empty styled block, changes block to 'unstyled'. Returns null if
	   * block or selection does not meet that criteria.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	
	      var firstBlock = content.getFirstBlock();
	      if (block.getLength() > 0 && block !== firstBlock) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _knownListItemDepthCl,
	    _assign = __webpack_require__(38);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CharacterMetadata = __webpack_require__(37);
	var ContentBlock = __webpack_require__(75);
	var ContentBlockNode = __webpack_require__(41);
	var DefaultDraftBlockRenderMap = __webpack_require__(189);
	var DraftEntity = __webpack_require__(139);
	var DraftFeatureFlags = __webpack_require__(67);
	var Immutable = __webpack_require__(16);
	
	var _require = __webpack_require__(16),
	    Set = _require.Set;
	
	var URI = __webpack_require__(1003);
	
	var cx = __webpack_require__(87);
	var generateRandomKey = __webpack_require__(58);
	var getSafeBodyFromHTML = __webpack_require__(442);
	var invariant = __webpack_require__(19);
	var sanitizeDraftText = __webpack_require__(194);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    OrderedSet = Immutable.OrderedSet;
	
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g');
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
	
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	
	var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
	
	var lastBlock = void 0;
	
	var EMPTY_CHUNK = {
	  text: '',
	  inlines: [],
	  entities: [],
	  blocks: []
	};
	
	var EMPTY_BLOCK = {
	  children: List(),
	  depth: 0,
	  key: '',
	  type: ''
	};
	
	var getListBlockType = function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	};
	
	var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  var tags = Set([]);
	
	  blockRenderMap.forEach(function (draftBlock) {
	    if (draftBlock.aliasedElements) {
	      draftBlock.aliasedElements.forEach(function (tag) {
	        tags = tags.add(tag);
	      });
	    }
	
	    tags = tags.add(draftBlock.element);
	  });
	
	  return tags.filter(function (tag) {
	    return tag && tag !== unstyledElement;
	  }).toArray().sort();
	};
	
	// custom element conversions
	var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	};
	
	var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
	    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
	      return alias === tag;
	    });
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	};
	
	var processInlineTag = function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    var htmlElement = node;
	    currentStyle = currentStyle.withMutations(function (style) {
	      var fontWeight = htmlElement.style.fontWeight;
	      var fontStyle = htmlElement.style.fontStyle;
	      var textDecoration = htmlElement.style.textDecoration;
	
	      if (boldValues.indexOf(fontWeight) >= 0) {
	        style.add('BOLD');
	      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	        style.remove('BOLD');
	      }
	
	      if (fontStyle === 'italic') {
	        style.add('ITALIC');
	      } else if (fontStyle === 'normal') {
	        style.remove('ITALIC');
	      }
	
	      if (textDecoration === 'underline') {
	        style.add('UNDERLINE');
	      }
	      if (textDecoration === 'line-through') {
	        style.add('STRIKETHROUGH');
	      }
	      if (textDecoration === 'none') {
	        style.remove('UNDERLINE');
	        style.remove('STRIKETHROUGH');
	      }
	    }).toOrderedSet();
	  }
	  return currentStyle;
	};
	
	var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInA = A.text.slice(-1);
	  var firstInB = B.text.slice(0, 1);
	
	  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (lastInA === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	};
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	};
	
	var hasValidLinkText = function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
	};
	
	var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return _extends({}, EMPTY_CHUNK, {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities
	  });
	};
	
	var getSoftNewlineChunk = function getSoftNewlineChunk() {
	  return _extends({}, EMPTY_CHUNK, {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1)
	  });
	};
	
	var getChunkedBlock = function getChunkedBlock() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _extends({}, EMPTY_BLOCK, props);
	};
	
	var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
	  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [getChunkedBlock({
	      parent: parentKey,
	      key: generateRandomKey(),
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    })]
	  };
	};
	
	/**
	 *  If we're pasting from one DraftEditor to another we can check to see if
	 *  existing list item depth classes are being used and preserve this style
	 */
	var getListItemDepth = function getListItemDepth(node) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
	    if (node.classList.contains(depthClass)) {
	      depth = knownListItemDepthClasses[depthClass];
	    }
	  });
	  return depth;
	};
	
	var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
	  var lastLastBlock = lastBlock;
	  var nodeName = node.nodeName.toLowerCase();
	  var newEntityMap = entityMap;
	  var nextBlockType = 'unstyled';
	  var newBlock = false;
	  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
	  var chunk = _extends({}, EMPTY_CHUNK);
	  var newChunk = null;
	  var blockKey = void 0;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var _text = node.textContent;
	    var nodeTextContent = _text.trim();
	
	    // We should not create blocks for leading spaces that are
	    // existing around ol/ul and their children list items
	    if (lastList && nodeTextContent === '' && node.parentElement) {
	      var parentNodeName = node.parentElement.nodeName.toLowerCase();
	      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
	        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
	      }
	    }
	
	    if (nodeTextContent === '' && inBlock !== 'pre') {
	      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      _text = _text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      chunk: {
	        text: _text,
	        inlines: Array(_text.length).fill(inlineStyle),
	        entities: Array(_text.length).fill(inEntity),
	        blocks: []
	      },
	      entityMap: entityMap
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
	      return {
	        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
	        entityMap: entityMap
	      };
	    }
	    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
	  }
	
	  // IMG tags
	  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
	    var image = node;
	    var entityConfig = {};
	
	    imgAttr.forEach(function (attr) {
	      var imageAttribute = image.getAttribute(attr);
	      if (imageAttribute) {
	        entityConfig[attr] = imageAttribute;
	      }
	    });
	    // Forcing this node to have children because otherwise no entity will be
	    // created for this node.
	    // The child text node cannot just have a space or return as content -
	    // we strip those out.
	    // See https://github.com/facebook/draft-js/issues/231 for some context.
	    node.textContent = '\uD83D\uDCF7';
	
	    // TODO: update this when we remove DraftEntity entirely
	    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
	  }
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
	    depth = getListItemDepth(node, depth);
	  }
	
	  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
	  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
	  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;
	
	  // Block Tags
	  if (inListBlock || inBlockOrHasNestedBlocks) {
	    chunk = getBlockDividerChunk(blockType, depth, parentKey);
	    blockKey = chunk.blocks[0].key;
	    inBlock = nodeName;
	    newBlock = !experimentalTreeDataSupport;
	  }
	
	  // this is required so that we can handle 'ul' and 'ol'
	  if (inListBlock) {
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
	      (function () {
	        var anchor = child;
	        var entityConfig = {};
	
	        anchorAttr.forEach(function (attr) {
	          var anchorAttribute = anchor.getAttribute(attr);
	          if (anchorAttribute) {
	            entityConfig[attr] = anchorAttribute;
	          }
	        });
	
	        entityConfig.url = new URI(anchor.href).toString();
	        // TODO: update this when we remove DraftEntity completely
	        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
	      })();
	    } else {
	      entityId = undefined;
	    }
	
	    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
	        generatedChunk = _genFragment.chunk,
	        maybeUpdatedEntityMap = _genFragment.entityMap;
	
	    newChunk = generatedChunk;
	    newEntityMap = maybeUpdatedEntityMap;
	
	    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  var chunk = fragment.chunk;
	  var newEntityMap = fragment.entityMap;
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
	      type: 'unstyled',
	      depth: 0
	    }));
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
	  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
	    return null;
	  }
	
	  var initialState = {
	    cacheRef: {},
	    contentBlocks: []
	  };
	
	  var start = 0;
	
	  var rawBlocks = chunk.blocks,
	      rawInlines = chunk.inlines,
	      rawEntities = chunk.entities;
	
	
	  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	
	    var block = rawBlocks[index];
	    var end = start + textBlock.length;
	    var inlines = rawInlines.slice(start, end);
	    var entities = rawEntities.slice(start, end);
	    var characterList = List(inlines.map(function (style, index) {
	      var data = { style: style, entity: null };
	      if (entities[index]) {
	        data.entity = entities[index];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    var depth = block.depth,
	        type = block.type,
	        parent = block.parent;
	
	
	    var key = block.key || generateRandomKey();
	    var parentTextNodeKey = null; // will be used to store container text nodes
	
	    // childrens add themselves to their parents since we are iterating in order
	    if (parent) {
	      var parentIndex = acc.cacheRef[parent];
	      var parentRecord = acc.contentBlocks[parentIndex];
	
	      // if parent has text we need to split it into a separate unstyled element
	      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
	        var parentCharacterList = parentRecord.getCharacterList();
	        var parentText = parentRecord.getText();
	        parentTextNodeKey = generateRandomKey();
	
	        var textNode = new ContentBlockNode({
	          key: parentTextNodeKey,
	          text: parentText,
	          characterList: parentCharacterList,
	          parent: parent,
	          nextSibling: key
	        });
	
	        acc.contentBlocks.push(textNode);
	
	        parentRecord = parentRecord.withMutations(function (block) {
	          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
	        });
	      }
	
	      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
	    }
	
	    var blockNode = new BlockNodeRecord({
	      key: key,
	      parent: parent,
	      type: type,
	      depth: depth,
	      text: textBlock,
	      characterList: characterList,
	      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
	      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
	    });
	
	    // insert node
	    acc.contentBlocks.push(blockNode);
	
	    // cache ref for building links
	    acc.cacheRef[blockNode.key] = index;
	
	    return acc;
	  }, initialState).contentBlocks;
	};
	
	var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
	  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
	
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  // TODO: replace DraftEntity with an OrderedMap here
	  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);
	
	  if (chunkData == null) {
	    return null;
	  }
	
	  var chunk = chunkData.chunk,
	      entityMap = chunkData.entityMap;
	
	  var contentBlocks = convertChunkToContentBlocks(chunk);
	
	  return {
	    contentBlocks: contentBlocks,
	    entityMap: entityMap
	  };
	};
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(190);
	var Keys = __webpack_require__(195);
	var UserAgent = __webpack_require__(51);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
	    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @format
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(191);
	var getSelectionOffsetKeyForNode = __webpack_require__(443);
	var getUpdatedSelectionState = __webpack_require__(445);
	var invariant = __webpack_require__(19);
	var nullthrows = __webpack_require__(46);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && (
	  // data-blocks has no offset
	  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && (
	  // data-blocks has no offset
	  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(141);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNextDelimiterBlockKey
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var ContentBlockNode = __webpack_require__(41);
	
	var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
	  var isExperimentalTreeBlock = block instanceof ContentBlockNode;
	
	  if (!isExperimentalTreeBlock) {
	    return null;
	  }
	
	  var nextSiblingKey = block.getNextSiblingKey();
	
	  if (nextSiblingKey) {
	    return nextSiblingKey;
	  }
	
	  var parent = block.getParentKey();
	
	  if (!parent) {
	    return null;
	  }
	
	  var nextNonDescendantBlock = blockMap.get(parent);
	  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
	    var parentKey = nextNonDescendantBlock.getParentKey();
	    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  if (!nextNonDescendantBlock) {
	    return null;
	  }
	
	  return nextNonDescendantBlock.getNextSiblingKey();
	};
	
	module.exports = getNextDelimiterBlockKey;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(51);
	
	var invariant = __webpack_require__(19);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	/* eslint-disable consistent-return */
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(51);
	
	var invariant = __webpack_require__(19);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ },
/* 443 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	function getSelectionOffsetKeyForNode(node) {
	  if (node instanceof Element) {
	    var offsetKey = node.getAttribute('data-offset-key');
	    if (offsetKey) {
	      return offsetKey;
	    }
	    for (var ii = 0; ii < node.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(19);
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    var result = reader.result;
	    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
	    callback(result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(140);
	
	var nullthrows = __webpack_require__(46);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ },
/* 446 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ },
/* 447 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ },
/* 448 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule randomizeBlockMapKeys
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(41);
	var Immutable = __webpack_require__(16);
	
	var generateRandomKey = __webpack_require__(58);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
	  var newKeysRef = {};
	
	  // we keep track of root blocks in order to update subsequent sibling links
	  var lastRootBlock = void 0;
	
	  return OrderedMap(blockMap.withMutations(function (blockMapState) {
	    blockMapState.forEach(function (block, index) {
	      var oldKey = block.getKey();
	      var nextKey = block.getNextSiblingKey();
	      var prevKey = block.getPrevSiblingKey();
	      var childrenKeys = block.getChildKeys();
	      var parentKey = block.getParentKey();
	
	      // new key that we will use to build linking
	      var key = generateRandomKey();
	
	      // we will add it here to re-use it later
	      newKeysRef[oldKey] = key;
	
	      if (nextKey) {
	        var nextBlock = blockMapState.get(nextKey);
	        if (nextBlock) {
	          blockMapState.setIn([nextKey, 'prevSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'nextSibling'], null);
	        }
	      }
	
	      if (prevKey) {
	        var prevBlock = blockMapState.get(prevKey);
	        if (prevBlock) {
	          blockMapState.setIn([prevKey, 'nextSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'prevSibling'], null);
	        }
	      }
	
	      if (parentKey && blockMapState.get(parentKey)) {
	        var parentBlock = blockMapState.get(parentKey);
	        var parentChildrenList = parentBlock.getChildKeys();
	        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
	      } else {
	        // blocks will then be treated as root block nodes
	        blockMapState.setIn([oldKey, 'parent'], null);
	
	        if (lastRootBlock) {
	          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
	          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
	        }
	
	        lastRootBlock = blockMapState.get(oldKey);
	      }
	
	      childrenKeys.forEach(function (childKey) {
	        var childBlock = blockMapState.get(childKey);
	        if (childBlock) {
	          blockMapState.setIn([childKey, 'parent'], key);
	        } else {
	          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
	            return child !== childKey;
	          }));
	        }
	      });
	    });
	  }).toArray().map(function (block) {
	    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
	  }));
	};
	
	var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
	  return OrderedMap(blockMap.toArray().map(function (block) {
	    var key = generateRandomKey();
	    return [key, block.set('key', key)];
	  }));
	};
	
	var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	
	  if (!isTreeBasedBlockMap) {
	    return randomizeContentBlockKeys(blockMap);
	  }
	
	  return randomizeContentBlockNodeKeys(blockMap);
	};
	
	module.exports = randomizeBlockMapKeys;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(37);
	
	var findRangesImmutable = __webpack_require__(110);
	var invariant = __webpack_require__(19);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	  var entityMap = contentState.getEntityMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(entityMap, block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = entityMap.__get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
	          start = _getRemovalRange.start,
	          end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(1001);
	
	var createArrayFromMixed = __webpack_require__(1008);
	var emptyFunction = __webpack_require__(199);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ },
/* 452 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(197);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',
	
	  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',
	
	  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ },
/* 454 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 455 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 456 */
455,
/* 457 */
455,
/* 458 */
455,
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1160);
	
	var _runTransitionHook = __webpack_require__(204);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(88);
	
	var _PathUtils = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77),
	    root = __webpack_require__(52);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(52);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1054);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 465 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1073),
	    isArguments = __webpack_require__(154),
	    isArray = __webpack_require__(47),
	    isBuffer = __webpack_require__(218),
	    isIndex = __webpack_require__(213),
	    isTypedArray = __webpack_require__(221);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 467 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(147),
	    eq = __webpack_require__(115);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1085);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(470),
	    keys = __webpack_require__(155);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(473),
	    toKey = __webpack_require__(114);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(47),
	    isKey = __webpack_require__(214),
	    stringToPath = __webpack_require__(483),
	    toString = __webpack_require__(487);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(208),
	    arraySome = __webpack_require__(1047),
	    cacheHas = __webpack_require__(212);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 477 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 478 */
[1638, 482],
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(115),
	    isArrayLike = __webpack_require__(78),
	    isIndex = __webpack_require__(213),
	    isObject = __webpack_require__(59);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 481 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 482 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1117);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 484 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(148);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(466),
	    baseKeysIn = __webpack_require__(1062),
	    isArrayLike = __webpack_require__(78);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1074);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(768);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1157);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 609 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 610 */
15,
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editor = function editor(editable, attr, format, editorClass, defaultValue, ignoreEditable, row) {
	  if (editable === true || editable === false && ignoreEditable || typeof editable === 'string') {
	    // simple declare
	    var type = editable ? 'text' : editable;
	    return _react2.default.createElement('input', _extends({}, attr, { type: type, defaultValue: defaultValue,
	      className: (editorClass || '') + ' form-control editor edit-text' }));
	  } else if (!editable) {
	    var _type = editable ? 'text' : editable;
	    return _react2.default.createElement('input', _extends({}, attr, { type: _type, defaultValue: defaultValue,
	      disabled: 'disabled',
	      className: (editorClass || '') + ' form-control editor edit-text' }));
	  } else if (editable && (editable.type === undefined || editable.type === null || editable.type.trim() === '')) {
	    var _type2 = editable ? 'text' : editable;
	    return _react2.default.createElement('input', _extends({}, attr, { type: _type2, defaultValue: defaultValue,
	      className: (editorClass || '') + ' form-control editor edit-text' }));
	  } else if (editable.type) {
	    // standard declare
	    // put style if exist
	    editable.style && (attr.style = editable.style);
	    // put class if exist
	    attr.className = (editorClass || '') + ' form-control editor edit-' + editable.type + (editable.className ? ' ' + editable.className : '');
	
	    if (editable.type === 'select') {
	      // process select input
	      var options = [];
	      var values = editable.options.values;
	      var _editable$options = editable.options,
	          textKey = _editable$options.textKey,
	          valueKey = _editable$options.valueKey;
	
	      if (_util2.default.isFunction(values)) {
	        values = values(row);
	      }
	      if (Array.isArray(values)) {
	        // only can use arrray data for options
	        var text = void 0;
	        var value = void 0;
	        options = values.map(function (option, i) {
	          if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	            text = textKey ? option[textKey] : option.text;
	            value = valueKey ? option[valueKey] : option.value;
	          } else {
	            text = format ? format(option) : option;
	            value = option;
	          }
	          return _react2.default.createElement(
	            'option',
	            { key: 'option' + i, value: value },
	            text
	          );
	        });
	      }
	      return _react2.default.createElement(
	        'select',
	        _extends({}, attr, { defaultValue: defaultValue }),
	        options
	      );
	    } else if (editable.type === 'textarea') {
	      // process textarea input
	      // put other if exist
	      editable.cols && (attr.cols = editable.cols);
	      editable.rows && (attr.rows = editable.rows);
	      var saveBtn = void 0;
	      var keyUpHandler = attr.onKeyDown;
	      if (keyUpHandler) {
	        attr.onKeyDown = function (e) {
	          if (e.keyCode !== 13) {
	            // not Pressed ENTER
	            keyUpHandler(e);
	          }
	        };
	        saveBtn = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-info btn-xs textarea-save-btn',
	            onClick: keyUpHandler },
	          'save'
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('textarea', _extends({}, attr, { defaultValue: defaultValue })),
	        saveBtn
	      );
	    } else if (editable.type === 'checkbox') {
	      var _values = 'true:false';
	      if (editable.options && editable.options.values) {
	        // values = editable.options.values.split(':');
	        _values = editable.options.values;
	      }
	      attr.className = attr.className.replace('form-control', '');
	      attr.className += ' checkbox pull-right';
	
	      var checked = defaultValue && defaultValue.toString() === _values.split(':')[0] ? true : false;
	
	      return _react2.default.createElement('input', _extends({}, attr, { type: 'checkbox',
	        value: _values, defaultChecked: checked }));
	    } else if (editable.type === 'datetime') {
	      return _react2.default.createElement('input', _extends({}, attr, { type: 'datetime-local', defaultValue: defaultValue }));
	    } else {
	      // process other input type. as password,url,email...
	      return _react2.default.createElement('input', _extends({}, attr, { type: editable.type, defaultValue: defaultValue }));
	    }
	  }
	  // default return for other case of editable
	  return _react2.default.createElement('input', _extends({}, attr, { type: 'text',
	    className: (editorClass || '') + ' form-control editor edit-text' }));
	};
	
	var _default = editor;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(editor, 'editor', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');
	}();
	
	;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.notice = undefined;
	
	var _reactSAlert = __webpack_require__(720);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notice = function notice(type, msg, title) {
	  var titleHTML = title ? '<h4><strong>' + title + '</strong></h4>' : '';
	
	  var bodyHTML = '\n    ' + titleHTML + '\n    <div>\n      <span class=\'fa fa-exclamation-triangle glyphicon glyphicon-alert\'></span>&nbsp;\n      <span>' + msg + '</span>\n    </div>\n  ';
	
	  _reactSAlert2.default.error(bodyHTML, {
	    position: 'top-right',
	    timeout: 3000,
	    html: true,
	    effect: 'scale'
	  });
	};
	
	exports.notice = notice;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(notice, 'notice', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');
	}();
	
	;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _Date = __webpack_require__(1177);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	var _Text = __webpack_require__(1181);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Regex = __webpack_require__(1179);
	
	var _Regex2 = _interopRequireDefault(_Regex);
	
	var _Select = __webpack_require__(1180);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Number = __webpack_require__(1178);
	
	var _Number2 = _interopRequireDefault(_Number);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint default-case: 0 */
	/* eslint guard-for-in: 0 */
	
	
	var TableHeaderColumn = function (_Component) {
	  _inherits(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn(props) {
	    _classCallCheck(this, TableHeaderColumn);
	
	    var _this = _possibleConstructorReturn(this, (TableHeaderColumn.__proto__ || Object.getPrototypeOf(TableHeaderColumn)).call(this, props));
	
	    _this.handleColumnClick = function () {
	      return _this.__handleColumnClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleFilter = _this.handleFilter.bind(_this);
	    return _this;
	  }
	
	  _createClass(TableHeaderColumn, [{
	    key: '__handleColumnClick__REACT_HOT_LOADER__',
	    value: function __handleColumnClick__REACT_HOT_LOADER__() {
	      return this.__handleColumnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.reset) {
	        this.cleanFiltered();
	      }
	
	      // If column not displaying the same dataField, reset the filter accordingly
	      if (nextProps.filter && nextProps.dataField !== this.props.dataField) {
	        var emitter = nextProps.filter.emitter || {};
	        var currentFilter = emitter.currentFilter || {};
	        var filter = currentFilter[nextProps.dataField];
	        var value = filter ? filter.value : '';
	
	        var _ref = this.getFilters(nextProps) || {},
	            ref = _ref.ref;
	
	        if (this.refs[ref]) {
	          this.refs[ref].setState({ value: value });
	        }
	      }
	    }
	  }, {
	    key: '__handleColumnClick__REACT_HOT_LOADER__',
	    value: function __handleColumnClick__REACT_HOT_LOADER__() {
	      if (this.props.isOnlyHead || !this.props.dataSort) return;
	      var order = this.props.sort;
	
	      if (!order && this.props.defaultASC) order = _Const2.default.SORT_ASC;else order = this.props.sort === _Const2.default.SORT_DESC ? _Const2.default.SORT_ASC : _Const2.default.SORT_DESC;
	      this.props.onSort(order, this.props.dataField);
	    }
	  }, {
	    key: 'handleFilter',
	    value: function handleFilter(value, type) {
	      var filter = this.props.filter;
	
	      filter.emitter.handleFilter(this.props.dataField, value, type, filter);
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters() {
	      var _this2 = this;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var headerText = props.headerText,
	          children = props.children;
	
	      switch (props.filter.type) {
	        case _Const2.default.FILTER_TYPE.TEXT:
	          {
	            return _react2.default.createElement(_Text2.default, _extends({ ref: function ref(n) {
	                return _this2.textFilter = n;
	              } }, props.filter, {
	              columnName: headerText || children, filterHandler: this.handleFilter }));
	          }
	        case _Const2.default.FILTER_TYPE.REGEX:
	          {
	            return _react2.default.createElement(_Regex2.default, _extends({ ref: function ref(n) {
	                return _this2.regexFilter = n;
	              } }, props.filter, {
	              columnName: headerText || children, filterHandler: this.handleFilter }));
	          }
	        case _Const2.default.FILTER_TYPE.SELECT:
	          {
	            return _react2.default.createElement(_Select2.default, _extends({ ref: function ref(n) {
	                return _this2.selectFilter = n;
	              } }, props.filter, {
	              columnName: headerText || children, filterHandler: this.handleFilter }));
	          }
	        case _Const2.default.FILTER_TYPE.NUMBER:
	          {
	            return _react2.default.createElement(_Number2.default, _extends({ ref: function ref(n) {
	                return _this2.numberFilter = n;
	              } }, props.filter, {
	              columnName: headerText || children, filterHandler: this.handleFilter }));
	          }
	        case _Const2.default.FILTER_TYPE.DATE:
	          {
	            return _react2.default.createElement(_Date2.default, _extends({ ref: function ref(n) {
	                return _this2.dateFilter = n;
	              } }, props.filter, {
	              columnName: headerText || children, filterHandler: this.handleFilter }));
	          }
	        case _Const2.default.FILTER_TYPE.CUSTOM:
	          {
	            var elm = props.filter.getElement(this.handleFilter, props.filter.customFilterParameters);
	
	            return _react2.default.cloneElement(elm, { ref: function ref(n) {
	                return _this2.customFilter = n;
	              } });
	          }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.headerCol.setAttribute('data-field', this.props.dataField);
	    }
	  }, {
	    key: 'renderDefaultCaret',
	    value: function renderDefaultCaret(dataSort, isBootstrap4) {
	      if (!dataSort) return null;
	      if (isBootstrap4) {
	        return _react2.default.createElement('span', { className: 'order fa fa-sort',
	          style: { margin: '10px 0 10px 5px', color: '#ccc' } });
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'order' },
	          _react2.default.createElement(
	            'span',
	            { className: 'dropdown' },
	            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0 10px 5px', color: '#ccc' } })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'dropup' },
	            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0', color: '#ccc' } })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var defaultCaret = void 0;
	      var sortCaret = void 0;
	      var sortClass = void 0;
	      var _props = this.props,
	          headerText = _props.headerText,
	          dataAlign = _props.dataAlign,
	          dataField = _props.dataField,
	          headerAlign = _props.headerAlign,
	          headerTitle = _props.headerTitle,
	          hidden = _props.hidden,
	          sort = _props.sort,
	          dataSort = _props.dataSort,
	          sortIndicator = _props.sortIndicator,
	          children = _props.children,
	          caretRender = _props.caretRender,
	          className = _props.className,
	          isOnlyHead = _props.isOnlyHead,
	          version = _props.version,
	          customSortClass = _props.sortHeaderColumnClassName,
	          style = _props.thStyle;
	
	      var thStyle = _extends({
	        textAlign: headerAlign || dataAlign,
	        display: hidden ? 'none' : null
	      }, style);
	      var isBootstrap4 = _util2.default.isBootstrap4(version);
	      if (!isOnlyHead) {
	        if (sortIndicator) {
	          defaultCaret = this.renderDefaultCaret(dataSort, isBootstrap4);
	        }
	        sortCaret = sort ? _util2.default.renderReactSortCaret(sort, isBootstrap4) : defaultCaret;
	        if (caretRender) {
	          sortCaret = caretRender(sort, dataField);
	        }
	      }
	
	      if (sort) {
	        sortClass = _util2.default.isFunction(customSortClass) ? customSortClass(sort, dataField) : customSortClass;
	      }
	      var classes = (0, _classnames2.default)(_util2.default.isFunction(className) ? className() : className, !isOnlyHead && dataSort ? 'sort-column' : '', sortClass);
	
	      var attr = {};
	      if (headerTitle) {
	        if (typeof children === 'string' && !headerText) {
	          attr.title = children;
	        } else {
	          attr.title = headerText;
	        }
	      }
	      return _react2.default.createElement(
	        'th',
	        _extends({ ref: function ref(node) {
	            return _this3.headerCol = node;
	          },
	          className: classes,
	          style: thStyle,
	          onClick: this.handleColumnClick,
	          rowSpan: this.props.rowSpan,
	          colSpan: this.props.colSpan,
	          'data-is-only-head': this.props.isOnlyHead
	        }, attr),
	        children,
	        sortCaret,
	        _react2.default.createElement(
	          'div',
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          this.props.filter && !isOnlyHead ? this.getFilters() : null
	        )
	      );
	    }
	  }, {
	    key: 'cleanFiltered',
	    value: function cleanFiltered() {
	      if (!this.props.filter) return;
	
	      switch (this.props.filter.type) {
	        case _Const2.default.FILTER_TYPE.TEXT:
	          {
	            this.textFilter.cleanFiltered();
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.REGEX:
	          {
	            this.regexFilter.cleanFiltered();
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.SELECT:
	          {
	            this.selectFilter.cleanFiltered();
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.NUMBER:
	          {
	            this.numberFilter.cleanFiltered();
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.DATE:
	          {
	            this.dateFilter.cleanFiltered();
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.CUSTOM:
	          {
	            this.customFilter.cleanFiltered();
	            break;
	          }
	      }
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter(val) {
	      if (!this.props.filter) return;
	      switch (this.props.filter.type) {
	        case _Const2.default.FILTER_TYPE.TEXT:
	          {
	            this.textFilter.applyFilter(val);
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.REGEX:
	          {
	            this.regexFilter.applyFilter(val);
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.SELECT:
	          {
	            this.selectFilter.applyFilter(val);
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.NUMBER:
	          {
	            this.numberFilter.applyFilter(val);
	            break;
	          }
	        case _Const2.default.FILTER_TYPE.DATE:
	          {
	            this.dateFilter.applyFilter(val);
	            break;
	          }
	      }
	    }
	  }]);
	
	  return TableHeaderColumn;
	}(_react.Component);
	
	var filterTypeArray = [];
	for (var key in _Const2.default.FILTER_TYPE) {
	  filterTypeArray.push(_Const2.default.FILTER_TYPE[key]);
	}
	
	TableHeaderColumn.propTypes = {
	  dataField: _propTypes2.default.string,
	  dataAlign: _propTypes2.default.string,
	  headerAlign: _propTypes2.default.string,
	  headerTitle: _propTypes2.default.bool,
	  headerText: _propTypes2.default.string,
	  dataSort: _propTypes2.default.bool,
	  onSort: _propTypes2.default.func,
	  dataFormat: _propTypes2.default.func,
	  csvFormat: _propTypes2.default.func,
	  csvHeader: _propTypes2.default.string,
	  csvFieldType: _propTypes2.default.oneOf([_Const2.default.CSV_STRING_TYPE, _Const2.default.CSV_NUMBER_TYPE]),
	  isKey: _propTypes2.default.bool,
	  editable: _propTypes2.default.any,
	  hidden: _propTypes2.default.bool,
	  hiddenOnInsert: _propTypes2.default.bool,
	  searchable: _propTypes2.default.bool,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  width: _propTypes2.default.string,
	  sortFunc: _propTypes2.default.func,
	  sortFuncExtraData: _propTypes2.default.any,
	  sortHeaderColumnClassName: _propTypes2.default.any,
	  columnClassName: _propTypes2.default.any,
	  editColumnClassName: _propTypes2.default.any,
	  invalidEditColumnClassName: _propTypes2.default.any,
	  columnTitle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.string]),
	  filterFormatted: _propTypes2.default.bool,
	  filterValue: _propTypes2.default.func,
	  sort: _propTypes2.default.string,
	  caretRender: _propTypes2.default.func,
	  formatExtraData: _propTypes2.default.any,
	  csvFormatExtraData: _propTypes2.default.any,
	  filter: _propTypes2.default.shape({
	    type: _propTypes2.default.oneOf(filterTypeArray),
	    delay: _propTypes2.default.number,
	    options: _propTypes2.default.oneOfType([_propTypes2.default.object, // for SelectFilter
	    _propTypes2.default.arrayOf(_propTypes2.default.number) // for NumberFilter
	    ]),
	    numberComparators: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    emitter: _propTypes2.default.object,
	    placeholder: _propTypes2.default.string,
	    getElement: _propTypes2.default.func,
	    customFilterParameters: _propTypes2.default.object,
	    condition: _propTypes2.default.oneOf([_Const2.default.FILTER_COND_EQ, _Const2.default.FILTER_COND_LIKE])
	  }),
	  sortIndicator: _propTypes2.default.bool,
	  export: _propTypes2.default.bool,
	  expandable: _propTypes2.default.bool,
	  tdAttr: _propTypes2.default.object,
	  editTdAttr: _propTypes2.default.object,
	  tdStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  thStyle: _propTypes2.default.object,
	  keyValidator: _propTypes2.default.bool,
	  defaultASC: _propTypes2.default.bool
	};
	
	TableHeaderColumn.defaultProps = {
	  dataAlign: 'left',
	  headerAlign: undefined,
	  headerTitle: true,
	  dataSort: false,
	  dataFormat: undefined,
	  csvFormat: undefined,
	  csvHeader: undefined,
	  csvFieldType: _Const2.default.CSV_STRING_TYPE,
	  isKey: false,
	  editable: true,
	  onSort: undefined,
	  hidden: false,
	  hiddenOnInsert: false,
	  searchable: true,
	  className: '',
	  columnTitle: false,
	  width: null,
	  sortFunc: undefined,
	  columnClassName: '',
	  editColumnClassName: '',
	  invalidEditColumnClassName: '',
	  filterFormatted: false,
	  filterValue: undefined,
	  sort: undefined,
	  formatExtraData: undefined,
	  sortFuncExtraData: undefined,
	  filter: undefined,
	  sortIndicator: true,
	  expandable: true,
	  tdAttr: undefined,
	  editTdAttr: undefined,
	  tdStyle: undefined,
	  thStyle: undefined,
	  keyValidator: false,
	  defaultASC: false
	};
	
	var _default = TableHeaderColumn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableHeaderColumn, 'TableHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
	
	  __REACT_HOT_LOADER__.register(filterTypeArray, 'filterTypeArray', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
	}();
	
	;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';
	
	var SizePerPageDropDown = function (_Component) {
	  _inherits(SizePerPageDropDown, _Component);
	
	  function SizePerPageDropDown() {
	    _classCallCheck(this, SizePerPageDropDown);
	
	    return _possibleConstructorReturn(this, (SizePerPageDropDown.__proto__ || Object.getPrototypeOf(SizePerPageDropDown)).apply(this, arguments));
	  }
	
	  _createClass(SizePerPageDropDown, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          hidden = _props.hidden,
	          onClick = _props.onClick,
	          onBlur = _props.onBlur,
	          options = _props.options,
	          className = _props.className,
	          variation = _props.variation,
	          btnContextual = _props.btnContextual,
	          isBootstrap4 = _props.isBootstrap4,
	          currSizePerPage = _props.currSizePerPage;
	
	
	      if (hidden) return null;
	
	      var openClass = open ? 'open show' : '';
	
	      var renderOptions = function renderOptions() {
	        var attrs = {
	          className: 'dropdown-menu ' + openClass,
	          role: 'menu',
	          'aria-labelledby': 'pageDropDown'
	        };
	        var type = isBootstrap4 ? 'div' : 'ul';
	
	        return _react2.default.createElement(type, attrs, options);
	      };
	
	      return _react2.default.createElement(
	        'span',
	        {
	          className: variation + ' ' + openClass + ' ' + className + ' ' + sizePerPageDefaultClass },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn ' + btnContextual + ' dropdown-toggle',
	            id: 'pageDropDown', 'data-toggle': 'dropdown',
	            'aria-expanded': open,
	            'aria-haspopup': !open,
	            onClick: onClick,
	            onBlur: onBlur },
	          currSizePerPage,
	          _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            _react2.default.createElement('span', { className: 'caret' })
	          )
	        ),
	        renderOptions()
	      );
	    }
	  }]);
	
	  return SizePerPageDropDown;
	}(_react.Component);
	
	SizePerPageDropDown.propTypes = {
	  open: _propTypes2.default.bool,
	  hidden: _propTypes2.default.bool,
	  btnContextual: _propTypes2.default.string,
	  currSizePerPage: _propTypes2.default.string,
	  options: _propTypes2.default.array,
	  variation: _propTypes2.default.oneOf(['dropdown', 'dropup']),
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func
	};
	SizePerPageDropDown.defaultProps = {
	  open: false,
	  hidden: false,
	  btnContextual: 'btn-default btn-secondary',
	  variation: 'dropdown',
	  className: ''
	};
	
	var _default = SizePerPageDropDown;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(sizePerPageDefaultClass, 'sizePerPageDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
	
	  __REACT_HOT_LOADER__.register(SizePerPageDropDown, 'SizePerPageDropDown', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
	}();
	
	;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var clearBtnDefaultClass = 'react-bs-table-search-clear-btn';
	
	var ClearSearchButton = function (_Component) {
	  _inherits(ClearSearchButton, _Component);
	
	  function ClearSearchButton() {
	    _classCallCheck(this, ClearSearchButton);
	
	    return _possibleConstructorReturn(this, (ClearSearchButton.__proto__ || Object.getPrototypeOf(ClearSearchButton)).apply(this, arguments));
	  }
	
	  _createClass(ClearSearchButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          btnContextual = _props.btnContextual,
	          className = _props.className,
	          onClick = _props.onClick,
	          btnText = _props.btnText,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnText', 'children']);
	
	      var content = children || _react2.default.createElement(
	        'span',
	        null,
	        btnText
	      );
	      return _react2.default.createElement(
	        'button',
	        _extends({
	          className: 'btn ' + btnContextual + ' ' + className + ' ' + clearBtnDefaultClass,
	          type: 'button',
	          onClick: onClick
	        }, rest),
	        content
	      );
	    }
	  }]);
	
	  return ClearSearchButton;
	}(_react.Component);
	
	ClearSearchButton.propTypes = {
	  btnContextual: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  btnText: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	ClearSearchButton.defaultProps = {
	  btnContextual: 'btn-default btn-secondary',
	  className: '',
	  btnText: 'Clear',
	  onClick: undefined
	};
	
	var _default = ClearSearchButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(clearBtnDefaultClass, 'clearBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
	
	  __REACT_HOT_LOADER__.register(ClearSearchButton, 'ClearSearchButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
	}();
	
	;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var deleteBtnDefaultClass = 'react-bs-table-del-btn';
	
	var DeleteButton = function (_Component) {
	  _inherits(DeleteButton, _Component);
	
	  function DeleteButton() {
	    _classCallCheck(this, DeleteButton);
	
	    return _possibleConstructorReturn(this, (DeleteButton.__proto__ || Object.getPrototypeOf(DeleteButton)).apply(this, arguments));
	  }
	
	  _createClass(DeleteButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          btnContextual = _props.btnContextual,
	          className = _props.className,
	          onClick = _props.onClick,
	          btnGlyphicon = _props.btnGlyphicon,
	          btnText = _props.btnText,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);
	
	      var content = children || _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
	        ' ',
	        btnText
	      );
	      return _react2.default.createElement(
	        'button',
	        _extends({ type: 'button',
	          className: 'btn ' + btnContextual + ' ' + deleteBtnDefaultClass + ' ' + className,
	          onClick: onClick
	        }, rest),
	        content
	      );
	    }
	  }]);
	
	  return DeleteButton;
	}(_react.Component);
	
	DeleteButton.propTypes = {
	  btnText: _propTypes2.default.string,
	  btnContextual: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  btnGlyphicon: _propTypes2.default.string
	};
	DeleteButton.defaultProps = {
	  btnText: _Const2.default.DELETE_BTN_TEXT,
	  btnContextual: 'btn-warning',
	  className: '',
	  onClick: undefined,
	  btnGlyphicon: 'glyphicon-trash fa-trash'
	};
	
	var _default = DeleteButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(deleteBtnDefaultClass, 'deleteBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
	
	  __REACT_HOT_LOADER__.register(DeleteButton, 'DeleteButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
	}();
	
	;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var exportCsvBtnDefaultClass = 'react-bs-table-csv-btn';
	
	var ExportCSVButton = function (_Component) {
	  _inherits(ExportCSVButton, _Component);
	
	  function ExportCSVButton() {
	    _classCallCheck(this, ExportCSVButton);
	
	    return _possibleConstructorReturn(this, (ExportCSVButton.__proto__ || Object.getPrototypeOf(ExportCSVButton)).apply(this, arguments));
	  }
	
	  _createClass(ExportCSVButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          btnContextual = _props.btnContextual,
	          className = _props.className,
	          onClick = _props.onClick,
	          btnGlyphicon = _props.btnGlyphicon,
	          btnText = _props.btnText,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);
	
	      var content = children || _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
	        ' ',
	        btnText
	      );
	      return _react2.default.createElement(
	        'button',
	        _extends({ type: 'button',
	          className: 'btn ' + btnContextual + ' ' + exportCsvBtnDefaultClass + ' ' + className + ' hidden-print',
	          onClick: onClick
	        }, rest),
	        content
	      );
	    }
	  }]);
	
	  return ExportCSVButton;
	}(_react.Component);
	
	ExportCSVButton.propTypes = {
	  btnText: _propTypes2.default.string,
	  btnContextual: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  btnGlyphicon: _propTypes2.default.string
	};
	ExportCSVButton.defaultProps = {
	  btnText: _Const2.default.EXPORT_CSV_TEXT,
	  btnContextual: 'btn-success',
	  className: '',
	  onClick: undefined,
	  btnGlyphicon: 'glyphicon-export fa-download'
	};
	
	var _default = ExportCSVButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(exportCsvBtnDefaultClass, 'exportCsvBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
	
	  __REACT_HOT_LOADER__.register(ExportCSVButton, 'ExportCSVButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
	}();
	
	;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var insertBtnDefaultClass = 'react-bs-table-add-btn';
	
	var InsertButton = function (_Component) {
	  _inherits(InsertButton, _Component);
	
	  function InsertButton() {
	    _classCallCheck(this, InsertButton);
	
	    return _possibleConstructorReturn(this, (InsertButton.__proto__ || Object.getPrototypeOf(InsertButton)).apply(this, arguments));
	  }
	
	  _createClass(InsertButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          btnContextual = _props.btnContextual,
	          className = _props.className,
	          onClick = _props.onClick,
	          btnGlyphicon = _props.btnGlyphicon,
	          btnText = _props.btnText,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);
	
	      var content = children || _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
	        ' ',
	        btnText
	      );
	      return _react2.default.createElement(
	        'button',
	        _extends({ type: 'button',
	          className: 'btn ' + btnContextual + ' ' + insertBtnDefaultClass + ' ' + className,
	          onClick: onClick
	        }, rest),
	        content
	      );
	    }
	  }]);
	
	  return InsertButton;
	}(_react.Component);
	
	InsertButton.propTypes = {
	  btnText: _propTypes2.default.string,
	  btnContextual: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  btnGlyphicon: _propTypes2.default.string
	};
	InsertButton.defaultProps = {
	  btnText: _Const2.default.INSERT_BTN_TEXT,
	  btnContextual: 'btn-info',
	  className: '',
	  onClick: undefined,
	  btnGlyphicon: 'glyphicon-plus fa-plus'
	};
	
	var _default = InsertButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(insertBtnDefaultClass, 'insertBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
	
	  __REACT_HOT_LOADER__.register(InsertButton, 'InsertButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
	}();
	
	;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Editor = __webpack_require__(611);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/display-name: 0 */
	
	
	var InsertModalBody = function (_Component) {
	  _inherits(InsertModalBody, _Component);
	
	  function InsertModalBody() {
	    _classCallCheck(this, InsertModalBody);
	
	    return _possibleConstructorReturn(this, (InsertModalBody.__proto__ || Object.getPrototypeOf(InsertModalBody)).apply(this, arguments));
	  }
	
	  _createClass(InsertModalBody, [{
	    key: 'getFieldValue',
	    value: function getFieldValue() {
	      var _this2 = this;
	
	      var newRow = {};
	      this.props.columns.forEach(function (column, i) {
	        var inputVal = void 0;
	        if (column.autoValue) {
	          // when you want same auto generate value and not allow edit, example ID field
	          var time = new Date().getTime();
	          inputVal = typeof column.autoValue === 'function' ? column.autoValue() : 'autovalue-' + time;
	        } else if (column.hiddenOnInsert || !column.field) {
	          inputVal = '';
	        } else {
	          var dom = _this2.refs[column.field + i];
	          inputVal = dom.value;
	
	          if (column.editable && column.editable.type === 'checkbox') {
	            var values = inputVal.split(':');
	            inputVal = dom.checked ? values[0] : values[1];
	          } else if (column.customInsertEditor) {
	            inputVal = inputVal || dom.getFieldValue();
	          }
	        }
	        newRow[column.field] = inputVal;
	      }, this);
	      return newRow;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          columns = _props.columns,
	          validateState = _props.validateState,
	          ignoreEditable = _props.ignoreEditable;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-body' },
	        columns.map(function (column, i) {
	          var editable = column.editable,
	              format = column.format,
	              field = column.field,
	              name = column.name,
	              autoValue = column.autoValue,
	              hiddenOnInsert = column.hiddenOnInsert,
	              customInsertEditor = column.customInsertEditor;
	
	          var attr = {
	            ref: field + i,
	            placeholder: editable.placeholder ? editable.placeholder : name
	          };
	          var fieldElement = void 0;
	          var defaultValue = editable.defaultValue || undefined;
	          if (customInsertEditor) {
	            var getElement = customInsertEditor.getElement;
	
	            fieldElement = getElement(column, attr, 'form-control', ignoreEditable, defaultValue);
	          }
	
	          // fieldElement = false, means to use default editor when enable custom editor
	          // Becasuse some users want to have default editor based on some condition.
	          if (!customInsertEditor || fieldElement === false) {
	            fieldElement = (0, _Editor2.default)(editable, attr, format, '', defaultValue, ignoreEditable);
	          }
	
	          if (autoValue || hiddenOnInsert || !column.field) {
	            // when you want same auto generate value
	            // and not allow edit, for example ID field
	            return null;
	          }
	          var error = validateState[field] ? _react2.default.createElement(
	            'span',
	            { className: 'help-block bg-danger' },
	            validateState[field]
	          ) : null;
	          return _react2.default.createElement(
	            'div',
	            { className: 'form-group', key: field },
	            _react2.default.createElement(
	              'label',
	              null,
	              name
	            ),
	            fieldElement,
	            error
	          );
	        })
	      );
	    }
	  }]);
	
	  return InsertModalBody;
	}(_react.Component);
	
	InsertModalBody.propTypes = {
	  columns: _propTypes2.default.array,
	  validateState: _propTypes2.default.object,
	  ignoreEditable: _propTypes2.default.bool
	};
	
	InsertModalBody.defaultProps = {
	  validateState: {},
	  ignoreEditable: false
	};
	
	var _default = InsertModalBody;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(InsertModalBody, 'InsertModalBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');
	}();
	
	;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsertModalFooter = function (_Component) {
	  _inherits(InsertModalFooter, _Component);
	
	  function InsertModalFooter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InsertModalFooter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalFooter.__proto__ || Object.getPrototypeOf(InsertModalFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
	      var _this2;
	
	      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _this.handleSaveBtnClick = function () {
	      var _this3;
	
	      return (_this3 = _this).__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this3, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InsertModalFooter, [{
	    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
	    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
	      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
	    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
	      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
	    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
	      var _props = this.props,
	          beforeClose = _props.beforeClose,
	          onModalClose = _props.onModalClose;
	
	      beforeClose && beforeClose(e);
	      onModalClose();
	    }
	  }, {
	    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
	    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(e) {
	      var _props2 = this.props,
	          beforeSave = _props2.beforeSave,
	          onSave = _props2.onSave;
	
	      beforeSave && beforeSave(e);
	      onSave();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          saveBtnText = _props3.saveBtnText,
	          closeBtnText = _props3.closeBtnText,
	          closeBtnContextual = _props3.closeBtnContextual,
	          saveBtnContextual = _props3.saveBtnContextual,
	          closeBtnClass = _props3.closeBtnClass,
	          saveBtnClass = _props3.saveBtnClass,
	          children = _props3.children;
	
	
	      var content = children || [_react2.default.createElement(
	        'button',
	        {
	          key: 'closeBtn',
	          type: 'button',
	          className: 'btn ' + closeBtnContextual + ' ' + closeBtnClass,
	          onClick: this.handleCloseBtnClick },
	        closeBtnText
	      ), _react2.default.createElement(
	        'button',
	        {
	          key: 'saveBtn',
	          type: 'button',
	          className: 'btn ' + saveBtnContextual + ' ' + saveBtnClass,
	          onClick: this.handleSaveBtnClick },
	        saveBtnText
	      )];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-footer ' + className },
	        content
	      );
	    }
	  }]);
	
	  return InsertModalFooter;
	}(_react.Component);
	
	InsertModalFooter.propTypes = {
	  className: _propTypes2.default.string,
	  saveBtnText: _propTypes2.default.string,
	  closeBtnText: _propTypes2.default.string,
	  closeBtnContextual: _propTypes2.default.string,
	  saveBtnContextual: _propTypes2.default.string,
	  closeBtnClass: _propTypes2.default.string,
	  saveBtnClass: _propTypes2.default.string,
	  beforeClose: _propTypes2.default.func,
	  beforeSave: _propTypes2.default.func,
	  onSave: _propTypes2.default.func,
	  onModalClose: _propTypes2.default.func
	};
	InsertModalFooter.defaultProps = {
	  className: '',
	  saveBtnText: _Const2.default.SAVE_BTN_TEXT,
	  closeBtnText: _Const2.default.CLOSE_BTN_TEXT,
	  closeBtnContextual: 'btn-default btn-secondary',
	  saveBtnContextual: 'btn-primary',
	  closeBtnClass: '',
	  saveBtnClass: '',
	  beforeClose: undefined,
	  beforeSave: undefined
	};
	
	var _default = InsertModalFooter;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(InsertModalFooter, 'InsertModalFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');
	}();
	
	;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsertModalHeader = function (_Component) {
	  _inherits(InsertModalHeader, _Component);
	
	  function InsertModalHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InsertModalHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalHeader.__proto__ || Object.getPrototypeOf(InsertModalHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
	      var _this2;
	
	      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InsertModalHeader, [{
	    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
	    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
	      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
	    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
	      var _props = this.props,
	          onModalClose = _props.onModalClose,
	          beforeClose = _props.beforeClose;
	
	      beforeClose && beforeClose(e);
	      onModalClose();
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent(closeBtn) {
	      var _props2 = this.props,
	          version = _props2.version,
	          titleText = _props2.title;
	
	      var title = _react2.default.createElement(
	        'h4',
	        { key: 'title', className: 'modal-title' },
	        titleText
	      );
	      if (_util2.default.isBootstrap4(version)) {
	        return [title, closeBtn];
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          closeBtn,
	          title
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          hideClose = _props3.hideClose,
	          className = _props3.className,
	          children = _props3.children;
	
	
	      var closeBtn = hideClose ? null : _react2.default.createElement(
	        'button',
	        { type: 'button',
	          className: 'close', onClick: this.handleCloseBtnClick },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'sr-only' },
	          'Close'
	        )
	      );
	
	      var content = children || this.renderContent(closeBtn);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-header ' + className },
	        content
	      );
	    }
	  }]);
	
	  return InsertModalHeader;
	}(_react.Component);
	
	InsertModalHeader.propTypes = {
	  version: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  onModalClose: _propTypes2.default.func,
	  hideClose: _propTypes2.default.bool,
	  beforeClose: _propTypes2.default.func
	};
	InsertModalHeader.defaultProps = {
	  version: '3',
	  className: '',
	  title: 'Add Row',
	  onModalClose: undefined,
	  hideClose: false,
	  beforeClose: undefined
	};
	
	var _default = InsertModalHeader;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(InsertModalHeader, 'InsertModalHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');
	}();
	
	;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchField = function (_Component) {
	  _inherits(SearchField, _Component);
	
	  function SearchField() {
	    _classCallCheck(this, SearchField);
	
	    return _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).apply(this, arguments));
	  }
	
	  _createClass(SearchField, [{
	    key: 'getValue',
	    value: function getValue() {
	      return _reactDom2.default.findDOMNode(this).value;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      _reactDom2.default.findDOMNode(this).value = value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          defaultValue = _props.defaultValue,
	          placeholder = _props.placeholder,
	          onKeyUp = _props.onKeyUp,
	          rest = _objectWithoutProperties(_props, ['className', 'defaultValue', 'placeholder', 'onKeyUp']);
	
	      return _react2.default.createElement('input', _extends({
	        className: 'form-control ' + className,
	        type: 'text',
	        defaultValue: defaultValue,
	        placeholder: placeholder || SearchField.defaultProps.placeholder,
	        onKeyUp: onKeyUp,
	        style: { zIndex: 0 }
	      }, rest));
	    }
	  }]);
	
	  return SearchField;
	}(_react.Component);
	
	SearchField.propTypes = {
	  className: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  onKeyUp: _propTypes2.default.func
	};
	SearchField.defaultProps = {
	  className: '',
	  defaultValue: '',
	  placeholder: 'Search',
	  onKeyUp: undefined
	};
	
	var _default = SearchField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SearchField, 'SearchField', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');
	}();
	
	;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var showSelectedOnlyBtnDefaultClass = 'react-bs-table-show-sel-only-btn';
	
	var ShowSelectedOnlyButton = function (_Component) {
	  _inherits(ShowSelectedOnlyButton, _Component);
	
	  function ShowSelectedOnlyButton() {
	    _classCallCheck(this, ShowSelectedOnlyButton);
	
	    return _possibleConstructorReturn(this, (ShowSelectedOnlyButton.__proto__ || Object.getPrototypeOf(ShowSelectedOnlyButton)).apply(this, arguments));
	  }
	
	  _createClass(ShowSelectedOnlyButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          btnContextual = _props.btnContextual,
	          className = _props.className,
	          onClick = _props.onClick,
	          toggle = _props.toggle,
	          showAllText = _props.showAllText,
	          showOnlySelectText = _props.showOnlySelectText,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'toggle', 'showAllText', 'showOnlySelectText', 'children']);
	
	      var content = children || _react2.default.createElement(
	        'span',
	        null,
	        toggle ? showAllText : showOnlySelectText
	      );
	      return _react2.default.createElement(
	        'button',
	        _extends({ type: 'button',
	          'aria-pressed': 'false',
	          'data-toggle': 'button',
	          className: 'btn ' + btnContextual + ' ' + showSelectedOnlyBtnDefaultClass + ' ' + className,
	          onClick: onClick
	        }, rest),
	        content
	      );
	    }
	  }]);
	
	  return ShowSelectedOnlyButton;
	}(_react.Component);
	
	ShowSelectedOnlyButton.propTypes = {
	  showAllText: _propTypes2.default.string,
	  showOnlySelectText: _propTypes2.default.string,
	  toggle: _propTypes2.default.bool,
	  btnContextual: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	ShowSelectedOnlyButton.defaultProps = {
	  showAllText: _Const2.default.SHOW_ALL,
	  showOnlySelectText: _Const2.default.SHOW_ONLY_SELECT,
	  toggle: false,
	  btnContextual: 'btn-primary',
	  className: '',
	  onClick: undefined
	};
	
	var _default = ShowSelectedOnlyButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(showSelectedOnlyBtnDefaultClass, 'showSelectedOnlyBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
	
	  __REACT_HOT_LOADER__.register(ShowSelectedOnlyButton, 'ShowSelectedOnlyButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
	}();
	
	;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(164);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(118);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(1248);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(118);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(91);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(247);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(164);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(1316);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(158);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(643);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(158);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 642 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1257), __esModule: true };

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1259), __esModule: true };

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(95);
	var document = __webpack_require__(71).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(93) && !__webpack_require__(119)(function () {
	  return Object.defineProperty(__webpack_require__(645)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(230);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(234);
	var $export = __webpack_require__(70);
	var redefine = __webpack_require__(653);
	var hide = __webpack_require__(94);
	var has = __webpack_require__(80);
	var Iterators = __webpack_require__(120);
	var $iterCreate = __webpack_require__(1274);
	var setToStringTag = __webpack_require__(237);
	var getPrototypeOf = __webpack_require__(1281);
	var ITERATOR = __webpack_require__(55)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(122);
	var createDesc = __webpack_require__(123);
	var toIObject = __webpack_require__(82);
	var toPrimitive = __webpack_require__(242);
	var has = __webpack_require__(80);
	var IE8_DOM_DEFINE = __webpack_require__(646);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(93) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(651);
	var hiddenKeys = __webpack_require__(233).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(80);
	var toIObject = __webpack_require__(82);
	var arrayIndexOf = __webpack_require__(1266)(false);
	var IE_PROTO = __webpack_require__(238)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(121);
	var toIObject = __webpack_require__(82);
	var isEnum = __webpack_require__(122).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(94);


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(240);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1283)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(648)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = activeElement;
	
	var _ownerDocument = __webpack_require__(96);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function activeElement() {
	  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
	  try {
	    return doc.activeElement;
	  } catch (e) {/* ie throws if no active element */}
	}
	module.exports = exports['default'];

/***/ },
/* 657 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offset;
	
	var _contains = __webpack_require__(97);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _isWindow = __webpack_require__(162);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(96);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function offset(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      win = (0, _isWindow2.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!(0, _contains2.default)(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  // IE8 getBoundingClientRect doesn't support width & height
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	
	  return box;
	}
	module.exports = exports['default'];

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(162);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelizeStyleName;
	
	var _camelize = __webpack_require__(1311);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^-ms-/; /**
	                          * Copyright 2014-2015, Facebook, Inc.
	                          * All rights reserved.
	                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	                          */
	function camelizeStyleName(string) {
	  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
	}
	module.exports = exports['default'];

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(249);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(124);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(248);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(97);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(666);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(124);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(161);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(660);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(161);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(245);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(162);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(96);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(669),
		PropTypes = __webpack_require__(2),
		createClass = __webpack_require__(98),
		moment = __webpack_require__(3),
		React = __webpack_require__(1),
		CalendarContainer = __webpack_require__(1327)
		;
	
	var viewModes = Object.freeze({
		YEARS: 'years',
		MONTHS: 'months',
		DAYS: 'days',
		TIME: 'time',
	});
	
	var TYPES = PropTypes;
	var Datetime = createClass({
		propTypes: {
			// value: TYPES.object | TYPES.string,
			// defaultValue: TYPES.object | TYPES.string,
			// viewDate: TYPES.object | TYPES.string,
			onFocus: TYPES.func,
			onBlur: TYPES.func,
			onChange: TYPES.func,
			onViewModeChange: TYPES.func,
			locale: TYPES.string,
			utc: TYPES.bool,
			input: TYPES.bool,
			// dateFormat: TYPES.string | TYPES.bool,
			// timeFormat: TYPES.string | TYPES.bool,
			inputProps: TYPES.object,
			timeConstraints: TYPES.object,
			viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
			isValidDate: TYPES.func,
			open: TYPES.bool,
			strictParsing: TYPES.bool,
			closeOnSelect: TYPES.bool,
			closeOnTab: TYPES.bool
		},
	
		getInitialState: function() {
			var state = this.getStateFromProps( this.props );
	
			if ( state.open === undefined )
				state.open = !this.props.input;
	
			state.currentView = this.props.dateFormat ?
				(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;
	
			return state;
		},
	
		parseDate: function (date, formats) {
			var parsedDate;
	
			if (date && typeof date === 'string')
				parsedDate = this.localMoment(date, formats.datetime);
			else if (date)
				parsedDate = this.localMoment(date);
	
			if (parsedDate && !parsedDate.isValid())
				parsedDate = null;
	
			return parsedDate;
		},
	
		getStateFromProps: function( props ) {
			var formats = this.getFormats( props ),
				date = props.value || props.defaultValue,
				selectedDate, viewDate, updateOn, inputValue
				;
	
			selectedDate = this.parseDate(date, formats);
	
			viewDate = this.parseDate(props.viewDate, formats);
	
			viewDate = selectedDate ?
				selectedDate.clone().startOf('month') :
				viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');
	
			updateOn = this.getUpdateOn(formats);
	
			if ( selectedDate )
				inputValue = selectedDate.format(formats.datetime);
			else if ( date.isValid && !date.isValid() )
				inputValue = '';
			else
				inputValue = date || '';
	
			return {
				updateOn: updateOn,
				inputFormat: formats.datetime,
				viewDate: viewDate,
				selectedDate: selectedDate,
				inputValue: inputValue,
				open: props.open
			};
		},
	
		getUpdateOn: function( formats ) {
			if ( formats.date.match(/[lLD]/) ) {
				return viewModes.DAYS;
			} else if ( formats.date.indexOf('M') !== -1 ) {
				return viewModes.MONTHS;
			} else if ( formats.date.indexOf('Y') !== -1 ) {
				return viewModes.YEARS;
			}
	
			return viewModes.DAYS;
		},
	
		getFormats: function( props ) {
			var formats = {
					date: props.dateFormat || '',
					time: props.timeFormat || ''
				},
				locale = this.localMoment( props.date, null, props ).localeData()
				;
	
			if ( formats.date === true ) {
				formats.date = locale.longDateFormat('L');
			}
			else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
				formats.time = '';
			}
	
			if ( formats.time === true ) {
				formats.time = locale.longDateFormat('LT');
			}
	
			formats.datetime = formats.date && formats.time ?
				formats.date + ' ' + formats.time :
				formats.date || formats.time
			;
	
			return formats;
		},
	
		componentWillReceiveProps: function( nextProps ) {
			var formats = this.getFormats( nextProps ),
				updatedState = {}
			;
	
			if ( nextProps.value !== this.props.value ||
				formats.datetime !== this.getFormats( this.props ).datetime ) {
				updatedState = this.getStateFromProps( nextProps );
			}
	
			if ( updatedState.open === undefined ) {
				if ( typeof nextProps.open !== 'undefined' ) {
					updatedState.open = nextProps.open;
				} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
					updatedState.open = false;
				} else {
					updatedState.open = this.state.open;
				}
			}
	
			if ( nextProps.viewMode !== this.props.viewMode ) {
				updatedState.currentView = nextProps.viewMode;
			}
	
			if ( nextProps.locale !== this.props.locale ) {
				if ( this.state.viewDate ) {
					var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
					updatedState.viewDate = updatedViewDate;
				}
				if ( this.state.selectedDate ) {
					var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
					updatedState.selectedDate = updatedSelectedDate;
					updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
				}
			}
	
			if ( nextProps.utc !== this.props.utc ) {
				if ( nextProps.utc ) {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().utc();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().utc();
						updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
					}
				} else {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().local();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().local();
						updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
					}
				}
			}
	
			if ( nextProps.viewDate !== this.props.viewDate ) {
				updatedState.viewDate = moment(nextProps.viewDate);
			}
			//we should only show a valid date if we are provided a isValidDate function. Removed in 2.10.3
			/*if (this.props.isValidDate) {
				updatedState.viewDate = updatedState.viewDate || this.state.viewDate;
				while (!this.props.isValidDate(updatedState.viewDate)) {
					updatedState.viewDate = updatedState.viewDate.add(1, 'day');
				}
			}*/
			this.setState( updatedState );
		},
	
		onInputChange: function( e ) {
			var value = e.target === null ? e : e.target.value,
				localMoment = this.localMoment( value, this.state.inputFormat ),
				update = { inputValue: value }
				;
	
			if ( localMoment.isValid() && !this.props.value ) {
				update.selectedDate = localMoment;
				update.viewDate = localMoment.clone().startOf('month');
			} else {
				update.selectedDate = null;
			}
	
			return this.setState( update, function() {
				return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
			});
		},
	
		onInputKey: function( e ) {
			if ( e.which === 9 && this.props.closeOnTab ) {
				this.closeCalendar();
			}
		},
	
		showView: function( view ) {
			var me = this;
			return function() {
				me.state.currentView !== view && me.props.onViewModeChange( view );
				me.setState({ currentView: view });
			};
		},
	
		setDate: function( type ) {
			var me = this,
				nextViews = {
					month: viewModes.DAYS,
					year: viewModes.MONTHS,
				}
			;
			return function( e ) {
				me.setState({
					viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
					currentView: nextViews[ type ]
				});
				me.props.onViewModeChange( nextViews[ type ] );
			};
		},
	
		addTime: function( amount, type, toSelected ) {
			return this.updateTime( 'add', amount, type, toSelected );
		},
	
		subtractTime: function( amount, type, toSelected ) {
			return this.updateTime( 'subtract', amount, type, toSelected );
		},
	
		updateTime: function( op, amount, type, toSelected ) {
			var me = this;
	
			return function() {
				var update = {},
					date = toSelected ? 'selectedDate' : 'viewDate'
				;
	
				update[ date ] = me.state[ date ].clone()[ op ]( amount, type );
	
				me.setState( update );
			};
		},
	
		allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
		setTime: function( type, value ) {
			var index = this.allowedSetTime.indexOf( type ) + 1,
				state = this.state,
				date = (state.selectedDate || state.viewDate).clone(),
				nextType
				;
	
			// It is needed to set all the time properties
			// to not to reset the time
			date[ type ]( value );
			for (; index < this.allowedSetTime.length; index++) {
				nextType = this.allowedSetTime[index];
				date[ nextType ]( date[nextType]() );
			}
	
			if ( !this.props.value ) {
				this.setState({
					selectedDate: date,
					inputValue: date.format( state.inputFormat )
				});
			}
			this.props.onChange( date );
		},
	
		updateSelectedDate: function( e, close ) {
			var target = e.target,
				modifier = 0,
				viewDate = this.state.viewDate,
				currentDate = this.state.selectedDate || viewDate,
				date
				;
	
			if (target.className.indexOf('rdtDay') !== -1) {
				if (target.className.indexOf('rdtNew') !== -1)
					modifier = 1;
				else if (target.className.indexOf('rdtOld') !== -1)
					modifier = -1;
	
				date = viewDate.clone()
					.month( viewDate.month() + modifier )
					.date( parseInt( target.getAttribute('data-value'), 10 ) );
			} else if (target.className.indexOf('rdtMonth') !== -1) {
				date = viewDate.clone()
					.month( parseInt( target.getAttribute('data-value'), 10 ) )
					.date( currentDate.date() );
			} else if (target.className.indexOf('rdtYear') !== -1) {
				date = viewDate.clone()
					.month( currentDate.month() )
					.date( currentDate.date() )
					.year( parseInt( target.getAttribute('data-value'), 10 ) );
			}
	
			date.hours( currentDate.hours() )
				.minutes( currentDate.minutes() )
				.seconds( currentDate.seconds() )
				.milliseconds( currentDate.milliseconds() );
	
			if ( !this.props.value ) {
				var open = !( this.props.closeOnSelect && close );
				if ( !open ) {
					this.props.onBlur( date );
				}
	
				this.setState({
					selectedDate: date,
					viewDate: date.clone().startOf('month'),
					inputValue: date.format( this.state.inputFormat ),
					open: open
				});
			} else {
				if ( this.props.closeOnSelect && close ) {
					this.closeCalendar();
				}
			}
	
			this.props.onChange( date );
		},
	
		openCalendar: function( e ) {
			if ( !this.state.open ) {
				this.setState({ open: true }, function() {
					this.props.onFocus( e );
				});
			}
		},
	
		closeCalendar: function() {
			this.setState({ open: false }, function () {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		},
	
		handleClickOutside: function() {
			if ( this.props.input && this.state.open && !this.props.open && !this.props.disableOnClickOutside ) {
				this.setState({ open: false }, function() {
					this.props.onBlur( this.state.selectedDate || this.state.inputValue );
				});
			}
		},
	
		localMoment: function( date, format, props ) {
			props = props || this.props;
			var momentFn = props.utc ? moment.utc : moment;
			var m = momentFn( date, format, props.strictParsing );
			if ( props.locale )
				m.locale( props.locale );
			return m;
		},
	
		componentProps: {
			fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
			fromState: ['viewDate', 'selectedDate', 'updateOn'],
			fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
		},
	
		getComponentProps: function() {
			var me = this,
				formats = this.getFormats( this.props ),
				props = {dateFormat: formats.date, timeFormat: formats.time}
				;
	
			this.componentProps.fromProps.forEach( function( name ) {
				props[ name ] = me.props[ name ];
			});
			this.componentProps.fromState.forEach( function( name ) {
				props[ name ] = me.state[ name ];
			});
			this.componentProps.fromThis.forEach( function( name ) {
				props[ name ] = me[ name ];
			});
	
			return props;
		},
	
		render: function() {
			// TODO: Make a function or clean up this code,
			// logic right now is really hard to follow
			var className = 'rdt' + (this.props.className ?
	                  ( Array.isArray( this.props.className ) ?
	                  ' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
				children = [];
	
			if ( this.props.input ) {
				var finalInputProps = assign({
					type: 'text',
					className: 'form-control',
					onClick: this.openCalendar,
					onFocus: this.openCalendar,
					onChange: this.onInputChange,
					onKeyDown: this.onInputKey,
					value: this.state.inputValue,
				}, this.props.inputProps);
				if ( this.props.renderInput ) {
					children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
				} else {
					children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
				}
			} else {
				className += ' rdtStatic';
			}
	
			if ( this.state.open )
				className += ' rdtOpen';
	
			return React.createElement( 'div', { className: className }, children.concat(
				React.createElement( 'div',
					{ key: 'dt', className: 'rdtPicker' },
					React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps(), onClickOutside: this.handleClickOutside })
				)
			));
		}
	});
	
	Datetime.defaultProps = {
		className: '',
		defaultValue: '',
		inputProps: {},
		input: true,
		onFocus: function() {},
		onBlur: function() {},
		onChange: function() {},
		onViewModeChange: function() {},
		timeFormat: true,
		timeConstraints: {},
		dateFormat: true,
		strictParsing: true,
		closeOnSelect: false,
		closeOnTab: true,
		utc: false
	};
	
	// Make moment accessible through the Datetime class
	Datetime.moment = moment;
	
	module.exports = Datetime;


/***/ },
/* 669 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 670 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(83);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(100);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactInstrumentation = __webpack_require__(43);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1390);
	var warning = __webpack_require__(26);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 673 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(266);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var LinkedValueUtils = __webpack_require__(255);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(50);
	
	var warning = __webpack_require__(26);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var ReactUpdates = __webpack_require__(50);
	var Transaction = __webpack_require__(170);
	
	var emptyFunction = __webpack_require__(61);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1332);
	var BeforeInputEventPlugin = __webpack_require__(1334);
	var ChangeEventPlugin = __webpack_require__(1336);
	var DefaultEventPluginOrder = __webpack_require__(1338);
	var EnterLeaveEventPlugin = __webpack_require__(1339);
	var HTMLDOMPropertyConfig = __webpack_require__(1341);
	var ReactComponentBrowserEnvironment = __webpack_require__(1343);
	var ReactDOMComponent = __webpack_require__(1346);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactDOMEmptyComponent = __webpack_require__(1347);
	var ReactDOMTreeTraversal = __webpack_require__(1356);
	var ReactDOMTextComponent = __webpack_require__(1354);
	var ReactDefaultBatchingStrategy = __webpack_require__(676);
	var ReactEventListener = __webpack_require__(1359);
	var ReactInjection = __webpack_require__(1360);
	var ReactReconcileTransaction = __webpack_require__(1364);
	var SVGDOMPropertyConfig = __webpack_require__(1369);
	var SelectEventPlugin = __webpack_require__(1370);
	var SimpleEventPlugin = __webpack_require__(1371);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 678 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1352);
	
	var containsNode = __webpack_require__(1394);
	var focusNode = __webpack_require__(697);
	var getActiveElement = __webpack_require__(698);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1382);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var DOMLazyTree = __webpack_require__(99);
	var DOMProperty = __webpack_require__(100);
	var React = __webpack_require__(85);
	var ReactBrowserEventEmitter = __webpack_require__(168);
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactDOMContainerInfo = __webpack_require__(674);
	var ReactDOMFeatureFlags = __webpack_require__(1348);
	var ReactFeatureFlags = __webpack_require__(679);
	var ReactInstanceMap = __webpack_require__(127);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMarkupChecksum = __webpack_require__(682);
	var ReactReconciler = __webpack_require__(84);
	var ReactUpdateQueue = __webpack_require__(258);
	var ReactUpdates = __webpack_require__(50);
	
	var emptyObject = __webpack_require__(267);
	var instantiateReactComponent = __webpack_require__(263);
	var invariant = __webpack_require__(15);
	var setInnerHTML = __webpack_require__(172);
	var shouldUpdateReactComponent = __webpack_require__(265);
	var warning = __webpack_require__(26);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var React = __webpack_require__(85);
	
	var invariant = __webpack_require__(15);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var PooledClass = __webpack_require__(83);
	var Transaction = __webpack_require__(170);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactServerUpdateQueue = __webpack_require__(1368);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 686 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 687 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 689 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(684);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(29);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 693 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	var escapeTextContentForBrowser = __webpack_require__(171);
	var setInnerHTML = __webpack_require__(172);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var REACT_ELEMENT_TYPE = __webpack_require__(1357);
	
	var getIteratorFn = __webpack_require__(1387);
	var invariant = __webpack_require__(15);
	var KeyEscapeUtils = __webpack_require__(254);
	var warning = __webpack_require__(26);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(61);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 697 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 698 */
454,
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(1413);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string") {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(1024);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 701 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(1423);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(1424);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1421);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(705);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(1433);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(269);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 706 */
[1636, 1431],
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This is largely taken from react-router/lib/Link.
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	function createLocationDescriptor(to, query, hash, state) {
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	var propTypes = {
	  onlyActiveOnIndex: _propTypes2.default.bool.isRequired,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]).isRequired,
	  query: _propTypes2.default.string,
	  hash: _propTypes2.default.string,
	  state: _propTypes2.default.object,
	  action: _propTypes2.default.oneOf(['push', 'replace']).isRequired,
	  onClick: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  target: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired
	};
	
	var contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var defaultProps = {
	  onlyActiveOnIndex: false,
	  action: 'push'
	};
	
	var LinkContainer = function (_React$Component) {
	  _inherits(LinkContainer, _React$Component);
	
	  function LinkContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function (event) {
	      var _this$props = _this.props,
	          to = _this$props.to,
	          query = _this$props.query,
	          hash = _this$props.hash,
	          state = _this$props.state,
	          children = _this$props.children,
	          onClick = _this$props.onClick,
	          target = _this$props.target,
	          action = _this$props.action;
	      var router = _this.context.router;
	
	
	      var toLocation = resolveToLocation(to, router);
	
	      if (children.props.onClick) {
	        children.props.onClick(event);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	
	      if (target || event.defaultPrevented || isModifiedEvent(event) || !isLeftClickEvent(event)) {
	        return;
	      }
	
	      event.preventDefault();
	
	      router[action](createLocationDescriptor(toLocation, query, hash, state));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LinkContainer.prototype.render = function render() {
	    var router = this.context.router;
	
	    var _props = this.props,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        to = _props.to,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['onlyActiveOnIndex', 'to', 'children']);
	
	    var toLocation = resolveToLocation(to, router);
	
	    props.onClick = this.onClick;
	
	    // Ignore if rendered outside Router context; simplifies unit testing.
	    if (router) {
	      props.href = router.createHref(toLocation);
	
	      if (props.active == null) {
	        props.active = router.isActive(toLocation, onlyActiveOnIndex);
	      }
	    }
	
	    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
	  };
	
	  return LinkContainer;
	}(_react2.default.Component);
	
	LinkContainer.propTypes = propTypes;
	LinkContainer.contextTypes = contextTypes;
	LinkContainer.defaultProps = defaultProps;
	
	exports.default = LinkContainer;
	module.exports = exports['default'];

/***/ },
/* 708 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(710);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(708);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1436);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1435);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 710 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(272);
	
	var _ContextUtils = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 712 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _PatternUtils = __webpack_require__(102);
	
	var _InternalPropTypes = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 714 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(461);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(460);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1035);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(718);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(103);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1445);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1442);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1449);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1446);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1451);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(461);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(460);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(20), __webpack_require__(2), __webpack_require__(275), __webpack_require__(274), __webpack_require__(1454)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('react-dom'), require('prop-types'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-store'), require('./SAlertContentTmpl'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.reactDom, global.propTypes, global.sAlertTools, global.sAlertStore, global.SAlertContentTmpl);
	        global.SAlertContent = mod.exports;
	    }
	})(this, function (exports, _react, _reactDom, _propTypes, _sAlertTools, _sAlertStore, _SAlertContentTmpl) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _reactDom2 = _interopRequireDefault(_reactDom);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);
	
	    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);
	
	    var _SAlertContentTmpl2 = _interopRequireDefault(_SAlertContentTmpl);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var SAlertContent = function (_React$Component) {
	        _inherits(SAlertContent, _React$Component);
	
	        function SAlertContent(props) {
	            _classCallCheck(this, SAlertContent);
	
	            return _possibleConstructorReturn(this, (SAlertContent.__proto__ || Object.getPrototypeOf(SAlertContent)).call(this, props));
	        }
	
	        _createClass(SAlertContent, [{
	            key: 'handleCloseAlert',
	            value: function handleCloseAlert() {
	                var closingTimeout = void 0;
	                var alertId = this.props.id;
	                var currentAlertElem = _reactDom2.default.findDOMNode(this);
	                var animationClose = function animationClose() {
	                    currentAlertElem.style.display = 'none';
	                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
	                    clearTimeout(closingTimeout);
	                };
	                if (document.hidden || document.webkitHidden || !currentAlertElem.classList.contains('s-alert-is-effect')) {
	                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
	                } else {
	                    currentAlertElem.classList.remove('s-alert-show');
	                    closingTimeout = setTimeout(function () {
	                        currentAlertElem.classList.add('s-alert-hide');
	                    }, 100);
	                    currentAlertElem.removeEventListener('webkitAnimationEnd', animationClose, false);
	                    currentAlertElem.removeEventListener('animationend', animationClose, false);
	                    currentAlertElem.addEventListener('webkitAnimationEnd', animationClose, false);
	                    currentAlertElem.addEventListener('animationend', animationClose, false);
	                }
	                // stop audio when closing
	                this.alertAudio && this.alertAudio.load();
	            }
	        }, {
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var beep = this.props.beep;
	                var condition = this.props.condition;
	                if (beep && typeof beep === 'string') {
	                    this.alertAudio = new Audio(beep);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'info') {
	                    this.alertAudio = new Audio(beep.info);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'error') {
	                    this.alertAudio = new Audio(beep.error);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'success') {
	                    this.alertAudio = new Audio(beep.success);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'warning') {
	                    this.alertAudio = new Audio(beep.warning);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                if (typeof this.props.timeout === 'number') {
	                    this.closeTimer = setTimeout(function () {
	                        _this2.handleCloseAlert();
	                    }, this.props.timeout);
	                }
	                if (this.props.onShow) {
	                    this.props.onShow();
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                if (this.closeTimer) {
	                    clearTimeout(this.closeTimer);
	                }
	                if (this.props.onClose) {
	                    this.props.onClose();
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var classNames = 's-alert-box s-alert-' + this.props.condition + ' s-alert-' + this.props.position + ' ' + (this.props.effect ? 's-alert-is-effect s-alert-effect-' + this.props.effect : '') + ' s-alert-show';
	                var message = this.props.html ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.message } }) : this.props.message;
	                var styles = this.props.boxPosition ? _sAlertTools2.default.styleToObj(this.props.boxPosition) : {};
	                var id = this.props.id;
	                var handleClose = this.handleCloseAlert.bind(this);
	                var contentTemplate = this.props.contentTemplate || _SAlertContentTmpl2.default;
	                var customFields = this.props.customFields || {};
	                var condition = this.props.condition;
	
	                return _react2.default.createElement(contentTemplate, { classNames: classNames, id: id, styles: styles, message: message, handleClose: handleClose, customFields: customFields, condition: condition });
	            }
	        }]);
	
	        return SAlertContent;
	    }(_react2.default.Component);
	
	    SAlertContent.propTypes = {
	        condition: _propTypes2.default.string.isRequired,
	        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	        position: _propTypes2.default.string.isRequired,
	        boxPosition: _propTypes2.default.string,
	        id: _propTypes2.default.string.isRequired,
	        effect: _propTypes2.default.string,
	        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
	        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
	        html: _propTypes2.default.bool,
	        onClose: _propTypes2.default.func,
	        onShow: _propTypes2.default.func,
	        customFields: _propTypes2.default.object,
	        contentTemplate: _propTypes2.default.func
	    };
	
	    exports.default = SAlertContent;
	});

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1453);

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(174);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(727);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(276);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(277);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(174);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1459);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 727 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(130),
	    _assign = __webpack_require__(178);
	
	var ReactNoopUpdateQueue = __webpack_require__(731);
	
	var canDefineProperty = __webpack_require__(732);
	var emptyObject = __webpack_require__(734);
	var invariant = __webpack_require__(105);
	var lowPriorityWarning = __webpack_require__(1490);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(130);
	
	var ReactCurrentOwner = __webpack_require__(62);
	
	var invariant = __webpack_require__(105);
	var warning = __webpack_require__(177);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 730 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(177);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 733 */
61,
/* 734 */
267,
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(1022);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(279);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: { form: form, field: field, index: index },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: { form: form, field: field, from: from, to: to }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: { form: form, field: field, index: index }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: { form: form, field: field }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: { form: form, field: field, touch: touch },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: { form: form }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: { form: form, field: field }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
	    form[_key] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: { form: form }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: { form: form, field: field }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty) {
	  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, type: type }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: { form: form }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: { form: form, field: field }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: { form: form, fields: fields },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: { form: form, fields: fields },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var unregisterField = function unregisterField(form, name) {
	  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: { form: form },
	    payload: { syncErrors: syncErrors, error: error }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: { form: form },
	    payload: { syncWarnings: syncWarnings, warning: warning }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	
	exports.default = actions;

/***/ },
/* 737 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: value === _value,
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: value || undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(_ref2, name, _ref) {
	  var getIn = _ref2.getIn,
	      toJS = _ref2.toJS;
	
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      onDrop = _ref.onDrop,
	      onDragStart = _ref.onDragStart,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      onFocus = _ref.onFocus,
	      form = _ref.form,
	      format = _ref.format,
	      initial = _ref.initial,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      validate = _ref.validate,
	      value = _ref.value,
	      _value = _ref._value,
	      warn = _ref.warn,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value),
	    meta: _extends({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ },
/* 738 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	exports.default = defaultShouldAsyncValidate;

/***/ },
/* 739 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldValidate;

/***/ },
/* 740 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(1513);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(1533);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  // read value from input
	  var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	  // parse value if we have a parser
	  if (parse) {
	    value = parse(value, name);
	  }
	
	  // normalize value
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	exports.default = onChangeValue;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(740);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	exports.default = silenceEvent;

/***/ },
/* 743 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      var formState = nonNullGetFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(485);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  return !(0, _isEqualWith3.default)(instance.props, nextProps, customizer) || !(0, _isEqualWith3.default)(instance.state, nextState, customizer);
	};
	
	exports.default = shallowCompare;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createPersistor;
	
	var _constants = __webpack_require__(132);
	
	var _asyncLocalStorage = __webpack_require__(746);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	var _purgeStoredState = __webpack_require__(749);
	
	var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);
	
	var _jsonStringifySafe = __webpack_require__(1566);
	
	var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPersistor(store, config) {
	  // defaults
	  var serializer = config.serialize === false ? function (data) {
	    return data;
	  } : defaultSerializer;
	  var deserializer = config.serialize === false ? function (data) {
	    return data;
	  } : defaultDeserializer;
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var transforms = config.transforms || [];
	  var debounce = config.debounce || false;
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // pluggable state shape (e.g. immutablejs)
	  var stateInit = config._stateInit || {};
	  var stateIterator = config._stateIterator || defaultStateIterator;
	  var stateGetter = config._stateGetter || defaultStateGetter;
	  var stateSetter = config._stateSetter || defaultStateSetter;
	
	  // storage with keys -> getAllKeys for localForage support
	  var storage = config.storage || (0, _asyncLocalStorage2.default)('local');
	  if (storage.keys && !storage.getAllKeys) {
	    storage.getAllKeys = storage.keys;
	  }
	
	  // initialize stateful values
	  var lastState = stateInit;
	  var paused = false;
	  var storesToProcess = [];
	  var timeIterator = null;
	
	  store.subscribe(function () {
	    if (paused) return;
	
	    var state = store.getState();
	
	    stateIterator(state, function (subState, key) {
	      if (!passWhitelistBlacklist(key)) return;
	      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
	      if (storesToProcess.indexOf(key) !== -1) return;
	      storesToProcess.push(key);
	    });
	
	    var len = storesToProcess.length;
	
	    // time iterator (read: debounce)
	    if (timeIterator === null) {
	      timeIterator = setInterval(function () {
	        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
	          clearInterval(timeIterator);
	          timeIterator = null;
	          return;
	        }
	
	        var key = storesToProcess.shift();
	        var storageKey = createStorageKey(key);
	        var endState = transforms.reduce(function (subState, transformer) {
	          return transformer.in(subState, key);
	        }, stateGetter(store.getState(), key));
	        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
	      }, debounce);
	    }
	
	    lastState = state;
	  });
	
	  function passWhitelistBlacklist(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return false;
	    if (blacklist.indexOf(key) !== -1) return false;
	    return true;
	  }
	
	  function adhocRehydrate(incoming) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var state = {};
	    if (options.serial) {
	      stateIterator(incoming, function (subState, key) {
	        try {
	          var data = deserializer(subState);
	          var value = transforms.reduceRight(function (interState, transformer) {
	            return transformer.out(interState, key);
	          }, data);
	          state = stateSetter(state, key, value);
	        } catch (err) {
	          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
	        }
	      });
	    } else state = incoming;
	
	    store.dispatch(rehydrateAction(state));
	    return state;
	  }
	
	  function createStorageKey(key) {
	    return '' + keyPrefix + key;
	  }
	
	  // return `persistor`
	  return {
	    rehydrate: adhocRehydrate,
	    pause: function pause() {
	      paused = true;
	    },
	    resume: function resume() {
	      paused = false;
	    },
	    purge: function purge(keys) {
	      return (0, _purgeStoredState2.default)({ storage: storage, keyPrefix: keyPrefix }, keys);
	    }
	  };
	}
	
	function warnIfSetError(key) {
	  return function setError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}
	
	function defaultSerializer(data) {
	  return (0, _jsonStringifySafe2.default)(data, null, null, function (k, v) {
	    if (false) return null;
	    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
	  });
	}
	
	function defaultDeserializer(serial) {
	  return JSON.parse(serial);
	}
	
	function rehydrateAction(data) {
	  return {
	    type: _constants.REHYDRATE,
	    payload: data
	  };
	}
	
	function defaultStateIterator(collection, callback) {
	  return Object.keys(collection).forEach(function (key) {
	    return callback(collection[key], key);
	  });
	}
	
	function defaultStateGetter(state, key) {
	  return state[key];
	}
	
	function defaultStateSetter(state, key, value) {
	  state[key] = value;
	  return state;
	}

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (type, config) {
	  var storage = getStorage(type);
	  return {
	    getAllKeys: function getAllKeys(cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var keys = [];
	          for (var i = 0; i < storage.length; i++) {
	            keys.push(storage.key(i));
	          }
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null, keys);
	            resolve(keys);
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    getItem: function getItem(key, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var s = storage.getItem(key);
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null, s);
	            resolve(s);
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    setItem: function setItem(key, string, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          storage.setItem(key, string);
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null);
	            resolve();
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    removeItem: function removeItem(key, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          storage.removeItem(key);
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null);
	            resolve();
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    }
	  };
	};
	
	var _setImmediate = __webpack_require__(750);
	
	var _setImmediate2 = _interopRequireDefault(_setImmediate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noStorage = function noStorage() {
	  /* noop */return null;
	};
	if (false) {
	  noStorage = function noStorage() {
	    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
	    return null;
	  };
	}
	
	function _hasStorage(storageType) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
	    return false;
	  }
	
	  try {
	    var storage = window[storageType];
	    var testKey = 'redux-persist ' + storageType + ' test';
	    storage.setItem(testKey, 'test');
	    storage.getItem(testKey);
	    storage.removeItem(testKey);
	  } catch (e) {
	    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
	    return false;
	  }
	  return true;
	}
	
	function hasLocalStorage() {
	  return _hasStorage('localStorage');
	}
	
	function hasSessionStorage() {
	  return _hasStorage('sessionStorage');
	}
	
	function getStorage(type) {
	  if (type === 'local') {
	    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	  if (type === 'session') {
	    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	}

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = getStoredState;
	
	var _constants = __webpack_require__(132);
	
	var _asyncLocalStorage = __webpack_require__(746);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStoredState(config, onComplete) {
	  var storage = config.storage || (0, _asyncLocalStorage2.default)('local');
	  var deserializer = config.serialize === false ? function (data) {
	    return data;
	  } : defaultDeserializer;
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var transforms = config.transforms || [];
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // fallback getAllKeys to `keys` if present (LocalForage compatability)
	  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });
	
	  var restoredState = {};
	  var completionCount = 0;
	
	  storage.getAllKeys(function (err, allKeys) {
	    if (err) {
	      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
	      complete(err);
	    }
	
	    var persistKeys = allKeys.filter(function (key) {
	      return key.indexOf(keyPrefix) === 0;
	    }).map(function (key) {
	      return key.slice(keyPrefix.length);
	    });
	    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);
	
	    var restoreCount = keysToRestore.length;
	    if (restoreCount === 0) complete(null, restoredState);
	    keysToRestore.forEach(function (key) {
	      storage.getItem(createStorageKey(key), function (err, serialized) {
	        if (err && ("production") !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
	        completionCount += 1;
	        if (completionCount === restoreCount) complete(null, restoredState);
	      });
	    });
	  });
	
	  function rehydrate(key, serialized) {
	    var state = null;
	
	    try {
	      var data = deserializer(serialized);
	      state = transforms.reduceRight(function (subState, transformer) {
	        return transformer.out(subState, key);
	      }, data);
	    } catch (err) {
	      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
	    }
	
	    return state;
	  }
	
	  function complete(err, restoredState) {
	    onComplete(err, restoredState);
	  }
	
	  function passWhitelistBlacklist(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return false;
	    if (blacklist.indexOf(key) !== -1) return false;
	    return true;
	  }
	
	  function createStorageKey(key) {
	    return '' + keyPrefix + key;
	  }
	
	  if (typeof onComplete !== 'function' && !!Promise) {
	    return new Promise(function (resolve, reject) {
	      onComplete = function onComplete(err, restoredState) {
	        if (err) reject(err);else resolve(restoredState);
	      };
	    });
	  }
	}
	
	function defaultDeserializer(serial) {
	  return JSON.parse(serial);
	}

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storages = exports.purgeStoredState = exports.persistStore = exports.getStoredState = exports.createTransform = exports.createPersistor = exports.autoRehydrate = undefined;
	
	var _autoRehydrate = __webpack_require__(1562);
	
	var _autoRehydrate2 = _interopRequireDefault(_autoRehydrate);
	
	var _createPersistor = __webpack_require__(745);
	
	var _createPersistor2 = _interopRequireDefault(_createPersistor);
	
	var _createTransform = __webpack_require__(1563);
	
	var _createTransform2 = _interopRequireDefault(_createTransform);
	
	var _getStoredState = __webpack_require__(747);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var _persistStore = __webpack_require__(1564);
	
	var _persistStore2 = _interopRequireDefault(_persistStore);
	
	var _purgeStoredState = __webpack_require__(749);
	
	var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @TODO remove in v5
	var deprecated = function deprecated(cb, cb2, cb3) {
	  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
	  if (typeof cb === 'function') cb();
	  if (typeof cb2 === 'function') cb2();
	  if (typeof cb3 === 'function') cb3();
	};
	var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
	var storages = {
	  asyncLocalStorage: deprecatedStorage,
	  asyncSessionStorage: deprecatedStorage
	};
	
	exports.autoRehydrate = _autoRehydrate2.default;
	exports.createPersistor = _createPersistor2.default;
	exports.createTransform = _createTransform2.default;
	exports.getStoredState = _getStoredState2.default;
	exports.persistStore = _persistStore2.default;
	exports.purgeStoredState = _purgeStoredState2.default;
	exports.storages = storages;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = purgeStoredState;
	
	var _constants = __webpack_require__(132);
	
	function purgeStoredState(config, keys) {
	  var storage = config.storage;
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // basic validation
	  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
	  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');
	
	  if (typeof keys === 'undefined') {
	    // if keys is not defined, purge all keys
	    return new Promise(function (resolve, reject) {
	      storage.getAllKeys(function (err, allKeys) {
	        if (err) {
	          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
	          reject(err);
	        } else {
	          resolve(purgeStoredState(config, allKeys.filter(function (key) {
	            return key.indexOf(keyPrefix) === 0;
	          }).map(function (key) {
	            return key.slice(keyPrefix.length);
	          })));
	        }
	      });
	    });
	  } else {
	    // otherwise purge specified keys
	    return Promise.all(keys.map(function (key) {
	      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
	    }));
	  }
	}
	
	function warnIfRemoveError(key) {
	  return function removeError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}

/***/ },
/* 750 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
	var setImmediate = hasNativeSupport ? function (fn, ms) {
	  return global.setImmediate(fn, ms);
	} : function (fn, ms) {
	  return setTimeout(fn, ms);
	};
	
	exports.default = setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 751 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(116);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1571);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 753 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(755);


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var cycle = __webpack_require__(1581);
	
	exports.stringify = function stringify(value, replacer, space, _options) {
	
	  if (arguments.length < 4) {
	    try {
	      if (arguments.length === 1) {
	        return JSON.stringify(value);
	      } else {
	        return JSON.stringify.apply(JSON, arguments);
	      }
	    } catch (e) {}
	  }
	
	  var options = _options || false;
	  if (typeof options === 'boolean') {
	    options = {
	      'date': options,
	      'function': options,
	      'regex': options,
	      'undefined': options,
	      'error': options,
	      'symbol': options,
	      'map': options,
	      'set': options,
	      'nan': options,
	      'infinity': options
	    }
	  }
	
	  var decycled = cycle.decycle(value, options, replacer);
	  if (arguments.length === 1) {
	    return JSON.stringify(decycled);
	  } else {
	    return JSON.stringify(decycled, replacer, space);
	  }
	
	}
	
	exports.parse = function parse(text, reviver) {
	  var needsRetrocycle = /"\$jsan"/.test(text);
	  var parsed;
	  if (arguments.length === 1) {
	    parsed = JSON.parse(text);
	  } else {
	    parsed = JSON.parse(text, reviver);
	  }
	  if (needsRetrocycle) {
	    parsed = cycle.retrocycle(parsed);
	  }
	  return parsed;
	}


/***/ },
/* 756 */
/***/ function(module, exports) {

	module.exports = pathGetter;
	
	function pathGetter(obj, path) {
	  if (path !== '$') {
	    var paths = getPaths(path);
	    for (var i = 0; i < paths.length; i++) {
	      path = paths[i].toString().replace(/\\"/g, '"');
	      if (typeof obj[path] === 'undefined' && i !== paths.length - 1) continue;
	      obj = obj[path];
	    }
	  }
	  return obj;
	}
	
	function getPaths(pathString) {
	  var regex = /(?:\.(\w+))|(?:\[(\d+)\])|(?:\["((?:[^\\"]|\\.)*)"\])/g;
	  var matches = [];
	  var match;
	  while (match = regex.exec(pathString)) {
	    matches.push( match[1] || match[2] || match[3] );
	  }
	  return matches;
	}


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1585);
	exports.encode = exports.stringify = __webpack_require__(1586);


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var scErrors = __webpack_require__(180);
	var InvalidActionError = scErrors.InvalidActionError;
	
	var Response = function (socket, id) {
	  this.socket = socket;
	  this.id = id;
	  this.sent = false;
	};
	
	Response.prototype._respond = function (responseData) {
	  if (this.sent) {
	    throw new InvalidActionError('Response ' + this.id + ' has already been sent');
	  } else {
	    this.sent = true;
	    this.socket.send(this.socket.encode(responseData));
	  }
	};
	
	Response.prototype.end = function (data) {
	  if (this.id) {
	    var responseData = {
	      rid: this.id
	    };
	    if (data !== undefined) {
	      responseData.data = data;
	    }
	    this._respond(responseData);
	  }
	};
	
	Response.prototype.error = function (error, data) {
	  if (this.id) {
	    var err = scErrors.dehydrateError(error);
	
	    var responseData = {
	      rid: this.id,
	      error: err
	    };
	    if (data !== undefined) {
	      responseData.data = data;
	    }
	
	    this._respond(responseData);
	  }
	};
	
	Response.prototype.callback = function (error, data) {
	  if (error) {
	    this.error(error, data);
	  } else {
	    this.end(data);
	  }
	};
	
	module.exports.Response = Response;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {var SCEmitter = __webpack_require__(179).SCEmitter;
	var SCChannel = __webpack_require__(1594).SCChannel;
	var Response = __webpack_require__(758).Response;
	var AuthEngine = __webpack_require__(1599).AuthEngine;
	var formatter = __webpack_require__(1597);
	var SCTransport = __webpack_require__(1601).SCTransport;
	var querystring = __webpack_require__(757);
	var LinkedList = __webpack_require__(1584);
	var base64 = __webpack_require__(1577);
	var clone = __webpack_require__(1578);
	
	var scErrors = __webpack_require__(180);
	var InvalidArgumentsError = scErrors.InvalidArgumentsError;
	var InvalidMessageError = scErrors.InvalidMessageError;
	var SocketProtocolError = scErrors.SocketProtocolError;
	var TimeoutError = scErrors.TimeoutError;
	
	var isBrowser = typeof window != 'undefined';
	
	
	var SCSocket = function (opts) {
	  var self = this;
	
	  SCEmitter.call(this);
	
	  this.id = null;
	  this.state = this.CLOSED;
	  this.authState = this.PENDING;
	  this.signedAuthToken = null;
	  this.authToken = null;
	  this.pendingReconnect = false;
	  this.pendingReconnectTimeout = null;
	  this.pendingConnectCallback = false;
	
	  this.connectTimeout = opts.connectTimeout;
	  this.ackTimeout = opts.ackTimeout;
	  this.channelPrefix = opts.channelPrefix || null;
	  this.disconnectOnUnload = opts.disconnectOnUnload == null ? true : opts.disconnectOnUnload;
	
	  // pingTimeout will be ackTimeout at the start, but it will
	  // be updated with values provided by the 'connect' event
	  this.pingTimeout = this.ackTimeout;
	
	  var maxTimeout = Math.pow(2, 31) - 1;
	
	  var verifyDuration = function (propertyName) {
	    if (self[propertyName] > maxTimeout) {
	      throw new InvalidArgumentsError('The ' + propertyName +
	        ' value provided exceeded the maximum amount allowed');
	    }
	  };
	
	  verifyDuration('connectTimeout');
	  verifyDuration('ackTimeout');
	  verifyDuration('pingTimeout');
	
	  this._localEvents = {
	    'connect': 1,
	    'connectAbort': 1,
	    'disconnect': 1,
	    'message': 1,
	    'error': 1,
	    'raw': 1,
	    'fail': 1,
	    'kickOut': 1,
	    'subscribe': 1,
	    'unsubscribe': 1,
	    'subscribeStateChange': 1,
	    'authStateChange': 1,
	    'authenticate': 1,
	    'deauthenticate': 1,
	    'removeAuthToken': 1,
	    'subscribeRequest': 1
	  };
	
	  this.connectAttempts = 0;
	
	  this._emitBuffer = new LinkedList();
	  this._channels = {};
	
	  this.options = opts;
	
	  this._cid = 1;
	
	  this.options.callIdGenerator = function () {
	    return self._callIdGenerator();
	  };
	
	  if (this.options.autoReconnect) {
	    if (this.options.autoReconnectOptions == null) {
	      this.options.autoReconnectOptions = {};
	    }
	
	    // Add properties to the this.options.autoReconnectOptions object.
	    // We assign the reference to a reconnectOptions variable to avoid repetition.
	    var reconnectOptions = this.options.autoReconnectOptions;
	    if (reconnectOptions.initialDelay == null) {
	      reconnectOptions.initialDelay = 10000;
	    }
	    if (reconnectOptions.randomness == null) {
	      reconnectOptions.randomness = 10000;
	    }
	    if (reconnectOptions.multiplier == null) {
	      reconnectOptions.multiplier = 1.5;
	    }
	    if (reconnectOptions.maxDelay == null) {
	      reconnectOptions.maxDelay = 60000;
	    }
	  }
	
	  if (this.options.subscriptionRetryOptions == null) {
	    this.options.subscriptionRetryOptions = {};
	  }
	
	  if (this.options.authEngine) {
	    this.auth = this.options.authEngine;
	  } else {
	    this.auth = new AuthEngine();
	  }
	
	  if (this.options.codecEngine) {
	    this.codec = this.options.codecEngine;
	  } else {
	    // Default codec engine
	    this.codec = formatter;
	  }
	
	  this.options.path = this.options.path.replace(/\/$/, '') + '/';
	
	  this.options.query = opts.query || {};
	  if (typeof this.options.query == 'string') {
	    this.options.query = querystring.parse(this.options.query);
	  }
	
	  if (this.options.autoConnect) {
	    this.connect();
	  }
	
	  this._channelEmitter = new SCEmitter();
	
	  if (isBrowser && this.disconnectOnUnload) {
	    var unloadHandler = function () {
	      self.disconnect();
	    };
	
	    if (global.attachEvent) {
	      global.attachEvent('onunload', unloadHandler);
	    } else if (global.addEventListener) {
	      global.addEventListener('beforeunload', unloadHandler, false);
	    }
	  }
	};
	
	SCSocket.prototype = Object.create(SCEmitter.prototype);
	
	SCSocket.CONNECTING = SCSocket.prototype.CONNECTING = SCTransport.prototype.CONNECTING;
	SCSocket.OPEN = SCSocket.prototype.OPEN = SCTransport.prototype.OPEN;
	SCSocket.CLOSED = SCSocket.prototype.CLOSED = SCTransport.prototype.CLOSED;
	
	SCSocket.AUTHENTICATED = SCSocket.prototype.AUTHENTICATED = 'authenticated';
	SCSocket.UNAUTHENTICATED = SCSocket.prototype.UNAUTHENTICATED = 'unauthenticated';
	SCSocket.PENDING = SCSocket.prototype.PENDING = 'pending';
	
	SCSocket.ignoreStatuses = scErrors.socketProtocolIgnoreStatuses;
	SCSocket.errorStatuses = scErrors.socketProtocolErrorStatuses;
	
	SCSocket.prototype._privateEventHandlerMap = {
	  '#publish': function (data) {
	    var undecoratedChannelName = this._undecorateChannelName(data.channel);
	    var isSubscribed = this.isSubscribed(undecoratedChannelName, true);
	
	    if (isSubscribed) {
	      this._channelEmitter.emit(undecoratedChannelName, data.data);
	    }
	  },
	  '#kickOut': function (data) {
	    var undecoratedChannelName = this._undecorateChannelName(data.channel);
	    var channel = this._channels[undecoratedChannelName];
	    if (channel) {
	      SCEmitter.prototype.emit.call(this, 'kickOut', data.message, undecoratedChannelName);
	      channel.emit('kickOut', data.message, undecoratedChannelName);
	      this._triggerChannelUnsubscribe(channel);
	    }
	  },
	  '#setAuthToken': function (data, response) {
	    var self = this;
	
	    if (data) {
	      var triggerAuthenticate = function (err) {
	        if (err) {
	          // This is a non-fatal error, we don't want to close the connection
	          // because of this but we do want to notify the server and throw an error
	          // on the client.
	          response.error(err);
	          self._onSCError(err);
	        } else {
	          self._changeToAuthenticatedState(data.token);
	          response.end();
	        }
	      };
	
	      this.auth.saveToken(this.options.authTokenName, data.token, {}, triggerAuthenticate);
	    } else {
	      response.error(new InvalidMessageError('No token data provided by #setAuthToken event'));
	    }
	  },
	  '#removeAuthToken': function (data, response) {
	    var self = this;
	
	    this.auth.removeToken(this.options.authTokenName, function (err, oldToken) {
	      if (err) {
	        // Non-fatal error - Do not close the connection
	        response.error(err);
	        self._onSCError(err);
	      } else {
	        SCEmitter.prototype.emit.call(self, 'removeAuthToken', oldToken);
	        self._changeToUnauthenticatedState();
	        response.end();
	      }
	    });
	  },
	  '#disconnect': function (data) {
	    this.transport.close(data.code, data.data);
	  }
	};
	
	SCSocket.prototype._callIdGenerator = function () {
	  return this._cid++;
	};
	
	SCSocket.prototype.getState = function () {
	  return this.state;
	};
	
	SCSocket.prototype.getBytesReceived = function () {
	  return this.transport.getBytesReceived();
	};
	
	SCSocket.prototype.deauthenticate = function (callback) {
	  var self = this;
	
	  this.auth.removeToken(this.options.authTokenName, function (err, oldToken) {
	    if (err) {
	      // Non-fatal error - Do not close the connection
	      self._onSCError(err);
	    } else {
	      self.emit('#removeAuthToken');
	      SCEmitter.prototype.emit.call(self, 'removeAuthToken', oldToken);
	      self._changeToUnauthenticatedState();
	    }
	    callback && callback(err);
	  });
	};
	
	SCSocket.prototype.connect = SCSocket.prototype.open = function () {
	  var self = this;
	
	  if (this.state == this.CLOSED) {
	    this.pendingReconnect = false;
	    this.pendingReconnectTimeout = null;
	    clearTimeout(this._reconnectTimeoutRef);
	
	    this.state = this.CONNECTING;
	    SCEmitter.prototype.emit.call(this, 'connecting');
	
	    this._changeToPendingAuthState();
	
	    if (this.transport) {
	      this.transport.off();
	    }
	
	    this.transport = new SCTransport(this.auth, this.codec, this.options);
	
	    this.transport.on('open', function (status) {
	      self.state = self.OPEN;
	      self._onSCOpen(status);
	    });
	
	    this.transport.on('error', function (err) {
	      self._onSCError(err);
	    });
	
	    this.transport.on('close', function (code, data) {
	      self.state = self.CLOSED;
	      self._onSCClose(code, data);
	    });
	
	    this.transport.on('openAbort', function (code, data) {
	      self.state = self.CLOSED;
	      self._onSCClose(code, data, true);
	    });
	
	    this.transport.on('event', function (event, data, res) {
	      self._onSCEvent(event, data, res);
	    });
	  }
	};
	
	SCSocket.prototype.reconnect = function () {
	  this.disconnect();
	  this.connect();
	};
	
	SCSocket.prototype.disconnect = function (code, data) {
	  code = code || 1000;
	
	  if (typeof code != 'number') {
	    throw new InvalidArgumentsError('If specified, the code argument must be a number');
	  }
	
	  if (this.state == this.OPEN || this.state == this.CONNECTING) {
	    this.transport.close(code, data);
	  } else {
	    this.pendingReconnect = false;
	    this.pendingReconnectTimeout = null;
	    clearTimeout(this._reconnectTimeoutRef);
	  }
	};
	
	SCSocket.prototype._changeToPendingAuthState = function () {
	  if (this.authState != this.PENDING) {
	    var oldState = this.authState;
	    this.authState = this.PENDING;
	    var stateChangeData = {
	      oldState: oldState,
	      newState: this.authState
	    };
	    SCEmitter.prototype.emit.call(this, 'authStateChange', stateChangeData);
	  }
	};
	
	SCSocket.prototype._changeToUnauthenticatedState = function () {
	  if (this.authState != this.UNAUTHENTICATED) {
	    var oldState = this.authState;
	    this.authState = this.UNAUTHENTICATED;
	    this.signedAuthToken = null;
	    this.authToken = null;
	
	    var stateChangeData = {
	      oldState: oldState,
	      newState: this.authState
	    };
	    SCEmitter.prototype.emit.call(this, 'authStateChange', stateChangeData);
	    if (oldState == this.AUTHENTICATED) {
	      SCEmitter.prototype.emit.call(this, 'deauthenticate');
	    }
	    SCEmitter.prototype.emit.call(this, 'authTokenChange', this.signedAuthToken);
	  }
	};
	
	SCSocket.prototype._changeToAuthenticatedState = function (signedAuthToken) {
	  this.signedAuthToken = signedAuthToken;
	  this.authToken = this._extractAuthTokenData(signedAuthToken);
	
	  if (this.authState != this.AUTHENTICATED) {
	    var oldState = this.authState;
	    this.authState = this.AUTHENTICATED;
	    var stateChangeData = {
	      oldState: oldState,
	      newState: this.authState,
	      signedAuthToken: signedAuthToken,
	      authToken: this.authToken
	    };
	    this.processPendingSubscriptions();
	
	    SCEmitter.prototype.emit.call(this, 'authStateChange', stateChangeData);
	    SCEmitter.prototype.emit.call(this, 'authenticate', signedAuthToken);
	  }
	  SCEmitter.prototype.emit.call(this, 'authTokenChange', signedAuthToken);
	};
	
	SCSocket.prototype.decodeBase64 = function (encodedString) {
	  var decodedString;
	  if (typeof Buffer == 'undefined') {
	    if (global.atob) {
	      decodedString = global.atob(encodedString);
	    } else {
	      decodedString = base64.decode(encodedString);
	    }
	  } else {
	    var buffer = new Buffer(encodedString, 'base64');
	    decodedString = buffer.toString('utf8');
	  }
	  return decodedString;
	};
	
	SCSocket.prototype.encodeBase64 = function (decodedString) {
	  var encodedString;
	  if (typeof Buffer == 'undefined') {
	    if (global.btoa) {
	      encodedString = global.btoa(decodedString);
	    } else {
	      encodedString = base64.encode(decodedString);
	    }
	  } else {
	    var buffer = new Buffer(decodedString, 'utf8');
	    encodedString = buffer.toString('base64');
	  }
	  return encodedString;
	};
	
	SCSocket.prototype._extractAuthTokenData = function (signedAuthToken) {
	  var tokenParts = (signedAuthToken || '').split('.');
	  var encodedTokenData = tokenParts[1];
	  if (encodedTokenData != null) {
	    var tokenData = encodedTokenData;
	    try {
	      tokenData = this.decodeBase64(tokenData);
	      return JSON.parse(tokenData);
	    } catch (e) {
	      return tokenData;
	    }
	  }
	  return null;
	};
	
	SCSocket.prototype.getAuthToken = function () {
	  return this.authToken;
	};
	
	SCSocket.prototype.getSignedAuthToken = function () {
	  return this.signedAuthToken;
	};
	
	// Perform client-initiated authentication by providing an encrypted token string
	SCSocket.prototype.authenticate = function (signedAuthToken, callback) {
	  var self = this;
	
	  this._changeToPendingAuthState();
	
	  this.emit('#authenticate', signedAuthToken, function (err, authStatus) {
	    if (authStatus && authStatus.authError) {
	      authStatus.authError = scErrors.hydrateError(authStatus.authError);
	    }
	    if (err) {
	      self._changeToUnauthenticatedState();
	      callback && callback(err, authStatus);
	    } else {
	      self.auth.saveToken(self.options.authTokenName, signedAuthToken, {}, function (err) {
	        callback && callback(err, authStatus);
	        if (err) {
	          self._changeToUnauthenticatedState();
	          self._onSCError(err);
	        } else {
	          if (authStatus.isAuthenticated) {
	            self._changeToAuthenticatedState(signedAuthToken);
	          } else {
	            self._changeToUnauthenticatedState();
	          }
	        }
	      });
	    }
	  });
	};
	
	SCSocket.prototype._tryReconnect = function (initialDelay) {
	  var self = this;
	
	  var exponent = this.connectAttempts++;
	  var reconnectOptions = this.options.autoReconnectOptions;
	  var timeout;
	
	  if (initialDelay == null || exponent > 0) {
	    var initialTimeout = Math.round(reconnectOptions.initialDelay + (reconnectOptions.randomness || 0) * Math.random());
	
	    timeout = Math.round(initialTimeout * Math.pow(reconnectOptions.multiplier, exponent));
	  } else {
	    timeout = initialDelay;
	  }
	
	  if (timeout > reconnectOptions.maxDelay) {
	    timeout = reconnectOptions.maxDelay;
	  }
	
	  clearTimeout(this._reconnectTimeoutRef);
	
	  this.pendingReconnect = true;
	  this.pendingReconnectTimeout = timeout;
	  this._reconnectTimeoutRef = setTimeout(function () {
	    self.connect();
	  }, timeout);
	};
	
	SCSocket.prototype._onSCOpen = function (status) {
	  var self = this;
	
	  if (status) {
	    this.id = status.id;
	    this.pingTimeout = status.pingTimeout;
	    this.transport.pingTimeout = this.pingTimeout;
	    if (status.isAuthenticated) {
	      this._changeToAuthenticatedState(status.authToken);
	    } else {
	      this._changeToUnauthenticatedState();
	    }
	  } else {
	    this._changeToUnauthenticatedState();
	  }
	
	  this.connectAttempts = 0;
	  if (this.options.autoProcessSubscriptions) {
	    this.processPendingSubscriptions();
	  } else {
	    this.pendingConnectCallback = true;
	  }
	
	  // If the user invokes the callback while in autoProcessSubscriptions mode, it
	  // won't break anything - The processPendingSubscriptions() call will be a no-op.
	  SCEmitter.prototype.emit.call(this, 'connect', status, function () {
	    self.processPendingSubscriptions();
	  });
	
	  this._flushEmitBuffer();
	};
	
	SCSocket.prototype._onSCError = function (err) {
	  var self = this;
	
	  // Throw error in different stack frame so that error handling
	  // cannot interfere with a reconnect action.
	  setTimeout(function () {
	    if (self.listeners('error').length < 1) {
	      throw err;
	    } else {
	      SCEmitter.prototype.emit.call(self, 'error', err);
	    }
	  }, 0);
	};
	
	SCSocket.prototype._suspendSubscriptions = function () {
	  var channel, newState;
	  for (var channelName in this._channels) {
	    if (this._channels.hasOwnProperty(channelName)) {
	      channel = this._channels[channelName];
	      if (channel.state == channel.SUBSCRIBED ||
	        channel.state == channel.PENDING) {
	
	        newState = channel.PENDING;
	      } else {
	        newState = channel.UNSUBSCRIBED;
	      }
	
	      this._triggerChannelUnsubscribe(channel, newState);
	    }
	  }
	};
	
	SCSocket.prototype._onSCClose = function (code, data, openAbort) {
	  var self = this;
	
	  this.id = null;
	
	  if (this.transport) {
	    this.transport.off();
	  }
	  this.pendingReconnect = false;
	  this.pendingReconnectTimeout = null;
	  clearTimeout(this._reconnectTimeoutRef);
	
	  this._changeToPendingAuthState();
	  this._suspendSubscriptions();
	
	  // Try to reconnect
	  // on server ping timeout (4000)
	  // or on client pong timeout (4001)
	  // or on close without status (1005)
	  // or on handshake failure (4003)
	  // or on socket hung up (1006)
	  if (this.options.autoReconnect) {
	    if (code == 4000 || code == 4001 || code == 1005) {
	      // If there is a ping or pong timeout or socket closes without
	      // status, don't wait before trying to reconnect - These could happen
	      // if the client wakes up after a period of inactivity and in this case we
	      // want to re-establish the connection as soon as possible.
	      this._tryReconnect(0);
	
	      // Codes 4500 and above will be treated as permanent disconnects.
	      // Socket will not try to auto-reconnect.
	    } else if (code != 1000 && code < 4500) {
	      this._tryReconnect();
	    }
	  }
	
	  if (openAbort) {
	    SCEmitter.prototype.emit.call(self, 'connectAbort', code, data);
	  } else {
	    SCEmitter.prototype.emit.call(self, 'disconnect', code, data);
	  }
	
	  if (!SCSocket.ignoreStatuses[code]) {
	    var failureMessage;
	    if (data) {
	      failureMessage = 'Socket connection failed: ' + data;
	    } else {
	      failureMessage = 'Socket connection failed for unknown reasons';
	    }
	    var err = new SocketProtocolError(SCSocket.errorStatuses[code] || failureMessage, code);
	    this._onSCError(err);
	  }
	};
	
	SCSocket.prototype._onSCEvent = function (event, data, res) {
	  var handler = this._privateEventHandlerMap[event];
	  if (handler) {
	    handler.call(this, data, res);
	  } else {
	    SCEmitter.prototype.emit.call(this, event, data, function () {
	      res && res.callback.apply(res, arguments);
	    });
	  }
	};
	
	SCSocket.prototype.decode = function (message) {
	  return this.transport.decode(message);
	};
	
	SCSocket.prototype.encode = function (object) {
	  return this.transport.encode(object);
	};
	
	SCSocket.prototype._flushEmitBuffer = function () {
	  var currentNode = this._emitBuffer.head;
	  var nextNode;
	
	  while (currentNode) {
	    nextNode = currentNode.next;
	    var eventObject = currentNode.data;
	    currentNode.detach();
	    this.transport.emitObject(eventObject);
	    currentNode = nextNode;
	  }
	};
	
	SCSocket.prototype._handleEventAckTimeout = function (eventObject, eventNode) {
	  if (eventNode) {
	    eventNode.detach();
	  }
	  var callback = eventObject.callback;
	  if (callback) {
	    delete eventObject.callback;
	    var error = new TimeoutError("Event response for '" + eventObject.event + "' timed out");
	    callback.call(eventObject, error, eventObject);
	  }
	};
	
	SCSocket.prototype._emit = function (event, data, callback) {
	  var self = this;
	
	  if (this.state == this.CLOSED) {
	    this.connect();
	  }
	  var eventObject = {
	    event: event,
	    data: data,
	    callback: callback
	  };
	
	  var eventNode = new LinkedList.Item();
	
	  if (this.options.cloneData) {
	    eventNode.data = clone(eventObject);
	  } else {
	    eventNode.data = eventObject;
	  }
	
	  eventObject.timeout = setTimeout(function () {
	    self._handleEventAckTimeout(eventObject, eventNode);
	  }, this.ackTimeout);
	
	  this._emitBuffer.append(eventNode);
	
	  if (this.state == this.OPEN) {
	    this._flushEmitBuffer();
	  }
	};
	
	SCSocket.prototype.send = function (data) {
	  this.transport.send(data);
	};
	
	SCSocket.prototype.emit = function (event, data, callback) {
	  if (this._localEvents[event] == null) {
	    this._emit(event, data, callback);
	  } else {
	    SCEmitter.prototype.emit.call(this, event, data);
	  }
	};
	
	SCSocket.prototype.publish = function (channelName, data, callback) {
	  var pubData = {
	    channel: this._decorateChannelName(channelName),
	    data: data
	  };
	  this.emit('#publish', pubData, callback);
	};
	
	SCSocket.prototype._triggerChannelSubscribe = function (channel, subscriptionOptions) {
	  var channelName = channel.name;
	
	  if (channel.state != channel.SUBSCRIBED) {
	    var oldState = channel.state;
	    channel.state = channel.SUBSCRIBED;
	
	    var stateChangeData = {
	      channel: channelName,
	      oldState: oldState,
	      newState: channel.state,
	      subscriptionOptions: subscriptionOptions
	    };
	    channel.emit('subscribeStateChange', stateChangeData);
	    channel.emit('subscribe', channelName, subscriptionOptions);
	    SCEmitter.prototype.emit.call(this, 'subscribeStateChange', stateChangeData);
	    SCEmitter.prototype.emit.call(this, 'subscribe', channelName, subscriptionOptions);
	  }
	};
	
	SCSocket.prototype._triggerChannelSubscribeFail = function (err, channel, subscriptionOptions) {
	  var channelName = channel.name;
	  var meetsAuthRequirements = !channel.waitForAuth || this.authState == this.AUTHENTICATED;
	
	  if (channel.state != channel.UNSUBSCRIBED && meetsAuthRequirements) {
	    channel.state = channel.UNSUBSCRIBED;
	
	    channel.emit('subscribeFail', err, channelName, subscriptionOptions);
	    SCEmitter.prototype.emit.call(this, 'subscribeFail', err, channelName, subscriptionOptions);
	  }
	};
	
	// Cancel any pending subscribe callback
	SCSocket.prototype._cancelPendingSubscribeCallback = function (channel) {
	  if (channel._pendingSubscriptionCid != null) {
	    this.transport.cancelPendingResponse(channel._pendingSubscriptionCid);
	    delete channel._pendingSubscriptionCid;
	  }
	};
	
	SCSocket.prototype._decorateChannelName = function (channelName) {
	  if (this.channelPrefix) {
	    channelName = this.channelPrefix + channelName;
	  }
	  return channelName;
	};
	
	SCSocket.prototype._undecorateChannelName = function (decoratedChannelName) {
	  if (this.channelPrefix && decoratedChannelName.indexOf(this.channelPrefix) == 0) {
	    return decoratedChannelName.replace(this.channelPrefix, '');
	  }
	  return decoratedChannelName;
	};
	
	SCSocket.prototype._trySubscribe = function (channel) {
	  var self = this;
	
	  var meetsAuthRequirements = !channel.waitForAuth || this.authState == this.AUTHENTICATED;
	
	  // We can only ever have one pending subscribe action at any given time on a channel
	  if (this.state == this.OPEN && !this.pendingConnectCallback &&
	    channel._pendingSubscriptionCid == null && meetsAuthRequirements) {
	
	    var options = {
	      noTimeout: true
	    };
	
	    var subscriptionOptions = {
	      channel: this._decorateChannelName(channel.name)
	    };
	    if (channel.waitForAuth) {
	      options.waitForAuth = true;
	      subscriptionOptions.waitForAuth = options.waitForAuth;
	    }
	    if (channel.data) {
	      subscriptionOptions.data = channel.data;
	    }
	
	    channel._pendingSubscriptionCid = this.transport.emit(
	      '#subscribe', subscriptionOptions, options,
	      function (err) {
	        delete channel._pendingSubscriptionCid;
	        if (err) {
	          self._triggerChannelSubscribeFail(err, channel, subscriptionOptions);
	        } else {
	          self._triggerChannelSubscribe(channel, subscriptionOptions);
	        }
	      }
	    );
	    SCEmitter.prototype.emit.call(this, 'subscribeRequest', channel.name, subscriptionOptions);
	  }
	};
	
	SCSocket.prototype.subscribe = function (channelName, options) {
	  var channel = this._channels[channelName];
	
	  if (!channel) {
	    channel = new SCChannel(channelName, this, options);
	    this._channels[channelName] = channel;
	  } else if (options) {
	    channel.setOptions(options);
	  }
	
	  if (channel.state == channel.UNSUBSCRIBED) {
	    channel.state = channel.PENDING;
	    this._trySubscribe(channel);
	  }
	
	  return channel;
	};
	
	SCSocket.prototype._triggerChannelUnsubscribe = function (channel, newState) {
	  var channelName = channel.name;
	  var oldState = channel.state;
	
	  if (newState) {
	    channel.state = newState;
	  } else {
	    channel.state = channel.UNSUBSCRIBED;
	  }
	  this._cancelPendingSubscribeCallback(channel);
	
	  if (oldState == channel.SUBSCRIBED) {
	    var stateChangeData = {
	      channel: channelName,
	      oldState: oldState,
	      newState: channel.state
	    };
	    channel.emit('subscribeStateChange', stateChangeData);
	    channel.emit('unsubscribe', channelName);
	    SCEmitter.prototype.emit.call(this, 'subscribeStateChange', stateChangeData);
	    SCEmitter.prototype.emit.call(this, 'unsubscribe', channelName);
	  }
	};
	
	SCSocket.prototype._tryUnsubscribe = function (channel) {
	  var self = this;
	
	  if (this.state == this.OPEN) {
	    var options = {
	      noTimeout: true
	    };
	    // If there is a pending subscribe action, cancel the callback
	    this._cancelPendingSubscribeCallback(channel);
	
	    // This operation cannot fail because the TCP protocol guarantees delivery
	    // so long as the connection remains open. If the connection closes,
	    // the server will automatically unsubscribe the socket and thus complete
	    // the operation on the server side.
	    var decoratedChannelName = this._decorateChannelName(channel.name);
	    this.transport.emit('#unsubscribe', decoratedChannelName, options);
	  }
	};
	
	SCSocket.prototype.unsubscribe = function (channelName) {
	
	  var channel = this._channels[channelName];
	
	  if (channel) {
	    if (channel.state != channel.UNSUBSCRIBED) {
	
	      this._triggerChannelUnsubscribe(channel);
	      this._tryUnsubscribe(channel);
	    }
	  }
	};
	
	SCSocket.prototype.channel = function (channelName, options) {
	  var currentChannel = this._channels[channelName];
	
	  if (!currentChannel) {
	    currentChannel = new SCChannel(channelName, this, options);
	    this._channels[channelName] = currentChannel;
	  }
	  return currentChannel;
	};
	
	SCSocket.prototype.destroyChannel = function (channelName) {
	  var channel = this._channels[channelName];
	  channel.unwatch();
	  channel.unsubscribe();
	  delete this._channels[channelName];
	};
	
	SCSocket.prototype.subscriptions = function (includePending) {
	  var subs = [];
	  var channel, includeChannel;
	  for (var channelName in this._channels) {
	    if (this._channels.hasOwnProperty(channelName)) {
	      channel = this._channels[channelName];
	
	      if (includePending) {
	        includeChannel = channel && (channel.state == channel.SUBSCRIBED ||
	          channel.state == channel.PENDING);
	      } else {
	        includeChannel = channel && channel.state == channel.SUBSCRIBED;
	      }
	
	      if (includeChannel) {
	        subs.push(channelName);
	      }
	    }
	  }
	  return subs;
	};
	
	SCSocket.prototype.isSubscribed = function (channelName, includePending) {
	  var channel = this._channels[channelName];
	  if (includePending) {
	    return !!channel && (channel.state == channel.SUBSCRIBED ||
	      channel.state == channel.PENDING);
	  }
	  return !!channel && channel.state == channel.SUBSCRIBED;
	};
	
	SCSocket.prototype.processPendingSubscriptions = function () {
	  var self = this;
	
	  this.pendingConnectCallback = false;
	
	  for (var i in this._channels) {
	    if (this._channels.hasOwnProperty(i)) {
	      (function (channel) {
	        if (channel.state == channel.PENDING) {
	          self._trySubscribe(channel);
	        }
	      })(this._channels[i]);
	    }
	  }
	};
	
	SCSocket.prototype.watch = function (channelName, handler) {
	  if (typeof handler != 'function') {
	    throw new InvalidArgumentsError('No handler function was provided');
	  }
	  this._channelEmitter.on(channelName, handler);
	};
	
	SCSocket.prototype.unwatch = function (channelName, handler) {
	  if (handler) {
	    this._channelEmitter.removeListener(channelName, handler);
	  } else {
	    this._channelEmitter.removeAllListeners(channelName);
	  }
	};
	
	SCSocket.prototype.watchers = function (channelName) {
	  return this._channelEmitter.listeners(channelName);
	};
	
	module.exports = SCSocket;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(300).Buffer))

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomByte = __webpack_require__(1611);
	
	function encode(lookup, number) {
	    var loopCounter = 0;
	    var done;
	
	    var str = '';
	
	    while (!done) {
	        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
	        done = number < (Math.pow(16, loopCounter + 1 ) );
	        loopCounter++;
	    }
	    return str;
	}
	
	module.exports = encode;


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	const defaultStopwords = __webpack_require__(762).words
	
	exports.removeStopwords = function(tokens, stopwords) {
	  stopwords = stopwords || defaultStopwords
	  if (typeof tokens !== 'object' || typeof stopwords != 'object'){
	    throw new Error ('expected Arrays try: removeStopwords(Array[, Array])')
	  }
	  return tokens.filter(function (value) {
	    return stopwords.indexOf(value.toLowerCase()) === -1
	  })
	}
	
	exports.ar = __webpack_require__(1614).words
	exports.bn = __webpack_require__(1615).words
	exports.da = __webpack_require__(1616).words
	exports.de = __webpack_require__(1617).words
	exports.en = __webpack_require__(762).words
	exports.es = __webpack_require__(1618).words
	exports.fa = __webpack_require__(1619).words
	exports.fr = __webpack_require__(1620).words
	exports.hi = __webpack_require__(1621).words
	exports.it = __webpack_require__(1622).words
	exports.ja = __webpack_require__(1623).words
	exports.nl = __webpack_require__(1624).words
	exports.no = __webpack_require__(1625).words
	exports.pl = __webpack_require__(1626).words
	exports.pt = __webpack_require__(1627).words
	exports.ru = __webpack_require__(1628).words
	exports.sv = __webpack_require__(1629).words
	exports.zh = __webpack_require__(1630).words


/***/ },
/* 762 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, Chris Umbel
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'about', 'after', 'all', 'also', 'am', 'an', 'and', 'another', 'any', 'are', 'as', 'at', 'be',
	  'because', 'been', 'before', 'being', 'between', 'both', 'but', 'by', 'came', 'can',
	  'come', 'could', 'did', 'do', 'each', 'for', 'from', 'get', 'got', 'has', 'had',
	  'he', 'have', 'her', 'here', 'him', 'himself', 'his', 'how', 'if', 'in', 'into',
	  'is', 'it', 'like', 'make', 'many', 'me', 'might', 'more', 'most', 'much', 'must',
	  'my', 'never', 'now', 'of', 'on', 'only', 'or', 'other', 'our', 'out', 'over',
	  'said', 'same', 'see', 'should', 'since', 'some', 'still', 'such', 'take', 'than',
	  'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'those',
	  'through', 'to', 'too', 'under', 'up', 'very', 'was', 'way', 'we', 'well', 'were',
	  'what', 'where', 'which', 'while', 'who', 'with', 'would', 'you', 'your', 'a', 'i']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 * IPv6 Support
	 *
	 * Version: 1.19.1
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.IPv6 = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  /*
	  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
	  var _out = IPv6.best(_in);
	  var _expected = "fe80::204:61ff:fe9d:f156";
	
	  console.log(_in, _out, _expected, _out === _expected);
	  */
	
	  // save current IPv6 variable, if any
	  var _IPv6 = root && root.IPv6;
	
	  function bestPresentation(address) {
	    // based on:
	    // Javascript to test an IPv6 address for proper format, and to
	    // present the "best text representation" according to IETF Draft RFC at
	    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
	    // 8 Feb 2010 Rich Brown, Dartware, LLC
	    // Please feel free to use this code as long as you provide a link to
	    // http://www.intermapper.com
	    // http://intermapper.com/support/tools/IPV6-Validator.aspx
	    // http://download.dartware.com/thirdparty/ipv6validator.js
	
	    var _address = address.toLowerCase();
	    var segments = _address.split(':');
	    var length = segments.length;
	    var total = 8;
	
	    // trim colons (:: or ::a:b:c… or …a:b:c::)
	    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
	      // must have been ::
	      // remove first two items
	      segments.shift();
	      segments.shift();
	    } else if (segments[0] === '' && segments[1] === '') {
	      // must have been ::xxxx
	      // remove the first item
	      segments.shift();
	    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
	      // must have been xxxx::
	      segments.pop();
	    }
	
	    length = segments.length;
	
	    // adjust total segments for IPv4 trailer
	    if (segments[length - 1].indexOf('.') !== -1) {
	      // found a "." which means IPv4
	      total = 7;
	    }
	
	    // fill empty segments them with "0000"
	    var pos;
	    for (pos = 0; pos < length; pos++) {
	      if (segments[pos] === '') {
	        break;
	      }
	    }
	
	    if (pos < total) {
	      segments.splice(pos, 1, '0000');
	      while (segments.length < total) {
	        segments.splice(pos, 0, '0000');
	      }
	    }
	
	    // strip leading zeros
	    var _segments;
	    for (var i = 0; i < total; i++) {
	      _segments = segments[i].split('');
	      for (var j = 0; j < 3 ; j++) {
	        if (_segments[0] === '0' && _segments.length > 1) {
	          _segments.splice(0,1);
	        } else {
	          break;
	        }
	      }
	
	      segments[i] = _segments.join('');
	    }
	
	    // find longest sequence of zeroes and coalesce them into one segment
	    var best = -1;
	    var _best = 0;
	    var _current = 0;
	    var current = -1;
	    var inzeroes = false;
	    // i; already declared
	
	    for (i = 0; i < total; i++) {
	      if (inzeroes) {
	        if (segments[i] === '0') {
	          _current += 1;
	        } else {
	          inzeroes = false;
	          if (_current > _best) {
	            best = current;
	            _best = _current;
	          }
	        }
	      } else {
	        if (segments[i] === '0') {
	          inzeroes = true;
	          current = i;
	          _current = 1;
	        }
	      }
	    }
	
	    if (_current > _best) {
	      best = current;
	      _best = _current;
	    }
	
	    if (_best > 1) {
	      segments.splice(best, _best, '');
	    }
	
	    length = segments.length;
	
	    // assemble remaining segments
	    var result = '';
	    if (segments[0] === '')  {
	      result = ':';
	    }
	
	    for (i = 0; i < length; i++) {
	      result += segments[i];
	      if (i === length - 1) {
	        break;
	      }
	
	      result += ':';
	    }
	
	    if (segments[length - 1] === '') {
	      result += ':';
	    }
	
	    return result;
	  }
	
	  function noConflict() {
	    /*jshint validthis: true */
	    if (root.IPv6 === this) {
	      root.IPv6 = _IPv6;
	    }
	
	    return this;
	  }
	
	  return {
	    best: bestPresentation,
	    noConflict: noConflict
	  };
	}));


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 * Second Level Domain (SLD) Support
	 *
	 * Version: 1.19.1
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.SecondLevelDomains = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  // save current SecondLevelDomains variable, if any
	  var _SecondLevelDomains = root && root.SecondLevelDomains;
	
	  var SLD = {
	    // list of known Second Level Domains
	    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
	    // ----
	    // publicsuffix.org is more current and actually used by a couple of browsers internally.
	    // downside is it also contains domains like "dyndns.org" - which is fine for the security
	    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
	    // ----
	    list: {
	      'ac':' com gov mil net org ',
	      'ae':' ac co gov mil name net org pro sch ',
	      'af':' com edu gov net org ',
	      'al':' com edu gov mil net org ',
	      'ao':' co ed gv it og pb ',
	      'ar':' com edu gob gov int mil net org tur ',
	      'at':' ac co gv or ',
	      'au':' asn com csiro edu gov id net org ',
	      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
	      'bb':' biz co com edu gov info net org store tv ',
	      'bh':' biz cc com edu gov info net org ',
	      'bn':' com edu gov net org ',
	      'bo':' com edu gob gov int mil net org tv ',
	      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
	      'bs':' com edu gov net org ',
	      'bz':' du et om ov rg ',
	      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
	      'ck':' biz co edu gen gov info net org ',
	      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
	      'co':' com edu gov mil net nom org ',
	      'cr':' ac c co ed fi go or sa ',
	      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
	      'do':' art com edu gob gov mil net org sld web ',
	      'dz':' art asso com edu gov net org pol ',
	      'ec':' com edu fin gov info med mil net org pro ',
	      'eg':' com edu eun gov mil name net org sci ',
	      'er':' com edu gov ind mil net org rochest w ',
	      'es':' com edu gob nom org ',
	      'et':' biz com edu gov info name net org ',
	      'fj':' ac biz com info mil name net org pro ',
	      'fk':' ac co gov net nom org ',
	      'fr':' asso com f gouv nom prd presse tm ',
	      'gg':' co net org ',
	      'gh':' com edu gov mil org ',
	      'gn':' ac com gov net org ',
	      'gr':' com edu gov mil net org ',
	      'gt':' com edu gob ind mil net org ',
	      'gu':' com edu gov net org ',
	      'hk':' com edu gov idv net org ',
	      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
	      'id':' ac co go mil net or sch web ',
	      'il':' ac co gov idf k12 muni net org ',
	      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
	      'iq':' com edu gov i mil net org ',
	      'ir':' ac co dnssec gov i id net org sch ',
	      'it':' edu gov ',
	      'je':' co net org ',
	      'jo':' com edu gov mil name net org sch ',
	      'jp':' ac ad co ed go gr lg ne or ',
	      'ke':' ac co go info me mobi ne or sc ',
	      'kh':' com edu gov mil net org per ',
	      'ki':' biz com de edu gov info mob net org tel ',
	      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
	      'kn':' edu gov net org ',
	      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
	      'kw':' com edu gov net org ',
	      'ky':' com edu gov net org ',
	      'kz':' com edu gov mil net org ',
	      'lb':' com edu gov net org ',
	      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
	      'lr':' com edu gov net org ',
	      'lv':' asn com conf edu gov id mil net org ',
	      'ly':' com edu gov id med net org plc sch ',
	      'ma':' ac co gov m net org press ',
	      'mc':' asso tm ',
	      'me':' ac co edu gov its net org priv ',
	      'mg':' com edu gov mil nom org prd tm ',
	      'mk':' com edu gov inf name net org pro ',
	      'ml':' com edu gov net org presse ',
	      'mn':' edu gov org ',
	      'mo':' com edu gov net org ',
	      'mt':' com edu gov net org ',
	      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
	      'mw':' ac co com coop edu gov int museum net org ',
	      'mx':' com edu gob net org ',
	      'my':' com edu gov mil name net org sch ',
	      'nf':' arts com firm info net other per rec store web ',
	      'ng':' biz com edu gov mil mobi name net org sch ',
	      'ni':' ac co com edu gob mil net nom org ',
	      'np':' com edu gov mil net org ',
	      'nr':' biz com edu gov info net org ',
	      'om':' ac biz co com edu gov med mil museum net org pro sch ',
	      'pe':' com edu gob mil net nom org sld ',
	      'ph':' com edu gov i mil net ngo org ',
	      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
	      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
	      'pr':' ac biz com edu est gov info isla name net org pro prof ',
	      'ps':' com edu gov net org plo sec ',
	      'pw':' belau co ed go ne or ',
	      'ro':' arts com firm info nom nt org rec store tm www ',
	      'rs':' ac co edu gov in org ',
	      'sb':' com edu gov net org ',
	      'sc':' com edu gov net org ',
	      'sh':' co com edu gov net nom org ',
	      'sl':' com edu gov net org ',
	      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
	      'sv':' com edu gob org red ',
	      'sz':' ac co org ',
	      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
	      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
	      'tw':' club com ebiz edu game gov idv mil net org ',
	      'mu':' ac co com gov net or org ',
	      'mz':' ac co edu gov org ',
	      'na':' co com ',
	      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
	      'pa':' abo ac com edu gob ing med net nom org sld ',
	      'pt':' com edu gov int net nome org publ ',
	      'py':' com edu gov mil net org ',
	      'qa':' com edu gov mil net org ',
	      're':' asso com nom ',
	      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
	      'rw':' ac co com edu gouv gov int mil net ',
	      'sa':' com edu gov med net org pub sch ',
	      'sd':' com edu gov info med net org tv ',
	      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
	      'sg':' com edu gov idn net org per ',
	      'sn':' art com edu gouv org perso univ ',
	      'sy':' com edu gov mil net news org ',
	      'th':' ac co go in mi net or ',
	      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
	      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
	      'tz':' ac co go ne or ',
	      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
	      'ug':' ac co go ne or org sc ',
	      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
	      'us':' dni fed isa kids nsn ',
	      'uy':' com edu gub mil net org ',
	      've':' co com edu gob info mil net org web ',
	      'vi':' co com k12 net org ',
	      'vn':' ac biz com edu gov health info int name net org pro ',
	      'ye':' co com gov ltd me net org plc ',
	      'yu':' ac co edu gov org ',
	      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
	      'zm':' ac co com edu gov net org sch ',
	      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
	      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
	      'net': 'gb jp se uk ',
	      'org': 'ae',
	      'de': 'com '
	    },
	    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
	    // in both performance and memory footprint. No initialization required.
	    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
	    // Following methods use lastIndexOf() rather than array.split() in order
	    // to avoid any memory allocations.
	    has: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
	    },
	    is: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset >= 0) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
	    },
	    get: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return null;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return null;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return null;
	      }
	      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
	        return null;
	      }
	      return domain.slice(sldOffset+1);
	    },
	    noConflict: function(){
	      if (root.SecondLevelDomains === this) {
	        root.SecondLevelDomains = _SecondLevelDomains;
	      }
	      return this;
	    }
	  };
	
	  return SLD;
	}));


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 *
	 * Version: 1.19.1
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory(__webpack_require__(766), __webpack_require__(763), __webpack_require__(764));
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(766), __webpack_require__(763), __webpack_require__(764)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
	  }
	}(this, function (punycode, IPv6, SLD, root) {
	  'use strict';
	  /*global location, escape, unescape */
	  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
	  /*jshint camelcase: false */
	
	  // save current URI variable, if any
	  var _URI = root && root.URI;
	
	  function URI(url, base) {
	    var _urlSupplied = arguments.length >= 1;
	    var _baseSupplied = arguments.length >= 2;
	
	    // Allow instantiation without the 'new' keyword
	    if (!(this instanceof URI)) {
	      if (_urlSupplied) {
	        if (_baseSupplied) {
	          return new URI(url, base);
	        }
	
	        return new URI(url);
	      }
	
	      return new URI();
	    }
	
	    if (url === undefined) {
	      if (_urlSupplied) {
	        throw new TypeError('undefined is not a valid argument for URI');
	      }
	
	      if (typeof location !== 'undefined') {
	        url = location.href + '';
	      } else {
	        url = '';
	      }
	    }
	
	    if (url === null) {
	      if (_urlSupplied) {
	        throw new TypeError('null is not a valid argument for URI');
	      }
	    }
	
	    this.href(url);
	
	    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
	    if (base !== undefined) {
	      return this.absoluteTo(base);
	    }
	
	    return this;
	  }
	
	  function isInteger(value) {
	    return /^[0-9]+$/.test(value);
	  }
	
	  URI.version = '1.19.1';
	
	  var p = URI.prototype;
	  var hasOwn = Object.prototype.hasOwnProperty;
	
	  function escapeRegEx(string) {
	    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
	    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	  }
	
	  function getType(value) {
	    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
	    if (value === undefined) {
	      return 'Undefined';
	    }
	
	    return String(Object.prototype.toString.call(value)).slice(8, -1);
	  }
	
	  function isArray(obj) {
	    return getType(obj) === 'Array';
	  }
	
	  function filterArrayValues(data, value) {
	    var lookup = {};
	    var i, length;
	
	    if (getType(value) === 'RegExp') {
	      lookup = null;
	    } else if (isArray(value)) {
	      for (i = 0, length = value.length; i < length; i++) {
	        lookup[value[i]] = true;
	      }
	    } else {
	      lookup[value] = true;
	    }
	
	    for (i = 0, length = data.length; i < length; i++) {
	      /*jshint laxbreak: true */
	      var _match = lookup && lookup[data[i]] !== undefined
	        || !lookup && value.test(data[i]);
	      /*jshint laxbreak: false */
	      if (_match) {
	        data.splice(i, 1);
	        length--;
	        i--;
	      }
	    }
	
	    return data;
	  }
	
	  function arrayContains(list, value) {
	    var i, length;
	
	    // value may be string, number, array, regexp
	    if (isArray(value)) {
	      // Note: this can be optimized to O(n) (instead of current O(m * n))
	      for (i = 0, length = value.length; i < length; i++) {
	        if (!arrayContains(list, value[i])) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    var _type = getType(value);
	    for (i = 0, length = list.length; i < length; i++) {
	      if (_type === 'RegExp') {
	        if (typeof list[i] === 'string' && list[i].match(value)) {
	          return true;
	        }
	      } else if (list[i] === value) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function arraysEqual(one, two) {
	    if (!isArray(one) || !isArray(two)) {
	      return false;
	    }
	
	    // arrays can't be equal if they have different amount of content
	    if (one.length !== two.length) {
	      return false;
	    }
	
	    one.sort();
	    two.sort();
	
	    for (var i = 0, l = one.length; i < l; i++) {
	      if (one[i] !== two[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  function trimSlashes(text) {
	    var trim_expression = /^\/+|\/+$/g;
	    return text.replace(trim_expression, '');
	  }
	
	  URI._parts = function() {
	    return {
	      protocol: null,
	      username: null,
	      password: null,
	      hostname: null,
	      urn: null,
	      port: null,
	      path: null,
	      query: null,
	      fragment: null,
	      // state
	      preventInvalidHostname: URI.preventInvalidHostname,
	      duplicateQueryParameters: URI.duplicateQueryParameters,
	      escapeQuerySpace: URI.escapeQuerySpace
	    };
	  };
	  // state: throw on invalid hostname
	  // see https://github.com/medialize/URI.js/pull/345
	  // and https://github.com/medialize/URI.js/issues/354
	  URI.preventInvalidHostname = false;
	  // state: allow duplicate query parameters (a=1&a=1)
	  URI.duplicateQueryParameters = false;
	  // state: replaces + with %20 (space in query strings)
	  URI.escapeQuerySpace = true;
	  // static properties
	  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
	  URI.idn_expression = /[^a-z0-9\._-]/i;
	  URI.punycode_expression = /(xn--)/i;
	  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
	  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
	  // credits to Rich Brown
	  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
	  // specification: http://www.ietf.org/rfc/rfc4291.txt
	  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
	  // expression used is "gruber revised" (@gruber v2) determined to be the
	  // best solution in a regex-golf we did a couple of ages ago at
	  // * http://mathiasbynens.be/demo/url-regex
	  // * http://rodneyrehm.de/t/url-regex.html
	  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
	  URI.findUri = {
	    // valid "scheme://" or "www."
	    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
	    // everything up to the next whitespace
	    end: /[\s\r\n]|$/,
	    // trim trailing punctuation captured by end RegExp
	    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
	    // balanced parens inclusion (), [], {}, <>
	    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
	  };
	  // http://www.iana.org/assignments/uri-schemes.html
	  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
	  URI.defaultPorts = {
	    http: '80',
	    https: '443',
	    ftp: '21',
	    gopher: '70',
	    ws: '80',
	    wss: '443'
	  };
	  // list of protocols which always require a hostname
	  URI.hostProtocols = [
	    'http',
	    'https'
	  ];
	
	  // allowed hostname characters according to RFC 3986
	  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
	  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
	  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
	  // map DOM Elements to their URI attribute
	  URI.domAttributes = {
	    'a': 'href',
	    'blockquote': 'cite',
	    'link': 'href',
	    'base': 'href',
	    'script': 'src',
	    'form': 'action',
	    'img': 'src',
	    'area': 'href',
	    'iframe': 'src',
	    'embed': 'src',
	    'source': 'src',
	    'track': 'src',
	    'input': 'src', // but only if type="image"
	    'audio': 'src',
	    'video': 'src'
	  };
	  URI.getDomAttribute = function(node) {
	    if (!node || !node.nodeName) {
	      return undefined;
	    }
	
	    var nodeName = node.nodeName.toLowerCase();
	    // <input> should only expose src for type="image"
	    if (nodeName === 'input' && node.type !== 'image') {
	      return undefined;
	    }
	
	    return URI.domAttributes[nodeName];
	  };
	
	  function escapeForDumbFirefox36(value) {
	    // https://github.com/medialize/URI.js/issues/91
	    return escape(value);
	  }
	
	  // encoding / decoding according to RFC3986
	  function strictEncodeURIComponent(string) {
	    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
	    return encodeURIComponent(string)
	      .replace(/[!'()*]/g, escapeForDumbFirefox36)
	      .replace(/\*/g, '%2A');
	  }
	  URI.encode = strictEncodeURIComponent;
	  URI.decode = decodeURIComponent;
	  URI.iso8859 = function() {
	    URI.encode = escape;
	    URI.decode = unescape;
	  };
	  URI.unicode = function() {
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = decodeURIComponent;
	  };
	  URI.characters = {
	    pathname: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
	        map: {
	          // -._~!'()*
	          '%24': '$',
	          '%26': '&',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%3A': ':',
	          '%40': '@'
	        }
	      },
	      decode: {
	        expression: /[\/\?#]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23'
	        }
	      }
	    },
	    reserved: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
	        map: {
	          // gen-delims
	          '%3A': ':',
	          '%2F': '/',
	          '%3F': '?',
	          '%23': '#',
	          '%5B': '[',
	          '%5D': ']',
	          '%40': '@',
	          // sub-delims
	          '%21': '!',
	          '%24': '$',
	          '%26': '&',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '='
	        }
	      }
	    },
	    urnpath: {
	      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
	      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
	      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
	      // note that the colon character is not featured in the encoding map; this is because URI.js
	      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
	      // should not appear unencoded in a segment itself.
	      // See also the note above about RFC3986 and capitalalized hex digits.
	      encode: {
	        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
	        map: {
	          '%21': '!',
	          '%24': '$',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%40': '@'
	        }
	      },
	      // These characters are the characters called out by RFC2141 as "reserved" characters that
	      // should never appear in a URN, plus the colon character (see note above).
	      decode: {
	        expression: /[\/\?#:]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23',
	          ':': '%3A'
	        }
	      }
	    }
	  };
	  URI.encodeQuery = function(string, escapeQuerySpace) {
	    var escaped = URI.encode(string + '');
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
	  };
	  URI.decodeQuery = function(string, escapeQuerySpace) {
	    string += '';
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    try {
	      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
	    } catch(e) {
	      // we're not going to mess with weird encodings,
	      // give up and return the undecoded original string
	      // see https://github.com/medialize/URI.js/issues/87
	      // see https://github.com/medialize/URI.js/issues/92
	      return string;
	    }
	  };
	  // generate encode/decode path functions
	  var _parts = {'encode':'encode', 'decode':'decode'};
	  var _part;
	  var generateAccessor = function(_group, _part) {
	    return function(string) {
	      try {
	        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
	          return URI.characters[_group][_part].map[c];
	        });
	      } catch (e) {
	        // we're not going to mess with weird encodings,
	        // give up and return the undecoded original string
	        // see https://github.com/medialize/URI.js/issues/87
	        // see https://github.com/medialize/URI.js/issues/92
	        return string;
	      }
	    };
	  };
	
	  for (_part in _parts) {
	    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
	    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
	  }
	
	  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
	    return function(string) {
	      // Why pass in names of functions, rather than the function objects themselves? The
	      // definitions of some functions (but in particular, URI.decode) will occasionally change due
	      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
	      // that the functions we use here are "fresh".
	      var actualCodingFunc;
	      if (!_innerCodingFuncName) {
	        actualCodingFunc = URI[_codingFuncName];
	      } else {
	        actualCodingFunc = function(string) {
	          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
	        };
	      }
	
	      var segments = (string + '').split(_sep);
	
	      for (var i = 0, length = segments.length; i < length; i++) {
	        segments[i] = actualCodingFunc(segments[i]);
	      }
	
	      return segments.join(_sep);
	    };
	  };
	
	  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
	  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
	  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
	  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
	  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
	
	  URI.encodeReserved = generateAccessor('reserved', 'encode');
	
	  URI.parse = function(string, parts) {
	    var pos;
	    if (!parts) {
	      parts = {
	        preventInvalidHostname: URI.preventInvalidHostname
	      };
	    }
	    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
	
	    // extract fragment
	    pos = string.indexOf('#');
	    if (pos > -1) {
	      // escaping?
	      parts.fragment = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract query
	    pos = string.indexOf('?');
	    if (pos > -1) {
	      // escaping?
	      parts.query = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract protocol
	    if (string.substring(0, 2) === '//') {
	      // relative-scheme
	      parts.protocol = null;
	      string = string.substring(2);
	      // extract "user:pass@host:port"
	      string = URI.parseAuthority(string, parts);
	    } else {
	      pos = string.indexOf(':');
	      if (pos > -1) {
	        parts.protocol = string.substring(0, pos) || null;
	        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
	          // : may be within the path
	          parts.protocol = undefined;
	        } else if (string.substring(pos + 1, pos + 3) === '//') {
	          string = string.substring(pos + 3);
	
	          // extract "user:pass@host:port"
	          string = URI.parseAuthority(string, parts);
	        } else {
	          string = string.substring(pos + 1);
	          parts.urn = true;
	        }
	      }
	    }
	
	    // what's left must be the path
	    parts.path = string;
	
	    // and we're done
	    return parts;
	  };
	  URI.parseHost = function(string, parts) {
	    if (!string) {
	      string = '';
	    }
	
	    // Copy chrome, IE, opera backslash-handling behavior.
	    // Back slashes before the query string get converted to forward slashes
	    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
	    // See: https://code.google.com/p/chromium/issues/detail?id=25916
	    // https://github.com/medialize/URI.js/pull/233
	    string = string.replace(/\\/g, '/');
	
	    // extract host:port
	    var pos = string.indexOf('/');
	    var bracketPos;
	    var t;
	
	    if (pos === -1) {
	      pos = string.length;
	    }
	
	    if (string.charAt(0) === '[') {
	      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
	      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
	      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
	      bracketPos = string.indexOf(']');
	      parts.hostname = string.substring(1, bracketPos) || null;
	      parts.port = string.substring(bracketPos + 2, pos) || null;
	      if (parts.port === '/') {
	        parts.port = null;
	      }
	    } else {
	      var firstColon = string.indexOf(':');
	      var firstSlash = string.indexOf('/');
	      var nextColon = string.indexOf(':', firstColon + 1);
	      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
	        // IPv6 host contains multiple colons - but no port
	        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
	        parts.hostname = string.substring(0, pos) || null;
	        parts.port = null;
	      } else {
	        t = string.substring(0, pos).split(':');
	        parts.hostname = t[0] || null;
	        parts.port = t[1] || null;
	      }
	    }
	
	    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
	      pos++;
	      string = '/' + string;
	    }
	
	    if (parts.preventInvalidHostname) {
	      URI.ensureValidHostname(parts.hostname, parts.protocol);
	    }
	
	    if (parts.port) {
	      URI.ensureValidPort(parts.port);
	    }
	
	    return string.substring(pos) || '/';
	  };
	  URI.parseAuthority = function(string, parts) {
	    string = URI.parseUserinfo(string, parts);
	    return URI.parseHost(string, parts);
	  };
	  URI.parseUserinfo = function(string, parts) {
	    // extract username:password
	    var firstSlash = string.indexOf('/');
	    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
	    var t;
	
	    // authority@ must come before /path
	    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
	      t = string.substring(0, pos).split(':');
	      parts.username = t[0] ? URI.decode(t[0]) : null;
	      t.shift();
	      parts.password = t[0] ? URI.decode(t.join(':')) : null;
	      string = string.substring(pos + 1);
	    } else {
	      parts.username = null;
	      parts.password = null;
	    }
	
	    return string;
	  };
	  URI.parseQuery = function(string, escapeQuerySpace) {
	    if (!string) {
	      return {};
	    }
	
	    // throw out the funky business - "?"[name"="value"&"]+
	    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
	
	    if (!string) {
	      return {};
	    }
	
	    var items = {};
	    var splits = string.split('&');
	    var length = splits.length;
	    var v, name, value;
	
	    for (var i = 0; i < length; i++) {
	      v = splits[i].split('=');
	      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
	      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
	      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
	
	      if (hasOwn.call(items, name)) {
	        if (typeof items[name] === 'string' || items[name] === null) {
	          items[name] = [items[name]];
	        }
	
	        items[name].push(value);
	      } else {
	        items[name] = value;
	      }
	    }
	
	    return items;
	  };
	
	  URI.build = function(parts) {
	    var t = '';
	
	    if (parts.protocol) {
	      t += parts.protocol + ':';
	    }
	
	    if (!parts.urn && (t || parts.hostname)) {
	      t += '//';
	    }
	
	    t += (URI.buildAuthority(parts) || '');
	
	    if (typeof parts.path === 'string') {
	      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
	        t += '/';
	      }
	
	      t += parts.path;
	    }
	
	    if (typeof parts.query === 'string' && parts.query) {
	      t += '?' + parts.query;
	    }
	
	    if (typeof parts.fragment === 'string' && parts.fragment) {
	      t += '#' + parts.fragment;
	    }
	    return t;
	  };
	  URI.buildHost = function(parts) {
	    var t = '';
	
	    if (!parts.hostname) {
	      return '';
	    } else if (URI.ip6_expression.test(parts.hostname)) {
	      t += '[' + parts.hostname + ']';
	    } else {
	      t += parts.hostname;
	    }
	
	    if (parts.port) {
	      t += ':' + parts.port;
	    }
	
	    return t;
	  };
	  URI.buildAuthority = function(parts) {
	    return URI.buildUserinfo(parts) + URI.buildHost(parts);
	  };
	  URI.buildUserinfo = function(parts) {
	    var t = '';
	
	    if (parts.username) {
	      t += URI.encode(parts.username);
	    }
	
	    if (parts.password) {
	      t += ':' + URI.encode(parts.password);
	    }
	
	    if (t) {
	      t += '@';
	    }
	
	    return t;
	  };
	  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
	    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
	    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
	    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
	    // URI.js treats the query string as being application/x-www-form-urlencoded
	    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
	
	    var t = '';
	    var unique, key, i, length;
	    for (key in data) {
	      if (hasOwn.call(data, key) && key) {
	        if (isArray(data[key])) {
	          unique = {};
	          for (i = 0, length = data[key].length; i < length; i++) {
	            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
	              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
	              if (duplicateQueryParameters !== true) {
	                unique[data[key][i] + ''] = true;
	              }
	            }
	          }
	        } else if (data[key] !== undefined) {
	          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
	        }
	      }
	    }
	
	    return t.substring(1);
	  };
	  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
	    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
	    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
	    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
	  };
	
	  URI.addQuery = function(data, name, value) {
	    if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.addQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (data[name] === undefined) {
	        data[name] = value;
	        return;
	      } else if (typeof data[name] === 'string') {
	        data[name] = [data[name]];
	      }
	
	      if (!isArray(value)) {
	        value = [value];
	      }
	
	      data[name] = (data[name] || []).concat(value);
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	  };
	
	  URI.setQuery = function(data, name, value) {
	    if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.setQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      data[name] = value === undefined ? null : value;
	    } else {
	      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
	    }
	  };
	
	  URI.removeQuery = function(data, name, value) {
	    var i, length, key;
	
	    if (isArray(name)) {
	      for (i = 0, length = name.length; i < length; i++) {
	        data[name[i]] = undefined;
	      }
	    } else if (getType(name) === 'RegExp') {
	      for (key in data) {
	        if (name.test(key)) {
	          data[key] = undefined;
	        }
	      }
	    } else if (typeof name === 'object') {
	      for (key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.removeQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (value !== undefined) {
	        if (getType(value) === 'RegExp') {
	          if (!isArray(data[name]) && value.test(data[name])) {
	            data[name] = undefined;
	          } else {
	            data[name] = filterArrayValues(data[name], value);
	          }
	        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
	          data[name] = undefined;
	        } else if (isArray(data[name])) {
	          data[name] = filterArrayValues(data[name], value);
	        }
	      } else {
	        data[name] = undefined;
	      }
	    } else {
	      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
	    }
	  };
	  URI.hasQuery = function(data, name, value, withinArray) {
	    switch (getType(name)) {
	      case 'String':
	        // Nothing to do here
	        break;
	
	      case 'RegExp':
	        for (var key in data) {
	          if (hasOwn.call(data, key)) {
	            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
	              return true;
	            }
	          }
	        }
	
	        return false;
	
	      case 'Object':
	        for (var _key in name) {
	          if (hasOwn.call(name, _key)) {
	            if (!URI.hasQuery(data, _key, name[_key])) {
	              return false;
	            }
	          }
	        }
	
	        return true;
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
	    }
	
	    switch (getType(value)) {
	      case 'Undefined':
	        // true if exists (but may be empty)
	        return name in data; // data[name] !== undefined;
	
	      case 'Boolean':
	        // true if exists and non-empty
	        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
	        return value === _booly;
	
	      case 'Function':
	        // allow complex comparison
	        return !!value(data[name], name, data);
	
	      case 'Array':
	        if (!isArray(data[name])) {
	          return false;
	        }
	
	        var op = withinArray ? arrayContains : arraysEqual;
	        return op(data[name], value);
	
	      case 'RegExp':
	        if (!isArray(data[name])) {
	          return Boolean(data[name] && data[name].match(value));
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      case 'Number':
	        value = String(value);
	        /* falls through */
	      case 'String':
	        if (!isArray(data[name])) {
	          return data[name] === value;
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
	    }
	  };
	
	
	  URI.joinPaths = function() {
	    var input = [];
	    var segments = [];
	    var nonEmptySegments = 0;
	
	    for (var i = 0; i < arguments.length; i++) {
	      var url = new URI(arguments[i]);
	      input.push(url);
	      var _segments = url.segment();
	      for (var s = 0; s < _segments.length; s++) {
	        if (typeof _segments[s] === 'string') {
	          segments.push(_segments[s]);
	        }
	
	        if (_segments[s]) {
	          nonEmptySegments++;
	        }
	      }
	    }
	
	    if (!segments.length || !nonEmptySegments) {
	      return new URI('');
	    }
	
	    var uri = new URI('').segment(segments);
	
	    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
	      uri.path('/' + uri.path());
	    }
	
	    return uri.normalize();
	  };
	
	  URI.commonPath = function(one, two) {
	    var length = Math.min(one.length, two.length);
	    var pos;
	
	    // find first non-matching character
	    for (pos = 0; pos < length; pos++) {
	      if (one.charAt(pos) !== two.charAt(pos)) {
	        pos--;
	        break;
	      }
	    }
	
	    if (pos < 1) {
	      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
	    }
	
	    // revert to last /
	    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
	      pos = one.substring(0, pos).lastIndexOf('/');
	    }
	
	    return one.substring(0, pos + 1);
	  };
	
	  URI.withinString = function(string, callback, options) {
	    options || (options = {});
	    var _start = options.start || URI.findUri.start;
	    var _end = options.end || URI.findUri.end;
	    var _trim = options.trim || URI.findUri.trim;
	    var _parens = options.parens || URI.findUri.parens;
	    var _attributeOpen = /[a-z0-9-]=["']?$/i;
	
	    _start.lastIndex = 0;
	    while (true) {
	      var match = _start.exec(string);
	      if (!match) {
	        break;
	      }
	
	      var start = match.index;
	      if (options.ignoreHtml) {
	        // attribut(e=["']?$)
	        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
	        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
	          continue;
	        }
	      }
	
	      var end = start + string.slice(start).search(_end);
	      var slice = string.slice(start, end);
	      // make sure we include well balanced parens
	      var parensEnd = -1;
	      while (true) {
	        var parensMatch = _parens.exec(slice);
	        if (!parensMatch) {
	          break;
	        }
	
	        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
	        parensEnd = Math.max(parensEnd, parensMatchEnd);
	      }
	
	      if (parensEnd > -1) {
	        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
	      } else {
	        slice = slice.replace(_trim, '');
	      }
	
	      if (slice.length <= match[0].length) {
	        // the extract only contains the starting marker of a URI,
	        // e.g. "www" or "http://"
	        continue;
	      }
	
	      if (options.ignore && options.ignore.test(slice)) {
	        continue;
	      }
	
	      end = start + slice.length;
	      var result = callback(slice, start, end, string);
	      if (result === undefined) {
	        _start.lastIndex = end;
	        continue;
	      }
	
	      result = String(result);
	      string = string.slice(0, start) + result + string.slice(end);
	      _start.lastIndex = start + result.length;
	    }
	
	    _start.lastIndex = 0;
	    return string;
	  };
	
	  URI.ensureValidHostname = function(v, protocol) {
	    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
	    // they are not part of DNS and therefore ignored by URI.js
	
	    var hasHostname = !!v; // not null and not an empty string
	    var hasProtocol = !!protocol;
	    var rejectEmptyHostname = false;
	
	    if (hasProtocol) {
	      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
	    }
	
	    if (rejectEmptyHostname && !hasHostname) {
	      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
	    } else if (v && v.match(URI.invalid_hostname_characters)) {
	      // test punycode
	      if (!punycode) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
	      }
	      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
	      }
	    }
	  };
	
	  URI.ensureValidPort = function (v) {
	    if (!v) {
	      return;
	    }
	
	    var port = Number(v);
	    if (isInteger(port) && (port > 0) && (port < 65536)) {
	      return;
	    }
	
	    throw new TypeError('Port "' + v + '" is not a valid port');
	  };
	
	  // noConflict
	  URI.noConflict = function(removeAll) {
	    if (removeAll) {
	      var unconflicted = {
	        URI: this.noConflict()
	      };
	
	      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
	        unconflicted.URITemplate = root.URITemplate.noConflict();
	      }
	
	      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
	        unconflicted.IPv6 = root.IPv6.noConflict();
	      }
	
	      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
	        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
	      }
	
	      return unconflicted;
	    } else if (root.URI === this) {
	      root.URI = _URI;
	    }
	
	    return this;
	  };
	
	  p.build = function(deferBuild) {
	    if (deferBuild === true) {
	      this._deferred_build = true;
	    } else if (deferBuild === undefined || this._deferred_build) {
	      this._string = URI.build(this._parts);
	      this._deferred_build = false;
	    }
	
	    return this;
	  };
	
	  p.clone = function() {
	    return new URI(this);
	  };
	
	  p.valueOf = p.toString = function() {
	    return this.build(false)._string;
	  };
	
	
	  function generateSimpleAccessor(_part){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        this._parts[_part] = v || null;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  function generatePrefixAccessor(_part, _key){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        if (v !== null) {
	          v = v + '';
	          if (v.charAt(0) === _key) {
	            v = v.substring(1);
	          }
	        }
	
	        this._parts[_part] = v;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  p.protocol = generateSimpleAccessor('protocol');
	  p.username = generateSimpleAccessor('username');
	  p.password = generateSimpleAccessor('password');
	  p.hostname = generateSimpleAccessor('hostname');
	  p.port = generateSimpleAccessor('port');
	  p.query = generatePrefixAccessor('query', '?');
	  p.fragment = generatePrefixAccessor('fragment', '#');
	
	  p.search = function(v, build) {
	    var t = this.query(v, build);
	    return typeof t === 'string' && t.length ? ('?' + t) : t;
	  };
	  p.hash = function(v, build) {
	    var t = this.fragment(v, build);
	    return typeof t === 'string' && t.length ? ('#' + t) : t;
	  };
	
	  p.pathname = function(v, build) {
	    if (v === undefined || v === true) {
	      var res = this._parts.path || (this._parts.hostname ? '/' : '');
	      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
	    } else {
	      if (this._parts.urn) {
	        this._parts.path = v ? URI.recodeUrnPath(v) : '';
	      } else {
	        this._parts.path = v ? URI.recodePath(v) : '/';
	      }
	      this.build(!build);
	      return this;
	    }
	  };
	  p.path = p.pathname;
	  p.href = function(href, build) {
	    var key;
	
	    if (href === undefined) {
	      return this.toString();
	    }
	
	    this._string = '';
	    this._parts = URI._parts();
	
	    var _URI = href instanceof URI;
	    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
	    if (href.nodeName) {
	      var attribute = URI.getDomAttribute(href);
	      href = href[attribute] || '';
	      _object = false;
	    }
	
	    // window.location is reported to be an object, but it's not the sort
	    // of object we're looking for:
	    // * location.protocol ends with a colon
	    // * location.query != object.search
	    // * location.hash != object.fragment
	    // simply serializing the unknown object should do the trick
	    // (for location, not for everything...)
	    if (!_URI && _object && href.pathname !== undefined) {
	      href = href.toString();
	    }
	
	    if (typeof href === 'string' || href instanceof String) {
	      this._parts = URI.parse(String(href), this._parts);
	    } else if (_URI || _object) {
	      var src = _URI ? href._parts : href;
	      for (key in src) {
	        if (key === 'query') { continue; }
	        if (hasOwn.call(this._parts, key)) {
	          this._parts[key] = src[key];
	        }
	      }
	      if (src.query) {
	        this.query(src.query, false);
	      }
	    } else {
	      throw new TypeError('invalid input');
	    }
	
	    this.build(!build);
	    return this;
	  };
	
	  // identification accessors
	  p.is = function(what) {
	    var ip = false;
	    var ip4 = false;
	    var ip6 = false;
	    var name = false;
	    var sld = false;
	    var idn = false;
	    var punycode = false;
	    var relative = !this._parts.urn;
	
	    if (this._parts.hostname) {
	      relative = false;
	      ip4 = URI.ip4_expression.test(this._parts.hostname);
	      ip6 = URI.ip6_expression.test(this._parts.hostname);
	      ip = ip4 || ip6;
	      name = !ip;
	      sld = name && SLD && SLD.has(this._parts.hostname);
	      idn = name && URI.idn_expression.test(this._parts.hostname);
	      punycode = name && URI.punycode_expression.test(this._parts.hostname);
	    }
	
	    switch (what.toLowerCase()) {
	      case 'relative':
	        return relative;
	
	      case 'absolute':
	        return !relative;
	
	      // hostname identification
	      case 'domain':
	      case 'name':
	        return name;
	
	      case 'sld':
	        return sld;
	
	      case 'ip':
	        return ip;
	
	      case 'ip4':
	      case 'ipv4':
	      case 'inet4':
	        return ip4;
	
	      case 'ip6':
	      case 'ipv6':
	      case 'inet6':
	        return ip6;
	
	      case 'idn':
	        return idn;
	
	      case 'url':
	        return !this._parts.urn;
	
	      case 'urn':
	        return !!this._parts.urn;
	
	      case 'punycode':
	        return punycode;
	    }
	
	    return null;
	  };
	
	  // component specific input validation
	  var _protocol = p.protocol;
	  var _port = p.port;
	  var _hostname = p.hostname;
	
	  p.protocol = function(v, build) {
	    if (v) {
	      // accept trailing ://
	      v = v.replace(/:(\/\/)?$/, '');
	
	      if (!v.match(URI.protocol_expression)) {
	        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
	      }
	    }
	
	    return _protocol.call(this, v, build);
	  };
	  p.scheme = p.protocol;
	  p.port = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      if (v === 0) {
	        v = null;
	      }
	
	      if (v) {
	        v += '';
	        if (v.charAt(0) === ':') {
	          v = v.substring(1);
	        }
	
	        URI.ensureValidPort(v);
	      }
	    }
	    return _port.call(this, v, build);
	  };
	  p.hostname = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
	      var res = URI.parseHost(v, x);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      v = x.hostname;
	      if (this._parts.preventInvalidHostname) {
	        URI.ensureValidHostname(v, this._parts.protocol);
	      }
	    }
	
	    return _hostname.call(this, v, build);
	  };
	
	  // compound accessors
	  p.origin = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      var protocol = this.protocol();
	      var authority = this.authority();
	      if (!authority) {
	        return '';
	      }
	
	      return (protocol ? protocol + '://' : '') + this.authority();
	    } else {
	      var origin = URI(v);
	      this
	        .protocol(origin.protocol())
	        .authority(origin.authority())
	        .build(!build);
	      return this;
	    }
	  };
	  p.host = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildHost(this._parts) : '';
	    } else {
	      var res = URI.parseHost(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.authority = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
	    } else {
	      var res = URI.parseAuthority(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.userinfo = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      var t = URI.buildUserinfo(this._parts);
	      return t ? t.substring(0, t.length -1) : t;
	    } else {
	      if (v[v.length-1] !== '@') {
	        v += '@';
	      }
	
	      URI.parseUserinfo(v, this._parts);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.resource = function(v, build) {
	    var parts;
	
	    if (v === undefined) {
	      return this.path() + this.search() + this.hash();
	    }
	
	    parts = URI.parse(v);
	    this._parts.path = parts.path;
	    this._parts.query = parts.query;
	    this._parts.fragment = parts.fragment;
	    this.build(!build);
	    return this;
	  };
	
	  // fraction accessors
	  p.subdomain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    // convenience, return "www" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // grab domain and add another segment
	      var end = this._parts.hostname.length - this.domain().length - 1;
	      return this._parts.hostname.substring(0, end) || '';
	    } else {
	      var e = this._parts.hostname.length - this.domain().length;
	      var sub = this._parts.hostname.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(sub));
	
	      if (v && v.charAt(v.length - 1) !== '.') {
	        v += '.';
	      }
	
	      if (v.indexOf(':') !== -1) {
	        throw new TypeError('Domains cannot contain colons');
	      }
	
	      if (v) {
	        URI.ensureValidHostname(v, this._parts.protocol);
	      }
	
	      this._parts.hostname = this._parts.hostname.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.domain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // convenience, return "example.org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // if hostname consists of 1 or 2 segments, it must be the domain
	      var t = this._parts.hostname.match(/\./g);
	      if (t && t.length < 2) {
	        return this._parts.hostname;
	      }
	
	      // grab tld and add another segment
	      var end = this._parts.hostname.length - this.tld(build).length - 1;
	      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
	      return this._parts.hostname.substring(end) || '';
	    } else {
	      if (!v) {
	        throw new TypeError('cannot set domain empty');
	      }
	
	      if (v.indexOf(':') !== -1) {
	        throw new TypeError('Domains cannot contain colons');
	      }
	
	      URI.ensureValidHostname(v, this._parts.protocol);
	
	      if (!this._parts.hostname || this.is('IP')) {
	        this._parts.hostname = v;
	      } else {
	        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.tld = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // return "org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      var pos = this._parts.hostname.lastIndexOf('.');
	      var tld = this._parts.hostname.substring(pos + 1);
	
	      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
	        return SLD.get(this._parts.hostname) || tld;
	      }
	
	      return tld;
	    } else {
	      var replace;
	
	      if (!v) {
	        throw new TypeError('cannot set TLD empty');
	      } else if (v.match(/[^a-zA-Z0-9-]/)) {
	        if (SLD && SLD.is(v)) {
	          replace = new RegExp(escapeRegEx(this.tld()) + '$');
	          this._parts.hostname = this._parts.hostname.replace(replace, v);
	        } else {
	          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
	        }
	      } else if (!this._parts.hostname || this.is('IP')) {
	        throw new ReferenceError('cannot set TLD on non-domain host');
	      } else {
	        replace = new RegExp(escapeRegEx(this.tld()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.directory = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path && !this._parts.hostname) {
	        return '';
	      }
	
	      if (this._parts.path === '/') {
	        return '/';
	      }
	
	      var end = this._parts.path.length - this.filename().length - 1;
	      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
	
	      return v ? URI.decodePath(res) : res;
	
	    } else {
	      var e = this._parts.path.length - this.filename().length;
	      var directory = this._parts.path.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(directory));
	
	      // fully qualifier directories begin with a slash
	      if (!this.is('relative')) {
	        if (!v) {
	          v = '/';
	        }
	
	        if (v.charAt(0) !== '/') {
	          v = '/' + v;
	        }
	      }
	
	      // directories always end with a slash
	      if (v && v.charAt(v.length - 1) !== '/') {
	        v += '/';
	      }
	
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.filename = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v !== 'string') {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var pos = this._parts.path.lastIndexOf('/');
	      var res = this._parts.path.substring(pos+1);
	
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      var mutatedDirectory = false;
	
	      if (v.charAt(0) === '/') {
	        v = v.substring(1);
	      }
	
	      if (v.match(/\.?\//)) {
	        mutatedDirectory = true;
	      }
	
	      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	
	      if (mutatedDirectory) {
	        this.normalizePath(build);
	      } else {
	        this.build(!build);
	      }
	
	      return this;
	    }
	  };
	  p.suffix = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var filename = this.filename();
	      var pos = filename.lastIndexOf('.');
	      var s, res;
	
	      if (pos === -1) {
	        return '';
	      }
	
	      // suffix may only contain alnum characters (yup, I made this up.)
	      s = filename.substring(pos+1);
	      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      if (v.charAt(0) === '.') {
	        v = v.substring(1);
	      }
	
	      var suffix = this.suffix();
	      var replace;
	
	      if (!suffix) {
	        if (!v) {
	          return this;
	        }
	
	        this._parts.path += '.' + URI.recodePath(v);
	      } else if (!v) {
	        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
	      } else {
	        replace = new RegExp(escapeRegEx(suffix) + '$');
	      }
	
	      if (replace) {
	        v = URI.recodePath(v);
	        this._parts.path = this._parts.path.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.segment = function(segment, v, build) {
	    var separator = this._parts.urn ? ':' : '/';
	    var path = this.path();
	    var absolute = path.substring(0, 1) === '/';
	    var segments = path.split(separator);
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
	    }
	
	    if (absolute) {
	      segments.shift();
	    }
	
	    if (segment < 0) {
	      // allow negative indexes to address from the end
	      segment = Math.max(segments.length + segment, 0);
	    }
	
	    if (v === undefined) {
	      /*jshint laxbreak: true */
	      return segment === undefined
	        ? segments
	        : segments[segment];
	      /*jshint laxbreak: false */
	    } else if (segment === null || segments[segment] === undefined) {
	      if (isArray(v)) {
	        segments = [];
	        // collapse empty elements within array
	        for (var i=0, l=v.length; i < l; i++) {
	          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
	            continue;
	          }
	
	          if (segments.length && !segments[segments.length -1].length) {
	            segments.pop();
	          }
	
	          segments.push(trimSlashes(v[i]));
	        }
	      } else if (v || typeof v === 'string') {
	        v = trimSlashes(v);
	        if (segments[segments.length -1] === '') {
	          // empty trailing elements have to be overwritten
	          // to prevent results such as /foo//bar
	          segments[segments.length -1] = v;
	        } else {
	          segments.push(v);
	        }
	      }
	    } else {
	      if (v) {
	        segments[segment] = trimSlashes(v);
	      } else {
	        segments.splice(segment, 1);
	      }
	    }
	
	    if (absolute) {
	      segments.unshift('');
	    }
	
	    return this.path(segments.join(separator), build);
	  };
	  p.segmentCoded = function(segment, v, build) {
	    var segments, i, l;
	
	    if (typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (v === undefined) {
	      segments = this.segment(segment, v, build);
	      if (!isArray(segments)) {
	        segments = segments !== undefined ? URI.decode(segments) : undefined;
	      } else {
	        for (i = 0, l = segments.length; i < l; i++) {
	          segments[i] = URI.decode(segments[i]);
	        }
	      }
	
	      return segments;
	    }
	
	    if (!isArray(v)) {
	      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
	    } else {
	      for (i = 0, l = v.length; i < l; i++) {
	        v[i] = URI.encode(v[i]);
	      }
	    }
	
	    return this.segment(segment, v, build);
	  };
	
	  // mutating query string
	  var q = p.query;
	  p.query = function(v, build) {
	    if (v === true) {
	      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    } else if (typeof v === 'function') {
	      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	      var result = v.call(this, data);
	      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else if (v !== undefined && typeof v !== 'string') {
	      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else {
	      return q.call(this, v, build);
	    }
	  };
	  p.setQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	
	    if (typeof name === 'string' || name instanceof String) {
	      data[name] = value !== undefined ? value : null;
	    } else if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          data[key] = name[key];
	        }
	      }
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.addQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.addQuery(data, name, value === undefined ? null : value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.removeQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.removeQuery(data, name, value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.hasQuery = function(name, value, withinArray) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    return URI.hasQuery(data, name, value, withinArray);
	  };
	  p.setSearch = p.setQuery;
	  p.addSearch = p.addQuery;
	  p.removeSearch = p.removeQuery;
	  p.hasSearch = p.hasQuery;
	
	  // sanitizing URLs
	  p.normalize = function() {
	    if (this._parts.urn) {
	      return this
	        .normalizeProtocol(false)
	        .normalizePath(false)
	        .normalizeQuery(false)
	        .normalizeFragment(false)
	        .build();
	    }
	
	    return this
	      .normalizeProtocol(false)
	      .normalizeHostname(false)
	      .normalizePort(false)
	      .normalizePath(false)
	      .normalizeQuery(false)
	      .normalizeFragment(false)
	      .build();
	  };
	  p.normalizeProtocol = function(build) {
	    if (typeof this._parts.protocol === 'string') {
	      this._parts.protocol = this._parts.protocol.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeHostname = function(build) {
	    if (this._parts.hostname) {
	      if (this.is('IDN') && punycode) {
	        this._parts.hostname = punycode.toASCII(this._parts.hostname);
	      } else if (this.is('IPv6') && IPv6) {
	        this._parts.hostname = IPv6.best(this._parts.hostname);
	      }
	
	      this._parts.hostname = this._parts.hostname.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePort = function(build) {
	    // remove port of it's the protocol's default
	    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
	      this._parts.port = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePath = function(build) {
	    var _path = this._parts.path;
	    if (!_path) {
	      return this;
	    }
	
	    if (this._parts.urn) {
	      this._parts.path = URI.recodeUrnPath(this._parts.path);
	      this.build(!build);
	      return this;
	    }
	
	    if (this._parts.path === '/') {
	      return this;
	    }
	
	    _path = URI.recodePath(_path);
	
	    var _was_relative;
	    var _leadingParents = '';
	    var _parent, _pos;
	
	    // handle relative paths
	    if (_path.charAt(0) !== '/') {
	      _was_relative = true;
	      _path = '/' + _path;
	    }
	
	    // handle relative files (as opposed to directories)
	    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
	      _path += '/';
	    }
	
	    // resolve simples
	    _path = _path
	      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
	      .replace(/\/{2,}/g, '/');
	
	    // remember leading parents
	    if (_was_relative) {
	      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
	      if (_leadingParents) {
	        _leadingParents = _leadingParents[0];
	      }
	    }
	
	    // resolve parents
	    while (true) {
	      _parent = _path.search(/\/\.\.(\/|$)/);
	      if (_parent === -1) {
	        // no more ../ to resolve
	        break;
	      } else if (_parent === 0) {
	        // top level cannot be relative, skip it
	        _path = _path.substring(3);
	        continue;
	      }
	
	      _pos = _path.substring(0, _parent).lastIndexOf('/');
	      if (_pos === -1) {
	        _pos = _parent;
	      }
	      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
	    }
	
	    // revert to relative
	    if (_was_relative && this.is('relative')) {
	      _path = _leadingParents + _path.substring(1);
	    }
	
	    this._parts.path = _path;
	    this.build(!build);
	    return this;
	  };
	  p.normalizePathname = p.normalizePath;
	  p.normalizeQuery = function(build) {
	    if (typeof this._parts.query === 'string') {
	      if (!this._parts.query.length) {
	        this._parts.query = null;
	      } else {
	        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
	      }
	
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeFragment = function(build) {
	    if (!this._parts.fragment) {
	      this._parts.fragment = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeSearch = p.normalizeQuery;
	  p.normalizeHash = p.normalizeFragment;
	
	  p.iso8859 = function() {
	    // expect unicode input, iso8859 output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = escape;
	    URI.decode = decodeURIComponent;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.unicode = function() {
	    // expect iso8859 input, unicode output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = unescape;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.readable = function() {
	    var uri = this.clone();
	    // removing username, password, because they shouldn't be displayed according to RFC 3986
	    uri.username('').password('').normalize();
	    var t = '';
	    if (uri._parts.protocol) {
	      t += uri._parts.protocol + '://';
	    }
	
	    if (uri._parts.hostname) {
	      if (uri.is('punycode') && punycode) {
	        t += punycode.toUnicode(uri._parts.hostname);
	        if (uri._parts.port) {
	          t += ':' + uri._parts.port;
	        }
	      } else {
	        t += uri.host();
	      }
	    }
	
	    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
	      t += '/';
	    }
	
	    t += uri.path(true);
	    if (uri._parts.query) {
	      var q = '';
	      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
	        var kv = (qp[i] || '').split('=');
	        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
	          .replace(/&/g, '%26');
	
	        if (kv[1] !== undefined) {
	          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
	            .replace(/&/g, '%26');
	        }
	      }
	      t += '?' + q.substring(1);
	    }
	
	    t += URI.decodeQuery(uri.hash(), true);
	    return t;
	  };
	
	  // resolving relative and absolute URLs
	  p.absoluteTo = function(base) {
	    var resolved = this.clone();
	    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
	    var basedir, i, p;
	
	    if (this._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    if (!(base instanceof URI)) {
	      base = new URI(base);
	    }
	
	    if (resolved._parts.protocol) {
	      // Directly returns even if this._parts.hostname is empty.
	      return resolved;
	    } else {
	      resolved._parts.protocol = base._parts.protocol;
	    }
	
	    if (this._parts.hostname) {
	      return resolved;
	    }
	
	    for (i = 0; (p = properties[i]); i++) {
	      resolved._parts[p] = base._parts[p];
	    }
	
	    if (!resolved._parts.path) {
	      resolved._parts.path = base._parts.path;
	      if (!resolved._parts.query) {
	        resolved._parts.query = base._parts.query;
	      }
	    } else {
	      if (resolved._parts.path.substring(-2) === '..') {
	        resolved._parts.path += '/';
	      }
	
	      if (resolved.path().charAt(0) !== '/') {
	        basedir = base.directory();
	        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
	        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
	        resolved.normalizePath();
	      }
	    }
	
	    resolved.build();
	    return resolved;
	  };
	  p.relativeTo = function(base) {
	    var relative = this.clone().normalize();
	    var relativeParts, baseParts, common, relativePath, basePath;
	
	    if (relative._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    base = new URI(base).normalize();
	    relativeParts = relative._parts;
	    baseParts = base._parts;
	    relativePath = relative.path();
	    basePath = base.path();
	
	    if (relativePath.charAt(0) !== '/') {
	      throw new Error('URI is already relative');
	    }
	
	    if (basePath.charAt(0) !== '/') {
	      throw new Error('Cannot calculate a URI relative to another relative URI');
	    }
	
	    if (relativeParts.protocol === baseParts.protocol) {
	      relativeParts.protocol = null;
	    }
	
	    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
	      return relative.build();
	    }
	
	    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
	      return relative.build();
	    }
	
	    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
	      relativeParts.hostname = null;
	      relativeParts.port = null;
	    } else {
	      return relative.build();
	    }
	
	    if (relativePath === basePath) {
	      relativeParts.path = '';
	      return relative.build();
	    }
	
	    // determine common sub path
	    common = URI.commonPath(relativePath, basePath);
	
	    // If the paths have nothing in common, return a relative URL with the absolute path.
	    if (!common) {
	      return relative.build();
	    }
	
	    var parents = baseParts.path
	      .substring(common.length)
	      .replace(/[^\/]*$/, '')
	      .replace(/.*?\//g, '../');
	
	    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';
	
	    return relative.build();
	  };
	
	  // comparing URIs
	  p.equals = function(uri) {
	    var one = this.clone();
	    var two = new URI(uri);
	    var one_map = {};
	    var two_map = {};
	    var checked = {};
	    var one_query, two_query, key;
	
	    one.normalize();
	    two.normalize();
	
	    // exact match
	    if (one.toString() === two.toString()) {
	      return true;
	    }
	
	    // extract query string
	    one_query = one.query();
	    two_query = two.query();
	    one.query('');
	    two.query('');
	
	    // definitely not equal if not even non-query parts match
	    if (one.toString() !== two.toString()) {
	      return false;
	    }
	
	    // query parameters have the same length, even if they're permuted
	    if (one_query.length !== two_query.length) {
	      return false;
	    }
	
	    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
	    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
	
	    for (key in one_map) {
	      if (hasOwn.call(one_map, key)) {
	        if (!isArray(one_map[key])) {
	          if (one_map[key] !== two_map[key]) {
	            return false;
	          }
	        } else if (!arraysEqual(one_map[key], two_map[key])) {
	          return false;
	        }
	
	        checked[key] = true;
	      }
	    }
	
	    for (key in two_map) {
	      if (hasOwn.call(two_map, key)) {
	        if (!checked[key]) {
	          // two contains a parameter not present in one
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	  // state
	  p.preventInvalidHostname = function(v) {
	    this._parts.preventInvalidHostname = !!v;
	    return this;
	  };
	
	  p.duplicateQueryParameters = function(v) {
	    this._parts.duplicateQueryParameters = !!v;
	    return this;
	  };
	
	  p.escapeQuerySpace = function(v) {
	    this._parts.escapeQuerySpace = !!v;
	    return this;
	  };
	
	  return URI;
	}));


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.4.0 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw new RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) {
				// in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else {
				// in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else {
			// in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module), (function() { return this; }())))

/***/ },
/* 767 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 768 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var bind = __webpack_require__(285);
	var Axios = __webpack_require__(771);
	var defaults = __webpack_require__(182);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(282);
	axios.CancelToken = __webpack_require__(770);
	axios.isCancel = __webpack_require__(283);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(785);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(282);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(182);
	var utils = __webpack_require__(40);
	var InterceptorManager = __webpack_require__(772);
	var dispatchRequest = __webpack_require__(773);
	var isAbsoluteURL = __webpack_require__(781);
	var combineURLs = __webpack_require__(779);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var transformData = __webpack_require__(776);
	var isCancel = __webpack_require__(283);
	var defaults = __webpack_require__(182);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 774 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(284);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 777 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 779 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 781 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 785 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(106);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URL = 'https://league.iesdev.com/api';
	var instance = _axios2.default.create({ timeout: 10000, baseURL: URL });
	
	instance.interceptors.request.use(function (config) {
	  if (config.debug) console.log('\n(' + config.method.toUpperCase() + ') ' + config.url + ' ' + JSON.stringify(config.params));
	  return config;
	}, function (error) {
	  return Promise.reject(error);
	});
	
	var LeagueAPI = function () {
	  function LeagueAPI() {
	    _classCallCheck(this, LeagueAPI);
	  }
	
	  _createClass(LeagueAPI, [{
	    key: 'getTournaments',
	    value: function getTournaments(tournamentId) {
	      return instance.get('/tournaments/' + tournamentId + '/');
	    }
	  }, {
	    key: 'getMatches',
	    value: function getMatches(params) {
	      return instance.get('/matches/', { params: params });
	    }
	  }, {
	    key: 'getMatch',
	    value: function getMatch(matchId) {
	      return instance.get('/matches/' + matchId + '/');
	    }
	  }, {
	    key: 'getGame',
	    value: function getGame(gameId) {
	      return instance.get('/games/' + gameId + '/');
	    }
	  }, {
	    key: 'getTeam',
	    value: function getTeam(id) {
	      return instance.get('/teams/' + id + '/');
	    }
	  }, {
	    key: 'getPlayer',
	    value: function getPlayer(id) {
	      return instance.get('/players/' + id);
	    }
	  }, {
	    key: 'getTeamStats',
	    value: function getTeamStats(id) {
	      return instance.get('/stats/teams/' + id + '/');
	    }
	  }, {
	    key: 'getPlayerStats',
	    value: function getPlayerStats(id, params) {
	      return instance.get('/stats/players/' + id + '/', { params: params });
	    }
	  }, {
	    key: 'getGamePlayers',
	    value: function getGamePlayers(params) {
	      return instance.get('/games/gameplayers/', { params: params });
	    }
	  }, {
	    key: 'getPlayerAutocomplete',
	    value: function getPlayerAutocomplete(params) {
	      return instance.get('/autocomplete/players', { params: params });
	    }
	  }, {
	    key: 'getTeamAutocomplete',
	    value: function getTeamAutocomplete(params) {
	      return instance.get('/autocomplete/teams', { params: params });
	    }
	  }, {
	    key: 'getTournamentAutocomplete',
	    value: function getTournamentAutocomplete(params) {
	      return instance.get('/autocomplete/tournaments', { params: params });
	    }
	  }, {
	    key: 'getSeriesAutocomplete',
	    value: function getSeriesAutocomplete(params) {
	      return instance.get('/autocomplete/series', { params: params });
	    }
	  }]);
	
	  return LeagueAPI;
	}();
	
	exports.default = new LeagueAPI();

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(106);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URL = 'https://api.rebrandly.com/v1';
	// let URL = 'https://beta.iesdev.com/api';
	// let URL = 'http://localhost:4000/api';
	var instance = _axios2.default.create({
	  baseURL: URL,
	  headers: { 'Content-Type': 'application/json', apikey: '3a67d7ef4d7544129a0f883ccd662be5', team: '22d545b844d14f168bbbdaeb0aaf6b94' }
	});
	
	instance.interceptors.request.use(function (config) {
	  console.log('\n(' + config.method.toUpperCase() + ') ' + config.url + ' ' + (config.params ? JSON.stringify(config.params) : JSON.stringify(config.data)));
	  return config;
	}, function (error) {
	  return Promise.reject(error);
	});
	
	var RebrandlyAPI = function () {
	  function RebrandlyAPI() {
	    _classCallCheck(this, RebrandlyAPI);
	  }
	
	  _createClass(RebrandlyAPI, [{
	    key: 'getUsers',
	    value: function getUsers(params) {
	      return instance.get('/users', { params: params });
	    }
	  }, {
	    key: 'postLinks',
	    value: function postLinks(params) {
	      return instance.post('/links', params);
	    }
	  }]);
	
	  return RebrandlyAPI;
	}();
	
	exports.default = new RebrandlyAPI();

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SideBar = __webpack_require__(790);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  _createClass(Container, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SideBar2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'dashboard-container' },
	          children
	        )
	      );
	    }
	  }]);
	
	  return Container;
	}(_react.Component);
	
	exports.default = Container;
	
	
	Container.propTypes = {
	  children: _propTypes2.default.object
	};

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _actions = __webpack_require__(183);
	
	var _utils = __webpack_require__(65);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this));
	
	    _this.state = {
	      email: '',
	      password: '',
	      loginActive: false,
	      showError: false
	    };
	
	    _this.handleUsernameChange = _this.handleUsernameChange.bind(_this);
	    _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Show Header Animation
	      setTimeout(function () {
	        this.setState({
	          loginActive: true
	        });
	      }.bind(this), 200);
	    }
	  }, {
	    key: 'handleUsernameChange',
	    value: function handleUsernameChange(e) {
	      var s = { email: e.target.value };
	      this.setState(s);
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(e) {
	      this.setState({ password: e.target.value });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var _this2 = this;
	
	      this.props.login({ user: this.state }).catch(function (error) {
	        switch (error.response.status) {
	          case 401:
	            _this2.setState({ showError: true });
	            break;
	          default:
	            alert('SOMETHING WENT WRONG! Let Jonathan know and copy paste him this\n' + JSON.stringify(error));
	            break;
	        }
	      });
	      e.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loggedIn = _props.loggedIn,
	          user = _props.user;
	      var _state = this.state,
	          email = _state.email,
	          loginActive = _state.loginActive,
	          password = _state.password,
	          showError = _state.showError;
	
	
	      if (loggedIn) {
	        _BlitzAPI2.default.setToken(user.profile.token);
	        _reactRouter.browserHistory.push('/entries/external');
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'login-container ' + (loginActive ? 'login-active' : null) },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-background' },
	          _react2.default.createElement('img', { className: 'fit-width', src: '/assets/img/thumbnails/content-collage.jpg', role: 'presentation' })
	        ),
	        _react2.default.createElement('div', { className: 'login-overlay' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'login' },
	          _react2.default.createElement(
	            'div',
	            { className: 'login-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'login-header-icon' },
	              _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/logo.png', role: 'presentation' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'login-header-title' },
	              _react2.default.createElement(
	                'span',
	                { className: 'login-header-blitz' },
	                'Blitz'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'login-header-cms' },
	                'CMS'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              _reactBootstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                'Email'
	              ),
	              _react2.default.createElement(_reactBootstrap.FormControl, {
	                type: 'text',
	                value: email,
	                placeholder: 'Email',
	                onChange: this.handleUsernameChange
	              })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                'Password'
	              ),
	              _react2.default.createElement(_reactBootstrap.FormControl, {
	                type: 'password',
	                value: password,
	                placeholder: 'Password',
	                onChange: this.handlePasswordChange
	              })
	            ),
	            showError && _react2.default.createElement(
	              'div',
	              { style: { paddingBottom: '5px' } },
	              'Incorrect Email or Password.',
	              _react2.default.createElement('br', null),
	              ' If you\'ve forgotten your password, ',
	              _react2.default.createElement('br', null),
	              'ping Jon for a reset!'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'submit', className: 'button-primary', value: 'submit' },
	              'Login'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  login: _propTypes2.default.func,
	  loggedIn: _propTypes2.default.bool,
	  user: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	  return {
	    loggedIn: (0, _utils.isLoggedIn)(state),
	    user: state.user
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    login: function login(data) {
	      return dispatch((0, _actions.login)(data));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _utils = __webpack_require__(65);
	
	var _actions = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideBar = function (_Component) {
	  _inherits(SideBar, _Component);
	
	  function SideBar(props) {
	    _classCallCheck(this, SideBar);
	
	    var _this = _possibleConstructorReturn(this, (SideBar.__proto__ || Object.getPrototypeOf(SideBar)).call(this, props));
	
	    _this.onLogoutClick = _this.onLogoutClick.bind(_this);
	    _this.state = {
	      adminPopoverActive: false
	    };
	    _this.toggleAdminPopover = _this.toggleAdminPopover.bind(_this);
	    return _this;
	  }
	
	  _createClass(SideBar, [{
	    key: 'onLogoutClick',
	    value: function onLogoutClick() {
	      var logout = this.props.logout;
	
	      logout();
	      _reactRouter.browserHistory.push('/login/');
	    }
	  }, {
	    key: 'toggleAdminPopover',
	    value: function toggleAdminPopover() {
	      var adminPopoverActive = this.state.adminPopoverActive;
	
	      this.setState({
	        adminPopoverActive: !adminPopoverActive
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var profile = this.props.profile;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Navbar,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-logo' },
	          _react2.default.createElement('img', { alt: 'logo', className: 'fit-height', src: '/assets/img/icons/logo.png' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'navbar-list-caption' },
	            'Manage Content'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/entries/blitz',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Blitz Entries'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/entries/external',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'External Content'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/entries/scheduled',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Scheduled Entries'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/pushnotifications/create/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Push Notifications'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/betausers/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Beta Users'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/tracking/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Blitz App Tracking'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/trackingfilter/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Blitz App Filter'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/trackingusers/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Blitz Tracking Users'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/championtips/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Blitz Champion Tips'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: '/blitzalert/',
	              className: 'navbar-list-item',
	              activeClassName: 'navbar-list-active'
	            },
	            'Blitz Alert'
	          )
	        ),
	        profile && _react2.default.createElement(
	          'div',
	          { className: 'navbar-list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'navbar-list-caption' },
	            'Admin Tools'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/sources', className: 'navbar-list-item', activeClassName: 'navbar-list-active' },
	            'Sources'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/chatrooms', className: 'navbar-list-item', activeClassName: 'navbar-list-active' },
	            'Chatrooms'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/users', className: 'navbar-list-item', activeClassName: 'navbar-list-active' },
	            'Users'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-logout', onClick: this.onLogoutClick },
	          'Logout'
	        )
	      );
	    }
	  }]);
	
	  return SideBar;
	}(_react.Component);
	
	SideBar.propTypes = {
	  logout: _propTypes2.default.func,
	  profile: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	  return {
	    profile: state.user.profile,
	    isLoggedIn: (0, _utils.isLoggedIn)(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { logout: _actions.logout })(SideBar);

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _SurveyForm = __webpack_require__(793);
	
	var _SurveyForm2 = _interopRequireDefault(_SurveyForm);
	
	var _AlertForm = __webpack_require__(792);
	
	var _AlertForm2 = _interopRequireDefault(_AlertForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alert = function (_Component) {
	  _inherits(Alert, _Component);
	
	  function Alert(props) {
	    _classCallCheck(this, Alert);
	
	    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));
	
	    _this.state = {
	      survey: null,
	      toast: null
	    };
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      Promise.all([_BlitzAPI2.default.getToast(), _BlitzAPI2.default.getSurvey()]).then(function (responses) {
	        _this2.setState({
	          toast: responses[0].data,
	          survey: responses[1].data
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          survey = _state.survey,
	          toast = _state.toast;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: 36, fontWeight: "bold", marginTop: 12, marginBottom: 12 } },
	          'Alert'
	        ),
	        _react2.default.createElement(_AlertForm2.default, { initialValues: toast, onSubmit: function onSubmit(value) {
	            var params = {
	              version: value.version,
	              message: value.message,
	              link: value.link
	            };
	            return _BlitzAPI2.default.postToast(params);
	          } }),
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: 36, fontWeight: "bold", marginTop: 12, marginBottom: 12 } },
	          'Survey'
	        ),
	        _react2.default.createElement(_SurveyForm2.default, { initialValues: survey, onSubmit: function onSubmit(value) {
	            var params = {
	              version: value.version,
	              message: value.message,
	              link: value.link
	            };
	            return _BlitzAPI2.default.postSurvey(params);
	          } })
	      );
	    }
	  }]);
	
	  return Alert;
	}(_react.Component);
	
	exports.default = Alert;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyForm = function SurveyForm(props) {
	  var handleSubmit = props.handleSubmit,
	      pristine = props.pristine,
	      reset = props.reset,
	      submitting = props.submitting,
	      initialize = props.initialize;
	
	  return _react2.default.createElement(
	    "form",
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "label",
	        null,
	        "Version"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reduxForm.Field, { style: { width: 500 }, name: "version", component: "input", type: "text" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "label",
	        null,
	        "Message"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reduxForm.Field, { style: { width: 500 }, name: "message", component: "input", type: "text" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "label",
	        null,
	        "Link"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reduxForm.Field, { style: { width: 500 }, name: "link", component: "input", type: "text" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { marginTop: 12 } },
	      _react2.default.createElement(
	        "button",
	        {
	          style: {
	            marginRight: 8,
	            paddingTop: 6,
	            paddingBottom: 6,
	            paddingLeft: 12,
	            paddingRight: 12,
	            backgroundColor: "rgba(38, 194, 129, 1)",
	            borderRadius: 4,
	            color: "white",
	            fontSize: 14
	          },
	          type: "submit",
	          disabled: submitting
	        },
	        "Submit"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          style: {
	            marginRight: 8,
	            paddingTop: 6,
	            paddingBottom: 6,
	            paddingLeft: 12,
	            paddingRight: 12,
	            backgroundColor: "rgba(38, 194, 129, 1)",
	            borderRadius: 4,
	            color: "white",
	            fontSize: 14
	          },
	          type: "button",
	          disabled: submitting,
	          onClick: function onClick() {
	            return initialize({
	              version: null,
	              message: null,
	              link: null
	            });
	          }
	        },
	        "Clear Values"
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: "blitzalert", // a unique identifier for this form
	  enableReinitialize: true
	})(SurveyForm);

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyForm = function SurveyForm(props) {
	  var handleSubmit = props.handleSubmit,
	      pristine = props.pristine,
	      reset = props.reset,
	      submitting = props.submitting,
	      initialize = props.initialize;
	
	  return _react2.default.createElement(
	    "form",
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "label",
	        null,
	        "Version"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reduxForm.Field, { style: { width: 500 }, name: "version", component: "input", type: "text" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "label",
	        null,
	        "Message"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reduxForm.Field, { style: { width: 500 }, name: "message", component: "input", type: "text" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "label",
	        null,
	        "Link"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reduxForm.Field, { style: { width: 500 }, name: "link", component: "input", type: "text" })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { marginTop: 12 } },
	      _react2.default.createElement(
	        "button",
	        {
	          style: {
	            marginRight: 8,
	            paddingTop: 6,
	            paddingBottom: 6,
	            paddingLeft: 12,
	            paddingRight: 12,
	            backgroundColor: "rgba(38, 194, 129, 1)",
	            borderRadius: 4,
	            color: "white",
	            fontSize: 14
	          },
	          type: "submit",
	          disabled: submitting
	        },
	        "Submit"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          style: {
	            marginRight: 8,
	            paddingTop: 6,
	            paddingBottom: 6,
	            paddingLeft: 12,
	            paddingRight: 12,
	            backgroundColor: "rgba(38, 194, 129, 1)",
	            borderRadius: 4,
	            color: "white",
	            fontSize: 14
	          },
	          type: "button",
	          disabled: submitting,
	          onClick: function onClick() {
	            return initialize({
	              version: null,
	              message: null,
	              link: null
	            });
	          }
	        },
	        "Clear Values"
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: "blitzsurvey", // a unique identifier for this form
	  enableReinitialize: true
	})(SurveyForm);

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BetaCreate = function (_Component) {
	  _inherits(BetaCreate, _Component);
	
	  function BetaCreate(props) {
	    _classCallCheck(this, BetaCreate);
	
	    var _this = _possibleConstructorReturn(this, (BetaCreate.__proto__ || Object.getPrototypeOf(BetaCreate)).call(this, props));
	
	    _this.checkUser = _this.checkUser.bind(_this);
	    _this.onEmailChange = _this.onEmailChange.bind(_this);
	    _this.addUser = _this.addUser.bind(_this);
	
	    _this.state = {
	      email: '',
	      query: {},
	      result: '',
	      added: '',
	      totalUsers: ''
	    };
	    return _this;
	  }
	
	  _createClass(BetaCreate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getTotalBetaUsers().then(function (resp) {
	        return _this2.setState({ totalUsers: resp.data.count });
	      });
	    }
	  }, {
	    key: 'onEmailChange',
	    value: function onEmailChange(e) {
	      this.setState({ email: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.email;
	      } else {
	        query = Object.assign({}, query, { email: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'checkUser',
	    value: function checkUser() {
	      var _this3 = this;
	
	      _BlitzAPI2.default.postCheckActivated({ email: this.state.email }).then(function (resp) {
	        _this3.setState({ result: resp.data });
	      });
	    }
	  }, {
	    key: 'addUser',
	    value: function addUser() {
	      var _this4 = this;
	
	      var email = this.state.email;
	
	      return _BlitzAPI2.default.postAddBetaUser({ email: email }).then(function (resp) {
	        return _this4.setState({ added: resp.data });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          email = _state.email,
	          result = _state.result,
	          added = _state.added,
	          totalUsers = _state.totalUsers;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Search for a user'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          'Total beta users: ',
	          totalUsers
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'userSearch' },
	            'Search'
	          ),
	          _react2.default.createElement('input', { value: email, onChange: this.onEmailChange }),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: this.checkUser },
	            'Check Email'
	          )
	        ),
	        result && _react2.default.createElement(
	          'div',
	          null,
	          JSON.stringify(result)
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { onClick: this.addUser },
	          'Add Email'
	        ),
	        added && _react2.default.createElement(
	          'div',
	          null,
	          added.success
	        )
	      );
	    }
	  }]);
	
	  return BetaCreate;
	}(_react.Component);
	
	exports.default = BetaCreate;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _ChatRoomForm = __webpack_require__(288);
	
	var _ChatRoomForm2 = _interopRequireDefault(_ChatRoomForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatRoomCreate = function (_Component) {
	  _inherits(ChatRoomCreate, _Component);
	
	  function ChatRoomCreate(props) {
	    _classCallCheck(this, ChatRoomCreate);
	
	    var _this = _possibleConstructorReturn(this, (ChatRoomCreate.__proto__ || Object.getPrototypeOf(ChatRoomCreate)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatRoomCreate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.postChatRoom({ chat_channel: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/chatrooms');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Create a new chatroom'
	        ),
	        _react2.default.createElement(_ChatRoomForm2.default, { onSubmit: this.handleSubmit })
	      );
	    }
	  }]);
	
	  return ChatRoomCreate;
	}(_react.Component);
	
	exports.default = ChatRoomCreate;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _ChatRoomForm = __webpack_require__(288);
	
	var _ChatRoomForm2 = _interopRequireDefault(_ChatRoomForm);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatRoomEdit = function (_Component) {
	  _inherits(ChatRoomEdit, _Component);
	
	  function ChatRoomEdit(props) {
	    _classCallCheck(this, ChatRoomEdit);
	
	    var _this = _possibleConstructorReturn(this, (ChatRoomEdit.__proto__ || Object.getPrototypeOf(ChatRoomEdit)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.state = {
	      chat_channel: null
	    };
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatRoomEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getChatRoom(this.props.params.chatRoomId).then(function (response) {
	        return _this2.setState({ chat_channel: response.data.data });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.patchChatRoom(this.props.params.chatRoomId, { chat_channel: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/chatrooms');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.chat_channel) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Loading'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Edit Chat Room'
	        ),
	        _react2.default.createElement(_ChatRoomForm2.default, { onSubmit: this.handleSubmit, initialValues: this.state.chat_channel })
	      );
	    }
	  }]);
	
	  return ChatRoomEdit;
	}(_react.Component);
	
	ChatRoomEdit.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouter.withRouter)(ChatRoomEdit);

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _ChatRoomTable = __webpack_require__(798);
	
	var _ChatRoomTable2 = _interopRequireDefault(_ChatRoomTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatRoomList = function (_Component) {
	  _inherits(ChatRoomList, _Component);
	
	  function ChatRoomList() {
	    _classCallCheck(this, ChatRoomList);
	
	    return _possibleConstructorReturn(this, (ChatRoomList.__proto__ || Object.getPrototypeOf(ChatRoomList)).apply(this, arguments));
	  }
	
	  _createClass(ChatRoomList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouterBootstrap.LinkContainer,
	          { to: '/chatrooms/create' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            null,
	            'Create Chatroom'
	          )
	        ),
	        _react2.default.createElement(_ChatRoomTable2.default, null)
	      );
	    }
	  }]);
	
	  return ChatRoomList;
	}(_react.Component);
	
	exports.default = ChatRoomList;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cellEditProp = {
	  mode: 'dbclick',
	  blurToSave: true
	};
	
	function chatRoomDataFormat(cell) {
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/chatrooms/' + cell },
	    _react2.default.createElement(
	      'div',
	      null,
	      cell
	    )
	  );
	}
	
	function trStyleFormat(row) {
	  var outClass = void 0;
	  switch (row.esport) {
	    case 'csgo':
	      outClass = 'entry-table-feed';
	      break;
	    case 'league':
	      outClass = 'entry-table-video';
	      break;
	    default:
	      outClass = 'entry-table-default';
	  }
	  return outClass;
	}
	
	var ChatRoomTable = function (_Component) {
	  _inherits(ChatRoomTable, _Component);
	
	  function ChatRoomTable(props) {
	    _classCallCheck(this, ChatRoomTable);
	
	    var _this = _possibleConstructorReturn(this, (ChatRoomTable.__proto__ || Object.getPrototypeOf(ChatRoomTable)).call(this, props));
	
	    _this.state = {
	      data: null,
	      query: { object_type: 'raffle,entry,match,lobby', featured_message: false },
	      esport: '',
	      featured_message: 'false'
	    };
	    _this.onCellEdit = _this.onCellEdit.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onTypeChange = _this.onTypeChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChatRoomTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'onCellEdit',
	    value: function onCellEdit(row, fieldName, value) {
	      var data = this.state.data;
	
	      var rowIndex = void 0;
	      var targetRow = data.find(function (currentRow, index) {
	        if (currentRow.id === row.id) {
	          rowIndex = index;
	          return true;
	        }
	        return false;
	      });
	
	      if (targetRow && targetRow[fieldName] !== value) {
	        targetRow[fieldName] = value;
	        data[rowIndex] = targetRow;
	        var chatchannelParams = {};
	        chatchannelParams[fieldName] = value;
	        _BlitzAPI2.default.patchChatRoom(row.id, { chat_channel: chatchannelParams }).then(function (response) {
	          return console.log(response);
	        });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(page, sizePerPage) {
	      var query = Object.assign({}, this.state.query, { page: page });
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(sortName, sortOrder) {
	      var sorting = sortOrder === 'asc' ? sortName : '-' + sortName;
	      var query = Object.assign({}, this.state.query, { order_by: sorting });
	      this.setState({
	        query: query
	      }, this.getData);
	    }
	  }, {
	    key: 'onTypeChange',
	    value: function onTypeChange(e) {
	      var _e$target = e.target,
	          value = _e$target.value,
	          checked = _e$target.checked;
	
	      var currTypes = this.state.query.object_type || '';
	      var currTypesList = currTypes.split(',');
	      var valueIndex = currTypesList.indexOf(value);
	      if (checked && valueIndex === -1) {
	        currTypesList.push(value);
	      } else if (!checked && valueIndex !== -1) {
	        currTypesList.splice(valueIndex, 1);
	      }
	
	      currTypesList = currTypesList.filter(function (x) {
	        return x;
	      });
	
	      var query = Object.assign({}, this.state.query, { object_type: currTypesList.join(',') });
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e, field) {
	      var value = e.target.value;
	      var query = this.state.query;
	
	      var newQuery = void 0;
	      switch (value) {
	        case 'true':
	          newQuery = Object.assign({}, query, _defineProperty({}, field, true));
	          break;
	        case 'false':
	          newQuery = Object.assign({}, query, _defineProperty({}, field, false));
	          break;
	        case '':
	          newQuery = Object.assign({}, query);
	          delete newQuery[field];
	          break;
	        default:
	          newQuery = Object.assign({}, query, _defineProperty({}, field, value));
	      }
	      this.setState(_defineProperty({}, field, value));
	      this.setState({ query: newQuery }, this.getData);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      var query = this.state.query;
	
	      _BlitzAPI2.default.getChatRooms(query).then(function (resp) {
	        return _this2.setState({
	          data: resp.data.data,
	          sizePerPage: resp.data.page_size,
	          dataTotalSize: resp.data.total_entries,
	          currentPage: resp.data.page_number
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          esport = _state.esport,
	          featured_message = _state.featured_message,
	          query = _state.query;
	
	
	      return this.state.data ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            _reactBootstrap.Form,
	            { horizontal: true },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                'Types'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Checkbox,
	                  { onChange: this.onTypeChange, value: 'entry', checked: query.object_type.includes('entry') },
	                  'Entry'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Checkbox,
	                  { onChange: this.onTypeChange, value: 'match', checked: query.object_type.includes('match') },
	                  'Match'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Checkbox,
	                  { onChange: this.onTypeChange, value: 'lobby', checked: query.object_type.includes('lobby') },
	                  'Lobby'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Checkbox,
	                  { onChange: this.onTypeChange, value: 'raffle', checked: query.object_type.includes('raffle') },
	                  'Raffle'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                'Has Message'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onRadioChange(e, 'featured_message');
	                    },
	                    value: true, checked: featured_message === 'true' // eslint-disable-line camelcase
	                  },
	                  'True'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onRadioChange(e, 'featured_message');
	                    },
	                    value: 'false',
	                    checked: featured_message === 'false' // eslint-disable-line camelcase
	                  },
	                  'All'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { sm: 3 },
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                'Esport'
	              ),
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onRadioChange(e, 'esport');
	                    },
	                    value: 'lol', checked: esport === 'lol' // eslint-disable-line camelcase
	                  },
	                  'League of Legends'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onRadioChange(e, 'esport');
	                    },
	                    value: 'csgo', checked: esport === 'csgo' // eslint-disable-line camelcase
	                  },
	                  'CSGO'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this3.onRadioChange(e, 'esport');
	                    },
	                    value: '',
	                    checked: esport === '' // eslint-disable-line camelcase
	                  },
	                  'All'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.BootstrapTable,
	          {
	            data: this.state.data,
	            remote: true, striped: true, hover: true,
	            cellEdit: cellEditProp,
	            pagination: true,
	            fetchInfo: { dataTotalSize: this.state.dataTotalSize },
	            options: {
	              onCellEdit: this.onCellEdit,
	              onSortChange: this.onSortChange,
	              sizePerPage: this.state.sizePerPage,
	              onPageChange: this.onPageChange,
	              page: this.state.currentPage
	            },
	            trClassName: trStyleFormat
	          },
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, isKey: true, dataField: 'id', editable: false, dataFormat: chatRoomDataFormat },
	            'Chat Channel ID'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'name', width: '600' },
	            'Name'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'object_id' },
	            'Object ID'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'object_type', editable: false },
	            'Object Type'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'message_count' },
	            'Message Count'
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return ChatRoomTable;
	}(_react.Component);
	
	exports.default = ChatRoomTable;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleLogin = __webpack_require__(1404);
	
	var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);
	
	var _PageItem = __webpack_require__(800);
	
	var _PageItem2 = _interopRequireDefault(_PageItem);
	
	var _PageItemHeader = __webpack_require__(801);
	
	var _PageItemHeader2 = _interopRequireDefault(_PageItemHeader);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLIENT_ID = "141763336902-buo058pgti87glccg7s89h9kmu1qjars.apps.googleusercontent.com";
	
	var DashboardHome = function (_Component) {
	  _inherits(DashboardHome, _Component);
	
	  function DashboardHome(props) {
	    _classCallCheck(this, DashboardHome);
	
	    var _this = _possibleConstructorReturn(this, (DashboardHome.__proto__ || Object.getPrototypeOf(DashboardHome)).call(this, props));
	
	    _this.getData = _this.getData.bind(_this);
	    _this.state = {
	      output: null,
	      pages: []
	    };
	    return _this;
	  }
	
	  _createClass(DashboardHome, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.gapi.load('auth2', function () {
	        if (!window.gapi.auth2.getAuthInstance()) {
	          window.gapi.auth2.init({ client_id: CLIENT_ID }).then(function () {
	            if (window.gapi.auth2.getAuthInstance().currentUser.get()) {
	              _this2.getData();
	            }
	          });
	        } else {
	          if (window.gapi.auth2.getAuthInstance().currentUser.get()) {
	            _this2.getData();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this3 = this;
	
	      var getEntries = _BlitzAPI2.default.getEntries({ is_blitz: 'true', type: 'article,youtube' }).then(function (response) {
	        var entries = {};
	        var slugs = response.data.data.map(function (entry) {
	          var slug = (0, _utils.generateEntrySlug)(entry);
	          entries[slug] = entry;
	          return (0, _utils.generateEntrySlug)(entry);
	        });
	        console.log(slugs);
	        var getReport = window.gapi.client.request({
	          path: '/v4/reports:batchGet',
	          root: 'https://analyticsreporting.googleapis.com/',
	          method: 'POST',
	          body: {
	            reportRequests: [{
	              viewId: '140796225',
	              dateRanges: [{
	                startDate: '7daysAgo',
	                endDate: 'today'
	              }],
	              metrics: [{ expression: 'ga:sessions' }, { expression: 'ga:avgTimeOnPage' }, { expression: 'ga:uniquePageviews' }],
	              dimensions: [{ name: 'ga:pagePath' }],
	              dimensionFilterClauses: [{
	                filters: [{
	                  dimensionName: 'ga:pagePath',
	                  operator: 'IN_LIST',
	                  expressions: slugs
	                }]
	              }]
	            }]
	          }
	        }).then(function (response2) {
	          var pages = response2.result.reports[0].data.rows;
	          pages.sort(function (a, b) {
	            var name_a = a.dimensions[0];
	            var name_b = b.dimensions[0];
	            return slugs.indexOf(name_a) > slugs.indexOf(name_b) ? 1 : -1;
	          });
	          _this3.setState({ pages: pages, entries: entries });
	        });
	      });
	    }
	  }, {
	    key: 'failure',
	    value: function failure() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactGoogleLogin2.default, {
	          clientId: CLIENT_ID,
	          buttonText: 'Login',
	          onSuccess: this.getData,
	          onFailure: this.failure
	        }),
	        ',',
	        _react2.default.createElement(_PageItemHeader2.default, null),
	        this.state.pages.map(function (page, i) {
	          var entry = _this4.state.entries[page.dimensions[0]];
	          return _react2.default.createElement(_PageItem2.default, { key: i, entry: entry, page: page });
	        })
	      );
	    }
	  }]);
	
	  return DashboardHome;
	}(_react.Component);
	
	exports.default = DashboardHome;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  cell: {
	    height: 75,
	    padding: 15
	  }
	};
	
	var PageItem = function (_Component) {
	  _inherits(PageItem, _Component);
	
	  function PageItem() {
	    _classCallCheck(this, PageItem);
	
	    return _possibleConstructorReturn(this, (PageItem.__proto__ || Object.getPrototypeOf(PageItem)).apply(this, arguments));
	  }
	
	  _createClass(PageItem, [{
	    key: 'prettyTime',
	    value: function prettyTime(string, pad, length) {
	      return (new Array(length + 1).join(pad) + string).slice(-length);
	    }
	  }, {
	    key: 'esportDataFormat',
	    value: function esportDataFormat(esport) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-item-esport-icon' },
	        _react2.default.createElement('img', { className: 'fit-height', role: 'presentation', src: '/assets/img/icons/' + esport + '.png' })
	      );
	    }
	  }, {
	    key: 'typeDataFormat',
	    value: function typeDataFormat(type) {
	      var icon = '';
	      if (type === 'youtube') {
	        icon = 'video.png';
	      } else if (type === 'article') {
	        icon = 'article.png';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-item-esport-icon' },
	        _react2.default.createElement('img', { className: 'fit-height', role: 'presentation', src: '/assets/img/icons/' + icon })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          page = _props.page,
	          entry = _props.entry;
	
	      var session = page.metrics[0].values[0];
	      var avgTime = page.metrics[0].values[1];
	      var pageViews = page.metrics[0].values[2];
	      var minutes = Math.floor(avgTime / 60);
	      var seconds = Math.floor(avgTime % 60);
	      var time = this.prettyTime(minutes, '0', 2) + ':' + this.prettyTime(seconds, '0', 2);
	
	      var icon = this.typeDataFormat(entry.type);
	      var esport = this.esportDataFormat(entry.esport);
	      var title = entry.title;
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'row' } },
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1 }) },
	          esport
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1 }) },
	          icon
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 10 }) },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1.5 }) },
	          session
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1.5 }) },
	          time
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1.5 }) },
	          pageViews
	        )
	      );
	    }
	  }]);
	
	  return PageItem;
	}(_react.Component);
	
	exports.default = PageItem;
	
	
	PageItem.propTypes = {
	  page: _propTypes2.default.object,
	  entry: _propTypes2.default.object
	};

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  cell: {
	    padding: 15
	  }
	};
	
	var PageItemHeader = function (_Component) {
	  _inherits(PageItemHeader, _Component);
	
	  function PageItemHeader() {
	    _classCallCheck(this, PageItemHeader);
	
	    return _possibleConstructorReturn(this, (PageItemHeader.__proto__ || Object.getPrototypeOf(PageItemHeader)).apply(this, arguments));
	  }
	
	  _createClass(PageItemHeader, [{
	    key: 'typeDataFormat',
	    value: function typeDataFormat(type) {
	      var icon = '';
	      if (type === 'youtube') {
	        icon = 'video.png';
	      } else if (type === 'article') {
	        icon = 'article.png';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-item-type-icon' },
	        _react2.default.createElement('img', { className: 'fit-height', role: 'presentation', src: '/assets/img/icons/' + icon })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'row' } },
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1 }) },
	          'Esport'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1 }) },
	          'Type'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 10 }) },
	          'Title'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1.5 }) },
	          'Session'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1.5 }) },
	          'AvgTime'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.cell, { flex: 1.5 }) },
	          'PageViews'
	        )
	      );
	    }
	  }]);
	
	  return PageItemHeader;
	}(_react.Component);
	
	exports.default = PageItemHeader;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _EntryListTableBlitz = __webpack_require__(804);
	
	var _EntryListTableBlitz2 = _interopRequireDefault(_EntryListTableBlitz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EntryListBlitz = function (_Component) {
	  _inherits(EntryListBlitz, _Component);
	
	  function EntryListBlitz(props) {
	    _classCallCheck(this, EntryListBlitz);
	
	    var _this = _possibleConstructorReturn(this, (EntryListBlitz.__proto__ || Object.getPrototypeOf(EntryListBlitz)).call(this, props));
	
	    _this.state = {
	      time: (0, _moment2.default)()
	    };
	    _this.updateTime = _this.updateTime.bind(_this);
	    return _this;
	  }
	
	  _createClass(EntryListBlitz, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateTime();
	    }
	  }, {
	    key: 'updateTime',
	    value: function updateTime() {
	      var _this2 = this;
	
	      this.setState({ time: (0, _moment2.default)() }, function () {
	        return setTimeout(_this2.updateTime, 1000);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-list' },
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-title' },
	            'Blitz Entries'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-caption' },
	            'Manage and Publish new Blitz article or video.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-time' },
	            this.state.time.format("dddd, MMMM Do YYYY, h:mm:ss a")
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/entries/blitz/create/article', className: 'entry-action entry-action-article' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              null,
	              'Create an Article'
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/entries/blitz/create/youtube', className: 'entry-action entry-action-video' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              null,
	              'Create a Video'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-body' },
	          _react2.default.createElement(_EntryListTableBlitz2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return EntryListBlitz;
	}(_react.Component);
	
	exports.default = EntryListBlitz;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _EntryListTableExternal = __webpack_require__(805);
	
	var _EntryListTableExternal2 = _interopRequireDefault(_EntryListTableExternal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EntryListExternal = function (_Component) {
	  _inherits(EntryListExternal, _Component);
	
	  function EntryListExternal(props) {
	    _classCallCheck(this, EntryListExternal);
	
	    var _this = _possibleConstructorReturn(this, (EntryListExternal.__proto__ || Object.getPrototypeOf(EntryListExternal)).call(this, props));
	
	    _this.state = {
	      time: (0, _moment2.default)()
	    };
	    _this.updateTime = _this.updateTime.bind(_this);
	    return _this;
	  }
	
	  _createClass(EntryListExternal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateTime();
	    }
	  }, {
	    key: 'updateTime',
	    value: function updateTime() {
	      var _this2 = this;
	
	      this.setState({ time: (0, _moment2.default)() }, function () {
	        return setTimeout(_this2.updateTime, 1000);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-list' },
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-title' },
	            'External Content'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-caption' },
	            'Manage and Import new content from an external source.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-time' },
	            this.state.time.format("dddd, MMMM Do YYYY, h:mm:ss a")
	          ),
	          _react2.default.createElement(
	            _reactRouterBootstrap.LinkContainer,
	            { to: '/entries/external/create', className: 'entry-action' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              null,
	              'Add New Content'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-body' },
	          _react2.default.createElement(_EntryListTableExternal2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return EntryListExternal;
	}(_react.Component);
	
	exports.default = EntryListExternal;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouter = __webpack_require__(17);
	
	__webpack_require__(455);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _TableDatetimeEditor = __webpack_require__(293);
	
	var _TableDatetimeEditor2 = _interopRequireDefault(_TableDatetimeEditor);
	
	var _constants = __webpack_require__(44);
	
	var _utils = __webpack_require__(65);
	
	var _TableUtils = __webpack_require__(289);
	
	var _utils2 = __webpack_require__(32);
	
	__webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createTableDateTimeEditor(onUpdate, props) {
	  return _react2.default.createElement(_TableDatetimeEditor2.default, Object.assign({ onUpdate: onUpdate }, props));
	}
	
	function entryDataFormat(cell, row) {
	  var entryLink = '/entries/blitz/' + cell;
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: entryLink },
	    _react2.default.createElement(
	      'div',
	      null,
	      cell
	    )
	  );
	}
	
	function titleDataFormat(cell, row) {
	  var entryLink = '/entries/blitz/' + row.id;
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: entryLink },
	    cell
	  );
	}
	
	function datetimeDataFormat(cell, row) {
	  var now = (0, _moment2.default)();
	  var date = (0, _moment2.default)(row.publish_date);
	  var isBefore = now.isBefore(date);
	  var blue = 'rgba(51, 163, 243, 1.0)';
	  return _react2.default.createElement(
	    'div',
	    null,
	    isBefore && _react2.default.createElement(
	      'div',
	      { style: row.published ? { color: blue, fontWeight: 'bold' } : {} },
	      (0, _moment2.default)(row.publish_date).fromNow()
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      (0, _moment2.default)(row.publish_date).format('MMM Do[,] YYYY h:mma')
	    )
	  );
	}
	
	function previewDataFormat(cell, row) {
	  return _react2.default.createElement(
	    'a',
	    {
	      href: (0, _utils2.generateEntrySlug)(row, false, true),
	      target: '_blank', rel: 'noopener noreferrer', className: 'entry-item-preview'
	    },
	    'Preview'
	  );
	}
	
	function trStyleFormat(row) {
	  var outClass = 'entry-table-item ';
	  if (!row.published) {
	    outClass += 'entry-table-draft';
	  }
	
	  /* if scheduled add class "entry-table-scheduled" */
	
	  return outClass;
	}
	
	var EntryListTableBlitz = function (_Component) {
	  _inherits(EntryListTableBlitz, _Component);
	
	  function EntryListTableBlitz(props) {
	    _classCallCheck(this, EntryListTableBlitz);
	
	    var _this = _possibleConstructorReturn(this, (EntryListTableBlitz.__proto__ || Object.getPrototypeOf(EntryListTableBlitz)).call(this, props));
	
	    _this.state = {
	      data: null,
	      sources: null,
	      query: { is_blitz: 'true', type: 'article,youtube,guide' },
	      is_blitz: 'true',
	      published: '',
	      esport: '',
	      search: ''
	    };
	    _this.onCellEdit = _this.onCellEdit.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onTypeChange = _this.onTypeChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.onSearchChange = _this.onSearchChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(EntryListTableBlitz, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getSources().then(function (response) {
	        var sourceOptions = (0, _utils.getSourceOptions)(response);
	        _this2.setState({
	          sources: sourceOptions
	        });
	      });
	      this.getData();
	    }
	  }, {
	    key: 'onCellEdit',
	    value: function onCellEdit(row, fieldName, value) {
	      var data = this.state.data;
	
	      var rowIndex = void 0;
	      var targetRow = data.find(function (currentRow, index) {
	        if (currentRow.id === row.id) {
	          rowIndex = index;
	          return true;
	        }
	        return false;
	      });
	
	      if (targetRow && targetRow[fieldName] !== value) {
	        targetRow[fieldName] = value;
	        data[rowIndex] = targetRow;
	        var entryParams = {};
	        entryParams[fieldName] = value;
	        _BlitzAPI2.default.patchEntry(row.id, { entry: entryParams }).then(function (response) {
	          return console.log(response);
	        });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(page, sizePerPage) {
	      var query = Object.assign({}, this.state.query, { page: page });
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(sortName, sortOrder) {
	      var sorting = sortOrder === 'asc' ? sortName : '-' + sortName;
	      var query = Object.assign({}, this.state.query, { order_by: sorting });
	      this.setState({
	        query: query
	      }, this.getData);
	    }
	  }, {
	    key: 'onTypeChange',
	    value: function onTypeChange(e) {
	      var _e$target = e.target,
	          value = _e$target.value,
	          checked = _e$target.checked;
	
	      var currTypes = this.state.query.type || '';
	      var currTypesList = currTypes.split(',');
	      var valueIndex = currTypesList.indexOf(value);
	      if (checked && valueIndex === -1) {
	        currTypesList.push(value);
	      } else if (!checked && valueIndex !== -1) {
	        currTypesList.splice(valueIndex, 1);
	      }
	
	      currTypesList = currTypesList.filter(function (x) {
	        return x;
	      });
	
	      var query = Object.assign({}, this.state.query, { type: currTypesList.join(',') });
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e, field) {
	      var value = e.target.value;
	      var query = this.state.query;
	
	      var newQuery = void 0;
	      switch (value) {
	        case 'true':
	          newQuery = Object.assign({}, query, _defineProperty({}, field, true));
	          break;
	        case 'false':
	          newQuery = Object.assign({}, query, _defineProperty({}, field, false));
	          break;
	        case '':
	          newQuery = Object.assign({}, query);
	          delete newQuery[field];
	          break;
	        default:
	          newQuery = Object.assign({}, query, _defineProperty({}, field, value));
	      }
	      this.setState(_defineProperty({}, field, value));
	      this.setState({ query: newQuery }, this.getData);
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(e) {
	      this.setState({ search: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.search;
	      } else {
	        query = Object.assign({}, query, { search: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this3 = this;
	
	      _BlitzAPI2.default.getEntries(this.state.query).then(function (resp) {
	        return _this3.setState({
	          data: resp.data.data,
	          sizePerPage: resp.data.page_size,
	          dataTotalSize: resp.data.total_entries,
	          currentPage: resp.data.page_number
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          published = _state.published,
	          esport = _state.esport,
	          search = _state.search,
	          data = _state.data,
	          sources = _state.sources,
	          dataTotalSize = _state.dataTotalSize;
	
	      console.log(dataTotalSize);
	
	      return data && sources ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container entry-filter entry-filter-blitz' },
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-filter-search' },
	            _react2.default.createElement('input', { value: search, onChange: this.onSearchChange, placeholder: 'Search' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Form,
	            { horizontal: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'entry-filter-item entry-filter-published' },
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this4.onRadioChange(e, 'published');
	                    },
	                    value: '',
	                    checked: published === '' // eslint-disable-line camelcase
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'All Stories'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this4.onRadioChange(e, 'published');
	                    },
	                    value: true, checked: published === 'true' // eslint-disable-line camelcase
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Published'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  {
	                    onChange: function onChange(e) {
	                      return _this4.onRadioChange(e, 'published');
	                    },
	                    value: false, checked: published === 'false' // eslint-disable-line camelcase
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Draft'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'entry-filter-item entry-filter-esport' },
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _constants.ESPORT_TYPE_OPTIONS.map(function (game, idx) {
	                  return _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    {
	                      onChange: function onChange(e) {
	                        return _this4.onRadioChange(e, 'esport');
	                      },
	                      value: game[0],
	                      checked: esport === game[0] // eslint-disable-line camelcase
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      game[1]
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrapTable.BootstrapTable,
	            {
	              data: data,
	              remote: true, hover: true,
	              pagination: true,
	              trClassName: trStyleFormat,
	              fetchInfo: { dataTotalSize: this.state.dataTotalSize },
	              options: {
	                onSortChange: this.onSortChange,
	                sizePerPage: this.state.sizePerPage,
	                onPageChange: this.onPageChange,
	                page: this.state.currentPage
	              }
	            },
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'esport',
	                dataFormat: _TableUtils.esportDataFormat,
	                width: '60',
	                editable: { type: 'select', options: { values: _constants.ESPORT_TABLE_TYPE_OPTIONS } }
	              },
	              'Esport'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'type',
	                width: '70',
	                dataFormat: _TableUtils.typeDataFormat,
	                dataSort: true,
	                editable: { type: 'select', options: { values: _constants.ENTRY_TABLE_TYPE_OPTIONS } }
	              },
	              'Type'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              { dataField: 'title', dataFormat: titleDataFormat, dataSort: true },
	              'Title'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'publish_date',
	                width: '200',
	                dataSort: true,
	                dataFormat: datetimeDataFormat,
	                customEditor: { getElement: createTableDateTimeEditor },
	                editColumnClassName: 'table-datetime-editor'
	              },
	              'Publish Date'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                isKey: true,
	                dataField: 'id',
	                width: '70',
	                dataFormat: entryDataFormat,
	                dataSort: true
	              },
	              'ID'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              { dataField: 'preview', width: '0', dataFormat: previewDataFormat },
	              'Preview'
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return EntryListTableBlitz;
	}(_react.Component);
	
	exports.default = EntryListTableBlitz;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouter = __webpack_require__(17);
	
	__webpack_require__(455);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _TableDatetimeEditor = __webpack_require__(293);
	
	var _TableDatetimeEditor2 = _interopRequireDefault(_TableDatetimeEditor);
	
	var _constants = __webpack_require__(44);
	
	var _TableUtils = __webpack_require__(289);
	
	var _utils = __webpack_require__(65);
	
	__webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createTableDateTimeEditor(onUpdate, props) {
	  return _react2.default.createElement(_TableDatetimeEditor2.default, Object.assign({ onUpdate: onUpdate }, props));
	}
	
	function entryDataFormat(cell, row) {
	  var entryLink = '/entries/external/' + cell;
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: entryLink },
	    _react2.default.createElement(
	      'div',
	      null,
	      cell
	    )
	  );
	}
	
	function titleDataFormat(cell, row) {
	  var entryLink = '/entries/external/' + row.id;
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: entryLink },
	    cell
	  );
	}
	
	function sourceDataFormat(cell) {
	  if (cell) {
	    return cell.name;
	  }
	  return null;
	}
	
	function datetimeDataFormat(cell, row) {
	  return (0, _moment2.default)(row.publish_date).format('MMM Do[,] YYYY h:mma');
	}
	
	function linkDataFormat(cell, row) {
	  return _react2.default.createElement(
	    'a',
	    { href: row.url, target: '_blank', rel: 'noopener noreferrer', className: 'entry-item-preview' },
	    'Link'
	  );
	}
	
	function trStyleFormat(row) {
	  var outClass = 'entry-table-item ';
	  if (!row.published) {
	    outClass += 'entry-table-draft';
	  }
	  return outClass;
	}
	
	var EntryListTableExternal = function (_Component) {
	  _inherits(EntryListTableExternal, _Component);
	
	  function EntryListTableExternal(props) {
	    _classCallCheck(this, EntryListTableExternal);
	
	    var _this = _possibleConstructorReturn(this, (EntryListTableExternal.__proto__ || Object.getPrototypeOf(EntryListTableExternal)).call(this, props));
	
	    _this.state = {
	      data: null,
	      sources: null,
	      query: { is_blitz: 'false', type: 'article,youtube,feed' },
	      type: 'article,youtube,feed',
	      is_blitz: 'true',
	      published: '',
	      esport: '',
	      search: ''
	    };
	    _this.onCellEdit = _this.onCellEdit.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onTypeChange = _this.onTypeChange.bind(_this);
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    _this.onSearchChange = _this.onSearchChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(EntryListTableExternal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getSources().then(function (response) {
	        var sourceOptions = (0, _utils.getSourceOptions)(response);
	        _this2.setState({
	          sources: sourceOptions
	        });
	      });
	      this.getData();
	    }
	  }, {
	    key: 'onCellEdit',
	    value: function onCellEdit(row, fieldName, value) {
	      var data = this.state.data;
	
	      var rowIndex = void 0;
	      var targetRow = data.find(function (currentRow, index) {
	        if (currentRow.id === row.id) {
	          rowIndex = index;
	          return true;
	        }
	        return false;
	      });
	
	      if (targetRow && targetRow[fieldName] !== value) {
	        targetRow[fieldName] = value;
	        data[rowIndex] = targetRow;
	        var entryParams = {};
	        entryParams[fieldName] = value;
	        _BlitzAPI2.default.patchEntry(row.id, { entry: entryParams }).then(function (response) {
	          return console.log(response);
	        });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(page, sizePerPage) {
	      var query = Object.assign({}, this.state.query, { page: page });
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(sortName, sortOrder) {
	      var sorting = sortOrder === 'asc' ? sortName : '-' + sortName;
	      var query = Object.assign({}, this.state.query, { order_by: sorting });
	      this.setState({
	        query: query
	      }, this.getData);
	    }
	  }, {
	    key: 'onTypeChange',
	    value: function onTypeChange(e) {
	      var value = e.target.value;
	
	
	      var query = Object.assign({}, this.state.query, { type: value });
	      this.setState({ query: query, type: value }, this.getData);
	    }
	  }, {
	    key: 'onRadioChange',
	    value: function onRadioChange(e, field) {
	      var value = e.target.value;
	      var query = this.state.query;
	
	      var newQuery = void 0;
	      switch (value) {
	        case 'true':
	          newQuery = Object.assign({}, query, _defineProperty({}, field, true));
	          break;
	        case 'false':
	          newQuery = Object.assign({}, query, _defineProperty({}, field, false));
	          break;
	        case '':
	          newQuery = Object.assign({}, query);
	          delete newQuery[field];
	          break;
	        default:
	          newQuery = Object.assign({}, query, _defineProperty({}, field, value));
	      }
	      this.setState(_defineProperty({}, field, value));
	      this.setState({ query: newQuery }, this.getData);
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(e) {
	      this.setState({ search: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.search;
	      } else {
	        query = Object.assign({}, query, { search: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this3 = this;
	
	      _BlitzAPI2.default.getEntries(this.state.query).then(function (resp) {
	        return _this3.setState({
	          data: resp.data.data,
	          sizePerPage: resp.data.page_size,
	          dataTotalSize: resp.data.total_entries,
	          currentPage: resp.data.page_number
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          esport = _state.esport,
	          type = _state.type,
	          search = _state.search;
	
	
	      return this.state.data && this.state.sources ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container entry-filter entry-filter-external' },
	          _react2.default.createElement(
	            'div',
	            { className: 'entry-filter-search' },
	            _react2.default.createElement('input', { value: search, onChange: this.onSearchChange, placeholder: 'Search' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Form,
	            { horizontal: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'entry-filter-item entry-filter-type' },
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  { onChange: this.onTypeChange, value: 'article,youtube,feed', checked: type === 'article,youtube,feed' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'All Content'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  { onChange: this.onTypeChange, value: 'article', checked: type === 'article' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Articles'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  { onChange: this.onTypeChange, value: 'youtube', checked: type === 'youtube' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Youtube'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Radio,
	                  { onChange: this.onTypeChange, value: 'feed', checked: type === 'feed' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'BlitzFeed'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'entry-filter-item entry-filter-esport' },
	              _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _constants.ESPORT_TYPE_OPTIONS.map(function (game, idx) {
	                  return _react2.default.createElement(
	                    _reactBootstrap.Radio,
	                    {
	                      onChange: function onChange(e) {
	                        return _this4.onRadioChange(e, 'esport');
	                      },
	                      value: game[0],
	                      checked: esport === game[0] // eslint-disable-line camelcase
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      game[1]
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrapTable.BootstrapTable,
	            {
	              data: this.state.data,
	              remote: true, hover: true,
	              pagination: true,
	              trClassName: trStyleFormat,
	              fetchInfo: { dataTotalSize: this.state.dataTotalSize },
	              options: {
	                onSortChange: this.onSortChange,
	                sizePerPage: this.state.sizePerPage,
	                onPageChange: this.onPageChange,
	                page: this.state.currentPage
	              }
	            },
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'esport',
	                dataFormat: _TableUtils.esportDataFormat,
	                width: '60',
	                editable: { type: 'select', options: { values: _constants.ESPORT_TABLE_TYPE_OPTIONS } }
	              },
	              'Esport'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'type',
	                width: '70',
	                dataFormat: _TableUtils.typeDataFormat,
	                dataSort: true,
	                editable: { type: 'select', options: { values: _constants.ENTRY_TABLE_TYPE_OPTIONS } }
	              },
	              'Type'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              { dataField: 'title', dataFormat: titleDataFormat, dataSort: true },
	              'Title'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'source',
	                editable: false,
	                dataFormat: sourceDataFormat,
	                width: '132'
	              },
	              'Source'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                dataField: 'publish_date',
	                width: '192',
	                dataSort: true,
	                dataFormat: datetimeDataFormat,
	                customEditor: { getElement: createTableDateTimeEditor },
	                editColumnClassName: 'table-datetime-editor'
	              },
	              'Publish Date'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              {
	                isKey: true,
	                dataField: 'id',
	                width: '70',
	                dataFormat: entryDataFormat,
	                dataSort: true
	              },
	              'ID'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              { dataField: 'preview', width: '0', dataFormat: linkDataFormat },
	              'Link'
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return EntryListTableExternal;
	}(_react.Component);
	
	exports.default = EntryListTableExternal;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _EntryScheduleBlock = __webpack_require__(807);
	
	var _EntryScheduleBlock2 = _interopRequireDefault(_EntryScheduleBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EntrySchedule = function (_Component) {
	  _inherits(EntrySchedule, _Component);
	
	  function EntrySchedule() {
	    _classCallCheck(this, EntrySchedule);
	
	    return _possibleConstructorReturn(this, (EntrySchedule.__proto__ || Object.getPrototypeOf(EntrySchedule)).apply(this, arguments));
	  }
	
	  _createClass(EntrySchedule, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          { style: { paddingBottom: '20px' } },
	          'Scheduled Articles'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_EntryScheduleBlock2.default, { platform: 'yt', alreadyRan: 'false' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_EntryScheduleBlock2.default, { platform: 'fb', alreadyRan: 'false' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_EntryScheduleBlock2.default, { platform: 'twitter', alreadyRan: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { style: { paddingBottom: '20px' } },
	          'Past Articles'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_EntryScheduleBlock2.default, { platform: 'yt', alreadyRan: 'true' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_EntryScheduleBlock2.default, { platform: 'fb', alreadyRan: 'true' })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 4 },
	            _react2.default.createElement(_EntryScheduleBlock2.default, { platform: 'twitter', alreadyRan: 'true' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EntrySchedule;
	}(_react.Component);
	
	exports.default = EntrySchedule;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function EntryScheduleInfo(props) {
	  var entry = props.entry,
	      platform = props.platform;
	
	  var entryLink = '/entries/blitz/' + entry.id;
	
	  var didRun = void 0;
	  switch (platform) {
	    case 'yt':
	      didRun = entry.yt_ran;
	      break;
	    case 'fb':
	      didRun = entry.fb_id ? 'true' : 'false';
	      break;
	    case 'twitter':
	      didRun = entry.twitter_id ? 'true' : 'false';
	      break;
	  }
	  return _react2.default.createElement(
	    'tr',
	    { style: {
	        border: '1px solid'
	      } },
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: entryLink },
	        entry.id
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: entryLink },
	        entry.title
	      )
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      (0, _moment2.default)(entry.publish_date).format('MMM Do[,] YYYY h:mma')
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      '' + didRun
	    )
	  );
	}
	
	function platformToFullName(p) {
	  var platforms = {
	    'fb': 'Facebook',
	    'yt': 'Youtube',
	    'twitter': 'Twitter'
	  };
	  return platforms[p];
	}
	
	var EntryScheduleBlock = function (_Component) {
	  _inherits(EntryScheduleBlock, _Component);
	
	  function EntryScheduleBlock(props) {
	    _classCallCheck(this, EntryScheduleBlock);
	
	    var _this = _possibleConstructorReturn(this, (EntryScheduleBlock.__proto__ || Object.getPrototypeOf(EntryScheduleBlock)).call(this, props));
	
	    _this.state = {
	      entries: null
	    };
	    return _this;
	  }
	
	  _createClass(EntryScheduleBlock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _BlitzApi$getEntries,
	          _this2 = this;
	
	      var _props = this.props,
	          platform = _props.platform,
	          alreadyRan = _props.alreadyRan;
	
	      _BlitzAPI2.default.getEntries((_BlitzApi$getEntries = {}, _defineProperty(_BlitzApi$getEntries, platform + '_publish', true), _defineProperty(_BlitzApi$getEntries, platform + '_ran', alreadyRan), _BlitzApi$getEntries)).then(function (response) {
	        _this2.setState({ entries: response.data.data });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var platform = this.props.platform;
	      var entries = this.state.entries;
	
	      console.log(entries);
	      return _react2.default.createElement(
	        'div',
	        { style: { paddingBottom: '40px' } },
	        _react2.default.createElement(
	          'h3',
	          { style: { marginBottom: '10px', marginTop: '10px' } },
	          platformToFullName(platform)
	        ),
	        entries && entries.length > 0 ? _react2.default.createElement(
	          'table',
	          { className: 'scheduler-table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              { style: {
	                  border: '1px solid'
	                } },
	              _react2.default.createElement(
	                'th',
	                null,
	                'ID'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Title'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Scheduled For'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Auto Published?'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            entries.map(function (e) {
	              return _react2.default.createElement(EntryScheduleInfo, { entry: e, key: e.id, platform: platform });
	            })
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          'Nothing scheduled right now'
	        )
	      );
	    }
	  }]);
	
	  return EntryScheduleBlock;
	}(_react.Component);
	
	exports.default = EntryScheduleBlock;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BlitzEntryForm = __webpack_require__(290);
	
	var _BlitzEntryForm2 = _interopRequireDefault(_BlitzEntryForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlitzEntryCreate = function (_Component) {
	  _inherits(BlitzEntryCreate, _Component);
	
	  function BlitzEntryCreate(props) {
	    _classCallCheck(this, BlitzEntryCreate);
	
	    var _this = _possibleConstructorReturn(this, (BlitzEntryCreate.__proto__ || Object.getPrototypeOf(BlitzEntryCreate)).call(this, props));
	
	    _this.parseEntryFromUrl = _this.parseEntryFromUrl.bind(_this);
	    _this.state = {
	      loadParseUrl: false
	    };
	    return _this;
	  }
	
	  _createClass(BlitzEntryCreate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.postEntry({ entry: values }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'parseEntryFromUrl',
	    value: function parseEntryFromUrl(url) {
	      var _this2 = this;
	
	      if (url) {
	        this.setState({ loadParseUrl: true });
	        _BlitzAPI2.default.parseEntryFromUrl({ url: url }).then(function (response) {
	          _this2.setState({ loadParseUrl: false });
	          _this2.setState({ entry: Object.assign(response.data.data, { is_blitz: true }) });
	        }).catch(function () {
	          _this2.setState({ loadParseUrl: false });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var params = this.props.params;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: 'create-header' },
	          'Create New Entry'
	        ),
	        _react2.default.createElement(_BlitzEntryForm2.default, {
	          onSubmit: this.handleSubmit,
	          parseEntryFromUrl: this.parseEntryFromUrl // Must be in parent
	          , loadParseUrl: this.state.loadParseUrl // Must be in parent
	          , initialValues: this.state.entry || {
	            show_mobile: true,
	            show_web: true,
	            type: params.type,
	            publish_date: (0, _moment2.default)(),
	            source_id: 11,
	            is_blitz: true
	          }
	        })
	      );
	    }
	  }]);
	
	  return BlitzEntryCreate;
	}(_react.Component);
	
	function mapStateToProps(state) {}
	
	BlitzEntryCreate.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(BlitzEntryCreate);

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzEntryForm = __webpack_require__(290);
	
	var _BlitzEntryForm2 = _interopRequireDefault(_BlitzEntryForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlitzEntryEdit = function (_Component) {
	  _inherits(BlitzEntryEdit, _Component);
	
	  function BlitzEntryEdit(props) {
	    _classCallCheck(this, BlitzEntryEdit);
	
	    var _this = _possibleConstructorReturn(this, (BlitzEntryEdit.__proto__ || Object.getPrototypeOf(BlitzEntryEdit)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.parseEntryFromUrl = _this.parseEntryFromUrl.bind(_this);
	    _this.state = {
	      entry: null,
	      error: null,
	      loadParseUrl: false
	    };
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(BlitzEntryEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getEntry(this.props.params.entryId).then(function (response) {
	        return _this2.setState({ entry: response.data.data });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      var data = Object.assign({}, values);
	      delete data.source;
	      delete data.author;
	      if (typeof data.top_image !== 'string') {
	        delete data.top_image;
	      }
	      if (typeof data.cover_image !== 'string') {
	        delete data.cover_image;
	      }
	
	      return _BlitzAPI2.default.patchEntry(this.props.params.entryId, { entry: data }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'parseEntryFromUrl',
	    value: function parseEntryFromUrl(url) {
	      var _this3 = this;
	
	      if (url) {
	        this.setState({ loadParseUrl: true });
	        _BlitzAPI2.default.parseEntryFromUrl({ url: url }).then(function (response) {
	          _this3.setState({ loadParseUrl: false });
	          _this3.setState({ entry: Object.assign(response.data.data, { is_blitz: true }) });
	        }).catch(function () {
	          _this3.setState({ loadParseUrl: false });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var entry = this.state.entry;
	
	
	      if (!entry) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Loading'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: 'create-header' },
	          'Edit this Entry'
	        ),
	        _react2.default.createElement(_BlitzEntryForm2.default, {
	          onSubmit: this.handleSubmit,
	          parseEntryFromUrl: this.parseEntryFromUrl,
	          loadParseUrl: this.state.loadParseUrl,
	          initialValues: entry,
	          url: this.props.url
	        })
	      );
	    }
	  }]);
	
	  return BlitzEntryEdit;
	}(_react.Component);
	
	BlitzEntryEdit.propTypes = {
	  params: _propTypes2.default.object,
	  url: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRouter.withRouter)(BlitzEntryEdit);

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TwitterPublished = function (_Component) {
	  _inherits(TwitterPublished, _Component);
	
	  function TwitterPublished() {
	    _classCallCheck(this, TwitterPublished);
	
	    return _possibleConstructorReturn(this, (TwitterPublished.__proto__ || Object.getPrototypeOf(TwitterPublished)).apply(this, arguments));
	  }
	
	  _createClass(TwitterPublished, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          message = _props.message,
	          link = _props.link;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'publish-facebook-preview clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'publish-facebook-preview-header clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'publish-facebook-preview-thumbnail' },
	            _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/thumbnails/blitz_lol.png', role: 'presentation' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'publish-facebook-preview-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'publish-facebook-preview-user' },
	              'Blitz Esports'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'publish-facebook-preview-content' },
	          message
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'publish-facebook-preview-content' },
	          link
	        )
	      );
	    }
	  }]);
	
	  return TwitterPublished;
	}(_react.Component);
	
	exports.default = TwitterPublished;
	
	
	TwitterPublished.propTypes = {
	  message: _propTypes2.default.string,
	  link: _propTypes2.default.string
	};

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  blue: {
	    color: 'rgba(51, 163, 243, 1.0)'
	  },
	  red: {
	    color: 'rgba(243, 83, 83, 1.0)'
	  },
	  status: {
	    fontWeight: 600
	  },
	  row: {
	    display: 'flex',
	    flexDirection: 'row'
	  }
	};
	
	var PublishItem = function (_Component) {
	  _inherits(PublishItem, _Component);
	
	  function PublishItem() {
	    _classCallCheck(this, PublishItem);
	
	    return _possibleConstructorReturn(this, (PublishItem.__proto__ || Object.getPrototypeOf(PublishItem)).apply(this, arguments));
	  }
	
	  _createClass(PublishItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isPublished = _props.isPublished,
	          title = _props.title,
	          id = _props.id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'create-entry-schedule-item' },
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, styles.row) },
	          _react2.default.createElement(
	            'div',
	            { className: 'create-entry-schedule-platform', style: { flex: 1 } },
	            title
	          ),
	          isPublished && !id && _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, styles.blue, styles.status) },
	            'Show'
	          ),
	          !isPublished && !id && _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, styles.red, styles.status) },
	            'Don\'t Show'
	          ),
	          id && _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, styles.blue, styles.status) },
	            'Already Published'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PublishItem;
	}(_react.Component);
	
	exports.default = PublishItem;
	
	
	PublishItem.propTypes = {
	  isPublished: _propTypes2.default.bool,
	  date: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  id: _propTypes2.default.number
	};

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PublishItem = __webpack_require__(811);
	
	var _PublishItem2 = _interopRequireDefault(_PublishItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  blue: {
	    color: 'rgba(51, 163, 243, 1.0)'
	  },
	  red: {
	    color: 'rgba(243, 83, 83, 1.0)'
	  },
	  status: {
	    fontWeight: 600,
	    fontSize: 12
	  },
	  row: {
	    display: 'flex',
	    flexDirection: 'row'
	  }
	};
	
	var PublishSchedule = function (_Component) {
	  _inherits(PublishSchedule, _Component);
	
	  function PublishSchedule() {
	    _classCallCheck(this, PublishSchedule);
	
	    return _possibleConstructorReturn(this, (PublishSchedule.__proto__ || Object.getPrototypeOf(PublishSchedule)).apply(this, arguments));
	  }
	
	  _createClass(PublishSchedule, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          twitterId = _props.twitterId,
	          fbId = _props.fbId,
	          showWeb = _props.showWeb,
	          showMobile = _props.showMobile,
	          publishDate = _props.publishDate,
	          twitterPublish = _props.twitterPublish,
	          fbPublish = _props.fbPublish;
	
	      var now = (0, _moment2.default)();
	      var date = (0, _moment2.default)(publishDate);
	      var isAfter = now.isAfter(date);
	      // Don't show if not published and not scheduled
	      if (isAfter) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'create-entry-schedule' },
	        _react2.default.createElement(
	          'div',
	          { className: 'create-entry-schedule-header clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'create-entry-schedule-header-title' },
	            'Scheduled'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'create-entry-schedule-header-icon' },
	            _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/schedule.png', alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'create-entry-schedule-content' },
	          publishDate && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, styles.status) },
	              (0, _moment2.default)(publishDate).format('MMM D YYYY, h:mmA z')
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, styles.blue, styles.status) },
	              ' ',
	              (0, _moment2.default)(publishDate).fromNow()
	            )
	          ),
	          _react2.default.createElement(_PublishItem2.default, { title: 'Website', isPublished: showWeb, date: publishDate }),
	          _react2.default.createElement(_PublishItem2.default, { title: 'Mobile', isPublished: showMobile, date: publishDate }),
	          _react2.default.createElement(_PublishItem2.default, { title: 'Twitter', id: twitterId, isPublished: twitterPublish, date: publishDate }),
	          _react2.default.createElement(_PublishItem2.default, { title: 'Facebook', id: fbId, isPublished: fbPublish, date: publishDate })
	        )
	      );
	    }
	  }]);
	
	  return PublishSchedule;
	}(_react.Component);
	
	PublishSchedule.propTypes = {
	  twitterId: _propTypes2.default.string,
	  fbId: _propTypes2.default.string,
	  showWeb: _propTypes2.default.bool,
	  showMobile: _propTypes2.default.bool,
	  publishDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  twitterPublish: _propTypes2.default.bool,
	  fbPublish: _propTypes2.default.bool
	};
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state) {
	  return {
	    showMobile: selector(state, 'show_mobile'),
	    showWeb: selector(state, 'show_web'),
	    publishDate: selector(state, 'publish_date'),
	    twitterPublish: selector(state, 'twitter_publish'),
	    fbPublish: selector(state, 'fb_publish'),
	    fbId: selector(state, 'fb_id'),
	    twitterId: selector(state, 'twitter_id'),
	    published: selector(state, 'published')
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PublishSchedule);

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublishingField = function (_Component) {
	  _inherits(PublishingField, _Component);
	
	  function PublishingField(props) {
	    _classCallCheck(this, PublishingField);
	
	    var _this = _possibleConstructorReturn(this, (PublishingField.__proto__ || Object.getPrototypeOf(PublishingField)).call(this, props));
	
	    var radioValue = void 0;
	    if (props.published) {
	      radioValue = 'now';
	    } else {
	      radioValue = 'never';
	    }
	
	    _this.state = {
	      radioValue: radioValue
	    };
	    _this.onRadioChange = _this.onRadioChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(PublishingField, [{
	    key: 'onRadioChange',
	    value: function onRadioChange(e) {
	      var _props = this.props,
	          publishFieldName = _props.publishFieldName,
	          change = _props.change;
	
	
	      switch (e.target.value) {
	        case 'now':
	          // change(dateFieldName, moment().toISOString());
	          change(publishFieldName, true);
	          break;
	        case 'scheduled':
	          change(publishFieldName, true);
	          break;
	        case 'never':
	        default:
	          change(publishFieldName, false);
	      }
	
	      this.setState({ radioValue: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var radioValue = this.state.radioValue;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'publish-options clearfix' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('form-publish-schedule-option', 'clearfix', radioValue === 'now' && 'form-publish-schedule-option-active')
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'form-publish-schedule-option-button'
	            },
	            _react2.default.createElement('input', {
	              name: 'publish',
	              type: 'radio',
	              value: 'now',
	              checked: radioValue === 'now',
	              onChange: this.onRadioChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-publish-schedule-option-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-publish-schedule-option-title' },
	              'Show'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-publish-schedule-option-caption' },
	              'The story will be shown on this platform'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('form-publish-schedule-option', 'clearfix', radioValue === 'never' && 'form-publish-schedule-option-active')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-publish-schedule-option-button' },
	            _react2.default.createElement('input', {
	              name: 'publish',
	              type: 'radio',
	              value: 'never',
	              checked: radioValue === 'scheduled',
	              onChange: this.onRadioChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-publish-schedule-option-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-publish-schedule-option-title' },
	              'Don\'t Show'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-publish-schedule-option-caption' },
	              'The story will not be shown on this platform'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PublishingField;
	}(_react.Component);
	
	PublishingField.propTypes = {
	  publishFieldName: _propTypes2.default.string,
	  published: _propTypes2.default.bool,
	  change: _propTypes2.default.func
	};
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state, ownProps) {
	  return {
	    published: selector(state, ownProps.publishFieldName)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PublishingField);

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _FileToUrl = __webpack_require__(184);
	
	var _FileToUrl2 = _interopRequireDefault(_FileToUrl);
	
	var _FormTextArea = __webpack_require__(185);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const client = new Twitter({
	//   consumer_key: 'gUT7pPUO48WLwjbzSab932gEr',
	//   consumer_secret: 'RJ2thrNt2y1ZJIDHzXIPJMm5dYpneWDOcEqedbEsjQfFgAQypL',
	//   access_token_key: '885251996608978945-eu7hfkCeEgb37Bit1sv5U6fEfh5Ob9A',
	//   access_token_secret: '9jcMGcRjZ9jXyRsENifaprzH6OG2dZKB0EwbQOwI4q87z',
	// });
	//
	
	var TwitterField = function (_Component) {
	  _inherits(TwitterField, _Component);
	
	  function TwitterField() {
	    _classCallCheck(this, TwitterField);
	
	    return _possibleConstructorReturn(this, (TwitterField.__proto__ || Object.getPrototypeOf(TwitterField)).apply(this, arguments));
	  }
	
	  _createClass(TwitterField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          change = _props.change,
	          twitterImage = _props.twitterImage;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'publish-twitter' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'twitter_message',
	            component: _FormTextArea2.default,
	            label: 'Tweet'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'twitter-image clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'create-form-image-item clearfix' },
	            _react2.default.createElement(_reduxForm.Field, {
	              label: 'Add Image',
	              name: 'twitter_image_url',
	              component: _BasicFormInput2.default,
	              controlId: 'twitterImage',
	              format: _utils.formatTopImage
	            }),
	            _react2.default.createElement(_FileToUrl2.default, { onUrlChange: function onUrlChange(newUrl) {
	                return change('twitter_image_url', newUrl);
	              } }),
	            (0, _utils.formatTopImage)(twitterImage) && _react2.default.createElement('img', { className: 'create-form-image-thumbnail', src: (0, _utils.formatTopImage)(twitterImage), role: 'presentation' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TwitterField;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state) {
	  return {
	    twitterImage: selector(state, 'twitter_image_url')
	  };
	}
	
	TwitterField.propTypes = {
	  change: _propTypes2.default.func,
	  twitterImage: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TwitterField);

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TwitterPublished = function (_Component) {
	  _inherits(TwitterPublished, _Component);
	
	  function TwitterPublished() {
	    _classCallCheck(this, TwitterPublished);
	
	    return _possibleConstructorReturn(this, (TwitterPublished.__proto__ || Object.getPrototypeOf(TwitterPublished)).apply(this, arguments));
	  }
	
	  _createClass(TwitterPublished, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          message = _props.message,
	          image = _props.image;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'publish-twitter-preview clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'publish-twitter-preview-thumbnail' },
	          _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/thumbnails/blitz_lol.png', role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'publish-twitter-preview-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'publish-twitter-preview-header clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'publish-twitter-preview-user' },
	              'Blitz Esports'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'publish-twitter-preview-handle' },
	              '@BlitzEsportsCOM'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'publish-twitter-preview-tweet' },
	            message
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'publish-twitter-preview-image' },
	            _react2.default.createElement('img', { className: 'fit-width', src: image, role: 'presentation' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TwitterPublished;
	}(_react.Component);
	
	exports.default = TwitterPublished;
	
	
	TwitterPublished.propTypes = {
	  message: _propTypes2.default.string,
	  image: _propTypes2.default.string
	};

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reduxForm = __webpack_require__(31);
	
	var _ExternalEntryForm = __webpack_require__(291);
	
	var _ExternalEntryForm2 = _interopRequireDefault(_ExternalEntryForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	var _SpinLoader = __webpack_require__(134);
	
	var _SpinLoader2 = _interopRequireDefault(_SpinLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalEntryCreate = function (_Component) {
	  _inherits(ExternalEntryCreate, _Component);
	
	  function ExternalEntryCreate(props) {
	    _classCallCheck(this, ExternalEntryCreate);
	
	    var _this = _possibleConstructorReturn(this, (ExternalEntryCreate.__proto__ || Object.getPrototypeOf(ExternalEntryCreate)).call(this, props));
	
	    _this.state = {
	      entry: null,
	      parsingUrl: false
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.parseEntryFromUrl = _this.parseEntryFromUrl.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExternalEntryCreate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.postEntry({ entry: values }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'parseEntryFromUrl',
	    value: function parseEntryFromUrl() {
	      var _this2 = this;
	
	      var url = this.props.url;
	
	      if (url) {
	        this.setState({ parsingUrl: true });
	        _BlitzAPI2.default.parseEntryFromUrl({ url: url }).then(function (response) {
	          _this2.setState({ entry: response.data.data, parsingUrl: false });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var url = this.props.url;
	      var _state = this.state,
	          entry = _state.entry,
	          parsingUrl = _state.parsingUrl;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: 'create-header' },
	          'Import an External Content'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            className: 'button-secondary create-form-button-parse',
	            type: 'button',
	            onClick: this.parseEntryFromUrl,
	            disabled: parsingUrl
	          },
	          'Parse from URL'
	        ),
	        parsingUrl && _react2.default.createElement(_SpinLoader2.default, {
	          style: {
	            'margin-left': '8px',
	            top: '296px',
	            width: '12px',
	            height: '12px',
	            position: 'relative',
	            display: 'inline-block'
	          }
	        }),
	        _react2.default.createElement(_ExternalEntryForm2.default, {
	          onSubmit: this.handleSubmit,
	          initialValues: entry || { show_mobile: true, show_web: true, type: 'article', is_blitz: false },
	          url: url
	        })
	      );
	    }
	  }]);
	
	  return ExternalEntryCreate;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('generic-entry');
	function mapStateToProps(state) {
	  var url = selector(state, 'url');
	  var type = selector(state, 'type');
	  return {
	    url: url,
	    type: type
	  };
	}
	
	ExternalEntryCreate.propTypes = {
	  url: _propTypes2.default.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExternalEntryCreate);

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _ExternalEntryForm = __webpack_require__(291);
	
	var _ExternalEntryForm2 = _interopRequireDefault(_ExternalEntryForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalEntryEdit = function (_Component) {
	  _inherits(ExternalEntryEdit, _Component);
	
	  function ExternalEntryEdit(props) {
	    _classCallCheck(this, ExternalEntryEdit);
	
	    var _this = _possibleConstructorReturn(this, (ExternalEntryEdit.__proto__ || Object.getPrototypeOf(ExternalEntryEdit)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.state = {
	      entry: null
	    };
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExternalEntryEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getEntry(this.props.params.entryId).then(function (response) {
	        return _this2.setState({ entry: response.data.data });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      var data = Object.assign({}, values);
	      delete data.source;
	      delete data.author;
	      if (typeof data.top_image !== 'string') {
	        delete data.top_image;
	      }
	      if (typeof data.cover_image !== 'string') {
	        delete data.cover_image;
	      }
	
	      return _BlitzAPI2.default.patchEntry(this.props.params.entryId, { entry: data }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.entry) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Loading'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: 'create-header' },
	          'Edit this Entry'
	        ),
	        _react2.default.createElement(_ExternalEntryForm2.default, {
	          onSubmit: this.handleSubmit,
	          initialValues: this.state.entry,
	          url: this.props.url
	        })
	      );
	    }
	  }]);
	
	  return ExternalEntryEdit;
	}(_react.Component);
	
	ExternalEntryEdit.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouter.withRouter)(ExternalEntryEdit);

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleButton = __webpack_require__(186);
	
	var _StyleButton2 = _interopRequireDefault(_StyleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BLOCK_TYPES = [{ label: 'Blockquote', style: 'blockquote', icon: '/assets/img/icons/editor/quote.svg' }, { label: 'UL', style: 'unordered-list-item', icon: '/assets/img/icons/editor/ul.svg' }, { label: 'OL', style: 'ordered-list-item', icon: '/assets/img/icons/editor/ol.svg' }, { label: 'HTML', style: 'code-block', icon: '/assets/img/icons/editor/html.svg' }];
	
	var BlockStyleControls = function (_Component) {
	  _inherits(BlockStyleControls, _Component);
	
	  function BlockStyleControls() {
	    _classCallCheck(this, BlockStyleControls);
	
	    return _possibleConstructorReturn(this, (BlockStyleControls.__proto__ || Object.getPrototypeOf(BlockStyleControls)).apply(this, arguments));
	  }
	
	  _createClass(BlockStyleControls, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var editorState = this.props.editorState;
	
	      var selection = editorState.getSelection();
	      var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls' },
	        BLOCK_TYPES.map(function (type) {
	          return _react2.default.createElement(_StyleButton2.default, {
	            key: type.label,
	            active: type.style === blockType,
	            label: type.label,
	            icon: type.icon,
	            onToggle: _this2.props.onToggle,
	            style: type.style
	          });
	        })
	      );
	    }
	  }]);
	
	  return BlockStyleControls;
	}(_react.Component);
	
	exports.default = BlockStyleControls;
	
	
	BlockStyleControls.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  editorState: _propTypes2.default.object.isRequired
	};

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _draftJs = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorHTML = function (_Component) {
	  _inherits(EditorHTML, _Component);
	
	  function EditorHTML() {
	    _classCallCheck(this, EditorHTML);
	
	    return _possibleConstructorReturn(this, (EditorHTML.__proto__ || Object.getPrototypeOf(EditorHTML)).apply(this, arguments));
	  }
	
	  _createClass(EditorHTML, [{
	    key: 'render',
	    value: function render() {
	      var block = this.props.block;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: block.getText() } }),
	        _react2.default.createElement(
	          'pre',
	          null,
	          _react2.default.createElement(_draftJs.EditorBlock, this.props)
	        )
	      );
	    }
	  }]);
	
	  return EditorHTML;
	}(_react.Component);
	
	EditorHTML.propTypes = {
	  block: _propTypes2.default.object
	};
	EditorHTML.defaultProps = {};
	
	exports.default = EditorHTML;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _draftJs = __webpack_require__(42);
	
	var _reactOnclickoutside = __webpack_require__(101);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _reactYoutube = __webpack_require__(1468);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _urijs = __webpack_require__(765);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var _reactTweetEmbed = __webpack_require__(1467);
	
	var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);
	
	var _constants = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorImage = function (_Component) {
	  _inherits(EditorImage, _Component);
	
	  function EditorImage(props) {
	    _classCallCheck(this, EditorImage);
	
	    var _this = _possibleConstructorReturn(this, (EditorImage.__proto__ || Object.getPrototypeOf(EditorImage)).call(this, props));
	
	    var contentState = props.contentState,
	        block = props.block;
	
	    var blockEntityType = block.getEntityAt(0);
	
	    _this.updateImageData = _this.updateImageData.bind(_this);
	
	    if (!blockEntityType) {
	      var _ret;
	
	      return _ret = null, _possibleConstructorReturn(_this, _ret);
	    }
	
	    var entity = contentState.getEntity(blockEntityType);
	
	    var _entity$getData = entity.getData(),
	        caption = _entity$getData.caption,
	        alt = _entity$getData.alt,
	        src = _entity$getData.src,
	        style = _entity$getData.style,
	        extraClasses = _entity$getData.extraClasses,
	        width = _entity$getData.width;
	
	    _this.state = {
	      caption: caption,
	      alt: alt,
	      src: src,
	      style: style,
	      extraClasses: extraClasses || '',
	      width: width
	    };
	    return _this;
	  }
	
	  _createClass(EditorImage, [{
	    key: 'updateImageData',
	    value: function updateImageData() {
	      var _state = this.state,
	          caption = _state.caption,
	          alt = _state.alt,
	          src = _state.src,
	          style = _state.style,
	          extraClasses = _state.extraClasses,
	          width = _state.width;
	      var _props = this.props,
	          contentState = _props.contentState,
	          block = _props.block;
	      var _props$blockProps = this.props.blockProps,
	          onEditorChange = _props$blockProps.onEditorChange,
	          editorState = _props$blockProps.editorState;
	
	
	      var blockEntityType = block.getEntityAt(0);
	      if (!blockEntityType) {
	        console.log("FML");
	        return null;
	      }
	
	      var newContent = contentState.mergeEntityData(blockEntityType, { caption: caption, alt: alt, src: src, style: style, extraClasses: extraClasses, width: width });
	
	      onEditorChange(_draftJs.EditorState.push(editorState, newContent, 'change-block-data'));
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      var block = this.props.block;
	      var _props$blockProps2 = this.props.blockProps,
	          editorState = _props$blockProps2.editorState,
	          resetSelection = _props$blockProps2.resetSelection,
	          setReadOnly = _props$blockProps2.setReadOnly;
	
	      if (editorState.getSelection().getStartKey() === block.getKey() && editorState.getSelection().getEndKey() === block.getKey() && editorState.getSelection().getHasFocus()) {
	        resetSelection();
	        setReadOnly(false);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          contentState = _props2.contentState,
	          block = _props2.block;
	      var editorState = this.props.blockProps.editorState;
	
	
	      var blockEntityType = block.getEntityAt(0);
	      if (!blockEntityType) {
	        return null;
	      }
	      var entity = contentState.getEntity(blockEntityType);
	      // console.log(JSON.stringify(entity._map));
	
	      var _entity$getData2 = entity.getData(),
	          src = _entity$getData2.src;
	
	      if (entity.type === 'image') {
	        var _state2 = this.state,
	            caption = _state2.caption,
	            alt = _state2.alt,
	            style = _state2.style,
	            extraClasses = _state2.extraClasses,
	            width = _state2.width;
	
	
	        var figureClass = void 0;
	        switch (style) {
	          case 'full-width':
	            figureClass = 'figure-full';
	            break;
	          case 'left':
	            figureClass = 'figure-left';
	            break;
	          case 'right':
	            figureClass = 'figure-right';
	            break;
	          default:
	            figureClass = '';
	        }
	
	        var figureBorder = editorState.getSelection().getStartKey() === block.getKey() && editorState.getSelection().getEndKey() === block.getKey() && editorState.getSelection().getHasFocus() && '2px solid #26c281';
	
	        var cleanedWidth = void 0;
	
	        if (width <= 0) {
	          cleanedWidth = 0;
	        } else if (width && width < 50) {
	          cleanedWidth = 50;
	        } else {
	          cleanedWidth = width;
	        }
	
	        var figureStyle = {
	          width: cleanedWidth ? cleanedWidth + 'px' : '',
	          border: figureBorder
	        };
	
	        return _react2.default.createElement(
	          'figure',
	          {
	            className: figureClass + ' ' + extraClasses,
	            onClick: function onClick() {
	              var _props$blockProps3 = _this2.props.blockProps,
	                  setReadOnly = _props$blockProps3.setReadOnly,
	                  setSelection = _props$blockProps3.setSelection;
	
	              var newSelection = _draftJs.SelectionState.createEmpty(block.getKey());
	              var finalSelection = newSelection.merge({
	                focusKey: block.getKey(),
	                focusOffset: 0,
	                anchorKey: block.getKey(),
	                anchorOffset: 0
	              });
	              setReadOnly(true);
	              setSelection(finalSelection);
	            },
	            style: figureStyle
	          },
	          _react2.default.createElement('img', {
	            src: src,
	            role: 'presentation',
	            alt: alt
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'figure-toolbox',
	              style: editorState.getSelection().getStartKey() === block.getKey() && editorState.getSelection().getEndKey() === block.getKey() && editorState.getSelection().getHasFocus() ? {} : { display: 'none' }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'figure-toolbox-field-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'figure-toolbox-field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'figure-toolbox-label' },
	                  'Caption'
	                ),
	                _react2.default.createElement('input', {
	                  className: 'figure-toolbox-input',
	                  value: caption,
	                  onChange: function onChange(e) {
	                    _this2.setState({ caption: e.target.value }, _this2.updateImageData);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'figure-toolbox-field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'figure-toolbox-label' },
	                  'Alt Text'
	                ),
	                _react2.default.createElement('input', { className: 'figure-toolbox-input', value: alt, onChange: function onChange(e) {
	                    return _this2.setState({ alt: e.target.value }, _this2.updateImageData);
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'figure-toolbox-field-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'figure-toolbox-field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'figure-toolbox-label' },
	                  'Align'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'figure-toolbox-segment clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'figure-toolbox-segment-item ' + (style === 'left' && 'figure-toolbox-segment-active'),
	                      onClick: function onClick(e) {
	                        return _this2.setState({ style: 'left' }, _this2.updateImageData);
	                      }
	                    },
	                    'Left'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'figure-toolbox-segment-item ' + (style === 'regular' && 'figure-toolbox-segment-active'),
	                      onClick: function onClick(e) {
	                        return _this2.setState({ style: 'regular' }, _this2.updateImageData);
	                      }
	                    },
	                    'Center'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'figure-toolbox-segment-item ' + (style === 'right' && 'figure-toolbox-segment-active'),
	                      onClick: function onClick(e) {
	                        return _this2.setState({ style: 'right' }, _this2.updateImageData);
	                      }
	                    },
	                    'Right'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'figure-toolbox-segment-item ' + (style === 'full-width' && 'figure-toolbox-segment-active'),
	                      style: { float: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.1)', clear: 'both' },
	                      onClick: function onClick(e) {
	                        return _this2.setState({ style: 'full-width' }, _this2.updateImageData);
	                      }
	                    },
	                    'Full Width'
	                  )
	                )
	              ),
	              style !== 'full-width' && _react2.default.createElement(
	                'div',
	                { className: 'figure-toolbox-field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'figure-toolbox-label' },
	                  'Width (0 is default! Minimum 50px)'
	                ),
	                _react2.default.createElement('input', { className: 'figure-toolbox-input', type: 'number', value: width, onChange: function onChange(e) {
	                    return _this2.setState({ width: e.target.value }, _this2.updateImageData);
	                  } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'figure-toolbox-field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'figure-toolbox-label' },
	                  'Extra Classes'
	                ),
	                _react2.default.createElement('input', { className: 'figure-toolbox-input', value: extraClasses, onChange: function onChange(e) {
	                    return _this2.setState({ extraClasses: e.target.value }, _this2.updateImageData);
	                  } })
	              )
	            )
	          ),
	          caption && _react2.default.createElement(
	            'figcaption',
	            { contentEditable: false },
	            caption
	          )
	        );
	      } else if (entity.type === 'youtube') {
	        var urlData = (0, _urijs2.default)(src);
	        var v = void 0;
	        if (urlData.domain() === 'youtu.be') {
	          v = urlData.path().slice(1, -1);
	        } else if (urlData.domain() === 'youtube.com' && urlData.hasQuery('v')) {
	          v = urlData.query(true).v;
	        }
	        return _react2.default.createElement(
	          'figure',
	          null,
	          _react2.default.createElement(_reactYoutube2.default, {
	            videoId: v,
	            frameBorder: '0',
	            allowFullScreen: true
	          })
	        );
	      } else if (entity.type === 'tweet') {
	        var urlList = src.split('/');
	        var tweetId = urlList[urlList.length - 1];
	        return _react2.default.createElement(
	          'figure',
	          null,
	          _react2.default.createElement(_reactTweetEmbed2.default, { id: tweetId })
	        );
	      }
	    }
	  }]);
	
	  return EditorImage;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(EditorImage);
	
	
	EditorImage.propTypes = {
	  contentState: _propTypes2.default.object,
	  block: _propTypes2.default.object,
	  blockProps: _propTypes2.default.object
	};

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _browserImageSize = __webpack_require__(299);
	
	var _browserImageSize2 = _interopRequireDefault(_browserImageSize);
	
	var _reactSelect = __webpack_require__(175);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _SpinLoader = __webpack_require__(134);
	
	var _SpinLoader2 = _interopRequireDefault(_SpinLoader);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _constants = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorImageControls = function (_Component) {
	  _inherits(EditorImageControls, _Component);
	
	  function EditorImageControls(props) {
	    _classCallCheck(this, EditorImageControls);
	
	    var _this = _possibleConstructorReturn(this, (EditorImageControls.__proto__ || Object.getPrototypeOf(EditorImageControls)).call(this, props));
	
	    _this.togglePopover = _this.togglePopover.bind(_this);
	    _this.onFileUpload = _this.onFileUpload.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.onUrlChange = _this.onUrlChange.bind(_this);
	    _this.onCaptionChange = _this.onCaptionChange.bind(_this);
	    _this.state = {
	      show: false,
	      url: '',
	      caption: '',
	      style: 'regular',
	      alt: '',
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(EditorImageControls, [{
	    key: 'onFileUpload',
	    value: function onFileUpload(e) {
	      var _this2 = this;
	
	      var formData = new FormData();
	      formData.append('file', e.target.files[0]);
	      this.setState({ loading: true });
	      _BlitzAPI2.default.postEntryImage(formData).then(function (response) {
	        _this2.setState({
	          url: response.data.image_url,
	          loading: false
	        });
	      });
	    }
	  }, {
	    key: 'onUrlChange',
	    value: function onUrlChange(e) {
	      this.setState({
	        url: e.target.value
	      });
	    }
	  }, {
	    key: 'onCaptionChange',
	    value: function onCaptionChange(e) {
	      this.setState({
	        caption: e.target.value
	      });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this3 = this;
	
	      var _state = this.state,
	          url = _state.url,
	          caption = _state.caption,
	          style = _state.style,
	          alt = _state.alt;
	
	      if (url) {
	        (0, _browserImageSize2.default)(url).then(function (size) {
	          return _this3.props.onImageAdd(url, caption, style, alt, size);
	        });
	      }
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      e.preventDefault();
	      var editorState = this.props.editorState;
	
	      if (editorState) {
	        this.setState({
	          show: !this.state.show
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var container = this.props.container;
	      var _state2 = this.state,
	          loading = _state2.loading,
	          show = _state2.show,
	          url = _state2.url,
	          caption = _state2.caption,
	          alt = _state2.alt,
	          style = _state2.style;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls entry-editor-controls-single' },
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-editor-styleButton', onClick: this.togglePopover },
	          _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/editor/image.svg', role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Overlay,
	          {
	            container: container,
	            show: show,
	            onHide: function onHide() {
	              return _this4.setState({ show: false });
	            },
	            placement: 'top',
	            target: function target() {
	              return _this4.linkButton;
	            },
	            rootClose: true
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Popover,
	            { title: 'Add an image', id: 'link-creator-field' },
	            _react2.default.createElement(
	              'div',
	              { className: 'popover-image-section-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'popover-image-section' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'popover-image-url' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'url' },
	                    'Image URL'
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'url', name: 'url',
	                    value: url, onChange: this.onUrlChange,
	                    onKeyDown: this.onKeyDown,
	                    disabled: loading
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'popover-image-upload' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'file' },
	                    'Upload Image'
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'file', name: 'file',
	                    onChange: this.onFileUpload,
	                    disabled: loading
	                  })
	                ),
	                loading && _react2.default.createElement(_SpinLoader2.default, null)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'popover-image-section' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'popover-image-caption' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'caption' },
	                    'Caption'
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text', name: 'caption',
	                    value: caption, onChange: this.onCaptionChange,
	                    disabled: loading
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'popover-image-alt' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'alt' },
	                    'Alt Text'
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text', name: 'alt',
	                    value: alt, onChange: function onChange(e) {
	                      return _this4.setState({ alt: e.target.value });
	                    },
	                    disabled: loading
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'style' },
	              'Style'
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              name: 'style',
	              value: style,
	              options: _constants.EDITOR_IMAGE_OPTIONS,
	              onChange: function onChange(val) {
	                return _this4.setState({ style: val.value });
	              }
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'button', onClick: this.onSubmit, disabled: loading },
	              'Add Image'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditorImageControls;
	}(_react.Component);
	
	exports.default = EditorImageControls;
	
	
	EditorImageControls.propTypes = {
	  container: _propTypes2.default.object,
	  editorState: _propTypes2.default.object,
	  onImageAdd: _propTypes2.default.func
	};

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	__webpack_require__(1025);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorLink = function (_Component) {
	  _inherits(EditorLink, _Component);
	
	  function EditorLink(props) {
	    _classCallCheck(this, EditorLink);
	
	    var _this = _possibleConstructorReturn(this, (EditorLink.__proto__ || Object.getPrototypeOf(EditorLink)).call(this, props));
	
	    _this.onLinkButtonClick = _this.onLinkButtonClick.bind(_this);
	    _this.onUrlChange = _this.onUrlChange.bind(_this);
	    _this.togglePopover = _this.togglePopover.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.state = {
	      url: '',
	      show: false,
	      selection: null
	    };
	    return _this;
	  }
	
	  _createClass(EditorLink, [{
	    key: 'onLinkButtonClick',
	    value: function onLinkButtonClick() {
	      var onLinkCreate = this.props.onLinkCreate;
	      var url = this.state.url;
	
	      onLinkCreate(url);
	    }
	  }, {
	    key: 'onUrlChange',
	    value: function onUrlChange(e) {
	      this.setState({
	        url: e.target.value
	      });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      var onLinkCreate = this.props.onLinkCreate;
	      var url = this.state.url;
	
	      if (e.which === 13) {
	        e.preventDefault();
	        onLinkCreate(url);
	      }
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      e.preventDefault();
	      var editorState = this.props.editorState;
	      var show = this.state.show;
	
	      var selection = editorState.getSelection();
	      var hasSelection = !selection.isCollapsed();
	      if (editorState && hasSelection) {
	        this.setState({
	          show: !show
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          container = _props.container,
	          onLinkRemove = _props.onLinkRemove;
	      var _state = this.state,
	          show = _state.show,
	          url = _state.url;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls entry-editor-controls-single' },
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-editor-styleButton', onClick: this.togglePopover },
	          _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/editor/link.svg', role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-editor-styleButton', onClick: onLinkRemove },
	          _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/editor/unlink.svg', role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Overlay,
	          {
	            container: container,
	            show: show,
	            onHide: function onHide() {
	              return _this2.setState({ show: false });
	            },
	            placement: 'top',
	            target: function target() {
	              return _this2.linkButton;
	            },
	            rootClose: true
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Popover,
	            { title: 'Enter a link', id: 'link-creator-field' },
	            _react2.default.createElement('input', {
	              type: 'url', name: 'url',
	              value: url, onChange: this.onUrlChange,
	              onKeyDown: this.onKeyDown
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'button', onClick: this.onLinkButtonClick },
	              'Create Link'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditorLink;
	}(_react.Component);
	
	exports.default = EditorLink;
	
	
	EditorLink.propTypes = {
	  container: _propTypes2.default.object,
	  onLinkCreate: _propTypes2.default.func,
	  onLinkRemove: _propTypes2.default.func,
	  editorState: _propTypes2.default.object
	};

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactOnclickoutside = __webpack_require__(101);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorLinkDisplay = function (_Component) {
	  _inherits(EditorLinkDisplay, _Component);
	
	  function EditorLinkDisplay(props) {
	    _classCallCheck(this, EditorLinkDisplay);
	
	    var _this = _possibleConstructorReturn(this, (EditorLinkDisplay.__proto__ || Object.getPrototypeOf(EditorLinkDisplay)).call(this, props));
	
	    _this.state = {
	      focused: false
	    };
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditorLinkDisplay, [{
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      this.setState({ focused: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentState = _props.contentState,
	          entityKey = _props.entityKey,
	          children = _props.children;
	
	      var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
	          url = _contentState$getEnti.url;
	
	      var focused = this.state.focused;
	
	
	      return _react2.default.createElement(
	        'span',
	        {
	          onClick: function onClick() {
	            return _this2.setState({ focused: true });
	          },
	          style: { position: 'relative' }
	        },
	        _react2.default.createElement(
	          'a',
	          {
	            href: url,
	            target: '_blank',
	            rel: 'noreferrer noopener',
	            style: {
	              color: '#3b5998',
	              textDecoration: 'underline'
	            }
	          },
	          children
	        ),
	        focused && _react2.default.createElement(
	          'div',
	          { style: { position: 'absolute', display: 'block', left: '0' } },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'entry-editor-link-display clearfix',
	              contentEditable: false
	            },
	            _react2.default.createElement(
	              'a',
	              { href: url, target: '_blank', rel: 'noreferrer noopener' },
	              url
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditorLinkDisplay;
	}(_react.Component);
	
	EditorLinkDisplay.propTypes = {
	  contentState: _propTypes2.default.object,
	  entityKey: _propTypes2.default.string,
	  children: _propTypes2.default.any
	};
	
	exports.default = (0, _reactOnclickoutside2.default)(EditorLinkDisplay);

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorTweetEmbedControls = function (_Component) {
	  _inherits(EditorTweetEmbedControls, _Component);
	
	  function EditorTweetEmbedControls(props) {
	    _classCallCheck(this, EditorTweetEmbedControls);
	
	    var _this = _possibleConstructorReturn(this, (EditorTweetEmbedControls.__proto__ || Object.getPrototypeOf(EditorTweetEmbedControls)).call(this, props));
	
	    _this.state = {
	      show: false,
	      url: ''
	    };
	    _this.togglePopover = _this.togglePopover.bind(_this);
	    _this.onUrlChange = _this.onUrlChange.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditorTweetEmbedControls, [{
	    key: 'onUrlChange',
	    value: function onUrlChange(e) {
	      this.setState({
	        url: e.target.value
	      });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit() {
	      var url = this.state.url;
	      var onTweetAdd = this.props.onTweetAdd;
	
	      if (url) {
	        onTweetAdd(url);
	      }
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      var show = this.state.show;
	
	      e.preventDefault();
	      this.setState({
	        show: !show
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var container = this.props.container;
	      var _state = this.state,
	          show = _state.show,
	          url = _state.url;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls entry-editor-controls-single' },
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-editor-styleButton', onClick: this.togglePopover },
	          _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/editor/twitter.svg', role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Overlay,
	          {
	            container: container,
	            show: show,
	            onHide: function onHide() {
	              return _this2.setState({ show: false });
	            },
	            placement: 'top',
	            target: function target() {
	              return _this2.linkButton;
	            },
	            rootClose: true
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Popover,
	            { title: 'Enter tweet link', id: 'link-creator-field' },
	            _react2.default.createElement('input', {
	              type: 'url', name: 'url',
	              value: url, onChange: this.onUrlChange
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'button', onClick: this.onSubmit },
	              'Add Tweet Embed'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditorTweetEmbedControls;
	}(_react.Component);
	
	exports.default = EditorTweetEmbedControls;
	
	
	EditorTweetEmbedControls.propTypes = {
	  container: _propTypes2.default.object,
	  onTweetAdd: _propTypes2.default.func
	};

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorYoutubeEmbedControls = function (_Component) {
	  _inherits(EditorYoutubeEmbedControls, _Component);
	
	  function EditorYoutubeEmbedControls(props) {
	    _classCallCheck(this, EditorYoutubeEmbedControls);
	
	    var _this = _possibleConstructorReturn(this, (EditorYoutubeEmbedControls.__proto__ || Object.getPrototypeOf(EditorYoutubeEmbedControls)).call(this, props));
	
	    _this.state = {
	      show: false,
	      url: ''
	    };
	    _this.togglePopover = _this.togglePopover.bind(_this);
	    _this.onUrlChange = _this.onUrlChange.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditorYoutubeEmbedControls, [{
	    key: 'onUrlChange',
	    value: function onUrlChange(e) {
	      this.setState({
	        url: e.target.value
	      });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit() {
	      var url = this.state.url;
	      var onYoutubeAdd = this.props.onYoutubeAdd;
	
	      if (url) {
	        onYoutubeAdd(url);
	      }
	    }
	  }, {
	    key: 'togglePopover',
	    value: function togglePopover(e) {
	      var show = this.state.show;
	
	      e.preventDefault();
	      this.setState({
	        show: !show
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var container = this.props.container;
	      var _state = this.state,
	          show = _state.show,
	          url = _state.url;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls entry-editor-controls-single' },
	        _react2.default.createElement(
	          'div',
	          { className: 'entry-editor-styleButton', onClick: this.togglePopover },
	          _react2.default.createElement('img', { className: 'fit-parent', src: '/assets/img/icons/editor/youtube.svg', role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Overlay,
	          {
	            container: container,
	            show: show,
	            onHide: function onHide() {
	              return _this2.setState({ show: false });
	            },
	            placement: 'top',
	            target: function target() {
	              return _this2.linkButton;
	            },
	            rootClose: true
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Popover,
	            { title: 'Enter youtube link', id: 'link-creator-field' },
	            _react2.default.createElement('input', {
	              type: 'url', name: 'url',
	              value: url, onChange: this.onUrlChange
	            }),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { type: 'button', onClick: this.onSubmit },
	              'Add Youtube Embed'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditorYoutubeEmbedControls;
	}(_react.Component);
	
	exports.default = EditorYoutubeEmbedControls;
	
	
	EditorYoutubeEmbedControls.propTypes = {
	  container: _propTypes2.default.object,
	  onYoutubeAdd: _propTypes2.default.func
	};

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleButton = __webpack_require__(186);
	
	var _StyleButton2 = _interopRequireDefault(_StyleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HEADING_TYPES = [{ label: 'H1', style: 'header-one', icon: '/assets/img/icons/editor/h1.svg' }, { label: 'H2', style: 'header-two', icon: '/assets/img/icons/editor/h2.svg' }, { label: 'H3', style: 'header-three', icon: '/assets/img/icons/editor/h3.svg' }];
	
	var BlockStyleControls = function (_Component) {
	  _inherits(BlockStyleControls, _Component);
	
	  function BlockStyleControls() {
	    _classCallCheck(this, BlockStyleControls);
	
	    return _possibleConstructorReturn(this, (BlockStyleControls.__proto__ || Object.getPrototypeOf(BlockStyleControls)).apply(this, arguments));
	  }
	
	  _createClass(BlockStyleControls, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var editorState = this.props.editorState;
	
	      var selection = editorState.getSelection();
	      var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls' },
	        HEADING_TYPES.map(function (type) {
	          return _react2.default.createElement(_StyleButton2.default, {
	            key: type.label,
	            active: type.style === blockType,
	            label: type.label,
	            icon: type.icon,
	            onToggle: _this2.props.onToggle,
	            style: type.style
	          });
	        })
	      );
	    }
	  }]);
	
	  return BlockStyleControls;
	}(_react.Component);
	
	exports.default = BlockStyleControls;
	
	
	BlockStyleControls.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  editorState: _propTypes2.default.object.isRequired
	};

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleButton = __webpack_require__(186);
	
	var _StyleButton2 = _interopRequireDefault(_StyleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INLINE_STYLES = [{ label: 'Bold', style: 'BOLD', icon: '/assets/img/icons/editor/bold.svg' }, { label: 'Italic', style: 'ITALIC', icon: '/assets/img/icons/editor/italic.svg' }, { label: 'Underline', style: 'UNDERLINE', icon: '/assets/img/icons/editor/underline.svg' }];
	
	var InlineStyleControls = function (_Component) {
	  _inherits(InlineStyleControls, _Component);
	
	  function InlineStyleControls() {
	    _classCallCheck(this, InlineStyleControls);
	
	    return _possibleConstructorReturn(this, (InlineStyleControls.__proto__ || Object.getPrototypeOf(InlineStyleControls)).apply(this, arguments));
	  }
	
	  _createClass(InlineStyleControls, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var currentStyle = this.props.editorState.getCurrentInlineStyle();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'entry-editor-controls' },
	        INLINE_STYLES.map(function (type) {
	          return _react2.default.createElement(_StyleButton2.default, {
	            key: type.label,
	            active: currentStyle.has(type.style),
	            label: type.label,
	            icon: type.icon,
	            onToggle: _this2.props.onToggle,
	            style: type.style
	          });
	        })
	      );
	    }
	  }]);
	
	  return InlineStyleControls;
	}(_react.Component);
	
	exports.default = InlineStyleControls;
	
	
	InlineStyleControls.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  editorState: _propTypes2.default.object.isRequired
	};

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _PushNotificationsForm = __webpack_require__(829);
	
	var _PushNotificationsForm2 = _interopRequireDefault(_PushNotificationsForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function trStyleFormat(row) {
	  var outClass = void 0;
	  switch (row.type) {
	    case 'feed':
	      outClass = 'entry-table-feed';
	      break;
	    case 'youtube':
	      outClass = 'entry-table-video';
	      break;
	    default:
	      outClass = 'entry-table-default';
	  }
	  return outClass;
	}
	
	var PushNotifications = function (_Component) {
	  _inherits(PushNotifications, _Component);
	
	  function PushNotifications(props) {
	    _classCallCheck(this, PushNotifications);
	
	    var _this = _possibleConstructorReturn(this, (PushNotifications.__proto__ || Object.getPrototypeOf(PushNotifications)).call(this, props));
	
	    _this.state = {
	      data: null,
	      initialValues: null
	    };
	    _this.onRowClick = _this.onRowClick.bind(_this);
	    _this.sendPushNotification = _this.sendPushNotification.bind(_this);
	    return _this;
	  }
	
	  _createClass(PushNotifications, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getEntries({ published: true, type: 'feed,youtube,article' }).then(function (resp) {
	        return _this2.setState({ data: resp.data.data });
	      });
	    }
	  }, {
	    key: 'onRowClick',
	    value: function onRowClick(row) {
	      var changeFormValue = this.props.changeFormValue;
	
	      changeFormValue('message', row.title);
	      changeFormValue('entry', row);
	    }
	  }, {
	    key: 'sendPushNotification',
	    value: function sendPushNotification(values) {
	      if (confirm('About to send a push notification')) {
	        _BlitzAPI2.default.sendPushNotification({ notification: values }).then(function (response) {
	          return console.log(response);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(_PushNotificationsForm2.default, { onSubmit: this.sendPushNotification })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8' },
	          this.state.data ? _react2.default.createElement(
	            _reactBootstrapTable.BootstrapTable,
	            {
	              data: this.state.data,
	              remote: true, striped: true, hover: true,
	              trClassName: trStyleFormat,
	              options: { onRowClick: this.onRowClick }
	            },
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              { isKey: true, dataField: 'id', width: '70' },
	              'Entry ID'
	            ),
	            _react2.default.createElement(
	              _reactBootstrapTable.TableHeaderColumn,
	              { dataField: 'title' },
	              'Title'
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return PushNotifications;
	}(_react.Component);
	
	PushNotifications.propTypes = {
	  changeFormValue: _propTypes2.default.func
	};
	
	function mapStateToProps(state) {
	  return {};
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    changeFormValue: function changeFormValue(field, value) {
	      dispatch((0, _reduxForm.change)('push_notifications', field, value));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PushNotifications);

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _BasicFormInput = __webpack_require__(64);
	
	var _BasicFormInput2 = _interopRequireDefault(_BasicFormInput);
	
	var _FormSelect = __webpack_require__(107);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _constants = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PushNotificationsForm = function (_Component) {
	  _inherits(PushNotificationsForm, _Component);
	
	  function PushNotificationsForm(props) {
	    _classCallCheck(this, PushNotificationsForm);
	
	    var _this = _possibleConstructorReturn(this, (PushNotificationsForm.__proto__ || Object.getPrototypeOf(PushNotificationsForm)).call(this, props));
	
	    _this.formatEntry = _this.formatEntry.bind(_this);
	    _this.parseEntryId = _this.parseEntryId.bind(_this);
	    return _this;
	  }
	
	  _createClass(PushNotificationsForm, [{
	    key: 'formatEntry',
	    value: function formatEntry(value, name) {
	      return value ? value.id : '';
	    }
	  }, {
	    key: 'parseEntryId',
	    value: function parseEntryId(value, name) {
	      return { id: Number(value) };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          onSubmit = _props.onSubmit;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(onSubmit) },
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'text',
	          label: 'Message',
	          name: 'message',
	          component: _BasicFormInput2.default
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          label: 'Game',
	          name: 'game',
	          component: _FormSelect2.default,
	          options: _constants.GAME_OPTIONS
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          label: 'Spoilers',
	          name: 'spoilers',
	          component: _FormSelect2.default,
	          options: _constants.SPOILER_OPTIONS
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          label: 'Entry ID',
	          name: 'entry',
	          type: 'number',
	          component: _BasicFormInput2.default,
	          format: this.formatEntry,
	          parse: this.parseEntryId
	        }),
	        _react2.default.createElement(_reduxForm.Field, {
	          type: 'checkbox',
	          name: 'chat',
	          placeholder: 'Send to Chat',
	          normalize: function normalize(v) {
	            return !!v;
	          },
	          component: _BasicFormInput2.default,
	          controlId: 'chat',
	          label: 'Sent to Chat'
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { type: 'submit' },
	          'Send push notification'
	        )
	      );
	    }
	  }]);
	
	  return PushNotificationsForm;
	}(_react.Component);
	
	PushNotificationsForm.propTypes = {
	  handleSubmit: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func
	};
	
	function mapStateToProps(state) {
	  return {
	    initialValues: {
	      spoilers: _constants.SPOILER_OPTIONS[0][0],
	      game: _constants.GAME_OPTIONS[0][0]
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({ form: 'push_notifications' })(PushNotificationsForm));

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _SourceForm = __webpack_require__(296);
	
	var _SourceForm2 = _interopRequireDefault(_SourceForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SourceCreate = function (_Component) {
	  _inherits(SourceCreate, _Component);
	
	  function SourceCreate(props) {
	    _classCallCheck(this, SourceCreate);
	
	    var _this = _possibleConstructorReturn(this, (SourceCreate.__proto__ || Object.getPrototypeOf(SourceCreate)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(SourceCreate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.postSource({ source: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/sources');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Create a new source'
	        ),
	        _react2.default.createElement(_SourceForm2.default, { onSubmit: this.handleSubmit })
	      );
	    }
	  }]);
	
	  return SourceCreate;
	}(_react.Component);
	
	exports.default = SourceCreate;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _SourceForm = __webpack_require__(296);
	
	var _SourceForm2 = _interopRequireDefault(_SourceForm);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SourceEdit = function (_Component) {
	  _inherits(SourceEdit, _Component);
	
	  function SourceEdit(props) {
	    _classCallCheck(this, SourceEdit);
	
	    var _this = _possibleConstructorReturn(this, (SourceEdit.__proto__ || Object.getPrototypeOf(SourceEdit)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.state = {
	      source: null
	    };
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(SourceEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getSource(this.props.params.sourceId).then(function (response) {
	        return _this2.setState({ source: response.data.data });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.patchSource(this.props.params.sourceId, { source: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/sources');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.source) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Loading'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Edit Source'
	        ),
	        _react2.default.createElement(_SourceForm2.default, { onSubmit: this.handleSubmit, initialValues: this.state.source })
	      );
	    }
	  }]);
	
	  return SourceEdit;
	}(_react.Component);
	
	SourceEdit.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouter.withRouter)(SourceEdit);

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _SourceListTable = __webpack_require__(833);
	
	var _SourceListTable2 = _interopRequireDefault(_SourceListTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SourceList = function (_Component) {
	  _inherits(SourceList, _Component);
	
	  function SourceList() {
	    _classCallCheck(this, SourceList);
	
	    return _possibleConstructorReturn(this, (SourceList.__proto__ || Object.getPrototypeOf(SourceList)).apply(this, arguments));
	  }
	
	  _createClass(SourceList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouterBootstrap.LinkContainer,
	          { to: '/sources/create' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            null,
	            'Create Source'
	          )
	        ),
	        _react2.default.createElement(_SourceListTable2.default, null)
	      );
	    }
	  }]);
	
	  return SourceList;
	}(_react.Component);
	
	exports.default = SourceList;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _constants = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cellEditProp = {
	  mode: 'dbclick',
	  blurToSave: true
	};
	
	function sourceDataFormat(cell) {
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/sources/' + cell },
	    _react2.default.createElement(
	      'div',
	      null,
	      cell
	    )
	  );
	}
	
	var SourceListTable = function (_Component) {
	  _inherits(SourceListTable, _Component);
	
	  function SourceListTable(props) {
	    _classCallCheck(this, SourceListTable);
	
	    var _this = _possibleConstructorReturn(this, (SourceListTable.__proto__ || Object.getPrototypeOf(SourceListTable)).call(this, props));
	
	    _this.state = {
	      data: null
	    };
	    _this.onCellEdit = _this.onCellEdit.bind(_this);
	    return _this;
	  }
	
	  _createClass(SourceListTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getSources().then(function (resp) {
	        return _this2.setState({ data: resp.data.data });
	      });
	    }
	  }, {
	    key: 'onCellEdit',
	    value: function onCellEdit(row, fieldName, value) {
	      var data = this.state.data;
	
	      var rowIndex = void 0;
	      var targetRow = data.find(function (currentRow, index) {
	        if (currentRow.id === row.id) {
	          rowIndex = index;
	          return true;
	        }
	        return false;
	      });
	
	      if (targetRow && targetRow[fieldName] !== value) {
	        targetRow[fieldName] = value;
	        data[rowIndex] = targetRow;
	        var sourceParams = {};
	        sourceParams[fieldName] = value;
	        _BlitzAPI2.default.patchSource(row.id, { source: sourceParams }).then(function (response) {
	          return console.log(response);
	        });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.data ? _react2.default.createElement(
	        _reactBootstrapTable.BootstrapTable,
	        {
	          data: this.state.data,
	          remote: true, striped: true, hover: true,
	          cellEdit: cellEditProp,
	          options: { onCellEdit: this.onCellEdit }
	        },
	        _react2.default.createElement(
	          _reactBootstrapTable.TableHeaderColumn,
	          { isKey: true, dataField: 'id', dataFormat: sourceDataFormat },
	          'Source ID'
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.TableHeaderColumn,
	          { dataField: 'name' },
	          'Name'
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.TableHeaderColumn,
	          {
	            dataField: 'type',
	            editable: { type: 'select', options: { values: _constants.SOURCE_TABLE_TYPE_OPTIONS } }
	          },
	          'Type'
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.TableHeaderColumn,
	          { dataField: 'url' },
	          'URL'
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return SourceListTable;
	}(_react.Component);
	
	exports.default = SourceListTable;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(175);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _chart = __webpack_require__(860);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LeagueAPI = __webpack_require__(786);
	
	var _LeagueAPI2 = _interopRequireDefault(_LeagueAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsQueryHome = function (_Component) {
	  _inherits(StatsQueryHome, _Component);
	
	  function StatsQueryHome(props) {
	    _classCallCheck(this, StatsQueryHome);
	
	    var _this = _possibleConstructorReturn(this, (StatsQueryHome.__proto__ || Object.getPrototypeOf(StatsQueryHome)).call(this, props));
	
	    _this.getPlayerOptions = _this.getPlayerOptions.bind(_this);
	    _this.getTeamOptions = _this.getTeamOptions.bind(_this);
	    _this.getTournamentOptions = _this.getTournamentOptions.bind(_this);
	    _this.getSeriesOptions = _this.getSeriesOptions.bind(_this);
	    _this.generateTable = _this.generateTable.bind(_this);
	    _this.state = {
	      player: null,
	      team: null,
	      series: null,
	      tournament: null
	    };
	    return _this;
	  }
	
	  _createClass(StatsQueryHome, [{
	    key: 'getPlayerOptions',
	    value: function getPlayerOptions(input) {
	      return _LeagueAPI2.default.getPlayerAutocomplete({ search: input }).then(function (resp) {
	        var options = resp.data.results.map(function (p) {
	          return { value: p.id, label: p.ign };
	        });
	        return { options: options };
	      });
	    }
	  }, {
	    key: 'getTeamOptions',
	    value: function getTeamOptions(input) {
	      return _LeagueAPI2.default.getTeamAutocomplete({ search: input }).then(function (resp) {
	        var options = resp.data.results.map(function (p) {
	          return { value: p.id, label: p.name };
	        });
	        return { options: options };
	      });
	    }
	  }, {
	    key: 'getTournamentOptions',
	    value: function getTournamentOptions(input) {
	      return _LeagueAPI2.default.getTournamentAutocomplete({ search: input }).then(function (resp) {
	        var options = resp.data.results.map(function (p) {
	          return { value: p.id, label: p.name };
	        });
	        return { options: options };
	      });
	    }
	  }, {
	    key: 'getSeriesOptions',
	    value: function getSeriesOptions(input) {
	      return _LeagueAPI2.default.getSeriesAutocomplete({ search: input }).then(function (resp) {
	        var options = resp.data.results.map(function (p) {
	          return { value: p.id, label: p.name };
	        });
	        return { options: options };
	      });
	    }
	  }, {
	    key: 'generateTable',
	    value: function generateTable() {
	      // This should generate a table based on the filters above.
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          player = _state.player,
	          team = _state.team,
	          tournament = _state.tournament,
	          series = _state.series;
	
	      console.log(player);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Stats Query'
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Player Filter'
	        ),
	        _react2.default.createElement(_reactSelect.Async, {
	          loadOptions: this.getPlayerOptions,
	          value: player,
	          onChange: function onChange(val) {
	            return _this2.setState({ player: val && val.value });
	          },
	          disabled: team
	        }),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Team Filter'
	        ),
	        _react2.default.createElement(_reactSelect.Async, {
	          loadOptions: this.getTeamOptions,
	          value: team,
	          disabled: player,
	          onChange: function onChange(val) {
	            return _this2.setState({ team: val && val.value });
	          }
	        }),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Series Filter'
	        ),
	        _react2.default.createElement(_reactSelect.Async, {
	          loadOptions: this.getSeriesOptions,
	          value: series,
	          disabled: tournament,
	          onChange: function onChange(val) {
	            return _this2.setState({ series: val && val.value });
	          }
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { onClick: this.generateTable },
	          'Generate Table'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { onClick: this.generateGraph },
	          'Generate Graph'
	        )
	      );
	    }
	  }]);
	
	  return StatsQueryHome;
	}(_react.Component);
	
	StatsQueryHome.propTypes = {};
	StatsQueryHome.defaultProps = {};
	
	exports.default = StatsQueryHome;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _TagForm = __webpack_require__(297);
	
	var _TagForm2 = _interopRequireDefault(_TagForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagCreate = function (_Component) {
	  _inherits(TagCreate, _Component);
	
	  function TagCreate(props) {
	    _classCallCheck(this, TagCreate);
	
	    var _this = _possibleConstructorReturn(this, (TagCreate.__proto__ || Object.getPrototypeOf(TagCreate)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagCreate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.postTag({ tag: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/tags');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Create a new tag'
	        ),
	        _react2.default.createElement(_TagForm2.default, { onSubmit: this.handleSubmit })
	      );
	    }
	  }]);
	
	  return TagCreate;
	}(_react.Component);
	
	exports.default = TagCreate;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _TagForm = __webpack_require__(297);
	
	var _TagForm2 = _interopRequireDefault(_TagForm);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagEdit = function (_Component) {
	  _inherits(TagEdit, _Component);
	
	  function TagEdit(props) {
	    _classCallCheck(this, TagEdit);
	
	    var _this = _possibleConstructorReturn(this, (TagEdit.__proto__ || Object.getPrototypeOf(TagEdit)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.state = {
	      tag: null
	    };
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getTag(this.props.params.tagId).then(function (response) {
	        return _this2.setState({ tag: response.data.data });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.patchTag(this.props.params.tagId, { tag: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/tags');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.tag) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Loading'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Edit Tag'
	        ),
	        _react2.default.createElement(_TagForm2.default, { onSubmit: this.handleSubmit, initialValues: this.state.tag })
	      );
	    }
	  }]);
	
	  return TagEdit;
	}(_react.Component);
	
	TagEdit.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouter.withRouter)(TagEdit);

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _TagListTable = __webpack_require__(838);
	
	var _TagListTable2 = _interopRequireDefault(_TagListTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagList = function (_Component) {
	  _inherits(TagList, _Component);
	
	  function TagList() {
	    _classCallCheck(this, TagList);
	
	    return _possibleConstructorReturn(this, (TagList.__proto__ || Object.getPrototypeOf(TagList)).apply(this, arguments));
	  }
	
	  _createClass(TagList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouterBootstrap.LinkContainer,
	          { to: '/tags/create' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            null,
	            'Create Tag'
	          )
	        ),
	        _react2.default.createElement(_TagListTable2.default, null)
	      );
	    }
	  }]);
	
	  return TagList;
	}(_react.Component);
	
	exports.default = TagList;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cellEditProp = {
	  mode: 'dbclick',
	  blurToSave: true
	};
	
	function tagDataFormat(cell) {
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/tags/' + cell },
	    _react2.default.createElement(
	      'div',
	      null,
	      cell
	    )
	  );
	}
	
	var TagListTable = function (_Component) {
	  _inherits(TagListTable, _Component);
	
	  function TagListTable(props) {
	    _classCallCheck(this, TagListTable);
	
	    var _this = _possibleConstructorReturn(this, (TagListTable.__proto__ || Object.getPrototypeOf(TagListTable)).call(this, props));
	
	    var query = {
	      ordering: 'id'
	    };
	    _this.state = {
	      data: null,
	      query: query,
	      search: ''
	    };
	    _this.onCellEdit = _this.onCellEdit.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    _this.onSearchChange = _this.onSearchChange.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagListTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      var query = this.state.query;
	
	      _BlitzAPI2.default.getTags(query).then(function (resp) {
	        _this2.setState({
	          data: resp.data.data
	        });
	      });
	    }
	  }, {
	    key: 'onCellEdit',
	    value: function onCellEdit(row, fieldName, value) {
	      var data = this.state.data;
	
	      var rowIndex = void 0;
	      var targetRow = data.find(function (currentRow, index) {
	        if (currentRow.id === row.id) {
	          rowIndex = index;
	          return true;
	        }
	        return false;
	      });
	
	      if (targetRow && targetRow[fieldName] !== value) {
	        targetRow[fieldName] = value;
	        data[rowIndex] = targetRow;
	        var sourceParams = {};
	        sourceParams[fieldName] = value;
	        _BlitzAPI2.default.patchTag(row.id, { tag: sourceParams }).then(function (response) {
	          return console.log(response);
	        });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(e) {
	      this.setState({ search: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.name;
	      } else {
	        query = Object.assign({}, query, { name: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(sortName, sortOrder) {
	      var sorting = sortOrder === 'asc' ? sortName : '-' + sortName;
	      var query = Object.assign({}, this.state.query, { order_by: sorting });
	      this.setState({
	        query: query
	      }, this.getData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          search = _state.search;
	
	
	      return data ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            null,
	            'Search'
	          ),
	          _react2.default.createElement('input', { value: search, onChange: this.onSearchChange })
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.BootstrapTable,
	          {
	            data: this.state.data,
	            remote: true, striped: true, hover: true,
	            cellEdit: cellEditProp,
	            options: {
	              onCellEdit: this.onCellEdit,
	              onSortChange: this.onSortChange
	            }
	          },
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            {
	              isKey: true, dataField: 'id', dataFormat: tagDataFormat, dataSort: true
	            },
	            'Tag ID'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'name', dataSort: true },
	            'Name'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'priority', dataSort: true },
	            'Priority'
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return TagListTable;
	}(_react.Component);
	
	exports.default = TagListTable;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(106);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _champions = __webpack_require__(1040);
	
	var _champions2 = _interopRequireDefault(_champions);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChampionTips = function (_Component) {
	  _inherits(ChampionTips, _Component);
	
	  function ChampionTips(props) {
	    _classCallCheck(this, ChampionTips);
	
	    var _this = _possibleConstructorReturn(this, (ChampionTips.__proto__ || Object.getPrototypeOf(ChampionTips)).call(this, props));
	
	    _this.state = {
	      champions: null,
	      patch: 8.4,
	      allData: []
	    };
	    return _this;
	  }
	
	  _createClass(ChampionTips, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _axios2.default.get('https://beta.iesdev.com/api/lolstats/patches/latest').then(function (response) {
	        return response.data.data.patch;
	      }).then(function (patch) {
	        _this2.setState({ patch: patch });
	        return _axios2.default.get("https://beta.iesdev.com/api/ddragon/" + patch + ".1/data/en_US/champion.json");
	      }).then(function (response) {
	        var champions = response.data.data;
	        _this2.setState({ champions: champions });
	      });
	
	      _axios2.default.get('https://beta.iesdev.com/api/championtips/').then(function (response) {
	        _this2.setState({ allData: response.data.data });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          champions = _state.champions,
	          allData = _state.allData;
	
	      if (!champions) return _react2.default.createElement(
	        "h1",
	        null,
	        "Loading"
	      );
	      var i = 0;
	      var keys = Object.keys(champions);
	      var columns = [];
	      while (i + 7 < keys.length) {
	        columns.push(keys.slice(i, i + 7));
	        i = i + 7;
	      }
	      columns.push(keys.slice(i));
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            flexDirection: "column"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          { style: { paddingLeft: 16 } },
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: 36, fontWeight: "bold" } },
	            "Champion Insights"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: 14, color: "rgba(0, 0, 0, 0.5)" } },
	            "Create and edit champion insight tips for Blitz desktop app"
	          )
	        ),
	        columns.map(function (rows) {
	          return _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                flexDirection: "row"
	              }
	            },
	            rows.map(function (row) {
	              var champion = champions[row];
	
	              var tip = allData.find(function (n) {
	                return n.champion_id.toString() === champion.key;
	              });
	
	              return _react2.default.createElement(
	                _reactRouterBootstrap.LinkContainer,
	                { to: "/championtips/" + champion.key },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: {
	                      display: "flex",
	                      flexDirection: "column",
	                      cursor: "pointer",
	                      width: 120,
	                      paddingTop: 16,
	                      paddingBottom: 16,
	                      alignItems: "center"
	                    }
	                  },
	                  _react2.default.createElement("img", {
	                    style: { width: 64, height: 64, borderRadius: 4 },
	                    src: "http://ddragon.leagueoflegends.com/cdn/" + _this3.state.patch + ".1/img/champion/" + row + ".png"
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { fontSize: 14, fontWeight: "bold" } },
	                    champion.name
	                  ),
	                  tip && _react2.default.createElement(
	                    "div",
	                    { style: { fontSize: 14, fontWeight: "bold", color: 'red' } },
	                    tip.last_updated_patch
	                  )
	                )
	              );
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ChampionTips;
	}(_react.Component);
	
	exports.default = ChampionTips;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactSortableHoc = __webpack_require__(1466);
	
	var _dragHandle = __webpack_require__(1406);
	
	var _dragHandle2 = _interopRequireDefault(_dragHandle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderField = function renderField(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      type = _ref.type,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      null,
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('input', Object.assign({}, input, { type: type, placeholder: label })),
	      touched && error && _react2.default.createElement(
	        'span',
	        null,
	        error
	      )
	    )
	  );
	};
	
	var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref2) {
	  var member = _ref2.member,
	      index = _ref2.index,
	      fields = _ref2.fields;
	  return _react2.default.createElement(
	    'div',
	    { style: { display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center' } },
	    _react2.default.createElement(_dragHandle2.default, { color: 'rgba(0,0,0,0.1)', size: 24, style: { marginRight: 12 } }),
	    _react2.default.createElement(_reduxForm.Field, { name: member + '.value', style: { width: 720, fontSize: 12 }, type: 'text', component: 'textarea', placeholder: 'description' })
	  );
	});
	
	var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref3) {
	  var items = _ref3.items;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    items.map(function (member, index) {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 12 }, key: 'item-' + index },
	        _react2.default.createElement(SortableItem, { index: index, member: member, fields: items }),
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: 12, marginLeft: 16, cursor: 'pointer', color: 'red' }, onClick: function onClick() {
	              return items.remove(index);
	            } },
	          'delete'
	        )
	      );
	    })
	  );
	});
	
	var renderMembers = function renderMembers(_ref4) {
	  var fields = _ref4.fields,
	      _ref4$meta = _ref4.meta,
	      touched = _ref4$meta.touched,
	      error = _ref4$meta.error;
	
	  var onSortEnd = function onSortEnd(_ref5) {
	    var oldIndex = _ref5.oldIndex,
	        newIndex = _ref5.newIndex;
	
	    fields.swap(oldIndex, newIndex);
	    (0, _reactSortableHoc.arrayMove)(fields, oldIndex, newIndex);
	  };
	  return _react2.default.createElement(
	    'div',
	    { style: { display: 'flex', flexDirection: 'column' } },
	    _react2.default.createElement(SortableList, { items: fields, onSortEnd: onSortEnd }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: 12, fontWeight: 'bold', cursor: 'pointer', color: 'rgba(51, 163, 243, 1)' }, onClick: function onClick() {
	            return fields.push({});
	          } },
	        '+ add item'
	      ),
	      touched && error && _react2.default.createElement(
	        'span',
	        null,
	        error
	      )
	    )
	  );
	};
	
	var TipsForm = function TipsForm(props) {
	  var handleSubmit = props.handleSubmit,
	      pristine = props.pristine,
	      reset = props.reset,
	      submitting = props.submitting;
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit, style: { paddingTop: 48 } },
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: 48 } },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: 12, fontWeight: 'bold' } },
	        'Insights'
	      ),
	      _react2.default.createElement(_reduxForm.FieldArray, { name: 'insights', component: renderMembers })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: 48 } },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: 12, fontWeight: 'bold' } },
	        'Strengths'
	      ),
	      _react2.default.createElement(_reduxForm.FieldArray, { name: 'strengths', component: renderMembers })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: 48 } },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: 12, fontWeight: 'bold' } },
	        'Weaknesses'
	      ),
	      _react2.default.createElement(_reduxForm.FieldArray, { name: 'weaknesses', component: renderMembers })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'submit',
	          disabled: submitting,
	          style: {
	            marginRight: 8,
	            paddingTop: 6,
	            paddingBottom: 6,
	            paddingLeft: 12,
	            paddingRight: 12,
	            backgroundColor: 'rgba(38, 194, 129, 1)',
	            borderRadius: 4,
	            color: 'white',
	            fontSize: 14
	          }
	        },
	        'Save'
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          onClick: function onClick() {
	            handleSubmit().then(function () {
	              _reactRouter.browserHistory.push('/championtips');
	            });
	          },
	          disabled: submitting,
	          style: {
	            marginRight: 8,
	            paddingTop: 6,
	            paddingBottom: 6,
	            paddingLeft: 12,
	            paddingRight: 12,
	            backgroundColor: 'rgba(38, 194, 129, 1)',
	            borderRadius: 4,
	            color: 'white',
	            fontSize: 14
	          }
	        },
	        'Save and go back'
	      )
	    )
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'tips',
	  enableReinitialize: true,
	  destroyOnUnmount: false
	})(TipsForm);

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _ChampionTipsForm = __webpack_require__(840);
	
	var _ChampionTipsForm2 = _interopRequireDefault(_ChampionTipsForm);
	
	var _axios = __webpack_require__(106);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChampionTipsItem = function (_Component) {
	  _inherits(ChampionTipsItem, _Component);
	
	  function ChampionTipsItem(props) {
	    _classCallCheck(this, ChampionTipsItem);
	
	    var _this = _possibleConstructorReturn(this, (ChampionTipsItem.__proto__ || Object.getPrototypeOf(ChampionTipsItem)).call(this, props));
	
	    _this.state = {
	      champions: null,
	      patch: 8.4,
	      data: null,
	      date: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(ChampionTipsItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var id = this.props.params.id;
	
	      _axios2.default.get('https://beta.iesdev.com/api/lolstats/patches/latest').then(function (response) {
	        return response.data.data.patch;
	      }).then(function (patch) {
	        _this2.setState({ patch: patch });
	        return _axios2.default.get('https://beta.iesdev.com/api/ddragon/' + patch + '.1/data/en_US/champion.json');
	      }).then(function (response) {
	        _this2.setState({ champions: response.data.data });
	      });
	      _axios2.default.get('https://beta.iesdev.com/api/championtips/' + id).then(function (response) {
	        _this2.setState({ data: response.data.data });
	      }).catch(function (error) {
	        _this2.setState({ data: {} });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var id = this.props.params.id;
	      var _state = this.state,
	          champions = _state.champions,
	          patch = _state.patch,
	          data = _state.data,
	          date = _state.date,
	          error = _state.error;
	
	      if (!champions || !data) return _react2.default.createElement(
	        'h1',
	        null,
	        'loading'
	      );
	      var keys = Object.keys(champions);
	      var key = keys.find(function (key) {
	        return champions[key].key === id;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: { marginTop: 50, marginBottom: 50 } },
	        _react2.default.createElement(
	          'div',
	          { style: { flexDirection: 'row', display: 'flex', alignItems: 'center' } },
	          _react2.default.createElement('img', {
	            style: { width: 64, height: 64, borderRadius: 4, marginRight: 12 },
	            src: 'http://ddragon.leagueoflegends.com/cdn/' + this.state.patch + '.1/img/champion/' + key + '.png'
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: 24, fontWeight: 'bold' } },
	              champions[key].name
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: 14 } },
	              'Previous Edit: ',
	              data.last_updated_patch || 'Never'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: 14, color: 'rgba(0,0,0,0.5)' } },
	              'Patch on PBE: ',
	              patch
	            )
	          )
	        ),
	        _react2.default.createElement(_ChampionTipsForm2.default, { initialValues: data.tips || {}, onSubmit: function onSubmit(item) {
	            var insights = item.insights;
	            var strengths = item.strengths;
	            var weaknesses = item.weaknesses;
	            var tips = { insights: insights, strengths: strengths, weaknesses: weaknesses };
	            var champion_tip = { tips: tips, last_updated_patch: patch, champion_id: id };
	            console.log(champion_tip);
	            return _axios2.default.patch('https://beta.iesdev.com/api/championtips/' + id, { champion_tip: champion_tip }).then(function (response) {
	              _this3.setState({ data: response.data.data, date: (0, _moment2.default)() });
	            }).catch(function (error) {
	              _this3.setState({ error: error });
	            });
	          } }),
	        date && _react2.default.createElement(
	          'div',
	          { style: { fontSize: 14, color: 'rgba(0,0,0,0.5)', marginTop: 8 } },
	          'Saved on ',
	          date.format('MMMM Do YYYY, h:mm:ss a')
	        ),
	        error && _react2.default.createElement(
	          'div',
	          { style: { fontSize: 14, color: 'rgba(0,0,0,0.5)', marginTop: 8 } },
	          'Issue with Saving. Contact Jonathan Lin Plox'
	        )
	      );
	    }
	  }]);
	
	  return ChampionTipsItem;
	}(_react.Component);
	
	exports.default = ChampionTipsItem;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function StatItem(props) {
	  var caption = props.caption,
	      data = props.data,
	      title = props.title;
	
	
	  var formattedData = data && data < 1 ? (data * 100).toPrecision(2) + '%' : data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'dashboard-stat-item ' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'dashboard-stat-content clearfix' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'dashboard-stat-number' },
	        formattedData
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'dashboard-stat-caption' },
	      caption
	    )
	  );
	}
	
	var AppTrackingDashboard = function (_Component) {
	  _inherits(AppTrackingDashboard, _Component);
	
	  function AppTrackingDashboard(props) {
	    _classCallCheck(this, AppTrackingDashboard);
	
	    var _this = _possibleConstructorReturn(this, (AppTrackingDashboard.__proto__ || Object.getPrototypeOf(AppTrackingDashboard)).call(this, props));
	
	    _this.state = {
	      data: null
	    };
	    return _this;
	  }
	
	  _createClass(AppTrackingDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getStatsOverview().then(function (resp) {
	        return _this2.setState({ data: resp.data });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dashboard' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Tracking Dashboard'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'page-title dashboard-title' },
	          'Last Week Stats'
	        ),
	        data && _react2.default.createElement(
	          'div',
	          { className: 'dashboard-stat clearfix' },
	          _react2.default.createElement(StatItem, {
	            title: 'Last Week Average Ratio',
	            data: data.last_week_average_ratio,
	            caption: 'Average ratio of all users last week.'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Last Week Tracked Once Ratio',
	            data: data.last_week_tracked_once_ratio,
	            caption: 'Ratio of all users who have been tracked at least once (used the app once) in the last week.'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Last Week Failed to Onboard',
	            data: data.last_week_never_tracked_percent,
	            caption: '% of users who installed app, but never tracked.'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Last Week New Users',
	            data: data.last_week_new_users,
	            caption: 'New Users last week'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Last Week Games Played',
	            data: data.last_week_games_played,
	            caption: 'Games played with the Blitz App last week'
	          })
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'page-title dashboard-title' },
	          'Overall Stats'
	        ),
	        data && _react2.default.createElement(
	          'div',
	          { className: 'dashboard-stat clearfix' },
	          _react2.default.createElement(StatItem, {
	            title: 'Overall Ratio',
	            data: data.overall_ratio,
	            caption: 'Average ratio of all users.'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Tracked Once Ratio',
	            data: data.tracked_once_ratio,
	            caption: 'Average ratio of all users who have tracked at least 1 time.'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Never Tracked Ratio',
	            data: data.never_tracked_percent,
	            caption: 'Ratio of all Users who failed to onboard (Track 1 game)'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Total users tracked',
	            data: data.total_tracked_users,
	            caption: 'Total Users who have tracked at least once'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Games played with Blitz',
	            data: data.total_games_played,
	            caption: 'Total games played by people using the Blitz App! (Recent to 7 days ago)'
	          })
	        )
	      );
	    }
	  }]);
	
	  return AppTrackingDashboard;
	}(_react.Component);
	
	exports.default = AppTrackingDashboard;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function StatItem(props) {
	  var caption = props.caption,
	      data = props.data,
	      subdata = props.subdata,
	      title = props.title;
	
	
	  var formattedData = data && data < 1 ? (data * 100).toPrecision(3) + '%' : data;
	  var formattedSubData = subdata && subdata < 1 ? (subdata * 100).toPrecision(3) + '%' : subdata;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'dashboard-stat-item ' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'dashboard-stat-content clearfix' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'dashboard-stat-number' },
	        formattedData,
	        ' ',
	        formattedSubData && '(' + formattedSubData + ')'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'dashboard-stat-caption' },
	      caption
	    )
	  );
	}
	
	StatItem.propTypes = {
	  caption: _propTypes2.default.string,
	  data: _propTypes2.default.number,
	  subdata: _propTypes2.default.number,
	  title: _propTypes2.default.string
	};
	
	var AppTrackingDashboard = function (_Component) {
	  _inherits(AppTrackingDashboard, _Component);
	
	  function AppTrackingDashboard(props) {
	    _classCallCheck(this, AppTrackingDashboard);
	
	    var _this = _possibleConstructorReturn(this, (AppTrackingDashboard.__proto__ || Object.getPrototypeOf(AppTrackingDashboard)).call(this, props));
	
	    _this.getData = _this.getData.bind(_this);
	    _this.onMinGameChange = _this.onMinGameChange.bind(_this);
	    _this.state = {
	      data: null,
	      query: {},
	      minGames: 1
	    };
	    return _this;
	  }
	
	  _createClass(AppTrackingDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'onMinGameChange',
	    value: function onMinGameChange(e) {
	      this.setState({ minGames: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.at_least;
	      } else {
	        query = Object.assign({}, query, { at_least: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      var query = this.state.query;
	
	      _BlitzAPI2.default.getStatsFilterable(query).then(function (resp) {
	        return _this2.setState({ data: resp.data });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          minGames = _state.minGames;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dashboard' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Filter Dashboard'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'page-title dashboard-title' },
	          'Overall Stats'
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Minimum number of games: '
	        ),
	        _react2.default.createElement('input', { type: 'number', onChange: this.onMinGameChange, value: minGames }),
	        data && _react2.default.createElement(
	          'div',
	          { className: 'dashboard-stat clearfix' },
	          _react2.default.createElement(StatItem, {
	            title: 'Overall Ratio',
	            data: data.overall_ratio,
	            subdata: data.overall_count,
	            caption: 'Average ratio of all users.'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Overall min game ratio',
	            data: data.at_least_ratio,
	            subdata: data.at_least_count,
	            caption: 'Average ratio of all users who have tracked at least ' + minGames + ' time(s).'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Last Week min game Ratio',
	            data: data.last_week_at_least_ratio,
	            subdata: data.last_week_at_least_count,
	            caption: 'Last week ratio of users who have tracked at least ' + minGames + ' time(s)'
	          }),
	          _react2.default.createElement(StatItem, {
	            title: 'Min game Lost users',
	            data: data.lost_count,
	            subdata: data.lost_count / data.at_least_count,
	            caption: 'users who stopped using the app (% of users) who\'ve tracked at least ' + minGames + ' games'
	          })
	        )
	      );
	    }
	  }]);
	
	  return AppTrackingDashboard;
	}(_react.Component);
	
	exports.default = AppTrackingDashboard;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _AppTrackingTable = __webpack_require__(845);
	
	var _AppTrackingTable2 = _interopRequireDefault(_AppTrackingTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserList = function (_Component) {
	  _inherits(UserList, _Component);
	
	  function UserList() {
	    _classCallCheck(this, UserList);
	
	    return _possibleConstructorReturn(this, (UserList.__proto__ || Object.getPrototypeOf(UserList)).apply(this, arguments));
	  }
	
	  _createClass(UserList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Tracking User List'
	        ),
	        _react2.default.createElement(_AppTrackingTable2.default, null)
	      );
	    }
	  }]);
	
	  return UserList;
	}(_react.Component);
	
	exports.default = UserList;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cellEditProp = {
	  mode: 'dbclick',
	  blurToSave: true
	};
	
	function emailDataFormat(cell, row) {
	  var args = {
	    subject: '[Free $10 RP] Blitz Esports wants to hear from you about the Desktop app!',
	    body: 'Hi ' + row.summoner_name + ',\n\nMy name is Shawn, Lead Designer at Blitz, and I\'d like to personally thank you for trying out Blitz Desktop Beta.\nWe noticed that you have stopped using the app for quite some time, and we\'d love to learn why it\'s not useful to you.\n\nAre you available for a quick 15-minute chat some time this week over Discord or Skype? If so, please sign up for a time slot that works the best for you here: https://calendly.com/blitz-interview-june/15min (You will receive free $10 RP gift card for your time.)\n\nIf not, feel free to just reply to share some thoughts!\n\nBest,\nShawn'
	  };
	
	  var argsString = Object.entries(args).map(function (kv) {
	    return kv.map(encodeURIComponent).join("=");
	  }).join("&");
	
	  var mailToData = 'mailto:' + row.email + '?' + argsString;
	
	  return _react2.default.createElement(
	    'a',
	    { href: mailToData },
	    cell
	  );
	}
	
	var UserListTable = function (_Component) {
	  _inherits(UserListTable, _Component);
	
	  function UserListTable(props) {
	    _classCallCheck(this, UserListTable);
	
	    var _this = _possibleConstructorReturn(this, (UserListTable.__proto__ || Object.getPrototypeOf(UserListTable)).call(this, props));
	
	    _this.state = {
	      data: null,
	      query: { page_size: 50 },
	      username: '',
	      search: ''
	    };
	    _this.getData = _this.getData.bind(_this);
	    _this.onSortChange = _this.onSortChange.bind(_this);
	    _this.onSizePerPageList = _this.onSizePerPageList.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.handleCheckboxToggle = _this.handleCheckboxToggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserListTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var query = this.state.query;
	
	      this.getData(query);
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(page, sizePerPage) {
	      var query = Object.assign({}, this.state.query, { page: page });
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'onSizePerPageList',
	    value: function onSizePerPageList(sizePerPage) {
	      var query = Object.assign({}, this.state.query, { page_size: sizePerPage });
	      this.setState({
	        query: query
	      }, this.getData);
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(sortName, sortOrder) {
	      var sorting = sortOrder === 'asc' ? sortName : '-' + sortName;
	      var query = Object.assign({}, this.state.query, { order_by: sorting });
	      this.setState({
	        query: query
	      }, this.getData);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getStatsUsers(this.state.query).then(function (resp) {
	        return _this2.setState({
	          data: resp.data.data,
	          sizePerPage: resp.data.page_size,
	          dataTotalSize: resp.data.total_entries,
	          currentPage: resp.data.page_number
	        });
	      });
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(e) {
	      this.setState({ search: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.search;
	      } else {
	        query = Object.assign({}, query, { search: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'handleCheckboxToggle',
	    value: function handleCheckboxToggle(event) {
	      var _setState;
	
	      var target = event.target;
	      var value = target.checked;
	      var name = target.name;
	      var query = this.state.query;
	
	      query = Object.assign({}, query, _defineProperty({}, name, value));
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'query', query), _setState), this.getData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          username = _state.username,
	          search = _state.search,
	          sizePerPage = _state.sizePerPage,
	          currentPage = _state.currentPage,
	          dataTotalSize = _state.dataTotalSize;
	
	
	      return data ? _react2.default.createElement(
	        'div',
	        { style: { marginTop: '20px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'div',
	            { style: { float: 'right' } },
	            _react2.default.createElement('input', { value: search, onChange: this.onSearchChange, placeholder: 'Search' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'form',
	              null,
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { style: { paddingRight: '10px' } },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Show only dropoff:'
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  name: 'dropoff',
	                  type: 'checkbox',
	                  checked: this.state.dropoff,
	                  onChange: this.handleCheckboxToggle })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.BootstrapTable,
	          {
	            data: this.state.data,
	            remote: true, striped: true, hover: true, pagination: true,
	            cellEdit: cellEditProp,
	            fetchInfo: { dataTotalSize: dataTotalSize },
	            options: {
	              onCellEdit: this.onCellEdit,
	              onSortChange: this.onSortChange,
	              sizePerPage: sizePerPage,
	              onPageChange: this.onPageChange,
	              page: currentPage,
	              onSizePerPageList: this.onSizePerPageList
	            }
	          },
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'summoner_name' },
	            'Summoner Name'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'email', dataFormat: emailDataFormat },
	            'Email'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'region' },
	            'Region'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'total_ratio' },
	            'Total Ratio'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'total_matches_tracked' },
	            'Total Matches Tracked'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'total_matches_played' },
	            'Total Matches Played'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'last_week_ratio' },
	            'Last Week Ratio'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'last_week_tracked' },
	            'Last Week Tracked'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, dataField: 'last_week_played' },
	            'Last Week Played'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataSort: true, isKey: true, dataField: 'account_id' },
	            'Account Id'
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return UserListTable;
	}(_react.Component);
	
	exports.default = UserListTable;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _UserForm = __webpack_require__(298);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserCreate = function (_Component) {
	  _inherits(UserCreate, _Component);
	
	  function UserCreate(props) {
	    _classCallCheck(this, UserCreate);
	
	    var _this = _possibleConstructorReturn(this, (UserCreate.__proto__ || Object.getPrototypeOf(UserCreate)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserCreate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.postUser({ user: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/users');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Create a new user'
	        ),
	        _react2.default.createElement(_UserForm2.default, { onSubmit: this.handleSubmit })
	      );
	    }
	  }]);
	
	  return UserCreate;
	}(_react.Component);
	
	exports.default = UserCreate;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	var _UserForm = __webpack_require__(298);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserEdit = function (_Component) {
	  _inherits(UserEdit, _Component);
	
	  function UserEdit(props) {
	    _classCallCheck(this, UserEdit);
	
	    var _this = _possibleConstructorReturn(this, (UserEdit.__proto__ || Object.getPrototypeOf(UserEdit)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.state = {
	      user: null
	    };
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      _BlitzAPI2.default.getUser(this.props.params.userId).then(function (response) {
	        return _this2.setState({ user: response.data.data });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(values) {
	      return _BlitzAPI2.default.patchAnyUser(this.props.params.userId, { user: values }).then(function (response) {
	        return _reactRouter.browserHistory.push('/users');
	      }).catch(_utils.handleFormErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.user) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Loading'
	          )
	        );
	      }
	      console.log(this.state.user);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Edit User'
	        ),
	        _react2.default.createElement(_UserForm2.default, { onSubmit: this.handleSubmit, initialValues: this.state.user })
	      );
	    }
	  }]);
	
	  return UserEdit;
	}(_react.Component);
	
	UserEdit.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouter.withRouter)(UserEdit);

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterBootstrap = __webpack_require__(56);
	
	var _reactBootstrap = __webpack_require__(13);
	
	var _UserListTable = __webpack_require__(849);
	
	var _UserListTable2 = _interopRequireDefault(_UserListTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserList = function (_Component) {
	  _inherits(UserList, _Component);
	
	  function UserList() {
	    _classCallCheck(this, UserList);
	
	    return _possibleConstructorReturn(this, (UserList.__proto__ || Object.getPrototypeOf(UserList)).apply(this, arguments));
	  }
	
	  _createClass(UserList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouterBootstrap.LinkContainer,
	          { to: '/users/create' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            null,
	            'Create User'
	          )
	        ),
	        _react2.default.createElement(_UserListTable2.default, null)
	      );
	    }
	  }]);
	
	  return UserList;
	}(_react.Component);
	
	exports.default = UserList;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapTable = __webpack_require__(69);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BlitzAPI = __webpack_require__(12);
	
	var _BlitzAPI2 = _interopRequireDefault(_BlitzAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cellEditProp = {
	  mode: 'dbclick',
	  blurToSave: true
	};
	
	function userDataFormat(cell) {
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/users/' + cell },
	    _react2.default.createElement(
	      'div',
	      null,
	      cell
	    )
	  );
	}
	
	var UserListTable = function (_Component) {
	  _inherits(UserListTable, _Component);
	
	  function UserListTable(props) {
	    _classCallCheck(this, UserListTable);
	
	    var _this = _possibleConstructorReturn(this, (UserListTable.__proto__ || Object.getPrototypeOf(UserListTable)).call(this, props));
	
	    _this.state = {
	      data: null,
	      query: {},
	      username: ''
	    };
	    _this.onCellEdit = _this.onCellEdit.bind(_this);
	    _this.onUsernameChange = _this.onUsernameChange.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserListTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var query = this.state.query;
	
	      this.getData(query);
	    }
	  }, {
	    key: 'onCellEdit',
	    value: function onCellEdit(row, fieldName, value) {
	      var data = this.state.data;
	
	      var rowIndex = void 0;
	      var targetRow = data.find(function (currentRow, index) {
	        if (currentRow.id === row.id) {
	          rowIndex = index;
	          return true;
	        }
	        return false;
	      });
	
	      if (targetRow && targetRow[fieldName] !== value) {
	        targetRow[fieldName] = value;
	        data[rowIndex] = targetRow;
	        var userParams = {};
	        userParams[fieldName] = value;
	        _BlitzAPI2.default.patchAnyUser(row.id, { user: userParams }).then(function (response) {
	          return console.log(response);
	        });
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'onUsernameChange',
	    value: function onUsernameChange(e) {
	      this.setState({ username: e.target.value });
	      var query = this.state.query;
	
	      if (!e.target.value) {
	        delete query.username;
	      } else {
	        query = Object.assign({}, query, { username: e.target.value });
	      }
	      this.setState({ query: query }, this.getData);
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var _this2 = this;
	
	      var query = this.state.query;
	
	      _BlitzAPI2.default.getUsers(query).then(function (resp) {
	        return _this2.setState({ data: resp.data.data });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          username = _state.username;
	
	
	      return data ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'userSearch' },
	            'Search'
	          ),
	          _react2.default.createElement('input', { value: username, onChange: this.onUsernameChange })
	        ),
	        _react2.default.createElement(
	          _reactBootstrapTable.BootstrapTable,
	          {
	            data: this.state.data,
	            remote: true, striped: true, hover: true,
	            cellEdit: cellEditProp,
	            options: { onCellEdit: this.onCellEdit }
	          },
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            {
	              isKey: true, dataField: 'id',
	              dataFormat: userDataFormat
	            },
	            'User ID'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'username' },
	            'Username'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'name' },
	            'Name'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'email' },
	            'Email'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'banned', editable: { type: 'checkbox' } },
	            'Banned'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'image_url', editable: true },
	            'Image URL'
	          ),
	          _react2.default.createElement(
	            _reactBootstrapTable.TableHeaderColumn,
	            { dataField: 'bio', editable: true },
	            'Biography'
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Loading'
	        )
	      );
	    }
	  }]);
	
	  return UserListTable;
	}(_react.Component);
	
	exports.default = UserListTable;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(133);
	
	var _remoteReduxDevtools = __webpack_require__(1576);
	
	var _reactRouterRedux = __webpack_require__(709);
	
	var _reduxForm = __webpack_require__(31);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reduxThunk = __webpack_require__(1567);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxPersist = __webpack_require__(748);
	
	var _reducers = __webpack_require__(852);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  var enhancer = (0, _remoteReduxDevtools.composeWithDevTools)((0, _redux.applyMiddleware)(_reduxThunk2.default), (0, _reduxPersist.autoRehydrate)(), (0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory)));
	  var reducers = (0, _redux.combineReducers)({
	    routing: _reactRouterRedux.routerReducer,
	    form: _reduxForm.reducer,
	    user: _reducers.userReducer
	  });
	  var store = (0, _redux.createStore)(reducers, initialState, enhancer);
	  return store;
	}

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1029);
	
	var _Root = __webpack_require__(286);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_Root2.default, null), document.getElementById('root'));

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userReducer = undefined;
	
	var _redux = __webpack_require__(133);
	
	var _actionTypes = __webpack_require__(287);
	
	var ActionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var PROFILE_INITIAL_STATE = {
	  fake_username: null,
	  username: null,
	  name: null,
	  email: null,
	  admin: null,
	  token: null,
	  staff: null
	};
	
	function profile() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PROFILE_INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ActionTypes.LOGOUT:
	      return Object.assign({}, state, PROFILE_INITIAL_STATE);
	    case ActionTypes.UPDATE_PROFILE:
	      return Object.assign({}, state, action.params);
	    default:
	      return state;
	  }
	}
	
	var userReducer = exports.userReducer = (0, _redux.combineReducers)({
	  profile: profile
	});

/***/ },
/* 853 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 854 */
/***/ function(module, exports) {

	
	/**
	 * Create object url.
	 */
	
	exports.create = (window.URL && URL.createObjectURL.bind(URL))
	  || (window.webkitURL && webkitURL.createObjectURL.bind(webkitURL))
	  || window.createObjectURL;
	
	/**
	 * Revoke object url.
	 */
	
	exports.revoke = (window.URL && URL.revokeObjectURL.bind(URL))
	  || (window.webkitURL && webkitURL.revokeObjectURL.bind(webkitURL))
	  || window.revokeObjectURL;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(858);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/i,
	       hex =  /^#([a-fA-F0-9]{6})$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 856 */
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(856);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },
/* 858 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 302,
		"./af.js": 302,
		"./ar": 309,
		"./ar-dz": 303,
		"./ar-dz.js": 303,
		"./ar-kw": 304,
		"./ar-kw.js": 304,
		"./ar-ly": 305,
		"./ar-ly.js": 305,
		"./ar-ma": 306,
		"./ar-ma.js": 306,
		"./ar-sa": 307,
		"./ar-sa.js": 307,
		"./ar-tn": 308,
		"./ar-tn.js": 308,
		"./ar.js": 309,
		"./az": 310,
		"./az.js": 310,
		"./be": 311,
		"./be.js": 311,
		"./bg": 312,
		"./bg.js": 312,
		"./bn": 313,
		"./bn.js": 313,
		"./bo": 314,
		"./bo.js": 314,
		"./br": 315,
		"./br.js": 315,
		"./bs": 316,
		"./bs.js": 316,
		"./ca": 317,
		"./ca.js": 317,
		"./cs": 318,
		"./cs.js": 318,
		"./cv": 319,
		"./cv.js": 319,
		"./cy": 320,
		"./cy.js": 320,
		"./da": 321,
		"./da.js": 321,
		"./de": 324,
		"./de-at": 322,
		"./de-at.js": 322,
		"./de-ch": 323,
		"./de-ch.js": 323,
		"./de.js": 324,
		"./dv": 325,
		"./dv.js": 325,
		"./el": 326,
		"./el.js": 326,
		"./en-au": 327,
		"./en-au.js": 327,
		"./en-ca": 328,
		"./en-ca.js": 328,
		"./en-gb": 329,
		"./en-gb.js": 329,
		"./en-ie": 330,
		"./en-ie.js": 330,
		"./en-nz": 331,
		"./en-nz.js": 331,
		"./eo": 332,
		"./eo.js": 332,
		"./es": 334,
		"./es-do": 333,
		"./es-do.js": 333,
		"./es.js": 334,
		"./et": 335,
		"./et.js": 335,
		"./eu": 336,
		"./eu.js": 336,
		"./fa": 337,
		"./fa.js": 337,
		"./fi": 338,
		"./fi.js": 338,
		"./fo": 339,
		"./fo.js": 339,
		"./fr": 342,
		"./fr-ca": 340,
		"./fr-ca.js": 340,
		"./fr-ch": 341,
		"./fr-ch.js": 341,
		"./fr.js": 342,
		"./fy": 343,
		"./fy.js": 343,
		"./gd": 344,
		"./gd.js": 344,
		"./gl": 345,
		"./gl.js": 345,
		"./gom-latn": 346,
		"./gom-latn.js": 346,
		"./he": 347,
		"./he.js": 347,
		"./hi": 348,
		"./hi.js": 348,
		"./hr": 349,
		"./hr.js": 349,
		"./hu": 350,
		"./hu.js": 350,
		"./hy-am": 351,
		"./hy-am.js": 351,
		"./id": 352,
		"./id.js": 352,
		"./is": 353,
		"./is.js": 353,
		"./it": 354,
		"./it.js": 354,
		"./ja": 355,
		"./ja.js": 355,
		"./jv": 356,
		"./jv.js": 356,
		"./ka": 357,
		"./ka.js": 357,
		"./kk": 358,
		"./kk.js": 358,
		"./km": 359,
		"./km.js": 359,
		"./kn": 360,
		"./kn.js": 360,
		"./ko": 361,
		"./ko.js": 361,
		"./ky": 362,
		"./ky.js": 362,
		"./lb": 363,
		"./lb.js": 363,
		"./lo": 364,
		"./lo.js": 364,
		"./lt": 365,
		"./lt.js": 365,
		"./lv": 366,
		"./lv.js": 366,
		"./me": 367,
		"./me.js": 367,
		"./mi": 368,
		"./mi.js": 368,
		"./mk": 369,
		"./mk.js": 369,
		"./ml": 370,
		"./ml.js": 370,
		"./mr": 371,
		"./mr.js": 371,
		"./ms": 373,
		"./ms-my": 372,
		"./ms-my.js": 372,
		"./ms.js": 373,
		"./my": 374,
		"./my.js": 374,
		"./nb": 375,
		"./nb.js": 375,
		"./ne": 376,
		"./ne.js": 376,
		"./nl": 378,
		"./nl-be": 377,
		"./nl-be.js": 377,
		"./nl.js": 378,
		"./nn": 379,
		"./nn.js": 379,
		"./pa-in": 380,
		"./pa-in.js": 380,
		"./pl": 381,
		"./pl.js": 381,
		"./pt": 383,
		"./pt-br": 382,
		"./pt-br.js": 382,
		"./pt.js": 383,
		"./ro": 384,
		"./ro.js": 384,
		"./ru": 385,
		"./ru.js": 385,
		"./sd": 386,
		"./sd.js": 386,
		"./se": 387,
		"./se.js": 387,
		"./si": 388,
		"./si.js": 388,
		"./sk": 389,
		"./sk.js": 389,
		"./sl": 390,
		"./sl.js": 390,
		"./sq": 391,
		"./sq.js": 391,
		"./sr": 393,
		"./sr-cyrl": 392,
		"./sr-cyrl.js": 392,
		"./sr.js": 393,
		"./ss": 394,
		"./ss.js": 394,
		"./sv": 395,
		"./sv.js": 395,
		"./sw": 396,
		"./sw.js": 396,
		"./ta": 397,
		"./ta.js": 397,
		"./te": 398,
		"./te.js": 398,
		"./tet": 399,
		"./tet.js": 399,
		"./th": 400,
		"./th.js": 400,
		"./tl-ph": 401,
		"./tl-ph.js": 401,
		"./tlh": 402,
		"./tlh.js": 402,
		"./tr": 403,
		"./tr.js": 403,
		"./tzl": 404,
		"./tzl.js": 404,
		"./tzm": 406,
		"./tzm-latn": 405,
		"./tzm-latn.js": 405,
		"./tzm.js": 406,
		"./uk": 407,
		"./uk.js": 407,
		"./ur": 408,
		"./ur.js": 408,
		"./uz": 410,
		"./uz-latn": 409,
		"./uz-latn.js": 409,
		"./uz.js": 410,
		"./vi": 411,
		"./vi.js": 411,
		"./x-pseudo": 412,
		"./x-pseudo.js": 412,
		"./yo": 413,
		"./yo.js": 413,
		"./zh-cn": 414,
		"./zh-cn.js": 414,
		"./zh-hk": 415,
		"./zh-hk.js": 415,
		"./zh-tw": 416,
		"./zh-tw.js": 416
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 859;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(879)();
	
	Chart.helpers = __webpack_require__(14);
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	__webpack_require__(878)(Chart);
	
	Chart.defaults = __webpack_require__(24);
	Chart.Element = __webpack_require__(45);
	Chart.elements = __webpack_require__(66);
	Chart.Interaction = __webpack_require__(417);
	Chart.platform = __webpack_require__(418);
	
	__webpack_require__(881)(Chart);
	__webpack_require__(875)(Chart);
	__webpack_require__(876)(Chart);
	__webpack_require__(877)(Chart);
	__webpack_require__(880)(Chart);
	__webpack_require__(883)(Chart);
	__webpack_require__(882)(Chart);
	__webpack_require__(884)(Chart);
	
	__webpack_require__(899)(Chart);
	__webpack_require__(897)(Chart);
	__webpack_require__(898)(Chart);
	__webpack_require__(900)(Chart);
	__webpack_require__(901)(Chart);
	__webpack_require__(902)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(868)(Chart);
	__webpack_require__(869)(Chart);
	__webpack_require__(870)(Chart);
	__webpack_require__(871)(Chart);
	__webpack_require__(872)(Chart);
	__webpack_require__(873)(Chart);
	__webpack_require__(874)(Chart);
	
	__webpack_require__(861)(Chart);
	__webpack_require__(862)(Chart);
	__webpack_require__(863)(Chart);
	__webpack_require__(864)(Chart);
	__webpack_require__(865)(Chart);
	__webpack_require__(866)(Chart);
	__webpack_require__(867)(Chart);
	
	// Loading built-it plugins
	var plugins = [];
	
	plugins.push(
		__webpack_require__(894)(Chart),
		__webpack_require__(895)(Chart),
		__webpack_require__(896)(Chart)
	);
	
	Chart.plugins.register(plugins);
	
	Chart.platform.initialize();
	
	module.exports = Chart;
	if (typeof window !== 'undefined') {
		window.Chart = Chart;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.canvasHelpers = Chart.helpers.canvas;


/***/ },
/* 861 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 862 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 863 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 864 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 865 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 866 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 867 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	};


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
	
				// Specific to Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				position: 'left',
				type: 'category',
	
				// Specific to Horizontal Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			callbacks: {
				title: function(item, data) {
					// Pick first xLabel for now
					var title = '';
	
					if (item.length > 0) {
						if (item[0].yLabel) {
							title = item[0].yLabel;
						} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
							title = data.labels[item[0].index];
						}
					}
	
					return title;
				},
	
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					return datasetLabel + ': ' + item.xLabel;
				}
			},
			mode: 'index',
			axis: 'y'
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: elements.Rectangle,
	
			initialize: function() {
				var me = this;
				var meta;
	
				Chart.DatasetController.prototype.initialize.apply(me, arguments);
	
				meta = me.getMeta();
				meta.stack = me.getDataset().stack;
				meta.bar = true;
			},
	
			update: function(reset) {
				var me = this;
				var rects = me.getMeta().data;
				var i, ilen;
	
				me._ruler = me.getRuler();
	
				for (i = 0, ilen = rects.length; i < ilen; ++i) {
					me.updateElement(rects[i], i, reset);
				}
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var dataset = me.getDataset();
				var custom = rectangle.custom || {};
				var rectangleOptions = chart.options.elements.rectangle;
	
				rectangle._xScale = me.getScaleForId(meta.xAxisID);
				rectangle._yScale = me.getScaleForId(meta.yAxisID);
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				rectangle._model = {
					datasetLabel: dataset.label,
					label: chart.data.labels[index],
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
				};
	
				me.updateElementGeometry(rectangle, index, reset);
	
				rectangle.pivot();
			},
	
			/**
			 * @private
			 */
			updateElementGeometry: function(rectangle, index, reset) {
				var me = this;
				var model = rectangle._model;
				var vscale = me.getValueScale();
				var base = vscale.getBasePixel();
				var horizontal = vscale.isHorizontal();
				var ruler = me._ruler || me.getRuler();
				var vpixels = me.calculateBarValuePixels(me.index, index);
				var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);
	
				model.horizontal = horizontal;
				model.base = reset ? base : vpixels.base;
				model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
				model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
				model.height = horizontal ? ipixels.size : undefined;
				model.width = horizontal ? undefined : ipixels.size;
			},
	
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().yAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getValueScale: function() {
				return this.getScaleForId(this.getValueScaleId());
			},
	
			/**
			 * @private
			 */
			getIndexScale: function() {
				return this.getScaleForId(this.getIndexScaleId());
			},
	
			/**
			 * Returns the effective number of stacks based on groups and bar visibility.
			 * @private
			 */
			getStackCount: function(last) {
				var me = this;
				var chart = me.chart;
				var scale = me.getIndexScale();
				var stacked = scale.options.stacked;
				var ilen = last === undefined ? chart.data.datasets.length : last + 1;
				var stacks = [];
				var i, meta;
	
				for (i = 0; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					if (meta.bar && chart.isDatasetVisible(i) &&
						(stacked === false ||
						(stacked === true && stacks.indexOf(meta.stack) === -1) ||
						(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
						stacks.push(meta.stack);
					}
				}
	
				return stacks.length;
			},
	
			/**
			 * Returns the stack index for the given dataset based on groups and bar visibility.
			 * @private
			 */
			getStackIndex: function(datasetIndex) {
				return this.getStackCount(datasetIndex) - 1;
			},
	
			/**
			 * @private
			 */
			getRuler: function() {
				var me = this;
				var scale = me.getIndexScale();
				var stackCount = me.getStackCount();
				var datasetIndex = me.index;
				var pixels = [];
				var isHorizontal = scale.isHorizontal();
				var start = isHorizontal ? scale.left : scale.top;
				var end = start + (isHorizontal ? scale.width : scale.height);
				var i, ilen;
	
				for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
					pixels.push(scale.getPixelForValue(null, i, datasetIndex));
				}
	
				return {
					pixels: pixels,
					start: start,
					end: end,
					stackCount: stackCount,
					scale: scale
				};
			},
	
			/**
			 * Note: pixel values are not clamped to the scale area.
			 * @private
			 */
			calculateBarValuePixels: function(datasetIndex, index) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var scale = me.getValueScale();
				var datasets = chart.data.datasets;
				var value = scale.getRightValue(datasets[datasetIndex].data[index]);
				var stacked = scale.options.stacked;
				var stack = meta.stack;
				var start = 0;
				var i, imeta, ivalue, base, head, size;
	
				if (stacked || (stacked === undefined && stack !== undefined)) {
					for (i = 0; i < datasetIndex; ++i) {
						imeta = chart.getDatasetMeta(i);
	
						if (imeta.bar &&
							imeta.stack === stack &&
							imeta.controller.getValueScaleId() === scale.id &&
							chart.isDatasetVisible(i)) {
	
							ivalue = scale.getRightValue(datasets[i].data[index]);
							if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
								start += ivalue;
							}
						}
					}
				}
	
				base = scale.getPixelForValue(start);
				head = scale.getPixelForValue(start + value);
				size = (head - base) / 2;
	
				return {
					size: size,
					base: base,
					head: head,
					center: head + size / 2
				};
			},
	
			/**
			 * @private
			 */
			calculateBarIndexPixels: function(datasetIndex, index, ruler) {
				var me = this;
				var options = ruler.scale.options;
				var stackIndex = me.getStackIndex(datasetIndex);
				var pixels = ruler.pixels;
				var base = pixels[index];
				var length = pixels.length;
				var start = ruler.start;
				var end = ruler.end;
				var leftSampleSize, rightSampleSize, leftCategorySize, rightCategorySize, fullBarSize, size;
	
				if (length === 1) {
					leftSampleSize = base > start ? base - start : end - base;
					rightSampleSize = base < end ? end - base : base - start;
				} else {
					if (index > 0) {
						leftSampleSize = (base - pixels[index - 1]) / 2;
						if (index === length - 1) {
							rightSampleSize = leftSampleSize;
						}
					}
					if (index < length - 1) {
						rightSampleSize = (pixels[index + 1] - base) / 2;
						if (index === 0) {
							leftSampleSize = rightSampleSize;
						}
					}
				}
	
				leftCategorySize = leftSampleSize * options.categoryPercentage;
				rightCategorySize = rightSampleSize * options.categoryPercentage;
				fullBarSize = (leftCategorySize + rightCategorySize) / ruler.stackCount;
				size = fullBarSize * options.barPercentage;
	
				size = Math.min(
					helpers.valueOrDefault(options.barThickness, size),
					helpers.valueOrDefault(options.maxBarThickness, Infinity));
	
				base -= leftCategorySize;
				base += fullBarSize * stackIndex;
				base += (fullBarSize - size) / 2;
	
				return {
					size: size,
					base: base,
					head: base + size,
					center: base + size / 2
				};
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var scale = me.getValueScale();
				var rects = me.getMeta().data;
				var dataset = me.getDataset();
				var ilen = rects.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, chart.chartArea);
	
				for (; i < ilen; ++i) {
					if (!isNaN(scale.getRightValue(dataset.data[i]))) {
						rects[i].draw();
					}
				}
	
				helpers.canvas.unclipArea(chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
		});
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().yAxisID;
			}
		});
	};


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	
	module.exports = function(Chart) {
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
			/**
			 * @protected
			 */
			dataElementType: elements.Point,
	
			/**
			 * @protected
			 */
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			/**
			 * @protected
			 */
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var options = me._resolveElementOptions(point, index);
				var data = me.getDataset().data[index];
				var dsIndex = me.index;
	
				var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
				var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
				point._xScale = xScale;
				point._yScale = yScale;
				point._options = options;
				point._datasetIndex = dsIndex;
				point._index = index;
				point._model = {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					hitRadius: options.hitRadius,
					pointStyle: options.pointStyle,
					radius: reset ? 0 : options.radius,
					skip: custom.skip || isNaN(x) || isNaN(y),
					x: x,
					y: y,
				};
	
				point.pivot();
			},
	
			/**
			 * @protected
			 */
			setHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
				model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
				model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
				model.radius = options.radius + options.hoverRadius;
			},
	
			/**
			 * @protected
			 */
			removeHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = options.backgroundColor;
				model.borderColor = options.borderColor;
				model.borderWidth = options.borderWidth;
				model.radius = options.radius;
			},
	
			/**
			 * @private
			 */
			_resolveElementOptions: function(point, index) {
				var me = this;
				var chart = me.chart;
				var datasets = chart.data.datasets;
				var dataset = datasets[me.index];
				var custom = point.custom || {};
				var options = chart.options.elements.point;
				var resolve = helpers.options.resolve;
				var data = dataset.data[index];
				var values = {};
				var i, ilen, key;
	
				// Scriptable options
				var context = {
					chart: chart,
					dataIndex: index,
					dataset: dataset,
					datasetIndex: me.index
				};
	
				var keys = [
					'backgroundColor',
					'borderColor',
					'borderWidth',
					'hoverBackgroundColor',
					'hoverBorderColor',
					'hoverBorderWidth',
					'hoverRadius',
					'hitRadius',
					'pointStyle'
				];
	
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						dataset[key],
						options[key]
					], context, index);
				}
	
				// Custom radius resolution
				values.radius = resolve([
					custom.radius,
					data ? data.r : undefined,
					dataset.radius,
					options.radius
				], context, index);
	
				return values;
			}
		});
	};


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,
	
		// The total circumference of the chart.
		circumference: Math.PI * 2.0,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	defaults._set('pie', helpers.clone(defaults.doughnut));
	defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
				var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
				var minSize = Math.min(availableWidth, availableHeight);
				var offset = {x: 0, y: 0};
				var meta = me.getMeta();
				var cutoutPercentage = opts.cutoutPercentage;
				var circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var animationOpts = opts.animation;
				var centerX = (chartArea.left + chartArea.right) / 2;
				var centerY = (chartArea.top + chartArea.bottom) / 2;
				var startAngle = opts.rotation; // non reset case handled later
				var endAngle = opts.rotation; // non reset case handled later
				var dataset = me.getDataset();
				var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
				var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
				var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
				var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(arcs) {
				var max = 0;
				var index = this.index;
				var length = arcs.length;
				var borderWidth;
				var hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
					hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	module.exports = function(Chart) {
	
		function lineEnabled(dataset, options) {
			return helpers.valueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
					borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var points = meta.data || [];
				var area = chart.chartArea;
				var ilen = points.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, area);
	
				if (lineEnabled(me.getDataset(), chart.options)) {
					meta.dataset.draw();
				}
	
				helpers.canvas.unclipArea(chart.ctx);
	
				// Draw the points
				for (; i < ilen; ++i) {
					points[i].draw(area);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					_scale: scale,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	
	defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		showLines: false,
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
	};


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.Animation = Element.extend({
			chart: null, // the animation associated chart instance
			currentStep: 0, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null, // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @param {Chart} chart - The chart to animate.
			 * @param {Chart.Animation} animation - The animation that we will animate.
			 * @param {Number} duration - The animation duration in ms.
			 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chart, animation, duration, lazy) {
				var animations = this.animations;
				var i, ilen;
	
				animation.chart = chart;
	
				if (!lazy) {
					chart.animating = true;
				}
	
				for (i = 0, ilen = animations.length; i < ilen; ++i) {
					if (animations[i].chart === chart) {
						animations[i] = animation;
						return;
					}
				}
	
				animations.push(animation);
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (animations.length === 1) {
					this.requestAnimationFrame();
				}
			},
	
			cancelAnimation: function(chart) {
				var index = helpers.findIndex(this.animations, function(animation) {
					return animation.chart === chart;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chart.animating = false;
				}
			},
	
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
	
			/**
			 * @private
			 */
			startDigest: function() {
				var me = this;
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				me.advance(1 + framesToDrop);
	
				var endTime = Date.now();
	
				me.dropFrames += (endTime - startTime) / me.frameDuration;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			},
	
			/**
			 * @private
			 */
			advance: function(count) {
				var animations = this.animations;
				var animation, chart;
				var i = 0;
	
				while (i < animations.length) {
					animation = animations[i];
					chart = animation.chart;
	
					animation.currentStep = (animation.currentStep || 0) + count;
					animation.currentStep = Math.min(animation.currentStep, animation.numSteps);
	
					helpers.callback(animation.render, [chart, animation], chart);
					helpers.callback(animation.onAnimationProgress, [animation], chart);
	
					if (animation.currentStep >= animation.numSteps) {
						helpers.callback(animation.onAnimationComplete, [animation], chart);
						chart.animating = false;
						animations.splice(i, 1);
					} else {
						++i;
					}
				}
			}
		};
	
		/**
		 * Provided for backward compatibility, use Chart.Animation instead
		 * @prop Chart.Animation#animationObject
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
			get: function() {
				return this;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart.Animation#chart instead
		 * @prop Chart.Animation#chartInstance
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
			get: function() {
				return this.chart;
			},
			set: function(value) {
				this.chart = value;
			}
		});
	
	};


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var helpers = __webpack_require__(14);
	var Interaction = __webpack_require__(417);
	var platform = __webpack_require__(418);
	
	module.exports = function(Chart) {
		var plugins = Chart.plugins;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				defaults.global,
				defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		function positionIsHorizontal(position) {
			return position === 'top' || position === 'bottom';
		}
	
		helpers.extend(Chart.prototype, /** @lends Chart */ {
			/**
			 * @private
			 */
			construct: function(item, config) {
				var me = this;
	
				config = initConfig(config);
	
				var context = platform.acquireContext(item, config);
				var canvas = context && context.canvas;
				var height = canvas && canvas.height;
				var width = canvas && canvas.width;
	
				me.id = helpers.uid();
				me.ctx = context;
				me.canvas = canvas;
				me.config = config;
				me.width = width;
				me.height = height;
				me.aspectRatio = height ? width / height : null;
				me.options = config.options;
				me._bufferedRender = false;
	
				/**
				 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
				 * the "instance" still need to be defined since it might be called from plugins.
				 * @prop Chart#chart
				 * @deprecated since version 2.6.0
				 * @todo remove at version 3
				 * @private
				 */
				me.chart = me;
				me.controller = me; // chart.chart.controller #inception
	
				// Add the chart instance to the global namespace
				Chart.instances[me.id] = me;
	
				// Define alias to the config data: `chart.data === chart.config.data`
				Object.defineProperty(me, 'data', {
					get: function() {
						return me.config.data;
					},
					set: function(value) {
						me.config.data = value;
					}
				});
	
				if (!context || !canvas) {
					// The given item is not a compatible context2d element, let's return before finalizing
					// the chart initialization but after setting basic chart / controller properties that
					// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
					// https://github.com/chartjs/Chart.js/issues/2807
					console.error("Failed to create chart: can't acquire context from the given item");
					return;
				}
	
				me.initialize();
				me.update();
			},
	
			/**
			 * @private
			 */
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me, me.options.devicePixelRatio);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.canvas.clear(this);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var options = me.options;
				var canvas = me.canvas;
				var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
	
				// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
				var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
				var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));
	
				if (me.width === newWidth && me.height === newHeight) {
					return;
				}
	
				canvas.width = me.width = newWidth;
				canvas.height = me.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(me, options.devicePixelRatio);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
						})
					);
				}
	
				if (options.scale) {
					items.push({
						options: options.scale,
						dtype: 'radialLinear',
						isDefault: true,
						dposition: 'chartArea'
					});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
						scaleOptions.position = item.dposition;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
					scale.mergeTicksOptions();
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					var type = dataset.type || me.config.type;
	
					if (meta.type && meta.type !== type) {
						me.destroyDatasetMeta(datasetIndex);
						meta = me.getDatasetMeta(datasetIndex);
					}
					meta.type = type;
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						var ControllerClass = Chart.controllers[meta.type];
						if (ControllerClass === undefined) {
							throw new Error('"' + meta.type + '" is not a chart type.');
						}
	
						meta.controller = new ControllerClass(me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Need to reset tooltip in case it is displayed with elements that are removed
				// after update.
				me.tooltip.initialize();
	
				// Last active contains items that were previously in the tooltip.
				// When we reset the tooltip, we need to clear it
				me.lastActive = [];
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						duration: config.duration,
						easing: config.easing,
						lazy: config.lazy
					};
				} else {
					me.render(config);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.width, this.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 * @private
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.updateDataset(i);
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			/**
			 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
			 * @private
			 */
			updateDataset: function(index) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index
				};
	
				if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
					return;
				}
	
				meta.controller.update();
	
				plugins.notify(me, 'afterDatasetUpdate', [args]);
			},
	
			render: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				var duration = config.duration;
				var lazy = config.lazy;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function(animation) {
					plugins.notify(me, 'afterRender');
					helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation({
						numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
						easing: config.easing || animationOptions.easing,
	
						render: function(chart, animationObject) {
							var easingFunction = helpers.easing.effects[animationObject.easing];
							var currentStep = animationObject.currentStep;
							var stepDecimal = currentStep / animationObject.numSteps;
	
							chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
						},
	
						onAnimationProgress: animationOptions.onProgress,
						onAnimationComplete: onComplete
					});
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
	
					// See https://github.com/chartjs/Chart.js/issues/3781
					onComplete(new Chart.Animation({numSteps: 0, chart: me}));
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (helpers.isNullOrUndef(easingValue)) {
					easingValue = 1;
				}
	
				me.transition(easingValue);
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
				me._drawTooltip(easingValue);
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * @private
			 */
			transition: function(easingValue) {
				var me = this;
	
				for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
					if (me.isDatasetVisible(i)) {
						me.getDatasetMeta(i).controller.transition(easingValue);
					}
				}
	
				me.tooltip.transition(easingValue);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw datasets reversed to support proper line stacking
				for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
					if (me.isDatasetVisible(i)) {
						me.drawDataset(i, easingValue);
					}
				}
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			/**
			 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
			 * @private
			 */
			drawDataset: function(index, easingValue) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
					return;
				}
	
				meta.controller.draw(easingValue);
	
				plugins.notify(me, 'afterDatasetDraw', [args]);
			},
	
			/**
			 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
			 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
			 * @private
			 */
			_drawTooltip: function(easingValue) {
				var me = this;
				var tooltip = me.tooltip;
				var args = {
					tooltip: tooltip,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
					return;
				}
	
				tooltip.draw();
	
				plugins.notify(me, 'afterTooltipDraw', [args]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			/**
			 * @private
			 */
			destroyDatasetMeta: function(datasetIndex) {
				var id = this.id;
				var dataset = this.data.datasets[datasetIndex];
				var meta = dataset._meta && dataset._meta[id];
	
				if (meta) {
					meta.controller.destroy();
					delete dataset._meta[id];
				}
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.canvas;
				var i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.destroyDatasetMeta(i);
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.canvas.clear(me);
					platform.releaseContext(me.ctx);
					me.canvas = null;
					me.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.canvas.toDataURL.apply(this.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me,
					_chartInstance: me, // deprecated, backward compatibility
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Elements used to detect size change should not be injected for non responsive charts.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i = 0, ilen = elements.length; i < ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// Invoke onHover hook
				// Need to call with native event here to not break backwards compatibility
				helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart instead.
		 * @class Chart.Controller
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.Controller = Chart;
	};


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	
	module.exports = function(Chart) {
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i = 0, ilen = data.length; i < ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			transition: function(easingValue) {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				for (; i < ilen; ++i) {
					elements[i].transition(easingValue);
				}
	
				if (meta.dataset) {
					meta.dataset.transition(easingValue);
				}
			},
	
			draw: function() {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				if (meta.dataset) {
					meta.dataset.draw();
				}
	
				for (; i < ilen; ++i) {
					elements[i].draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var getHoverColor = helpers.getHoverColor;
				var model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i = 0; i < count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length - 1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(301);
	var defaults = __webpack_require__(24);
	var helpers = __webpack_require__(14);
	
	module.exports = function(Chart) {
	
		// -- Basic js utility methods
	
		helpers.configMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					var tval = target[key] || {};
					var sval = source[key];
	
					if (key === 'scales') {
						// scale config merging is complex. Add our own function here for that
						target[key] = helpers.scaleMerge(tval, sval);
					} else if (key === 'scale') {
						// used in polar area & radar charts since there is only one scale
						target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.scaleMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					if (key === 'xAxes' || key === 'yAxes') {
						var slen = source[key].length;
						var i, type, scale;
	
						if (!target[key]) {
							target[key] = [];
						}
	
						for (i = 0; i < slen; ++i) {
							scale = source[key][i];
							type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
							if (i >= target[key].length) {
								target[key].push({});
							}
	
							if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
								// new/untyped scale or type changed: let's apply the new defaults
								// then merge source scale to correctly overwrite the defaults.
								helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
							} else {
								// scales type are the same
								helpers.merge(target[key][i], scale);
							}
						}
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.currentTarget || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientWidth;
			}
	
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientHeight;
			}
	
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers.color = !color ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = defaults.global.defaultColor;
				}
	
				return color(value);
			};
	
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	
	defaults._set('global', {
		responsive: true,
		responsiveAnimationDuration: 0,
		maintainAspectRatio: true,
		events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		showLines: true,
	
		// Element defaults defined in element extensions
		elements: {},
	
		// Layout options such as padding
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.construct(item, config);
			return this;
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	
	module.exports = function(Chart) {
	
		function filterByPosition(array, position) {
			return helpers.where(array, function(v) {
				return v.position === position;
			});
		}
	
		function sortByWeight(array, reverse) {
			array.forEach(function(v, i) {
				v._tmpIndex_ = i;
				return v;
			});
			array.sort(function(a, b) {
				var v0 = reverse ? b : a;
				var v1 = reverse ? a : b;
				return v0.weight === v1.weight ?
					v0._tmpIndex_ - v1._tmpIndex_ :
					v0.weight - v1.weight;
			});
			array.forEach(function(v) {
				delete v._tmpIndex_;
			});
		}
	
		/**
		 * @interface ILayoutItem
		 * @prop {String} position - The position of the item in the chart layout. Possible values are
		 * 'left', 'top', 'right', 'bottom', and 'chartArea'
		 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
		 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
		 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
		 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
		 * @prop {Function} getPadding -  Returns an object with padding on the edges
		 * @prop {Number} width - Width of item. Must be valid after update()
		 * @prop {Number} height - Height of item. Must be valid after update()
		 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
		 */
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			/**
			 * Register a box to a chart.
			 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
			 * @param {Chart} chart - the chart to use
			 * @param {ILayoutItem} item - the item to add to be layed out
			 */
			addBox: function(chart, item) {
				if (!chart.boxes) {
					chart.boxes = [];
				}
	
				// initialize item with default values
				item.fullWidth = item.fullWidth || false;
				item.position = item.position || 'top';
				item.weight = item.weight || 0;
	
				chart.boxes.push(item);
			},
	
			/**
			 * Remove a layoutItem from a chart
			 * @param {Chart} chart - the chart to remove the box from
			 * @param {Object} layoutItem - the item to remove from the layout
			 */
			removeBox: function(chart, layoutItem) {
				var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
				if (index !== -1) {
					chart.boxes.splice(index, 1);
				}
			},
	
			/**
			 * Sets (or updates) options on the given `item`.
			 * @param {Chart} chart - the chart in which the item lives (or will be added to)
			 * @param {Object} item - the item to configure with the given options
			 * @param {Object} options - the new item options.
			 */
			configure: function(chart, item, options) {
				var props = ['fullWidth', 'position', 'weight'];
				var ilen = props.length;
				var i = 0;
				var prop;
	
				for (; i < ilen; ++i) {
					prop = props[i];
					if (options.hasOwnProperty(prop)) {
						item[prop] = options[prop];
					}
				}
			},
	
			/**
			 * Fits boxes of the given chart into the given size by having each box measure itself
			 * then running a fitting algorithm
			 * @param {Chart} chart - the chart
			 * @param {Number} width - the width to fit into
			 * @param {Number} height - the height to fit into
			 */
			update: function(chart, width, height) {
				if (!chart) {
					return;
				}
	
				var layoutOptions = chart.options.layout || {};
				var padding = helpers.options.toPadding(layoutOptions.padding);
				var leftPadding = padding.left;
				var rightPadding = padding.right;
				var topPadding = padding.top;
				var bottomPadding = padding.bottom;
	
				var leftBoxes = filterByPosition(chart.boxes, 'left');
				var rightBoxes = filterByPosition(chart.boxes, 'right');
				var topBoxes = filterByPosition(chart.boxes, 'top');
				var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
				var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');
	
				// Sort boxes by weight. A higher weight is further away from the chart area
				sortByWeight(leftBoxes, true);
				sortByWeight(rightBoxes, false);
				sortByWeight(topBoxes, true);
				sortByWeight(bottomBoxes, false);
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chart.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chart.chartArea.left;
					box.top = chart.chartArea.top;
					box.right = chart.chartArea.right;
					box.bottom = chart.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		plugins: {}
	});
	
	module.exports = function(Chart) {
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i = 0; i < ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults.global.plugins[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeDatasetUpdate
	 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
		 * returns `false`, the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetUpdate
	 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
		 * that this hook will not be called if the datasets update has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetDraw
	 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
		 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
		 * is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetDraw
	 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
		 * (datasets are drawn in the reverse order). Note that this hook will not be called
		 * if the datasets drawing has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
	  	 * @method IPlugin#beforeTooltipDraw
		 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
		 * the tooltip drawing is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.tooltip - The tooltip.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
	  	 */
		/**
	 	 * @method IPlugin#afterTooltipDraw
	  	 * @desc Called after drawing the `tooltip`. Note that this hook will not
	 	 * be called if the tooltip drawing has been previously cancelled.
	 	 * @param {Chart} chart - The chart instance.
	 	 * @param {Object} args - The call arguments.
	 	 * @param {Object} args.tooltip - The tooltip.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 	 * @param {Object} options - The plugin options.
	 	 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = Element.extend({});
	};


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	var Ticks = __webpack_require__(108);
	
	defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// line height
			lineHeight: 1.2,
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: Ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}
	
		return labels;
	}
	
	function getLineValue(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);
	
		if (offsetGridLines) {
			if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}
	
	module.exports = function(Chart) {
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var valueOrDefault = helpers.valueOrDefault;
			var globalDefaults = defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		function parseLineHeight(options) {
			return helpers.options.toLineHeight(
				helpers.valueOrDefault(options.lineHeight, 1.2),
				helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
		}
	
		Chart.Scale = Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			/**
			 * Returns the scale tick objects ({label, major})
			 * @since 2.7
			 */
			getTicks: function() {
				return this._ticks;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			mergeTicksOptions: function() {
				var ticks = this.options.ticks;
				if (ticks.minor === false) {
					ticks.minor = {
						display: false
					};
				}
				if (ticks.major === false) {
					ticks.major = {
						display: false
					};
				}
				for (var key in ticks) {
					if (key !== 'major' && key !== 'minor') {
						if (typeof ticks.minor[key] === 'undefined') {
							ticks.minor[key] = ticks[key];
						}
						if (typeof ticks.major[key] === 'undefined') {
							ticks.major[key] = ticks[key];
						}
					}
				}
			},
			beforeUpdate: function() {
				helpers.callback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
				var i, ilen, labels, label, ticks, tick;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks - `this.ticks` is now DEPRECATED!
				// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
				// and must not be accessed directly from outside this class. `this.ticks` being
				// around for long time and not marked as private, we can't change its structure
				// without unexpected breaking changes. If you need to access the scale ticks,
				// use scale.getTicks() instead.
	
				me.beforeBuildTicks();
	
				// New implementations should return an array of objects but for BACKWARD COMPAT,
				// we still support no return (`this.ticks` internally set by calling this method).
				ticks = me.buildTicks() || [];
	
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
	
				// New implementations should return the formatted tick labels but for BACKWARD
				// COMPAT, we still support no return (`this.ticks` internally changed by calling
				// this method and supposed to contain only string values).
				labels = me.convertTicksToLabels(ticks) || me.ticks;
	
				me.afterTickToLabelConversion();
	
				me.ticks = labels;   // BACKWARD COMPATIBILITY
	
				// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!
	
				// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
				for (i = 0, ilen = labels.length; i < ilen; ++i) {
					label = labels[i];
					tick = ticks[i];
					if (!tick) {
						ticks.push(tick = {
							label: label,
							major: false
						});
					} else {
						tick.label = label;
					}
				}
	
				me._ticks = ticks;
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
			},
			afterTickToLabelConversion: function() {
				helpers.callback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
				var labels = labelsFromTicks(me._ticks);
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (labels.length && me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation, sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var labels = labelsFromTicks(me._ticks);
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
					var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
					var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;
	
					if (isHorizontal) {
						minSize.height += deltaHeight;
					} else {
						minSize.width += deltaHeight;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
					var lineSpace = tickFont.size * 0.5;
					var tickPadding = me.options.ticks.padding;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * (tallestLabelHeightInLines - 1))
							+ lineSpace; // padding
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
						me.ctx.font = tickFont.font;
						var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
						var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
						// which means that the right padding is dominated by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the
						// dominant factor here, so get that length first and account for padding
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							// use lineSpace for consistency with horizontal axis
							// tickPadding is not implemented for horizontal
							largestTextWidth += tickPadding + lineSpace;
						}
	
						minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
	
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (helpers.isNullOrUndef(rawValue)) {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof rawValue === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (rawValue) {
					if (this.isHorizontal()) {
						if (rawValue.x !== undefined) {
							return this.getRightValue(rawValue.x);
						}
					} else if (rawValue.y !== undefined) {
						return this.getRightValue(rawValue.y);
					}
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			/**
			 * Used to get the value to display in the tooltip for the data at the given index
			 * @param index
			 * @param datasetIndex
			 */
			getLabelForIndex: helpers.noop,
	
			/**
			 * Returns the location of the given data point. Value can either be an index or a numerical value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param value
			 * @param index
			 * @param datasetIndex
			 */
			getPixelForValue: helpers.noop,
	
			/**
			 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param pixel
			 */
			getValueForPixel: helpers.noop,
	
			/**
			 * Returns the location of the tick at the given index
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForTick: function(index) {
				var me = this;
				var offset = me.options.offset;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (offset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me._ticks.length - 1)));
			},
	
			/**
			 * Utility for getting the pixel location of a percentage of scale
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForDecimal: function(decimal) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			/**
			 * Returns the pixel for the minimum chart value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0;
			},
	
			/**
			 * Returns a subset of ticks to be plotted to avoid overlapping labels.
			 * @private
			 */
			_autoSkip: function(ticks) {
				var skipRatio;
				var me = this;
				var isHorizontal = me.isHorizontal();
				var optionTicks = me.options.ticks.minor;
				var tickCount = ticks.length;
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
				var result = [];
				var i, tick, shouldSkip;
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				if (isHorizontal) {
					skipRatio = false;
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && tickCount > maxTicks) {
						skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
					}
				}
	
				for (i = 0; i < tickCount; i++) {
					tick = ticks[i];
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
					if (shouldSkip && i !== tickCount - 1) {
						// leave tick in place but make sure it's not displayed (#4635)
						delete tick.label;
					}
					result.push(tick);
				}
				return result;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = defaults.global;
				var optionTicks = options.ticks.minor;
				var optionMajorTicks = options.ticks.major || optionTicks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var isHorizontal = me.isHorizontal();
	
				var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
				var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
				var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
				var majorTickFont = parseFontOptions(optionMajorTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
	
				var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
	
				var itemsToDraw = [];
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(ticks, function(tick, index) {
					// autoskipper skipped this tick (#4635)
					if (helpers.isNullOrUndef(tick.label)) {
						return;
					}
	
					var label = tick.label;
					var lineWidth, lineColor, borderDash, borderDashOffset;
					if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
						borderDash = gridLines.zeroLineBorderDash;
						borderDashOffset = gridLines.zeroLineBorderDashOffset;
					} else {
						lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
						borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
						borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
					var tickPadding = optionTicks.padding;
	
					if (isHorizontal) {
						var labelYOffset = tl + tickPadding;
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated ? 'top' : 'middle';
							textAlign = !isRotated ? 'center' : 'right';
							labelY = me.top + labelYOffset;
						} else {
							// top
							textBaseline = !isRotated ? 'bottom' : 'middle';
							textAlign = !isRotated ? 'center' : 'left';
							labelY = me.bottom - labelYOffset;
						}
	
						var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (xLineValue < me.left) {
							lineColor = 'rgba(0,0,0,0)';
						}
						xLineValue += helpers.aliasPixel(lineWidth);
	
						labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (yLineValue < me.top) {
							lineColor = 'rgba(0,0,0,0)';
						}
						yLineValue += helpers.aliasPixel(lineWidth);
	
						labelY = me.getPixelForTick(index) + optionTicks.labelOffset;
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						major: tick.major,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						// Make sure we draw text in the correct color and font
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
						context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
					var halfLineHeight = parseLineHeight(scaleLabel) / 2;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom'
							? me.bottom - halfLineHeight - scaleLabelPadding.bottom
							: me.top + halfLineHeight + scaleLabelPadding.top;
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft
							? me.left + halfLineHeight + scaleLabelPadding.top
							: me.right - halfLineHeight - scaleLabelPadding.top;
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left;
					var x2 = me.right;
					var y1 = me.top;
					var y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var helpers = __webpack_require__(14);
	
	module.exports = function(Chart) {
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, scaleDefaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(scaleDefaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var me = this;
				if (me.defaults.hasOwnProperty(type)) {
					me.defaults[type] = helpers.extend(me.defaults[type], additions);
				}
			},
			addScalesToLayout: function(chart) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chart.scales, function(scale) {
					// Set ILayoutItem parameters for backwards compatibility
					scale.fullWidth = scale.options.fullWidth;
					scale.position = scale.options.position;
					scale.weight = scale.options.weight;
					Chart.layoutService.addBox(chart, scale);
				});
			}
		};
	};


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					label += tooltipItem.yLabel;
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		}
	});
	
	module.exports = function(Chart) {
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index;
			var datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors,
				borderColor: tooltipOpts.borderColor,
				borderWidth: tooltipOpts.borderWidth
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize;
			var bodyFontSize = model.bodyFontSize;
			var footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chart.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize;
			var caretPadding = vm.caretPadding;
			var cornerRadius = vm.cornerRadius;
			var xAlign = alignment.xAlign;
			var yAlign = alignment.yAlign;
			var paddingAndSize = caretSize + caretPadding;
			var radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
				this._lastActive = [];
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
				var title = callbacks.title.apply(me, arguments);
				var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					var labelTextColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
						labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
					});
	
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = opts.caretPadding;
					model.labelColors = labelColors;
					model.labelTextColors = labelTextColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size) {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
				ctx.lineTo(caretPosition.x1, caretPosition.y1);
				ctx.lineTo(caretPosition.x2, caretPosition.y2);
				ctx.lineTo(caretPosition.x3, caretPosition.y3);
			},
			getCaretPosition: function(tooltipPoint, size, vm) {
				var x1, x2, x3, y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var ptX = tooltipPoint.x;
				var ptY = tooltipPoint.y;
				var width = size.width;
				var height = size.height;
	
				if (yAlign === 'center') {
					y2 = ptY + (height / 2);
	
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
	
						y1 = y2 + caretSize;
						y3 = y2 - caretSize;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
	
						y1 = y2 - caretSize;
						y3 = y2 + caretSize;
					}
				} else {
					if (xAlign === 'left') {
						x2 = ptX + cornerRadius + (caretSize);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x2 = ptX + width - cornerRadius - caretSize;
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
						// invert drawing order
						var tmp = x3;
						x3 = x1;
						x1 = tmp;
					}
				}
				return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize;
					var titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
					ctx.fillStyle = textColor;
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.lineWidth = 1;
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
				ctx.lineWidth = vm.borderWidth;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var x = pt.x;
				var y = pt.y;
				var width = tooltipSize.width;
				var height = tooltipSize.height;
				var radius = vm.cornerRadius;
	
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				if (yAlign === 'top') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				if (yAlign === 'center' && xAlign === 'right') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				if (yAlign === 'bottom') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				if (yAlign === 'center' && xAlign === 'left') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
	
				ctx.fill();
	
				if (vm.borderWidth > 0) {
					ctx.stroke();
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				// Truthy/falsey value for empty tooltip
				var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
				if (this._options.enabled && hasTooltipContent) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
	
				// If tooltip didn't change, do not handle the target event
				if (!changed) {
					return false;
				}
	
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len, nearestElement;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2
			}
		}
	});
	
	module.exports = Element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;
	
			ctx.beginPath();
	
			ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
			ctx.closePath();
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
	
			ctx.fillStyle = vm.backgroundColor;
	
			ctx.fill();
			ctx.lineJoin = 'bevel';
	
			if (vm.borderWidth) {
				ctx.stroke();
			}
		}
	});


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	var globalDefaults = defaults.global;
	
	defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: globalDefaults.defaultColor,
				borderWidth: 3,
				borderColor: globalDefaults.defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	module.exports = Element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;
	
			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;
	
			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers.previousItem(points, index);
				currentVM = current._view;
	
				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	var defaultColor = defaults.global.defaultColor;
	
	defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor,
				borderColor: defaultColor,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}
	
	module.exports = Element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var model = this._model;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var color = helpers.color;
			var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
			var ratio = 0;
	
			if (vm.skip) {
				return;
			}
	
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
	
			// Cliping for Points.
			// going out from inner charArea?
			if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
				// Point fade out
				if (model.x < chartArea.left) {
					ratio = (x - model.x) / (chartArea.left - model.x);
				} else if (chartArea.right * errMargin < model.x) {
					ratio = (model.x - x) / (model.x - chartArea.right);
				} else if (model.y < chartArea.top) {
					ratio = (y - model.y) / (chartArea.top - model.y);
				} else if (chartArea.bottom * errMargin < model.y) {
					ratio = (model.y - y) / (model.y - chartArea.bottom);
				}
				ratio = Math.round(ratio * 100) / 100;
				ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
				ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
			}
	
			helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
		}
	});


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	
	defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: defaults.global.defaultColor,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(bar) {
		return bar._view.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(bar) {
		var vm = bar._view;
		var x1, x2, y1, y2;
	
		if (isVertical(bar)) {
			// vertical
			var halfWidth = vm.width / 2;
			x1 = vm.x - halfWidth;
			x2 = vm.x + halfWidth;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			// horizontal bar
			var halfHeight = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - halfHeight;
			y2 = vm.y + halfHeight;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	module.exports = Element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped;
			var borderWidth = vm.borderWidth;
	
			if (!vm.horizontal) {
				// bar
				left = vm.x - vm.width / 2;
				right = vm.x + vm.width / 2;
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top ? 1 : -1;
				borderSkipped = vm.borderSkipped || 'bottom';
			} else {
				// horizontal bar
				left = vm.base;
				right = vm.x;
				top = vm.y - vm.height / 2;
				bottom = vm.y + vm.height / 2;
				signX = right > left ? 1 : -1;
				signY = 1;
				borderSkipped = vm.borderSkipped || 'left';
			}
	
			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
				// borderWidth shold be less than bar width and bar height.
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
				borderWidth = borderWidth > barSize ? barSize : borderWidth;
				var halfStroke = borderWidth / 2;
				// Adjust borderWidth when bar top position is near vm.base(zero).
				var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
				var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
				var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
				var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
				// not become a vertical line?
				if (borderLeft !== borderRight) {
					top = borderTop;
					bottom = borderBottom;
				}
				// not become a horizontal line?
				if (borderTop !== borderBottom) {
					left = borderLeft;
					right = borderRight;
				}
			}
	
			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;
	
			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			];
	
			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
				startCorner = 0;
			}
	
			function cornerAt(index) {
				return corners[(startCorner + index) % 4];
			}
	
			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);
	
			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i);
				ctx.lineTo(corner[0], corner[1]);
			}
	
			ctx.fill();
			if (borderWidth) {
				ctx.stroke();
			}
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			var inRange = false;
	
			if (this._view) {
				var bounds = getBarBounds(this);
				inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var me = this;
			if (!me._view) {
				return false;
			}
	
			var inRange = false;
			var bounds = getBarBounds(me);
	
			if (isVertical(me)) {
				inRange = mouseX >= bounds.left && mouseX <= bounds.right;
			} else {
				inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inXRange: function(mouseX) {
			var bounds = getBarBounds(this);
			return mouseX >= bounds.left && mouseX <= bounds.right;
		},
	
		inYRange: function(mouseY) {
			var bounds = getBarBounds(this);
			return mouseY >= bounds.top && mouseY <= bounds.bottom;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(this)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
			return vm.width * Math.abs(vm.y - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(135);
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports = module.exports = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {Number} width - The rectangle's width.
		 * @param {Number} height - The rectangle's height.
		 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var rx = Math.min(radius, width / 2);
				var ry = Math.min(radius, height / 2);
	
				ctx.moveTo(x + rx, y);
				ctx.lineTo(x + width - rx, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
				ctx.lineTo(x + width, y + height - ry);
				ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
				ctx.lineTo(x + rx, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
				ctx.lineTo(x, y + ry);
				ctx.quadraticCurveTo(x, y, x + rx, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (style) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				ctx.beginPath();
				this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			if (target.steppedLine) {
				if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.clear = exports.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports.roundedRect.apply(exports, arguments);
		ctx.closePath();
	};


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(135);
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	module.exports = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.easingEffects = effects;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(135);
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	module.exports = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {Number|Object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {Object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array[]} inputs - An array of values, falling back to the last value.
		 * @param {Object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {Number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};


/***/ },
/* 892 */
/***/ function(module, exports) {

	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	module.exports = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Chart.Platform implementation for targeting a web browser
	 */
	
	'use strict';
	
	var helpers = __webpack_require__(14);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {Number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addEventListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeEventListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var resizer = document.createElement('div');
		var cls = CSS_PREFIX + 'size-monitor';
		var maxSize = 1000000;
		var style =
			'position:absolute;' +
			'left:0;' +
			'top:0;' +
			'right:0;' +
			'bottom:0;' +
			'overflow:hidden;' +
			'pointer-events:none;' +
			'visibility:hidden;' +
			'z-index:-1;';
	
		resizer.style.cssText = style;
		resizer.className = cls;
		resizer.innerHTML =
			'<div class="' + cls + '-expand" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:' + maxSize + 'px;' +
					'height:' + maxSize + 'px;' +
					'left:0;' +
					'top:0">' +
				'</div>' +
			'</div>' +
			'<div class="' + cls + '-shrink" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:200%;' +
					'height:200%;' +
					'left:0; ' +
					'top:0">' +
				'</div>' +
			'</div>';
	
		var expand = resizer.childNodes[0];
		var shrink = resizer.childNodes[1];
	
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			addEventListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers.each(ANIMATION_START_EVENTS, function(type) {
				removeEventListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				return listener(createEvent('resize', chart));
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	function injectCSS(platform, css) {
		// http://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}
	
		style.appendChild(document.createTextNode(css));
	}
	
	module.exports = {
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		initialize: function() {
			var keyframes = 'from{opacity:0.99}to{opacity:1}';
	
			injectCSS(this,
				// DOM rendering detection
				// https://davidwalsh.name/detect-node-insertion
				'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'.' + CSS_RENDER_MONITOR + '{' +
					'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
					'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'}'
			);
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addEventListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas, listener);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeEventListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.addEvent = addEventListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.removeEvent = removeEventListener;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Plugin based on discussion from the following Chart.js issues:
	 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
	 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
	 */
	
	'use strict';
	
	var defaults = __webpack_require__(24);
	var elements = __webpack_require__(66);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	module.exports = function() {
	
		var mappers = {
			dataset: function(source) {
				var index = source.fill;
				var chart = source.chart;
				var meta = chart.getDatasetMeta(index);
				var visible = meta && chart.isDatasetVisible(index);
				var points = (visible && meta.dataset._children) || [];
				var length = points.length || 0;
	
				return !length ? null : function(point, i) {
					return (i < length && points[i]._view) || null;
				};
			},
	
			boundary: function(source) {
				var boundary = source.boundary;
				var x = boundary ? boundary.x : null;
				var y = boundary ? boundary.y : null;
	
				return function(point) {
					return {
						x: x === null ? point.x : x,
						y: y === null ? point.y : y,
					};
				};
			}
		};
	
		// @todo if (fill[0] === '#')
		function decodeFill(el, index, count) {
			var model = el._model || {};
			var fill = model.fill;
			var target;
	
			if (fill === undefined) {
				fill = !!model.backgroundColor;
			}
	
			if (fill === false || fill === null) {
				return false;
			}
	
			if (fill === true) {
				return 'origin';
			}
	
			target = parseFloat(fill, 10);
			if (isFinite(target) && Math.floor(target) === target) {
				if (fill[0] === '-' || fill[0] === '+') {
					target = index + target;
				}
	
				if (target === index || target < 0 || target >= count) {
					return false;
				}
	
				return target;
			}
	
			switch (fill) {
			// compatibility
			case 'bottom':
				return 'start';
			case 'top':
				return 'end';
			case 'zero':
				return 'origin';
			// supported boundaries
			case 'origin':
			case 'start':
			case 'end':
				return fill;
			// invalid fill values
			default:
				return false;
			}
		}
	
		function computeBoundary(source) {
			var model = source.el._model || {};
			var scale = source.el._scale || {};
			var fill = source.fill;
			var target = null;
			var horizontal;
	
			if (isFinite(fill)) {
				return null;
			}
	
			// Backward compatibility: until v3, we still need to support boundary values set on
			// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
			// controllers might still use it (e.g. the Smith chart).
	
			if (fill === 'start') {
				target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
			} else if (fill === 'end') {
				target = model.scaleTop === undefined ? scale.top : model.scaleTop;
			} else if (model.scaleZero !== undefined) {
				target = model.scaleZero;
			} else if (scale.getBasePosition) {
				target = scale.getBasePosition();
			} else if (scale.getBasePixel) {
				target = scale.getBasePixel();
			}
	
			if (target !== undefined && target !== null) {
				if (target.x !== undefined && target.y !== undefined) {
					return target;
				}
	
				if (typeof target === 'number' && isFinite(target)) {
					horizontal = scale.isHorizontal();
					return {
						x: horizontal ? target : null,
						y: horizontal ? null : target
					};
				}
			}
	
			return null;
		}
	
		function resolveTarget(sources, index, propagate) {
			var source = sources[index];
			var fill = source.fill;
			var visited = [index];
			var target;
	
			if (!propagate) {
				return fill;
			}
	
			while (fill !== false && visited.indexOf(fill) === -1) {
				if (!isFinite(fill)) {
					return fill;
				}
	
				target = sources[fill];
				if (!target) {
					return false;
				}
	
				if (target.visible) {
					return fill;
				}
	
				visited.push(fill);
				fill = target.fill;
			}
	
			return false;
		}
	
		function createMapper(source) {
			var fill = source.fill;
			var type = 'dataset';
	
			if (fill === false) {
				return null;
			}
	
			if (!isFinite(fill)) {
				type = 'boundary';
			}
	
			return mappers[type](source);
		}
	
		function isDrawable(point) {
			return point && !point.skip;
		}
	
		function drawArea(ctx, curve0, curve1, len0, len1) {
			var i;
	
			if (!len0 || !len1) {
				return;
			}
	
			// building first area curve (normal)
			ctx.moveTo(curve0[0].x, curve0[0].y);
			for (i = 1; i < len0; ++i) {
				helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
			}
	
			// joining the two area curves
			ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
			// building opposite area curve (reverse)
			for (i = len1 - 1; i > 0; --i) {
				helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
			}
		}
	
		function doFill(ctx, points, mapper, view, color, loop) {
			var count = points.length;
			var span = view.spanGaps;
			var curve0 = [];
			var curve1 = [];
			var len0 = 0;
			var len1 = 0;
			var i, ilen, index, p0, p1, d0, d1;
	
			ctx.beginPath();
	
			for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
				index = i % count;
				p0 = points[index]._view;
				p1 = mapper(p0, index, view);
				d0 = isDrawable(p0);
				d1 = isDrawable(p1);
	
				if (d0 && d1) {
					len0 = curve0.push(p0);
					len1 = curve1.push(p1);
				} else if (len0 && len1) {
					if (!span) {
						drawArea(ctx, curve0, curve1, len0, len1);
						len0 = len1 = 0;
						curve0 = [];
						curve1 = [];
					} else {
						if (d0) {
							curve0.push(p0);
						}
						if (d1) {
							curve1.push(p1);
						}
					}
				}
			}
	
			drawArea(ctx, curve0, curve1, len0, len1);
	
			ctx.closePath();
			ctx.fillStyle = color;
			ctx.fill();
		}
	
		return {
			id: 'filler',
	
			afterDatasetsUpdate: function(chart, options) {
				var count = (chart.data.datasets || []).length;
				var propagate = options.propagate;
				var sources = [];
				var meta, i, el, source;
	
				for (i = 0; i < count; ++i) {
					meta = chart.getDatasetMeta(i);
					el = meta.dataset;
					source = null;
	
					if (el && el._model && el instanceof elements.Line) {
						source = {
							visible: chart.isDatasetVisible(i),
							fill: decodeFill(el, i, count),
							chart: chart,
							el: el
						};
					}
	
					meta.$filler = source;
					sources.push(source);
				}
	
				for (i = 0; i < count; ++i) {
					source = sources[i];
					if (!source) {
						continue;
					}
	
					source.fill = resolveTarget(sources, i, propagate);
					source.boundary = computeBoundary(source);
					source.mapper = createMapper(source);
				}
			},
	
			beforeDatasetDraw: function(chart, args) {
				var meta = args.meta.$filler;
				if (!meta) {
					return;
				}
	
				var ctx = chart.ctx;
				var el = meta.el;
				var view = el._view;
				var points = el._children || [];
				var mapper = meta.mapper;
				var color = view.backgroundColor || defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers.canvas.unclipArea(ctx);
				}
			}
		};
	};


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},
	
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});
	
	module.exports = function(Chart) {
	
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels || {};
				var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = defaults.global;
				var valueOrDefault = helpers.valueOrDefault;
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = defaults.global;
				var lineDefault = globalDefault.elements.line;
				var legendWidth = me.width;
				var lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx;
					var valueOrDefault = helpers.valueOrDefault;
					var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
					var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
					var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
					var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
					var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
					var cursor;
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'middle';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						var halfFontSize = fontSize / 2;
						var xLeft = boxWidth + halfFontSize + x;
						var yMiddle = y + halfFontSize;
	
						ctx.fillText(legendItem.text, xLeft, yMiddle);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(xLeft, yMiddle);
							ctx.lineTo(xLeft + textWidth, yMiddle);
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width;
						var width = boxWidth + (fontSize / 2) + textWidth;
						var x = cursor.x;
						var y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x;
				var y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chart, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chart.ctx,
				options: legendOpts,
				chart: chart
			});
	
			layout.configure(chart, legend, legendOpts);
			layout.addBox(chart, legend);
			chart.legend = legend;
		}
	
		return {
			id: 'legend',
	
			beforeInit: function(chart) {
				var legendOpts = chart.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chart, legendOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var legendOpts = chart.options.legend;
				var legend = chart.legend;
	
				if (legendOpts) {
					helpers.mergeIf(legendOpts, defaults.global.legend);
	
					if (legend) {
						layout.configure(chart, legend, legendOpts);
						legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chart, legendOpts);
					}
				} else if (legend) {
					layout.removeBox(chart, legend);
					delete chart.legend;
				}
			},
	
			afterEvent: function(chart, e) {
				var legend = chart.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		};
	};


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var Element = __webpack_require__(45);
	var helpers = __webpack_require__(14);
	
	defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			lineHeight: 1.2,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	module.exports = function(Chart) {
	
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		Chart.Title = Element.extend({
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var valueOrDefault = helpers.valueOrDefault;
				var opts = me.options;
				var display = opts.display;
				var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
				var minSize = me.minSize;
				var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = textSize;
				} else {
					minSize.width = textSize;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this;
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var opts = me.options;
				var globalDefaults = defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
					var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
					var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
					var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
					var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
					var offset = lineHeight / 2 + opts.padding;
					var rotation = 0;
					var top = me.top;
					var left = me.left;
					var bottom = me.bottom;
					var right = me.right;
					var maxWidth, titleX, titleY;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + offset;
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + offset : right - offset;
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
	
					var text = opts.text;
					if (helpers.isArray(text)) {
						var y = 0;
						for (var i = 0; i < text.length; ++i) {
							ctx.fillText(text[i], 0, y, maxWidth);
							y += lineHeight;
						}
					} else {
						ctx.fillText(text, 0, 0, maxWidth);
					}
	
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chart, titleOpts) {
			var title = new Chart.Title({
				ctx: chart.ctx,
				options: titleOpts,
				chart: chart
			});
	
			layout.configure(chart, title, titleOpts);
			layout.addBox(chart, title);
			chart.titleBlock = title;
		}
	
		return {
			id: 'title',
	
			beforeInit: function(chart) {
				var titleOpts = chart.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var titleOpts = chart.options.title;
				var titleBlock = chart.titleBlock;
	
				if (titleOpts) {
					helpers.mergeIf(titleOpts, defaults.global.title);
	
					if (titleBlock) {
						layout.configure(chart, titleBlock, titleOpts);
						titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chart, titleOpts);
					}
				} else if (titleBlock) {
					Chart.layoutService.removeBox(chart, titleBlock);
					delete chart.titleBlock;
				}
			}
		};
	};


/***/ },
/* 897 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
	
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = labels.indexOf(me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = labels.indexOf(me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index) {
				var me = this;
				var offset = me.options.offset;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);
	
				// If value is a data object, then index is the index in the data array,
				// not the index of the scale. We need to change that.
				var valueCategory;
				if (value !== undefined && value !== null) {
					valueCategory = me.isHorizontal() ? value.x : value.y;
				}
				if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
					var labels = me.getLabels();
					value = valueCategory || value;
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (offset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (offset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var offset = me.options.offset;
				var value;
				var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (offset) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value + me.minIndex;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var helpers = __webpack_require__(14);
	var Ticks = __webpack_require__(108);
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
	
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				var DEFAULT_MIN = 0;
				var DEFAULT_MAX = 1;
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
				me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	var Ticks = __webpack_require__(108);
	
	module.exports = function(Chart) {
	
		var noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			getRightValue: function(value) {
				if (typeof value === 'string') {
					return +value;
				}
				return Chart.Scale.prototype.getRightValue.call(this, value);
			},
	
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
				var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					if (me.min === null) {
						me.min = tickOpts.suggestedMin;
					} else {
						me.min = Math.min(me.min, tickOpts.suggestedMin);
					}
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					if (me.max === null) {
						me.max = tickOpts.suggestedMax;
					} else {
						me.max = Math.max(me.max, tickOpts.suggestedMax);
					}
				}
	
				if (setMin !== setMax) {
					// We set the min or the max but not both.
					// So ensure that our range is good
					// Inverted or 0 length range can happen when
					// ticks.min is set, and no datasets are visible
					if (me.min >= me.max) {
						if (setMin) {
							me.max = me.min + 1;
						} else {
							me.min = me.max - 1;
						}
					}
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(14);
	var Ticks = __webpack_require__(108);
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var valueOrDefault = helpers.valueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = valueOrDefault(tickOpts.min, me.min);
				me.max = valueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var opts = me.options;
				var tickOpts = opts.ticks;
				var innerDimension, pixel, range;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
						}
					} else if (newVal === 0) {
						pixel = tickOpts.reverse ? me.top : me.bottom;
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else { // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(24);
	var helpers = __webpack_require__(14);
	var Ticks = __webpack_require__(108);
	
	module.exports = function(Chart) {
	
		var globalDefaults = defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			gridLines: {
				circular: false
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Ticks.formatters.linear
			},
	
			pointLabels: {
				// Boolean - if true, show point labels
				display: true,
	
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			var opts = scale.options;
			return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				r: scale.width,
				l: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i, textSize, pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y += spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
	
				if (pointLabelOpts.display) {
					// Extra 3px out for some label spacing
					var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
					// Keep this in loop since we may support array properties here
					var pointLabelFontColor = valueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
					ctx.font = plFont.font;
					ctx.fillStyle = pointLabelFontColor;
	
					var angleRadians = scale.getIndexAngle(i);
					var angle = helpers.toDegrees(angleRadians);
					ctx.textAlign = getTextAlignForAngle(angle);
					adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
					fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
				}
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.gridLines.circular) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
	
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.pointLabels.display) {
					fitWithPointLabels(this);
				} else {
					fit(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea;
				var maxLeft = leftMovement + me.drawingArea;
				var maxTop = topMovement + me.drawingArea;
				var maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.ticks.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers.valueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
					var startAngle = this.getIndexAngle(0);
	
					// Tick Font
					var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || tickOpts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								ctx.save();
								ctx.translate(me.xCenter, me.yCenter);
								ctx.rotate(startAngle);
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										-labelWidth / 2 - tickOpts.backdropPaddingX,
										-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, 0, -yCenterOffset);
								ctx.restore();
							}
						}
					});
	
					if (opts.angleLines.display || opts.pointLabels.display) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(4);
	moment = typeof moment === 'function' ? moment : window.moment;
	
	var defaults = __webpack_require__(24);
	var helpers = __webpack_require__(14);
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	/**
	 * Convert the given value to a moment object using the given time options.
	 * @see http://momentjs.com/docs/#/parsing/
	 */
	function momentify(value, options) {
		var parser = options.parser;
		var format = options.parser || options.format;
	
		if (typeof parser === 'function') {
			return parser(value);
		}
	
		if (typeof value === 'string' && typeof format === 'string') {
			return moment(value, format);
		}
	
		if (!(value instanceof moment)) {
			value = moment(value);
		}
	
		if (value.isValid()) {
			return value;
		}
	
		// Labels are in an incompatible moment format and no `parser` has been provided.
		// The user might still use the deprecated `format` option to convert his inputs.
		if (typeof format === 'function') {
			return format(value);
		}
	
		return value;
	}
	
	function parse(input, scale) {
		if (helpers.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = momentify(scale.getRightValue(input), options);
		if (!value.isValid()) {
			return null;
		}
	
		if (options.round) {
			value.startOf(options.round);
		}
	
		return value.valueOf();
	}
	
	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;
	
		if (!steps) {
			return Math.ceil(range / ((capacity || 1) * milliseconds));
		}
	
		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}
	
		return factor;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(ticks, minUnit, min, max) {
		var duration = moment.duration(moment(max).diff(moment(min)));
		var ilen = UNITS.length;
		var i, unit;
	
		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(min, max, capacity, options) {
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = moment(min);
		var last = moment(max);
		var ticks = [];
		var time;
	
		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = first.isoWeekday(weekday);
			last = last.isoWeekday(weekday);
		}
	
		// Align first/last ticks on unit
		first = first.startOf(weekday ? 'day' : minor);
		last = last.startOf(weekday ? 'day' : minor);
	
		// Make sure that the last tick include max
		if (last < max) {
			last.add(1, minor);
		}
	
		time = moment(first);
	
		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time.startOf(major);
			time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}
	
		for (; time < last; time.add(stepSize, minor)) {
			ticks.push(+time);
		}
	
		ticks.push(+time);
	
		return ticks;
	}
	
	/**
	 * Returns the right and left offsets from edges in the form of {left, right}.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var left = 0;
		var right = 0;
		var upper, lower;
	
		if (options.offset && ticks.length) {
			if (!options.time.min) {
				upper = ticks.length > 1 ? ticks[1] : max;
				lower = ticks[0];
				left = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
			if (!options.time.max) {
				upper = ticks[ticks.length - 1];
				lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
				right = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
		}
	
		return {left: left, right: right};
	}
	
	function ticksFromTimestamps(values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;
	
		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;
	
			ticks.push({
				value: value,
				major: major
			});
		}
	
		return ticks;
	}
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'bottom',
	
			/**
			 * Data distribution along the scale:
			 * - 'linear': data are spread according to their time (distances can vary),
			 * - 'series': data are spread at the same distance from each other.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			distribution: 'linear',
	
			/**
			 * Scale boundary strategy (bypassed by min/max time options)
			 * - `data`: make sure data are fully visible, ticks outside are removed
			 * - `ticks`: make sure ticks are fully visible, data outside are truncated
			 * @see https://github.com/chartjs/Chart.js/pull/4556
			 * @since 2.7.0
			 */
			bounds: 'data',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm a', // 11:20 AM
					hour: 'hA', // 5PM
					day: 'MMM D', // Sep 4
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				},
			},
			ticks: {
				autoSkip: false,
	
				/**
				 * Ticks generation input values:
				 * - 'auto': generates "optimal" ticks based on scale size and time options.
				 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
				 * - 'labels': generates ticks from user given `data.labels` values ONLY.
				 * @see https://github.com/chartjs/Chart.js/pull/4507
				 * @since 2.7.0
				 */
				source: 'auto',
	
				major: {
					enabled: false
				}
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				this.mergeTicksOptions();
	
				Chart.Scale.prototype.initialize.call(this);
			},
	
			update: function() {
				var me = this;
				var options = me.options;
	
				// DEPRECATIONS: output a message only one time per update
				if (options.time && options.time.format) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser.');
				}
	
				return Chart.Scale.prototype.update.apply(me, arguments);
			},
	
			/**
			 * Allows data to be referenced via 't' attribute
			 */
			getRightValue: function(rawValue) {
				if (rawValue && rawValue.t !== undefined) {
					rawValue = rawValue.t;
				}
				return Chart.Scale.prototype.getRightValue.call(this, rawValue);
			},
	
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var timeOpts = me.options.time;
				var min = MAX_INTEGER;
				var max = MIN_INTEGER;
				var timestamps = [];
				var datasets = [];
				var labels = [];
				var i, j, ilen, jlen, data, timestamp;
	
				// Convert labels to timestamps
				for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
					labels.push(parse(chart.data.labels[i], me));
				}
	
				// Convert data to timestamps
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						data = chart.data.datasets[i].data;
	
						// Let's consider that all data have the same format.
						if (helpers.isObject(data[0])) {
							datasets[i] = [];
	
							for (j = 0, jlen = data.length; j < jlen; ++j) {
								timestamp = parse(data[j], me);
								timestamps.push(timestamp);
								datasets[i][j] = timestamp;
							}
						} else {
							timestamps.push.apply(timestamps, labels);
							datasets[i] = labels.slice(0);
						}
					} else {
						datasets[i] = [];
					}
				}
	
				if (labels.length) {
					// Sort labels **after** data have been converted
					labels = arrayUnique(labels).sort(sorter);
					min = Math.min(min, labels[0]);
					max = Math.max(max, labels[labels.length - 1]);
				}
	
				if (timestamps.length) {
					timestamps = arrayUnique(timestamps).sort(sorter);
					min = Math.min(min, timestamps[0]);
					max = Math.max(max, timestamps[timestamps.length - 1]);
				}
	
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// In case there is no valid min/max, let's use today limits
				min = min === MAX_INTEGER ? +moment().startOf('day') : min;
				max = max === MIN_INTEGER ? +moment().endOf('day') + 1 : max;
	
				// Make sure that max is strictly higher than min (required by the lookup table)
				me.min = Math.min(min, max);
				me.max = Math.max(min + 1, max);
	
				// PRIVATE
				me._horizontal = me.isHorizontal();
				me._table = [];
				me._timestamps = {
					data: timestamps,
					datasets: datasets,
					labels: labels
				};
			},
	
			buildTicks: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
				var options = me.options;
				var timeOpts = options.time;
				var timestamps = [];
				var ticks = [];
				var i, ilen, timestamp;
	
				switch (options.ticks.source) {
				case 'data':
					timestamps = me._timestamps.data;
					break;
				case 'labels':
					timestamps = me._timestamps.labels;
					break;
				case 'auto':
				default:
					timestamps = generate(min, max, me.getLabelCapacity(min), options);
				}
	
				if (options.bounds === 'ticks' && timestamps.length) {
					min = timestamps[0];
					max = timestamps[timestamps.length - 1];
				}
	
				// Enforce limits with user min/max options
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// Remove ticks outside the min/max range
				for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
					timestamp = timestamps[i];
					if (timestamp >= min && timestamp <= max) {
						ticks.push(timestamp);
					}
				}
	
				me.min = min;
				me.max = max;
	
				// PRIVATE
				me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
				me._majorUnit = determineMajorUnit(me._unit);
				me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
				me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
				return ticksFromTimestamps(ticks, me._majorUnit);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var timeOpts = me.options.time;
				var label = data.labels && index < data.labels.length ? data.labels[index] : '';
				var value = data.datasets[datasetIndex].data[index];
	
				if (helpers.isObject(value)) {
					label = me.getRightValue(value);
				}
				if (timeOpts.tooltipFormat) {
					label = momentify(label, timeOpts).format(timeOpts.tooltipFormat);
				}
	
				return label;
			},
	
			/**
			 * Function to format an individual tick mark
			 * @private
			 */
			tickFormatFunction: function(tick, index, ticks, formatOverride) {
				var me = this;
				var options = me.options;
				var time = tick.valueOf();
				var formats = options.time.displayFormats;
				var minorFormat = formats[me._unit];
				var majorUnit = me._majorUnit;
				var majorFormat = formats[majorUnit];
				var majorTime = tick.clone().startOf(majorUnit).valueOf();
				var majorTickOpts = options.ticks.major;
				var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
				var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
				var tickOpts = major ? majorTickOpts : options.ticks.minor;
				var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				return formatter ? formatter(label, index, ticks) : label;
			},
	
			convertTicksToLabels: function(ticks) {
				var labels = [];
				var i, ilen;
	
				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
				}
	
				return labels;
			},
	
			/**
			 * @private
			 */
			getPixelForOffset: function(time) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = interpolate(me._table, 'time', time, 'pos');
	
				return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
			},
	
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var time = null;
	
				if (index !== undefined && datasetIndex !== undefined) {
					time = me._timestamps.datasets[datasetIndex][index];
				}
	
				if (time === null) {
					time = parse(value, me);
				}
	
				if (time !== null) {
					return me.getPixelForOffset(time);
				}
			},
	
			getPixelForTick: function(index) {
				var ticks = this.getTicks();
				return index >= 0 && index < ticks.length ?
					this.getPixelForOffset(ticks[index].value) :
					null;
			},
	
			getValueForPixel: function(pixel) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
				var time = interpolate(me._table, 'pos', pos, 'time');
	
				return moment(time);
			},
	
			/**
			 * Crude approximation of what the label width might be
			 * @private
			 */
			getLabelWidth: function(label) {
				var me = this;
				var ticksOpts = me.options.ticks;
				var tickLabelWidth = me.ctx.measureText(label).width;
				var angle = helpers.toRadians(ticksOpts.maxRotation);
				var cosRotation = Math.cos(angle);
				var sinRotation = Math.sin(angle);
				var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);
	
				return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
			},
	
			/**
			 * @private
			 */
			getLabelCapacity: function(exampleTime) {
				var me = this;
	
				var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation
	
				var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
				var tickLabelWidth = me.getLabelWidth(exampleLabel);
				var innerWidth = me.isHorizontal() ? me.width : me.height;
	
				return Math.floor(innerWidth / tickLabelWidth);
			}
		});
	
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	};


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(906);
	
	var emptyObject = __webpack_require__(904);
	var _invariant = __webpack_require__(905);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 906 */
30,
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	// @flow
	
	const docsSoap = __webpack_require__(909);
	const parseHTML = __webpack_require__(419);
	
	module.exports = {
	  default: docsSoap,
	  docsSoap: docsSoap,
	  parseHTML: parseHTML,
	};


/***/ },
/* 908 */
/***/ function(module, exports) {

	'use strict';
	
	var docsId = /id="docs\-internal\-guid/;
	
	var styles = {
	  BOLD: '700',
	  ITALIC: 'italic',
	  UNDERLINE: 'underline',
	  STRIKETHROUGH: 'line-through',
	  SUPERSCRIPT: 'super',
	  SUBSCRIPT: 'sub'
	};
	
	var elements = {
	  ANCHOR: 'a',
	  BOLD: 'strong',
	  ITALIC: 'em',
	  UNDERLINE: 'u',
	  STRIKETHROUGH: 'del',
	  SUPERSCRIPT: 'sup',
	  SUBSCRIPT: 'sub'
	};
	
	var headers = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	module.exports = { docsId: docsId, styles: styles, elements: elements, headers: headers };

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var constants = __webpack_require__(908);
	var parseHTML = __webpack_require__(419);
	
	var docsId = constants.docsId,
	    elements = constants.elements,
	    headers = constants.headers,
	    styles = constants.styles;
	
	
	var wrapNodeAnchor = function wrapNodeAnchor(node, href) {
	  var anchor = document.createElement(elements.ANCHOR);
	  anchor.href = href;
	  anchor.appendChild(node.cloneNode(true));
	  return anchor;
	};
	
	var wrapNodeInline = function wrapNodeInline(node, style) {
	  var el = document.createElement(style);
	  el.appendChild(node.cloneNode(true));
	  return el;
	};
	
	var wrapNode = function wrapNode(inner, result) {
	  var newNode = result.cloneNode(true);
	  if (!inner) {
	    return newNode;
	  }
	  if (inner.style && inner.style.fontWeight === styles.BOLD) {
	    newNode = wrapNodeInline(newNode, elements.BOLD);
	  }
	  if (inner.style && inner.style.fontStyle === styles.ITALIC) {
	    newNode = wrapNodeInline(newNode, elements.ITALIC);
	  }
	  if (inner.style && inner.style.textDecoration === styles.UNDERLINE) {
	    newNode = wrapNodeInline(newNode, elements.UNDERLINE);
	  }
	  if (inner.style && inner.style.textDecoration === styles.STRIKETHROUGH) {
	    newNode = wrapNodeInline(newNode, elements.STRIKETHROUGH);
	  }
	  if (inner.style && inner.style.verticalAlign === styles.SUPERSCRIPT) {
	    newNode = wrapNodeInline(newNode, elements.SUPERSCRIPT);
	  }
	  if (inner.style && inner.style.verticalAlign === styles.SUBSCRIPT) {
	    newNode = wrapNodeInline(newNode, elements.SUBSCRIPT);
	  }
	  return newNode;
	};
	
	var applyBlockStyles = function applyBlockStyles(dirty) {
	  var node = dirty.cloneNode(true);
	  var newNode = document.createTextNode(node.textContent);
	  var styledNode = document.createTextNode('');
	  if (node.childNodes[0] && node.childNodes[0].style) {
	    styledNode = node.childNodes[0];
	  }
	  if (node.childNodes[0] && node.childNodes[0].nodeName === 'A') {
	    // flow-ignore Flow doesn't recognize that a childNode can be an HTMLAnchorElement
	    newNode = wrapNodeAnchor(newNode.cloneNode(true), node.childNodes[0].href);
	    styledNode = node.childNodes[0].childNodes[0];
	  }
	  newNode = wrapNode(styledNode, newNode);
	  return newNode;
	};
	
	var applyInlineStyles = function applyInlineStyles(dirty) {
	  var node = dirty.cloneNode(true);
	  var newNode = document.createTextNode(node.textContent);
	  var styledNode = node;
	  if (node.nodeName === 'A') {
	    // flow-ignore Flow doesn't recognize that cloneNode() can return an HTMLAnchorElement
	    newNode = wrapNodeAnchor(newNode, node.href);
	    if (node.childNodes[0] && node.childNodes[0].style) {
	      styledNode = node.childNodes[0];
	    }
	  }
	  newNode = wrapNode(styledNode, newNode);
	  return newNode;
	};
	
	var getCleanNode = function getCleanNode(node) {
	  if (node.childNodes && (node.childNodes.length <= 1 || node.nodeName === 'OL' || node.nodeName === 'UL')) {
	    var newWrapper = null;
	    var newNode = document.createTextNode(node.textContent);
	    if (node.nodeName === 'UL' || node.nodeName === 'OL' || node.nodeName === 'LI') {
	      newWrapper = document.createElement(node.nodeName);
	      newNode = document.createDocumentFragment();
	      var items = [];
	      for (var i = 0; i < node.childNodes.length; i++) {
	        items.push.apply(items, _toConsumableArray(getCleanNode(node.childNodes[i])));
	      }
	      items.map(function (i) {
	        return newNode.appendChild(i);
	      });
	    } else if (headers.indexOf(node.nodeName) !== -1) {
	      newWrapper = document.createElement(node.nodeName);
	      newNode = applyInlineStyles(node.childNodes[0]);
	    } else if (node.nodeName === 'P') {
	      newWrapper = document.createElement('p');
	      newNode = applyBlockStyles(node);
	    } else if (node.nodeName === 'BR') {
	      newNode = node;
	    } else {
	      newWrapper = document.createElement('span');
	      newNode = applyInlineStyles(node);
	    }
	    if (newWrapper) {
	      newWrapper.appendChild(newNode);
	      return [newWrapper];
	    }
	    return [node.cloneNode(true)];
	  }
	  if (node.childNodes) {
	    var nodes = [];
	    for (var _i = 0; _i < node.childNodes.length; _i++) {
	      nodes.push.apply(nodes, _toConsumableArray(getCleanNode(node.childNodes[_i])));
	    }
	    return nodes;
	  }
	  return [node];
	};
	
	/**
	 * parses the given "dirty" clipboard content and returns a (mostly) clean
	 * HTML document with only the HTML content you want
	 * @param dirty
	 * @returns {HTMLElement}
	 */
	var getCleanDocument = function getCleanDocument(dirty) {
	  // create a new document to preserve the integrity of the original data
	  var body = document.createElement('body');
	  var nodes = dirty.childNodes;
	  var cleanNodes = [];
	
	  // for each top level node, clean it up recursively
	  for (var i = 0; i < nodes.length; i++) {
	    cleanNodes.push.apply(cleanNodes, _toConsumableArray(getCleanNode(nodes[i])));
	  }
	
	  // append all of the clean nodes to the new document
	  for (var _i2 = 0; _i2 < cleanNodes.length; _i2++) {
	    body.appendChild(cleanNodes[_i2].cloneNode(true));
	  }
	
	  // all clean
	  return body;
	};
	
	module.exports = function (clipboardContent) {
	  if (typeof clipboardContent !== 'string') {
	    throw new Error('Expected \'clipboardContent\' to be a string of HTML, received ' + (typeof clipboardContent === 'undefined' ? 'undefined' : _typeof(clipboardContent)));
	  }
	  if (clipboardContent.length <= 0) {
	    throw new Error('Expected clipboardContent to have content, received empty string');
	  }
	  if (!clipboardContent.match(docsId)) {
	    return parseHTML(clipboardContent.replace(/(\r\n|\n|\r)/, '')).outerHTML;
	  }
	  return getCleanDocument(parseHTML(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
	};

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _updateMutation = __webpack_require__(423);
	
	var _updateMutation2 = _interopRequireDefault(_updateMutation);
	
	var _rangeSort = __webpack_require__(136);
	
	var _rangeSort2 = _interopRequireDefault(_rangeSort);
	
	var _getElementHTML = __webpack_require__(421);
	
	var _getElementHTML2 = _interopRequireDefault(_getElementHTML);
	
	var _getElementTagLength = __webpack_require__(919);
	
	var _getElementTagLength2 = _interopRequireDefault(_getElementTagLength);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var converter = function converter() {
	  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var originalText = arguments[1];
	
	  return originalText;
	};
	
	exports.default = function (block, entityMap) {
	  var entityConverter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : converter;
	
	  var resultText = [].concat(_toConsumableArray(block.text));
	
	  var getEntityHTML = entityConverter;
	
	  if (entityConverter.__isMiddleware) {
	    getEntityHTML = entityConverter(converter);
	  }
	
	  if (Object.prototype.hasOwnProperty.call(block, 'entityRanges') && block.entityRanges.length > 0) {
	    var entities = block.entityRanges.sort(_rangeSort2.default);
	
	    var styles = block.inlineStyleRanges;
	
	    var _loop = function _loop(index) {
	      var entityRange = entities[index];
	      var entity = entityMap[entityRange.key];
	
	      var originalText = resultText.slice(entityRange.offset, entityRange.offset + entityRange.length).join('');
	
	      var entityHTML = getEntityHTML(entity, originalText);
	      var converted = (0, _getElementHTML2.default)(entityHTML, originalText) || originalText;
	
	      var prefixLength = (0, _getElementTagLength2.default)(entityHTML, 'start');
	      var suffixLength = (0, _getElementTagLength2.default)(entityHTML, 'end');
	
	      var updateLaterMutation = function updateLaterMutation(mutation, mutationIndex) {
	        if (mutationIndex > index || Object.prototype.hasOwnProperty.call(mutation, 'style')) {
	          return (0, _updateMutation2.default)(mutation, entityRange.offset, entityRange.length, converted.length, prefixLength, suffixLength);
	        }
	        return mutation;
	      };
	
	      var updateLaterMutations = function updateLaterMutations(mutationList) {
	        return mutationList.reduce(function (acc, mutation, mutationIndex) {
	          var updatedMutation = updateLaterMutation(mutation, mutationIndex);
	          if (Array.isArray(updatedMutation)) {
	            return acc.concat(updatedMutation);
	          }
	
	          return acc.concat([updatedMutation]);
	        }, []);
	      };
	
	      entities = updateLaterMutations(entities);
	      styles = updateLaterMutations(styles);
	
	      resultText = [].concat(_toConsumableArray(resultText.slice(0, entityRange.offset)), _toConsumableArray(converted), _toConsumableArray(resultText.slice(entityRange.offset + entityRange.length)));
	    };
	
	    for (var index = 0; index < entities.length; index++) {
	      _loop(index);
	    }
	
	    return Object.assign({}, block, {
	      text: resultText.join(''),
	      inlineStyleRanges: styles,
	      entityRanges: entities
	    });
	  }
	
	  return block;
	};

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _styleObjectFunction = __webpack_require__(921);
	
	var _styleObjectFunction2 = _interopRequireDefault(_styleObjectFunction);
	
	var _accumulateFunction = __webpack_require__(420);
	
	var _accumulateFunction2 = _interopRequireDefault(_accumulateFunction);
	
	var _getElementHTML = __webpack_require__(421);
	
	var _getElementHTML2 = _interopRequireDefault(_getElementHTML);
	
	var _rangeSort = __webpack_require__(136);
	
	var _rangeSort2 = _interopRequireDefault(_rangeSort);
	
	var _defaultInlineHTML = __webpack_require__(915);
	
	var _defaultInlineHTML2 = _interopRequireDefault(_defaultInlineHTML);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subtractStyles = function subtractStyles(original, toRemove) {
	  return original.filter(function (el) {
	    return !toRemove.some(function (elToRemove) {
	      return elToRemove.style === el.style;
	    });
	  });
	};
	
	var popEndingStyles = function popEndingStyles(styleStack, endingStyles) {
	  return endingStyles.reduceRight(function (stack, style) {
	    var styleToRemove = stack[stack.length - 1];
	
	    (0, _invariant2.default)(styleToRemove.style === style.style, 'Style ' + styleToRemove.style + ' to be removed doesn\'t match expected ' + style.style);
	
	    return stack.slice(0, -1);
	  }, styleStack);
	};
	
	var characterStyles = function characterStyles(offset, ranges) {
	  return ranges.filter(function (range) {
	    return offset >= range.offset && offset < range.offset + range.length;
	  });
	};
	
	var rangeIsSubset = function rangeIsSubset(firstRange, secondRange) {
	  // returns true if the second range is a subset of the first
	  var secondStartWithinFirst = firstRange.offset <= secondRange.offset;
	  var secondEndWithinFirst = firstRange.offset + firstRange.length >= secondRange.offset + secondRange.length;
	
	  return secondStartWithinFirst && secondEndWithinFirst;
	};
	
	var latestStyleLast = function latestStyleLast(s1, s2) {
	  // make sure longer-lasting styles are added first
	  var s2endIndex = s2.offset + s2.length;
	  var s1endIndex = s1.offset + s1.length;
	  return s2endIndex - s1endIndex;
	};
	
	var getStylesToReset = function getStylesToReset(remainingStyles, newStyles) {
	  var i = 0;
	  while (i < remainingStyles.length) {
	    if (newStyles.every(rangeIsSubset.bind(null, remainingStyles[i]))) {
	      i++;
	    } else {
	      return remainingStyles.slice(i);
	    }
	  }
	  return [];
	};
	
	var appendStartMarkup = function appendStartMarkup(inlineHTML, string, styleRange) {
	  return string + (0, _getElementHTML2.default)(inlineHTML(styleRange.style)).start;
	};
	
	var prependEndMarkup = function prependEndMarkup(inlineHTML, string, styleRange) {
	  return (0, _getElementHTML2.default)(inlineHTML(styleRange.style)).end + string;
	};
	
	var defaultCustomInlineHTML = function defaultCustomInlineHTML(next) {
	  return function (style) {
	    return next(style);
	  };
	};
	defaultCustomInlineHTML.__isMiddleware = true;
	
	exports.default = function (rawBlock) {
	  var customInlineHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomInlineHTML;
	
	  (0, _invariant2.default)(rawBlock !== null && rawBlock !== undefined, 'Expected raw block to be non-null');
	
	  var inlineHTML = void 0;
	  if (customInlineHTML.__isMiddleware === true) {
	    inlineHTML = customInlineHTML(_defaultInlineHTML2.default);
	  } else {
	    inlineHTML = (0, _accumulateFunction2.default)((0, _styleObjectFunction2.default)(customInlineHTML), (0, _styleObjectFunction2.default)(_defaultInlineHTML2.default));
	  }
	
	  var result = '';
	  var styleStack = [];
	
	  var sortedRanges = rawBlock.inlineStyleRanges.sort(_rangeSort2.default);
	
	  for (var i = 0; i < rawBlock.text.length; i++) {
	    var styles = characterStyles(i, sortedRanges);
	
	    var endingStyles = subtractStyles(styleStack, styles);
	    var newStyles = subtractStyles(styles, styleStack);
	    var remainingStyles = subtractStyles(styleStack, endingStyles);
	
	    // reset styles: look for any already existing styles that will need to
	    // end before styles that are being added on this character. to solve this
	    // close out those current tags and all nested children,
	    // then open new ones nested within the new styles.
	    var resetStyles = getStylesToReset(remainingStyles, newStyles);
	
	    var openingStyles = resetStyles.concat(newStyles).sort(latestStyleLast);
	
	    var openingStyleTags = openingStyles.reduce(appendStartMarkup.bind(null, inlineHTML), '');
	    var endingStyleTags = endingStyles.concat(resetStyles).reduce(prependEndMarkup.bind(null, inlineHTML), '');
	
	    result += endingStyleTags + openingStyleTags + rawBlock.text[i];
	
	    styleStack = popEndingStyles(styleStack, resetStyles.concat(endingStyles));
	    styleStack = styleStack.concat(openingStyles);
	
	    (0, _invariant2.default)(styleStack.length === styles.length, 'Character ' + i + ': ' + (styleStack.length - styles.length) + ' styles left on stack that should no longer be there');
	  }
	
	  result = styleStack.reduceRight(function (res, openStyle) {
	    return res + (0, _getElementHTML2.default)(inlineHTML(openStyle.style)).end;
	  }, result);
	
	  return result;
	};

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                               * All rights reserved.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                               * All rights reserved.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This source code is licensed under the BSD-style license found in the
	                                                                                                                                                                                                                                                                               * LICENSE file in the /src directory of this source tree. An additional grant
	                                                                                                                                                                                                                                                                               * of patent rights can be found in the PATENTS file in the same directory.
	                                                                                                                                                                                                                                                                               */
	
	var _immutable = __webpack_require__(16);
	
	var _draftJs = __webpack_require__(42);
	
	var _parseHTML = __webpack_require__(422);
	
	var _parseHTML2 = _interopRequireDefault(_parseHTML);
	
	var _rangeSort = __webpack_require__(136);
	
	var _rangeSort2 = _interopRequireDefault(_rangeSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	/* eslint-disable no-control-regex */
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	/* eslint-enable no-control-regex */
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'blockquote', 'pre'];
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var handleMiddleware = function handleMiddleware(maybeMiddleware, base) {
	  if (maybeMiddleware && maybeMiddleware.__isMiddleware === true) {
	    return maybeMiddleware(base);
	  }
	
	  return maybeMiddleware;
	};
	
	var defaultHTMLToBlock = function defaultHTMLToBlock(nodeName, node, lastList) {
	  return undefined;
	};
	
	var defaultHTMLToStyle = function defaultHTMLToStyle(nodeName, node, currentStyle) {
	  return currentStyle;
	};
	
	var defaultHTMLToEntity = function defaultHTMLToEntity(nodeName, node) {
	  return undefined;
	};
	
	var defaultTextToEntity = function defaultTextToEntity(text) {
	  return [];
	};
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error('Got unexpected null or undefined');
	};
	
	var sanitizeDraftText = function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	};
	
	function getEmptyChunk() {
	  return {
	    text: '',
	    inlines: [],
	    entities: [],
	    blocks: []
	  };
	}
	
	function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return {
	    text: SPACE,
	    inlines: [(0, _immutable.OrderedSet)()],
	    entities: entities,
	    blocks: []
	  };
	}
	
	function getSoftNewlineChunk(block, depth) {
	  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _immutable.Map)();
	
	  if (flat === true) {
	    return {
	      text: '\r',
	      inlines: [(0, _immutable.OrderedSet)()],
	      entities: new Array(1),
	      blocks: [{
	        type: block,
	        data: data,
	        depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	      }],
	      isNewline: true
	    };
	  }
	
	  return {
	    text: '\n',
	    inlines: [(0, _immutable.OrderedSet)()],
	    entities: new Array(1),
	    blocks: []
	  };
	}
	
	function getBlockDividerChunk(block, depth) {
	  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.Map)();
	
	  return {
	    text: '\r',
	    inlines: [(0, _immutable.OrderedSet)()],
	    entities: new Array(1),
	    blocks: [{
	      type: block,
	      data: data,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    }]
	  };
	}
	
	function getBlockTypeForTag(tag, lastList) {
	  switch (tag) {
	    case 'h1':
	      return 'header-one';
	    case 'h2':
	      return 'header-two';
	    case 'h3':
	      return 'header-three';
	    case 'h4':
	      return 'header-four';
	    case 'h5':
	      return 'header-five';
	    case 'h6':
	      return 'header-six';
	    case 'li':
	      if (lastList === 'ol') {
	        return 'ordered-list-item';
	      }
	      return 'unordered-list-item';
	    case 'blockquote':
	      return 'blockquote';
	    case 'pre':
	      return 'code-block';
	    case 'div':
	    case 'p':
	      return 'unstyled';
	    default:
	      return null;
	  }
	}
	
	function baseCheckBlockType(nodeName, node, lastList) {
	  return getBlockTypeForTag(nodeName, lastList);
	}
	
	function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    (function () {
	      var htmlElement = node;
	      currentStyle = currentStyle.withMutations(function (style) {
	        if (htmlElement.style.fontWeight === 'bold') {
	          style.add('BOLD');
	        }
	
	        if (htmlElement.style.fontStyle === 'italic') {
	          style.add('ITALIC');
	        }
	
	        if (htmlElement.style.textDecoration === 'underline') {
	          style.add('UNDERLINE');
	        }
	
	        if (htmlElement.style.textDecoration === 'line-through') {
	          style.add('STRIKETHROUGH');
	        }
	      }).toOrderedSet();
	    })();
	  }
	  return currentStyle;
	}
	
	function baseProcessInlineTag(tag, node) {
	  return processInlineTag(tag, node, (0, _immutable.OrderedSet)());
	}
	
	function joinChunks(A, B) {
	  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var firstInB = B.text.slice(0, 1);
	  var lastInA = A.text.slice(-1);
	
	  var adjacentDividers = lastInA === '\r' && firstInB === '\r';
	  var isJoiningBlocks = A.text !== '\r' && B.text !== '\r'; // when joining two full blocks like this we want to pop one divider
	  var addingNewlineToEmptyBlock = A.text === '\r' && !A.isNewline && B.isNewline; // when joining a newline to an empty block we want to remove the newline
	
	  if (adjacentDividers && (isJoiningBlocks || addingNewlineToEmptyBlock)) {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks if flat mode is on
	  if (A.text.slice(-1) === '\r' && flat === true) {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  var isNewline = A.text.length === 0 && B.isNewline;
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks),
	    isNewline: isNewline
	  };
	}
	
	/*
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	function containsSemanticBlockMarkup(html) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	}
	
	function genFragment(node, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, inEntity) {
	  var nodeName = node.nodeName.toLowerCase();
	  var newBlock = false;
	  var nextBlockType = 'unstyled';
	
	  // Base Case
	  if (nodeName === '#text') {
	    var _ret2 = function () {
	      var text = node.textContent;
	      if (text.trim() === '' && inBlock === null) {
	        return {
	          v: getEmptyChunk()
	        };
	      }
	
	      if (text.trim() === '' && inBlock !== 'code-block') {
	        return {
	          v: getWhitespaceChunk(inEntity)
	        };
	      }
	      if (inBlock !== 'code-block') {
	        // Can't use empty string because MSWord
	        text = text.replace(REGEX_LF, SPACE);
	      }
	
	      var entities = Array(text.length).fill(inEntity);
	
	      var offsetChange = 0;
	      var textEntities = checkEntityText(text).sort(_rangeSort2.default);
	      textEntities.forEach(function (_ref) {
	        var entity = _ref.entity,
	            offset = _ref.offset,
	            length = _ref.length,
	            result = _ref.result;
	
	        var adjustedOffset = offset + offsetChange;
	
	        if (result === null || result === undefined) {
	          result = text.substr(adjustedOffset, length);
	        }
	
	        var textArray = text.split('');
	        textArray.splice.bind(textArray, adjustedOffset, length).apply(textArray, result.split(''));
	        text = textArray.join('');
	
	        entities.splice.bind(entities, adjustedOffset, length).apply(entities, Array(result.length).fill(entity));
	        offsetChange += result.length - length;
	      });
	
	      return {
	        v: {
	          text: text,
	          inlines: Array(text.length).fill(inlineStyle),
	          entities: entities,
	          blocks: []
	        }
	      };
	    }();
	
	    if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	  }
	
	  // BR tags
	  if (nodeName === 'br') {
	    var _blockType = inBlock;
	
	    if (_blockType === null) {
	      //  BR tag is at top level, treat it as an unstyled block
	      return getSoftNewlineChunk('unstyled', depth, true);
	    }
	
	    return getSoftNewlineChunk(_blockType || 'unstyled', depth, options.flat);
	  }
	
	  var chunk = getEmptyChunk();
	  var newChunk = null;
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	  inlineStyle = processCustomInlineStyles(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	    inBlock = null;
	  }
	
	  // Block Tags
	  var blockInfo = checkBlockType(nodeName, node, lastList, inBlock);
	  var blockType = void 0;
	  var blockDataMap = void 0;
	
	  if (blockInfo === false) {
	    return getEmptyChunk();
	  }
	
	  blockInfo = blockInfo || {};
	
	  if (typeof blockInfo === 'string') {
	    blockType = blockInfo;
	    blockDataMap = (0, _immutable.Map)();
	  } else {
	    blockType = typeof blockInfo === 'string' ? blockInfo : blockInfo.type;
	    blockDataMap = blockInfo.data ? (0, _immutable.Map)(blockInfo.data) : (0, _immutable.Map)();
	  }
	  if (!inBlock && (fragmentBlockTags.indexOf(nodeName) !== -1 || blockType)) {
	    chunk = getBlockDividerChunk(blockType || getBlockTypeForTag(nodeName, lastList), depth, blockDataMap);
	    inBlock = blockType || getBlockTypeForTag(nodeName, lastList);
	    newBlock = true;
	  } else if (lastList && (inBlock === 'ordered-list-item' || inBlock === 'unordered-list-item') && nodeName === 'li') {
	    var listItemBlockType = getBlockTypeForTag(nodeName, lastList);
	    chunk = getBlockDividerChunk(listItemBlockType, depth);
	    inBlock = listItemBlockType;
	    newBlock = true;
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  } else if (inBlock && inBlock !== 'atomic' && blockType === 'atomic') {
	    inBlock = blockType;
	    newBlock = true;
	    chunk = getSoftNewlineChunk(blockType, depth, true, // atomic blocks within non-atomic blocks must always be split out
	    blockDataMap);
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	
	  // hack to allow conversion of atomic blocks from HTML (e.g. <figure><img
	  // src="..." /></figure>). since metadata must be stored on an entity text
	  // must exist for the entity to apply to. the way chunks are joined strips
	  // whitespace at the end so it cannot be a space character.
	
	  if (child == null && inEntity && (blockType === 'atomic' || inBlock === 'atomic')) {
	    child = document.createTextNode('a');
	  }
	
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    entityId = checkEntityNode(nodeName, child);
	
	    newChunk = genFragment(child, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, entityId || inEntity);
	
	    chunk = joinChunks(chunk, newChunk, options.flat);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (sibling && fragmentBlockTags.indexOf(nodeName) >= 0 && inBlock) {
	      var newBlockInfo = checkBlockType(nodeName, child, lastList, inBlock);
	
	      var newBlockType = void 0;
	      var newBlockData = void 0;
	
	      if (newBlockInfo !== false) {
	        newBlockInfo = newBlockInfo || {};
	
	        if (typeof newBlockInfo === 'string') {
	          newBlockType = newBlockInfo;
	          newBlockData = (0, _immutable.Map)();
	        } else {
	          newBlockType = newBlockInfo.type || getBlockTypeForTag(nodeName, lastList);
	          newBlockData = newBlockInfo.data ? (0, _immutable.Map)(newBlockInfo.data) : (0, _immutable.Map)();
	        }
	
	        chunk = joinChunks(chunk, getSoftNewlineChunk(newBlockType, depth, options.flat, newBlockData), options.flat);
	      }
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, (0, _immutable.Map)()), options.flat);
	  }
	
	  return chunk;
	}
	
	function getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, DOMBuilder) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html) ? blockTags.concat(['div']) : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to sta rt with.
	  var chunk = genFragment(safeBody, (0, _immutable.OrderedSet)(), 'ul', null, workingBlocks, -1, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options);
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push({ type: 'unstyled', data: (0, _immutable.Map)(), depth: 0 });
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', data: (0, _immutable.Map)(), depth: 0 });
	  }
	
	  return chunk;
	}
	
	function convertFromHTMLtoContentBlocks(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, DOMBuilder) {
	  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  var chunk = getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, options, DOMBuilder);
	  if (chunk == null) {
	    return [];
	  }
	  var start = 0;
	  return chunk.text.split('\r').map(function (textBlock, blockIndex) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	    var end = start + textBlock.length;
	    var inlines = nullthrows(chunk).inlines.slice(start, end);
	    var entities = nullthrows(chunk).entities.slice(start, end);
	    var characterList = (0, _immutable.List)(inlines.map(function (style, entityIndex) {
	      var data = { style: style, entity: null };
	      if (entities[entityIndex]) {
	        data.entity = entities[entityIndex];
	      }
	      return _draftJs.CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    return new _draftJs.ContentBlock({
	      key: (0, _draftJs.genKey)(),
	      type: nullthrows(chunk).blocks[blockIndex].type,
	      data: nullthrows(chunk).blocks[blockIndex].data,
	      depth: nullthrows(chunk).blocks[blockIndex].depth,
	      text: textBlock,
	      characterList: characterList
	    });
	  });
	}
	
	var convertFromHTML = function convertFromHTML(_ref2) {
	  var _ref2$htmlToStyle = _ref2.htmlToStyle,
	      htmlToStyle = _ref2$htmlToStyle === undefined ? defaultHTMLToStyle : _ref2$htmlToStyle,
	      _ref2$htmlToEntity = _ref2.htmlToEntity,
	      htmlToEntity = _ref2$htmlToEntity === undefined ? defaultHTMLToEntity : _ref2$htmlToEntity,
	      _ref2$textToEntity = _ref2.textToEntity,
	      textToEntity = _ref2$textToEntity === undefined ? defaultTextToEntity : _ref2$textToEntity,
	      _ref2$htmlToBlock = _ref2.htmlToBlock,
	      htmlToBlock = _ref2$htmlToBlock === undefined ? defaultHTMLToBlock : _ref2$htmlToBlock;
	  return function (html) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	      flat: false
	    };
	    var DOMBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _parseHTML2.default;
	
	    return _draftJs.ContentState.createFromBlockArray(convertFromHTMLtoContentBlocks(html, handleMiddleware(htmlToStyle, baseProcessInlineTag), handleMiddleware(htmlToEntity, defaultHTMLToEntity), handleMiddleware(textToEntity, defaultTextToEntity), handleMiddleware(htmlToBlock, baseCheckBlockType), options, DOMBuilder));
	  };
	};
	
	exports.default = function () {
	  if (arguments.length >= 1 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	    return convertFromHTML({}).apply(undefined, arguments);
	  }
	  return convertFromHTML.apply(undefined, arguments);
	};

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(173);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _draftJs = __webpack_require__(42);
	
	var _encodeBlock = __webpack_require__(916);
	
	var _encodeBlock2 = _interopRequireDefault(_encodeBlock);
	
	var _blockEntities = __webpack_require__(910);
	
	var _blockEntities2 = _interopRequireDefault(_blockEntities);
	
	var _blockInlineStyles = __webpack_require__(911);
	
	var _blockInlineStyles2 = _interopRequireDefault(_blockInlineStyles);
	
	var _accumulateFunction = __webpack_require__(420);
	
	var _accumulateFunction2 = _interopRequireDefault(_accumulateFunction);
	
	var _blockTypeObjectFunction = __webpack_require__(917);
	
	var _blockTypeObjectFunction2 = _interopRequireDefault(_blockTypeObjectFunction);
	
	var _getBlockTags = __webpack_require__(918);
	
	var _getBlockTags2 = _interopRequireDefault(_getBlockTags);
	
	var _getNestedBlockTags = __webpack_require__(920);
	
	var _getNestedBlockTags2 = _interopRequireDefault(_getNestedBlockTags);
	
	var _defaultBlockHTML = __webpack_require__(914);
	
	var _defaultBlockHTML2 = _interopRequireDefault(_defaultBlockHTML);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Immutable from 'immutable'; // eslint-disable-line no-unused-vars
	var NESTED_BLOCK_TYPES = ['ordered-list-item', 'unordered-list-item'];
	
	var defaultEntityToHTML = function defaultEntityToHTML(entity, originalText) {
	  return originalText;
	};
	
	var convertToHTML = function convertToHTML(_ref) {
	  var _ref$styleToHTML = _ref.styleToHTML,
	      styleToHTML = _ref$styleToHTML === undefined ? {} : _ref$styleToHTML,
	      _ref$blockToHTML = _ref.blockToHTML,
	      blockToHTML = _ref$blockToHTML === undefined ? {} : _ref$blockToHTML,
	      _ref$entityToHTML = _ref.entityToHTML,
	      entityToHTML = _ref$entityToHTML === undefined ? defaultEntityToHTML : _ref$entityToHTML;
	  return function (contentState) {
	    (0, _invariant2.default)(contentState !== null && contentState !== undefined, 'Expected contentState to be non-null');
	
	    var getBlockHTML = void 0;
	    if (blockToHTML.__isMiddleware === true) {
	      getBlockHTML = blockToHTML((0, _blockTypeObjectFunction2.default)(_defaultBlockHTML2.default));
	    } else {
	      getBlockHTML = (0, _accumulateFunction2.default)((0, _blockTypeObjectFunction2.default)(blockToHTML), (0, _blockTypeObjectFunction2.default)(_defaultBlockHTML2.default));
	    }
	
	    var rawState = (0, _draftJs.convertToRaw)(contentState);
	
	    var listStack = [];
	
	    var result = rawState.blocks.map(function (block) {
	      var type = block.type,
	          depth = block.depth;
	
	
	      var closeNestTags = '';
	      var openNestTags = '';
	
	      if (NESTED_BLOCK_TYPES.indexOf(type) === -1) {
	        // this block can't be nested, so reset all nesting if necessary
	        closeNestTags = listStack.reduceRight(function (string, nestedBlock) {
	          return string + (0, _getNestedBlockTags2.default)(getBlockHTML(nestedBlock)).nestEnd;
	        }, '');
	        listStack = [];
	      } else {
	        while (depth + 1 !== listStack.length || type !== listStack[depth].type) {
	          if (depth + 1 === listStack.length) {
	            // depth is right but doesn't match type
	            var blockToClose = listStack[depth];
	            closeNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(blockToClose)).nestEnd;
	            openNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(block)).nestStart;
	            listStack[depth] = block;
	          } else if (depth + 1 < listStack.length) {
	            var _blockToClose = listStack[listStack.length - 1];
	            closeNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(_blockToClose)).nestEnd;
	            listStack = listStack.slice(0, -1);
	          } else {
	            openNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(block)).nestStart;
	            listStack.push(block);
	          }
	        }
	      }
	
	      var innerHTML = (0, _blockInlineStyles2.default)((0, _blockEntities2.default)((0, _encodeBlock2.default)(block), rawState.entityMap, entityToHTML), styleToHTML);
	
	      var blockHTML = (0, _getBlockTags2.default)(getBlockHTML(block));
	
	      var html = void 0;
	
	      if (typeof blockHTML === 'string') {
	        html = blockHTML;
	      } else {
	        html = blockHTML.start + innerHTML + blockHTML.end;
	      }
	
	      if (innerHTML.length === 0 && Object.prototype.hasOwnProperty.call(blockHTML, 'empty')) {
	        if (_react2.default.isValidElement(blockHTML.empty)) {
	          html = _server2.default.renderToStaticMarkup(blockHTML.empty);
	        } else {
	          html = blockHTML.empty;
	        }
	      }
	
	      return closeNestTags + openNestTags + html;
	    }).join('');
	
	    result = listStack.reduce(function (res, nestBlock) {
	      return res + (0, _getNestedBlockTags2.default)(getBlockHTML(nestBlock)).nestEnd;
	    }, result);
	
	    return result;
	  };
	};
	
	exports.default = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 1 && Object.prototype.hasOwnProperty.call(args[0], '_map') && args[0].getBlockMap != null) {
	    // skip higher-order function and use defaults
	    return convertToHTML({}).apply(undefined, args);
	  }
	
	  return convertToHTML.apply(undefined, args);
	};

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  'unstyled': _react2.default.createElement('p', null),
	  'paragraph': _react2.default.createElement('p', null),
	  'header-one': _react2.default.createElement('h1', null),
	  'header-two': _react2.default.createElement('h2', null),
	  'header-three': _react2.default.createElement('h3', null),
	  'header-four': _react2.default.createElement('h4', null),
	  'header-five': _react2.default.createElement('h5', null),
	  'header-six': _react2.default.createElement('h6', null),
	  'blockquote': _react2.default.createElement('blockquote', null),
	  'unordered-list-item': {
	    element: _react2.default.createElement('li', null),
	    nest: _react2.default.createElement('ul', null)
	  },
	  'ordered-list-item': {
	    element: _react2.default.createElement('li', null),
	    nest: _react2.default.createElement('ol', null)
	  },
	  'media': _react2.default.createElement('figure', null)
	};

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultInlineHTML;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultInlineHTML(style) {
	  switch (style) {
	    case 'BOLD':
	      return _react2.default.createElement('strong', null);
	    case 'ITALIC':
	      return _react2.default.createElement('em', null);
	    case 'UNDERLINE':
	      return _react2.default.createElement('u', null);
	    case 'CODE':
	      return _react2.default.createElement('code', null);
	    default:
	      return {
	        start: '',
	        end: ''
	      };
	  }
	}

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _updateMutation = __webpack_require__(423);
	
	var _updateMutation2 = _interopRequireDefault(_updateMutation);
	
	var _rangeSort = __webpack_require__(136);
	
	var _rangeSort2 = _interopRequireDefault(_rangeSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ENTITY_MAP = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '\n': '<br/>'
	};
	
	exports.default = function (block) {
	  var blockText = [].concat(_toConsumableArray(block.text));
	
	  var entities = block.entityRanges.sort(_rangeSort2.default);
	  var styles = block.inlineStyleRanges.sort(_rangeSort2.default);
	  var resultText = '';
	
	  var _loop = function _loop(index) {
	    var char = blockText[index];
	
	    if (ENTITY_MAP[char] !== undefined) {
	      (function () {
	        var encoded = ENTITY_MAP[char];
	        var resultIndex = resultText.length;
	        resultText += encoded;
	
	        var updateForChar = function updateForChar(mutation) {
	          return (0, _updateMutation2.default)(mutation, resultIndex, char.length, encoded.length, 0, 0);
	        };
	
	        entities = entities.map(updateForChar);
	        styles = styles.map(updateForChar);
	      })();
	    } else {
	      resultText += char;
	    }
	  };
	
	  for (var index = 0; index < blockText.length; index++) {
	    _loop(index);
	  }
	
	  return Object.assign({}, block, {
	    text: resultText,
	    inlineStyleRanges: styles,
	    entityRanges: entities
	  });
	};

/***/ },
/* 917 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (typeObject) {
	  return function (block) {
	    if (typeof typeObject === 'function') {
	      // handle case where typeObject is already a function
	      return typeObject(block);
	    }
	
	    return typeObject[block.type];
	  };
	};

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBlockTags;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(173);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _splitReactElement = __webpack_require__(137);
	
	var _splitReactElement2 = _interopRequireDefault(_splitReactElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasChildren(element) {
	  return _react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) > 0;
	}
	
	function getBlockTags(blockHTML) {
	  (0, _invariant2.default)(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');
	
	  if (typeof blockHTML === 'string') {
	    return blockHTML;
	  }
	
	  if (_react2.default.isValidElement(blockHTML)) {
	    if (hasChildren(blockHTML)) {
	      return _server2.default.renderToStaticMarkup(blockHTML);
	    }
	
	    return (0, _splitReactElement2.default)(blockHTML);
	  }
	
	  if (Object.prototype.hasOwnProperty.call(blockHTML, 'element') && _react2.default.isValidElement(blockHTML.element)) {
	    return Object.assign({}, blockHTML, (0, _splitReactElement2.default)(blockHTML.element));
	  }
	
	  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(blockHTML, 'start') && Object.prototype.hasOwnProperty.call(blockHTML, 'end'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
	
	  return blockHTML;
	}

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _splitReactElement = __webpack_require__(137);
	
	var _splitReactElement2 = _interopRequireDefault(_splitReactElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (element) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';
	
	  if (_react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) === 0) {
	    return (0, _splitReactElement2.default)(element)[type].length;
	  }
	
	  if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object') {
	    return element[type] ? element[type].length : 0;
	  }
	
	  return 0;
	};

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getNestedBlockTags;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _splitReactElement2 = __webpack_require__(137);
	
	var _splitReactElement3 = _interopRequireDefault(_splitReactElement2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getNestedBlockTags(blockHTML) {
	  (0, _invariant2.default)(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');
	
	  if (_react2.default.isValidElement(blockHTML.nest)) {
	    var _splitReactElement = (0, _splitReactElement3.default)(blockHTML.nest),
	        start = _splitReactElement.start,
	        end = _splitReactElement.end;
	
	    return Object.assign({}, blockHTML, {
	      nestStart: start,
	      nestEnd: end
	    });
	  }
	
	  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(blockHTML, 'nestStart') && Object.prototype.hasOwnProperty.call(blockHTML, 'nestEnd'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
	
	  return blockHTML;
	}

/***/ },
/* 921 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (object) {
	  return function (style) {
	    if (typeof object === 'function') {
	      return object(style);
	    }
	
	    return object[style];
	  };
	};

/***/ },
/* 922 */
/***/ function(module, exports) {

	/**
	 * Return command for a keyboard event
	 *
	 * @param {SyntheticKeyboardEvent} event
	 * @return {String}
	 */
	function getKeyBinding(e) {}
	
	module.exports = getKeyBinding;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	var removeIndent = __webpack_require__(930);
	
	/**
	 * Handle key command for code blocks
	 *
	 * @param {Draft.EditorState} editorState
	 * @param {String} command
	 * @return {Boolean}
	 */
	function handleKeyCommand(editorState, command) {
	  if (command === 'backspace') {
	    return removeIndent(editorState);
	  }
	}
	
	module.exports = handleKeyCommand;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var Draft = __webpack_require__(42);
	var insertNewLine = __webpack_require__(929);
	
	/**
	 *  We split code blocks only if user pressed Cmd+Enter
	 *
	 * @param {SyntheticKeyboardEvent} event
	 * @param {Draft.EditorState} editorState
	 * @return {Draft.EditorState}
	 */
	function handleReturn(e, editorState) {
	  var contentState = editorState.getCurrentContent();
	  var selection = editorState.getSelection();
	
	  // Command+Return: As usual, split blocks
	  if (selection.isCollapsed() && Draft.KeyBindingUtil.hasCommandModifier(e)) {
	    var newContentState = Draft.Modifier.splitBlock(contentState, selection);
	    return Draft.EditorState.push(editorState, newContentState, 'split-block');
	  }
	
	  return insertNewLine(editorState);
	}
	
	module.exports = handleReturn;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var Draft = __webpack_require__(42);
	var getIndentation = __webpack_require__(424);
	
	// TODO: tab should complete indentation instead of just inserting one
	
	/**
	 * Handle pressing tab in the editor
	 *
	 * @param {SyntheticKeyboardEvent} event
	 * @param {Draft.EditorState} editorState
	 * @return {Draft.EditorState}
	 */
	function handleTab(e, editorState) {
	  e.preventDefault();
	
	  var contentState = editorState.getCurrentContent();
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  var currentBlock = contentState.getBlockForKey(startKey);
	
	  var indentation = getIndentation(currentBlock.getText());
	  var newContentState;
	
	  if (selection.isCollapsed()) {
	    newContentState = Draft.Modifier.insertText(
	      contentState,
	      selection,
	      indentation
	    );
	  } else {
	    newContentState = Draft.Modifier.replaceText(
	      contentState,
	      selection,
	      indentation
	    );
	  }
	
	  return Draft.EditorState.push(
	    editorState,
	    newContentState,
	    'insert-characters'
	  );
	}
	
	module.exports = handleTab;


/***/ },
/* 926 */
/***/ function(module, exports) {

	/**
	 * Return true if selection is inside a code block
	 *
	 * @param {Draft.EditorState} editorState
	 * @return {Boolean}
	 */
	function hasSelectionInBlock(editorState) {
	  var selection = editorState.getSelection();
	  var contentState = editorState.getCurrentContent();
	  var startKey = selection.getStartKey();
	  var currentBlock = contentState.getBlockForKey(startKey);
	
	  return currentBlock.getType() === 'code-block';
	}
	
	module.exports = hasSelectionInBlock;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  getKeyBinding: __webpack_require__(922),
	  hasSelectionInBlock: __webpack_require__(926),
	  handleKeyCommand: __webpack_require__(923),
	  handleReturn: __webpack_require__(924),
	  handleTab: __webpack_require__(925)
	};


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var detectIndent = __webpack_require__(427);
	
	/**
	 * Return indentation of a line
	 * @param {String} line
	 * @return {String}
	 */
	function getIndentForLine(line) {
	  return detectIndent(line).indent || '';
	}
	
	module.exports = getIndentForLine;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var Draft = __webpack_require__(42);
	var getNewLine = __webpack_require__(138);
	var getLines = __webpack_require__(426);
	var getLineAnchorForOffset = __webpack_require__(425);
	var getIndentForLine = __webpack_require__(928);
	
	/**
	 *  Insert a new line with right inden
	 *
	 * @param {SyntheticKeyboardEvent} event
	 * @param {Draft.EditorState} editorState
	 * @return {Draft.EditorState}
	 */
	function insertNewLine(editorState) {
	  var contentState = editorState.getCurrentContent();
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var currentBlock = contentState.getBlockForKey(startKey);
	  var blockText = currentBlock.getText();
	
	  var newContentState;
	
	  // Detect newline separation
	  var newLine = getNewLine(blockText);
	
	  // Add or replace
	  if (selection.isCollapsed()) {
	    // Create line to insert with right indentation
	    var lines = getLines(blockText, newLine);
	    var currentLineIndex = getLineAnchorForOffset(
	      blockText,
	      startOffset,
	      newLine
	    ).getLine();
	    var currentLine = lines.get(currentLineIndex);
	    var lineToInsert = newLine + getIndentForLine(currentLine);
	
	    newContentState = Draft.Modifier.insertText(
	      contentState,
	      selection,
	      lineToInsert
	    );
	  } else {
	    newContentState = Draft.Modifier.replaceText(
	      contentState,
	      selection,
	      newLine
	    );
	  }
	
	  var newEditorState = Draft.EditorState.push(
	    editorState,
	    newContentState,
	    'insert-characters'
	  );
	
	  return Draft.EditorState.forceSelection(
	    newEditorState,
	    newContentState.getSelectionAfter()
	  );
	}
	
	module.exports = insertNewLine;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var Draft = __webpack_require__(42);
	var endsWith = __webpack_require__(932);
	
	var getNewLine = __webpack_require__(138);
	var getIndentation = __webpack_require__(424);
	var getLines = __webpack_require__(426);
	var getLineAnchorForOffset = __webpack_require__(425);
	
	/**
	 * Remove last indentation before cursor, return undefined if no modification is done
	 *
	 * @param {Draft.EditorState} editorState
	 * @return {Draft.EditorState|undefined}
	 */
	function removeIndent(editorState) {
	  var contentState = editorState.getCurrentContent();
	  var selection = editorState.getSelection();
	
	  if (!selection.isCollapsed()) {
	    return;
	  }
	
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var currentBlock = contentState.getBlockForKey(startKey);
	  var blockText = currentBlock.getText();
	
	  // Detect newline separator and indentation
	  var newLine = getNewLine(blockText);
	  var indent = getIndentation(blockText);
	
	  // Get current line
	  var lines = getLines(blockText, newLine);
	  var lineAnchor = getLineAnchorForOffset(blockText, startOffset, newLine);
	
	  var currentLine = lines.get(lineAnchor.getLine());
	  var beforeSelection = currentLine.slice(0, lineAnchor.getOffset());
	
	  // If the line before selection ending with the indentation?
	  if (!endsWith(beforeSelection, indent)) {
	    return;
	  }
	
	  // Remove indent
	  var beforeIndentOffset = startOffset - indent.length;
	  var rangeToRemove = selection.merge({
	    focusKey: startKey,
	    focusOffset: beforeIndentOffset,
	    anchorKey: startKey,
	    anchorOffset: startOffset,
	    isBackward: true
	  });
	
	  var newContentState = Draft.Modifier.removeRange(
	    contentState,
	    rangeToRemove,
	    'backward'
	  );
	  var newEditorState = Draft.EditorState.push(
	    editorState,
	    newContentState,
	    'remove-range'
	  );
	
	  return Draft.EditorState.forceSelection(
	    newEditorState,
	    newContentState.getSelectionAfter()
	  );
	}
	
	module.exports = removeIndent;


/***/ },
/* 931 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		var newlines = (str.match(/(?:\r?\n)/g) || []);
	
		if (newlines.length === 0) {
			return null;
		}
	
		var crlf = newlines.filter(function (el) {
			return el === '\r\n';
		}).length;
	
		var lf = newlines.length - crlf;
	
		return crlf > lf ? '\r\n' : '\n';
	};
	
	module.exports.graceful = function (str) {
		return module.exports(str) || '\n';
	};


/***/ },
/* 932 */
/***/ function(module, exports) {

	/*!
	 * ends-with <https://github.com/jonschlinkert/ends-with>
	 *
	 * Copyright (c) 2014 Jon Schlinkert, contributors.
	 * Licensed under the MIT license.
	 */
	
	'use strict';
	
	module.exports = function (a, b) {
	  if (Array.isArray(a)) {
	    return a[a.length - 1] === b;
	  }
	
	  a = String(a);
	  b = String(b);
	
	  var i = b.length;
	  var len = a.length - i;
	
	  while (i--) {
	    if (b.charAt(i) !== a.charAt(len + i)) {
	      return false;
	    }
	  }
	  return true;
	};

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var numberIsNan = __webpack_require__(934);
	
	module.exports = Number.isFinite || function (val) {
		return !(typeof val !== 'number' || numberIsNan(val) || val === Infinity || val === -Infinity);
	};


/***/ },
/* 934 */
/***/ function(module, exports) {

	'use strict';
	module.exports = Number.isNaN || function (x) {
		return x !== x;
	};


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isFinite = __webpack_require__(933);
	
	module.exports = function (str, n) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected `input` to be a string');
		}
	
		if (n < 0 || !isFinite(n)) {
			throw new TypeError('Expected `count` to be a positive finite number');
		}
	
		var ret = '';
	
		do {
			if (n & 1) {
				ret += str;
			}
	
			str += str;
		} while ((n >>= 1));
	
		return ret;
	};


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var BlockMapBuilder = __webpack_require__(109);
	var CharacterMetadata = __webpack_require__(37);
	var ContentBlock = __webpack_require__(75);
	var ContentBlockNode = __webpack_require__(41);
	var DraftFeatureFlags = __webpack_require__(67);
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	var Immutable = __webpack_require__(16);
	var SelectionState = __webpack_require__(86);
	
	var generateRandomKey = __webpack_require__(58);
	var moveBlockInContentState = __webpack_require__(996);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var atomicBlockConfig = {
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    };
	
	    var atomicDividerBlockConfig = {
	      key: generateRandomKey(),
	      type: 'unstyled'
	    };
	
	    if (experimentalTreeDataSupport) {
	      atomicBlockConfig = _extends({}, atomicBlockConfig, {
	        nextSibling: atomicDividerBlockConfig.key
	      });
	      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
	        prevSibling: atomicBlockConfig.key
	      });
	    }
	
	    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  },
	
	  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var withMovedAtomicBlock = void 0;
	
	    if (insertionMode === 'before' || insertionMode === 'after') {
	      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
	
	      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
	    } else {
	      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
	
	      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
	      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
	
	      if (selectionAfterRemoval.getStartOffset() === 0) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
	      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
	      } else {
	        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
	
	        var selectionAfterSplit = afterSplit.getSelectionAfter();
	        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
	
	        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
	      }
	    }
	
	    var newContent = withMovedAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'move-block');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Immutable = __webpack_require__(16);
	
	var List = Immutable.List;
	
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	      var callback = function callback( /*number*/start, /*number*/end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      };
	      strategy(block, callback, contentState);
	    });
	
	    return List(decorations);
	  };
	
	  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(37);
	
	var _require = __webpack_require__(16),
	    Map = _require.Map;
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @format
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(189);
	var DefaultDraftInlineStyle = __webpack_require__(430);
	var DraftEditorCompositionHandler = __webpack_require__(940);
	var DraftEditorContents = __webpack_require__(942);
	var DraftEditorDragHandler = __webpack_require__(943);
	var DraftEditorEditHandler = __webpack_require__(944);
	var DraftEditorPlaceholder = __webpack_require__(946);
	var EditorState = __webpack_require__(23);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(20);
	var Scroll = __webpack_require__(452);
	var Style = __webpack_require__(196);
	var UserAgent = __webpack_require__(51);
	
	var cx = __webpack_require__(87);
	var emptyFunction = __webpack_require__(199);
	var generateRandomKey = __webpack_require__(58);
	var getDefaultKeyBinding = __webpack_require__(437);
	var getScrollPosition = __webpack_require__(200);
	var invariant = __webpack_require__(19);
	var nullthrows = __webpack_require__(46);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  edit: DraftEditorEditHandler,
	  composite: DraftEditorCompositionHandler,
	  drag: DraftEditorDragHandler,
	  cut: null,
	  render: null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	var DraftEditor = function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  function DraftEditor(props) {
	    _classCallCheck(this, DraftEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.focus = function (scrollPosition) {
	      var editorState = _this.props.editorState;
	
	      var alreadyHasFocus = editorState.getSelection().getHasFocus();
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	
	      if (!editorNode) {
	        // once in a while people call 'focus' in a setTimeout, and the node has
	        // been deleted, so it can be null in that case.
	        return;
	      }
	
	      var scrollParent = Style.getScrollParent(editorNode);
	
	      var _ref = scrollPosition || getScrollPosition(scrollParent),
	          x = _ref.x,
	          y = _ref.y;
	
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.focus();
	
	      // Restore scroll position
	      if (scrollParent === window) {
	        window.scrollTo(x, y);
	      } else {
	        Scroll.setTop(scrollParent, y);
	      }
	
	      // On Chrome and Safari, calling focus on contenteditable focuses the
	      // cursor at the first character. This is something you don't expect when
	      // you're clicking on an input element but not directly on a character.
	      // Put the cursor back where it was before the blur.
	      if (!alreadyHasFocus) {
	        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	      }
	    };
	
	    _this.blur = function () {
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.blur();
	    };
	
	    _this.setMode = function (mode) {
	      _this._handler = handlerMap[mode];
	    };
	
	    _this.exitCurrentMode = function () {
	      _this.setMode('edit');
	    };
	
	    _this.restoreEditorDOM = function (scrollPosition) {
	      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
	        _this.focus(scrollPosition);
	      });
	    };
	
	    _this.setClipboard = function (clipboard) {
	      _this._clipboard = clipboard;
	    };
	
	    _this.getClipboard = function () {
	      return _this._clipboard;
	    };
	
	    _this.update = function (editorState) {
	      _this._latestEditorState = editorState;
	      _this.props.onChange(editorState);
	    };
	
	    _this.onDragEnter = function () {
	      _this._dragCount++;
	    };
	
	    _this.onDragLeave = function () {
	      _this._dragCount--;
	      if (_this._dragCount === 0) {
	        _this.exitCurrentMode();
	      }
	    };
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = props.editorKey || generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	    _this._latestEditorState = props.editorState;
	    _this._latestCommittedEditorState = props.editorState;
	
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	
	    // See `restoreEditorDOM()`.
	    _this.state = { contentsKey: 0 };
	    return _this;
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	
	
	  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	        method && method(_this2, e);
	      }
	    };
	  };
	
	  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      var placeHolderProps = {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      };
	
	      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
	    }
	    return null;
	  };
	
	  DraftEditor.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleFn = _props.customStyleFn,
	        customStyleMap = _props.customStyleMap,
	        editorState = _props.editorState,
	        readOnly = _props.readOnly,
	        textAlignment = _props.textAlignment,
	        textDirectionality = _props.textDirectionality;
	
	
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	
	    var contentStyle = {
	      outline: 'none',
	      // fix parent-draggable Safari bug. #1326
	      userSelect: 'text',
	      WebkitUserSelect: 'text',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    };
	
	    // The aria-expanded and aria-haspopup properties should only be rendered
	    // for a combobox.
	    var ariaRole = this.props.role || 'textbox';
	    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
	
	    var editorContentsProps = {
	      blockRenderMap: blockRenderMap,
	      blockRendererFn: blockRendererFn,
	      blockStyleFn: blockStyleFn,
	      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
	      customStyleFn: customStyleFn,
	      editorKey: this._editorKey,
	      editorState: editorState,
	      key: 'contents' + this.state.contentsKey,
	      textDirectionality: textDirectionality
	    };
	
	    return React.createElement(
	      'div',
	      { className: rootClass },
	      this._renderPlaceholder(),
	      React.createElement(
	        'div',
	        {
	          className: cx('DraftEditor/editorContainer'),
	          ref: function ref(_ref3) {
	            return _this3.editorContainer = _ref3;
	          } },
	        React.createElement(
	          'div',
	          {
	            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	            'aria-controls': readOnly ? null : this.props.ariaControls,
	            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
	            'aria-expanded': readOnly ? null : ariaExpanded,
	            'aria-label': this.props.ariaLabel,
	            'aria-labelledby': this.props.ariaLabelledBy,
	            'aria-multiline': this.props.ariaMultiline,
	            autoCapitalize: this.props.autoCapitalize,
	            autoComplete: this.props.autoComplete,
	            autoCorrect: this.props.autoCorrect,
	            className: cx({
	              // Chrome's built-in translation feature mutates the DOM in ways
	              // that Draft doesn't expect (ex: adding <font> tags inside
	              // DraftEditorLeaf spans) and causes problems. We add notranslate
	              // here which makes its autotranslation skip over this subtree.
	              notranslate: !readOnly,
	              'public/DraftEditor/content': true
	            }),
	            contentEditable: !readOnly,
	            'data-testid': this.props.webDriverTestID,
	            onBeforeInput: this._onBeforeInput,
	            onBlur: this._onBlur,
	            onCompositionEnd: this._onCompositionEnd,
	            onCompositionStart: this._onCompositionStart,
	            onCopy: this._onCopy,
	            onCut: this._onCut,
	            onDragEnd: this._onDragEnd,
	            onDragEnter: this.onDragEnter,
	            onDragLeave: this.onDragLeave,
	            onDragOver: this._onDragOver,
	            onDragStart: this._onDragStart,
	            onDrop: this._onDrop,
	            onFocus: this._onFocus,
	            onInput: this._onInput,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseUp: this._onMouseUp,
	            onPaste: this._onPaste,
	            onSelect: this._onSelect,
	            ref: function ref(_ref2) {
	              return _this3.editor = _ref2;
	            },
	            role: readOnly ? null : ariaRole,
	            spellCheck: allowSpellCheck && this.props.spellCheck,
	            style: contentStyle,
	            suppressContentEditableWarning: true,
	            tabIndex: this.props.tabIndex },
	          React.createElement(DraftEditorContents, editorContentsProps)
	        )
	      )
	    );
	  };
	
	  DraftEditor.prototype.componentDidMount = function componentDidMount() {
	    this.setMode('edit');
	
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	    if (isIE) {
	      document.execCommand('AutoUrlDetect', false, false);
	    }
	  };
	
	  /**
	   * Prevent selection events from affecting the current editor state. This
	   * is mostly intended to defend against IE, which fires off `selectionchange`
	   * events regardless of whether the selection is set via the browser or
	   * programmatically. We only care about selection events that occur because
	   * of browser interaction, not re-renders and forced selections.
	   */
	
	
	  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    this._blockSelectEvents = true;
	    this._latestEditorState = nextProps.editorState;
	  };
	
	  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	    this._latestCommittedEditorState = this.props.editorState;
	  };
	
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * We attempt to preserve scroll position when focusing. You can also pass
	   * a specified scroll position (for cases like `cut` behavior where it should
	   * be restored to a known position).
	   */
	
	
	  /**
	   * Used via `this.setMode(...)`.
	   *
	   * Set the behavior mode for the editor component. This switches the current
	   * handler module to ensure that DOM events are managed appropriately for
	   * the active mode.
	   */
	
	
	  /**
	   * Used via `this.restoreEditorDOM()`.
	   *
	   * Force a complete re-render of the DraftEditorContents based on the current
	   * EditorState. This is useful when we know we are going to lose control of
	   * the DOM state (cut command, IME) and we want to make sure that
	   * reconciliation occurs on a version of the DOM that is synchronized with
	   * our EditorState.
	   */
	
	
	  /**
	   * Used via `this.setClipboard(...)`.
	   *
	   * Set the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.getClipboard()`.
	   *
	   * Retrieve the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.update(...)`.
	   *
	   * Propagate a new `EditorState` object to higher-level components. This is
	   * the method by which event handlers inform the `DraftEditor` component of
	   * state changes. A component that composes a `DraftEditor` **must** provide
	   * an `onChange` prop to receive state updates passed along from this
	   * function.
	   */
	
	
	  /**
	   * Used in conjunction with `onDragLeave()`, by counting the number of times
	   * a dragged element enters and leaves the editor (or any of its children),
	   * to determine when the dragged element absolutely leaves the editor.
	   */
	
	
	  /**
	   * See `onDragEnter()`.
	   */
	
	
	  return DraftEditor;
	}(React.Component);
	
	DraftEditor.defaultProps = {
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: emptyFunction.thatReturnsNull,
	  blockStyleFn: emptyFunction.thatReturns(''),
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	};
	
	
	module.exports = DraftEditor;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(67);
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	var Keys = __webpack_require__(195);
	
	var getEntityKeyForSelection = __webpack_require__(192);
	var isEventHandled = __webpack_require__(111);
	var isSelectionAtLeafStart = __webpack_require__(447);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(editor, e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart(editor) {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd(editor) {
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition(editor);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(editor, e) {
	    if (!stillComposing) {
	      // If a keydown event is received after compositionend but before the
	      // 20ms timer expires (ex: type option-E then backspace, or type A then
	      // backspace in 2-Set Korean), we should immediately resolve the
	      // composition and reinterpret the key press in edit mode.
	      DraftEditorCompositionHandler.resolveComposition(editor);
	      editor._onKeyDown(e);
	      return;
	    }
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(editor, e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition(editor) {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(editor._latestEditorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      editor.restoreEditorDOM();
	    }
	
	    editor.exitCurrentMode();
	
	    if (composedChars) {
	      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
	        return;
	      }
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      editor.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents-core.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(431);
	var DraftOffsetKey = __webpack_require__(140);
	var EditorState = __webpack_require__(23);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(87);
	var joinClasses = __webpack_require__(1018);
	var nullthrows = __webpack_require__(46);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	};
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	
	var DraftEditorContents = function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap();
	
	    // Text direction has changed for one or more blocks. We must re-render.
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode();
	
	    // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  DraftEditorContents.prototype.render = function render() {
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleMap = _props.customStyleMap,
	        customStyleFn = _props.customStyleFn,
	        editorState = _props.editorState,
	        editorKey = _props.editorKey,
	        textDirectionality = _props.textDirectionality;
	
	
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	
	    var blocksAsArray = content.getBlocksAsArray();
	    var processedBlocks = [];
	
	    var currentDepth = null;
	    var lastWrapperTemplate = null;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      var _block = blocksAsArray[ii];
	      var key = _block.getKey();
	      var blockType = _block.getType();
	
	      var customRenderer = blockRendererFn(_block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        contentState: content,
	        block: _block,
	        blockProps: customProps,
	        blockStyleFn: blockStyleFn,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        key: key,
	        offsetKey: offsetKey,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	
	      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
	      var wrapperTemplate = configForType.wrapper;
	
	      var Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = _block.getDepth();
	      var className = '';
	      if (blockStyleFn) {
	        className = blockStyleFn(_block);
	      }
	
	      // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	      if (Element === 'li') {
	        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
	        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      var childProps = {
	        className: className,
	        'data-block': true,
	        'data-editor': editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	      if (customEditable !== undefined) {
	        childProps = _extends({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));
	
	      processedBlocks.push({
	        block: child,
	        wrapperTemplate: wrapperTemplate,
	        key: key,
	        offsetKey: offsetKey
	      });
	
	      if (wrapperTemplate) {
	        currentDepth = _block.getDepth();
	      } else {
	        currentDepth = null;
	      }
	      lastWrapperTemplate = wrapperTemplate;
	    }
	
	    // Group contiguous runs of blocks that have the same wrapperTemplate
	    var outputBlocks = [];
	    for (var _ii = 0; _ii < processedBlocks.length;) {
	      var info = processedBlocks[_ii];
	      if (info.wrapperTemplate) {
	        var blocks = [];
	        do {
	          blocks.push(processedBlocks[_ii].block);
	          _ii++;
	        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        _ii++;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { 'data-contents': 'true' },
	      outputBlocks
	    );
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	module.exports = DraftEditorContents;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEditorContents = __webpack_require__(941);
	
	module.exports = DraftEditorContents;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DataTransfer = __webpack_require__(451);
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	
	var findAncestorOffsetKey = __webpack_require__(191);
	var getTextContentFromFiles = __webpack_require__(444);
	var getUpdatedSelectionState = __webpack_require__(445);
	var isEventHandled = __webpack_require__(111);
	var nullthrows = __webpack_require__(46);
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (typeof document.caretRangeFromPoint === 'function') {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd(editor) {
	    editor.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(editor, e) {
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = editor._latestEditorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    editor.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
	      });
	      return;
	    }
	
	    var dragType = editor._internalDrag ? 'internal' : 'external';
	    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
	      return;
	    }
	
	    if (editor._internalDrag) {
	      editor.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(963);
	var onBlur = __webpack_require__(964);
	var onCompositionStart = __webpack_require__(965);
	var onCopy = __webpack_require__(966);
	var onCut = __webpack_require__(967);
	var onDragOver = __webpack_require__(968);
	var onDragStart = __webpack_require__(969);
	var onFocus = __webpack_require__(970);
	var onInput = __webpack_require__(971);
	var onKeyDown = __webpack_require__(972);
	var onPaste = __webpack_require__(973);
	var onSelect = __webpack_require__(974);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(947);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(20);
	
	var invariant = __webpack_require__(19);
	var setDraftEditorSelection = __webpack_require__(998);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
	    var selection = this.props.selection;
	
	    // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _props = this.props,
	        block = _props.block,
	        start = _props.start,
	        text = _props.text;
	
	    var blockKey = block.getKey();
	    var end = start + text.length;
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    }
	
	    // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	    var node = ReactDOM.findDOMNode(this);
	    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
	    var child = node.firstChild;
	    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
	    var targetNode = void 0;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (child.tagName === 'BR') {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	  /**
	   * By making individual leaf instances aware of their context within
	   * the text of the editor, we can set our selection range more
	   * easily than we could in the non-React world.
	   *
	   * Note that this depends on our maintaining tight control over the
	   * DOM structure of the DraftEditor component. If leaves had multiple
	   * text nodes, this would be harder.
	   */
	
	  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var leafNode = ReactDOM.findDOMNode(this.leaf);
	    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
	    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	  };
	
	  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.render = function render() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var text = this.props.text;
	
	    // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _props2 = this.props,
	        customStyleMap = _props2.customStyleMap,
	        customStyleFn = _props2.customStyleFn,
	        offsetKey = _props2.offsetKey,
	        styleSet = _props2.styleSet;
	
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet, block);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement(
	      'span',
	      {
	        'data-offset-key': offsetKey,
	        ref: function ref(_ref) {
	          return _this2.leaf = _ref;
	        },
	        style: styleObj },
	      React.createElement(
	        DraftEditorTextNode,
	        null,
	        text
	      )
	    );
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(87);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  DraftEditorPlaceholder.prototype.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	
	    var contentStyle = {
	      whiteSpace: 'pre-wrap'
	    };
	
	    return React.createElement(
	      'div',
	      { className: className },
	      React.createElement(
	        'div',
	        {
	          className: cx('public/DraftEditorPlaceholder/inner'),
	          id: this.props.accessibilityID,
	          style: contentStyle },
	        this.props.text
	      )
	    );
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(20);
	var UserAgent = __webpack_require__(51);
	
	var invariant = __webpack_require__(19);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = ReactDOM.findDOMNode(this);
	    var shouldBeNewline = nextProps.children === '';
	    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
	    if (shouldBeNewline) {
	      return !isNewline(node);
	    }
	    return node.textContent !== nextProps.children;
	  };
	
	  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.render = function render() {
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	    }
	    return React.createElement(
	      'span',
	      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	      this.props.children
	    );
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ },
/* 948 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ },
/* 949 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags-core
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = {
	  draft_killswitch_allow_nontextnodes: false,
	  draft_segmented_entities_behavior: false,
	  draft_handlebeforeinput_composed_text: false,
	  draft_tree_data_support: false
	};
	
	module.exports = DraftFeatureFlags;

/***/ },
/* 950 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftJsDebugLogging
	 */
	
	'use strict';
	
	module.exports = {
	  logSelectionStateFailure: function logSelectionStateFailure() {
	    return null;
	  }
	};

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CharacterMetadata = __webpack_require__(37);
	var ContentBlock = __webpack_require__(75);
	var ContentBlockNode = __webpack_require__(41);
	var DraftFeatureFlags = __webpack_require__(67);
	var Immutable = __webpack_require__(16);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(436);
	var generateRandomKey = __webpack_require__(58);
	var getSafeBodyFromHTML = __webpack_require__(442);
	var sanitizeDraftText = __webpack_require__(194);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character, type) {
	    return textBlocks.reduce(function (acc, textLine, index) {
	      textLine = sanitizeDraftText(textLine);
	      var key = generateRandomKey();
	
	      var blockNodeConfig = {
	        key: key,
	        type: type,
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      };
	
	      // next block updates previous block
	      if (experimentalTreeDataSupport && index !== 0) {
	        var prevSiblingIndex = index - 1;
	        // update previous block
	        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
	          nextSibling: key
	        });
	        blockNodeConfig = _extends({}, blockNodeConfig, {
	          prevSibling: previousBlock.getKey()
	        });
	      }
	
	      acc.push(new ContentBlockRecord(blockNodeConfig));
	
	      return acc;
	    }, []);
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftTreeAdapter
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var invariant = __webpack_require__(19);
	
	var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
	  var stack = [].concat(blocks).reverse();
	  while (stack.length) {
	    var _block = stack.pop();
	
	    fn(_block);
	
	    var children = _block.children;
	
	    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
	
	    stack = stack.concat([].concat(children.reverse()));
	  }
	};
	
	var isListBlock = function isListBlock(block) {
	  if (!(block && block.type)) {
	    return false;
	  }
	  var type = block.type;
	
	  return type === 'unordered-list-item' || type === 'ordered-list-item';
	};
	
	var addDepthToChildren = function addDepthToChildren(block) {
	  if (Array.isArray(block.children)) {
	    block.children = block.children.map(function (child) {
	      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
	    });
	  }
	};
	
	/**
	 * This adapter is intended to be be used as an adapter to draft tree data
	 *
	 * draft state <=====> draft tree state
	 */
	var DraftTreeAdapter = {
	  /**
	   * Converts from a tree raw state back to  draft raw state
	   */
	  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
	    var blocks = draftTreeState.blocks;
	
	    var transformedBlocks = [];
	
	    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;
	
	    if (!Array.isArray(blocks) || !blocks.length) {
	      return draftTreeState;
	    }
	
	    traverseInDepthOrder(blocks, function (block) {
	      var newBlock = _extends({}, block);
	
	      if (isListBlock(block)) {
	        newBlock.depth = newBlock.depth || 0;
	        addDepthToChildren(block);
	      }
	
	      delete newBlock.children;
	
	      transformedBlocks.push(newBlock);
	    });
	
	    draftTreeState.blocks = transformedBlocks;
	
	    return _extends({}, draftTreeState, {
	      blocks: transformedBlocks
	    });
	  },
	
	
	  /**
	   * Converts from draft raw state to tree draft state
	   */
	  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
	    var lastListDepthCacheRef = {};
	    var transformedBlocks = [];
	
	    draftState.blocks.forEach(function (block) {
	      var isList = isListBlock(block);
	      var depth = block.depth || 0;
	      var treeBlock = _extends({}, block, {
	        children: []
	      });
	
	      if (!isList) {
	        // reset the cache path
	        lastListDepthCacheRef = {};
	        transformedBlocks.push(treeBlock);
	        return;
	      }
	
	      // update our depth cache reference path
	      lastListDepthCacheRef[depth] = treeBlock;
	
	      // if we are greater than zero we must have seen a parent already
	      if (depth > 0) {
	        var parent = lastListDepthCacheRef[depth - 1];
	
	        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;
	
	        // push nested list blocks
	        parent.children.push(treeBlock);
	        return;
	      }
	
	      // push root list blocks
	      transformedBlocks.push(treeBlock);
	    });
	
	    return _extends({}, draftState, {
	      blocks: transformedBlocks
	    });
	  }
	};
	
	module.exports = DraftTreeAdapter;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(16);
	var UnicodeBidiService = __webpack_require__(1004);
	
	var nullthrows = __webpack_require__(46);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	
	var getContentStateFragment = __webpack_require__(141);
	var nullthrows = __webpack_require__(46);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ },
/* 955 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(37);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(16);
	
	var applyEntityToContentBlock = __webpack_require__(956);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(75);
	var ContentBlockNode = __webpack_require__(41);
	var DraftStringKey = __webpack_require__(434);
	
	var encodeEntityRanges = __webpack_require__(975);
	var encodeInlineStyleRanges = __webpack_require__(976);
	var invariant = __webpack_require__(19);
	
	var createRawBlock = function createRawBlock(block, entityStorageMap) {
	  return {
	    key: block.getKey(),
	    text: block.getText(),
	    type: block.getType(),
	    depth: block.getDepth(),
	    inlineStyleRanges: encodeInlineStyleRanges(block),
	    entityRanges: encodeEntityRanges(block, entityStorageMap),
	    data: block.getData().toObject()
	  };
	};
	
	var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
	  if (block instanceof ContentBlock) {
	    rawBlocks.push(createRawBlock(block, entityMap));
	    return;
	  }
	
	  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
	
	  var parentKey = block.getParentKey();
	  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
	    children: []
	  });
	
	  if (parentKey) {
	    blockCacheRef[parentKey].children.push(rawBlock);
	    return;
	  }
	
	  rawBlocks.push(rawBlock);
	};
	
	var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
	  var entityMap = rawState.entityMap;
	
	
	  var rawBlocks = [];
	
	  var blockCacheRef = {};
	  var entityCacheRef = {};
	  var entityStorageKey = 0;
	
	  contentState.getBlockMap().forEach(function (block) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      var entityKey = block.getEntityAt(start);
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
	      // This makes this function resilient to two entities
	      // erroneously having the same key
	      if (entityCacheRef[stringifiedEntityKey]) {
	        return;
	      }
	      entityCacheRef[stringifiedEntityKey] = entityKey;
	      // we need the `any` casting here since this is a temporary state
	      // where we will later on flip the entity map and populate it with
	      // real entity, at this stage we just need to map back the entity
	      // key used by the BlockNode
	      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
	      entityStorageKey++;
	    });
	
	    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
	  });
	
	  return {
	    blocks: rawBlocks,
	    entityMap: entityMap
	  };
	};
	
	// Flip storage map so that our storage keys map to global
	// DraftEntity keys.
	var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
	  var blocks = rawState.blocks,
	      entityMap = rawState.entityMap;
	
	
	  var rawEntityMap = {};
	
	  Object.keys(entityMap).forEach(function (key, index) {
	    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
	    rawEntityMap[index] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    blocks: blocks,
	    entityMap: rawEntityMap
	  };
	};
	
	var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
	  var rawDraftContentState = {
	    entityMap: {},
	    blocks: []
	  };
	
	  // add blocks
	  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);
	
	  // add entities
	  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
	
	  return rawDraftContentState;
	};
	
	module.exports = convertFromDraftStateToRaw;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(38);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(75);
	var ContentBlockNode = __webpack_require__(41);
	var ContentState = __webpack_require__(188);
	var DraftEntity = __webpack_require__(139);
	var DraftFeatureFlags = __webpack_require__(67);
	var DraftTreeAdapter = __webpack_require__(952);
	var Immutable = __webpack_require__(16);
	var SelectionState = __webpack_require__(86);
	
	var createCharacterList = __webpack_require__(960);
	var decodeEntityRanges = __webpack_require__(961);
	var decodeInlineStyleRanges = __webpack_require__(962);
	var generateRandomKey = __webpack_require__(58);
	var invariant = __webpack_require__(19);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedMap = Immutable.OrderedMap;
	
	
	var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
	  var key = block.key,
	      type = block.type,
	      data = block.data,
	      text = block.text,
	      depth = block.depth;
	
	
	  var blockNodeConfig = {
	    text: text,
	    depth: depth || 0,
	    type: type || 'unstyled',
	    key: key || generateRandomKey(),
	    data: Map(data),
	    characterList: decodeCharacterList(block, entityMap)
	  };
	
	  return blockNodeConfig;
	};
	
	var decodeCharacterList = function decodeCharacterList(block, entityMap) {
	  var text = block.text,
	      rawEntityRanges = block.entityRanges,
	      rawInlineStyleRanges = block.inlineStyleRanges;
	
	
	  var entityRanges = rawEntityRanges || [];
	  var inlineStyleRanges = rawInlineStyleRanges || [];
	
	  // Translate entity range keys to the DraftEntity map.
	  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
	    return entityMap.hasOwnProperty(range.key);
	  }).map(function (range) {
	    return _extends({}, range, { key: entityMap[range.key] });
	  })));
	};
	
	var addKeyIfMissing = function addKeyIfMissing(block) {
	  return _extends({}, block, {
	    key: block.key || generateRandomKey()
	  });
	};
	
	/**
	 * Node stack is responsible to ensure we traverse the tree only once
	 * in depth order, while also providing parent refs to inner nodes to
	 * construct their links.
	 */
	var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
	  var nodesWithParentRef = nodes.map(function (block) {
	    return _extends({}, block, {
	      parentRef: parentRef
	    });
	  });
	
	  // since we pop nodes from the stack we need to insert them in reverse
	  return stack.concat(nodesWithParentRef.reverse());
	};
	
	/**
	 * This will build a tree draft content state by creating the node
	 * reference links into a single tree walk. Each node has a link
	 * reference to "parent", "children", "nextSibling" and "prevSibling"
	 * blockMap will be created using depth ordering.
	 */
	var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
	  return blocks
	  // ensure children have valid keys to enable sibling links
	  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
	    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	
	    // ensure children have valid keys to enable sibling links
	    var children = block.children.map(addKeyIfMissing);
	
	    // root level nodes
	    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
	      prevSibling: index === 0 ? null : blocks[index - 1].key,
	      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
	      children: List(children.map(function (child) {
	        return child.key;
	      }))
	    }));
	
	    // push root node to blockMap
	    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);
	
	    // this stack is used to ensure we visit all nodes respecting depth ordering
	    var stack = updateNodeStack([], children, contentBlockNode);
	
	    // start computing children nodes
	    while (stack.length > 0) {
	      // we pop from the stack and start processing this node
	      var node = stack.pop();
	
	      // parentRef already points to a converted ContentBlockNode
	      var parentRef = node.parentRef;
	      var siblings = parentRef.getChildKeys();
	      var _index = siblings.indexOf(node.key);
	      var isValidBlock = Array.isArray(node.children);
	
	      if (!isValidBlock) {
	        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	        break;
	      }
	
	      // ensure children have valid keys to enable sibling links
	      var _children = node.children.map(addKeyIfMissing);
	
	      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
	        parent: parentRef.getKey(),
	        children: List(_children.map(function (child) {
	          return child.key;
	        })),
	        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
	        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
	      }));
	
	      // push node to blockMap
	      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);
	
	      // this stack is used to ensure we visit all nodes respecting depth ordering
	      stack = updateNodeStack(stack, _children, _contentBlockNode);
	    }
	
	    return blockMap;
	  }, OrderedMap());
	};
	
	var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
	  return OrderedMap(blocks.map(function (block) {
	    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
	    return [contentBlock.getKey(), contentBlock];
	  }));
	};
	
	var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
	  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
	  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;
	
	  if (!experimentalTreeDataSupport) {
	    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
	  }
	
	  return decodeContentBlockNodes(rawBlocks, entityMap);
	};
	
	var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
	  var rawEntityMap = rawState.entityMap;
	
	  var entityMap = {};
	
	  // TODO: Update this once we completely remove DraftEntity
	  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
	    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
	        type = _rawEntityMap$rawEnti.type,
	        mutability = _rawEntityMap$rawEnti.mutability,
	        data = _rawEntityMap$rawEnti.data;
	
	    // get the key reference to created entity
	
	    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
	  });
	
	  return entityMap;
	};
	
	var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
	  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;
	
	  // decode entities
	  var entityMap = decodeRawEntityMap(rawState);
	
	  // decode blockMap
	  var blockMap = decodeRawBlocks(rawState, entityMap);
	
	  // create initial selection
	  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	
	  return new ContentState({
	    blockMap: blockMap,
	    entityMap: entityMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	};
	
	module.exports = convertFromRawToDraftState;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(37);
	var Immutable = __webpack_require__(16);
	
	var List = Immutable.List;
	
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(76);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(16),
	    OrderedSet = _require.OrderedSet;
	
	var UnicodeUtils = __webpack_require__(76);
	
	var substr = UnicodeUtils.substr;
	
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockTree = __webpack_require__(429);
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	var UserAgent = __webpack_require__(51);
	
	var getEntityKeyForSelection = __webpack_require__(192);
	var isEventHandled = __webpack_require__(111);
	var isSelectionAtLeafStart = __webpack_require__(447);
	var nullthrows = __webpack_require__(46);
	var setImmediate = __webpack_require__(1021);
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	var FF_QUICKFIND_CHAR = "'";
	var FF_QUICKFIND_LINK_CHAR = '/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(editor, e) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var editorState = editor._latestEditorState;
	
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var selection = editorState.getSelection();
	  var selectionStart = selection.getStartOffset();
	  var selectionEnd = selection.getEndOffset();
	  var anchorKey = selection.getAnchorKey();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	
	    // If the currently selected text matches what the user is trying to
	    // replace it with, let's just update the `SelectionState`. If not, update
	    // the `ContentState` with the new text.
	    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
	    if (chars === currentlySelectedChars) {
	      editor.update(EditorState.forceSelection(editorState, selection.merge({
	        focusOffset: selectionEnd
	      })));
	    } else {
	      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    }
	    return;
	  }
	
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  // Bunch of different cases follow where we need to prevent native insertion.
	  var mustPreventNative = false;
	  if (!mustPreventNative) {
	    // Browsers tend to insert text in weird places in the DOM when typing at
	    // the start of a leaf, so we'll handle it ourselves.
	    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
	  }
	  if (!mustPreventNative) {
	    // Chrome will also split up a node into two pieces if it contains a Tab
	    // char, for no explicable reason. Seemingly caused by this commit:
	    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
	    var nativeSelection = global.getSelection();
	    // Selection is necessarily collapsed at this point due to earlier check.
	    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
	      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
	      var parentNode = nativeSelection.anchorNode.parentNode;
	      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
	    }
	  }
	  if (!mustPreventNative) {
	    // Check the old and new "fingerprints" of the current block to determine
	    // whether this insertion requires any addition or removal of text nodes,
	    // in which case we would prevent the native character insertion.
	    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
	    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	    mustPreventNative = originalFingerprint !== newFingerprint;
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = mustPreventDefaultForCharacter(chars);
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
	  }
	
	  if (mustPreventNative) {
	    e.preventDefault();
	    editor.update(newEditorState);
	    return;
	  }
	
	  // We made it all the way! Let the browser do its thing and insert the char.
	  newEditorState = EditorState.set(newEditorState, {
	    nativelyRenderedContent: newEditorState.getCurrentContent()
	  });
	  // The native event is allowed to occur. To allow user onChange handlers to
	  // change the inserted text, we wait until the text is actually inserted
	  // before we actually update our state. That way when we rerender, the text
	  // we see in the DOM will already have been inserted properly.
	  editor._pendingStateFromBeforeInput = newEditorState;
	  setImmediate(function () {
	    if (editor._pendingStateFromBeforeInput !== undefined) {
	      editor.update(editor._pendingStateFromBeforeInput);
	      editor._pendingStateFromBeforeInput = undefined;
	    }
	  });
	}
	
	module.exports = editOnBeforeInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	
	var containsNode = __webpack_require__(198);
	var getActiveElement = __webpack_require__(454);
	
	function editOnBlur(editor, e) {
	  // In a contentEditable element, when you select a range and then click
	  // another active element, this does trigger a `blur` event but will not
	  // remove the DOM selection from the contenteditable.
	  // This is consistent across all browsers, but we prefer that the editor
	  // behave like a textarea, where a `blur` event clears the DOM selection.
	  // We therefore force the issue to be certain, checking whether the active
	  // element is `body` to force it when blurring occurs within the window (as
	  // opposed to clicking to another tab or window).
	  if (getActiveElement() === document.body) {
	    var _selection = global.getSelection();
	    var editorNode = editor.editor;
	    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
	      _selection.removeAllRanges();
	    }
	  }
	
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  editor.props.onBlur && editor.props.onBlur(e);
	  editor.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart(editor, e) {
	  editor.setMode('composite');
	  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
	  // Allow composition handler to interpret the compositionstart event
	  editor._onCompositionStart(e);
	}
	
	module.exports = editOnCompositionStart;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(439);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
	}
	
	module.exports = editOnCopy;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	var Style = __webpack_require__(196);
	
	var getFragmentFromSelection = __webpack_require__(439);
	var getScrollPosition = __webpack_require__(200);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	  var element = e.target;
	  var scrollPosition = void 0;
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  if (element instanceof Node) {
	    scrollPosition = getScrollPosition(Style.getScrollParent(element));
	  }
	
	  var fragment = getFragmentFromSelection(editorState);
	  editor.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  editor.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    editor.restoreEditorDOM(scrollPosition);
	    editor.exitCurrentMode();
	    editor.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ },
/* 968 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	function editOnDragOver(editor, e) {
	  editor._internalDrag = false;
	  editor.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ },
/* 969 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	function editOnDragStart(editor) {
	  editor._internalDrag = true;
	  editor.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	var UserAgent = __webpack_require__(51);
	
	function editOnFocus(editor, e) {
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  editor.props.onFocus && editor.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  // But it looks like this is fixed in Chrome 60.0.3081.0.
	  // Other browsers also don't have this bug, so we prefer to acceptSelection
	  // when possible, to ensure that unfocusing and refocusing a Draft editor
	  // doesn't preserve the selection, matching how textareas work.
	  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
	    editor.update(EditorState.forceSelection(editorState, selection));
	  } else {
	    editor.update(EditorState.acceptSelection(editorState, selection));
	  }
	}
	
	module.exports = editOnFocus;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(67);
	var DraftModifier = __webpack_require__(35);
	var DraftOffsetKey = __webpack_require__(140);
	var EditorState = __webpack_require__(23);
	var UserAgent = __webpack_require__(51);
	
	var findAncestorOffsetKey = __webpack_require__(191);
	var nullthrows = __webpack_require__(46);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput(editor) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode,
	      isCollapsed = domSelection.isCollapsed;
	
	  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
	  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;
	
	  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
	    if (isNotTextNode) {
	      return;
	    }
	  } else {
	    if (isNotTextOrElementNode) {
	      // TODO: (t16149272) figure out context for this change
	      return;
	    }
	  }
	
	  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
	    // When typing at the beginning of a visual line, Chrome splits the text
	    // nodes into two. Why? No one knows. This commit is suspicious:
	    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
	    // To work around, we'll merge the sibling text nodes back into this one.
	    var span = anchorNode.parentNode;
	    anchorNode.nodeValue = span.textContent;
	    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
	      if (child !== anchorNode) {
	        span.removeChild(child);
	      }
	    }
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = editor._latestEditorState;
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
	      blockKey = _DraftOffsetKey$decod.blockKey,
	      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
	      leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
	      start = _editorState$getBlock.start,
	      end = _editorState$getBlock.end;
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    // This can be buggy for some Android keyboards because they don't fire
	    // standard onkeydown/pressed events and only fired editOnInput
	    // so domText is already changed by the browser and ends up being equal
	    // to modelText unexpectedly
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && content.getEntity(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	var KeyBindingUtil = __webpack_require__(190);
	var Keys = __webpack_require__(195);
	var SecondaryClipboard = __webpack_require__(954);
	var UserAgent = __webpack_require__(51);
	
	var isEventHandled = __webpack_require__(111);
	var keyCommandBackspaceToStartOfLine = __webpack_require__(985);
	var keyCommandBackspaceWord = __webpack_require__(986);
	var keyCommandDeleteWord = __webpack_require__(987);
	var keyCommandInsertNewline = __webpack_require__(988);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(989);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(990);
	var keyCommandPlainBackspace = __webpack_require__(991);
	var keyCommandPlainDelete = __webpack_require__(992);
	var keyCommandTransposeCharacters = __webpack_require__(993);
	var keyCommandUndo = __webpack_require__(994);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(editor, e) {
	  var keyCode = e.which;
	  var editorState = editor._latestEditorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      editor.props.onEscape && editor.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      editor.props.onTab && editor.props.onTab(e);
	      return;
	    case Keys.UP:
	      editor.props.onUpArrow && editor.props.onUpArrow(e);
	      return;
	    case Keys.RIGHT:
	      editor.props.onRightArrow && editor.props.onRightArrow(e);
	      return;
	    case Keys.DOWN:
	      editor.props.onDownArrow && editor.props.onDownArrow(e);
	      return;
	    case Keys.LEFT:
	      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
	        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = editor.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, editor.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    editor.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(109);
	var CharacterMetadata = __webpack_require__(37);
	var DataTransfer = __webpack_require__(451);
	var DraftModifier = __webpack_require__(35);
	var DraftPasteProcessor = __webpack_require__(951);
	var EditorState = __webpack_require__(23);
	var RichTextEditorUtil = __webpack_require__(435);
	
	var getEntityKeyForSelection = __webpack_require__(192);
	var getTextContentFromFiles = __webpack_require__(444);
	var isEventHandled = __webpack_require__(111);
	var splitTextIntoTextBlocks = __webpack_require__(1000);
	
	/**
	 * Paste content.
	 */
	function editOnPaste(editor, e) {
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = editor._latestEditorState;
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	  var editorState = editor._latestEditorState;
	
	  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!editor.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = editor.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(editor.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	      return;
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
	      if (htmlFragment) {
	        var contentBlocks = htmlFragment.contentBlocks,
	            entityMap = htmlFragment.entityMap;
	
	        if (contentBlocks) {
	          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
	          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
	          return;
	        }
	      }
	    }
	
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    editor.setClipboard(null);
	  }
	
	  if (textBlocks.length) {
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    editor.update(insertFragment(editor._latestEditorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment, entityMap) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  // TODO: merge the entity map once we stop using DraftEntity
	  // like this:
	  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);
	
	  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	var ReactDOM = __webpack_require__(20);
	
	var getDraftEditorSelection = __webpack_require__(979);
	var invariant = __webpack_require__(19);
	
	function editOnSelect(editor) {
	  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
	    return;
	  }
	
	  var editorState = editor.props.editorState;
	  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
	  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
	  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
	  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    editor.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(434);
	var UnicodeUtils = __webpack_require__(76);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(76);
	
	var findRangesImmutable = __webpack_require__(110);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @format
	 * 
	 */
	
	var UnicodeUtils = __webpack_require__(76);
	
	var getRangeClientRects = __webpack_require__(441);
	var invariant = __webpack_require__(19);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  var documentBody = document.body;
	  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;
	
	  // forced layout here
	  documentBody.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  documentBody.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEntitySegments = __webpack_require__(948);
	
	var getRangesForDraftEntity = __webpack_require__(981);
	var invariant = __webpack_require__(19);
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var startEntityKey = startBlock.getEntityAt(start);
	  var endEntityKey = endBlock.getEntityAt(end - 1);
	  if (!startEntityKey && !endEntityKey) {
	    return selectionState;
	  }
	  var newSelectionState = selectionState;
	  if (startEntityKey && startEntityKey === endEntityKey) {
	    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
	  } else if (startEntityKey && endEntityKey) {
	    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: startSelectionState.getAnchorOffset(),
	      focusOffset: endSelectionState.getFocusOffset(),
	      isBackward: false
	    });
	  } else if (startEntityKey) {
	    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: _startSelectionState.getStartOffset(),
	      isBackward: false
	    });
	  } else if (endEntityKey) {
	    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      focusOffset: _endSelectionState.getEndOffset(),
	      isBackward: false
	    });
	  }
	  return newSelectionState;
	}
	
	function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entity = entityMap.__get(entityKey);
	  var mutability = entity.getMutability();
	  var sideToConsider = isEntityAtStart ? start : end;
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return sideToConsider <= range.end && sideToConsider >= range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  if (!isEntireSelectionWithinEntity) {
	    if (isEntityAtStart) {
	      end = entityRange.end;
	    } else {
	      start = entityRange.start;
	    }
	  }
	
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(438);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeClientRects = __webpack_require__(441);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    // If the first rectangle has 0 width, we use the second, this is needed
	    // because Chrome renders a 0 width rectangle when the selection contains
	    // a line break.
	    if (rects.length > 1 && rects[0].width === 0) {
	      var _rects$ = rects[1];
	      top = _rects$.top;
	      right = _rects$.right;
	      bottom = _rects$.bottom;
	      left = _rects$.left;
	    } else {
	      var _rects$2 = rects[0];
	      top = _rects$2.top;
	      right = _rects$2.right;
	      bottom = _rects$2.bottom;
	      left = _rects$2.left;
	    }
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 && rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(980);
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top,
	      right = boundingRect.right,
	      bottom = boundingRect.bottom,
	      left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(109);
	var ContentBlockNode = __webpack_require__(41);
	var Immutable = __webpack_require__(16);
	
	var insertIntoList = __webpack_require__(446);
	var invariant = __webpack_require__(19);
	var randomizeBlockMapKeys = __webpack_require__(449);
	
	var List = Immutable.List;
	
	
	var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
	  var targetBlock = blockMap.get(targetKey);
	  var text = targetBlock.getText();
	  var chars = targetBlock.getCharacterList();
	  var finalKey = targetKey;
	  var finalOffset = targetOffset + fragmentBlock.getText().length;
	
	  var newBlock = targetBlock.merge({
	    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
	    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
	    data: fragmentBlock.getData()
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.set(targetKey, newBlock),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Appends text/characterList from the fragment first block to
	 * target block.
	 */
	var updateHead = function updateHead(block, targetOffset, fragment) {
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var headText = text.slice(0, targetOffset);
	  var headCharacters = chars.slice(0, targetOffset);
	  var appendToHead = fragment.first();
	
	  return block.merge({
	    text: headText + appendToHead.getText(),
	    characterList: headCharacters.concat(appendToHead.getCharacterList()),
	    type: headText ? block.getType() : appendToHead.getType(),
	    data: appendToHead.getData()
	  });
	};
	
	/**
	 * Appends offset text/characterList from the target block to the last
	 * fragment block.
	 */
	var updateTail = function updateTail(block, targetOffset, fragment) {
	  // Modify tail portion of block.
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var blockSize = text.length;
	  var tailText = text.slice(targetOffset, blockSize);
	  var tailCharacters = chars.slice(targetOffset, blockSize);
	  var prependToTail = fragment.last();
	
	  return prependToTail.merge({
	    text: prependToTail.getText() + tailText,
	    characterList: prependToTail.getCharacterList().concat(tailCharacters),
	    data: prependToTail.getData()
	  });
	};
	
	var getRootBlocks = function getRootBlocks(block, blockMap) {
	  var headKey = block.getKey();
	  var rootBlock = block;
	  var rootBlocks = [];
	
	  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
	  // the fragment head is used to update the target block, however when this does not happen we need
	  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
	  // fragment root block
	  if (blockMap.get(headKey)) {
	    rootBlocks.push(headKey);
	  }
	
	  while (rootBlock && rootBlock.getNextSiblingKey()) {
	    var lastSiblingKey = rootBlock.getNextSiblingKey();
	
	    if (!lastSiblingKey) {
	      break;
	    }
	
	    rootBlocks.push(lastSiblingKey);
	    rootBlock = blockMap.get(lastSiblingKey);
	  }
	
	  return rootBlocks;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
	  return blockMap.withMutations(function (blockMapState) {
	    var targetKey = targetBlock.getKey();
	    var headKey = fragmentHeadBlock.getKey();
	    var targetNextKey = targetBlock.getNextSiblingKey();
	    var targetParentKey = targetBlock.getParentKey();
	    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
	    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];
	
	    if (blockMapState.get(headKey)) {
	      // update the fragment head when it is part of the blockMap otherwise
	      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
	      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
	    } else {
	      // update the target block that had the fragment head contents merged into it
	      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
	      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
	    }
	
	    // update the last root block fragment
	    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);
	
	    // update the original target next block
	    if (targetNextKey) {
	      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
	    }
	
	    // update fragment parent links
	    fragmentRootBlocks.forEach(function (blockKey) {
	      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
	    });
	
	    // update targetBlock parent child links
	    if (targetParentKey) {
	      var targetParent = blockMap.get(targetParentKey);
	      var originalTargetParentChildKeys = targetParent.getChildKeys();
	
	      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
	      var insertionIndex = targetBlockIndex + 1;
	
	      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();
	
	      // insert fragment children
	      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
	
	      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
	    }
	  });
	};
	
	var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	  var newBlockArr = [];
	  var fragmentSize = fragment.size;
	  var target = blockMap.get(targetKey);
	  var head = fragment.first();
	  var tail = fragment.last();
	  var finalOffset = tail.getLength();
	  var finalKey = tail.getKey();
	  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
	
	  blockMap.forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    if (shouldNotUpdateFromFragmentBlock) {
	      newBlockArr.push(block);
	    } else {
	      newBlockArr.push(updateHead(block, targetOffset, fragment));
	    }
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment
	    // when we are updating the target block with the head fragment block we skip the first fragment
	    // head since its contents have already been merged with the target block otherwise we include
	    // the whole fragment
	    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      return newBlockArr.push(fragmentBlock);
	    });
	
	    // update tail
	    newBlockArr.push(updateTail(block, targetOffset, fragment));
	  });
	
	  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);
	
	  if (isTreeBasedBlockMap) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var targetBlock = blockMap.get(targetKey);
	
	  if (targetBlock instanceof ContentBlockNode) {
	    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
	  }
	
	  // When we insert a fragment with a single block we simply update the target block
	  // with the contents of the inserted fragment block
	  if (fragment.size === 1) {
	    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
	  }
	
	  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
	};
	
	module.exports = insertFragmentIntoContentState;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(16);
	
	var insertIntoList = __webpack_require__(446);
	var invariant = __webpack_require__(19);
	
	var Repeat = Immutable.Repeat;
	
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	
	var expandRangeToStartOfLine = __webpack_require__(977);
	var getDraftEditorSelectionWithNodes = __webpack_require__(438);
	var moveSelectionBackward = __webpack_require__(193);
	var removeTextWithStrategy = __webpack_require__(112);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(433);
	var EditorState = __webpack_require__(23);
	
	var moveSelectionBackward = __webpack_require__(193);
	var removeTextWithStrategy = __webpack_require__(112);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(433);
	var EditorState = __webpack_require__(23);
	
	var moveSelectionForward = __webpack_require__(448);
	var removeTextWithStrategy = __webpack_require__(112);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	var UnicodeUtils = __webpack_require__(76);
	
	var moveSelectionBackward = __webpack_require__(193);
	var removeTextWithStrategy = __webpack_require__(112);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	var UnicodeUtils = __webpack_require__(76);
	
	var moveSelectionForward = __webpack_require__(448);
	var removeTextWithStrategy = __webpack_require__(112);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(35);
	var EditorState = __webpack_require__(23);
	
	var getContentStateFragment = __webpack_require__(141);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(23);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule modifyBlockForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(16);
	
	var Map = Immutable.Map;
	
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(41);
	var Immutable = __webpack_require__(16);
	
	var getNextDelimiterBlockKey = __webpack_require__(440);
	var invariant = __webpack_require__(19);
	
	var OrderedMap = Immutable.OrderedMap,
	    List = Immutable.List;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
	  if (!isExperimentalTreeBlock) {
	    return blockMap;
	  }
	  // possible values of 'insertionMode' are: 'after', 'before'
	  var isInsertedAfterTarget = insertionMode === 'after';
	
	  var originalBlockKey = originalBlockToBeMoved.getKey();
	  var originalTargetKey = originalTargetBlock.getKey();
	  var originalParentKey = originalBlockToBeMoved.getParentKey();
	  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
	  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
	  var newParentKey = originalTargetBlock.getParentKey();
	  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
	  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
	
	  return blockMap.withMutations(function (blocks) {
	    // update old parent
	    transformBlock(originalParentKey, blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      return block.merge({
	        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
	      });
	    });
	
	    // update old prev
	    transformBlock(originalPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalNextSiblingKey
	      });
	    });
	
	    // update old next
	    transformBlock(originalNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalPrevSiblingKey
	      });
	    });
	
	    // update new next
	    transformBlock(newNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	
	    // update new prev
	    transformBlock(newPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalBlockKey
	      });
	    });
	
	    // update new parent
	    transformBlock(newParentKey, blocks, function (block) {
	      var newParentChildrenList = block.getChildKeys();
	      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
	
	      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
	
	      var newChildrenArray = newParentChildrenList.toArray();
	      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: newNextSiblingKey,
	        prevSibling: newPrevSiblingKey,
	        parent: newParentKey
	      });
	    });
	  });
	};
	
	var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
	  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
	
	  var targetKey = targetBlock.getKey();
	  var blockKey = blockToBeMoved.getKey();
	
	  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
	
	  var blocksToBeMoved = [blockToBeMoved];
	  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);
	
	  if (isExperimentalTreeBlock) {
	    blocksToBeMoved = [];
	    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
	      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
	      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
	
	      blocks.toSeq().skipUntil(function (block) {
	        return block.getKey() === blockKey;
	      }).takeWhile(function (block) {
	        var key = block.getKey();
	        var isBlockToBeMoved = key === blockKey;
	        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
	        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
	
	        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
	      }).forEach(function (block) {
	        blocksToBeMoved.push(block);
	        blocks['delete'](block.getKey());
	      });
	    });
	  }
	
	  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
	    return v === targetBlock;
	  });
	
	  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
	    return v === targetBlock;
	  }).skip(1);
	
	  var slicedBlocks = blocksToBeMoved.map(function (block) {
	    return [block.getKey(), block];
	  });
	
	  var newBlocks = OrderedMap();
	
	  if (insertionMode === 'before') {
	    var blockBefore = contentState.getBlockBefore(targetKey);
	
	    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
	  } else if (insertionMode === 'after') {
	    var blockAfter = contentState.getBlockAfter(targetKey);
	
	    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
	  }
	
	  return contentState.merge({
	    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
	    selectionBefore: contentState.getSelectionAfter(),
	    selectionAfter: contentState.getSelectionAfter().merge({
	      anchorKey: blockKey,
	      focusKey: blockKey
	    })
	  });
	};
	
	module.exports = moveBlockInContentState;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(41);
	var Immutable = __webpack_require__(16);
	
	var getNextDelimiterBlockKey = __webpack_require__(440);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	/**
	 * Ancestors needs to be preserved when there are non selected
	 * children to make sure we do not leave any orphans behind
	 */
	var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
	  var parents = [];
	
	  if (!blockKey) {
	    return parents;
	  }
	
	  var blockNode = blockMap.get(blockKey);
	  while (blockNode && blockNode.getParentKey()) {
	    var parentKey = blockNode.getParentKey();
	    if (parentKey) {
	      parents.push(parentKey);
	    }
	    blockNode = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  return parents;
	};
	
	/**
	 * Get all next delimiter keys until we hit a root delimiter and return
	 * an array of key references
	 */
	var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
	  var nextDelimiters = [];
	
	  if (!block) {
	    return nextDelimiters;
	  }
	
	  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
	  while (nextDelimiter && blockMap.get(nextDelimiter)) {
	    var _block = blockMap.get(nextDelimiter);
	    nextDelimiters.push(nextDelimiter);
	
	    // we do not need to keep checking all root node siblings, just the first occurance
	    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
	  }
	
	  return nextDelimiters;
	};
	
	var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();
	
	  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
	    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
	  }
	
	  return nextValidSiblingKey;
	};
	
	var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();
	
	  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
	    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
	  }
	
	  return prevValidSiblingKey;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
	  return blockMap.withMutations(function (blocks) {
	    // update start block if its retained
	    transformBlock(startBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update endblock if its retained
	    transformBlock(endBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update start block parent ancestors
	    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      return transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update start block next - can only happen if startBlock == endBlock
	    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: startBlock.getPrevSiblingKey()
	      });
	    });
	
	    // update start block prev
	    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block next
	    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block prev
	    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: endBlock.getNextSiblingKey()
	      });
	    });
	
	    // update end block parent ancestors
	    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update next delimiters all the way to a root delimiter
	    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
	      return transformBlock(delimiterKey, blocks, function (block) {
	        return block.merge({
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	  });
	};
	
	var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	
	  // we assume that ContentBlockNode and ContentBlocks are not mixed together
	  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;
	
	  // used to retain blocks that should not be deleted to avoid orphan children
	  var parentAncestors = [];
	
	  if (isExperimentalTreeBlock) {
	    var endBlockchildrenKeys = endBlock.getChildKeys();
	    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);
	
	    // endBlock has unselected sibblings so we can not remove its ancestors parents
	    if (endBlock.getNextSiblingKey()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors);
	    }
	
	    // endBlock has children so can not remove this block or any of its ancestors
	    if (!endBlockchildrenKeys.isEmpty()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
	    }
	
	    // we need to retain all ancestors of the next delimiter block
	    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
	  }
	
	  var characterList = void 0;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).filter(function (_, k) {
	    return parentAncestors.indexOf(k) === -1;
	  }).concat(Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  if (isExperimentalTreeBlock) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	};
	
	module.exports = removeRangeFromContentState;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftJsDebugLogging = __webpack_require__(950);
	
	var containsNode = __webpack_require__(198);
	var getActiveElement = __webpack_require__(454);
	var invariant = __webpack_require__(19);
	
	function getAnonymizedDOM(node, getNodeLabels) {
	  if (!node) {
	    return '[empty]';
	  }
	
	  var anonymized = anonymizeTextWithin(node, getNodeLabels);
	  if (anonymized.nodeType === Node.TEXT_NODE) {
	    return anonymized.textContent;
	  }
	
	  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
	  return anonymized.outerHTML;
	}
	
	function anonymizeTextWithin(node, getNodeLabels) {
	  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];
	
	  if (node.nodeType === Node.TEXT_NODE) {
	    var length = node.textContent.length;
	    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
	  }
	
	  var clone = node.cloneNode();
	  if (clone.nodeType === 1 && labels.length) {
	    clone.setAttribute('data-labels', labels.join(', '));
	  }
	  var childNodes = node.childNodes;
	  for (var ii = 0; ii < childNodes.length; ii++) {
	    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
	  }
	
	  return clone;
	}
	
	function getAnonymizedEditorDOM(node, getNodeLabels) {
	  // grabbing the DOM content of the Draft editor
	  var currentNode = node;
	  while (currentNode) {
	    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
	      // found the Draft editor container
	      return getAnonymizedDOM(currentNode, getNodeLabels);
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	  return 'Could not find contentEditable parent of node';
	}
	
	function getNodeLength(node) {
	  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset, selectionState) {
	  var activeElement = getActiveElement();
	  if (selection.extend && containsNode(activeElement, node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	
	    // logging to catch bug that is being reported in t16250795
	    if (offset > getNodeLength(node)) {
	      // the call to 'selection.extend' is about to throw
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node),
	        extraParams: JSON.stringify({ offset: offset }),
	        selectionState: JSON.stringify(selectionState.toJS())
	      });
	    }
	
	    // logging to catch bug that is being reported in t18110632
	    var nodeWasFocus = node === selection.focusNode;
	    try {
	      selection.extend(node, offset);
	    } catch (e) {
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
	          var labels = [];
	          if (n === activeElement) {
	            labels.push('active element');
	          }
	          if (n === selection.anchorNode) {
	            labels.push('selection anchor node');
	          }
	          if (n === selection.focusNode) {
	            labels.push('selection focus node');
	          }
	          return labels;
	        }),
	        extraParams: JSON.stringify({
	          activeElementName: activeElement ? activeElement.nodeName : null,
	          nodeIsFocus: node === selection.focusNode,
	          nodeWasFocus: nodeWasFocus,
	          selectionRangeCount: selection.rangeCount,
	          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
	          selectionAnchorOffset: selection.anchorOffset,
	          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
	          selectionFocusOffset: selection.focusOffset,
	          message: e ? '' + e : null,
	          offset: offset
	        }, null, 2),
	        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
	      });
	      // allow the error to be thrown -
	      // better than continuing in a broken state
	      throw e;
	    }
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset, selectionState) {
	  var range = document.createRange();
	  // logging to catch bug that is being reported in t16250795
	  if (offset > getNodeLength(node)) {
	    // in this case we know that the call to 'range.setStart' is about to throw
	    DraftJsDebugLogging.logSelectionStateFailure({
	      anonymizedDom: getAnonymizedEditorDOM(node),
	      extraParams: JSON.stringify({ offset: offset }),
	      selectionState: JSON.stringify(selectionState.toJS())
	    });
	  }
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(41);
	var Immutable = __webpack_require__(16);
	
	var generateRandomKey = __webpack_require__(58);
	var invariant = __webpack_require__(19);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
	  return blockMap.withMutations(function (blocks) {
	    var originalBlockKey = originalBlock.getKey();
	    var belowBlockKey = belowBlock.getKey();
	
	    // update block parent
	    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
	      var newChildrenArray = parentChildrenList.toArray();
	
	      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update original next block
	    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: belowBlockKey
	      });
	    });
	
	    // update original block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: belowBlockKey
	      });
	    });
	
	    // update below block
	    transformBlock(belowBlockKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	  });
	};
	
	var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	  var keyBelow = generateRandomKey();
	  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();
	
	  if (isExperimentalTreeBlock) {
	    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
	
	    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
	  }
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	};
	
	module.exports = splitBlockInContentState;

/***/ },
/* 1000 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ },
/* 1001 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ },
/* 1002 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ },
/* 1003 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(453);
	var UnicodeBidiDirection = __webpack_require__(197);
	
	var invariant = __webpack_require__(19);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(1631);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(19);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ },
/* 1007 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1008 */
[1634, 19],
/* 1009 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  if (doc.scrollingElement) {
	    return doc.scrollingElement;
	  }
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(1011);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(198);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(1007);
	var hyphenate = __webpack_require__(1015);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ },
/* 1013 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1014 */
/***/ function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ },
/* 1015 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1016 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1017 */
[1635, 1016],
/* 1018 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ },
/* 1019 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 1020 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	// setimmediate adds setImmediate to the global. We want to make sure we export
	// the actual function.
	
	__webpack_require__(1605);
	module.exports = global.setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1022 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 1023 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 1025 */
455,
/* 1026 */
455,
/* 1027 */
455,
/* 1028 */
455,
/* 1029 */
455,
/* 1030 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(201);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(88);
	
	var _DOMUtils = __webpack_require__(143);
	
	var _DOMStateStorage = __webpack_require__(459);
	
	var _PathUtils = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(201);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(88);
	
	var _PathUtils = __webpack_require__(68);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var _BrowserProtocol = __webpack_require__(201);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1032);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(143);
	
	var _createHistory = __webpack_require__(203);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var _DOMUtils = __webpack_require__(143);
	
	var _HashProtocol = __webpack_require__(1031);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(203);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(88);
	
	var _PathUtils = __webpack_require__(68);
	
	var _createHistory = __webpack_require__(203);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 1036 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1037 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1038 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1039 */
/***/ function(module, exports) {

	module.exports = {
		"_args": [
			[
				"draft-convert@1.4.8",
				"C:\\Users\\Bobby Yang\\projects\\blitz-cms-frontend"
			]
		],
		"_from": "draft-convert@1.4.8",
		"_id": "draft-convert@1.4.8",
		"_inBundle": false,
		"_integrity": "sha1-dHQKzjaJeVOb0nt0GNmQHgZ+8m8=",
		"_location": "/draft-convert",
		"_phantomChildren": {},
		"_requested": {
			"type": "version",
			"registry": true,
			"raw": "draft-convert@1.4.8",
			"name": "draft-convert",
			"escapedName": "draft-convert",
			"rawSpec": "1.4.8",
			"saveSpec": null,
			"fetchSpec": "1.4.8"
		},
		"_requiredBy": [
			"/"
		],
		"_resolved": "https://registry.npmjs.org/draft-convert/-/draft-convert-1.4.8.tgz",
		"_spec": "1.4.8",
		"_where": "C:\\Users\\Bobby Yang\\projects\\blitz-cms-frontend",
		"author": {
			"name": "bbriggs@hubspot.com"
		},
		"bugs": {
			"url": "https://github.com/HubSpot/draft-convert/issues"
		},
		"dependencies": {
			"immutable": "~3.7.4",
			"invariant": "^2.2.1"
		},
		"description": "Extensibly serialize & deserialize Draft.js ContentState",
		"devDependencies": {
			"babel-cli": "^6.10.1",
			"babel-core": "^6.7.7",
			"babel-eslint": "^7.1.1",
			"babel-jest": "^18.0.0",
			"babel-loader": "^6.2.4",
			"babel-preset-es2015": "^6.6.0",
			"babel-preset-react": "^6.5.0",
			"cross-env": "^3.1.4",
			"draft-js": "^0.8.1",
			"eslint": "3.12.0",
			"eslint-config-hubspot": "^7.0.0",
			"eslint-plugin-react": "6.8.0",
			"jasmine": "^2.2.0",
			"jest": "^18.1.0",
			"json-loader": "^0.5.4",
			"karma": "^0.13.22",
			"karma-chrome-launcher": "^0.2.3",
			"karma-jasmine": "^0.3.8",
			"karma-webpack": "^1.7.0",
			"react": "^15.4.2",
			"react-dom": "^15.4.2",
			"rimraf": "2.5.4",
			"webpack": "^1.13.0"
		},
		"files": [
			"dist",
			"lib"
		],
		"homepage": "https://github.com/HubSpot/draft-convert#readme",
		"jest": {
			"testRegex": "/test/spec/.*\\.js$"
		},
		"keywords": [
			"draft",
			"draftjs",
			"draft-convert",
			"convert"
		],
		"license": "Apache-2.0",
		"main": "lib/index.js",
		"name": "draft-convert",
		"peerDependencies": {
			"draft-js": ">=0.7.0",
			"react": "^15.0.2",
			"react-dom": "^15.0.2"
		},
		"repository": {
			"type": "git",
			"url": "git+https://github.com/HubSpot/draft-convert.git"
		},
		"scripts": {
			"build": "npm run build:commonjs && npm run build:umd && npm run build:umd:min",
			"build-and-test": "npm run clean && npm run build && npm run test-once",
			"build:commonjs": "cross-env BABEL_ENV=commonjs babel src --out-dir lib",
			"build:umd": "webpack --config webpack.config.development.js ./src/index.js ./dist/draft-convert.js",
			"build:umd:min": "webpack --config webpack.config.production.js ./src/index.js ./dist/draft-convert.min.js",
			"clean": "rimraf ./dist && rimraf ./lib",
			"jest": "jest",
			"jest-debug": "node --debug-brk --inspect ./node_modules/.bin/jest -i",
			"lint": "eslint src/ test/",
			"prepublish": "npm run lint && npm run build-and-test",
			"test": "npm run jest",
			"test-once": "npm run jest",
			"test-once:karma": "karma start test/karma.config.js --single-run",
			"test:karma": "karma start test/karma.config.js"
		},
		"version": "1.4.8"
	};

/***/ },
/* 1040 */
/***/ function(module, exports) {

	module.exports = {
		"type": "champion",
		"format": "full",
		"version": "8.4.1",
		"data": {
			"Aatrox": {
				"id": "Aatrox",
				"key": "266",
				"name": "Aatrox",
				"title": "the Darkin Blade",
				"image": {
					"full": "Aatrox.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "266000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "266001",
						"num": 1,
						"name": "Justicar Aatrox",
						"chromas": false
					},
					{
						"id": "266002",
						"num": 2,
						"name": "Mecha Aatrox",
						"chromas": true
					},
					{
						"id": "266003",
						"num": 3,
						"name": "Sea Hunter Aatrox",
						"chromas": false
					}
				],
				"lore": "One of the ancient darkin, Aatrox was once a peerless swordmaster who reveled in the bloody chaos of the battlefield. Trapped within his own blade by the magic of his foes, he waited out the millennia for a suitable host to wield him—this mortal warrior was corrupted and transformed by the living weapon, and Aatrox was reborn. Though tales of the darkin have now passed into legend, he remembers only too well the destruction of his race, and wreaks his vengeance one sword blow at a time.",
				"blurb": "One of the ancient darkin, Aatrox was once a peerless swordmaster who reveled in the bloody chaos of the battlefield. Trapped within his own blade by the magic of his foes, he waited out the millennia for a suitable host to wield him—this mortal warrior...",
				"allytips": [
					"Being Hellbent contributes a significant amount of power in a fight, so avoid engaging with an empty Blood Well.",
					"Building Life Steal or small amounts of defense can be very potent on Aatrox, giving him more time to get the most out of being Hellbent.",
					"Massacre is great at turning the tide of a battle. Make sure to use it at the right moment to maximize its benefits."
				],
				"enemytips": [
					"Aatrox is much more powerful while Hellbent, so be cautious fighting him if he's able to fill his Blood Well.",
					"When Aatrox casts Dark Flight towards your location, avoid being knocked up by moving away from the center of impact.",
					"Aatrox is reliant on basic attacks for most of his damage and survivability, reducing his attack speed by purchasing Randuin's Omen or Frozen Heart can help reduce both of those components greatly."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Blood Well",
				"info": {
					"attack": 8,
					"defense": 4,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 580,
					"hpperlevel": 85,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 33,
					"armorperlevel": 3.8,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 150,
					"hpregen": 6.5,
					"hpregenperlevel": 0.5,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 70,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.04,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "AatroxQ",
						"name": "Dark Flight",
						"description": "Aatrox takes flight and slams down at a targeted location, dealing damage and knocking up enemies at the center of impact.",
						"tooltip": "Aatrox takes flight and slams down at target location, dealing {{ e1 }}<span class=\"colorF88017\"> (+{{ a1 }})</span> physical damage and knocking up enemies at the center of impact for {{ e4 }} second.<br /><br />Aatrox fills up 20% of the Blood Well upon cast.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12.5,
							12,
							11.5,
							11
						],
						"cooldownBurn": "13/12.5/12/11.5/11",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								50,
								80,
								110,
								140
							],
							[
								310,
								310,
								310,
								310,
								310
							],
							[
								190,
								190,
								190,
								190,
								190
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/50/80/110/140",
							"310",
							"190",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.1,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "AatroxQ.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "AatroxW",
						"name": "Blood Thirst / Blood Price",
						"description": "While toggled on Aatrox deals bonus damage and fills a portion of his Blood Well every third subsequent attack. While toggled off Aatrox restores Health every third subsequent attack.",
						"tooltip": "<span class=\"colorFF9900\">Toggle Off:</span><span class=\"colore60000\"> Blood Thirst: </span>Every third attack, Aatrox restores {{ e3 }} <span class=\"colorCC3300\">(+{{ f1*100 }}% Missing Health)</span> Health.<br /><br /><span class=\"colorFF9900\">Toggle On:</span><span class=\"color9900ff\"> Blood Price: </span>Every third attack, Aatrox deals {{ e2 }}<span class=\"colorF88017\"> (+{{ a2 }})</span> bonus physical damage and fills up 20% of the Blood Well.",
						"leveltip": {
							"label": [
								"Heal",
								"Damage"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						"cooldownBurn": "0.5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								50,
								85,
								120,
								155,
								190
							],
							[
								30,
								45,
								60,
								75,
								90
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200",
							"50/85/120/155/190",
							"30/45/60/75/90",
							"50",
							"50",
							"0.5",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.75,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "AatroxW.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "AatroxE",
						"name": "Blades of Torment",
						"description": "Aatrox unleashes the power of his blade, dealing damage to enemies hit and slowing them.",
						"tooltip": "Aatrox unleashes the power of his blade, dealing {{ e1 }} <span class=\"colorF88017\">(+{{ a2 }})</span> physical damage to enemies hit and slowing them by {{ e2 }}% for {{ e3 }} seconds.<br /><br />Aatrox fills up 20% of the Blood Well upon cast.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"30/35/40/45/50",
							"2",
							"30",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.7,
								"key": "a2"
							}
						],
						"costType": " Health",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "AatroxE.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e4 }} Health"
					},
					{
						"id": "AatroxR",
						"name": "Massacre",
						"description": "Aatrox draws in the blood of his foes, damaging all nearby enemy champions around him and gaining increased Attack Speed and bonus Attack Range for a short duration.",
						"tooltip": "Aatrox draws in the blood of his foes, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemy champions, filling up 20% of the Blood Well for each hit.<br /><br />Aatrox gains {{ e3 }}% Attack Speed and {{ e5 }} attack range for {{ e8 }} seconds upon cast.",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							85,
							70
						],
						"cooldownBurn": "100/85/70",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								550,
								550,
								550
							],
							[
								200,
								300,
								400
							],
							[
								40,
								50,
								60
							],
							[
								0,
								0,
								0
							],
							[
								225,
								225,
								225
							],
							[
								0,
								0,
								0
							],
							[
								20,
								20,
								20
							],
							[
								12,
								12,
								12
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"550",
							"200/300/400",
							"40/50/60",
							"0",
							"225",
							"0",
							"20",
							"12",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "AatroxR.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Blood Well",
					"description": "Aatrox fills up his Blood Well through his abilities. When filled, Aatrox becomes Hellbent for as long as he stays in combat with champions or monsters, granting him attack damage, attack speed, and the ability to survive fatal damage.",
					"image": {
						"full": "Aatrox_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Aatrox",
						"title": "AatroxARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "AatroxCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "AatroxFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "AatroxKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "AatroxSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "AatroxSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "AatroxTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Aatrox",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Ahri": {
				"id": "Ahri",
				"key": "103",
				"name": "Ahri",
				"title": "the Nine-Tailed Fox",
				"image": {
					"full": "Ahri.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "103000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "103001",
						"num": 1,
						"name": "Dynasty Ahri",
						"chromas": false
					},
					{
						"id": "103002",
						"num": 2,
						"name": "Midnight Ahri",
						"chromas": false
					},
					{
						"id": "103003",
						"num": 3,
						"name": "Foxfire Ahri",
						"chromas": false
					},
					{
						"id": "103004",
						"num": 4,
						"name": "Popstar Ahri",
						"chromas": true
					},
					{
						"id": "103005",
						"num": 5,
						"name": "Challenger Ahri",
						"chromas": false
					},
					{
						"id": "103006",
						"num": 6,
						"name": "Academy Ahri",
						"chromas": false
					},
					{
						"id": "103007",
						"num": 7,
						"name": "Arcade Ahri",
						"chromas": false
					},
					{
						"id": "103014",
						"num": 14,
						"name": "Star Guardian Ahri",
						"chromas": false
					}
				],
				"lore": "Innately connected to the latent power of Runeterra, Ahri is a vastaya who can reshape magic into orbs of raw energy. She revels in toying with her prey by manipulating their emotions before devouring their life essence. Despite her predatory nature, Ahri retains a sense of empathy as she receives flashes of memory from each soul she consumes.",
				"blurb": "Innately connected to the latent power of Runeterra, Ahri is a vastaya who can reshape magic into orbs of raw energy. She revels in toying with her prey by manipulating their emotions before devouring their life essence. Despite her predatory nature...",
				"allytips": [
					"Use Charm to set up your combos, it will make landing Orb of Deception and Fox-Fire dramatically easier.",
					"Initiate team fights using Charm, and chase down stragglers with Spirit Rush.",
					"Spirit Rush enables Ahri's abilities, it opens up paths for Charm, helps double hitting with Orb of Deception, and closes to make use of Fox-Fire."
				],
				"enemytips": [
					"Ahri's survivability is dramatically reduced when her Ultimate, Spirit Rush, is down.",
					"Stay behind minions to make Charm difficult to land, this will reduce Ahri's damage potential significantly."
				],
				"tags": [
					"Mage",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 4,
					"magic": 8,
					"difficulty": 5
				},
				"stats": {
					"hp": 526,
					"hpperlevel": 92,
					"mp": 334,
					"mpperlevel": 50,
					"movespeed": 330,
					"armor": 20.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.065,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "AhriOrbofDeception",
						"name": "Orb of Deception",
						"description": "Ahri sends out and pulls back her orb, dealing magic damage on the way out and true damage on the way back. Ahri gains movement speed that decays while her orb is traveling.",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage on the way out, and {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> true damage on the way back.<br /><br />Ahri gains movement speed that decays while her orb is traveling.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"  {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							7,
							7,
							7,
							7
						],
						"cooldownBurn": "7",
						"cost": [
							65,
							70,
							75,
							80,
							85
						],
						"costBurn": "65/70/75/80/85",
						"effect": [
							null,
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/65/90/115/140",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							880,
							880,
							880,
							880,
							880
						],
						"rangeBurn": "880",
						"image": {
							"full": "AhriOrbofDeception.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AhriFoxFire",
						"name": "Fox-Fire",
						"description": "Ahri releases three fox-fires, that lock onto and attack nearby enemies.",
						"tooltip": "Releases three fox-fires that lock on to nearby enemies (prioritizes Champions) dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Enemies hit with multiple fox-fires take 30% damage from each additional fox-fire beyond the first, for a maximum of {{ f1 }} damage to a single enemy.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								12,
								19.5,
								27,
								34.5,
								42
							],
							[
								64,
								104,
								144,
								184,
								224
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/65/90/115/140",
							"12/19.5/27/34.5/42",
							"64/104/144/184/224",
							"30",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "AhriFoxFire.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AhriSeduce",
						"name": "Charm",
						"description": "Ahri blows a kiss that damages and charms an enemy it encounters, causing them to walk harmlessly towards her.",
						"tooltip": "Blows a kiss dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and charms an enemy causing them to walk harmlessly towards Ahri for {{ e2 }} second(s).",
						"leveltip": {
							"label": [
								"Damage",
								"Duration"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							85,
							85,
							85,
							85,
							85
						],
						"costBurn": "85",
						"effect": [
							null,
							[
								60,
								95,
								130,
								165,
								200
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/95/130/165/200",
							"1/1.25/1.5/1.75/2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							975,
							975,
							975,
							975,
							975
						],
						"rangeBurn": "975",
						"image": {
							"full": "AhriSeduce.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AhriTumble",
						"name": "Spirit Rush",
						"description": "Ahri dashes forward and fires essence bolts, damaging 3 nearby enemies (prioritizes Champions). Spirit Rush can be cast up to three times before going on cooldown.",
						"tooltip": "Nimbly dashes forward firing 3 essence bolts at nearby enemies (prioritizes Champions) dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Can be cast up to three times within 10 seconds before going on cooldown.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							95,
							80
						],
						"cooldownBurn": "110/95/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								70,
								110,
								150
							],
							[
								10,
								20,
								30
							],
							[
								28,
								23,
								18
							],
							[
								2,
								2,
								2
							],
							[
								1,
								1,
								1
							],
							[
								10,
								10,
								10
							],
							[
								10,
								10,
								10
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150",
							"10/20/30",
							"28/23/18",
							"2",
							"1",
							"10",
							"10",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "AhriTumble.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Essence Theft",
					"description": "Gains a charge of Essence Theft whenever a spell hits an enemy (max: 3 charges per spell). Upon reaching 9 charges, Ahri's next spell heals her whenever it hits an enemy.",
					"image": {
						"full": "Ahri_SoulEater.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ahri",
						"title": "AhriARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3114",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "AhriTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ahri",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					}
				]
			},
			"Akali": {
				"id": "Akali",
				"key": "84",
				"name": "Akali",
				"title": "the Fist of Shadow",
				"image": {
					"full": "Akali.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "84000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "84001",
						"num": 1,
						"name": "Stinger Akali",
						"chromas": false
					},
					{
						"id": "84002",
						"num": 2,
						"name": "Crimson Akali",
						"chromas": false
					},
					{
						"id": "84003",
						"num": 3,
						"name": "All-star Akali",
						"chromas": false
					},
					{
						"id": "84004",
						"num": 4,
						"name": "Nurse Akali",
						"chromas": false
					},
					{
						"id": "84005",
						"num": 5,
						"name": "Blood Moon Akali",
						"chromas": false
					},
					{
						"id": "84006",
						"num": 6,
						"name": "Silverfang Akali",
						"chromas": false
					},
					{
						"id": "84007",
						"num": 7,
						"name": "Headhunter Akali",
						"chromas": false
					},
					{
						"id": "84008",
						"num": 8,
						"name": "Sashimi Akali",
						"chromas": false
					}
				],
				"lore": "A prodigy in the fighting arts, Akali is a member of the martial order known as the Kinkou. She succeeds her mother as the Fist of Shadow, entrusted with the sacred duty to end those who would bring imbalance to her homeland. While some find her methods extreme, Akali is judicious in maintaining harmony across Ionia.",
				"blurb": "A prodigy in the fighting arts, Akali is a member of the martial order known as the Kinkou. She succeeds her mother as the Fist of Shadow, entrusted with the sacred duty to end those who would bring imbalance to her homeland. While some find her methods...",
				"allytips": [
					"Akali excels at killing weaker characters. Let your team initiate and then strike at the people in the back.",
					"Find the balance between storing Essence of Shadows, and using Shadow Dance before having max charges."
				],
				"enemytips": [
					"Akali can still be hit by area effect spells while Invisible inside Twilight Shroud.",
					"Akali can choose where she starts within her Twilight Shroud before casting it, even if part of the shroud would extend beyond a wall.",
					"Return to base if your Health is low and Akali has multiple charges of her ultimate."
				],
				"tags": [
					"Assassin"
				],
				"partype": "Energy",
				"info": {
					"attack": 5,
					"defense": 3,
					"magic": 8,
					"difficulty": 7
				},
				"stats": {
					"hp": 593,
					"hpperlevel": 90,
					"mp": 200,
					"mpperlevel": 0,
					"movespeed": 350,
					"armor": 31.38,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.65,
					"mpregen": 50,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 58.376,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.1,
					"attackspeedperlevel": 3.1
				},
				"spells": [
					{
						"id": "AkaliMota",
						"name": "Mark of the Assassin",
						"description": "Akali spins her kama at a target enemy to deal Magic Damage and mark the target for 6 seconds. Akali's melee attacks against a marked target will trigger and consume the mark to cause additional damage and restore Energy.",
						"tooltip": "Akali throws her kama at a target enemy to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and mark the target for {{ e4 }} seconds.<br /><br />Akali's melee attacks against a marked target will consume the mark to deal {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and restore {{ e3 }} energy.",
						"leveltip": {
							"label": [
								"Damage (initial)",
								"Damage (secondary)",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.5,
							5,
							4.5,
							4
						],
						"cooldownBurn": "6/5.5/5/4.5/4",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								35,
								55,
								75,
								95,
								115
							],
							[
								45,
								70,
								95,
								120,
								145
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/55/75/95/115",
							"45/70/95/120/145",
							"40",
							"6",
							"0",
							"0.4",
							"4",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a2"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "AkaliMota.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "AkaliSmokeBomb",
						"name": "Twilight Shroud",
						"description": "Akali teleports to a nearby location, leaving a cover of smoke at her previous location. While inside the shroud, Akali becomes Invisible and gains Movement Speed. Attacking or using abilities will briefly reveal her. Enemies inside the smoke have their Movement Speed reduced.",
						"tooltip": "Akali teleports to a nearby location, leaving a cover of smoke at her previous location that lasts for {{ e2 }} seconds and slows enemies within its area by {{ e3 }}%.<br /><br />While inside the shroud Akali gains <span class=\"color91d7ee\">Invisibility</span> and {{ e6 }}% movement speed. Attacking or using abilities briefly removes <span class=\"color91d7ee\">Invisibility</span>.<br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Akali can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
						"leveltip": {
							"label": [
								"Movement Speed",
								"Slow",
								"Cost"
							],
							"effect": [
								"{{ e6 }}% -> {{ e6NL }}%",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							18,
							18,
							18,
							18
						],
						"cooldownBurn": "18",
						"cost": [
							60,
							55,
							50,
							45,
							40
						],
						"costBurn": "60/55/50/45/40",
						"effect": [
							null,
							[
								425,
								425,
								425,
								425,
								425
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								14,
								18,
								22,
								26,
								30
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"425",
							"8",
							"14/18/22/26/30",
							"250",
							"0",
							"20/40/60/80/100",
							"1",
							"0.5",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							270,
							270,
							270,
							270,
							270
						],
						"rangeBurn": "270",
						"image": {
							"full": "AkaliSmokeBomb.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "AkaliShadowSwipe",
						"name": "Crescent Slash",
						"description": "Akali flourishes her kamas, dealing damage based on her bonus Attack Damage and Ability Power. When Crescent Slash kills a unit, it has a shorter cooldown.",
						"tooltip": "Akali flourishes her kamas, slicing enemies for {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage.<br /><br />If Crescent Slash kills an enemy, its cooldown is refunded by {{ e3 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							4.5,
							4,
							3.5,
							3
						],
						"cooldownBurn": "5/4.5/4/3.5/3",
						"cost": [
							60,
							55,
							50,
							45,
							40
						],
						"costBurn": "60/55/50/45/40",
						"effect": [
							null,
							[
								70,
								100,
								130,
								160,
								190
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/100/130/160/190",
							"1",
							"60",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "AkaliShadowSwipe.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "AkaliShadowDance",
						"name": "Shadow Dance",
						"description": "Akali moves through shadows to quickly strike through her target, dealing damage and consuming an Essence of Shadow charge. Akali recharges Essence of Shadow charges periodically, max 3 stacks.",
						"tooltip": "Akali quickly strikes through her target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Akali stores an Essence of Shadow on kills and assists as well as every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds up to {{ e4 }} total.",
						"leveltip": {
							"label": [
								"Damage",
								"Essence Refresh Timer"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f1 }} -> {{ f2 }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							2,
							2,
							2
						],
						"cooldownBurn": "2",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								50,
								100,
								150
							],
							[
								2000,
								2000,
								2000
							],
							[
								1,
								1,
								1
							],
							[
								3,
								3,
								3
							],
							[
								1,
								1,
								1
							],
							[
								100,
								100,
								100
							],
							[
								200,
								200,
								200
							],
							[
								600,
								600,
								600
							],
							[
								225,
								225,
								225
							],
							[
								1,
								1,
								1
							]
						],
						"effectBurn": [
							null,
							"50/100/150",
							"2000",
							"1",
							"3",
							"1",
							"100",
							"200",
							"600",
							"225",
							"1"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							},
							{
								"link": "@cooldownchampion",
								"coeff": [
									30,
									22.5,
									15
								],
								"key": "f1"
							},
							{
								"link": "@cooldownchampion",
								"coeff": [
									30,
									22.5,
									15
								],
								"key": "f1"
							},
							{
								"link": "@cooldownchampion",
								"coeff": [
									22.5,
									15
								],
								"key": "f2"
							}
						],
						"costType": " Essence of Shadow",
						"maxammo": "3",
						"range": [
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "AkaliShadowDance.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e5 }} Essence of Shadow"
					}
				],
				"passive": {
					"name": "Twin Disciplines",
					"description": "Akali's first two attacks are empowered. The first strike heals her, and the second strike deals bonus magic damage. Twin Disciplines will recharge itself automatically a short while after being used.",
					"image": {
						"full": "AkaliTwinDisciplines.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Akali",
						"title": "AkaliARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "AkaliCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "AkaliFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "AkaliKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "AkaliSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "AkaliSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "AkaliTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Akali",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"customPanel": "",
						"customPanelCurrencyType": "",
						"customPanelBuffCurrencyName": "",
						"blocks": [
							{
								"type": "beginner_Starter",
								"recMath": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_Starter",
								"recMath": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"recMath": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Alistar": {
				"id": "Alistar",
				"key": "12",
				"name": "Alistar",
				"title": "the Minotaur",
				"image": {
					"full": "Alistar.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "12000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "12001",
						"num": 1,
						"name": "Black Alistar",
						"chromas": false
					},
					{
						"id": "12002",
						"num": 2,
						"name": "Golden Alistar",
						"chromas": false
					},
					{
						"id": "12003",
						"num": 3,
						"name": "Matador Alistar",
						"chromas": false
					},
					{
						"id": "12004",
						"num": 4,
						"name": "Longhorn Alistar",
						"chromas": false
					},
					{
						"id": "12005",
						"num": 5,
						"name": "Unchained Alistar",
						"chromas": false
					},
					{
						"id": "12006",
						"num": 6,
						"name": "Infernal Alistar",
						"chromas": false
					},
					{
						"id": "12007",
						"num": 7,
						"name": "Sweeper Alistar",
						"chromas": false
					},
					{
						"id": "12008",
						"num": 8,
						"name": "Marauder Alistar",
						"chromas": false
					},
					{
						"id": "12009",
						"num": 9,
						"name": "SKT T1 Alistar",
						"chromas": false
					},
					{
						"id": "12010",
						"num": 10,
						"name": "Moo Cow Alistar",
						"chromas": true
					}
				],
				"lore": "Always a mighty warrior with a fearsome reputation, Alistar seeks revenge for the death of his clan at the hands of the Noxian empire. Though he was enslaved and forced into the life of a gladiator, his unbreakable will was what kept him from truly becoming a beast. Now, free of the chains of his former masters, he fights in the name of the downtrodden and the disadvantaged, his rage as much a weapon as his horns, hooves and fists.",
				"blurb": "Always a mighty warrior with a fearsome reputation, Alistar seeks revenge for the death of his clan at the hands of the Noxian empire. Though he was enslaved and forced into the life of a gladiator, his unbreakable will was what kept him from truly...",
				"allytips": [
					"Using Pulverize can allow you to establish better positioning for Headbutt.",
					"Movement speed is very important on Alistar. Consider which boots to buy carefully.",
					"Using Flash can allow you catch your target off guard to knock them back into your allies with Pulverize and Headbutt."
				],
				"enemytips": [
					"Alistar is very disruptive but very tough - try to target more fragile damage dealers.",
					"Watch out for the Pulverize-Headbutt combo when around turrets.",
					"When Alistar uses his ultimate, it's often better to move back and wait until the effect wears off before attacking him."
				],
				"tags": [
					"Tank",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 9,
					"magic": 5,
					"difficulty": 7
				},
				"stats": {
					"hp": 613.36,
					"hpperlevel": 106,
					"mp": 278.84,
					"mpperlevel": 38,
					"movespeed": 330,
					"armor": 44,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.85,
					"mpregen": 8.5,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61.1116,
					"attackdamageperlevel": 3.62,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.125
				},
				"spells": [
					{
						"id": "Pulverize",
						"name": "Pulverize",
						"description": "Alistar smashes the ground, dealing damage to nearby enemies and tossing them into the air.",
						"tooltip": "Alistar smashes the ground, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and tossing nearby enemy units into the air for {{ e3 }} second.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							16,
							15,
							14,
							13
						],
						"cooldownBurn": "17/16/15/14/13",
						"cost": [
							65,
							70,
							75,
							80,
							85
						],
						"costBurn": "65/70/75/80/85",
						"effect": [
							null,
							[
								375,
								375,
								375,
								375,
								375
							],
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"375",
							"60/105/150/195/240",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							365,
							365,
							365,
							365,
							365
						],
						"rangeBurn": "365",
						"image": {
							"full": "Pulverize.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Headbutt",
						"name": "Headbutt",
						"description": "Alistar rams a target with his head, dealing damage and knocking the target back.",
						"tooltip": "Alistar rams into an enemy, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and knocking them back.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							65,
							70,
							75,
							80,
							85
						],
						"costBurn": "65/70/75/80/85",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								55,
								110,
								165,
								220,
								275
							],
							[
								700,
								700,
								700,
								700,
								700
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"55/110/165/220/275",
							"700",
							"0.75",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "Headbutt.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AlistarE",
						"name": "Trample",
						"description": "Alistar tramples nearby enemy units, ignoring unit collision and gaining stacks if he damages an enemy champion. At full stacks Alistar's next basic attack against an enemy champion deals additional magic damage and stuns them.",
						"tooltip": "Alistar tramples the ground, ignoring unit collision and dealing {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage over {{ e3 }} seconds to nearby enemies. Each pulse that damages at least one enemy champion grants Alistar a <span class=\"colorFF6E1C\">Trample</span> stack.<br /><br />At {{ e5 }} <span class=\"colorFF6E1C\">Trample</span> stacks Alistar empowers his next basic attack against an enemy champion to deal an additional <span class=\"colorFFFFFF\">{{ f3 }}</span> magic damage and stun for {{ e6 }} second.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Mana Cost",
								"Trample Damage"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11.5,
							11,
							10.5,
							10
						],
						"cooldownBurn": "12/11.5/11/10.5/10",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								100,
								125,
								150,
								175,
								200
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								350,
								350,
								350,
								350,
								350
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/125/150/175/200",
							"50",
							"5",
							"350",
							"5",
							"1",
							"5",
							"40",
							"15",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "AlistarE.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FerociousHowl",
						"name": "Unbreakable Will",
						"description": "Alistar lets out a wild roar, removing all crowd control effects on himself, and reducing incoming physical and magical damage for the duration.",
						"tooltip": "Removes all disables from Alistar. For {{ e1 }} seconds Alistar takes {{ e2 }}% reduced physical and magical damage.",
						"leveltip": {
							"label": [
								"Damage Reduction",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								7,
								7,
								7
							],
							[
								55,
								65,
								75
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"7",
							"55/65/75",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "FerociousHowl.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Triumphant Roar",
					"description": "Alistar charges his roar by stunning or displacing enemy champions or when nearby enemies die. When fully charged he heals himself and all nearby allied champions.",
					"image": {
						"full": "Alistar_E.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Alistar",
						"title": "AlistarARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "AlistarCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "AlistarFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3711",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "AlistarKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "AlistarSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "AlistarSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "AlistarTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Alistar",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3158",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3065",
										"count": 1
									},
									{
										"id": "3110",
										"count": 1
									},
									{
										"id": "3001",
										"count": 1
									},
									{
										"id": "3083",
										"count": 1
									}
								]
							}
						]
					}
				]
			},
			"Amumu": {
				"id": "Amumu",
				"key": "32",
				"name": "Amumu",
				"title": "the Sad Mummy",
				"image": {
					"full": "Amumu.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "32000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "32001",
						"num": 1,
						"name": "Pharaoh Amumu",
						"chromas": false
					},
					{
						"id": "32002",
						"num": 2,
						"name": "Vancouver Amumu",
						"chromas": false
					},
					{
						"id": "32003",
						"num": 3,
						"name": "Emumu",
						"chromas": false
					},
					{
						"id": "32004",
						"num": 4,
						"name": "Re-Gifted Amumu",
						"chromas": false
					},
					{
						"id": "32005",
						"num": 5,
						"name": "Almost-Prom King Amumu",
						"chromas": false
					},
					{
						"id": "32006",
						"num": 6,
						"name": "Little Knight Amumu",
						"chromas": false
					},
					{
						"id": "32007",
						"num": 7,
						"name": "Sad Robot Amumu",
						"chromas": false
					},
					{
						"id": "32008",
						"num": 8,
						"name": "Surprise Party Amumu",
						"chromas": true
					}
				],
				"lore": "Legend claims that Amumu is a lonely and melancholy soul from ancient Shurima, roaming the world in search of a friend. Doomed by an ancient curse to remain alone forever, his touch is death, his affection ruin. Those who claim to have seen him describe a living cadaver, small in stature and wrapped in creeping bandages. Amumu has inspired myths, songs, and folklore told and retold for generations—such that it is impossible to separate truth from fiction.",
				"blurb": "Legend claims that Amumu is a lonely and melancholy soul from ancient Shurima, roaming the world in search of a friend. Doomed by an ancient curse to remain alone forever, his touch is death, his affection ruin. Those who claim to have seen him describe...",
				"allytips": [
					"Amumu is highly dependent on teammates, so try laning with your friends for maximum effectiveness.",
					"Cooldown Reduction on Amumu is very strong, but it's often difficult to itemize for it. Grab the Golem buff whenever possible to gain Cooldown Reduction without sacrificing stats.",
					"Despair is very effective against other tanks, so make sure you're in range of opponents with the highest Health."
				],
				"enemytips": [
					"Avoid bunching up with other allies when Amumu has his ultimate available.",
					"Erratic movement, or hiding behind creep waves can make it difficult for Amumu to instigate a fight with Bandage Toss.",
					"Amumu's Despair makes purchasing primarily Health items a risky proposition."
				],
				"tags": [
					"Tank",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 6,
					"magic": 8,
					"difficulty": 3
				},
				"stats": {
					"hp": 613.12,
					"hpperlevel": 84,
					"mp": 287.2,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 33,
					"armorperlevel": 3.8,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9,
					"hpregenperlevel": 0.85,
					"mpregen": 7.382,
					"mpregenperlevel": 0.525,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.38,
					"attackdamageperlevel": 3.8,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 2.18
				},
				"spells": [
					{
						"id": "BandageToss",
						"name": "Bandage Toss",
						"description": "Amumu tosses a sticky bandage at a target, stunning and damaging the target while he pulls himself to them.",
						"tooltip": "Launches a bandage in a direction. If it hits an enemy unit, Amumu pulls himself to them, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and stunning for {{ e2 }} second. ",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14,
							12,
							10,
							8
						],
						"cooldownBurn": "16/14/12/10/8",
						"cost": [
							80,
							90,
							100,
							110,
							120
						],
						"costBurn": "80/90/100/110/120",
						"effect": [
							null,
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1350,
								1350,
								1350,
								1350,
								1350
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/130/180/230/280",
							"1",
							"1350",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "BandageToss.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AuraofDespair",
						"name": "Despair",
						"description": "Overcome by anguish, nearby enemies lose a percentage of their maximum Health each second and have their <font color='#9b0f5f'>Curses</font> refreshed.",
						"tooltip": "<span class=\"colorFF9900\">Toggle: </span>Amumu cries, refreshing <span class=\"color9b0f5f\">Curses</span> on nearby enemies and dealing magic damage equal to {{ e2 }} plus {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of their maximum health each second.",
						"leveltip": {
							"label": [
								"Percent Health Damaged",
								"Base Damage"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1,
							1,
							1,
							1,
							1
						],
						"cooldownBurn": "1",
						"cost": [
							8,
							8,
							8,
							8,
							8
						],
						"costBurn": "8",
						"effect": [
							null,
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1/1.25/1.5/1.75/2",
							"10/15/20/25/30",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.01,
								"key": "a1"
							}
						],
						"costType": " Mana per Second",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "AuraofDespair.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana per Second"
					},
					{
						"id": "Tantrum",
						"name": "Tantrum",
						"description": "Permanently reduces the physical damage Amumu would take. Amumu can unleash his rage, dealing damage to surrounding enemies. Each time Amumu is hit, the cooldown on Tantrum is reduced by 0.5 seconds.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Amumu takes {{ e1 }} reduced damage from physical attacks.<br /><br /><span class=\"colorFF9900\">Active: </span>Amumu tantrums, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to surrounding units.<br /><br /><span class=\"size16 color8C8C8C\">Basic attacks that hit Amumu reduce the cooldown of Tantrum by 0.5 seconds.</span>",
						"leveltip": {
							"label": [
								"Damage Reduced",
								"Cooldown",
								"Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							35,
							35,
							35,
							35,
							35
						],
						"costBurn": "35",
						"effect": [
							null,
							[
								2,
								4,
								6,
								8,
								10
							],
							[
								75,
								100,
								125,
								150,
								175
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2/4/6/8/10",
							"75/100/125/150/175",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "Tantrum.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CurseoftheSadMummy",
						"name": "Curse of the Sad Mummy",
						"description": "Amumu entangles surrounding enemy units in bandages, applying his <font color='#9b0f5f'>Curse</font>, damaging them and rendering them unable to attack or move.",
						"tooltip": "Amumu entangles nearby enemy units, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and applying <span class=\"color9b0f5f\">Curse</span>. Entangled enemies are unable to attack or move for 2 seconds.",
						"leveltip": {
							"label": [
								"Damage Dealt",
								"Mana Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							150,
							130,
							110
						],
						"cooldownBurn": "150/130/110",
						"cost": [
							100,
							150,
							200
						],
						"costBurn": "100/150/200",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "CurseoftheSadMummy.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Cursed Touch",
					"description": "Amumu's basic attacks <font color='#9b0f5f'>Curse</font> enemies for 3 seconds, causing them to take 10% bonus true damage from any magic damage dealt to them.<rules>",
					"image": {
						"full": "Amumu_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Amumu",
						"title": "AmumuARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "AmumuCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "AmumuFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "AmumuKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "AmumuSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "AmumuSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "AmumuTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Amumu",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1054",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1054",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3068",
										"count": 1
									},
									{
										"id": "3105",
										"count": 1
									},
									{
										"id": "3110",
										"count": 1
									},
									{
										"id": "3001",
										"count": 1
									}
								]
							}
						]
					}
				]
			},
			"Anivia": {
				"id": "Anivia",
				"key": "34",
				"name": "Anivia",
				"title": "the Cryophoenix",
				"image": {
					"full": "Anivia.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "34000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "34001",
						"num": 1,
						"name": "Team Spirit Anivia",
						"chromas": false
					},
					{
						"id": "34002",
						"num": 2,
						"name": "Bird of Prey Anivia",
						"chromas": false
					},
					{
						"id": "34003",
						"num": 3,
						"name": "Noxus Hunter Anivia",
						"chromas": false
					},
					{
						"id": "34004",
						"num": 4,
						"name": "Hextech Anivia",
						"chromas": false
					},
					{
						"id": "34005",
						"num": 5,
						"name": "Blackfrost Anivia",
						"chromas": false
					},
					{
						"id": "34006",
						"num": 6,
						"name": "Prehistoric Anivia",
						"chromas": false
					},
					{
						"id": "34007",
						"num": 7,
						"name": "Festival Queen Anivia",
						"chromas": false
					}
				],
				"lore": "Anivia is a benevolent winged spirit who endures endless cycles of life, death, and rebirth to protect the Freljord. A demigod born of unforgiving ice and bitter winds, she wields those elemental powers to thwart any who dare disturb her homeland. Anivia guides and protects the tribes of the harsh north, who revere her as a symbol of hope, and a portent of great change. She fights with every ounce of her being, knowing that through her sacrifice, her memory will endure, and she will be reborn into a new tomorrow.",
				"blurb": "Anivia is a benevolent winged spirit who endures endless cycles of life, death, and rebirth to protect the Freljord. A demigod born of unforgiving ice and bitter winds, she wields those elemental powers to thwart any who dare disturb her homeland...",
				"allytips": [
					"Timing Flash Frost with Frostbite can lead to devastating combinations.",
					"Anivia is extremely reliant on Mana for Glacial Storm. Try getting items with Mana or going for a Crest of the Ancient Golem buff on Summoner's Rift.",
					"It can be very difficult for enemy champions to kill her egg early in game. Seize the advantage by playing aggressively."
				],
				"enemytips": [
					"Try to gank Anivia when she's laning. With multiple people, it is easier to ensure that her egg dies.",
					"If you're playing a ranged champion, stay far enough away from Anivia so you can dodge Flash Frost more easily.",
					"Try to fight Anivia in the lanes. In the jungle she can block pathways with lower ranks of Crystallize."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 4,
					"magic": 10,
					"difficulty": 10
				},
				"stats": {
					"hp": 480,
					"hpperlevel": 82,
					"mp": 396.04,
					"mpperlevel": 50,
					"movespeed": 325,
					"armor": 21.22,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 600,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 51.376,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.68
				},
				"spells": [
					{
						"id": "FlashFrost",
						"name": "Flash Frost",
						"description": "Anivia brings her wings together and summons a sphere of ice that flies towards her opponents, chilling and damaging anyone in its path. When the sphere explodes it does moderate damage in a radius, stunning anyone in the area.",
						"tooltip": "A massive chunk of ice flies toward target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. <br /><br />At the end of its range or if Anivia activates the spell again, the missile detonates, doing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage in a small area and stunning units for {{ e4 }} seconds.<br /><br />Enemies damaged by Flash Frost are also slowed by {{ f1 }}% for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Stun Duration",
								"Cooldown",
								"Mana Cost "
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							80,
							90,
							100,
							110,
							120
						],
						"costBurn": "80/90/100/110/120",
						"effect": [
							null,
							[
								60,
								85,
								110,
								135,
								160
							],
							[
								13,
								12,
								11,
								10,
								9
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.1,
								1.2,
								1.3,
								1.4,
								1.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/85/110/135/160",
							"13/12/11/10/9",
							"0",
							"1.1/1.2/1.3/1.4/1.5",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "FlashFrost.png",
							"sprite": "spell0.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Crystallize",
						"name": "Crystallize",
						"description": "Anivia condenses the moisture in the air into an impassable wall of ice to block all movement. The wall only lasts a short duration before it melts.",
						"tooltip": "Anivia summons an impassable wall of ice {{ e2 }} units wide, blocking all movement. The wall lasts for {{ e1 }} seconds before it melts.",
						"leveltip": {
							"label": [
								"Width"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							17,
							17,
							17,
							17
						],
						"cooldownBurn": "17",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								400,
								500,
								600,
								700,
								800
							],
							[
								4,
								5,
								6,
								7,
								8
							],
							[
								120,
								120,
								120,
								120,
								120
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5",
							"400/500/600/700/800",
							"4/5/6/7/8",
							"120",
							"250",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "Crystallize.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Frostbite",
						"name": "Frostbite",
						"description": "With a flap of her wings, Anivia blasts a freezing gust of wind at her target, dealing a low amount of damage. If the target was recently stunned by Flash Frost or damaged by a fully formed Glacial Storm, the damage they take is doubled.",
						"tooltip": "Anivia blasts her target with a freezing wind, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. <br /><br />If a target was recently stunned by Anivia or damaged by a fully formed Glacial Storm, they take double damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "Frostbite.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GlacialStorm",
						"name": "Glacial Storm",
						"description": "Anivia summons a driving rain of ice and hail to damage her enemies and slow their advance.",
						"tooltip": "<span class=\"colorFF9900\">Activate: </span>Drains {{ e2 }} Mana per second. <br /><br />Anivia calls forth a driving rain of ice and hail that increases in size over {{ e7 }} seconds, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to targets and slowing their Movement Speed by {{ e4 }}%. <br /><br />When the Glacial Storm is fully formed, it slows targets' Movement Speed by {{ f1 }}% and does {{ e3 }}% damage instead.",
						"leveltip": {
							"label": [
								"Damage Per Second",
								"Chilled Slow Amount",
								"Mana Cost Per Second"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							75,
							75,
							75
						],
						"costBurn": "75",
						"effect": [
							null,
							[
								40,
								60,
								80
							],
							[
								40,
								50,
								60
							],
							[
								300,
								300,
								300
							],
							[
								20,
								30,
								40
							],
							[
								0,
								0,
								0
							],
							[
								1,
								1,
								1
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								50,
								50,
								50
							],
							[
								800,
								800,
								800
							],
							[
								1000,
								1000,
								1000
							]
						],
						"effectBurn": [
							null,
							"40/60/80",
							"40/50/60",
							"300",
							"20/30/40",
							"0",
							"1",
							"1.5",
							"50",
							"800",
							"1000"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.125,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "GlacialStorm.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Rebirth",
					"description": "Upon dying, Anivia will revert into an egg. If the egg can survive for six seconds, she is gloriously reborn.",
					"image": {
						"full": "Anivia_P.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Anivia",
						"title": "AniviaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "AniviaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "AniviaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "AniviaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "AniviaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "AniviaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "AniviaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Anivia",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Annie": {
				"id": "Annie",
				"key": "1",
				"name": "Annie",
				"title": "the Dark Child",
				"image": {
					"full": "Annie.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "1000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "1001",
						"num": 1,
						"name": "Goth Annie",
						"chromas": false
					},
					{
						"id": "1002",
						"num": 2,
						"name": "Red Riding Annie",
						"chromas": false
					},
					{
						"id": "1003",
						"num": 3,
						"name": "Annie in Wonderland",
						"chromas": false
					},
					{
						"id": "1004",
						"num": 4,
						"name": "Prom Queen Annie",
						"chromas": false
					},
					{
						"id": "1005",
						"num": 5,
						"name": "Frostfire Annie",
						"chromas": false
					},
					{
						"id": "1006",
						"num": 6,
						"name": "Reverse Annie",
						"chromas": false
					},
					{
						"id": "1007",
						"num": 7,
						"name": "FrankenTibbers Annie",
						"chromas": false
					},
					{
						"id": "1008",
						"num": 8,
						"name": "Panda Annie",
						"chromas": false
					},
					{
						"id": "1009",
						"num": 9,
						"name": "Sweetheart Annie",
						"chromas": false
					},
					{
						"id": "1010",
						"num": 10,
						"name": "Hextech Annie",
						"chromas": false
					},
					{
						"id": "1011",
						"num": 11,
						"name": "Super Galaxy Annie",
						"chromas": false
					}
				],
				"lore": "Dangerous, yet disarmingly precocious, Annie is a child mage with immense pyromantic power. Even in the shadows of the mountains north of Noxus, she is a magical outlier. Her natural affinity for fire manifested early in life through unpredictable, emotional outbursts, though she eventually learned to control these “playful tricks.” Her favorite includes the summoning of her beloved teddy bear, Tibbers, as a fiery protector. Lost in the perpetual innocence of childhood, Annie wanders the dark forests, always looking for someone to play with.",
				"blurb": "Dangerous, yet disarmingly precocious, Annie is a child mage with immense pyromantic power. Even in the shadows of the mountains north of Noxus, she is a magical outlier. Her natural affinity for fire manifested early in life through unpredictable...",
				"allytips": [
					"Storing a stun for use with her ultimate can turn the tide of a team fight.",
					"Striking killing blows on minions with Disintegrate enables Annie to farm extremely well early in the game.",
					"Molten Shield is a good spell to cast to work up to Annie's stun, so sometimes it's beneficial to grab at least 1 rank in it early."
				],
				"enemytips": [
					"Annie's summoned bear, Tibbers, burns opposing units around himself. Try to keep your distance from him after he's been summoned.",
					"Summoner Smite can be used to help take down Tibbers.",
					"Keep an eye out for a white, swirling power around Annie. It means she's ready to unleash her stun."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 3,
					"magic": 10,
					"difficulty": 6
				},
				"stats": {
					"hp": 524,
					"hpperlevel": 88,
					"mp": 334,
					"mpperlevel": 50,
					"movespeed": 335,
					"armor": 19.22,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 575,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 50.41,
					"attackdamageperlevel": 2.625,
					"attackspeedoffset": 0.08,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "Disintegrate",
						"name": "Disintegrate",
						"description": "Annie hurls a Mana infused fireball, dealing damage and refunding the Mana cost if it destroys the target.",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Mana cost and half the cooldown are refunded if Disintegrate kills the target.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								80,
								115,
								150,
								185,
								220
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/115/150/185/220",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "Disintegrate.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Incinerate",
						"name": "Incinerate",
						"description": "Annie casts a blazing cone of fire, dealing damage to all enemies in the area.",
						"tooltip": "Casts a cone of fire dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in the area.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.85,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "Incinerate.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MoltenShield",
						"name": "Molten Shield",
						"description": "Grants Annie and Tibbers increased percentage Damage Resist and damages enemies who attack with basic attacks.",
						"tooltip": "Annie grants herself and Tibbers {{ e1 }}% damage reduction for {{ e3 }} seconds.<br /><br />While the shield is active, enemies who basic attack it take {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Damage Reduction",
								"Damage Return"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								16,
								22,
								28,
								34,
								40
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"16/22/28/34/40",
							"20/30/40/50/60",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							0,
							0,
							0,
							0,
							0
						],
						"rangeBurn": "0",
						"image": {
							"full": "MoltenShield.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "InfernalGuardian",
						"name": "Summon: Tibbers",
						"description": "Annie wills her bear Tibbers to life, dealing damage to units in the area. Tibbers can attack and also burns enemies that stand near him.",
						"tooltip": "Summons Tibbers, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the target area. For the next 45 seconds, Tibbers burns nearby enemies for {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> per second and attacks for {{ e3 }} <span class=\"color99FF99\">(+{{ f1 }})</span> as magic damage. Annie can control Tibbers by reactivating this ability.<br /><br />Tibbers <span class=\"colorFFEB7F\">Enrages</span> when: summoned; Annie uses Pyromania on an enemy Champion; and when Annie dies.<br /><br /><span class=\"colorFFEB7F\">Enrages</span>: Tibbers gains 275% Attack Speed and 100% Movement Speed, decaying over 3 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Tibbers Health",
								"Tibbers Armor and Magic Resist",
								"Tibbers Attack Damage",
								"Tibbers Burn Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e0 }} -> {{ e0NL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								275,
								400
							],
							[
								10,
								15,
								20
							],
							[
								50,
								75,
								100
							],
							[
								-0.1,
								-0.1,
								-0.1
							],
							[
								1,
								1,
								1
							],
							[
								3,
								3,
								3
							],
							[
								30,
								50,
								70
							],
							[
								0,
								900,
								1800
							],
							[
								0.15,
								0.15,
								0.15
							],
							[
								1200,
								2100,
								3000
							]
						],
						"effectBurn": [
							null,
							"150/275/400",
							"10/15/20",
							"50/75/100",
							"-0.1",
							"1",
							"3",
							"30/50/70",
							"0/900/1800",
							"0.15",
							"1200/2100/3000"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "InfernalGuardian.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Pyromania",
					"description": "After casting 4 spells, Annie's next offensive spell will stun the target for a short duration.",
					"image": {
						"full": "Annie_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Annie",
						"title": "AnnieARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "AnnieCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "AnnieFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "AnnieKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "AnnieSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "AnnieSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "AnnieTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Annie",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Ashe": {
				"id": "Ashe",
				"key": "22",
				"name": "Ashe",
				"title": "the Frost Archer",
				"image": {
					"full": "Ashe.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "22000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "22001",
						"num": 1,
						"name": "Freljord Ashe",
						"chromas": false
					},
					{
						"id": "22002",
						"num": 2,
						"name": "Sherwood Forest Ashe",
						"chromas": false
					},
					{
						"id": "22003",
						"num": 3,
						"name": "Woad Ashe",
						"chromas": false
					},
					{
						"id": "22004",
						"num": 4,
						"name": "Queen Ashe",
						"chromas": false
					},
					{
						"id": "22005",
						"num": 5,
						"name": "Amethyst Ashe",
						"chromas": false
					},
					{
						"id": "22006",
						"num": 6,
						"name": "Heartseeker Ashe",
						"chromas": false
					},
					{
						"id": "22007",
						"num": 7,
						"name": "Marauder Ashe",
						"chromas": false
					},
					{
						"id": "22008",
						"num": 8,
						"name": "PROJECT: Ashe",
						"chromas": false
					},
					{
						"id": "22009",
						"num": 9,
						"name": "Championship Ashe",
						"chromas": true
					}
				],
				"lore": "Iceborn warmother of the Avarosan tribe, Ashe commands the most populous horde in the north. Stoic, intelligent, and idealistic, yet uncomfortable with her role as leader, she taps into the ancestral magics of her lineage to wield a bow of True Ice. With her people's belief that she is the mythological hero Avarosa reincarnated, Ashe hopes to unify the Freljord once more by retaking their ancient, tribal lands.",
				"blurb": "Iceborn warmother of the Avarosan tribe, Ashe commands the most populous horde in the north. Stoic, intelligent, and idealistic, yet uncomfortable with her role as leader, she taps into the ancestral magics of her lineage to wield a bow of True Ice...",
				"allytips": [
					"Try to fire Enchanted Crystal Arrow in the same direction enemies are moving, so it is more likely to hit.",
					"Volley arrows are blocked by the first enemy they hit, so keep your distance to avoid having them all absorbed by enemy frontliners.",
					"Hawkshot reveals units in brush. If a team fight is occuring in the jungle it can give you a significant advantage."
				],
				"enemytips": [
					"Ashe has very few defensive options, and she's a good target to gank.",
					"Be wary of moving around the map alone if Ashe has not recently cast her Enchanted Crystal Arrow."
				],
				"tags": [
					"Marksman",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 3,
					"magic": 2,
					"difficulty": 4
				},
				"stats": {
					"hp": 527.72,
					"hpperlevel": 79,
					"mp": 280,
					"mpperlevel": 32,
					"movespeed": 325,
					"armor": 30,
					"armorperlevel": 3.4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 600,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6.972,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 2.26,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3.33
				},
				"spells": [
					{
						"id": "AsheQ",
						"name": "Ranger's Focus",
						"description": "Ashe builds up Focus by attacking. At maximum Focus, Ashe can cast Ranger's Focus to consume all stacks of Focus, temporarily increasing her Attack Speed and transforming her basic attack into a powerful flurry attack for the duration.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Basic attacks grant Focus for {{ e1 }} seconds, stacking up to {{ e2 }} times. Stacks fall off one at a time, and at {{ e2 }} stacks, Ranger's Focus can be cast, consuming all Focus.<br /><br /><span class=\"colorFF9900\">Active:</span> For {{ e3 }} seconds, Ashe gains {{ e4 }}% Attack Speed, and her basic attacks fire a flurry of arrows dealing <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage. During this time, she does not stack Focus. Ranger's Focus applies Frost Shot.",
						"leveltip": {
							"label": [
								"Attack Speed Bonus",
								"Flurry Attack Damage ratio"
							],
							"effect": [
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e6 }} -> {{ e6NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0.21,
								0.22,
								0.23,
								0.24,
								0.25
							],
							[
								1.05,
								1.1,
								1.15,
								1.2,
								1.25
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4",
							"4",
							"4",
							"20/25/30/35/40",
							"0.21/0.22/0.23/0.24/0.25",
							"1.05/1.1/1.15/1.2/1.25",
							"1",
							"1",
							"1",
							"0"
						],
						"vars": [],
						"costType": " Mana, {{ e2 }} Focus",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "AsheQ.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana, {{ e2 }} Focus"
					},
					{
						"id": "Volley",
						"name": "Volley",
						"description": "Ashe fires 9 arrows in a cone for increased damage. Also applies Frost Shot.",
						"tooltip": "Fires arrows in a cone, each dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. Enemies can block multiple arrows, but only take damage from the first.<br /><br />Champion hits count as Critical Strikes for the purposes of Frost Shot.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							12.5,
							10,
							7.5,
							5
						],
						"cooldownBurn": "15/12.5/10/7.5/5",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								5,
								7,
								9,
								11,
								13
							],
							[
								20,
								35,
								50,
								65,
								80
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5/7/9/11/13",
							"20/35/50/65/80",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "Volley.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AsheSpiritOfTheHawk",
						"name": "Hawkshot",
						"description": "Ashe sends her Hawk Spirit on a scouting mission anywhere on the map.",
						"tooltip": "Reveals terrain as it flies toward target location anywhere on the map. Grants vision for {{ e4 }} seconds. Ashe can store up to 2 charges of Hawkshot.",
						"leveltip": {
							"label": [
								"Recharge Time"
							],
							"effect": [
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							5,
							5,
							5,
							5
						],
						"cooldownBurn": "5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								50,
								90,
								130,
								170,
								210
							],
							[
								25000,
								25000,
								25000,
								25000,
								25000
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"3",
							"50/90/130/170/210",
							"25000",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "2",
						"range": [
							25000,
							25000,
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "AsheSpiritOfTheHawk.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "EnchantedCrystalArrow",
						"name": "Enchanted Crystal Arrow",
						"description": "Ashe fires a missile of ice in a straight line. If the arrow collides with an enemy Champion, it deals damage and stuns the Champion, stunning for longer the farther arrow has traveled. In addition, surrounding enemy units take damage and are slowed.",
						"tooltip": "Launches a crystal arrow of ice that stuns the first enemy Champion hit, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The farther the arrow flies, the longer the stun, up to {{ e2 }} seconds. Surrounding enemies take half damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								200,
								400,
								600
							],
							[
								3.5,
								3.5,
								3.5
							],
							[
								50,
								50,
								50
							],
							[
								3,
								3,
								3
							],
							[
								5,
								5,
								5
							],
							[
								1100,
								1200,
								1300
							],
							[
								1,
								1,
								1
							],
							[
								400,
								400,
								400
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/400/600",
							"3.5",
							"50",
							"3",
							"5",
							"1100/1200/1300",
							"1",
							"400",
							"0.5",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "EnchantedCrystalArrow.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Frost Shot",
					"description": "Ashe's attacks slow their target, causing her to deal increased damage to these targets.<br><br>Ashe's critical strikes deal no bonus damage but apply an empowered slow to the target.",
					"image": {
						"full": "Ashe_P.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ashe",
						"title": "AsheARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheBT",
						"map": "SR",
						"mode": "TUTORIAL",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AshePRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "AsheTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Ashe",
						"title": "Map12T",
						"map": "HA",
						"mode": "TUTORIAL",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"AurelionSol": {
				"id": "AurelionSol",
				"key": "136",
				"name": "Aurelion Sol",
				"title": "The Star Forger",
				"image": {
					"full": "AurelionSol.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "136000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "136001",
						"num": 1,
						"name": "Ashen Lord Aurelion Sol",
						"chromas": false
					}
				],
				"lore": "Aurelion Sol once graced the vast emptiness of the cosmos with celestial wonders of his own devising. Now, he is forced to wield his awesome power at the behest of a space-faring empire that tricked him into servitude. Desiring a return to his star-forging ways, Aurelion Sol will drag the very stars from the sky, if he must, in order to regain his freedom.",
				"blurb": "Aurelion Sol once graced the vast emptiness of the cosmos with celestial wonders of his own devising. Now, he is forced to wield his awesome power at the behest of a space-faring empire that tricked him into servitude. Desiring a return to his...",
				"allytips": [
					"You can use Comet of Legend's flight to grow Starsurge to massive proportions.",
					"Save Voice of Light to use as a defense against melee opponents if you need to - otherwise, use its slow to start a fight at long range.",
					"Comet of Legend allows you to move quickly around the map; use it to put pressure on other lanes."
				],
				"enemytips": [
					"Try to get inside his orbit, since his stars can't hurt you up close.",
					"His stars disappear while stunned or silenced, giving you an easy opportunity to fight him.",
					"He gains speed while chasing in a straight line, but taking damage makes him lose that momentum.",
					"His Starsurge ability can grow to cover a huge area - don't stay in the same place too long!"
				],
				"tags": [
					"Mage",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 3,
					"magic": 8,
					"difficulty": 7
				},
				"stats": {
					"hp": 562,
					"hpperlevel": 92,
					"mp": 350,
					"mpperlevel": 50,
					"movespeed": 325,
					"armor": 19,
					"armorperlevel": 3.6,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 57,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "AurelionSolQ",
						"name": "Starsurge",
						"description": "Aurelion Sol creates an expanding disk, which explodes to stun and damage enemies when it moves too far away from him.",
						"tooltip": "<span class=\"colorFF9900\">First Press: </span>Aurelion Sol creates a new stellar core, which grows over time and grants him {{ e2 }}% Movement Speed.<br /><br />The core will detonate when it reaches his <span class=\"color308BDB\">Outer Limit</span>, applying {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and a {{ e4 }} second stun.<br /><br /><span class=\"colorFF9900\">Second Press: </span>Detonate the core early.<br />",
						"leveltip": {
							"label": [
								"Damage",
								"Stun Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								1.1,
								1.2,
								1.3,
								1.4,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"10",
							"20",
							"1.1/1.2/1.3/1.4/1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "AurelionSolQ.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AurelionSolW",
						"name": "Celestial Expansion",
						"description": "Aurelion Sol pushes his stars farther out, magnifying their damage.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Increases Star base damage by {{ e2 }}.<br /><br /><span class=\"colorFF9900\">Toggle: </span>Aurelion Sol's Stars orbit at his <span class=\"color308BDB\">Outer Limit</span> and deal {{ e1 }}% damage, for a total of {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage.<br />",
						"leveltip": {
							"label": [
								"Passive Damage Bonus",
								"Mana Cost Per Second",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.5,
							5,
							4.5,
							4
						],
						"cooldownBurn": "6/5.5/5/4.5/4",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								5,
								10,
								15,
								20,
								25
							],
							[
								22,
								24,
								26,
								28,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150",
							"5/10/15/20/25",
							"22/24/26/28/30",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana plus {{ e3 }} Mana Per Second",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "AurelionSolW.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana plus {{ e3 }} Mana Per Second"
					},
					{
						"id": "AurelionSolE",
						"name": "Comet of Legend",
						"description": "Aurelion Sol gains speed while moving in one continuous direction, and can take off flying for a long distance.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Continuously moving in one direction grants increasing Movement Speed up to {{ e2 }}%.<br /><br /><span class=\"colorFF9900\">Active: </span>Fly for {{ e3 }} units in the chosen direction. Only castable outside of combat. Aurelion Sol can see and be seen over walls while flying.<br /><br />Taking champion or turret damage will force a landing and reset the passive movement speed.<br />",
						"leveltip": {
							"label": [
								"Movement Speed Cap ",
								"Flight Range",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							60,
							55,
							50,
							45,
							40
						],
						"cooldownBurn": "60/55/50/45/40",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								5,
								6,
								7,
								8,
								9
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								3000,
								4000,
								5000,
								6000,
								7000
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5/6/7/8/9",
							"25/30/35/40/45",
							"3000/4000/5000/6000/7000",
							"600",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3000,
							4000,
							5000,
							6000,
							7000
						],
						"rangeBurn": "3000/4000/5000/6000/7000",
						"image": {
							"full": "AurelionSolE.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AurelionSolR",
						"name": "Voice of Light",
						"description": "Aurelion Sol projects a blast of pure starfire, damaging and slowing all enemies caught in it and knocking nearby enemies back to a safer distance.",
						"tooltip": "Breathes out a blast of pure starfire, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing by {{ e2 }}% for {{ e3 }} seconds. <br /><br />The blast will also knock nearby enemies back to Aurelion Sol's <span class=\"color308BDB\">Outer Limit</span>.<br />",
						"leveltip": {
							"label": [
								"Damage",
								"Slow ",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							90,
							70
						],
						"cooldownBurn": "110/90/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								40,
								50,
								60
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								650,
								650,
								650
							],
							[
								50,
								50,
								50
							],
							[
								1300,
								1300,
								1300
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"40/50/60",
							"2",
							"0",
							"650",
							"50",
							"1300",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1500,
							1500,
							1500
						],
						"rangeBurn": "1500",
						"image": {
							"full": "AurelionSolR.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Center of the Universe",
					"description": "Stars orbit Aurelion Sol, dealing magic damage when they hit an enemy.",
					"image": {
						"full": "AurelionSol_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "AurelionSol",
						"title": "AurelionSolARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolBEGINNER",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "AurelionSol",
						"title": "AurelionSolTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Azir": {
				"id": "Azir",
				"key": "268",
				"name": "Azir",
				"title": "the Emperor of the Sands",
				"image": {
					"full": "Azir.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "268000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "268001",
						"num": 1,
						"name": "Galactic Azir",
						"chromas": false
					},
					{
						"id": "268002",
						"num": 2,
						"name": "Gravelord Azir",
						"chromas": false
					},
					{
						"id": "268003",
						"num": 3,
						"name": "SKT T1 Azir",
						"chromas": false
					},
					{
						"id": "268004",
						"num": 4,
						"name": "Warring Kingdoms Azir",
						"chromas": false
					}
				],
				"lore": "Azir was a mortal emperor of Shurima in a far distant age, a proud man who stood at the cusp of immortality. His hubris saw him betrayed and murdered at the moment of his greatest triumph, but now, millennia later, he has been reborn as an Ascended being of immense power. With his buried city risen from the sand, Azir seeks to restore Shurima to its former glory.",
				"blurb": "Azir was a mortal emperor of Shurima in a far distant age, a proud man who stood at the cusp of immortality. His hubris saw him betrayed and murdered at the moment of his greatest triumph, but now, millennia later, he has been reborn as an Ascended...",
				"allytips": [
					"Be careful about putting down both of the soldiers stored by Arise! Unless you're going all-in, always have a soldier in your back pocket if you need to escape over a wall or if you misposition your other soldier and need damage now.",
					"In the lane, try to position your soldiers between the enemy's minions and the enemy champion. This way you can use them both to last hit and to project threat onto your lane opponent.",
					"Think of Emperor's Divide as a defensive ability first and foremost. Use it when the enemy engages on you or your allies. Remember that your team can walk through the soldiers summoned by Emperor's Divide and use this to your advantage when enemy melee champions engage on you.",
					"Be a bird!"
				],
				"enemytips": [
					"Azir relies on his soldiers to deal damage and can only move them so often. Try to capitalize on windows of time when his soldiers are stationary.",
					"Azir has immense damage over a prolonged amount of time but lacks the upfront burst of other mages. Try to burst him out before he can turn a confrontation around.",
					"Try to think of Sand Soldiers as fire. Don't stand in the fire."
				],
				"tags": [
					"Mage",
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 3,
					"magic": 8,
					"difficulty": 9
				},
				"stats": {
					"hp": 552,
					"hpperlevel": 92,
					"mp": 350.56,
					"mpperlevel": 42,
					"movespeed": 335,
					"armor": 19.04,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 52,
					"attackdamageperlevel": 2.8,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 1.5
				},
				"spells": [
					{
						"id": "AzirQWrapper",
						"name": "Conquering Sands",
						"description": "Azir sends all Sand Soldiers towards a location. Sand Soldiers deal magic damage to enemies they pass through and apply a slow for 1 second.",
						"tooltip": "Azir sends all <span class=\"colorEED6AF\">Sand Soldiers</span> towards a location. <span class=\"colorEED6AF\">Sand Soldiers</span> deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies they pass through and apply a {{ e2 }}% slow for 1 second.<br /><br />Enemies hit by multiple <span class=\"colorEED6AF\">Sand Soldiers</span> will not take additional damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f1 }} -> {{ f2 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								70,
								95,
								120,
								145,
								170
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								15,
								12.5,
								10,
								7.5,
								5
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								1600,
								1600,
								1600,
								1600,
								1600
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								370,
								370,
								370,
								370,
								370
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/95/120/145/170",
							"25",
							"15/12.5/10/7.5/5",
							"70",
							"1600",
							"200",
							"370",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							740,
							740,
							740,
							740,
							740
						],
						"rangeBurn": "740",
						"image": {
							"full": "AzirQWrapper.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AzirW",
						"name": "Arise!",
						"description": "Azir summons a Sand Soldier to attack nearby targets for him, replacing his basic attack against targets within the soldier's range. Their attacks deal magic damage to enemies in a line. Arise! also passively grants attack speed to Azir and his Sand Soldiers.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Azir gains {{ e3 }}% attack speed. When Azir has {{ e6 }} or more <span class=\"colorEED6AF\">Sand Soldiers</span>, he gains {{ e7 }}% additional attack speed for {{ e8 }} seconds.<br /><br /><span class=\"colorFF9900\">Active:</span> Azir summons a <span class=\"colorEED6AF\">Sand Soldier</span> for {{ e1 }} seconds. When Azir attacks an enemy in a soldier's range, the soldier attacks in his stead, stabbing the target for <scaleLevel>{{ f2 }}</scaleLevel> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Other enemies caught in the soldier's attack take <scaleLevel>{{ f7 }}%</scaleLevel> of the stab's damage.<br /><br />Azir stores up to {{ maxammo }} <span class=\"colorEED6AF\">Sand Soldiers</span> and prepares a new one every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds.<br /><br /><span class=\"color919191\"><i>Sand Soldiers that strike the same targets deal {{ e9 }}% damage after the first.<br />Sand Soldiers can attack targets outside of Azir's basic attack range.<br />Sand Soldiers expire twice as fast when near an enemy turret.</i></span>",
						"leveltip": {
							"label": [
								"Recharge",
								"Passive Attack Speed",
								"Attack Speed with Soldiers"
							],
							"effect": [
								"{{ f1 }} -> {{ f3 }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e7 }}% -> {{ e7NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								8,
								7.5,
								7,
								6.5,
								6
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							]
						],
						"effectBurn": [
							null,
							"10",
							"8/7.5/7/6.5/6",
							"20/30/40/50/60",
							"0",
							"1.5",
							"3",
							"20/30/40/50/60",
							"5",
							"25",
							"0.5"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "AzirW.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AzirEWrapper",
						"name": "Shifting Sands",
						"description": "Azir shields himself briefly and dashes to one of his Sand Soldiers, damaging enemies. If he hits an enemy champion, he instantly readies a new Sand Soldier for deployment and halts his dash.",
						"tooltip": "Azir shields himself for {{ e6 }} seconds, blocking up to {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage and dashes to one of his <span class=\"colorEED6AF\">Sand Soldiers</span>, damaging enemies hit for {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />If Azir hits an enemy champion, he halts his dash and instantly prepares a new <span class=\"colorEED6AF\">Sand Soldier</span>.",
						"leveltip": {
							"label": [
								"Shield Amount",
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ f2 }} -> {{ f3 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								1700,
								1700,
								1700,
								1700,
								1700
							],
							[
								19,
								18,
								17,
								16,
								15
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								0.3,
								0.5,
								0.7,
								0.9,
								1.1
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1100,
								1100,
								1100,
								1100,
								1100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								25,
								25,
								25,
								25,
								25
							]
						],
						"effectBurn": [
							null,
							"1700",
							"19/18/17/16/15",
							"60/90/120/150/180",
							"80/120/160/200/240",
							"0.3/0.5/0.7/0.9/1.1",
							"1.5",
							"1100",
							"0",
							"5",
							"25"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "AzirEWrapper.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AzirR",
						"name": "Emperor's Divide",
						"description": "Azir summons a wall of soldiers which charge forward, knocking back and damaging enemies.",
						"tooltip": "Azir summons a wall of armored soldiers that charge forward, knocking back enemies and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The soldiers then remain as a wall for {{ e4 }} seconds.<br /><br />Azir and his allies can pass freely through Emperor's Divide.<br /><br /><span class=\"color919191\"><i>Emperor's Divide does not interact with Azir's basic attacks or spells.</i></span>",
						"leveltip": {
							"label": [
								"Damage",
								"Number of Soldiers",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								450
							],
							[
								0,
								0,
								0
							],
							[
								5,
								6,
								7
							],
							[
								3,
								3,
								3
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/450",
							"0",
							"5/6/7",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							250,
							250,
							250
						],
						"rangeBurn": "250",
						"image": {
							"full": "AzirR.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Shurima's Legacy",
					"description": "Azir can summon the Disc of the Sun from the ruins of allied or enemy turrets.",
					"image": {
						"full": "Azir_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Azir",
						"title": "AhriFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1004",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2044",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "AzirTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Azir",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Bard": {
				"id": "Bard",
				"key": "432",
				"name": "Bard",
				"title": "the Wandering Caretaker",
				"image": {
					"full": "Bard.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "432000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "432001",
						"num": 1,
						"name": "Elderwood Bard",
						"chromas": false
					},
					{
						"id": "432005",
						"num": 5,
						"name": "Snow Day Bard",
						"chromas": false
					},
					{
						"id": "432006",
						"num": 6,
						"name": "Bard Bard",
						"chromas": false
					}
				],
				"lore": "A traveler from beyond the stars, Bard is an agent of serendipity who fights to maintain a balance where life can endure the indifference of chaos. Many Runeterrans sing songs that ponder his extraordinary nature, yet they all agree that the cosmic vagabond is drawn to artifacts of great magical power. Surrounded by a jubilant choir of helpful spirit meeps, it is impossible to mistake his actions as malevolent, as Bard always serves the greater good... in his own odd way.",
				"blurb": "A traveler from beyond the stars, Bard is an agent of serendipity who fights to maintain a balance where life can endure the indifference of chaos. Many Runeterrans sing songs that ponder his extraordinary nature, yet they all agree that the cosmic...",
				"allytips": [
					"It's important to collect chimes to improve your meep's attacks, but don't neglect your lane partner! Try to make a big entrance by bringing an ally into the lane with you with Magical Journey.",
					"Let your Caretaker's Shrines charge up - they heal for a lot more when at full power.",
					"Don't forget that enemies can also use your Magical Journey doorways, and that your ultimate can also hit your allies!"
				],
				"enemytips": [
					"Bard's opponents can also travel through his Magical Journey doorways. You can follow him, if you think it's safe.",
					"You can crush Bard's healing shrines just by walking over them. Don't let his allies take them without a fight.",
					"Bard's ultimate, Tempered Fate, affects allies, enemies, monsters, and turrets alike. Sometimes it can be to your advantage to jump into it!"
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 4,
					"magic": 5,
					"difficulty": 9
				},
				"stats": {
					"hp": 535,
					"hpperlevel": 89,
					"mp": 350,
					"mpperlevel": 50,
					"movespeed": 330,
					"armor": 34,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 7.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 52,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "BardQ",
						"name": "Cosmic Binding",
						"description": "Bard fires a missile which will slow the first enemy struck, and continue onward. If it strikes a wall, it will stun the initial target; if it strikes another enemy, it will stun them both.",
						"tooltip": "Bard fires an energy bolt, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to one or two enemies. The first target hit will be slowed by {{ e3 }}% for {{ e4 }} second(s).<br /><br />If the bolt hits another enemy or a wall, any enemies hit are stunned for {{ e2 }} second(s).<br />",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Duration",
								"Stun Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10,
							9,
							8,
							7
						],
						"cooldownBurn": "11/10/9/8/7",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								1,
								1.2,
								1.4,
								1.6,
								1.8
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								1,
								1.2,
								1.4,
								1.6,
								1.8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"1/1.2/1.4/1.6/1.8",
							"60",
							"1/1.2/1.4/1.6/1.8",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "BardQ.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BardW",
						"name": "Caretaker's Shrine",
						"description": "Reveals a healing shrine which powers up over a short time, disappearing after healing the first ally that touches it.",
						"tooltip": "Bard raises a health shrine that immediately offers {{ e5 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health, but restores up to {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> health as it gathers power for 10 seconds. The shrine's effect also grants {{ e1 }}% decaying movement speed for {{ e2 }} seconds. <br /><br />Bard can have up to {{ e3 }} shrines active at once, which remain until visited by an ally champion or crushed by an enemy champion.<br /><br /><span class=\"colorFFCC00\">Active Shrines: </span><span class=\"colorFFFFFF\">{{ f1 }}</span> / <span class=\"colorFFCC00\">{{ f2 }}</span></mainText><br />",
						"leveltip": {
							"label": [
								"Base Heal",
								"Max Heal"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e6 }} -> {{ e6NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							90,
							90,
							90,
							90,
							90
						],
						"costBurn": "90",
						"effect": [
							null,
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								30,
								60,
								90,
								120,
								150
							],
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50",
							"1.5",
							"3",
							"0",
							"30/60/90/120/150",
							"70/110/150/190/230",
							"0",
							"10",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "BardW.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BardE",
						"name": "Magical Journey",
						"description": "Bard opens a portal in nearby terrain. Allies and enemies alike can take a one-way trip through that terrain by moving into the portal.",
						"tooltip": "Bard opens a one-way corridor through nearby terrain. Both allies and enemies can use the corridor by right-clicking on any part of it while near its entrance, with allies travelling {{ e2 }}% faster than enemies.<br /><br />The corridor disappears after {{ e1 }} seconds.<br />",
						"leveltip": {
							"label": [
								"Cooldown",
								"Ally Travel Speed Bonus"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10",
							"10/20/30/40/50",
							"800",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "BardE.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BardR",
						"name": "Tempered Fate",
						"description": "Bard sends spirit energy arcing to a location, putting all champions, minions, monsters, and turrets hit into stasis for a brief time.",
						"tooltip": "Bard sends magical energy arcing to a target location. On impact, all champions, minions, monsters, and turrets in the target area are put in stasis, becoming invincible, untargetable, and unable to act for {{ e1 }} seconds.<br /><br />Epic monsters are also put into stasis, despite normally being immune to disables.",
						"leveltip": {
							"label": [
								"Cooldown"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							115,
							90
						],
						"cooldownBurn": "130/115/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3400,
							3400,
							3400
						],
						"rangeBurn": "3400",
						"image": {
							"full": "BardR.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Traveler's Call",
					"description": "Bard's presence causes magical chimes to appear, which grant Bard experience, mana, and a burst of speed. Additionally, lesser spirits follow Bard and aid in his attacks - collecting chimes causes these meeps to gain power over the course of the game.",
					"image": {
						"full": "Bard_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Bard",
						"title": "BardARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Bard",
						"title": "BardCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "support",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Bard",
						"title": "BardFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "support",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Bard",
						"title": "BardKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Bard",
						"title": "BardSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "support",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Bard",
						"title": "BardSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "support",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Bard",
						"title": "BardTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Blitzcrank": {
				"id": "Blitzcrank",
				"key": "53",
				"name": "Blitzcrank",
				"title": "the Great Steam Golem",
				"image": {
					"full": "Blitzcrank.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "53000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "53001",
						"num": 1,
						"name": "Rusty Blitzcrank",
						"chromas": false
					},
					{
						"id": "53002",
						"num": 2,
						"name": "Goalkeeper Blitzcrank",
						"chromas": false
					},
					{
						"id": "53003",
						"num": 3,
						"name": "Boom Boom Blitzcrank",
						"chromas": false
					},
					{
						"id": "53004",
						"num": 4,
						"name": "Piltover Customs Blitzcrank",
						"chromas": false
					},
					{
						"id": "53005",
						"num": 5,
						"name": "Definitely Not Blitzcrank",
						"chromas": false
					},
					{
						"id": "53006",
						"num": 6,
						"name": "iBlitzcrank",
						"chromas": false
					},
					{
						"id": "53007",
						"num": 7,
						"name": "Riot Blitzcrank",
						"chromas": false
					},
					{
						"id": "53011",
						"num": 11,
						"name": "Battle Boss Blitzcrank",
						"chromas": true
					},
					{
						"id": "53020",
						"num": 20,
						"name": "Lancer Rogue Blitzcrank",
						"chromas": false
					},
					{
						"id": "53021",
						"num": 21,
						"name": "Lancer Paragon Blitzcrank",
						"chromas": false
					}
				],
				"lore": "Blitzcrank is an enormous, near-indestructible automaton from Zaun, originally built to dispose of hazardous waste. However, he found this primary purpose too restricting, and modified his own form to better serve the fragile people of the Sump. Blitzcrank selflessly uses his strength and durability to protect others, extending a helpful metal fist or burst of energy to subdue any troublemakers.",
				"blurb": "Blitzcrank is an enormous, near-indestructible automaton from Zaun, originally built to dispose of hazardous waste. However, he found this primary purpose too restricting, and modified his own form to better serve the fragile people of the Sump...",
				"allytips": [
					"The 1-2-3 combo of Rocket Grab, Power Fist, and Static Field can devastate an individual opponent.",
					"Using Blitzcrank's grab to pull an enemy into your tower range followed by a Power Fist will allow the tower to get several hits on them."
				],
				"enemytips": [
					"Blitzcrank's passive Mana Barrier grants him a shield when he is low on health.",
					"Staying behind creeps can prevent you from being Rocket Grabbed. Blitzcrank's Rocket Grab only pulls the first enemy target it encounters."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 8,
					"magic": 5,
					"difficulty": 4
				},
				"stats": {
					"hp": 582.6,
					"hpperlevel": 95,
					"mp": 267.2,
					"mpperlevel": 40,
					"movespeed": 325,
					"armor": 44,
					"armorperlevel": 4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.75,
					"mpregen": 8.5,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61.54,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.13
				},
				"spells": [
					{
						"id": "RocketGrab",
						"name": "Rocket Grab",
						"description": "Blitzcrank fires his right hand to grab an opponent on its path, dealing damage and dragging it back to him.",
						"tooltip": "Blitzcrank fires his right hand. If it encounters an enemy unit it will stun them and deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage while he pulls them to himself.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							19,
							18,
							17,
							16
						],
						"cooldownBurn": "20/19/18/17/16",
						"cost": [
							100,
							100,
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								80,
								135,
								190,
								245,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/135/190/245/300",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "RocketGrab.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Overdrive",
						"name": "Overdrive",
						"description": "Blitzcrank super charges himself to get dramatically increased Movement and Attack Speed. He is temporarily slowed after the effect ends.",
						"tooltip": "Blitzcrank supercharges himself, gaining {{ e1 }}% Movement Speed and {{ e2 }}% Attack Speed for {{ e4 }} seconds. The Movement Speed bonus decays over the duration.<br /><br />When Overdrive ends, Blitzcrank's Movement Speed is slowed by {{ e3 }}% for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Movement Speed",
								"Attack Speed"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							75,
							75,
							75,
							75,
							75
						],
						"costBurn": "75",
						"effect": [
							null,
							[
								70,
								75,
								80,
								85,
								90
							],
							[
								30,
								38,
								46,
								54,
								62
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/75/80/85/90",
							"30/38/46/54/62",
							"30",
							"5",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "Overdrive.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PowerFist",
						"name": "Power Fist",
						"description": "Blitzcrank charges up his fist to make his next attack deal double damage and pop his target up in the air.",
						"tooltip": "Blitzcrank charges up his fist to make his next attack deal double his total attack damage as physical damage and pop his target up in the air.",
						"leveltip": {
							"label": [
								"Cooldown"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							25,
							25,
							25,
							25,
							25
						],
						"costBurn": "25",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "PowerFist.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "StaticField",
						"name": "Static Field",
						"description": "Passively causes lightning bolts to damage a nearby enemy. Additionally, Blitzcrank can activate this ability to damage nearby enemies and silence them for 0.5 seconds, but doing so removes the passive lightning until Static Field becomes available again.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Lightning arcs off of Blitzcrank to hit a random nearby enemy for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage every 2.5 seconds.<br /><br /><span class=\"colorFF9900\">Active: </span>Deals {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and silences surrounding enemy units for 0.5 seconds. The passive is not in effect during the cooldown.",
						"leveltip": {
							"label": [
								"Lightning Damage",
								"Activation Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							60,
							40,
							20
						],
						"cooldownBurn": "60/40/20",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								200,
								300
							],
							[
								250,
								375,
								500
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/200/300",
							"250/375/500",
							"2.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "StaticField.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Mana Barrier",
					"description": "When Blitzcrank's life is brought below 20% health, he activates Mana Barrier. This creates a mana shield equal to 50% of his mana for 10 seconds. Mana Barrier can only occur once every 90 seconds.",
					"image": {
						"full": "Blitzcrank_ManaBarrier.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Blitzcrank",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "1)buystarteritems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Blitzcrank",
						"title": "BlitzcrankTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Brand": {
				"id": "Brand",
				"key": "63",
				"name": "Brand",
				"title": "the Burning Vengeance",
				"image": {
					"full": "Brand.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "63000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "63001",
						"num": 1,
						"name": "Apocalyptic Brand",
						"chromas": false
					},
					{
						"id": "63002",
						"num": 2,
						"name": "Vandal Brand",
						"chromas": false
					},
					{
						"id": "63003",
						"num": 3,
						"name": "Cryocore Brand",
						"chromas": false
					},
					{
						"id": "63004",
						"num": 4,
						"name": "Zombie Brand",
						"chromas": false
					},
					{
						"id": "63005",
						"num": 5,
						"name": "Spirit Fire Brand",
						"chromas": false
					},
					{
						"id": "63006",
						"num": 6,
						"name": "Battle Boss Brand",
						"chromas": false
					}
				],
				"lore": "Once a tribesman of the icy Freljord named Kegan Rodhe, the creature known as Brand is a lesson in the temptation of greater power. Seeking one of the legendary World Runes, Kegan betrayed his companions and seized it for himself—and, in an instant, the man was no more. His soul burned away, his body a vessel of living flame, Brand now roams Valoran in search of other Runes, swearing revenge for wrongs he could never possibly have suffered in a dozen mortal lifetimes.",
				"blurb": "Once a tribesman of the icy Freljord named Kegan Rodhe, the creature known as Brand is a lesson in the temptation of greater power. Seeking one of the legendary World Runes, Kegan betrayed his companions and seized it for himself—and, in an instant, the...",
				"allytips": [
					"You can deter enemies from standing near their minions by setting them ablaze, due to Conflagration.",
					"You can use Brand's abilities in a variety of combinations to maximize his damage in different situations.",
					"Pyroclasm bounces randomly between enemies, so try to cast it on a small group of enemies if you want to hit the same target multiple times."
				],
				"enemytips": [
					"Brand must land an ability before his combo is able to get started. Dodging his Sear or Pillar of Flame will disrupt his rhythm.",
					"Try to move away from allies when you see Pyroclasm being cast. The initial missile speed is slow, which should give your team time to react.",
					"Brand's passive allows him to excel against teams that cluster together. Be sure to split up against him."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 2,
					"magic": 9,
					"difficulty": 4
				},
				"stats": {
					"hp": 519.68,
					"hpperlevel": 88,
					"mp": 375.6,
					"mpperlevel": 42,
					"movespeed": 340,
					"armor": 21.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 8.008,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 57.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "BrandQ",
						"name": "Sear",
						"description": "Brand launches a ball of fire forward that deals magic damage. If the target is ablaze, Sear will stun the target for 1.5 seconds.",
						"tooltip": "Brand launches a ball of fire forward that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> If the target is ablaze, Sear will stun the target for 1.5 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7.5,
							7,
							6.5,
							6
						],
						"cooldownBurn": "8/7.5/7/6.5/6",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/110/140/170/200",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.55,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1050,
							1050,
							1050,
							1050,
							1050
						],
						"rangeBurn": "1050",
						"image": {
							"full": "BrandQ.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BrandW",
						"name": "Pillar of Flame",
						"description": "After a short delay, Brand creates a Pillar of Flame at a target area, dealing magic damage to enemy units within the area. Units that are ablaze take an additional 25% damage.",
						"tooltip": "After a short delay, Brand creates a Pillar of Flame at a location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> Units that are ablaze take an additional 25% damage from Pillar of Flame.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9.5,
							9,
							8.5,
							8
						],
						"cooldownBurn": "10/9.5/9/8.5/8",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								75,
								120,
								165,
								210,
								255
							],
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/120/165/210/255",
							"20/40/60/80/100",
							"0.25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "BrandW.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BrandE",
						"name": "Conflagration",
						"description": "Brand conjures a powerful blast at his target, dealing magic damage to them. If the target is ablaze, Conflagration spreads to nearby enemies.",
						"tooltip": "Brand conjures a powerful blast at his target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> If the target is ablaze, Conflagration spreads to nearby enemies. ",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								70,
								90,
								110,
								130,
								150
							],
							[
								375,
								375,
								375,
								375,
								375
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/90/110/130/150",
							"375",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "BrandE.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BrandR",
						"name": "Pyroclasm",
						"description": "Brand unleashes a devastating torrent of fire, dealing magic damage each time it bounces, up to 5 bounces. Bounces prioritize stacking Blaze to max on Champions. If a target is ablaze, Pyroclasm will briefly slow them.",
						"tooltip": "Brand unleashes a devastating torrent of fire, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage each time it bounces up to 5 bounces. Bounces prioritize stacking Blaze to max on Champions.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> If the target is ablaze, Pyroclasm will briefly slow the target by {{ e4 }}%.",
						"leveltip": {
							"label": [
								"Damage per Bounce",
								"Slow Amount",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							105,
							90,
							75
						],
						"cooldownBurn": "105/90/75",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								200,
								300
							],
							[
								5,
								7,
								9
							],
							[
								150,
								225,
								300
							],
							[
								30,
								45,
								60
							],
							[
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/200/300",
							"5/7/9",
							"150/225/300",
							"30/45/60",
							"0.25",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "BrandR.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Blaze",
					"description": "Brand's spells light his targets ablaze, dealing 4% of their maximum Health in magic damage over 4 seconds, stacking up to 3 times. If Brand kills an enemy while it is ablaze he regains mana. When Blaze reaches max stacks on a Champion or large monster, it becomes unstable. It detonates in 2 seconds, applying spell effects and dealing massive damage in an area around the victim.",
					"image": {
						"full": "BrandP.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Brand",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot-mid",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandSRSupport",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot-support",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Brand",
						"title": "BrandTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Braum": {
				"id": "Braum",
				"key": "201",
				"name": "Braum",
				"title": "the Heart of the Freljord",
				"image": {
					"full": "Braum.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "201000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "201001",
						"num": 1,
						"name": "Dragonslayer Braum",
						"chromas": true
					},
					{
						"id": "201002",
						"num": 2,
						"name": "El Tigre Braum",
						"chromas": false
					},
					{
						"id": "201003",
						"num": 3,
						"name": "Braum Lionheart",
						"chromas": false
					},
					{
						"id": "201010",
						"num": 10,
						"name": "Santa Braum",
						"chromas": false
					}
				],
				"lore": "Blessed with massive biceps and an even bigger heart, Braum is a beloved hero of the Freljord. Every mead hall north of Frostheld toasts his legendary strength, said to have felled a forest of oaks in a single night, and punched an entire mountain into rubble. Bearing an enchanted vault door as his shield, Braum roams the frozen north sporting a mustachioed smile as big as his muscles—a true friend to all those in need.",
				"blurb": "Blessed with massive biceps and an even bigger heart, Braum is a beloved hero of the Freljord. Every mead hall north of Frostheld toasts his legendary strength, said to have felled a forest of oaks in a single night, and punched an entire mountain into...",
				"allytips": [
					"Work with your allies to stack Concussive Blows, encourage them to basic attack marked targets.",
					"Leap in front of squishy friends and shield them from projectiles with Unbreakable.",
					"Glacial Fissure leaves a powerful slow zone, position it well to split teamfights and slow the enemy approach."
				],
				"enemytips": [
					"Braum must land Winter's Bite or a basic attack to start Concussive Blows. If you get marked, exit combat range before getting hit 3 more times to avoid the stun.",
					"Braum's ultimate has a long cast time, use that extra time to dodge. Walking over the frozen ground left behind will slow you, position so that you don't need to cross it.",
					"Unbreakable gives Braum extremely strong directional defense, either wait until it is down or outposition the ability."
				],
				"tags": [
					"Support",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 9,
					"magic": 4,
					"difficulty": 3
				},
				"stats": {
					"hp": 576.16,
					"hpperlevel": 87,
					"mp": 310.6,
					"mpperlevel": 45,
					"movespeed": 335,
					"armor": 47,
					"armorperlevel": 4.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 1,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55.376,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.03,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "BraumQ",
						"name": "Winter's Bite",
						"description": "Braum propels freezing ice from his shield, slowing and dealing magic damage.<br><br>Applies a stack of <font color='#FFF673'>Concussive Blows</font>.",
						"tooltip": "Braum propels freezing ice from his shield dealing {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [2.5% of Braum's Max Health]</span> magic damage to the first enemy hit and slowing them by {{ e2 }}%, decaying over the next {{ e5 }} seconds.<br /><br />Applies a stack of <span class=\"colorFFF673\">Concussive Blows</span>. ",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							55,
							60,
							65,
							70,
							75
						],
						"costBurn": "55/60/65/70/75",
						"effect": [
							null,
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0.02,
								0.02,
								0.02,
								0.02,
								0.02
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1050,
								1050,
								1050,
								1050,
								1050
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/105/150/195/240",
							"70",
							"30",
							"0.02",
							"2",
							"1050",
							"4",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "BraumQ.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BraumW",
						"name": "Stand Behind Me",
						"description": "Braum leaps to a target allied champion or minion. On arrival, Braum and the ally gain Armor and Magic Resist for a few seconds.",
						"tooltip": "Braum leaps to target allied champion or minion.<br /><br />On arrival, Braum and the ally gain <span class=\"colorFFFF00\">{{ f3 }}</span> Armor and <span class=\"colorFF00FF\">{{ f4 }}</span> Magic Resist ({{ e4 }} plus {{ e3 }}% of Braum's bonus Armor/Magic Resist) for {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Base Armor",
								"Base Magic Resist",
								"Defensive Scaling",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								750,
								750,
								750,
								750,
								750
							],
							[
								10,
								11.5,
								13,
								14.5,
								16
							],
							[
								17.5,
								20,
								22.5,
								25,
								27.5
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"3",
							"750",
							"10/11.5/13/14.5/16",
							"17.5/20/22.5/25/27.5",
							"15/17.5/20/22.5/25",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "@special.BraumWArmor",
								"coeff": 0,
								"key": "f3"
							},
							{
								"link": "@special.BraumWMR",
								"coeff": 0,
								"key": "f4"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "BraumW.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BraumE",
						"name": "Unbreakable",
						"description": "Braum raises his shield in a direction for several seconds, intercepting all projectiles causing them to hit him and be destroyed. He negates the damage of the first attack completely and reduces the damage of all subsequent attacks from this direction.",
						"tooltip": "<span class=\"colorFFFFFF\">Braum reduces incoming damage and blocks for allies behind him.</span><br />Braum raises his shield in a direction for {{ e2 }} seconds negating the damage of the next attack from that direction. Subsequent attacks deal {{ e3 }}% reduced damage.<br /><br />Braum <span class=\"colorFFF673\">intercepts</span> projectiles, causing them to hit him and be destroyed.<br /><br />Braum gains {{ e4 }}% Movement Speed for the duration.",
						"leveltip": {
							"label": [
								"Duration",
								"Damage Reduction",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							30,
							35,
							40,
							45,
							50
						],
						"costBurn": "30/35/40/45/50",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								3,
								3.25,
								3.5,
								3.75,
								4
							],
							[
								30,
								32.5,
								35,
								37.5,
								40
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"3/3.25/3.5/3.75/4",
							"30/32.5/35/37.5/40",
							"10",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "BraumE.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BraumRWrapper",
						"name": "Glacial Fissure",
						"description": "Braum slams the ground, knocking up enemies nearby and in a line in front of him. A fissure is left along the line that slows enemies.",
						"tooltip": "Braum slams the ground, knocking up enemies nearby and in a line in front of him. A fissure is left along the line for {{ e3 }} seconds, slowing enemies above it by {{ e4 }}%.<br /><br />Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The first champion hit is knocked up for {{ e5 }} seconds, subsequent enemies are knocked up briefly.",
						"leveltip": {
							"label": [
								"Damage",
								"Knockup Duration",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							120,
							100
						],
						"cooldownBurn": "140/120/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								0.3,
								0.3,
								0.3
							],
							[
								4,
								4,
								4
							],
							[
								40,
								50,
								60
							],
							[
								1,
								1.25,
								1.5
							],
							[
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"0.3",
							"4",
							"40/50/60",
							"1/1.25/1.5",
							"0.25",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1250,
							1250,
							1250
						],
						"rangeBurn": "1250",
						"image": {
							"full": "BraumRWrapper.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Concussive Blows",
					"description": "Braum adds stacks of Concussive Blows to enemies with basic attacks or Winter's Bite. He and his allies continue to add stacks with basic attacks, at 4 stacks their target will be stunned.",
					"image": {
						"full": "Braum_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Braum",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Braum",
						"title": "BraumTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Caitlyn": {
				"id": "Caitlyn",
				"key": "51",
				"name": "Caitlyn",
				"title": "the Sheriff of Piltover",
				"image": {
					"full": "Caitlyn.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "51000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "51001",
						"num": 1,
						"name": "Resistance Caitlyn",
						"chromas": false
					},
					{
						"id": "51002",
						"num": 2,
						"name": "Sheriff Caitlyn",
						"chromas": false
					},
					{
						"id": "51003",
						"num": 3,
						"name": "Safari Caitlyn",
						"chromas": false
					},
					{
						"id": "51004",
						"num": 4,
						"name": "Arctic Warfare Caitlyn",
						"chromas": false
					},
					{
						"id": "51005",
						"num": 5,
						"name": "Officer Caitlyn",
						"chromas": false
					},
					{
						"id": "51006",
						"num": 6,
						"name": "Headhunter Caitlyn",
						"chromas": false
					},
					{
						"id": "51010",
						"num": 10,
						"name": "Lunar Wraith Caitlyn",
						"chromas": true
					},
					{
						"id": "51011",
						"num": 11,
						"name": "Pulsefire Caitlyn",
						"chromas": false
					}
				],
				"lore": "Renowned as its finest peacekeeper, Caitlyn is also Piltover's best shot at ridding the city of its elusive criminal elements. She is often paired with Vi, acting as a cool counterpoint to her partner's more impetuous nature. Even though she carries a one-of-a-kind hextech rifle, Caitlyn's most powerful weapon is her superior intellect, allowing her to lay elaborate traps for any lawbreakers foolish enough to operate in the City of Progress.",
				"blurb": "Renowned as its finest peacekeeper, Caitlyn is also Piltover's best shot at ridding the city of its elusive criminal elements. She is often paired with Vi, acting as a cool counterpoint to her partner's more impetuous nature. Even though she carries a...",
				"allytips": [
					"Make use of her Yordle Snap Traps by placing them pre-emptively to ensure that you'll have one off of cooldown during combat.",
					"Avoid using Ace in the Hole in large team melees as it might be blocked by the wrong target.",
					"Fire 90 Caliber Net away from the opponent to close the gap or hop over walls."
				],
				"enemytips": [
					"Keep behind allied minions if Caitlyn is harassing you with Piltover Peacemaker (it deals less damage with each subsequent target).",
					"You can intercept Ace in the Hole's missile from hitting an ally if you stand in its path."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 2,
					"magic": 2,
					"difficulty": 6
				},
				"stats": {
					"hp": 475,
					"hpperlevel": 85,
					"mp": 313.7,
					"mpperlevel": 35,
					"movespeed": 325,
					"armor": 32,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 650,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 7.4,
					"mpregenperlevel": 0.55,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 62,
					"attackdamageperlevel": 2.18,
					"attackspeedoffset": 0.1,
					"attackspeedperlevel": 4
				},
				"spells": [
					{
						"id": "CaitlynPiltoverPeacemaker",
						"name": "Piltover Peacemaker",
						"description": "Caitlyn revs up her rifle for 1 second to unleash a penetrating shot that deals physical damage (deals less damage to subsequent targets).",
						"tooltip": "Revs the rifle for {{ e4 }} second to fire a narrow piercing shot dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage. After hitting any target, it opens into a wider shot that deals {{ e2 }}% less damage. <br /><br />Always deals full damage to trap revealed targets.",
						"leveltip": {
							"label": [
								"Damage",
								"Total Attack Damage Ratio",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								30,
								70,
								110,
								150,
								190
							],
							[
								33,
								33,
								33,
								33,
								33
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								130,
								140,
								150,
								160,
								170
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/70/110/150/190",
							"33",
							"50",
							"1",
							"130/140/150/160/170",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1250,
							1250,
							1250,
							1250,
							1250
						],
						"rangeBurn": "1250",
						"image": {
							"full": "CaitlynPiltoverPeacemaker.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CaitlynYordleTrap",
						"name": "Yordle Snap Trap",
						"description": "Caitlyn sets a trap to find sneaky yordles. When sprung, the trap reveals and immobilizes the enemy champion for 1.5 seconds.",
						"tooltip": "Sets traps that an enemy Champion can spring, immobilizing them for {{ e6 }} seconds and granting <span class=\"coloree91d7\">True Sight</span> for a short duration.<br /><br />Traps last for {{ e3 }} seconds. {{ e5 }} traps may be active at once.<br /><br />Trapped enemies take an additional {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> increased damage from Headshot.",
						"leveltip": {
							"label": [
								"Bonus Headshot Damage on Trapped Targets",
								"Bonus Attack Damage Ratio",
								"Recharge Rate",
								"Maximum Traps",
								"Trap Duration"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e7 }}% -> {{ e7NL }}%",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e3 }} -> {{ e3NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						"cooldownBurn": "0.5",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								40,
								90,
								140,
								190,
								240
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								3,
								3,
								4,
								4,
								5
							],
							[
								3,
								3,
								4,
								4,
								5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2",
							"40/90/140/190/240",
							"30/35/40/45/50",
							"3/3/4/4/5",
							"3/3/4/4/5",
							"1.5",
							"40/55/70/85/100",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "CaitlynYordleTrap.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CaitlynEntrapment",
						"name": "90 Caliber Net",
						"description": "Caitlyn fires a heavy net to slow her target. The recoil knocks Caitlyn back.",
						"tooltip": "Fires a net, knocking Caitlyn backwards. The net deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slows the first enemy hit by {{ e3 }}% for {{ e2 }} second.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14.5,
							13,
							11.5,
							10
						],
						"cooldownBurn": "16/14.5/13/11.5/10",
						"cost": [
							75,
							75,
							75,
							75,
							75
						],
						"costBurn": "75",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"1",
							"50",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "CaitlynEntrapment.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CaitlynAceintheHole",
						"name": "Ace in the Hole",
						"description": "Caitlyn takes time to line up the perfect shot, dealing massive damage to a single target at a huge range. Enemy champions can intercept the bullet for their ally.",
						"tooltip": "Takes a second to line up the perfect shot on an enemy Champion at up to {{ e2 }} range. The shot deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage, but other enemy Champions can intercept it.<br /><br />Grants <span class=\"coloree91d7\">True Sight</span> of the target during the channel.",
						"leveltip": {
							"label": [
								"Damage",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							90,
							75,
							60
						],
						"cooldownBurn": "90/75/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								250,
								475,
								700
							],
							[
								2000,
								2500,
								3000
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250/475/700",
							"2000/2500/3000",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 2,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							2000,
							2500,
							3000
						],
						"rangeBurn": "2000/2500/3000",
						"image": {
							"full": "CaitlynAceintheHole.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Headshot",
					"description": "Every few basic attacks, or against a target she has trapped or netted, Caitlyn will fire a headshot dealing bonus damage that scales with her critical strike chance. On trapped or netted targets, Caitlyn's Headshot attack range is doubled.",
					"image": {
						"full": "Caitlyn_Headshot.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Caitlyn",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Caitlyn",
						"title": "CaitlynTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Camille": {
				"id": "Camille",
				"key": "164",
				"name": "Camille",
				"title": "the Steel Shadow",
				"image": {
					"full": "Camille.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "164000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "164001",
						"num": 1,
						"name": "Program Camille",
						"chromas": false
					}
				],
				"lore": "Weaponized to operate outside the boundaries of the law, Camille is the Principal Intelligencer of Clan Ferros—an elegant and elite agent who ensures the Piltover machine and its Zaunite underbelly runs smoothly. Adaptable and precise, she views sloppy technique as an embarrassment that must be put to order. With a mind as sharp as the blades she bears, Camille's pursuit of superiority through hextech body augmentation has left many to wonder if she is now more machine than woman.",
				"blurb": "Weaponized to operate outside the boundaries of the law, Camille is the Principal Intelligencer of Clan Ferros—an elegant and elite agent who ensures the Piltover machine and its Zaunite underbelly runs smoothly. Adaptable and precise, she views sloppy...",
				"allytips": [
					"Try waiting until the other team is distracted with fighting your team, and use Hookshot to pick off vulnerable targets.",
					"Use the CC from your abilities to land both of your Precision Protocol attacks on enemies."
				],
				"enemytips": [
					"Camille's shield only works against one damage type, so hit her when she's vulnerable to your damage.",
					"The Hextech Ultimatum has a very short range to cast, so try to flash away from her before she gets close."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 6,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 575.6,
					"hpperlevel": 85,
					"mp": 338.8,
					"mpperlevel": 32,
					"movespeed": 340,
					"armor": 35,
					"armorperlevel": 3.8,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.8,
					"mpregen": 8.15,
					"mpregenperlevel": 0.75,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "CamilleQ",
						"name": "Precision Protocol",
						"description": "Camille's next attack deals bonus damage and grants bonus movement speed. This spell can be recast for a short period of time, doing significantly increased bonus damage if Camille delays a period of time between the two attacks.",
						"tooltip": "Camille's next basic attack deals <span class=\"colorFF8C00\">{{ f1 }}</span> bonus physical damage and increases her movement speed by {{ e4 }}% for {{ e5 }} second. This ability can be recast in the next {{ e0 }} seconds at no cost.<br /><br />If the second Precision Protocol attack hits at least {{ e1 }} seconds after the first, the bonus damage is increased by {{ e8 }}% to <span class=\"colorFF8C00\">{{ f2 }}</span> and <span class=\"colorFFFFFF\">{{ f3 }}%</span> of the attack is converted into true damage.<br /><br /><span class=\"size16 colorFFEB7F\">Precision Protocol</span> <span class=\"size16 color8C8C8C\">cannot critically strike.</span>",
						"leveltip": {
							"label": [
								"Total AD Ratio",
								"Cooldown",
								"Movement Speed"
							],
							"effect": [
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e4 }}% -> {{ e4NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8.25,
							7.5,
							6.75,
							6
						],
						"cooldownBurn": "9/8.25/7.5/6.75/6",
						"cost": [
							25,
							25,
							25,
							25,
							25
						],
						"costBurn": "25",
						"effect": [
							null,
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0.04,
								0.04,
								0.04,
								0.04,
								0.04
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								3.5,
								3.5,
								3.5,
								3.5,
								3.5
							]
						],
						"effectBurn": [
							null,
							"1.5",
							"50",
							"20/25/30/35/40",
							"20/25/30/35/40",
							"1",
							"0.4",
							"0.04",
							"100",
							"2",
							"3.5"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "CamilleQ.png",
							"sprite": "spell1.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CamilleW",
						"name": "Tactical Sweep",
						"description": "Camille blasts in a cone after a delay, dealing damage. Enemies in the outer half are slowed and take extra damage, while also healing Camille.",
						"tooltip": "Camille winds up and then slices in a direction, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to enemies hit.<br /><br />Enemies hit by the outer half are slowed by {{ e4 }}%, decaying over {{ e2 }} seconds. They take extra physical damage equal to {{ e5 }}% (<span class=\"colorFF8C00\">+{{ f2 }}</span>%) of their maximum health, and Camille heals for {{ e9 }}% of the bonus damage dealt to champions.<br /><br /><span class=\"size16 colorFFEB7F\">Tactical Sweep</span> <span class=\"size16 color8C8C8C\">does {{ e8 }}% less damage to non-epic monsters.</span>",
						"leveltip": {
							"label": [
								"Mana Cost",
								"Damage",
								"Maximum Health Damage",
								"Cooldown"
							],
							"effect": [
								"{{ cost }} -> {{ costNL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							13.5,
							12,
							10.5,
							9
						],
						"cooldownBurn": "15/13.5/12/10.5/9",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								70,
								100,
								130,
								160,
								190
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								6,
								6.5,
								7,
								7.5,
								8
							],
							[
								650,
								650,
								650,
								650,
								650
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							]
						],
						"effectBurn": [
							null,
							"70/100/130/160/190",
							"2",
							"0.75",
							"80",
							"6/6.5/7/7.5/8",
							"650",
							"30",
							"50",
							"100",
							"0.1"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							610,
							610,
							610,
							610,
							610
						],
						"rangeBurn": "610",
						"image": {
							"full": "CamilleW.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CamilleE",
						"name": "Hookshot",
						"description": "Camille pulls herself to a wall, leaping off and knocking up enemies upon landing.",
						"tooltip": "<span class=\"colorFF8C00\">First Cast:</span> Fire a hookshot that attaches to terrain, pulling Camille to it and allowing Hookshot to be recast for 1 second.<br /><br /><span class=\"colorFF8C00\">Second Cast:</span> Camille leaps from the wall, colliding with the first enemy champion hit. Upon landing, she deals {{ e3 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and a {{ e1 }} second stun to nearby enemies. Dashes towards enemy champions travel twice as far and grant {{ e2 }}% attack speed for {{ e5 }} seconds on impact.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Damage",
								"Attack Speed"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14.5,
							13,
							11.5,
							10
						],
						"cooldownBurn": "16/14.5/13/11.5/10",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								75,
								120,
								175,
								210,
								255
							],
							[
								1050,
								1050,
								1050,
								1050,
								1050
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								130,
								130,
								130,
								130,
								130
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0.75",
							"40/50/60/70/80",
							"75/120/175/210/255",
							"1050",
							"5",
							"1",
							"800",
							"400",
							"130",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "CamilleE.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CamilleR",
						"name": "The Hextech Ultimatum",
						"description": "Camille dashes to target champion, anchoring them to the area. She also deals bonus magic damage to the target with her basic attacks.",
						"tooltip": "Camille briefly becomes untargetable and leaps onto an enemy champion, interrupting channels and locking them into an area they cannot escape by any means for {{ e3 }} seconds. Other nearby enemies are knocked away. Her basic attacks against the trapped enemy deal bonus magic damage equal to {{ e2 }} plus {{ e1 }}% of their current health.<br /><br /><span class=\"size16 colorFFEB7F\">The Hextech Ultimatum</span> <span class=\"size16 color8C8C8C\">ends if Camille leaves the area.",
						"leveltip": {
							"label": [
								"Duration",
								"Cooldown",
								"Bonus Damage",
								"Current Health Damage"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							115,
							90
						],
						"cooldownBurn": "140/115/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								4,
								6,
								8
							],
							[
								5,
								10,
								15
							],
							[
								2.5,
								3.25,
								4
							],
							[
								-0.9,
								-0.9,
								-0.9
							],
							[
								425,
								425,
								425
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/6/8",
							"5/10/15",
							"2.5/3.25/4",
							"-0.9",
							"425",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							475,
							475,
							475
						],
						"rangeBurn": "475",
						"image": {
							"full": "CamilleR.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Adaptive Defenses",
					"description": "Basic attacks on champions grant a shield equal to 20% of Camille's maximum health against their damage type (Physical or Magic) for a brief duration.",
					"image": {
						"full": "Camille_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Camille",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Camille",
						"title": "CamilleTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Cassiopeia": {
				"id": "Cassiopeia",
				"key": "69",
				"name": "Cassiopeia",
				"title": "the Serpent's Embrace",
				"image": {
					"full": "Cassiopeia.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "69000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "69001",
						"num": 1,
						"name": "Desperada Cassiopeia",
						"chromas": false
					},
					{
						"id": "69002",
						"num": 2,
						"name": "Siren Cassiopeia",
						"chromas": false
					},
					{
						"id": "69003",
						"num": 3,
						"name": "Mythic Cassiopeia",
						"chromas": false
					},
					{
						"id": "69004",
						"num": 4,
						"name": "Jade Fang Cassiopeia",
						"chromas": false
					},
					{
						"id": "69008",
						"num": 8,
						"name": "Eternum Cassiopeia",
						"chromas": false
					}
				],
				"lore": "Cassiopeia is a deadly creature bent on manipulating others to her sinister will. Youngest and most beautiful daughter of the noble Du Couteau family of Noxus, she ventured deep into the crypts beneath Shurima in search of ancient power. There, she was bitten by a gruesome tomb guardian, whose venom transformed her into a viper-like predator. Cunning and agile, Cassiopeia now slithers under the veil of night, petrifying her enemies with her baleful gaze.",
				"blurb": "Cassiopeia is a deadly creature bent on manipulating others to her sinister will. Youngest and most beautiful daughter of the noble Du Couteau family of Noxus, she ventured deep into the crypts beneath Shurima in search of ancient power. There, she was...",
				"allytips": [
					"Use Twin Fang on poisoned stationary targets like monsters and units stunned by her Petrifying Gaze for maximum damage.",
					"Lead your enemy when targeting with Noxious Blast to ensure the hit."
				],
				"enemytips": [
					"Be wary of Cassiopeia's damage potential with Twin Fang when she has you poisoned.",
					"Turn away from Cassiopeia when she is casting Petrifying Gaze to get slowed instead of stunned."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 3,
					"magic": 9,
					"difficulty": 10
				},
				"stats": {
					"hp": 537,
					"hpperlevel": 87,
					"mp": 334,
					"mpperlevel": 63,
					"movespeed": 328,
					"armor": 25,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.5,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.034,
					"attackspeedperlevel": 1.5
				},
				"spells": [
					{
						"id": "CassiopeiaQ",
						"name": "Noxious Blast",
						"description": "Cassiopeia blasts an area with Poison after a brief delay, granting her increased Movement Speed if she hits an enemy champion.",
						"tooltip": "Blasts enemies in an area with <span class=\"color32CD32\">Noxious Poison</span>. If a champion is hit, Cassiopeia gains {{ e3 }}% Movement Speed decaying over {{ e4 }} seconds.<br /><br /><span class=\"color32CD32\">Noxious Poison</span> deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Movement Speed",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						],
						"cooldownBurn": "3.5",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								75,
								120,
								165,
								210,
								255
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/120/165/210/255",
							"3",
							"30/35/40/45/50",
							"3",
							"7",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "CassiopeiaQ.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CassiopeiaW",
						"name": "Miasma",
						"description": "Cassiopeia releases several clouds of poison, slowing, grounding, and lightly damaging enemies that pass through them. Grounded enemies cannot use Movement abilities.",
						"tooltip": "Cassiopeia spews venom in an arc, leaving toxic clouds for {{ e4 }} seconds.<br /><br />Enemies in the clouds are continually afflicted with <span class=\"color32CD32\">Debilitating Poison</span>, inflicting a decaying {{ e2 }}% slow and grounding them, prohibiting the use of Movement abilities. They also take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second.<br /><br />Miasma has a minimum cast range.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Slow Amount",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								20,
								35,
								50,
								65,
								80
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/35/50/65/80",
							"40/50/60/70/80",
							"1",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "CassiopeiaW.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CassiopeiaE",
						"name": "Twin Fang",
						"description": "Cassiopeia lets loose an attack that deals increased damage to Poisoned targets and heals her for a percentage of the damage dealt. If the target dies from this attack, Cassiopeia regains Mana.",
						"tooltip": "Deal <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to a target. If the target is killed by Twin Fang, or is killed during its flight, Cassiopeia gains {{ cost }} Mana.<br /><br />If the victim is <span class=\"color32CD32\">Poisoned</span> when Twin Fang hits, it takes {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> additional magic damage and Cassiopeia heals for <span class=\"colorFFFFFF\">{{ f4 }}</span> <span class=\"color99FF99\">(+{{ f2 }})</span>.",
						"leveltip": {
							"label": [
								"Bonus Poison Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						"cooldownBurn": "0.75",
						"cost": [
							40,
							50,
							60,
							70,
							80
						],
						"costBurn": "40/50/60/70/80",
						"effect": [
							null,
							[
								10,
								30,
								50,
								70,
								90
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/30/50/70/90",
							"0",
							"0.1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.55,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "CassiopeiaE.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CassiopeiaR",
						"name": "Petrifying Gaze",
						"description": "Cassiopeia releases a swirl of magical energy from her eyes, stunning any enemies in front of her that are facing her and slowing any others with their back turned.",
						"tooltip": "Cassiopeia deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in front of her. Enemies facing her turn to stone and are stunned for {{ e3 }} seconds while enemies facing away are slowed by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								40,
								40,
								40
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"40",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							825,
							825,
							825
						],
						"rangeBurn": "825",
						"image": {
							"full": "CassiopeiaR.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Serpentine Grace",
					"description": "Cassiopeia gains Movement Speed per level, but she cannot purchase Boots items.",
					"image": {
						"full": "Cassiopeia_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Cassiopeia",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Cassiopeia",
						"title": "CassiopeiaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Chogath": {
				"id": "Chogath",
				"key": "31",
				"name": "Cho'Gath",
				"title": "the Terror of the Void",
				"image": {
					"full": "Chogath.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "31000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "31001",
						"num": 1,
						"name": "Nightmare Cho'Gath",
						"chromas": false
					},
					{
						"id": "31002",
						"num": 2,
						"name": "Gentleman Cho'Gath",
						"chromas": false
					},
					{
						"id": "31003",
						"num": 3,
						"name": "Loch Ness Cho'Gath",
						"chromas": false
					},
					{
						"id": "31004",
						"num": 4,
						"name": "Jurassic Cho'Gath",
						"chromas": false
					},
					{
						"id": "31005",
						"num": 5,
						"name": "Battlecast Prime Cho'Gath",
						"chromas": false
					},
					{
						"id": "31006",
						"num": 6,
						"name": "Prehistoric Cho'Gath",
						"chromas": false
					}
				],
				"lore": "From the moment Cho'Gath first emerged into the harsh light of Runeterra's sun, the beast was driven by the most pure and insatiable hunger. A perfect expression of the Void's desire to consume all life, Cho'Gath's complex biology quickly converts matter into new bodily growth—increasing its muscle mass and density, or hardening its outer carapace like organic diamond. When growing larger does not suit the Void-spawn's needs, it vomits out the excess material as razor-sharp spines, leaving prey skewered and ready to feast upon later.",
				"blurb": "From the moment Cho'Gath first emerged into the harsh light of Runeterra's sun, the beast was driven by the most pure and insatiable hunger. A perfect expression of the Void's desire to consume all life, Cho'Gath's complex biology quickly converts...",
				"allytips": [
					"Try to line up your attacks with Vorpal Spikes so that they kill minions and harass enemy champions at the same time.",
					"If you're having difficulty feasting upon champions, try eating minions until you're larger.",
					"Using Rupture on creeps in combination with Carnivore is a good way to gain Health and Mana."
				],
				"enemytips": [
					"Purchasing a few HP items decreases the chances of Cho'Gath killing you quickly.",
					"Focus on preventing Cho'Gath from reaching his max size.",
					"Rupture has a smoke cloud indicating the area it will strike. Try to watch out for it to prevent Cho'Gath from being able to combo his abilities."
				],
				"tags": [
					"Tank",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 7,
					"magic": 7,
					"difficulty": 5
				},
				"stats": {
					"hp": 574.4,
					"hpperlevel": 80,
					"mp": 272.2,
					"mpperlevel": 40,
					"movespeed": 345,
					"armor": 38,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9,
					"hpregenperlevel": 0.85,
					"mpregen": 7.206,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 69,
					"attackdamageperlevel": 4.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.44
				},
				"spells": [
					{
						"id": "Rupture",
						"name": "Rupture",
						"description": "Ruptures the ground at target location, popping enemy units into the air, dealing damage and slowing them.",
						"tooltip": "Ruptures the ground at target location. Enemies caught in the rupture are launched into the air for {{ e5 }} second, take {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage, and are slowed by {{ e2 }}% for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								80,
								135,
								190,
								245,
								300
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0.625,
								0.625,
								0.625,
								0.625,
								0.625
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/135/190/245/300",
							"60",
							"1.5",
							"0.63",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "Rupture.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FeralScream",
						"name": "Feral Scream",
						"description": "Cho'Gath unleashes a terrible scream at enemies in a cone, dealing magic damage and Silencing enemies for a few seconds.",
						"tooltip": "Silences enemies in a cone for {{ e2 }} seconds and deals {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Silence Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								75,
								125,
								175,
								225,
								275
							],
							[
								1.6,
								1.7,
								1.8,
								1.9,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/125/175/225/275",
							"1.6/1.7/1.8/1.9/2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "FeralScream.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VorpalSpikes",
						"name": "Vorpal Spikes",
						"description": "Cho'Gath's attacks release deadly spikes, dealing damage and slowing all enemy units in front of him.",
						"tooltip": "Cho'Gath's next 3 basic attacks launch spikes that deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> plus {{ f1 }}% of enemies' maximum Health as magic damage and slow by {{ e2 }}% for {{ e3 }} seconds, decaying over the duration.<br /><br /><rules>Spikes grow wider as Cho'Gath gains Feast stacks.<br />Spikes deal an additional 0.5% of enemies' maximum Health per Feast stack.<br />Percent Health damage against minions and monsters is capped at {{ e8 }}.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Slow"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7,
							6,
							5,
							4
						],
						"cooldownBurn": "8/7/6/5/4",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								50,
								50,
								50,
								50,
								50
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"30/35/40/45/50",
							"1.5",
							"6",
							"3",
							"3",
							"0.5",
							"60/80/100/120/140",
							"6",
							"50"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							40,
							40,
							40,
							40,
							40
						],
						"rangeBurn": "40",
						"image": {
							"full": "VorpalSpikes.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Feast",
						"name": "Feast",
						"description": "Devours an enemy unit, dealing a high amount of true damage. If the target is killed, Cho'Gath grows, gaining maximum Health.",
						"tooltip": "Ravenously feed on an enemy, dealing {{ e2 }} <scaleHealth>(+{{ f2 }})</scaleHealth> <scaleAP>(+{{ a2 }})</scaleAP> true damage to champions or {{ e1 }} <scaleHealth>(+{{ f2 }}) </scaleHealth><scaleAP>(+{{ a2 }})</scaleAP> to minions and monsters. If the target is killed, Cho'Gath gains a stack of Feast, which causes him to grow in size and gain {{ e3 }} maximum health.<br /><br /><rules>Only {{ e4 }} total stacks can be gained from minions and non-epic monsters. <span class=\"colorFFF673\">(Current: {{ f3 }}/{{ e4 }})</span></rules>",
						"leveltip": {
							"label": [
								"Champion Damage",
								"Health per Stack"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							80,
							80,
							80
						],
						"cooldownBurn": "80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								1000,
								1000,
								1000
							],
							[
								300,
								475,
								650
							],
							[
								80,
								120,
								160
							],
							[
								6,
								6,
								6
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1000",
							"300/475/650",
							"80/120/160",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							175,
							175,
							175
						],
						"rangeBurn": "175",
						"image": {
							"full": "Feast.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Carnivore",
					"description": "Whenever Cho'Gath kills a unit, he recovers Health and Mana. The values restored increase with Cho'Gath's level.",
					"image": {
						"full": "GreenTerror_TailSpike.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Chogath",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3105",
										"count": 1
									},
									{
										"id": "3001",
										"count": 1
									},
									{
										"id": "3110",
										"count": 1
									},
									{
										"id": "3083",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Chogath",
						"title": "ChogathTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Corki": {
				"id": "Corki",
				"key": "42",
				"name": "Corki",
				"title": "the Daring Bombardier",
				"image": {
					"full": "Corki.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "42000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "42001",
						"num": 1,
						"name": "UFO Corki",
						"chromas": false
					},
					{
						"id": "42002",
						"num": 2,
						"name": "Ice Toboggan Corki",
						"chromas": false
					},
					{
						"id": "42003",
						"num": 3,
						"name": "Red Baron Corki",
						"chromas": false
					},
					{
						"id": "42004",
						"num": 4,
						"name": "Hot Rod Corki",
						"chromas": false
					},
					{
						"id": "42005",
						"num": 5,
						"name": "Urfrider Corki",
						"chromas": false
					},
					{
						"id": "42006",
						"num": 6,
						"name": "Dragonwing Corki",
						"chromas": true
					},
					{
						"id": "42007",
						"num": 7,
						"name": "Fnatic Corki",
						"chromas": false
					},
					{
						"id": "42008",
						"num": 8,
						"name": "Arcade Corki",
						"chromas": true
					}
				],
				"lore": "The yordle pilot Corki loves two things above all others: flying, and his glamorous mustache... though not necessarily in that order. After leaving Bandle City, he settled in Piltover and fell in love with the wondrous machines he found there. He dedicated himself to the development of flying contraptions, leading an aerial defense force of seasoned veterans known as the Screaming Yipsnakes. Calm under fire, Corki patrols the skies around his adopted home, and has never encountered a problem that a good missile barrage couldn't solve.",
				"blurb": "The yordle pilot Corki loves two things above all others: flying, and his glamorous mustache... though not necessarily in that order. After leaving Bandle City, he settled in Piltover and fell in love with the wondrous machines he found there. He...",
				"allytips": [
					"Phosphorus Bomb can be used to reveal enemy units that might be hiding in a nearby patch of brush.",
					"Valkyrie can be used defensively as well, so try using it for a quick escape.",
					"Corki can continue to attack while using Gatling Gun. Maximizing Gatling Gun is key to mastering Corki."
				],
				"enemytips": [
					"Watch out for Corki's Missile Barrage. They deal splash damage, so you can get hit even when hiding behind minions.",
					"Corki is vulnerable after he uses his Valkyrie or Special Delivery, so try switching focus to him if he uses them to enter a fight."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 3,
					"magic": 6,
					"difficulty": 6
				},
				"stats": {
					"hp": 518,
					"hpperlevel": 87,
					"mp": 350.16,
					"mpperlevel": 34,
					"movespeed": 325,
					"armor": 28,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 7.424,
					"mpregenperlevel": 0.55,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 60,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 2.3
				},
				"spells": [
					{
						"id": "PhosphorusBomb",
						"name": "Phosphorus Bomb",
						"description": "Corki fires a flash bomb at a target location, dealing magic damage to enemies in the area. This attack additionally reveals units in the area for a duration.",
						"tooltip": "Corki lobs a bomb, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the target area. In addition, the blast reveals the area and champions hit by the blast for {{ e2 }} seconds (does not reveal stealth).",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								75,
								120,
								165,
								210,
								255
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/120/165/210/255",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							825,
							825,
							825,
							825,
							825
						],
						"rangeBurn": "825",
						"image": {
							"full": "PhosphorusBomb.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CarpetBomb",
						"name": "Valkyrie",
						"description": "Corki flies a short distance, dropping bombs that create a trail of fire that damages opponents who remain in it.",
						"tooltip": "<span class=\"colorFF9900\">Active:</span> Corki flies a short distance, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to enemies in the fire left along his path.<br /><br /><span class=\"colorFF9900\">Special Delivery:</span> Corki flies a great distance, dropping bombs that knock aside enemies and leave a burning trail for 5 seconds. The trail slows enemies by {{ e2 }}% and burns them for {{ f1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage per second.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							19,
							18,
							17,
							16
						],
						"cooldownBurn": "20/19/18/17/16",
						"cost": [
							100,
							100,
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								90,
								90,
								90,
								90,
								90
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/90/120/150/180",
							"90",
							"0",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "CarpetBomb.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GGun",
						"name": "Gatling Gun",
						"description": "Corki's gatling gun rapidly fires in a cone in front of him, dealing damage and reducing enemy Armor and Magic Resist.",
						"tooltip": "Corki's gatling gun fires continuously at targets in front of him for {{ e2 }} seconds, dealing up to {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> damage and reducing up to {{ e4 }} armor and magic resist.<br /><br /><span class=\"color919191\"><i>Gatling Gun's damage is {{ e7 }}% physical, {{ e8 }}% magic.<br />Defense reductions last for {{ e6 }} seconds after last being damaged by Gatling Gun.</i></span>",
						"leveltip": {
							"label": [
								"Damage",
								"Defense Reduction"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							16,
							16,
							16,
							16
						],
						"cooldownBurn": "16",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								80,
								140,
								200,
								260,
								320
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								8,
								12,
								16,
								20
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/140/200/260/320",
							"4",
							"4",
							"4/8/12/16/20",
							"8",
							"2",
							"50",
							"50",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "GGun.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MissileBarrage",
						"name": "Missile Barrage",
						"description": "Corki fires a missile toward his target location that explodes on impact, dealing damage to enemies in an area. Corki stores missiles over time, up to a maximum. Every 3rd missile fired will be a Big One, dealing extra damage.",
						"tooltip": "<span class=\"colorFF9900\">Active:</span> Corki fires a missile that explodes at the first enemy it hits, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all nearby enemies.<br /><br />Corki can store up to 7 missiles, and every 3rd missile will be a Big One, dealing {{ f2 }}% damage ({{ f3 }})</span>.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Attack Damage Scaling",
								"Missile Reload Time"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							2,
							2,
							2
						],
						"cooldownBurn": "2",
						"cost": [
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								75,
								100,
								125
							],
							[
								15,
								45,
								75
							],
							[
								300,
								300,
								300
							],
							[
								2,
								2,
								2
							],
							[
								0.15,
								0.45,
								0.75
							],
							[
								0,
								0,
								0
							],
							[
								50,
								50,
								50
							],
							[
								200,
								200,
								200
							],
							[
								200,
								200,
								200
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/100/125",
							"15/45/75",
							"300",
							"2",
							"0.15/0.45/0.75",
							"0",
							"50",
							"200",
							"200",
							"0"
						],
						"vars": [
							{
								"link": "@cooldownchampion",
								"coeff": 10,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "@dynamic.attackdamage",
								"coeff": 0,
								"key": "f3"
							}
						],
						"costType": " Mana",
						"maxammo": "7",
						"range": [
							1225,
							1225,
							1225
						],
						"rangeBurn": "1225",
						"image": {
							"full": "MissileBarrage.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Hextech Munitions",
					"description": "Corki's basic attack deals a percentage of their damage as magic instead of physical. Every once in a while, The Package arrives in Corki's base to be picked up, temporarily granting him out of combat Movement Speed and upgrading Valkyrie into Special Delivery.",
					"image": {
						"full": "Corki_RapidReload.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Corki",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Corki",
						"title": "CorkiTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Darius": {
				"id": "Darius",
				"key": "122",
				"name": "Darius",
				"title": "the Hand of Noxus",
				"image": {
					"full": "Darius.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "122000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "122001",
						"num": 1,
						"name": "Lord Darius",
						"chromas": false
					},
					{
						"id": "122002",
						"num": 2,
						"name": "Bioforge Darius",
						"chromas": false
					},
					{
						"id": "122003",
						"num": 3,
						"name": "Woad King Darius",
						"chromas": false
					},
					{
						"id": "122004",
						"num": 4,
						"name": "Dunkmaster Darius",
						"chromas": true
					},
					{
						"id": "122008",
						"num": 8,
						"name": "Academy Darius",
						"chromas": false
					},
					{
						"id": "122014",
						"num": 14,
						"name": "Dreadnova Darius",
						"chromas": false
					}
				],
				"lore": "There is no greater symbol of Noxian might than Darius, the nation's most feared and battle-hardened leader. Rising from humble origins to become the Hand of Noxus, he cleaves through the empire's enemies—many of them Noxians themselves. Knowing that he never doubts his cause is just, and never hesitates once his axe is raised, those who stand against the commander of the Trifarian Legion can expect no mercy.",
				"blurb": "There is no greater symbol of Noxian might than Darius, the nation's most feared and battle-hardened leader. Rising from humble origins to become the Hand of Noxus, he cleaves through the empire's enemies—many of them Noxians themselves. Knowing that he...",
				"allytips": [
					"Decimate is a powerful harassment ability. Strike an enemy from maximum range for the greatest effect.",
					"Noxian Guillotine does more damage the more attacks you can land prior to it. Use Noxian Might to deal maximum damage.",
					"Darius benefits greatly from enhanced survivability. The longer you can prolong a fight, the more powerful he becomes."
				],
				"enemytips": [
					"When Darius's axe grab is on cooldown, he is vulnerable to harassment attacks.",
					"Darius's ability to escape from fights is limited. If you have an advantage against him, press your lead."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 5,
					"magic": 1,
					"difficulty": 2
				},
				"stats": {
					"hp": 582.24,
					"hpperlevel": 100,
					"mp": 263,
					"mpperlevel": 37.5,
					"movespeed": 340,
					"armor": 39,
					"armorperlevel": 4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 10,
					"hpregenperlevel": 0.95,
					"mpregen": 6.6,
					"mpregenperlevel": 0.35,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1
				},
				"spells": [
					{
						"id": "DariusCleave",
						"name": "Decimate",
						"description": "Darius winds up and swings his axe in a wide circle. Enemies struck by the blade take more damage than those struck by the handle. Darius heals based on enemy champions hit by the blade.",
						"tooltip": "After a short delay, Darius swings his axe around himself, striking enemies in its path. Enemies hit by the axe's blade take {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage. Enemies hit by the handle take {{ e6 }}% damage (does not apply Hemorrhage).<br /><br />Darius heals for <span class=\"colorFF0000\">{{ e5 }}% of his missing Health</span> per enemy champion hit by the blade (max: {{ e7 }}%).",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Damage Scaling",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							30,
							35,
							40,
							45,
							50
						],
						"costBurn": "30/35/40/45/50",
						"effect": [
							null,
							[
								100,
								110,
								120,
								130,
								140
							],
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								99,
								99,
								99,
								99,
								99
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								36,
								36,
								36,
								36,
								36
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/110/120/130/140",
							"40/70/100/130/160",
							"99",
							"0.1",
							"12",
							"35",
							"36",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.05,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "DariusCleave.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DariusNoxianTacticsONH",
						"name": "Crippling Strike",
						"description": "Darius's next attack strikes an enemy's crucial artery. As they bleed out, their Movement Speed is slowed.",
						"tooltip": " Darius's next basic attack deals <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage and slows the target by {{ e2 }}% for {{ e5 }} second.<br /><br />Crippling Strike refunds its Mana cost and {{ e3 }}% of its cooldown if it kills the target.",
						"leveltip": {
							"label": [
								"Attack Damage Scaling",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								90,
								90,
								90,
								90,
								90
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								140,
								145,
								150,
								155,
								160
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"90",
							"50",
							"140/145/150/155/160",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "DariusNoxianTacticsONH.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DariusAxeGrabCone",
						"name": "Apprehend",
						"description": "Darius hones his axe, passively causing his physical damage to ignore a percentage of his target's Armor. When activated, Darius sweeps up his enemies with his axe's hook and pulls them to him.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Darius gains {{ e1 }}% Armor Penetration.<br /><br /><span class=\"colorFF9900\">Active: </span>Pulls in all enemies in front of Darius and slows them by {{ e2 }}% for {{ e3 }} second.",
						"leveltip": {
							"label": [
								"Armor Penetration",
								"Cooldown "
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							21,
							18,
							15,
							12
						],
						"cooldownBurn": "24/21/18/15/12",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/15/20/25/30",
							"40",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							535,
							535,
							535,
							535,
							535
						],
						"rangeBurn": "535",
						"image": {
							"full": "DariusAxeGrabCone.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DariusExecute",
						"name": "Noxian Guillotine",
						"description": "Darius leaps to an enemy champion and strikes a lethal blow, dealing true damage. This damage is increased for each stack of Hemorrhage on the target. If Noxian Guillotine is a killing blow, its cooldown is refreshed for a brief duration.",
						"tooltip": "Leaps to target enemy champion and strikes a lethal blow, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> true damage. For each stack of Hemorrhage on the target, Noxian Guillotine deals an additional {{ e3 }}% damage.<span class=\"size8 colorFF9900\"><br /><br /></span><span class=\"colorF50F00\">Maximum Damage: {{ f3 }}</span><span class=\"size8\"><br /><br /></span>If Noxian Guillotine kills the target, it may be re-cast at no cost within 20 seconds.<span class=\"size8\"><br /><br /></span>At rank 3, Noxian Guillotine <span class=\"colorFFFF66\"><i>unlocks</i></span> - its cooldown resets entirely on kills and it no longer has a Mana cost.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							0
						],
						"costBurn": "100/100/0",
						"effect": [
							null,
							[
								100,
								200,
								300
							],
							[
								0.75,
								0.75,
								0.75
							],
							[
								20,
								20,
								20
							],
							[
								25,
								50,
								100
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/200/300",
							"0.75",
							"20",
							"25/50/100",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.75,
								"key": "f1"
							},
							{
								"link": "@special.dariusr3",
								"coeff": 0,
								"key": "f3"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							460,
							460,
							460
						],
						"rangeBurn": "460",
						"image": {
							"full": "DariusExecute.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Hemorrhage",
					"description": "Darius aims his attacks strategically, causing his target to bleed. This effect stacks up to five times. Enemies that reach max Hemorrhage cause Darius to gain Noxian Might, greatly increasing his damage.",
					"image": {
						"full": "Darius_PassiveBuff.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Darius",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Darius",
						"title": "DariusTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Diana": {
				"id": "Diana",
				"key": "131",
				"name": "Diana",
				"title": "Scorn of the Moon",
				"image": {
					"full": "Diana.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "131000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "131001",
						"num": 1,
						"name": "Dark Valkyrie Diana",
						"chromas": false
					},
					{
						"id": "131002",
						"num": 2,
						"name": "Lunar Goddess Diana",
						"chromas": true
					},
					{
						"id": "131003",
						"num": 3,
						"name": "Infernal Diana",
						"chromas": false
					},
					{
						"id": "131011",
						"num": 11,
						"name": "Blood Moon Diana",
						"chromas": false
					}
				],
				"lore": "Bearing her crescent moonblade, Diana fights as a warrior of the Lunari—a faith all but quashed in the lands around Mount Targon. Clad in shimmering armor the color of winter snow at night, she is a living embodiment of the silver moon's power. Imbued with the essence of an Aspect from beyond Targon's towering summit, Diana is no longer wholly human, and struggles to understand her power and purpose in this world.",
				"blurb": "Bearing her crescent moonblade, Diana fights as a warrior of the Lunari—a faith all but quashed in the lands around Mount Targon. Clad in shimmering armor the color of winter snow at night, she is a living embodiment of the silver moon's power. Imbued...",
				"allytips": [
					"Landing Crescent Strike is critically important, but don't be afraid to miss. The cooldown is short and the mana cost is low.",
					"Consider when to cast Lunar Rush without Moonlight and when to wait for another Crescent Strike.",
					"Use Moonfall and Lunar Rush to stay on targets and activate Moonsilver Blade for extra damage."
				],
				"enemytips": [
					"Dodge Crescent Strike, or move to safety if you are affected by Moonlight.",
					"Pale Cascade orbs only last a few seconds. Avoid Diana and engage her after the shield dissipates.",
					"Diana can play very aggressively if she uses Lunar Rush without Moonlight, but you can punish her by slowing or stunning her when she has no way to get back into position."
				],
				"tags": [
					"Fighter",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 6,
					"magic": 8,
					"difficulty": 4
				},
				"stats": {
					"hp": 594,
					"hpperlevel": 95,
					"mp": 297.2,
					"mpperlevel": 40,
					"movespeed": 345,
					"armor": 31,
					"armorperlevel": 3.6,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 150,
					"hpregen": 7.5,
					"hpregenperlevel": 0.85,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.25
				},
				"spells": [
					{
						"id": "DianaArc",
						"name": "Crescent Strike",
						"description": "Diana swings her blade to unleash a bolt of lunar energy that deals damage in an arc before exploding. Afflicts enemies struck with the Moonlight debuff, revealing them if they are not stealthed. ",
						"tooltip": "Unleashes a bolt of lunar energy in an arc dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage.<br /><br />Afflicts enemies struck with Moonlight, revealing them if they are not stealthed for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7.5,
							7,
							6.5,
							6
						],
						"cooldownBurn": "8/7.5/7/6.5/6",
						"cost": [
							55,
							55,
							55,
							55,
							55
						],
						"costBurn": "55",
						"effect": [
							null,
							[
								60,
								95,
								130,
								165,
								200
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								55,
								55,
								55,
								55,
								55
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/95/130/165/200",
							"15",
							"55",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "DianaArc.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DianaOrbs",
						"name": "Pale Cascade",
						"description": "Diana creates three orbiting spheres that detonate on contact with enemies to deal damage in an area. She also gains a temporary shield that absorbs damage. If her third sphere detonates, the shield gains additional strength.",
						"tooltip": "Creates three orbiting spheres that explode on contact with enemies dealing {{ e2 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage. Lasts {{ e1 }} seconds.<br /><br />Grants a temporary shield that absorbs {{ e3 }} <scaleAP>(+{{ a2 }})</scaleAP> damage. If the third sphere detonates, the shield increases by {{ e3 }} <scaleAP>(+{{ a2 }})</scaleAP>.",
						"leveltip": {
							"label": [
								"Damage",
								"Shield",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							40,
							55,
							70,
							85,
							100
						],
						"costBurn": "40/55/70/85/100",
						"effect": [
							null,
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								22,
								34,
								46,
								58,
								70
							],
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5",
							"22/34/46/58/70",
							"40/55/70/85/100",
							"1",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "DianaOrbs.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DianaVortex",
						"name": "Moonfall",
						"description": "Diana draws in and slows all nearby enemies. Passively grants Diana attack speed after spell casts.",
						"tooltip": "<spellPassive>Passive:</spellPassive> Increases the attack speed gained from Moonsilver Blade to {{ e3 }}%.<br /><br /><spellActive>Active:</spellActive> Reveals and draws in all nearby enemies and then slows them by {{ e1 }}% for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							26,
							24,
							22,
							20,
							18
						],
						"cooldownBurn": "26/24/22/20/18",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								35,
								40,
								45,
								50,
								55
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								50,
								60,
								70,
								80,
								90
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/40/45/50/55",
							"2",
							"50/60/70/80/90",
							"3",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "DianaVortex.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DianaTeleport",
						"name": "Lunar Rush",
						"description": "Diana dashes to an enemy and deals magic damage. Lunar Rush has no cooldown when used to teleport to a target afflicted with Moonlight.",
						"tooltip": "Becomes the living embodiment of the vengeful moon, dashing to an enemy and dealing {{ e2 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage.<br /><br />Lunar Rush has no cooldown when used to dash to an enemy afflicted with Moonlight. All other enemies will have the Moonlight debuff removed regardless of whether they were the target of Lunar Rush.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							25,
							20,
							15
						],
						"cooldownBurn": "25/20/15",
						"cost": [
							50,
							65,
							80
						],
						"costBurn": "50/65/80",
						"effect": [
							null,
							[
								4,
								4,
								4
							],
							[
								100,
								160,
								220
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4",
							"100/160/220",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							825,
							825,
							825
						],
						"rangeBurn": "825",
						"image": {
							"full": "DianaTeleport.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Moonsilver Blade",
					"description": "Every third strike restores mana and cleaves nearby enemies for additional magic damage. Every spell cast grants attack speed for the next 3 attacks.",
					"image": {
						"full": "Diana_Passive_LunarBlade.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Diana",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Diana",
						"title": "DianaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Draven": {
				"id": "Draven",
				"key": "119",
				"name": "Draven",
				"title": "the Glorious Executioner",
				"image": {
					"full": "Draven.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "119000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "119001",
						"num": 1,
						"name": "Soul Reaver Draven",
						"chromas": false
					},
					{
						"id": "119002",
						"num": 2,
						"name": "Gladiator Draven",
						"chromas": false
					},
					{
						"id": "119003",
						"num": 3,
						"name": "Primetime Draven",
						"chromas": true
					},
					{
						"id": "119004",
						"num": 4,
						"name": "Pool Party Draven",
						"chromas": false
					},
					{
						"id": "119005",
						"num": 5,
						"name": "Beast Hunter Draven",
						"chromas": false
					},
					{
						"id": "119006",
						"num": 6,
						"name": "Draven Draven",
						"chromas": false
					},
					{
						"id": "119012",
						"num": 12,
						"name": "Santa Draven",
						"chromas": false
					}
				],
				"lore": "In Noxus, warriors known as reckoners face one another in arenas where blood is spilled and strength tested—but none has ever been as celebrated as Draven. A former soldier, he found that the crowds uniquely appreciated his flair for the dramatic, not to mention the spray of blood from each of his spinning axes. Addicted to the spectacle of his own brash perfection, Draven has sworn to defeat whomever he must to ensure that his name is chanted throughout the empire forever more.",
				"blurb": "In Noxus, warriors known as reckoners face one another in arenas where blood is spilled and strength tested—but none has ever been as celebrated as Draven. A former soldier, he found that the crowds uniquely appreciated his flair for the dramatic, not...",
				"allytips": [
					"If Draven doesn't move, Spinning Axe will fall near his present location. It will fall directly on him, or just to the right or left.",
					"If Draven does move after attacking, Spinning Axe will lead him in the direction of his movement. Use this to control where the Spinning Axe will go."
				],
				"enemytips": [
					"Launch skillshots toward the landing position of Draven's Spinning Axes.",
					"Disrupt Draven with the goal of making him drop his axes. If you do, his power drops dramatically."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 3,
					"magic": 1,
					"difficulty": 8
				},
				"stats": {
					"hp": 557.76,
					"hpperlevel": 82,
					"mp": 360.56,
					"mpperlevel": 39,
					"movespeed": 330,
					"armor": 35,
					"armorperlevel": 3.3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6,
					"hpregenperlevel": 0.7,
					"mpregen": 8.042,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 2.91,
					"attackspeedoffset": -0.08,
					"attackspeedperlevel": 2.7
				},
				"spells": [
					{
						"id": "DravenSpinning",
						"name": "Spinning Axe",
						"description": "Draven's next attack will deal bonus physical damage. This axe will ricochet off the target high up into the air. If Draven catches it, he automatically readies another Spinning Axe. Draven can have two Spinning Axes at once.",
						"tooltip": "Draven's next attack will deal <span class=\"colorFF8C00\">{{ f1 }}</span> bonus physical damage. The bonus is equal to {{ e5 }} plus {{ e2 }}% of his bonus Attack Damage.<br /><br />This axe will ricochet off the target high up into the air. If Draven catches it, he automatically readies another Spinning Axe.<br /><br /><span class=\"colorDDDD77\">Draven can have two Spinning Axes at once.</span>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Bonus AD Percentage",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								65,
								75,
								85,
								95,
								105
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								5.75,
								5.75,
								5.75,
								5.75,
								5.75
							],
							[
								35,
								40,
								45,
								50,
								55
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100",
							"65/75/85/95/105",
							"30/35/40/45/50",
							"5.75",
							"35/40/45/50/55",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.45,
									0.55,
									0.65,
									0.75,
									0.85
								],
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "DravenSpinning.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DravenFury",
						"name": "Blood Rush",
						"description": "Draven gains increased Movement Speed and Attack Speed. The Movement Speed bonus decreases rapidly over its duration. Catching a Spinning Axe will refresh the cooldown of Blood Rush.",
						"tooltip": "",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Mana Cost",
								"Movement Speed"
							],
							"effect": [
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cost }} -> {{ costNL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							40,
							35,
							30,
							25,
							20
						],
						"costBurn": "40/35/30/25/20",
						"effect": [
							null,
							[
								4,
								5,
								6,
								7,
								8
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								-0.05,
								-0.056,
								-0.062,
								-0.069,
								-0.075
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/5/6/7/8",
							"40/45/50/55/60",
							"1.5",
							"20/25/30/35/40",
							"3",
							"-0.05/-0.056/-0.062/-0.069/-0.075",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "DravenFury.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DravenDoubleShot",
						"name": "Stand Aside",
						"description": "Draven throws his axes, dealing physical damage to targets hit and knocking them aside. Targets hit are slowed.",
						"tooltip": "Draven throws his axes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to targets hit and knocking them aside. Targets hit are slowed by {{ e2 }}% for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Amount",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								75,
								110,
								145,
								180,
								215
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/110/145/180/215",
							"20/25/30/35/40",
							"2",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1050,
							1050,
							1050,
							1050,
							1050
						],
						"rangeBurn": "1050",
						"image": {
							"full": "DravenDoubleShot.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DravenRCast",
						"name": "Whirling Death",
						"description": "Draven hurls two massive axes to deal physical damage to each unit struck. Whirling Death slowly reverses direction and returns to Draven after striking an enemy champion. Draven may also activate this ability while the axes are in flight to cause it to return early. Deals less damage for each unit hit and resets when the axes reverse direction.",
						"tooltip": "Draven hurls two massive axes to deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to each unit struck.<br /><br />Whirling Death slowly reverses direction and returns to Draven after striking an enemy champion. Draven may also activate this ability while the axes are in flight to cause it to return early. Deals {{ e4 }}% less damage for each unit hit (Minimum {{ e2 }}%) and resets when the axes reverse direction.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								175,
								275,
								375
							],
							[
								40,
								40,
								40
							],
							[
								0,
								0,
								0
							],
							[
								8,
								8,
								8
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"175/275/375",
							"40",
							"0",
							"8",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.1,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20000,
							20000,
							20000
						],
						"rangeBurn": "20000",
						"image": {
							"full": "DravenRCast.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "League of Draven",
					"description": "Draven gains his fans' Adoration when he catches a Spinning Axe or kills a minion, monster, or tower. Killing enemy champions grants Draven bonus gold based on how much Adoration he has.",
					"image": {
						"full": "Draven_passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Draven",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Draven",
						"title": "DravenTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"DrMundo": {
				"id": "DrMundo",
				"key": "36",
				"name": "Dr. Mundo",
				"title": "the Madman of Zaun",
				"image": {
					"full": "DrMundo.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "36000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "36001",
						"num": 1,
						"name": "Toxic Dr. Mundo",
						"chromas": false
					},
					{
						"id": "36002",
						"num": 2,
						"name": "Mr. Mundoverse",
						"chromas": false
					},
					{
						"id": "36003",
						"num": 3,
						"name": "Corporate Mundo",
						"chromas": false
					},
					{
						"id": "36004",
						"num": 4,
						"name": "Mundo Mundo",
						"chromas": false
					},
					{
						"id": "36005",
						"num": 5,
						"name": "Executioner Mundo",
						"chromas": false
					},
					{
						"id": "36006",
						"num": 6,
						"name": "Rageborn Mundo",
						"chromas": false
					},
					{
						"id": "36007",
						"num": 7,
						"name": "TPA Mundo",
						"chromas": false
					},
					{
						"id": "36008",
						"num": 8,
						"name": "Pool Party Mundo",
						"chromas": false
					},
					{
						"id": "36009",
						"num": 9,
						"name": "El Macho Mundo",
						"chromas": false
					}
				],
				"lore": "Utterly insane, unrepentantly homicidal, and horrifyingly purple, Dr. Mundo is what keeps many of Zaun's citizens indoors on particularly dark nights. This monosyllabic monstrosity seems to want nothing more than pain—both the giving of it, and the receiving of it. Wielding his massive meat cleaver as if it were weightless, Mundo is infamous for capturing and torturing dozens of Zaun's citizens for his nefarious “operations,” which seem to have no overall point or goal. He is brutal. He is unpredictable. He goes where he pleases. He is also not, technically, a doctor.",
				"blurb": "Utterly insane, unrepentantly homicidal, and horrifyingly purple, Dr. Mundo is what keeps many of Zaun's citizens indoors on particularly dark nights. This monosyllabic monstrosity seems to want nothing more than pain—both the giving of it, and the...",
				"allytips": [
					"A well-timed Sadism can bait enemy champions into attacking you even when they lack the damage to finish you.",
					"Spirit Visage will increase the healing done by your ultimate and lower cooldowns on all of your abilities.",
					"Cleavers are a powerful tool for killing neutral monsters. Instead of returning to base, farm neutral monsters until your ultimate can heal you."
				],
				"enemytips": [
					"Try to coordinate high-damage abilities with your allies right after Dr. Mundo uses his ultimate, but if you're unable to kill him quickly with burst he will heal through the damage.",
					"Try casting Ignite when Dr. Mundo uses Sadism to negate a large portion of its healing."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "None",
				"info": {
					"attack": 5,
					"defense": 7,
					"magic": 6,
					"difficulty": 5
				},
				"stats": {
					"hp": 582.52,
					"hpperlevel": 89,
					"mp": 0,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 36,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.75,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61.27,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.8
				},
				"spells": [
					{
						"id": "InfectedCleaverMissileCast",
						"name": "Infected Cleaver",
						"description": "Dr. Mundo hurls his cleaver, dealing damage equal to a portion of his target's current Health and slowing them for a short time. Dr. Mundo delights in the suffering of others, so he is returned half of the Health cost when he successfully lands a cleaver (increased to the full Health cost on killing blows).",
						"tooltip": "Dr. Mundo hurls his cleaver, dealing {{ e2 }}% of the target's current health as magic damage (no less than {{ e1 }}) and slowing them by {{ e4 }}% for {{ e5 }} seconds.<br /><br />If the cleaver hits, {{ f1 }} health is refunded ({{ f2 }} if the cleaver kills).<br /><br /><rules>Infected Cleaver deals no more than {{ e6 }} damage against monsters.</rules>",
						"leveltip": {
							"label": [
								"Cleaver Damage",
								"Damage Minimum",
								"Damage Maximum (vs monsters)",
								"Cost"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e3 }} -> {{ e3NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								50,
								60,
								70,
								80,
								90
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								300,
								350,
								400,
								450,
								500
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/130/180/230/280",
							"15/17.5/20/22.5/25",
							"50/60/70/80/90",
							"40",
							"2",
							"300/350/400/450/500",
							"0.5",
							"1",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Health",
						"maxammo": "-1",
						"range": [
							975,
							975,
							975,
							975,
							975
						],
						"rangeBurn": "975",
						"image": {
							"full": "InfectedCleaverMissileCast.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e3 }} Health"
					},
					{
						"id": "BurningAgony",
						"name": "Burning Agony",
						"description": "Dr. Mundo drains his Health to reduce the duration of disables and deal continual damage to nearby enemies.",
						"tooltip": "<spellActive>Toggle:</spellActive> Dr. Mundo sets himself on fire, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to nearby enemies every second.<br /><br />While on fire, the duration of disables against Dr. Mundo are reduced by {{ e5 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Disable Reduction",
								"Cost"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								325,
								325,
								325,
								325,
								325
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/55/70/85/100",
							"10/15/20/25/30",
							"2",
							"325",
							"10/15/20/25/30",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Health Every Second",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "BurningAgony.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e2 }} Health Every Second"
					},
					{
						"id": "Masochism",
						"name": "Masochism",
						"description": "Dr. Mundo gains bonus attack damage based on his missing health, and his next basic attack headbutts his target for additional damage. Passively increases magic resist whenever Dr. Mundo is dealt magic damage or pays a health cost.",
						"tooltip": "<spellPassive>Passive:</spellPassive> When Dr. Mundo suffers magic damage or pays a health cost, his magic resist is increased by {{ e8 }}% for {{ e0 }} seconds, up to a maximum of {{ f3*100 }}%.<br /><br /><spellActive>Active:</spellActive> Dr. Mundo's next basic attack will headbutt the enemy, dealing an additional <scaleHealth>{{ f1 }}</scaleHealth> physical damage ({{ e1 }}% of maximum health) at the cost of {{ e2 }} health.<br /><br />Upon activation, Dr. Mundo gains up to {{ e4 }} attack damage (no less than {{ e5 }}) for {{ e6 }} seconds based on his missing health.<br /><br /><rules>Masochism grants {{ f2 }} attack damage above the minimum for every 1% of missing health (<scaleHealth>{{ f5 }}</scaleHealth>).",
						"leveltip": {
							"label": [
								"Headbutt Damage",
								"Headbutt Cost",
								"Attack Damage Maximum",
								"Attack Damage Minimum",
								"Magic Resist Maximum"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ f3*100 }}% -> {{ f4*100 }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								3,
								3.5,
								4,
								4.5,
								5
							],
							[
								25,
								35,
								45,
								55,
								65
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								3,
								6,
								9,
								12,
								15
							],
							[
								2,
								2,
								2,
								2,
								2
							]
						],
						"effectBurn": [
							null,
							"3/3.5/4/4.5/5",
							"25/35/45/55/65",
							"25",
							"60/100/140/180/220",
							"30/50/70/90/110",
							"5",
							"0",
							"2",
							"3/6/9/12/15",
							"2"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "Masochism.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "Sadism",
						"name": "Sadism",
						"description": "Dr. Mundo sacrifices a portion of his Health for increased Movement Speed and drastically increased Health Regeneration.",
						"tooltip": "Dr. Mundo regenerates <scaleHealth>{{ f1 }}</scaleHealth> Health ({{ e1 }}% of max health) over {{ e2 }} seconds, and gains {{ e3 }}% movement speed for the duration.",
						"leveltip": {
							"label": [
								"Regeneration",
								"Movement Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							85,
							70
						],
						"cooldownBurn": "100/85/70",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								40,
								50,
								60
							],
							[
								12,
								12,
								12
							],
							[
								15,
								25,
								35
							],
							[
								20,
								20,
								20
							],
							[
								0.015,
								0.015,
								0.015
							],
							[
								5,
								5,
								5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/50/60",
							"12",
							"15/25/35",
							"20",
							"0.01",
							"5",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "% of Current Health",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "Sadism.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e4 }}% of Current Health"
					}
				],
				"passive": {
					"name": "Adrenaline Rush",
					"description": "Dr. Mundo regenerates 0.3% of his maximum Health each second.",
					"image": {
						"full": "DrMundo_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "DrMundo",
						"title": "DrMundoARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "DrMundo",
						"title": "DrMundoCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "DrMundo",
						"title": "DrMundoFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "DrMundo",
						"title": "DrMundoKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "DrMundo",
						"title": "DrMundoSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "DrMundo",
						"title": "DrMundoSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "DrMundo",
						"title": "DrMundoTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Ekko": {
				"id": "Ekko",
				"key": "245",
				"name": "Ekko",
				"title": "the Boy Who Shattered Time",
				"image": {
					"full": "Ekko.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "245000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "245001",
						"num": 1,
						"name": "Sandstorm Ekko",
						"chromas": true
					},
					{
						"id": "245002",
						"num": 2,
						"name": "Academy Ekko",
						"chromas": false
					},
					{
						"id": "245003",
						"num": 3,
						"name": "PROJECT: Ekko",
						"chromas": false
					},
					{
						"id": "245011",
						"num": 11,
						"name": "SKT T1 Ekko",
						"chromas": false
					}
				],
				"lore": "A prodigy from the rough streets of Zaun, Ekko manipulates time to twist any situation to his advantage. Using his own invention, the Zero Drive, he explores the branching possibilities of reality to craft the perfect moment. Though he revels in this freedom, when there's a threat to his friends he'll do anything to defend them. To outsiders, Ekko seems to achieve the impossible the first time, every time.",
				"blurb": "A prodigy from the rough streets of Zaun, Ekko manipulates time to twist any situation to his advantage. Using his own invention, the Zero Drive, he explores the branching possibilities of reality to craft the perfect moment. Though he revels in this...",
				"allytips": [
					"Chronobreak is a potent escape tool, but it can also be quite powerful when used offensively. Don't underestimate its damage potential.",
					"If you can proc Z-Drive Resonance on an enemy champion, it's worth taking risks to do so. The bonus movement speed makes it easy to escape.",
					"Phase Dive's dash is a great tool for setting up Ekko's other abilities. Use it to get double hits with Timewinder or get into position to detonate Parallel Convergence."
				],
				"enemytips": [
					"Ekko is significantly weaker when his ultimate is down. Watch for the trail he leaves behind to determine if Chronobreak is available.",
					"Ekko's stun zone takes 3 seconds to arm. Watch for the image he creates on cast and try to guess where the zone was placed.",
					"The second hit of Timewinder does more damage than the first; try to avoid it."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 3,
					"magic": 7,
					"difficulty": 8
				},
				"stats": {
					"hp": 585,
					"hpperlevel": 85,
					"mp": 280,
					"mpperlevel": 50,
					"movespeed": 340,
					"armor": 32,
					"armorperlevel": 3,
					"spellblock": 32,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9,
					"hpregenperlevel": 0.9,
					"mpregen": 7,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.3
				},
				"spells": [
					{
						"id": "EkkoQ",
						"name": "Timewinder",
						"description": "Ekko throws a temporal grenade that expands into a time-distortion field upon hitting an enemy champion, slowing and damaging anyone caught inside. After a delay, the grenade rewinds back to Ekko, dealing damage on its return.",
						"tooltip": "Ekko throws a device that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies it passes through. It expands into a slowing field on the first champion hit, slowing everything inside by {{ e2 }}%. It then returns to him after a delay, dealing {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to all targets hit upon return.",
						"leveltip": {
							"label": [
								"Outgoing Damage",
								"Return Damage",
								"Slow",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8.5,
							8,
							7.5,
							7
						],
						"cooldownBurn": "9/8.5/8/7.5/7",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								60,
								75,
								90,
								105,
								120
							],
							[
								32,
								39,
								46,
								53,
								60
							],
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								165,
								165,
								165,
								165,
								165
							],
							[
								1.75,
								1.75,
								1.75,
								1.75,
								1.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/75/90/105/120",
							"32/39/46/53/60",
							"40/65/90/115/140",
							"100",
							"0",
							"165",
							"1.75",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "EkkoQ.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EkkoW",
						"name": "Parallel Convergence",
						"description": "Ekko splits the timeline, creating an anomaly after a few seconds that slows enemies caught inside. If Ekko enters the anomaly, he gains shielding and triggers a detonation, stunning enemies by suspending them in time.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Ekko's basic attacks deal bonus magic damage to enemies under 30% health equal to {{ e3 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> of their missing health. Deals a minimum of {{ e6 }} damage, and a maximum of {{ e5 }} damage vs. minions and monsters.<br /><br /><span class=\"colorFF9900\">Active:</span> After a 3 second delay, Ekko creates a short-lived chronosphere at the target location that slows enemies who enter by {{ e0 }}%. If Ekko enters the sphere, he will detonate it, gaining a shield that absorbs up to {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for 2 seconds. Enemies caught inside are stunned for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Shield Amount",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}<"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20,
							18,
							16,
							14
						],
						"cooldownBurn": "22/20/18/16/14",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								375,
								375,
								375,
								375,
								375
							],
							[
								1.75,
								1.75,
								1.75,
								1.75,
								1.75
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								80,
								100,
								120,
								140,
								160
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								40,
								40,
								40,
								40,
								40
							]
						],
						"effectBurn": [
							null,
							"375",
							"1.75",
							"3",
							"80/100/120/140/160",
							"150",
							"15",
							"1.5",
							"3",
							"2",
							"40"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.03,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 1.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1600,
							1600,
							1600,
							1600,
							1600
						],
						"rangeBurn": "1600",
						"image": {
							"full": "EkkoW.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EkkoE",
						"name": "Phase Dive",
						"description": "Ekko rolls evasively while charging up his Z-Drive. His next attack deals bonus damage and warps reality, teleporting him to his target.",
						"tooltip": " Ekko dashes a short distance in the targeted direction. His next attack will deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and teleport him to his target.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8.5,
							8,
							7.5,
							7
						],
						"cooldownBurn": "9/8.5/8/7.5/7",
						"cost": [
							40,
							50,
							60,
							70,
							80
						],
						"costBurn": "40/50/60/70/80",
						"effect": [
							null,
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								350,
								350,
								350,
								350,
								350
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/65/90/115/140",
							"350",
							"3",
							"300",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "EkkoE.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EkkoR",
						"name": "Chronobreak",
						"description": "Ekko shatters his timeline, becoming untargetable and rewinding to a more favorable point in time. He returns to whenever he was a few seconds ago, and heals for a percentage of the damage received in that duration. Enemies near his arrival zone take massive damage.",
						"tooltip": "Ekko turns back time, going briefly untargetable and invulnerable. He teleports to where he was 4 seconds ago and deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies on arrival. Additionally, Ekko heals for {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span>, increased by {{ e5 }}% for each 1% of his health lost over the last 4 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Flat Heal",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							90,
							70
						],
						"cooldownBurn": "110/90/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								300,
								450
							],
							[
								20,
								20,
								20
							],
							[
								100,
								150,
								200
							],
							[
								375,
								375,
								375
							],
							[
								3,
								3,
								3
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/300/450",
							"20",
							"100/150/200",
							"375",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "EkkoR.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Z-Drive Resonance",
					"description": "Ekko's Zero-Drive charges his spells and attacks with temporal energy. The third hit deals bonus damage and, if the target is a champion, Ekko gains accelerated movement speed.",
					"image": {
						"full": "Ekko_P.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ekko",
						"title": "Beginner",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ekko",
						"title": "EkkoTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Elise": {
				"id": "Elise",
				"key": "60",
				"name": "Elise",
				"title": "the Spider Queen",
				"image": {
					"full": "Elise.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "60000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "60001",
						"num": 1,
						"name": "Death Blossom Elise",
						"chromas": false
					},
					{
						"id": "60002",
						"num": 2,
						"name": "Victorious Elise",
						"chromas": false
					},
					{
						"id": "60003",
						"num": 3,
						"name": "Blood Moon Elise",
						"chromas": false
					},
					{
						"id": "60004",
						"num": 4,
						"name": "SKT T1 Elise",
						"chromas": false
					},
					{
						"id": "60005",
						"num": 5,
						"name": "Super Galaxy Elise",
						"chromas": false
					}
				],
				"lore": "Elise is a deadly predator who dwells in a shuttered, lightless palace, deep within the oldest city of Noxus. Once mortal, she was the mistress of a powerful house, but the bite of a vile demigod transformed her into something beautiful, yet utterly inhuman—a spider-like creature, drawing unsuspecting prey into her web. To maintain her eternal youth, Elise now prefers to feed upon the naive and the faithless, and there are few who can resist her seductions.",
				"blurb": "Elise is a deadly predator who dwells in a shuttered, lightless palace, deep within the oldest city of Noxus. Once mortal, she was the mistress of a powerful house, but the bite of a vile demigod transformed her into something beautiful, yet utterly...",
				"allytips": [
					"Spider Form is most effective at finishing off enemies with low health; Human Form's Neurotoxin does more damage to healthy foes. ",
					"When in Spider Form, Spiderlings will attack the target that Elise uses Venomous Bite on. ",
					"Elise's Spider Form and Spider Form abilities do not cost mana and can be prioritized when you are trying to conserve mana."
				],
				"enemytips": [
					"Elise's Spider Form is more dangerous when you are at low health, and her Human Form more potent when you are at high health.",
					"Rappel will only move Elise straight up and down unless she can descend upon an enemy unit.",
					"Rappel has a long cooldown. Elise is vulnerable after she has used it."
				],
				"tags": [
					"Mage",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 5,
					"magic": 7,
					"difficulty": 9
				},
				"stats": {
					"hp": 534,
					"hpperlevel": 85,
					"mp": 324,
					"mpperlevel": 50,
					"movespeed": 325,
					"armor": 27,
					"armorperlevel": 3.35,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.75
				},
				"spells": [
					{
						"id": "EliseHumanQ",
						"name": "Neurotoxin / Venomous Bite",
						"description": "Human Form: Deals damage based upon how high the target's Health is.<br><br>Spider Form: Lunges at an enemy and deals damage based upon how low their Health is.",
						"tooltip": "Deals magic damage equal to {{ e1 }} plus {{ e6 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of the target's current health. Maximum bonus against monsters: {{ e2 }}.",
						"leveltip": {
							"label": [
								"Neurotoxin Damage",
								"Venomous Bite Damage",
								"Max Damage to Monsters",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							80,
							85,
							90,
							95,
							100
						],
						"costBurn": "80/85/90/95/100",
						"effect": [
							null,
							[
								40,
								75,
								110,
								145,
								180
							],
							[
								75,
								100,
								125,
								150,
								175
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								36,
								42,
								48,
								54,
								60
							],
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/75/110/145/180",
							"75/100/125/150/175",
							"15/20/25/30/35",
							"36/42/48/54/60",
							"60/100/140/180/220",
							"4",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.03,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "EliseHumanQ.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EliseHumanW",
						"name": "Volatile Spiderling / Skittering Frenzy",
						"description": "Human Form: Releases a venom-gorged Spiderling that explodes when it nears a target.<br><br>Spider Form: Elise and her Spiderlings gain Attack Speed.",
						"tooltip": "Summons a venom-gorged Spiderling that moves to target location and explodes, dealing {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage when it nears an enemy or after 3 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								55,
								95,
								135,
								175,
								215
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								65,
								75,
								85,
								95,
								105
							],
							[
								275,
								275,
								275,
								275,
								275
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4",
							"60/80/100/120/140",
							"55/95/135/175/215",
							"3",
							"65/75/85/95/105",
							"275",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.95,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "EliseHumanW.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EliseHumanE",
						"name": "Cocoon / Rappel",
						"description": "Human Form: Stuns the first enemy unit hit and reveals them if they are not stealthed.<br><br>Spider Form: Elise and her Spiderlings ascend into the air and then descend upon target enemy.",
						"tooltip": "Stuns the first enemy hit for {{ e5 }} seconds and reveals them if they are not stealthed.",
						"leveltip": {
							"label": [
								"Stun Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								14,
								13,
								12,
								11,
								10
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								26,
								24,
								22,
								20,
								18
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1.6,
								1.7,
								1.8,
								1.9,
								2
							],
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"14/13/12/11/10",
							"15/20/25/30/35",
							"26/24/22/20/18",
							"2",
							"1.6/1.7/1.8/1.9/2",
							"40/55/70/85/100",
							"250",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "EliseHumanE.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EliseR",
						"name": "Spider Form",
						"description": "Transforms into a menacing spider, reducing her attack range in exchange for movement speed, new abilities, and a Spiderling swarm that will attack her foes.",
						"tooltip": "Elise transforms into a menacing spider, sacrificing 425 attack range in exchange for {{ e3 }} movement speed and access to arachnid abilities. All dormant Spiderlings are awakened and will attack nearby foes.<br /><br /><span class=\"colorFF3300\">Spiderlings: </span>Spiderlings deal {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage and take {{ e4 }}% reduced damage from multi-target abilities.",
						"leveltip": {
							"label": [
								"Spider Form Bite Damage",
								"Spiderling Bonus Damage",
								"Maximum Number of Spiderlings",
								"Spiderling Armor",
								"Spiderling Magic Resist"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e7 }} -> {{ e7NL }}"
							]
						},
						"maxrank": 4,
						"cooldown": [
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								10,
								15,
								20,
								25
							],
							[
								10,
								20,
								30,
								40
							],
							[
								25,
								25,
								25,
								25
							],
							[
								25,
								25,
								25,
								25
							],
							[
								2,
								3,
								4,
								5
							],
							[
								30,
								50,
								70,
								90
							],
							[
								50,
								70,
								90,
								110
							],
							[
								4,
								6,
								8,
								10
							],
							[
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/15/20/25",
							"10/20/30/40",
							"25",
							"25",
							"2/3/4/5",
							"30/50/70/90",
							"50/70/90/110",
							"4/6/8/10",
							"0.1",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "EliseR.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Spider Queen",
					"description": "Human Form: When Elise's abilities hit an enemy, she gains a dormant Spiderling.<br><br>Spider Form: Basic attacks deal bonus magic damage and restore health to Elise.",
					"image": {
						"full": "ElisePassive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Elise",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "ItemSmiteAoE",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Elise",
						"title": "EliseTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Evelynn": {
				"id": "Evelynn",
				"key": "28",
				"name": "Evelynn",
				"title": "Agony's Embrace",
				"image": {
					"full": "Evelynn.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "28000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "28001",
						"num": 1,
						"name": "Shadow Evelynn",
						"chromas": false
					},
					{
						"id": "28002",
						"num": 2,
						"name": "Masquerade Evelynn",
						"chromas": false
					},
					{
						"id": "28003",
						"num": 3,
						"name": "Tango Evelynn",
						"chromas": false
					},
					{
						"id": "28004",
						"num": 4,
						"name": "Safecracker Evelynn",
						"chromas": false
					}
				],
				"lore": "Within the dark seams of Runeterra, the demon Evelynn searches for her next victim. She lures in prey with the voluptuous façade of a human female, but once a person succumbs to her charms, Evelynn's true form is unleashed. She then subjects her victim to unspeakable torment, gratifying herself with their pain. To the demon, these liaisons are innocent flings. To the rest of Runeterra, they are ghoulish tales of lust gone awry and horrific reminders of the cost of wanton desire.",
				"blurb": "Within the dark seams of Runeterra, the demon Evelynn searches for her next victim. She lures in prey with the voluptuous façade of a human female, but once a person succumbs to her charms, Evelynn's true form is unleashed. She then subjects her victim...",
				"allytips": [
					"Allure's arm time might seem long, but the Charm and magic resist shred put Evelynn at an exteme advantage so are worth the wait.",
					"While stealthed, pay attention to when you are (near) being detected by enemy champions. This is identified by the glowing yellow and red eyes over nearby enemy champions.",
					"If at low health, you can take advantage of Demon Shade's healing and Camouflage to return to the fight and surprise opponents."
				],
				"enemytips": [
					"Purchasing Vision Wards can help you detect Evelynn's location in order to prepare for her ambushes.",
					"A large share of Evelynn's threat is in her charm, 'Allure.' Protect allies marked with 'Allure' or, if you are marked, make sure allies are between you and where Evelynn may attack from.",
					"If you suspect Evelynn is about to ambush one of your teammates, let them know by pinging the minimap and typing in chat."
				],
				"tags": [
					"Assassin",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 2,
					"magic": 7,
					"difficulty": 10
				},
				"stats": {
					"hp": 572,
					"hpperlevel": 84,
					"mp": 315.6,
					"mpperlevel": 42,
					"movespeed": 335,
					"armor": 37,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.75,
					"mpregen": 8.108,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.1
				},
				"spells": [
					{
						"id": "EvelynnQ",
						"name": "Hate Spike",
						"description": "Evelynn strikes out with her Lasher, dealing damage to the first unit hit. Then, Evelynn can shoot a line of spikes at nearby foes up to 3 times.",
						"tooltip": "Evelynn's Lasher strikes in the target direction, dealing {{ e5 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to the first unit hit and causing Evelynn's next 3 spells or attacks on that unit deal {{ e4 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> bonus magic damage. Then, Evelynn can recast this ability up to 3 times.<br /><br /><span class=\"colorFF9900\">Recast:</span> Fires spikes through the nearest enemy, dealing {{ e5 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to all units hit.<br /><br /><rules><span class=\"color8c8c8c\">Refunds {{ e1 }}% of Hate Spike's cooldown if the Lasher hits a monster. Hate Spike prioritizes the target Evelynn is attacking.</span></rules>",
						"leveltip": {
							"label": [
								"Lasher and Spike Damage",
								"Bonus Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								-0.25,
								-0.25,
								-0.25,
								-0.25,
								-0.25
							]
						],
						"effectBurn": [
							null,
							"60",
							"30",
							"60",
							"10/20/30/40/50",
							"25/30/35/40/45",
							"6",
							"30",
							"50",
							"8",
							"-0.25"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "EvelynnQ.png",
							"sprite": "spell2.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EvelynnW",
						"name": "Allure",
						"description": "Evelynn curses her target, causing her next attack or spell after a delay to charm her target and reduce their magic resist.",
						"tooltip": "Curses target champion or monster for 5 seconds. If Evelynn hits the target with a basic attack or ability, she will expunge the Curse, refund its mana cost, and briefly slow the target by {{ e3 }}%.<br /><br />If the Curse lasts at least 2.5 seconds, expunging it Charms the target for {{ e2 }} second(s) and: <li>Against champions: shreds Magic Resist by {{ e9 }}% for {{ e0 }} seconds.<br />Against monsters: deals {{ e7 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Charm duration increased by {{ e1 }} seconds.</li><br /><rules><span class=\"color8c8c8c\">Casting Allure does not remove Evelynn from Demon Shade.</span></rules>",
						"leveltip": {
							"label": [
								"Charm Duration",
								"Magic Resist Shred",
								"Monster Damage",
								"Cooldown",
								"Cast Range"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e9 }}% -> {{ e9NL }}%",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ f8 }} -> {{ f9 }}",
								"{{ castrange }} -> {{ castrangeNL }}\t"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								65,
								65,
								65,
								65,
								65
							],
							[
								15,
								14,
								13,
								12,
								11
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								250,
								300,
								350,
								400,
								450
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								25,
								27.5,
								30,
								32.5,
								35
							],
							[
								4,
								4,
								4,
								4,
								4
							]
						],
						"effectBurn": [
							null,
							"2",
							"1/1.25/1.5/1.75/2",
							"65",
							"15/14/13/12/11",
							"5",
							"1.5",
							"250/300/350/400/450",
							"0.75",
							"25/27.5/30/32.5/35",
							"4"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1300,
							1400,
							1500,
							1600
						],
						"rangeBurn": "1200/1300/1400/1500/1600",
						"image": {
							"full": "EvelynnW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EvelynnE",
						"name": "Whiplash",
						"description": "Evelynn whips her target with her Lasher, dealing damage. She then gains movement speed for a short duration.",
						"tooltip": "Whip target with Lashers, applying on hit effects and dealing magic damage equal to {{ f1 }} plus {{ e5 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of their max health. Then, gain {{ e3 }}% movement speed for {{ e4 }} seconds.<br /><br />Entering <span class=\"color9542f4\">Demon Shade</span> resets <span class=\"colorFFFFFF\"><i>Whiplash's</i></span> cooldown and empowers it. When empowered, <span class=\"colorFFFFFF\"><i>Whiplash</i></span> pulls Evelynn to her target, dealing magic damage to them and enemies in the way equal to {{ f2 }} plus {{ e6 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> of their max health.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Empowered Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								55,
								70,
								85,
								100,
								115
							],
							[
								95,
								115,
								135,
								155,
								175
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								0.5,
								0.6,
								0.7,
								0.8,
								0.9
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0.9,
								1.05,
								1.2,
								1.35,
								1.5
							]
						],
						"effectBurn": [
							null,
							"55/70/85/100/115",
							"95/115/135/155/175",
							"30",
							"2",
							"3",
							"4",
							"450",
							"0.5/0.6/0.7/0.8/0.9",
							"2",
							"0.9/1.05/1.2/1.35/1.5"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.4,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.015,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.025,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							210,
							210,
							210,
							210,
							210
						],
						"rangeBurn": "210",
						"image": {
							"full": "EvelynnE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EvelynnR",
						"name": "Last Caress",
						"description": "Evelynn briefly goes untargetable and decimates the area in front of her before warping backwards a long distance.",
						"tooltip": "Evelynn unleashes her demonic energy, becoming untargetable and decimating enemies in front of her. She then warps backwards. Deals {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage, increased to {{ f1 }}<span class=\"color99FF99\"> (+{{ f2 }})</span> to enemies below {{ e7 }}% health.",
						"leveltip": {
							"label": [
								"Damage",
								"Empowered Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							110,
							80
						],
						"cooldownBurn": "140/110/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								300,
								550,
								800
							],
							[
								1,
								1,
								1
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								150,
								225,
								300
							],
							[
								3,
								3,
								3
							],
							[
								5,
								4,
								3
							],
							[
								30,
								30,
								30
							],
							[
								700,
								700,
								700
							],
							[
								30,
								45,
								60
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"300/550/800",
							"1",
							"2.5",
							"150/225/300",
							"3",
							"5/4/3",
							"30",
							"700",
							"30/45/60",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "EvelynnR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Demon Shade",
					"description": "When out of combat, Evelynn enters Demon Shade. Demon Shade heals Evelynn when she is low on health and grants Camouflage after level 6.",
					"image": {
						"full": "Evelynn_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Evelynn",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standardjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "kingporosnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeoffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegedefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1082",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Evelynn",
						"title": "EvelynnTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Ezreal": {
				"id": "Ezreal",
				"key": "81",
				"name": "Ezreal",
				"title": "the Prodigal Explorer",
				"image": {
					"full": "Ezreal.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "81000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "81001",
						"num": 1,
						"name": "Nottingham Ezreal",
						"chromas": false
					},
					{
						"id": "81002",
						"num": 2,
						"name": "Striker Ezreal",
						"chromas": false
					},
					{
						"id": "81003",
						"num": 3,
						"name": "Frosted Ezreal",
						"chromas": false
					},
					{
						"id": "81004",
						"num": 4,
						"name": "Explorer Ezreal",
						"chromas": false
					},
					{
						"id": "81005",
						"num": 5,
						"name": "Pulsefire Ezreal",
						"chromas": false
					},
					{
						"id": "81006",
						"num": 6,
						"name": "TPA Ezreal",
						"chromas": false
					},
					{
						"id": "81007",
						"num": 7,
						"name": "Debonair Ezreal",
						"chromas": true
					},
					{
						"id": "81008",
						"num": 8,
						"name": "Ace of Spades Ezreal",
						"chromas": false
					},
					{
						"id": "81009",
						"num": 9,
						"name": "Arcade Ezreal",
						"chromas": false
					},
					{
						"id": "81018",
						"num": 18,
						"name": "Star Guardian Ezreal",
						"chromas": false
					}
				],
				"lore": "A self-assured Piltovan explorer with an uncanny ability to find his way into and out of trouble, Ezreal travels Runeterra in search of adventure. Armed with a magical gauntlet procured from the ruins of ancient Shurima, he seeks out the world's most cryptic mysteries. Ezreal fires bolts of mystic energy, shifting through treacherous, uncharted places with a cocky grin on his face.",
				"blurb": "A self-assured Piltovan explorer with an uncanny ability to find his way into and out of trouble, Ezreal travels Runeterra in search of adventure. Armed with a magical gauntlet procured from the ruins of ancient Shurima, he seeks out the world's most...",
				"allytips": [
					"Use Arcane Shift to help line up your other skill shots.",
					"You can play Ezreal either as a Attack Damage carry or Ability Power carry depending on how you build him.",
					"You can line up Trueshot Barrage to hit multiple minion waves or even Monsters."
				],
				"enemytips": [
					"Ezreal is a very fragile champion so take the fight to him.",
					"Ezreal is completely skill shot based, so make sure to keep minions in between you.",
					"Mystic Shot applies on-hit effects including the Crest of Cinders."
				],
				"tags": [
					"Marksman",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 2,
					"magic": 6,
					"difficulty": 7
				},
				"stats": {
					"hp": 484.4,
					"hpperlevel": 80,
					"mp": 360.6,
					"mpperlevel": 42,
					"movespeed": 325,
					"armor": 31,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6.5,
					"hpregenperlevel": 0.55,
					"mpregen": 8.092,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.5
				},
				"spells": [
					{
						"id": "EzrealMysticShot",
						"name": "Mystic Shot",
						"description": "Ezreal fires a damaging bolt of energy which reduces all of his cooldowns by 1.5 seconds if it strikes an enemy unit.",
						"tooltip": "Ezreal fires a bolt of energy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> physical damage (applies on-hit effects). <br /><br />Ezreal's cooldowns are reduced by {{ e2 }} seconds if Mystic Shot hits a target.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5.5,
							5.25,
							5,
							4.75,
							4.5
						],
						"cooldownBurn": "5.5/5.25/5/4.75/4.5",
						"cost": [
							28,
							31,
							34,
							37,
							40
						],
						"costBurn": "28/31/34/37/40",
						"effect": [
							null,
							[
								15,
								40,
								65,
								90,
								115
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/40/65/90/115",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.1,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1150,
							1150,
							1150,
							1150,
							1150
						],
						"rangeBurn": "1150",
						"image": {
							"full": "EzrealMysticShot.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EzrealEssenceFlux",
						"name": "Essence Flux",
						"description": "Ezreal fires a fluctuating wave of energy, dealing magic damage to enemy champions, while increasing the Attack Speed of allied champions.",
						"tooltip": "Ezreal fires a wave of energy that damages all enemy champions it passes through for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. If Ezreal or his Allied champions are hit by the wave, their Attack Speed is increased by {{ e2 }}% for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Speed",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }}% -> {{ e2NL }}%",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"20/25/30/35/40",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "EzrealEssenceFlux.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EzrealArcaneShift",
						"name": "Arcane Shift",
						"description": "Ezreal teleports to a target nearby location and fires a homing bolt which strikes the nearest enemy unit.",
						"tooltip": "Ezreal teleports to a nearby location and fires a bolt at the nearest enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							19,
							17.5,
							16,
							14.5,
							13
						],
						"cooldownBurn": "19/17.5/16/14.5/13",
						"cost": [
							90,
							90,
							90,
							90,
							90
						],
						"costBurn": "90",
						"effect": [
							null,
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/130/180/230/280",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							475,
							475,
							475,
							475,
							475
						],
						"rangeBurn": "475",
						"image": {
							"full": "EzrealArcaneShift.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EzrealTrueshotBarrage",
						"name": "Trueshot Barrage",
						"description": "Ezreal winds up for 1 second to fire a powerful barrage of energy missiles which do massive damage to each unit they pass through (deals 10% less damage to each unit it passes through).",
						"tooltip": "Ezreal winds up for 1 second to fire a long range missile that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to each enemy it passes through. Deals {{ e2 }}% less damage for each enemy hit (minimum {{ e3 }}%).",
						"leveltip": {
							"label": [
								"Damage"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							120,
							120
						],
						"cooldownBurn": "120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								350,
								500,
								650
							],
							[
								10,
								10,
								10
							],
							[
								30,
								30,
								30
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"350/500/650",
							"10",
							"30",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20000,
							20000,
							20000
						],
						"rangeBurn": "20000",
						"image": {
							"full": "EzrealTrueshotBarrage.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Rising Spell Force",
					"description": "Ezreal gains increasing Attack Speed each time he successfully hits a spell, stacking up to 5 times.",
					"image": {
						"full": "Ezreal_RisingSpellForce.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ezreal",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3008",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3008",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3008",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ezreal",
						"title": "EzrealTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3034",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Fiddlesticks": {
				"id": "Fiddlesticks",
				"key": "9",
				"name": "Fiddlesticks",
				"title": "the Harbinger of Doom",
				"image": {
					"full": "Fiddlesticks.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "9000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "9001",
						"num": 1,
						"name": "Spectral Fiddlesticks",
						"chromas": false
					},
					{
						"id": "9002",
						"num": 2,
						"name": "Union Jack Fiddlesticks",
						"chromas": false
					},
					{
						"id": "9003",
						"num": 3,
						"name": "Bandito Fiddlesticks",
						"chromas": false
					},
					{
						"id": "9004",
						"num": 4,
						"name": "Pumpkinhead Fiddlesticks",
						"chromas": false
					},
					{
						"id": "9005",
						"num": 5,
						"name": "Fiddle Me Timbers",
						"chromas": false
					},
					{
						"id": "9006",
						"num": 6,
						"name": "Surprise Party Fiddlesticks",
						"chromas": false
					},
					{
						"id": "9007",
						"num": 7,
						"name": "Dark Candy Fiddlesticks",
						"chromas": false
					},
					{
						"id": "9008",
						"num": 8,
						"name": "Risen Fiddlesticks",
						"chromas": false
					}
				],
				"lore": "Fiddlesticks is a ghastly, living scarecrow who stalks the darkness, wielding a cruel scythe and preying upon the unwary. Once a lonely man accused of bringing famine to his village, he was tied up and left to starve in his own barren field. Resurrected by the savage murder of crows that fed on his remains, Fiddlesticks now relishes terrorizing his victims before claiming their lives amid a flurry of feathers and blood-splattered beaks.",
				"blurb": "Fiddlesticks is a ghastly, living scarecrow who stalks the darkness, wielding a cruel scythe and preying upon the unwary. Once a lonely man accused of bringing famine to his village, he was tied up and left to starve in his own barren field. Resurrected...",
				"allytips": [
					"Use Dark Wind to rack up many minion kills, and try to use Drain on minions to get the maximum health drain.",
					"Use Terrify on enemies before starting up Crowstorm or Drain to ensure maximum damage.",
					"Fiddlesticks is very fragile if you build AP items. Try to strike a balance between offense and defense with runes, masteries, and items."
				],
				"enemytips": [
					"Avoid attacking while close to your allies. Dark Wind will bounce between you and your allies, increasing its damage.",
					"If Fiddlesticks has used Crowstorm, try casting a stun or slow and moving out of range until the spell dissipates.",
					"If Fiddlesticks is nowhere to be seen, watch out for an ambush Crowstorm from brush."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 3,
					"magic": 9,
					"difficulty": 9
				},
				"stats": {
					"hp": 524.4,
					"hpperlevel": 80,
					"mp": 400.12,
					"mpperlevel": 56,
					"movespeed": 335,
					"armor": 30,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 480,
					"hpregen": 5.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 48.36,
					"attackdamageperlevel": 2.625,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.11
				},
				"spells": [
					{
						"id": "Terrify",
						"name": "Terrify",
						"description": "Strikes a target unit with fear, causing it to flee in terror for a duration.",
						"tooltip": "Terrifies a target, causing it to flee from Fiddlesticks for {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							14,
							13,
							12,
							11
						],
						"cooldownBurn": "15/14/13/12/11",
						"cost": [
							65,
							65,
							65,
							65,
							65
						],
						"costBurn": "65",
						"effect": [
							null,
							[
								1.25,
								1.5,
								1.75,
								2,
								2.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.25/1.5/1.75/2/2.25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							575,
							575,
							575,
							575,
							575
						],
						"rangeBurn": "575",
						"image": {
							"full": "Terrify.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Drain",
						"name": "Drain",
						"description": "Fiddlesticks saps the life force of an enemy, dealing damage to a target over time and healing himself.",
						"tooltip": "Fiddlesticks creates a tether to the target unit and channels <span class=\"colorFFEB7F\">Drain</span> on it, granting <span class=\"coloree91d7\">True Sight</span> and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to the target. Fiddlesticks heals for {{ e3 }}% of the damage dealt.<br /><br /><span class=\"colorFFEB7F\">Drain</span> lasts up to {{ e4 }} seconds, dealing a total of {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> damage.<br /><br /><span class=\"size16 color8C8C8C\"><span class=\"size16 colorFFEB7F\">Drain</span> <span class=\"size16 color8C8C8C\">returns cooldown equal to its remaining duration if the target dies.</span>",
						"leveltip": {
							"label": [
								"Damage Per Second",
								"Cooldown",
								"Mana Cost",
								"Drain Ratio"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							3.75,
							3.5,
							3.25,
							3
						],
						"cooldownBurn": "4/3.75/3.5/3.25/3",
						"cost": [
							80,
							90,
							100,
							110,
							120
						],
						"costBurn": "80/90/100/110/120",
						"effect": [
							null,
							[
								80,
								105,
								130,
								155,
								180
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								60,
								65,
								70,
								75,
								80
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								650,
								650,
								650,
								650,
								650
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/105/130/155/180",
							"4",
							"60/65/70/75/80",
							"5",
							"650",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							575,
							575,
							575,
							575,
							575
						],
						"rangeBurn": "575",
						"image": {
							"full": "Drain.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FiddlesticksDarkWind",
						"name": "Dark Wind",
						"description": "A wisp of wind strikes an enemy unit and then bounces to nearby enemy units, dealing damage and silencing the victims.",
						"tooltip": "Unleashes a Crow at the targeted enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage before bouncing to another target. Units struck are also silenced for {{ e2 }} seconds the first time per cast.<br /><br />Dark Wind can strike up to {{ e3 }} times and will prioritize enemies being <span class=\"colorFFEB7F\">Drained</span> or ones it has not yet hit. Deals {{ e4 }}% damage to monsters.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								65,
								85,
								105,
								125,
								145
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/85/105/125/145",
							"1.25",
							"6",
							"200",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "FiddlesticksDarkWind.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Crowstorm",
						"name": "Crowstorm",
						"description": "A murder of crows flock wildly around Fiddlesticks, dealing damage per second to all enemy units in the area.",
						"tooltip": "Fiddlesticks channels for {{ e3 }} seconds, then blinks to the target point unleashing a murder of crows that flock wildly around him, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to all enemy units in the area.<br /><br />The effect lasts for {{ e2 }} seconds, dealing up to {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> total magic damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							110,
							80
						],
						"cooldownBurn": "140/110/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								125,
								225,
								325
							],
							[
								5,
								5,
								5
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"125/225/325",
							"5",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "Crowstorm.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Dread",
					"description": "Standing still or channeling abilities for 1.5 seconds empowers Fiddlesticks with Dread. Immobilizing crowd control resets this timer.<br><br>Dread grants Movement Speed, but only lasts for 1.5s after Fiddlesticks starts moving.",
					"image": {
						"full": "Fiddlesticks_Passive.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "FiddleSticks",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "FiddleSticks",
						"title": "FiddleARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiddlesticks",
						"title": "FiddlesticksCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "FiddleSticks",
						"title": "FiddleFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiddlesticks",
						"title": "FiddlesticksKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiddlesticks",
						"title": "FiddlesticksSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "FiddleSticks",
						"title": "FiddleSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "TeleportCancel",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "FiddleSticks",
						"title": "FiddleTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Fiora": {
				"id": "Fiora",
				"key": "114",
				"name": "Fiora",
				"title": "the Grand Duelist",
				"image": {
					"full": "Fiora.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "114000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "114001",
						"num": 1,
						"name": "Royal Guard Fiora",
						"chromas": false
					},
					{
						"id": "114002",
						"num": 2,
						"name": "Nightraven Fiora",
						"chromas": false
					},
					{
						"id": "114003",
						"num": 3,
						"name": "Headmistress Fiora",
						"chromas": true
					},
					{
						"id": "114004",
						"num": 4,
						"name": "PROJECT: Fiora",
						"chromas": false
					},
					{
						"id": "114005",
						"num": 5,
						"name": "Pool Party Fiora",
						"chromas": true
					},
					{
						"id": "114022",
						"num": 22,
						"name": "Soaring Sword Fiora",
						"chromas": false
					}
				],
				"lore": "The most feared duelist in all Valoran, Fiora is as renowned for her brusque manner and cunning mind as she is for the speed of her bluesteel rapier. Born to House Laurent in the kingdom of Demacia, Fiora took control of the family from her father in the wake of a scandal that nearly destroyed them. House Laurent's reputation was sundered, but Fiora bends her every effort to restore her family's honor and return them to their rightful place among the great and good of Demacia.",
				"blurb": "The most feared duelist in all Valoran, Fiora is as renowned for her brusque manner and cunning mind as she is for the speed of her bluesteel rapier. Born to House Laurent in the kingdom of Demacia, Fiora took control of the family from her father in...",
				"allytips": [
					"Thanks to Duelist's Dance, Fiora excels at quick trades. Use the movement speed boost from striking a Vital to escape unscathed or set up for the next one.",
					"Grand Challenge allows Fiora to take down even the most durable opponents and then recover if successful, so do not hesitate to attack the enemy's front line."
				],
				"enemytips": [
					"Duelist's Dance shows you where Fiora will try to attack from, so be ready to punish her when she tries.",
					"Be careful when casting immobilizing disables on Fiora. If her Riposte is available, she can turn their power against you."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 10,
					"defense": 4,
					"magic": 2,
					"difficulty": 3
				},
				"stats": {
					"hp": 550,
					"hpperlevel": 85,
					"mp": 300,
					"mpperlevel": 40,
					"movespeed": 345,
					"armor": 33,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 150,
					"hpregen": 8.5,
					"hpregenperlevel": 0.55,
					"mpregen": 8,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.2
				},
				"spells": [
					{
						"id": "FioraQ",
						"name": "Lunge",
						"description": "Fiora lunges in a direction and stabs a nearby enemy, dealing physical damage and applying on-hit effects.",
						"tooltip": "Fiora lunges in a direction and stabs a nearby enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and applying on-hit effects. This attack prioritizes <span class=\"colorD4BD22\">Vitals</span> and enemies it will kill.<br /><br />If this ability hits an enemy, {{ e4 }}% of its cooldown is refunded. ",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus AD Ratio",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }}  -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14,
							12,
							10,
							8
						],
						"cooldownBurn": "16/14/12/10/8",
						"cost": [
							20,
							25,
							30,
							35,
							40
						],
						"costBurn": "20/25/30/35/40",
						"effect": [
							null,
							[
								70,
								80,
								90,
								100,
								110
							],
							[
								0.95,
								1,
								1.05,
								1.1,
								1.15
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								90,
								120,
								150,
								180,
								210
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/80/90/100/110",
							"0.95/1/1.05/1.1/1.15",
							"50",
							"60",
							"2.5",
							"2",
							"90/120/150/180/210",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "FioraQ.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FioraW",
						"name": "Riposte",
						"description": "Fiora parries all incoming damage and disables for a short time, then stabs in a direction. This stab slows the first enemy champion hit, or stuns them if Fiora blocked an immobilizing effect with this ability.",
						"tooltip": "Fiora parries all incoming damage, debuffs, and disables for the next {{ e2 }} seconds and then stabs in the target direction.<br /><br />The stab deals {{ e1 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage to the first enemy champion hit and slows their movement and attack speed by {{ e4 }}% for {{ e3 }} seconds. <br /><br />If Fiora parries an immobilizing effect, Riposte stuns instead of slowing.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f2 }} -> {{ f3 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								90,
								130,
								170,
								210,
								250
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0.03,
								0.03,
								0.03,
								0.03,
								0.03
							],
							[
								0.15,
								0.15,
								0.15,
								0.15,
								0.25
							],
							[
								24,
								22,
								20,
								18,
								16
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"90/130/170/210/250",
							"0.75",
							"1.5",
							"50",
							"0.03",
							"0.15/0.15/0.15/0.15/0.25",
							"24/22/20/18/16",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "FioraW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FioraE",
						"name": "Bladework",
						"description": "Fiora has increased attack speed for the next two attacks. The first attack slows the target, and the second attack will critically strike.",
						"tooltip": "Fiora gains {{ e4 }}% attack speed for her next two attacks. The first attack cannot critically strike, but will apply a {{ e3 }}% slow for {{ e2 }} second. The second attack is guaranteed to critically strike for {{ f4 }}% damage <span class=\"colorFF8C00\">({{ f3 }})</span>.",
						"leveltip": {
							"label": [
								"Critical Strike Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ f4 }}%  -> {{ f5 }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							11,
							9,
							7,
							5
						],
						"cooldownBurn": "13/11/9/7/5",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								140,
								155,
								170,
								185,
								200
							],
							[
								5,
								10,
								15,
								20,
								25
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								10,
								12.5,
								15,
								17.5,
								20
							],
							[
								20,
								20,
								20,
								20,
								20
							]
						],
						"effectBurn": [
							null,
							"3",
							"1",
							"30",
							"50",
							"100",
							"140/155/170/185/200",
							"5/10/15/20/25",
							"40/50/60/70/80",
							"10/12.5/15/17.5/20",
							"20"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							425,
							425,
							425,
							425,
							425
						],
						"rangeBurn": "425",
						"image": {
							"full": "FioraE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FioraR",
						"name": "Grand Challenge",
						"description": "Fiora reveals all four Vitals on an enemy champion and gains movement speed while near them. If Fiora hits all 4 Vitals or if the target dies after she has hit at least one, Fiora and her allies in the area are healed over the next few seconds.",
						"tooltip": "Fiora reveals all four <span class=\"colorD4BD22\">Vitals</span> on target champion, for a potential <span class=\"colorFFFFFF\">{{ f8 }}%</span> max health true damage. In addition, Fiora gains Duelist's Dance's movement speed bonus <span class=\"colorFFFFFF\">({{ f6 }}%)</span> while near the target.<br /><br />If Fiora hits all 4 <span class=\"colorD4BD22\">Vitals</span> in {{ e1 }} seconds or if the target dies after she has hit at least one, Fiora and her allies in the area are healed for {{ e7 }} <span class=\"colorFF8C00\">(+{{ f9 }})</span> each second for between {{ e9 }} to {{ e6 }} seconds, scaling with the amount of Vitals hit.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Duelist Movement Speed",
								"Heal Per Second"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e7 }} -> {{ e7NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							90,
							70
						],
						"cooldownBurn": "110/90/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								8,
								8,
								8
							],
							[
								30,
								40,
								50
							],
							[
								0,
								0,
								0
							],
							[
								30,
								45,
								60
							],
							[
								500,
								500,
								500
							],
							[
								5,
								5,
								5
							],
							[
								80,
								110,
								140
							],
							[
								550,
								550,
								550
							],
							[
								2,
								2,
								2
							],
							[
								1,
								1,
								1
							]
						],
						"effectBurn": [
							null,
							"8",
							"30/40/50",
							"0",
							"30/45/60",
							"500",
							"5",
							"80/110/140",
							"550",
							"2",
							"1"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "FioraR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Duelist's Dance",
					"description": "Fiora challenges nearby enemy Champions to dodge her. She calls out a direction from which she will try to strike. If she can complete her own challenge, she receives a small bonus and calls out a new direction.",
					"image": {
						"full": "Fiora_P.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Fiora",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fiora",
						"title": "FioraTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Fizz": {
				"id": "Fizz",
				"key": "105",
				"name": "Fizz",
				"title": "the Tidal Trickster",
				"image": {
					"full": "Fizz.png",
					"sprite": "champion0.png",
					"group": "champion",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "105000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "105001",
						"num": 1,
						"name": "Atlantean Fizz",
						"chromas": false
					},
					{
						"id": "105002",
						"num": 2,
						"name": "Tundra Fizz",
						"chromas": false
					},
					{
						"id": "105003",
						"num": 3,
						"name": "Fisherman Fizz",
						"chromas": false
					},
					{
						"id": "105004",
						"num": 4,
						"name": "Void Fizz",
						"chromas": false
					},
					{
						"id": "105008",
						"num": 8,
						"name": "Cottontail Fizz",
						"chromas": false
					},
					{
						"id": "105009",
						"num": 9,
						"name": "Super Galaxy Fizz",
						"chromas": false
					},
					{
						"id": "105010",
						"num": 10,
						"name": "Omega Squad Fizz",
						"chromas": true
					}
				],
				"lore": "Fizz is an amphibious yordle, who dwells among the reefs surrounding Bilgewater. He often retrieves and returns the tithes cast into the sea by superstitious captains, but even the saltiest of sailors know better than to cross him—many are the tales of those who have underestimated this slippery character. Often mistaken for some manner of capricious ocean spirit, he commands the huge, carnivorous beasts of the deep, and delights in confounding his allies and enemies alike.",
				"blurb": "Fizz is an amphibious yordle, who dwells among the reefs surrounding Bilgewater. He often retrieves and returns the tithes cast into the sea by superstitious captains, but even the saltiest of sailors know better than to cross him—many are the tales of...",
				"allytips": [
					"Since Fizz can move through units, find opportunities in lane to walk through minions and apply Seastone Trident's passive - following it up with the ability's active attack after a few seconds.",
					"Fizz's ultimate ability, Chum the Waters, can be aimed at an enemy or towards the area where you think they'll be going.",
					"Fizz's spells scale off Ability Power - consider getting items like Zhonya's Hourglass or Banshee's Veil against teams that have high burst threat - and items like Lich Bane or Rabadon's Deathcap if you think you can survive without the Health."
				],
				"enemytips": [
					"Fizz becomes extremely deadly if his damage over time ability ticks on you for a few seconds - keep him away until it falls off!",
					"Fizz is a slippery target when his abilities are not on cooldown - bait him into using them early and follow up with crowd control or hard-hitting attacks!"
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 4,
					"magic": 7,
					"difficulty": 6
				},
				"stats": {
					"hp": 570,
					"hpperlevel": 98,
					"mp": 317.2,
					"mpperlevel": 37,
					"movespeed": 335,
					"armor": 22.412,
					"armorperlevel": 3.4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.7,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 58.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3.1
				},
				"spells": [
					{
						"id": "FizzQ",
						"name": "Urchin Strike",
						"description": "Fizz dashes through his target, dealing magic damage and applying on hit effects.",
						"tooltip": "Fizz dashes through his target, dealing <span class=\"colorFF8C00\">{{ a2 }}</span> physical damage plus {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. This spell applies on-hit effects. <br /><br /><span class=\"size16 colorFFEB7F\">Seastone Trident</span> <span class=\"size16 color8C8C8C\">is applied to all enemy units Fizz passes through during his dash.</span>",
						"leveltip": {
							"label": [
								"Magic Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7.5,
							7,
							6.5,
							6
						],
						"cooldownBurn": "8/7.5/7/6.5/6",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								10,
								25,
								40,
								55,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								650,
								750,
								850,
								950,
								1050
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.35,
								0.35,
								0.35,
								0.35,
								0.35
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/25/40/55/70",
							"0",
							"650/750/850/950/1050",
							"1.5",
							"600",
							"1",
							"0.35",
							"40",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.55,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "FizzQ.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FizzW",
						"name": "Seastone Trident",
						"description": "Fizz's attacks bleed his enemies, dealing magic damage over several seconds. Fizz can empower his next attack to deal bonus damage, increased by how long the bleed was active on his target.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Fizz's basic attacks bleed his enemies, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage over {{ e8 }} seconds. <br /><br /><span class=\"colorFF9900\">Active: </span>Fizz's next basic attack deals {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus magic damage. If the target has been bleeding for at least {{ e7 }} seconds, this bonus increases to {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span>. <br /><br /><span class=\"size16 color8C8C8C\">If the Active kills a target it refunds {{ e2 }} mana and resets its cooldown to {{ e0 }} second.</span>",
						"leveltip": {
							"label": [
								"Passive / Active Damage",
								"Charged Active Damage",
								"Cooldown",
								"Mana Cost",
								"Mana Refund"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9.5,
							9,
							8.5,
							8
						],
						"cooldownBurn": "10/9.5/9/8.5/8",
						"cost": [
							30,
							40,
							50,
							60,
							70
						],
						"costBurn": "30/40/50/60/70",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								20,
								28,
								36,
								42,
								50
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								750,
								750,
								750,
								750,
								750
							],
							[
								1,
								1,
								1,
								1,
								1
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"20/28/36/42/50",
							"60/90/120/150/180",
							"6",
							"2",
							"4",
							"2",
							"3",
							"750",
							"1"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 1.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "FizzW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FizzE",
						"name": "Playful / Trickster",
						"description": "Fizz hops into the air, landing gracefully upon his spear and becoming untargetable. From this position, Fizz can either slam the ground or choose to jump again before smashing back down.",
						"tooltip": "Fizz hops on his trident towards the cursor, becoming briefly untargetable.<br /><br /><span class=\"colorFF9900\">Reactivation: </span>Fizz cancels the spell early, jumping towards the cursor a second time and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies.<br /><br />If Fizz does not reactivate, he deals damage in a larger area and slows all enemies hit by {{ e2 }}% for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Percentage",
								"Mana Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14.5,
							13,
							11.5,
							10
						],
						"cooldownBurn": "16/14.5/13/11.5/10",
						"cost": [
							90,
							95,
							100,
							105,
							110
						],
						"costBurn": "90/95/100/105/110",
						"effect": [
							null,
							[
								70,
								120,
								170,
								220,
								270
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								375,
								375,
								375,
								375,
								375
							],
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/120/170/220/270",
							"40/45/50/55/60",
							"225",
							"2",
							"375",
							"80",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "FizzE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "FizzR",
						"name": "Chum the Waters",
						"description": "Fizz tosses a fish in a direction that attaches to any champion that touches it, slowing the target. After a short delay, a shark erupts from the ground, knocking up the target and knocking any nearby enemies aside. All enemies hit are dealt magic damage and slowed.",
						"tooltip": "Fizz launches a fish that attaches to the first enemy champion it hits, slowing them, granting <span class=\"coloree91d7\">True Sight</span>, and attracting a shark. After {{ e8 }} seconds, the shark erupts out of the ground, knocking its target up and knocking other enemies aside.<br /><br />The farther the fish travels before attaching, the bigger the shark it attracts, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and slowing by 40% to 80%.<br /><br /><span class=\"size16 colorFFEB7F\">Seastone Trident</span> <span class=\"size16 color8C8C8C\">applies to the champion the fish attaches to and targets hit by the shark.",
						"leveltip": {
							"label": [
								"Small Shark Damage",
								"Medium Shark Damage",
								"Big Shark Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} ->{{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							85,
							70
						],
						"cooldownBurn": "100/85/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								225,
								325,
								425
							],
							[
								300,
								400,
								500
							],
							[
								200,
								200,
								200
							],
							[
								325,
								325,
								325
							],
							[
								450,
								450,
								450
							],
							[
								1300,
								1300,
								1300
							],
							[
								2,
								2,
								2
							],
							[
								2,
								2,
								2
							],
							[
								60,
								60,
								60
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"225/325/425",
							"300/400/500",
							"200",
							"325",
							"450",
							"1300",
							"2",
							"2",
							"60"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 1.2,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1300,
							1300,
							1300
						],
						"rangeBurn": "1300",
						"image": {
							"full": "FizzR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Nimble Fighter",
					"description": "Fizz's dexterity allows him to move through units and take less physical damage from basic attacks.",
					"image": {
						"full": "Fizz_P.png",
						"sprite": "passive0.png",
						"group": "passive",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Fizz",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3100",
										"count": 1
									},
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1414",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Fizz",
						"title": "FizzTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Galio": {
				"id": "Galio",
				"key": "3",
				"name": "Galio",
				"title": "the Colossus",
				"image": {
					"full": "Galio.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "3000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "3001",
						"num": 1,
						"name": "Enchanted Galio",
						"chromas": false
					},
					{
						"id": "3002",
						"num": 2,
						"name": "Hextech Galio",
						"chromas": false
					},
					{
						"id": "3003",
						"num": 3,
						"name": "Commando Galio",
						"chromas": false
					},
					{
						"id": "3004",
						"num": 4,
						"name": "Gatekeeper Galio",
						"chromas": false
					},
					{
						"id": "3005",
						"num": 5,
						"name": "Debonair Galio",
						"chromas": false
					}
				],
				"lore": "Outside the gleaming city of Demacia, the stone colossus Galio keeps vigilant watch. Built as a bulwark against enemy mages, he often stands motionless for decades until the presence of powerful magic stirs him to life. Once activated, Galio makes the most of his time, savoring the thrill of a fight and the rare honor of defending his countrymen. But his triumphs are always bittersweet, for the magic he destroys is also his source of reanimation, and each victory leaves him dormant once again.",
				"blurb": "Outside the gleaming city of Demacia, the stone colossus Galio keeps vigilant watch. Built as a bulwark against enemy mages, he often stands motionless for decades until the presence of powerful magic stirs him to life. Once activated, Galio makes the...",
				"allytips": [
					"You can release Shield of Durand even while crowd controlled.",
					"You can use the minimap ally icons to cast Hero's Entrance.",
					"You can use the step back from Justice Punch to dodge enemy spells."
				],
				"enemytips": [
					"Galio moves slower when he is charging Shield of Durand.",
					"Hero's Entrance can be interrupted before Galio jumps into the air.",
					"Galio cannot traverse walls with Justice Punch."
				],
				"tags": [
					"Tank",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 10,
					"magic": 6,
					"difficulty": 5
				},
				"stats": {
					"hp": 562,
					"hpperlevel": 112,
					"mp": 400,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 24,
					"armorperlevel": 3.5,
					"spellblock": 32,
					"spellblockperlevel": 1.25,
					"attackrange": 150,
					"hpregen": 8,
					"hpregenperlevel": 0.8,
					"mpregen": 7,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 59,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.5
				},
				"spells": [
					{
						"id": "GalioQ",
						"name": "Winds of War",
						"description": "Galio fires two windblasts that converge into a large tornado.",
						"tooltip": "Galio fires two windblasts that deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />When the windblasts meet, they combine into a giant tornado that deals {{ e5 }} <span class=\"color99FF99\">(+{{ charabilitypower2.0*3 }})</span> plus <span class=\"color99FF99\">(+{{ f9 }})</span>% of enemies' maximum Health (max {{ e4 }} vs. monsters) as magic damage over {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Windblast Damage",
								"Tornado Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								50,
								80,
								110,
								140,
								170
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								30,
								40.002,
								50.001,
								60,
								70.002
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/80/110/140/170",
							"1",
							"1.5",
							"150",
							"30/40.002/50.001/60/70.002",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							825,
							825,
							825,
							825,
							825
						],
						"rangeBurn": "825",
						"image": {
							"full": "GalioQ.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GalioW",
						"name": "Shield of Durand",
						"description": "Galio charges a defensive stance, moving slowly. Upon releasing the charge, Galio will taunt and damage nearby enemies.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> After not taking damage for {{ e6 }} seconds Galio gains a shield that absorbs <span class=\"colorFF0000\">{{ f3 }}</span> magic damage.<br /><br /><span class=\"colorFF9900\">First Cast:</span> Galio starts to charge, gaining {{ e1 }} <span class=\"colorFF00FF\">(+{{ f2 }})</span><span class=\"color99FF99\">(+{{ f4 }})</span>% Damage Reduction from Magic Damage and {{ f5 }}% of that amount as Damage Reduction from Physical Damage. While charging, Galio slows himself by {{ e3 }}%.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Galio taunts nearby enemy champions for {{ e4 }} to {{ e7 }} seconds, deals {{ f8 }} <span class=\"color99FF99\">(+{{ f9 }})</span> to {{ f10 }} <span class=\"color99FF99\">(+{{ f11 }})</span> damage, and refreshes the Damage Reduction for {{ e8 }} seconds. Taunt duration, damage, and radius increase with charge time.<br /><br /><span class=\"colorDDDD77\">Shield of Durand's charge cannot be interrupted by crowd control.</span>",
						"leveltip": {
							"label": [
								"Shield Health Ratio",
								"Magic Damage Reduction",
								"Physical Damage Reduction",
								"Cooldown",
								"Max Damage"
							],
							"effect": [
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ f6 }}% -> {{ f7 }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ f10 }} -> {{ f12 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								8,
								11,
								14,
								17,
								20
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								5,
								5,
								5,
								5,
								5
							]
						],
						"effectBurn": [
							null,
							"20/25/30/35/40",
							"2",
							"30",
							"0.5",
							"8/11/14/17/20",
							"12",
							"1.5",
							"2",
							"1.25",
							"5"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							275,
							275,
							275,
							275,
							275
						],
						"rangeBurn": "275",
						"image": {
							"full": "GalioW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GalioE",
						"name": "Justice Punch",
						"description": "Galio will briefly step back and charge, knocking up the first enemy champion he encounters.",
						"tooltip": "Galio lunges forward with a mighty blow, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies and knocking them into the air for {{ e2 }} seconds. Galio will stop upon hitting a champion or terrain.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								100,
								130,
								160,
								190,
								220
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/130/160/190/220",
							"0.75",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "GalioE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GalioR",
						"name": "Hero's Entrance",
						"description": "Galio grants damage reduction to an ally. After a delay Galio smashes down on the ally's original location, knocking up nearby enemies.",
						"tooltip": "Galio designates an allied champion's current position as his landing spot and grants {{ e5 }} <span class=\"colorFF00FF\">(+{{ f2 }})</span>% damage reduction to that ally until he lands. <br /><br />When Galio lands, enemies in the area take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are knocked into the air for {{ e3 }} seconds ({{ e2 }} seconds in the center).",
						"leveltip": {
							"label": [
								"Damage",
								"Damage Reduction to Ally",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ e8 }} -> {{ e8NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							180,
							150,
							120
						],
						"cooldownBurn": "180/150/120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								1.25,
								1.25,
								1.25
							],
							[
								0.75,
								0.75,
								0.75
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								20,
								25,
								30
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								4000,
								4750,
								5500
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"1.25",
							"0.75",
							"2.5",
							"20/25/30",
							"0",
							"0",
							"4000/4750/5500",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							4000,
							4750,
							5500
						],
						"rangeBurn": "4000/4750/5500",
						"image": {
							"full": "GalioR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Colossal Smash",
					"description": "<mainText>Every few seconds, Galio's next basic attack deals bonus magic damage in an area. Colossal Smash's cooldown is reduced when Galio hits champions with his spells.</mainText>",
					"image": {
						"full": "Galio_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Galio",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Galio",
						"title": "GalioTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Gangplank": {
				"id": "Gangplank",
				"key": "41",
				"name": "Gangplank",
				"title": "the Saltwater Scourge",
				"image": {
					"full": "Gangplank.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "41000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "41001",
						"num": 1,
						"name": "Spooky Gangplank",
						"chromas": false
					},
					{
						"id": "41002",
						"num": 2,
						"name": "Minuteman Gangplank",
						"chromas": false
					},
					{
						"id": "41003",
						"num": 3,
						"name": "Sailor Gangplank",
						"chromas": false
					},
					{
						"id": "41004",
						"num": 4,
						"name": "Toy Soldier Gangplank",
						"chromas": false
					},
					{
						"id": "41005",
						"num": 5,
						"name": "Special Forces Gangplank",
						"chromas": false
					},
					{
						"id": "41006",
						"num": 6,
						"name": "Sultan Gangplank",
						"chromas": false
					},
					{
						"id": "41007",
						"num": 7,
						"name": "Captain Gangplank",
						"chromas": false
					},
					{
						"id": "41008",
						"num": 8,
						"name": "Dreadnova Gangplank",
						"chromas": true
					}
				],
				"lore": "As unpredictable as he is brutal, the dethroned reaver king Gangplank is feared far and wide. Once, he ruled the port city of Bilgewater, and while his reign is over, there are those who believe this has only made him more dangerous. Gangplank would see Bilgewater bathed in blood once more before letting someone else take it—and now with pistol, cutlass, and barrels of gunpowder, he is determined to reclaim what he has lost.",
				"blurb": "As unpredictable as he is brutal, the dethroned reaver king Gangplank is feared far and wide. Once, he ruled the port city of Bilgewater, and while his reign is over, there are those who believe this has only made him more dangerous. Gangplank would see...",
				"allytips": [
					"Parrrley applies On Hit effects like Frozen Mallet or Black Cleaver.",
					"Paying attention to low-health enemies on the map can land you a surprise kill with Cannon Barrage.",
					"Try placing Cannon Barrage on the path of escape to cut off fleeing enemies."
				],
				"enemytips": [
					"Parrrley deals a high amount of physical damage. Items that grant Armor can help if an enemy Gangplank is doing well.",
					"Once Gangplank reaches level 6, watch out for his global-range ultimate, Cannon Barrage!"
				],
				"tags": [
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 6,
					"magic": 4,
					"difficulty": 9
				},
				"stats": {
					"hp": 540,
					"hpperlevel": 82,
					"mp": 282,
					"mpperlevel": 40,
					"movespeed": 345,
					"armor": 35,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 6,
					"hpregenperlevel": 0.6,
					"mpregen": 7.5,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.2
				},
				"spells": [
					{
						"id": "GangplankQWrapper",
						"name": "Parrrley",
						"description": "Shoots target, plundering Gold for each enemy unit killed.",
						"tooltip": "Fires a bullet that deals {{ e1 }} (<span class=\"colorFF8C00\">+{{ a1 }}</span>) physical damage (can crit and applies on-hit effects).<br /><br />If Parrrley kills the target, Gangplank plunders <span class=\"colorFFDD00\">{{ e2 }}</span> bonus Gold and <span class=\"colorFFDD00\">{{ e5 }}</span> <span class=\"colorffd700\">Silver Serpents</span>. (Trade <span class=\"colorffd700\">Silver Serpents</span> at the shop to upgrade Cannon Barrage).<br /><br />",
						"leveltip": {
							"label": [
								"Damage",
								"Plunder Gold",
								"Plunder Silver Serpents",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							5,
							5,
							5,
							5
						],
						"cooldownBurn": "5",
						"cost": [
							60,
							55,
							50,
							45,
							40
						],
						"costBurn": "60/55/50/45/40",
						"effect": [
							null,
							[
								20,
								45,
								70,
								95,
								120
							],
							[
								3,
								4,
								5,
								6,
								7
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								500,
								500,
								500,
								500,
								500
							],
							[
								4,
								5,
								6,
								7,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/45/70/95/120",
							"3/4/5/6/7",
							"0",
							"500",
							"4/5/6/7/8",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "GangplankQWrapper.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GangplankW",
						"name": "Remove Scurvy",
						"description": "Eats citrus to cure crowd control effects and restore Health.",
						"tooltip": "Gangplank consumes a large quantity of citrus fruit, curing all disabling effects and healing him for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> + <span class=\"colorCC3300\">{{ e2 }}% of his missing Health</span>.",
						"leveltip": {
							"label": [
								"Healing",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20,
							18,
							16,
							14
						],
						"cooldownBurn": "22/20/18/16/14",
						"cost": [
							80,
							90,
							100,
							110,
							120
						],
						"costBurn": "80/90/100/110/120",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"15",
							"0.25",
							"200",
							"30/40/50/60/70",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "GangplankW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GangplankE",
						"name": "Powder Keg",
						"description": "Gangplank uncovers a powder keg at target location. If he attacks it, it explodes, spreading the attack's damage to enemies in the area, slowing them.",
						"tooltip": "Places a powder keg that can be attacked by Gangplank or his enemies at a location for {{ e5 }} seconds.<br /><br />If Gangplank destroys a keg, it explodes dealing <span class=\"colorFF8C00\">the attack's damage</span> as physical damage (ignores {{ e0 }}% Armor) to enemies and slowing them by {{ e4 }}% for {{ e2 }} seconds. Champions take {{ e3 }} bonus physical damage from the explosion.<br /><br />When a keg explodes, other kegs with overlapping blast zones chain explode (damage does not stack).<br /><br />Kegs health decays every {{ f5 }} seconds. (Decay rate increases at level 7 and 13)<br /><br /><span class=\"colorffd700\">Keg explosions apply Parrrley's plunder effect.</span>",
						"leveltip": {
							"label": [
								"Barrel Ammo Charge",
								"Slow",
								"Bonus Damage Against Champions"
							],
							"effect": [
								"{{ f2 }} -> {{ f3 }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e3 }} -> {{ e3NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								40,
								40,
								40,
								40,
								40
							]
						],
						"effectBurn": [
							null,
							"3",
							"2",
							"60/90/120/150/180",
							"40/50/60/70/80",
							"25",
							"2",
							"10",
							"100",
							"0.5",
							"40"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "3",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "GangplankE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GangplankR",
						"name": "Cannon Barrage",
						"description": "Gangplank signals his ship to bombard an area, slowing and damaging enemies.",
						"tooltip": "Signals Gangplank's ship to fire {{ f3 }} waves of cannonballs at an area over {{ e3 }} seconds. Each wave deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slows enemies by {{ e2 }}% for {{ e6 }} seconds.<br /><br /><span class=\"colorffd700\">Collect Silver Serpents with Parrrley to upgrade in the shop.</span>",
						"leveltip": {
							"label": [
								"Damage Per Wave",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							180,
							160,
							140
						],
						"cooldownBurn": "180/160/140",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								35,
								60,
								85
							],
							[
								30,
								30,
								30
							],
							[
								8,
								8,
								8
							],
							[
								2,
								2,
								2
							],
							[
								1.5,
								0.5,
								0.5
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								300,
								300,
								300
							],
							[
								60,
								60,
								60
							],
							[
								1,
								1,
								1
							],
							[
								30,
								30,
								30
							]
						],
						"effectBurn": [
							null,
							"35/60/85",
							"30",
							"8",
							"2",
							"1.5/0.5/0.5",
							"0.5",
							"300",
							"60",
							"1",
							"30"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							30000,
							30000,
							30000
						],
						"rangeBurn": "30000",
						"image": {
							"full": "GangplankR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Trial by Fire",
					"description": "Every few seconds, Gangplank's melee strike will set his opponent on fire.",
					"image": {
						"full": "Gangplank_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Gangplank",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "Map12",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "GangplankCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "GangplankFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "GangplankKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "GangplankSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "GangplankSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gangplank",
						"title": "GangplankTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3902",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3903",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3901",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Garen": {
				"id": "Garen",
				"key": "86",
				"name": "Garen",
				"title": "The Might of Demacia",
				"image": {
					"full": "Garen.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "86000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "86001",
						"num": 1,
						"name": "Sanguine Garen",
						"chromas": false
					},
					{
						"id": "86002",
						"num": 2,
						"name": "Desert Trooper Garen",
						"chromas": false
					},
					{
						"id": "86003",
						"num": 3,
						"name": "Commando Garen",
						"chromas": false
					},
					{
						"id": "86004",
						"num": 4,
						"name": "Dreadknight Garen",
						"chromas": false
					},
					{
						"id": "86005",
						"num": 5,
						"name": "Rugged Garen",
						"chromas": false
					},
					{
						"id": "86006",
						"num": 6,
						"name": "Steel Legion Garen",
						"chromas": false
					},
					{
						"id": "86010",
						"num": 10,
						"name": "Rogue Admiral Garen",
						"chromas": false
					},
					{
						"id": "86011",
						"num": 11,
						"name": "Warring Kingdoms Garen",
						"chromas": true
					}
				],
				"lore": "A proud and noble warrior, Garen fights as one of the Dauntless Vanguard. He is popular among his fellows, and respected well enough by his enemies—not least as a scion of the prestigious Crownguard family, entrusted with defending Demacia and its ideals. Clad in magic-resistant armor and bearing a mighty broadsword, Garen stands ready to confront mages and sorcerers on the field of battle, in a veritable whirlwind of righteous steel.",
				"blurb": "A proud and noble warrior, Garen fights as one of the Dauntless Vanguard. He is popular among his fellows, and respected well enough by his enemies—not least as a scion of the prestigious Crownguard family, entrusted with defending Demacia and its...",
				"allytips": [
					"Garen's regeneration greatly increases if he can avoid receiving damage for several seconds.",
					"Judgment deals maximum damage when only hitting a single target. For effective trading, try to position such that only the enemy champion is hit.",
					"Garen is only constrained by cooldowns, making items such as Black Cleaver very effective for him."
				],
				"enemytips": [
					"Stack armor items to lower the large amount of physical damage that Garen deals out.",
					"Try to run away from Garen as your health gets lower, as he can execute you quickly with Demacian Justice.",
					"Be careful about attacking Garen in brush. It often will lead to taking full damage from Judgment.",
					"Judgment deals maximum damage when only hitting a single target. If getting out of its radius isn't possible, move through allied minions to reduce damage taken."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "None",
				"info": {
					"attack": 7,
					"defense": 7,
					"magic": 1,
					"difficulty": 5
				},
				"stats": {
					"hp": 616.28,
					"hpperlevel": 84.25,
					"mp": 0,
					"mpperlevel": 0,
					"movespeed": 340,
					"armor": 36,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.5,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 4.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.9
				},
				"spells": [
					{
						"id": "GarenQ",
						"name": "Decisive Strike",
						"description": "Garen gains a burst of movement speed, breaking free of all slows affecting him. His next attack strikes a vital area of his foe, dealing bonus damage and silencing them.",
						"tooltip": "Garen breaks free from all slows affecting him, and gains {{ e2 }}% movement speed for {{ e4 }} seconds.<br /><br />His next basic attack within {{ e5 }} seconds deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and silences his target for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Movement Speed Duration"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								30,
								55,
								80,
								105,
								130
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1.5,
								2,
								2.5,
								3,
								3.5
							],
							[
								4.5,
								4.5,
								4.5,
								4.5,
								4.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/55/80/105/130",
							"30",
							"1.5",
							"1.5/2/2.5/3/3.5",
							"4.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.4,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "GarenQ.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GarenW",
						"name": "Courage",
						"description": "Garen passively increases his armor and magic resist by killing enemies. He may also activate this ability to give him a huge burst of Tenacity and damage reduction for a brief moment followed by a lesser amount of damage reduction for a longer duration.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Killing units permanently grants {{ f2 }} armor and magic resist, up to a maximum of {{ e2 }}. Current Bonus: <span class=\"colorFFFFFF\">{{ f1 }}</span><br /><br /><span class=\"colorFF9900\">Active: </span>Garen steels his courage for {{ e4 }} seconds. For the first {{ e7 }} seconds, he takes {{ e6 }}% less damage and gains {{ e5 }}% Tenacity. For the remaining duration, he takes {{ e3 }}% less damage.",
						"leveltip": {
							"label": [
								"Total Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							23,
							22,
							21,
							20
						],
						"cooldownBurn": "24/23/22/21/20",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								2,
								3,
								4,
								5,
								6
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0.25",
							"30",
							"30",
							"2/3/4/5/6",
							"60",
							"60",
							"0.75",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "GarenW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GarenE",
						"name": "Judgment",
						"description": "Garen performs a dance of death with his sword, dealing damage around him for the duration and shredding the armor of enemy champions hit.",
						"tooltip": "Garen rapidly spins his sword around his body for {{ e2 }} seconds, dealing {{ f3 }} physical damage to nearby enemies -- {{ e1 }} plus {{ e3 }}% of his attack damage <span class=\"colorFF8C00\">(+{{ f1 }})</span>, <span class=\"colorFFFFFF\">{{ f2 }}</span> times (increased by 1 every 3 champion levels) -- over the duration.<br /><br />Enemy champions hit by {{ e6 }} spins lose {{ e5 }}% of their armor for {{ e7 }} seconds.<br /><br /><span class=\"color99FF99\">Judgment deals {{ e4 }}% increased damage when striking only one enemy.<br />Cancelling Judgment returns cooldown equal to the remaining duration.<br /><span class=\"color99FF99\">Judgment can critically strike for bonus damage.</span>",
						"leveltip": {
							"label": [
								"Base Damage per hit",
								"Total Attack Damage Ratio per hit"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								14,
								18,
								22,
								26,
								30
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								36,
								37,
								38,
								39,
								40
							],
							[
								33,
								33,
								33,
								33,
								33
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"14/18/22/26/30",
							"3",
							"36/37/38/39/40",
							"33",
							"25",
							"4",
							"6",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "GarenE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GarenR",
						"name": "Demacian Justice",
						"description": "The enemy champion with the most recent kills is the Villain. Garen's attacks deal additional true damage to that champion.<br><br>Garen can call upon the might of Demacia to deal a finishing blow to an enemy champion that deals damage based upon how much health his target has missing. This damage is true damage against the Villain.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> The enemy champion with the most recent kills is the <span class=\"colorFFF673\">Villain</span>. Judgment and basic attacks against it deal an additional {{ e3 }}% of its maximum health as true damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Garen calls upon the might of Demacia to attempt to execute an enemy champion, dealing magic damage equal to {{ e1 }} plus {{ e2 }}% of the target's missing health. Deals true damage to the <span class=\"colorFFF673\">Villain</span>.",
						"leveltip": {
							"label": [
								"Damage",
								"Missing Health Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								175,
								350,
								525
							],
							[
								28,
								33,
								40
							],
							[
								1,
								1,
								1
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"175/350/525",
							"28/33/40",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "GarenR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Perseverance",
					"description": "If Garen has not recently been struck by damage or enemy abilities, he regenerates a percentage of his total health each second. Minion damage does not stop Perseverance.",
					"image": {
						"full": "Garen_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Garen",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenBT",
						"map": "SR",
						"mode": "TUTORIAL",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Garen",
						"title": "GarenTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Gnar": {
				"id": "Gnar",
				"key": "150",
				"name": "Gnar",
				"title": "the Missing Link",
				"image": {
					"full": "Gnar.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "150000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "150001",
						"num": 1,
						"name": "Dino Gnar",
						"chromas": true
					},
					{
						"id": "150002",
						"num": 2,
						"name": "Gentleman Gnar",
						"chromas": false
					},
					{
						"id": "150003",
						"num": 3,
						"name": "Snow Day Gnar",
						"chromas": false
					},
					{
						"id": "150004",
						"num": 4,
						"name": "El León Gnar",
						"chromas": false
					},
					{
						"id": "150013",
						"num": 13,
						"name": "Super Galaxy Gnar",
						"chromas": false
					}
				],
				"lore": "Gnar is a primeval yordle whose playful antics can erupt into a toddler's outrage in an instant, transforming him into a massive beast bent on destruction. Frozen in True Ice for millennia, the curious creature broke free and now hops about a changed world he sees as exotic and wondrous. Delighted by danger, Gnar flings whatever he can at his enemies, be it his bonetooth boomerang, or a nearby building.",
				"blurb": "Gnar is a primeval yordle whose playful antics can erupt into a toddler's outrage in an instant, transforming him into a massive beast bent on destruction. Frozen in True Ice for millennia, the curious creature broke free and now hops about a changed...",
				"allytips": [
					"Managing your Rage is very important. Try to time out your transformations so you can get maximum benefit from both forms.",
					"Position yourself next to walls to bait your enemies into getting stunned by your ultimate.",
					"Know your strengths! Mini Gnar is fast, squishy, and has high sustained damage. Mega Gnar is slow, tough, and has high burst."
				],
				"enemytips": [
					"Gnar can't gain Rage for 15 seconds after he turns from big to little. Use this chance to engage on his team.",
					"Gnar's animations and resource bar change as he gets closer to transforming.  ",
					"Gnar's ultimate stuns if he hits you into a wall. Be careful when fighting him near one."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Rage",
				"info": {
					"attack": 6,
					"defense": 5,
					"magic": 5,
					"difficulty": 8
				},
				"stats": {
					"hp": 510,
					"hpperlevel": 65,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 325,
					"armor": 32,
					"armorperlevel": 2.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 175,
					"hpregen": 4.5,
					"hpregenperlevel": 1.75,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 59,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 6
				},
				"spells": [
					{
						"id": "GnarQ",
						"name": "Boomerang Throw / Boulder Toss",
						"description": "Gnar throws a boomerang that damages and slows enemies it hits before returning to him. If he catches the boomerang its cooldown is reduced.<br><br>Mega Gnar instead throws a boulder that stops on the first unit hit, damaging and slowing everything nearby. It can then be picked up to reduce the cooldown.",
						"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span>Throws a boomerang that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slows enemies by {{ e3 }}% for {{ e4 }} seconds. The boomerang returns towards Gnar after hitting an enemy, dealing {{ e7 }}% damage to subsequent targets. Each enemy can only be hit once. Catching the boomerang reduces its cooldown by {{ f1 }}%.<br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Throws a boulder that stops when it hits an enemy, slowing all nearby enemies and dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage. Picking up the boulder reduces its cooldown by {{ e6 }}%.",
						"leveltip": {
							"label": [
								"Boomerang Damage",
								"Boulder Damage",
								"Slow Amount",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							17.5,
							15,
							12.5,
							10
						],
						"cooldownBurn": "20/17.5/15/12.5/10",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								5,
								45,
								85,
								125,
								165
							],
							[
								5,
								45,
								85,
								125,
								165
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								3000,
								3000,
								3000,
								3000,
								3000
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								280,
								280,
								280,
								280,
								280
							]
						],
						"effectBurn": [
							null,
							"5/45/85/125/165",
							"5/45/85/125/165",
							"15/20/25/30/35",
							"2",
							"3000",
							"60",
							"50",
							"200",
							"6",
							"280"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.15,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 1.2,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "GnarQ.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GnarW",
						"name": "Hyper / Wallop",
						"description": "Gnar's attacks and spells hype him up, dealing bonus damage and granting him Movement Speed.<br><br>Mega Gnar is too enraged to be hyper and instead can rear up on his hind legs and smash down on the area in front of him, stunning enemies in an area.",
						"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span><span class=\"colorFF9900\">Passive:</span> Every 3rd attack or spell on the same target deals an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }}) </span>+ {{ e2 }}% of the target's max Health as magic damage and grants Gnar {{ f1 }}% Movement Speed that decays over 3 seconds (max {{ e4 }} damage vs. monsters). <br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Stuns enemies in an area for {{ e5 }} seconds, dealing {{ e3 }}<span class=\"colorFF8C00\"> (+{{ a2 }})</span> physical damage.<br /><br />Gnar gains Hyper's Movement Speed bonus when he leaves Mega form.",
						"leveltip": {
							"label": [
								"Hyper Damage",
								"Hyper % Health Damage",
								"Hyper Max Damage to monsters",
								"Wallop Damage",
								"Wallop Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							13,
							11,
							9,
							7
						],
						"cooldownBurn": "15/13/11/9/7",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								6,
								8,
								10,
								12,
								14
							],
							[
								25,
								45,
								65,
								85,
								105
							],
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								3.5,
								3.5,
								3.5,
								3.5,
								3.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								550,
								550,
								550,
								550,
								550
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/20/30/40/50",
							"6/8/10/12/14",
							"25/45/65/85/105",
							"100/150/200/250/300",
							"1.25",
							"3.5",
							"3",
							"550",
							"200",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							0,
							0,
							0,
							0,
							0
						],
						"rangeBurn": "0",
						"image": {
							"full": "GnarW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GnarE",
						"name": "Hop / Crunch",
						"description": "Gnar leaps to a location and bounces off the head of any unit he lands on, traveling further.<br><br>Mega Gnar is too large to bounce and instead lands with earth-shattering force, dealing damage in an area around him.",
						"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span>Leaps to a location, gaining {{ e2 }}% Attack Speed for 3 seconds. If Gnar lands on a unit he will bounce off it, traveling further. Deals {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [6% of Gnar's Max Health]</span> physical damage and slows briefly if the unit landed on was an enemy.<br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Leaps to a location and deals {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [6% of Gnar's Max Health]</span> physical damage to nearby enemies on landing. Enemies Gnar lands directly on top of are slowed briefly.<br /><br />If Crunch is used to transform, Gnar will still be able to bounce.",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							19.5,
							17,
							14.5,
							12
						],
						"cooldownBurn": "22/19.5/17/14.5/12",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								50,
								85,
								120,
								155,
								190
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								-0.8,
								-0.8,
								-0.8,
								-0.8,
								-0.8
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								475,
								475,
								475,
								475,
								475
							],
							[
								525,
								525,
								525,
								525,
								525
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								375,
								375,
								375,
								375,
								375
							]
						],
						"effectBurn": [
							null,
							"50/85/120/155/190",
							"20/30/40/50/60",
							"600",
							"-0.8",
							"0.5",
							"475",
							"525",
							"200",
							"0.6",
							"375"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							475,
							475,
							475,
							475,
							475
						],
						"rangeBurn": "475",
						"image": {
							"full": "GnarE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "GnarR",
						"name": "GNAR!",
						"description": "Mega Gnar throws everything around him in a chosen direction, dealing damage and slowing them.  Any enemy that hits a wall is stunned and takes bonus damage.",
						"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span><span class=\"colorFF9900\">Passive:</span> Increases Hyper's Movement Speed bonus to {{ e2 }}%.<br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Knocks nearby enemies in the specified direction, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> physical damage and slowing them by {{ e8 }}% for {{ e3 }} seconds. Enemies that hit a wall take {{ e7 }}% damage and are stunned instead of slowed.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow/Stun Duration",
								"Hyper Movement Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								200,
								300,
								400
							],
							[
								45,
								60,
								75
							],
							[
								1.25,
								1.5,
								1.75
							],
							[
								40,
								40,
								40
							],
							[
								475,
								475,
								475
							],
							[
								500,
								500,
								500
							],
							[
								150,
								150,
								150
							],
							[
								45,
								45,
								45
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/300/400",
							"45/60/75",
							"1.25/1.5/1.75",
							"40",
							"475",
							"500",
							"150",
							"45",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							590,
							590,
							590
						],
						"rangeBurn": "590",
						"image": {
							"full": "GnarR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Rage Gene",
					"description": "While in combat Gnar generates Rage. At maximum Rage his next ability will transform him into Mega Gnar, granting increased survivability and access to new spells.",
					"image": {
						"full": "Gnar_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Gnar",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gnar",
						"title": "GnarTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Gragas": {
				"id": "Gragas",
				"key": "79",
				"name": "Gragas",
				"title": "the Rabble Rouser",
				"image": {
					"full": "Gragas.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "79000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "79001",
						"num": 1,
						"name": "Scuba Gragas",
						"chromas": false
					},
					{
						"id": "79002",
						"num": 2,
						"name": "Hillbilly Gragas",
						"chromas": false
					},
					{
						"id": "79003",
						"num": 3,
						"name": "Santa Gragas",
						"chromas": false
					},
					{
						"id": "79004",
						"num": 4,
						"name": "Gragas, Esq.",
						"chromas": false
					},
					{
						"id": "79005",
						"num": 5,
						"name": "Vandal Gragas",
						"chromas": false
					},
					{
						"id": "79006",
						"num": 6,
						"name": "Oktoberfest Gragas",
						"chromas": false
					},
					{
						"id": "79007",
						"num": 7,
						"name": "Superfan Gragas",
						"chromas": false
					},
					{
						"id": "79008",
						"num": 8,
						"name": "Fnatic Gragas",
						"chromas": false
					},
					{
						"id": "79009",
						"num": 9,
						"name": "Gragas Caskbreaker",
						"chromas": false
					},
					{
						"id": "79010",
						"num": 10,
						"name": "Arctic Ops Gragas",
						"chromas": false
					}
				],
				"lore": "Equal parts jolly and imposing, Gragas is a massive, rowdy brewmaster on his own quest for the perfect pint of ale. Hailing from parts unknown, he now searches for rare ingredients among the unblemished wastes of the Freljord, trying each recipe as he goes. Often intoxicated and extremely impulsive, he is legendary for the brawls he starts, which often end in all-night parties and widespread property damage. Any appearance from Gragas must surely foreshadow drinking and destruction—in that order.",
				"blurb": "Equal parts jolly and imposing, Gragas is a massive, rowdy brewmaster on his own quest for the perfect pint of ale. Hailing from parts unknown, he now searches for rare ingredients among the unblemished wastes of the Freljord, trying each recipe as he...",
				"allytips": [
					"The damage reduction from Drunken Rage is applied when you start drinking, try to use it when you see damage coming your way.",
					"Try to knock enemies back into your towers with Explosive Cask.",
					"Try to combo Body Slam with Explosive Cask to set up kills for your team."
				],
				"enemytips": [
					"Gragas can knock everybody away with his ultimate. Be careful that you don't get knocked into him or, worse, an enemy tower.",
					"Body Slam is on a very low cooldown, making it difficult to pursue Gragas. Don't overextend yourself chasing him."
				],
				"tags": [
					"Fighter",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 7,
					"magic": 6,
					"difficulty": 5
				},
				"stats": {
					"hp": 583.52,
					"hpperlevel": 89,
					"mp": 400,
					"mpperlevel": 47,
					"movespeed": 330,
					"armor": 35,
					"armorperlevel": 3.6,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 5.5,
					"hpregenperlevel": 0.5,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61.38,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.05
				},
				"spells": [
					{
						"id": "GragasQ",
						"name": "Barrel Roll",
						"description": "Gragas rolls his cask to a location, which can be activated to explode or will explode on its own after 4 seconds. Enemies struck by the blast have their Movement Speed slowed.",
						"tooltip": "Gragas rolls his cask to a location. When reactivated, or after {{ e4 }} seconds, the cask will explode, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and slowing their movement speed by {{ e2 }}% for {{ e3 }} seconds.<br /><br />The damage and slow amount increase as the cask ferments, up to {{ e6 }}% after {{ e5 }} seconds. Deals {{ e7 }}% damage to minions.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow %",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10,
							9,
							8,
							7
						],
						"cooldownBurn": "11/10/9/8/7",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"40/45/50/55/60",
							"2",
							"4",
							"2",
							"150",
							"70",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "GragasQ.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GragasW",
						"name": "Drunken Rage",
						"description": "Gragas guzzles down brew from his cask for 1 second. After finishing, he becomes drunkenly empowered, dealing magic damage to all nearby enemies on his next basic attack and reducing damage received.",
						"tooltip": "Gragas guzzles down his brew, taking {{ e1 }}% reduced damage for {{ e5 }} seconds.<br /><br />After finishing his drink, his next basic attack deals magic damage to nearby enemies equal to {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> plus {{ e2 }}% of their max Health (max {{ e4 }} vs monsters).",
						"leveltip": {
							"label": [
								"Damage Reduction",
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7,
							6,
							5,
							4
						],
						"cooldownBurn": "8/7/6/5/4",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								10,
								12,
								14,
								16,
								18
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								20,
								50,
								80,
								110,
								140
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/12/14/16/18",
							"8",
							"20/50/80/110/140",
							"300",
							"2.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "GragasW.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GragasE",
						"name": "Body Slam",
						"description": "Gragas charges to a location and collides with the first enemy unit he comes across, dealing damage to all nearby enemy units and stunning them.",
						"tooltip": "Gragas charges forward, colliding with the first enemy unit. He deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the area and bumps them back, stunning them for {{ e2 }} second.<br /><br />Body Slam's Cooldown is reduced by {{ f1 }} seconds if Gragas collides with a unit.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/130/180/230/280",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "GragasE.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GragasR",
						"name": "Explosive Cask",
						"description": "Gragas hurls his cask to a location, dealing damage and knocking back enemies caught in the blast radius.",
						"tooltip": "Gragas hurls his cask, causing it to explode when it lands. Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are knocked away from the explosion.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								200,
								300,
								400
							],
							[
								900,
								900,
								900
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/300/400",
							"900",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "GragasR.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Happy Hour",
					"description": "On ability use, Gragas takes a drink restoring 6% of his max Health. This effect can only happen every 8 seconds.",
					"image": {
						"full": "GragasPassiveHeal.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Gragas",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumable",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Gragas",
						"title": "GragasTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Graves": {
				"id": "Graves",
				"key": "104",
				"name": "Graves",
				"title": "the Outlaw",
				"image": {
					"full": "Graves.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "104000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "104001",
						"num": 1,
						"name": "Hired Gun Graves",
						"chromas": false
					},
					{
						"id": "104002",
						"num": 2,
						"name": "Jailbreak Graves",
						"chromas": false
					},
					{
						"id": "104003",
						"num": 3,
						"name": "Mafia Graves",
						"chromas": false
					},
					{
						"id": "104004",
						"num": 4,
						"name": "Riot Graves",
						"chromas": false
					},
					{
						"id": "104005",
						"num": 5,
						"name": "Pool Party Graves",
						"chromas": true
					},
					{
						"id": "104006",
						"num": 6,
						"name": "Cutthroat Graves",
						"chromas": false
					},
					{
						"id": "104007",
						"num": 7,
						"name": "Snow Day Graves",
						"chromas": false
					},
					{
						"id": "104014",
						"num": 14,
						"name": "Victorious Graves",
						"chromas": true
					}
				],
				"lore": "Malcolm Graves is a renowned mercenary, gambler, and thief—a wanted man in every city and empire he has visited. Even though he has an explosive temper, he possesses a strict sense of criminal honor, often enforced at the business end of his double-barreled shotgun Destiny. In recent years, he has reconciled a troubled partnership with Twisted Fate, and together they have prospered once more in the turmoil of Bilgewater's criminal underbelly.",
				"blurb": "Malcolm Graves is a renowned mercenary, gambler, and thief—a wanted man in every city and empire he has visited. Even though he has an explosive temper, he possesses a strict sense of criminal honor, often enforced at the business end of his...",
				"allytips": [
					"Smoke Screen can be used both to escape and to set up a kill.",
					"Using Quickdraw to get into range and delivering a point blank Buckshot can do lots of damage."
				],
				"enemytips": [
					"Graves deals mostly physical damage so Armor is an effective counter.",
					"Leaving the Smoke Screen's area of effect removes the harmful effect immediately."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 3,
					"difficulty": 3
				},
				"stats": {
					"hp": 551.12,
					"hpperlevel": 84,
					"mp": 322.2,
					"mpperlevel": 40,
					"movespeed": 340,
					"armor": 33,
					"armorperlevel": 3.4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 425,
					"hpregen": 8,
					"hpregenperlevel": 0.7,
					"mpregen": 7.9,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 69,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": 0.3,
					"attackspeedperlevel": 2.6
				},
				"spells": [
					{
						"id": "GravesQLineSpell",
						"name": "End of the Line",
						"description": "Graves fires an explosive shell that detonates after 2 seconds, or 0.2 seconds if it strikes terrain.",
						"tooltip": "Fires a powder round that deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ f1 }})</span> physical damage to enemies in a line.<br /><br />After 2 seconds or {{ e6 }} seconds on collision with terrain, the round detonates, dealing {{ e2 }}<span class=\"colorFF8C00\"> (+{{ f2 }})</span> physical damage to all nearby enemies.",
						"leveltip": {
							"label": [
								"Damage",
								"Detonation AD Ratio",
								"Mana Cost",
								"Cooldown "
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }} / {{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								45,
								60,
								75,
								90,
								105
							],
							[
								85,
								115,
								145,
								175,
								205
							],
							[
								0.4,
								0.7,
								1,
								1.3,
								1.6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.2,
								0.2,
								0.2,
								0.2,
								0.2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"45/60/75/90/105",
							"85/115/145/175/205",
							"0.4/0.7/1/1.3/1.6",
							"0",
							"1",
							"0.2",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "GravesQLineSpell.png",
							"sprite": "spell3.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GravesSmokeGrenade",
						"name": "Smoke Screen",
						"description": "Graves fires a smoke canister at the target area creating a cloud of smoke that reduces sight range. Enemies caught in the initial impact are dealt magic damage and have their movement speed reduced briefly.",
						"tooltip": "Creates a cloud of Black Smoke lasting 4 seconds. Enemies inside Black Smoke cannot see out.<br /><br />Enemies caught in the initial impact are dealt {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and have their movement speed reduced by {{ e2 }}% for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							26,
							24,
							22,
							20,
							18
						],
						"cooldownBurn": "26/24/22/20/18",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/110/160/210/260",
							"50",
							"200",
							"4",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "GravesSmokeGrenade.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GravesMove",
						"name": "Quickdraw",
						"description": "Graves dashes forward gaining an Armor boost for several seconds. If Graves dashes towards an enemy champion, gain two stacks of True Grit instead. Hitting enemies with basic attacks lowers the cooldown of this skill and refreshes the resistance boost. ",
						"tooltip": "Dashes in a direction, reloading one shell. Graves gains <span class=\"colorFFF673\">True Grit</span> for 4 seconds. If Graves dashes towards an enemy champion, gain two stacks of <span class=\"colorFFF673\">True Grit</span> instead. <br /><br />Basic attack hits lower the cooldown of Quickdraw by {{ e4 }} seconds. Damage against non-minions also refreshes <span class=\"colorFFF673\">True Grit</span>.<br /><br /><span class=\"colorFFF673\">True Grit</span> grants {{ e5 }} Armor (stacks up to {{ e0 }} times).",
						"leveltip": {
							"label": [
								"True Grit Armor",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								5,
								7.5,
								10,
								12.5,
								15
							],
							[
								750,
								750,
								750,
								750,
								750
							],
							[
								375,
								375,
								375,
								375,
								375
							],
							[
								275,
								275,
								275,
								275,
								275
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								8,
								8,
								8,
								8,
								8
							]
						],
						"effectBurn": [
							null,
							"30/40/50/60/70",
							"4",
							"20/25/30/35/40",
							"0.5",
							"5/7.5/10/12.5/15",
							"750",
							"375",
							"275",
							"60",
							"8"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							425,
							425,
							425,
							425,
							425
						],
						"rangeBurn": "425",
						"image": {
							"full": "GravesMove.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "GravesChargeShot",
						"name": "Collateral Damage",
						"description": "Graves fires an explosive shell dealing heavy damage to the first champion it hits. After hitting a champion or reaching the end of its range, the shell explodes dealing damage in a cone. ",
						"tooltip": "Fires an explosive shell with such force that it knocks Graves back. The shell deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ f1 }})</span> physical damage to the first enemy hit. After hitting an enemy Champion or reaching the end of its range, the shell explodes, dealing {{ e2 }}<span class=\"colorFF8C00\"> (+{{ f2 }})</span> physical damage in a cone.",
						"leveltip": {
							"label": [
								"Primary Damage",
								"Cone Damage",
								"Cooldown "
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								250,
								400,
								550
							],
							[
								200,
								320,
								440
							],
							[
								400,
								400,
								400
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250/400/550",
							"200/320/440",
							"400",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "GravesChargeShot.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "New Destiny",
					"description": "Graves's shotgun holds two shells. After firing them he must reload. Each attack fires several bullets in a cone. Hitting an enemy with multiple bullets does bonus damage. These bullets cannot pass through units.",
					"image": {
						"full": "GravesTrueGrit.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Graves",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Graves",
						"title": "GravesTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Hecarim": {
				"id": "Hecarim",
				"key": "120",
				"name": "Hecarim",
				"title": "the Shadow of War",
				"image": {
					"full": "Hecarim.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "120000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "120001",
						"num": 1,
						"name": "Blood Knight Hecarim",
						"chromas": false
					},
					{
						"id": "120002",
						"num": 2,
						"name": "Reaper Hecarim",
						"chromas": false
					},
					{
						"id": "120003",
						"num": 3,
						"name": "Headless Hecarim",
						"chromas": false
					},
					{
						"id": "120004",
						"num": 4,
						"name": "Arcade Hecarim",
						"chromas": false
					},
					{
						"id": "120005",
						"num": 5,
						"name": "Elderwood Hecarim",
						"chromas": false
					},
					{
						"id": "120006",
						"num": 6,
						"name": "Worldbreaker Hecarim",
						"chromas": false
					},
					{
						"id": "120007",
						"num": 7,
						"name": "Lancer Zero Hecarim",
						"chromas": false
					}
				],
				"lore": "Hecarim is a spectral fusion of man and beast, cursed to ride down the souls of the living for all eternity. When the Blessed Isles fell into shadow, this proud knight was obliterated by the destructive energies of the Ruination, along with all his cavalry and their mounts. Now, whenever the Black Mist reaches out across Runeterra, he leads their devastating charge, reveling in the slaughter and crushing the foe beneath his armored hooves.",
				"blurb": "Hecarim is a spectral fusion of man and beast, cursed to ride down the souls of the living for all eternity. When the Blessed Isles fell into shadow, this proud knight was obliterated by the destructive energies of the Ruination, along with all his...",
				"allytips": [
					"Spirit of Dread restores Health when nearby enemies take damage, including damage dealt by allies. Cast this during a large fight to maximize Hecarim's survivability.",
					"Devastating Charge deals more damage based on the distance traveled. Try using Onslaught of Shadows or Summoner Spells such as Ghost or Flash to maximize this damage."
				],
				"enemytips": [
					"Hecarim gains life from nearby enemies with Spirit of Dread but lacks durability, use burst damage.",
					"Hecarim's ultimate causes opponents to flee in terror. Spread out to reduce his power in fights."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 6,
					"magic": 4,
					"difficulty": 6
				},
				"stats": {
					"hp": 580,
					"hpperlevel": 90,
					"mp": 277.2,
					"mpperlevel": 40,
					"movespeed": 345,
					"armor": 36,
					"armorperlevel": 4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 7,
					"hpregenperlevel": 0.75,
					"mpregen": 6.5,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.0672,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "HecarimRapidSlash",
						"name": "Rampage",
						"description": "Hecarim cleaves nearby enemies dealing physical damage. ",
						"tooltip": "Hecarim cleaves nearby enemies for {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage. ({{ e5 }}% damage to minions)<br /><br />If Hecarim damages at least one enemy with this attack he gains a stack of Rampage, reducing the base cooldown of this skill by {{ e3 }} second for a short duration. This effect can stack up to {{ e2 }} times.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							32,
							34,
							36,
							38,
							40
						],
						"costBurn": "32/34/36/38/40",
						"effect": [
							null,
							[
								55,
								90,
								125,
								160,
								195
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								66,
								66,
								66,
								66,
								66
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/90/125/160/195",
							"2",
							"1",
							"3",
							"66",
							"6",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "HecarimRapidSlash.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "HecarimW",
						"name": "Spirit of Dread",
						"description": "Hecarim deals magic damage to nearby enemies for a short duration. Hecarim gains Health equal to a percentage of any damage those enemies suffer.",
						"tooltip": "Hecarim deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e3 }} seconds to all nearby enemies. Hecarim is healed for {{ e1 }}% of the damage these enemies take from any source.<br /><br />Hecarim cannot heal more than {{ e4 }} Health from minions or monsters.",
						"leveltip": {
							"label": [
								"Damage",
								"Healing Cap",
								"Cooldown",
								"Mana Cost "
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							21,
							20,
							19,
							18
						],
						"cooldownBurn": "22/21/20/19/18",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								90,
								120,
								150,
								180,
								210
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20",
							"80/120/160/200/240",
							"4",
							"90/120/150/180/210",
							"8",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							575,
							575,
							575,
							575,
							575
						],
						"rangeBurn": "575",
						"image": {
							"full": "HecarimW.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "HecarimRamp",
						"name": "Devastating Charge",
						"description": "Hecarim gains increasing Movement Speed and can move through units for a short duration. His next attack knocks the target back and deals additional physical damage based on the distance he has traveled since activating the ability. ",
						"tooltip": "Hecarim gains increasing Movement Speed and can move through units for {{ e5 }} seconds. His next attack knocks the target back dealing {{ e4 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> to {{ e3 }}<span class=\"colorFF8C00\"> (+{{ a2 }})</span> physical damage based on how far Hecarim has traveled during Devastating Charge (knockback distance also scales).<br /><br /><rules>Devastating Charge's remaining duration pauses during Onslaught of Shadows.</rules>",
						"leveltip": {
							"label": [
								"Minimum Damage",
								"Maximum Damage",
								"Cooldown"
							],
							"effect": [
								" {{ e4 }} -> {{ e4NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							22,
							20,
							18,
							16
						],
						"cooldownBurn": "24/22/20/18/16",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								90,
								160,
								230,
								300,
								370
							],
							[
								45,
								80,
								115,
								150,
								185
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								1200,
								1200,
								1200,
								1200,
								1200
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250",
							"450",
							"90/160/230/300/370",
							"45/80/115/150/185",
							"4",
							"0.75",
							"1200",
							"0.25",
							"2.5",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "HecarimRamp.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "HecarimUlt",
						"name": "Onslaught of Shadows",
						"description": "Hecarim summons spectral riders and charges forward, dealing magic damage in a line. Hecarim creates a shockwave when he finishes his charge, causing nearby enemies to flee in terror.",
						"tooltip": "Hecarim summons spectral riders and charges forward, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies hit. <br /><br />Hecarim releases a shockwave at the end of his charge, causing nearby enemies to flee from him for {{ e2 }} to {{ e3 }} seconds (increases by charge distance).<br /><br /><rules>Hecarim himself will only move to the targeted location. The riders will always move the full distance.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							120,
							100
						],
						"cooldownBurn": "140/120/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								0.75,
								0.75,
								0.75
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								1100,
								1100,
								1100
							],
							[
								1000,
								1000,
								1000
							],
							[
								950,
								950,
								950
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"0.75",
							"1.5",
							"1100",
							"1000",
							"950",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							50000,
							50000,
							50000
						],
						"rangeBurn": "50000",
						"image": {
							"full": "HecarimUlt.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Warpath",
					"description": "Hecarim gains Attack Damage equal to a percentage of his bonus Movement Speed.",
					"image": {
						"full": "Hecarim_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Hecarim",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1054",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1054",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "3044",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3009",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3044",
										"count": 1
									},
									{
										"id": "3057",
										"count": 1
									},
									{
										"id": "3086",
										"count": 1
									},
									{
										"id": "3078",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3065",
										"count": 1
									},
									{
										"id": "3071",
										"count": 1
									},
									{
										"id": "3068",
										"count": 1
									},
									{
										"id": "3105",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "Map12",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "HecarimCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "HecarimFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "HecarimKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "HecarimSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "HecarimSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Hecarim",
						"title": "HecarimTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Heimerdinger": {
				"id": "Heimerdinger",
				"key": "74",
				"name": "Heimerdinger",
				"title": "the Revered Inventor",
				"image": {
					"full": "Heimerdinger.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "74000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "74001",
						"num": 1,
						"name": "Alien Invader Heimerdinger",
						"chromas": false
					},
					{
						"id": "74002",
						"num": 2,
						"name": "Blast Zone Heimerdinger",
						"chromas": false
					},
					{
						"id": "74003",
						"num": 3,
						"name": "Piltover Customs Heimerdinger",
						"chromas": false
					},
					{
						"id": "74004",
						"num": 4,
						"name": "Snowmerdinger",
						"chromas": false
					},
					{
						"id": "74005",
						"num": 5,
						"name": "Hazmat Heimerdinger",
						"chromas": false
					}
				],
				"lore": "A brilliant yet eccentric yordle scientist, Professor Cecil B. Heimerdinger is one of the most innovative and esteemed inventors Piltover has ever known. Relentless in his work to the point of neurotic obsession, he thrives on answering the universe's most impenetrable questions. Though his theories often appear opaque and esoteric, Heimerdinger has crafted some of Piltover's most miraculous—not to mention lethal—machinery, and constantly tinkers with his inventions to make them even more efficient.",
				"blurb": "A brilliant yet eccentric yordle scientist, Professor Cecil B. Heimerdinger is one of the most innovative and esteemed inventors Piltover has ever known. Relentless in his work to the point of neurotic obsession, he thrives on answering the universe's...",
				"allytips": [
					"Turret placement can be a deciding factor in a battle. Against most enemies turrets are best when they can support each other, but if the enemy has a lot of area of effect damage your turrets can be destroyed quickly. Placing turrets in brush can lead to a surprise attack in your favor.",
					"The success of Electron Storm Grenade is very important to Heimerdinger's survival. The slow and stun both are capable of keeping enemies in place long enough to punish them, but it is also the first line of defense against a surprise attack.",
					"Spreading out Hextech Micro-Rockets leads to more reliable damage and more efficiency against multiple targets, but focusing it creates the biggest impact."
				],
				"enemytips": [
					"It's better to destroy all of Heimerdinger's turrets at once with the help of creeps than to fight them one at a time.",
					"Be wary of Heimerdinger's Upgrade!!!, as he can use it to find an answer to most trouble he gets into. Once his ultimate is down, go in for the kill!"
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 6,
					"magic": 8,
					"difficulty": 8
				},
				"stats": {
					"hp": 488,
					"hpperlevel": 87,
					"mp": 307.2,
					"mpperlevel": 40,
					"movespeed": 340,
					"armor": 19.04,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55.536,
					"attackdamageperlevel": 2.7,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "HeimerdingerQ",
						"name": "H-28G Evolution Turret",
						"description": "Heimerdinger lays down a rapid-fire cannon turret equipped with a secondary pass-through beam attack (turrets deal half damage to towers).",
						"tooltip": "Places a Turret. Turret attacks prioritize Heimerdinger's targets and enemies attacking Heimerdinger. Turrets shut down if Heimerdinger moves far away. Heimerdinger generates a Turret Kit every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can hold {{ e3 }} Kits at once. <br /><br /><u><span class=\"colorFFFFFF\">H-28G Evolution Turret Stats</span></u><br /><span class=\"colorFFDD77\">Health:</span> <span class=\"colorFFFFFF\">{{ f4 }}</span> <span class=\"color99FF99\">(+{{ f2 }})</span><br /><span class=\"colorFFDD77\">Attack - Cannon:</span> {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage.<br /><span class=\"colorFFDD77\">Attack - Beam:</span> {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage every {{ e6 }} seconds.<br /><span class=\"colorFFDD77\">Maximum Turrets Placed:</span> 3",
						"leveltip": {
							"label": [
								"Cannon Damage",
								"Beam Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1,
							1,
							1,
							1,
							1
						],
						"cooldownBurn": "1",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								6,
								9,
								12,
								15,
								18
							],
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								26,
								22,
								18,
								14,
								10
							],
							[
								900,
								900,
								900,
								900,
								900
							],
							[
								90,
								90,
								90,
								90,
								90
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								20,
								20,
								20,
								20,
								20
							]
						],
						"effectBurn": [
							null,
							"6/9/12/15/18",
							"40/60/80/100/120",
							"3",
							"26/22/18/14/10",
							"900",
							"90",
							"0",
							"0.25",
							"0",
							"20"
						],
						"vars": [
							{
								"link": "@cooldownchampion",
								"coeff": 0,
								"key": "f1"
							},
							{
								"link": "@text",
								"coeff": [
									150,
									175,
									200,
									225,
									250,
									275,
									300,
									325,
									350,
									375,
									400,
									425,
									450,
									475,
									500,
									525,
									550,
									575
								],
								"key": "f4"
							},
							{
								"link": "@cooldownchampion",
								"coeff": 0,
								"key": "f2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.55,
								"key": "a2"
							}
						],
						"costType": " Mana and  Turret Kit",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "HeimerdingerQ.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana and  Turret Kit"
					},
					{
						"id": "HeimerdingerW",
						"name": "Hextech Micro-Rockets",
						"description": "Heimerdinger fires long-range rockets that converge on his cursor. ",
						"tooltip": "Unleashes a barrage of 5 rockets that converge towards the cursor and fan out past it. Rockets deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage. Additional rocket hits deal reduced damage:<br /><br /><span class=\"colorFFDD77\">Champions and Monsters:</span> {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage, max {{ e6 }} <span class=\"color99FF99\">(+{{ f2 }})</span> total damage<br /><span class=\"colorFFDD77\">Minions:</span> 60% of base damage<br /><br />Rocket hits against champions charge nearby turret beam attacks.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Damage",
								"Maximum Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10,
							9,
							8,
							7
						],
						"cooldownBurn": "11/10/9/8/7",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								12,
								18,
								24,
								30,
								36
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								108,
								162,
								216,
								270,
								324
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/90/120/150/180",
							"12/18/24/30/36",
							"25",
							"20",
							"30",
							"108/162/216/270/324",
							"5",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.12,
								"key": "a2"
							},
							{
								"link": "@dynamic.abilitypower",
								"coeff": 0.93,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1325,
							1325,
							1325,
							1325,
							1325
						],
						"rangeBurn": "1325",
						"image": {
							"full": "HeimerdingerW.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "HeimerdingerE",
						"name": "CH-2 Electron Storm Grenade",
						"description": "Heimerdinger lobs a grenade at a location, dealing damage to enemy units, as well as stunning anyone directly hit and slowing surrounding units.",
						"tooltip": "Hurls a grenade that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to enemies and slows their Movement Speed by {{ e3 }}% for {{ e2 }} seconds. Enemies in the center of the blast are also stunned for {{ e4 }} seconds.<br /><br />Hitting a champion fully charges nearby turret beams.",
						"leveltip": {
							"label": [
								"Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							85,
							85,
							85,
							85,
							85
						],
						"costBurn": "85",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"2",
							"35",
							"1.25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							970,
							970,
							970,
							970,
							970
						],
						"rangeBurn": "970",
						"image": {
							"full": "HeimerdingerE.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "HeimerdingerR",
						"name": "UPGRADE!!!",
						"description": "Heimerdinger invents an upgrade, causing his next spell to have increased effects. ",
						"tooltip": "Makes Heimerdinger's next ability free and gives it bonus effects. Reactivate to cancel. <br /><br /><span class=\"colorFFFF99\">H-28Q Apex Turret:</span> Places a Turret for 8 seconds that deals {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage with its cannon and {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage with its beam. It has splash damage, immunity to disables, its attacks slow by 25% for 2 seconds and it doesn't count toward the Turret limit. <br /><br /><span class=\"colorFFFF99\">Hextech Rocket Swarm:</span> Fires 4 waves of rockets that each deal {{ e8 }} <span class=\"color99FF99\">(+{{ f1 }})</span> Magic Damage. Champions and Monsters hit by multiple rockets take reduced damage, max {{ e5 }} <span class=\"color99FF99\">(+{{ f2 }})</span>. <br /><br /><span class=\"colorFFFF99\">CH-3X Lightning Grenade:</span> Throws a bouncing grenade that discharges three times, dealing {{ e0 }} <span class=\"color99FF99\">(+{{ f4 }})</span> Magic Damage. Both the stun and slow areas are larger and the slow is improved to 80%. ",
						"leveltip": {
							"label": [
								"Cooldown",
								"Apex Turret Cannon Damage",
								"Turret Beam Damage",
								"Rocket Swarm Damage",
								"Rocket Swarm Max Damage",
								"Lightning Grenade Damage"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e8 }} -> {{ e8NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e0 }} -> {{ e0NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							85,
							70
						],
						"cooldownBurn": "100/85/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								140,
								180
							],
							[
								80,
								80,
								80
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								0.12,
								0.12,
								0.12
							],
							[
								500,
								690,
								865
							],
							[
								0.45,
								0.45,
								0.45
							],
							[
								80,
								100,
								120
							],
							[
								135,
								180,
								225
							],
							[
								28,
								39,
								49
							],
							[
								150,
								250,
								350
							]
						],
						"effectBurn": [
							null,
							"100/140/180",
							"80",
							"1.5",
							"0.12",
							"500/690/865",
							"0.45",
							"80/100/120",
							"135/180/225",
							"28/39/49",
							"150/250/350"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "@dynamic.abilitypower",
								"coeff": 0,
								"key": "f1"
							},
							{
								"link": "@dynamic.abilitypower",
								"coeff": 1.83,
								"key": "f2"
							},
							{
								"link": "@dynamic.abilitypower",
								"coeff": 0.6,
								"key": "f4"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "HeimerdingerR.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Hextech Affinity",
					"description": "Gain Movement Speed while near allied towers and turrets deployed by Heimerdinger.",
					"image": {
						"full": "Heimerdinger_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Heimerdinger",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Heimerdinger",
						"title": "HeimerdingerTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Illaoi": {
				"id": "Illaoi",
				"key": "420",
				"name": "Illaoi",
				"title": "the Kraken Priestess",
				"image": {
					"full": "Illaoi.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "420000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "420001",
						"num": 1,
						"name": "Void Bringer Illaoi",
						"chromas": false
					}
				],
				"lore": "Illaoi's powerful physique is dwarfed only by her indomitable faith. As the prophet of the Great Kraken, she uses a huge, golden idol to rip her foes' spirits from their bodies and shatter their perception of reality. All who challenge the “Truth Bearer of Nagakabouros” soon discover Illaoi never battles alone—the god of the Serpent Isles fights by her side.",
				"blurb": "Illaoi's powerful physique is dwarfed only by her indomitable faith. As the prophet of the Great Kraken, she uses a huge, golden idol to rip her foes' spirits from their bodies and shatter their perception of reality. All who challenge the “Truth Bearer...",
				"allytips": [
					"Tentacles are an immense source of power. Don't fight without them.",
					"Spirits inherit their target's current health. If making a ",
					"Vessel",
					" is your goal, try whittling your opponent's health down a bit first to make killing the spirit easier.",
					"Leap of Faith is best used to follow-up a strong engage or when being engaged upon. Be careful about being the first one into a fight."
				],
				"enemytips": [
					"Killing Tentacles whenever possible will make it much easier to win a fight against Illaoi.",
					"When your spirit gets pulled out, fight back if you can. Dealing damage to Illaoi reduces the spirit's duration.",
					"Avoid grouping up for Leap of Faith to reduce the number of Tentacles available to Illaoi."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 6,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 585.6,
					"hpperlevel": 95,
					"mp": 300,
					"mpperlevel": 40,
					"movespeed": 340,
					"armor": 35,
					"armorperlevel": 3.8,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9.5,
					"hpregenperlevel": 0.8,
					"mpregen": 7.5,
					"mpregenperlevel": 0.75,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "IllaoiQ",
						"name": "Tentacle Smash",
						"description": "Increases the damage dealt by Tentacles. When activated, Illaoi smashes down a Tentacle that deals physical damage.",
						"tooltip": "<span class=\"colorFF8C00\">Passive:</span> <span class=\"color85FFAD\">Slam</span> damage is increased by {{ e6 }}% (<span class=\"colorFF8C00\">{{ f1 }}</span>).<br /><br /><span class=\"colorFF8C00\">Active:</span> Illaoi swings her idol, causing a Tentacle to <span class=\"color85FFAD\">Slam</span> forward.",
						"leveltip": {
							"label": [
								"Slam Bonus",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e6 }}% -> {{ e6NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								10,
								8,
								6,
								4,
								2
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								1.2,
								1.2,
								1.2,
								1.2,
								1.2
							],
							[
								-0.3,
								-0.35,
								-0.4,
								-0.45,
								-0.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10",
							"200",
							"800",
							"10/8/6/4/2",
							"5",
							"10/15/20/25/30",
							"1.2",
							"-0.3/-0.35/-0.4/-0.45/-0.5",
							"1.5",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "IllaoiQ.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IllaoiW",
						"name": "Harsh Lesson",
						"description": "Illaoi leaps to her target, dealing physical damage and causing nearby Tentacles to also swing at the target.",
						"tooltip": "Illaoi leaps at her target on her next basic attack, dealing bonus physical damage equal to <span class=\"colorFF8C00\">{{ f1*100 }}%</span> of their maximum health [{{ e1 }}% + {{ f2*100 }}% per 100 attack damage].<br /><br />When she strikes, nearby Tentacles will <span class=\"color85FFAD\">Slam</span> at the target.<br /><br /><span class=\"color919191\"><i>Harsh Lesson's bonus damage against monsters is capped at {{ e3 }} damage per hit.</i></span>",
						"leveltip": {
							"label": [
								"Base Damage"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								3,
								3.5,
								4,
								4.5,
								5
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"3/3.5/4/4.5/5",
							"2",
							"300",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "IllaoiW.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IllaoiE",
						"name": "Test of Spirit",
						"description": "Illaoi rips the spirit from a foe's body, forcing it to stand before her. Spirits echo a percentage of the damage they take to the original target. If killed, or if the target gets too far from the spirit, the target will become a <font color='#669900'>Vessel</font> and begin spawning Tentacles.",
						"tooltip": "Illaoi pulls the spirit from an enemy champion for {{ e3 }} seconds (reduced when Illaoi is attacked by the target). The spirit can be attacked, with {{ e1 }}% <span class=\"colorFF8C00\">(+{{ f5 }}%)</span> of the damage taken echoing to its owner.<br /><br />If the spirit dies or the target leaves its range, the target becomes a <span class=\"color669900\">Vessel</span> for {{ e2 }} seconds and is slowed by {{ e8 }}% for {{ e5 }} seconds. <span class=\"color669900\">Vessels</span> spawn Tentacles every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds if no other Tentacles are nearby.<br /><br />Tentacles will automatically <span class=\"color85FFAD\">Slam</span> at spirits and <span class=\"color669900\">Vessels</span> once every 10 seconds.",
						"leveltip": {
							"label": [
								"Damage Echo",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ f4 }} -> {{ f6 }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							35,
							40,
							45,
							50,
							55
						],
						"costBurn": "35/40/45/50/55",
						"effect": [
							null,
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								1500,
								1500,
								1500,
								1500,
								1500
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								20,
								18,
								16,
								14,
								12
							],
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								4,
								3,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/30/35/40/45",
							"12",
							"10",
							"1500",
							"1.5",
							"3",
							"20/18/16/14/12",
							"80",
							"8",
							"4/3/0/0/0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "IllaoiE.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IllaoiR",
						"name": "Leap of Faith",
						"description": "Illaoi smashes her idol into the ground, dealing physical damage to nearby enemies. A Tentacle spawns for each enemy champion hit.",
						"tooltip": "Illaoi smashes her idol into the ground, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and spawning a Tentacle for each enemy champion hit.<br /><br />For the next {{ e1 }} seconds Tentacles are untargetable and will <span class=\"color85FFAD\">Slam</span> 50% faster, and Harsh Lesson has a 2 second cooldown.<br /><br /><span class=\"colorcccccc\"><i>'There are kind and gentle gods. Mine isn't one of those.'</i></span>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown<"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								8,
								8,
								8
							],
							[
								150,
								250,
								350
							],
							[
								1500,
								1500,
								1500
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"8",
							"150/250/350",
							"1500",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "IllaoiR.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Prophet of an Elder God",
					"description": "Illaoi and the <font color='#669900'>Vessels</font> she creates spawn Tentacles on nearby impassible terrain. Tentacles swing at spirits, <font color='#669900'>Vessels</font>, and victims of Illaoi's Harsh lesson. Tentacles deal physical damage to enemies hit, and will heal Illaoi if they damage a champion.",
					"image": {
						"full": "Illaoi_P.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Illaoi",
						"title": "IllaoiARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Illaoi",
						"title": "IllaoiCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Illaoi",
						"title": "IllaoiFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Illaoi",
						"title": "IllaoiKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Illaoi",
						"title": "IllaoiSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Illaoi",
						"title": "IllaoiSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Illaoi",
						"title": "IllaoiTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Irelia": {
				"id": "Irelia",
				"key": "39",
				"name": "Irelia",
				"title": "the Will of the Blades",
				"image": {
					"full": "Irelia.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "39000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "39001",
						"num": 1,
						"name": "Nightblade Irelia",
						"chromas": false
					},
					{
						"id": "39002",
						"num": 2,
						"name": "Aviator Irelia",
						"chromas": false
					},
					{
						"id": "39003",
						"num": 3,
						"name": "Infiltrator Irelia",
						"chromas": false
					},
					{
						"id": "39004",
						"num": 4,
						"name": "Frostblade Irelia",
						"chromas": false
					},
					{
						"id": "39005",
						"num": 5,
						"name": "Order of the Lotus Irelia",
						"chromas": false
					}
				],
				"lore": "Raised in the shadow of Noxian occupation, Irelia developed one of the most exotic—and deadly—fighting styles in Ionia. While most of her family died at the hands of the invaders, she survived and learned to wield her levitating blades with nothing but her own determined spirit. She remains a fierce symbol of the resistance, ready to strike down any tyrant who may reach the shores of her homeland.",
				"blurb": "Raised in the shadow of Noxian occupation, Irelia developed one of the most exotic—and deadly—fighting styles in Ionia. While most of her family died at the hands of the invaders, she survived and learned to wield her levitating blades with nothing but...",
				"allytips": [
					"Use Bladesurge to cover great distances by targeting low life minions on your way to champion targets.",
					"Save your Transcendent Blades attacks for the right moment.",
					"Reserving Equilibrium Strike for losing battles can often turn the tide."
				],
				"enemytips": [
					"Be wary of Irelia's Equilibrium Strike, as it stuns if you have a higher Health % than her.",
					"Irelia can quickly cover great distances by using Bladesurge on low life targets (its cooldown refreshes if it slays the target)."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 4,
					"magic": 5,
					"difficulty": 5
				},
				"stats": {
					"hp": 607.2,
					"hpperlevel": 90,
					"mp": 338.8,
					"mpperlevel": 32,
					"movespeed": 345,
					"armor": 34,
					"armorperlevel": 3.75,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.65,
					"mpregen": 8.1,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 70,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": -0.06,
					"attackspeedperlevel": 3.2
				},
				"spells": [
					{
						"id": "IreliaGatotsu",
						"name": "Bladesurge",
						"description": "Irelia dashes forward to strike her target. If it kills the target, Bladesurge's cooldown refreshes and refunds a portion of the Mana Cost.",
						"tooltip": "Irelia dashes forward to strike her target, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and applying on-hit effects.<br /><br />If it kills the target, Bladesurge's cooldown is refreshed and Irelia gains {{ e2 }} Mana.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							12,
							10,
							8,
							6
						],
						"cooldownBurn": "14/12/10/8/6",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								20,
								50,
								80,
								110,
								140
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								1400,
								1400,
								1400,
								1400,
								1400
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/50/80/110/140",
							"35",
							"1400",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "IreliaGatotsu.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IreliaHitenStyle",
						"name": "Hiten Style",
						"description": "Irelia is skilled in the art of Hiten, passively giving her physical attacks Health restoration. Activating Hiten Style doubles her Health restoration and gives her basic attacks true damage.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Basic attacks restore {{ e1 }} Health.<br /><br /><span class=\"colorFF9900\">Active:</span> Irelia's basic attacks deal {{ e2 }} true damage and Hiten Style restores twice as much health for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Health Restoration",
								"True Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								5,
								7,
								9,
								11,
								13
							],
							[
								15,
								30,
								45,
								60,
								75
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5/7/9/11/13",
							"15/30/45/60/75",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "IreliaHitenStyle.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IreliaEquilibriumStrike",
						"name": "Equilibrium Strike",
						"description": "Irelia's attack balances the scales, dealing damage and slowing the target. However, if the target has a higher Health % than Irelia, then the blow stuns the target instead of slowing.",
						"tooltip": "Irelia pierces her target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing them by {{ e3 }}% for {{ e2 }} second(s).<br /><br />If the target has a higher Health % than Irelia, she stuns them for the duration instead.",
						"leveltip": {
							"label": [
								"Damage",
								"Disable Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }} -> {{ e2NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"1/1.25/1.5/1.75/2",
							"60",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "IreliaEquilibriumStrike.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IreliaTranscendentBlades",
						"name": "Transcendent Blades",
						"description": "Irelia summons 4 spirit blades that she can fling to deal physical damage and siphon life from enemies they pass through.",
						"tooltip": "Irelia summons 4 spirit blades that she can fling to deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to enemies they pass through. She heals for {{ e3 }}% of the damage dealt against champions. ({{ e4 }}% vs. minions and monsters)",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							80,
							60
						],
						"cooldownBurn": "100/80/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								80,
								120,
								160
							],
							[
								10,
								10,
								10
							],
							[
								25,
								25,
								25
							],
							[
								10,
								10,
								10
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160",
							"10",
							"25",
							"10",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.7,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "IreliaTranscendentBlades.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Ionian Fervor",
					"description": "Irelia reduces the duration of disables on herself based on whether she is Outnumbered by nearby champions. If she's in an even fight, she'll reduce disables by a small amount, if she's outnumbered, she'll reduce disables by a larger amount.",
					"image": {
						"full": "Irelia_IonianFervor.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Irelia",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1419",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Irelia",
						"title": "IreliaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Ivern": {
				"id": "Ivern",
				"key": "427",
				"name": "Ivern",
				"title": "the Green Father",
				"image": {
					"full": "Ivern.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "427000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "427001",
						"num": 1,
						"name": "Candy King Ivern",
						"chromas": false
					}
				],
				"lore": "Ivern Bramblefoot, known to many as the Green Father, is a peculiar half man, half tree who roams Runeterra's forests, cultivating life everywhere he goes. He knows the secrets of the natural world, and holds deep friendships with all things that grow, fly, and scuttle. Ivern wanders the wilderness, imparting strange wisdom to any he meets, enriching the forests, and occasionally entrusting loose-lipped butterflies with his secrets.",
				"blurb": "Ivern Bramblefoot, known to many as the Green Father, is a peculiar half man, half tree who roams Runeterra's forests, cultivating life everywhere he goes. He knows the secrets of the natural world, and holds deep friendships with all things that grow...",
				"allytips": [
					"Try to help allies follow up a good Rootcaller hit with Triggerseed!",
					"Use Brushmaker to set up future ambush spots!",
					"Daisy can block skillshots and slow down enemies. Use her to peel for your teammates!"
				],
				"enemytips": [
					"Ivern can be deceptively slippery. Be careful chasing him too far.",
					"Ivern's brush has a long duration. Watch out for ambushes!",
					"Be careful when fighting Ivern alone if he has Daisy ready to help!"
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 5,
					"magic": 7,
					"difficulty": 7
				},
				"stats": {
					"hp": 585,
					"hpperlevel": 95,
					"mp": 450,
					"mpperlevel": 60,
					"movespeed": 325,
					"armor": 27,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7,
					"hpregenperlevel": 0.85,
					"mpregen": 6,
					"mpregenperlevel": 0.75,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 50,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.03,
					"attackspeedperlevel": 3.4
				},
				"spells": [
					{
						"id": "IvernQ",
						"name": "Rootcaller",
						"description": "Ivern conjures a vine, dealing damage and rooting enemy targets hit. Ivern's allies can dash to the rooted target.",
						"tooltip": "Ivern conjures a vine dealing {{ e5 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage and rooting the first enemy hit for {{ e1 }} second(s). Allies can click on rooted enemies to dash into attack range.",
						"leveltip": {
							"label": [
								"Root Duration",
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								1.2,
								1.4,
								1.6,
								1.8,
								2
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								26,
								23,
								20,
								17,
								14
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.2/1.4/1.6/1.8/2",
							"15/20/25/30/35",
							"26/23/20/17/14",
							"2",
							"80/125/170/215/260",
							"40/55/70/85/100",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "IvernQ.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IvernW",
						"name": "Brushmaker",
						"description": "In brush, Ivern's attacks are ranged and deal bonus magic damage. Ivern can activate this ability to create a patch of brush.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> In brush, Ivern's attacks are ranged and deal {{ e5 }} <span class=\"color99FF99\">(+{{ f2 }})</span> bonus magic damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Ivern grows a patch of brush for {{ e1 }} seconds. For 3 seconds the area in and around the brush is revealed.",
						"leveltip": {
							"label": [
								"Bonus Magic Damage",
								"Brush Recharge"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e4 }} -> {{ e4NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						"cooldownBurn": "0.5",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								90,
								90,
								90,
								90,
								90
							],
							[
								190,
								190,
								190,
								190,
								190
							],
							[
								40,
								36,
								32,
								28,
								24
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30",
							"90",
							"190",
							"40/36/32/28/24",
							"20/30/40/50/60",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "3",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "IvernW.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IvernE",
						"name": "Triggerseed",
						"description": "Ivern places a shield on an ally which explodes after a short duration slowing and damaging enemies.",
						"tooltip": "Ivern shields an ally, absorbing up to {{ e1 }} <span class=\"color99FF99\">(+{{ f3 }})</span> damage. After 2 seconds, the shield bursts dealing {{ e2 }} <span class=\"color99FF99\">(+{{ f4 }})</span> magic damage and slowing enemies by {{ e3 }}% for {{ e4 }} seconds.<br /><br /><rules><span class=\"colorFFFF00\">Can also be cast on Daisy.</span></rules>",
						"leveltip": {
							"label": [
								"Shield",
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								75,
								110,
								145,
								180,
								215
							],
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/110/145/180/215",
							"60/80/100/120/140",
							"40/45/50/55/60",
							"2",
							"1",
							"80/120/160/200/240",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "IvernE.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IvernR",
						"name": "Daisy!",
						"description": "Ivern summons his Sentinel friend Daisy to fight with him. Daisy will send out a shockwave if she attacks the same champion three times in a row.",
						"tooltip": "Ivern summons his sentinel friend Daisy for {{ f6 }} seconds. If Daisy attacks the same champion three times in a row, she will create a shockwave knocking enemies up for 1 second (3s cooldown). Daisy has:<li>Health: {{ e1 }} <span class=\"color99FF99\">(+{{ f1 }})</span><br />Armor and Magic Resist: {{ e2 }} <span class=\"color99FF99\">(+{{ f2 }})</span><br />Attack Damage: {{ f4 }} <span class=\"color99FF99\">(+{{ f3 }})</span></li><br /><rules><span class=\"colorFFFF00\">Recast to manually issue orders to Daisy.</span></rules>",
						"leveltip": {
							"label": [
								"Cooldown",
								"Daisy's Base Health",
								"Daisy's Base Armor And Magic Resist",
								"Daisy Bonus Attack Speed"
							],
							"effect": [
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 3,
						"cooldown": [
							160,
							140,
							120
						],
						"cooldownBurn": "160/140/120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								1250,
								2500,
								3750
							],
							[
								15,
								40,
								90
							],
							[
								30,
								50,
								70
							],
							[
								30,
								60,
								130
							],
							[
								25,
								25,
								25
							],
							[
								160,
								140,
								120
							],
							[
								40,
								40,
								40
							],
							[
								25,
								25,
								25
							],
							[
								5,
								5,
								5
							],
							[
								0.05,
								0.05,
								0.05
							]
						],
						"effectBurn": [
							null,
							"1250/2500/3750",
							"15/40/90",
							"30/50/70",
							"30/60/130",
							"25",
							"160/140/120",
							"40",
							"25",
							"5",
							"0.05"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "IvernR.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Friend of the Forest",
					"description": "Ivern cannot attack or be attacked by non-epic monsters. Ivern can create magical groves on jungle camps which grow over time. When the grove is fully grown, Ivern may free the monsters to receive gold and experience. After level 5 Ivern can share jungle buffs with allies.",
					"image": {
						"full": "IvernP.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ivern",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1004",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3114",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "ItemTeleportCancel",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3114",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3801",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3711",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ivern",
						"title": "IvernTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Janna": {
				"id": "Janna",
				"key": "40",
				"name": "Janna",
				"title": "the Storm's Fury",
				"image": {
					"full": "Janna.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "40000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "40001",
						"num": 1,
						"name": "Tempest Janna",
						"chromas": false
					},
					{
						"id": "40002",
						"num": 2,
						"name": "Hextech Janna",
						"chromas": false
					},
					{
						"id": "40003",
						"num": 3,
						"name": "Frost Queen Janna",
						"chromas": false
					},
					{
						"id": "40004",
						"num": 4,
						"name": "Victorious Janna",
						"chromas": false
					},
					{
						"id": "40005",
						"num": 5,
						"name": "Forecast Janna",
						"chromas": false
					},
					{
						"id": "40006",
						"num": 6,
						"name": "Fnatic Janna",
						"chromas": false
					},
					{
						"id": "40007",
						"num": 7,
						"name": "Star Guardian Janna",
						"chromas": false
					},
					{
						"id": "40008",
						"num": 8,
						"name": "Sacred Sword Janna",
						"chromas": true
					}
				],
				"lore": "Armed with the power of Runeterra's gales, Janna is a mysterious, elemental wind spirit who protects the dispossessed of Zaun. Some believe she was brought into existence by the pleas of Runeterra's sailors who prayed for fair winds as they navigated treacherous waters and braved rough tempests. Her favor and protection has since been called into the depths of Zaun, where Janna has become a beacon of hope to those in need. No one knows where or when she will appear, but more often than not, she's come to help.",
				"blurb": "Armed with the power of Runeterra's gales, Janna is a mysterious, elemental wind spirit who protects the dispossessed of Zaun. Some believe she was brought into existence by the pleas of Runeterra's sailors who prayed for fair winds as they navigated...",
				"allytips": [
					"Eye of the Storm can be used on allied turrets.",
					"Quickly firing a Howling Gale without the charge up can be used to heavily disable the other team.",
					"Timing Janna's ultimate can push enemies away from a wounded ally or even separate enemies."
				],
				"enemytips": [
					"Save an interrupt ability for when Janna uses her ultimate.",
					"Listen for the charge up sound on Howling Gale in case Janna is trying to hit you with it from off screen or from brush.",
					"Janna's at her strongest when buffing another ally. If you can harass her ally, it will weaken her ability to fight you."
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 5,
					"magic": 7,
					"difficulty": 7
				},
				"stats": {
					"hp": 500,
					"hpperlevel": 70,
					"mp": 350,
					"mpperlevel": 64,
					"movespeed": 320,
					"armor": 28,
					"armorperlevel": 3.8,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 11.5,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 46,
					"attackdamageperlevel": 1.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.95
				},
				"spells": [
					{
						"id": "HowlingGale",
						"name": "Howling Gale",
						"description": "By creating a localized change in pressure and temperature, Janna is able to create a small storm that grows in size with time. She can activate the spell again to release the storm. On release this storm will fly towards the direction it was cast in, dealing damage and knocking away any enemies in its path.",
						"tooltip": "Summons a whirlwind, which deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in its path and knocks them into the air for {{ e4 }} seconds.<br /><br />The whirlwind can be charged up to {{ e6 }} seconds. For each second charged, it:<br /><li>Deals {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus damage<br />Knocks up for an additional {{ e5 }} seconds<br />Travels {{ e3 }}% further</li><br />Howling Gale always reaches its destination in {{ e8 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Activate again to release the whirlwind early.</span>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Damage Per Second Charged",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ e2 }} -> {{ e2NL }} ",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							60,
							80,
							100,
							120,
							140
						],
						"costBurn": "60/80/100/120/140",
						"effect": [
							null,
							[
								60,
								85,
								110,
								135,
								160
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/85/110/135/160",
							"15/20/25/30/35",
							"25",
							"0.5",
							"0.25",
							"3",
							"0",
							"1.5",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1700,
							1700,
							1700,
							1700,
							1700
						],
						"rangeBurn": "1700",
						"image": {
							"full": "HowlingGale.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SowTheWind",
						"name": "Zephyr",
						"description": "Janna summons an air elemental that passively increases her Movement Speed and enables her to pass through units. She may also activate this ability to deal damage and slow an enemy's Movement Speed. The passive is lost while this ability is on cooldown.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> While Zephyr is not on cooldown, Janna gains {{ e1 }}% <span class=\"color99FF99\">(+{{ f1 }}%)</span> Movement Speed and can move through units.<br /><br /><span class=\"colorFF9900\">Active: </span>Deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFFF673\">(+{{ f3 }})</span> magic damage to an enemy and slows their Movement Speed by {{ e3 }}% <span class=\"color99FF99\">(+{{ f2 }}%)</span> for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Passive Movement Speed",
								"Damage",
								"Slow Amount",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }} ",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								6,
								7,
								8,
								9,
								10
							],
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								24,
								28,
								32,
								36,
								40
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0.0002,
								0.0002,
								0.0002,
								0.0002,
								0.0002
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6/7/8/9/10",
							"60/105/150/195/240",
							"24/28/32/36/40",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.02,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.06,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "SowTheWind.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "EyeOfTheStorm",
						"name": "Eye Of The Storm",
						"description": "Janna conjures a defensive gale that shields an ally champion or turret from incoming damage and increases their Attack Damage.",
						"tooltip": "Shields an allied Champion or turret for {{ e3 }} seconds. The shield absorbs up to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage and grants {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Attack Damage until it breaks.",
						"leveltip": {
							"label": [
								"Shield Health",
								"Attack Damage Bonus",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								10,
								17.5,
								25,
								32.5,
								40
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"10/17.5/25/32.5/40",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "EyeOfTheStorm.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ReapTheWhirlwind",
						"name": "Monsoon",
						"description": "Janna surrounds herself in a magical storm, throwing enemies back. After the storm has settled, soothing winds heal nearby allies while the ability is active.",
						"tooltip": "Summons forth the might of the wind to knock surrounding enemies back and restores {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health to nearby allies each second for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Heal Per Second",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							150,
							135,
							120
						],
						"cooldownBurn": "150/135/120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								150,
								200
							],
							[
								300,
								450,
								600
							],
							[
								3,
								3,
								3
							],
							[
								700,
								700,
								700
							],
							[
								875,
								875,
								875
							],
							[
								875,
								875,
								875
							],
							[
								1200,
								1200,
								1200
							],
							[
								10,
								10,
								10
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/150/200",
							"300/450/600",
							"3",
							"700",
							"875",
							"875",
							"1200",
							"10",
							"0.5",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "ReapTheWhirlwind.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Tailwind",
					"description": "Janna passively gains 8% Movement Speed, and nearby allied champions gain this bonus when moving toward her.<br><br>Additionally, Janna's basic attacks cause additional magic damage based on her bonus Movement Speed.",
					"image": {
						"full": "Janna_Tailwind.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Janna",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									},
									{
										"id": "3151",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3041",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Janna",
						"title": "JannaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"JarvanIV": {
				"id": "JarvanIV",
				"key": "59",
				"name": "Jarvan IV",
				"title": "the Exemplar of Demacia",
				"image": {
					"full": "JarvanIV.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "59000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "59001",
						"num": 1,
						"name": "Commando Jarvan IV",
						"chromas": false
					},
					{
						"id": "59002",
						"num": 2,
						"name": "Dragonslayer Jarvan IV",
						"chromas": false
					},
					{
						"id": "59003",
						"num": 3,
						"name": "Darkforge Jarvan IV",
						"chromas": false
					},
					{
						"id": "59004",
						"num": 4,
						"name": "Victorious Jarvan IV",
						"chromas": false
					},
					{
						"id": "59005",
						"num": 5,
						"name": "Warring Kingdoms Jarvan IV",
						"chromas": false
					},
					{
						"id": "59006",
						"num": 6,
						"name": "Fnatic Jarvan IV",
						"chromas": false
					},
					{
						"id": "59007",
						"num": 7,
						"name": "Dark Star Jarvan IV",
						"chromas": false
					}
				],
				"lore": "Prince Jarvan, scion of the Lightshield dynasty, is heir apparent to the throne of Demacia. Raised to be a paragon of his nation's greatest virtues, he is forced to balance the heavy expectations placed upon him with his own desire to fight on the front lines. Jarvan inspires his troops with his fearsome courage and selfless determination, raising his family's colors high and revealing his true strength as a future leader of his people.",
				"blurb": "Prince Jarvan, scion of the Lightshield dynasty, is heir apparent to the throne of Demacia. Raised to be a paragon of his nation's greatest virtues, he is forced to balance the heavy expectations placed upon him with his own desire to fight on the front...",
				"allytips": [
					"You can use the Dragon Strike / Demacian Standard combo to get out of your own Cataclysm arenas.",
					"Split your basic attacks on different champions at the beginning of fights to maximize damage.",
					"Use Demacian Standard as a scouting tool when worried about incoming enemies."
				],
				"enemytips": [
					"Keep out of the path between Jarvan IV and his Demacian Standard to avoid being knocked up in the air.",
					"Cataclysm's terrain is a frightening force to fight against, but movement abilities can go through it."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 8,
					"magic": 3,
					"difficulty": 5
				},
				"stats": {
					"hp": 571.2,
					"hpperlevel": 90,
					"mp": 302.2,
					"mpperlevel": 40,
					"movespeed": 340,
					"armor": 34,
					"armorperlevel": 3.6,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.7,
					"mpregen": 6.756,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 3.4,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "JarvanIVDragonStrike",
						"name": "Dragon Strike",
						"description": "Jarvan IV extends his lance, dealing physical damage and lowering the Armor of enemies in its path. Additionally, this will pull Jarvan to his Demacian Standard, knocking up enemies in his path.",
						"tooltip": "Extends Jarvan IV's lance dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and lowering the Armor of enemies hit by {{ e2 }}% for {{ e3 }} seconds.<br /><br />If the lance contacts Demacian Standard it will pull Jarvan IV to its location, knocking up enemies in his path. This effect can be triggered even while immobilized.",
						"leveltip": {
							"label": [
								"Damage",
								"Armor Reduction",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								10,
								14,
								18,
								22,
								26
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"10/14/18/22/26",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							770,
							770,
							770,
							770,
							770
						],
						"rangeBurn": "770",
						"image": {
							"full": "JarvanIVDragonStrike.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JarvanIVGoldenAegis",
						"name": "Golden Aegis",
						"description": "Jarvan IV calls upon the ancient kings of Demacia to shield him from harm and slow surrounding enemies.",
						"tooltip": "Grants a shield that absorbs {{ e1 }} (<span class=\"colorCC3300\">+{{ f1 }}</span> [{{ e6 }}% max Health] for each nearby enemy champion) damage for {{ e4 }} seconds, and slows surrounding enemies by {{ e2 }}% for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Shield",
								"Bonus Shield Percent Health",
								"Slow Amount"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e6 }}% -> {{ e6NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								60,
								85,
								110,
								135,
								160
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								2,
								2.25,
								2.5,
								2.75,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/85/110/135/160",
							"15/20/25/30/35",
							"10/20/30/40/50",
							"5",
							"2",
							"2/2.25/2.5/2.75/3",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "JarvanIVGoldenAegis.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JarvanIVDemacianStandard",
						"name": "Demacian Standard",
						"description": "Jarvan IV carries the pride of Demacia, passively granting him bonus Attack Speed. Activating Demacian Standard allows Jarvan IV to place a Demacian flag that deals magic damage on impact and grants Attack Speed to nearby allied champions.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Gains {{ e3 }}% Attack Speed.<br /><br /><span class=\"colorFF9900\">Active:</span> Throws a Demacian Standard to a nearby area dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies. The Standard lasts for {{ e4 }} seconds and grants surrounding allied champions {{ e3 }}% Attack Speed.",
						"leveltip": {
							"label": [
								"Damage",
								"Passive Attack Speed",
								"Active Attack Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								" {{ e3 }}% -> {{ e3NL }}%",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12.5,
							12,
							11.5,
							11
						],
						"cooldownBurn": "13/12.5/12/11.5/11",
						"cost": [
							55,
							55,
							55,
							55,
							55
						],
						"costBurn": "55",
						"effect": [
							null,
							[
								10,
								13,
								16,
								19,
								22
							],
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0.15,
								0.025,
								0.025,
								0.025,
								0.025
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/13/16/19/22",
							"60/105/150/195/240",
							"15/17.5/20/22.5/25",
							"8",
							"0.15/0.025/0.025/0.025/0.025",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							860,
							860,
							860,
							860,
							860
						],
						"rangeBurn": "860",
						"image": {
							"full": "JarvanIVDemacianStandard.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JarvanIVCataclysm",
						"name": "Cataclysm",
						"description": "Jarvan IV heroically leaps into battle at a target with such force that he terraforms the surrounding area to create an arena around them. Nearby enemies are damaged at the moment of impact.",
						"tooltip": "Heroically leaps to an enemy Champion dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and creating an arena of impassable terrain around them for {{ e2 }} seconds.<br /><br />Activate again to collapse the terrain.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								200,
								325,
								450
							],
							[
								3.5,
								3.5,
								3.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/325/450",
							"3.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "JarvanIVCataclysm.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Martial Cadence",
					"description": "Jarvan IV's initial basic attack on a target deals bonus physical damage. This effect cannot occur again on the same target for a short duration.",
					"image": {
						"full": "JarvanIV_MartialCadence.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "JarvanIV",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "3044",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3044",
										"count": 1
									},
									{
										"id": "3057",
										"count": 1
									},
									{
										"id": "3086",
										"count": 1
									},
									{
										"id": "3078",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3105",
										"count": 1
									},
									{
										"id": "3071",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									},
									{
										"id": "3068",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "JarvanIV",
						"title": "JarvanIVTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Jax": {
				"id": "Jax",
				"key": "24",
				"name": "Jax",
				"title": "Grandmaster at Arms",
				"image": {
					"full": "Jax.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "24000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "24001",
						"num": 1,
						"name": "The Mighty Jax",
						"chromas": false
					},
					{
						"id": "24002",
						"num": 2,
						"name": "Vandal Jax",
						"chromas": false
					},
					{
						"id": "24003",
						"num": 3,
						"name": "Angler Jax",
						"chromas": false
					},
					{
						"id": "24004",
						"num": 4,
						"name": "PAX Jax",
						"chromas": false
					},
					{
						"id": "24005",
						"num": 5,
						"name": "Jaximus",
						"chromas": false
					},
					{
						"id": "24006",
						"num": 6,
						"name": "Temple Jax",
						"chromas": false
					},
					{
						"id": "24007",
						"num": 7,
						"name": "Nemesis Jax",
						"chromas": true
					},
					{
						"id": "24008",
						"num": 8,
						"name": "SKT T1 Jax",
						"chromas": false
					},
					{
						"id": "24012",
						"num": 12,
						"name": "Warden Jax",
						"chromas": false
					},
					{
						"id": "24013",
						"num": 13,
						"name": "God Staff Jax",
						"chromas": false
					}
				],
				"lore": "Unmatched in both his skill with unique armaments and his biting sarcasm, Jax is the last known weapons master of Icathia. After his homeland was laid low by its own hubris in unleashing the Void, Jax and his kind vowed to protect what little remained. As magic now rises in the world, this slumbering threat stirs once more, and Jax roams Valoran, wielding the last light of Icathia and testing all warriors he meets to see if any are strong enough to stand beside him...",
				"blurb": "Unmatched in both his skill with unique armaments and his biting sarcasm, Jax is the last known weapons master of Icathia. After his homeland was laid low by its own hubris in unleashing the Void, Jax and his kind vowed to protect what little remained...",
				"allytips": [
					"Jax can Leap Strike to friendly units, including wards. You can use them to plan your escape.",
					"Jax benefits greatly from items that have both Ability Power and Attack Damage such as Guinsoo's Rageblade and Hextech Gunblade."
				],
				"enemytips": [
					"Try to engage him in short bursts instead of going toe-to-toe with him. Preventing him from attacking consecutively drastically lowers his damage output.",
					"Jax can dodge all incoming attacks for a very short amount of time and stuns enemies in melee range when it ends. Wait to strike him until after his dodge is finished."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 5,
					"magic": 7,
					"difficulty": 5
				},
				"stats": {
					"hp": 592.8,
					"hpperlevel": 85,
					"mp": 338.8,
					"mpperlevel": 32,
					"movespeed": 350,
					"armor": 36,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.55,
					"mpregen": 7.576,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 69.97,
					"attackdamageperlevel": 3.375,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 3.4
				},
				"spells": [
					{
						"id": "JaxLeapStrike",
						"name": "Leap Strike",
						"description": "Jax leaps toward a unit. If they are an enemy, he strikes them with his weapon.",
						"tooltip": "Jax leaps to target unit, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage if it is an enemy.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							65,
							65,
							65,
							65,
							65
						],
						"costBurn": "65",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "JaxLeapStrike.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JaxEmpowerTwo",
						"name": "Empower",
						"description": "Jax charges his weapon with energy, causing his next attack to deal additional damage.",
						"tooltip": "Jax charges his weapon with energy, causing his next basic attack or Leap Strike to deal an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }}) </span>Magic Damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6,
							5,
							4,
							3
						],
						"cooldownBurn": "7/6/5/4/3",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								40,
								75,
								110,
								145,
								180
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/75/110/145/180",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "JaxEmpowerTwo.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JaxCounterStrike",
						"name": "Counter Strike",
						"description": "Jax's combat prowess allows him to dodge all incoming attacks for a short duration and then quickly counterattack, stunning all surrounding enemies.",
						"tooltip": "Jax enters a defensive stance for up to {{ e6 }} seconds, dodging all incoming basic attacks and taking {{ e3 }}% less damage from area of effect abilities.<br /><br />After 2 seconds or if activated again, Jax stuns surrounding enemies for {{ e2 }} second and deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage to them.<br /><br /><span class=\"color99FF99\">Counter Strike deals {{ e5 }}% more damage for each attack Jax dodged (max: {{ e4 }}% increased damage).</span>",
						"leveltip": {
							"label": [
								"Cooldown",
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }} "
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14,
							12,
							10,
							8
						],
						"cooldownBurn": "16/14/12/10/8",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								55,
								80,
								105,
								130,
								155
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/80/105/130/155",
							"1",
							"25",
							"100",
							"20",
							"2",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "JaxCounterStrike.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JaxRelentlessAssault",
						"name": "Grandmaster's Might",
						"description": "Every third consecutive attack deals additional Magic Damage. Additionally, Jax can activate this ability to strengthen his resolve, increasing his Armor and Magic Resist for a short duration.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Every third consecutive strike Jax deals {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }}) </span>additional Magic Damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Jax strengthens his resolve, granting him <span class=\"colorFF8C00\">{{ f2 }}</span> Armor and <span class=\"color99FF99\">{{ f1 }}</span> Magic Resist for {{ e5 }} seconds.<span class=\"colorFF8C00\"><br /><br />Armor bonus is equal to {{ e3 }} + {{ e6 }}% bonus Attack Damage.</span><span class=\"color99FF99\"><br />Magic Resist bonus is equal to {{ e3 }} + {{ e7 }}% Ability Power.</span>",
						"leveltip": {
							"label": [
								"Passive Damage",
								"Armor Bonus",
								"Magic Resist Bonus"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e3 }} -> {{ e3NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							80,
							80,
							80
						],
						"cooldownBurn": "80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								160,
								220
							],
							[
								3,
								3,
								3
							],
							[
								30,
								50,
								70
							],
							[
								6,
								8,
								10
							],
							[
								8,
								8,
								8
							],
							[
								50,
								50,
								50
							],
							[
								20,
								20,
								20
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/160/220",
							"3",
							"30/50/70",
							"6/8/10",
							"8",
							"50",
							"20",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "@special.jaxrarmor",
								"coeff": 0.3,
								"key": "f2"
							},
							{
								"link": "@special.jaxrmr",
								"coeff": 0.2,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							100,
							100,
							100
						],
						"rangeBurn": "100",
						"image": {
							"full": "JaxRelentlessAssault.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Relentless Assault",
					"description": "Jax's consecutive basic attacks continuously increase his Attack Speed.",
					"image": {
						"full": "Armsmaster_MasterOfArms.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Jax",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "3044",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3044",
										"count": 1
									},
									{
										"id": "3057",
										"count": 1
									},
									{
										"id": "3086",
										"count": 1
									},
									{
										"id": "3078",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3124",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									},
									{
										"id": "3083",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jax",
						"title": "JaxTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Jayce": {
				"id": "Jayce",
				"key": "126",
				"name": "Jayce",
				"title": "the Defender of Tomorrow",
				"image": {
					"full": "Jayce.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "126000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "126001",
						"num": 1,
						"name": "Full Metal Jayce",
						"chromas": false
					},
					{
						"id": "126002",
						"num": 2,
						"name": "Debonair Jayce",
						"chromas": false
					},
					{
						"id": "126003",
						"num": 3,
						"name": "Forsaken Jayce",
						"chromas": false
					},
					{
						"id": "126004",
						"num": 4,
						"name": "Jayce Brighthammer",
						"chromas": false
					}
				],
				"lore": "Jayce is a brilliant inventor who has pledged his life to the defense of Piltover and its unyielding pursuit of progress. With his transforming hextech hammer in hand, Jayce uses his strength, courage, and considerable intelligence to protect his hometown. While revered throughout the city as a hero, he hasn't taken well to the attention heroism brings. Still, Jayce's heart is in the right place, and even those who envy his natural skills are grateful for his protection in the City of Progress.",
				"blurb": "Jayce is a brilliant inventor who has pledged his life to the defense of Piltover and its unyielding pursuit of progress. With his transforming hextech hammer in hand, Jayce uses his strength, courage, and considerable intelligence to protect his...",
				"allytips": [
					"Be sure to switch stances often. It will enhance your attacks and grant you quick bursts of speed.",
					"If you find yourself taking lots of damage, try using Jayce's Hammer Stance, as it grants you additional defenses.",
					"For increased range and damage, try casting Shock Blast through the Acceleration Gate."
				],
				"enemytips": [
					"Jayce can attack in melee or at range. Pay attention to his stance and weapon color to know how he is going to attack.",
					"If you see Jayce drop his Acceleration Gate, be careful, he is probably about to cast Shock Blast.",
					"Jayce is strong in the early game. If he gains the advantage, play defensively."
				],
				"tags": [
					"Fighter",
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 4,
					"magic": 3,
					"difficulty": 7
				},
				"stats": {
					"hp": 576,
					"hpperlevel": 95,
					"mp": 357.2,
					"mpperlevel": 37,
					"movespeed": 335,
					"armor": 27,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 125,
					"hpregen": 7.5,
					"hpregenperlevel": 0.8,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 58,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "JayceToTheSkies",
						"name": "To the Skies! / Shock Blast",
						"description": "Hammer Stance: Leaps to an enemy dealing physical damage and slowing enemies.<br><br>Cannon Stance: Fires an orb of electricity that detonates upon hitting an enemy (or reaching the end of its path) dealing physical damage to all enemies hit.",
						"tooltip": "Leaps to an enemy dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and slowing them by {{ e3 }}% for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Slow"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 6,
						"cooldown": [
							16,
							14,
							12,
							10,
							8,
							6
						],
						"cooldownBurn": "16/14/12/10/8/6",
						"cost": [
							40,
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								45,
								80,
								115,
								150,
								185,
								220
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5,
								2
							],
							[
								30,
								35,
								40,
								45,
								50,
								55
							],
							[
								20,
								40,
								60,
								80,
								0,
								0
							],
							[
								2,
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"45/80/115/150/185/220",
							"1.5/1.5/1.5/1.5/1.5/2",
							"30/35/40/45/50/55",
							"20/40/60/80/0/0",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "JayceToTheSkies.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JayceStaticField",
						"name": "Lightning Field / Hyper Charge",
						"description": "Hammer Stance: Passive: Restores Mana per strike. Active: Creates a field of lightning damaging nearby enemies for several seconds.<br><br>Cannon Stance: Gains a burst of energy, increasing Attack Speed to maximum for several attacks.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Gains {{ e5 }} Mana per strike while in Hammer Stance.<br /><br /><span class=\"colorFF9900\">Active:</span> Creates an electric aura dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e2 }} seconds to nearby enemies.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Return"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e5 }} -> {{ e5NL }}"
							]
						},
						"maxrank": 6,
						"cooldown": [
							10,
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							40,
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								25,
								35,
								45,
								55,
								65,
								75
							],
							[
								4,
								4,
								4,
								4,
								4,
								4
							],
							[
								25,
								30,
								35,
								40,
								45,
								50
							],
							[
								100,
								160,
								220,
								280,
								340,
								400
							],
							[
								6,
								8,
								10,
								12,
								14,
								16
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/35/45/55/65/75",
							"4",
							"25/30/35/40/45/50",
							"100/160/220/280/340/400",
							"6/8/10/12/14/16",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							285,
							285,
							285,
							285,
							285,
							285
						],
						"rangeBurn": "285",
						"image": {
							"full": "JayceStaticField.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JayceThunderingBlow",
						"name": "Thundering Blow / Acceleration Gate",
						"description": "Hammer Stance: Deals magic damage to an enemy and knocks them back a short distance.<br><br>Cannon Stance: Deploys an Acceleration Gate increasing the Movement Speed of all allied champions who pass through it. If Shock Blast is fired through the gate the missile speed, range, and damage will increase.",
						"tooltip": "Deals {{ e4 }}% of the target's maximum health <span class=\"colorFF8C00\">(+{{ a1 }})</span> as magic damage and knocks them back a short distance. ({{ e1 }} Maximum Damage against monsters)",
						"leveltip": {
							"label": [
								"Maximum Health %",
								"Cooldown",
								"Maximum Damage against monsters"
							],
							"effect": [
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 6,
						"cooldown": [
							20,
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "20/18/16/14/12/10",
						"cost": [
							55,
							55,
							55,
							55,
							55,
							55
						],
						"costBurn": "55",
						"effect": [
							null,
							[
								200,
								300,
								400,
								500,
								600,
								700
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								10,
								20,
								30,
								40,
								50,
								60
							],
							[
								8,
								10.4,
								12.8,
								15.2,
								17.6,
								20
							],
							[
								40,
								70,
								100,
								130,
								160,
								190
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/300/400/500/600/700",
							"0.25",
							"10/20/30/40/50/60",
							"8/10.4/12.8/15.2/17.6/20",
							"40/70/100/130/160/190",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							240,
							240,
							240,
							240,
							240,
							240
						],
						"rangeBurn": "240",
						"image": {
							"full": "JayceThunderingBlow.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JayceStanceHtG",
						"name": "Mercury Cannon / Mercury Hammer",
						"description": "Hammer Stance: Transforms the Mercury Hammer into the Mercury Cannon gaining new abilities and increased range. The first attack in this form reduces the target's Armor and Magic Resist.<br><br>Cannon Stance: Transforms the Mercury Cannon into the Mercury Hammer gaining new abilities and increasing Armor and Magic Resist. The first attack in this form deals additional magic damage.",
						"tooltip": "<span class=\"colorFF8C00\">Active: </span>Transforms the Mercury Hammer into the Mercury Cannon gaining new abilities and ranged attacks.<br /><br />The next attack in Cannon Stance reduces the target's Armor and Magic Resist by {{ f3 }}% for {{ e3 }} seconds.",
						"maxrank": 1,
						"cooldown": [
							6
						],
						"cooldownBurn": "6",
						"cost": [
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								5
							],
							[
								10
							],
							[
								5
							],
							[
								5
							],
							[
								20
							],
							[
								0
							],
							[
								0
							],
							[
								0
							],
							[
								0
							],
							[
								0
							]
						],
						"effectBurn": [
							null,
							"5",
							"10",
							"5",
							"5",
							"20",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "JayceStanceHtG.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Hextech Capacitor",
					"description": "After casting Transform Jayce gains 40 Movement Speed and can move through units for the next 1.25 seconds.",
					"image": {
						"full": "Jayce_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Jayce",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3008",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3155",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jayce",
						"title": "JayceTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Jhin": {
				"id": "Jhin",
				"key": "202",
				"name": "Jhin",
				"title": "the Virtuoso",
				"image": {
					"full": "Jhin.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "202000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "202001",
						"num": 1,
						"name": "High Noon Jhin",
						"chromas": false
					},
					{
						"id": "202002",
						"num": 2,
						"name": "Blood Moon Jhin",
						"chromas": false
					},
					{
						"id": "202003",
						"num": 3,
						"name": "SKT T1 Jhin",
						"chromas": false
					},
					{
						"id": "202004",
						"num": 4,
						"name": "PROJECT: Jhin",
						"chromas": false
					}
				],
				"lore": "Jhin is a meticulous criminal psychopath who believes murder is art. Once an Ionian prisoner, but freed by shadowy elements within Ionia's ruling council, the serial killer now works as their cabal's assassin. Using his gun as his paintbrush, Jhin creates works of artistic brutality, horrifying victims and onlookers. He gains a cruel pleasure from putting on his gruesome theater, making him the ideal choice to send the most powerful of messages: terror.",
				"blurb": "Jhin is a meticulous criminal psychopath who believes murder is art. Once an Ionian prisoner, but freed by shadowy elements within Ionia's ruling council, the serial killer now works as their cabal's assassin. Using his gun as his paintbrush, Jhin...",
				"allytips": [
					"Deadly Flourish has incredible range. When approaching a fight be sure to look ahead for enemies that could be rooted.",
					"Your ultimate deals significantly less damage to enemies with full health. Look to pick off weakened targets as they run away.",
					"You can still cast your spells while reloading. Use them to fill the down time."
				],
				"enemytips": [
					"Deadly Flourish only roots those hit by one of Jhin's basic attacks, traps, or allies within the last 4 seconds.",
					"Jhin places invisible traps around the map. Watch where you step!",
					"Jhin's attacks are quite potent, but he runs out of ammo after the 4th shot. Use this window to jump him and burst him down."
				],
				"tags": [
					"Marksman",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 10,
					"defense": 2,
					"magic": 6,
					"difficulty": 6
				},
				"stats": {
					"hp": 540,
					"hpperlevel": 85,
					"mp": 300,
					"mpperlevel": 50,
					"movespeed": 330,
					"armor": 29,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61,
					"attackdamageperlevel": 4,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 0
				},
				"spells": [
					{
						"id": "JhinQ",
						"name": "Dancing Grenade",
						"description": "Jhin launches a magical cartridge at an enemy. It can hit up to four targets and gains damage each time it kills.",
						"tooltip": "Jhin launches a cartridge at the targeted enemy that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }}) </span>physical damage before bouncing to a nearby target that has not yet been hit.<br /><br />The cartridge can hit a maximum of 4 times. Each kill by the cartridge increases the damage of subsequent hits by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Total AD Ratio",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								45,
								70,
								95,
								120,
								145
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								0.4,
								0.45,
								0.5,
								0.55,
								0.6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"45/70/95/120/145",
							"35",
							"0.4/0.45/0.5/0.55/0.6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "JhinQ.png",
							"sprite": "spell4.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JhinW",
						"name": "Deadly Flourish",
						"description": "Jhin brandishes his cane, firing a single shot with incredible range. It pierces through minions and monsters, but stops on the first champion hit. If the target was recently struck by Jhin's allies, lotus traps, or basic attacks, they are rooted.",
						"tooltip": "Jhin fires a long range shot that stops on the first champion hit, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to it, and {{ e4 }}% of that damage to minions and monsters hit along the way.<br /><br />If Deadly Flourish strikes a champion that has been hit by one of Jhin's basic attacks, Lotus Traps, or allies within the last 4 seconds it will root them for {{ e2 }} seconds and grants Jhin movement speed as though he had <span class=\"colorFF5802\">crit</span> them.",
						"leveltip": {
							"label": [
								"Damage",
								"Root Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							14,
							14,
							14,
							14
						],
						"cooldownBurn": "14",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								50,
								85,
								120,
								155,
								190
							],
							[
								0.75,
								1,
								1.25,
								1.5,
								1.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/85/120/155/190",
							"0.75/1/1.25/1.5/1.75",
							"0",
							"75",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3000,
							3000,
							3000,
							3000,
							3000
						],
						"rangeBurn": "3000",
						"image": {
							"full": "JhinW.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JhinE",
						"name": "Captive Audience",
						"description": "Jhin places an invisible lotus trap that blooms when walked over. It slows nearby enemies before dealing damage with an explosion of serrated petals. <br><br><font color='#FFFFFF'>Beauty in Death -</font> When Jhin kills an enemy champion, a lotus trap will bloom near their corpse.",
						"tooltip": "Jhin places an invisible Lotus Trap that lasts {{ e5 }} minutes and activates when stepped on, revealing nearby enemies for 4 seconds.<br /><br />The trap leaves behind a zone that slows enemies inside by {{ e7 }}% and detonates after 2 seconds, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage ({{ e1 }}% damage on subsequent hits and vs. minions and monsters).<br /><br />Jhin prepares a new trap every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can store 2 at once. <br /><br /><span class=\"colorFFFFFF\">Beauty in Death -</span> When Jhin kills an enemy champion a Lotus Trap will spawn and detonate where they were killed.",
						"leveltip": {
							"label": [
								"Damage",
								"Recharge Time",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ f1 }} -> {{ f2 }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							2,
							2,
							2,
							2,
							2
						],
						"cooldownBurn": "2",
						"cost": [
							30,
							35,
							40,
							45,
							50
						],
						"costBurn": "30/35/40/45/50",
						"effect": [
							null,
							[
								65,
								65,
								65,
								65,
								65
							],
							[
								20,
								80,
								140,
								200,
								260
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65",
							"20/80/140/200/260",
							"0",
							"0.75",
							"2",
							"0",
							"35",
							"1",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "JhinE.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JhinR",
						"name": "Curtain Call",
						"description": "Jhin channels, transforming Whisper into a shoulder-mounted mega-cannon. It is able to fire 4 super shots at extreme range that pierce through minions and monsters, but stop on the first champion impacted. Whisper cripples enemies hit, which slows them and deals execute damage. The 4th shot is perfectly crafted, epically powerful, and guaranteed to critically strike.",
						"tooltip": "Jhin sets up and channels, enabling him to fire 4 super shots at extreme range in a cone in front of him. The shots stop on the first champion hit, slowing it by {{ e3 }}% for {{ e4 }} seconds and dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage, increased by {{ e5 }}% for each 1% health the target is missing (up to {{ f2 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span>). The 4th shot <span class=\"colorFF5802\">crits</span> for <span class=\"colorFFFFFF\">{{ f1 }}%</span> damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								50,
								125,
								200
							],
							[
								200,
								200,
								200
							],
							[
								80,
								80,
								80
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								1,
								1,
								1
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/125/200",
							"200",
							"80",
							"0.5",
							"2.5",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "JhinR.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Whisper",
					"description": "Jhin's hand cannon, Whisper, is a precise instrument designed to deal superior damage. It fires at a fixed rate and carries only four shots. Jhin imbues the final bullet with dark magics to critically strike and deal bonus execute damage. Whenever Whisper crits, it inspires Jhin with a burst of movement speed.",
					"image": {
						"full": "Jhin_P.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Jhin",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jhin",
						"title": "JhinTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Jinx": {
				"id": "Jinx",
				"key": "222",
				"name": "Jinx",
				"title": "the Loose Cannon",
				"image": {
					"full": "Jinx.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "222000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "222001",
						"num": 1,
						"name": "Mafia Jinx",
						"chromas": false
					},
					{
						"id": "222002",
						"num": 2,
						"name": "Firecracker Jinx",
						"chromas": true
					},
					{
						"id": "222003",
						"num": 3,
						"name": "Slayer Jinx",
						"chromas": false
					},
					{
						"id": "222004",
						"num": 4,
						"name": "Star Guardian Jinx",
						"chromas": false
					},
					{
						"id": "222012",
						"num": 12,
						"name": "Ambitious Elf Jinx",
						"chromas": false
					}
				],
				"lore": "A manic and impulsive criminal from Zaun, Jinx lives to wreak havoc without care for the consequences. With an arsenal of deadly weapons, she unleashes the loudest blasts and brightest explosions to leave a trail of mayhem and panic in her wake. Jinx despises boredom, and gleefully brings her own chaotic brand of pandemonium wherever she goes.",
				"blurb": "A manic and impulsive criminal from Zaun, Jinx lives to wreak havoc without care for the consequences. With an arsenal of deadly weapons, she unleashes the loudest blasts and brightest explosions to leave a trail of mayhem and panic in her wake. Jinx...",
				"allytips": [
					"Rockets aren't always the best choice! Jinx's minigun is incredibly powerful when fully ramped up. Switch to it whenever an enemy champion gets too close.",
					"Jinx's rockets deal full damage to all enemies in the explosion. Use them on minions in lane to hit nearby enemy champions without drawing minion aggro.",
					"When a fight starts try to stay on the edge of fray by poking with rockets and Zap!. Do not run in and unload with the minigun until you feel it is safe."
				],
				"enemytips": [
					"Jinx's minigun takes time to ramp up. If you see her poking with rockets try to jump on her and burst her down.",
					"Jinx's ultimate does less damage the closer you are to her.",
					"Jinx's snare grenades have a long cooldown and are her primary means of protecting herself. If she misses with them she will have a hard time escaping if engaged upon. "
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 2,
					"magic": 4,
					"difficulty": 6
				},
				"stats": {
					"hp": 515,
					"hpperlevel": 82,
					"mp": 245,
					"mpperlevel": 45,
					"movespeed": 325,
					"armor": 32,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 6,
					"hpregenperlevel": 0.5,
					"mpregen": 6.7,
					"mpregenperlevel": 1,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61,
					"attackdamageperlevel": 2.7,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1
				},
				"spells": [
					{
						"id": "JinxQ",
						"name": "Switcheroo!",
						"description": "Jinx modifies her basic attacks by swapping between Pow-Pow, her minigun and Fishbones, her rocket launcher. Attacks with Pow-Pow grant Attack Speed, while attacks with Fishbones deal area of effect damage, gain increased range, and drain Mana.",
						"tooltip": "Jinx swaps weapons.<br /><br /><span class=\"colorFF9900\">Fishbones, the Rocket Launcher:</span> Basic attacks deal 110% Damage to the target and nearby enemies, gain {{ e3 }} range, drain Mana, and scale {{ e5 }}% less with bonus Attack Speed.<br /><br /><span class=\"colorFF9900\">Pow-Pow, the Minigun:</span> Basic attacks grant bonus Attack Speed for 2.5 seconds. This effect stacks up to 3 times for a total bonus of {{ e1 }}%.<br /><br /><rules>Stacks fall off one at a time and only benefit Jinx's first attack after switching to Rocket Launcher.</rules>",
						"leveltip": {
							"label": [
								"Rocket Bonus Range",
								"Minigun Total Attack Speed"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1,
							1,
							1,
							1,
							1
						],
						"cooldownBurn": "1",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								30,
								55,
								80,
								105,
								130
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								75,
								100,
								125,
								150,
								175
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								33.25,
								33.25,
								33.25,
								33.25,
								33.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/55/80/105/130",
							"100",
							"75/100/125/150/175",
							"0",
							"25",
							"33.25",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana per Rocket",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "JinxQ.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana per Rocket"
					},
					{
						"id": "JinxW",
						"name": "Zap!",
						"description": "Jinx uses Zapper, her shock pistol, to fire a blast that deals damage to the first enemy hit, slowing and revealing it.",
						"tooltip": "Jinx fires a shock blast that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage to the first enemy hit, revealing it and slowing it by {{ e2 }}% for 2 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7,
							6,
							5,
							4
						],
						"cooldownBurn": "8/7/6/5/4",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								10,
								60,
								110,
								160,
								210
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/60/110/160/210",
							"30/40/50/60/70",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1450,
							1450,
							1450,
							1450,
							1450
						],
						"rangeBurn": "1450",
						"image": {
							"full": "JinxW.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JinxE",
						"name": "Flame Chompers!",
						"description": "Jinx throws out a line of snare grenades that explode after 5 seconds, lighting enemies on fire. Flame Chompers will bite enemy champions who walk over them, rooting them in place.",
						"tooltip": "Jinx tosses out 3 chompers that, once armed, explode on contact with enemy champions, rooting the target for 1.5 seconds and stopping in-progress movement abilities on the spot before dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage over 1.5 seconds to nearby enemies. Chompers last for 5 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							20.5,
							17,
							13.5,
							10
						],
						"cooldownBurn": "24/20.5/17/13.5/10",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								70,
								120,
								170,
								220,
								270
							],
							[
								100,
								140,
								180,
								220,
								260
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								35,
								50,
								65,
								80,
								95
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/120/170/220/270",
							"100/140/180/220/260",
							"30/35/40/45/50",
							"35/50/65/80/95",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "JinxE.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JinxR",
						"name": "Super Mega Death Rocket!",
						"description": "Jinx fires a super rocket across the map that gains damage as it travels. The rocket will explode upon colliding with an enemy champion, dealing damage to it and surrounding enemies based on their missing Health. ",
						"tooltip": "Jinx fires a rocket that gains damage over the first second it travels. It explodes on the first enemy champion hit, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> to {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> Physical Damage plus {{ e3 }}% of the target's missing Health. Nearby enemies take 80% Damage.",
						"leveltip": {
							"label": [
								"Minimum Damage",
								"Maximum Damage",
								"Percent Missing Health Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							90,
							75,
							60
						],
						"cooldownBurn": "90/75/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								25,
								35,
								45
							],
							[
								250,
								350,
								450
							],
							[
								25,
								30,
								35
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/35/45",
							"250/350/450",
							"25/30/35",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.15,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1.5,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "JinxR.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Get Excited!",
					"description": "Jinx receives massively increased Movement Speed and stacking Attack Speed whenever she damages an enemy champion, tower, or inhibitor that is then killed or destroyed within 3 seconds.",
					"image": {
						"full": "Jinx_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Jinx",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Jinx",
						"title": "JinxTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2015",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Kalista": {
				"id": "Kalista",
				"key": "429",
				"name": "Kalista",
				"title": "the Spear of Vengeance",
				"image": {
					"full": "Kalista.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "429000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "429001",
						"num": 1,
						"name": "Blood Moon Kalista",
						"chromas": false
					},
					{
						"id": "429002",
						"num": 2,
						"name": "Championship Kalista",
						"chromas": false
					},
					{
						"id": "429003",
						"num": 3,
						"name": "SKT T1 Kalista",
						"chromas": false
					}
				],
				"lore": "A specter of wrath and retribution, Kalista is the undying spirit of vengeance, an armored nightmare summoned from the Shadow Isles to hunt deceivers and traitors. The betrayed may cry out in blood to be avenged, but Kalista only answers those willing to pay with their very souls. Those who become the focus of Kalista's wrath should make their final peace, for any pact sealed with this grim hunter can only end with the cold, piercing fire of her soul-spears.",
				"blurb": "A specter of wrath and retribution, Kalista is the undying spirit of vengeance, an armored nightmare summoned from the Shadow Isles to hunt deceivers and traitors. The betrayed may cry out in blood to be avenged, but Kalista only answers those willing...",
				"allytips": [
					"Rend is a valuable last hitting aid, since its cooldown resets if it kills a target. ",
					"Entering a move order once to trigger Martial Poise will not clear Kalista's basic attack target.",
					"Due to her passive, Kalista's Movement Speed is effectively increased by Attack Speed."
				],
				"enemytips": [
					"Kalista's mobility is dependent upon attacking. This means it is low when she is outside of her attack range and that Attack Speed slows reduce the amount of distance she can cover in an engagement.",
					"Kalista cannot cancel her basic attack wind up. While she is very mobile, this offers a window to land spells on her if you anticipate when she will begin attacking.",
					"If you can break line of sight from Kalista, including through brush, her basic attacks will miss you, falling harmlessly to the ground."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 2,
					"magic": 4,
					"difficulty": 7
				},
				"stats": {
					"hp": 517.76,
					"hpperlevel": 83,
					"mp": 231.8,
					"mpperlevel": 35,
					"movespeed": 325,
					"armor": 28,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 6,
					"hpregenperlevel": 0.55,
					"mpregen": 6.3,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 2.9,
					"attackspeedoffset": -0.1,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "KalistaMysticShot",
						"name": "Pierce",
						"description": "Throw a fast moving spear that passes through enemies it kills.",
						"tooltip": "Hurl a fast but narrow spear that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. Triggers <span class=\"colorFFFFFF\"><i>Martial Poise</i> (P)</span>, <span class=\"colorFFFFFF\"><i>Sentinel</i> (W)</span>, and <span class=\"colorFFFFFF\"><i>Rend</i> (E)</span>.<br /><br /><span class=\"colorFFFF00\">If it kills a target, </span><span class=\"colorFFFFFF\"><i>Pierce</i></span><span class=\"colorFFFF00\"> continues onward, passing all stacks of <span class=\"colorFFFFFF\"><i>Rend</i></span> to the next target.</span>",
						"leveltip": {
							"label": [
								"Mana Cost",
								"Damage"
							],
							"effect": [
								"{{ cost }} -> {{ costNL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								10,
								70,
								130,
								190,
								250
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/70/130/190/250",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1150,
							1150,
							1150,
							1150,
							1150
						],
						"rangeBurn": "1150",
						"image": {
							"full": "KalistaMysticShot.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KalistaW",
						"name": "Sentinel",
						"description": "Passively gain Attack Damage when near her Oathsworn ally, and deal bonus damage when striking the same target. <br><br>Activate to send a soul to scout out the path, revealing the area in front of it.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>When Kalista is near her <i>Oathsworn</i>, she gains {{ e8 }} Attack Damage. If they both basic attack the same target, she deals {{ e2 }}% of their max health as magic damage. {{ e7 }} second cooldown per target.<br /><br /><span class=\"colorFF9900\">Active: </span>Send a soul Sentinel to patrol an unseen area. Champions spotted are revealed for 4 seconds. Sentinels last 3 laps.<br /><br />Kalista gains a charge of Sentinel every {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Passive Attack Damage",
								"Damage",
								"Ammo Recharge"
							],
							"effect": [
								"{{ e8 }} -> {{ e8NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e4 }} -> {{ e4NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							30,
							30,
							30,
							30,
							30
						],
						"cooldownBurn": "30",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								5,
								7.5,
								10,
								12.5,
								15
							],
							[
								125,
								150,
								175,
								200,
								225
							],
							[
								90,
								80,
								70,
								60,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								75,
								100,
								125,
								150,
								175
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								5,
								10,
								15,
								20,
								25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80",
							"5/7.5/10/12.5/15",
							"125/150/175/200/225",
							"90/80/70/60/50",
							"0",
							"75/100/125/150/175",
							"10",
							"5/10/15/20/25",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							5000,
							5000,
							5000,
							5000,
							5000
						],
						"rangeBurn": "5000",
						"image": {
							"full": "KalistaW.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KalistaExpungeWrapper",
						"name": "Rend",
						"description": "Attacks impale their targets with spears. Activate to rip the spears out, slowing and dealing escalating damage.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Kalista's spears pierce their target, lingering for 4 seconds.<br /><br /><span class=\"colorFF9900\">Active: </span>Rip the spears from nearby targets, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slowing their Movement Speed by {{ e2 }}% for {{ e6 }} seconds.</span><br /><br /><span class=\"colorFFFF00\">If </span><span class=\"colorFFFFFF\"><i>Rend</i></span><span class=\"colorFFFF00\"> kills at least one target, its cooldown is reset and it refunds <span class=\"color44DDFF\">{{ e8 }}</span> mana.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Mana Refund",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e8 }} -> {{ e8NL }}",
								"{{ e5 }} -> {{ e5NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								33,
								37.5,
								41.667,
								45.833,
								50
							],
							[
								14,
								12.5,
								11,
								9.5,
								8
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								254,
								254,
								254,
								254,
								254
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								10,
								14,
								19,
								25,
								32
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"25/30/35/40/45",
							"0",
							"33/37.5/41.667/45.833/50",
							"14/12.5/11/9.5/8",
							"2",
							"254",
							"10/15/20/25/30",
							"10/14/19/25/32",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "KalistaExpungeWrapper.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KalistaRx",
						"name": "Fate's Call",
						"description": "Kalista teleports the Oathsworn ally to herself. They gain the ability to dash toward a position, knocking enemy champions back.",
						"tooltip": "Draw Kalista's <i>Oathsworn</i> to her. For up to 4 seconds, the Oathsworn is untargetable and pacified.<br /><br />The Oathsworn may mouse click to fly toward target position, stopping at the first enemy champion hit and knocking all enemies in a small radius back.<br /><br />Kalista's Oathsworn must be within 1100 units for her to cast this ability.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Knock Up Duration"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							150,
							120,
							90
						],
						"cooldownBurn": "150/120/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								0,
								0,
								0
							],
							[
								1.5,
								1.75,
								2
							],
							[
								40,
								60,
								80
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"1.5/1.75/2",
							"40/60/80",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "KalistaRx.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Martial Poise",
					"description": "Enter a movement command while winding up Kalista's basic attack or Pierce to lunge a short distance when she launches her attack.",
					"image": {
						"full": "Kalista_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kalista",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kalista",
						"title": "KalistaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Karma": {
				"id": "Karma",
				"key": "43",
				"name": "Karma",
				"title": "the Enlightened One",
				"image": {
					"full": "Karma.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "43000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "43001",
						"num": 1,
						"name": "Sun Goddess Karma",
						"chromas": false
					},
					{
						"id": "43002",
						"num": 2,
						"name": "Sakura Karma",
						"chromas": false
					},
					{
						"id": "43003",
						"num": 3,
						"name": "Traditional Karma",
						"chromas": false
					},
					{
						"id": "43004",
						"num": 4,
						"name": "Order of the Lotus Karma",
						"chromas": false
					},
					{
						"id": "43005",
						"num": 5,
						"name": "Warden Karma",
						"chromas": false
					},
					{
						"id": "43006",
						"num": 6,
						"name": "Winter Wonder Karma",
						"chromas": false
					},
					{
						"id": "43007",
						"num": 7,
						"name": "Conqueror Karma",
						"chromas": false
					}
				],
				"lore": "No champion exemplifies the spiritual traditions of Ionia more than Karma. She is the living embodiment of an ancient soul reincarnated countless times, carrying all her accumulated memories into each new life. With this insight, she serves as a spiritual beacon to her people, bestowing boundless wisdom and healing in times of crisis. Despite being blessed with power that few could comprehend, she rarely uses her magic for destruction, as it always comes at a considerable cost—both to her, and to the land she holds most dear.",
				"blurb": "No champion exemplifies the spiritual traditions of Ionia more than Karma. She is the living embodiment of an ancient soul reincarnated countless times, carrying all her accumulated memories into each new life. With this insight, she serves as a...",
				"allytips": [
					"Gathering Fire rewards aggressive play. Look to land abilities and basic attacks on your opponent to lower Mantra's cooldown and stay on the offensive.",
					"When using Focused Resolve, slow your opponents with Inner Flame or speed yourself up with Inspire if you're having trouble sticking to a target. ",
					"Don't be too conservative with Mantra. Gathering Fire is strongest in teamfights, making it easy to recharge Mantra multiple times."
				],
				"enemytips": [
					"Karma's passive lowers her Mantra cooldown when she hits enemy champions with abilities and basic attacks. Deny her from getting free hits on you.",
					"Karma's Soulflare erupts for bonus damage in the area in which it's placed. React quickly and escape the circle to avoid taking heavy damage.",
					"Focused Resolve is a strong disengage tool. Create distance to avoid being rooted and seek to engage afterwards."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 7,
					"magic": 8,
					"difficulty": 5
				},
				"stats": {
					"hp": 534,
					"hpperlevel": 95,
					"mp": 374,
					"mpperlevel": 50,
					"movespeed": 335,
					"armor": 20.384,
					"armorperlevel": 3.8,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 8.5,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.544,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.3
				},
				"spells": [
					{
						"id": "KarmaQ",
						"name": "Inner Flame",
						"description": "Karma sends forth a ball of spirit energy that explodes and deals damage upon hitting an enemy unit.<br><br>Mantra Bonus: In addition to the explosion, Mantra increases the destructive power of her Inner Flame, creating a cataclysm which deals damage after a short delay.",
						"tooltip": "Fires a blast of energy that explodes upon enemy contact, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing Movement Speed by {{ e2 }}% for {{ e3 }} seconds. <br /><br /><span class=\"colorFF9900\">Mantra Bonus - Soulflare:</span> Deals {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> additional magic damage and leaves a circle of flame that slows enemies by {{ f3 }}%. After 1.5 seconds the circle erupts, dealing {{ f2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the area.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"25",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "@text",
								"coeff": [
									25,
									75,
									125,
									175
								],
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "@text",
								"coeff": [
									50,
									150,
									250,
									350
								],
								"key": "f2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "KarmaQ.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KarmaSpiritBind",
						"name": "Focused Resolve",
						"description": "Karma creates a tether between herself and a targeted enemy, dealing damage and revealing them. If the tether is not broken, the enemy will be rooted and damaged again.<br><br>Mantra Bonus: Karma strengthens the link, healing herself and extending the root duration.",
						"tooltip": "Links Karma to an enemy champion or monster, granting <span class=\"coloree91d7\">True Sight</span> and dealing {{ effect1amount*0.5 }} <span class=\"color99FF99\">(+{{ f4 }}) </span>magic damage. If the link is unbroken for {{ e3 }} seconds, the target is rooted for {{ e2 }} second(s) and takes an additional {{ effect1amount*0.5 }} <span class=\"color99FF99\">(+{{ f4 }}) </span>magic damage.<br /><br /><span class=\"colorFF9900\">Mantra Bonus - Renewal:</span> Karma is healed for {{ f1 }}% <span class=\"color99FF99\">(+{{ f3 }}%)</span> of her missing health. If the link is not broken or the target dies, the root duration is increased by {{ f2 }} second(s) and Karma is healed for {{ f1 }}% <span class=\"color99FF99\">(+{{ f3 }}%)</span> of her missing health.",
						"leveltip": {
							"label": [
								"Damage",
								"Root Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ effect1amount*0.5 }} -> {{ effect1amountnl*0.5 }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								825,
								825,
								825,
								825,
								825
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/110/160/210/260",
							"1/1.25/1.5/1.75/2",
							"2",
							"2",
							"825",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "@text",
								"coeff": [
									75,
									150,
									225,
									300
								],
								"key": "f1"
							},
							{
								"link": "@text",
								"coeff": [
									75,
									150,
									225,
									300
								],
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							675,
							675,
							675,
							675,
							675
						],
						"rangeBurn": "675",
						"image": {
							"full": "KarmaSpiritBind.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KarmaSolKimShield",
						"name": "Inspire",
						"description": "Karma summons a protective shield that absorbs incoming damage and increases the Movement Speed of the protected ally.<br><br>Mantra Bonus: Energy radiates out from her target, strengthening the initial shield and applying Inspire to nearby allied champions.",
						"tooltip": "Target ally gains a shield, granting {{ e3 }}% Movement Speed for {{ e2 }} seconds and absorbing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for {{ e4 }} seconds.<br /><br /><span class=\"colorFF9900\">Mantra Bonus - Defiance:</span> The shield overflows with energy, absorbing an additional {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage. Nearby allied champions gain shields that absorb {{ f2 }}% as much as the initial target's shield. All champions shielded gain {{ f3 }}% movement speed for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage Absorption",
								"Movement Speed",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9.5,
							9,
							8.5,
							8
						],
						"cooldownBurn": "10/9.5/9/8.5/8",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								70,
								95,
								120,
								145,
								170
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/95/120/145/170",
							"1.5",
							"40/45/50/55/60",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "@text",
								"coeff": [
									60,
									140,
									220,
									300
								],
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "KarmaSolKimShield.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KarmaMantra",
						"name": "Mantra",
						"description": "Karma empowers her next ability to do an additional effect. Mantra is available at level 1 and does not require a skill point.",
						"tooltip": "Karma empowers her next ability within 8 seconds for an additional effect. <br /><br /><span class=\"colorFF9900\">Soulflare: </span>Deals bonus damage and leaves behind a circle of flame, slowing enemies and dealing additional damage. <br /><br /><span class=\"colorFF9900\">Renewal: </span>Karma heals for a portion of her missing health. If the link is unbroken the root is longer and Karma is healed again.<br /><br /><span class=\"colorFF9900\">Defiance: </span>The shield is stronger and allied champions around the target also gain a shield and movement speed.",
						"leveltip": {
							"label": [
								"Soulflare Impact",
								"Soulflare Circle Damage",
								"Renewal Root Extension",
								"Defiance Shield",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 4,
						"cooldown": [
							45,
							42,
							39,
							36
						],
						"cooldownBurn": "45/42/39/36",
						"cost": [
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								25,
								75,
								125,
								175
							],
							[
								50,
								150,
								250,
								350
							],
							[
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0.5,
								0.75,
								1,
								1.25
							],
							[
								0.2,
								0.2,
								0.2,
								0.2
							],
							[
								30,
								90,
								150,
								210
							],
							[
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								0.3,
								0.3,
								0.3,
								0.3
							],
							[
								0.01,
								0.01,
								0.01,
								0.01
							]
						],
						"effectBurn": [
							null,
							"25/75/125/175",
							"50/150/250/350",
							"0.5",
							"1.5",
							"0.5/0.75/1/1.25",
							"0.2",
							"30/90/150/210",
							"0.6",
							"0.3",
							"0.01"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "KarmaMantra.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Gathering Fire",
					"description": "Reduces Mantra's cooldown each time Karma damages an enemy champion with one of her abilities (Half-effect for Karma's basic attacks)",
					"image": {
						"full": "Karma_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Karma",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaSRMid",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karma",
						"title": "KarmaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Karthus": {
				"id": "Karthus",
				"key": "30",
				"name": "Karthus",
				"title": "the Deathsinger",
				"image": {
					"full": "Karthus.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "30000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "30001",
						"num": 1,
						"name": "Phantom Karthus",
						"chromas": false
					},
					{
						"id": "30002",
						"num": 2,
						"name": "Statue of Karthus",
						"chromas": false
					},
					{
						"id": "30003",
						"num": 3,
						"name": "Grim Reaper Karthus",
						"chromas": true
					},
					{
						"id": "30004",
						"num": 4,
						"name": "Pentakill Karthus",
						"chromas": false
					},
					{
						"id": "30005",
						"num": 5,
						"name": "Fnatic Karthus",
						"chromas": false
					},
					{
						"id": "30009",
						"num": 9,
						"name": "Karthus Lightsbane",
						"chromas": false
					}
				],
				"lore": "The harbinger of oblivion, Karthus is an undying spirit whose haunting songs are a prelude to the horror of his nightmarish appearance. The living fear the eternity of undeath, but Karthus sees only beauty and purity in its embrace, a perfect union of life and death. When Karthus emerges from the Shadow Isles, it is to bring the joy of death to mortals, an apostle of the unliving.",
				"blurb": "The harbinger of oblivion, Karthus is an undying spirit whose haunting songs are a prelude to the horror of his nightmarish appearance. The living fear the eternity of undeath, but Karthus sees only beauty and purity in its embrace, a perfect union of...",
				"allytips": [
					"Ask your allies to help point out when you should use Requiem to get kills in different lanes.",
					"Lay Waste is very strong at farming minions and harassing enemy champions."
				],
				"enemytips": [
					"Karthus can cast spells for a short duration after he is killed. Move away from his corpse to be safe.",
					"Make sure you always have enough health to survive Requiem, even if you have to go back to the base more frequently to heal."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 2,
					"magic": 10,
					"difficulty": 7
				},
				"stats": {
					"hp": 528,
					"hpperlevel": 87,
					"mp": 372.48,
					"mpperlevel": 61,
					"movespeed": 335,
					"armor": 20.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 450,
					"hpregen": 6.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 45.66,
					"attackdamageperlevel": 3.25,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.11
				},
				"spells": [
					{
						"id": "KarthusLayWasteA1",
						"name": "Lay Waste",
						"description": "Karthus unleashes a delayed blast at a location, dealing damage to nearby enemies.",
						"tooltip": "Creates a delayed blast at Karthus' cursor position dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to each nearby enemy.<br /><br />If the blast hits only a single unit it deals double damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							20,
							26,
							32,
							38,
							44
						],
						"costBurn": "20/26/32/38/44",
						"effect": [
							null,
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/60/80/100/120",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							875,
							875,
							875,
							875,
							875
						],
						"rangeBurn": "875",
						"image": {
							"full": "KarthusLayWasteA1.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KarthusWallOfPain",
						"name": "Wall of Pain",
						"description": "Karthus creates a passable screen of leeching energy. Any enemy units that walk through the screen have their Movement Speed and Magic Resist reduced for a period.",
						"tooltip": "Creates a wall that lasts for {{ e4 }} seconds. Enemies that pass through the wall have their Magic Resist reduced by {{ e1 }}% and Movement Speed reduced by {{ e3 }}% for {{ e5 }} seconds (their Movement Speed gradually recovers over the duration).",
						"leveltip": {
							"label": [
								"Wall Width",
								"Movement Speed Slow"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								" {{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							18,
							18,
							18,
							18
						],
						"cooldownBurn": "18",
						"cost": [
							100,
							100,
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								800,
								900,
								1000,
								1100,
								1200
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15",
							"800/900/1000/1100/1200",
							"40/50/60/70/80",
							"5",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "KarthusWallOfPain.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KarthusDefile",
						"name": "Defile",
						"description": "Karthus passively steals energy from his victims, gaining Mana on each kill. Alternatively, Karthus can surround himself in the souls of his prey, dealing damage to nearby enemies, but quickly draining his own Mana.  ",
						"tooltip": "<span class=\"colorFF9900\">Toggle Off: </span>When Karthus kills a unit, he restores {{ e2 }} Mana.<br /><br /><span class=\"colorFF9900\">Toggle On: </span>Drains {{ cost }} Mana to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies each second. ",
						"leveltip": {
							"label": [
								"Damage per second",
								"Mana Restore",
								"Mana Cost per second"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						"cooldownBurn": "0.5",
						"cost": [
							30,
							42,
							54,
							66,
							78
						],
						"costBurn": "30/42/54/66/78",
						"effect": [
							null,
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								20,
								27,
								34,
								41,
								48
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/50/70/90/110",
							"20/27/34/41/48",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana Per Second",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "KarthusDefile.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana Per Second"
					},
					{
						"id": "KarthusFallenOne",
						"name": "Requiem",
						"description": "After channeling for 3 seconds, Karthus deals damage to all enemy champions.",
						"tooltip": "After channeling for 3 seconds, Karthus deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemy champions (regardless of distance). ",
						"leveltip": {
							"label": [
								"Damage",
								"Mana cost",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							200,
							180,
							160
						],
						"cooldownBurn": "200/180/160",
						"cost": [
							150,
							175,
							200
						],
						"costBurn": "150/175/200",
						"effect": [
							null,
							[
								250,
								400,
								550
							],
							[
								200,
								300,
								400
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250/400/550",
							"200/300/400",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							10000,
							10000,
							10000
						],
						"rangeBurn": "10000",
						"image": {
							"full": "KarthusFallenOne.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Death Defied",
					"description": "Upon dying, Karthus enters a spirit form that allows him to continue casting spells for 7 seconds.",
					"image": {
						"full": "Karthus_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Karthus",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Karthus",
						"title": "KarthusTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Kassadin": {
				"id": "Kassadin",
				"key": "38",
				"name": "Kassadin",
				"title": "the Void Walker",
				"image": {
					"full": "Kassadin.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "38000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "38001",
						"num": 1,
						"name": "Festival Kassadin",
						"chromas": false
					},
					{
						"id": "38002",
						"num": 2,
						"name": "Deep One Kassadin",
						"chromas": false
					},
					{
						"id": "38003",
						"num": 3,
						"name": "Pre-Void Kassadin",
						"chromas": false
					},
					{
						"id": "38004",
						"num": 4,
						"name": "Harbinger Kassadin",
						"chromas": false
					},
					{
						"id": "38005",
						"num": 5,
						"name": "Cosmic Reaver Kassadin",
						"chromas": false
					}
				],
				"lore": "Cutting a burning swath through the darkest places of the world, Kassadin knows his days are numbered. Though once a notorious adventurer, he had chosen to live anonymously and raise a family among the nomad tribes of Shurima—until the day his daughter was claimed by the Void. Kassadin vowed to bring her back, combining a number of arcane artifacts and forbidden technologies for the struggle ahead. His precautions were not enough, however, and these devices now only serve to slow the insidious corruption that ravages his body... but he will gladly pay that price, if only he can save her...",
				"blurb": "Cutting a burning swath through the darkest places of the world, Kassadin knows his days are numbered. Though once a notorious adventurer, he had chosen to live anonymously and raise a family among the nomad tribes of Shurima—until the day his daughter...",
				"allytips": [
					"Kassadin has multiple item paths; he can go caster via Mana and Ability Power or anti-caster with Cooldown Reduction and Magic Resist.",
					"Kassadin's ultimate has many uses and is on a shorter cooldown than most, use it often.",
					"Try to get the Ancient Golem buff to counteract Riftwalk's increasing Mana cost."
				],
				"enemytips": [
					"Kassadin deals mostly magic damage. If he's doing well consider buying magic resist items like Mercury's Treads and Banshee's Veil.",
					"Each time Kassadin consecutively uses Riftwalk, he pays more and more mana. Keep this in mind as you chase him.",
					"It takes 6 spell casts for Kassadin's slow, Force Pulse, to become castable. If he levels up that ability, judiciously use your own skills while laning against him."
				],
				"tags": [
					"Assassin",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 5,
					"magic": 8,
					"difficulty": 8
				},
				"stats": {
					"hp": 576,
					"hpperlevel": 90,
					"mp": 397.6,
					"mpperlevel": 67,
					"movespeed": 340,
					"armor": 23.376,
					"armorperlevel": 3.2,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 150,
					"hpregen": 8,
					"hpregenperlevel": 0.5,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 58.852,
					"attackdamageperlevel": 3.9,
					"attackspeedoffset": -0.023,
					"attackspeedperlevel": 3.7
				},
				"spells": [
					{
						"id": "NullLance",
						"name": "Null Sphere",
						"description": "Kassadin fires an orb of void energy at a target, dealing damage and interrupting channels. The excess energy forms around himself, granting a temporary shield that absorbs magic damage.",
						"tooltip": "Kassadin fires an orb of void energy that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and interrupts channels.<br /><br />The excess energy forms around himself, granting a shield that absorbs {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Shield",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								65,
								95,
								125,
								155,
								185
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/95/125/155/185",
							"0",
							"40/70/100/130/160",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "NullLance.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NetherBlade",
						"name": "Nether Blade",
						"description": "Passive: Kassadin's basic attacks deal bonus magic damage. Active: Kassadin's next basic attack deals significant bonus magic damage and restores Mana.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Kassadin's basic attacks draw energy from the void, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage.<br /><br /><span class=\"colorFF9900\">Active: </span>Kassadin charges his Nether Blade, causing his next basic attack to deal {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus magic damage and restore <span class=\"color44DDFF\">{{ e1 }}% of his missing Mana</span> (increases to <span class=\"color44DDFF\">{{ e4 }}%</span> against champions).",
						"leveltip": {
							"label": [
								"Active Damage",
								"Base Mana Restore",
								"Champion Mana Restore"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e4 }}% -> {{ e4NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							7,
							7,
							7,
							7
						],
						"cooldownBurn": "7",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								4,
								5,
								6,
								7,
								8
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/5/6/7/8",
							"20",
							"40/65/90/115/140",
							"20/25/30/35/40",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "NetherBlade.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "ForcePulse",
						"name": "Force Pulse",
						"description": "Kassadin draws energy from spells cast in his vicinity. Upon charging up, Kassadin can use Force Pulse to damage and slow enemies in a cone in front of him.",
						"tooltip": "Kassadin draws energy from spells cast in his vicinity, gaining a charge whenever a spell is cast near him.<br /><br />Upon reaching 6 charges, Kassadin can use Force Pulse to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slow enemies by {{ e2 }}% for {{ e3 }} second in a cone in front of him.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow %",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							5,
							5,
							5,
							5
						],
						"cooldownBurn": "5",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								80,
								105,
								130,
								155,
								180
							],
							[
								50,
								60,
								70,
								80,
								90
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/105/130/155/180",
							"50/60/70/80/90",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "ForcePulse.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RiftWalk",
						"name": "Riftwalk",
						"description": "Kassadin teleports to a nearby location dealing damage to nearby enemy units. Multiple Riftwalks in a short period of time cost additional Mana but also deal additional damage.",
						"tooltip": "Kassadin teleports to a nearby location dealing {{ e1 }} <span class=\"color44DDFF\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to surrounding enemy units.<br /><br />Each subsequent Riftwalk within the next {{ e2 }} seconds doubles the Mana cost and deals an additional {{ e3 }} <span class=\"color44DDFF\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ f3 }})</span> magic damage per stack, stacking up to {{ e6 }} times.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Damage Per Stack",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							6,
							4,
							2
						],
						"cooldownBurn": "6/4/2",
						"cost": [
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								80,
								100,
								120
							],
							[
								15,
								15,
								15
							],
							[
								40,
								50,
								60
							],
							[
								1,
								1,
								1
							],
							[
								0,
								0,
								0
							],
							[
								4,
								4,
								4
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/100/120",
							"15",
							"40/50/60",
							"1",
							"0",
							"4",
							"2",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "RiftWalk.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Void Stone",
					"description": "Kassadin takes 15% reduced magic damage and ignores unit collision.",
					"image": {
						"full": "Kassadin_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kassadin",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerOdinPromote",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kassadin",
						"title": "KassadinTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Katarina": {
				"id": "Katarina",
				"key": "55",
				"name": "Katarina",
				"title": "the Sinister Blade",
				"image": {
					"full": "Katarina.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "55000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "55001",
						"num": 1,
						"name": "Mercenary Katarina",
						"chromas": false
					},
					{
						"id": "55002",
						"num": 2,
						"name": "Red Card Katarina",
						"chromas": false
					},
					{
						"id": "55003",
						"num": 3,
						"name": "Bilgewater Katarina",
						"chromas": false
					},
					{
						"id": "55004",
						"num": 4,
						"name": "Kitty Cat Katarina",
						"chromas": false
					},
					{
						"id": "55005",
						"num": 5,
						"name": "High Command Katarina",
						"chromas": false
					},
					{
						"id": "55006",
						"num": 6,
						"name": "Sandstorm Katarina",
						"chromas": false
					},
					{
						"id": "55007",
						"num": 7,
						"name": "Slay Belle Katarina",
						"chromas": false
					},
					{
						"id": "55008",
						"num": 8,
						"name": "Warring Kingdoms Katarina",
						"chromas": true
					},
					{
						"id": "55009",
						"num": 9,
						"name": "PROJECT: Katarina",
						"chromas": false
					},
					{
						"id": "55010",
						"num": 10,
						"name": "Death Sworn Katarina",
						"chromas": false
					}
				],
				"lore": "Decisive in judgment and lethal in combat, Katarina is a Noxian assassin of the highest caliber. Eldest daughter to the legendary General Du Couteau, she made her talents known with swift kills against unsuspecting enemies. Her fiery ambition has driven her to pursue heavily-guarded targets, even at the risk of endangering her allies—but no matter the mission, Katarina will not hesitate to execute her duty amid a whirlwind of serrated daggers.",
				"blurb": "Decisive in judgment and lethal in combat, Katarina is a Noxian assassin of the highest caliber. Eldest daughter to the legendary General Du Couteau, she made her talents known with swift kills against unsuspecting enemies. Her fiery ambition has driven...",
				"allytips": [
					"Picking up Daggers will significantly reduce Shunpo's cooldown.",
					"Try waiting until the other team is distracted with fighting your team, and use Shunpo to teleport into the fray and unleash a devastating Death Lotus.",
					"Using Shunpo on an allied Champion, Dagger, or minion can be a great escape tactic."
				],
				"enemytips": [
					"Katarina's abilities deal magic damage, so even if she's building Attack Damage items, get magic resistance to counter her.",
					"Try to save a disable for when Katarina uses her Death Lotus."
				],
				"tags": [
					"Assassin",
					"Mage"
				],
				"partype": "None",
				"info": {
					"attack": 4,
					"defense": 3,
					"magic": 9,
					"difficulty": 8
				},
				"stats": {
					"hp": 602,
					"hpperlevel": 94,
					"mp": 0,
					"mpperlevel": 0,
					"movespeed": 340,
					"armor": 27.88,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7.5,
					"hpregenperlevel": 0.7,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 58,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2.74
				},
				"spells": [
					{
						"id": "KatarinaQ",
						"name": "Bouncing Blade",
						"description": "Katarina throws a <font color='#FFF673'>Dagger</font> at the target that then bounces to nearby enemies before ricocheting onto the ground.",
						"tooltip": "Katarina throws a <span class=\"colorFFF673\">Dagger</span>, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the target and {{ e4 }} nearby enemies. The dagger then ricochets onto the ground behind the primary target.<br /><br /><span class=\"size16 color8C8C8C\">The dagger always lands 350 units on the opposite side from where it struck the first target, getting there in the same amount of time regardless of how many times it bounces.</span>",
						"leveltip": {
							"label": [
								"Initial Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10,
							9,
							8,
							7
						],
						"cooldownBurn": "11/10/9/8/7",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								75,
								105,
								135,
								165,
								195
							],
							[
								350,
								350,
								350,
								350,
								350
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/105/135/165/195",
							"350",
							"450",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "KatarinaQ.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "KatarinaW",
						"name": "Preparation",
						"description": "Katarina gains a burst of movement speed, tossing a <font color='#FFF673'>Dagger</font> into the air directly above herself.",
						"tooltip": "Katarina tosses a <span class=\"colorFFF673\">Dagger</span> into the air and gains {{ e4 }}% decaying movement speed over {{ e2 }} seconds.</span>",
						"leveltip": {
							"label": [
								"Movement Speed Buff",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							14,
							13,
							12,
							11
						],
						"cooldownBurn": "15/14/13/12/11",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								50,
								60,
								70,
								80,
								90
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"1.25",
							"0",
							"50/60/70/80/90",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "KatarinaW.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "KatarinaEWrapper",
						"name": "Shunpo",
						"description": "Katarina blinks to the target, striking it if its an enemy, or striking the nearest enemy otherwise.",
						"tooltip": "Katarina dashes in the blink of an eye to the target ally, enemy, or <span class=\"colorFFF673\">Dagger</span>. If it is an enemy, Katarina strikes for {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage - otherwise she strikes the nearest enemy in range.<br /><br />Picking up a <span class=\"colorFFF673\">Dagger</span> will reduce Shunpo's cooldown by <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds (<span class=\"colorFFFFFF\">{{ f3*100 }}%</span>).<br /><br /><span class=\"size16 color8C8C8C\">Katarina can blink to any location near the target.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}<Br>{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							12.5,
							11,
							9.5,
							8
						],
						"cooldownBurn": "14/12.5/11/9.5/8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								15,
								30,
								45,
								60,
								75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								14,
								12.5,
								11,
								9.5,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/30/45/60/75",
							"0",
							"14/12.5/11/9.5/8",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "KatarinaEWrapper.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "KatarinaR",
						"name": "Death Lotus",
						"description": "Katarina becomes a flurry of blades, dealing massive magic damage while she channels to the 3 nearest enemy champions.",
						"tooltip": "Katarina becomes a flurry of blades, rapidly throwing knives at the three nearest enemy champions, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per knife. Total over {{ e3 }} seconds to each enemy: {{ f1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ f3 }})</span> magic damage.<br /><br />Applies Grievous Wounds to all enemies struck, reducing their healing and regeneration by 40%.",
						"leveltip": {
							"label": [
								"Damage Per Knife",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							90,
							60,
							45
						],
						"cooldownBurn": "90/60/45",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								25,
								37.5,
								50
							],
							[
								6,
								6,
								6
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								3,
								3,
								3
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/37.5/50",
							"6",
							"2.5",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.22,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.19,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 3,
								"key": "f1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "KatarinaR.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Voracity",
					"description": "Whenever an enemy champion dies that Katarina has damaged in the last 3 seconds, her ability cooldowns are reduced by 15 seconds.<br><br>If Katarina picks up a <font color='#FFF673'>Dagger</font>, she uses it to slash through all nearby enemies, dealing magic damage.",
					"image": {
						"full": "Katarina_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Katarina",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Katarina",
						"title": "KatarinaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Kayle": {
				"id": "Kayle",
				"key": "10",
				"name": "Kayle",
				"title": "The Judicator",
				"image": {
					"full": "Kayle.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "10000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "10001",
						"num": 1,
						"name": "Silver Kayle",
						"chromas": false
					},
					{
						"id": "10002",
						"num": 2,
						"name": "Viridian Kayle",
						"chromas": false
					},
					{
						"id": "10003",
						"num": 3,
						"name": "Unmasked Kayle",
						"chromas": false
					},
					{
						"id": "10004",
						"num": 4,
						"name": "Battleborn Kayle",
						"chromas": false
					},
					{
						"id": "10005",
						"num": 5,
						"name": "Judgment Kayle",
						"chromas": false
					},
					{
						"id": "10006",
						"num": 6,
						"name": "Aether Wing Kayle",
						"chromas": false
					},
					{
						"id": "10007",
						"num": 7,
						"name": "Riot Kayle",
						"chromas": false
					},
					{
						"id": "10008",
						"num": 8,
						"name": "Iron Inquisitor Kayle",
						"chromas": false
					},
					{
						"id": "10009",
						"num": 9,
						"name": "Pentakill Kayle",
						"chromas": false
					}
				],
				"lore": "A great hero and the strongest among her kind, Kayle is an angelic warrior dedicated to purging those beyond redemption. After conflict divided her people, she took up her enchanted armor and flaming sword in the name of order, disowning her very flesh and blood in the process. When Kayle descends upon the field of battle, her justice is swift—for none can escape the light of divine and righteous fury.",
				"blurb": "A great hero and the strongest among her kind, Kayle is an angelic warrior dedicated to purging those beyond redemption. After conflict divided her people, she took up her enchanted armor and flaming sword in the name of order, disowning her very flesh...",
				"allytips": [
					"Using Intervention on a high-DPS ally can turn the tides of battle by giving your ally free reign to attack. ",
					"Kayle can effectively do large amounts of damage or support her allies depending on her item build. ",
					"Kayle benefits greatly from Attack Damage and Ability Power, making hybrid items like Nashor's Tooth and Trinity Force very effective on her. ",
					"If you wish to support your allies, items like Locket of the Iron Solari can help you assist teammates."
				],
				"enemytips": [
					"Intervention only grants Kayle or her allies immunity to damage. Slows and stuns can still be applied, so trap them if they're being overzealous.",
					"Kayle is usually a fragile target. If you see her ultimate cast on an ally, switch to attacking her.",
					"Be sure to look at what items Kayle is building to determine what role she is fulfilling on her team."
				],
				"tags": [
					"Fighter",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 6,
					"magic": 7,
					"difficulty": 7
				},
				"stats": {
					"hp": 586,
					"hpperlevel": 105,
					"mp": 322.2,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 26.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.75,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 51,
					"attackdamageperlevel": 2.2,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 2.2
				},
				"spells": [
					{
						"id": "JudicatorReckoning",
						"name": "Reckoning",
						"description": "Blasts an enemy unit with angelic force, dealing damage, slowing Movement Speed, and applying Holy Fervor.",
						"tooltip": "Blasts an enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, slowing their Movement Speed by {{ e2 }}% for {{ e3 }} seconds, and applying a stack of Holy Fervor.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }}  ->  {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								35,
								40,
								45,
								50,
								55
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/110/160/210/260",
							"35/40/45/50/55",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "JudicatorReckoning.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JudicatorDivineBlessing",
						"name": "Divine Blessing",
						"description": "Blesses a target friendly champion, granting them increased Movement Speed and healing them.",
						"tooltip": "Blesses an allied champion, increasing their Movement Speed by {{ e2 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> for {{ e3 }} seconds and healing them for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health.",
						"leveltip": {
							"label": [
								"Healing",
								"Movement Speed",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								18,
								21,
								24,
								27,
								30
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/105/150/195/240",
							"18/21/24/27/30",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.07,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "JudicatorDivineBlessing.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JudicatorRighteousFury",
						"name": "Righteous Fury",
						"description": "Passive: Grants Kayle on Hit magic Damage.  Activate: Ignite Kayle's sword with a holy flame, granting Kayle a ranged attack that damages multiple enemies and deals bonus magic damage.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Kayle's Basic Attacks deal an additional {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage on hit.<br /><br /><span class=\"colorFF9900\">Active: </span>Kayle increases her Attack Range by 400 for 10 seconds and the passive bonus is increased to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and apply spell effects on hit.<br /><br />In addition, deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and applies spell effects on attack to enemies near her target.",
						"leveltip": {
							"label": [
								"Passive Damage",
								"Active Damage",
								"Damage to Nearby Enemies Ratio",
								"Cooldown "
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0.2,
								0.25,
								0.3,
								0.35,
								0.4
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"20/25/30/35/40",
							"0.2/0.25/0.3/0.35/0.4",
							"10/15/20/25/30",
							"10",
							"400",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": [
									0.2,
									0.25,
									0.3,
									0.35,
									0.4
								],
								"key": "f2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "JudicatorRighteousFury.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JudicatorIntervention",
						"name": "Intervention",
						"description": "Shields Kayle or an ally for a short time, causing them to be immune to damage.",
						"tooltip": "Bathes Kayle's target in a holy light, rendering them immune to all damage for {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								2,
								2.5,
								3
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2/2.5/3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "JudicatorIntervention.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Holy Fervor",
					"description": "When Kayle attacks a champion, the target loses 3% Armor and Magic Resist for 5 seconds. This effect stacks up to 5 times.",
					"image": {
						"full": "Kayle_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kayle",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1042",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kayle",
						"title": "KayleTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Kayn": {
				"id": "Kayn",
				"key": "141",
				"name": "Kayn",
				"title": "the Shadow Reaper",
				"image": {
					"full": "Kayn.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "141000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "141001",
						"num": 1,
						"name": "Soulhunter Kayn",
						"chromas": false
					}
				],
				"lore": "A peerless practitioner of lethal shadow magic, Shieda Kayn battles to achieve his true destiny—to one day lead the Order of the Shadow into a new era of Ionian supremacy. He audaciously wields the sentient darkin weapon Rhaast, undeterred by its creeping corruption of his body and mind. There are only two possible outcomes: either Kayn bends the weapon to his will... or the malevolent blade consumes him completely, paving the way for the destruction of all Runeterra.",
				"blurb": "A peerless practitioner of lethal shadow magic, Shieda Kayn battles to achieve his true destiny—to one day lead the Order of the Shadow into a new era of Ionian supremacy. He audaciously wields the sentient darkin weapon Rhaast, undeterred by its...",
				"allytips": [
					"Look at the line-up of both your team and the enemy's team when picking your form.",
					"Remember that nearby enemies can see which wall you're in."
				],
				"enemytips": [
					"Umbral Trespass requires Kayn to damage a target first. Try to dodge Blade's Reach to deny him a long range cast of Umbral Trespass.",
					"When Kayn is in terrain near you, you will get a visual warning on the edge of the terrain he's in.",
					"Damage Kayn while he's in Shadow Step to shorten its duration, or apply hard crowd control (stun, charm, knockup, etc) to end Shadow Step immediately."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 10,
					"defense": 6,
					"magic": 1,
					"difficulty": 8
				},
				"stats": {
					"hp": 585,
					"hpperlevel": 85,
					"mp": 410,
					"mpperlevel": 50,
					"movespeed": 340,
					"armor": 38,
					"armorperlevel": 3.3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.75,
					"mpregen": 11.5,
					"mpregenperlevel": 0.95,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.7
				},
				"spells": [
					{
						"id": "KaynQ",
						"name": "Reaping Slash",
						"description": "Kayn dashes, then slashes. Both deal damage.",
						"tooltip": "Kayn dashes forward to strike nearby enemies. Both dash and strike deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><hr><span class=\"colorff2323\">Darkin:</span> Deal a percentage of the target's maximum health instead.<br /><br /><rules>Deals {{ e6 }} bonus physical damage to monsters.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								200,
								250,
								300,
								350,
								400
							],
							[
								55,
								55,
								55,
								55,
								55
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/80/100/120/140",
							"0.5",
							"5",
							"4",
							"200/250/300/350/400",
							"55",
							"300",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "KaynQ.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KaynW",
						"name": "Blade's Reach",
						"description": "Kayn damages and slows targets in a line.",
						"tooltip": "Kayn deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slows enemies hit by {{ e3 }}%, decaying over the next {{ e5 }} seconds.<br /><hr><span class=\"color7777ff\">Shadow Assassin:</span> Gain extra range and the ability to move during Blade's Reach.<br /><br /><span class=\"colorff2323\">Darkin:</span> Gain a knock up.</li></ul>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								90,
								135,
								180,
								225,
								270
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								160,
								160,
								160,
								160,
								160
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								900,
								900,
								900,
								900,
								900
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"90/135/180/225/270",
							"1",
							"60",
							"160",
							"1.5",
							"900",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "KaynW.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KaynE",
						"name": "Shadow Step",
						"description": "Kayn can walk through terrain.",
						"tooltip": "Kayn gains {{ e1 }}% movement speed and the ability to walk through terrain for {{ e2 }} seconds. When he first enters terrain, he is healed for {{ e7 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span>.<br /><hr><span class=\"color7777ff\">Shadow Assassin:</span> Gain more movement speed and slow immunity.<br /><br /><rules>Maximum duration in combat with enemy champions: {{ e6 }} seconds.<br />Immobilizing effects and spending more than {{ e3 }} consecutive seconds outside of terrain end Shadow Step immediately.</rules>",
						"leveltip": {
							"label": [
								"Duration",
								"Heal",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}s -> {{ e2NL }}s",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 5,
						"cooldown": [
							21,
							19,
							17,
							15,
							13
						],
						"cooldownBurn": "21/19/17/15/13",
						"cost": [
							90,
							90,
							90,
							90,
							90
						],
						"costBurn": "90",
						"effect": [
							null,
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								5,
								6,
								7,
								8,
								9
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1250,
								1250,
								1250,
								1250,
								1250
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								100,
								115,
								130,
								145,
								160
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40",
							"5/6/7/8/9",
							"1.5",
							"1250",
							"70",
							"1.5",
							"100/115/130/145/160",
							"0.4",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "KaynE.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KaynR",
						"name": "Umbral Trespass",
						"description": "Kayn hides in an enemy's body, dealing massive damage when he bursts out.",
						"tooltip": "Kayn infests an enemy champion <specialRules>he has recently damaged</specialRules>, becoming untargetable for up to {{ e4 }} seconds. <span class=\"colorffffff\">Reactivate</span> to end this effect early. When Umbral Trespass ends, the target takes {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><hr><span class=\"color7777ff\">Shadow Assassin:</span> Gains extra range and refresh The Darkin Scythe on exit.<br /><br /><span class=\"colorff2323\">Darkin:</span> Deals percent maximum health damage and heals for a percentage of target maximum health.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								300,
								300,
								300
							],
							[
								10,
								10,
								10
							],
							[
								13,
								13,
								13
							],
							[
								70,
								70,
								70
							],
							[
								750,
								750,
								750
							],
							[
								550,
								550,
								550
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"0.5",
							"0",
							"2.5",
							"300",
							"10",
							"13",
							"70",
							"750",
							"550"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "KaynR.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "The Darkin Scythe",
					"description": "At one point in the game, Kayn will permanently transform into either a Shadow Assassin or a Darkin.",
					"image": {
						"full": "Kayn_Passive_Primary.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kayn",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayn",
						"title": "KaynARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayn",
						"title": "KaynCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayn",
						"title": "KaynFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayn",
						"title": "KaynSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayn",
						"title": "KaynSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									"kaynass",
									"kaynslay"
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynass"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynass"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynass"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynslay"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynslay"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynslay"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kayn",
						"title": "KaynTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									"kaynslay",
									"kaynass"
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynass"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynass"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynass"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynslay"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynslay"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									"kaynslay"
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Kennen": {
				"id": "Kennen",
				"key": "85",
				"name": "Kennen",
				"title": "the Heart of the Tempest",
				"image": {
					"full": "Kennen.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "85000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "85001",
						"num": 1,
						"name": "Deadly Kennen",
						"chromas": false
					},
					{
						"id": "85002",
						"num": 2,
						"name": "Swamp Master Kennen",
						"chromas": false
					},
					{
						"id": "85003",
						"num": 3,
						"name": "Karate Kennen",
						"chromas": false
					},
					{
						"id": "85004",
						"num": 4,
						"name": "Kennen M.D.",
						"chromas": false
					},
					{
						"id": "85005",
						"num": 5,
						"name": "Arctic Ops Kennen",
						"chromas": false
					},
					{
						"id": "85006",
						"num": 6,
						"name": "Blood Moon Kennen",
						"chromas": false
					},
					{
						"id": "85007",
						"num": 7,
						"name": "Super Kennen",
						"chromas": false
					}
				],
				"lore": "More than just the lightning-quick enforcer of Ionian balance, Kennen is the only yordle member of the Kinkou. Despite his small, furry stature, he is eager to take on any threat with a whirling storm of shuriken and boundless enthusiasm. Alongside his master Shen, Kennen patrols the spirit realm, employing devastating electrical energy to strike down his enemies.",
				"blurb": "More than just the lightning-quick enforcer of Ionian balance, Kennen is the only yordle member of the Kinkou. Despite his small, furry stature, he is eager to take on any threat with a whirling storm of shuriken and boundless enthusiasm. Alongside his...",
				"allytips": [
					"You can stun your opponents by inflicting 3 Marks of the Storm upon them.",
					"Lightning Rush can be used to initiate fights with its Energy return component, allowing him to use other abilities afterward.",
					"You can land an initial Mark of the Storm debuff on an opponent with Thundering Shuriken, and then add to it with Electrical Surge."
				],
				"enemytips": [
					"Consider playing a bit more cautiously around Kennen when you have a Mark of the Storm debuff. If he hits you with 3 Marks of the Storm, you will get stunned.",
					"Kennen is flimsy by nature - turn and attack him if he gets careless with Lightning Rush."
				],
				"tags": [
					"Mage",
					"Marksman"
				],
				"partype": "Energy",
				"info": {
					"attack": 6,
					"defense": 4,
					"magic": 7,
					"difficulty": 4
				},
				"stats": {
					"hp": 541,
					"hpperlevel": 84,
					"mp": 200,
					"mpperlevel": 0,
					"movespeed": 335,
					"armor": 29,
					"armorperlevel": 3.75,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.65,
					"mpregen": 50,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 50.544,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": -0.0947,
					"attackspeedperlevel": 3.4
				},
				"spells": [
					{
						"id": "KennenShurikenHurlMissile1",
						"name": "Thundering Shuriken",
						"description": "Kennen throws a fast moving shuriken towards a location, causing damage and adding a Mark of the Storm to any opponent that it hits.",
						"tooltip": "Throws a shuriken that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy it hits.",
						"leveltip": {
							"label": [
								"Damage",
								"Energy Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7,
							6,
							5,
							4
						],
						"cooldownBurn": "8/7/6/5/4",
						"cost": [
							60,
							55,
							50,
							45,
							40
						],
						"costBurn": "60/55/50/45/40",
						"effect": [
							null,
							[
								75,
								115,
								155,
								195,
								235
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/115/155/195/235",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "KennenShurikenHurlMissile1.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "KennenBringTheLight",
						"name": "Electrical Surge",
						"description": "Kennen passively deals extra damage and adds a Mark of the Storm to his target every few attacks, and he can activate this ability to damage and add another Mark of the Storm to targets who are already marked.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Every 5 attacks, Kennen deals bonus magic damage equal to {{ e2 }} <scaleAD>(+{{ f1 }})</scaleAD> <scaleAP>(+{{ a2 }})</scaleAP> and adds a Mark of the Storm to his target.<br /><br /><span class=\"colorFF9900\">Active:</span> Sends a surge of electricity through all nearby enemies affected by Mark of the Storm or Slicing Maelstrom, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Damage (passive)",
								"Damage (active)",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							12,
							10,
							8,
							6
						],
						"cooldownBurn": "14/12/10/8/6",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								65,
								95,
								125,
								155,
								185
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/95/125/155/185",
							"15/20/25/30/35",
							"0.6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.55,
								"key": "a1"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "KennenBringTheLight.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "KennenLightningRush",
						"name": "Lightning Rush",
						"description": "Kennen morphs into a lightning form, enabling him to pass through units. Each enemy unit he touches takes damage and receives a Mark of the Storm.",
						"tooltip": "Kennen doubles his base movement speed and ignores unit collision for 2 seconds, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to any enemy he passes through. Additionally, Kennen will gain {{ e2 }} Armor and Magic Resist for 4 seconds.<br /><br />Kennen gains 40 Energy the first time he passes through an enemy.<br />Lightning Rush deals half damage to minions.",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus Armor and Magic Resist",
								"Cooldown",
								"Energy Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							100,
							95,
							90,
							85,
							80
						],
						"costBurn": "100/95/90/85/80",
						"effect": [
							null,
							[
								85,
								125,
								165,
								205,
								245
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"85/125/165/205/245",
							"10/20/30/40/50",
							"40",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							200,
							200,
							200,
							200,
							200
						],
						"rangeBurn": "200",
						"image": {
							"full": "KennenLightningRush.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "KennenShurikenStorm",
						"name": "Slicing Maelstrom",
						"description": "Kennen summons a storm that strikes at nearby enemy champions for magical damage.",
						"tooltip": "Summons a magical storm for {{ e3 }} seconds that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies near Kennen every {{ e2 }} seconds. Each maelstrom hit applies Mark of the Storm, up to a maximum of 3.<br /><br />Successive maelstrom hits against the same enemy deal an additional {{ e4 }}% damage for each hit they've already suffered from this storm.",
						"leveltip": {
							"label": [
								"Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							120,
							120
						],
						"cooldownBurn": "120",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								40,
								75,
								110
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								3,
								3,
								3
							],
							[
								10,
								10,
								10
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/75/110",
							"0.5",
							"3",
							"10",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "KennenShurikenStorm.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Mark of the Storm",
					"description": "Kennen's abilities add one stack of Mark of the Storm to their target for 6 seconds. If the target reaches 3 stacks, it is stunned for 1.25 seconds and Kennen gains 25 Energy. <br><br><font color='#99FF99'>The stun will be a diminished duration of 0.5 seconds if it occurs again within 6 seconds.</font>",
					"image": {
						"full": "Kennen_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kennen",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kennen",
						"title": "KennenTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Khazix": {
				"id": "Khazix",
				"key": "121",
				"name": "Kha'Zix",
				"title": "the Voidreaver",
				"image": {
					"full": "Khazix.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "121000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "121001",
						"num": 1,
						"name": "Mecha Kha'Zix",
						"chromas": true
					},
					{
						"id": "121002",
						"num": 2,
						"name": "Guardian of the Sands Kha'Zix",
						"chromas": false
					},
					{
						"id": "121003",
						"num": 3,
						"name": "Death Blossom Kha'Zix",
						"chromas": false
					},
					{
						"id": "121004",
						"num": 4,
						"name": "Dark Star Kha'Zix",
						"chromas": false
					}
				],
				"lore": "The Void grows, and the Void adapts—in none of its myriad spawn are these truths more apparent than Kha'Zix. Evolution drives the core of this mutating horror, born to survive and to slay the strong. Where it struggles to do so, it grows new, more effective ways to counter and kill its prey. Initially a mindless beast, Kha'Zix's intelligence has developed as much as its form. Now, the creature plans out its hunts, and even utilizes the visceral terror it engenders in its victims.",
				"blurb": "The Void grows, and the Void adapts—in none of its myriad spawn are these truths more apparent than Kha'Zix. Evolution drives the core of this mutating horror, born to survive and to slay the strong. Where it struggles to do so, it grows new, more...",
				"allytips": [
					"Enemies are considered isolated if they have no allies within a short distance. The damage of Taste Their Fear is massively increased against these targets.",
					"Unseen Threat activates when Kha'Zix cannot be seen by the enemy team. Reactivate by using brush or Void Assault. Don't forget to apply Unseen Threat by autoattacking enemy champions.",
					"Kha'Zix has a great deal of freedom to choose where and when to fight. Pick your battles carefully to succeed."
				],
				"enemytips": [
					"Taste Their Fear deals bonus damage to targets that are isolated. Gain an advantage by fighting near allied minions, champions, or turrets.",
					"Leap and Void Assault have long cooldowns. Kha'Zix is very vulnerable when these are not available."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 4,
					"magic": 3,
					"difficulty": 6
				},
				"stats": {
					"hp": 572.8,
					"hpperlevel": 85,
					"mp": 327.2,
					"mpperlevel": 40,
					"movespeed": 350,
					"armor": 36,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7.5,
					"hpregenperlevel": 0.75,
					"mpregen": 7.59,
					"mpregenperlevel": 0.5,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 63,
					"attackdamageperlevel": 3.1,
					"attackspeedoffset": -0.065,
					"attackspeedperlevel": 2.7
				},
				"spells": [
					{
						"id": "KhazixQ",
						"name": "Taste Their Fear",
						"description": "Deals physical damage to the target. Damage increased on <font color='#FFF673'>Isolated</font> targets. If he chooses to <font color='#00DD33'>Evolve Reaper Claws</font>, this refunds a percent of it's cooldown against <font color='#FFF673'>Isolated</font> targets. Kha'Zix also gains increased range on his basic attacks and Taste Their Fear.",
						"tooltip": "Deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. If the target is <span class=\"colorFFF673\">Isolated</span>, the damage is increased by {{ e2 }}% (<span class=\"colorFF8C00\">{{ f1 }}</span>).<br /><br /><span class=\"color00DD33\">Evolved Reaper Claws:</span> Increases the range of Taste Their Fear and Kha'Zix's basic attacks by {{ e3 }}. If target is <span class=\"colorFFF673\">Isolated</span>, refunds {{ e4 }}% of Taste Their Fear's cooldown.",
						"leveltip": {
							"label": [
								"Base Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								65,
								90,
								115,
								140,
								165
							],
							[
								65,
								65,
								65,
								65,
								65
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								45,
								45,
								45,
								45,
								45
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/90/115/140/165",
							"65",
							"50",
							"45",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "KhazixQ.png",
							"sprite": "spell5.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KhazixW",
						"name": "Void Spike",
						"description": "Kha'Zix fires exploding spikes that deal physical damage to enemies hit. Kha'Zix is healed if he is also within the explosion radius. If he chooses to <font color='#00DD33'>Evolve Spike Racks</font>, Void Spike now fires three spikes in a cone, slow enemies hit, and reveals enemy champions hit for 2 seconds. <font color='#FFF673'>Isolated</font> targets are slowed for extra.",
						"tooltip": "Fires exploding spikes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to enemies hit ({{ e5 }}% bonus damage to monsters). Heals Kha'Zix for {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> if he is within the explosion radius.<br /><br /><span class=\"color00DD33\">Evolved Spike Racks:</span> Void Spike fires three spikes in a cone and slows targets hit by {{ e3 }}% for {{ e4 }} seconds. Reveals enemy champions hit for 2 seconds. <span class=\"colorFFF673\">Isolated</span> targets are slowed for {{ e7 }}% instead.",
						"leveltip": {
							"label": [
								"Damage",
								"Healing",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							55,
							60,
							65,
							70,
							75
						],
						"costBurn": "55/60/65/70/75",
						"effect": [
							null,
							[
								85,
								115,
								145,
								175,
								205
							],
							[
								60,
								85,
								110,
								135,
								160
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"85/115/145/175/205",
							"60/85/110/135/160",
							"40",
							"2",
							"20",
							"2",
							"80",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "KhazixW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KhazixE",
						"name": "Leap",
						"description": "Kha'Zix leaps to an area, dealing physical damage upon landing. If he chooses to <font color='#00DD33'>Evolve Wings</font>, Leap's range increases by 200 and the cooldown resets on champion kill or assist.",
						"tooltip": "Leaps to target area, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><br /><span class=\"color00DD33\">Evolved Wings:</span> Increases Leap's range by 200, and the cooldown resets on champion kill or assist.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							18,
							16,
							14,
							12
						],
						"cooldownBurn": "20/18/16/14/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								65,
								100,
								135,
								170,
								205
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/100/135/170/205",
							"30/35/40/45/50",
							"10",
							"2.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "KhazixE.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KhazixR",
						"name": "Void Assault",
						"description": "Each rank allows Kha'Zix to evolve one of his abilities, giving it a unique additional effect. When activated, Kha'Zix becomes <font color='#91d7ee'>Invisible</font>, triggering Unseen Threat and increasing Movement Speed. If he chooses to <font color='#00DD33'>Evolve Adaptive Cloaking</font>, while out of combat Kha'Zix also passively gains Void Assault upon entering a new brush.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Ranking up Void Assault allows Kha'Zix to evolve one of his abilities.<br /><br /><span class=\"colorFF9900\">Active:</span> Kha'Zix becomes <span class=\"color91d7ee\">Invisible</span> for {{ e1 }} seconds and activates Unseen Threat. While <span class=\"color91d7ee\">Invisible</span>, he gains {{ e3 }}% movement speed and ignores unit collision. Void Assault can be cast a second time within {{ e2 }} seconds.<br /><br /><span class=\"color00DD33\">Evolved Adaptive Cloaking:</span> While out of combat, Kha'Zix also passively gains Void Assault for {{ e5 }} seconds in brush. This persists for up to {{ f1 }} seconds after exiting the brush ({{ f1 }} second per brush cooldown).<br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Kha'Zix can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.</span>",
						"leveltip": {
							"label": [
								"Evolutions Available",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								1.5,
								1.5,
								1.5
							],
							[
								10,
								10,
								10
							],
							[
								40,
								40,
								40
							],
							[
								1,
								2,
								3
							],
							[
								3,
								3,
								3
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.5",
							"10",
							"40",
							"1/2/3",
							"3",
							"2",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "KhazixR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Unseen Threat",
					"description": "When Kha'Zix is not visible to the enemy team, he gains Unseen Threat, causing his next basic attack against an enemy Champion to deal bonus magic damage and slow.",
					"image": {
						"full": "Khazix_P.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Khazix",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "KhazixTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Khazix",
						"title": "RainbowScytherFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									},
									{
										"id": "3342",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3181",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2044",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Kindred": {
				"id": "Kindred",
				"key": "203",
				"name": "Kindred",
				"title": "The Eternal Hunters",
				"image": {
					"full": "Kindred.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "203000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "203001",
						"num": 1,
						"name": "Shadowfire Kindred",
						"chromas": false
					},
					{
						"id": "203002",
						"num": 2,
						"name": "Super Galaxy Kindred",
						"chromas": false
					}
				],
				"lore": "Separate, but never parted, Kindred represents the twin essences of death. Lamb's bow offers a swift release from the mortal realm for those who accept their fate. Wolf hunts down those who run from their end, delivering violent finality within his crushing jaws. Though interpretations of Kindred's nature vary across Runeterra, every mortal must choose the true face of their death.",
				"blurb": "Separate, but never parted, Kindred represents the twin essences of death. Lamb's bow offers a swift release from the mortal realm for those who accept their fate. Wolf hunts down those who run from their end, delivering violent finality within his...",
				"allytips": [
					"Moving around between attacks while jungling will help you avoid damage and also generate more heals from Wolf's Frenzy.",
					"Pick which Hunts you want to pursue carefully; getting many of them is the key to success as the game goes on.",
					"Don't go in first to a large team fight. Wait for your teammates to initiate."
				],
				"enemytips": [
					"Kindred is fragile - turn the pressure up on her, and she will be forced to play cautiously.",
					"Clear the Hunts Wolf activates on jungle camps to slow down Kindred's damage output.",
					"When Kindred uses Lamb's Respite get inside, it stops all champions from dying."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 2,
					"magic": 2,
					"difficulty": 4
				},
				"stats": {
					"hp": 540,
					"hpperlevel": 85,
					"mp": 300,
					"mpperlevel": 35,
					"movespeed": 325,
					"armor": 29,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 6.972,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 2.26,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "KindredQ",
						"name": "Dance of Arrows",
						"description": "Kindred tumbles and shoots up to three arrows at nearby targets.",
						"tooltip": "Lamb vaults, firing up to 3 arrows at nearby enemies, dealing {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> physical damage and gains <scaleLevel>{{ f2 }}%</scaleLevel> bonus attack speed for {{ e8 }} seconds.<br /><br />Casting <span class=\"colorFFFFFF\">Wolf's Frenzy</span> or vaulting inside of its effect reduces the cooldown of this spell to {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown in Wolf's Frenzy"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							35,
							35,
							35,
							35,
							35
						],
						"costBurn": "35",
						"effect": [
							null,
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								500,
								500,
								500,
								500,
								500
							],
							[
								4,
								3.5,
								3,
								2.5,
								2
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/80/100/120/140",
							"0",
							"500",
							"4/3.5/3/2.5/2",
							"100",
							"12",
							"0.1",
							"4",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							340,
							340,
							340,
							340,
							340
						],
						"rangeBurn": "340",
						"image": {
							"full": "KindredQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KindredW",
						"name": "Wolf's Frenzy",
						"description": "Wolf enrages and attacks enemies around him.",
						"tooltip": "Wolf claims a territory, attacking nearby enemies inside it for {{ e4 }} seconds. Lamb can redirect Wolf to new targets by attacking them. If Lamb leaves Wolf's territory he will cease attacking and join her.<br /><br />Wolf's attacks deal magic damage equal to {{ e5 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> plus <scaleLevel>{{ f3 }}%</scaleLevel> of the target's current health.<br /><br /><rules>Wolf attacks faster based on Kindred's attack speed. His attacks maim monsters for {{ e7 }}% increased damage and reduce their attack and movement speed by {{ e8 }}% for 2 seconds.</rules>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								8.5,
								8.5,
								8.5,
								8.5,
								8.5
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/45/50/55/60",
							"1",
							"1.5",
							"8.5",
							"25/30/35/40/45",
							"800",
							"50",
							"50",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							560,
							560,
							560,
							560,
							560
						],
						"rangeBurn": "560",
						"image": {
							"full": "KindredW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KindredEWrapper",
						"name": "Mounting Dread",
						"description": "Lamb fires a carefully placed shot, slowing the target. If Lamb attacks the target two more times, her third attack instead directs Wolf to pounce on the enemy, savaging them for massive damage.",
						"tooltip": "Cripple an enemy, slowing their movement speed by {{ e2 }}% for {{ e8 }} second.<br /><br />After Lamb attacks the target twice, her third attack instead directs Wolf to pounce on the enemy, dealing {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> plus <scaleLevel>{{ f2 }}%</scaleLevel> of the target's missing health as bonus physical damage.<br /><br />Wolf's attack critically strikes targets for {{ e6 }}% increased damage if they are below {{ e5 }}% <span class=\"colorFF5802\">(+{{ f3 }}%)</span> health (Increased by <span class=\"colorFF5802\">Critical Strike Chance</span>).<br /><br /><rules>[Maximum {{ e0 }} vs. monsters]</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								65,
								85,
								105,
								125,
								145
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								300,
								300,
								300,
								300,
								300
							]
						],
						"effectBurn": [
							null,
							"65/85/105/125/145",
							"50",
							"0.5",
							"8",
							"15",
							"50",
							"4",
							"1",
							"4",
							"300"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "KindredEWrapper.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KindredR",
						"name": "Lamb's Respite",
						"description": "Lamb grants all living things inside a zone a respite from death. Until the effect ends, nothing can die. At the end, units are healed.",
						"tooltip": "Lamb blesses the ground underneath her for {{ e2 }} seconds, creating an area in which no living things, <span class=\"color99FF99\">ally</span> or <span class=\"colorFF9999\">enemy</span>, can die. Upon reaching 10% Health, units become immune to further damage or healing.<br /><br />When the blessing ends all living things inside heal for {{ e1 }}.",
						"leveltip": {
							"label": [
								"Heal",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							160,
							130,
							100
						],
						"cooldownBurn": "160/130/100",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								200,
								250,
								300
							],
							[
								4,
								4,
								4
							],
							[
								530,
								530,
								530
							],
							[
								400,
								600,
								800
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/250/300",
							"4",
							"530",
							"400/600/800",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "KindredR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Mark of the Kindred",
					"description": "Kindred can mark targets to Hunt. Successfully completing a Hunt permanently empowers Kindred's basic abilities. Every 4 hunts completed also increases Kindred's basic attack range.",
					"image": {
						"full": "Kindred_Passive.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kindred",
						"title": "KindredARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kindred",
						"title": "KindredCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kindred",
						"title": "KindredFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kindred",
						"title": "KindredKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kindred",
						"title": "KindredSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kindred",
						"title": "KindredSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kindred",
						"title": "KindredTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1419",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Kled": {
				"id": "Kled",
				"key": "240",
				"name": "Kled",
				"title": "the Cantankerous Cavalier",
				"image": {
					"full": "Kled.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "240000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "240001",
						"num": 1,
						"name": "Sir Kled",
						"chromas": false
					}
				],
				"lore": "A warrior as fearless as he is ornery, the yordle Kled embodies the furious bravado of Noxus. He is an icon beloved by the empire's soldiers, distrusted by its officers, and loathed by the nobility. Many claim Kled has fought in every campaign the legions have waged, has “acquired” every military title, and has never once backed down from a fight. Though the truth of the matter is often questionable, one part of his legend is undeniable: Charging into battle on his un-trusty steed, Skaarl, Kled fights to protect what's his… and to take whatever he can get.",
				"blurb": "A warrior as fearless as he is ornery, the yordle Kled embodies the furious bravado of Noxus. He is an icon beloved by the empire's soldiers, distrusted by its officers, and loathed by the nobility. Many claim Kled has fought in every campaign the...",
				"allytips": [
					"Kled generates some courage by killing minions, but gets much more from fighting Champions.",
					"The last hit of Violent Tendencies deals more damage than the first three - make sure you hit it!",
					"Chaaaaaaaarge!!! can be cast at a great range. Try and predict where the enemy team will be by the time you reach them."
				],
				"enemytips": [
					"Kled generates courage by damaging enemies with his Pocket Pistol and basic attacks, killing minions, and attacking structures or epic monsters.",
					"Watch Kled's courage bar when he's off his mount - when it reaches 100%, he will remount and regain a significant amount of health.",
					"Kled is much more threatening when he has Violent Tendencies ready."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Courage",
				"info": {
					"attack": 8,
					"defense": 2,
					"magic": 2,
					"difficulty": 7
				},
				"stats": {
					"hp": 340,
					"hpperlevel": 70,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 35,
					"armorperlevel": 4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 6,
					"hpregenperlevel": 0.75,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "KledQ",
						"name": "Bear Trap on a Rope",
						"description": "Kled throws a bear trap that damages and hooks an enemy champion. If shackled for a short duration, the target takes additional physical damage and is yanked toward Kled.<br><br>When dismounted, this ability is replaced by Pocket Pistol, a ranged gun blast that knocks back Kled and restores courage.",
						"tooltip": "Kled throws a bear trap that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }}) </span>physical damage and hooks onto the first enemy champion or large monster hit, granting <span class=\"coloree91d7\">True Sight</span>. Deals 150% damage to minions passed through.<br /><br />If Kled stays near a hooked enemy for {{ e3 }} seconds, he deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ charbonusphysical*2 }})</span> physical damage, yanks the enemy toward him, and slows the enemy by {{ e5 }}% for 1.5 seconds.<br /><br /><span class=\"colorFF8C00\">Dismounted:</span> Becomes Pocket Pistol, a ranged ability that restores <span class=\"coloreae57e\">courage</span>.",
						"leveltip": {
							"label": [
								"Throw Damage",
								"Rip Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8.5,
							8,
							7.5,
							7
						],
						"cooldownBurn": "9/8.5/8/7.5/7",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								1.75,
								1.75,
								1.75,
								1.75,
								1.75
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								9,
								8.5,
								8,
								7.5,
								7
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/110/160/210/260",
							"0.6",
							"1.75",
							"2",
							"40/45/50/55/60",
							"9/8.5/8/7.5/7",
							"1.5",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "KledQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "KledW",
						"name": "Violent Tendencies",
						"description": "Kled gains massive attack speed for four attacks. The fourth attack deals more damage.",
						"tooltip": "<span class=\"colorFF8C00\">Passive:</span> When Kled basic attacks, he frenzies, gaining {{ e2 }}% attack speed for four attacks or {{ e6 }} seconds. Violent Tendencies then goes on cooldown.<br /><br />The fourth hit deals bonus physical damage equal to {{ e4 }} plus {{ e1 }}% <span class=\"colorFF8C00\">(+{{ f1 }}%)</span> of the target's maximum health (maximum {{ e7 }} vs monsters).",
						"leveltip": {
							"label": [
								"Flat Damage",
								"Percentage Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							12.5,
							11,
							9.5,
							8
						],
						"cooldownBurn": "14/12.5/11/9.5/8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								4.5,
								5,
								5.5,
								6,
								6.5
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								15,
								30,
								45,
								60,
								75
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4.5/5/5.5/6/6.5",
							"150",
							"20",
							"20/30/40/50/60",
							"15/30/45/60/75",
							"4",
							"200",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							0,
							0,
							0,
							0,
							0
						],
						"rangeBurn": "0",
						"image": {
							"full": "KledW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "KledE",
						"name": "Jousting",
						"description": "Kled dashes, dealing physical damage and gaining a short burst of speed. Kled can cast this ability again to dash back through his initial target, dealing the same damage.",
						"tooltip": "Kled dashes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }}) </span>physical damage to enemies in his path. Cannot cross walls.<br /><br />If Jousting hits an enemy champion or large monster, Kled gains {{ e5 }}% movement speed for {{ e4 }} second and <span class=\"coloree91d7\">True Sight</span> of the target. He can cast this ability again within {{ e6 }} seconds to dash back through the same target, dealing the same damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								35,
								60,
								85,
								110,
								135
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								350,
								350,
								350,
								350,
								350
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								700,
								700,
								700,
								700,
								700
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/60/85/110/135",
							"0",
							"350",
							"1",
							"50",
							"3",
							"600",
							"700",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "KledE.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "KledR",
						"name": "Chaaaaaaaarge!!!",
						"description": "Kled and Skaarl charge to a location, leaving a speed-granting trail behind them and gaining a shield. Skaarl locks onto and rams the first enemy champion encountered.",
						"tooltip": "Kled charges toward a location, leaving a trail that grants allies increasing movement speed. While charging, Kled gains a shield that increases over time to a maximum of {{ e4 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> and lasts for 2 seconds after the charge ends.<br /><br />Skaarl rams the first enemy champion encountered, dealing up to {{ f5 }}% <span class=\"colorFF8C00\">(+{{ f1*3 }}%)</span> of the target's maximum health as physical damage based on distance traveled.",
						"leveltip": {
							"label": [
								"Maximum Damage",
								"Maximum Shield",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e0 }} -> {{ e0NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							160,
							140,
							120
						],
						"cooldownBurn": "160/140/120",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								12,
								15,
								18
							],
							[
								4,
								4,
								4
							],
							[
								0,
								0,
								0
							],
							[
								200,
								300,
								400
							],
							[
								3,
								3,
								3
							],
							[
								100,
								150,
								0
							],
							[
								0,
								0,
								0
							],
							[
								150,
								0,
								0
							],
							[
								3,
								3,
								3
							],
							[
								3500,
								4000,
								4500
							]
						],
						"effectBurn": [
							null,
							"12/15/18",
							"4",
							"0",
							"200/300/400",
							"3",
							"100/150/0",
							"0",
							"150/0/0",
							"3",
							"3500/4000/4500"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 3,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							3500,
							4000,
							4500
						],
						"rangeBurn": "3500/4000/4500",
						"image": {
							"full": "KledR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Skaarl, the Cowardly Lizard",
					"description": "Kled rides his trusty steed, Skaarl, who takes damage for him. When Skaarl's health depletes, Kled dismounts.<br><br>While dismounted, Kled's abilities change and he deals less damage to champions. Kled can restore Skaarl's courage by fighting enemies. At maximum courage, Kled remounts with a portion of Skaarl's health.",
					"image": {
						"full": "Kled_P.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Kled",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Kled",
						"title": "KledTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"KogMaw": {
				"id": "KogMaw",
				"key": "96",
				"name": "Kog'Maw",
				"title": "the Mouth of the Abyss",
				"image": {
					"full": "KogMaw.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "96000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "96001",
						"num": 1,
						"name": "Caterpillar Kog'Maw",
						"chromas": false
					},
					{
						"id": "96002",
						"num": 2,
						"name": "Sonoran Kog'Maw",
						"chromas": false
					},
					{
						"id": "96003",
						"num": 3,
						"name": "Monarch Kog'Maw",
						"chromas": false
					},
					{
						"id": "96004",
						"num": 4,
						"name": "Reindeer Kog'Maw",
						"chromas": false
					},
					{
						"id": "96005",
						"num": 5,
						"name": "Lion Dance Kog'Maw",
						"chromas": false
					},
					{
						"id": "96006",
						"num": 6,
						"name": "Deep Sea Kog'Maw",
						"chromas": false
					},
					{
						"id": "96007",
						"num": 7,
						"name": "Jurassic Kog'Maw",
						"chromas": false
					},
					{
						"id": "96008",
						"num": 8,
						"name": "Battlecast Kog'Maw",
						"chromas": false
					},
					{
						"id": "96009",
						"num": 9,
						"name": "Pug'Maw",
						"chromas": false
					},
					{
						"id": "96010",
						"num": 10,
						"name": "Hextech Kog'Maw",
						"chromas": false
					}
				],
				"lore": "Belched forth from a rotting Void incursion deep in the wastelands of Icathia, Kog'Maw is an inquisitive yet putrid creature with a caustic, gaping mouth. This particular Void-spawn needs to gnaw and drool on anything within reach to truly understand it. Though not inherently evil, Kog'Maw's beguiling naiveté is dangerous, as it often precedes a feeding frenzy—not for sustenance, but to satisfy its unending curiosity.",
				"blurb": "Belched forth from a rotting Void incursion deep in the wastelands of Icathia, Kog'Maw is an inquisitive yet putrid creature with a caustic, gaping mouth. This particular Void-spawn needs to gnaw and drool on anything within reach to truly understand it...",
				"allytips": [
					"Kog'Maw can outrange most champions with his Bio-Arcane Barrage ability.",
					"Use Void Ooze to set up a perfect Living Artillery.",
					"Make the most out of your Icathian Surprise."
				],
				"enemytips": [
					"Kog'Maw doesn't have a good escape ability, so he is especially prone to ganks.",
					"Run away from Kog'Maw after he dies!!!!",
					"The range on Living Artillery increases each rank.",
					"Bio-Arcane Barrage allows Kog'Maw to kill Baron Nashor extremely early. It can be valuable to ward Nashor when Kog'Maw completes his Blade of the Ruined King."
				],
				"tags": [
					"Marksman",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 2,
					"magic": 5,
					"difficulty": 6
				},
				"stats": {
					"hp": 517.76,
					"hpperlevel": 82,
					"mp": 322.2,
					"mpperlevel": 40,
					"movespeed": 325,
					"armor": 29,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 6,
					"hpregenperlevel": 0.55,
					"mpregen": 8.676,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": -0.06,
					"attackspeedperlevel": 2.65
				},
				"spells": [
					{
						"id": "KogMawQ",
						"name": "Caustic Spittle",
						"description": "Kog'Maw launches a corrosive projectile which deals magic damage and corrodes the target's armor and magic resist for a short time. Kog'Maw also gains additional attack speed.",
						"tooltip": "<span class=\"colorFF8C00\">Passive: </span> Kog'Maw gains {{ e2 }}% bonus attack speed.<br /><br /><span class=\"colorFF8C00\">Active: </span>Launches a corrosive projectile that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to the first enemy hit and shreds its Armor and Magic Resist by {{ e3 }}% for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Bonus Attack Speed",
								"Damage",
								"Armor and Magic Resist Shred"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								20,
								22,
								24,
								26,
								28
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/130/180/230/280",
							"15/20/25/30/35",
							"20/22/24/26/28",
							"4",
							"1",
							"1",
							"100",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1175,
							1175,
							1175,
							1175,
							1175
						],
						"rangeBurn": "1175",
						"image": {
							"full": "KogMawQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KogMawBioArcaneBarrage",
						"name": "Bio-Arcane Barrage",
						"description": "Kog'Maw's attacks gain range and deal a percent of the target's maximum health as magic damage.",
						"tooltip": "For {{ e3 }} seconds, Kog'Maw's basic attacks gain {{ e1 }} range and deal {{ e2 }}% <span class=\"color99FF99\">(+{{ f1 }})%</span> of the target's maximum health as bonus magic damage.",
						"leveltip": {
							"label": [
								"Range",
								"Bonus Max Health Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							17,
							17,
							17,
							17
						],
						"cooldownBurn": "17",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								130,
								150,
								170,
								190,
								210
							],
							[
								3,
								3.75,
								4.5,
								5.25,
								6
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								0.15,
								0.2,
								0.25,
								0.3,
								0.35
							],
							[
								15,
								20,
								25,
								30,
								35
							]
						],
						"effectBurn": [
							null,
							"130/150/170/190/210",
							"3/3.75/4.5/5.25/6",
							"8",
							"100",
							"100",
							"0",
							"100",
							"15",
							"0.15/0.2/0.25/0.3/0.35",
							"15/20/25/30/35"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							530,
							530,
							530,
							530,
							530
						],
						"rangeBurn": "530",
						"image": {
							"full": "KogMawBioArcaneBarrage.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KogMawVoidOoze",
						"name": "Void Ooze",
						"description": "Kog'Maw launches a peculiar ooze which damages all enemies it passes through and leaves a trail which slows enemies who stand on it.",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to enemies hit and leaves a trail on the ground for {{ e3 }} seconds, slowing enemies in it by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							80,
							90,
							100,
							110,
							120
						],
						"costBurn": "80/90/100/110/120",
						"effect": [
							null,
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								20,
								28,
								36,
								44,
								52
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/105/150/195/240",
							"20/28/36/44/52",
							"4",
							"0.25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "KogMawVoidOoze.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "KogMawLivingArtillery",
						"name": "Living Artillery",
						"description": "Kog'Maw fires an artillery shell at a great distance dealing magic damage (increased significantly on low health enemies) and revealing non-stealthed targets. Additionally, multiple Living Artilleries in a short period of time cause them to cost additional Mana.",
						"tooltip": "Fires an artillery shot, damaging enemies above 40% health for {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ effect1amount*1.5 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage based on their missing health.<br /><br />If enemies are below 40% health, they take {{ f4 }} <span class=\"colorFF8C00\">(+{{ f6 }})</span> <span class=\"color99FF99\">(+{{ f5 }})</span> magic damage instead.<br /><br />Each subsequent shot within {{ e4 }} seconds costs {{ e3 }} more Mana (max {{ e5 }}).",
						"leveltip": {
							"label": [
								"Damage",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							2,
							1.5,
							1
						],
						"cooldownBurn": "2/1.5/1",
						"cost": [
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								100,
								140,
								180
							],
							[
								1200,
								1500,
								1800
							],
							[
								40,
								40,
								40
							],
							[
								8,
								8,
								8
							],
							[
								400,
								400,
								400
							],
							[
								2,
								2,
								2
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								2,
								2,
								2
							],
							[
								360,
								360,
								360
							],
							[
								400,
								400,
								400
							]
						],
						"effectBurn": [
							null,
							"100/140/180",
							"1200/1500/1800",
							"40",
							"8",
							"400",
							"2",
							"1.5",
							"2",
							"360",
							"400"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.65,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1500,
							1800
						],
						"rangeBurn": "1200/1500/1800",
						"image": {
							"full": "KogMawLivingArtillery.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Icathian Surprise",
					"description": "Upon dying, Kog'Maw starts a chain reaction in his body which causes him to move faster and detonate after 4 seconds; dealing 100 + (25 x lvl) true damage to surrounding enemies.",
					"image": {
						"full": "KogMaw_IcathianSurprise.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "KogMaw",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogMawARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogMawCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogmawFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogMawKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogMawPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogMawSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogmawSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "KogMaw",
						"title": "KogmawTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Leblanc": {
				"id": "Leblanc",
				"key": "7",
				"name": "LeBlanc",
				"title": "the Deceiver",
				"image": {
					"full": "Leblanc.png",
					"sprite": "champion1.png",
					"group": "champion",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "7000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "7001",
						"num": 1,
						"name": "Wicked LeBlanc",
						"chromas": false
					},
					{
						"id": "7002",
						"num": 2,
						"name": "Prestigious LeBlanc",
						"chromas": true
					},
					{
						"id": "7003",
						"num": 3,
						"name": "Mistletoe LeBlanc",
						"chromas": false
					},
					{
						"id": "7004",
						"num": 4,
						"name": "Ravenborn LeBlanc",
						"chromas": false
					},
					{
						"id": "7005",
						"num": 5,
						"name": "Elderwood LeBlanc",
						"chromas": false
					}
				],
				"lore": "Mysterious even to other members of the Black Rose cabal, LeBlanc is but one of many names for a pale woman who has manipulated people and events since the earliest days of Noxus. Using her magic to mirror herself, the sorceress can appear to anyone, anywhere, and even be in many places at once. Always plotting just out of sight, LeBlanc's true motives are as inscrutable as her shifting identity.",
				"blurb": "Mysterious even to other members of the Black Rose cabal, LeBlanc is but one of many names for a pale woman who has manipulated people and events since the earliest days of Noxus. Using her magic to mirror herself, the sorceress can appear to anyone...",
				"allytips": [
					"Distortion allows you to be aggressive with your other spells while being able to return to safety.",
					"Using Distortion can help your positioning to land Ethereal Chains.",
					"You can chain Sigil of Malice and Ethereal Chains to prevent characters with blink from escaping for up to 4 seconds."
				],
				"enemytips": [
					"LeBlanc's ultimate can create fake LeBlancs during her spellcast or, rarely, at a distant position. ",
					"The fake LeBlanc created at a distance will always run at the nearest Champion, cast a harmless spell, then immediately disappear.",
					"Attacking LeBlanc first avoids most of her tricks, especially if she's recently used her dash, Distortion.",
					"Stunning or silencing LeBlanc will prevent her from activating the return part of Distortion."
				],
				"tags": [
					"Assassin",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 4,
					"magic": 10,
					"difficulty": 9
				},
				"stats": {
					"hp": 528,
					"hpperlevel": 92,
					"mp": 334,
					"mpperlevel": 50,
					"movespeed": 340,
					"armor": 21.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 7.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 54.88,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.4
				},
				"spells": [
					{
						"id": "LeblancQ",
						"name": "Shatter Orb",
						"description": "LeBlanc projects an orb towards her target, dealing magic damage. When Shatter Orb is empowered by Sigil of Malice, the spell bounces to the nearest ready Sigil of Malice (bounces deal reduced damage to minions).",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. When Shatter Orb is empowered by Sigil of Malice, the spell bounces to the nearest ready Sigil of Malice (bounces deal {{ e7 }}% damage to minions). ",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								55,
								90,
								125,
								160,
								195
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								3.5,
								3.5,
								3.5,
								3.5,
								3.5
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/90/125/160/195",
							"25",
							"3.5",
							"6",
							"60/90/120/150/180",
							"0",
							"60",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "LeblancQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LeblancW",
						"name": "Distortion",
						"description": "LeBlanc rapidly dashes to a target location, dealing magic damage to nearby units. In the following 4 seconds, she can activate Distortion again to return to her starting location.",
						"tooltip": "Dashes to target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the target area.<br /><br />For the next 4 seconds, she can activate Distortion again to return to her starting location.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								0.85,
								0.85,
								0.85,
								0.85,
								0.85
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/55/70/85/100",
							"2",
							"4",
							"600",
							"0.85",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "LeblancW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LeblancE",
						"name": "Ethereal Chains",
						"description": "LeBlanc flings illusionary chains towards a target location. If it hits an enemy unit, it will deal initial magic damage and shackle them. If the target remains shackled for 1.5 seconds, the target takes additional magic damage and is unable to move.",
						"tooltip": "Launches a chain that shackles the first unit hit to LeBlanc, granting <span class=\"coloree91d7\">True Sight</span> of the unit and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />If the target remains shackled for {{ e2 }} seconds they are rooted for {{ e2 }} seconds and take an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. ",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f1 }} -> {{ f2 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								885,
								885,
								885,
								885,
								885
							],
							[
								14,
								13.25,
								12.5,
								11.75,
								11
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/60/80/100/120",
							"1.5",
							"1.5",
							"25",
							"885",
							"14/13.25/12.5/11.75/11",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "LeblancE.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LeblancR",
						"name": "Mimic",
						"description": "LeBlanc creates a clone and casts a mimicked version of one of her basic spells. The clone casts a fake copy of that spell. LeBlanc can instead send the clone far away, where it casts a fake copy of her most recently cast spell.",
						"tooltip": "LeBlanc copies one of her spells and creates a <span class=\"colorCC00FF\">Mimic</span> decoy to cast it with her. The <span class=\"colorCC00FF\">Mimic</span> lasts {{ e7 }} seconds. <br /><br /><li>Shatter Orb deals {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.<br />Distortion deals {{ e5 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage.<br />Ethereal Chains deals {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage each time.<br />Using this spell on itself invokes <span class=\"colorDDDD77\">Shadow of the Rose</span>.</li><br /><span class=\"colorDDDD77\">Shadow of the Rose</span><br />The <span class=\"colorCC00FF\">Mimic</span> appears at target location and approaches the closest visible enemy Champion, then casts a fake version of LeBlanc's most recent basic ability. <br /><br />Has a separate <span class=\"colorFFFFFF\">{{ f2 }} second</span> cooldown. This <span class=\"colorCC00FF\">Mimic</span> lasts much longer but cannot be controlled.",
						"leveltip": {
							"label": [
								"Mimicked Shatter Orb Damage",
								"Mimicked Distortion Damage",
								"Mimicked Ethereal Chains Damage",
								"Shadow of the Rose Cooldown",
								"Mimic Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ f2 }} -> {{ f3 }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							54,
							42,
							30
						],
						"cooldownBurn": "54/42/30",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								40,
								60
							],
							[
								30,
								37.5,
								45
							],
							[
								150,
								275,
								400
							],
							[
								100,
								160,
								220
							],
							[
								60,
								120,
								180
							],
							[
								160,
								140,
								120
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								150,
								150,
								150
							],
							[
								0.3,
								0.3,
								0.3
							],
							[
								0.075,
								0.075,
								0.075
							]
						],
						"effectBurn": [
							null,
							"20/40/60",
							"30/37.5/45",
							"150/275/400",
							"100/160/220",
							"60/120/180",
							"160/140/120",
							"2.5",
							"150",
							"0.3",
							"0.08"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": "Toggle",
						"maxammo": "2",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "LeblancR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "Toggle"
					}
				],
				"passive": {
					"name": "Sigil of Malice",
					"description": "When LeBlanc damages an enemy with a spell, she marks the target for 4 seconds. After 1.5 seconds, LeBlanc's next spell shatters the Sigil to deal magic damage.<br><br>Sigil of Malice cannot occur again on the same unit for 5 seconds.",
					"image": {
						"full": "LeblancP.png",
						"sprite": "passive1.png",
						"group": "passive",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Leblanc",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1082",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leblanc",
						"title": "LeblancTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"LeeSin": {
				"id": "LeeSin",
				"key": "64",
				"name": "Lee Sin",
				"title": "the Blind Monk",
				"image": {
					"full": "LeeSin.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "64000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "64001",
						"num": 1,
						"name": "Traditional Lee Sin",
						"chromas": false
					},
					{
						"id": "64002",
						"num": 2,
						"name": "Acolyte Lee Sin",
						"chromas": false
					},
					{
						"id": "64003",
						"num": 3,
						"name": "Dragon Fist Lee Sin",
						"chromas": true
					},
					{
						"id": "64004",
						"num": 4,
						"name": "Muay Thai Lee Sin",
						"chromas": false
					},
					{
						"id": "64005",
						"num": 5,
						"name": "Pool Party Lee Sin",
						"chromas": false
					},
					{
						"id": "64006",
						"num": 6,
						"name": "SKT T1 Lee Sin",
						"chromas": false
					},
					{
						"id": "64010",
						"num": 10,
						"name": "Knockout Lee Sin",
						"chromas": false
					},
					{
						"id": "64011",
						"num": 11,
						"name": "God Fist Lee Sin",
						"chromas": false
					}
				],
				"lore": "A master of Ionia's ancient martial arts, Lee Sin is a principled fighter who channels the essence of the dragon spirit to face any challenge. Though he lost his sight many years ago, the warrior-monk has devoted his life to protecting his homeland against any who would dare upset its sacred balance. Enemies who underestimate his meditative demeanor will endure his fabled burning fists and blazing roundhouse kicks.",
				"blurb": "A master of Ionia's ancient martial arts, Lee Sin is a principled fighter who channels the essence of the dragon spirit to face any challenge. Though he lost his sight many years ago, the warrior-monk has devoted his life to protecting his homeland...",
				"allytips": [
					"Use Sonic Wave before Dragon's Rage so you can chase the target with Resonating Strike.",
					"Take advantage of Flurry by weaving in basic attacks between spell casts - this maximizes damage output and minimizes Energy loss.",
					"Self-casting Safeguard and using Iron Will are powerful tools for killing neutral monsters (in the jungle)."
				],
				"enemytips": [
					"Stay spread out to minimize the impact of Lee Sin's ultimate, Dragon's Rage.",
					"Lee Sin has powerful tools to combat physical damage in Iron Will and Cripple but he is still vulnerable to magic damage.",
					"Lee Sin relies heavily on following up with his abilities. Use disables to prevent him from chaining together his abilities and attacks."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Energy",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 3,
					"difficulty": 6
				},
				"stats": {
					"hp": 570.8,
					"hpperlevel": 85,
					"mp": 200,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 33,
					"armorperlevel": 3.7,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7.5,
					"hpregenperlevel": 0.7,
					"mpregen": 50,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 69.18,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.04,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "BlindMonkQOne",
						"name": "Sonic Wave / Resonating Strike",
						"description": "Sonic Wave: Lee Sin projects a discordant wave of sound to locate his enemies, dealing physical damage to the first enemy it encounters. If Sonic Wave hits, Lee Sin can cast Resonating Strike for the next 3 seconds.<br>Resonating Strike: Lee Sin dashes to the enemy hit by Sonic Wave, dealing physical damage plus 8% of their missing Health.",
						"tooltip": "<spellActive>Sonic Wave: </spellActive>Lee Sin projects a discordant wave of sound to locate his enemies, dealing {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage to the first enemy it encounters, granting <keyword>True Sight</keyword> of the target. <specialRules>If Sonic Wave hits, Lee Sin can cast Resonating Strike for the next {{ e7 }} seconds.</specialRules><br /><br /><spellActive>Resonating Strike: </spellActive>Lee Sin dashes to the enemy hit by Sonic Wave, dealing {{ e2 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage plus {{ e3 }}% of their missing Health (Max: {{ e6 }} Damage vs. Monsters).",
						"leveltip": {
							"label": [
								"Sonic Wave Damage",
								"Resonating Strike Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10,
							9,
							8,
							7
						],
						"cooldownBurn": "11/10/9/8/7",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								55,
								85,
								115,
								145,
								175
							],
							[
								55,
								85,
								115,
								145,
								175
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								1350,
								1350,
								1350,
								1350,
								1350
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/85/115/145/175",
							"55/85/115/145/175",
							"8",
							"30",
							"1350",
							"400",
							"3",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.9,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Energy / {{ e4 }} Energy",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "BlindMonkQOne.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy / {{ e4 }} Energy"
					},
					{
						"id": "BlindMonkWOne",
						"name": "Safeguard / Iron Will",
						"description": "Safeguard: Lee Sin rushes to target ally, shielding himself from damage. If the ally is a champion, they are also shielded. After using Safeguard, Lee Sin can cast Iron Will for the next 3 seconds.<br>Iron Will: Lee Sin's intense training allows him to thrive in battle. For 4 seconds, Lee Sin gains Life Steal and Spell Vamp.",
						"tooltip": "<spellActive>Safeguard: </spellActive>Lee Sin rushes to target ally. If the ally is a champion, Lee Sin shields the ally and himself for {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> damage for {{ e3 }} seconds and Safeguard's cooldown is reduced by {{ e6 }}%. <specialRules>After using Safeguard, Lee Sin can cast Iron Will for the next {{ e9 }} seconds.</specialRules><br /><br /><spellActive>Iron Will: </spellActive>Lee Sin gains {{ e2 }}% Life Steal and Spell Vamp for {{ e8 }} seconds.",
						"leveltip": {
							"label": [
								"Safeguard Shield Absorption",
								"Iron Will Lifesteal / Spell Vamp %"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							14,
							14,
							14,
							14
						],
						"cooldownBurn": "14",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								55,
								110,
								165,
								220,
								275
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								1350,
								1350,
								1350,
								1350,
								1350
							]
						],
						"effectBurn": [
							null,
							"55/110/165/220/275",
							"10/15/20/25/30",
							"2",
							"30",
							"5",
							"50",
							"0",
							"4",
							"3",
							"1350"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Energy / {{ e4 }} Energy",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "BlindMonkWOne.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy / {{ e4 }} Energy"
					},
					{
						"id": "BlindMonkEOne",
						"name": "Tempest / Cripple",
						"description": "Tempest: Lee Sin smashes the ground, sending out a shockwave that deals magic damage and reveals enemy units hit. If Tempest hits an enemy, Lee Sin can cast cripple for the next 3 seconds.<br>Cripple: Lee Sin cripples nearby enemies damaged by Tempest, reducing their Movement Speed for 4 seconds. Movement Speed recovers gradually over the duration.",
						"tooltip": "<spellActive>Tempest: </spellActive>Lee Sin smashes the ground, sending out a shockwave that deals {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> magic damage. <specialRules>If Tempest hits an enemy, Lee Sin can cast Cripple for the next {{ e6 }} seconds.</specialRules><br /><br /><spellActive>Cripple: </spellActive>Lee Sin cripples nearby enemies struck by Tempest for {{ e5 }} seconds, slowing their Movement Speed by {{ e2 }}%. Movement Speed recovers gradually over the duration.",
						"leveltip": {
							"label": [
								"Tempest Damage",
								"Cripple Slow"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								60,
								95,
								130,
								165,
								200
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"20/30/40/50/60",
							"60/95/130/165/200",
							"30",
							"4",
							"3",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Energy / {{ e4 }} Energy",
						"maxammo": "-1",
						"range": [
							425,
							425,
							425,
							425,
							425
						],
						"rangeBurn": "425",
						"image": {
							"full": "BlindMonkEOne.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy / {{ e4 }} Energy"
					},
					{
						"id": "BlindMonkRKick",
						"name": "Dragon's Rage",
						"description": "Lee Sin performs a powerful roundhouse kick launching his target back, dealing physical damage to the target and any enemies they collide with. Enemies the target collides with are knocked into the air for a short duration. This technique was taught to him by Jesse Perring, although Lee Sin does not kick players off the map.",
						"tooltip": "Lee Sin performs a powerful roundhouse kick knocking an enemy champion back and dealing {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage.<br /><br />Enemies the target collides with are knocked into the air briefly and take physical damage equal to {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> plus {{ e3 }}% of the initial target's bonus health.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus Health Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							85,
							60
						],
						"cooldownBurn": "110/85/60",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								150,
								300,
								450
							],
							[
								75,
								125,
								175
							],
							[
								12,
								15,
								18
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/300/450",
							"75/125/175",
							"12/15/18",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 2,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 2,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							375,
							375,
							375
						],
						"rangeBurn": "375",
						"image": {
							"full": "BlindMonkRKick.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Flurry",
					"description": "After Lee Sin uses an ability, his next 2 basic attacks gain 40% Attack Speed and return 20/10 Energy.",
					"image": {
						"full": "LeeSinPassive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "LeeSin",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3252",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "LeeSin",
						"title": "LeeSinTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3252",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Leona": {
				"id": "Leona",
				"key": "89",
				"name": "Leona",
				"title": "the Radiant Dawn",
				"image": {
					"full": "Leona.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "89000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "89001",
						"num": 1,
						"name": "Valkyrie Leona",
						"chromas": false
					},
					{
						"id": "89002",
						"num": 2,
						"name": "Defender Leona",
						"chromas": false
					},
					{
						"id": "89003",
						"num": 3,
						"name": "Iron Solari Leona",
						"chromas": false
					},
					{
						"id": "89004",
						"num": 4,
						"name": "Pool Party Leona",
						"chromas": true
					},
					{
						"id": "89008",
						"num": 8,
						"name": "PROJECT: Leona",
						"chromas": false
					},
					{
						"id": "89009",
						"num": 9,
						"name": "Barbecue Leona",
						"chromas": false
					}
				],
				"lore": "Imbued with the fire of the sun, Leona is a holy warrior of the Solari who defends Mount Targon with her Zenith Blade and the Shield of Daybreak. Her skin shimmers with starfire while her eyes burn with the power of the celestial Aspect within her. Armored in gold and bearing a terrible burden of ancient knowledge, Leona brings enlightenment to some, death to others.",
				"blurb": "Imbued with the fire of the sun, Leona is a holy warrior of the Solari who defends Mount Targon with her Zenith Blade and the Shield of Daybreak. Her skin shimmers with starfire while her eyes burn with the power of the celestial Aspect within her...",
				"allytips": [
					"Lead the charge and mark your foes with Sunlight before your allies deal damage.",
					"Shield of Daybreak and Zenith Blade form a powerful offensive combo.",
					"You can absorb a huge amount of damage using Eclipse, but you must stay near enemies to gain the bonus duration."
				],
				"enemytips": [
					"When Leona activates Eclipse, you have three seconds to get away from her before she deals damage.",
					"Only foes in the center of Solar Flare get stunned, so you can often avoid this if you're quick."
				],
				"tags": [
					"Tank",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 8,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 576.16,
					"hpperlevel": 87,
					"mp": 302.2,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 47,
					"armorperlevel": 3.6,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.85,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 60.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.9
				},
				"spells": [
					{
						"id": "LeonaShieldOfDaybreak",
						"name": "Shield of Daybreak",
						"description": "Leona uses her shield to perform her next basic attack, dealing bonus magic damage and stunning the target.",
						"tooltip": "Next basic attack deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and stuns for {{ e1 }} second.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								10,
								35,
								60,
								85,
								110
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1",
							"10/35/60/85/110",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							100,
							100,
							100,
							100,
							100
						],
						"rangeBurn": "100",
						"image": {
							"full": "LeonaShieldOfDaybreak.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LeonaSolarBarrier",
						"name": "Eclipse",
						"description": "Leona raises her shield to gain Armor and Magic Resist. When the duration first ends, if there are nearby enemies, she will deal magic damage to them and prolong the duration of the effect.",
						"tooltip": "Grants {{ e4 }} <span class=\"colorFFFF00\">(+{{ f1 }})</span> bonus Armor and {{ e2 }} <span class=\"colorFF00FF\">(+{{ f2 }})</span> Magic Resist for {{ e3 }} seconds. When the effect ends, nearby enemies struck take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and Leona retains her bonus Armor and Magic Resist for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Armor",
								"Magic Resist"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							14,
							14,
							14,
							14
						],
						"cooldownBurn": "14",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								40,
								80,
								120,
								160,
								200
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								25,
								35,
								45,
								55,
								65
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/80/120/160/200",
							"20/30/40/50/60",
							"3",
							"25/35/45/55/65",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusarmor",
								"coeff": 0.2,
								"key": "f1"
							},
							{
								"link": "bonusspellblock",
								"coeff": 0.2,
								"key": "f2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "LeonaSolarBarrier.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LeonaZenithBlade",
						"name": "Zenith Blade",
						"description": "Leona projects a solar image of her sword, dealing magic damage to all enemies in a line. When the image fades, the last enemy champion struck will be briefly immobilized and Leona will dash to them.",
						"tooltip": "Strikes all enemies in a line dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The last enemy Champion struck will be rooted for {{ e2 }} seconds and Leona will dash to them.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							875,
							875,
							875,
							875,
							875
						],
						"rangeBurn": "875",
						"image": {
							"full": "LeonaZenithBlade.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LeonaSolarFlare",
						"name": "Solar Flare",
						"description": "Leona calls down a beam of solar energy, dealing damage to enemies in an area. Enemies in the center of the area are stunned, while enemies on the outside are slowed. Afterward, Leona's sword is charged with the power of the sun and deals bonus magic damage for a few attacks.",
						"tooltip": "Calls down a radiant beam of solar energy dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing enemies by {{ e1 }}% for {{ e2 }} seconds. Enemies in the center of the flare are stunned instead of slowed.<br /><br />Leona's sword remains charged with <span class=\"colorFFBB00\">Incandescence</span>, causing her next {{ e5 }} basic attacks to gain 100 range and deal {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus magic damage on hit.",
						"leveltip": {
							"label": [
								"Damage",
								"Incandescence Damage",
								"Incandescent Attacks",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							90,
							75,
							60
						],
						"cooldownBurn": "90/75/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								80,
								80,
								80
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								30,
								40,
								50
							],
							[
								100,
								175,
								250
							],
							[
								3,
								4,
								5
							],
							[
								5,
								5,
								5
							],
							[
								100,
								100,
								100
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80",
							"1.5",
							"30/40/50",
							"100/175/250",
							"3/4/5",
							"5",
							"100",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "LeonaSolarFlare.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Sunlight",
					"description": "Damaging spells afflict enemies with Sunlight for 1.5 seconds. When allied Champions deal damage to those targets, they consume the Sunlight to deal additional magic damage.",
					"image": {
						"full": "LeonaSunlight.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Leona",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Leona",
						"title": "LeonaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Lissandra": {
				"id": "Lissandra",
				"key": "127",
				"name": "Lissandra",
				"title": "the Ice Witch",
				"image": {
					"full": "Lissandra.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "127000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "127001",
						"num": 1,
						"name": "Bloodstone Lissandra",
						"chromas": false
					},
					{
						"id": "127002",
						"num": 2,
						"name": "Blade Queen Lissandra",
						"chromas": false
					},
					{
						"id": "127003",
						"num": 3,
						"name": "Program Lissandra",
						"chromas": false
					}
				],
				"lore": "Lissandra's magic twists the pure power of ice into something dark and terrible. With the force of her black ice, she does more than freeze—she impales and crushes those who oppose her. To the terrified denizens of the north, she is known only as ''The Ice Witch.'' The truth is much more sinister: Lissandra is a corruptor of nature who plots to unleash an ice age on the world.",
				"blurb": "Lissandra's magic twists the pure power of ice into something dark and terrible. With the force of her black ice, she does more than freeze—she impales and crushes those who oppose her. To the terrified denizens of the north, she is known only as ''The...",
				"allytips": [
					"You can instantly use your ultimate on yourself by pressing the self cast key and the ultimate key at once (alt+R by default).",
					"Casting Glacial Path and then running in the opposite direction will leave your enemies uncertain which way you will actually go.",
					"Lissandra's abilities are shorter range than those of many mages. As a result, buying items that offer both ability power and defense, like Zhonya's Hourglass and Banshee's Veil, can be a great choice to help her both survive and deal damage."
				],
				"enemytips": [
					"The best way to stop Lissandra from moving using her Glacial Path is to immobilize her before she reactivates it.",
					"Lissandra's Ring of Frost has a long cooldown at early ranks; engage her while it's on cooldown.",
					"Lissandra's Ice Shard only slows the first unit it hits. Approach Lissandra from behind your team's minions to avoid being slowed."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 5,
					"magic": 8,
					"difficulty": 6
				},
				"stats": {
					"hp": 518,
					"hpperlevel": 87,
					"mp": 304,
					"mpperlevel": 60,
					"movespeed": 325,
					"armor": 20.216,
					"armorperlevel": 3.7,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 5.672,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53,
					"attackdamageperlevel": 2.7,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "LissandraQ",
						"name": "Ice Shard",
						"description": "Throws a spear of ice that shatters when it hits an enemy, dealing magic damage and slowing Movement Speed. Shards pass through the target, dealing the same damage to other enemies hit.",
						"tooltip": "Throws a spear of ice that shatters when it hits an enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing Movement Speed by {{ e3 }}% for {{ e2 }} seconds. Shards then pass through the target, dealing the same damage to other enemies hit.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.25,
							4.5,
							3.75,
							3
						],
						"cooldownBurn": "6/5.25/4.5/3.75/3",
						"cost": [
							85,
							85,
							85,
							85,
							85
						],
						"costBurn": "85",
						"effect": [
							null,
							[
								70,
								100,
								130,
								160,
								190
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								16,
								19,
								22,
								25,
								28
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/100/130/160/190",
							"1.5",
							"16/19/22/25/28",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "LissandraQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LissandraW",
						"name": "Ring of Frost",
						"description": "Freezes nearby enemies in ice, dealing magic damage and rooting them. ",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and roots them for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Root Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								1.1,
								1.2,
								1.3,
								1.4,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"1.1/1.2/1.3/1.4/1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "LissandraW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LissandraE",
						"name": "Glacial Path",
						"description": "Lissandra creates an ice claw that deals magic damage. Reactivating this ability transports Lissandra to the claw's current location.",
						"tooltip": "Casts an ice claw that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies hit.<br /><br />Reactivating this ability transports Lissandra to the claw's current location.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							21,
							18,
							15,
							12
						],
						"cooldownBurn": "24/21/18/15/12",
						"cost": [
							80,
							85,
							90,
							95,
							100
						],
						"costBurn": "80/85/90/95/100",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								14,
								13,
								12,
								11,
								10
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"14/13/12/11/10",
							"20",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1050,
							1050,
							1050,
							1050,
							1050
						],
						"rangeBurn": "1050",
						"image": {
							"full": "LissandraE.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LissandraR",
						"name": "Frozen Tomb",
						"description": "If cast on an enemy champion, the target is frozen solid, stunning it. If cast on Lissandra, she encases herself in dark ice, healing herself while becoming untargetable and invulnerable. Dark ice then emanates from the target dealing magic damage to enemies and slowing Movement Speed.",
						"tooltip": "<span class=\"colorFF9999\">On Enemy Cast: </span>Freezes target champion solid, stunning it for {{ e4 }} seconds.<br /><br /><span class=\"colorCCFF99\">On Self Cast: </span>Lissandra encases herself in dark ice for {{ e5 }} seconds, healing for {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span>, increased by {{ e7 }}% for each {{ e8 }}% Health she is missing. During this time Lissandra is untargetable and invulnerable but is unable to take any actions.<br /><br />Dark ice then emanates from the target dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies. The ice lasts for {{ e3 }} seconds and slows enemy Movement Speed by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Heal",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							105,
							80
						],
						"cooldownBurn": "130/105/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								30,
								45,
								75
							],
							[
								3,
								3,
								3
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								100,
								150,
								200
							],
							[
								1,
								1,
								1
							],
							[
								1,
								1,
								1
							],
							[
								292,
								292,
								292
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"30/45/75",
							"3",
							"1.5",
							"2.5",
							"100/150/200",
							"1",
							"1",
							"292",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "LissandraR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Iceborn",
					"description": "Every several seconds Lissandra's next ability costs no Mana. This cooldown is reduced whenever Lissandra impairs an enemy's movement with an ability (does not apply to movement-impairing effects from items).",
					"image": {
						"full": "Lissandra_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Lissandra",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3191",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lissandra",
						"title": "LissandraTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Lucian": {
				"id": "Lucian",
				"key": "236",
				"name": "Lucian",
				"title": "the Purifier",
				"image": {
					"full": "Lucian.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "236000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "236001",
						"num": 1,
						"name": "Hired Gun Lucian",
						"chromas": false
					},
					{
						"id": "236002",
						"num": 2,
						"name": "Striker Lucian",
						"chromas": false
					},
					{
						"id": "236006",
						"num": 6,
						"name": "PROJECT: Lucian",
						"chromas": false
					},
					{
						"id": "236007",
						"num": 7,
						"name": "Heartseeker Lucian",
						"chromas": false
					}
				],
				"lore": "Once a Sentinel of Light, Lucian is a grim hunter of undying spirits, pursuing them relentlessly and annihilating them with his twin relic pistols. Consumed by the need to avenge his dead wife, he will not rest until Thresh, the specter who holds her soul, is destroyed. Merciless and single-minded, Lucian allows nothing to stand in the path of this vengeance—anyone or anything foolish enough to try is blown away by an overwhelming barrage of magical gunfire.",
				"blurb": "Once a Sentinel of Light, Lucian is a grim hunter of undying spirits, pursuing them relentlessly and annihilating them with his twin relic pistols. Consumed by the need to avenge his dead wife, he will not rest until Thresh, the specter who holds her...",
				"allytips": [
					"For optimal burst, try to combine Relentless Pursuit into Piercing Light.",
					"Ardent Blaze actually explodes in a star pattern. Try to line it up so the spokes hit enemy champions.",
					"Once you have chosen an angle for The Culling, you cannot change it. Pick your moment well!",
					"Because of Lightslinger, Lucian benefits more from Attack Damage than he does from Attack Speed."
				],
				"enemytips": [
					"Lucian has strong burst, but little sustained damage.",
					"Lucian cannot change the aim of The Culling. Take advantage of this by avoiding the angle of the bullets.",
					"Piercing Light does not give Lucian extra Attack Range. He still needs to find a target in range to line up his shot. Avoid Piercing Light by anticipating the angle Lucian will choose."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 3,
					"difficulty": 6
				},
				"stats": {
					"hp": 554.4,
					"hpperlevel": 80,
					"mp": 348.88,
					"mpperlevel": 38,
					"movespeed": 335,
					"armor": 33,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 6,
					"hpregenperlevel": 0.65,
					"mpregen": 8.176,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 3.3
				},
				"spells": [
					{
						"id": "LucianQ",
						"name": "Piercing Light",
						"description": "Lucian shoots a bolt of piercing light through a target.",
						"tooltip": "Shoots a bolt of piercing light through an enemy unit, damaging enemies in a line for {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> ({{ e2 }}% of bonus Attack Damage) physical damage.<br /><br /><rules><span class=\"color8c8c8c\">Piercing Light's cast time decreases slightly as Lucian gains levels.</span></rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus Attack Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								85,
								120,
								155,
								190,
								225
							],
							[
								60,
								70,
								80,
								90,
								100
							],
							[
								900,
								900,
								900,
								900,
								900
							],
							[
								0.41,
								0.41,
								0.41,
								0.41,
								0.41
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"85/120/155/190/225",
							"60/70/80/90/100",
							"900",
							"0.41",
							"100",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.6,
									0.75,
									0.9,
									1.05,
									1.2
								],
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "LucianQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LucianW",
						"name": "Ardent Blaze",
						"description": "Lucian shoots a missile that explodes in a star shape, marking enemies. Lucian gains Movement Speed for attacking marked enemies.",
						"tooltip": "Fires a shot that explodes upon enemy contact or reaching the end of its path. The explosion deals {{ e1 }} <span class=\"color88FF88\">(+{{ a1 }})</span> magic damage and marks enemies for 6 seconds.<br /><br />When Lucian or his allies damage a marked target, Lucian gains {{ e2 }} Movement Speed for 1 second.",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed",
								"Cooldown</br>"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								60,
								65,
								70,
								75,
								80
							],
							[
								900,
								900,
								900,
								900,
								900
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								700,
								700,
								700,
								700,
								700
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"60/65/70/75/80",
							"900",
							"0",
							"1",
							"200",
							"1",
							"6",
							"1",
							"700"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "LucianW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LucianE",
						"name": "Relentless Pursuit",
						"description": "Lucian quickly dashes a short distance. Lightslinger attacks reduce Relentless Pursuit's cooldown.",
						"tooltip": "Quickly dashes a short distance.<br /><br />Whenever Lightslinger hits an enemy, Relentless Pursuit's cooldown is reduced by {{ e1 }} second (doubles to {{ e2 }} seconds against champions).",
						"leveltip": {
							"label": [
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20,
							18,
							16,
							14
						],
						"cooldownBurn": "22/20/18/16/14",
						"cost": [
							40,
							30,
							20,
							10,
							0
						],
						"costBurn": "40/30/20/10/0",
						"effect": [
							null,
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								425,
								425,
								425,
								425,
								425
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								1350,
								1350,
								1350,
								1350,
								1350
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1",
							"2",
							"425",
							"200",
							"1350",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							445,
							445,
							445,
							445,
							445
						],
						"rangeBurn": "445",
						"image": {
							"full": "LucianE.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LucianR",
						"name": "The Culling",
						"description": "Lucian unleashes a torrent of shots from his weapons.",
						"tooltip": "Lucian moves freely while firing rapidly in a single direction for {{ e1 }} seconds. His shots collide with the first enemy they hit and each do {{ e2 }} <span class=\"color88FF88\">(+{{ a1 }})</span> <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage.  The Culling does {{ e8 }}% damage to minions.<br /><br />Lucian may use Relentless Pursuit during The Culling.<br /><br />Reactivate The Culling to cancel early.",
						"leveltip": {
							"label": [
								"Damage",
								"Number of Shots",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							100,
							90
						],
						"cooldownBurn": "110/100/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								3,
								3,
								3
							],
							[
								20,
								35,
								50
							],
							[
								2.5,
								3,
								3.5
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								20,
								25,
								30
							],
							[
								0.75,
								0.75,
								0.75
							],
							[
								1050,
								1050,
								1050
							],
							[
								400,
								400,
								400
							],
							[
								125,
								125,
								125
							],
							[
								0.25,
								0.25,
								0.25
							]
						],
						"effectBurn": [
							null,
							"3",
							"20/35/50",
							"2.5/3/3.5",
							"2.5",
							"20/25/30",
							"0.75",
							"1050",
							"400",
							"125",
							"0.25"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 0.2,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1400,
							1400,
							1400
						],
						"rangeBurn": "1400",
						"image": {
							"full": "LucianR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Lightslinger",
					"description": "Whenever Lucian uses an ability, his next attack becomes a double-shot.",
					"image": {
						"full": "Lucian_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Lucian",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lucian",
						"title": "LucianTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Lulu": {
				"id": "Lulu",
				"key": "117",
				"name": "Lulu",
				"title": "the Fae Sorceress",
				"image": {
					"full": "Lulu.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "117000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "117001",
						"num": 1,
						"name": "Bittersweet Lulu",
						"chromas": false
					},
					{
						"id": "117002",
						"num": 2,
						"name": "Wicked Lulu",
						"chromas": false
					},
					{
						"id": "117003",
						"num": 3,
						"name": "Dragon Trainer Lulu",
						"chromas": false
					},
					{
						"id": "117004",
						"num": 4,
						"name": "Winter Wonder Lulu",
						"chromas": false
					},
					{
						"id": "117005",
						"num": 5,
						"name": "Pool Party Lulu",
						"chromas": true
					},
					{
						"id": "117006",
						"num": 6,
						"name": "Star Guardian Lulu",
						"chromas": false
					}
				],
				"lore": "The yordle mage Lulu is known for conjuring dreamlike illusions and fanciful creatures as she roams Runeterra with her fairy companion Pix. Lulu shapes reality on a whim, warping the fabric of the world, and what she views as the constraints of this mundane, physical realm. While others might consider her magic at best unnatural, and at worst dangerous, she believes everyone could use a touch of enchantment.",
				"blurb": "The yordle mage Lulu is known for conjuring dreamlike illusions and fanciful creatures as she roams Runeterra with her fairy companion Pix. Lulu shapes reality on a whim, warping the fabric of the world, and what she views as the constraints of this...",
				"allytips": [
					"Glitterlance can be fired at odd angles depending on where your cursor is - Moving your cursor closer to Pix and Lulu will change your area of effect size considerably.",
					"Consider casting Help, Pix! on ranged attackers for the Pix boost and Wild Growth on Tanks or Fighters for the added initiation power."
				],
				"enemytips": [
					"The shots from Lulu's faerie can be intercepted - hide behind your minions to avoid the additional Faerie attacks.",
					"Lulu excels when opponents heavily commit. Don't give her this chance! Use heavy harass tactics instead to force Lulu and her partner out of lane."
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 5,
					"magic": 7,
					"difficulty": 5
				},
				"stats": {
					"hp": 525,
					"hpperlevel": 74,
					"mp": 350,
					"mpperlevel": 55,
					"movespeed": 330,
					"armor": 28.22,
					"armorperlevel": 3.7,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6,
					"hpregenperlevel": 0.6,
					"mpregen": 11,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 46.368,
					"attackdamageperlevel": 2.6,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.25
				},
				"spells": [
					{
						"id": "LuluQ",
						"name": "Glitterlance",
						"description": "Pix and Lulu each fire a bolt of magical energy that heavily slows all enemies it hits. An enemy can only be damaged by one bolt.",
						"tooltip": "Lulu and Pix each fire a piercing bolt dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy hit and {{ f4 }}<span class=\"color99FF99\"> (+{{ f5 }})</span> to all additional enemies. Enemies hit are slowed by {{ e2 }}%, decaying over the next {{ e3 }} second(s).<br /><br />An enemy can only be damaged for up to a total of <span class=\"color99FF99\">{{ f6 }}</span> damage per cast.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							7,
							7,
							7,
							7
						],
						"cooldownBurn": "7",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.7,
								0.7,
								0.7,
								0.7,
								0.7
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"80",
							"2",
							"0",
							"0.7",
							"8",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "LuluQ.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LuluW",
						"name": "Whimsy",
						"description": "If cast on an ally, grants them Attack Speed and Movement Speed for a short time. If cast on an enemy, turns them into an adorable critter that can't attack or cast spells.",
						"tooltip": "<span class=\"colorCCFF99\">On Ally Cast: </span>Target ally gains {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span>% Movement Speed and {{ e7 }}% Attack Speed for {{ e5 }} seconds.<br /><br /><span class=\"colorFF9999\">On Enemy Cast: </span>Polymorphs an enemy champion for {{ e3 }} seconds, disabling their ability to attack or cast spells and reducing their base Movement Speed by {{ e4 }}.",
						"leveltip": {
							"label": [
								"Movement and Attack Speed Duration",
								"Attack Speed Bonus",
								"Polymorph Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e7 }}% -> {{ e7NL }}%",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							65,
							65,
							65,
							65,
							65
						],
						"costBurn": "65",
						"effect": [
							null,
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.25,
								1.5,
								1.75,
								2,
								2.25
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								3,
								3.25,
								3.5,
								3.75,
								4
							],
							[
								0.01,
								0.01,
								0.01,
								0.01,
								0.01
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30",
							"0",
							"1.25/1.5/1.75/2/2.25",
							"60",
							"3/3.25/3.5/3.75/4",
							"0.01",
							"25/30/35/40/45",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.05,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "LuluW.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LuluE",
						"name": "Help, Pix!",
						"description": "If cast on an ally, commands Pix to jump to an ally and shield them. He then follows them and aids their attacks. If cast on an enemy, commands Pix to jump to an enemy and damage them. He then follows them and grants you vision of that enemy.",
						"tooltip": "<span class=\"colorCCFF99\">On Ally Cast: </span>Commands Pix to jump to an ally and then follow and aid their attacks instead of Lulu's for {{ e1 }} seconds. If the ally is a champion, Pix shields them from {{ e2 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> damage for {{ e1 }} seconds.<br /><br /><span class=\"colorFF9999\">On Enemy Cast: </span>Pix deals {{ e4 }}<span class=\"color99FF99\"> (+{{ a2 }})</span> magic damage to target enemy unit. Pix then follows and grants <span class=\"coloree91d7\">True Sight</span> of them for {{ e6 }} seconds.</span> ",
						"leveltip": {
							"label": [
								"Shield Amount",
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6",
							"70/105/140/175/210",
							"50",
							"80/110/140/170/200",
							"25",
							"4",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "LuluE.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LuluR",
						"name": "Wild Growth",
						"description": "Lulu enlarges an ally, knocking nearby enemies into the air and granting the ally a large amount of bonus health. For the next few seconds, that ally gains an aura that slows nearby enemies.",
						"tooltip": "Lulu enlarges her ally, knocking nearby enemies into the air. For {{ e4 }} seconds, her ally gains {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> bonus health and slows nearby enemies by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Bonus Health",
								"Slow Percent",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							95,
							80
						],
						"cooldownBurn": "110/95/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								300,
								450,
								600
							],
							[
								30,
								45,
								60
							],
							[
								1,
								1,
								1
							],
							[
								7,
								7,
								7
							],
							[
								50,
								50,
								50
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"300/450/600",
							"30/45/60",
							"1",
							"7",
							"50",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "LuluR.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Pix, Faerie Companion",
					"description": "Pix is a wild Faerie that accompanies Lulu. Pix will fire a barrage of magical energy at targets that Lulu attacks.",
					"image": {
						"full": "Lulu_PixFaerieCompanion.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Lulu",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerTeleport",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerTeleport",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lulu",
						"title": "LuluTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Lux": {
				"id": "Lux",
				"key": "99",
				"name": "Lux",
				"title": "the Lady of Luminosity",
				"image": {
					"full": "Lux.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "99000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "99001",
						"num": 1,
						"name": "Sorceress Lux",
						"chromas": false
					},
					{
						"id": "99002",
						"num": 2,
						"name": "Spellthief Lux",
						"chromas": false
					},
					{
						"id": "99003",
						"num": 3,
						"name": "Commando Lux",
						"chromas": false
					},
					{
						"id": "99004",
						"num": 4,
						"name": "Imperial Lux",
						"chromas": false
					},
					{
						"id": "99005",
						"num": 5,
						"name": "Steel Legion Lux",
						"chromas": false
					},
					{
						"id": "99006",
						"num": 6,
						"name": "Star Guardian Lux",
						"chromas": false
					},
					{
						"id": "99007",
						"num": 7,
						"name": "Elementalist Lux",
						"chromas": false
					},
					{
						"id": "99008",
						"num": 8,
						"name": "Lunar Empress Lux",
						"chromas": true
					}
				],
				"lore": "Luxanna Crownguard hails from Demacia, an insular realm where magical abilities are viewed with fear and suspicion. Able to bend light to her will, she grew up dreading discovery and exile, and was forced to keep her power secret, in order to preserve her family's noble status. Nonetheless, Lux's optimism and resilience have led her to embrace her unique talents, and she now covertly wields them in service of her homeland.",
				"blurb": "Luxanna Crownguard hails from Demacia, an insular realm where magical abilities are viewed with fear and suspicion. Able to bend light to her will, she grew up dreading discovery and exile, and was forced to keep her power secret, in order to preserve...",
				"allytips": [
					"Lux has great zone control abilities. Try to set up Lucent Singularity to prevent an enemy's advance or escape.",
					"If you have trouble landing Prismatic Barrier, remember that it returns to you after it reaches max range. Try positioning yourself to hit your allies with its return trip.",
					"Lucent Singularity is a great scouting tool. Try throwing it into brush before walking into it to check for ambushes."
				],
				"enemytips": [
					"Lux has powerful zone control abilities. Try to spread out and attack from different directions so she cannot lock down a specific area.",
					"When retreating with low health, be prepared to dodge Lux's Final Spark, a red targeting beam fires prior to the main beam, so try to move to the side if possible."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 4,
					"magic": 9,
					"difficulty": 5
				},
				"stats": {
					"hp": 490,
					"hpperlevel": 91,
					"mp": 384,
					"mpperlevel": 47,
					"movespeed": 330,
					"armor": 18.72,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.54,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "LuxLightBinding",
						"name": "Light Binding",
						"description": "Lux releases a sphere of light that binds and deals damage to up to two enemy units.",
						"tooltip": "Fires a ball of light, rooting up to two enemies for {{ e3 }} seconds and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to each.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12.5,
							12,
							11.5,
							11
						],
						"cooldownBurn": "13/12.5/12/11.5/11",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								50,
								100,
								150,
								200,
								250
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/100/150/200/250",
							"50",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1175,
							1175,
							1175,
							1175,
							1175
						],
						"rangeBurn": "1175",
						"image": {
							"full": "LuxLightBinding.png",
							"sprite": "spell6.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LuxPrismaticWave",
						"name": "Prismatic Barrier",
						"description": "Lux throws her wand and bends the light around any friendly target it touches, protecting them from enemy damage.",
						"tooltip": "Throws Lux's wand in target direction protecting her and all allied Champions it touches from {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for 3 seconds.<br /><br />Upon reaching its destination it returns to Lux, protecting her and other allied Champions it touches from another {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for 3 seconds.<br /><br /><rules>Shielding an ally with the outgoing shield doubles the value of the returning shield.</rules>",
						"leveltip": {
							"label": [
								"Shield",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								2,
								4,
								6,
								8,
								10
							],
							[
								50,
								65,
								80,
								95,
								110
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2/4/6/8/10",
							"50/65/80/95/110",
							"3",
							"100",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "LuxPrismaticWave.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LuxLightStrikeKugel",
						"name": "Lucent Singularity",
						"description": "Fires an anomaly of twisted light to an area, which slows nearby enemies. Lux can detonate it to damage enemies in the area of effect.",
						"tooltip": "Creates a zone that slows enemies by {{ e1 }}%. After {{ e3 }} seconds the zone detonates dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Activate again to detonate early.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Amount",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							70,
							85,
							100,
							115,
							130
						],
						"costBurn": "70/85/100/115/130",
						"effect": [
							null,
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/30/35/40/45",
							"60/105/150/195/240",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "LuxLightStrikeKugel.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "LuxMaliceCannon",
						"name": "Final Spark",
						"description": "After gathering energy, Lux fires a beam of light that deals damage to all targets in the area. If Final Spark kills a champion, part of its cooldown is refunded. In addition, triggers Lux's passive ability and refreshes the Illumination debuff duration.",
						"tooltip": "Fires a dazzling ray of light dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in a line. If Final Spark kills an enemy champion, {{ e3 }}% of its cooldown is refunded.<br /><br />Final Spark ignites and refreshes the Illumination debuff. ",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown Refund",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							80,
							65,
							50
						],
						"cooldownBurn": "80/65/50",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								300,
								400,
								500
							],
							[
								1,
								1,
								1
							],
							[
								10,
								30,
								50
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"300/400/500",
							"1",
							"10/30/50",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3340,
							3340,
							3340
						],
						"rangeBurn": "3340",
						"image": {
							"full": "LuxMaliceCannon.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Illumination",
					"description": "Lux's damaging spells charge the target with energy for 6 seconds. Lux's next attack ignites the energy, dealing bonus magic damage (depending on Lux's level) to the target.",
					"image": {
						"full": "LuxIlluminatingFraulein.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Lux",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3114",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Lux",
						"title": "LuxTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Malphite": {
				"id": "Malphite",
				"key": "54",
				"name": "Malphite",
				"title": "Shard of the Monolith",
				"image": {
					"full": "Malphite.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "54000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "54001",
						"num": 1,
						"name": "Shamrock Malphite",
						"chromas": false
					},
					{
						"id": "54002",
						"num": 2,
						"name": "Coral Reef Malphite",
						"chromas": false
					},
					{
						"id": "54003",
						"num": 3,
						"name": "Marble Malphite",
						"chromas": false
					},
					{
						"id": "54004",
						"num": 4,
						"name": "Obsidian Malphite",
						"chromas": false
					},
					{
						"id": "54005",
						"num": 5,
						"name": "Glacial Malphite",
						"chromas": false
					},
					{
						"id": "54006",
						"num": 6,
						"name": "Mecha Malphite",
						"chromas": true
					},
					{
						"id": "54007",
						"num": 7,
						"name": "Ironside Malphite",
						"chromas": false
					}
				],
				"lore": "A massive creature of living stone, Malphite struggles to impose blessed order on a chaotic world. Birthed as a servitor-shard to an otherworldly obelisk known as the Monolith, he used his tremendous elemental strength to maintain and protect his progenitor, but ultimately failed. The only survivor of the destruction that followed, Malphite now endures Runeterra's soft folk and their fluid temperaments, while struggling to find a new role worthy of the last of his kind.",
				"blurb": "A massive creature of living stone, Malphite struggles to impose blessed order on a chaotic world. Birthed as a servitor-shard to an otherworldly obelisk known as the Monolith, he used his tremendous elemental strength to maintain and protect his...",
				"allytips": [
					"Armor naturally reduces the rate that attacks go through Granite Shield, so Brutal Strikes will strengthen the shield against physical damage.",
					"Despite his abilities scaling on Armor, some games require Malphite to get Magic Resist. When those games occur, try getting Aegis of the Legion, Mercury's Treads, and Guardian Angel."
				],
				"enemytips": [
					"If you're a physical damage character stay behind your allies when fighting Malphite. Ground Slam can significantly reduce your damage output.",
					"Malphite is one of a couple tanks who are capable of jungling. Watch out if he gets Smite."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 9,
					"magic": 7,
					"difficulty": 2
				},
				"stats": {
					"hp": 574.2,
					"hpperlevel": 90,
					"mp": 282.2,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 37,
					"armorperlevel": 3.75,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 7.324,
					"mpregenperlevel": 0.55,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61.97,
					"attackdamageperlevel": 3.375,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 3.4
				},
				"spells": [
					{
						"id": "SeismicShard",
						"name": "Seismic Shard",
						"description": "Using his primal elemental magic, Malphite sends a shard of the earth through the ground at his foe, dealing damage upon impact and stealing Movement Speed for 4 seconds.",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and steals {{ e2 }}% Movement Speed from the target for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								70,
								120,
								170,
								220,
								270
							],
							[
								14,
								17,
								20,
								23,
								26
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/120/170/220/270",
							"14/17/20/23/26",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "SeismicShard.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Obduracy",
						"name": "Brutal Strikes",
						"description": "Malphite starts to hit with such force that his attacks deal damage to all units in front of him. Passively increases his Armor (this amount is tripled while Granite Shield is active).",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Malphite's armor is increased by {{ e1 }}% (<span class=\"colorFFFF00\">{{ f1 }}</span>). While Granite Shield is active, this bonus is tripled to {{ f4.0 }}% (<span class=\"colorFFFF00\">{{ f3 }}</span>).<br /><br /><span class=\"colorFF9900\">Active: </span>Basic attacks deal an additional {{ e2 }} <span class=\"colorFFFF00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to the target and nearby enemies. Lasts {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Armor",
								"Damage"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							25,
							25,
							25,
							25,
							25
						],
						"costBurn": "25",
						"effect": [
							null,
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								15,
								30,
								45,
								60,
								75
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/15/20/25/30",
							"15/30/45/60/75",
							"6",
							"225",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "Obduracy.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Landslide",
						"name": "Ground Slam",
						"description": "Malphite slams the ground, sending out a shockwave that deals magic damage based on his Armor as damage and reduces the Attack Speed of enemies for a short duration.",
						"tooltip": "Malphite slams the ground dealing {{ e2 }} <span class=\"colorFFFF00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to surrounding enemies, reducing their Attack Speed by {{ e1 }}% for {{ e4 }} seconds.<br /><br />This ability gains damage equal to {{ e3 }}% of Malphite's Armor.",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Speed Reduction",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							7,
							7,
							7,
							7
						],
						"cooldownBurn": "7",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								60,
								95,
								130,
								165,
								200
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/35/40/45/50",
							"60/95/130/165/200",
							"40",
							"3",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "armor",
								"coeff": 0.3,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "Landslide.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UFSlash",
						"name": "Unstoppable Force",
						"description": "Malphite ferociously charges to a location, damaging enemies and knocking them into the air.",
						"tooltip": "Malphite charges to target area. Upon his arrival he deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and knocks them into the air for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							115,
							100
						],
						"cooldownBurn": "130/115/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								1.5,
								1.75,
								2
							],
							[
								200,
								300,
								400
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.5/1.75/2",
							"200/300/400",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "UFSlash.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Granite Shield",
					"description": "Malphite is shielded by a layer of rock which absorbs damage up to 10% of his maximum Health. If Malphite has not been hit for 10 seconds, this effect recharges.",
					"image": {
						"full": "Malphite_GraniteShield.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Malphite",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3082",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malphite",
						"title": "MalphiteTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Malzahar": {
				"id": "Malzahar",
				"key": "90",
				"name": "Malzahar",
				"title": "the Prophet of the Void",
				"image": {
					"full": "Malzahar.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "90000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "90001",
						"num": 1,
						"name": "Vizier Malzahar",
						"chromas": false
					},
					{
						"id": "90002",
						"num": 2,
						"name": "Shadow Prince Malzahar",
						"chromas": false
					},
					{
						"id": "90003",
						"num": 3,
						"name": "Djinn Malzahar",
						"chromas": false
					},
					{
						"id": "90004",
						"num": 4,
						"name": "Overlord Malzahar",
						"chromas": false
					},
					{
						"id": "90005",
						"num": 5,
						"name": "Snow Day Malzahar",
						"chromas": false
					},
					{
						"id": "90006",
						"num": 6,
						"name": "Battle Boss Malzahar",
						"chromas": false
					}
				],
				"lore": "A religious zealot dedicated to the unification of all life, Malzahar truly believes the newly emergent Void to be the gateway to Runeterra's salvation. In the desert wastes of Shurima, he opened his mind to the universe, and the whispers that answered led him to Icathia. Amidst the ruins of that land, he gazed into the dark heart of the Void itself—and Malzahar emerged changed, a shepherd empowered to bring others into the fold… or to release the voidling creatures that dwell beneath.",
				"blurb": "A religious zealot dedicated to the unification of all life, Malzahar truly believes the newly emergent Void to be the gateway to Runeterra's salvation. In the desert wastes of Shurima, he opened his mind to the universe, and the whispers that answered...",
				"allytips": [
					"Wait to cast Void Swarm until there are nearby enemies for the Voidling to attack or kill.",
					"Use Call of the Void and Nether Grasp to renew the duration of Malefic Visions on enemies.",
					"Avoiding damage in lane maximizes the uptime on Void Shift, increasing Malzahar's safety dramatically."
				],
				"enemytips": [
					"When Malzahar hits a spell on enemies affected by Malefic Visions, the Visions are refreshed.",
					"Avoid minion waves that have been affected by Malefic Visions. You never know when they may die and pass the Visions onto you.",
					"Malzahar is especially dangerous when he has built up his Void Swarm."
				],
				"tags": [
					"Mage",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 2,
					"magic": 9,
					"difficulty": 6
				},
				"stats": {
					"hp": 537,
					"hpperlevel": 87,
					"mp": 300,
					"mpperlevel": 55,
					"movespeed": 335,
					"armor": 18,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 6,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.5
				},
				"spells": [
					{
						"id": "MalzaharQ",
						"name": "Call of the Void",
						"description": "Malzahar opens up two portals to the Void. After a short delay, they fire projectiles that deal Magic Damage and silence enemy champions.",
						"tooltip": "Malzahar opens two portals to the Void that fire projectiles inward, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage and silencing enemies hit for {{ e2 }} second(s).",
						"leveltip": {
							"label": [
								"Damage",
								"Silence Duration"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"1/1.25/1.5/1.75/2",
							"0.4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "MalzaharQ.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MalzaharW",
						"name": "Void Swarm",
						"description": "Malzahar summons Voidlings to attack nearby enemies.",
						"tooltip": "<span class=\"colorFF8C00\">Passive:</span> Casting Malzahar's other spells gives him Gathering Swarm, increasing the number of Voidlings summoned by Void Swarm (max {{ e6 }}).<br /><br /><span class=\"colorFF8C00\">Active:</span> Summons one or more Voidlings. Voidlings last {{ e1 }} seconds and deal an additional {{ e2 }} <scaleAP>(+{{ a1 }})</scaleAP> <scaleAD>(+{{ a2 }})</scaleAD> magic damage each hit.<br /><br /><span class=\"color919191\"><i>Voidlings deal {{ e3 }}% damage to lane minions affected by Malefic Visions.<br />Voidlings deal {{ e4 }}% damage to epic monsters.</i></span>",
						"leveltip": {
							"label": [
								"Voidling Bonus Damage",
								"Voidling Duration",
								"Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								8,
								8,
								9,
								9,
								10
							],
							[
								12,
								14,
								16,
								18,
								20
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								25000,
								25000,
								25000,
								25000,
								25000
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"8/8/9/9/10",
							"12/14/16/18/20",
							"300",
							"50",
							"25000",
							"2",
							"0.5",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.4,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "0",
						"range": [
							150,
							150,
							150,
							150,
							150
						],
						"rangeBurn": "150",
						"image": {
							"full": "MalzaharW.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MalzaharE",
						"name": "Malefic Visions",
						"description": "Malzahar infects his target's mind with cruel visions of their demise, dealing damage over time. Using Malzahar's other spells on the target will refresh the visions.<br><br>If the target dies while afflicted by the visions, they pass on to a nearby enemy unit and Malzahar gains Mana. Malzahar's Voidlings are attracted to affected units.",
						"tooltip": "Deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to an enemy target over {{ e3 }} seconds. Applying Call of the Void or Nether Grasp to the victim during this time refreshes the visions.<br /><br />If the victim is killed, Malzahar gains <scaleMana>{{ f1 }}</scaleMana> Mana ({{ e5 }}% of max mana) and the visions spread to the nearest enemy.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							13,
							11,
							9,
							7
						],
						"cooldownBurn": "15/13/11/9/7",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								80,
								115,
								150,
								185,
								220
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/115/150/185/220",
							"8",
							"4",
							"8",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "MalzaharE.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MalzaharR",
						"name": "Nether Grasp",
						"description": "Malzahar channels the essence of the Void to suppress an enemy champion over a zone of damaging negative energy.",
						"tooltip": "Malzahar suppresses a target champion for {{ e4 }} seconds, dealing {{ e7 }} <scaleAP>(+{{ a2 }})</scaleAP> magic damage over the duration. A zone of negative energy is created around his target for {{ e3 }} seconds, dealing {{ e1 }}% <scaleAP>(+{{ a1 }}%)</scaleAP> of nearby enemies max health as magic damage per second.",
						"leveltip": {
							"label": [
								"Nether Grasp Damage",
								"Null Zone Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e7 }} -> {{ e7NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							110,
							80
						],
						"cooldownBurn": "140/110/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								2,
								3,
								4
							],
							[
								120,
								100,
								80
							],
							[
								5,
								5,
								5
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								120,
								120,
								120
							],
							[
								10,
								10,
								10
							],
							[
								125,
								200,
								275
							],
							[
								1250,
								1250,
								1250
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2/3/4",
							"120/100/80",
							"5",
							"2.5",
							"120",
							"10",
							"125/200/275",
							"1250",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.005,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "MalzaharR.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Void Shift",
					"description": "When he hasn't recently taken damage or been crowd controlled, Malzahar gains massive damage reduction and crowd control immunity, lingering for a short period after taking damage.<br><br>Damage from lane minions is unaffected.",
					"image": {
						"full": "Malzahar_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Malzahar",
						"title": "MalzaharARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malzahar",
						"title": "MalzaharCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malzahar",
						"title": "MalzaharKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Malzahar",
						"title": "MalzaharSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Malzahar",
						"title": "MalzaharSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1414",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Malzahar",
						"title": "MalzaharTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Maokai": {
				"id": "Maokai",
				"key": "57",
				"name": "Maokai",
				"title": "the Twisted Treant",
				"image": {
					"full": "Maokai.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "57000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "57001",
						"num": 1,
						"name": "Charred Maokai",
						"chromas": false
					},
					{
						"id": "57002",
						"num": 2,
						"name": "Totemic Maokai",
						"chromas": false
					},
					{
						"id": "57003",
						"num": 3,
						"name": "Festive Maokai",
						"chromas": false
					},
					{
						"id": "57004",
						"num": 4,
						"name": "Haunted Maokai",
						"chromas": false
					},
					{
						"id": "57005",
						"num": 5,
						"name": "Goalkeeper Maokai",
						"chromas": false
					},
					{
						"id": "57006",
						"num": 6,
						"name": "Meowkai",
						"chromas": true
					},
					{
						"id": "57007",
						"num": 7,
						"name": "Victorious Maokai",
						"chromas": false
					}
				],
				"lore": "Maokai is a rageful, towering treant who fights the unnatural horrors of the Shadow Isles. He was twisted into a force of vengeance after a magical cataclysm destroyed his home, surviving undeath only through the Waters of Life infused within his heartwood. Once a peaceful nature spirit, Maokai now furiously battles to banish the scourge of unlife from the Shadow Isles and restore his home to its former beauty.",
				"blurb": "Maokai is a rageful, towering treant who fights the unnatural horrors of the Shadow Isles. He was twisted into a force of vengeance after a magical cataclysm destroyed his home, surviving undeath only through the Waters of Life infused within his...",
				"allytips": [
					"Saplings can be tossed into brush for empowered effect - but don't stack well.",
					"Try looking for flanks or other situations where Nature's Grasp is unavoidable or takes enemies by surprise.",
					"Maokai's passive makes him extremely durable against focus fire from spells - so long as he can still basic attack something."
				],
				"enemytips": [
					"Saplings will chase the first enemy that gets too close, but detonate after a few seconds or if they collide with other enemies. Be especially careful around brush sapling, as they are much more dangerous.",
					"The cooldown on Maokai's self healing is heavily gated on how many time you hit him with spells. Careful about wasting abilities on him.",
					"Maokai will avoid taking damage while he's using Twisted Advance, so don't waste your spells."
				],
				"tags": [
					"Tank",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 8,
					"magic": 6,
					"difficulty": 3
				},
				"stats": {
					"hp": 565,
					"hpperlevel": 95,
					"mp": 377.28,
					"mpperlevel": 43,
					"movespeed": 335,
					"armor": 39,
					"armorperlevel": 4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 5,
					"hpregenperlevel": 0.75,
					"mpregen": 7.2,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 63.54,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": -0.1,
					"attackspeedperlevel": 2.125
				},
				"spells": [
					{
						"id": "MaokaiQ",
						"name": "Bramble Smash",
						"description": "Maokai knocks back nearby enemies with a shockwave, dealing magic damage and slowing them.",
						"tooltip": "Maokai smashes his fist into the ground, releasing a shockwave. Nearby enemies are knocked away from him and all affected enemies take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed briefly.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7.25,
							6.5,
							5.75,
							5
						],
						"cooldownBurn": "8/7.25/6.5/5.75/5",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								65,
								105,
								145,
								185,
								225
							],
							[
								325,
								325,
								325,
								325,
								325
							],
							[
								99,
								99,
								99,
								99,
								99
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								750,
								750,
								750,
								750,
								750
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/105/145/185/225",
							"325",
							"99",
							"0.25",
							"750",
							"300",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "MaokaiQ.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MaokaiW",
						"name": "Twisted Advance",
						"description": "Maokai contorts into a mass of moving roots, becoming untargetable and dashing to the target. Upon arrival, he roots the target.",
						"tooltip": "Maokai transforms into a moving mass of roots, becoming untargetable and dashing to the target.<br /><br />Upon arrival, he deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and roots the target for {{ e2 }} second(s).",
						"leveltip": {
							"label": [
								"Damage",
								"Root Duration",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								1,
								1.1,
								1.2,
								1.3,
								1.4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1300,
								1300,
								1300,
								1300,
								1300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"1/1.1/1.2/1.3/1.4",
							"0",
							"0",
							"1300",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							525,
							525,
							525,
							525,
							525
						],
						"rangeBurn": "525",
						"image": {
							"full": "MaokaiW.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MaokaiE",
						"name": "Sapling Toss",
						"description": "Maokai flings a sapling to the target area to stand guard. More effective in brush.",
						"tooltip": "Maokai flings a sapling, which stands watch for {{ f1 }} seconds. Saplings will chase nearby enemies, detonating on proximity, dealing {{ e1 }} <span class=\"colorCC3300\">+{{ e8 }}% <span class=\"color99FF99\">[+{{ a1 }}%]</span> Target Max Health</span> magic damage and slowing enemies struck by {{ e5 }}% for {{ e6 }} seconds.<br /><br />Saplings placed in brush last for <span class=\"colorCC3300\">{{ f2 }}</span> seconds and cause a larger explosion, dealing double damage over {{ e6 }} seconds to all enemies hit.<br /><br /><rules><span class=\"color8c8c8c\">Maximum {{ e4 }} Damage to non-Champions, doubled for brush.</span></rules>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Max Health Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e8 }}% -> {{ e8NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							11,
							11,
							11,
							11
						],
						"cooldownBurn": "11",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								25,
								50,
								75,
								100,
								125
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								6,
								6.5,
								7,
								7.5,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								550,
								550,
								550,
								550,
								550
							]
						],
						"effectBurn": [
							null,
							"25/50/75/100/125",
							"0.5",
							"2",
							"300",
							"35",
							"2",
							"2",
							"6/6.5/7/7.5/8",
							"0",
							"550"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.01,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "MaokaiE.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MaokaiR",
						"name": "Nature's Grasp",
						"description": "Maokai summons a colossal wall of brambles and thorns that slowly advances forwards, damaging and rooting any enemies in the path.",
						"tooltip": "Maokai summons a colossal wall of brambles and thorns that slowly advances forwards, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and rooting any enemies struck for ({{ e2 }} to {{ e2 }}) seconds, increasing with distance travelled.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								225,
								300
							],
							[
								2.4,
								2.4,
								2.4
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/225/300",
							"2.4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3000,
							3000,
							3000
						],
						"rangeBurn": "3000",
						"image": {
							"full": "MaokaiR.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Sap Magic",
					"description": "Maokai's basic attack also heal him on a moderate cooldown. Each time Maokai casts a spell or is struck by an enemy's spell, this cooldown is reduced.",
					"image": {
						"full": "Maokai_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Maokai",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3711",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "kingporosnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Maokai",
						"title": "MaokaiTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"MasterYi": {
				"id": "MasterYi",
				"key": "11",
				"name": "Master Yi",
				"title": "the Wuju Bladesman",
				"image": {
					"full": "MasterYi.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "11000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "11001",
						"num": 1,
						"name": "Assassin Master Yi",
						"chromas": false
					},
					{
						"id": "11002",
						"num": 2,
						"name": "Chosen Master Yi",
						"chromas": false
					},
					{
						"id": "11003",
						"num": 3,
						"name": "Ionia Master Yi",
						"chromas": false
					},
					{
						"id": "11004",
						"num": 4,
						"name": "Samurai Yi",
						"chromas": false
					},
					{
						"id": "11005",
						"num": 5,
						"name": "Headhunter Master Yi",
						"chromas": true
					},
					{
						"id": "11009",
						"num": 9,
						"name": "PROJECT: Yi",
						"chromas": false
					},
					{
						"id": "11010",
						"num": 10,
						"name": "Cosmic Blade Master Yi",
						"chromas": false
					},
					{
						"id": "11011",
						"num": 11,
						"name": "Eternal Sword Yi",
						"chromas": true
					}
				],
				"lore": "Master Yi has tempered his body and sharpened his mind, so that thought and action have become almost as one. Though he chooses to enter into violence only as a last resort, the grace and speed of his blade ensures resolution is always swift. As one of the last living practitioners of the Ionian art of wuju, Yi has devoted his life to continuing the legacy of his people—scrutinizing potential new disciples with the Seven Lenses of Insight to identify the most worthy among them.",
				"blurb": "Master Yi has tempered his body and sharpened his mind, so that thought and action have become almost as one. Though he chooses to enter into violence only as a last resort, the grace and speed of his blade ensures resolution is always swift. As one of...",
				"allytips": [
					"If you're in a lane against ranged players, leveling up Meditate can allow you to stay in the lane longer and gain levels faster than they will.",
					"Wuju Style is very strong early for last hitting minions.",
					"Try using Alpha Strike on a minion in front of an enemy champion so you are placed at a safe distance at the end of the spell."
				],
				"enemytips": [
					"Meditate is an effective method of healing damage over time, but Master Yi is susceptible to coordinated team ganks early in the game.",
					"If Master Yi tries to farm with Alpha Strike, hit him a few times so he has to use mana with Meditate to heal.",
					"Although Master Yi cannot be slowed while using Highlander, other disables can stop him in his tracks."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 10,
					"defense": 4,
					"magic": 2,
					"difficulty": 4
				},
				"stats": {
					"hp": 598.56,
					"hpperlevel": 92,
					"mp": 250.56,
					"mpperlevel": 42,
					"movespeed": 355,
					"armor": 33,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7.5,
					"hpregenperlevel": 0.65,
					"mpregen": 7.256,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.08,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "AlphaStrike",
						"name": "Alpha Strike",
						"description": "Master Yi teleports across the battlefield with blinding speed, dealing physical damage to multiple units in his path, while simultaneously becoming untargetable. Alpha Strike can critically strike and deals bonus physical damage to minions and monsters. Basic attacks reduce Alpha Strike's cooldown.",
						"tooltip": "Master Yi teleports to strike up to {{ e8 }} enemies, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage, with an additional {{ e3 }} damage to minions and monsters. During Alpha Strike Master Yi is untargetable.<br /><br />Alpha Strike can critically strike, dealing an additional <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage. Basic attacks lower the cooldown of Alpha Strike by {{ e7 }} second.",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus Minion/Monster Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								25,
								60,
								95,
								130,
								165
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								75,
								100,
								125,
								150,
								175
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/60/95/130/165",
							"50",
							"75/100/125/150/175",
							"1",
							"0.25",
							"0.6",
							"1",
							"4",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 0.6,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "AlphaStrike.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Meditate",
						"name": "Meditate",
						"description": "Master Yi rejuvenates his body by focus of mind, restoring Health and taking reduced damage for a short time. In addition, Master Yi will gain stacks of Double Strike and pause the remaining duration on Wuju Style and Highlander for each second he channels.",
						"tooltip": "Master Yi channels, reducing incoming damage by {{ e2 }}% and restoring {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> health over {{ f1.-1 }} seconds. This healing is increased by up to {{ e0 }}% based on Master Yi's missing health.<br /><br />In addition, Master Yi will gain stacks of Double Strike and pause the remaining duration on Wuju Style and Highlander for each second he channels.<br /><br /><rules>Meditate's damage reduction is halved against structures.</rules>",
						"leveltip": {
							"label": [
								"Health Restored",
								"Damage Reduction"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							35,
							35,
							35,
							35,
							35
						],
						"cooldownBurn": "35",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								120,
								200,
								280,
								360,
								440
							],
							[
								50,
								55,
								60,
								65,
								70
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1,
								1,
								1,
								1,
								1
							]
						],
						"effectBurn": [
							null,
							"120/200/280/360/440",
							"50/55/60/65/70",
							"0.5",
							"4",
							"0",
							"0.5",
							"0",
							"0",
							"0",
							"1"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "Meditate.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "WujuStyle",
						"name": "Wuju Style",
						"description": "Master Yi becomes skilled in the art of Wuju, passively increasing his Attack Damage. Activating Wuju Style grants bonus true damage on basic attacks, but the passive bonus is then lost while on cooldown.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Grants {{ e1 }}% <span class=\"colorFF8C00\">({{ f1 }})</span> Attack Damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Basic attacks deal {{ e3 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> bonus true damage for {{ e5 }} seconds. Afterwards the passive bonus is lost while Wuju Style is on cooldown.",
						"leveltip": {
							"label": [
								"Active Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								18,
								26,
								34,
								42,
								50
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10",
							"35",
							"18/26/34/42/50",
							"20/30/40/50/60",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.1,
									0.125,
									0.15,
									0.175,
									0.2
								],
								"key": "f2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "WujuStyle.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "Highlander",
						"name": "Highlander",
						"description": "Master Yi moves with unparalleled agility, temporarily increasing his Movement and Attack Speeds as well as making him immune to all slowing effects. While active, Champion kills or assists extend Highlander's duration. Passively reduces cooldown for his other abilities on a kill or assist.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Champion kills and assists reduce the remaining cooldown of Master Yi's basic abilities by {{ e5 }}%.<br /><br /><span class=\"colorFF9900\">Active:</span> Increases Movement Speed by {{ e3 }}%, Attack Speed by {{ e2 }}%, and grants immunity to slows for {{ e1 }} seconds. While active, champion kills and assists extend the duration of Highlander by {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Movement Speed"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 3,
						"cooldown": [
							85,
							85,
							85
						],
						"cooldownBurn": "85",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								7,
								7,
								7
							],
							[
								30,
								55,
								80
							],
							[
								25,
								35,
								45
							],
							[
								7,
								7,
								7
							],
							[
								70,
								70,
								70
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"7",
							"30/55/80",
							"25/35/45",
							"7",
							"70",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "Highlander.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Double Strike",
					"description": "Every few strikes, Master Yi strikes twice.",
					"image": {
						"full": "MasterYi_Passive1.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "MasterYi",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1419",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1419",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MasterYi",
						"title": "MasterYiTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1036",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"MissFortune": {
				"id": "MissFortune",
				"key": "21",
				"name": "Miss Fortune",
				"title": "the Bounty Hunter",
				"image": {
					"full": "MissFortune.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "21000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "21001",
						"num": 1,
						"name": "Cowgirl Miss Fortune",
						"chromas": false
					},
					{
						"id": "21002",
						"num": 2,
						"name": "Waterloo Miss Fortune",
						"chromas": false
					},
					{
						"id": "21003",
						"num": 3,
						"name": "Secret Agent Miss Fortune",
						"chromas": false
					},
					{
						"id": "21004",
						"num": 4,
						"name": "Candy Cane Miss Fortune",
						"chromas": false
					},
					{
						"id": "21005",
						"num": 5,
						"name": "Road Warrior Miss Fortune",
						"chromas": false
					},
					{
						"id": "21006",
						"num": 6,
						"name": "Mafia Miss Fortune",
						"chromas": false
					},
					{
						"id": "21007",
						"num": 7,
						"name": "Arcade Miss Fortune",
						"chromas": true
					},
					{
						"id": "21008",
						"num": 8,
						"name": "Captain Fortune",
						"chromas": false
					},
					{
						"id": "21009",
						"num": 9,
						"name": "Pool Party Miss Fortune",
						"chromas": false
					},
					{
						"id": "21015",
						"num": 15,
						"name": "Star Guardian Miss Fortune",
						"chromas": false
					}
				],
				"lore": "A Bilgewater captain famed for her looks but feared for her ruthlessness, Sarah Fortune paints a stark figure among the hardened criminals of the port city. As a child, she witnessed the reaver king Gangplank murder her family—an act she brutally avenged years later, blowing up his flagship while he was still aboard. Those who underestimate her will face a beguiling and unpredictable opponent… and, likely, a bullet or two in their guts.",
				"blurb": "A Bilgewater captain famed for her looks but feared for her ruthlessness, Sarah Fortune paints a stark figure among the hardened criminals of the port city. As a child, she witnessed the reaver king Gangplank murder her family—an act she brutally...",
				"allytips": [
					"Miss Fortune ramps up speed if she hasn't recently taken damage. Avoid getting hit to move very fast.",
					"Use Double Up on the furthest enemy minion if enemy champions are hiding in back; it will bounce to them for lots of damage.",
					"Make sure to utilize Love Tap while Strut is on cooldown to maximize the active's availability."
				],
				"enemytips": [
					"Miss Fortune's speed boost is removed if she is damaged by an enemy.",
					"Miss Fortune is easy to kill if you can reach her; target her first in team fights."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 2,
					"magic": 5,
					"difficulty": 1
				},
				"stats": {
					"hp": 530,
					"hpperlevel": 85,
					"mp": 325.84,
					"mpperlevel": 35,
					"movespeed": 325,
					"armor": 33,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6,
					"hpregenperlevel": 0.65,
					"mpregen": 8.042,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 54,
					"attackdamageperlevel": 1,
					"attackspeedoffset": -0.0473,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "MissFortuneRicochetShot",
						"name": "Double Up",
						"description": "Miss Fortune fires a bullet at an enemy, damaging them and a target behind them. Both strikes can also apply Love Tap.",
						"tooltip": "Miss Fortune fires a bouncing shot through an enemy, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to each target hit. Both apply on-hit effects.<br /><br />The second shot can critically strike for {{ f1 }}% damage, and it always critically strikes if the first shot kills its target.",
						"leveltip": {
							"label": [
								"Mana Cost",
								"Cooldown",
								"Damage"
							],
							"effect": [
								"{{ cost }} -> {{ costNL }} ",
								"{{ cooldown }} -> {{ cooldownNL }} ",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6,
							5,
							4,
							3
						],
						"cooldownBurn": "7/6/5/4/3",
						"cost": [
							43,
							46,
							49,
							52,
							55
						],
						"costBurn": "43/46/49/52/55",
						"effect": [
							null,
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								110,
								110,
								110,
								110,
								110
							],
							[
								160,
								160,
								160,
								160,
								160
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1",
							"20/40/60/80/100",
							"1",
							"40/70/100/130/160",
							"40",
							"20",
							"40",
							"110",
							"160",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "MissFortuneRicochetShot.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MissFortuneViciousStrikes",
						"name": "Strut",
						"description": "Miss Fortune passively gains Movement Speed when not attacked. This ability can be activated to grant bonus Attack Speed for a short duration. While it's on cooldown, Love Taps reduce the remaining cooldown of Strut.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> After 5 seconds of not taking direct damage, Miss Fortune gains {{ e5 }} Movement Speed. After another 5 seconds, this bonus increases to {{ e2 }}.<br /><br /><span class=\"colorFF9900\">Active:</span> Fully activates Strut's Movement Speed and grants {{ e1 }}% Attack Speed for {{ e3 }} seconds.<br /><br />Love Taps reduce the cooldown of Strut by {{ f2 }} seconds.",
						"leveltip": {
							"label": [
								"Max Movement Speed",
								"Attack Speed"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								40,
								55,
								70,
								85,
								100
							],
							[
								60,
								70,
								80,
								90,
								100
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/55/70/85/100",
							"60/70/80/90/100",
							"4",
							"2",
							"25",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "MissFortuneViciousStrikes.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MissFortuneScattershot",
						"name": "Make It Rain",
						"description": "Miss Fortune reveals an area with a flurry of bullets, dealing waves of damage to opponents and slowing them.",
						"tooltip": "Miss Fortune reveals an area, raining down bullets that deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over 2 seconds and slow enemies hit by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Damage",
								"Slow"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }} ",
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								80,
								115,
								150,
								185,
								220
							],
							[
								28,
								36,
								44,
								52,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/115/150/185/220",
							"28/36/44/52/60",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "MissFortuneScattershot.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MissFortuneBulletTime",
						"name": "Bullet Time",
						"description": "Miss Fortune channels a flurry of bullets into a cone in front of her, dealing large amounts of damage to enemies. Each wave of Bullet Time can critically strike.",
						"tooltip": "Miss Fortune channels a barrage of bullets for {{ e3 }} seconds, dealing <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage per wave ({{ e2 }} waves total).<br /><br />Each wave of Bullet Time can critically strike for {{ f3 }}% damage.<br /><br /><span class=\"colorF50F00\">Total Damage: {{ f2 }}</span>",
						"leveltip": {
							"label": [
								"Cooldown",
								"Waves Fired"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }} ",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								0,
								0,
								0
							],
							[
								12,
								14,
								16
							],
							[
								3,
								3,
								3
							],
							[
								75,
								75,
								75
							],
							[
								120,
								120,
								120
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"12/14/16",
							"3",
							"75",
							"120",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.35,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "MissFortuneBulletTime.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Love Tap",
					"description": "Miss Fortune deals bonus physical damage whenever she attacks a new target.",
					"image": {
						"full": "MissFortune_W.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "MissFortune",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortunePRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MissFortune",
						"title": "MissFortuneTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"MonkeyKing": {
				"id": "MonkeyKing",
				"key": "62",
				"name": "Wukong",
				"title": "the Monkey King",
				"image": {
					"full": "MonkeyKing.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "62000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "62001",
						"num": 1,
						"name": "Volcanic Wukong",
						"chromas": false
					},
					{
						"id": "62002",
						"num": 2,
						"name": "General Wukong",
						"chromas": false
					},
					{
						"id": "62003",
						"num": 3,
						"name": "Jade Dragon Wukong",
						"chromas": false
					},
					{
						"id": "62004",
						"num": 4,
						"name": "Underworld Wukong",
						"chromas": false
					},
					{
						"id": "62005",
						"num": 5,
						"name": "Radiant Wukong",
						"chromas": false
					}
				],
				"lore": "Wukong is a vastayan trickster who uses his strength, agility, and intelligence to confuse his opponents and gain the upper hand. After finding a lifelong friend in the warrior known as Master Yi, Wukong became the last student of the ancient martial art known as Wuju. Armed with an enchanted staff, Wukong seeks to prevent Ionia from falling to ruin.",
				"blurb": "Wukong is a vastayan trickster who uses his strength, agility, and intelligence to confuse his opponents and gain the upper hand. After finding a lifelong friend in the warrior known as Master Yi, Wukong became the last student of the ancient martial...",
				"allytips": [
					"Decoy and Nimbus Strike work well together to quickly strike your enemy and get out before they can retaliate.",
					"Try using Decoy near brush to make an enemy overreact to your movement."
				],
				"enemytips": [
					"Wukong will often use Decoy after Nimbus Strike. Try delaying your abilities by a short amount of time to ensure that you're hitting the real Wukong.",
					"Wukong becomes tougher to kill when surrounded by his enemies. Try to isolate him to gain an advantage."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 2,
					"difficulty": 3
				},
				"stats": {
					"hp": 577.8,
					"hpperlevel": 85,
					"mp": 265.84,
					"mpperlevel": 38,
					"movespeed": 345,
					"armor": 34,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 6,
					"hpregenperlevel": 0.65,
					"mpregen": 8.042,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "MonkeyKingDoubleAttack",
						"name": "Crushing Blow",
						"description": "Wukong's next attack deals additional physical damage, gains range, and reduces the enemy's Armor for a short duration.",
						"tooltip": "Wukong's next attack gains {{ e4 }} range, deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> bonus physical damage and reduces the enemy's Armor by {{ e2 }}% for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Armor Reduction",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} ->{{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								30,
								60,
								90,
								120,
								150
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								125,
								125,
								125,
								125,
								125
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/60/90/120/150",
							"10/15/20/25/30",
							"3",
							"125",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "MonkeyKingDoubleAttack.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MonkeyKingDecoy",
						"name": "Decoy",
						"description": "Wukong becomes Invisible for a short duration, leaving behind a decoy that will deal Magic Damage to enemies near it when Wukong's stealth expires.",
						"tooltip": "Wukong becomes <span class=\"color91d7ee\">Invisible</span> for {{ e2 }} seconds, leaving behind a decoy that will deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to enemies near it after {{ e2 }} seconds. <br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Wukong can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} ->{{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "MonkeyKingDecoy.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MonkeyKingNimbus",
						"name": "Nimbus Strike",
						"description": "Wukong dashes to target enemy and sends out images to attack up to 2 additional enemies near his target, dealing physical damage to each enemy struck.",
						"tooltip": "Wukong dashes to target enemy and sends out images to attack up to 2 additional enemies nearby. Each enemy struck takes {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. Wukong then gains {{ e2 }}% Attack Speed for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Attack Speed",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} ->{{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								65,
								110,
								155,
								200,
								245
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								1050,
								1050,
								1050,
								1050,
								1050
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/110/155/200/245",
							"30/35/40/45/50",
							"4",
							"1050",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "MonkeyKingNimbus.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MonkeyKingSpinToWin",
						"name": "Cyclone",
						"description": "Wukong's staff grows outward and he spins it around, dealing damage and knocking up enemies. Wukong gains Movement Speed over the duration of the spell.",
						"tooltip": "Wukong's staff grows outward and he spins it around for 4 seconds, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage per second to nearby enemies, knocking them up for {{ e4 }} second the first time they get hit.<br /><br />At the start, Wukong gains {{ e2 }}% Movement Speed, and he gains an additional {{ e3 }}% per second over the duration.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} ->{{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								20,
								110,
								200
							],
							[
								15,
								15,
								15
							],
							[
								10,
								10,
								10
							],
							[
								1,
								1,
								1
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/110/200",
							"15",
							"10",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							315,
							315,
							315
						],
						"rangeBurn": "315",
						"image": {
							"full": "MonkeyKingSpinToWin.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Stone Skin",
					"description": "Increases Wukong's Armor and Magic Resist for each nearby enemy champion.",
					"image": {
						"full": "MonkeyKingStoneSkin.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "MonkeyKing",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "WukongARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "MonkeyKingCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "WukongFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3342",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2044",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "MonkeyKingKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "MonkeyKingSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "WukongSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "MonkeyKing",
						"title": "WukongTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Mordekaiser": {
				"id": "Mordekaiser",
				"key": "82",
				"name": "Mordekaiser",
				"title": "the Iron Revenant",
				"image": {
					"full": "Mordekaiser.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "82000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "82001",
						"num": 1,
						"name": "Dragon Knight Mordekaiser",
						"chromas": false
					},
					{
						"id": "82002",
						"num": 2,
						"name": "Infernal Mordekaiser",
						"chromas": false
					},
					{
						"id": "82003",
						"num": 3,
						"name": "Pentakill Mordekaiser",
						"chromas": false
					},
					{
						"id": "82004",
						"num": 4,
						"name": "Lord Mordekaiser",
						"chromas": false
					},
					{
						"id": "82005",
						"num": 5,
						"name": "King of Clubs Mordekaiser",
						"chromas": false
					}
				],
				"lore": "The baleful revenant Mordekaiser is among the most terrifying and hateful spirits haunting the Shadow Isles. He has existed for countless centuries, shielded from true death by necromantic sorcery and the force of his own dark will. Those who dare face Mordekaiser in battle risk a horrific curse: He enslaves his victims' souls to become instruments of destruction.",
				"blurb": "The baleful revenant Mordekaiser is among the most terrifying and hateful spirits haunting the Shadow Isles. He has existed for countless centuries, shielded from true death by necromantic sorcery and the force of his own dark will. Those who dare face...",
				"allytips": [
					"You can control a pet by holding down the alt key and using the right mouse button.",
					"Sometimes the best defense is more offense; use Mordekaiser's abilities to charge up his shield.",
					"Remember that Children of the Grave can be used defensively because of its lifesteal component."
				],
				"enemytips": [
					"Mordekaiser's abilities charge up his shield, making him tougher to kill over time. Try focusing fire on Mordekaiser to burst him down.",
					"Keep your distance and don't stand near creep waves since he'll be aiming Siphon of Destruction at them.",
					"Watch out for the Children of the Grave and Ignite combo. If you're low enough, this will kill you and give his team a powerful ghost."
				],
				"tags": [
					"Fighter"
				],
				"partype": "Shield",
				"info": {
					"attack": 4,
					"defense": 6,
					"magic": 7,
					"difficulty": 4
				},
				"stats": {
					"hp": 530,
					"hpperlevel": 78,
					"mp": 0,
					"mpperlevel": 0,
					"movespeed": 325,
					"armor": 25,
					"armorperlevel": 3.75,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 4,
					"hpregenperlevel": 0.3,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61,
					"attackdamageperlevel": 5,
					"attackspeedoffset": 0.04,
					"attackspeedperlevel": 2.2
				},
				"spells": [
					{
						"id": "MordekaiserMaceOfSpades",
						"name": "Mace of Spades",
						"description": "Mordekaiser's next three attacks deal escalating bonus damage.",
						"tooltip": "Mordekaiser's next three hits are empowered. The first two strikes deal {{ e3 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ f2 }})</span> bonus magic damage. The final strike deals {{ e9 }} times the bonus damage of the previous strikes, up to {{ f5 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> <span class=\"color99FF99\">(+{{ f4 }})</span>.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Attack Damage Ratio",
								"Cooldown",
								"Health Cost"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e0 }} -> {{ e0NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							8.5,
							7,
							5.5,
							4
						],
						"cooldownBurn": "10/8.5/7/5.5/4",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								132,
								181.5,
								231,
								280.5,
								330
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								30,
								60,
								90,
								120,
								150
							],
							[
								20,
								225,
								250,
								275,
								300
							],
							[
								0.5,
								0.6,
								0.7,
								0.8,
								0.9
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								20,
								23,
								26,
								29,
								32
							]
						],
						"effectBurn": [
							null,
							"132/181.5/231/280.5/330",
							"10/15/20/25/30",
							"10/20/30/40/50",
							"4",
							"30/60/90/120/150",
							"20/225/250/275/300",
							"0.5/0.6/0.7/0.8/0.9",
							"0.6",
							"2",
							"20/23/26/29/32"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.65,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "f2"
							}
						],
						"costType": " Health",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "MordekaiserMaceOfSpades.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e0 }} Health"
					},
					{
						"id": "MordekaiserCreepingDeathCast",
						"name": "Harvesters of Sorrow",
						"description": "Coats an ally in magnetic metal, increasing each unit's movement speed toward one another. While near one another, the metal swirls violently dealing damage per second to enemies.",
						"tooltip": "<span class=\"size18 colorFF9900\">Passive:</span> Mordekaiser gains bonus experience for killing minions near allied champions.<br /><br />Bonus Experience Earned: <span class=\"colorFFFFFF\">{{ f3 }}</span><br /><br /><span class=\"size18 colorFF9900\">Active:</span> Target an ally, linking them to Mordekaiser:<span class=\"size4\"><br /><br /></span><li>Both gain up to {{ e5 }} movement speed toward one another.<span class=\"size8\"><br /><br /></span>When they touch, they deal {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over 4 seconds to nearby enemies.<span class=\"size8\"><br /><br /></span>Reactivate to both instantly steal {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> health from nearby enemies ({{ e7 }}% heal on minions, max {{ e8 }} units; deals magic damage).",
						"leveltip": {
							"label": [
								"Damage",
								"Reactivation Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								140,
								180,
								220,
								260,
								300
							],
							[
								25,
								35,
								45,
								55,
								65
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								50,
								85,
								120,
								155,
								190
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"140/180/220/260/300",
							"25/35/45/55/65",
							"1",
							"75",
							"50/85/120/155/190",
							"25",
							"2",
							"50",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Health",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "MordekaiserCreepingDeathCast.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e3 }} Health"
					},
					{
						"id": "MordekaiserSyphonOfDestruction",
						"name": "Siphon of Destruction",
						"description": "Mordekaiser deals damage to enemies in a cone in front of him. For each unit hit, Mordekaiser's shield absorbs energy.",
						"tooltip": "Mordekaiser deals {{ e3 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span><span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage in a cone.<span class=\"size8\"><br /><br /></span>For each Champion hit, he gains {{ e5 }}% maximum shield.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"% Max Shield From Champions",
								"Health Cost"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.75,
							5.5,
							5.25,
							5
						],
						"cooldownBurn": "6/5.75/5.5/5.25/5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								24,
								36,
								48,
								60,
								72
							],
							[
								1,
								2,
								3,
								4,
								5
							],
							[
								35,
								65,
								95,
								125,
								155
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"24/36/48/60/72",
							"1/2/3/4/5",
							"35/65/95/125/155",
							"4",
							"15/17.5/20/22.5/25",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Health",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "MordekaiserSyphonOfDestruction.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e1 }} Health"
					},
					{
						"id": "MordekaiserChildrenOfTheGrave",
						"name": "Children of the Grave",
						"description": "Mordekaiser curses an enemy champion or the Dragon, stealing a percent of their life initially and each second. If the target dies while the spell is active, their soul is enslaved and will follow Mordekaiser as a ghost.",
						"tooltip": "<span class=\"size18 colorFF9900\">Passive - Dragon Force:</span> Damaging the Dragon will <span class=\"size18 color53c653\">Curse</span> it for 10 seconds.<br /><br /><span class=\"size18 colorFF9900\">Active:</span> <span class=\"size18 color53c653\">Curse</span> target Champion and steal {{ e1 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of their maximum health (25% initially, 75% over 10 seconds; deals magic damage).<br /><br /><span class=\"size18 color53c653\">Curse Effect:</span> When killed by Mordekaiser's team, the Cursed unit's soul will follow Mordekaiser for {{ e9 }} seconds. Mordekaiser gains {{ e7 }}% of their ability power and {{ e8 }}% of their bonus health. The ghost gains <span class=\"colorFF8C00\">(+{{ f1 }})</span> attack damage and <span class=\"colorCC3300\">(+{{ f2 }})</span> health.<br /><br /><span class=\"color53c653\">The ghost can be controlled by holding the alt key and using the right mouse button or by reactivating this ability.</span>",
						"leveltip": {
							"label": [
								"Total Health Stolen",
								"Cooldown",
								"Ghost Lifetime"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e9 }} -> {{ e9NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								25,
								30,
								35
							],
							[
								55,
								65,
								75
							],
							[
								75,
								150,
								225
							],
							[
								2,
								2,
								2
							],
							[
								3,
								3,
								3
							],
							[
								10,
								25,
								50
							],
							[
								30,
								30,
								30
							],
							[
								25,
								25,
								25
							],
							[
								45,
								60,
								75
							],
							[
								2000,
								2000,
								2000
							]
						],
						"effectBurn": [
							null,
							"25/30/35",
							"55/65/75",
							"75/150/225",
							"2",
							"3",
							"10/25/50",
							"30",
							"25",
							"45/60/75",
							"2000"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.04,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "MordekaiserChildrenOfTheGrave.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Iron Man",
					"description": "A percent of the damage dealt from abilities is converted into a temporary shield, absorbing incoming damage.",
					"image": {
						"full": "MordekaiserPassive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Mordekaiser",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Mordekaiser",
						"title": "MordekaiserTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Morgana": {
				"id": "Morgana",
				"key": "25",
				"name": "Morgana",
				"title": "Fallen Angel",
				"image": {
					"full": "Morgana.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "25000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "25001",
						"num": 1,
						"name": "Exiled Morgana",
						"chromas": false
					},
					{
						"id": "25002",
						"num": 2,
						"name": "Sinful Succulence Morgana",
						"chromas": false
					},
					{
						"id": "25003",
						"num": 3,
						"name": "Blade Mistress Morgana",
						"chromas": false
					},
					{
						"id": "25004",
						"num": 4,
						"name": "Blackthorn Morgana",
						"chromas": false
					},
					{
						"id": "25005",
						"num": 5,
						"name": "Ghost Bride Morgana",
						"chromas": false
					},
					{
						"id": "25006",
						"num": 6,
						"name": "Victorious Morgana",
						"chromas": false
					},
					{
						"id": "25010",
						"num": 10,
						"name": "Lunar Wraith Morgana",
						"chromas": false
					},
					{
						"id": "25011",
						"num": 11,
						"name": "Bewitching Morgana",
						"chromas": false
					}
				],
				"lore": "Driven by vindictive obsession, Morgana is a potent mistress of suffering and the black arts. Once a being of grace and light, she was ripped from her kind during an ancient conflict that broke her soul, turning her into the cruel tormentor she is today. Comforted by a prophecy that claims she will strike the final blow and gain her revenge, Morgana lies in wait, her lust for power growing endlessly.",
				"blurb": "Driven by vindictive obsession, Morgana is a potent mistress of suffering and the black arts. Once a being of grace and light, she was ripped from her kind during an ancient conflict that broke her soul, turning her into the cruel tormentor she is today...",
				"allytips": [
					"Shrewd use of Black Shield can determine the outcome of team fights.",
					"Items that provide survivability allow Morgana to become extremely difficult to kill in conjunction with Black Shield and Soul Shackles.",
					"Tormented Soil is an excellent farming tool if you're by yourself in a lane."
				],
				"enemytips": [
					"Tormented Soil deals tons of damage to units missing large amounts of Health. When low on Health, be wary of Morgana's attempts to trap you within its reach.",
					"Morgana often needs to land Dark Binding to setup her other attacks. Use your minions as shields against Dark Binding."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 6,
					"magic": 8,
					"difficulty": 1
				},
				"stats": {
					"hp": 559.48,
					"hpperlevel": 90,
					"mp": 340.8,
					"mpperlevel": 60,
					"movespeed": 335,
					"armor": 25.384,
					"armorperlevel": 3.8,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 450,
					"hpregen": 5.5,
					"hpregenperlevel": 0.6,
					"mpregen": 11.5,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55.46,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.53
				},
				"spells": [
					{
						"id": "DarkBindingMissile",
						"name": "Dark Binding",
						"description": "Morgana releases a sphere of dark magic. Upon contact with an enemy unit, the sphere will deal magic damage and force the unit to the ground for a period of time.",
						"tooltip": "Fires a bolt of dark energy, rooting the first enemy hit for {{ e2 }} seconds and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Root Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							11,
							11,
							11,
							11
						],
						"cooldownBurn": "11",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								80,
								135,
								190,
								245,
								300
							],
							[
								2,
								2.25,
								2.5,
								2.75,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/135/190/245/300",
							"2/2.25/2.5/2.75/3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1175,
							1175,
							1175,
							1175,
							1175
						],
						"rangeBurn": "1175",
						"image": {
							"full": "DarkBindingMissile.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TormentedSoil",
						"name": "Tormented Soil",
						"description": "Infects an area with desecrated soil, causing enemy units who stand on the location to take continual damage.",
						"tooltip": "Curses an area for {{ e7 }} seconds. Enemies on the cursed ground are dealt<br />from {{ e5 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage every second based on the enemy's missing Health.<br /><br />Every time <span class=\"colorE9DDAB\">Soul Siphon</span> heals Morgana, Tormented Soil's cooldown is reduced by {{ e4 }}%.",
						"leveltip": {
							"label": [
								"Damage ",
								"Mana Cost"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }} ",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							70,
							85,
							100,
							115,
							130
						],
						"costBurn": "70/85/100/115/130",
						"effect": [
							null,
							[
								8,
								16,
								24,
								32,
								40
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								280,
								280,
								280,
								280,
								280
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								16,
								32,
								48,
								64,
								80
							],
							[
								24,
								48,
								72,
								96,
								120
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"8/16/24/32/40",
							"0.5",
							"280",
							"5",
							"16/32/48/64/80",
							"24/48/72/96/120",
							"5",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.22,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.33,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "TormentedSoil.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BlackShield",
						"name": "Black Shield",
						"description": "Places a protective barrier around an allied champion, absorbing magical damage and disables until penetrated or the shield dissipates.",
						"tooltip": "Shields an allied Champion for {{ e2 }} seconds. The shield absorbs {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and prevents disables until it breaks.",
						"leveltip": {
							"label": [
								"Shield Health",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							23,
							21,
							19,
							17,
							15
						],
						"cooldownBurn": "23/21/19/17/15",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								70,
								140,
								210,
								280,
								350
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/140/210/280/350",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "BlackShield.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SoulShackles",
						"name": "Soul Shackles",
						"description": "Latches chains of energy onto nearby enemy champions, dealing initial damage to them and slowing their Movement Speed, and then echoing the pain a few seconds later and stunning them if they remain close to Morgana.",
						"tooltip": "Dark chains latch onto nearby enemy Champions dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing them by {{ e4 }}% for {{ e3 }} seconds, granting <span class=\"coloree91d7\">True Sight</span>. After {{ e3 }} seconds, they are dealt an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are stunned for {{ e2 }} seconds.<br /><br />Enemy Champions can break the chains by moving away from Morgana.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								225,
								300
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								3,
								3,
								3
							],
							[
								20,
								20,
								20
							],
							[
								575,
								575,
								575
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/225/300",
							"1.5",
							"3",
							"20",
							"575",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "SoulShackles.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Soul Siphon",
					"description": "Morgana heals for the spell damage she deals to champions, large minions, and large monsters.",
					"image": {
						"full": "FallenAngel_Empathize.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Morgana",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Morgana",
						"title": "MorganaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Nami": {
				"id": "Nami",
				"key": "267",
				"name": "Nami",
				"title": "the Tidecaller",
				"image": {
					"full": "Nami.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "267000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "267001",
						"num": 1,
						"name": "Koi Nami",
						"chromas": true
					},
					{
						"id": "267002",
						"num": 2,
						"name": "River Spirit Nami",
						"chromas": false
					},
					{
						"id": "267003",
						"num": 3,
						"name": "Urf the Nami-tee",
						"chromas": false
					},
					{
						"id": "267007",
						"num": 7,
						"name": "Deep Sea Nami",
						"chromas": false
					},
					{
						"id": "267008",
						"num": 8,
						"name": "SKT T1 Nami",
						"chromas": false
					}
				],
				"lore": "A headstrong young vastaya of the seas, Nami was the first of the Marai tribe to leave the waves and venture onto dry land, when their ancient accord with the Targonians was broken. With no other option, she took it upon herself to complete the sacred ritual that would ensure the safety of her people. Amidst the chaos of this new age, Nami faces an uncertain future with grit and determination, using her Tidecaller staff to summon the strength of the oceans themselves.",
				"blurb": "A headstrong young vastaya of the seas, Nami was the first of the Marai tribe to leave the waves and venture onto dry land, when their ancient accord with the Targonians was broken. With no other option, she took it upon herself to complete the sacred...",
				"allytips": [
					"Aqua Prison has a long cooldown, make sure to use it at the right moment.",
					"Using Ebb and Flow during an engagement with enemy champions will help sway the battle in your favor.",
					"Nami's ultimate can come in very handy for initiating on enemies who are far away."
				],
				"enemytips": [
					"Aqua Prison is a very powerful ability with a long cooldown, take advantage of the situation if Nami misses this ability.",
					"Tidal Wave has a very long range but travels slowly, be aware of when it is coming your way as you can move out of its path.",
					"Try to avoid fighting an opponent affected by Tidecaller's Blessing, it lasts a short duration so waiting it out can help you greatly."
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 3,
					"magic": 7,
					"difficulty": 5
				},
				"stats": {
					"hp": 489.32,
					"hpperlevel": 74,
					"mp": 377.24,
					"mpperlevel": 43,
					"movespeed": 335,
					"armor": 29,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 11.5,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 51.208,
					"attackdamageperlevel": 3.1,
					"attackspeedoffset": -0.03,
					"attackspeedperlevel": 2.61
				},
				"spells": [
					{
						"id": "NamiQ",
						"name": "Aqua Prison",
						"description": "Sends a bubble to a target area, dealing damage and stunning all enemies on impact.",
						"tooltip": "Sends a bubble to target area, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies, and stunning them for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								75,
								130,
								185,
								240,
								295
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/130/185/240/295",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							875,
							875,
							875,
							875,
							875
						],
						"rangeBurn": "875",
						"image": {
							"full": "NamiQ.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NamiW",
						"name": "Ebb and Flow",
						"description": "Unleashes a stream of water that bounces back and forth between allied and enemy champions, healing allies and damaging enemies.",
						"tooltip": "Unleashes a stream of water that bounces back and forth between allied and enemy champions.<br /><br /><span class=\"colorCCFF99\">On Ally Hit: </span>Heals {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Health and will bounce to a nearby enemy champion.<br /><br /><span class=\"colorFF9999\">On Enemy Hit: </span>Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and bounces to a nearby allied champion.<br /><br />Bounces to each target only once, and hits up to {{ e2 }} targets. The damage and healing value is modified by <span class=\"color99FF99\">({{ f1 }}%)</span> each bounce. ",
						"leveltip": {
							"label": [
								"Heal",
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							70,
							85,
							100,
							115,
							130
						],
						"costBurn": "70/85/100/115/130",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								65,
								95,
								125,
								155,
								185
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								0.075,
								0.075,
								0.075,
								0.075,
								0.075
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"3",
							"65/95/125/155/185",
							"15",
							"0.08",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "NamiW.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NamiE",
						"name": "Tidecaller's Blessing",
						"description": "Empowers an allied champion for a short duration. The ally's basic attacks deal bonus magic damage and slow the target.",
						"tooltip": "Empowers an allied champion's next {{ e4 }} basic attacks, causing them to slow the target by {{ e2 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> for {{ e3 }} second and deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage. Lasts for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							11,
							11,
							11,
							11
						],
						"cooldownBurn": "11",
						"cost": [
							55,
							60,
							65,
							70,
							75
						],
						"costBurn": "55/60/65/70/75",
						"effect": [
							null,
							[
								25,
								40,
								55,
								70,
								85
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/40/55/70/85",
							"15/20/25/30/35",
							"1",
							"3",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.05,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "NamiE.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NamiR",
						"name": "Tidal Wave",
						"description": "Summons a massive Tidal Wave that knocks up, slows, and damages enemies. Allies hit gain double the effect of Surging Tides.",
						"tooltip": "Summons a Tidal Wave from Nami's position. The wave knocks up enemies and slows them by {{ e4 }}%, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The duration of the slow increases based on how far the Tidal Wave has traveled, with a minimum duration of {{ e3 }} seconds and a maximum of {{ e5 }} seconds.<br /><br />Allies hit by the wave gain double the effect of Surging Tides.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Slow"
							],
							"effect": [
								" ",
								" {{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e4 }}% -> {{ e4NL }}%"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								2,
								2,
								2
							],
							[
								50,
								60,
								70
							],
							[
								4,
								4,
								4
							],
							[
								0.002,
								0.002,
								0.002
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"0.5",
							"2",
							"50/60/70",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							2550,
							2550,
							2550
						],
						"rangeBurn": "2550",
						"image": {
							"full": "NamiR.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Surging Tides",
					"description": "When Nami's abilities hit allied champions they gain Movement Speed for a short duration.",
					"image": {
						"full": "NamiPassive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Nami",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "NamiARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "NamiCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "namiFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "NamiKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "NamiSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "namiSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nami",
						"title": "namiTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Nasus": {
				"id": "Nasus",
				"key": "75",
				"name": "Nasus",
				"title": "the Curator of the Sands",
				"image": {
					"full": "Nasus.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "75000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "75001",
						"num": 1,
						"name": "Galactic Nasus",
						"chromas": false
					},
					{
						"id": "75002",
						"num": 2,
						"name": "Pharaoh Nasus",
						"chromas": false
					},
					{
						"id": "75003",
						"num": 3,
						"name": "Dreadknight Nasus",
						"chromas": true
					},
					{
						"id": "75004",
						"num": 4,
						"name": "Riot K-9 Nasus",
						"chromas": false
					},
					{
						"id": "75005",
						"num": 5,
						"name": "Infernal Nasus",
						"chromas": false
					},
					{
						"id": "75006",
						"num": 6,
						"name": "Archduke Nasus",
						"chromas": false
					},
					{
						"id": "75010",
						"num": 10,
						"name": "Worldbreaker Nasus",
						"chromas": false
					},
					{
						"id": "75011",
						"num": 11,
						"name": "Lunar Guardian Nasus",
						"chromas": true
					}
				],
				"lore": "Nasus is an imposing, jackal-headed Ascended being from ancient Shurima, a heroic figure regarded as a demigod by the people of the desert. Fiercely intelligent, he was a guardian of knowledge and peerless strategist whose wisdom guided the ancient empire of Shurima to greatness for many centuries. After the fall of the empire, he went into self-imposed exile, becoming little more than a legend. Now that the ancient city of Shurima has risen once more, he has returned, determined to ensure it never falls again.",
				"blurb": "Nasus is an imposing, jackal-headed Ascended being from ancient Shurima, a heroic figure regarded as a demigod by the people of the desert. Fiercely intelligent, he was a guardian of knowledge and peerless strategist whose wisdom guided the ancient...",
				"allytips": [
					"Paying attention to last hitting with Siphoning Strike will have a large impact at the end of a game.",
					"If you're solo, Spirit Fire is a great way to farm a lane. It can be bad if you're in a lane with 2 and you push too far. Find the right balance between Siphoning Strike last hits and AoE farming.",
					"If you have low defenses, people will focus you down even during your ultimate. Try buying some survivability items even in your DPS builds."
				],
				"enemytips": [
					"While transformed by his ultimate, Nasus is stronger than most champions in the League. Engage him only if you have a clear advantage.",
					"Max rank Wither is a very effective counter to Attack Damage characters, so try to avoid getting caught alone by it.",
					"Nasus is prone to being kited. Try not to engage him at full Health."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 5,
					"magic": 6,
					"difficulty": 6
				},
				"stats": {
					"hp": 561.2,
					"hpperlevel": 90,
					"mp": 325.6,
					"mpperlevel": 42,
					"movespeed": 350,
					"armor": 34,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9,
					"hpregenperlevel": 0.9,
					"mpregen": 7.44,
					"mpregenperlevel": 0.5,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 67,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 3.48
				},
				"spells": [
					{
						"id": "NasusQ",
						"name": "Siphoning Strike",
						"description": "Nasus strikes his foe, dealing damage and increasing the power of his future Siphoning Strikes if he slays his target.",
						"tooltip": "Nasus's next basic attack will deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color5555FF\">(+{{ f1 }})</span> physical damage.<br /><br />Siphoning Strike permanently gains <span class=\"color5555FF\">{{ e2 }}</span> damage if it kills an enemy. This bonus is doubled against Champions, large minions and large monsters.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7,
							6,
							5,
							4
						],
						"cooldownBurn": "8/7/6/5/4",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/50/70/90/110",
							"3",
							"25",
							"6",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "@stacks",
								"coeff": 3,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "NasusQ.png",
							"sprite": "spell7.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NasusW",
						"name": "Wither",
						"description": "Nasus ages an enemy champion, decelerating their Movement and Attack Speeds over time.",
						"tooltip": "Nasus ages target champion over {{ e3 }} seconds, slowing their Movement Speed by {{ e2 }}%, increasing to {{ e1 }}% over the duration. The target's Attack Speed is reduced by half the amount.",
						"leveltip": {
							"label": [
								"Max Slow",
								"Cooldown"
							],
							"effect": [
								" {{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							14,
							13,
							12,
							11
						],
						"cooldownBurn": "15/14/13/12/11",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								47,
								59,
								71,
								83,
								95
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								17.5,
								17.5,
								17.5,
								17.5,
								17.5
							],
							[
								1.5,
								3,
								4.5,
								6,
								7.5
							],
							[
								3,
								6,
								9,
								12,
								15
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"47/59/71/83/95",
							"35",
							"5",
							"17.5",
							"1.5/3/4.5/6/7.5",
							"3/6/9/12/15",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "NasusW.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NasusE",
						"name": "Spirit Fire",
						"description": "Nasus unleashes a spirit flame at a location, dealing damage and reducing the Armor of enemies who stand on it.",
						"tooltip": "Nasus unleashes a spirit flame at target location, dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.<br /><br />For the next {{ e3 }} seconds, enemies in the area have their Armor reduced by {{ e2 }}% and are dealt an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage each second.",
						"leveltip": {
							"label": [
								"Initial Damage",
								"Damage Per Second",
								"Armor Reduction",
								"Mana Cost"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							70,
							85,
							100,
							115,
							130
						],
						"costBurn": "70/85/100/115/130",
						"effect": [
							null,
							[
								11,
								19,
								27,
								35,
								43
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								55,
								95,
								135,
								175,
								215
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"11/19/27/35/43",
							"15/20/25/30/35",
							"5",
							"55/95/135/175/215",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.12,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "NasusE.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NasusR",
						"name": "Fury of the Sands",
						"description": "Nasus unleashes a mighty sandstorm that batters nearby enemies. While the storm rages, he gains increased Health, Attack Range, damages nearby enemies, has a reduced cooldown on Siphoning Strike, and gains bonus Armor and Magic Resistance for the duration.",
						"tooltip": "Nasus becomes empowered in the sandstorm for 15 seconds, increasing his maximum Health by {{ e1 }} and Armor and Magic Resistance by {{ e4 }}.<br /><br />While the storm rages, he deals {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of nearby enemies' maximum Health each second as magic damage ({{ e5 }} damage max per second), gains an additional {{ e8 }} Armor and Magic Resistance each second, and Siphoning Strike has a {{ e9 }}% reduced cooldown.",
						"leveltip": {
							"label": [
								"Bonus Health",
								"Max Health %",
								"Initial Armor and Magic Resistance",
								"Incremental Armor and Magic Resistance"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e8 }} -> {{ e8NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							120,
							120
						],
						"cooldownBurn": "120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								300,
								450,
								600
							],
							[
								50,
								50,
								50
							],
							[
								3,
								4,
								5
							],
							[
								15,
								35,
								55
							],
							[
								240,
								240,
								240
							],
							[
								15,
								15,
								15
							],
							[
								0,
								0,
								0
							],
							[
								1,
								2,
								3
							],
							[
								50,
								50,
								50
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"300/450/600",
							"50",
							"3/4/5",
							"15/35/55",
							"240",
							"15",
							"0",
							"1/2/3",
							"50",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.01,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "NasusR.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Soul Eater",
					"description": "Nasus drains his foe's spiritual energy, giving him bonus Life Steal.",
					"image": {
						"full": "Nasus_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Nasus",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nasus",
						"title": "NasusTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Nautilus": {
				"id": "Nautilus",
				"key": "111",
				"name": "Nautilus",
				"title": "the Titan of the Depths",
				"image": {
					"full": "Nautilus.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "111000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "111001",
						"num": 1,
						"name": "Abyssal Nautilus",
						"chromas": false
					},
					{
						"id": "111002",
						"num": 2,
						"name": "Subterranean Nautilus",
						"chromas": false
					},
					{
						"id": "111003",
						"num": 3,
						"name": "AstroNautilus",
						"chromas": false
					},
					{
						"id": "111004",
						"num": 4,
						"name": "Warden Nautilus",
						"chromas": false
					},
					{
						"id": "111005",
						"num": 5,
						"name": "Worldbreaker Nautilus",
						"chromas": false
					}
				],
				"lore": "All know the tales; all pay the Bilgewater tithe. Since time immemorial, Nautilus has roamed the dark waters off the coast of the Blue Flame Isles, dragging impious sailors to their doom. The armored goliath strikes without warning, his inexorable footfalls churning the waters, before swinging his enormous anchor upward to shatter mast and keel alike. He then pulls the flotsam beneath the waves to appease the wrath of the Bearded Lady.",
				"blurb": "All know the tales; all pay the Bilgewater tithe. Since time immemorial, Nautilus has roamed the dark waters off the coast of the Blue Flame Isles, dragging impious sailors to their doom. The armored goliath strikes without warning, his inexorable...",
				"allytips": [
					"While ganking, consider aiming Dredge Line at nearby terrain and following it up with Riptide for a higher hit rate.",
					"Riptide has a delayed blast timing on activation - you can use this while running away or when enemies are incoming to serve as a deterrent."
				],
				"enemytips": [
					"If Nautilus uses Riptide right next to you, hold in place until the ripple effect finishes before running. Running early will run straight into the secondary explosions, causing you to take additional damage and slow.",
					"While Nautilus is shielded, he is capable of dealing large amounts of area of effect damage with his basic attacks - consider taking down the shield if you have time."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 6,
					"magic": 6,
					"difficulty": 6
				},
				"stats": {
					"hp": 576.48,
					"hpperlevel": 86,
					"mp": 334,
					"mpperlevel": 47,
					"movespeed": 325,
					"armor": 35.46,
					"armorperlevel": 3.75,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8.5,
					"hpregenperlevel": 0.55,
					"mpregen": 8.626,
					"mpregenperlevel": 0.5,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 57.54,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0.02,
					"attackspeedperlevel": 1
				},
				"spells": [
					{
						"id": "NautilusAnchorDrag",
						"name": "Dredge Line",
						"description": "Nautilus hurls his anchor forward. If it hits a champion, he drags both himself and the opponent close together. If it hits terrain, Nautilus instead pulls himself to the anchor, the cooldown of Dredge Line is reduced by half, and half the Mana cost is refunded.",
						"tooltip": "Nautilus hurls his anchor forward. If it hits an enemy unit, Nautilus drags himself and the target together dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage and stunning them briefly.<br /><br />If the anchor hits terrain, Nautilus will drag himself forward, the cooldown is reduced by {{ e3 }}% (<totalValue>{{ f1 }}</totalValue>), and {{ e4 }}% of the Mana cost is refunded.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"0",
							"50",
							"50",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							},
							{
								"link": "@special.nautilusq",
								"coeff": 0.5,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "NautilusAnchorDrag.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NautilusPiercingGaze",
						"name": "Titan's Wrath",
						"description": "Nautilus surrounds himself with dark energies, gaining a shield that blocks incoming damage. While the shield persists, his attacks apply a damage over time effect to enemies around his target.",
						"tooltip": "Nautilus surrounds himself with dark energies for {{ e3 }} seconds, shielding him from the next {{ e1 }} <scaleHealth>(+{{ f1 }})</scaleHealth> ({{ e2 }}% of his max Health) damage.<br /><br />While the shield persists, Nautilus' basic attacks deal {{ e4 }} <scaleAP>(+{{ a1 }})</scaleAP> bonus magic damage over 2 seconds to all enemies around his target.",
						"leveltip": {
							"label": [
								"Shield Amount",
								"Bonus Magic Damage",
								"Percent Max Health"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							18,
							18,
							18,
							18
						],
						"cooldownBurn": "18",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								65,
								70,
								75,
								80,
								85
							],
							[
								9,
								11,
								13,
								15,
								17
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/70/75/80/85",
							"9/11/13/15/17",
							"10",
							"30/40/50/60/70",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonushealth",
								"coeff": 0.1,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "NautilusPiercingGaze.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NautilusSplashZone",
						"name": "Riptide",
						"description": "Nautilus slams the ground, causing the earth to explode around him in a set of three explosions. Each explosion damages and slows enemies.",
						"tooltip": "Nautilus slams the ground, causing the earth to explode around him. Each explosion deals {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to enemies in the area and slows them by {{ e2 }}% for {{ e4 }} seconds. This slow diminishes over time.<br /><br />A unit can be hit by more than one explosion, but they take {{ e3 }}% less damage from additional explosions.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								55,
								85,
								115,
								145,
								175
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/85/115/145/175",
							"30/35/40/45/50",
							"50",
							"1.25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "NautilusSplashZone.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NautilusGrandLine",
						"name": "Depth Charge",
						"description": "Nautilus fires a shockwave into the earth that chases an opponent. This shockwave rips up the earth above it, knocking enemies into the air. When it reaches the opponent, the shockwave erupts, knocking his target into the air and stunning them.",
						"tooltip": "Nautilus fires a shockwave that chases an enemy champion, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to other enemies it passes through, knocking them into the air, and stunning them for {{ e5 }} seconds.<br /><br />The shockwave explodes upon hitting its target dealing {{ e2 }} <scaleAP>(+{{ a2 }})</scaleAP> magic damage, launching them into the air and stunning them for {{ e5 }} seconds. ",
						"leveltip": {
							"label": [
								"Pass Through Damage",
								"Explosion Damage",
								"Stun Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								125,
								175,
								225
							],
							[
								200,
								325,
								450
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								1,
								1.5,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"125/175/225",
							"200/325/450",
							"0",
							"0",
							"1/1.5/2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							825,
							825,
							825
						],
						"rangeBurn": "825",
						"image": {
							"full": "NautilusGrandLine.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Staggering Blow",
					"description": "Nautilus' basic attacks deal bonus physical damage and immobilize his targets. This effect cannot happen more than once every few seconds on the same target.",
					"image": {
						"full": "Nautilus_StaggeringBlow.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Nautilus",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusSupport",
						"map": "any",
						"mode": "any",
						"type": "riot-support",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nautilus",
						"title": "NautilusTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Nidalee": {
				"id": "Nidalee",
				"key": "76",
				"name": "Nidalee",
				"title": "the Bestial Huntress",
				"image": {
					"full": "Nidalee.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "76000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "76001",
						"num": 1,
						"name": "Snow Bunny Nidalee",
						"chromas": false
					},
					{
						"id": "76002",
						"num": 2,
						"name": "Leopard Nidalee",
						"chromas": false
					},
					{
						"id": "76003",
						"num": 3,
						"name": "French Maid Nidalee",
						"chromas": false
					},
					{
						"id": "76004",
						"num": 4,
						"name": "Pharaoh Nidalee",
						"chromas": false
					},
					{
						"id": "76005",
						"num": 5,
						"name": "Bewitching Nidalee",
						"chromas": false
					},
					{
						"id": "76006",
						"num": 6,
						"name": "Headhunter Nidalee",
						"chromas": false
					},
					{
						"id": "76007",
						"num": 7,
						"name": "Warring Kingdoms Nidalee",
						"chromas": false
					},
					{
						"id": "76008",
						"num": 8,
						"name": "Challenger Nidalee",
						"chromas": false
					},
					{
						"id": "76009",
						"num": 9,
						"name": "Super Galaxy Nidalee",
						"chromas": false
					}
				],
				"lore": "Raised in the deepest jungle, Nidalee is a master tracker who can shapeshift into a ferocious cougar at will. Neither wholly woman nor beast, she viciously defends her territory from any and all trespassers, with carefully placed traps and deft spear throws. She cripples her quarry before pouncing on them in feline form—the lucky few who survive tell tales of a wild woman with razor-sharp instincts, and even sharper claws...",
				"blurb": "Raised in the deepest jungle, Nidalee is a master tracker who can shapeshift into a ferocious cougar at will. Neither wholly woman nor beast, she viciously defends her territory from any and all trespassers, with carefully placed traps and deft spear...",
				"allytips": [
					"Use brush to your advantage! Moving in and out of brush can heavily alter your effectiveness in battle.",
					"Start team fights by harassing with your Javelin Toss, and then switch to cougar form to chase down Hunted targets.",
					"Bushwhack traps deal damage based on their victim's current Health. Set them up in your team's backline before fights break out during sieges to help your team deal damage to the enemy frontline."
				],
				"enemytips": [
					"Nidalee's Hunt debuff is only applied with Javelin Toss and Bushwhack. Avoiding being hit by these abilities will impair her ability to deal follow-up damage.",
					"Nidalee's Javelin Toss deals more damage the farther she is. If she is far away, it's imperative to dodge it.",
					"Nidalee's Takedown deals extreme damage to Hunted targets, but she has to get close to use it. Save your crowd control or defensive abilities for when she goes in for the kill."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 4,
					"magic": 7,
					"difficulty": 8
				},
				"stats": {
					"hp": 545,
					"hpperlevel": 85,
					"mp": 295.6,
					"mpperlevel": 45,
					"movespeed": 335,
					"armor": 28,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 6,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 3.22
				},
				"spells": [
					{
						"id": "JavelinToss",
						"name": "Javelin Toss / Takedown",
						"description": "In human form, Nidalee throws a spiked javelin at her target that gains damage as it flies.  As a cougar, her next attack will attempt to fatally wound her target, dealing more damage the less life they have.",
						"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee throws her javelin, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage. If it exceeds her basic attack range, it gains damage based on distance flown, up to a potential {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> total damage.<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee's next attack deals additional damage, greatly increased on low health targets.",
						"leveltip": {
							"label": [
								"Javelin Minimum Damage",
								"Javelin Maximum Damage",
								"Javelin Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								70,
								85,
								100,
								115,
								130
							],
							[
								210,
								255,
								300,
								345,
								390
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								1.2,
								1.2,
								1.2,
								1.2,
								1.2
							],
							[
								525,
								525,
								525,
								525,
								525
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/85/100/115/130",
							"210/255/300/345/390",
							"0",
							"0",
							"0.4",
							"1.2",
							"525",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 1.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1500,
							1500,
							1500,
							1500,
							1500
						],
						"rangeBurn": "1500",
						"image": {
							"full": "JavelinToss.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Bushwhack",
						"name": "Bushwhack / Pounce",
						"description": "In human form, Nidalee lays a trap for unwary opponents that, when sprung, damages and reveals its target. As a cougar, she jumps in a direction, dealing damage in an area where she lands.",
						"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee places an invisible trap that lasts for 2 minutes. The trap triggers when an enemy walks over it, revealing the victim and bleeding them for {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage over 4 seconds.<br /><br /><span class=\"colorFFFFFF\">{{ f4 }}</span> traps may be active at once. (Maximum traps increases at level 6, 11 and 16)<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee lunges in target direction, dealing damage to nearby enemies.",
						"leveltip": {
							"label": [
								"Trap Damage",
								"Trap Cooldown",
								"Trap Mana Cost"
							],
							"effect": [
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								13,
								12,
								11,
								10,
								9
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								120,
								120,
								120,
								120,
								120
							],
							[
								40,
								80,
								120,
								160,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"0",
							"4",
							"13/12/11/10/9",
							"10/20/30/40/50",
							"120",
							"40/80/120/160/200",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "0",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "Bushwhack.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PrimalSurge",
						"name": "Primal Surge / Swipe",
						"description": "In human form, Nidalee channels the spirit of the cougar to heal her allies and imbue them with Attack Speed for a short duration. As a cougar, she claws in a direction, dealing damage to enemies in front of her.",
						"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee heals target ally champion for {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> to {{ e2 }} <span class=\"color99FF99\">(+{{ f3 }})</span> based on their missing health and grants them {{ e4 }}% Attack Speed for 7 seconds.<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee claws at enemies in target direction.",
						"leveltip": {
							"label": [
								"Primal Surge Heal",
								"Primal Surge Attack Speed",
								"Primal Surge Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							60,
							75,
							90,
							105,
							120
						],
						"costBurn": "60/75/90/105/120",
						"effect": [
							null,
							[
								35,
								55,
								75,
								95,
								115
							],
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.05,
								0.05,
								0.05,
								0.05,
								0.05
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/55/75/95/115",
							"70/110/150/190/230",
							"0",
							"20/30/40/50/60",
							"0",
							"0.05",
							"2",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.325,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "PrimalSurge.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AspectOfTheCougar",
						"name": "Aspect Of The Cougar",
						"description": "Nidalee transforms into a cougar, gaining new abilities.",
						"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee transforms into a vicious cougar with the basic abilities Takedown, Pounce, and Swipe.<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee transforms back into human form. While in human form, triggering a <span class=\"colorFFF673\">Hunt</span> resets the cooldown of Aspect of the Cougar.",
						"leveltip": {
							"label": [
								"Takedown Damage",
								"Takedown Damage Amp",
								"Pounce Damage",
								"Swipe Damage",
								"Enhanced Pounce Cooldown"
							],
							"effect": [
								"{{ f1 }} -> {{ f6 }}",
								"{{ f4 }}% -> {{ f5 }}%",
								"{{ f7 }} -> {{ f8 }}",
								"{{ f9 }} -> {{ f10 }}",
								"{{ f2 }} -> {{ f3 }}"
							]
						},
						"maxrank": 4,
						"cooldown": [
							3,
							3,
							3,
							3
						],
						"cooldownBurn": "3",
						"cost": [
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0
							],
							[
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0
							],
							[
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"0",
							"0",
							"0",
							"0",
							"6",
							"0",
							"10",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "AspectOfTheCougar.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Prowl",
					"description": "Moving through brush increases Nidalee's Movement Speed by 10% for 2 seconds, increased to 30% toward visible enemy champions within 1400 range.<br><br>Hitting champions or monsters with Javelin Toss or Bushwhack triggers a <font color='#FFF673'>Hunt</font>, granting <font color='#ee91d7'>True Sight</font> of them for 4 seconds. During this time, Nidalee gains 10% Movement Speed (increased to 30% toward the <font color='#FFF673'>Hunted</font> target) and her Takedown and Pounce are enhanced against them.",
					"image": {
						"full": "Nidalee_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Nidalee",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1410",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nidalee",
						"title": "NidaleeTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Nocturne": {
				"id": "Nocturne",
				"key": "56",
				"name": "Nocturne",
				"title": "the Eternal Nightmare",
				"image": {
					"full": "Nocturne.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "56000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "56001",
						"num": 1,
						"name": "Frozen Terror Nocturne",
						"chromas": false
					},
					{
						"id": "56002",
						"num": 2,
						"name": "Void Nocturne",
						"chromas": false
					},
					{
						"id": "56003",
						"num": 3,
						"name": "Ravager Nocturne",
						"chromas": false
					},
					{
						"id": "56004",
						"num": 4,
						"name": "Haunting Nocturne",
						"chromas": false
					},
					{
						"id": "56005",
						"num": 5,
						"name": "Eternum Nocturne",
						"chromas": false
					},
					{
						"id": "56006",
						"num": 6,
						"name": "Cursed Revenant Nocturne",
						"chromas": false
					}
				],
				"lore": "A demonic amalgamation drawn from the nightmares that haunt every sentient mind, the thing known as Nocturne has become a primordial force of pure evil. It is liquidly chaotic in aspect, a faceless shadow with cold eyes and armed with wicked-looking blades. After freeing itself from the spirit realm, Nocturne descended upon the waking world, to feed upon the kind of terror that can only thrive in true darkness.",
				"blurb": "A demonic amalgamation drawn from the nightmares that haunt every sentient mind, the thing known as Nocturne has become a primordial force of pure evil. It is liquidly chaotic in aspect, a faceless shadow with cold eyes and armed with wicked-looking...",
				"allytips": [
					"Using Paranoia at a critical moment is well worth it even if you cannot use the dash.",
					"Duskbringer isn't only an offensive ability. It can be used to close distance out of combat or escape from certain death.",
					"Use Shroud of Darkness in tandem with Paranoia's dash. Your opponents may panic and waste a critical disable on your spell shield."
				],
				"enemytips": [
					"Stay close to your allies when Paranoia is cast - there is strength in numbers!",
					"Nocturne's Unspeakable Horror is broken with range, so try to save your movement abilities for when he casts it."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 5,
					"magic": 2,
					"difficulty": 4
				},
				"stats": {
					"hp": 582.8,
					"hpperlevel": 85,
					"mp": 273.8,
					"mpperlevel": 35,
					"movespeed": 345,
					"armor": 36,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.75,
					"mpregen": 6.756,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 67.21,
					"attackdamageperlevel": 3.1,
					"attackspeedoffset": -0.065,
					"attackspeedperlevel": 2.7
				},
				"spells": [
					{
						"id": "NocturneDuskbringer",
						"name": "Duskbringer",
						"description": "Nocturne throws a shadow blade that deals damage, leaves a Dusk Trail, and causes champions to leave a Dusk Trail. While on the trail, Nocturne can move through units and has increased Movement Speed and Attack Damage.",
						"tooltip": "Nocturne throws a shadow blade that deals {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and leaves a Dusk Trail for {{ e3 }} seconds. Enemy champions hit also leave a Dusk Trail.<br /><br />While on the trail, Nocturne can move through units and gains {{ e1 }}% Movement Speed and {{ e4 }} Attack Damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed Bonus",
								"Bonus Attack Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								" {{ e1 }}% -> {{ e1NL }}%",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								65,
								110,
								155,
								200,
								245
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								15,
								25,
								35,
								45,
								55
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/20/25/30/35",
							"65/110/155/200/245",
							"5",
							"15/25/35/45/55",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.75,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1125,
							1125,
							1125,
							1125,
							1125
						],
						"rangeBurn": "1125",
						"image": {
							"full": "NocturneDuskbringer.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NocturneShroudofDarkness",
						"name": "Shroud of Darkness",
						"description": "Nocturne empowers his blades, passively gaining Attack Speed. Activating Shroud of Darkness allows Nocturne to fade into the shadows, creating a magical barrier which blocks a single enemy ability and doubles his passive Attack Speed if successful.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Nocturne gains {{ e1 }}% Attack Speed.<br /><br /><span class=\"colorFF9900\">Active:</span> Nocturne creates a magical barrier for 1.5 seconds, which blocks the next enemy ability.<br /><br />If an ability is blocked by the shield, Nocturne's passive Attack Speed bonus doubles for 5 seconds.",
						"leveltip": {
							"label": [
								"Attack Speed Bonus",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							18,
							16,
							14,
							12
						],
						"cooldownBurn": "20/18/16/14/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0.2,
								0.05,
								0.05,
								0.05,
								0.05
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/25/30/35/40",
							"0.2/0.05/0.05/0.05/0.05",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "NocturneShroudofDarkness.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NocturneUnspeakableHorror",
						"name": "Unspeakable Horror",
						"description": "Nocturne plants a nightmare into his target's mind, dealing damage each second and terrifying the target if they do not get out of range by the end of the duration.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Nocturne gains massively increased Movement Speed toward terrified enemies.<br /><br /><span class=\"colorFF9900\">Active:</span> Nocturne plants a nightmare into his target's mind, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e3 }} seconds. If Nocturne stays within range of the target for the full duration, the target becomes terrified for {{ e2 }} second(s).",
						"leveltip": {
							"label": [
								"Damage",
								"Terrify Duration",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							14,
							13,
							12,
							11
						],
						"cooldownBurn": "15/14/13/12/11",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								1.25,
								1.5,
								1.75,
								2,
								2.25
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								465,
								465,
								465,
								465,
								465
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"1.25/1.5/1.75/2/2.25",
							"2",
							"465",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							425,
							425,
							425,
							425,
							425
						],
						"rangeBurn": "425",
						"image": {
							"full": "NocturneUnspeakableHorror.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "NocturneParanoia",
						"name": "Paranoia",
						"description": "Nocturne reduces the sight radius of all enemy champions and removes their ally vision in the process. He can then launch himself at a nearby enemy champion.",
						"tooltip": "Nocturne reduces the sight radius of all enemy champions and removes their ally vision for 4 seconds.<br /><br />While Paranoia is active, Nocturne can launch himself at an enemy champion, dealing {{ e3 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							150,
							125,
							100
						],
						"cooldownBurn": "150/125/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								250,
								250,
								250
							],
							[
								2500,
								3250,
								4000
							],
							[
								150,
								250,
								350
							],
							[
								3500,
								4250,
								5000
							],
							[
								1800,
								1800,
								1800
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250",
							"2500/3250/4000",
							"150/250/350",
							"3500/4250/5000",
							"1800",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							2500,
							3250,
							4000
						],
						"rangeBurn": "2500/3250/4000",
						"image": {
							"full": "NocturneParanoia.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Umbra Blades",
					"description": "Every 10 seconds, Nocturne's next attack strikes surrounding enemies for 120% physical damage and heals himself. <br><br>Nocturne's basic attacks reduce this cooldown by 1 second.",
					"image": {
						"full": "Nocturne_UmbraBlades.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Nocturne",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumablesjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nocturne",
						"title": "NocturneTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Nunu": {
				"id": "Nunu",
				"key": "20",
				"name": "Nunu",
				"title": "the Yeti Rider",
				"image": {
					"full": "Nunu.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "20000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "20001",
						"num": 1,
						"name": "Sasquatch Nunu",
						"chromas": false
					},
					{
						"id": "20002",
						"num": 2,
						"name": "Workshop Nunu",
						"chromas": false
					},
					{
						"id": "20003",
						"num": 3,
						"name": "Grungy Nunu",
						"chromas": false
					},
					{
						"id": "20004",
						"num": 4,
						"name": "Nunu Bot",
						"chromas": false
					},
					{
						"id": "20005",
						"num": 5,
						"name": "Demolisher Nunu",
						"chromas": false
					},
					{
						"id": "20006",
						"num": 6,
						"name": "TPA Nunu",
						"chromas": false
					},
					{
						"id": "20007",
						"num": 7,
						"name": "Zombie Nunu",
						"chromas": false
					}
				],
				"lore": "Frolicking through the hills of the Freljord, Nunu and Willump make an unlikely pair, but many travellers would swear they have seen the yeti with a fearless boy clinging to his back. Though Nunu may have tamed the beast's heart, Willump's anger remains, fueled by a ravenous hunger. Some have even tried to separate the two, yet the bond of friendship between them is stronger than any chain, and they continue to ramble on their wild adventures.",
				"blurb": "Frolicking through the hills of the Freljord, Nunu and Willump make an unlikely pair, but many travellers would swear they have seen the yeti with a fearless boy clinging to his back. Though Nunu may have tamed the beast's heart, Willump's anger remains...",
				"allytips": [
					"Consume allows Nunu to stay in a lane against ranged opponents.",
					"You can choose to interrupt Absolute Zero early for partial damage if an opponent is about to run out of range.",
					"It's often beneficial to delay the casting of Absolute Zero until the initial round of disables are used. Try to hang back before rushing into a team fight."
				],
				"enemytips": [
					"Nunu's Blood Boil allows its target to run away from fights. Make sure to snare and stun any target with Blood Boil on.",
					"Interrupting the charge up on Absolute Zero will lower the amount of damage your team takes.",
					"Using Summoner Flash is a surefire way to escape Absolute Zero.",
					"With only 1 single target ability that can break a spell shield, Banshee's Veil is extremely effective against Nunu."
				],
				"tags": [
					"Support",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 6,
					"magic": 7,
					"difficulty": 4
				},
				"stats": {
					"hp": 590,
					"hpperlevel": 90,
					"mp": 283.56,
					"mpperlevel": 42,
					"movespeed": 345,
					"armor": 28,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 5,
					"hpregenperlevel": 0.8,
					"mpregen": 7.44,
					"mpregenperlevel": 0.5,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 67,
					"attackdamageperlevel": 4,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.25
				},
				"spells": [
					{
						"id": "Consume",
						"name": "Consume",
						"description": "Nunu commands the yeti to take a bite out of a target minion or monster, dealing heavy damage to it and healing himself.",
						"tooltip": "Nunu commands the yeti to take a bite out of a minion or monster, dealing {{ e1 }} true damage and healing himself for {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span>.<br /><br /><span class=\"colorFF9900\">Passive -</span><span class=\"color33FF33\"> Feed The Yeti</span>: For every Large or Epic Monster the yeti bites, Nunu gains {{ e4 }} <scaleAP>(+{{ a2 }})</scaleAP> magic damage on hit, {{ e0 }}% Maximum Health, increased size, and {{ e9 }} out of combat Movement Speed for the next <span class=\"colorFFFFFF\">{{ f5 }}</span> seconds (max {{ e6 }} stacks).<br /><br /><span class=\"colorDDDD77\">Recently Consumed monsters will not grant additional bonuses ({{ e5 }} second cooldown).</span>",
						"leveltip": {
							"label": [
								"Damage (bite)",
								"Damage (on hit)",
								"Health Restore",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								340,
								500,
								660,
								820,
								980
							],
							[
								50,
								100,
								150,
								200,
								250
							],
							[
								120,
								150,
								180,
								210,
								240
							],
							[
								1,
								2,
								3,
								4,
								5
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0.02,
								0.02,
								0.02,
								0.02,
								0.02
							]
						],
						"effectBurn": [
							null,
							"340/500/660/820/980",
							"50/100/150/200/250",
							"120/150/180/210/240",
							"1/2/3/4/5",
							"60",
							"5",
							"5",
							"50",
							"10",
							"0.02"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.05,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							125,
							125,
							125,
							125,
							125
						],
						"rangeBurn": "125",
						"image": {
							"full": "Consume.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "BloodBoil",
						"name": "Blood Boil",
						"description": "Nunu invigorates himself and an allied unit by heating their blood, increasing their Attack Speed, Movement Speed, and Ability Power.",
						"tooltip": "The heat of Nunu and a target ally's blood rises, increasing Ability Power by {{ e4 }}% (max: {{ e5 }}), Movement Speed by {{ e2 }}%, and Attack Speed by {{ e1 }}% for {{ e3 }} seconds.<br /><br />If Nunu targets himself, Blood Boil will try to target the nearest Ally champion.",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Ability Power (max)",
								"Movement Speed"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								8,
								9,
								10,
								11,
								12
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/30/35/40/45",
							"8/9/10/11/12",
							"12",
							"40",
							"40/60/80/100/120",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "BloodBoil.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "IceBlast",
						"name": "Ice Blast",
						"description": "Nunu launches a ball of ice at an enemy unit, dealing damage and temporarily slowing their Movement and Attack Speeds.",
						"tooltip": "Nunu launches a ball of ice at an enemy unit, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing their Movement Speed by {{ e2 }}% and Attack Speed by {{ e3 }}% for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed Slow",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.5,
							5,
							4.5,
							4
						],
						"cooldownBurn": "6/5.5/5/4.5/4",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"40/45/50/55/60",
							"25",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "IceBlast.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "AbsoluteZero",
						"name": "Absolute Zero",
						"description": "Nunu begins to sap the area of heat, slowing all nearby enemies. When Absolute Zero ends, he deals massive damage to all enemies caught in the area.",
						"tooltip": "Nunu channels for {{ e4 }} seconds, sapping the area of heat. Nearby enemies have their Movement Speed slowed by {{ e2 }}% and their Attack Speed slowed by {{ e3 }}%. The Movement Speed slow increases to {{ e6 }}% over the duration of the channel.<br /><br />Enemies caught in the area when the channel ends take up to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, depending on how long Absolute Zero was channeled.<br />(Minimum Damage: <span class=\"color99FF99\">{{ f2 }}</span>)",
						"leveltip": {
							"label": [
								"Maximum Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							100,
							90
						],
						"cooldownBurn": "110/100/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								625,
								875,
								1125
							],
							[
								50,
								50,
								50
							],
							[
								25,
								25,
								25
							],
							[
								3,
								3,
								3
							],
							[
								3,
								3,
								3
							],
							[
								95,
								95,
								95
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"625/875/1125",
							"50",
							"25",
							"3",
							"3",
							"95",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 2.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "AbsoluteZero.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Visionary",
					"description": "After 5 attacks, Nunu's next spell costs no Mana and is empowered to do its next rank's effects.",
					"image": {
						"full": "Nunu_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Nunu",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3068",
										"count": 1
									},
									{
										"id": "3065",
										"count": 1
									},
									{
										"id": "3110",
										"count": 1
									},
									{
										"id": "3001",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3711",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Nunu",
						"title": "NunuTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Olaf": {
				"id": "Olaf",
				"key": "2",
				"name": "Olaf",
				"title": "the Berserker",
				"image": {
					"full": "Olaf.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "2000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "2001",
						"num": 1,
						"name": "Forsaken Olaf",
						"chromas": false
					},
					{
						"id": "2002",
						"num": 2,
						"name": "Glacial Olaf",
						"chromas": false
					},
					{
						"id": "2003",
						"num": 3,
						"name": "Brolaf",
						"chromas": true
					},
					{
						"id": "2004",
						"num": 4,
						"name": "Pentakill Olaf",
						"chromas": false
					},
					{
						"id": "2005",
						"num": 5,
						"name": "Marauder Olaf",
						"chromas": false
					},
					{
						"id": "2006",
						"num": 6,
						"name": "Butcher Olaf",
						"chromas": false
					},
					{
						"id": "2015",
						"num": 15,
						"name": "SKT T1 Olaf",
						"chromas": false
					}
				],
				"lore": "An unstoppable force of destruction, the axe-wielding Olaf wants nothing but to die in glorious combat. Hailing from the brutal Freljordian peninsula of Lokfar, he once received a prophecy foretelling his peaceful passing—a coward's fate, and a great insult among his people. Seeking death, and fueled by rage, he rampaged across the land, slaughtering scores of great warriors and legendary beasts in search of any opponent who could stop him. Now a brutal enforcer for the Winter's Claw, he seeks his end in the great wars to come.",
				"blurb": "An unstoppable force of destruction, the axe-wielding Olaf wants nothing but to die in glorious combat. Hailing from the brutal Freljordian peninsula of Lokfar, he once received a prophecy foretelling his peaceful passing—a coward's fate, and a great...",
				"allytips": [
					"Olaf can combine Berserker Rage, Vicious Strikes, and Ragnarok at low life to become deceptively strong.",
					"The bonus healing granted by Vicious Strikes amplifies your Life Steal from all sources as well as heals from allies."
				],
				"enemytips": [
					"Olaf becomes more dangerous the lower life he is. Save your disables to finish him off.",
					"Preventing Olaf from reaching his axe will minimize the amount of harassment he can cause in the laning phase.",
					"Olaf has reduced defenses from damage during Ragnarok, despite being immune to disables. If you can't escape from Olaf during Ragnarok, try focusing your damage on him with your teammates."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 5,
					"magic": 3,
					"difficulty": 3
				},
				"stats": {
					"hp": 597.24,
					"hpperlevel": 93,
					"mp": 315.6,
					"mpperlevel": 42,
					"movespeed": 350,
					"armor": 35,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.9,
					"mpregen": 7.466,
					"mpregenperlevel": 0.575,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": -0.1,
					"attackspeedperlevel": 2.7
				},
				"spells": [
					{
						"id": "OlafAxeThrowCast",
						"name": "Undertow",
						"description": "Olaf throws an axe into the ground at a target location, dealing damage to enemies it passes through and slowing their Movement Speed. If Olaf picks up the axe, the ability's cooldown is reduced by 4.5 seconds.",
						"tooltip": "Olaf throws an axe to target location, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to units it passes through and slowing them by {{ e2 }}% for up to {{ e3 }} seconds. The further the Axe flies, the longer the slow lasts, but it is never less than {{ e4 }} seconds.<br /><br />If Olaf picks up the axe, the ability's cooldown is reduced by 4.5 seconds.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Slow %"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							7,
							7,
							7,
							7
						],
						"cooldownBurn": "7",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								29,
								33,
								37,
								41,
								45
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"29/33/37/41/45",
							"2.5",
							"1.5",
							"800",
							"400",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "OlafAxeThrowCast.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OlafFrenziedStrikes",
						"name": "Vicious Strikes",
						"description": "Olaf's Attack Speed is increased, he gains Life Steal and has increased healing from all sources based on how much Health he is missing.",
						"tooltip": "For 6 seconds, Olaf gains {{ e2 }}% Life Steal and his Attack Speed is increased by {{ e1 }}%.<br /><br />During this time, Olaf also receives 1% increased healing from all sources for every {{ e3 }}% of Health he is missing.",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Life Steal"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							16,
							16,
							16,
							16
						],
						"cooldownBurn": "16",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								14,
								16,
								18,
								20,
								22
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/50/60/70/80",
							"14/16/18/20/22",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "OlafFrenziedStrikes.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OlafRecklessStrike",
						"name": "Reckless Swing",
						"description": "Olaf attacks with such force that it deals true damage to his target and himself, refunding the Health cost if he destroys the target.",
						"tooltip": "Olaf ferociously swings his axes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> true damage to his target. This ability's cost is equal to {{ e2 }}% of the total damage dealt, but the cost is refunded if it kills the target.<br /><br />Basic attacks lower the cooldown of Reckless Swing by 1 second.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"30",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": "Health",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "OlafRecklessStrike.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "Health"
					},
					{
						"id": "OlafRagnarok",
						"name": "Ragnarok",
						"description": "Olaf temporarily becomes immune to disables.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Olaf gains {{ e1 }} Armor and {{ e1 }} Magic Resist.<br /><br /><span class=\"colorFF9900\">Active: </span>Olaf removes all disables from himself and becomes immune to them for the next {{ e2 }} seconds. Olaf also receives a {{ e5 }}% Movement Speed bonus towards enemy champions for {{ e4 }} second. During this time, Olaf loses the passive portion of Ragnarok and gains {{ e3 }} Attack Damage.",
						"leveltip": {
							"label": [
								"Armor and Magic Resist",
								"Attack Damage",
								"Movement Speed Bonus",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								30,
								40
							],
							[
								6,
								6,
								6
							],
							[
								40,
								60,
								80
							],
							[
								1,
								1,
								1
							],
							[
								50,
								60,
								70
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40",
							"6",
							"40/60/80",
							"1",
							"50/60/70",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "OlafRagnarok.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Berserker Rage",
					"description": "Olaf's Attack Speed is increased by 1% for each 1% of his Health he is missing.",
					"image": {
						"full": "Olaf_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Olaf",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3082",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Olaf",
						"title": "OlafTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Orianna": {
				"id": "Orianna",
				"key": "61",
				"name": "Orianna",
				"title": "the Lady of Clockwork",
				"image": {
					"full": "Orianna.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "61000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "61001",
						"num": 1,
						"name": "Gothic Orianna",
						"chromas": false
					},
					{
						"id": "61002",
						"num": 2,
						"name": "Sewn Chaos Orianna",
						"chromas": false
					},
					{
						"id": "61003",
						"num": 3,
						"name": "Bladecraft Orianna",
						"chromas": false
					},
					{
						"id": "61004",
						"num": 4,
						"name": "TPA Orianna",
						"chromas": false
					},
					{
						"id": "61005",
						"num": 5,
						"name": "Winter Wonder Orianna",
						"chromas": false
					},
					{
						"id": "61006",
						"num": 6,
						"name": "Heartseeker Orianna",
						"chromas": false
					},
					{
						"id": "61007",
						"num": 7,
						"name": "Dark Star Orianna",
						"chromas": false
					}
				],
				"lore": "Once a curious girl of flesh and blood, Orianna is now a technological marvel comprised entirely of clockwork. She became gravely ill after an accident in the lower districts of Zaun, and her failing body had to be replaced with exquisite artifice, piece by piece. Accompanied by an extraordinary brass sphere she built for companionship and protection, Orianna is now free to explore the wonders of Piltover, and beyond.",
				"blurb": "Once a curious girl of flesh and blood, Orianna is now a technological marvel comprised entirely of clockwork. She became gravely ill after an accident in the lower districts of Zaun, and her failing body had to be replaced with exquisite artifice...",
				"allytips": [
					"Command: Protect can be used on yourself to return the Ball back to you quickly. Combine this with Command: Attack for a quick harassment.",
					"Command: Dissonance is a very powerful escape tool if Orianna has the Ball. The combination of speed and leaving a slowing obstacle can be quite powerful.",
					"Command: Shockwave can be used to drag enemies towards you or away from you if you position the Ball properly."
				],
				"enemytips": [
					"Orianna can only affect the area the Ball is around. Use this to your advantage.",
					"Watch out for Orianna's Ball returning to her due to leashing. This may cause some unexpected situations."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 3,
					"magic": 9,
					"difficulty": 7
				},
				"stats": {
					"hp": 530,
					"hpperlevel": 91,
					"mp": 334,
					"mpperlevel": 50,
					"movespeed": 325,
					"armor": 17.04,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 40.368,
					"attackdamageperlevel": 2.6,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "OrianaIzunaCommand",
						"name": "Command: Attack",
						"description": "Orianna commands her Ball to fire toward a target location, dealing magic damage to targets along the way (deals less damage to subsequent targets). Her Ball remains at the target location after.",
						"tooltip": "Orianna commands her Ball to shoot toward a target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to targets along the way. However, it deals {{ e2 }}% less damage for each unit it hits (Minimum {{ e3 }}%).<br /><br />Her Ball remains behind at the target location afterwards.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.25,
							4.5,
							3.75,
							3
						],
						"cooldownBurn": "6/5.25/4.5/3.75/3",
						"cost": [
							30,
							35,
							40,
							45,
							50
						],
						"costBurn": "30/35/40/45/50",
						"effect": [
							null,
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/90/120/150/180",
							"10",
							"40",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							815,
							815,
							815,
							815,
							815
						],
						"rangeBurn": "815",
						"image": {
							"full": "OrianaIzunaCommand.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OrianaDissonanceCommand",
						"name": "Command: Dissonance",
						"description": "Orianna commands the Ball to release a pulse of energy, dealing magic damage around it. This leaves a field behind that speeds up allies and slows enemies.",
						"tooltip": "Orianna commands her Ball to release an electric pulse, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies.<br /><br />The pulse leaves behind an energy field for {{ e4 }} seconds, lowering enemy Movement Speed by {{ e2 }}% and increasing ally Movement Speed by {{ e3 }}% for {{ e5 }} seconds. This effect diminishes over time.",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed Bonus",
								"Slow Amount",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/105/150/195/240",
							"20/25/30/35/40",
							"20/25/30/35/40",
							"3",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							255,
							255,
							255,
							255,
							255
						],
						"rangeBurn": "255",
						"image": {
							"full": "OrianaDissonanceCommand.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OrianaRedactCommand",
						"name": "Command: Protect",
						"description": "Orianna commands her Ball to attach to an allied champion, shielding them and dealing magic damage to any enemies it passes through on the way. Additionally, the Ball grants additional Armor and Magic Resist to the champion it is attached to.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>The Ball adds {{ e2 }} Armor and Magic Resist to the allied champion it is attached to.<br /><br /><span class=\"colorFF9900\">Active: </span>Orianna commands her Ball to travel to and attach onto an allied champion, shielding them for {{ e5 }} seconds from the next {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage. Enemies the Ball passes through along the way are damaged for {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Armor Bonus",
								"Magic Resist Bonus",
								"Damage Absorption"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"10/15/20/25/30",
							"60/90/120/150/180",
							"75",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1095,
							1095,
							1095,
							1095,
							1095
						],
						"rangeBurn": "1095",
						"image": {
							"full": "OrianaRedactCommand.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OrianaDetonateCommand",
						"name": "Command: Shockwave",
						"description": "Orianna commands her Ball to unleash a shockwave, dealing magic damage and launching nearby enemies towards the Ball after a short delay.",
						"tooltip": "Orianna commands her Ball to unleash a shockwave after a brief delay, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and flinging them into the air a set distance in the direction of the Ball.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							95,
							80
						],
						"cooldownBurn": "110/95/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								225,
								300
							],
							[
								40,
								50,
								60
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/225/300",
							"40/50/60",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							410,
							410,
							410
						],
						"rangeBurn": "410",
						"image": {
							"full": "OrianaDetonateCommand.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Clockwork Windup",
					"description": "Orianna's autoattack deals additional magic damage. This damage increases the more Orianna attacks the same target.",
					"image": {
						"full": "OriannaPassive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Orianna",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Orianna",
						"title": "OriannaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Ornn": {
				"id": "Ornn",
				"key": "516",
				"name": "Ornn",
				"title": "The Fire below the Mountain",
				"image": {
					"full": "Ornn.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "516000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "516001",
						"num": 1,
						"name": "Thunder Lord Ornn",
						"chromas": false
					}
				],
				"lore": "Ornn is the Freljordian spirit of forging and craftsmanship. He works in the solitude of a massive smithy, hammered out from the lava caverns beneath the volcano Hearth-Home. There he stokes bubbling cauldrons of molten rock to purify ores and fashion items of unsurpassed quality. When other deities—especially Volibear—walk the earth and meddle in mortal affairs, Ornn arises to put these impetuous beings back in their place, either with his trusty hammer or the fiery power of the mountains themselves.",
				"blurb": "Ornn is the Freljordian spirit of forging and craftsmanship. He works in the solitude of a massive smithy, hammered out from the lava caverns beneath the volcano Hearth-Home. There he stokes bubbling cauldrons of molten rock to purify ores and fashion...",
				"allytips": [
					"Learning build paths of items can help quickly select upgrades in lane.",
					"Volcanic Rupture can be used to set up zoning areas to threaten enemies.",
					"The order of your abilties matters! Try to optimize Brittle usage."
				],
				"enemytips": [
					"Try to stay away from walls. Ornn is much less strong if he cannot stun you.",
					"Attack Ornn to keep him from creating items in lane."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 9,
					"magic": 3,
					"difficulty": 5
				},
				"stats": {
					"hp": 565.64,
					"hpperlevel": 90,
					"mp": 340.6,
					"mpperlevel": 45,
					"movespeed": 335,
					"armor": 33.04,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 9,
					"hpregenperlevel": 0.8,
					"mpregen": 8.01,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 67.72,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": -0.08,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "OrnnQ",
						"name": "Volcanic Rupture",
						"description": "Ornn slams the ground, sending out a fissure dealing damage and slowing enemies hit. After a small delay, a magma pillar forms at the end location.",
						"tooltip": "Ornn slams the ground, creating a fissure which deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and slows by {{ e5 }}% for {{ e6 }} seconds. A magma pillar then forms at the fissure's end for {{ e3 }} seconds.<br /><br /><span class=\"size16 color8C8C8C\">The fissure stops shortly after hitting an enemy champion.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8.5,
							8,
							7.5,
							7
						],
						"cooldownBurn": "9/8.5/8/7.5/7",
						"cost": [
							55,
							55,
							55,
							55,
							55
						],
						"costBurn": "55",
						"effect": [
							null,
							[
								20,
								50,
								80,
								110,
								140
							],
							[
								1.125,
								1.125,
								1.125,
								1.125,
								1.125
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/50/80/110/140",
							"1.13",
							"4",
							"0",
							"40/45/50/55/60",
							"2",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.6,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "OrnnQ.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OrnnW",
						"name": "Bellows Breath",
						"description": "Ornn advances, breathing fire and shielding himself. Enemies hit by the final gout of flame become Brittle.",
						"tooltip": "Ornn stomps forwards, breathing fire and shielding himself for <span class=\"colorCC3300\">{{ f5 }}</span> (12% max health) for {{ e5 }} seconds. The fire deals up to {{ e0 }}% of the enemy's max health as magic damage (minimum {{ e3 }}).<br /><br />Enemies hit by the final gout of flame become <span class=\"colorFF5733\">Brittle</span> for {{ f9 }} seconds. The next immobilizing effect against a Brittle enemy has its duration increased by 30% and deals <span class=\"colorFFFFFF\">{{ f8 }}</span>% of their max health as magic damage.<br /><br /><span class=\"size16 color8C8C8C\">Ornn's basic attacks knock back Brittle targets.</span>",
						"leveltip": {
							"label": [
								"Max Damage",
								"Min Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e0 }}% -> {{ e0NL }}%",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							15,
							13,
							11,
							9
						],
						"cooldownBurn": "17/15/13/11/9",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								0.024,
								0.026,
								0.028,
								0.03,
								0.032
							],
							[
								3.5,
								3.5,
								3.5,
								3.5,
								3.5
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								550,
								550,
								550,
								550,
								550
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								12,
								13,
								14,
								15,
								16
							]
						],
						"effectBurn": [
							null,
							"0.75",
							"0",
							"80/130/180/230/280",
							"0.024/0.026/0.028/0.03/0.032",
							"3.5",
							"225",
							"550",
							"0.5",
							"1.5",
							"12/13/14/15/16"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "OrnnW.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OrnnE",
						"name": "Searing Charge",
						"description": "Ornn charges, dealing damage to enemies he passes through. If Ornn collides with terrain while charging, the impact creates a shockwave around him which deals damage and knocks up enemies.",
						"tooltip": "Ornn charges, dealing {{ e1 }} <span class=\"colorFFFF00\">(+{{ f2 }})</span><span class=\"colorFF00FF\">(+{{ f3 }})</span> physical damage to enemies hit.<br /><br />If Ornn rams into terrain, he creates a shockwave that knocks up enemies for {{ e6 }} second and applies Searing Charge's damage to those not hit by the charge.<br /><br /><span class=\"size16 color8C8C8C\">The shockwave destroys magma pillars and terrain created by enemy champions.</span>",
						"leveltip": {
							"label": [
								"Dash Damage",
								"Shockwave Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								1600,
								1600,
								1600,
								1600,
								1600
							],
							[
								650,
								650,
								650,
								650,
								650
							],
							[
								360,
								360,
								360,
								360,
								360
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"80/125/170/215/260",
							"1600",
							"650",
							"360",
							"1",
							"150",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "OrnnE.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "OrnnR",
						"name": "Call of the Forge God",
						"description": "Ornn summons a massive elemental at a location which travels toward him with increasing speed. Enemies run over by the elemental take damage, are slowed and are made Brittle. Ornn can recast the ability to charge into the elemental, redirecting it in the direction he hits it, causing the elemental to affect any enemies it runs over to be knocked up, dealing the same damage and re-applying Brittle.",
						"tooltip": "Ornn summons a massive lava elemental which stampedes toward him. Enemies run over by the elemental take {{ e2 }} <span class=\"color99FF99\">(+{{ f4 }})</span> magic damage, are slowed by {{ e5 }}% for {{ e6 }} seconds and become <span class=\"colorFF5733\">Brittle</span> for {{ f10 }} seconds.<br /><br />Ornn can recast this ability to smash into the elemental to redirect and empower it. The empowered elemental knocks up enemies for 1.5 seconds, deals {{ e2 }} <span class=\"color99FF99\">(+{{ f4 }})</span> magic damage and applies <span class=\"colorFF5733\">Brittle</span>.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							120,
							100
						],
						"cooldownBurn": "140/120/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								2500,
								2500,
								2500
							],
							[
								125,
								175,
								225
							],
							[
								1200,
								1200,
								1200
							],
							[
								100,
								100,
								100
							],
							[
								40,
								60,
								80
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2500",
							"125/175/225",
							"1200",
							"100",
							"40/60/80",
							"2",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							2500,
							2500,
							2500
						],
						"rangeBurn": "2500",
						"image": {
							"full": "OrnnR.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Living Forge",
					"description": "Ornn can spend gold to forge non-consumable items anywhere.<br><br>Additionally, when Ornn reaches level 13 masterwork upgrades for some items become available for Ornn and his team to purchase.<br><br><font color='#8C8C8C' size='16'>Ornn can smith items directly from his forge menu or the shop.</font>",
					"image": {
						"full": "OrnnP.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ornn",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendary",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extenOrnnPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extenOrnnPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extenOrnnPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3801",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ornn",
						"title": "OrnnTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Pantheon": {
				"id": "Pantheon",
				"key": "80",
				"name": "Pantheon",
				"title": "the Artisan of War",
				"image": {
					"full": "Pantheon.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "80000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "80001",
						"num": 1,
						"name": "Myrmidon Pantheon",
						"chromas": false
					},
					{
						"id": "80002",
						"num": 2,
						"name": "Ruthless Pantheon",
						"chromas": false
					},
					{
						"id": "80003",
						"num": 3,
						"name": "Perseus Pantheon",
						"chromas": false
					},
					{
						"id": "80004",
						"num": 4,
						"name": "Full Metal Pantheon",
						"chromas": false
					},
					{
						"id": "80005",
						"num": 5,
						"name": "Glaive Warrior Pantheon",
						"chromas": false
					},
					{
						"id": "80006",
						"num": 6,
						"name": "Dragonslayer Pantheon",
						"chromas": true
					},
					{
						"id": "80007",
						"num": 7,
						"name": "Slayer Pantheon",
						"chromas": false
					},
					{
						"id": "80008",
						"num": 8,
						"name": "Baker Pantheon",
						"chromas": false
					}
				],
				"lore": "The peerless warrior known as Pantheon is a nigh-unstoppable paragon of battle. He was born among the Rakkor, a warlike people living on the flanks of Mount Targon, and after climbing the mountain's treacherous peak and being deemed worthy, he was chosen to become the earthly incarnation of the celestial Aspect of War. Imbued with inhuman power, he relentlessly seeks the enemies of Targon, leaving only corpses in his wake.",
				"blurb": "The peerless warrior known as Pantheon is a nigh-unstoppable paragon of battle. He was born among the Rakkor, a warlike people living on the flanks of Mount Targon, and after climbing the mountain's treacherous peak and being deemed worthy, he was...",
				"allytips": [
					"Using Aegis of Zeonia quickly followed by Heartseeker Strike can devastate your enemies.",
					"Using Spear Shot frequently in a battle, along with Attack Speed items, can help defensively by charging Aegis Protection.",
					"Using Grand Skyfall to assist your allies across the map can quickly turn the tides of battle, putting your allies at an advantage."
				],
				"enemytips": [
					"Keeping yourself hidden in brush can make it harder for Pantheon to target you with Grand Skyfall.",
					"Watch out for when Pantheon has a stunning or snaring partner in lane with him (example: Morgana, Sion) as he can cause devastating damage with his Heartseeker Strike.",
					"Pantheon's Aegis Protection shield will block a single champion basic attack or turret shot, but he's vulnerable until he brings it back up again by attacking or using abilities."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 4,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 579.16,
					"hpperlevel": 87,
					"mp": 317.12,
					"mpperlevel": 31,
					"movespeed": 355,
					"armor": 37,
					"armorperlevel": 3.9,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 150,
					"hpregen": 8,
					"hpregenperlevel": 0.65,
					"mpregen": 7.356,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 2.9,
					"attackspeedoffset": -0.03,
					"attackspeedperlevel": 2.95
				},
				"spells": [
					{
						"id": "PantheonQ",
						"name": "Spear Shot",
						"description": "Pantheon hurls his spear at an opponent, dealing damage.",
						"tooltip": "Pantheon hurls his spear at an opponent, dealing {{ e2 }} <scaleAD>(+{{ f1 }})</scaleAD> physical damage. ",
						"leveltip": {
							"label": [
								"Base Damage"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								100,
								115,
								130,
								145,
								160
							],
							[
								75,
								110,
								155,
								195,
								235
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/115/130/145/160",
							"75/110/155/195/235",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.4,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "PantheonQ.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PantheonW",
						"name": "Aegis of Zeonia",
						"description": "Pantheon leaps at an enemy and bashes them with his shield, stunning them. After finishing the attack, Pantheon readies himself to block the next attack.",
						"tooltip": "Pantheon leaps at target enemy, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage and stunning them for {{ e2 }} second. Pantheon also instantly refreshes his Aegis Protection.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							55,
							55,
							55,
							55,
							55
						],
						"costBurn": "55",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "PantheonW.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PantheonE",
						"name": "Heartseeker Strike",
						"description": "Pantheon focuses and unleashes 3 swift strikes to the area in front of him dealing damage to all enemies. Pantheon also becomes more aware of his enemy's vital spots, allowing him to always crit enemies below 15% Health.",
						"tooltip": "<spellPassive>Passive: </spellPassive>Pantheon's basic attacks and Spear Shot gain 100% critical strike chance against targets below {{ e3 }}% Health.<br /><br /><spellActive>Active: </spellActive>Pantheon focuses and delivers {{ e4 }} swift strikes in front of him for a total of {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage (deals {{ e2 }}% damage to minions and monsters).<br /><br />Damage per Strike: <totalValue>{{ f1 }}</totalValue>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/150/200/250/300",
							"60",
							"15",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 3,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "PantheonE.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PantheonRJump",
						"name": "Grand Skyfall",
						"description": "Pantheon composes himself then leaps into the air to a target, striking all enemy units in an area. Enemies closer to the impact point take more damage.",
						"tooltip": "Pantheon gathers his strength and then leaps high into the air, crashing down at target area a few seconds later. Deals up to {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to enemies at the center (down to {{ e6 }}% at the edge) and slows their Movement Speed by {{ e4 }}% for 1 second.<br /><br />If Pantheon cancels this channel, Grand Skyfall is put on a {{ e5 }} second cooldown.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							150,
							135,
							120
						],
						"cooldownBurn": "150/135/120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								400,
								700,
								1000
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								35,
								35,
								35
							],
							[
								30,
								30,
								30
							],
							[
								50,
								50,
								50
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"400/700/1000",
							"0",
							"0",
							"35",
							"30",
							"50",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							5500,
							5500,
							5500
						],
						"rangeBurn": "5500",
						"image": {
							"full": "PantheonRJump.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Aegis Protection",
					"description": "After attacking or casting spells 4 times, Pantheon will block the next incoming basic attack or turret attack.",
					"image": {
						"full": "Pantheon_AOZ.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Pantheon",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "3044",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3044",
										"count": 1
									},
									{
										"id": "3057",
										"count": 1
									},
									{
										"id": "3086",
										"count": 1
									},
									{
										"id": "3078",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3071",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3035",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Pantheon",
						"title": "PantheonTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Poppy": {
				"id": "Poppy",
				"key": "78",
				"name": "Poppy",
				"title": "Keeper of the Hammer",
				"image": {
					"full": "Poppy.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "78000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "78001",
						"num": 1,
						"name": "Noxus Poppy",
						"chromas": false
					},
					{
						"id": "78002",
						"num": 2,
						"name": "Lollipoppy",
						"chromas": false
					},
					{
						"id": "78003",
						"num": 3,
						"name": "Blacksmith Poppy",
						"chromas": false
					},
					{
						"id": "78004",
						"num": 4,
						"name": "Ragdoll Poppy",
						"chromas": false
					},
					{
						"id": "78005",
						"num": 5,
						"name": "Battle Regalia Poppy",
						"chromas": true
					},
					{
						"id": "78006",
						"num": 6,
						"name": "Scarlet Hammer Poppy",
						"chromas": false
					},
					{
						"id": "78007",
						"num": 7,
						"name": "Star Guardian Poppy",
						"chromas": false
					},
					{
						"id": "78014",
						"num": 14,
						"name": "Snow Fawn Poppy",
						"chromas": false
					}
				],
				"lore": "Runeterra has no shortage of valiant champions, but few are as tenacious as Poppy. Bearing the legendary hammer of Orlon, a weapon twice her size, this determined yordle has spent untold years searching in secret for the fabled “Hero of Demacia,” said to be its rightful wielder. Until then, she dutifully charges into battle, pushing back the kingdom's enemies with every whirling strike.",
				"blurb": "Runeterra has no shortage of valiant champions, but few are as tenacious as Poppy. Bearing the legendary hammer of Orlon, a weapon twice her size, this determined yordle has spent untold years searching in secret for the fabled “Hero of Demacia,” said...",
				"allytips": [
					"Iron Ambassador tends to land near walls, try to take advantage of this with Heroic Charge.",
					"Keeper's Verdict can be released immediately to send the enemy straight up, take advantage of this in duels."
				],
				"enemytips": [
					"Poppy can stop nearby enemies from dashing with Steadfast Presence.",
					"When Poppy starts to spin her hammer, she is charging Keeper's Verdict.",
					"You can step on Poppy's shield to deny it from her."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 7,
					"magic": 2,
					"difficulty": 6
				},
				"stats": {
					"hp": 540,
					"hpperlevel": 90,
					"mp": 280,
					"mpperlevel": 40,
					"movespeed": 345,
					"armor": 38,
					"armorperlevel": 3.5,
					"spellblock": 32,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.8,
					"mpregen": 7,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 4,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "PoppyQ",
						"name": "Hammer Shock",
						"description": "Poppy swings her hammer, dealing damage and creating a zone that will slow enemies and explode after a delay.",
						"tooltip": "Poppy smashes the ground, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> plus {{ e5 }}% of the enemies' maximum Health as physical damage, and leaving an unstable area.<br /><br />The area slows enemies inside it by {{ e3 }}% and erupts after {{ e4 }} second, dealing the initial damage again.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							35,
							40,
							45,
							50,
							55
						],
						"costBurn": "35/40/45/50/55",
						"effect": [
							null,
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/60/80/100/120",
							"0.5",
							"20/25/30/35/40",
							"1",
							"8",
							"40/60/80/100/120",
							"100",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							430,
							430,
							430,
							430,
							430
						],
						"rangeBurn": "430",
						"image": {
							"full": "PoppyQ.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PoppyW",
						"name": "Steadfast Presence",
						"description": "Poppy passively gains Armor and Magic Resist. This bonus increases when she is low on Health. Poppy can activate Steadfast Presence to stop enemy dashes around her and gain movement speed.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Poppy gains <span class=\"colorFFFF00\">{{ f1 }}</span> Armor and <span class=\"colorFF00FF\">{{ f2 }}</span> Magic Resist ({{ e3 }}% of Armor and Magic Resist). This bonus is doubled if Poppy is below 40% Health.<br /><br /><span class=\"colorFF9900\">Active:</span> For the next {{ e1 }} seconds, Poppy gains {{ e2 }}% Movement Speed. While Steadfast Presence is active, she stops enemy dashes in an area around her, dealing {{ e5 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Movement Speed",
								"Cooldown",
								"Damage"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e5 }} -> {{ e5NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							22,
							20,
							18,
							16
						],
						"cooldownBurn": "24/22/20/18/16",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								32,
								34,
								36,
								38,
								40
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2.5",
							"32/34/36/38/40",
							"15",
							"0.5",
							"70/110/150/190/230",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "PoppyW.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PoppyE",
						"name": "Heroic Charge",
						"description": "Poppy dashes to the target and pushes it back. If the target is pushed into a wall, it is stunned.",
						"tooltip": "Poppy tackles an enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and carrying them forward. If Poppy carries the target into terrain, the enemy takes {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> additional physical damage and is stunned for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Initial Damage",
								"Wall Damage",
								"Stun Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								1.6,
								1.7,
								1.8,
								1.9,
								2
							],
							[
								1800,
								1800,
								1800,
								1800,
								1800
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/80/100/120/140",
							"60/80/100/120/140",
							"1.6/1.7/1.8/1.9/2",
							"1800",
							"400",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							425,
							425,
							425,
							425,
							425
						],
						"rangeBurn": "425",
						"image": {
							"full": "PoppyE.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PoppyR",
						"name": "Keeper's Verdict",
						"description": "Poppy channels a hammer strike that knocks enemies very far away.",
						"tooltip": "<span class=\"colorFF9900\">First Cast:</span> Poppy channels for up to {{ e3 }} seconds, slowing herself by {{ e7 }}%.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Poppy smashes the ground, emanating a shockwave that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to enemies around the first champion hit and knocking them a large distance toward their Summoning Platform. The shockwave length and knockback distance increases with channel duration.<br /><br />Enemies hit with an uncharged Keeper's Verdict will take half the damage and be knocked straight into the air for half the duration. Enemies are untargetable while they are being knocked away.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							120,
							100
						],
						"cooldownBurn": "140/120/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								200,
								300,
								400
							],
							[
								0.25,
								0.25,
								0.25
							],
							[
								4,
								4,
								4
							],
							[
								2400,
								2400,
								2400
							],
							[
								2,
								2,
								2
							],
							[
								1,
								1,
								1
							],
							[
								15,
								15,
								15
							],
							[
								30,
								30,
								30
							],
							[
								1,
								1,
								1
							],
							[
								0.5,
								0.5,
								0.5
							]
						],
						"effectBurn": [
							null,
							"200/300/400",
							"0.25",
							"4",
							"2400",
							"2",
							"1",
							"15",
							"30",
							"1",
							"0.5"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "PoppyR.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Iron Ambassador",
					"description": "<mainText>Poppy throws her buckler, gaining range and bonus magic damage.<br><br>The buckler lands at a nearby location and Poppy can pick it up to gain a shield. Enemies can step on the buckler to destroy it.</mainText>",
					"image": {
						"full": "Poppy_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Poppy",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppyARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppyCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppyFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppyKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppySG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppySIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppySR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Poppy",
						"title": "PoppyTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Quinn": {
				"id": "Quinn",
				"key": "133",
				"name": "Quinn",
				"title": "Demacia's Wings",
				"image": {
					"full": "Quinn.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "133000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "133001",
						"num": 1,
						"name": "Phoenix Quinn",
						"chromas": false
					},
					{
						"id": "133002",
						"num": 2,
						"name": "Woad Scout Quinn",
						"chromas": false
					},
					{
						"id": "133003",
						"num": 3,
						"name": "Corsair Quinn",
						"chromas": false
					},
					{
						"id": "133004",
						"num": 4,
						"name": "Heartseeker Quinn",
						"chromas": false
					}
				],
				"lore": "Quinn is an elite ranger-knight of Demacia, who undertakes dangerous missions deep in enemy territory. She and her legendary eagle, Valor, share an unbreakable bond, and their foes are often slain before they realize they are fighting not one, but two of the kingdom's greatest heroes. Nimble and acrobatic when required, Quinn takes aim with her crossbow while Valor marks their elusive targets from above, making them a deadly pair on the battlefield.",
				"blurb": "Quinn is an elite ranger-knight of Demacia, who undertakes dangerous missions deep in enemy territory. She and her legendary eagle, Valor, share an unbreakable bond, and their foes are often slain before they realize they are fighting not one, but two...",
				"allytips": [
					"Attacking a ",
					"Vulnerable",
					" target marked by Valor will put Harrier on cooldown. Quickly consuming Harrier marks will allow you to generate them faster.",
					"Vault is powerful but must be used with caution, as enemies can attack Quinn when she strikes them. Vault can sometimes be used to cross terrain if your back is to a wall.",
					"Use Behind Enemy Lines for traveling very long distances quickly, for farming minions around the map, or for chasing wounded targets."
				],
				"enemytips": [
					"After being marked, move away from Quinn so she can't take advantage of it.",
					"Keep tabs on Quinn's position. Behind Enemy Lines can enable Valor to cross the map very quickly and attack you by surprise.",
					"When Quinn is using Behind Enemy Lines, damaging her will end the effect."
				],
				"tags": [
					"Marksman",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 4,
					"magic": 2,
					"difficulty": 5
				},
				"stats": {
					"hp": 532.8,
					"hpperlevel": 85,
					"mp": 268.8,
					"mpperlevel": 35,
					"movespeed": 335,
					"armor": 32,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6.972,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 62,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": -0.065,
					"attackspeedperlevel": 3.1
				},
				"spells": [
					{
						"id": "QuinnQ",
						"name": "Blinding Assault",
						"description": "Quinn calls Valor to mark an enemy and hinder its vision before damaging all enemies in the immediate area.",
						"tooltip": "Valor flies in a line, marking the first enemy he hits as <span class=\"colorFFF673\">Vulnerable</span> and reducing its vision radius dramatically for {{ e3 }} seconds. He then deals {{ e1 }} <scaleAD>(+{{ f2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> physical damage to all nearby enemies.<br /><br />If the primary target is not a champion, it cannot attack for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Total Attack Damage Ratio",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10.5,
							10,
							9.5,
							9
						],
						"cooldownBurn": "11/10.5/10/9.5/9",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								20,
								45,
								70,
								95,
								120
							],
							[
								-1000,
								-1000,
								-1000,
								-1000,
								-1000
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0.8,
								0.9,
								1,
								1.1,
								1.2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/45/70/95/120",
							"-1000",
							"1.5",
							"0.8/0.9/1/1.1/1.2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1025,
							1025,
							1025,
							1025,
							1025
						],
						"rangeBurn": "1025",
						"image": {
							"full": "QuinnQ.png",
							"sprite": "spell8.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "QuinnW",
						"name": "Heightened Senses",
						"description": "Passively grants Quinn Attack Speed and Movement Speed after she attacks a <font color='#FFF673'>Vulnerable</font> target. Activate to have Valor reveal a large area nearby.",
						"tooltip": "<spellPassive>Passive:</spellPassive> Attacking a <span class=\"colorFFF673\">Vulnerable</span> target increases Quinn's Attack Speed by {{ e2 }}% and Movement Speed by {{ e3 }}% for {{ e1 }} seconds.<br /><br /><spellActive>Active:</spellActive> Valor reveals a large area nearby for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Attack Speed Bonus",
								"Movement Speed Bonus",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							50,
							45,
							40,
							35,
							30
						],
						"cooldownBurn": "50/45/40/35/30",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								20,
								35,
								50,
								65,
								80
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								2100,
								2100,
								2100,
								2100,
								2100
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2",
							"20/35/50/65/80",
							"20/25/30/35/40",
							"2100",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							2100,
							2100,
							2100,
							2100,
							2100
						],
						"rangeBurn": "2100",
						"image": {
							"full": "QuinnW.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "QuinnE",
						"name": "Vault",
						"description": "Quinn dashes to an enemy, dealing physical damage and slowing the target's Movement Speed. Upon reaching the target, she leaps off the target, briefly interrupting it, and lands near her maximum Attack Range away from the target.",
						"tooltip": "Quinn dashes to an enemy, dealing {{ e2 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage while Valor marks it as <span class=\"colorFFF673\">Vulnerable</span>.<br /><br />Upon reaching the target, Quinn leaps off, briefly displacing and slowing it by {{ e1 }}% (diminishing over {{ e3 }} seconds).",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50",
							"40/70/100/130/160",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							675,
							675,
							675,
							675,
							675
						],
						"rangeBurn": "675",
						"image": {
							"full": "QuinnE.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "QuinnR",
						"name": "Behind Enemy Lines",
						"description": "Quinn and Valor team up to fly around at great speed.",
						"tooltip": "Quinn calls down Valor to assist her. After a 2 second channel, they unite, gaining {{ e3 }}% Total Movement Speed and the ability to cast Skystrike by recasting this ability or taking offensive action. Skystrike damages nearby enemies.<br /><br />Taking champion or turret damage puts Behind Enemy Lines on a 3 second cooldown.",
						"leveltip": {
							"label": [
								"Movement Speed Bonus",
								"Mana Cost"
							],
							"effect": [
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e7 }} -> {{ e7NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							3,
							3,
							3
						],
						"cooldownBurn": "3",
						"cost": [
							100,
							50,
							0
						],
						"costBurn": "100/50/0",
						"effect": [
							null,
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								70,
								100,
								130
							],
							[
								25000,
								25000,
								25000
							],
							[
								0,
								0,
								0
							],
							[
								8,
								8,
								8
							],
							[
								100,
								50,
								0
							],
							[
								0.4,
								0.4,
								0.4
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"0",
							"70/100/130",
							"25000",
							"0",
							"8",
							"100/50/0",
							"0.4",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "QuinnR.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Harrier",
					"description": "Valor periodically marks enemies as <font color='#FFF673'>Vulnerable</font>. Quinn's first basic attack against <font color='#FFF673'>Vulnerable</font> targets will deal bonus physical damage.",
					"image": {
						"full": "Quinn_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Quinn",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Quinn",
						"title": "QuinnTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Rakan": {
				"id": "Rakan",
				"key": "497",
				"name": "Rakan",
				"title": "The Charmer",
				"image": {
					"full": "Rakan.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "497000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "497001",
						"num": 1,
						"name": "Cosmic Dawn Rakan",
						"chromas": false
					},
					{
						"id": "497002",
						"num": 2,
						"name": "Sweetheart Rakan",
						"chromas": false
					}
				],
				"lore": "As mercurial as he is charming, Rakan is an infamous vastayan troublemaker and the greatest battle-dancer in Lhotlan tribal history. To the humans of the Ionian highlands, his name has long been synonymous with wild festivals, uncontrollable parties, and anarchic music. Few would suspect this energetic, traveling showman is also partner to the rebel Xayah, and is dedicated to her cause.",
				"blurb": "As mercurial as he is charming, Rakan is an infamous vastayan troublemaker and the greatest battle-dancer in Lhotlan tribal history. To the humans of the Ionian highlands, his name has long been synonymous with wild festivals, uncontrollable parties...",
				"allytips": [
					"Rakan requires allies near him to make the most out of his tools.",
					"Rakan's dash speeds increase with his movement speed. Use the extra speed to surprise your enemies!",
					"Danger is as fun as you let it be."
				],
				"enemytips": [
					"Rakan's movement abilities forecast their destination. Try to use this to your advantage.",
					"Champions with crowd control that can be applied quickly excel against Rakan.",
					"Catching Rakan with no allies around severely inhibits his mobility. Try to find him alone."
				],
				"tags": [
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 4,
					"magic": 8,
					"difficulty": 5
				},
				"stats": {
					"hp": 510,
					"hpperlevel": 85,
					"mp": 315,
					"mpperlevel": 50,
					"movespeed": 335,
					"armor": 36,
					"armorperlevel": 3.9,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 300,
					"hpregen": 5,
					"hpregenperlevel": 0.5,
					"mpregen": 8.75,
					"mpregenperlevel": 0.5,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 70,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "RakanQ",
						"name": "Gleaming Quill",
						"description": "Flings a magical feather that deals magic damage. Striking a champion or epic monster enables Rakan to heal his allies.",
						"tooltip": "Flings a magical feather that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy hit.<br /><br />If the feather hits a champion or epic monster, Rakan restores <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a2 }})</span> health to himself and nearby allies after {{ e4 }} seconds or when he touches an ally.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f3 }} -> {{ f2 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								7.5,
								7.5,
								7.5,
								7.5,
								7.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								12,
								10.5,
								9,
								7.5,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"15",
							"7.5",
							"3",
							"12/10.5/9/7.5/6",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "RakanQ.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RakanW",
						"name": "Grand Entrance",
						"description": "Dashes to a location, knocking up nearby enemies on arrival.",
						"tooltip": "Dashes to a location. Upon arrival Rakan spirals into the air, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and knocking up enemies for {{ e3 }} second.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16.5,
							15,
							13.5,
							12
						],
						"cooldownBurn": "18/16.5/15/13.5/12",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								2050,
								2050,
								2050,
								2050,
								2050
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.3,
								0.3,
								0.3,
								0.3,
								0.3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"2050",
							"1",
							"0.3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "RakanW.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RakanE",
						"name": "Battle Dance",
						"description": "Flies to an allied champion granting them a shield. Can be re-cast for free for a short duration.",
						"tooltip": "Flies to an allied champion, granting them a {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health shield for {{ e3 }} seconds.<br /><br />Can be re-cast at no cost once within {{ e2 }} seconds.<br /><br /><span class=\"colore5c100\">Battle Dance's cast range is increased when cast on Xayah.</span></i>",
						"leveltip": {
							"label": [
								"Shield Health",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f2 }} -> {{ f6 }}",
								"{{ e5 }} -> {{ e5NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								20,
								18,
								16,
								14,
								12
							],
							[
								60,
								70,
								80,
								90,
								100
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								1150,
								1150,
								1150,
								1150,
								1150
							],
							[
								1250,
								1250,
								1250,
								1250,
								1250
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"5",
							"3",
							"20/18/16/14/12",
							"60/70/80/90/100",
							"600",
							"1000",
							"1150",
							"1250",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "RakanE.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RakanR",
						"name": "The Quickness",
						"description": "Gains movement speed, charming and dealing magic damage to enemies touched.",
						"tooltip": "Gain {{ e5 }}% movement speed for {{ e2 }} seconds.<br /><br />Touching enemies deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and charms them for {{ e3 }} second(s) the first time they're hit. The first champion charmed grants Rakan {{ e6 }}% decaying movement speed.",
						"leveltip": {
							"label": [
								"Charm Duration",
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								200,
								300
							],
							[
								4,
								4,
								4
							],
							[
								1,
								1.25,
								1.5
							],
							[
								0.25,
								0.25,
								0.25
							],
							[
								50,
								50,
								50
							],
							[
								150,
								150,
								150
							],
							[
								150,
								150,
								150
							],
							[
								120,
								100,
								80
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/200/300",
							"4",
							"1/1.25/1.5",
							"0.25",
							"50",
							"150",
							"150",
							"120/100/80",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							200,
							200,
							200
						],
						"rangeBurn": "200",
						"image": {
							"full": "RakanR.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Fey Feathers",
					"description": "Rakan periodically gains a shield.",
					"image": {
						"full": "Rakan_P.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Rakan",
						"title": "Beginner",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rakan",
						"title": "RakanARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rakan",
						"title": "RakanCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rakan",
						"title": "RakanKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rakan",
						"title": "RakanSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rakan",
						"title": "RakanSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rakan",
						"title": "RakanTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Rammus": {
				"id": "Rammus",
				"key": "33",
				"name": "Rammus",
				"title": "the Armordillo",
				"image": {
					"full": "Rammus.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "33000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "33001",
						"num": 1,
						"name": "King Rammus",
						"chromas": false
					},
					{
						"id": "33002",
						"num": 2,
						"name": "Chrome Rammus",
						"chromas": false
					},
					{
						"id": "33003",
						"num": 3,
						"name": "Molten Rammus",
						"chromas": false
					},
					{
						"id": "33004",
						"num": 4,
						"name": "Freljord Rammus",
						"chromas": false
					},
					{
						"id": "33005",
						"num": 5,
						"name": "Ninja Rammus",
						"chromas": false
					},
					{
						"id": "33006",
						"num": 6,
						"name": "Full Metal Rammus",
						"chromas": false
					},
					{
						"id": "33007",
						"num": 7,
						"name": "Guardian of the Sands Rammus",
						"chromas": false
					}
				],
				"lore": "Idolized by many, dismissed by some, mystifying to all, the curious being Rammus is an enigma. Protected by a spiked shell, he inspires increasingly disparate theories on his origin wherever he goes—from demigod, to sacred oracle, to a mere beast transformed by magic. Whatever the truth may be, Rammus keeps his own counsel and stops for no one as he roams the Shuriman desert.",
				"blurb": "Idolized by many, dismissed by some, mystifying to all, the curious being Rammus is an enigma. Protected by a spiked shell, he inspires increasingly disparate theories on his origin wherever he goes—from demigod, to sacred oracle, to a mere beast...",
				"allytips": [
					"Powerball can be used as an effective escape mechanism.",
					"Using taunt on a champion by your tower can cause the tower to attack your enemy.",
					"Tremors and Defensive Ball Curl can be used late in the game to obliterate towers. If you're bogged down in a team fight, it is often valuable to break off and attack the buildings."
				],
				"enemytips": [
					"Pay particular attention to when his Defensive Ball Curl is off. Rammus has much lower stats than a normal tank when he's out of the stance.",
					"Rammus often stacks high Armor, leaving him especially vulnerable to caster damage while not in Defensive Ball Curl."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 10,
					"magic": 5,
					"difficulty": 5
				},
				"stats": {
					"hp": 564.48,
					"hpperlevel": 86,
					"mp": 310.44,
					"mpperlevel": 33,
					"movespeed": 335,
					"armor": 36,
					"armorperlevel": 4.3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.55,
					"mpregen": 7.84,
					"mpregenperlevel": 0.5,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55.88,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.215
				},
				"spells": [
					{
						"id": "PowerBall",
						"name": "Powerball",
						"description": "Rammus accelerates in a ball towards his enemies, dealing damage and slowing targets affected by the impact.",
						"tooltip": "Rammus accelerates in a ball, gaining up to <span class=\"colorFFFFFF\">{{ f2 }}%</span> Movement Speed over {{ e4 }} seconds. On enemy collision, he stops, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies, knocking them back, and slowing them by {{ e2 }}% for {{ e3 }} second.<br /><br /><rules><span class=\"color8c8c8c\">Can be reactivated to end the effect early and put Powerball on cooldown.<br />Powerball is a channeled spell and is subject to interruption by spells that prevent casting.<br />Casting Powerball cancels Defensive Ball Curl and puts it on cooldown.</span></rules>",
						"leveltip": {
							"label": [
								"Damage ",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							13.5,
							11,
							8.5,
							6
						],
						"cooldownBurn": "16/13.5/11/8.5/6",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								100,
								135,
								170,
								205,
								240
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								125,
								125,
								125,
								125,
								125
							],
							[
								0.35,
								0.35,
								0.35,
								0.35,
								0.35
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							]
						],
						"effectBurn": [
							null,
							"100/135/170/205/240",
							"40/50/60/70/80",
							"1",
							"6",
							"125",
							"0.35",
							"25",
							"0.25",
							"50",
							"1000"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "PowerBall.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "DefensiveBallCurl",
						"name": "Defensive Ball Curl",
						"description": "Rammus goes into a defensive formation, vastly increasing his Armor and Magic Resistance, amplifying Spiked Shells' damage, and returning damage to enemies that basic attack him, but he is also slowed during this time.",
						"tooltip": "Rammus enters a defensive formation for up to {{ e3 }} seconds, increasing Armor by {{ e1 }} plus {{ e6 }}% <span class=\"colorFFFF00\">({{ f1 }})</span> and Magic Resist by {{ e8 }} plus {{ e7 }}% <span class=\"colorFF00FF\">({{ f2 }})</span> but becoming slowed by {{ e5 }}%.<br /><br />During this time, Spiked Shell deals {{ e4 }}% damage and also deals its damage to enemies that basic attack Rammus.<br /><br /><rules><span class=\"color8c8c8c\">Can be reactivated to end the effect early and put Defensive Ball Curl on cooldown.<br />Casting Defensive Ball Curl cancels Powerball and puts it on cooldown.</span></rules>",
						"leveltip": {
							"label": [
								"Percent Armor Bonus",
								"Percent Magic Resist Bonus"
							],
							"effect": [
								"{{ e6 }}% -> {{ e6NL }}%",
								"{{ e7 }}% -> {{ e7NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								25,
								35,
								45,
								55,
								65
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								50,
								60,
								70,
								80,
								90
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20",
							"25/35/45/55/65",
							"6",
							"150",
							"30",
							"50/60/70/80/90",
							"25/30/35/40/45",
							"10",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "armor",
								"coeff": 0.1,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "DefensiveBallCurl.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PuncturingTaunt",
						"name": "Frenzying Taunt",
						"description": "Rammus taunts an enemy champion or monster into a reckless assault against him. Additionally, he gains increased Attack Speed for a short time, but this bonus is extended by having any of his other spells active.",
						"tooltip": "Taunt an enemy champion or monster for {{ e1 }} seconds and gain {{ e2 }}% Attack Speed for the same duration.<br /><br />While any of Rammus' other spells are active, Frenzying Taunt's Attack Speed bonus is refreshed.",
						"leveltip": {
							"label": [
								"Duration",
								"Attack Speed Bonus"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								1.25,
								1.5,
								1.75,
								2,
								2.25
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.25/1.5/1.75/2/2.25",
							"20/25/30/35/40",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "PuncturingTaunt.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Tremors2",
						"name": "Tremors",
						"description": "Rammus creates waves of destruction pulsing through the ground, causing damage to nearby enemies and slowing them. Turrets take double damage from Tremors.",
						"tooltip": "Shake the earth for {{ e2 }} seconds, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and slowing them by {{ e4 }}% for {{ e3 }} seconds, stacking up to {{ e6 }} times.<br /><br />Tremors deals {{ e5 }}% damage to turrets.",
						"leveltip": {
							"label": [
								"Damage per Tremor",
								"Slow per Tremor",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							80,
							60
						],
						"cooldownBurn": "100/80/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								40,
								80,
								120
							],
							[
								7,
								7,
								7
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								8,
								10,
								12
							],
							[
								200,
								200,
								200
							],
							[
								8,
								8,
								8
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/80/120",
							"7",
							"1.5",
							"8/10/12",
							"200",
							"8",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							375,
							375,
							375
						],
						"rangeBurn": "375",
						"image": {
							"full": "Tremors2.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Spiked Shell",
					"description": "Rammus' basic attacks deal bonus magic damage, scaling with his Armor.",
					"image": {
						"full": "Armordillo_ScavengeArmor.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Rammus",
						"title": "RammusARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rammus",
						"title": "RammusCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rammus",
						"title": "RammusFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3711",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rammus",
						"title": "RammusKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rammus",
						"title": "RammusSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rammus",
						"title": "RammusSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rammus",
						"title": "RammusTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"RekSai": {
				"id": "RekSai",
				"key": "421",
				"name": "Rek'Sai",
				"title": "the Void Burrower",
				"image": {
					"full": "RekSai.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "421000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "421001",
						"num": 1,
						"name": "Eternum Rek'Sai",
						"chromas": false
					},
					{
						"id": "421002",
						"num": 2,
						"name": "Pool Party Rek'Sai",
						"chromas": false
					}
				],
				"lore": "An apex predator, Rek'Sai is a merciless Void-spawn that tunnels beneath the ground to ambush and devour unsuspecting prey. Her insatiable hunger has laid waste to entire regions of the once-great empire of Shurima—merchants, traders, even armed caravans, will go hundreds of miles out of their way to avoid her and her offspring's hunting grounds. All know that once Rek'Sai is seen on the horizon, death from below is all but guaranteed.",
				"blurb": "An apex predator, Rek'Sai is a merciless Void-spawn that tunnels beneath the ground to ambush and devour unsuspecting prey. Her insatiable hunger has laid waste to entire regions of the once-great empire of Shurima—merchants, traders, even armed...",
				"allytips": [
					"Keeping tunnels spread out across the map will ensure you have choices when you want to cast Void Rush.",
					"Cast Burrow before travelling around the map to take advantage of the increased Movement Speed and the safety provided by Tremor Sense.",
					"Tremor Sense can warn you of enemies closing in, and is particularly useful when entering enemy territory."
				],
				"enemytips": [
					"If you see one of Rek'Sai's tunnels, briefly stand on one of the entrances to destroy it.",
					"Rek'Sai's Furious Bite gains damage as she builds Fury. Be very careful around her when her Fury is full.",
					"When Rek'Sai is near, she can see the position of you and your allies, but only if you're moving."
				],
				"tags": [
					"Fighter"
				],
				"partype": "Fury",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 2,
					"difficulty": 3
				},
				"stats": {
					"hp": 570,
					"hpperlevel": 85,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 335,
					"armor": 33,
					"armorperlevel": 3.75,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 7.5,
					"hpregenperlevel": 0.65,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65.5,
					"attackdamageperlevel": 3.35,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "RekSaiQ",
						"name": "Queen's Wrath / Prey Seeker",
						"description": "Rek'Sai's next 3 basic attacks deal bonus Physical Damage to nearby enemies.<br><br>While Burrowed, Rek'Sai launches a burst of void-charged earth that deals Physical Damage and reveals enemies hit.",
						"tooltip": "<span class=\"colorFF8C00\">Un-Burrowed:</span> Rek'Sai's next 3 basic attacks within 5 seconds deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> bonus Physical Damage to nearby enemies.<br /><br /><span class=\"colorFF8C00\">Burrowed:</span> Rek'Sai launches a burst of void-charged earth that explodes on first enemy hit, dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage and revealing non-stealthed enemies for {{ e6 }} seconds.",
						"leveltip": {
							"label": [
								"Queen's Wrath Damage",
								"Prey Seeker Damage",
								"Prey Seeker Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e5 }} -> {{ e5NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								11,
								10,
								9,
								8,
								7
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/25/30/35/40",
							"0",
							"0",
							"60/90/120/150/180",
							"11/10/9/8/7",
							"2.5",
							"5",
							"300",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a2"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "RekSaiQ.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "RekSaiW",
						"name": "Burrow / Un-burrow",
						"description": "Rek'Sai burrows into the ground, gaining new abilities and increased Movement Speed. Her vision range is reduced and she cannot use basic attacks.<br><br>While Burrowed, Rek'Sai may cast Un-burrow to knock up and damage nearby enemies.",
						"tooltip": "<span class=\"colorFF8C00\">Un-Burrowed:</span> Burrow into the ground. <br /><br /><span class=\"colorFF8C00\">Burrowed:</span> Un-burrow, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage and knocking up the closest enemy for {{ e5 }} second. All other nearby enemies will be knocked back. An enemy who has been knocked up will be immune from further Un-burrow effects for {{ e6 }} seconds.<br /><br /><span class=\"colorFF8C00\">Burrowed Effects:</span> New abilities, <span class=\"colorFFFFFF\">+{{ f1 }}</span> Movement Speed, reduced vision range, disabled basic attacks, and gains <span class=\"color993299\">Tremor Sense:</span> Nearby enemies that move in Fog of War have their position revealed to Rek'Sai and her allies.",
						"leveltip": {
							"label": [
								"Un-burrow Damage"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								1500,
								1500,
								1500,
								1500,
								1500
							],
							[
								55,
								70,
								85,
								100,
								115
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								175,
								175,
								175,
								175,
								175
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.3,
								0.3,
								0.3,
								0.3,
								0.3
							]
						],
						"effectBurn": [
							null,
							"1500",
							"55/70/85/100/115",
							"0",
							"0",
							"1",
							"10",
							"250",
							"175",
							"3",
							"0.3"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1650,
							1650,
							1650,
							1650,
							1650
						],
						"rangeBurn": "1650",
						"image": {
							"full": "RekSaiW.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "RekSaiE",
						"name": "Furious Bite / Tunnel",
						"description": "Rek'Sai bites her target, dealing double and True Damage if she has max Fury.<br><br>While Burrowed, Rek'Sai creates a re-usable, long lasting tunnel. Enemies can destroy it by standing on top of either entrance.",
						"tooltip": "<span class=\"colorFF8C00\">Un-Burrowed:</span> Rek'Sai bites a target dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage. At max Fury, the bite does 100% more and deals True Damage.<br /><br />Maximum Damage: <span class=\"colorFFFFFF\">{{ f2 }}</span><br /><br /><span class=\"colorFF8C00\">Burrowed:</span> Rek'Sai tunnels forward leaving two connected <span class=\"color993299\">Tunnel Entrances</span>. Clicking a <span class=\"color993299\">Tunnel Entrance</span> will make Rek'Sai dive to the other entrance.<br /><br /><span class=\"color993299\">Tunnel Entrances</span> last for {{ e5 }} minutes and can be destroyed by enemies. Rek'Sai may have {{ e6 }} tunnels at one time. Tunnels have a {{ e8 }} second cooldown on use.",
						"leveltip": {
							"label": [
								"Furious Bite Damage",
								"Tunnel Cast Cooldown",
								"Tunnel Use Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f4 }} -> {{ f5 }}",
								"{{ e8 }} -> {{ e8NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								55,
								65,
								75,
								85,
								95
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								10,
								8,
								6,
								4,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/65/75/85/95",
							"0",
							"12",
							"0",
							"10",
							"8",
							"0",
							"10/8/6/4/2",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.85,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							250,
							250,
							250,
							250,
							250
						],
						"rangeBurn": "250",
						"image": {
							"full": "RekSaiE.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "RekSaiRWrapper",
						"name": "Void Rush",
						"description": "Rek'Sai dives underground and leaps towards her target, dealing massive damage.",
						"tooltip": "<span class=\"colorFF8C00\">Passive:</span> Dealing damage to enemy Champions marks them for the next {{ e6 }} seconds.<br /><br /><span class=\"colorFF8C00\">Active:</span> Rek'Sai lets out a harrowing scream before burrowing underground seeking out a marked target. Moments later she leaps from underground, dealing {{ e8 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage plus {{ e9 }}% of their missing Health.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Missing Health Damage"
							],
							"effect": [
								"{{ e8 }} -> {{ e8NL }}",
								"{{ f7 }} -> {{ f8 }}",
								"{{ e9 }}% -> {{ e9NL }}%"
							]
						},
						"maxrank": 3,
						"cooldown": [
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								5,
								5,
								5
							],
							[
								0,
								0,
								0
							],
							[
								100,
								250,
								400
							],
							[
								20,
								25,
								30
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"0",
							"0",
							"0",
							"0",
							"5",
							"0",
							"100/250/400",
							"20/25/30",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.85,
								"key": "a2"
							}
						],
						"costType": "No cost",
						"maxammo": "-1",
						"range": [
							1500,
							1500,
							1500
						],
						"rangeBurn": "1500",
						"image": {
							"full": "RekSaiRWrapper.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No cost"
					}
				],
				"passive": {
					"name": "Fury of the Xer'Sai",
					"description": "While unburrowed Rek'Sai generates Fury with her basic attacks and spells. When burrowed Rek'Sai consumes Fury to heal herself.",
					"image": {
						"full": "RekSai_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "RekSai",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3052",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "RekSai",
						"title": "RekSaiTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Renekton": {
				"id": "Renekton",
				"key": "58",
				"name": "Renekton",
				"title": "the Butcher of the Sands",
				"image": {
					"full": "Renekton.png",
					"sprite": "champion2.png",
					"group": "champion",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "58000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "58001",
						"num": 1,
						"name": "Galactic Renekton",
						"chromas": false
					},
					{
						"id": "58002",
						"num": 2,
						"name": "Outback Renekton",
						"chromas": false
					},
					{
						"id": "58003",
						"num": 3,
						"name": "Bloodfury Renekton",
						"chromas": false
					},
					{
						"id": "58004",
						"num": 4,
						"name": "Rune Wars Renekton",
						"chromas": false
					},
					{
						"id": "58005",
						"num": 5,
						"name": "Scorched Earth Renekton",
						"chromas": false
					},
					{
						"id": "58006",
						"num": 6,
						"name": "Pool Party Renekton",
						"chromas": false
					},
					{
						"id": "58007",
						"num": 7,
						"name": "Prehistoric Renekton",
						"chromas": false
					},
					{
						"id": "58008",
						"num": 8,
						"name": "SKT T1 Renekton",
						"chromas": false
					},
					{
						"id": "58009",
						"num": 9,
						"name": "Renektoy",
						"chromas": false
					}
				],
				"lore": "Renekton is a terrifying, rage-fueled Ascended being from the scorched deserts of Shurima. Once, he was his empire's most esteemed warrior, leading the nation's armies to countless victories. However, after the empire's fall, Renekton was entombed beneath the sands, and slowly, as the world turned and changed, he succumbed to insanity. Now free once more, he is utterly consumed with finding and killing his brother, Nasus, who he blames, in his madness, for the centuries he spent in darkness.",
				"blurb": "Renekton is a terrifying, rage-fueled Ascended being from the scorched deserts of Shurima. Once, he was his empire's most esteemed warrior, leading the nation's armies to countless victories. However, after the empire's fall, Renekton was entombed...",
				"allytips": [
					"Slice and Dice excels at harassing maneuvers. Slice in, follow up with another skill and then Dice back out to safety.",
					"Cull the Meek drains an enormous amount of life when used in the middle of the fray. You can use this to bait opponents into thinking you are weaker than you really are.",
					"Cooldown reduction is especially good for Renekton, allowing him to both quickly build up and use his Fury."
				],
				"enemytips": [
					"Pay close attention to Renekton's Fury gauge as that will usually signify when he is about to attack.",
					"Keeping Renekton from being able to fight and gain Fury by continually harassing him will severely reduce the effectiveness of his abilities."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Fury",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 2,
					"difficulty": 3
				},
				"stats": {
					"hp": 572.16,
					"hpperlevel": 87,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 35,
					"armorperlevel": 3.8,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.75,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 69,
					"attackdamageperlevel": 3.75,
					"attackspeedoffset": -0.06,
					"attackspeedperlevel": 2.65
				},
				"spells": [
					{
						"id": "RenektonCleave",
						"name": "Cull the Meek",
						"description": "Renekton swings his blade, dealing moderate physical damage to all targets around him, and heals for a small portion of the damage dealt. If he has more than 50 Fury, his damage and heal are increased.",
						"tooltip": "Renekton swings his blade, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and healing himself for {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> Health for each non-champion hit and {{ f2 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> Health for each champion hit, up to {{ e4 }} Health.<br /><br />He generates <span class=\"colorFF6633\">2.5 Fury</span> for each non-champion hit and <span class=\"colorFF6633\">10 Fury</span> for each champion hit, up to a maximum of <span class=\"colorFF6633\">30 Fury</span>.<br /><br /><span class=\"colorFF6633\">50 Fury Bonus:</span> Damage increased to {{ e6 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span>. Heal increased to {{ e7 }} <span class=\"colorFF8C00\">(+{{ f4 }})</span> per non-champion and {{ f5 }} <span class=\"colorFF8C00\">(+{{ f6 }})</span> per champion, up to {{ e9 }}. No longer generates <span class=\"colorFF6633\">Fury</span>.",
						"leveltip": {
							"label": [
								"Damage",
								"Max Health Gain",
								"Fury Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} / {{ e9 }} -> {{ e4NL }} / {{ e9NL }}",
								"{{ e6 }} -> {{ e6NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								65,
								100,
								135,
								170,
								205
							],
							[
								3,
								4.5,
								6,
								7.5,
								9
							],
							[
								0.04,
								0.04,
								0.04,
								0.04,
								0.04
							],
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								9,
								13.5,
								18,
								22.5,
								27
							],
							[
								0.12,
								0.12,
								0.12,
								0.12,
								0.12
							],
							[
								150,
								225,
								300,
								375,
								450
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/100/135/170/205",
							"3/4.5/6/7.5/9",
							"0.04",
							"50/75/100/125/150",
							"300",
							"100/150/200/250/300",
							"9/13.5/18/22.5/27",
							"0.12",
							"150/225/300/375/450",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "f2"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1.2,
								"key": "a2"
							}
						],
						"costType": "No Cost or 50 Fury",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "RenektonCleave.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost or 50 Fury"
					},
					{
						"id": "RenektonPreExecute",
						"name": "Ruthless Predator",
						"description": "Renekton slashes his target twice, dealing moderate physical damage and stuns them for 0.75 seconds. If Renekton has more than 50 Fury, he slashes his target three times, dealing high physical damage and stuns them for 1.5 seconds.",
						"tooltip": "Renekton's next attack strikes twice, stunning his target for {{ e3 }} seconds and dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage per hit ({{ e5 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> total).<br /><br />Each strike applies on-hit effects and generates <span class=\"colorFF6633\">Fury</span>. Hitting a champion generates an additional <span class=\"colorFF6633\">{{ e7 }} Fury</span>.<br /><br /><span class=\"colorFF6633\">50 Fury Bonus:</span> Renekton attacks three times, stunning his target for {{ e4 }} seconds and dealing a total of {{ e6 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> damage.  No longer generates <span class=\"colorFF6633\">Fury</span>.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} / {{ e6 }} -> {{ e5NL }} / {{ e6NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								5,
								15,
								25,
								35,
								45
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								10,
								30,
								50,
								70,
								90
							],
							[
								15,
								45,
								75,
								105,
								135
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5/15/25/35/45",
							"0.75",
							"0.75",
							"1.5",
							"10/30/50/70/90",
							"15/45/75/105/135",
							"10",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.5,
								"key": "f1"
							},
							{
								"link": "attackdamage",
								"coeff": 2.25,
								"key": "f2"
							}
						],
						"costType": "No Cost or 50 Fury",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "RenektonPreExecute.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost or 50 Fury"
					},
					{
						"id": "RenektonSliceAndDice",
						"name": "Slice and Dice",
						"description": "Renekton dashes, dealing damage to units along the way. Empowered, Renekton deals bonus damage and reduces the Armor of units hit.",
						"tooltip": "<span class=\"colorFF6633\">Slice:</span> Renekton dashes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to enemies he passes through. Hitting an enemy grants the ability to use Dice for {{ e8 }} seconds.<br /><br /><span class=\"colorFF6633\">Dice:</span> Renekton dashes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to enemies he passes through.<br /><br />He generates <span class=\"colorFF6633\">{{ e4 }} Fury</span> for each non-champion hit and <span class=\"colorFF6633\">{{ e5 }} Fury</span> for each champion hit, up to a maximum of <span class=\"colorFF6633\">{{ e0 }} Fury</span>.<br /><br /><span class=\"colorFF6633\">Dice - 50 Fury Bonus:</span> Damage increased to {{ e3 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span>. Enemies hit have {{ e2 }}% reduced Armor for {{ e9 }} seconds. No longer generates <span class=\"colorFF6633\">Fury</span>.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Armor Reduction %",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0.9,
								0.9,
								0.9,
								0.9,
								0.9
							],
							[
								1.35,
								1.35,
								1.35,
								1.35,
								1.35
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								30,
								30,
								30,
								30,
								30
							]
						],
						"effectBurn": [
							null,
							"40/70/100/130/160",
							"15/20/25/30/35",
							"60/105/150/195/240",
							"2",
							"10",
							"0.9",
							"1.35",
							"4",
							"4",
							"30"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.9,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.9,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1.35,
								"key": "f2"
							}
						],
						"costType": "No Cost or 50 Fury",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "RenektonSliceAndDice.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost or 50 Fury"
					},
					{
						"id": "RenektonReignOfTheTyrant",
						"name": "Dominus",
						"description": "Renekton transforms into the Tyrant form, gaining bonus Health and dealing damage to enemies around him. While in this form, Renekton gains Fury periodically.",
						"tooltip": "Renekton surrounds himself with dark energies for {{ e5 }} seconds, gaining {{ e1 }} Health and <span class=\"colorFF6633\">{{ e6 }} Fury</span>. While active, he deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and gains <span class=\"colorFF6633\">{{ e4 }} Fury</span> per second.",
						"leveltip": {
							"label": [
								"Bonus Health",
								"Periodic Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							120,
							120
						],
						"cooldownBurn": "120",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								250,
								500,
								750
							],
							[
								40,
								80,
								120
							],
							[
								7.5,
								7.5,
								7.5
							],
							[
								5,
								5,
								5
							],
							[
								15,
								15,
								15
							],
							[
								20,
								20,
								20
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250/500/750",
							"40/80/120",
							"7.5",
							"5",
							"15",
							"20",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "RenektonReignOfTheTyrant.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Reign of Anger",
					"description": "Renekton gains Fury for every autoattack he makes. This Fury can empower his abilities with bonus effects. Additionally, Renekton gains bonus Fury when he is low on life.",
					"image": {
						"full": "Renekton_Passive.png",
						"sprite": "passive2.png",
						"group": "passive",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Renekton",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Renekton",
						"title": "RenektonTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Rengar": {
				"id": "Rengar",
				"key": "107",
				"name": "Rengar",
				"title": "the Pridestalker",
				"image": {
					"full": "Rengar.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "107000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "107001",
						"num": 1,
						"name": "Headhunter Rengar",
						"chromas": true
					},
					{
						"id": "107002",
						"num": 2,
						"name": "Night Hunter Rengar",
						"chromas": false
					},
					{
						"id": "107003",
						"num": 3,
						"name": "SSW Rengar",
						"chromas": false
					},
					{
						"id": "107008",
						"num": 8,
						"name": "Mecha Rengar",
						"chromas": true
					}
				],
				"lore": "Rengar is a ferocious vastayan trophy hunter who lives for the thrill of tracking down and killing dangerous creatures. He scours the world for the most fearsome beasts he can find, especially seeking any trace of Kha'Zix, the void creature who scratched out his eye. Rengar stalks his prey neither for food nor glory, but for the sheer beauty of the pursuit.",
				"blurb": "Rengar is a ferocious vastayan trophy hunter who lives for the thrill of tracking down and killing dangerous creatures. He scours the world for the most fearsome beasts he can find, especially seeking any trace of Kha'Zix, the void creature who...",
				"allytips": [
					"Use Rengar's ultimate to find and assassinate high priority targets in team fights and skirmishes.",
					"A lot of Rengar's power comes from empowered abilities he uses at the right moment - choose wisely!",
					"Make sure to take paths through brush when chasing opponents to take advantage of Rengar's passive."
				],
				"enemytips": [
					"Rengar gains an empowered ability when his resource bar is full. Try to confront him when it's low.",
					"Rengar's passive enables him to leap out of brush, so avoid fighting him when near bushes.",
					"Rengar puts an indicator over the nearest enemy champion when he is camouflaged during his ultimate."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Ferocity",
				"info": {
					"attack": 7,
					"defense": 4,
					"magic": 2,
					"difficulty": 8
				},
				"stats": {
					"hp": 585,
					"hpperlevel": 90,
					"mp": 4,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 34,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7,
					"hpregenperlevel": 0.5,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "RengarQ",
						"name": "Savagery",
						"description": "Rengar slashes all enemies in an arc before piercing all enemies in a line. Casting this outside the max range moves Rengar a short distance in that direction.<br><br>Ferocity effect: deals increased damage.",
						"tooltip": "Rengar gains {{ e5 }}% Attack Speed for his next 2 attacks. The first attack deals {{ e1 }} <span class=\"colorF88017\">(+{{ f2 }})</span> physical damage.<br /><br /><span class=\"colorEDDA74\">Ferocity effect:</span><br />Savagery's damage is increased to <span class=\"colorFFFFFF\">{{ f3 }}</span> <span class=\"colorFF8C00\">(+{{ a2 }})</span> and grants Rengar <span class=\"colorFFFFFF\">{{ f4 }}</span>% Attack Speed for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						"cooldownBurn": "0.25",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								50,
								80,
								110,
								140
							],
							[
								110,
								110,
								110,
								110,
								110
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.2,
								0.3,
								0.4,
								0.5,
								0.6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/50/80/110/140",
							"110",
							"5",
							"5",
							"40",
							"3",
							"0.2/0.3/0.4/0.5/0.6",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.3,
								"key": "a2"
							}
						],
						"costType": "Generates 1 Ferocity",
						"maxammo": "1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "RengarQ.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "Generates 1 Ferocity"
					},
					{
						"id": "RengarW",
						"name": "Battle Roar",
						"description": "Rengar lets out a battle roar, damaging enemies and healing for some of the recent damage he has taken.<br><br>Ferocity effect: additionally breaks crowd control effects.",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and heals Rengar for {{ e2 }}% of the damage he took in the last {{ e3 }} seconds.<br /><br /><span class=\"colorEDDA74\">Ferocity effect: </span><br />Deals <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and removes existing crowd control effects, in addition to its normal effect.<br /><br /><rules><span class=\"color8c8c8c\">Damage healed from monster attacks is increased by {{ e5 }}%.</span></rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						"cooldownBurn": "0.25",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								50,
								80,
								110,
								140,
								170
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/80/110/140/170",
							"50",
							"1.5",
							"1.5",
							"50",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": "Generates 1 Ferocity",
						"maxammo": "1",
						"range": [
							450,
							450,
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "RengarW.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "Generates 1 Ferocity"
					},
					{
						"id": "RengarE",
						"name": "Bola Strike",
						"description": "Rengar throws a bola, slowing the first target hit for a short duration.<br><br>Ferocity effect: roots the target.",
						"tooltip": "Throw a bola, dealing {{ e1 }}<span class=\"colorF88017\"> (+{{ a1 }})</span> physical damage and slowing the first enemy hit by {{ e2 }}% for {{ e3 }} seconds.<br /><br /><span class=\"colorEDDA74\">Ferocity effect:</span><br />Deals <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"colorF88017\">(+{{ a1 }})</span> physical damage and roots the target for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Amount"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						"cooldownBurn": "0.25",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								55,
								100,
								145,
								190,
								235
							],
							[
								30,
								45,
								60,
								75,
								90
							],
							[
								1.75,
								1.75,
								1.75,
								1.75,
								1.75
							],
							[
								1.75,
								1.75,
								1.75,
								1.75,
								1.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/100/145/190/235",
							"30/45/60/75/90",
							"1.75",
							"1.75",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": "Generates 1 Ferocity",
						"maxammo": "1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "RengarE.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "Generates 1 Ferocity"
					},
					{
						"id": "RengarR",
						"name": "Thrill of the Hunt",
						"description": "Rengar's predatory instincts take over, <font color='#cd90ee'>Camouflaging</font> him and revealing the nearest enemy champion in a large radius around him. During Thrill of the Hunt, Rengar gains Movement Speed and he can leap to the tracked enemy for a guaranteed critical strike, even without being in brush.",
						"tooltip": "Rengar gains {{ e1 }}% Movement Speed and <span class=\"coloree91d7\">True Sight</span> of the nearest enemy champion within {{ e9 }} range for {{ e2 }} seconds.<br /><br />After the first {{ e6 }} seconds, Rengar becomes <span class=\"colorcd90ee\">Camouflaged</span> and can leap to an enemy without being in brush. Leaping to the nearest champion deals <span class=\"colorF88017\">{{ a1 }}</span> bonus physical damage and reduces their Armor by {{ e8 }} for {{ e7 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Enemy champions within {{ e3 }} range and their nearby allies can sense Rengar during Thrill of the Hunt.<br />Enemies revealed by Thrill of the Hunt stay revealed for the spell's duration.<br />Attacking or casting most spells ends Thrill of the Hunt.</span><br /><span class=\"colorcd90ee\"><u>Stealth - Camouflaged:</u></span><span class=\"color8c8c8c\"> This character is hidden from view. It is revealed by nearby enemy champions and turrets.</span></rules>",
						"leveltip": {
							"label": [
								"Armor Shred",
								"Duration",
								"Movement Speed",
								"Tracking Range",
								"Cooldown"
							],
							"effect": [
								"{{ e8 }} -> {{ e8NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e9 }} -> {{ e9NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							100,
							70
						],
						"cooldownBurn": "130/100/70",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								40,
								50,
								60
							],
							[
								12,
								16,
								20
							],
							[
								1600,
								1600,
								1600
							],
							[
								750,
								750,
								750
							],
							[
								725,
								725,
								725
							],
							[
								2,
								2,
								2
							],
							[
								4,
								4,
								4
							],
							[
								12,
								18,
								24
							],
							[
								2500,
								3000,
								3500
							],
							[
								50,
								100,
								150
							]
						],
						"effectBurn": [
							null,
							"40/50/60",
							"12/16/20",
							"1600",
							"750",
							"725",
							"2",
							"4",
							"12/18/24",
							"2500/3000/3500",
							"50/100/150"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1600,
							1600,
							1600
						],
						"rangeBurn": "1600",
						"image": {
							"full": "RengarR.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Unseen Predator",
					"description": "While in brush, Rengar leaps at his target with his basic attack.<br><br><font color='#EDDA74'>Rengar's abilities build Ferocity. Upon reaching full Ferocity, his next ability becomes empowered and grants him Movement Speed on cast, but he instantly loses all Ferocity if he leaves combat.<br><br>Killing enemy champions awards trophies on Rengar's Bonetooth Necklace, permanently increasing his Attack Damage.</font>",
					"image": {
						"full": "Rengar_P.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Rengar",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rengar",
						"title": "RengarTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Riven": {
				"id": "Riven",
				"key": "92",
				"name": "Riven",
				"title": "the Exile",
				"image": {
					"full": "Riven.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "92000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "92001",
						"num": 1,
						"name": "Redeemed Riven",
						"chromas": false
					},
					{
						"id": "92002",
						"num": 2,
						"name": "Crimson Elite Riven",
						"chromas": false
					},
					{
						"id": "92003",
						"num": 3,
						"name": "Battle Bunny Riven",
						"chromas": true
					},
					{
						"id": "92004",
						"num": 4,
						"name": "Championship Riven",
						"chromas": false
					},
					{
						"id": "92005",
						"num": 5,
						"name": "Dragonblade Riven",
						"chromas": true
					},
					{
						"id": "92006",
						"num": 6,
						"name": "Arcade Riven",
						"chromas": false
					},
					{
						"id": "92007",
						"num": 7,
						"name": "Championship Riven 2016",
						"chromas": false
					},
					{
						"id": "92016",
						"num": 16,
						"name": "Dawnbringer Riven",
						"chromas": false
					}
				],
				"lore": "Once a leader in the warhosts of Noxus, Riven is an expatriate in a land she previously tried to conquer. She rose through the ranks on the strength of her conviction and her brutal efficiency, and was rewarded with a legendary runic blade—however, on the Ionian front, Riven's faith in her homeland was tested and ultimately broken. Having severed all ties to the empire, she now wanders with her shattered sword, seeking atonement for a past she cannot forgive.",
				"blurb": "Once a leader in the warhosts of Noxus, Riven is an expatriate in a land she previously tried to conquer. She rose through the ranks on the strength of her conviction and her brutal efficiency, and was rewarded with a legendary runic blade—however, on...",
				"allytips": [
					"Riven's Broken Wings locks onto the champion your cursor is over at the time of cast. If you want to move past your opponent, make sure that your cursor is past your opponent as well.",
					"Riven lacks a source of healing or strong defense and must compensate with burst combos. Lead into fights with Broken Wings and Ki Burst, while using Valor to escape and absorb counter-harass."
				],
				"enemytips": [
					"Riven has a great deal of mobility but she cannot move very far with any one skill. Rooting or silencing her during her combo will greatly reduce her effectiveness.",
					"All of Riven's damage is physical, prioritize high Armor if an opposing Riven gets out of control.",
					"Riven excels at dueling multiple melee attackers at once, as she will be on an almost equal footing damage-wise. If pairing up against Riven, don't go in as double melee until she has expended her full combo."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "None",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 1,
					"difficulty": 8
				},
				"stats": {
					"hp": 558.48,
					"hpperlevel": 86,
					"mp": 0,
					"mpperlevel": 0,
					"movespeed": 340,
					"armor": 33,
					"armorperlevel": 3.2,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 5.5,
					"hpregenperlevel": 0.5,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "RivenTriCleave",
						"name": "Broken Wings",
						"description": "Riven lashes out in a series of strikes. This ability can be reactivated three times in a short time frame with the third hit knocking back nearby enemies.",
						"tooltip": "Riven strikes out in front of her in a short line. This ability may be re-cast {{ e4 }} additional times.<br /><br /><span class=\"colorDDDD77\">1st and 2nd Use:</span> Slashes forward, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to all units she comes in contact with.<br /><span class=\"colorDDDD77\">3rd Use:</span> Leaps forward and slams the ground dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and knocking nearby enemies up. This leap can cross unpathable terrain.<br /><br /><span class=\"colorDDDD77\">Riven will target the unit your cursor is hovering over, or if no targets are present, Riven will simply strike the direction she is currently facing.</span>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Attack Damage Scaling"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							13,
							13,
							13,
							13
						],
						"cooldownBurn": "13",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								15,
								35,
								55,
								75,
								95
							],
							[
								30,
								55,
								80,
								105,
								130
							],
							[
								150,
								225,
								300,
								375,
								450
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								45,
								50,
								55,
								60,
								65
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/35/55/75/95",
							"30/55/80/105/130",
							"150/225/300/375/450",
							"2",
							"45/50/55/60/65",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.4,
									0.45,
									0.5,
									0.55,
									0.6
								],
								"key": "f1"
							},
							{
								"link": "attackdamage",
								"coeff": [
									0.4,
									0.45,
									0.5,
									0.55,
									0.6
								],
								"key": "f1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							275,
							275,
							275,
							275,
							275
						],
						"rangeBurn": "275",
						"image": {
							"full": "RivenTriCleave.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "RivenMartyr",
						"name": "Ki Burst",
						"description": "Riven emits a Ki Burst, damaging and stunning nearby enemies.",
						"tooltip": "Riven's sword emits a burst of runic energy that shocks nearby enemies, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and stunning them for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							10,
							9,
							8,
							7
						],
						"cooldownBurn": "11/10/9/8/7",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								55,
								85,
								115,
								145,
								175
							],
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/85/115/145/175",
							"40/70/100/130/160",
							"3",
							"0.75",
							"0.75",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "f1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							260,
							260,
							260,
							260,
							260
						],
						"rangeBurn": "260",
						"image": {
							"full": "RivenMartyr.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "RivenFeint",
						"name": "Valor",
						"description": "Riven steps forward a short distance and blocks incoming damage.",
						"tooltip": "Riven does a quick dash in the direction of your cursor and becomes shielded, blocking up to {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> incoming damage for 1.5 seconds.",
						"leveltip": {
							"label": [
								"Damage Blocked",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								95,
								125,
								155,
								185,
								215
							],
							[
								95,
								125,
								155,
								185,
								215
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"95/125/155/185/215",
							"95/125/155/185/215",
							"4",
							"800",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "f1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							250,
							250,
							250,
							250,
							250
						],
						"rangeBurn": "250",
						"image": {
							"full": "RivenFeint.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "RivenFengShuiEngine",
						"name": "Blade of the Exile",
						"description": "Riven empowers her keepsake weapon with energy, and gains Attack Damage and Range. During this time, she also gains the ability to use Wind Slash, a powerful ranged attack, once. ",
						"tooltip": "Riven's weapon surges with spiritual energy for {{ e4 }} seconds, granting her {{ e5 }}% extra Attack Damage (<span class=\"colorFF8C00\">+{{ f3 }}</span>), increased Range on her damaging spells and attacks, and the ability to use Wind Slash once.<br /><br /><span class=\"colorDDDD77\">Wind Slash:</span> Riven fires a shockwave that deals from {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> to {{ e2 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage to all enemies hit, increasing based on how much Health they are missing.",
						"leveltip": {
							"label": [
								"Shockwave Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} / {{ e2 }} -> {{ e1NL }} / {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							95,
							60
						],
						"cooldownBurn": "130/95/60",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								100,
								150,
								200
							],
							[
								300,
								450,
								600
							],
							[
								20,
								20,
								20
							],
							[
								15,
								15,
								15
							],
							[
								20,
								20,
								20
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/150/200",
							"300/450/600",
							"20",
							"15",
							"20",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.2,
								"key": "f3"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1.8,
								"key": "f2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							200,
							200,
							200
						],
						"rangeBurn": "200",
						"image": {
							"full": "RivenFengShuiEngine.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Runic Blade",
					"description": "Riven's abilities charge her blade, causing her basic attacks to deal bonus physical damage. Riven's blade may be charged up to three times and expends one charge per attack.",
					"image": {
						"full": "RivenRunicBlades.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Riven",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Riven",
						"title": "RivenTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Rumble": {
				"id": "Rumble",
				"key": "68",
				"name": "Rumble",
				"title": "the Mechanized Menace",
				"image": {
					"full": "Rumble.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "68000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "68001",
						"num": 1,
						"name": "Rumble in the Jungle",
						"chromas": false
					},
					{
						"id": "68002",
						"num": 2,
						"name": "Bilgerat Rumble",
						"chromas": false
					},
					{
						"id": "68003",
						"num": 3,
						"name": "Super Galaxy Rumble",
						"chromas": false
					}
				],
				"lore": "Rumble is a young inventor with a temper. Using nothing more than his own two hands and a heap of scrap, the feisty yordle constructed a colossal mech suit outfitted with an arsenal of electrified harpoons and incendiary rockets. Though others may scoff and sneer at his junkyard creations, Rumble doesn't mind—after all, he's the one with the flamespitter.",
				"blurb": "Rumble is a young inventor with a temper. Using nothing more than his own two hands and a heap of scrap, the feisty yordle constructed a colossal mech suit outfitted with an arsenal of electrified harpoons and incendiary rockets. Though others may scoff...",
				"allytips": [
					"Try and pace yourself to stay in the Danger Zone to maximize your effectiveness. It is easy to overheat if you rapidly use your abilities.",
					"Try and keep targets in the range of your Flamespitter. It can deal a lot of damage overtime.",
					"If you are winning a fight you can use your ultimate to wall off an escape path."
				],
				"enemytips": [
					"Watch Rumble's Heat bar carefully. If you see him Overheat, go in for the kill while his skills are disabled.",
					"Rumble's ultimate can deal a lot of damage if you stay inside the area of effect. When you see the missiles falling, move out of the way as quickly as possible.",
					"Rumble deals almost entirely magic damage. Build some Magic Resistance to reduce his damage."
				],
				"tags": [
					"Fighter",
					"Mage"
				],
				"partype": "Heat",
				"info": {
					"attack": 3,
					"defense": 6,
					"magic": 8,
					"difficulty": 10
				},
				"stats": {
					"hp": 589,
					"hpperlevel": 85,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 30.88,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.6,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 61.036,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.03,
					"attackspeedperlevel": 1.85
				},
				"spells": [
					{
						"id": "RumbleFlameThrower",
						"name": "Flamespitter",
						"description": "Rumble torches opponents in front of him, dealing magic damage in a cone for 3 seconds. While in Danger Zone this damage is increased. ",
						"tooltip": "Rumble torches his opponents, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage in a cone over {{ e9 }} seconds. This spell deals {{ e4 }}% damage to minions.<br /><br /><caution>Danger Zone Bonus:</caution> Deals {{ e5 }}% damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								135,
								180,
								225,
								270,
								315
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"135/180/225/270/315",
							"20",
							"0",
							"75",
							"150",
							"12",
							"0.25",
							"3",
							"3",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1.1,
								"key": "a1"
							}
						],
						"costType": " Heat",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "RumbleFlameThrower.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e2 }} Heat"
					},
					{
						"id": "RumbleShield",
						"name": "Scrap Shield",
						"description": "Rumble pulls up a shield, protecting him from damage and granting him a quick burst of speed. While in Danger Zone, the shield strength and speed bonus is increased. ",
						"tooltip": "Rumble tosses up a shield for {{ e5 }} seconds that absorbs {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> damage. Rumble also gains an additional {{ e2 }}% Movement Speed for {{ e6 }} second. </span><br /><br /><caution>Danger Zone Bonus:</caution> 50% increase in shield health and Movement Speed.",
						"leveltip": {
							"label": [
								"Damage Absorption",
								"Movement Speed Bonus"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/110/140/170/200",
							"10/15/20/25/30",
							"20",
							"0",
							"1.5",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Heat",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "RumbleShield.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e3 }} Heat"
					},
					{
						"id": "RumbleGrenade",
						"name": "Electro Harpoon",
						"description": "Rumble launches a taser, electrocuting his target with magic damage and slowing their Movement Speed. Rumble can carry 2 harpoons at a time. While in Danger Zone the damage and slow percentage is increased.  ",
						"tooltip": "Rumble shoots his opponent with up to 2 tasers, dealing {{ e1 }}<scaleAP> (+{{ a1 }})</scaleAP> magic damage and applying a stacking slow of {{ e2 }}% for {{ e7 }} seconds.<br /><br /><caution>Danger Zone Bonus:</caution> Damage and slow percentage increased by 50%.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Amount"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						"cooldownBurn": "0.5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								60,
								85,
								110,
								135,
								160
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/85/110/135/160",
							"15/20/25/30/35",
							"10",
							"0",
							"0",
							"0",
							"2",
							"30/40/50/60/70",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Heat",
						"maxammo": "2",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "RumbleGrenade.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e3 }} Heat"
					},
					{
						"id": "RumbleCarpetBomb",
						"name": "The Equalizer",
						"description": "Rumble fires off a group of rockets, creating a wall of flames that damages and slows enemies. ",
						"tooltip": "Rumble launches a line of rockets that creates a burning trail for {{ e5 }} seconds. Enemies in the area have their Movement Speed slowed by {{ e3 }}% and take {{ e1 }}<scaleAP> (+{{ a2 }})</scaleAP> magic damage each second.<br /><br /><specialRules>You can control the placement of this attack by clicking and dragging your mouse in a line.</specialRules>",
						"leveltip": {
							"label": [
								"Damage Per Second",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							100,
							90
						],
						"cooldownBurn": "110/100/90",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								130,
								185,
								240
							],
							[
								0,
								0,
								0
							],
							[
								35,
								35,
								35
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								5,
								5,
								5
							],
							[
								6,
								6,
								6
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"130/185/240",
							"0",
							"35",
							"0.5",
							"5",
							"6",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1750,
							1750,
							1750
						],
						"rangeBurn": "1750",
						"image": {
							"full": "RumbleCarpetBomb.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Junkyard Titan",
					"description": "Every spell Rumble casts gives him Heat. When he reaches 50% Heat he reaches Danger Zone, granting all his basic abilities bonus effects. When he reaches 100% Heat, he starts Overheating, granting his basic attacks bonus damage, but making him unable to cast spells for a few seconds. ",
					"image": {
						"full": "Rumble_Junkyard Titan1.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Rumble",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Rumble",
						"title": "RumbleTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Ryze": {
				"id": "Ryze",
				"key": "13",
				"name": "Ryze",
				"title": "the Rune Mage",
				"image": {
					"full": "Ryze.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "13000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "13001",
						"num": 1,
						"name": "Young Ryze",
						"chromas": false
					},
					{
						"id": "13002",
						"num": 2,
						"name": "Tribal Ryze",
						"chromas": false
					},
					{
						"id": "13003",
						"num": 3,
						"name": "Uncle Ryze",
						"chromas": false
					},
					{
						"id": "13004",
						"num": 4,
						"name": "Triumphant Ryze",
						"chromas": false
					},
					{
						"id": "13005",
						"num": 5,
						"name": "Professor Ryze",
						"chromas": false
					},
					{
						"id": "13006",
						"num": 6,
						"name": "Zombie Ryze",
						"chromas": false
					},
					{
						"id": "13007",
						"num": 7,
						"name": "Dark Crystal Ryze",
						"chromas": false
					},
					{
						"id": "13008",
						"num": 8,
						"name": "Pirate Ryze",
						"chromas": false
					},
					{
						"id": "13009",
						"num": 9,
						"name": "Ryze Whitebeard",
						"chromas": false
					},
					{
						"id": "13010",
						"num": 10,
						"name": "SKT T1 Ryze",
						"chromas": false
					}
				],
				"lore": "Widely considered one of the most adept sorcerers on Runeterra, Ryze is an ancient, hard-bitten archmage with an impossibly heavy burden to bear. Armed with immense arcane power and a boundless constitution, he tirelessly hunts for World Runes—fragments of the raw magic that once shaped the world from nothingness. He must retrieve these artifacts before they fall into the wrong hands, for Ryze understands the horrors they could unleash on Runeterra.",
				"blurb": "Widely considered one of the most adept sorcerers on Runeterra, Ryze is an ancient, hard-bitten archmage with an impossibly heavy burden to bear. Armed with immense arcane power and a boundless constitution, he tirelessly hunts for World Runes—fragments...",
				"allytips": [
					"Use Overload's passive to optimize for maximum damage or maximum survivability.",
					"Spell Flux's short cooldown allows it to be used to spread Flux to many enemies.",
					"Ryze can move and cast other spells while Realm Warp is charging without cancelling the portal."
				],
				"enemytips": [
					"Ryze is especially dangerous to opponents that are marked with Flux.",
					"Use Realm Warp's windup time to figure out how to deal with what may be coming out of the portal.",
					"Crowd controlling Ryze during Realm Warp's windup will cancel the portal."
				],
				"tags": [
					"Mage",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 2,
					"magic": 10,
					"difficulty": 7
				},
				"stats": {
					"hp": 570.48,
					"hpperlevel": 98,
					"mp": 400,
					"mpperlevel": 50,
					"movespeed": 340,
					"armor": 21.552,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.112
				},
				"spells": [
					{
						"id": "RyzeQWrapper",
						"name": "Overload",
						"description": "Passively, Ryze's other damaging spells reset Overload and begin to charge a Rune that can be used to empower Overload.<br><br>On cast, Ryze throws a charge of pure energy in a line, dealing damage to the first enemy struck. If a Rune is fully charged, Ryze also gains a shield and Movement Speed.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Rune Prison and Spell Flux reset Overload's cooldown and charge a <span class=\"colorFFF673\">Rune</span> for {{ e2 }} seconds, up to {{ e9 }} <span class=\"colorFFF673\">Runes</span>.<br /><br /><span class=\"colorFF9900\">Active:</span> Unleash a runic blast, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"color44DDFF\">(+{{ f1 }})</span> magic damage to the first enemy struck. Any active <span class=\"colorFFF673\">Runes</span> are discharged.<br /><br />If {{ e9 }} <span class=\"colorFFF673\">Runes</span> are discharged, they Overload, shielding Ryze from <span class=\"colorFFFFFF\">{{ f3 }}</span> <span class=\"color99FF99\">(+{{ a2 }})</span> <span class=\"color44DDFF\">(+{{ f2 }})</span> damage and increasing his Movement Speed by {{ e4 }}% for {{ e5 }} seconds. ",
						"leveltip": {
							"label": [
								"Base Damage",
								"Movement Speed"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }}% -> {{ e4NL }}%"
							]
						},
						"maxrank": 6,
						"cooldown": [
							6,
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							40,
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								60,
								85,
								110,
								135,
								160,
								185
							],
							[
								4,
								4,
								4,
								4,
								4,
								4
							],
							[
								55,
								55,
								55,
								55,
								55,
								55
							],
							[
								25,
								28,
								31,
								34,
								37,
								40
							],
							[
								2,
								2,
								2,
								2,
								2,
								2
							],
							[
								2,
								2,
								2,
								2,
								2,
								2
							],
							[
								3,
								3,
								3,
								3,
								3,
								3
							],
							[
								3,
								3,
								3,
								3,
								3,
								3
							],
							[
								2,
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/85/110/135/160/185",
							"4",
							"55",
							"25/28/31/34/37/40",
							"2",
							"2",
							"3",
							"3",
							"2",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "RyzeQWrapper.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RyzeW",
						"name": "Rune Prison",
						"description": "Ryze traps a target enemy unit in a cage of runes, damaging them and preventing them from moving.",
						"tooltip": "Instantly root an enemy for {{ e1 }} second and deal {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"color44DDFF\">(+{{ f1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								80,
								100,
								120,
								140,
								160
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0.75",
							"80/100/120/140/160",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							615,
							615,
							615,
							615,
							615
						],
						"rangeBurn": "615",
						"image": {
							"full": "RyzeW.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RyzeE",
						"name": "Spell Flux",
						"description": "Ryze releases an orb of pure magical power that damages an enemy and debuffs them. Ryze's spells have additional effects against the debuffed enemy.",
						"tooltip": "Apply Flux to an enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"color44DDFF\">(+{{ f1 }})</span> magic damage. Spells consume Flux for bonus effects:<br /><br /><span class=\"colorFFF673\">Overload:</span> Deals {{ e2 }}% more damage and spreads to nearby enemies with Flux.<br /><span class=\"colorFFF673\">Rune Prison:</span> Root duration is increased to {{ e6 }} seconds.<br /><span class=\"colorFFF673\">Spell Flux:</span> Spreads Spell Flux to nearby enemies.<br /><br /><i>Spells that kill enemies affected by Flux spread Spell Flux to nearby enemies.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Overload Damage Increase",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							3.25,
							3,
							2.75,
							2.5,
							2.25
						],
						"cooldownBurn": "3.25/3/2.75/2.5/2.25",
						"cost": [
							40,
							55,
							70,
							85,
							100
						],
						"costBurn": "40/55/70/85/100",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								40,
								50,
								60,
								70,
								80
							],
							[
								167,
								167,
								167,
								167,
								167
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"40/50/60/70/80",
							"167",
							"0.1",
							"1.5",
							"2",
							"4",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							615,
							615,
							615,
							615,
							615
						],
						"rangeBurn": "615",
						"image": {
							"full": "RyzeE.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "RyzeR",
						"name": "Realm Warp",
						"description": "Ryze creates a portal to a nearby location. After a few seconds, allies standing near the portal are teleported to the target location.",
						"tooltip": "Ryze opens a portal to a location up to {{ e7 }} range away. After {{ e4 }} seconds, all allies near the portal are teleported to that location.<br /><br /><i>If Ryze becomes unable to cast or move, Realm Warp is cancelled.</i>",
						"leveltip": {
							"label": [
								"Range"
							],
							"effect": [
								"{{ e7 }} -> {{ e7NL }}"
							]
						},
						"maxrank": 2,
						"cooldown": [
							120,
							120
						],
						"cooldownBurn": "120",
						"cost": [
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								2.1,
								2.1
							],
							[
								0.65,
								0.65
							],
							[
								0.75,
								0.75
							],
							[
								2,
								2
							],
							[
								150,
								250
							],
							[
								6,
								6
							],
							[
								1750,
								3000
							],
							[
								0,
								0
							],
							[
								0,
								0
							],
							[
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2.1",
							"0.65",
							"0.75",
							"2",
							"150/250",
							"6",
							"1750/3000",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1750,
							3000
						],
						"rangeBurn": "1750/3000",
						"image": {
							"full": "RyzeR.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Arcane Mastery",
					"description": "<mainText>Ryze's spells deal extra damage based on his Bonus Mana, and he gains a percentage increase to his maximum Mana based on his Ability Power.</mainText>",
					"image": {
						"full": "Ryze_P.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ryze",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeBT",
						"map": "SR",
						"mode": "TUTORIAL",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ryze",
						"title": "RyzeTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Sejuani": {
				"id": "Sejuani",
				"key": "113",
				"name": "Sejuani",
				"title": "Fury of the North",
				"image": {
					"full": "Sejuani.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "113000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "113001",
						"num": 1,
						"name": "Sabretusk Sejuani",
						"chromas": false
					},
					{
						"id": "113002",
						"num": 2,
						"name": "Darkrider Sejuani",
						"chromas": false
					},
					{
						"id": "113003",
						"num": 3,
						"name": "Traditional Sejuani",
						"chromas": false
					},
					{
						"id": "113004",
						"num": 4,
						"name": "Bear Cavalry Sejuani",
						"chromas": false
					},
					{
						"id": "113005",
						"num": 5,
						"name": "Poro Rider Sejuani",
						"chromas": false
					},
					{
						"id": "113006",
						"num": 6,
						"name": "Beast Hunter Sejuani",
						"chromas": false
					},
					{
						"id": "113007",
						"num": 7,
						"name": "Sejuani Dawnchaser",
						"chromas": false
					}
				],
				"lore": "Sejuani is the brutal, unforgiving Iceborn warmother of the Winter's Claw, one of the most feared tribes of the Freljord. Her people's survival is a constant, desperate battle against the elements, forcing them to raid Noxians, Demacians, and Avarosans alike to survive the harsh winters. Sejuani herself spearheads the most dangerous of these attacks from the saddle of her drüvask boar Bristle, using her True Ice flail to freeze and shatter her enemies.",
				"blurb": "Sejuani is the brutal, unforgiving Iceborn warmother of the Winter's Claw, one of the most feared tribes of the Freljord. Her people's survival is a constant, desperate battle against the elements, forcing them to raid Noxians, Demacians, and Avarosans...",
				"allytips": [
					"Use Arctic Assault to escape bad situations, interupt channeled spells or chase runners.",
					"Melee allies can stack Frost for your Permafrost, keep an eye on who they are attacking.",
					"Save Glacial Prison for encounters where you have teammates present to take advantage of it."
				],
				"enemytips": [
					"Dodging Arctic Assault and Glacial Prison can give you a huge advantage.",
					"Focus on avoiding the second swing of Winter's Wrath which carries the brunt of the damage.",
					"Melee enemies can also stack Frost for Sejuani, be very careful around them."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 7,
					"magic": 6,
					"difficulty": 4
				},
				"stats": {
					"hp": 560,
					"hpperlevel": 95,
					"mp": 400,
					"mpperlevel": 40,
					"movespeed": 340,
					"armor": 31,
					"armorperlevel": 3,
					"spellblock": 27.1,
					"spellblockperlevel": 0.75,
					"attackrange": 150,
					"hpregen": 8.5,
					"hpregenperlevel": 0.85,
					"mpregen": 7,
					"mpregenperlevel": 0.7,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "SejuaniQ",
						"name": "Arctic Assault",
						"description": "Sejuani charges forward, knocking enemies into the air. The charge stops after hitting an enemy champion.",
						"tooltip": "Sejuani charges, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies and knocking them up. The charge ends after hitting an enemy champion.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							15.5,
							14,
							12.5,
							11
						],
						"cooldownBurn": "17/15.5/14/12.5/11",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								625,
								625,
								625,
								625,
								625
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/90/120/150/180",
							"625",
							"1000",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "SejuaniQ.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SejuaniW",
						"name": "Winter's Wrath",
						"description": "Sejuani swings her mace twice, dealing damage and applying Frost stacks.",
						"tooltip": "Sejuani swings her flail, dealing {{ e1 }} <span class=\"colorFF3300\">(+{{ f1 }})</span> physical damage and applying <span class=\"color07F2F1\">Frost</span> to enemies hit and knocking minions and monsters back.<br /><br />She then lashes out with her flail, dealing {{ e3 }} <span class=\"colorFF3300\">(+{{ f2 }})</span> physical damage, applying <span class=\"color07F2F1\">Frost</span> and slowing enemies hit briefly.",
						"leveltip": {
							"label": [
								"First Hit Damage",
								"Second Hit Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								30,
								65,
								100,
								135,
								170
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/25/30/35/40",
							"0.75",
							"30/65/100/135/170",
							"0",
							"75",
							"0.25",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "SejuaniW.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SejuaniE",
						"name": "Permafrost",
						"description": "Sejuani freezes and stuns an enemy champion that has maximum Frost stacks.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Nearby melee allied champions' basic attacks apply <span class=\"color07F2F1\">Frost</span> to enemy champions and large monsters.<br /><br /><span class=\"colorFF9900\">Active:</span> Target enemy with 4 stacks of <span class=\"color07F2F1\">Frost</span> takes {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, is stunned for {{ e1 }} second(s), and is briefly displaced.<br /><br /><span class=\"size16 color8C8C8C\">An enemy stunned by Sejuani cannot gain </span><span class=\"size16 color07F2F1\">Frost</span><span class=\"size16 color8C8C8C\"> for {{ f2 }} seconds.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Stun Duration"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						"cooldownBurn": "1.5",
						"cost": [
							20,
							20,
							20,
							20,
							20
						],
						"costBurn": "20",
						"effect": [
							null,
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								1100,
								1100,
								1100,
								1100,
								1100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1/1.25/1.5/1.75/2",
							"0",
							"20/30/40/50/60",
							"4",
							"5",
							"1100",
							"0",
							"0",
							"250",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "SejuaniE.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SejuaniR",
						"name": "Glacial Prison",
						"description": "Sejuani throws her bola that freezes and stuns the first champion hit and creates an ice storm that slows other enemies.",
						"tooltip": "Sejuani throws her True Ice bola that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy champion hit and stuns them for {{ e2 }} second.<br /><br />The bola becomes more powerful as it travels, dealing {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage, stunning for {{ e6 }} seconds and creating a storm that slows other enemies by {{ e8 }}%. After {{ e3 }} seconds, the storm deals {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and slows by {{ e4 }}% for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Minimum Damage",
								"Maximum Damage",
								"Cooldown"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								125,
								150
							],
							[
								1,
								1,
								1
							],
							[
								2,
								2,
								2
							],
							[
								80,
								80,
								80
							],
							[
								3,
								3,
								3
							],
							[
								2,
								2,
								2
							],
							[
								150,
								250,
								350
							],
							[
								30,
								30,
								30
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/125/150",
							"1",
							"2",
							"80",
							"3",
							"2",
							"150/250/350",
							"30",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1300,
							1300,
							1300
						],
						"rangeBurn": "1300",
						"image": {
							"full": "SejuaniR.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Fury of the North",
					"description": "<mainText>After being out of combat, Sejuani gains Frost Armor which grants Armor and Magic Resist and immunity to slows. Frost Armor persists for a short time after Sejuani takes damage.  Sejuani can damage a stunned enemy to shatter it, dealing massive magic damage.</mainText>",
					"image": {
						"full": "Sejuani_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Sejuani",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sejuani",
						"title": "SejuaniTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Shaco": {
				"id": "Shaco",
				"key": "35",
				"name": "Shaco",
				"title": "the Demon Jester",
				"image": {
					"full": "Shaco.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "35000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "35001",
						"num": 1,
						"name": "Mad Hatter Shaco",
						"chromas": false
					},
					{
						"id": "35002",
						"num": 2,
						"name": "Royal Shaco",
						"chromas": false
					},
					{
						"id": "35003",
						"num": 3,
						"name": "Nutcracko",
						"chromas": false
					},
					{
						"id": "35004",
						"num": 4,
						"name": "Workshop Shaco",
						"chromas": false
					},
					{
						"id": "35005",
						"num": 5,
						"name": "Asylum Shaco",
						"chromas": false
					},
					{
						"id": "35006",
						"num": 6,
						"name": "Masked Shaco",
						"chromas": false
					},
					{
						"id": "35007",
						"num": 7,
						"name": "Wild Card Shaco",
						"chromas": false
					}
				],
				"lore": "Crafted long ago as a plaything for a lonely prince, the enchanted marionette Shaco now delights in murder and mayhem. Corrupted by dark magic and the loss of his beloved charge, the once-kind puppet finds pleasure only in the misery of the poor souls he torments. He uses toys and simple tricks to deadly effect, finding the results of his bloody “games” hilarious—and for those who hear a dark chuckle in the dead of night, the Demon Jester may have marked them as his next plaything.",
				"blurb": "Crafted long ago as a plaything for a lonely prince, the enchanted marionette Shaco now delights in murder and mayhem. Corrupted by dark magic and the loss of his beloved charge, the once-kind puppet finds pleasure only in the misery of the poor souls...",
				"allytips": [
					"Using Deceive over terrain can help you make a clean escape.",
					"Try getting items with on-hit effects. These will also benefit your Hallucination clone.",
					"Backstab's damage can be increased with increased Critical Damage effects like Infinity Edge."
				],
				"enemytips": [
					"If Shaco is doing well early-game, it is worth the investment to place Stealth Wards near his Jungle camps.",
					"If Shaco uses Deceive to enter a fight he won't be able to quickly use it again to get away. Work with your team to quickly focus him down."
				],
				"tags": [
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 4,
					"magic": 6,
					"difficulty": 9
				},
				"stats": {
					"hp": 587,
					"hpperlevel": 89,
					"mp": 297.2,
					"mpperlevel": 40,
					"movespeed": 350,
					"armor": 30,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.55,
					"mpregen": 7.156,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": -0.1,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "Deceive",
						"name": "Deceive",
						"description": "Shaco becomes Invisible and teleports to target location.",
						"tooltip": "Shaco teleports nearby and becomes <span class=\"color91d7ee\">Invisible</span> for {{ e3 }} seconds. Shaco remains <span class=\"color91d7ee\">Invisible</span> even if he uses Jack in the Box or Hallucinate. <br /><br />His next basic attack during or shortly after <span class=\"color91d7ee\">Invisibility</span> will reduce Deceive's cooldown by {{ f3 }} seconds. <br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Shaco can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
						"leveltip": {
							"label": [
								"Stealth Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15.5,
							15,
							14.5,
							14
						],
						"cooldownBurn": "16/15.5/15/14.5/14",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								1.5,
								2.25,
								3,
								3.75,
								4.5
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"200",
							"1.5/2.25/3/3.75/4.5",
							"6",
							"400",
							"2.5",
							"0",
							"2.5",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "Deceive.png",
							"sprite": "spell9.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "JackInTheBox",
						"name": "Jack In The Box",
						"description": "Shaco creates a hidden animated Jack-in-the-Box. When triggered, it will fear and attack nearby enemies.",
						"tooltip": "Shaco creates a Jack in the Box that hides from view after {{ e5 }} seconds. It pops out when an enemy comes near or when uncovered by a ward or trinket, making nearby enemies flee very slowly for {{ e3 }} seconds.<br /><br />Its attacks deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage. It lasts for {{ e4 }} <scaleAP>(+{{ a2 }})</scaleAP> seconds while hidden or 5 seconds while firing. ",
						"leveltip": {
							"label": [
								"Damage",
								"Fear Duration",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							16,
							16,
							16,
							16
						],
						"cooldownBurn": "16",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								35,
								50,
								65,
								80,
								95
							],
							[
								200,
								300,
								400,
								500,
								600
							],
							[
								0.5,
								0.75,
								1,
								1.25,
								1.5
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/50/65/80/95",
							"200/300/400/500/600",
							"0.5/0.75/1/1.25/1.5",
							"60",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.05,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "JackInTheBox.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TwoShivPoison",
						"name": "Two-Shiv Poison",
						"description": "Shaco's Shivs passively poison targets on hit, slowing their movement speed. He can throw his Shivs to deal damage and poison the target. The thrown Shiv deals bonus damage based on the target's missing Health.",
						"tooltip": "<spellPassive>Passive:</spellPassive> While Two-Shiv Poison is ready to cast, Shaco's basic attacks reduce the target's movement speed by {{ e4 }}% for {{ e5 }} seconds.<br /><br /><spellActive>Active:</spellActive> Shaco throws a shiv that deals {{ e1 }} <scaleAD>(+{{ f1 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> physical damage and reduces the target's movement speed by {{ e4 }}% for {{ e6 }} seconds. The shiv's damage is increased by up to {{ e3 }}% based on the target's missing health.",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus AD Ratio",
								"Slow",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								55,
								80,
								105,
								130,
								155
							],
							[
								60,
								75,
								90,
								105,
								120
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								20,
								22.5,
								25,
								27.5,
								30
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/80/105/130/155",
							"60/75/90/105/120",
							"50",
							"20/22.5/25/27.5/30",
							"2",
							"3",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "TwoShivPoison.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "HallucinateFull",
						"name": "Hallucinate",
						"description": "Shaco creates an illusion of himself near him, which can attack nearby enemies (Deals reduced damage to turrets).  Upon death, it explodes, spawning three mini Jack in the Boxes and dealing damage to nearby enemies. ",
						"tooltip": "Shaco vanishes briefly and reappears with a clone. The clone lasts up to 18 seconds and detonates when it dies, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to nearby enemies and spawning three mini Jack in the Boxes. <br /><br /><li>Mini boxes deal {{ e6 }} <scaleAP>(+{{ a2 }})</scaleAP> damage, make enemies flee for {{ e7 }} second(s), and trigger together. <br /><br />Clone deals {{ e8 }}% of Shaco's damage and receives {{ e2 }}% increased damage.</li><br /><scaleAP>The clone can be controlled by holding the alt key and using the right mouse button or by reactivating this ability.</scaleAP>",
						"leveltip": {
							"label": [
								"On Death Damage",
								"Mini Box Damage",
								"Mini Box Flee Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								200,
								300,
								400
							],
							[
								50,
								50,
								50
							],
							[
								15,
								15,
								15
							],
							[
								2,
								2,
								2
							],
							[
								6,
								6,
								6
							],
							[
								25,
								50,
								75
							],
							[
								0.75,
								1,
								1.25
							],
							[
								75,
								75,
								75
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/300/400",
							"50",
							"15",
							"2",
							"6",
							"25/50/75",
							"0.75/1/1.25",
							"75",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "HallucinateFull.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Backstab",
					"description": "Shaco's basic attack critically strikes for extra damage when striking a unit from behind. Units can't be Backstabbed more than once every few seconds, modified by Shaco's cooldown reduction.",
					"image": {
						"full": "Jester_CarefulStrikes.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Shaco",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2015",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "selective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shaco",
						"title": "ShacoTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1036",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Shen": {
				"id": "Shen",
				"key": "98",
				"name": "Shen",
				"title": "the Eye of Twilight",
				"image": {
					"full": "Shen.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "98000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "98001",
						"num": 1,
						"name": "Frozen Shen",
						"chromas": false
					},
					{
						"id": "98002",
						"num": 2,
						"name": "Yellow Jacket Shen",
						"chromas": false
					},
					{
						"id": "98003",
						"num": 3,
						"name": "Surgeon Shen",
						"chromas": false
					},
					{
						"id": "98004",
						"num": 4,
						"name": "Blood Moon Shen",
						"chromas": false
					},
					{
						"id": "98005",
						"num": 5,
						"name": "Warlord Shen",
						"chromas": true
					},
					{
						"id": "98006",
						"num": 6,
						"name": "TPA Shen",
						"chromas": false
					}
				],
				"lore": "Among the secretive, Ionian warriors known as the Kinkou, Shen serves as their leader, the Eye of Twilight. He longs to remain free from the confusion of emotion, prejudice, and ego, and walks the unseen path of dispassionate judgment between the spirit realm and the physical world. Tasked with enforcing the equilibrium between them, Shen wields blades of steel and arcane energy against any who would threaten it.",
				"blurb": "Among the secretive, Ionian warriors known as the Kinkou, Shen serves as their leader, the Eye of Twilight. He longs to remain free from the confusion of emotion, prejudice, and ego, and walks the unseen path of dispassionate judgment between the spirit...",
				"allytips": [
					"Keep an eye on allies and be ready to save them with your teleport.",
					"Leverage your Energy to get a long-term advantage over Mana users."
				],
				"enemytips": [
					"Be ready to dodge Shen's taunt and punish him if he misses.",
					"Once Shen reaches level 6, watch out for his global-range ultimate, which can turn fights quickly."
				],
				"tags": [
					"Tank"
				],
				"partype": "Energy",
				"info": {
					"attack": 3,
					"defense": 9,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 540,
					"hpperlevel": 85,
					"mp": 400,
					"mpperlevel": 0,
					"movespeed": 340,
					"armor": 34,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.75,
					"mpregen": 50,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 60,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "ShenQ",
						"name": "Twilight Assault",
						"description": "Shen recalls his spirit blade to attack with it, dealing damage based on the target's max health. The attacks are greatly empowered if it collides with an enemy champion, and all collided enemies are slowed while running away from Shen.",
						"tooltip": "Shen recalls his <span class=\"colorBB77FF\">spirit blade</span> and draws it. Enemies it collides with are slowed by {{ e4 }}% when moving away from Shen for the next {{ e5 }} seconds.<br /><br />Shen's next {{ e3 }} attacks deal <scaleLevel>{{ f1 }}</scaleLevel> plus {{ e2 }} <span class=\"color99FF99\">(+{{ charabilitypower*.01 }})</span>% of their target's max health as bonus magic damage. If the <span class=\"colorBB77FF\">spirit blade</span> collided with an enemy champion, those attacks deal <scaleLevel>{{ f2 }}</scaleLevel> plus {{ e6 }} <span class=\"color99FF99\">(+{{ charabilitypower2*.01 }})</span>% instead and have +{{ e9 }}% Attack Speed.<br /><br /><rules>Each attack deals {{ e1 }}% increased damage to monsters (capped at {{ e7 }}).</rules>",
						"leveltip": {
							"label": [
								"Base Percent Damage",
								"Enhanced Percent Damage",
								"Energy Cost",
								"Monster Damage Cap",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e6 }}% -> {{ e6NL }}%",
								"{{ cost }} -> {{ costNL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7.25,
							6.5,
							5.75,
							5
						],
						"cooldownBurn": "8/7.25/6.5/5.75/5",
						"cost": [
							140,
							130,
							120,
							110,
							100
						],
						"costBurn": "140/130/120/110/100",
						"effect": [
							null,
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								2,
								2.5,
								3,
								3.5,
								4
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								4,
								4.5,
								5,
								5.5,
								6
							],
							[
								75,
								100,
								125,
								150,
								175
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								75,
								75,
								75,
								75,
								75
							]
						],
						"effectBurn": [
							null,
							"100",
							"2/2.5/3/3.5/4",
							"3",
							"35",
							"2",
							"4/4.5/5/5.5/6",
							"75/100/125/150/175",
							"8",
							"50",
							"75"
						],
						"vars": [],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "ShenQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "ShenW",
						"name": "Spirit's Refuge",
						"description": "Attacks that would hit Shen or his allies near his spirit blade are blocked.",
						"tooltip": "Shen's <span class=\"colorBB77FF\">spirit blade</span> creates a defensive zone for {{ e1 }} seconds. Basic attacks that would hit Shen or an allied champion in the zone are blocked.<br /><br />If there are no champions to protect in the zone when it starts, the <span class=\"colorBB77FF\">spirit blade</span> will not activate until one enters or {{ e2 }} seconds pass.",
						"leveltip": {
							"label": [
								"Cooldown"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16.5,
							15,
							13.5,
							11
						],
						"cooldownBurn": "18/16.5/15/13.5/11",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								1.75,
								1.75,
								1.75,
								1.75,
								1.75
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.75",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "ShenW.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "ShenE",
						"name": "Shadow Dash",
						"description": "Shen dashes in a direction, taunting enemies in his path.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Dealing damage with Shadow Dash or Twilight Assault recovers <span class=\"colorFFFFFF\">{{ f1 }}</span> Energy.<br /><br /><span class=\"colorFF9900\">Active:</span> Shen dashes in a direction, dealing {{ e2 }} <span class=\"colorCC3300\">[+{{ f2 }}]</span> physical damage to enemy champions and neutral monsters in his path and taunting them for {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							150,
							150,
							150,
							150,
							150
						],
						"costBurn": "150",
						"effect": [
							null,
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								125,
								125,
								125,
								125,
								125
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.5",
							"50/75/100/125/150",
							"25",
							"300",
							"125",
							"150",
							"800",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "ShenE.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "ShenR",
						"name": "Stand United",
						"description": "Shen shields target allied champion from incoming damage, and soon after teleports to their location.",
						"tooltip": "Shen grants a shield to a target allied champion that lasts {{ e2 }} seconds and absorbs up to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e8 }} <span class=\"color99FF99\">(+{{ f2 }})</span> damage based on their missing health. After channeling for {{ f1 }} seconds, Shen and his <span class=\"colorBB77FF\">spirit blade</span> teleport to the ally's location.",
						"leveltip": {
							"label": [
								"Minimum Shield Health",
								"Maximum Shield Health",
								"Cooldown "
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ e8 }} -> {{ e8NL }} ",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							200,
							180,
							160
						],
						"cooldownBurn": "200/180/160",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								175,
								350,
								525
							],
							[
								5,
								5,
								5
							],
							[
								175,
								175,
								175
							],
							[
								2000,
								2000,
								2000
							],
							[
								600,
								600,
								600
							],
							[
								0.4,
								0.4,
								0.4
							],
							[
								1.6,
								1.6,
								1.6
							],
							[
								280,
								560,
								840
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"175/350/525",
							"5",
							"175",
							"2000",
							"600",
							"0.4",
							"1.6",
							"280/560/840",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1.35,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							35000,
							35000,
							35000
						],
						"rangeBurn": "35000",
						"image": {
							"full": "ShenR.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Ki Barrier",
					"description": "After casting a spell, Shen gets a shield. Affecting other champions reduces the cooldown of this effect.",
					"image": {
						"full": "Shen_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Shen",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1054",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1054",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "3044",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3044",
										"count": 1
									},
									{
										"id": "3057",
										"count": 1
									},
									{
										"id": "3086",
										"count": 1
									},
									{
										"id": "3078",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3068",
										"count": 1
									},
									{
										"id": "3091",
										"count": 1
									},
									{
										"id": "3065",
										"count": 1
									},
									{
										"id": "3083",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1413",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shen",
						"title": "ShenTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Shyvana": {
				"id": "Shyvana",
				"key": "102",
				"name": "Shyvana",
				"title": "the Half-Dragon",
				"image": {
					"full": "Shyvana.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "102000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "102001",
						"num": 1,
						"name": "Ironscale Shyvana",
						"chromas": false
					},
					{
						"id": "102002",
						"num": 2,
						"name": "Boneclaw Shyvana",
						"chromas": false
					},
					{
						"id": "102003",
						"num": 3,
						"name": "Darkflame Shyvana",
						"chromas": false
					},
					{
						"id": "102004",
						"num": 4,
						"name": "Ice Drake Shyvana",
						"chromas": false
					},
					{
						"id": "102005",
						"num": 5,
						"name": "Championship Shyvana",
						"chromas": false
					},
					{
						"id": "102006",
						"num": 6,
						"name": "Super Galaxy Shyvana",
						"chromas": false
					}
				],
				"lore": "Shyvana is a creature with the magic of a rune shard burning within her heart. Though she often appears humanoid, she can take her true form as a fearsome dragon, incinerating her foes with fiery breath. Having saved the life of the crown prince Jarvan IV, Shyvana now serves uneasily in his royal guard, struggling to find acceptance among the suspicious people of Demacia.",
				"blurb": "Shyvana is a creature with the magic of a rune shard burning within her heart. Though she often appears humanoid, she can take her true form as a fearsome dragon, incinerating her foes with fiery breath. Having saved the life of the crown prince Jarvan...",
				"allytips": [
					"Shyvana's abilities all benefit from attacking units. As a result, Attack Speed items are more valuable on her than most champions.",
					"Flame Breath is great to level-up against difficult lane opponents.",
					"Burnout is an ideal choice for jungling. Monsters will be hit by the full duration, and the speed boost improves her ganking potential.",
					"It can be valuable to purchase one of the items that can slow enemies: Frozen Mallet, Dead Man's Plate, or Entropy."
				],
				"enemytips": [
					"A significant portion of Shyvana's power is generated through aggression, making her weak against opponents who are able to keep their distance.",
					"All of Shyvana's basic abilities hit multiple enemies in dragon form. It's important for opposing champions to not cluster while fighting her.",
					"Shyvana's Fury Bar indicate her ultimate can be activated. Harassing her when she's low on Fury can be very effective."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Fury",
				"info": {
					"attack": 8,
					"defense": 6,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 595,
					"hpperlevel": 95,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 350,
					"armor": 38,
					"armorperlevel": 3.35,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.8,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 2.8,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "ShyvanaDoubleAttack",
						"name": "Twin Bite",
						"description": "Shyvana strikes twice on her next attack. Basic attacks reduce the cooldown of Twin Bite by 0.5 seconds.<br><br><font color='#FF3300'>Dragon Form: </font>Twin Bite cleaves all units in front Shyvana. ",
						"tooltip": "Shyvana strikes twice on her next attack, dealing <span class=\"colorFF8C00\">{{ f2 }}</span> and <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage on the first and second hits respectively.<br /><br />While Twin Bite is on cooldown, basic attacks reduce the remaining cooldown duration by {{ e3 }} seconds.<br /><br /><span class=\"colorFF3300\">Dragon Form: </span>Twin Bite cleaves all units in front Shyvana.<br /><br /><span class=\"color919191\"><i>Twin Bite's second hit damage is equal to {{ e1 }}% of Shyvana's attack damage.</i></span>",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} ->{{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								35,
								50,
								65,
								80
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/35/50/65/80",
							"250",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.8,
									0.85,
									0.9,
									0.95,
									1
								],
								"key": "f1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "ShyvanaDoubleAttack.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "ShyvanaImmolationAura",
						"name": "Burnout",
						"description": "Shyvana surrounds herself in fire, dealing magic damage per second to nearby enemies and moving faster for 3 seconds, part of this damage is applied again when Shyvana basic attacks an enemy with Burnout active. The Movement Speed reduces over the duration of the spell. Basic attacks extend the duration of Burnout. <br><br><font color='#FF3300'>Dragon Form: </font>Burnout grows in size.",
						"tooltip": "Shyvana deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage per second to nearby enemies and gains a bonus {{ e2 }}% movement speed that decays over {{ e7 }} seconds.<br /><br />While Burnout is active, basic attacks deal {{ effect1amount*0.25 }} <span class=\"colorFF8C00\">(+{{ charbonusphysical*0.25 }})</span> <span class=\"color99FF99\">(+{{ charabilitypower2*.25 }})</span> magic damage to nearby enemies and extend its duration by {{ e8 }} second.<br /><br /><span class=\"colorFF3300\">Dragon Form: </span>Burnout grows in size.<br /><br /><span class=\"color919191\"><i>Burnout has a maximum duration of {{ e9 }} seconds.</i></span>",
						"leveltip": {
							"label": [
								"Damage (aura)",
								"Damage (on hit)",
								"Movement Speed Bonus"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ effect1amount*0.25 }} -> {{ effect1amountnl*0.25 }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								32,
								45,
								57,
								70
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								0.85,
								0.85,
								0.85,
								0.85,
								0.85
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								325,
								325,
								325,
								325,
								325
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								350,
								365,
								380,
								380,
								380
							]
						],
						"effectBurn": [
							null,
							"20/32/45/57/70",
							"30/35/40/45/50",
							"0.85",
							"0",
							"25",
							"325",
							"3",
							"1",
							"7",
							"350/365/380/380/380"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "ShyvanaImmolationAura.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "ShyvanaFireball",
						"name": "Flame Breath",
						"description": "Shyvana unleashes a fireball that deals damage to all enemies it encounters and leaves cinders on the target, marking them for 5 seconds. Shyvana's basic attacks on marked targets deal a percentage of their maximum Health as damage on-hit.<br><br><font color='#FF3300'>Dragon Form: </font>Flame Breath explodes on impact or at target location, dealing bonus damage and scorching the earth for a short duration.",
						"tooltip": "Shyvana unleashes a fireball that stops after hitting a champion. All enemies hit take {{ e1 }} <span class=\"colorFF8C00\">(+{{ f4 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are marked for {{ e2 }} seconds.<br /><br />Shyvana's basic attacks against marked targets deal {{ e4 }}% of their maximum health as magic damage on hit.<br /><br /><span class=\"colorFF3300\">Dragon Form: </span>Flame Breath explodes on impact or at target location, dealing <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"colorFF8C00\">(+{{ f5 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and scorching the earth for 4 seconds. Enemies on scorched earth take <span class=\"colorFFFFFF\">{{ f3 }}</span> <span class=\"colorFF8C00\">(+{{ f6 }})</span> <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage per second.<br /><br /><span class=\"color919191\"><i>Flame Breath's on-hit damage against monsters is capped at {{ e3 }} damage per hit.</i></span>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								4.5,
								4.5,
								4.5,
								4.5,
								4.5
							],
							[
								220,
								240,
								260,
								260,
								260
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"5",
							"100",
							"2.5",
							"0",
							"60/100/140/180/220",
							"4.5",
							"220/240/260/260/260",
							"0.1",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "ShyvanaFireball.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "ShyvanaTransformCast",
						"name": "Dragon's Descent",
						"description": "Shyvana transforms into a dragon and takes flight to a target location. Enemies along her path take damage and are knocked toward her target location.<br><br>Shyvana passively gains Fury per second and gains 2 Fury on basic attack.",
						"tooltip": "<span class=\"colorFF9900\">Active: </span>Shyvana transforms into a dragon, gaining {{ e0 }} Health and flying to target location. Enemies along her path take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are knocked toward her target location.<br /><br /><span class=\"colorFF9900\">Passive: </span>Shyvana generates {{ e3 }} Fury every second. Basic Attacks generate {{ e2 }} Fury.",
						"leveltip": {
							"label": [
								"Passive Fury Gain",
								"Dragon Size",
								"Bonus Health",
								"Flight Damage"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"Big -> Bigger",
								"{{ e0 }} -> {{ e0NL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								2,
								2,
								2
							],
							[
								1,
								1.5,
								2
							],
							[
								5,
								5,
								5
							],
							[
								1100,
								1100,
								1100
							],
							[
								275,
								275,
								275
							],
							[
								100,
								100,
								100
							],
							[
								200,
								230,
								260
							],
							[
								0,
								0.085,
								0.16
							],
							[
								150,
								250,
								350
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"2",
							"1/1.5/2",
							"5",
							"1100",
							"275",
							"100",
							"200/230/260",
							"0/0.085/0.16",
							"150/250/350"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Fury a Second",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "ShyvanaTransformCast.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e4 }} Fury a Second"
					}
				],
				"passive": {
					"name": "Fury of the Dragonborn",
					"description": "<mainText>Shyvana deals bonus damage to dragons and gains Armor and Magic Resistance. As Shyvana and her allies slay more dragons, she gains more bonus Armor and Magic Resistance.</mainText>",
					"image": {
						"full": "ShyvanaReinforcedScales.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Shyvana",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3052",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3052",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Shyvana",
						"title": "ShyvanaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Singed": {
				"id": "Singed",
				"key": "27",
				"name": "Singed",
				"title": "the Mad Chemist",
				"image": {
					"full": "Singed.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "27000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "27001",
						"num": 1,
						"name": "Riot Squad Singed",
						"chromas": false
					},
					{
						"id": "27002",
						"num": 2,
						"name": "Hextech Singed",
						"chromas": false
					},
					{
						"id": "27003",
						"num": 3,
						"name": "Surfer Singed",
						"chromas": false
					},
					{
						"id": "27004",
						"num": 4,
						"name": "Mad Scientist Singed",
						"chromas": false
					},
					{
						"id": "27005",
						"num": 5,
						"name": "Augmented Singed",
						"chromas": false
					},
					{
						"id": "27006",
						"num": 6,
						"name": "Snow Day Singed",
						"chromas": false
					},
					{
						"id": "27007",
						"num": 7,
						"name": "SSW Singed",
						"chromas": false
					},
					{
						"id": "27008",
						"num": 8,
						"name": "Black Scourge Singed",
						"chromas": false
					},
					{
						"id": "27009",
						"num": 9,
						"name": "Beekeeper Singed",
						"chromas": false
					}
				],
				"lore": "Singed is a Zaunite alchemist of unmatched intellect, who has devoted his life to pushing the boundaries of knowledge—with no price, even his own sanity, too high to pay. Is there a method to his madness? His concoctions rarely fail, but it appears to many that Singed has lost all sense of humanity, leaving a toxic trail of misery and terror in his wake.",
				"blurb": "Singed is a Zaunite alchemist of unmatched intellect, who has devoted his life to pushing the boundaries of knowledge—with no price, even his own sanity, too high to pay. Is there a method to his madness? His concoctions rarely fail, but it appears to...",
				"allytips": [
					"Poison Trail is very effective at farming and harassing, allowing Singed to dominate the flow of whatever lane he's in.",
					"Use Insanity Potion to trick your opponents into chasing you through your Poison Trail.",
					"Flinging enemies into your tower can deal heavy amounts of damage to them."
				],
				"enemytips": [
					"Keep your distance to avoid being Flung back into Singed's allies.",
					"Singed needs to run close to your team to be effective. Try to take advantage of this by using crowd control effects on him while attacking his allies.",
					"Be careful when chasing Singed. He's very difficult to bring down, and can leave his Poison Trail to damage you in your pursuit."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 8,
					"magic": 7,
					"difficulty": 5
				},
				"stats": {
					"hp": 580,
					"hpperlevel": 85,
					"mp": 290.6,
					"mpperlevel": 45,
					"movespeed": 345,
					"armor": 37,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.55,
					"mpregen": 7.524,
					"mpregenperlevel": 0.55,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 62.32,
					"attackdamageperlevel": 3.375,
					"attackspeedoffset": 0.02,
					"attackspeedperlevel": 1.81
				},
				"spells": [
					{
						"id": "PoisonTrail",
						"name": "Poison Trail",
						"description": "Leaves a trail of poison behind Singed, dealing damage to enemies caught in the path.",
						"tooltip": "<span class=\"colorFF9900\">Toggle: </span>Singed lays a poisonous trail that deals {{ e1 }} <span class=\"color99FF99\">(+{{ charabilitypower*4 }})</span> magic damage per second.",
						"leveltip": {
							"label": [
								"Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							13,
							13,
							13,
							13,
							13
						],
						"costBurn": "13",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								3.25,
								3.25,
								3.25,
								3.25,
								3.25
							],
							[
								2.1,
								2.1,
								2.1,
								2.1,
								2.1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"1",
							"3.25",
							"2.1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana per Second",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "PoisonTrail.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana per Second"
					},
					{
						"id": "MegaAdhesive",
						"name": "Mega Adhesive",
						"description": "Throws a vial of mega adhesive on the ground, slowing and grounding enemies who walk on it.",
						"tooltip": "Singed leaves a sticky area on the ground for {{ e2 }} seconds. Enemies in the area are slowed by {{ e1 }}% and grounded, prohibiting the use of Movement abilities.<br /><br />If Singed flings a target into the zone, it will root them.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Mana Cost "
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							16,
							15,
							14,
							13
						],
						"cooldownBurn": "17/16/15/14/13",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								265,
								265,
								265,
								265,
								265
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40",
							"3",
							"0",
							"265",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "MegaAdhesive.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "Fling",
						"name": "Fling",
						"description": "Damages target enemy unit and flings them into the air behind Singed. If the target Singed flings lands in his Mega Adhesive, they are also rooted.",
						"tooltip": "Singed flings an enemy over his shoulder, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> plus {{ e3 }}% of the target's maximum Health as magic damage. Max 300 bonus damage against minions and monsters.<br /><br />If the target Singed flings lands in his Mega Adhesive, they are also rooted for {{ e2 }} second(s).",
						"leveltip": {
							"label": [
								"Damage",
								"Max Health Damage",
								"Root Duration",
								"Mana Cost "
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							80,
							95,
							110,
							125,
							140
						],
						"costBurn": "80/95/110/125/140",
						"effect": [
							null,
							[
								50,
								65,
								80,
								95,
								110
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								6,
								6.5,
								7,
								7.5,
								8
							],
							[
								420,
								420,
								420,
								420,
								420
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/65/80/95/110",
							"1/1.25/1.5/1.75/2",
							"6/6.5/7/7.5/8",
							"420",
							"300",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							125,
							125,
							125,
							125,
							125
						],
						"rangeBurn": "125",
						"image": {
							"full": "Fling.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "InsanityPotion",
						"name": "Insanity Potion",
						"description": "Singed drinks a potent brew of chemicals, granting him increased combat stats.",
						"tooltip": "Singed drinks a potent brew of chemicals, granting him {{ e1 }} Ability Power, Armor, Magic Resist, Movement Speed, Health Regen, and Mana Regen for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Bonus Stats",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								35,
								60,
								85
							],
							[
								25,
								25,
								25
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/60/85",
							"25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "InsanityPotion.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Noxious Slipstream",
					"description": "Singed drafts off nearby champions, gaining a burst of movement speed when passing them.",
					"image": {
						"full": "Singed_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Singed",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1082",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3801",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1082",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3801",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Singed",
						"title": "SingedTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Sion": {
				"id": "Sion",
				"key": "14",
				"name": "Sion",
				"title": "The Undead Juggernaut",
				"image": {
					"full": "Sion.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "14000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "14001",
						"num": 1,
						"name": "Hextech Sion",
						"chromas": false
					},
					{
						"id": "14002",
						"num": 2,
						"name": "Barbarian Sion",
						"chromas": false
					},
					{
						"id": "14003",
						"num": 3,
						"name": "Lumberjack Sion",
						"chromas": false
					},
					{
						"id": "14004",
						"num": 4,
						"name": "Warmonger Sion",
						"chromas": false
					},
					{
						"id": "14005",
						"num": 5,
						"name": "Mecha Zero Sion",
						"chromas": false
					}
				],
				"lore": "A war hero from a bygone era, Sion was revered in Noxus for choking the life out of a Demacian king with his bare hands—but, denied oblivion, he was resurrected to serve his empire even in death. His indiscriminate slaughter claimed all who stood in his way, regardless of allegiance, proving he no longer retained his former humanity. Even so, with crude armor bolted onto rotten flesh, Sion continues to charge into battle with reckless abandon, struggling to remember his true self between the swings of his mighty axe.",
				"blurb": "A war hero from a bygone era, Sion was revered in Noxus for choking the life out of a Demacian king with his bare hands—but, denied oblivion, he was resurrected to serve his empire even in death. His indiscriminate slaughter claimed all who stood in his...",
				"allytips": [
					"You only have very slight turning ability during Unstoppable Onslaught, so make sure to use it in straight paths.",
					"Roar of the Slayer is a great setup ability to land a very powerful Decimating Smash.",
					"The Soul Furnace buff displays how much shield strength is remaining, use this information to time its explosion perfectly."
				],
				"enemytips": [
					"Even if Sion still hits a Decimating Smash, making him release the charge earlier reduces its impact.",
					"Use the time after Sion has died to reposition and prepare for his return."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 9,
					"magic": 3,
					"difficulty": 5
				},
				"stats": {
					"hp": 542.64,
					"hpperlevel": 73,
					"mp": 325.6,
					"mpperlevel": 42,
					"movespeed": 345,
					"armor": 32,
					"armorperlevel": 3,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 10,
					"hpregenperlevel": 0.8,
					"mpregen": 8.008,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 4,
					"attackspeedoffset": -0.08,
					"attackspeedperlevel": 1.3
				},
				"spells": [
					{
						"id": "SionQ",
						"name": "Decimating Smash",
						"description": "Sion charges a powerful swing in an area in front of himself that will deal damage to enemies when released. If he charges for enough time, enemies hit by the swing will also be knocked up and stunned.</font>",
						"tooltip": "Sion charges up a heavy blow for up to 2 seconds. When released, he deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> to {{ e4 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage to enemies hit ({{ e8 }}% damage to minions) and briefly slows them.<br /><br />If Sion charges for at least 1 second, enemies are knocked up and stunned for 1.25 to 2.25 seconds.",
						"leveltip": {
							"label": [
								"Minimum Damage",
								"Maximum Damage",
								"Cooldown "
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								0.65,
								0.65,
								0.65,
								0.65,
								0.65
							],
							[
								60,
								120,
								180,
								240,
								300
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								1.95,
								1.95,
								1.95,
								1.95,
								1.95
							],
							[
								7.5,
								7.5,
								7.5,
								7.5,
								7.5
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								80,
								80,
								80,
								80,
								80
							],
							[
								-0.8,
								-0.8,
								-0.8,
								-0.8,
								-0.8
							]
						],
						"effectBurn": [
							null,
							"20/40/60/80/100",
							"1.25",
							"0.65",
							"60/120/180/240/300",
							"2.5",
							"1.95",
							"7.5",
							"60",
							"80",
							"-0.8"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.6,
								"key": "f1"
							},
							{
								"link": "attackdamage",
								"coeff": 1.8,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							10000,
							10000,
							10000,
							10000,
							10000
						],
						"rangeBurn": "10000",
						"image": {
							"full": "SionQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SionW",
						"name": "Soul Furnace",
						"description": "Sion shields himself and can reactivate after 3 seconds to deal Magic Damage to enemies nearby. When Sion kills enemies, he passively gains maximum Health.",
						"tooltip": "<span class=\"colorFFE076\">Passive:</span> Sion gains {{ e5 }} maximum Health when he kills a unit ({{ e6 }} for champion kills, assists, large minions and large monsters). <span class=\"colorFF3300\">Current Bonus: {{ f1 }} </span><br /><br /><span class=\"colorFFE076\">Active:</span> Sion shields himself for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFF3300\">(+{{ f2 }})</span> ({{ e3 }}% of maximum Health) for 6 seconds. After {{ e7 }} seconds, while the shield holds, Sion can reactivate to deal {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> plus {{ e4 }}% of the target's maximum Health as magic damage to nearby enemies. Max 400 bonus damage to minions and monsters.",
						"leveltip": {
							"label": [
								"Shield",
								"Damage",
								"Max Health Damage",
								"Max Health Shield Ratio",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							11,
							11,
							11,
							11
						],
						"cooldownBurn": "11",
						"cost": [
							65,
							70,
							75,
							80,
							85
						],
						"costBurn": "65/70/75/80/85",
						"effect": [
							null,
							[
								30,
								55,
								80,
								105,
								130
							],
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								8,
								9,
								10,
								11,
								12
							],
							[
								10,
								11,
								12,
								13,
								14
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/55/80/105/130",
							"40/65/90/115/140",
							"8/9/10/11/12",
							"10/11/12/13/14",
							"3",
							"10",
							"3",
							"10",
							"6",
							"0"
						],
						"vars": [
							{
								"link": "health",
								"coeff": 0.1,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "SionW.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SionE",
						"name": "Roar of the Slayer",
						"description": "Sion fires a short range shockwave that damages and slows and reduces the Armor of the first enemy hit. If the shockwave hits a minion or monster, it will be knocked back, damaging and slowing all enemies that it passes through.",
						"tooltip": "Sion fires a shockwave, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy hit, slowing it by {{ e2 }}%, and reducing its Armor by {{ e5 }}% for 2.5 seconds.<br /><br />If the target is not a champion, it will be knocked back. Enemies that the knocked back unit collides with take {{ e6 }}% bonus damage and are slowed by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown",
								"Mana Cost "
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							35,
							40,
							45,
							50,
							55
						],
						"costBurn": "35/40/45/50/55",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"40/45/50/55/60",
							"5",
							"40/45/50/55/60",
							"20",
							"30",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "SionE.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SionR",
						"name": "Unstoppable Onslaught",
						"description": "Sion charges in a direction, ramping up speed over time. He can steer his charge slightly with the mouse cursor location. When he collides with an enemy he deals damage and knocks them up based on the distance he has charged.",
						"tooltip": "Sion charges in a direction for 8 seconds and can steer slowly towards the mouse cursor. While charging, Sion is immune to all Crowd Control. Reactivating will cancel Sion's charge early.<br /><br />When Sion collides with an enemy champion or wall, he deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and knocks up enemies in a small area for {{ e5 }} seconds. Enemies in a larger area take the same damage and are slowed by {{ e3 }}% for 3 seconds.<br /><br />The damage increases to {{ e2 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> and the stun increases to {{ e6 }} seconds as Sion charges farther.",
						"leveltip": {
							"label": [
								"Minimum Damage",
								"Maximum Damage",
								"Slow",
								"Cooldown "
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							100,
							60
						],
						"cooldownBurn": "140/100/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								300,
								450
							],
							[
								400,
								800,
								1200
							],
							[
								40,
								45,
								50
							],
							[
								500,
								500,
								500
							],
							[
								0.75,
								0.75,
								0.75
							],
							[
								1.75,
								1.75,
								1.75
							],
							[
								950,
								950,
								950
							],
							[
								0,
								0,
								0
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/300/450",
							"400/800/1200",
							"40/45/50",
							"500",
							"0.75",
							"1.75",
							"950",
							"0",
							"2",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.4,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							7500,
							7500,
							7500
						],
						"rangeBurn": "7500",
						"image": {
							"full": "SionR.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Glory in Death",
					"description": "After being killed, Sion will reanimate with rapidly decaying Health. His attacks become very rapid, gain 100% Lifesteal and deal bonus damage equal to 10% of his target's maximum Health (max 75 to monsters).<br><br>All his abilities are replaced with Death Surge, which grants a burst of Movement Speed.",
					"image": {
						"full": "Sion_Passive1.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Sion",
						"title": "SionARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sion",
						"title": "SionCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sion",
						"title": "SionFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sion",
						"title": "SionKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sion",
						"title": "SionSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sion",
						"title": "SionSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "S5_SummonerSmiteDuel",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sion",
						"title": "SionTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Sivir": {
				"id": "Sivir",
				"key": "15",
				"name": "Sivir",
				"title": "the Battle Mistress",
				"image": {
					"full": "Sivir.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "15000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "15001",
						"num": 1,
						"name": "Warrior Princess Sivir",
						"chromas": false
					},
					{
						"id": "15002",
						"num": 2,
						"name": "Spectacular Sivir",
						"chromas": false
					},
					{
						"id": "15003",
						"num": 3,
						"name": "Huntress Sivir",
						"chromas": false
					},
					{
						"id": "15004",
						"num": 4,
						"name": "Bandit Sivir",
						"chromas": false
					},
					{
						"id": "15005",
						"num": 5,
						"name": "PAX Sivir",
						"chromas": false
					},
					{
						"id": "15006",
						"num": 6,
						"name": "Snowstorm Sivir",
						"chromas": false
					},
					{
						"id": "15007",
						"num": 7,
						"name": "Warden Sivir",
						"chromas": false
					},
					{
						"id": "15008",
						"num": 8,
						"name": "Victorious Sivir",
						"chromas": false
					},
					{
						"id": "15009",
						"num": 9,
						"name": "Neo PAX Sivir",
						"chromas": false
					}
				],
				"lore": "Sivir is a renowned fortune hunter and mercenary captain who plies her trade in the deserts of Shurima. Armed with her legendary jeweled crossblade, she has fought and won countless battles for those who can afford her exorbitant price. Known for her fearless resolve and endless ambition, she prides herself on recovering buried treasures from the perilous tombs of Shurima—for a generous bounty. With ancient forces stirring the very bones of Shurima, Sivir finds herself torn between conflicting destinies.",
				"blurb": "Sivir is a renowned fortune hunter and mercenary captain who plies her trade in the deserts of Shurima. Armed with her legendary jeweled crossblade, she has fought and won countless battles for those who can afford her exorbitant price. Known for her...",
				"allytips": [
					"Sivir's Boomerang Blade returns to her after reaching the max range, so you can shift position to hit enemies who would otherwise have evaded it.",
					"Ricochet resets Sivir's basic attack timer on activation, so activating this immediately after landing a normal basic attack will maximize damage output.",
					"Try saving Spell Shield for enemy abilities that can disable you such as stuns and roots."
				],
				"enemytips": [
					"Boomerang Blade costs a lot of mana to cast, so dodging it sets Sivir back. If it hits you on the way out, avoid its path on the way back.",
					"Sivir is a powerful pushing champion, so leaving her unattended in a lane for too long will often result in your turrets being destroyed.",
					"When laning against Sivir, it is possible to throw off the timing of her Spell Shield by faking an advance, then backing off."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 3,
					"magic": 1,
					"difficulty": 4
				},
				"stats": {
					"hp": 515.76,
					"hpperlevel": 82,
					"mp": 284,
					"mpperlevel": 50,
					"movespeed": 335,
					"armor": 31,
					"armorperlevel": 3.25,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 5,
					"hpregenperlevel": 0.55,
					"mpregen": 8.012,
					"mpregenperlevel": 0.9,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.6
				},
				"spells": [
					{
						"id": "SivirQ",
						"name": "Boomerang Blade",
						"description": "Sivir hurls her crossblade like a boomerang, dealing damage each way.",
						"tooltip": "Sivir hurls her crossblade like a boomerang, which deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to the first target hit and {{ e2 }}% reduced damage to each subsequent target down to a minimum of {{ e3 }}%.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Attack Damage Scaling",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								35,
								55,
								75,
								95,
								115
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								0.7,
								0.8,
								0.9,
								1,
								1.1
							],
							[
								70,
								80,
								90,
								100,
								110
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/55/75/95/115",
							"15",
							"40",
							"0.7/0.8/0.9/1/1.1",
							"70/80/90/100/110",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "SivirQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SivirW",
						"name": "Ricochet",
						"description": "Sivir's next few basic attacks will bounce to nearby targets, dealing reduced damage to secondary targets.",
						"tooltip": "Sivir's next {{ e4 }} basic attacks bounce to nearby targets, dealing <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage to the first target and <span class=\"colorFF8C00\">{{ f2 }}</span> physical damage to each subsequent target.<br /><br />If a given Ricochet attack critically strikes its first target, all subsequent bounces from that attack will also critically strike.<br /><br /><span class=\"color919191\"><i>Targets cannot be hit more than once by a given Ricochet attack and on-hit effects are applied only to the first target of each attack.</i></span>",
						"leveltip": {
							"label": [
								"Cooldown",
								"Bounce Damage (total attack damage)"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							10.5,
							9,
							7.5,
							6
						],
						"cooldownBurn": "12/10.5/9/7.5/6",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								5,
								6,
								7,
								8,
								9
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								50,
								55,
								60,
								65,
								70
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								60,
								70,
								80,
								90,
								100
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								4.5,
								4.25,
								4,
								3.75,
								3.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5/6/7/8/9",
							"10/20/30/40/50",
							"50/55/60/65/70",
							"3",
							"60/70/80/90/100",
							"1",
							"0",
							"4.5/4.25/4/3.75/3.5",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0,
								"key": "f1"
							},
							{
								"link": "attackdamage",
								"coeff": 0,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "SivirW.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SivirE",
						"name": "Spell Shield",
						"description": "Creates a magical barrier that blocks a single enemy ability cast on Sivir. She receives Mana back if a spell is blocked.",
						"tooltip": "Sivir creates a magical barrier for {{ e1 }} seconds that blocks the next incoming enemy ability.<br /><br />If an ability is blocked by the shield, Sivir regains {{ e2 }} Mana.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Mana Gain"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							19,
							16,
							13,
							10
						],
						"cooldownBurn": "22/19/16/13/10",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								80,
								95,
								110,
								125,
								140
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.5",
							"80/95/110/125/140",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "SivirE.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "SivirR",
						"name": "On The Hunt",
						"description": "Sivir leads her allies in battle, granting them a surge Movement Speed for a period of time. Additionally passively grants Sivir bonus Attack Speed while Ricochet is active.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Sivir gains {{ e1 }}% Attack Speed while Ricochet is active.<br /><br /><span class=\"colorFF9900\">Active: </span>Sivir rallies her allies for {{ e3 }} seconds, granting all nearby allies an initial {{ e4 }}% Movement Speed bonus that reduces to {{ e2 }}% after the first {{ e5 }} seconds of On The Hunt elapse.",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Enhanced Movement Speed Bonus",
								"Enhanced Movement Speed Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								30,
								45,
								60
							],
							[
								20,
								20,
								20
							],
							[
								8,
								8,
								8
							],
							[
								40,
								50,
								60
							],
							[
								2,
								3,
								4
							],
							[
								1000,
								1000,
								1000
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/45/60",
							"20",
							"8",
							"40/50/60",
							"2/3/4",
							"1000",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "SivirR.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Fleet of Foot",
					"description": "Sivir gains a short burst of Movement Speed when she attacks an enemy champion.",
					"image": {
						"full": "Sivir_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Sivir",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sivir",
						"title": "SivirTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Skarner": {
				"id": "Skarner",
				"key": "72",
				"name": "Skarner",
				"title": "the Crystal Vanguard",
				"image": {
					"full": "Skarner.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "72000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "72001",
						"num": 1,
						"name": "Sandscourge Skarner",
						"chromas": false
					},
					{
						"id": "72002",
						"num": 2,
						"name": "Earthrune Skarner",
						"chromas": false
					},
					{
						"id": "72003",
						"num": 3,
						"name": "Battlecast Alpha Skarner",
						"chromas": false
					},
					{
						"id": "72004",
						"num": 4,
						"name": "Guardian of the Sands Skarner",
						"chromas": false
					}
				],
				"lore": "Skarner is an immense crystalline scorpion from a hidden valley in Shurima. Part of the ancient Brackern race, Skarner and his kin are known for their great wisdom and deep connection to the land, as their souls are fused with powerful life crystals which hold the living thoughts and memories of their ancestors. In an age long past, the Brackern entered hibernation to avoid untold magical destruction, but recent, threatening events have roused Skarner. As the only Brackern awake, he strives to protect his kind from those who seek to harm them.",
				"blurb": "Skarner is an immense crystalline scorpion from a hidden valley in Shurima. Part of the ancient Brackern race, Skarner and his kin are known for their great wisdom and deep connection to the land, as their souls are fused with powerful life crystals...",
				"allytips": [
					"Basic attacks reduce the cooldown of Crystal Slash. Use them as often as possible for maximum damage.",
					"Capturing Crystal Spires before attempting neutral objectives or team fights around them improves Skarner's performance in said fights dramatically.",
					"Impale is extremely powerful when you use it to position an enemy so your allies can attack them."
				],
				"enemytips": [
					"Skarner can't harm you very much outside of short range, so stay away from him!",
					"Skarner's Movement Speed is increased as long as his shield, Crystalline Exoskeleton, persists. Attack him to lower his speed.",
					"Skarner is especially dangerous when inside Crystal Spire zones his team controls. Try to capture them ahead of time if a fight may break out around them."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 6,
					"magic": 5,
					"difficulty": 5
				},
				"stats": {
					"hp": 601.28,
					"hpperlevel": 90,
					"mp": 320,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 38,
					"armorperlevel": 3.8,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9,
					"hpregenperlevel": 0.85,
					"mpregen": 7.206,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 4.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.1
				},
				"spells": [
					{
						"id": "SkarnerVirulentSlash",
						"name": "Crystal Slash",
						"description": "Skarner lashes out with his claws, dealing physical damage to all nearby enemies and charging himself with Crystal Energy for several seconds if a unit is struck. If he casts Crystal Slash again while powered by Crystal Energy, he deals bonus magic damage.",
						"tooltip": "Skarner deals <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage to all nearby enemies. If a unit is struck, he charges himself with Crystal Energy for {{ e2 }} seconds.<br /><br />While Skarner is charged, Crystal Slash deals <span class=\"colorFF8C00\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage.<br /><br />Basic attacks against non-structures lower Crystal Slash's cooldown by 0.25 seconds (quadrupled against champions).",
						"leveltip": {
							"label": [
								"Total Attack Damage Ratio",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							3.5,
							3.25,
							3,
							2.75,
							2.5
						],
						"cooldownBurn": "3.5/3.25/3/2.75/2.5",
						"cost": [
							10,
							11,
							12,
							13,
							14
						],
						"costBurn": "10/11/12/13/14",
						"effect": [
							null,
							[
								33,
								36,
								39,
								42,
								45
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"33/36/39/42/45",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "f1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "f1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "SkarnerVirulentSlash.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SkarnerExoskeleton",
						"name": "Crystalline Exoskeleton",
						"description": "Skarner gains a shield and has increased Movement Speed while the shield persists.",
						"tooltip": "Skarner is shielded for <span class=\"colorCC3300\">{{ f1 }}</span> ({{ e1 }}% of his maximum health) <span class=\"color99FF99\">(+{{ a1 }})</span> damage for {{ e4 }} seconds. While the shield persists, Skarner gains movement speed that ramps up to {{ e5 }}% over 3 seconds.",
						"leveltip": {
							"label": [
								"Max Health Damage Absorption",
								"Movement Speed Bonus",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e5 }}% -> {{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12.5,
							12,
							11.5,
							11
						],
						"cooldownBurn": "13/12.5/12/11.5/11",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								10,
								11,
								12,
								13,
								14
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								8,
								10,
								12,
								14,
								16
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								16,
								20,
								24,
								28,
								32
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/11/12/13/14",
							"30/35/40/45/50",
							"8/10/12/14/16",
							"6",
							"16/20/24/28/32",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "SkarnerExoskeleton.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SkarnerFracture",
						"name": "Fracture",
						"description": "Skarner summons a blast of crystalline energy which deals damage to enemies struck and slows them. Basic attacking these enemies within a short window will stun them.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> Crystallizing enemies with Fracture and Impale grants <span class=\"colorFFF673\">Crystal Charge</span> for the disable duration and reduces the cooldown of Fracture by the same amount.<br /><br /><span class=\"colorFF9900\">Active:</span> Skarner summons a blast of crystalline energy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, slowing targets hit by {{ e8 }}% for {{ e7 }} seconds and reducing the blast's speed.<br /><br />Enemies hit by Fracture are afflicted with Crystal Venom for {{ e6 }} seconds, causing Skarner's next basic attack against them to deal {{ e2 }} additional physical damage and stun the target for {{ e3 }} second.",
						"leveltip": {
							"label": [
								"Blast Damage / Attack Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} / {{ e2 }} -> {{ e1NL }} / {{ e2NL }}",
								"{{ e8 }}% -> {{ e8NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13.5,
							13,
							12.5,
							12
						],
						"cooldownBurn": "14/13.5/13/12.5/12",
						"cost": [
							55,
							55,
							55,
							55,
							55
						],
						"costBurn": "55",
						"effect": [
							null,
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/65/90/115/140",
							"30/50/70/90/110",
							"1.5",
							"50",
							"6",
							"5",
							"2.5",
							"30/35/40/45/50",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							980,
							980,
							980,
							980,
							980
						],
						"rangeBurn": "980",
						"image": {
							"full": "SkarnerFracture.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SkarnerImpale",
						"name": "Impale",
						"description": "Skarner suppresses an enemy champion and deals damage to it. During this time, Skarner can move freely and will drag his helpless victim around with him. When the effect ends, the target will be dealt additional damage.",
						"tooltip": "Skarner suppresses an enemy champion for {{ e1 }} seconds, dealing <span class=\"colorFF8C00\">{{ a2 }}</span> physical damage plus {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Skarner can move freely during this time, and will drag his helpless victim around with him. When the effect ends, Skarner's target will be dealt the same damage again.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								1.75,
								1.75,
								1.75
							],
							[
								20,
								60,
								100
							],
							[
								50,
								75,
								100
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.75",
							"20/60/100",
							"50/75/100",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.6,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "SkarnerImpale.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Crystal Spires",
					"description": "Skarner's presence causes crystals to spawn in set locations around the map. While near crystals his team owns, Skarner gains tremendous movement speed, attack speed, and mana regeneration.",
					"image": {
						"full": "Skarner_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Skarner",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": true
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Skarner",
						"title": "SkarnerTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Sona": {
				"id": "Sona",
				"key": "37",
				"name": "Sona",
				"title": "Maven of the Strings",
				"image": {
					"full": "Sona.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "37000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "37001",
						"num": 1,
						"name": "Muse Sona",
						"chromas": false
					},
					{
						"id": "37002",
						"num": 2,
						"name": "Pentakill Sona",
						"chromas": false
					},
					{
						"id": "37003",
						"num": 3,
						"name": "Silent Night Sona",
						"chromas": false
					},
					{
						"id": "37004",
						"num": 4,
						"name": "Guqin Sona",
						"chromas": true
					},
					{
						"id": "37005",
						"num": 5,
						"name": "Arcade Sona",
						"chromas": false
					},
					{
						"id": "37006",
						"num": 6,
						"name": "DJ Sona",
						"chromas": false
					},
					{
						"id": "37007",
						"num": 7,
						"name": "Sweetheart Sona",
						"chromas": false
					}
				],
				"lore": "Sona is Demacia's foremost virtuoso of the stringed etwahl, speaking only through her graceful chords and vibrant arias. This genteel manner has endeared her to the highborn, though others suspect her spellbinding melodies to actually emanate magic—a Demacian taboo. Silent to outsiders but somehow understood by close companions, Sona plucks her harmonies not only to soothe injured allies, but also to strike down unsuspecting enemies.",
				"blurb": "Sona is Demacia's foremost virtuoso of the stringed etwahl, speaking only through her graceful chords and vibrant arias. This genteel manner has endeared her to the highborn, though others suspect her spellbinding melodies to actually emanate magic—a...",
				"allytips": [
					"Make sure to tag your allies while Sona's auras are active, but avoid getting caught out by enemies.",
					"Save Crescendo for the game-altering moment.",
					"Well-timed uses of Aria of Perseverance will grant you maximum survivability."
				],
				"enemytips": [
					"Spread out when you see Sona so she can't make your entire team dance.",
					"Kill Sona first, as she will heal up her team if left alone for too long."
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 2,
					"magic": 8,
					"difficulty": 4
				},
				"stats": {
					"hp": 482.36,
					"hpperlevel": 77,
					"mp": 340.6,
					"mpperlevel": 45,
					"movespeed": 325,
					"armor": 28,
					"armorperlevel": 3.3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 11.5,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 46,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.03,
					"attackspeedperlevel": 2.3
				},
				"spells": [
					{
						"id": "SonaQ",
						"name": "Hymn of Valor",
						"description": "Sona plays the Hymn of Valor, sends out bolts of sound, dealing magic damage to two nearby enemies, prioritizing champions and monsters. Sona gains a temporary aura that grants allies tagged by the zone bonus damage on their next attack against enemies.",
						"tooltip": "<span class=\"colorFF9900\">Active:</span> Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the nearest two enemies (prioritizes champions) and changes her <span class=\"colorEEEEEE\">Power Chord</span> bonus to <span class=\"color4477FF\">Staccato</span>.<br /><br /><span class=\"colorFF9900\">Melody:</span> Sona gains an aura for {{ e3 }} seconds. Allied champions that enter the aura will gain an additional {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage on their next attack.",
						"leveltip": {
							"label": [
								"Damage (active)",
								"Damage (melody)",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/70/100/130/160",
							"400",
							"3",
							"10/15/20/25/30",
							"5",
							"0.4",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							825,
							825,
							825,
							825,
							825
						],
						"rangeBurn": "825",
						"image": {
							"full": "SonaQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SonaW",
						"name": "Aria of Perseverance",
						"description": "Sona plays the Aria of Perseverance, sending out protective melodies, healing Sona and a nearby wounded ally. Sona gains a temporary aura that grants allies tagged by the zone a temporary shield.",
						"tooltip": "<span class=\"colorFF9900\">Active:</span> Restores {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health to Sona and a nearby allied champion (prioritizes most wounded) and changes her <span class=\"colorEEEEEE\">Power Chord</span> bonus to <span class=\"color44FF77\">Diminuendo</span>.<br /><br /><span class=\"colorFF9900\">Melody:</span> Sona gains an aura for {{ e3 }} seconds. Allied champions that enter the aura will gain a shield that prevents up to {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage within the next {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Heal (active)",
								"Shield (melody)",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							10,
							10,
							10,
							10
						],
						"cooldownBurn": "10",
						"cost": [
							80,
							85,
							90,
							95,
							100
						],
						"costBurn": "80/85/90/95/100",
						"effect": [
							null,
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								25,
								50,
								75,
								100,
								125
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0.04,
								0.04,
								0.04,
								0.04,
								0.04
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/50/70/90/110",
							"400",
							"3",
							"25/50/75/100/125",
							"1.5",
							"0.25",
							"0.04",
							"3",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "SonaW.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SonaE",
						"name": "Song of Celerity",
						"description": "Sona plays the Song of Celerity, granting nearby allies bonus Movement Speed. Sona gains a temporary aura that grants allied champions tagged by the zone bonus Movement Speed on their next attack.",
						"tooltip": "<span class=\"colorFF9900\">Active:</span> Grants Sona <span class=\"color99FF99\">{{ f1*100 }}%</span> movement speed [{{ e1 }}% + {{ f2*100 }}% per 100 ability power] for {{ e9 }} seconds (or until damaged) and changes her <span class=\"colorEEEEEE\">Power Chord</span> bonus to <span class=\"colorDD5599\">Tempo</span>.<br /><br /><span class=\"colorFF9900\">Melody:</span> Sona gains an aura for {{ e3 }} seconds. Allied champions that enter the aura will gain <span class=\"color99FF99\">{{ f3*100 }}%</span> movement speed for {{ e5 }} seconds.<br /><br /><span class=\"color919191\"><i>Sona's personal movement speed increase will always last at least {{ e5 }} seconds.</i></span>",
						"leveltip": {
							"label": [
								"Movement Speed"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							65,
							65,
							65,
							65,
							65
						],
						"costBurn": "65",
						"effect": [
							null,
							[
								10,
								11,
								12,
								13,
								14
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.1,
								0.11,
								0.12,
								0.13,
								0.14
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0.04,
								0.04,
								0.04,
								0.04,
								0.04
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/11/12/13/14",
							"400",
							"3",
							"0.1/0.11/0.12/0.13/0.14",
							"3",
							"0.4",
							"0.04",
							"2",
							"7",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							430,
							430,
							430,
							430,
							430
						],
						"rangeBurn": "430",
						"image": {
							"full": "SonaE.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SonaR",
						"name": "Crescendo",
						"description": "Sona plays her ultimate chord, stunning enemy champions and forcing them to dance and dealing magic damage to them. Each rank reduces the base cooldown of Sona's basic abilities.",
						"tooltip": "<span class=\"colorFF9900\">Active: </span>Strikes an irresistible chord, stunning enemy Champions and forcing them to dance for {{ e2 }} seconds and take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorFF9900\">Passive: </span>Reduces the base cooldown of Sona's basic abilities by {{ e3 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Hymn of Valor Cooldown",
								"Aria of Perseverance Cooldown",
								"Song of Celerity Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ f1 }} -> {{ f2 }}",
								"{{ f3 }} -> {{ f4 }}",
								"{{ f5 }} -> {{ f6 }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							120,
							100
						],
						"cooldownBurn": "140/120/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								10,
								25,
								40
							],
							[
								-0.1,
								-0.25,
								-0.4
							],
							[
								-0.1,
								-0.25,
								-0.4
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"1.5",
							"10/25/40",
							"-0.1/-0.25/-0.4",
							"-0.1/-0.25/-0.4",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "SonaR.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Power Chord",
					"description": "After casting 3 spells, Sona's next attack deals bonus magic damage in addition to a bonus effect depending on what song Sona last activated.",
					"image": {
						"full": "Sona_Passive_Charged.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Sona",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "ability_scaling",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "ability_scaling",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "ability_scaling",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3114",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "ability_scaling",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Sona",
						"title": "SonaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Soraka": {
				"id": "Soraka",
				"key": "16",
				"name": "Soraka",
				"title": "the Starchild",
				"image": {
					"full": "Soraka.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "16000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "16001",
						"num": 1,
						"name": "Dryad Soraka",
						"chromas": false
					},
					{
						"id": "16002",
						"num": 2,
						"name": "Divine Soraka",
						"chromas": false
					},
					{
						"id": "16003",
						"num": 3,
						"name": "Celestine Soraka",
						"chromas": false
					},
					{
						"id": "16004",
						"num": 4,
						"name": "Reaper Soraka",
						"chromas": false
					},
					{
						"id": "16005",
						"num": 5,
						"name": "Order of the Banana Soraka",
						"chromas": false
					},
					{
						"id": "16006",
						"num": 6,
						"name": "Program Soraka",
						"chromas": false
					},
					{
						"id": "16007",
						"num": 7,
						"name": "Star Guardian Soraka",
						"chromas": false
					}
				],
				"lore": "A wanderer from the celestial dimensions beyond Mount Targon, Soraka gave up her immortality to protect the mortal races from their own more violent instincts. She endeavors to spread the virtues of compassion and mercy to everyone she meets—even healing those who would wish harm upon her. And, for all Soraka has seen of this world's struggles, she still believes the people of Runeterra have yet to reach their full potential.",
				"blurb": "A wanderer from the celestial dimensions beyond Mount Targon, Soraka gave up her immortality to protect the mortal races from their own more violent instincts. She endeavors to spread the virtues of compassion and mercy to everyone she meets—even...",
				"allytips": [
					"Soraka is a powerful ally in battle, using her strong healing to keep the party moving forward.",
					"You can use Wish on your allies from across the map to save them from otherwise fatal events.",
					"Equinox can be used as a powerful zoning tool to keep enemies at bay."
				],
				"enemytips": [
					"Focus on attacking Soraka when she ever ventures to the frontline to heal her allies.",
					"Take advantage of Soraka's long cooldown on Equinox if she uses it to harass.",
					"It's easier to focus Soraka than the ally she is healing."
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 5,
					"magic": 7,
					"difficulty": 3
				},
				"stats": {
					"hp": 529.04,
					"hpperlevel": 78,
					"mp": 350.8,
					"mpperlevel": 60,
					"movespeed": 325,
					"armor": 32,
					"armorperlevel": 3.8,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 2.5,
					"hpregenperlevel": 0.5,
					"mpregen": 11.5,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 50.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.14
				},
				"spells": [
					{
						"id": "SorakaQ",
						"name": "Starcall",
						"description": "A star falls from the sky at the target location dealing magic damage and slowing enemies. If an enemy champion is hit by Starcall, Soraka recovers health and gains movement speed when moving away from enemy champions.",
						"tooltip": "Calls down a star from Soraka to a target location. Enemies standing in the explosion radius take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed by {{ e2 }}% for 2 seconds.<br /><br />If Starcall hits a champion Soraka gains <span class=\"colorDDDDDD\">Rejuvenation</span> for {{ e5 }} seconds, which restores {{ e3 }} <span class=\"color99FF99\">(+{{ f1 }})</span> health per second and grants {{ e9 }}% movement speed when not moving toward enemy champions.",
						"leveltip": {
							"label": [
								"Damage",
								"Health Restore (Rejuvenation)",
								"Rejuvenation Duration (for allies)",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							5,
							5,
							5,
							5
						],
						"cooldownBurn": "5",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								14,
								16,
								18,
								20,
								22
							],
							[
								7,
								9,
								11,
								13,
								15
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								3,
								3.5,
								4,
								4.5,
								5
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0.05,
								0.05,
								0.05,
								0.05,
								0.05
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"30",
							"14/16/18/20/22",
							"7/9/11/13/15",
							"4",
							"3/3.5/4/4.5/5",
							"0.1",
							"0.05",
							"10",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							810,
							810,
							810,
							810,
							810
						],
						"rangeBurn": "810",
						"image": {
							"full": "SorakaQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SorakaW",
						"name": "Astral Infusion",
						"description": "Soraka sacrifices a portion of her own health to heal another friendly champion.",
						"tooltip": "Restores {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health to another champion ally.<br /><br />If cast while affected by <span class=\"colorDDDDDD\">Rejuvenation</span>, Soraka will grant her target its benefits for {{ f1 }} seconds.<br /><br /><span class=\"color919191\"><i>Cannot be cast if Soraka is below 5% Health.</i></span>",
						"leveltip": {
							"label": [
								"Heal Amount",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							6.5,
							5,
							3.5,
							2
						],
						"cooldownBurn": "8/6.5/5/3.5/2",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/110/140/170/200",
							"0.1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "SorakaW.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "10% Max Health, {{ cost }} Mana"
					},
					{
						"id": "SorakaE",
						"name": "Equinox",
						"description": "Creates a zone at a location that silences all enemies inside. When the zone expires, all enemies still inside are rooted.",
						"tooltip": "Creates a zone at target location for 1.5 seconds, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemy Champions in the cast radius. Enemy Champions standing in the zone are silenced until they leave. <br /><br />When the zone disappears, all enemy Champions still standing in the zone are rooted for {{ e1 }} second(s) and are dealt {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }}) </span>magic damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Root Duration"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							22,
							20,
							18,
							16
						],
						"cooldownBurn": "24/22/20/18/16",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								40,
								70,
								100,
								130,
								160
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								260,
								260,
								260,
								260,
								260
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1/1.25/1.5/1.75/2",
							"70/110/150/190/230",
							"40/70/100/130/160",
							"5",
							"20/40/60/80/100",
							"60/90/120/150/180",
							"1.5",
							"260",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "SorakaE.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SorakaR",
						"name": "Wish",
						"description": "Soraka fills her allies with hope, instantly restoring health to herself and all friendly champions.",
						"tooltip": "Calls upon divine powers to restore {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health to all allied Champions. Wish's power is increased by 50% on each Champion below 40% Health.",
						"leveltip": {
							"label": [
								"Health Restored",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							160,
							145,
							130
						],
						"cooldownBurn": "160/145/130",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								120,
								90,
								60
							],
							[
								250,
								350,
								450
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"120/90/60",
							"250/350/450",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.55,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "SorakaR.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Salvation",
					"description": "Soraka runs faster towards nearby low health allies.",
					"image": {
						"full": "Soraka_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Soraka",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3096",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Soraka",
						"title": "SorakaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3301",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3504",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3060",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Swain": {
				"id": "Swain",
				"key": "50",
				"name": "Swain",
				"title": "the Noxian Grand General",
				"image": {
					"full": "Swain.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "50000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "50001",
						"num": 1,
						"name": "Northern Front Swain",
						"chromas": false
					},
					{
						"id": "50002",
						"num": 2,
						"name": "Bilgewater Swain",
						"chromas": false
					},
					{
						"id": "50003",
						"num": 3,
						"name": "Tyrant Swain",
						"chromas": false
					},
					{
						"id": "50004",
						"num": 4,
						"name": "Dragon Master Swain",
						"chromas": false
					}
				],
				"lore": "Jericho Swain is the visionary ruler of Noxus, an expansionist nation that reveres only strength. Though he was cast down and crippled in the Ionian wars, his left arm severed, he seized control of the empire with ruthless determination… and a new, demonic hand. Now, Swain commands from the front lines, marching against a coming darkness that only he can see—in glimpses gathered by shadowy ravens from the corpses all around him. In a swirl of sacrifice and secrets, the greatest secret of all is that the true enemy lies within.",
				"blurb": "Jericho Swain is the visionary ruler of Noxus, an expansionist nation that reveres only strength. Though he was cast down and crippled in the Ionian wars, his left arm severed, he seized control of the empire with ruthless determination… and a new...",
				"allytips": [
					"If you're having trouble rooting an enemy with Nevermove, try throwing it at opponents when they are near their minions so the explosion surprises them.",
					"While laning, try to use Death's Hand's piercing damage to damage opponents from a safe distance.",
					"Vision of Empire is quite difficult to land on its own, look for skirmishes around the map where enemies may be distracted or crowd controlled so you can land it more easily.",
					"Demonic Ascension may make Swain very hard to kill but he's pretty easy to get away from. Try building items that can slow opponents to keep them in range if their mobility is overwhelming."
				],
				"enemytips": [
					"Swain's passive is very potent if you are immobilized. Make sure to be extra careful around enemies who have immobilizing effects.",
					"High mobility counters all of Swain's basic abilities: Death's Hand does more damage the closer he is, Vision of Empire has a very long delay and Nevermove must start returning back to him to be dangerous.",
					"Buying an item with Grievous Wounds will make Swain much easier to kill during his Demonic Ascension."
				],
				"tags": [
					"Mage",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 6,
					"magic": 9,
					"difficulty": 8
				},
				"stats": {
					"hp": 525,
					"hpperlevel": 90,
					"mp": 374,
					"mpperlevel": 57,
					"movespeed": 335,
					"armor": 22.72,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 7,
					"hpregenperlevel": 0.65,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 58,
					"attackdamageperlevel": 2.7,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.11
				},
				"spells": [
					{
						"id": "SwainQ",
						"name": "Death's Hand",
						"description": "Swain unleashes several bolts of eldritch power that pierce through targets killed. Enemies hit take more damage for each bolt they are struck by.",
						"tooltip": "Swain unleashes {{ e5 }} bolts of eldritch power that strike the first enemy they hit and pierce through enemies they kill. Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, plus {{ e2 }}% per additional bolt. Max Damage: {{ f2 }}.<br /><br />Each unit killed by Death's Hand restores <span class=\"color44DDFF\">{{ f1 }}</span> Mana ({{ e4 }}% max mana).",
						"leveltip": {
							"label": [
								"Bolt Damage",
								"Additional Bolt Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7.5,
							6.25,
							5,
							3.75,
							2.5
						],
						"cooldownBurn": "7.5/6.25/5/3.75/2.5",
						"cost": [
							65,
							70,
							75,
							80,
							85
						],
						"costBurn": "65/70/75/80/85",
						"effect": [
							null,
							[
								65,
								85,
								105,
								125,
								145
							],
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								700,
								700,
								700,
								700,
								700
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								-0.4,
								-0.4,
								-0.4,
								-0.4,
								-0.4
							]
						],
						"effectBurn": [
							null,
							"65/85/105/125/145",
							"15/20/25/30/35",
							"3",
							"3",
							"5",
							"0.4",
							"700",
							"15/17.5/20/22.5/25",
							"0.75",
							"-0.4"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "SwainQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SwainW",
						"name": "Vision of Empire",
						"description": "Swain opens a demon eye that deals damage and slows enemies. Champions hit are revealed and also grant Swain a Soul Fragment.",
						"tooltip": "Swain opens a demon eye up to {{ castrange }} range away that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slows for {{ e4 }}% for {{ e7 }} seconds.<br /><br />Champions hit grant Swain a <span class=\"size18 colorFF3F3F\">Soul Fragment</span> and are revealed for {{ e9 }} seconds.<br /><br /><rules>Damage is reduced by {{ e6 }}% against minions.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Reveal Duration",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e9 }} -> {{ e9NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							21,
							20,
							19,
							18
						],
						"cooldownBurn": "22/21/20/19/18",
						"cost": [
							70,
							85,
							100,
							115,
							130
						],
						"costBurn": "70/85/100/115/130",
						"effect": [
							null,
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								0.05,
								0.05,
								0.05,
								0.05,
								0.05
							],
							[
								265,
								265,
								265,
								265,
								265
							],
							[
								25,
								35,
								45,
								55,
								65
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								420,
								420,
								420,
								420,
								420
							],
							[
								4,
								5,
								6,
								7,
								8
							],
							[
								4,
								5,
								6,
								7,
								8
							]
						],
						"effectBurn": [
							null,
							"100/150/200/250/300",
							"0.05",
							"265",
							"25/35/45/55/65",
							"0.5",
							"50",
							"2.5",
							"420",
							"4/5/6/7/8",
							"4/5/6/7/8"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3500,
							3500,
							3500,
							3500,
							3500
						],
						"rangeBurn": "3500",
						"image": {
							"full": "SwainW.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SwainE",
						"name": "Nevermove",
						"description": "Swain launches a wave of demonic power forward. It then returns to Swain and roots enemies it hits.",
						"tooltip": "Swain launches a wave of demonic power, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to enemies it passes through.<br /><br />Swain then commands the wave to return, detonating it on the first enemy hit. Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are rooted for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Pass-through Damage",
								"Detonation Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								35,
								45,
								55,
								65,
								75
							],
							[
								35,
								70,
								105,
								140,
								175
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1500,
								1500,
								1500,
								1500,
								1500
							],
							[
								-0.5,
								-0.5,
								-0.5,
								-0.5,
								-0.5
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								60,
								85,
								105,
								125,
								150
							],
							[
								60,
								85,
								105,
								125,
								150
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								400,
								400,
								400,
								400,
								400
							]
						],
						"effectBurn": [
							null,
							"35/45/55/65/75",
							"35/70/105/140/175",
							"1.5",
							"1500",
							"-0.5",
							"0.75",
							"60/85/105/125/150",
							"60/85/105/125/150",
							"15",
							"400"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "SwainE.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SwainR",
						"name": "Demonic Ascension",
						"description": "Swain transforms into a demon and drains health from the 3 closest enemy champions. After draining enough health, Swain can cast Demonflare to end his transformation and decimate nearby enemies with a nova of soulfire.",
						"tooltip": "Swain frees the demon within for {{ e3 }} seconds, gaining {{ e6 }} health. Every second, he drains the 3 closest enemy champions for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, healing him for {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> health. After draining <scaleLevel>{{ f7 }}</scaleLevel> health, Swain gains the ability to cast Demonflare.<br /><br /><span class=\"colorDDDD77\">Demonflare:</span> Swain unleashes a nova of soulfire dealing magic damage and ending his transformation. Damage per <span class=\"size18 colorFF3F3F\">Soul Fragment</span>: {{ e0 }} <span class=\"color99FF99\">(+{{ f1 }})</span>.<br /><br />Current Damage: {{ f3 }}<br />Max Damage: {{ f2 }}<br /><br /><rules>Swain can drain non-champions to heal for {{ e7 }}% of the normal amount.",
						"leveltip": {
							"label": [
								"Health Gain",
								"Drain Damage",
								"Drain Heal",
								"Damage Per Soul"
							],
							"effect": [
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e0 }} -> {{ e0NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							120,
							120
						],
						"cooldownBurn": "120",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								35,
								50,
								65
							],
							[
								1,
								1,
								1
							],
							[
								12,
								12,
								12
							],
							[
								20,
								35,
								50
							],
							[
								0.04,
								0.06,
								0.08
							],
							[
								150,
								275,
								400
							],
							[
								20,
								20,
								20
							],
							[
								0.27,
								0.27,
								0.27
							],
							[
								0,
								0,
								0
							],
							[
								45,
								60,
								75
							]
						],
						"effectBurn": [
							null,
							"35/50/65",
							"1",
							"12",
							"20/35/50",
							"0.04/0.06/0.08",
							"150/275/400",
							"20",
							"0.27",
							"0",
							"45/60/75"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.14,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.16,
								"key": "a2"
							}
						],
						"costType": "All Soul Fragments",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "SwainR.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "All Soul Fragments"
					}
				],
				"passive": {
					"name": "Ravenous Flock",
					"description": "Swain's ravens collect <i>Soul Fragments</i> that heal him. Swain can right-click an immobilized enemy champions to pull them closer to him, dealing damage and ripping out a <i>Soul Fragment</i>.",
					"image": {
						"full": "Swain_P.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Swain",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3001",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Swain",
						"title": "SwainTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Syndra": {
				"id": "Syndra",
				"key": "134",
				"name": "Syndra",
				"title": "the Dark Sovereign",
				"image": {
					"full": "Syndra.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "134000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "134001",
						"num": 1,
						"name": "Justicar Syndra",
						"chromas": false
					},
					{
						"id": "134002",
						"num": 2,
						"name": "Atlantean Syndra",
						"chromas": false
					},
					{
						"id": "134003",
						"num": 3,
						"name": "Queen of Diamonds Syndra",
						"chromas": false
					},
					{
						"id": "134004",
						"num": 4,
						"name": "Snow Day Syndra",
						"chromas": false
					},
					{
						"id": "134005",
						"num": 5,
						"name": "SKT T1 Syndra",
						"chromas": false
					},
					{
						"id": "134006",
						"num": 6,
						"name": "Star Guardian Syndra",
						"chromas": false
					}
				],
				"lore": "Syndra is a fearsome dark mage with incredible power at her command. As a child of Ionia, she disturbed the village elders with her prodigious but reckless use of magic. They sent her away to be trained under strict supervision, but she quickly surpassed her mentor and discovered he was restraining her powers. Betrayed and disgusted by such cowardice, Syndra eliminated her teacher and struck out to destroy all who would try to limit her potential, dark spheres in hand.",
				"blurb": "Syndra is a fearsome dark mage with incredible power at her command. As a child of Ionia, she disturbed the village elders with her prodigious but reckless use of magic. They sent her away to be trained under strict supervision, but she quickly...",
				"allytips": [
					"To maximize your ultimate's damage use it when there are many spheres on the battlefield.",
					"After you hit an enemy champion with Force of Will follow up with Dark Sphere, they'll be slowed and have a hard time avoiding it.",
					"Get one of your spells to rank 5 as quickly as possible, they gain powerful bonus effects at max rank."
				],
				"enemytips": [
					"Get boots early when playing against Syndra, they'll help you avoid many of her spells.",
					"Attack Syndra after she's used Scatter the Weak, it has a long cooldown so she'll be vulnerable.",
					"At max rank Syndra's spells gain bonus effects and change in appearance."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 3,
					"magic": 9,
					"difficulty": 8
				},
				"stats": {
					"hp": 523,
					"hpperlevel": 90,
					"mp": 384,
					"mpperlevel": 60,
					"movespeed": 330,
					"armor": 24.712,
					"armorperlevel": 3.4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.872,
					"attackdamageperlevel": 2.9,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "SyndraQ",
						"name": "Dark Sphere",
						"description": "Syndra conjures a Dark Sphere dealing magic damage. The sphere remains and can be manipulated by her other powers.",
						"tooltip": "Conjures a Dark Sphere dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The sphere remains for <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can be manipulated by Syndra's other abilities.<br /><br /><span class=\"color99FF99\">This spell can be cast while moving.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							40,
							50,
							60,
							70,
							80
						],
						"costBurn": "40/50/60/70/80",
						"effect": [
							null,
							[
								50,
								95,
								140,
								185,
								230
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								2,
								2.2,
								2.4,
								2.6,
								2.8
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/95/140/185/230",
							"6",
							"2/2.2/2.4/2.6/2.8",
							"8",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "SyndraQ.png",
							"sprite": "spell10.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SyndraW",
						"name": "Force of Will",
						"description": "Syndra picks up and throws a Dark Sphere or enemy minion dealing magic damage and slowing the Movement Speed of enemies. ",
						"tooltip": "<span class=\"colorFF9900\">First Cast:</span> Grabs target Dark Sphere or enemy minion. If no target is selected, grabs nearest Dark Sphere.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Throws the grabbed unit. Enemies hit take {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed by <span class=\"colorFFFFFF\">{{ e1 }}%</span> for {{ f2 }} seconds.<br /><br /><span class=\"color99FF99\">This spell can be cast while moving.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }} ",
								"{{ cost }} -> {{ costNL }} ",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								12,
								11,
								10,
								9,
								8
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								0.2,
								0.2,
								0.2,
								0.2,
								0.2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"25/30/35/40/45",
							"70/110/150/190/230",
							"12/11/10/9/8",
							"1.5",
							"400",
							"0.2",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "@text",
								"coeff": 1.5,
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "SyndraW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SyndraE",
						"name": "Scatter the Weak",
						"description": "Syndra knocks enemies and Dark Spheres back dealing magic damage. Enemies hit by Dark Spheres become stunned.",
						"tooltip": "Knocks enemies and Dark Spheres back dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to them and any enemies they collide with.<br /><br />Dark Spheres that are knocked back stun all enemies in their path for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ cooldown }} -> {{ cooldownNL }} "
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/115/160/205/250",
							"1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "SyndraE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "SyndraR",
						"name": "Unleashed Power",
						"description": "Syndra bombards an enemy Champion with all of her Dark Spheres.",
						"tooltip": "Draws upon Syndra's full cataclysmic power, harnessing Dark Spheres to deal magic damage to target enemy Champion. Unleashed Power manipulates the three Dark Spheres orbiting Syndra, in addition to up to 4 Dark Spheres previously created.<br /><br />Damage per sphere: {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>.<br />Minimum total damage: {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span>.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }} ",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								90,
								135,
								180
							],
							[
								270,
								405,
								540
							],
							[
								7,
								7,
								7
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"90/135/180",
							"270/405/540",
							"7",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							675,
							675,
							675
						],
						"rangeBurn": "675",
						"image": {
							"full": "SyndraR.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Transcendent",
					"description": "Spells gain extra effects at max rank.<br><br><font color='#FF9900'>Dark Sphere</font>: Sphere's lifetime is increased to 8 seconds.<br><font color='#FF9900'>Force of Will</font>: Deals 20% bonus true damage.<br><font color='#FF9900'>Scatter the Weak</font>: Spell width increased by 50%.<br><font color='#FF9900'>Unleashed Power</font>: Range increased by 75.",
					"image": {
						"full": "SyndraPassive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Syndra",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraSG",
						"map": "CityPark",
						"mode": "STARGUARDIAN",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Syndra",
						"title": "SyndraTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"TahmKench": {
				"id": "TahmKench",
				"key": "223",
				"name": "Tahm Kench",
				"title": "the River King",
				"image": {
					"full": "TahmKench.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "223000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "223001",
						"num": 1,
						"name": "Master Chef Tahm Kench",
						"chromas": false
					},
					{
						"id": "223002",
						"num": 2,
						"name": "Urf Kench",
						"chromas": false
					}
				],
				"lore": "Known by many names throughout history, the demon Tahm Kench travels the waterways of Runeterra, feeding his insatiable appetite with the misery of others. Though he may appear singularly charming and proud, he swaggers through the physical realm like a vagabond in search of unsuspecting prey. His lashing tongue can stun even a heavily armored warrior from a dozen paces, and to fall into his rumbling belly is to tumble into an abyss from which there is little hope of return.",
				"blurb": "Known by many names throughout history, the demon Tahm Kench travels the waterways of Runeterra, feeding his insatiable appetite with the misery of others. Though he may appear singularly charming and proud, he swaggers through the physical realm like a...",
				"allytips": [
					"Your most important function as a support is to keep fragile allies safe. Keep Devour's range and cooldown in mind and position accordingly!",
					"Consider carefully when to use Thick Skin's active. Sometimes shielding early to avoid further damage is good, but sometimes the healing is more beneficial."
				],
				"enemytips": [
					"When you see Tahm Kench use the shield from Thick Skin, remember that he just opted out of a good deal of healing. He will also not accumulate new gray health until Thick Skin comes off cooldown. Use this to your advantage!",
					"If Tahm Kench harasses you by spitting minions at you, try going in for a trade right after he spits. His Devour will be on cooldown and you should be able to trade favourably if he can't eat you."
				],
				"tags": [
					"Support",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 3,
					"defense": 9,
					"magic": 6,
					"difficulty": 5
				},
				"stats": {
					"hp": 610,
					"hpperlevel": 95,
					"mp": 325,
					"mpperlevel": 40,
					"movespeed": 335,
					"armor": 47,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 6.5,
					"hpregenperlevel": 0.55,
					"mpregen": 8,
					"mpregenperlevel": 1,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 56,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "TahmKenchQ",
						"name": "Tongue Lash",
						"description": "Tahm Kench lashes out with his tongue, damaging and slowing the first unit hit. This ability gains a stun after three stacks of An Acquired Taste.",
						"tooltip": "Damage the first enemy hit for {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slow them by {{ e4 }}% for {{ e5 }}s. Champions with 3 stacks of An Acquired Taste will additionally be stunned for {{ e6 }}s.<br /><br />Activate <span class=\"color0bf7de\">Devour</span> while your tongue is in midair to devour monsters/minions from a distance.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Slow Amount"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e4 }}% -> {{ e4NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								875,
								875,
								875,
								875,
								875
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								80,
								130,
								180,
								230,
								280
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"875",
							"1000",
							"80/130/180/230/280",
							"30/40/50/60/70",
							"2",
							"1.5",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "TahmKenchQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TahmKenchW",
						"name": "Devour",
						"description": "Tahm Kench devours a target, dealing a percentage of their maximum health as magic damage. He can spit devoured minions and monsters out as a skillshot that deals magic damage in an area upon impact.",
						"tooltip": "Devour a target for {{ e1 }}s (half that for enemy champions.) Enemies are dealt {{ e3 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of their maximum health as magic damage (maximum of {{ e2 }} against neutral monsters).<br /><br /><span class=\"colorFF9900\">Enemy Champions:</span> Requires 3 stacks of An Acquired Taste to be devoured. While holding an enemy champion, Tahm Kench is slowed by 95%. <br /><br /><span class=\"colorFF9900\">Allied Champions:</span> While holding an allied champion, Tahm Kench gains {{ e4 }}% movement speed toward enemy champions.<br /><br /><span class=\"colorFF9900\">Minions and Monsters:</span> Reactivate to spit them, dealing {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to targets hit.",
						"leveltip": {
							"label": [
								"Devour Duration",
								"Max Health Damage",
								"Max Damage to Monsters",
								"Minion Spit Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}s -> {{ e1NL }}s",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							13,
							12,
							11,
							10
						],
						"cooldownBurn": "14/13/12/11/10",
						"cost": [
							90,
							90,
							90,
							90,
							90
						],
						"costBurn": "90",
						"effect": [
							null,
							[
								4,
								4.5,
								5,
								5.5,
								6
							],
							[
								400,
								450,
								500,
								550,
								600
							],
							[
								20,
								23,
								26,
								29,
								32
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/4.5/5/5.5/6",
							"400/450/500/550/600",
							"20/23/26/29/32",
							"30/35/40/45/50",
							"0",
							"0",
							"100/150/200/250/300",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.02,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							250,
							250,
							250,
							250,
							250
						],
						"rangeBurn": "250",
						"image": {
							"full": "TahmKenchW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TahmKenchE",
						"name": "Thick Skin",
						"description": "Tahm Kench turns incoming damage into gray health. As gray health decays, Tahm Kench is healed for a percentage of the gray health amount. When activated, this ability turns all gray health into a shield.",
						"tooltip": "<span class=\"colorFF9900\">Passive:</span> {{ e3 }}% of the Damage taken while this ability is not cooling down is converted to gray health. If allowed to decay, {{ e2 }}% of gray health will turn back into health.<br /><br /><span class=\"colorFF9900\">Active:</span> Convert all of your gray health into a shield that lasts {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Damage to Gray Health Conversion",
								"Gray Health to Healing Conversion"
							],
							"effect": [
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								70,
								75,
								80,
								85,
								90
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"3",
							"25/30/35/40/45",
							"70/75/80/85/90",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "TahmKenchE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TahmKenchNewR",
						"name": "Abyssal Voyage",
						"description": "Tahm Kench teleports across the map, and he may bring one ally champion with him.",
						"tooltip": "Begin to channel for up to 6 seconds. During this time, one ally champion can right click Tahm Kench to join in. Alternatively, reactivate this ability to travel alone. On reactivation or once an ally has opted in, Tahm travels to the target location. Incoming champion damage breaks the channel.<br /><br /><span class=\"colorcccccc\"><i>'Boy, the world's one river, and I'm its king. Ain't no place I ain't been; ain't no place I can't go again.'</i></span>",
						"leveltip": {
							"label": [
								"Cooldown",
								"Range"
							],
							"effect": [
								"{{ cooldown }}s -> {{ cooldownNL }}s",
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								4500,
								5500,
								6500
							],
							[
								0.02,
								0.04,
								0.06
							],
							[
								20,
								20,
								20
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4500/5500/6500",
							"0.02/0.04/0.06",
							"20",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							4500,
							5500,
							6500
						],
						"rangeBurn": "4500/5500/6500",
						"image": {
							"full": "TahmKenchNewR.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "An Acquired Taste",
					"description": "Tahm Kench puts the heft of his immense body behind his attacks and abilities, gaining extra damage based on his total health. Damaging enemy champions builds stacks of An Acquired Taste. At three stacks, he can use Devour on an enemy champion.",
					"image": {
						"full": "TahmKench_P.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Maokai",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1054",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1054",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "3067",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3067",
										"count": 1
									},
									{
										"id": "3211",
										"count": 1
									},
									{
										"id": "3065",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3025",
										"count": 1
									},
									{
										"id": "3068",
										"count": 1
									},
									{
										"id": "3001",
										"count": 1
									},
									{
										"id": "3105",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TahmKench",
						"title": "TahmKenchTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Taliyah": {
				"id": "Taliyah",
				"key": "163",
				"name": "Taliyah",
				"title": "the Stoneweaver",
				"image": {
					"full": "Taliyah.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "163000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "163001",
						"num": 1,
						"name": "Freljord Taliyah",
						"chromas": false
					}
				],
				"lore": "Taliyah is a nomadic mage from Shurima, torn between teenage wonder and adult responsibility. She has crossed nearly all of Valoran on a journey to learn the true nature of her growing powers, though more recently she has returned to protect her tribe. Some have mistaken her compassion for weakness and paid the ultimate price—for beneath Taliyah's youthful demeanor is a will strong enough to move mountains, and a spirit fierce enough to make the earth itself tremble.",
				"blurb": "Taliyah is a nomadic mage from Shurima, torn between teenage wonder and adult responsibility. She has crossed nearly all of Valoran on a journey to learn the true nature of her growing powers, though more recently she has returned to protect her tribe...",
				"allytips": [
					"Try to throw enemies into Unraveled Earth using Seismic Shove.",
					"Remember, you don't always have to ride Weaver's Wall.",
					"Once you have Rylai's Crystal Scepter, casting Threaded Volley at enemies chasing you is a great way of making them regret everything."
				],
				"enemytips": [
					"When Taliyah casts Unraveled Earth in the lane, be on the lookout for Seismic Shove. If she throws you into her minefield, the throws and stones will break your bones.",
					"Taliyah's Threaded Volley is locked into a direction. If she's throwing rocks at you, dodge to the side!"
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 7,
					"magic": 8,
					"difficulty": 5
				},
				"stats": {
					"hp": 532,
					"hpperlevel": 90,
					"mp": 340,
					"mpperlevel": 60,
					"movespeed": 325,
					"armor": 20,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 7,
					"hpregenperlevel": 0.7,
					"mpregen": 7,
					"mpregenperlevel": 0.85,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 56,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "TaliyahQ",
						"name": "Threaded Volley",
						"description": "Taliyah throws a volley of missiles in a target direction, moving freely as she does. This works the ground below her. If Taliyah casts Threaded Volley on worked ground, she only throws one missile.",
						"tooltip": "Hurls 5 rocks in a direction, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage in a small area around the first enemy hit. Subsequent hits on the same unit deal {{ e2 }}% reduced damage. Creates <span class=\"colora56705\">Worked Ground</span> for <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds.<br /><br />Taliyah gains <span class=\"colorffffff\">{{ f2 }}%</span> movement speed on <span class=\"colora56705\">Worked Ground</span>. Casting Threaded Volley on <span class=\"colora56705\">Worked Ground</span> only hurls one rock but refunds {{ e7 }}% of its mana cost.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							7.5,
							6,
							4.5,
							3
						],
						"cooldownBurn": "9/7.5/6/4.5/3",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								70,
								95,
								120,
								145,
								170
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								160,
								160,
								160,
								160,
								160
							],
							[
								120,
								120,
								120,
								120,
								120
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/95/120/145/170",
							"60",
							"0",
							"0",
							"160",
							"120",
							"50",
							"450",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "TaliyahQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TaliyahWVC",
						"name": "Seismic Shove",
						"description": "Taliyah causes an area of ground to erupt and throws enemies within in a direction of her choosing.",
						"tooltip": "Taliyah targets an area. After a short delay, enemies caught within the area will be <span class=\"colorffffff\">pushed</span> and dealt {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />You can control the direction enemies will be <span class=\"colorffffff\">pushed</span> by clicking and dragging your mouse in a line.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								0.55,
								0.55,
								0.55,
								0.55,
								0.55
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/80/100/120/140",
							"0.55",
							"400",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "TaliyahWVC.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TaliyahE",
						"name": "Unraveled Earth",
						"description": "Taliyah creates a slowing minefield that explodes if enemies dash through it or are pushed/pulled through it.",
						"tooltip": "Places a field of dash-sensitive traps that deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slow enemies in the area by <span class=\"color99FF99\">{{ f2 }}%</span>. After {{ e3 }} seconds, the traps explode, dealing damage again.<br /><br />Enemies <span class=\"colorFFFFFF\">dashing</span>, being <span class=\"colorFFFFFF\">pushed</span>, or being <span class=\"colorFFFFFF\">pulled</span> through Unraveled Earth will trigger traps, taking {{ f3 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage from each trap (maximum 4, each hit after the first deals {{ f4 }}% less damage).",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14,
							12,
							10,
							8
						],
						"cooldownBurn": "16/14/12/10/8",
						"cost": [
							90,
							95,
							100,
							105,
							110
						],
						"costBurn": "90/95/100/105/110",
						"effect": [
							null,
							[
								70,
								90,
								110,
								130,
								150
							],
							[
								-0.2,
								-0.2,
								-0.2,
								-0.2,
								-0.2
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								85,
								85,
								85,
								85,
								85
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.15,
								0.15,
								0.15,
								0.15,
								0.15
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/90/110/130/150",
							"-0.2",
							"4",
							"85",
							"0.5",
							"4",
							"0.15",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "TaliyahE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TaliyahR",
						"name": "Weaver's Wall",
						"description": "Taliyah creates a very long wall and then surfs it.",
						"tooltip": "Cast once to create a wall. Recast immediately to ride ahead of the wall. Moving or receiving damage will cause Taliyah to stop.<br /><br />Weaver's Wall lasts for {{ e1 }} seconds. Deactivate this spell to break the wall early.",
						"leveltip": {
							"label": [
								"Duration",
								"Wall length",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}s -> {{ e1NL }}s",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 3,
						"cooldown": [
							180,
							150,
							120
						],
						"cooldownBurn": "180/150/120",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								6,
								7,
								8
							],
							[
								3000,
								4500,
								6000
							],
							[
								0.1,
								0.1,
								0.1
							],
							[
								2500,
								2500,
								2500
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6/7/8",
							"3000/4500/6000",
							"0.1",
							"2500",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3000,
							4500,
							6000
						],
						"rangeBurn": "3000/4500/6000",
						"image": {
							"full": "TaliyahR.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Rock Surfing",
					"description": "Taliyah gains movement speed near walls.",
					"image": {
						"full": "Taliyah_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Taliyah",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Taliyah",
						"title": "TaliyahTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Talon": {
				"id": "Talon",
				"key": "91",
				"name": "Talon",
				"title": "the Blade's Shadow",
				"image": {
					"full": "Talon.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "91000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "91001",
						"num": 1,
						"name": "Renegade Talon",
						"chromas": false
					},
					{
						"id": "91002",
						"num": 2,
						"name": "Crimson Elite Talon",
						"chromas": false
					},
					{
						"id": "91003",
						"num": 3,
						"name": "Dragonblade Talon",
						"chromas": true
					},
					{
						"id": "91004",
						"num": 4,
						"name": "SSW Talon",
						"chromas": false
					},
					{
						"id": "91005",
						"num": 5,
						"name": "Blood Moon Talon",
						"chromas": false
					}
				],
				"lore": "Talon is the knife in the darkness, a merciless killer able to strike without warning and escape before any alarm is raised. He carved out a dangerous reputation on the brutal streets of Noxus, where he was forced to fight, kill, and steal to survive. Adopted by the notorious Du Couteau family, he now plies his deadly trade at the empire's command, assassinating enemy leaders, captains, and heroes… as well as any Noxian foolish enough to earn the scorn of their masters.",
				"blurb": "Talon is the knife in the darkness, a merciless killer able to strike without warning and escape before any alarm is raised. He carved out a dangerous reputation on the brutal streets of Noxus, where he was forced to fight, kill, and steal to survive...",
				"allytips": [
					"You can use Assassin's Path to get behind the enemy and set up for Noxian Diplomacy's melee attack.",
					"Shadow Assault is a powerful escape tool, but can also be offensively used to assault a group.",
					"Remember to pick your target before the fight. Focusing all of Talon's abilities on one target can be very rewarding, but splitting them up between many may leave you helpless."
				],
				"enemytips": [
					"Talon's attacks are all physical damage. Build armor early to counter his burst damage.",
					"Talon is heavily reliant on Shadow Assault to escape a fight. When it is down he's significantly more vulnerable.",
					"Talon has unrivaled roaming ability. Make sure to keep track of his position or force him to stay in lane by pushing aggressively."
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 3,
					"magic": 1,
					"difficulty": 7
				},
				"stats": {
					"hp": 588,
					"hpperlevel": 95,
					"mp": 377.2,
					"mpperlevel": 37,
					"movespeed": 335,
					"armor": 30,
					"armorperlevel": 3.5,
					"spellblock": 39,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.75,
					"mpregen": 7.6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.1,
					"attackspeedoffset": -0.065,
					"attackspeedperlevel": 2.9
				},
				"spells": [
					{
						"id": "TalonQ",
						"name": "Noxian Diplomacy",
						"description": "Talon stabs the target unit. If they are within melee range, this attack deals critical damage. If they are outside melee range, Talon will leap at his target before stabbing them. Talon refunds some health and cooldown if this ability kills the target.",
						"tooltip": "Talon leaps to target and deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. If cast from melee range, Talon does not leap but instead critically strikes, dealing {{ f2 }}% damage <span class=\"colorFF8C00\">({{ f3 }})</span>.<br /><br />When Noxian Diplomacy kills a unit, Talon regains <span class=\"colorFFFFFF\">{{ f4 }}</span> health and refunds {{ e5 }}% of its cooldown.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f5 }} -> {{ f6 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								65,
								90,
								115,
								140,
								165
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								17,
								17,
								17,
								17,
								17
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								8,
								7.5,
								7,
								6.5,
								6
							],
							[
								0.8,
								0.8,
								0.8,
								0.8,
								0.8
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/90/115/140/165",
							"50",
							"17",
							"3",
							"50",
							"8/7.5/7/6.5/6",
							"0.8",
							"1.5",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "TalonQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TalonW",
						"name": "Rake",
						"description": "Talon sends out a volley of daggers that then return back to him, dealing physical damage every time it passes through an enemy. The returning blades deal bonus damage and slow units hit.",
						"tooltip": "Talon tosses a volley of blades, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to units hit and returning to him after a delay.<br /><br />On their way back to Talon, the blades deal {{ e5 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> additional damage and slow the enemy by {{ e2 }}% for 1 second.",
						"leveltip": {
							"label": [
								"Initial Damage",
								"Return Damage",
								"Slow Amount",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							55,
							60,
							65,
							70,
							75
						],
						"costBurn": "55/60/65/70/75",
						"effect": [
							null,
							[
								50,
								65,
								80,
								95,
								110
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								14,
								13,
								12,
								11,
								10
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								70,
								95,
								120,
								145,
								170
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/65/80/95/110",
							"40/45/50/55/60",
							"14/13/12/11/10",
							"2",
							"70/95/120/145/170",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "TalonW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TalonE",
						"name": "Assassin's Path",
						"description": "Talon vaults over any terrain or structure, up to a max distance. This ability has a low cooldown, but puts the used terrain on a long cooldown.",
						"tooltip": "Talon vaults up to {{ f2 }} units over the nearest structure or terrain in the target direction. The vault's speed is affected by Talon's movement speed.<br /><br />Talon cannot dash over the same section of terrain more than once every <span class=\"colorFFFFFF\">{{ f3 }}</span> seconds.",
						"leveltip": {
							"label": [
								"Terrain Cooldown"
							],
							"effect": [
								"{{ f3 }} -> {{ f4 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								625,
								625,
								625,
								625,
								625
							],
							[
								1250,
								1250,
								1250,
								1250,
								1250
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								160,
								135,
								110,
								85,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0",
							"0",
							"625",
							"1250",
							"2",
							"160/135/110/85/60",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No cost",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "TalonE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "No cost"
					},
					{
						"id": "TalonR",
						"name": "Shadow Assault",
						"description": "Talon disperses a ring of blades and becomes Invisible while gaining additional Movement Speed. When Talon emerges from Invisibility, the blades converge on his location. Each time the blades move, Shadow Assault deals physical damage to enemies hit by at least one blade.  ",
						"tooltip": "Talon disperses a ring of blades that deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to all units they hit, gains {{ e2 }}% increased movement speed, and becomes <span class=\"color91d7ee\">Invisible</span> for up to {{ e3 }} seconds. When the <span class=\"color91d7ee\">Invisibility</span> ends, the blades converge, dealing the same damage again to enemies they pass through.<br /><br />If Talon cancels <span class=\"color91d7ee\">Invisibility</span> with an attack or Noxian Diplomacy, the blades converge on his target's location instead.<br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Talon can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							80,
							60
						],
						"cooldownBurn": "100/80/60",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								90,
								135,
								180
							],
							[
								40,
								55,
								70
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"90/135/180",
							"40/55/70",
							"2.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "TalonR.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Blade's End",
					"description": "Talon's spells Wound champions and epic monsters, stacking up to 3 times. When Talon attacks a champion with 3 stacks of Wound, they bleed for heavy damage over time.",
					"image": {
						"full": "TalonP.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Talon",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Talon",
						"title": "TalonTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3104",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Taric": {
				"id": "Taric",
				"key": "44",
				"name": "Taric",
				"title": "the Shield of Valoran",
				"image": {
					"full": "Taric.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "44000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "44001",
						"num": 1,
						"name": "Emerald Taric",
						"chromas": false
					},
					{
						"id": "44002",
						"num": 2,
						"name": "Armor of the Fifth Age Taric",
						"chromas": false
					},
					{
						"id": "44003",
						"num": 3,
						"name": "Bloodstone Taric",
						"chromas": false
					},
					{
						"id": "44004",
						"num": 4,
						"name": "Pool Party Taric",
						"chromas": false
					}
				],
				"lore": "Taric is the Aspect of the Protector, wielding incredible power as Runeterra's guardian of life, love, and beauty. Shamed by a dereliction of duty and exiled from his homeland Demacia, Taric ascended Mount Targon to find redemption, only to discover a higher calling among the stars. Imbued with the might of ancient Targon, the Shield of Valoran now stands ever vigilant against the insidious corruption of the Void.",
				"blurb": "Taric is the Aspect of the Protector, wielding incredible power as Runeterra's guardian of life, love, and beauty. Shamed by a dereliction of duty and exiled from his homeland Demacia, Taric ascended Mount Targon to find redemption, only to discover a...",
				"allytips": [
					"The cooldown reducing component of Bravado makes Cooldown Reduction items like Frozen Heart, Iceborn Gauntlet, and Spirit Visage exceptionally powerful on Taric.",
					"Using Starlight's Touch at lower charges makes its healing less Mana efficient, but can greatly increase Taric's sustained damage via Bravado.",
					"Rather than saving Cosmic Radiance for the last moment and risking someone dying during the delay, it can be more beneficial to cast it as soon as you know a teamfight is guaranteed to start."
				],
				"enemytips": [
					"Taric's ultimate, Cosmic Radiance, has a long delay before its effect. Try to quickly assess whether to disengage the fight or attempt to kill his allies before it goes off.",
					"Taric reduces his spell cooldowns by basic attacking enemies with Bravado. Try to kite him in teamfights and punish him for approaching the minion wave in lane."
				],
				"tags": [
					"Support",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 8,
					"magic": 5,
					"difficulty": 3
				},
				"stats": {
					"hp": 575,
					"hpperlevel": 90,
					"mp": 300,
					"mpperlevel": 60,
					"movespeed": 340,
					"armor": 40,
					"armorperlevel": 3.4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 150,
					"hpregen": 6,
					"hpregenperlevel": 0.5,
					"mpregen": 8.5,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "TaricQ",
						"name": "Starlight's Touch",
						"description": "Heals nearby allied champions based on charges stored. Bravado-empowered attacks grant a charge of Starlight's Touch.",
						"tooltip": "Spends all charges to heal nearby allied champions for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFF3300\">(+{{ f1 }})</span> ({{ e2 }}% of maximum Health) per charge, up to {{ e5 }} <span class=\"color99FF99\">(+{{ f3 }})</span> <span class=\"colorFF3300\">(+{{ f2 }})</span> at maximum charges.<br />Maximum charges: {{ e6 }}<br /><br />Bravado-empowered attacks grant 1 charge of Starlight's Touch.",
						"leveltip": {
							"label": [
								"Max Charges",
								"Max Healing",
								"Mana Cost"
							],
							"effect": [
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							3,
							3,
							3,
							3,
							3
						],
						"cooldownBurn": "3",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.2,
								0.4,
								0.6,
								0.8,
								1
							],
							[
								1,
								2,
								3,
								4,
								5
							],
							[
								30,
								60,
								90,
								120,
								150
							],
							[
								1,
								2,
								3,
								4,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30",
							"1",
							"0.2/0.4/0.6/0.8/1",
							"1/2/3/4/5",
							"30/60/90/120/150",
							"1/2/3/4/5",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana, all Charges",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "TaricQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana, all Charges"
					},
					{
						"id": "TaricW",
						"name": "Bastion",
						"description": "Passively increase the Armor of Taric and any allied champion with Bastion.<br><br>Actively shields an ally and grants them Bastion for as long as they remain near Taric. Taric's spells also cast off the ally with Bastion.",
						"tooltip": "Taric's spells will also cast from a nearby ally protected by Bastion.<br /><br /><span class=\"colorFF9900\">Passive: </span>Bastion increases Armor by <span class=\"colorFFFF00\">{{ f1 }}</span> ({{ e1 }}% of Taric's Armor).<br /><br /><span class=\"colorFF9900\">Active: </span>Blesses an ally with Bastion and shields them for {{ e2 }}% of their maximum Health for {{ e3 }} seconds. Bastion lasts on the target until a new one is chosen.",
						"leveltip": {
							"label": [
								"Passive Armor",
								"Shield Ratio"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								10,
								12.5,
								15,
								17.5,
								20
							],
							[
								8,
								9,
								10,
								11,
								12
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								1300,
								1300,
								1300,
								1300,
								1300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/12.5/15/17.5/20",
							"8/9/10/11/12",
							"2.5",
							"1000",
							"1300",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "TaricW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TaricE",
						"name": "Dazzle",
						"description": "Taric readies a beam of starlight that, after a brief delay, deals magic damage and stuns enemies.",
						"tooltip": "Readies a beam of starlight that, after {{ e3 }} second, deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFFFF00\">(+{{ f1 }})</span> magic damage and stuns enemies for {{ e2 }} second(s).",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							16,
							15,
							14,
							13
						],
						"cooldownBurn": "17/16/15/14/13",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								105,
								150,
								195,
								240,
								285
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"105/150/195/240/285",
							"1.25",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							610,
							610,
							610,
							610,
							610
						],
						"rangeBurn": "610",
						"image": {
							"full": "TaricE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TaricR",
						"name": "Cosmic Radiance",
						"description": "Pulses cosmic energy onto nearby allied champions after a delay, making them invulnerable for a short duration.",
						"tooltip": "After a {{ e4 }} second delay, pulses cosmic energy onto nearby allied champions, making them invulnerable for {{ e5 }} seconds.",
						"leveltip": {
							"label": [
								"Cooldown"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							160,
							130,
							100
						],
						"cooldownBurn": "160/130/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								275,
								400
							],
							[
								25,
								35,
								45
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/275/400",
							"25/35/45",
							"2.5",
							"2.5",
							"2.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "TaricR.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Bravado",
					"description": "Spellcasts empower Taric's next 2 basic attacks to deal bonus magic damage, reduce his spell cooldowns, and attack in quick succession.",
					"image": {
						"full": "Taric_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Taric",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3107",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3341",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2045",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3341",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Taric",
						"title": "TaricTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Teemo": {
				"id": "Teemo",
				"key": "17",
				"name": "Teemo",
				"title": "the Swift Scout",
				"image": {
					"full": "Teemo.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "17000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "17001",
						"num": 1,
						"name": "Happy Elf Teemo",
						"chromas": false
					},
					{
						"id": "17002",
						"num": 2,
						"name": "Recon Teemo",
						"chromas": false
					},
					{
						"id": "17003",
						"num": 3,
						"name": "Badger Teemo",
						"chromas": false
					},
					{
						"id": "17004",
						"num": 4,
						"name": "Astronaut Teemo",
						"chromas": false
					},
					{
						"id": "17005",
						"num": 5,
						"name": "Cottontail Teemo",
						"chromas": true
					},
					{
						"id": "17006",
						"num": 6,
						"name": "Super Teemo",
						"chromas": false
					},
					{
						"id": "17007",
						"num": 7,
						"name": "Panda Teemo",
						"chromas": false
					},
					{
						"id": "17008",
						"num": 8,
						"name": "Omega Squad Teemo",
						"chromas": true
					},
					{
						"id": "17014",
						"num": 14,
						"name": "Little Devil Teemo",
						"chromas": false
					}
				],
				"lore": "Undeterred by even the most dangerous and threatening of obstacles, Teemo scouts the world with boundless enthusiasm and a cheerful spirit. A yordle with an unwavering sense of morality, he takes pride in following the Bandle Scout's Code, sometimes with such eagerness that he is unaware of the broader consequences of his actions. Though some say the existence of the Scouts is questionable, one thing is for certain: Teemo's conviction is nothing to be trifled with.",
				"blurb": "Undeterred by even the most dangerous and threatening of obstacles, Teemo scouts the world with boundless enthusiasm and a cheerful spirit. A yordle with an unwavering sense of morality, he takes pride in following the Bandle Scout's Code, sometimes...",
				"allytips": [
					"Teemo's mushrooms can be used to farm creep waves very effectively.",
					"Place your mushrooms at key locations on the map, such as by the Dragon or Baron Nashor, to reveal when your enemies might be attempting to kill them."
				],
				"enemytips": [
					"Teemo's Toxic Shot punishes players who get hit and back out, so stay at a safe range until you're ready to commit.",
					"It can be valuable to use Oracle's Lens(Trinket) to destroy mushrooms around key locations."
				],
				"tags": [
					"Marksman",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 3,
					"magic": 7,
					"difficulty": 6
				},
				"stats": {
					"hp": 528,
					"hpperlevel": 90,
					"mp": 267.2,
					"mpperlevel": 40,
					"movespeed": 330,
					"armor": 24.3,
					"armorperlevel": 3.75,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 500,
					"hpregen": 5.5,
					"hpregenperlevel": 0.65,
					"mpregen": 7.206,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 54,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.0947,
					"attackspeedperlevel": 3.38
				},
				"spells": [
					{
						"id": "BlindingDart",
						"name": "Blinding Dart",
						"description": "Obscures an enemy's vision with a powerful venom, dealing damage to the target unit and blinding it for the duration.",
						"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and blinds the target for {{ e2 }} seconds. ",
						"leveltip": {
							"label": [
								"Damage",
								"Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }} -> {{ e2NL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								80,
								125,
								170,
								215,
								260
							],
							[
								1.5,
								1.75,
								2,
								2.25,
								2.5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/125/170/215/260",
							"1.5/1.75/2/2.25/2.5",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							680,
							680,
							680,
							680,
							680
						],
						"rangeBurn": "680",
						"image": {
							"full": "BlindingDart.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "MoveQuick",
						"name": "Move Quick",
						"description": "Teemo scampers around, passively increasing his Movement Speed until he is struck by an enemy champion or turret. Teemo can sprint to gain bonus Movement Speed that isn't stopped by being struck for a short time.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Teemo's Movement Speed is increased by {{ e1 }}% unless he has been damaged by an enemy champion or turret in the last 5 seconds.<br /><br /><span class=\"colorFF9900\">Active: </span>Teemo sprints, gaining twice his normal bonus for {{ e2 }} seconds. This bonus is not lost when struck.",
						"leveltip": {
							"label": [
								"Base Movement Speed Bonus"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							17,
							17,
							17,
							17
						],
						"cooldownBurn": "17",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								10,
								14,
								18,
								22,
								26
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.2,
								0.28,
								0.36,
								0.44,
								0.52
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/14/18/22/26",
							"3",
							"0.2/0.28/0.36/0.44/0.52",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "MoveQuick.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ToxicShot",
						"name": "Toxic Shot",
						"description": "Each of Teemo's attacks will poison the target, dealing damage on impact and each second after for 4 seconds.",
						"tooltip": "Teemo's basic attacks poison their target, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magical damage upon impact and {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magical damage each second for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Impact Damage",
								"Damage per Second "
							],
							"effect": [
								" {{ e2 }} -> {{ e2NL }}",
								" {{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							8,
							8,
							8,
							8
						],
						"cooldownBurn": "8",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								6,
								12,
								18,
								24,
								30
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4.5,
								4.5,
								4.5,
								4.5,
								4.5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6/12/18/24/30",
							"10/20/30/40/50",
							"4",
							"4.5",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.1,
								"key": "a2"
							}
						],
						"costType": "Passive",
						"maxammo": "-1",
						"range": [
							680,
							680,
							680,
							680,
							680
						],
						"rangeBurn": "680",
						"image": {
							"full": "ToxicShot.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "Passive"
					},
					{
						"id": "TeemoRCast",
						"name": "Noxious Trap",
						"description": "Teemo throws an explosive poisonous trap using one of the mushrooms stored in his pack. If an enemy steps on the trap, it will release a poisonous cloud, slowing enemies and damaging them over time. If Teemo throws a mushroom onto another mushroom it will bounce, gaining additional range.",
						"tooltip": "Tosses a stored mushroom as a trap that detonates if an enemy steps on it, spreading poison to nearby enemies that slows Movement Speed by {{ e2 }}%, reveals them and deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e9 }} seconds. <br /><br />Traps last {{ e5 }} minutes and take {{ e4 }} second to arm and stealth. If a thrown trap lands on another trap, it will bounce up to <span class=\"colorFFFF99\">{{ e6 }}</span> Teemos further before planting.<br /><br />Teemo forages for a mushroom every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds, but he is only big enough to carry 3 at once.",
						"leveltip": {
							"label": [
								"Damage ",
								"Slow Percent",
								"Max Bounce Range",
								"Forage Timer",
								"Cast Range"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }}% -> {{ e2NL }}%",
								"{{ e6 }} Teemos -> {{ e6NL }} Teemos",
								" {{ f1 }} -> {{ f2 }}",
								" {{ e8 }} -> {{ e8NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							0.25,
							0.25,
							0.25
						],
						"cooldownBurn": "0.25",
						"cost": [
							75,
							75,
							75
						],
						"costBurn": "75",
						"effect": [
							null,
							[
								200,
								325,
								450
							],
							[
								30,
								40,
								50
							],
							[
								75,
								75,
								75
							],
							[
								1,
								1,
								1
							],
							[
								5,
								5,
								5
							],
							[
								3,
								4,
								5
							],
							[
								30,
								25,
								20
							],
							[
								400,
								650,
								900
							],
							[
								4,
								4,
								4
							],
							[
								450,
								450,
								450
							]
						],
						"effectBurn": [
							null,
							"200/325/450",
							"30/40/50",
							"75",
							"1",
							"5",
							"3/4/5",
							"30/25/20",
							"400/650/900",
							"4",
							"450"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "3",
						"range": [
							400,
							650,
							900
						],
						"rangeBurn": "400/650/900",
						"image": {
							"full": "TeemoRCast.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Guerrilla Warfare",
					"description": "If Teemo stands still and takes no actions for a short duration, he becomes Invisible indefinitely. If he's in brush, Teemo can enter and maintain his Invisibility while moving. After leaving Invisibility, Teemo gains the Element of Surprise, increasing his Attack Speed for 3 seconds.",
					"image": {
						"full": "Teemo_P.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Teemo",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3146",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3115",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Teemo",
						"title": "TeemoTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3136",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Thresh": {
				"id": "Thresh",
				"key": "412",
				"name": "Thresh",
				"title": "the Chain Warden",
				"image": {
					"full": "Thresh.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "412000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "412001",
						"num": 1,
						"name": "Deep Terror Thresh",
						"chromas": false
					},
					{
						"id": "412002",
						"num": 2,
						"name": "Championship Thresh",
						"chromas": false
					},
					{
						"id": "412003",
						"num": 3,
						"name": "Blood Moon Thresh",
						"chromas": false
					},
					{
						"id": "412004",
						"num": 4,
						"name": "SSW Thresh",
						"chromas": false
					},
					{
						"id": "412005",
						"num": 5,
						"name": "Dark Star Thresh",
						"chromas": false
					}
				],
				"lore": "Sadistic and cunning, Thresh is an ambitious and restless spirit of the Shadow Isles. Once the custodian of countless arcane secrets, he sought a power greater than life or death, and now sustains himself by tormenting and breaking others with slow, excruciating inventiveness. His victims suffer far beyond their brief mortal coil as Thresh wreaks agony upon their souls, imprisoning them in his unholy lantern to torture for all eternity.",
				"blurb": "Sadistic and cunning, Thresh is an ambitious and restless spirit of the Shadow Isles. Once the custodian of countless arcane secrets, he sought a power greater than life or death, and now sustains himself by tormenting and breaking others with slow...",
				"allytips": [
					"Communication is key when making use of Thresh's lantern. Let your teammates know how you like to use it.",
					"Death Sentence and Flay can be combined in either cast order for powerful combinations.",
					"Thresh can collect souls without needing to kill units himself. Planning your map position to be near the most deaths will help to maximize soul collection."
				],
				"enemytips": [
					"Thresh's Death Sentence has a long cast time. Watch for the cast to begin to take evasive actions.",
					"Intentionally breaking a wall of The Box can allow a vulnerable ally to escape unscathed.",
					"Thresh relies on collecting souls for a portion of his defense and damage. Try punishing him when he moves to collect them."
				],
				"tags": [
					"Support",
					"Fighter"
				],
				"partype": "Mana",
				"info": {
					"attack": 5,
					"defense": 6,
					"magic": 6,
					"difficulty": 7
				},
				"stats": {
					"hp": 560.52,
					"hpperlevel": 93,
					"mp": 273.92,
					"mpperlevel": 44,
					"movespeed": 335,
					"armor": 28,
					"armorperlevel": 0,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 450,
					"hpregen": 7,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 56,
					"attackdamageperlevel": 2.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "ThreshQ",
						"name": "Death Sentence",
						"description": "Thresh binds an enemy in chains and pulls them toward him. Activating this ability a second time pulls Thresh to the enemy.",
						"tooltip": "Thresh throws out his scythe, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, granting <span class=\"coloree91d7\">True Sight</span> and stunning the first unit hit, pulling them in for {{ e2 }} seconds.<br /><br />Reactivating this ability will pull Thresh to the bound enemy.<br /><br />Death Sentence's cooldown is reduced by {{ e4 }} seconds if it hits an enemy.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							18,
							16,
							14,
							12
						],
						"cooldownBurn": "20/18/16/14/12",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"1.5",
							"75",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1075,
							1075,
							1075,
							1075,
							1075
						],
						"rangeBurn": "1075",
						"image": {
							"full": "ThreshQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ThreshW",
						"name": "Dark Passage",
						"description": "Thresh throws out a lantern that shields nearby allied Champions from damage. Allies can click the lantern to dash to Thresh.",
						"tooltip": "Thresh throws the Lantern to a target location. If an ally clicks on it Thresh will pull both the Lantern and his ally to him.<br /><br />The Lantern grants a shield lasting {{ e5 }} seconds that absorbs up to {{ e1 }} <span class=\"color0bf7de\">(+{{ f6 }})</span> damage to Thresh and up to one ally if they come near it. The shield amount scales with the number of <span class=\"color0bf7de\">souls</span> Thresh has collected.",
						"leveltip": {
							"label": [
								"Shield Absorption",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20.5,
							19,
							17.5,
							16
						],
						"cooldownBurn": "22/20.5/19/17.5/16",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"1",
							"0",
							"6",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "ThreshW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ThreshE",
						"name": "Flay",
						"description": "Thresh's attacks wind up, dealing more damage the longer he waits between attacks. When activated, Thresh sweeps his chain, knocking all enemies hit in the direction of the blow.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Thresh's basic attacks deal from <span class=\"color0bf7de\">{{ f3 }}</span> to <span class=\"color0bf7de\">{{ f3 }}</span> <span class=\"colorFF8C00\">(+{{ f2 }})</span> additional magic damage, which builds up while not attacking (total <span class=\"color0bf7de\">souls</span> collected plus up to {{ e3 }}% total Attack Damage).<br /><br /><span class=\"colorFF9900\">Active: </span>Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage in a line beginning behind Thresh. Enemies hit are pushed in the direction of the swing, then slowed by {{ e2 }}% for {{ e4 }} second.<br /><br />Cast forward to push; cast backward to pull.",
						"leveltip": {
							"label": [
								"Passive Damage",
								"Active Damage",
								"Slow",
								"Mana Cost"
							],
							"effect": [
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							9,
							9,
							9,
							9
						],
						"cooldownBurn": "9",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								65,
								95,
								125,
								155,
								185
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"65/95/125/155/185",
							"20/25/30/35/40",
							"80/110/140/170/200",
							"1",
							"1",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "ThreshE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ThreshRPenta",
						"name": "The Box",
						"description": "A prison of walls that slow and deal damage if broken.",
						"tooltip": "Thresh creates a prison of spectral walls around himself. Enemy champions who walk through a wall suffer {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed by {{ e3 }}% for {{ e2 }} seconds, but break that wall.  <br /><br />Once one wall is broken, the remaining walls deal no damage and apply half slow duration. An enemy cannot be affected by multiple walls simultaneously.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							120,
							100
						],
						"cooldownBurn": "140/120/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								250,
								400,
								550
							],
							[
								2,
								2,
								2
							],
							[
								99,
								99,
								99
							],
							[
								4,
								4,
								4
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"250/400/550",
							"2",
							"99",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "ThreshRPenta.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Damnation",
					"description": "Thresh can harvest the souls of enemies that die near him, permanently granting him Armor and Ability Power.",
					"image": {
						"full": "Thresh_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Thresh",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3097",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Thresh",
						"title": "ThreshTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3109",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Tristana": {
				"id": "Tristana",
				"key": "18",
				"name": "Tristana",
				"title": "the Yordle Gunner",
				"image": {
					"full": "Tristana.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "18000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "18001",
						"num": 1,
						"name": "Riot Girl Tristana",
						"chromas": false
					},
					{
						"id": "18002",
						"num": 2,
						"name": "Earnest Elf Tristana",
						"chromas": false
					},
					{
						"id": "18003",
						"num": 3,
						"name": "Firefighter Tristana",
						"chromas": false
					},
					{
						"id": "18004",
						"num": 4,
						"name": "Guerilla Tristana",
						"chromas": false
					},
					{
						"id": "18005",
						"num": 5,
						"name": "Buccaneer Tristana",
						"chromas": false
					},
					{
						"id": "18006",
						"num": 6,
						"name": "Rocket Girl Tristana",
						"chromas": true
					},
					{
						"id": "18010",
						"num": 10,
						"name": "Dragon Trainer Tristana",
						"chromas": false
					},
					{
						"id": "18011",
						"num": 11,
						"name": "Bewitching Tristana",
						"chromas": false
					},
					{
						"id": "18012",
						"num": 12,
						"name": "Omega Squad Tristana",
						"chromas": true
					}
				],
				"lore": "While many other yordles channel their energy into discovery, invention, or just plain mischief-making, Tristana was always inspired by the adventures of great warriors. She had heard much about Runeterra, its factions, and its wars, and believed her kind could become worthy of legend too. Setting foot in the world for the first time, she took up her trusty cannon Boomer, and now leaps into battle with steadfast courage and optimism.",
				"blurb": "While many other yordles channel their energy into discovery, invention, or just plain mischief-making, Tristana was always inspired by the adventures of great warriors. She had heard much about Runeterra, its factions, and its wars, and believed her...",
				"allytips": [
					"Her massive gun allows Tristana to fire on targets at a great distance. Utilize this to prevent your enemies from ever laying a hand on you.",
					"Use Rocket Jump after you have stacked up your Explosive Charge on an enemy to finish them off with a burst of damage.",
					"Use Rapid Fire to help stack up your Explosive Charge on enemy champions."
				],
				"enemytips": [
					"If you see Tristana activate Rapid Fire in a fight, stun her and try to back off until the spell dissipates.",
					"Stand away from your creeps in a lane to take less collateral damage from Explosive Charge."
				],
				"tags": [
					"Marksman",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 3,
					"magic": 5,
					"difficulty": 4
				},
				"stats": {
					"hp": 542.76,
					"hpperlevel": 82,
					"mp": 246.76,
					"mpperlevel": 32,
					"movespeed": 325,
					"armor": 31,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6,
					"hpregenperlevel": 0.65,
					"mpregen": 7.206,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 65,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": -0.0473,
					"attackspeedperlevel": 1.5
				},
				"spells": [
					{
						"id": "TristanaQ",
						"name": "Rapid Fire",
						"description": "Tristana fires her weapon rapidly, increasing her Attack Speed for a short time.",
						"tooltip": "<span class=\"colorFF9900\">Active: </span>Increases Tristana's Attack Speed by {{ e1 }}% for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Attack Speed %",
								"Cooldown"
							],
							"effect": [
								" {{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}</postScriptRight>"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							19,
							18,
							17,
							16
						],
						"cooldownBurn": "20/19/18/17/16",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/50/70/90/110",
							"7",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "TristanaQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "TristanaW",
						"name": "Rocket Jump",
						"description": "Tristana fires at the ground to propel her to a distant location, dealing damage and slowing surrounding units for a brief period where she lands.",
						"tooltip": "Tristana launches herself to target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and slowing surrounding enemies by {{ e3 }}% for {{ e2 }} seconds.<br /><br />Kills, Assists, and max stack Explosive Charge detonations on Champions reset Rocket Jump's cooldown.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20,
							18,
							16,
							14
						],
						"cooldownBurn": "22/20/18/16/14",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								1,
								1.5,
								2,
								2.5,
								3
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								350,
								350,
								350,
								350,
								350
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/110/160/210/260",
							"1/1.5/2/2.5/3",
							"60",
							"350",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "TristanaW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TristanaE",
						"name": "Explosive Charge",
						"description": "When Tristana kills a unit, her cannonballs burst into shrapnel, dealing damage to surrounding enemies. Can be activated to place a bomb on a target enemy that explodes after a short duration dealing damage to surrounding units.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Enemies explode when slain by Tristana's basic attacks, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage to nearby enemies.<br /><br /><span class=\"colorFF9900\">Active: </span>Places a bomb on an enemy or turret that explodes after 4 seconds, dealing {{ e4 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> Physical Damage. Each attack and ability charges the bomb's damage by +{{ e6 }}%.<br /><br />At 4 charges, the bomb explodes immediately. The detonation radius is twice as large if used on a turret.",
						"leveltip": {
							"label": [
								"Passive Explosion Damage",
								"Base Charge Damage",
								"Mana Cost",
								"Bonus Attack Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ e5 }}% -> {{ e5NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15.5,
							15,
							14.5,
							14
						],
						"cooldownBurn": "16/15.5/15/14.5/14",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								55,
								80,
								105,
								130,
								155
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								60,
								70,
								80,
								90,
								100
							],
							[
								50,
								60,
								70,
								80,
								90
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								500,
								500,
								500,
								500,
								500
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/80/105/130/155",
							"4",
							"300",
							"60/70/80/90/100",
							"50/60/70/80/90",
							"30",
							"500",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "TristanaE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TristanaR",
						"name": "Buster Shot",
						"description": "Tristana loads a massive cannonball into her weapon and fires it at an enemy unit. This deals Magic Damage and knocks the target back. If the target is carrying the Explosive Charge bomb, the bomb detonation radius is doubled.",
						"tooltip": "Tristana fires a massive cannonball at an enemy unit. This deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and knocks surrounding units back {{ e2 }} distance.",
						"leveltip": {
							"label": [
								"Damage",
								"Knockback Distance",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								" {{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								300,
								400,
								500
							],
							[
								600,
								800,
								1000
							],
							[
								200,
								200,
								200
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"300/400/500",
							"600/800/1000",
							"200",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "TristanaR.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Draw a Bead",
					"description": "Increases Tristana's Attack Range as she levels.",
					"image": {
						"full": "Tristana_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Tristana",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tristana",
						"title": "TristanaTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Trundle": {
				"id": "Trundle",
				"key": "48",
				"name": "Trundle",
				"title": "the Troll King",
				"image": {
					"full": "Trundle.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "48000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "48001",
						"num": 1,
						"name": "Lil' Slugger Trundle",
						"chromas": false
					},
					{
						"id": "48002",
						"num": 2,
						"name": "Junkyard Trundle",
						"chromas": false
					},
					{
						"id": "48003",
						"num": 3,
						"name": "Traditional Trundle",
						"chromas": false
					},
					{
						"id": "48004",
						"num": 4,
						"name": "Constable Trundle",
						"chromas": false
					},
					{
						"id": "48005",
						"num": 5,
						"name": "Worldbreaker Trundle",
						"chromas": false
					}
				],
				"lore": "Trundle is a hulking and devious troll with a particularly vicious streak, and there is nothing he cannot bludgeon into submission—not even the Freljord itself. Fiercely territorial, he chases down anyone foolish enough to enter his domain. Then, his massive club of True Ice at the ready, he chills his enemies to the bone and impales them with jagged, frozen pillars, laughing as they bleed out onto the tundra.",
				"blurb": "Trundle is a hulking and devious troll with a particularly vicious streak, and there is nothing he cannot bludgeon into submission—not even the Freljord itself. Fiercely territorial, he chases down anyone foolish enough to enter his domain. Then, his...",
				"allytips": [
					"Trundle excels at fighting within his Frozen Domain. Try to draw enemies onto it.",
					"Use Subjugate to soften a powerful enemy tank or to create a target for your team to focus fire.",
					"Chomp is good for lowering the physical damage of enemies; try to focus it on enemy physical damage dealers."
				],
				"enemytips": [
					"Trundle is very powerful at location-based combat. Try to draw him off of his Frozen Domain.",
					"Make sure to get out of his Pillar of Ice as quickly as possible, as it significantly slows you down."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 6,
					"magic": 2,
					"difficulty": 5
				},
				"stats": {
					"hp": 616.28,
					"hpperlevel": 96,
					"mp": 281.6,
					"mpperlevel": 45,
					"movespeed": 350,
					"armor": 37,
					"armorperlevel": 2.7,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 6,
					"hpregenperlevel": 0.75,
					"mpregen": 7.508,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.0672,
					"attackspeedperlevel": 2.9
				},
				"spells": [
					{
						"id": "TrundleTrollSmash",
						"name": "Chomp",
						"description": "Trundle bites his opponent, dealing damage, briefly slowing and sapping some of their Attack Damage.",
						"tooltip": "Trundle lunges at his opponent with his next basic attack, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and briefly slowing his target.<br /><br />This attack increases Trundle's Attack Damage by {{ e3 }} for {{ e6 }} seconds, with his opponent losing half of this amount.",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Damage",
								"Attack Damage Scaling"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							4,
							4,
							4,
							4,
							4
						],
						"cooldownBurn": "4",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								100,
								105,
								110,
								115,
								120
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								-10,
								-12.5,
								-15,
								-17.5,
								-20
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/40/60/80/100",
							"100/105/110/115/120",
							"20/25/30/35/40",
							"-10/-12.5/-15/-17.5/-20",
							"7",
							"8",
							"0.75",
							"0.1",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.8,
									0.9,
									1,
									1.1,
									1.2
								],
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "TrundleTrollSmash.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "trundledesecrate",
						"name": "Frozen Domain",
						"description": "Trundle turns target location into his domain, gaining Attack Speed, Movement Speed, and increased healing from all sources while on it.",
						"tooltip": "Trundle coats target location with ice for {{ e4 }} seconds, gaining {{ e1 }}% Movement Speed, {{ e2 }}% Attack Speed and {{ e3 }}% increased healing and regeneration from all sources.",
						"leveltip": {
							"label": [
								"Movement Speed",
								"Attack Speed"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							60,
							60,
							60,
							60,
							60
						],
						"costBurn": "60",
						"effect": [
							null,
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								20,
								35,
								50,
								65,
								80
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								775,
								775,
								775,
								775,
								775
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/25/30/35/40",
							"20/35/50/65/80",
							"25",
							"8",
							"775",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "trundledesecrate.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TrundleCircle",
						"name": "Pillar of Ice",
						"description": "Trundle creates an ice pillar at target location, becoming impassable terrain and slowing all nearby enemy units.",
						"tooltip": "Trundle creates an icy pillar at target location for {{ e1 }} seconds, becoming impassable terrain and slowing all nearby enemy units by {{ e2 }}%.",
						"leveltip": {
							"label": [
								"Cooldown",
								"Slow"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20,
							18,
							16,
							14
						],
						"cooldownBurn": "22/20/18/16/14",
						"cost": [
							75,
							75,
							75,
							75,
							75
						],
						"costBurn": "75",
						"effect": [
							null,
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								360,
								360,
								360,
								360,
								360
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6",
							"30/35/40/45/50",
							"360",
							"225",
							"150",
							"225",
							"400",
							"60",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "TrundleCircle.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TrundlePain",
						"name": "Subjugate",
						"description": "Trundle immediately steals a percent of his target's Health, Armor and Magic Resistance. Over the next 4 seconds the amount of Health, Armor, and Magic Resistance stolen is doubled.",
						"tooltip": "Trundle drains {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of an enemy champion's maximum Health as Magic Damage and {{ e2 }}% of their Armor and Magic Resist, half immediately and half over {{ e3 }} seconds. The Armor and Magic Resist is returned {{ e3 }} seconds after the drain ends.",
						"leveltip": {
							"label": [
								"Health Drain",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							90,
							70
						],
						"cooldownBurn": "110/90/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								20,
								27.5,
								35
							],
							[
								40,
								40,
								40
							],
							[
								4,
								4,
								4
							],
							[
								4,
								4,
								4
							],
							[
								8,
								8,
								8
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								5,
								5,
								5
							],
							[
								0.02,
								0.02,
								0.02
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/27.5/35",
							"40",
							"4",
							"4",
							"8",
							"0.5",
							"5",
							"0.02",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.02,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "TrundlePain.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "King's Tribute",
					"description": "When an enemy unit dies near Trundle, he heals for a percent of its maximum Health.",
					"image": {
						"full": "Trundle_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Trundle",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Trundle",
						"title": "TrundleTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Tryndamere": {
				"id": "Tryndamere",
				"key": "23",
				"name": "Tryndamere",
				"title": "the Barbarian King",
				"image": {
					"full": "Tryndamere.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "23000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "23001",
						"num": 1,
						"name": "Highland Tryndamere",
						"chromas": false
					},
					{
						"id": "23002",
						"num": 2,
						"name": "King Tryndamere",
						"chromas": false
					},
					{
						"id": "23003",
						"num": 3,
						"name": "Viking Tryndamere",
						"chromas": false
					},
					{
						"id": "23004",
						"num": 4,
						"name": "Demonblade Tryndamere",
						"chromas": false
					},
					{
						"id": "23005",
						"num": 5,
						"name": "Sultan Tryndamere",
						"chromas": false
					},
					{
						"id": "23006",
						"num": 6,
						"name": "Warring Kingdoms Tryndamere",
						"chromas": false
					},
					{
						"id": "23007",
						"num": 7,
						"name": "Nightmare Tryndamere",
						"chromas": false
					},
					{
						"id": "23008",
						"num": 8,
						"name": "Beast Hunter Tryndamere",
						"chromas": false
					},
					{
						"id": "23009",
						"num": 9,
						"name": "Chemtech Tryndamere",
						"chromas": false
					}
				],
				"lore": "Fueled by unbridled fury and rage, Tryndamere once carved his way through the Freljord, openly challenging the greatest warriors of the north to prepare himself for even darker days ahead. The wrathful barbarian has long sought revenge for the annihilation of his clan, though more recently he has found companionship with Ashe, the Avarosan warmother, and a home with her people. His almost inhuman strength and fortitude is legendary, and has delivered him and his new allies countless victories against the greatest of odds.",
				"blurb": "Fueled by unbridled fury and rage, Tryndamere once carved his way through the Freljord, openly challenging the greatest warriors of the north to prepare himself for even darker days ahead. The wrathful barbarian has long sought revenge for the...",
				"allytips": [
					"Delaying the activation of Undying Rage is a very effective way to make an enemy champion over-commit to trying to kill you.",
					"Bloodlust is an excellent way to heal Tryndamere. Try not to let it fade off before you activate it.",
					"If the enemy is stacking Armor, try building items like Last Whisper or Youmuu's Ghostblade."
				],
				"enemytips": [
					"Try harassing Tryndamere early so he can't kill minions and heal with Bloodlust.",
					"Remember, Tryndamere can only slow you if you are facing away from him.",
					"Most of Tryndamere's damage is physical. If he's getting too strong, consider buying a Thornmail."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Fury",
				"info": {
					"attack": 10,
					"defense": 5,
					"magic": 2,
					"difficulty": 5
				},
				"stats": {
					"hp": 625.64,
					"hpperlevel": 98,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 33,
					"armorperlevel": 3.1,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8.5,
					"hpregenperlevel": 0.9,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 69,
					"attackdamageperlevel": 3.7,
					"attackspeedoffset": -0.0672,
					"attackspeedperlevel": 2.9
				},
				"spells": [
					{
						"id": "TryndamereQ",
						"name": "Bloodlust",
						"description": "Tryndamere thrives on the thrills of combat, increasing his Attack Damage as he is more and more wounded. He can cast Bloodlust to consume his Fury and heal himself.",
						"tooltip": "<spellPassive>Passive:</spellPassive> Tryndamere thirsts for blood, gaining {{ e1 }} Attack Damage plus {{ e2 }} per 1% Health missing.<br /><br /><spellActive>Active:</spellActive> Tryndamere consumes his Fury, restoring {{ e3 }} <scaleAP>(+{{ a1 }})</scaleAP> Health, plus {{ e4 }} <scaleAP>(+{{ f2 }})</scaleAP> Health per Fury consumed.",
						"leveltip": {
							"label": [
								"Attack Damage",
								"Attack Damage per Health % Missing",
								"Heal",
								"Heal Per Fury"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e4 }} -> {{ e4NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								5,
								10,
								15,
								20,
								25
							],
							[
								0.15,
								0.2,
								0.25,
								0.3,
								0.35
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								0.5,
								0.95,
								1.4,
								1.85,
								2.3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5/10/15/20/25",
							"0.15/0.2/0.25/0.3/0.35",
							"30/40/50/60/70",
							"0.5/0.95/1.4/1.85/2.3",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "TryndamereQ.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "TryndamereW",
						"name": "Mocking Shout",
						"description": "Tryndamere lets out an insulting cry, decreasing surrounding champions' Attack Damage. Enemies with their backs turned to Tryndamere also have their Movement Speed reduced.",
						"tooltip": "Decreases surrounding champions' Attack Damage by {{ e1 }} for {{ e3 }} seconds, and enemies with their backs turned also have their Movement Speed reduced by {{ e2 }}% for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Attack Damage Reduction",
								"Movement Speed Reduction"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							14,
							14,
							14,
							14
						],
						"cooldownBurn": "14",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								35,
								50,
								65,
								80
							],
							[
								30,
								37.5,
								45,
								52.5,
								60
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/35/50/65/80",
							"30/37.5/45/52.5/60",
							"4",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "TryndamereW.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "TryndamereE",
						"name": "Spinning Slash",
						"description": "Tryndamere slices toward a target unit, dealing damage to enemies in his path.",
						"tooltip": "Tryndamere spins through his enemies, dealing {{ e1 }} <scaleAD>(+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> physical damage to enemies in his path and generating Fury.<br /><br />Spinning Slash's cooldown is reduced by {{ e2 }} second whenever Tryndamere critically strikes. This reduction is increased to {{ e3 }} seconds against champions.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/110/140/170/200",
							"1",
							"2",
							"2",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.3,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "TryndamereE.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "UndyingRage",
						"name": "Undying Rage",
						"description": "Tryndamere's lust for battle becomes so strong that he is unable to die, no matter how wounded he becomes.",
						"tooltip": "Tryndamere becomes completely immune to death for {{ e3 }} seconds, refusing to be reduced below {{ e2 }} Health and instantly gaining {{ e1 }} Fury.",
						"leveltip": {
							"label": [
								"Fury Gained",
								"Minimum Health",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							100,
							90
						],
						"cooldownBurn": "110/100/90",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								50,
								75,
								100
							],
							[
								30,
								50,
								70
							],
							[
								5,
								5,
								5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100",
							"30/50/70",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "UndyingRage.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Battle Fury",
					"description": "Tryndamere gains Fury for each attack, critical strike, and killing blow he makes. Fury passively increases his Critical Strike Chance and can be consumed with his Bloodlust spell.",
					"image": {
						"full": "Tryndamere_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Tryndamere",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1054",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3065",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3035",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2015",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2015",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Tryndamere",
						"title": "TryndamereTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"TwistedFate": {
				"id": "TwistedFate",
				"key": "4",
				"name": "Twisted Fate",
				"title": "the Card Master",
				"image": {
					"full": "TwistedFate.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "4000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "4001",
						"num": 1,
						"name": "PAX Twisted Fate",
						"chromas": false
					},
					{
						"id": "4002",
						"num": 2,
						"name": "Jack of Hearts Twisted Fate",
						"chromas": false
					},
					{
						"id": "4003",
						"num": 3,
						"name": "The Magnificent Twisted Fate",
						"chromas": false
					},
					{
						"id": "4004",
						"num": 4,
						"name": "Tango Twisted Fate",
						"chromas": false
					},
					{
						"id": "4005",
						"num": 5,
						"name": "High Noon Twisted Fate",
						"chromas": false
					},
					{
						"id": "4006",
						"num": 6,
						"name": "Musketeer Twisted Fate",
						"chromas": false
					},
					{
						"id": "4007",
						"num": 7,
						"name": "Underworld Twisted Fate",
						"chromas": false
					},
					{
						"id": "4008",
						"num": 8,
						"name": "Red Card Twisted Fate",
						"chromas": false
					},
					{
						"id": "4009",
						"num": 9,
						"name": "Cutpurse Twisted Fate",
						"chromas": false
					},
					{
						"id": "4010",
						"num": 10,
						"name": "Blood Moon Twisted Fate",
						"chromas": false
					}
				],
				"lore": "Twisted Fate is an infamous cardsharp and swindler who has gambled and charmed his way across much of the known world, earning the enmity and admiration of the rich and foolish alike. He rarely takes things seriously, greeting each day with a mocking smile and an insouciant swagger. In every possible way, Twisted Fate always has an ace up his sleeve.",
				"blurb": "Twisted Fate is an infamous cardsharp and swindler who has gambled and charmed his way across much of the known world, earning the enmity and admiration of the rich and foolish alike. He rarely takes things seriously, greeting each day with a mocking...",
				"allytips": [
					"Coordinate with your allies for the best time to use Destiny to ambush enemies.",
					"Stealth characters often escape a battle with very low hit points. Take advantage of Destiny's ability to reveal stealthed units to finish them off.",
					"Twisted Fate is viable as an Attack Damage or Ability Power character, letting him fit on many different team compositions."
				],
				"enemytips": [
					"Focus on dodging Wild Cards early when your champion doesn't have the hit points to afford getting hit.",
					"If you have low Health, use Destiny as an indicator to run to safety. It will give you a head start in escaping any possible ganks."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 2,
					"magic": 6,
					"difficulty": 9
				},
				"stats": {
					"hp": 534,
					"hpperlevel": 94,
					"mp": 265.84,
					"mpperlevel": 38,
					"movespeed": 335,
					"armor": 20.542,
					"armorperlevel": 3.15,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 5.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 49.954,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": -0.04,
					"attackspeedperlevel": 3.22
				},
				"spells": [
					{
						"id": "WildCards",
						"name": "Wild Cards",
						"description": "Twisted Fate throws three cards, dealing damage to each enemy unit they pass through.",
						"tooltip": "Throws three cards that deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage to each enemy unit they pass through.",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							60,
							70,
							80,
							90,
							100
						],
						"costBurn": "60/70/80/90/100",
						"effect": [
							null,
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/105/150/195/240",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							10000,
							10000,
							10000,
							10000,
							10000
						],
						"rangeBurn": "10000",
						"image": {
							"full": "WildCards.png",
							"sprite": "spell11.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "PickACard",
						"name": "Pick A Card",
						"description": "Twisted Fate chooses a magic card from his deck, and uses that for his next attack, causing bonus effects.",
						"tooltip": "Cast once to shuffle the deck and again to choose your card, enhancing your next attack.<br /><br /><span class=\"color4455FF\">Blue Card</span> deals {{ e1 }} <scaleAD>(+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage and restores {{ e6 }} Mana.<br /><br /><span class=\"colorFF2222\">Red Card</span> deals {{ e4 }} <scaleAD>(+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage to units around the target and slows their Movement Speed by {{ e2 }}% for 2.5 seconds.<br /><br /><span class=\"colorFFD700\">Gold Card</span> deals {{ e5 }}<scaleAD> (+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage and stuns for {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Blue Card Damage",
								"Blue Card Mana Restore",
								"Red Card Damage",
								"Red Card Slow %",
								"Gold Card Damage",
								"Gold Card Stun Duration",
								"Mana Cost"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							40,
							55,
							70,
							85,
							100
						],
						"costBurn": "40/55/70/85/100",
						"effect": [
							null,
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								1,
								1.25,
								1.5,
								1.75,
								2
							],
							[
								30,
								45,
								60,
								75,
								90
							],
							[
								15,
								22.5,
								30,
								37.5,
								45
							],
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/60/80/100/120",
							"30/35/40/45/50",
							"1/1.25/1.5/1.75/2",
							"30/45/60/75/90",
							"15/22.5/30/37.5/45",
							"50/75/100/125/150",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a2"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							200,
							200,
							200,
							200,
							200
						],
						"rangeBurn": "200",
						"image": {
							"full": "PickACard.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "CardmasterStack",
						"name": "Stacked Deck",
						"description": "Every 4 attacks, Twisted Fate deals bonus damage. In addition, his Attack Speed is increased.",
						"tooltip": "<spellPassive>Passive:</spellPassive> Every 4 attacks, Twisted Fate deals an additional {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage.<br /><br />In addition, his Attack Speed is increased by {{ e3 }}%.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Attack Speed Increase"
							],
							"effect": [
								" {{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								55,
								80,
								105,
								130,
								155
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/80/105/130/155",
							"0",
							"10/15/20/25/30",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": "",
						"maxammo": "-1",
						"range": [
							0,
							0,
							0,
							0,
							0
						],
						"rangeBurn": "0",
						"image": {
							"full": "CardmasterStack.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						}
					},
					{
						"id": "Destiny",
						"name": "Destiny",
						"description": "Twisted Fate predicts the fortunes of his foes, revealing all enemy champions and enabling the use of Gate, which teleports Twisted Fate to any target location in 1.5 seconds.",
						"tooltip": "Grants <span class=\"coloree91d7\">True Sight</span> on all enemy champions on the map for {{ e1 }} seconds.<br /><br />While Destiny is active, Twisted Fate can teleport up to {{ e4 }} units away in 1.5 seconds.",
						"leveltip": {
							"label": [
								"Duration",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							180,
							150,
							120
						],
						"cooldownBurn": "180/150/120",
						"cost": [
							150,
							125,
							100
						],
						"costBurn": "150/125/100",
						"effect": [
							null,
							[
								6,
								8,
								10
							],
							[
								180,
								150,
								120
							],
							[
								150,
								125,
								100
							],
							[
								5500,
								5500,
								5500
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6/8/10",
							"180/150/120",
							"150/125/100",
							"5500",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							5500,
							5500,
							5500
						],
						"rangeBurn": "5500",
						"image": {
							"full": "Destiny.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Loaded Dice",
					"description": "Upon killing a unit, Twisted Fate rolls his 'lucky' dice receiving anywhere between 1 and 6 bonus gold.",
					"image": {
						"full": "Cardmaster_SealFate.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "TwistedFate",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "TwistedFate",
						"title": "TwistedFateTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Twitch": {
				"id": "Twitch",
				"key": "29",
				"name": "Twitch",
				"title": "the Plague Rat",
				"image": {
					"full": "Twitch.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "29000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "29001",
						"num": 1,
						"name": "Kingpin Twitch",
						"chromas": false
					},
					{
						"id": "29002",
						"num": 2,
						"name": "Whistler Village Twitch",
						"chromas": false
					},
					{
						"id": "29003",
						"num": 3,
						"name": "Medieval Twitch",
						"chromas": false
					},
					{
						"id": "29004",
						"num": 4,
						"name": "Gangster Twitch",
						"chromas": false
					},
					{
						"id": "29005",
						"num": 5,
						"name": "Vandal Twitch",
						"chromas": false
					},
					{
						"id": "29006",
						"num": 6,
						"name": "Pickpocket Twitch",
						"chromas": false
					},
					{
						"id": "29007",
						"num": 7,
						"name": "SSW Twitch",
						"chromas": false
					},
					{
						"id": "29008",
						"num": 8,
						"name": "Omega Squad Twitch",
						"chromas": true
					}
				],
				"lore": "A Zaunite plague rat by birth, but a connoisseur of filth by passion, Twitch is not afraid to get his paws dirty. Aiming a chem-powered crossbow at the gilded heart of Piltover, he has vowed to show those in the city above just how filthy they really are. Always a sneaky sneak, when he's not rooting around in the Sump, he's digging deep into other people's garbage for discarded treasures… and perhaps a moldy sandwich.",
				"blurb": "A Zaunite plague rat by birth, but a connoisseur of filth by passion, Twitch is not afraid to get his paws dirty. Aiming a chem-powered crossbow at the gilded heart of Piltover, he has vowed to show those in the city above just how filthy they really...",
				"allytips": [
					"Twitch's Attack Speed is among the highest in the game; try purchasing items with on-hit effects such as Black Cleaver or Wit's End.",
					"Contaminate has a large range; apply as many stacks of Deadly Venom as possible before using it.",
					"You can catch up to an enemy out of attack range with Venom Cask."
				],
				"enemytips": [
					"Twitch is fragile. Work with teammates to focus on him when you're able to catch him out of Camouflage.",
					"Spell Shields won't block the damage from Deadly Venom, but they will block the effects Twitch can trigger with it.",
					"If you suspect Twitch has left the lane, let your teammates know that Twitch is ''MIA.''"
				],
				"tags": [
					"Marksman",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 2,
					"magic": 3,
					"difficulty": 6
				},
				"stats": {
					"hp": 525.08,
					"hpperlevel": 81,
					"mp": 287.2,
					"mpperlevel": 40,
					"movespeed": 330,
					"armor": 32,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6,
					"hpregenperlevel": 0.6,
					"mpregen": 7.256,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 63,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": -0.08,
					"attackspeedperlevel": 3.38
				},
				"spells": [
					{
						"id": "TwitchHideInShadows",
						"name": "Ambush",
						"description": "Twitch becomes Camouflaged for a short duration and gains Movement Speed. When leaving Camouflage, Twitch gains Attack Speed for a short duration.<br><br>When an enemy champion with Deadly Venom dies, Ambush's cooldown is reset.",
						"tooltip": "Twitch becomes <span class=\"colorcd90ee\">Camouflaged</span> and gains {{ e3 }}% Movement Speed for {{ e2 }} seconds. This bonus triples when he is nearby an enemy champion that cannot see him. <br /><br />Twitch gains {{ e1 }}% Attack Speed for {{ e6 }} seconds after exiting Ambush. Ambush resets when a champion dies while affected by <span class=\"color3ca126\">Deadly Venom.</span><br /><br /><font color='#cd90ee'size='16'><u>Stealth - Camouflage:</u></span> <font color='#8C8C8C'size='16'>Twitch is hidden from view while enemy champions remain outside his detection radius. Attacking or casting spells ends Camouflage.</span>",
						"leveltip": {
							"label": [
								"Camouflage Duration",
								"Attack Speed"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }}% -> {{ e1NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							16,
							16,
							16,
							16
						],
						"cooldownBurn": "16",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								10,
								11,
								12,
								13,
								14
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								500,
								500,
								500,
								500,
								500
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								30,
								30,
								30,
								30,
								30
							]
						],
						"effectBurn": [
							null,
							"30/35/40/45/50",
							"10/11/12/13/14",
							"10",
							"1",
							"1",
							"5",
							"3",
							"500",
							"1000",
							"30"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							20,
							20,
							20,
							20,
							20
						],
						"rangeBurn": "20",
						"image": {
							"full": "TwitchHideInShadows.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TwitchVenomCask",
						"name": "Venom Cask",
						"description": "Twitch hurls a cask of venom that explodes in an area, slowing targets and applying deadly venom to the target.",
						"tooltip": "Twitch hurls a cask that adds a stack of <span class=\"color3ca126\">Deadly Venom</span> to all enemies struck and leaves behind a toxic cloud that persists for {{ e3 }} seconds.<br /><br />Enemies that remain within the cloud have {{ e2 }}% reduced Movement Speed and receive an additional stack of <span class=\"color3ca126\">Deadly Venom</span> each second.",
						"leveltip": {
							"label": [
								"Slow Amount",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								3.5,
								3.5,
								3.5,
								3.5,
								3.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2",
							"25/30/35/40/45",
							"3",
							"300",
							"3.5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							950,
							950,
							950,
							950,
							950
						],
						"rangeBurn": "950",
						"image": {
							"full": "TwitchVenomCask.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TwitchExpunge",
						"name": "Contaminate",
						"description": "Twitch wreaks further havoc on poisoned enemies with a blast of his vile diseases.",
						"tooltip": "Deals {{ e2 }} physical damage plus {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> <span class=\"colorFF8C00\">(+{{ f1 }})</span> per stack of <span class=\"color3ca126\">Deadly Venom</span> to all nearby enemies affected by <span class=\"color3ca126\">Deadly Venom.</span> <span class=\"colora3554e\">(Max Stack Damage: {{ f2 }})</span>",
						"leveltip": {
							"label": [
								"Base Damage",
								"Damage per Stack",
								"Mana Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/20/25/30/35",
							"20/25/30/35/40",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "TwitchExpunge.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "TwitchFullAutomatic",
						"name": "Spray and Pray",
						"description": "Twitch unleashes the full power of his crossbow, shooting bolts over a great distance that pierce all enemies caught in their path.",
						"tooltip": "For {{ e2 }} seconds Twitch gains {{ e5 }} Attack Range and {{ e1 }} Bonus Attack Damage.<br /><br />For the duration, his basic attacks become piercing bolts that deal {{ e3 }}% less damage to subsequent targets, down to a minimum of {{ e4 }}% damage.<br /><br /><font color='#cd90ee'size='16'><u>Stealth - Camouflage:</u></span> <font color='#8C8C8C'size='16'>Activating Spray and Pray does not end Camouflage.",
						"leveltip": {
							"label": [
								"Attack Damage Bonus"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							90,
							90,
							90
						],
						"cooldownBurn": "90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								20,
								30,
								40
							],
							[
								5,
								5,
								5
							],
							[
								20,
								20,
								20
							],
							[
								40,
								40,
								40
							],
							[
								300,
								300,
								300
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40",
							"5",
							"20",
							"40",
							"300",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "TwitchFullAutomatic.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Deadly Venom",
					"description": "Twitch's basic attacks infect the target, dealing true damage each second.",
					"image": {
						"full": "Twitch_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Twitch",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1043",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Twitch",
						"title": "TwitchTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Udyr": {
				"id": "Udyr",
				"key": "77",
				"name": "Udyr",
				"title": "the Spirit Walker",
				"image": {
					"full": "Udyr.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "77000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "77001",
						"num": 1,
						"name": "Black Belt Udyr",
						"chromas": false
					},
					{
						"id": "77002",
						"num": 2,
						"name": "Primal Udyr",
						"chromas": false
					},
					{
						"id": "77003",
						"num": 3,
						"name": "Spirit Guard Udyr",
						"chromas": false
					},
					{
						"id": "77004",
						"num": 4,
						"name": "Definitely Not Udyr",
						"chromas": false
					}
				],
				"lore": "Udyr is more than a man; he is a vessel for the untamed power of four primal animal spirits. When tapping into the spirits' bestial natures, Udyr can harness their unique strengths: The tiger grants him speed and ferocity, the turtle resilience, the bear might, and the phoenix its eternal flame. With their combined power, Udyr can turn back all those who would attempt to harm the natural order.",
				"blurb": "Udyr is more than a man; he is a vessel for the untamed power of four primal animal spirits. When tapping into the spirits' bestial natures, Udyr can harness their unique strengths: The tiger grants him speed and ferocity, the turtle resilience, the...",
				"allytips": [
					"Damage is applied to turtle shield post-mitigation. Therefore, buying defensive items can drastically increase your survivability.",
					"Udyr is one of the best junglers in the game. Taking advantage of this can give your team a large XP advantage and map control."
				],
				"enemytips": [
					"Udyr players will often start in the jungle and only appear to gank in lanes. Try warding key locations to keep track of his movement.",
					"Once the initial shield effect has faded, Turtle Stance is weak against other champions. Press the attack to force him to switch stances and prevent him from regenerating health.",
					"Some Udyr players buy tank items to become very durable. If they do, focus their weaker teammates instead."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 7,
					"magic": 4,
					"difficulty": 7
				},
				"stats": {
					"hp": 593.32,
					"hpperlevel": 99,
					"mp": 270.4,
					"mpperlevel": 30,
					"movespeed": 345,
					"armor": 34,
					"armorperlevel": 4,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 6,
					"hpregenperlevel": 0.75,
					"mpregen": 7.506,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 5,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2.67
				},
				"spells": [
					{
						"id": "UdyrTigerStance",
						"name": "Tiger Stance",
						"description": "Tiger Stance: Activation - Udyr's Attack Speed is increased for a few seconds. Persistent Effect - Udyr's first attack and every third attack after will deal a high amount of damage over 2 seconds.",
						"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Udyr's first attack and every third attack after will perform a Tiger Strike, dealing bonus {{ e1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage over {{ e5 }} seconds. <br /><br />If a target is affected by Tiger Strike, a new application of Tiger Strike will deal the remaining damage instantly.<br /><br /><span class=\"colorFF9900\">Activation:</span> Increases Attack Speed by {{ e2 }}% for {{ e6 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
						"leveltip": {
							"label": [
								"Tiger Strike Damage",
								"Attack Speed",
								"Tiger Strike Scaling"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e4 }}% -> {{ e4NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								30,
								60,
								90,
								120,
								150
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								0.15,
								0.15,
								0.15,
								0.15,
								0.15
							],
							[
								120,
								135,
								150,
								165,
								180
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/60/90/120/150",
							"30/40/50/60/70",
							"0.15",
							"120/135/150/165/180",
							"2",
							"5",
							"0.5",
							"0.25",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									1.2,
									1.3,
									1.4,
									1.5,
									1.6
								],
								"key": "f2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "UdyrTigerStance.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UdyrTurtleStance",
						"name": "Turtle Stance",
						"description": "Turtle Stance: Activation - Udyr gains a temporary shield that absorbs damage. Persistent Effect - Udyr's first attack and every third attack after heals him for 2.5% of his maximum health.",
						"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Udyr's first attack and every third attack after heals him for <span class=\"colorFF3300\">(+{{ f1 }})</span> ({{ e3 }}% of his maximum health), increasing by 1% for every percent of Udyr's missing health.<br /><br /><span class=\"colorFF9900\">Activation: </span>Gains a shield that absorbs {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for {{ e2 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
						"leveltip": {
							"label": [
								"Shield Amount"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								60,
								95,
								130,
								165,
								200
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0.05,
								0.05,
								0.05,
								0.05,
								0.05
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/95/130/165/200",
							"5",
							"2.5",
							"0.05",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "UdyrTurtleStance.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UdyrBearStance",
						"name": "Bear Stance",
						"description": "Bear Stance: Activation - Udyr increases Movement Speed for a short duration. Persistent Effect - Udyr's basic attacks stun his target for 1 second. This effect cannot occur on the same target for several seconds.",
						"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Basic attacks stun the target for {{ e3 }} second. This effect cannot occur on the same target again for {{ e4 }} seconds.<br /><br /><span class=\"colorFF9900\">Activation: </span>Increases Movement Speed by {{ e1 }}% and ignores unit collision for {{ e2 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
						"leveltip": {
							"label": [
								"Movement Speed Increase",
								"Movement Speed Duration"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								2,
								2.25,
								2.5,
								2.75,
								3
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/20/25/30/35",
							"2/2.25/2.5/2.75/3",
							"1",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "UdyrBearStance.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UdyrPhoenixStance",
						"name": "Phoenix Stance",
						"description": "Phoenix Stance: Activation - Udyr unleashes pulsing waves of fire, dealing damage to nearby enemies. Persistent Effect - Udyr's first attack and every third attack after engulfs enemies in front of him with flames.",
						"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Udyr's first attack and every third attack after burns enemies in front of him, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorFF9900\">Activation: </span>Unleashes pulsing waves of fire, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage each second to nearby enemies for {{ e5 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
						"leveltip": {
							"label": [
								"Pulse Damage",
								"Flame Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								40,
								80,
								120,
								160,
								200
							],
							[
								16,
								24,
								32,
								40,
								48
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								325,
								325,
								325,
								325,
								325
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/20/30/40/50",
							"40/80/120/160/200",
							"16/24/32/40/48",
							"1",
							"4",
							"325",
							"400",
							"3",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							325,
							325,
							325,
							325,
							325
						],
						"rangeBurn": "325",
						"image": {
							"full": "UdyrPhoenixStance.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Monkey's Agility",
					"description": "Entering a stance grants Udyr bonus Attack Speed and Movement Speed for a short duration. This effect can stack multiple times.",
					"image": {
						"full": "Udyr_MonkeysAgility.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Udyr",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3401",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Udyr",
						"title": "UdyrTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3024",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Urgot": {
				"id": "Urgot",
				"key": "6",
				"name": "Urgot",
				"title": "the Dreadnought",
				"image": {
					"full": "Urgot.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "6000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "6001",
						"num": 1,
						"name": "Giant Enemy Crabgot",
						"chromas": false
					},
					{
						"id": "6002",
						"num": 2,
						"name": "Butcher Urgot",
						"chromas": false
					},
					{
						"id": "6003",
						"num": 3,
						"name": "Battlecast Urgot",
						"chromas": true
					}
				],
				"lore": "Once a powerful Noxian headsman, Urgot was betrayed by the empire for which he had killed so many. Bound in iron chains, he was forced to learn the true meaning of strength in the Dredge—a prison mine deep beneath Zaun. Emerging in a disaster that spread chaos throughout the city, he now casts an imposing shadow over its criminal underworld. Raising his victims on the very chains that once enslaved him, he will purge his new home of the unworthy, making it a crucible of pain.",
				"blurb": "Once a powerful Noxian headsman, Urgot was betrayed by the empire for which he had killed so many. Bound in iron chains, he was forced to learn the true meaning of strength in the Dredge—a prison mine deep beneath Zaun. Emerging in a disaster that...",
				"allytips": [
					"Pay attention to your individual leg's cooldowns, as they make for a signficiant portion of your damage",
					"Land Corrosive Charge or Disdain to lock on to target's with Purge - a great way to trigger multiple legs in rapid succession.",
					"Save Fear Beyond Death for opponents you know are already too weak to survive. It's especially good for picking off fleeing foes."
				],
				"enemytips": [
					"Urgot relies heavily on blasting opponents with his legs, which have their own cooldowns and only detonate when he attacks in the direction they are facing. Avoid getting hit by multiple.",
					"Urgot can deal and absorb tremendous amounts of damage with Purge, but slows himself while firing.",
					"If you are struck by Fear Beyond Death, do your best to avoid falling below the execution threshold (25% of your Maximum Health) until the effect times out."
				],
				"tags": [
					"Fighter",
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 3,
					"difficulty": 8
				},
				"stats": {
					"hp": 585,
					"hpperlevel": 88,
					"mp": 300,
					"mpperlevel": 45,
					"movespeed": 330,
					"armor": 39,
					"armorperlevel": 4.25,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 350,
					"hpregen": 7.5,
					"hpregenperlevel": 0.7,
					"mpregen": 7.25,
					"mpregenperlevel": 0.6,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 63,
					"attackdamageperlevel": 4,
					"attackspeedoffset": 0.05,
					"attackspeedperlevel": 3.75
				},
				"spells": [
					{
						"id": "UrgotQ",
						"name": "Corrosive Charge",
						"description": "Fires an explosive charge at the target location, dealing physical damage and slowing enemies caught in the explosion.",
						"tooltip": "Urgot fires an explosive charge, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slowing enemies hit by {{ e4 }}% for {{ e5 }} second.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								25,
								70,
								115,
								160,
								205
							],
							[
								0.3,
								0.3,
								0.3,
								0.3,
								0.3
							],
							[
								45,
								50,
								55,
								60,
								65
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0.3,
								0.3,
								0.3,
								0.3,
								0.3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"0.1",
							"25/70/115/160/205",
							"0.3",
							"45/50/55/60/65",
							"1",
							"0.3",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "UrgotQ.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UrgotW",
						"name": "Purge",
						"description": "Urgot shields himself, slowing himself while he unloads his weapon on nearby enemies. Prioritizes enemy champions Urgot has recently struck with other abilities and triggers Echoing Flames.",
						"tooltip": "For {{ e3 }} seconds, Urgot shoots at a nearby enemy {{ e8 }} times a second, dealing {{ e9 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> physical damage per shot, <span class=\"colorFFEB7F\">locking onto</span> champions recently damaged by his other abilities. He also shields himself, absorbing {{ e1 }} <span class=\"colorCC3300\">(+{{ f2 }})</span> damage.<br /><br />While firing, Urgot loses {{ e5 }} movement speed but has {{ e2 }}% slow resistance and can walk over minions and non-epic monsters.<br /><br /><rules><span class=\"color8c8c8c\">Applies on-hits at 33% damage. Cannot critically strike. Minimum of {{ e0 }} damage to minions.</span></rules>",
						"leveltip": {
							"label": [
								"Shield",
								"Attack Damage Per Shot",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e7 }}% -> {{ e7NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								125,
								125,
								125,
								125,
								125
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								20,
								24,
								28,
								32,
								36
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								12,
								12,
								12,
								12,
								12
							],
							[
								50,
								50,
								50,
								50,
								50
							]
						],
						"effectBurn": [
							null,
							"60/90/120/150/180",
							"40",
							"4",
							"450",
							"125",
							"0.5",
							"20/24/28/32/36",
							"3",
							"12",
							"50"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							490,
							490,
							490,
							490,
							490
						],
						"rangeBurn": "490",
						"image": {
							"full": "UrgotW.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UrgotE",
						"name": "Disdain",
						"description": "Urgot charges in a direction, trampling non-champion enemies. If he catches an enemy champion, he will stop and hurl them out of his way.",
						"tooltip": "Urgot charges forwards. If he catches an enemy champion, he will stop and hurl them behind him, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and stunning them for {{ e6 }} seconds.<br /><br />Non-champions take the same damage but are knocked aside.<br /><br /><rules><span class=\"color8c8c8c\">Cannot cross terrain.</span></rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								1200,
								1200,
								1200,
								1200,
								1200
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								1.25,
								1.25,
								1.25,
								1.25,
								1.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"450",
							"1200",
							"100",
							"1.25",
							"0.75",
							"1.25",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							475,
							475,
							475,
							475,
							475
						],
						"rangeBurn": "475",
						"image": {
							"full": "UrgotE.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "UrgotR",
						"name": "Fear Beyond Death",
						"description": "Urgot fires a chem-drill that impales the first enemy champion hit. If that champion falls below a health threshold, Urgot judges them weak and can execute them.",
						"tooltip": "Urgot fires a chem-drill, impaling the first enemy champion hit. Deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slows for {{ e4 }} seconds by up to {{ e3 }}% based on the victim's missing health.<br /><br />If the victim falls below {{ e2 }}% health while impaled, Urgot may recast this ability, suppressing the victim and dragging them in for execution. Activates automatically if the target is below {{ e2 }}% at the end of the effect.<br /><br />When Urgot executes a victim, nearby enemies flee in terror for {{ e0 }} seconds.</span></rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							95,
							70
						],
						"cooldownBurn": "120/95/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								50,
								175,
								300
							],
							[
								25,
								25,
								25
							],
							[
								75,
								75,
								75
							],
							[
								4,
								4,
								4
							],
							[
								1,
								1,
								1
							],
							[
								1,
								1,
								1
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								25000,
								25000,
								25000
							],
							[
								600,
								600,
								600
							],
							[
								1.5,
								1.5,
								1.5
							]
						],
						"effectBurn": [
							null,
							"50/175/300",
							"25",
							"75",
							"4",
							"1",
							"1",
							"0.5",
							"25000",
							"600",
							"1.5"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.5,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1600,
							1600,
							1600
						],
						"rangeBurn": "1600",
						"image": {
							"full": "UrgotR.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Echoing Flames",
					"description": "Urgot's basic attacks and Purge periodically trigger blasts of flame from his legs, dealing physical damage.",
					"image": {
						"full": "Urgot_Passive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Urgot",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Urgot",
						"title": "UrgotARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3085",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Urgot",
						"title": "UrgotCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Urgot",
						"title": "UrgotFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Urgot",
						"title": "UrgotSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Urgot",
						"title": "UrgotSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3364",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Urgot",
						"title": "UrgotTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Varus": {
				"id": "Varus",
				"key": "110",
				"name": "Varus",
				"title": "the Arrow of Retribution",
				"image": {
					"full": "Varus.png",
					"sprite": "champion3.png",
					"group": "champion",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "110000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "110001",
						"num": 1,
						"name": "Blight Crystal Varus",
						"chromas": false
					},
					{
						"id": "110002",
						"num": 2,
						"name": "Arclight Varus",
						"chromas": false
					},
					{
						"id": "110003",
						"num": 3,
						"name": "Arctic Ops Varus",
						"chromas": false
					},
					{
						"id": "110004",
						"num": 4,
						"name": "Heartseeker Varus",
						"chromas": false
					},
					{
						"id": "110005",
						"num": 5,
						"name": "Varus Swiftbolt",
						"chromas": false
					},
					{
						"id": "110006",
						"num": 6,
						"name": "Dark Star Varus",
						"chromas": false
					}
				],
				"lore": "One of the ancient race of darkin, Varus was a deadly killer who loved to torment his foes, driving them almost to insanity before delivering the killing arrow. He was imprisoned at the end of the Darkin War, but escaped centuries later in the remade flesh of two Ionian hunters—they had unwittingly released him, cursed to bear the bow containing his bound essence. Varus now seeks out those who trapped him in order to enact his brutal vengeance, but the mortals' souls within him still resist every step of the way.",
				"blurb": "One of the ancient race of darkin, Varus was a deadly killer who loved to torment his foes, driving them almost to insanity before delivering the killing arrow. He was imprisoned at the end of the Darkin War, but escaped centuries later in the remade...",
				"allytips": [
					"An early point in Blighted Quiver helps harass enemy champions and get killing blows on minions.",
					"During short range fights it's sometimes best to fire Piercing Arrow quickly, rather than charging it to full power.",
					"Try to take advantage of Piercing Arrow's very long range to snipe at enemy champions before a fight or as they're trying to flee."
				],
				"enemytips": [
					"If you are affected by Blight, Varus' abilities will deal extra damage to you.",
					"When he gets a kill or assist, Varus temporarily gains Attack Speed and is much more dangerous.",
					"You'll get bound in place if a tendril from Varus' ultimate, Chain of Corruption, reaches you. You can cause the tendril to die however by running far enough away from it."
				],
				"tags": [
					"Marksman",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 3,
					"magic": 4,
					"difficulty": 2
				},
				"stats": {
					"hp": 537.76,
					"hpperlevel": 82,
					"mp": 360.48,
					"mpperlevel": 33,
					"movespeed": 330,
					"armor": 32,
					"armorperlevel": 3.4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 575,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 7.34,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 63,
					"attackdamageperlevel": 2.41,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3
				},
				"spells": [
					{
						"id": "VarusQ",
						"name": "Piercing Arrow",
						"description": "Varus readies and then fires a powerful shot that gains extra range and damage the longer he spends preparing to fire.",
						"tooltip": "<span class=\"colorFF9900\">First Cast:</span> Varus starts drawing back his next shot, gradually increasing its range and damage. While preparing to shoot Varus' Movement Speed is slowed by {{ e7 }}%. After {{ e5 }} seconds, Piercing Arrow fails but refunds {{ e4 }}% of its Mana cost.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Varus fires, dealing {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> to {{ e2 }}<span class=\"colorFF8C00\"> (+{{ a2 }})</span> physical damage, reduced by {{ e3 }}% per enemy hit (minimum {{ e9 }}%).<br /><br />Piercing Arrow's cooldown is reduced by {{ f1 }} seconds if the arrow detonates <span class=\"colorB829FF\">Blight</span> stacks from at least one enemy champion.",
						"leveltip": {
							"label": [
								"Max Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							18,
							16,
							14,
							12
						],
						"cooldownBurn": "20/18/16/14/12",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								10,
								47,
								84,
								120,
								157
							],
							[
								15,
								70,
								125,
								180,
								235
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								33,
								33,
								33,
								33,
								33
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/47/84/120/157",
							"15/70/125/180/235",
							"15",
							"50",
							"4",
							"4",
							"20",
							"0",
							"33",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 1.5,
								"key": "a2"
							},
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "VarusQ.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VarusW",
						"name": "Blighted Quiver",
						"description": "Varus' basic attacks deal bonus magic damage and apply Blight. Varus' other abilities detonate Blight, dealing magic damage based on the target's maximum Health.",
						"tooltip": "Varus' basic attacks deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and apply <span class=\"colorB829FF\">Blight</span> for {{ e3 }} seconds (stacks {{ e4 }} times).<br /><br />Varus' other abilities detonate <span class=\"colorB829FF\">Blight</span>, dealing magic damage equal to {{ e2 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> of the target's maximum Health per stack. Max damage vs. monsters: {{ e5 }} per stack.",
						"leveltip": {
							"label": [
								"Initial Damage",
								"Max Health Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								10,
								14,
								18,
								22,
								26
							],
							[
								2,
								2.75,
								3.5,
								4.25,
								5
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								120,
								120,
								120,
								120,
								120
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/14/18/22/26",
							"2/2.75/3.5/4.25/5",
							"6",
							"3",
							"120",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.02,
								"key": "a2"
							}
						],
						"costType": "Passive",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "VarusW.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "Passive"
					},
					{
						"id": "VarusE",
						"name": "Hail of Arrows",
						"description": "Varus fires a hail of arrows that deal physical damage and desecrate the ground. Desecrated ground slows enemies' Movement Speed and reduces their self healing and regeneration. ",
						"tooltip": "Varus fires a hail of arrows that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and desecrates the ground for {{ e3 }} seconds.<br /><br />Desecrated Ground slows enemy Movement Speed by {{ e2 }}% and reduces healing effects by {{ e4 }}%.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							16,
							14,
							12,
							10
						],
						"cooldownBurn": "18/16/14/12/10",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								25,
								30,
								35,
								40,
								45
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"25/30/35/40/45",
							"4",
							"40",
							"300",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							925,
							925,
							925,
							925,
							925
						],
						"rangeBurn": "925",
						"image": {
							"full": "VarusE.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VarusR",
						"name": "Chain of Corruption",
						"description": "Varus flings out a damaging tendril of corruption that immobilizes the first enemy champion hit and then spreads towards nearby uninfected champions, immobilizing them too on contact. ",
						"tooltip": "Varus flings out a tendril of corruption that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and immobilizes the first enemy champion hit for {{ e2 }} seconds.<br /><br />The corruption then spreads towards nearby uninfected enemy champions. If it reaches them, they take the same damage and are also immobilized. Immobilized units gain {{ e4 }} <span class=\"colorB829FF\">Blight</span> stacks over the duration.",
						"leveltip": {
							"label": [
								"Damage ",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							90,
							70
						],
						"cooldownBurn": "110/90/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								175,
								250
							],
							[
								2,
								2,
								2
							],
							[
								650,
								650,
								650
							],
							[
								3,
								3,
								3
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								600,
								600,
								600
							],
							[
								1.75,
								1.75,
								1.75
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/175/250",
							"2",
							"650",
							"3",
							"0.5",
							"600",
							"1.75",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1200,
							1200,
							1200
						],
						"rangeBurn": "1200",
						"image": {
							"full": "VarusR.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Living Vengeance",
					"description": "On kill or assist, Varus temporarily gains Attack Speed. This bonus is larger if the enemy is a champion.",
					"image": {
						"full": "VarusPassive.png",
						"sprite": "passive3.png",
						"group": "passive",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Varus",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3008",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Varus",
						"title": "VarusTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Vayne": {
				"id": "Vayne",
				"key": "67",
				"name": "Vayne",
				"title": "the Night Hunter",
				"image": {
					"full": "Vayne.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "67000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "67001",
						"num": 1,
						"name": "Vindicator Vayne",
						"chromas": false
					},
					{
						"id": "67002",
						"num": 2,
						"name": "Aristocrat Vayne",
						"chromas": false
					},
					{
						"id": "67003",
						"num": 3,
						"name": "Dragonslayer Vayne",
						"chromas": true
					},
					{
						"id": "67004",
						"num": 4,
						"name": "Heartseeker Vayne",
						"chromas": false
					},
					{
						"id": "67005",
						"num": 5,
						"name": "SKT T1 Vayne",
						"chromas": false
					},
					{
						"id": "67006",
						"num": 6,
						"name": "Arclight Vayne",
						"chromas": false
					},
					{
						"id": "67010",
						"num": 10,
						"name": "Soulstealer Vayne",
						"chromas": false
					},
					{
						"id": "67011",
						"num": 11,
						"name": "PROJECT: Vayne",
						"chromas": false
					}
				],
				"lore": "Shauna Vayne is a deadly, remorseless Demacian monster hunter, who has dedicated her life to finding and destroying the demon that murdered her family. Armed with a wrist-mounted crossbow and a heart full of vengeance, she is only truly happy when slaying practitioners or creations of the dark arts, striking from the shadows with a flurry of silver bolts.",
				"blurb": "Shauna Vayne is a deadly, remorseless Demacian monster hunter, who has dedicated her life to finding and destroying the demon that murdered her family. Armed with a wrist-mounted crossbow and a heart full of vengeance, she is only truly happy when...",
				"allytips": [
					"Tumble has many uses, but it cannot pass over walls.",
					"Condemn can be used to both pin targets to walls to ensure a kill, or to escape a pursuer.",
					"Don't go in first to a large teamfight. Wait for your teammates to initiate."
				],
				"enemytips": [
					"Vayne is fragile - turn the pressure up on her and she will be forced to play cautiously.",
					"Deny Vayne the opportunity to pin you against walls."
				],
				"tags": [
					"Marksman",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 10,
					"defense": 1,
					"magic": 1,
					"difficulty": 8
				},
				"stats": {
					"hp": 498.44,
					"hpperlevel": 83,
					"mp": 231.8,
					"mpperlevel": 35,
					"movespeed": 330,
					"armor": 28,
					"armorperlevel": 3.4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6.972,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 1.66,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 3.3
				},
				"spells": [
					{
						"id": "VayneTumble",
						"name": "Tumble",
						"description": "Vayne tumbles, maneuvering to carefully place her next shot. Her next attack critically strikes.",
						"tooltip": "Vayne rolls a short distance, and deals <scaleAD>{{ f1 }}</scaleAD> bonus physical damage on her next basic attack within {{ e3 }} seconds.<br /><br /><rules>Tumble's bonus damage is equal to {{ e1 }}% of Vayne's total attack damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5,
							4,
							3,
							2
						],
						"cooldownBurn": "6/5/4/3/2",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								50,
								55,
								60,
								65,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/55/60/65/70",
							"0",
							"7",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": [
									0.3,
									0.35,
									0.4,
									0.45,
									0.5
								],
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "VayneTumble.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VayneSilveredBolts",
						"name": "Silver Bolts",
						"description": "Vayne tips her bolts with a rare metal, toxic to evil things. The third consecutive attack or ability against the same target deals a percentage of the target's maximum Health as bonus true damage. (Max: 200 damage vs. Monsters)",
						"tooltip": "Every third consecutive attack or ability against an enemy deals an additional {{ e1 }}% of the enemy's maximum health as true damage (no less than {{ e2 }}).<br /><br /><rules>Silver Bolts deals no more than {{ e3 }} damage against monsters.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Minimum Damage"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }} -> {{ e2NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								4,
								6,
								8,
								10,
								12
							],
							[
								50,
								65,
								80,
								95,
								110
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								3.5,
								3.5,
								3.5,
								3.5,
								3.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/6/8/10/12",
							"50/65/80/95/110",
							"200",
							"3.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "Passive",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "VayneSilveredBolts.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "Passive"
					},
					{
						"id": "VayneCondemn",
						"name": "Condemn",
						"description": "Vayne draws a heavy crossbow from her back, and fires a huge bolt at her target, knocking them back and dealing damage. If they collide with terrain, they are impaled, dealing bonus damage and stunning them.",
						"tooltip": "Fires a bolt that knocks back a target and deals {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage.<br /><br />If the target collides with terrain, the damage is increased to <scaleAD>{{ f1 }}</scaleAD> and the target is stunned for {{ e3 }} seconds.<br /><br /><rules>Condemn's damage is increased by {{ e2 }}% if the target collides with terrain.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							18,
							16,
							14,
							12
						],
						"cooldownBurn": "20/18/16/14/12",
						"cost": [
							90,
							90,
							90,
							90,
							90
						],
						"costBurn": "90",
						"effect": [
							null,
							[
								50,
								85,
								120,
								155,
								190
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								475,
								475,
								475,
								475,
								475
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/85/120/155/190",
							"100",
							"1.5",
							"475",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.5,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "VayneCondemn.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VayneInquisition",
						"name": "Final Hour",
						"description": "Readying herself for an epic confrontation, Vayne gains increased Attack Damage, Invisibility during Tumble, and triple the bonus Movement Speed from Night Hunter.",
						"tooltip": "Vayne gains {{ e1 }} bonus attack damage and improvements to Night Hunter and Tumble for {{ e2 }} seconds. The duration of Final Hour is extended by {{ e5 }} seconds whenever a champion damaged by Vayne dies within {{ e6 }} seconds.<br /><br /><span class=\"colorF0F0F0\">Night Hunter</span>: Vayne instead gains {{ e4 }} movement speed.<br /><span class=\"colorF0F0F0\">Tumble</span>: Vayne will also gain <span class=\"color91d7ee\">Invisibility</span> for {{ e3 }} second when she Tumbles.<br /><br /><rules><span class=\"color91d7ee\">Stealth - Invisible:</span> Vayne can only be revealed by nearby enemy Turrets or <span class=\"coloree91d7\">True Sight</span>.<br />Final Hour's duration can't be increased beyond its original maximum duration.</rules>",
						"leveltip": {
							"label": [
								"Bonus Attack Damage",
								"Duration",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							85,
							70
						],
						"cooldownBurn": "100/85/70",
						"cost": [
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								20,
								30,
								40
							],
							[
								8,
								10,
								12
							],
							[
								1,
								1,
								1
							],
							[
								90,
								90,
								90
							],
							[
								4,
								4,
								4
							],
							[
								3,
								3,
								3
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40",
							"8/10/12",
							"1",
							"90",
							"4",
							"3",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1,
							1,
							1
						],
						"rangeBurn": "1",
						"image": {
							"full": "VayneInquisition.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Night Hunter",
					"description": "Vayne ruthlessly hunts evil-doers, gaining 30 movement speed when moving toward nearby enemy champions.",
					"image": {
						"full": "Vayne_NightHunter.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Vayne",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "1053",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1042",
										"count": 1
									},
									{
										"id": "3006",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "1053",
										"count": 1
									},
									{
										"id": "1038",
										"count": 1
									},
									{
										"id": "3072",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3087",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									},
									{
										"id": "3031",
										"count": 1
									},
									{
										"id": "3102",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3144",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VaynePRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vayne",
						"title": "VayneTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Veigar": {
				"id": "Veigar",
				"key": "45",
				"name": "Veigar",
				"title": "the Tiny Master of Evil",
				"image": {
					"full": "Veigar.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "45000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "45001",
						"num": 1,
						"name": "White Mage Veigar",
						"chromas": false
					},
					{
						"id": "45002",
						"num": 2,
						"name": "Curling Veigar",
						"chromas": false
					},
					{
						"id": "45003",
						"num": 3,
						"name": "Veigar Greybeard",
						"chromas": false
					},
					{
						"id": "45004",
						"num": 4,
						"name": "Leprechaun Veigar",
						"chromas": false
					},
					{
						"id": "45005",
						"num": 5,
						"name": "Baron Von Veigar",
						"chromas": false
					},
					{
						"id": "45006",
						"num": 6,
						"name": "Superb Villain Veigar",
						"chromas": false
					},
					{
						"id": "45007",
						"num": 7,
						"name": "Bad Santa Veigar",
						"chromas": false
					},
					{
						"id": "45008",
						"num": 8,
						"name": "Final Boss Veigar",
						"chromas": false
					},
					{
						"id": "45009",
						"num": 9,
						"name": "Omega Squad Veigar",
						"chromas": true
					}
				],
				"lore": "An enthusiastic master of dark sorcery, Veigar has embraced powers that few mortals dare approach. As a free-spirited inhabitant of Bandle City, he longed to push beyond the limitations of yordle magic, and turned instead to arcane texts that had been hidden away for thousands of years. Now a stubborn creature with an endless fascination for the mysteries of the universe, Veigar is often underestimated by others—but even though he believes himself truly evil, he possesses an inner morality that leads some to question his deeper motivations.",
				"blurb": "An enthusiastic master of dark sorcery, Veigar has embraced powers that few mortals dare approach. As a free-spirited inhabitant of Bandle City, he longed to push beyond the limitations of yordle magic, and turned instead to arcane texts that had been...",
				"allytips": [
					"Use Event Horizon to increase your chances of landing Dark Matter.",
					"Veigar is extremely Mana and Cooldown Reduction dependent. Try buying items with these stats in order to increase the effectiveness of your passive and Baleful Strike.",
					"Veigar is very fragile. It is valuable to select at least one summoner spell that can be used defensively."
				],
				"enemytips": [
					"Dark Matter deals very high damage, but it can be avoided. Pay attention to the sound and visual indicator to be aware of when and where the spell will land.",
					"Event Horizon only stuns units on the edge. If you're inside the spell, you can still move and attack.",
					"Veigar's ultimate deals increased damage based on your missing health."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 2,
					"magic": 10,
					"difficulty": 7
				},
				"stats": {
					"hp": 505,
					"hpperlevel": 94,
					"mp": 392.4,
					"mpperlevel": 52,
					"movespeed": 340,
					"armor": 22.55,
					"armorperlevel": 3.75,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 50.71,
					"attackdamageperlevel": 2.625,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.24
				},
				"spells": [
					{
						"id": "VeigarBalefulStrike",
						"name": "Baleful Strike",
						"description": "Veigar unleashes a bolt of dark energy that deals magic damage to the first two enemies hit. Units killed by this bolt grant Veigar some ability power permanently.",
						"tooltip": "Unleashes a bolt of dark energy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first two enemies hit.<br /><br />Killing a unit with this also grants Veigar a stack of <span class=\"colorFFF673\">Phenomenal Evil</span>. Large minions and large monsters grant two.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"1",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "VeigarBalefulStrike.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VeigarDarkMatter",
						"name": "Dark Matter",
						"description": "Veigar calls a great mass of dark matter to fall from the sky to the target location, dealing magic damage when it lands. Stacks of Phenomenal Evil reduce Dark Matter's cooldown.",
						"tooltip": "After 1.2 seconds, dark matter falls from the sky to the target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Every 50 stacks of <span class=\"colorFFF673\">Phenomenal Evil</span> reduce Dark Matter's cooldown by 10% (currently <span class=\"colorFFF673\">{{ f2.0*100 }}%</span>).",
						"leveltip": {
							"label": [
								"Damage",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								1.2,
								1.2,
								1.2,
								1.2,
								1.2
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.02,
								0.02,
								0.02,
								0.02,
								0.02
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/150/200/250/300",
							"1.2",
							"8",
							"0",
							"0.02",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "VeigarDarkMatter.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VeigarEventHorizon",
						"name": "Event Horizon",
						"description": "After a brief delay Veigar twists the edges of space around the target location for 3 seconds, stunning enemies who pass through the perimeter.",
						"tooltip": "After a {{ e2 }} second delay, Veigar twists the edges of space around the target location for 3 seconds, forming a pentagon of walls. Enemies who attempt to pass through the perimeter are stopped and stunned for {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Stun Duration",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							17,
							16,
							15,
							14
						],
						"cooldownBurn": "18/17/16/15/14",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								1.5,
								1.75,
								2,
								2.25,
								2.5
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1.5/1.75/2/2.25/2.5",
							"0.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							725,
							725,
							725,
							725,
							725
						],
						"rangeBurn": "725",
						"image": {
							"full": "VeigarEventHorizon.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VeigarR",
						"name": "Primordial Burst",
						"description": "Blasts target enemy champion, dealing a large amount of magic damage, increasing based on the target's missing health.",
						"tooltip": "Blasts the target with primal magic to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage, increasing based on the <span class=\"colorCC3300\">target's missing health</span>.<br /><br />Damage is maximized against enemies below 33% health.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								175,
								250,
								325
							],
							[
								350,
								500,
								650
							],
							[
								1,
								1,
								1
							],
							[
								2,
								2,
								2
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"175/250/325",
							"350/500/650",
							"1",
							"2",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 1.5,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "VeigarR.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Phenomenal Evil Power",
					"description": "Veigar is the greatest Evil to ever strike at the hearts of Runeterra - and he's only getting bigger! Striking an enemy Champion with a spell or scoring a takedown grants Veigar permanently increased Ability Power.",
					"image": {
						"full": "Veigar_Entropy.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Veigar",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Veigar",
						"title": "VeigarTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Velkoz": {
				"id": "Velkoz",
				"key": "161",
				"name": "Vel'Koz",
				"title": "the Eye of the Void",
				"image": {
					"full": "Velkoz.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "161000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "161001",
						"num": 1,
						"name": "Battlecast Vel'Koz",
						"chromas": false
					},
					{
						"id": "161002",
						"num": 2,
						"name": "Arclight Vel'Koz",
						"chromas": false
					},
					{
						"id": "161003",
						"num": 3,
						"name": "Definitely Not Vel'Koz",
						"chromas": false
					}
				],
				"lore": "It is unclear if Vel'Koz was the first Void-spawn to emerge on Runeterra, but there has certainly never been another to match his level of cruel, calculating sentience. While his kin devour or defile everything around them, he seeks instead to scrutinize and study the physical realm—and the strange, warlike beings that dwell there—for any weakness the Void might exploit. But Vel'Koz is far from a passive observer, striking back at threats with deadly plasma, or by disrupting the very fabric of the world itself.",
				"blurb": "It is unclear if Vel'Koz was the first Void-spawn to emerge on Runeterra, but there has certainly never been another to match his level of cruel, calculating sentience. While his kin devour or defile everything around them, he seeks instead to...",
				"allytips": [
					"When laning, use Void Rift to kill minions while building stacks of Organic Deconstruction on your opponent. You can then follow up with your other abilities.",
					"Shooting Plasma Fission diagonally and splitting at maximum range allows you to hit opponents that are out of the range of the initial missile, but is more challenging to pull off.",
					"Be very careful about when to use Life Form Disintegration Ray. Many champions have abilities that can interrupt the spell."
				],
				"enemytips": [
					"Vel'Koz is very dangerous if left alone in a fight. Try to focus him down early.",
					"Vel'Koz has fairly low mobility and is vulnerable to ganks.",
					"Life Form Disintegration Ray can be interrupted by stuns, silences and knockups."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 2,
					"magic": 10,
					"difficulty": 8
				},
				"stats": {
					"hp": 520,
					"hpperlevel": 88,
					"mp": 375.6,
					"mpperlevel": 42,
					"movespeed": 340,
					"armor": 21.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 54.9379,
					"attackdamageperlevel": 3.1416,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "VelkozQ",
						"name": "Plasma Fission",
						"description": "Vel'Koz shoots a bolt of plasma that splits in two on reactivation or upon hitting an enemy. The bolt slows and damages on hit.",
						"tooltip": "Vel'Koz shoots a plasma bolt that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and applies a slow of {{ e5 }}% that decays over {{ e4 }} second(s).<br /><br />Upon reactivation or upon hitting an enemy, the bolt splits at a 90 degree angle.<br /><br />Killing a unit with this refunds {{ e2 }}% of the <span class=\"color44DDFF\">Mana Cost</span>.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							7,
							7,
							7,
							7
						],
						"cooldownBurn": "7",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								1,
								1.4,
								1.8,
								2.2,
								2.6
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"50",
							"0.25",
							"1/1.4/1.8/2.2/2.6",
							"70",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1050,
							1050,
							1050,
							1050,
							1050
						],
						"rangeBurn": "1050",
						"image": {
							"full": "VelkozQ.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VelkozW",
						"name": "Void Rift",
						"description": "Vel'Koz opens a rift to the void that deals an initial burst of damage, then explodes for a second burst of damage after a delay.",
						"tooltip": "Vel'Koz opens a rift to the void that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage. After a delay, it deals an additional {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage.<br /><br />Void Rift has a 2 second cooldown between casts.",
						"leveltip": {
							"label": [
								"Initial Damage",
								"Secondary Damage",
								"Ammo Recharge Time",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						"cooldownBurn": "1.5",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								30,
								50,
								70,
								90,
								110
							],
							[
								45,
								75,
								105,
								135,
								165
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								88,
								88,
								88,
								88,
								88
							],
							[
								500,
								500,
								500,
								500,
								500
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/50/70/90/110",
							"45/75/105/135/165",
							"100",
							"0",
							"0.25",
							"0.5",
							"88",
							"500",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.25,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							1050,
							1050,
							1050,
							1050,
							1050
						],
						"rangeBurn": "1050",
						"image": {
							"full": "VelkozW.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VelkozE",
						"name": "Tectonic Disruption",
						"description": "Vel'Koz causes an area to explode, knocking up enemies, and knocking close enemies slightly away.",
						"tooltip": "Vel'Koz disrupts a nearby area which, after a delay, deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and knocks up enemies hit for {{ e2 }} seconds.<br /><br />Any enemies hit that are close to Vel'Koz will be pushed slightly in the direction the ability was cast.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15,
							14,
							13,
							12
						],
						"cooldownBurn": "16/15/14/13/12",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								70,
								100,
								130,
								160,
								190
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/100/130/160/190",
							"0.75",
							"0",
							"225",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							810,
							810,
							810,
							810,
							810
						],
						"rangeBurn": "810",
						"image": {
							"full": "VelkozE.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VelkozR",
						"name": "Life Form Disintegration Ray",
						"description": "Vel'Koz unleashes a channelled beam that follows the cursor for 2.5 seconds that deals magic damage. Organic Deconstruction Researches enemy champions causing them to take true damage instead.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Deconstructing enemy Champions <span class=\"colorFFFFFF\">Researches</span> them for {{ e2 }} seconds. Basic attacks and all abilities refresh Research.<br /><br /><span class=\"colorFF9900\">Active: </span>Vel'Koz channels a ray of energy that follows the cursor for 2.5 seconds, dealing Magic Damage up to a total of {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> and slowing units hit by {{ e3 }}%.<br /><br />Enemies that stay in the beam will periodically gain <span class=\"colorFFFFFF\">Organic Deconstruction</span> stacks. Deals True Damage instead of Magic against <span class=\"colorFFFFFF\">Researched</span> units.",
						"leveltip": {
							"label": [
								"Total Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								450,
								625,
								800
							],
							[
								7,
								7,
								7
							],
							[
								20,
								20,
								20
							],
							[
								40,
								40,
								40
							],
							[
								175,
								175,
								175
							],
							[
								7,
								7,
								7
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"450/625/800",
							"7",
							"20",
							"40",
							"175",
							"7",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1.25,
								"key": "a1"
							}
						],
						"costType": "Mana",
						"maxammo": "-1",
						"range": [
							1575,
							1575,
							1575
						],
						"rangeBurn": "1575",
						"image": {
							"full": "VelkozR.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "Mana"
					}
				],
				"passive": {
					"name": "Organic Deconstruction",
					"description": "Vel'Koz's abilities apply <font color='#FFFFFF'>Organic Deconstruction</font> to enemies on hit. If 3 stacks are accumulated, the enemy will take a burst of true damage.",
					"image": {
						"full": "Velkoz_Passive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Velkoz",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3028",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Velkoz",
						"title": "VelkozTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Vi": {
				"id": "Vi",
				"key": "254",
				"name": "Vi",
				"title": "the Piltover Enforcer",
				"image": {
					"full": "Vi.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "254000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "254001",
						"num": 1,
						"name": "Neon Strike Vi",
						"chromas": false
					},
					{
						"id": "254002",
						"num": 2,
						"name": "Officer Vi",
						"chromas": true
					},
					{
						"id": "254003",
						"num": 3,
						"name": "Debonair Vi",
						"chromas": false
					},
					{
						"id": "254004",
						"num": 4,
						"name": "Demon Vi",
						"chromas": false
					},
					{
						"id": "254005",
						"num": 5,
						"name": "Warring Kingdoms Vi",
						"chromas": false
					},
					{
						"id": "254011",
						"num": 11,
						"name": "PROJECT: Vi",
						"chromas": false
					}
				],
				"lore": "Once a criminal from the mean streets of Zaun, Vi is a hotheaded, impulsive, and fearsome woman with only a very loose respect for authority figures. Growing up all but alone, Vi developed finely honed survival instincts as well as a wickedly abrasive sense of humor. Now working with the Wardens of Piltover to keep the peace, she wields mighty hextech gauntlets that can punch through walls and suspects with equal ease.",
				"blurb": "Once a criminal from the mean streets of Zaun, Vi is a hotheaded, impulsive, and fearsome woman with only a very loose respect for authority figures. Growing up all but alone, Vi developed finely honed survival instincts as well as a wickedly abrasive...",
				"allytips": [
					"A fully charged Vault Breaker will deal double damage. It's great for catching and finishing off fleeing enemies.",
					"Excessive Force does full damage to anyone caught in the shockwave. Use it on minions in lane to hit enemies hiding behind them.",
					"Assault and Battery is a powerful initiation tool, just remember not to get too far ahead of the rest of your team."
				],
				"enemytips": [
					"A fully charged Vault breaker deals double damage. If you see Vi start to charge you should back off or try to dodge it.",
					"Vi will shred your Armor and gain Attack Speed if she manages to hit you three times in a row. Try not to engage in extended brawls with her.",
					"Vi cannot be stopped while using her ult. Remember to save your displacement effects until after she's done charging."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 5,
					"magic": 3,
					"difficulty": 4
				},
				"stats": {
					"hp": 582.8,
					"hpperlevel": 85,
					"mp": 295.6,
					"mpperlevel": 45,
					"movespeed": 340,
					"armor": 35,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 9,
					"hpregenperlevel": 0.9,
					"mpregen": 8.092,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 3.5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "ViQ",
						"name": "Vault Breaker",
						"description": "Vi charges her gauntlets and unleashes a vault shattering punch, carrying her forward. Enemies she hits are knocked back and receive a stack of Denting Blows.",
						"tooltip": "Charges a powerful punch that carries Vi forward.<br /><br /><span class=\"colorFF9900\">First Cast:</span> Slows Movement Speed by {{ e4 }}% while increasing damage and dash range over 1.25 seconds.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Dashes forward dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> to {{ f2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and applying Denting Blows to all enemies hit (deals {{ e3 }}% damage to minions and monsters). Stops upon colliding with an enemy champion, knocking it back.",
						"leveltip": {
							"label": [
								"Min Damage",
								"Max Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							14,
							12,
							10,
							8
						],
						"cooldownBurn": "16/14/12/10/8",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								110,
								160,
								210,
								260,
								310
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								75,
								75,
								75,
								75,
								75
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"110/160/210/260/310",
							"2",
							"75",
							"15",
							"6",
							"5",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 1.4,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							250,
							250,
							250,
							250,
							250
						],
						"rangeBurn": "250",
						"image": {
							"full": "ViQ.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ViW",
						"name": "Denting Blows",
						"description": "Vi's punches break her opponent's Armor, dealing bonus damage and granting her Attack Speed.",
						"tooltip": "Every 3rd attack on the same target deals an additional {{ e1 }}% <span class=\"colorFF8C00\">(+{{ f1 }}%)</span> of the target's maximum Health as physical damage, reduces its Armor by {{ e3 }}% and grants Vi {{ e2 }}% Attack Speed for {{ e4 }} seconds (max {{ e5 }} damage vs. monsters).",
						"leveltip": {
							"label": [
								"Max Health Damage",
								"Attack Speed"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								4,
								5.5,
								7,
								8.5,
								10
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.0286,
								0.0286,
								0.0286,
								0.0286,
								0.0286
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/5.5/7/8.5/10",
							"30/35/40/45/50",
							"20",
							"4",
							"300",
							"4",
							"0.03",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "@special.viw",
								"coeff": 35,
								"key": "f1"
							}
						],
						"costType": "Passive",
						"maxammo": "-1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "ViW.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "Passive"
					},
					{
						"id": "ViE",
						"name": "Excessive Force",
						"description": "Vi's next attack blasts through her target, dealing damage to enemies behind it.",
						"tooltip": "Causes next basic attack to deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to the target and enemies behind it.<br /><br /></span>Vi charges a new punch every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can hold 2 charges at once.",
						"leveltip": {
							"label": [
								"Damage",
								"Charge Time",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f1 }} -> {{ f2 }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1,
							1,
							1,
							1,
							1
						],
						"cooldownBurn": "1",
						"cost": [
							40,
							45,
							50,
							55,
							60
						],
						"costBurn": "40/45/50/55/60",
						"effect": [
							null,
							[
								10,
								30,
								50,
								70,
								90
							],
							[
								1.15,
								1.15,
								1.15,
								1.15,
								1.15
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10/30/50/70/90",
							"1.15",
							"50",
							"1.5",
							"6",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.15,
								"key": "f3"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							},
							{
								"link": "@text",
								"coeff": [
									14,
									12.5,
									11,
									9.5,
									8
								],
								"key": "f1"
							},
							{
								"link": "@text",
								"coeff": [
									14,
									12.5,
									11,
									9.5,
									8
								],
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "ViE.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ViR",
						"name": "Assault and Battery",
						"description": "Vi runs down an enemy, knocking aside anyone in the way. When she reaches her target she knocks it into the air, jumps after it, and slams it back into the ground.",
						"tooltip": "Targets an enemy champion and chases it down, knocking it up for 1.25 seconds, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><br />While charging, Vi cannot be stopped and has <span class=\"coloree91d7\">True Sight</span> of the target. Any enemies in the way are knocked aside and dealt 75% of the damage.",
						"leveltip": {
							"label": [
								"Total Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								" {{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							100,
							70
						],
						"cooldownBurn": "130/100/70",
						"cost": [
							100,
							125,
							150
						],
						"costBurn": "100/125/150",
						"effect": [
							null,
							[
								150,
								300,
								450
							],
							[
								0.75,
								0.75,
								0.75
							],
							[
								1.25,
								1.25,
								1.25
							],
							[
								4,
								4,
								4
							],
							[
								1,
								1.5,
								2
							],
							[
								800,
								800,
								800
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/300/450",
							"0.75",
							"1.25",
							"4",
							"1/1.5/2",
							"800",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "ViR.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Blast Shield",
					"description": "Vi charges a shield over time. The shield can be activated by hitting an enemy with an ability.",
					"image": {
						"full": "ViPassive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Vi",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1055",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1055",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1036",
										"count": 1
									},
									{
										"id": "3044",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "1029",
										"count": 1
									},
									{
										"id": "3047",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3044",
										"count": 1
									},
									{
										"id": "3057",
										"count": 1
									},
									{
										"id": "3086",
										"count": 1
									},
									{
										"id": "3078",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3071",
										"count": 1
									},
									{
										"id": "3110",
										"count": 1
									},
									{
										"id": "3105",
										"count": 1
									},
									{
										"id": "3022",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vi",
						"title": "ViTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1400",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3252",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Viktor": {
				"id": "Viktor",
				"key": "112",
				"name": "Viktor",
				"title": "the Machine Herald",
				"image": {
					"full": "Viktor.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "112000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "112001",
						"num": 1,
						"name": "Full Machine Viktor",
						"chromas": false
					},
					{
						"id": "112002",
						"num": 2,
						"name": "Prototype Viktor",
						"chromas": false
					},
					{
						"id": "112003",
						"num": 3,
						"name": "Creator Viktor",
						"chromas": false
					},
					{
						"id": "112004",
						"num": 4,
						"name": "Death Sworn Viktor",
						"chromas": false
					}
				],
				"lore": "The herald of a new age of technology, Viktor has devoted his life to the advancement of humankind. An idealist who seeks to lift the people of Zaun to a new level of understanding, he believes that only by embracing a glorious evolution of technology can humanity's full potential be realized. With a body augmented by steel and science, Viktor is zealous in his pursuit of this bright future.",
				"blurb": "The herald of a new age of technology, Viktor has devoted his life to the advancement of humankind. An idealist who seeks to lift the people of Zaun to a new level of understanding, he believes that only by embracing a glorious evolution of technology...",
				"allytips": [
					"Death Ray is a powerful poke and a strong area of denial tool. Use it in combination with Gravity Field to control your enemy's position.",
					"Make sure you choose the right augment at the right time."
				],
				"enemytips": [
					"Be careful about how close you let Viktor get to you. Viktor's control of the battlefield increases with his proximity to his opponent.",
					"Be aware of how many augments Viktor has upgraded by looking at the color of the light on his staff (purple, yellow, blue, red)."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 4,
					"magic": 10,
					"difficulty": 9
				},
				"stats": {
					"hp": 528.04,
					"hpperlevel": 90,
					"mp": 324,
					"mpperlevel": 50,
					"movespeed": 335,
					"armor": 22.72,
					"armorperlevel": 4,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 8,
					"hpregenperlevel": 0.65,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 52.04,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2.11
				},
				"spells": [
					{
						"id": "ViktorPowerTransfer",
						"name": "Siphon Power",
						"description": "Viktor blasts an enemy unit dealing magic damage, gaining a shield and empowering his next basic attack.<br><br>Augment: Siphon Power's shield is increased by 60% and Viktor gains bonus Movement Speed after casting.",
						"tooltip": "Viktor blasts an enemy unit, dealing {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage while granting Viktor a shield that absorbs up to <span class=\"color44DDFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ f2 }})</span> damage over the next {{ e2 }} seconds.<br /><br />Viktor's next basic attack deals {{ e5 }}<span class=\"color99FF99\"> (+{{ a2 }})</span> bonus magic damage.<br /><br /><span class=\"colorFFCC00\">Augment - Turbocharge:</span> Siphon Power's shield is increased by 60% and Viktor gains {{ e3 }}% Movement Speed for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage (missile)",
								"Damage (attack)",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8,
							7,
							6,
							5,
							4
						],
						"cooldownBurn": "8/7/6/5/4",
						"cost": [
							45,
							50,
							55,
							60,
							65
						],
						"costBurn": "45/50/55/60/65",
						"effect": [
							null,
							[
								60,
								80,
								100,
								120,
								140
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								20,
								40,
								60,
								80,
								100
							],
							[
								0.08,
								0.08,
								0.08,
								0.08,
								0.08
							],
							[
								0.15,
								0.15,
								0.15,
								0.15,
								0.15
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/80/100/120/140",
							"2.5",
							"30",
							"0",
							"20/40/60/80/100",
							"0.08",
							"0.15",
							"0.6",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "ViktorPowerTransfer.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ViktorGravitonField",
						"name": "Gravity Field",
						"description": "Viktor conjures a heavy gravitational field that slows enemies in its radius. Enemies who stay within the device for too long are stunned.<br><br>Augment: Enemies stunned by Gravity Field are dragged to the center.",
						"tooltip": "Viktor deploys a gravitational imprisonment device for {{ e3 }} seconds, slowing enemy units by {{ e1 }}% and adding a stack every {{ e4 }} seconds. At {{ e5 }} stacks the target is stunned for {{ e2 }} seconds.<br /><br /><span class=\"colorFFCC00\">Augment - Implosion:</span> Enemies stunned by Gravity Field are dragged to the center.",
						"leveltip": {
							"label": [
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							17,
							16,
							15,
							14,
							13
						],
						"cooldownBurn": "17/16/15/14/13",
						"cost": [
							65,
							65,
							65,
							65,
							65
						],
						"costBurn": "65",
						"effect": [
							null,
							[
								28,
								32,
								36,
								40,
								44
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"28/32/36/40/44",
							"1.5",
							"4",
							"0.5",
							"3",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "ViktorGravitonField.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ViktorDeathRay",
						"name": "Death Ray",
						"description": "Viktor uses his robotic arm to fire a chaos beam that cuts across the field in a line, dealing damage to all enemies in its path.<br><br>Augment: An explosion follows the Death Ray's wake, dealing magic damage.",
						"tooltip": "Viktor uses his robotic arm to fire a chaos beam that cuts across the field in a line, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to every enemy in its path.<br /><br /><span class=\"colorFFCC00\">Augment - Aftershock:</span> An explosion follows the Death Ray's wake, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Damage (Death Ray)",
								"Damage (Aftershock)",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								70,
								110,
								150,
								190,
								230
							],
							[
								20,
								60,
								100,
								140,
								180
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/110/150/190/230",
							"20/60/100/140/180",
							"1",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							525,
							525,
							525,
							525,
							525
						],
						"rangeBurn": "525",
						"image": {
							"full": "ViktorDeathRay.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ViktorChaosStorm",
						"name": "Chaos Storm",
						"description": "Viktor conjures a singularity on the field which deals magic damage and interrupts enemy channels. The singularity then periodically does magic damage to all nearby enemies. Viktor can redirect the singularity.<br><br>Augment: The Chaos Storm moves faster.",
						"tooltip": "Viktor conjures a singularity at target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and interrupting enemy channels.<br /><br />Viktor can redirect the singularity for {{ e3 }} seconds, which will discharge {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage every {{ e4 }} seconds to nearby enemies. The singularity will move slower as it attempts to move farther away from Viktor.<br /><br /><span class=\"colorFFCC00\">Augment - Velocity:</span> Chaos Storm moves {{ e0 }}% faster.",
						"leveltip": {
							"label": [
								"Damage (impact)",
								"Damage (discharge)",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							100,
							80
						],
						"cooldownBurn": "120/100/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								175,
								250
							],
							[
								150,
								250,
								350
							],
							[
								6.5,
								6.5,
								6.5
							],
							[
								2,
								2,
								2
							],
							[
								3,
								3,
								3
							],
							[
								400,
								400,
								400
							],
							[
								200,
								200,
								200
							],
							[
								300,
								300,
								300
							],
							[
								900,
								900,
								900
							],
							[
								0.2,
								0.2,
								0.2
							]
						],
						"effectBurn": [
							null,
							"100/175/250",
							"150/250/350",
							"6.5",
							"2",
							"3",
							"400",
							"200",
							"300",
							"900",
							"0.2"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "ViktorChaosStorm.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Glorious Evolution",
					"description": "Viktor starts with the Prototype Hex Core that can be upgraded three times in the store to augment his abilities.",
					"image": {
						"full": "Viktor_Passive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Viktor",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3196",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3196",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Viktor",
						"title": "ViktorTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3196",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3198",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Vladimir": {
				"id": "Vladimir",
				"key": "8",
				"name": "Vladimir",
				"title": "the Crimson Reaper",
				"image": {
					"full": "Vladimir.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "8000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "8001",
						"num": 1,
						"name": "Count Vladimir",
						"chromas": false
					},
					{
						"id": "8002",
						"num": 2,
						"name": "Marquis Vladimir",
						"chromas": false
					},
					{
						"id": "8003",
						"num": 3,
						"name": "Nosferatu Vladimir",
						"chromas": false
					},
					{
						"id": "8004",
						"num": 4,
						"name": "Vandal Vladimir",
						"chromas": false
					},
					{
						"id": "8005",
						"num": 5,
						"name": "Blood Lord Vladimir",
						"chromas": false
					},
					{
						"id": "8006",
						"num": 6,
						"name": "Soulstealer Vladimir",
						"chromas": false
					},
					{
						"id": "8007",
						"num": 7,
						"name": "Academy Vladimir",
						"chromas": false
					}
				],
				"lore": "A fiend with a thirst for mortal blood, Vladimir has influenced the affairs of Noxus since the empire's earliest days. In addition to unnaturally extending his life, his mastery of hemomancy allows him to control the minds and bodies of others as easily as his own. In the flamboyant salons of the Noxian aristocracy, this has enabled him to build a fanatical cult of personality around himself—while in the lowest back alleys, it allows him to bleed his enemies dry.",
				"blurb": "A fiend with a thirst for mortal blood, Vladimir has influenced the affairs of Noxus since the empire's earliest days. In addition to unnaturally extending his life, his mastery of hemomancy allows him to control the minds and bodies of others as easily...",
				"allytips": [
					"Transfusion instantly deals damage to the enemy before healing Vladimir, making it one of the best last hitting tools in the game.",
					"Cast Hemoplague where it will afflict the most units.",
					"Sanguine Pool pops incoming missiles, so it can be used to dodge disables."
				],
				"enemytips": [
					"Try to take Vladimir down before Hemoplague detonates, as it will heal him for each afflicted enemy Champion.",
					"Making Vladimir use Sanguine Pool at the start of a fight will maximize the Health cost of the ability to him.",
					"Items that counter Health stacking, such as Liandry's Torment and Blade of the Ruined King, are very effective against Vladimir."
				],
				"tags": [
					"Mage",
					"Tank"
				],
				"partype": "Crimson Rush",
				"info": {
					"attack": 2,
					"defense": 6,
					"magic": 8,
					"difficulty": 7
				},
				"stats": {
					"hp": 537,
					"hpperlevel": 96,
					"mp": 2,
					"mpperlevel": 0,
					"movespeed": 330,
					"armor": 23,
					"armorperlevel": 3.3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 450,
					"hpregen": 7,
					"hpregenperlevel": 0.6,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 55,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "VladimirQ",
						"name": "Transfusion",
						"description": "Vladimir steals life from the target enemy. When Vladimir's resource is full, Transfusion will benefit from massively increased damage and healing for a brief time.",
						"tooltip": "Vladimir drains the lifeforce of his target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and healing himself for {{ e2 }}<span class=\"color99ff99\"> (+{{ a2 }})</span> health. After casting Transfusion twice, Vladimir gains <span class=\"colorFFB3B3\">Crimson Rush</span> the next time it becomes available to cast.<br /><br /><span class=\"colorFFB3B3\">Crimson Rush:</span> Vladimir is briefly hasted and for the next {{ e8 }} seconds Transfusion deals {{ e7 }}% increased damage and heals for an additional <span class=\"colorFFFFFF\">{{ f7 }}</span> plus {{ e5 }}% <span class=\"color99FF99\">(+{{ f6 }}%)</span> of his missing health (empowered heal has {{ e9 }}% effectiveness against minions). ",
						"leveltip": {
							"label": [
								"Damage",
								"Heal",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								80,
								100,
								120,
								140,
								160
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0.04,
								0.04,
								0.04,
								0.04,
								0.04
							],
							[
								85,
								85,
								85,
								85,
								85
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/100/120/140/160",
							"20/25/30/35/40",
							"0",
							"0",
							"5",
							"0.04",
							"85",
							"2.5",
							"35",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a2"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "VladimirQ.png",
							"sprite": "spell12.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "VladimirSanguinePool",
						"name": "Sanguine Pool",
						"description": "Vladimir sinks into a pool of blood, becoming untargetable for 2 seconds. Additionally, enemies on the pool are slowed and Vladimir siphons life from them.",
						"tooltip": "Vladimir sinks into a pool of blood for 2 seconds, gaining a brief haste and becoming untargetable while slowing enemies above him by {{ e3 }}%.<br /><br />Vladimir deals {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [{{ e4 }}% of bonus Health]</span> magic damage over the duration and heals himself for {{ e5 }}% of that amount.<br /><br />Sanguine Pool can be cast while charging Tides of Blood.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							28,
							25,
							22,
							19,
							16
						],
						"cooldownBurn": "28/25/22/19/16",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								80,
								135,
								190,
								245,
								300
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/135/190/245/300",
							"20",
							"40",
							"10",
							"15",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonushealth",
								"coeff": 0.15,
								"key": "f1"
							}
						],
						"costType": "% of current Health",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "VladimirSanguinePool.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e2 }}% of current Health"
					},
					{
						"id": "VladimirE",
						"name": "Tides of Blood",
						"description": "Vladimir pays his own health to charge up a reservoir of blood which, when released, deals damage in the area around him but can be blocked by enemy units.",
						"tooltip": "<span class=\"colorFF9900\">First Cast: </span>Vladimir charges up a reservoir of blood, spending up to <span class=\"colorCC3300\">{{ e2 }}% of his max Health ({{ f3 }})</span> to increase this spell's damage. While at full charge, Vladimir is slowed.<br /><br /><span class=\"colorFF9900\">Second Cast: </span>Vladimir unleashes a nova of blood at surrounding enemies which deals between {{ e3 }}<span class=\"colorCC3300\"> (+{{ f2 }})</span><span class=\"color99FF99\"> (+{{ a1 }})</span> and {{ e0 }}<span class=\"colorCC3300\"> (+{{ f4 }})</span><span class=\"color99FF99\"> (+{{ a2 }})</span> magic damage and, at full charge, briefly slows by {{ e9 }}%. Targets hit block a portion of the nova.<br /><br />Tides of Blood will release automatically if held for more than {{ e7 }} seconds.",
						"leveltip": {
							"label": [
								"Min Damage",
								"Max Damage",
								"Slow Amount",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e0 }} -> {{ e0NL }}",
								"{{ e9 }}% -> {{ e9NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							11,
							9,
							7,
							5
						],
						"cooldownBurn": "13/11/9/7/5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								30,
								45,
								60,
								75,
								90
							],
							[
								6,
								6,
								6,
								6,
								6
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								60,
								90,
								120,
								150,
								180
							]
						],
						"effectBurn": [
							null,
							"0",
							"8",
							"30/45/60/75/90",
							"6",
							"150",
							"0",
							"1.5",
							"1",
							"40/45/50/55/60",
							"60/90/120/150/180"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 1,
								"key": "a2"
							}
						],
						"costType": "% of max Health",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "VladimirE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "Channeling Cost {{ e2 }}% of max Health"
					},
					{
						"id": "VladimirHemoplague",
						"name": "Hemoplague",
						"description": "Vladimir infects an area with a virulent plague. Affected enemies take increased damage for the duration. After a few seconds, Hemoplague deals magic damage to infected enemies and heals Vladimir for each enemy Champion hit.",
						"tooltip": "Vladimir infects enemies in a target area with a virulent plague, causing them to take {{ e2 }}% increased damage from all sources for {{ e4 }} seconds.<br /><br />After {{ e4 }} seconds, Vladimir deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all infected targets. If Hemoplague damages an enemy Champion, Vladimir heals himself for {{ f4 }} <span class=\"color99FF99\">(+{{ f3 }})</span>, plus {{ e5 }}% for each Champion beyond the first.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							150,
							135,
							120
						],
						"cooldownBurn": "150/135/120",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								10,
								10,
								10
							],
							[
								100,
								100,
								100
							],
							[
								4,
								4,
								4
							],
							[
								50,
								50,
								50
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"10",
							"100",
							"4",
							"50",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "VladimirHemoplague.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Crimson Pact",
					"description": "Every 40 points of bonus Health gives Vladimir 1 Ability Power and every 1 point of Ability Power gives Vladimir 1.4 bonus Health (does not stack with itself).",
					"image": {
						"full": "VladimirP.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Vladimir",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Vladimir",
						"title": "VladimirTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1052",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Volibear": {
				"id": "Volibear",
				"key": "106",
				"name": "Volibear",
				"title": "the Thunder's Roar",
				"image": {
					"full": "Volibear.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "106000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "106001",
						"num": 1,
						"name": "Thunder Lord Volibear",
						"chromas": false
					},
					{
						"id": "106002",
						"num": 2,
						"name": "Northern Storm Volibear",
						"chromas": false
					},
					{
						"id": "106003",
						"num": 3,
						"name": "Runeguard Volibear",
						"chromas": false
					},
					{
						"id": "106004",
						"num": 4,
						"name": "Captain Volibear",
						"chromas": false
					},
					{
						"id": "106005",
						"num": 5,
						"name": "El Rayo Volibear",
						"chromas": false
					}
				],
				"lore": "The thunderous demigod known as the Thousand-Pierced Bear is the battle-spirit of the Freljord. Thousands of years of constant and bitter wars, fought in the coldest winters, have hardened Volibear into a truly indomitable force, hurling bolts of lightning from the highest peaks—and when snowy tempests rage down, it can only mean that he is on the attack once more. Any who dare to face him may find themselves joining his fierce army of Ursine warriors… assuming they do not fall victim to his savage claws.",
				"blurb": "The thunderous demigod known as the Thousand-Pierced Bear is the battle-spirit of the Freljord. Thousands of years of constant and bitter wars, fought in the coldest winters, have hardened Volibear into a truly indomitable force, hurling bolts of...",
				"allytips": [
					"Lead the charge with Rolling Thunder and slow enemies with Majestic Roar.",
					"Volibear benefits a great deal from additional Health and cooldown reduction.",
					"You must attack three times in rapid succession before Frenzy can be activated - having the toughness to survive for a long time is one way to accomplish this goal."
				],
				"enemytips": [
					"Volibear can gain great Movement Speed while chasing targets, but he gains much less of a bonus when running away.",
					"Volibear regenerates a large amount of Health when he drops to critical Health.",
					"Slowing or stunning Volibear when he tries to charge will greatly reduce his effectiveness."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 7,
					"defense": 7,
					"magic": 4,
					"difficulty": 3
				},
				"stats": {
					"hp": 584.48,
					"hpperlevel": 86,
					"mp": 270.4,
					"mpperlevel": 30,
					"movespeed": 345,
					"armor": 35,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 8,
					"hpregenperlevel": 0.65,
					"mpregen": 8.092,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 68,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": -0.05,
					"attackspeedperlevel": 2.67
				},
				"spells": [
					{
						"id": "VolibearQ",
						"name": "Rolling Thunder",
						"description": "Volibear drops to all fours and runs faster. This bonus speed increases when chasing enemy champions. The first enemy he attacks is thrown backwards over Volibear.",
						"tooltip": "Volibear drops to all fours to hunt his enemies, gaining {{ e4 }}% Movement Speed for {{ e3 }} seconds. This bonus is enhanced to {{ e2 }}% Movement Speed while moving toward enemy champions.<br /><br />Volibear's next attack during this time deals an additional {{ e1 }} physical damage and flings the target behind him.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Cooldown",
								"Bonus Movement Speed Min",
								"Bonus Movement Speed Max"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								30,
								60,
								90,
								120,
								150
							],
							[
								30,
								37.5,
								45,
								52.5,
								60
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/60/90/120/150",
							"30/37.5/45/52.5/60",
							"4",
							"15/17.5/20/22.5/25",
							"400",
							"1",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "VolibearQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VolibearW",
						"name": "Frenzy",
						"description": "Volibear's repeated attacks grant him additional Attack Speed. Once Volibear has repeatedly attacked three times, he can perform a vicious bite on his target which deals increased damage based on the target's missing Health.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Volibear gains {{ e1 }}% Attack Speed with each attack. Stacks up to {{ e2 }} times.<br /><br /><span class=\"colorFF9900\">Active: </span>When Volibear has {{ e2 }} stacks of Frenzy, he can bite an enemy to deal {{ e3 }} <span class=\"colorCC3300\">(+{{ f1 }} [{{ e4 }}% of bonus Health])</span> physical damage, increased by {{ e5 }}% for each {{ e7 }}% Health the target is missing. If Volibear bites a minion or monster, Frenzy's cooldown is reduced by {{ e6 }}%.",
						"leveltip": {
							"label": [
								"Attack Speed Bonus",
								"Bite Damage"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e3 }} -> {{ e3NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							18,
							18,
							18,
							18,
							18
						],
						"cooldownBurn": "18",
						"cost": [
							35,
							35,
							35,
							35,
							35
						],
						"costBurn": "35",
						"effect": [
							null,
							[
								4,
								8,
								12,
								16,
								20
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4/8/12/16/20",
							"3",
							"60/110/160/210/260",
							"15",
							"1",
							"50",
							"1",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonushealth",
								"coeff": 0.15,
								"key": "f1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "VolibearW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VolibearE",
						"name": "Majestic Roar",
						"description": "Volibear lets out a powerful roar that damages, slows, and slightly knocks back enemies. Enemies who are airborne or dashing are dealt additional damage. Minions and monsters are feared as well.",
						"tooltip": "Volibear deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies, knocking them back slightly and slowing them by {{ e1 }}% for {{ e3 }} seconds. Enemies who are airborne or dashing are dealt an additional {{ e5 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.<br /><br />Additionally, minions and monsters are feared for 3 seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus Damage",
								"Slow Amount ",
								"Mana Cost "
							],
							"effect": [
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							11,
							11,
							11,
							11,
							11
						],
						"cooldownBurn": "11",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								49,
								49,
								49,
								49,
								49
							],
							[
								40,
								60,
								80,
								100,
								120
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								140,
								140,
								140,
								140,
								140
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/35/40/45/50",
							"60/105/150/195/240",
							"3",
							"49",
							"40/60/80/100/120",
							"70",
							"140",
							"100",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							425,
							425,
							425,
							425,
							425
						],
						"rangeBurn": "425",
						"image": {
							"full": "VolibearE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "VolibearR",
						"name": "Thunder Claws",
						"description": "Volibear erupts with chain lightning, damaging a number nearby enemies. The power of the storm causes Volibear's attacks to blast his targets with lightning that bounces to other nearby enemies.",
						"tooltip": "Volibear erupts with chain lightning, striking up to {{ e4 }} nearby enemies with {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />For the next {{ e3 }} seconds, the storm empowers Volibear, causing his basic attacks to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage that chains to {{ e4 }} nearby enemies.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							100,
							90,
							80
						],
						"cooldownBurn": "100/90/80",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								75,
								115,
								155
							],
							[
								9,
								9,
								9
							],
							[
								12,
								12,
								12
							],
							[
								8,
								8,
								8
							],
							[
								0.08,
								0.08,
								0.08
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/115/155",
							"9",
							"12",
							"8",
							"0.08",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "VolibearR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Chosen of the Storm",
					"description": "Volibear heals rapidly for a few seconds when his Health drops to a critical level.",
					"image": {
						"full": "VolibearPassive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Volibear",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Volibear",
						"title": "VolibearTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2032",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Warwick": {
				"id": "Warwick",
				"key": "19",
				"name": "Warwick",
				"title": "the Uncaged Wrath of Zaun",
				"image": {
					"full": "Warwick.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "19000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "19001",
						"num": 1,
						"name": "Grey Warwick",
						"chromas": false
					},
					{
						"id": "19002",
						"num": 2,
						"name": "Urf the Manatee",
						"chromas": false
					},
					{
						"id": "19003",
						"num": 3,
						"name": "Big Bad Warwick",
						"chromas": false
					},
					{
						"id": "19004",
						"num": 4,
						"name": "Tundra Hunter Warwick",
						"chromas": false
					},
					{
						"id": "19005",
						"num": 5,
						"name": "Feral Warwick",
						"chromas": false
					},
					{
						"id": "19006",
						"num": 6,
						"name": "Firefang Warwick",
						"chromas": false
					},
					{
						"id": "19007",
						"num": 7,
						"name": "Hyena Warwick",
						"chromas": false
					},
					{
						"id": "19008",
						"num": 8,
						"name": "Marauder Warwick",
						"chromas": false
					},
					{
						"id": "19009",
						"num": 9,
						"name": "Urfwick",
						"chromas": false
					},
					{
						"id": "19010",
						"num": 10,
						"name": "Lunar Guardian Warwick",
						"chromas": true
					}
				],
				"lore": "Warwick is a monster who hunts the gray alleys of Zaun. Transformed by agonizing experiments, his body is fused with an intricate system of chambers and pumps, machinery filling his veins with alchemical rage. Bursting out of the shadows, he preys upon those criminals who terrorize the city's depths. Warwick is drawn to blood, and driven mad by its scent. None who spill it can escape him.",
				"blurb": "Warwick is a monster who hunts the gray alleys of Zaun. Transformed by agonizing experiments, his body is fused with an intricate system of chambers and pumps, machinery filling his veins with alchemical rage. Bursting out of the shadows, he preys upon...",
				"allytips": [
					"Follow your Blood Hunt trails to low health enemy champions.",
					"Infinite Duress (R)'s distance scales with any movement speed you gain, even from ally buffs and summoner spells.",
					"Jaws of the Beast (Q) will follow enemies who run, dash or teleport if you keep the button held down."
				],
				"enemytips": [
					"Warwick's attacks heal him at low health. Save your disables to finish him off.",
					"Warwick is empowered versus low health enemies. Manage your health to keep him at bay.",
					"Warwick's ultimate cast range scales with his movement speed."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 9,
					"defense": 5,
					"magic": 3,
					"difficulty": 3
				},
				"stats": {
					"hp": 550,
					"hpperlevel": 85,
					"mp": 280,
					"mpperlevel": 35,
					"movespeed": 335,
					"armor": 33,
					"armorperlevel": 3.2,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 4,
					"hpregenperlevel": 0.75,
					"mpregen": 7.466,
					"mpregenperlevel": 0.575,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 3,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 2.3
				},
				"spells": [
					{
						"id": "WarwickQ",
						"name": "Jaws of the Beast",
						"description": "Warwick lunges forward and bites his target, dealing damage based on their maximum health and healing for damage dealt.",
						"tooltip": "Warwick lunges forward and bites his target. While the key is held down, he will <span class=\"colorFFEB7F\">attach</span> to the target then leap behind them.<br /><br />On release, deals <span class=\"colorFF8C00\">{{ a1 }}</span><span class=\"color99FF99\">+{{ a2 }}</span> plus {{ e1 }}% of your target's maximum health as magic damage (applies On Hit effects). Heal {{ e3 }}% of damage dealt.<br /><br /><span class=\"size16 color8C8C8C\">While <span class=\"size16 colorFFEB7F\">attached</span>, Warwick follows any movements they make and cannot be displaced.</span>",
						"leveltip": {
							"label": [
								"Heal",
								"Percent Health Damage",
								"Cost"
							],
							"effect": [
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							50,
							60,
							70,
							80,
							90
						],
						"costBurn": "50/60/70/80/90",
						"effect": [
							null,
							[
								6,
								7,
								8,
								9,
								10
							],
							[
								100,
								150,
								200,
								250,
								300
							],
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								100,
								125,
								150,
								175,
								200
							],
							[
								450,
								450,
								450,
								450,
								450
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								425,
								425,
								425,
								425,
								425
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"6/7/8/9/10",
							"100/150/200/250/300",
							"30/40/50/60/70",
							"100/125/150/175/200",
							"450",
							"200",
							"300",
							"425",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.2,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "WarwickQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "WarwickW",
						"name": "Blood Hunt",
						"description": "Warwick senses enemies below 50% health, gaining movement speed toward and attack speed against them. When they fall below 20% health, he frenzies and these bonuses triple.",
						"tooltip": "<span class=\"colorFF9900\"></span><span class=\"colorFF9900\">Passive: </span>Warwick gains {{ e2 }}% attack speed against enemies below 50% health. He also senses low health champions globally, moving {{ e1 }}% faster toward them when out of combat. These bonuses are tripled against enemies below 20% health.<br /><br /><span class=\"colorFF9900\">Active: </span>Warwick briefly senses all enemies. The nearest sensed champion is Blood Hunted for 8 seconds. Cast only while not in combat with a champion.<br /><br />While no enemies are being hunted, Blood Hunt cools down twice as fast.",
						"leveltip": {
							"label": [
								"Movement Speed",
								"Attack Speed",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							120,
							105,
							90,
							75,
							60
						],
						"cooldownBurn": "120/105/90/75/60",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								35,
								40,
								45,
								50,
								55
							],
							[
								50,
								65,
								80,
								95,
								110
							],
							[
								10,
								15,
								20,
								25,
								30
							],
							[
								80,
								90,
								100,
								110,
								120
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/40/45/50/55",
							"50/65/80/95/110",
							"10/15/20/25/30",
							"80/90/100/110/120",
							"30",
							"8",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "2",
						"range": [
							4000,
							4000,
							4000,
							4000,
							4000
						],
						"rangeBurn": "4000",
						"image": {
							"full": "WarwickW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "WarwickE",
						"name": "Primal Howl",
						"description": "Warwick gains damage reduction for 2.5 seconds. At the end, or if re-activated, he howls, causing nearby enemies to flee for 1 second.",
						"tooltip": "Warwick gains {{ e1 }}% damage reduction for 2.5 seconds. At the end of the duration, or if activated again, Warwick howls, causing all nearby enemies to flee for {{ e3 }} second.",
						"leveltip": {
							"label": [
								"Damage Reduction",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							14,
							13,
							12,
							11
						],
						"cooldownBurn": "15/14/13/12/11",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								35,
								40,
								45,
								50,
								55
							],
							[
								2.75,
								2.75,
								2.75,
								2.75,
								2.75
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"35/40/45/50/55",
							"2.75",
							"1",
							"1",
							"800",
							"400",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							375,
							375,
							375,
							375,
							375
						],
						"rangeBurn": "375",
						"image": {
							"full": "WarwickE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "WarwickR",
						"name": "Infinite Duress",
						"description": "Warwick leaps in a direction (scaling with his bonus movement speed), suppressing the first champion he collides with for 1.5 seconds.",
						"tooltip": "Warwick leaps 2.5 seconds worth of movement speed in a direction, suppressing the first champion he collides with for {{ e2 }} seconds. Deals {{ e7 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> magic damage and applies on-hit effects 3 times. Warwick heals for 100% of all damage he deals during Infinite Duress.",
						"leveltip": {
							"label": [
								"Base Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e7 }} -> {{ e7NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							110,
							90,
							70
						],
						"cooldownBurn": "110/90/70",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								30,
								30,
								30
							],
							[
								5,
								5,
								5
							],
							[
								20,
								20,
								20
							],
							[
								0,
								0,
								0
							],
							[
								175,
								350,
								525
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"1.5",
							"30",
							"5",
							"20",
							"0",
							"175/350/525",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.67,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							25000,
							25000,
							25000
						],
						"rangeBurn": "25000",
						"image": {
							"full": "WarwickR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Eternal Hunger",
					"description": "Warwick's basic attacks deal bonus magic damage. If Warwick is below 50% health, he heals the same amount. If Warwick is below 25% health, this healing triples.",
					"image": {
						"full": "WarwickP.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Warwick",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3009",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3091",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Warwick",
						"title": "WarwickTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3077",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3084",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Xayah": {
				"id": "Xayah",
				"key": "498",
				"name": "Xayah",
				"title": "the Rebel",
				"image": {
					"full": "Xayah.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "498000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "498001",
						"num": 1,
						"name": "Cosmic Dusk Xayah",
						"chromas": false
					},
					{
						"id": "498002",
						"num": 2,
						"name": "Sweetheart Xayah",
						"chromas": false
					}
				],
				"lore": "Deadly and precise, Xayah is a vastayan revolutionary waging a personal war to save her people. She uses her speed, guile, and razor-sharp feather blades to cut down anyone who stands in her way. Xayah fights alongside her partner and lover, Rakan, to protect their dwindling tribe, and restore their race to her vision of its former glory.",
				"blurb": "Deadly and precise, Xayah is a vastayan revolutionary waging a personal war to save her people. She uses her speed, guile, and razor-sharp feather blades to cut down anyone who stands in her way. Xayah fights alongside her partner and lover, Rakan, to...",
				"allytips": [
					"Xayah's attacks and abilities leave Feathers on the ground that she can later recall for massive area damage and control.",
					"Xayah can use Featherstorm to dodge almost any ability while also creating a ton of Feathers. Try to utilize the offensive and defensive aspects of this ability."
				],
				"enemytips": [
					"Xayah's Bladecaller will only root targets hit by 3 or more returning Feathers.",
					"Long fights in the same area with Xayah will allow her to drop a lot of Feathers. Try to stay on the move!",
					"Make sure you are ready when you go for the kill. Untargetability from Featherstorm can quickly turn an ambush in Xayah's favor."
				],
				"tags": [
					"Marksman"
				],
				"partype": "Mana",
				"info": {
					"attack": 10,
					"defense": 6,
					"magic": 1,
					"difficulty": 5
				},
				"stats": {
					"hp": 545,
					"hpperlevel": 80,
					"mp": 340,
					"mpperlevel": 40,
					"movespeed": 325,
					"armor": 33,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 6,
					"hpregenperlevel": 0.75,
					"mpregen": 8.25,
					"mpregenperlevel": 0.75,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 64,
					"attackdamageperlevel": 2.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.3
				},
				"spells": [
					{
						"id": "XayahQ",
						"name": "Double Daggers",
						"description": "Xayah throws two damaging daggers that also drop Feathers she can recall.",
						"tooltip": "Xayah throws two knives dealing {{ f1 }} <span class=\"colorFF9900\">(+{{ f2 }})</span> physical damage and leaving two <span class=\"colorC200E1\">Feathers</span>. Targets hit after the first take {{ e2 }}% damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9,
							8,
							7,
							6
						],
						"cooldownBurn": "10/9/8/7/6",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								90,
								130,
								170,
								210,
								250
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0.334,
								0.334,
								0.334,
								0.334,
								0.334
							],
							[
								0.584,
								0.584,
								0.584,
								0.584,
								0.584
							],
							[
								3500,
								3500,
								3500,
								3500,
								3500
							],
							[
								3500,
								3500,
								3500,
								3500,
								3500
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"90/130/170/210/250",
							"50",
							"0.33",
							"0.58",
							"3500",
							"3500",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "XayahQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XayahW",
						"name": "Deadly Plumage",
						"description": "Xayah creates a storm of blades that increase her basic attack speed and damage while granting her movement speed if she attacks a champion.",
						"tooltip": "Xayah creates a storm of blades for {{ e2 }} seconds that grant her {{ e1 }}% attack speed and cause her basic attacks to strike an additional time for {{ e5 }}% damage. <br /><br />If Deadly Plumage strikes an enemy champion, Xayah gains {{ e3 }}% movement speed for {{ e4 }} seconds.<br /><br /><span class=\"colore5c100\">If Rakan is nearby he will also gain the effects of Deadly Plumage.</span>",
						"leveltip": {
							"label": [
								"Attack Speed",
								"Cooldown",
								"Cost"
							],
							"effect": [
								"{{ e1 }}% -> {{ e1NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							19,
							18,
							17,
							16
						],
						"cooldownBurn": "20/19/18/17/16",
						"cost": [
							60,
							55,
							50,
							45,
							40
						],
						"costBurn": "60/55/50/45/40",
						"effect": [
							null,
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/35/40/45/50",
							"4",
							"30",
							"1.5",
							"20",
							"1000",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "XayahW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XayahE",
						"name": "Bladecaller",
						"description": "Xayah calls back all her dropped Feathers dealing damage and rooting enemies.",
						"tooltip": "Xayah calls all <span class=\"colorC200E1\">Feathers</span> back to her, dealing {{ e1 }} <span class=\"colorFF9900\">(+{{ f3 }})</span> <span class=\"colorFF5802\">(+{{ f4 }})</span> physical damage to enemies they pass through (Increased by <span class=\"colorFF5802\">Critical Strike Chance</span>).<br /><br />Hitting an enemy with {{ e5 }} <span class=\"colorC200E1\">Feathers</span> roots them for {{ e4 }} second.<br /><br />Minions take {{ e2 }}% damage from Bladecaller.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							40,
							40,
							40,
							40,
							40
						],
						"costBurn": "40",
						"effect": [
							null,
							[
								55,
								65,
								75,
								85,
								95
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"55/65/75/85/95",
							"50",
							"0.1",
							"1",
							"3",
							"0.25",
							"0",
							"0.5",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							2000,
							2000,
							2000,
							2000,
							2000
						],
						"rangeBurn": "2000",
						"image": {
							"full": "XayahE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XayahR",
						"name": "Featherstorm",
						"description": "Xayah leaps into the air becoming untargetable and throwing out a fan of daggers, dropping Feathers she can recall.",
						"tooltip": "Xayah leaps into the air becoming untargetable. She then rains down daggers which deal {{ e1 }}<span class=\"colorFF9900\"> (+{{ a1 }})</span> physical damage and leave behind a line of <span class=\"colorC200E1\">Feathers</span>.<br /><br />Xayah can move while in the air.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							140,
							125,
							110
						],
						"cooldownBurn": "140/125/110",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								100,
								150,
								200
							],
							[
								1,
								1,
								1
							],
							[
								1.25,
								1.25,
								1.25
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"100/150/200",
							"1",
							"1.25",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							450,
							450,
							450
						],
						"rangeBurn": "450",
						"image": {
							"full": "XayahR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Clean Cuts",
					"description": "After using an ability, Xayah's next few basic attacks will hit all enemies along their path and dropping Feathers she can recall.",
					"image": {
						"full": "XayahPassive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Xayah",
						"title": "XayahARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahPRJ17",
						"map": "ProjectSlums",
						"mode": "PROJECT",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "recommended",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3508",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "3363",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Xayah",
						"title": "XayahTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1037",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3094",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Xerath": {
				"id": "Xerath",
				"key": "101",
				"name": "Xerath",
				"title": "the Magus Ascendant",
				"image": {
					"full": "Xerath.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "101000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "101001",
						"num": 1,
						"name": "Runeborn Xerath",
						"chromas": false
					},
					{
						"id": "101002",
						"num": 2,
						"name": "Battlecast Xerath",
						"chromas": false
					},
					{
						"id": "101003",
						"num": 3,
						"name": "Scorched Earth Xerath",
						"chromas": false
					},
					{
						"id": "101004",
						"num": 4,
						"name": "Guardian of the Sands Xerath",
						"chromas": false
					}
				],
				"lore": "Xerath is an Ascended Magus of ancient Shurima, a being of arcane energy writhing in the broken shards of a magical sarcophagus. For millennia, he was trapped beneath the desert sands, but the rise of Shurima freed him from his ancient prison. Driven insane with power, he now seeks to take what he believes is rightfully his and replace the upstart civilizations of the world with one fashioned in his image.",
				"blurb": "Xerath is an Ascended Magus of ancient Shurima, a being of arcane energy writhing in the broken shards of a magical sarcophagus. For millennia, he was trapped beneath the desert sands, but the rise of Shurima freed him from his ancient prison. Driven...",
				"allytips": [
					"It's easier to land Arcanopulse on an enemy when they're moving toward or away from you, rather than side to side.",
					"Eye of Destruction will make landing Arcanopulse easier as the target will be slowed.",
					"If you stun an enemy with Shocking Orb, follow up with a guaranteed center hit on Eye of Destruction."
				],
				"enemytips": [
					"Xerath's range can be intimidating, but most champions who close distance with him can trade favorably.",
					"Xerath takes a long time to engage Rite of the Arcane. Watch for his spellcast animation and start dodging.",
					"Banshee's Veil will make it much harder for Xerath to land Shocking Orb on you."
				],
				"tags": [
					"Mage",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 3,
					"magic": 10,
					"difficulty": 8
				},
				"stats": {
					"hp": 526,
					"hpperlevel": 92,
					"mp": 366.96,
					"mpperlevel": 44,
					"movespeed": 340,
					"armor": 21.88,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 5.5,
					"hpregenperlevel": 0.55,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 54.7,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 1.36
				},
				"spells": [
					{
						"id": "XerathArcanopulseChargeUp",
						"name": "Arcanopulse",
						"description": "Fires a long-range beam of energy, dealing magic damage to all targets hit.",
						"tooltip": "<span class=\"colorFF9900\">First cast:</span> Xerath charges Arcanopulse, gradually decreasing his Movement Speed while increasing the spell's range.<br /><br /><span class=\"colorFF9900\">Second cast:</span> Xerath fires Arcanopulse, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in a line.<br /><br />While charging Arcanopulse, Xerath cannot attack or cast other spells. If Xerath does not fire the spell, half the Mana cost is refunded.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							80,
							90,
							100,
							110,
							120
						],
						"costBurn": "80/90/100/110/120",
						"effect": [
							null,
							[
								80,
								120,
								160,
								200,
								240
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								145,
								145,
								145,
								145,
								145
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								-0.2,
								-0.2,
								-0.2,
								-0.2,
								-0.2
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/120/160/200/240",
							"4",
							"0.5",
							"145",
							"0.5",
							"-0.2",
							"0.1",
							"0.5",
							"1.5",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.75,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "1",
						"range": [
							750,
							750,
							750,
							750,
							750
						],
						"rangeBurn": "750",
						"image": {
							"full": "XerathArcanopulseChargeUp.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 240,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XerathArcaneBarrage2",
						"name": "Eye of Destruction",
						"description": "Calls down a barrage of arcane energy, slowing and dealing magic damage to all enemies in an area. Targets in the middle receive additional damage and a stronger slow.",
						"tooltip": "Xerath calls down a blast of arcane energy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies within the target area, slowing them by {{ e8 }}% for {{ e4 }} seconds. Enemies in the center of the blast take {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage and are slowed by {{ e3 }}%. This slow decays rapidly.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Slow Amount",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
								"{{ e3 }}% -> {{ e3NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							1,
							1,
							1,
							1,
							1
						],
						"cooldownBurn": "1",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								60,
								65,
								70,
								75,
								80
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								25,
								25,
								25,
								25,
								25
							],
							[
								0.8,
								0.8,
								0.8,
								0.8,
								0.8
							],
							[
								-0.25,
								-0.25,
								-0.25,
								-0.25,
								-0.25
							]
						],
						"effectBurn": [
							null,
							"60/90/120/150/180",
							"2",
							"60/65/70/75/80",
							"2.5",
							"0.5",
							"50",
							"50",
							"25",
							"0.8",
							"-0.25"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "XerathArcaneBarrage2.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 288,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XerathMageSpear",
						"name": "Shocking Orb",
						"description": "Deals magic damage to an enemy and stuns them.",
						"tooltip": "Xerath fires an orb of raw magic. The first enemy hit takes {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and is stunned for between {{ e8 }} and {{ e2 }} seconds. The stun duration lengthens based on how far the orb travels.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12.5,
							12,
							11.5,
							11
						],
						"cooldownBurn": "13/12.5/12/11.5/11",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								80,
								110,
								140,
								170,
								200
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0.17,
								0.17,
								0.17,
								0.17,
								0.17
							],
							[
								1125,
								1125,
								1125,
								1125,
								1125
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/110/140/170/200",
							"2",
							"0.17",
							"1125",
							"0.5",
							"0",
							"0",
							"0.5",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.45,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "1",
						"range": [
							1050,
							1050,
							1050,
							1050,
							1050
						],
						"rangeBurn": "1050",
						"image": {
							"full": "XerathMageSpear.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 336,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XerathLocusOfPower2",
						"name": "Rite of the Arcane",
						"description": "Xerath immobilizes himself and gains numerous long-range barrages.",
						"tooltip": "Xerath ascends to his true form, becoming rooted in place and gaining {{ e2 }} Arcane Barrages. This magic artillery deals {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies hit.<br /><br />The root ends after {{ e1 }} seconds, when all shots have been fired or when manually deactivated by issuing a move command. If no barrages are fired, {{ e7 }}% of the cooldown is refunded.",
						"leveltip": {
							"label": [
								"Damage",
								"Number of Shots",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							115,
							100
						],
						"cooldownBurn": "130/115/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								10,
								10,
								10
							],
							[
								3,
								4,
								5
							],
							[
								200,
								240,
								280
							],
							[
								200,
								200,
								200
							],
							[
								3200,
								4400,
								5600
							],
							[
								0.8,
								0.8,
								0.8
							],
							[
								50,
								50,
								50
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"10",
							"3/4/5",
							"200/240/280",
							"200",
							"3200/4400/5600",
							"0.8",
							"50",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.43,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3200,
							4400,
							5600
						],
						"rangeBurn": "3200/4400/5600",
						"image": {
							"full": "XerathLocusOfPower2.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 384,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Mana Surge",
					"description": "Xerath's basic attacks periodically restore Mana.",
					"image": {
						"full": "Xerath_Passive1.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Xerath",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3907",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Xerath",
						"title": "XerathTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"XinZhao": {
				"id": "XinZhao",
				"key": "5",
				"name": "Xin Zhao",
				"title": "the Seneschal of Demacia",
				"image": {
					"full": "XinZhao.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "5000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "5001",
						"num": 1,
						"name": "Commando Xin Zhao",
						"chromas": false
					},
					{
						"id": "5002",
						"num": 2,
						"name": "Imperial Xin Zhao",
						"chromas": false
					},
					{
						"id": "5003",
						"num": 3,
						"name": "Viscero Xin Zhao",
						"chromas": false
					},
					{
						"id": "5004",
						"num": 4,
						"name": "Winged Hussar Xin Zhao",
						"chromas": false
					},
					{
						"id": "5005",
						"num": 5,
						"name": "Warring Kingdoms Xin Zhao",
						"chromas": true
					},
					{
						"id": "5006",
						"num": 6,
						"name": "Secret Agent Xin Zhao",
						"chromas": false
					},
					{
						"id": "5013",
						"num": 13,
						"name": "Dragonslayer Xin Zhao",
						"chromas": true
					}
				],
				"lore": "Xin Zhao is a resolute warrior loyal to the ruling Lightshield dynasty. Once condemned to the fighting pits of Noxus, he survived countless gladiatorial bouts, but after being freed by Demacian forces, he swore his life and allegiance to these brave liberators. Armed with his favored three-talon spear, Xin Zhao now fights for his adopted kingdom, audaciously challenging any foe, no matter the odds.",
				"blurb": "Xin Zhao is a resolute warrior loyal to the ruling Lightshield dynasty. Once condemned to the fighting pits of Noxus, he survived countless gladiatorial bouts, but after being freed by Demacian forces, he swore his life and allegiance to these brave...",
				"allytips": [
					"Xin Zhao is a great initiator to combat. Lead the front to start a fight and use your ultimate to do the most damage possible.",
					"Try to position yourself so your ultimate's knockback is most effective."
				],
				"enemytips": [
					"Xin Zhao is a powerful initiator with both his charge and ultimate dealing damage to all units around him. Try having your team stay spread out until he's used his ultimate.",
					"Xin Zhao relies heavily on his Three Talon Strikes for damage and cooldown resets, so preventing him from finishing his combo will have a dramatic effect."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Mana",
				"info": {
					"attack": 8,
					"defense": 6,
					"magic": 3,
					"difficulty": 2
				},
				"stats": {
					"hp": 570,
					"hpperlevel": 92,
					"mp": 273.8,
					"mpperlevel": 35,
					"movespeed": 345,
					"armor": 35,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.7,
					"mpregen": 7.256,
					"mpregenperlevel": 0.45,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 66,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 3.5
				},
				"spells": [
					{
						"id": "XinZhaoQ",
						"name": "Three Talon Strike",
						"description": "Xin Zhao's next 3 standard attacks deal increased damage with the third attack knocking an opponent into the air.",
						"tooltip": "Xin Zhao's next 3 basic attacks deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> extra physical damage and reduce his other cooldowns by 1 second. The final strike also knocks the target into the air for {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Bonus Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							9,
							8,
							7,
							6,
							5
						],
						"cooldownBurn": "9/8/7/6/5",
						"cost": [
							30,
							30,
							30,
							30,
							30
						],
						"costBurn": "30",
						"effect": [
							null,
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/25/30/35/40",
							"0.75",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							375,
							375,
							375,
							375,
							375
						],
						"rangeBurn": "375",
						"image": {
							"full": "XinZhaoQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 432,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XinZhaoW",
						"name": "Wind Becomes Lightning",
						"description": "Xin Zhao slashes in front of himself with his spear, then thrusts it forward, slowing affected enemies.",
						"tooltip": "Xin Zhao slashes in front of himself with his spear, then thrusts it forward.<br /><br /><span class=\"colorDDDD77\">Slash</span>: {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> damage.<br /><span class=\"colorDDDD77\">Thrust</span>: {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> damage and slows by {{ e6 }}% for {{ e7 }} seconds.<br /><br />Cast time is reduced with Attack Speed provided from items and levels (minimum of 0.4 seconds). Current cast time: <span class=\"colorFFFFFF\">{{ f5 }}</fontcolor><br /><br /><rules>Deals 50% less damage to minions.<br />Lifesteal is 33% effective on both attacks.<br />Extends the current duration of Xin Zhao's other abilities by {{ f5 }} seconds.</rules>",
						"leveltip": {
							"label": [
								"Slash Damage",
								"Thrust Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							45,
							45,
							45,
							45,
							45
						],
						"costBurn": "45",
						"effect": [
							null,
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								30,
								65,
								100,
								135,
								170
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								140,
								140,
								140,
								140,
								140
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/40/50/60/70",
							"30/65/100/135/170",
							"0.5",
							"0.4",
							"0.4",
							"50",
							"1.5",
							"140",
							"200",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "attackdamage",
								"coeff": 0.75,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "XinZhaoW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 0,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XinZhaoE",
						"name": "Audacious Charge",
						"description": "Xin Zhao charges to an enemy, dealing damage to all enemies in the area and slowing them briefly.",
						"tooltip": "Xin Zhao charges to an enemy. The charge deals {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage to nearby enemies and slows them by {{ e2 }}% for 0.5 seconds.  Charging grants Xin Zhao {{ e3 }}% attack speed for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Attack Speed"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								50,
								75,
								100,
								125,
								150
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								40,
								45,
								50,
								55,
								60
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								250,
								250,
								250,
								250,
								250
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"50/75/100/125/150",
							"50",
							"40/45/50/55/60",
							"5",
							"250",
							"0.5",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "XinZhaoE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 48,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "XinZhaoR",
						"name": "Crescent Guard",
						"description": "Xin Zhao deals damage to nearby enemies based on their current Health and knocks non-challenged targets back. Xin Zhao is impervious to damage dealt by champions outside of the circle created.",
						"tooltip": "Xin Zhao unleashes a sweep around him that deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> plus {{ e2 }}% of target's current Health in physical damage and knocks them back (max 600 vs monsters).<br /><br />For {{ e5 }} seconds after casting this ability, Xin Zhao has increased <span class=\"colorDDDD77\">Awareness</span> and will completely block damage from enemies that are far away. Xin Zhao's attacks and spell casts increase the duration of <span class=\"colorDDDD77\">Awareness</span> by {{ e7 }} seconds each.<br /><br />The last champion hit by Xin Zhao's basic attacks or Audacious Charge is not knocked back.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							110,
							100
						],
						"cooldownBurn": "120/110/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								75,
								175,
								275
							],
							[
								15,
								15,
								15
							],
							[
								0,
								0,
								0
							],
							[
								40,
								60,
								80
							],
							[
								3,
								3,
								3
							],
							[
								450,
								450,
								450
							],
							[
								0.3,
								0.3,
								0.3
							],
							[
								3,
								3,
								3
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/175/275",
							"15",
							"0",
							"40/60/80",
							"3",
							"450",
							"0.3",
							"3",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							500,
							500,
							500
						],
						"rangeBurn": "500",
						"image": {
							"full": "XinZhaoR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 96,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Determination",
					"description": "Every third attack deals bonus damage and heals Xin Zhao.",
					"image": {
						"full": "XinZhaoP.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "XinZhao",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3361",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3715",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1412",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3124",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "XinZhao",
						"title": "XinZhaoTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1416",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3252",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Yasuo": {
				"id": "Yasuo",
				"key": "157",
				"name": "Yasuo",
				"title": "the Unforgiven",
				"image": {
					"full": "Yasuo.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "157000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "157001",
						"num": 1,
						"name": "High Noon Yasuo",
						"chromas": true
					},
					{
						"id": "157002",
						"num": 2,
						"name": "PROJECT: Yasuo",
						"chromas": false
					},
					{
						"id": "157003",
						"num": 3,
						"name": "Blood Moon Yasuo",
						"chromas": false
					},
					{
						"id": "157009",
						"num": 9,
						"name": "Nightbringer Yasuo",
						"chromas": false
					}
				],
				"lore": "An Ionian of deep resolve, Yasuo is an agile swordsman, trained to wield the air itself against his enemies. As a young man, pride led him down a path of loss, costing him his position, his mentor, and ultimately his own brother. Disgraced by false accusations and now hunted as little more than a criminal, Yasuo wanders his homeland seeking redemption for his past, with only the wind to guide his blade.",
				"blurb": "An Ionian of deep resolve, Yasuo is an agile swordsman, trained to wield the air itself against his enemies. As a young man, pride led him down a path of loss, costing him his position, his mentor, and ultimately his own brother. Disgraced by false...",
				"allytips": [
					"Dash through a minion to have Sweeping Blade available to chase your opponent should they flee; Dash directly to your opponent to preserve a minion as your escape route.",
					"At level 18, Yasuo's Steel Tempest reaches its Attack Speed cap with 55% Attack Speed from items.",
					"Last Breath can be cast on any target that is knocked Airborne, even by one of your allies."
				],
				"enemytips": [
					"Steel Tempest is very narrow. Dodge laterally if possible. ",
					"When Yasuo lands two Steel Tempests in a row, his next will fire a tornado. Watch and listen for the associated sound to prepare to dodge.",
					"Yasuo is at his weakest just after he has launched a whirlwind. Engage at that point.",
					"Yasuo's shield from Resolve lasts only 2 seconds. Dealing damage to him will trigger it. Wait it out, then engage."
				],
				"tags": [
					"Fighter",
					"Assassin"
				],
				"partype": "Flow",
				"info": {
					"attack": 8,
					"defense": 4,
					"magic": 4,
					"difficulty": 10
				},
				"stats": {
					"hp": 523,
					"hpperlevel": 87,
					"mp": 100,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 30,
					"armorperlevel": 3.4,
					"spellblock": 30,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 6.5,
					"hpregenperlevel": 0.9,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 60,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": -0.067,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "YasuoQW",
						"name": "Steel Tempest",
						"description": "A skillshot basic attack. After two successful Steel Tempests, the next fires a tornado that knocks enemies Airborne.",
						"tooltip": "Thrusts forward, dealing {{ f2.0 }} <span class=\"colorFF8C00\">(+{{ f3.0 }})</span> physical damage.<br /><br />On hit, Steel Tempest grants a stack of Gathering Storm for 6 seconds. At 2 stacks, Steel Tempest fires a whirlwind that knocks <span class=\"color6655CC\">Airborne</span>.<br /><br />Steel Tempest is treated as a basic attack: It can critically strike, applies on-hit effects, is interruptible by crowd control and its cooldown and cast time are reduced by Attack Speed.<br /><br /><span class=\"color99FF99\">If cast while dashing, Steel Tempest will strike as a circle.</span>",
						"leveltip": {
							"label": [
								"Damage"
							],
							"effect": [
								"{{ f2.0 }} -> {{ f4.0 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.5,
							5,
							4.5,
							4
						],
						"cooldownBurn": "6/5.5/5/4.5/4",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								45,
								70,
								95,
								120
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/45/70/95/120",
							"100",
							"0",
							"4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							475,
							475,
							475,
							475,
							475
						],
						"rangeBurn": "475",
						"image": {
							"full": "YasuoQW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 144,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "YasuoWMovingWall",
						"name": "Wind Wall",
						"description": "Creates a moving wall that blocks enemy projectiles.",
						"tooltip": "Creates a moving wall that blocks all enemy projectiles for 4 seconds.",
						"leveltip": {
							"label": [
								"Wall Width",
								"Cooldown"
							],
							"effect": [
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							26,
							24,
							22,
							20,
							18
						],
						"cooldownBurn": "26/24/22/20/18",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								15,
								20,
								25,
								30,
								35
							],
							[
								60,
								90,
								120,
								150,
								180
							],
							[
								3,
								6,
								9,
								12,
								15
							],
							[
								300,
								350,
								400,
								450,
								500
							],
							[
								320,
								390,
								460,
								530,
								600
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/20/25/30/35",
							"60/90/120/150/180",
							"3/6/9/12/15",
							"300/350/400/450/500",
							"320/390/460/530/600",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							400,
							400,
							400,
							400,
							400
						],
						"rangeBurn": "400",
						"image": {
							"full": "YasuoWMovingWall.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 192,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					},
					{
						"id": "YasuoDashWrapper",
						"name": "Sweeping Blade",
						"description": "Dashes through a unit, dealing escalating Magic Damage with each cast.",
						"tooltip": "Dashes through target enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFF8C00\">(+{{ f3 }})</span> Magic Damage. Each cast increases your next dash's base Damage by 25%, up to {{ e6 }}%.<br /><br />Cannot be re-cast on the same enemy for {{ e2 }} seconds.<br /><br /><span class=\"color99FF99\">If cast while dashing, Steel Tempest will strike as a circle.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Recast Block",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }} -> {{ e2NL }}",
								"{{ f1 }} -> {{ f2 }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								60,
								70,
								80,
								90,
								100
							],
							[
								10,
								9,
								8,
								7,
								6
							],
							[
								0.5,
								0.4,
								0.3,
								0.2,
								0.1
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								15,
								17.5,
								20,
								22.5,
								25
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/70/80/90/100",
							"10/9/8/7/6",
							"0.5/0.4/0.3/0.2/0.1",
							"1.5",
							"15/17.5/20/22.5/25",
							"50",
							"20",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							}
						],
						"costType": "",
						"maxammo": "-1",
						"range": [
							475,
							475,
							475,
							475,
							475
						],
						"rangeBurn": "475",
						"image": {
							"full": "YasuoDashWrapper.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 240,
							"y": 96,
							"w": 48,
							"h": 48
						}
					},
					{
						"id": "YasuoRKnockUpComboW",
						"name": "Last Breath",
						"description": "Moves to a unit and strikes them repeatedly for heavy damage. Can only be cast on Airborne targets.",
						"tooltip": "Blinks to an <span class=\"color6655CC\">Airborne</span> enemy champion, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and holding all <span class=\"color6655CC\">Airborne</span> enemies in the area in the air for an additional 1 second. Grants maximum Flow but resets all stacks of Gathering Storm.<br /><br />For 15 seconds, Yasuo's critical strikes gain {{ e5 }}% Bonus Armor Penetration - this affects Armor from items, buffs, and runes.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ f1 }} -> {{ f2 }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								200,
								300,
								400
							],
							[
								33,
								66,
								100
							],
							[
								650,
								750,
								850
							],
							[
								1.5,
								1.5,
								1.5
							],
							[
								50,
								50,
								50
							],
							[
								33,
								66,
								100
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"200/300/400",
							"33/66/100",
							"650/750/850",
							"1.5",
							"50",
							"33/66/100",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 1.5,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							1400,
							1400,
							1400
						],
						"rangeBurn": "1400",
						"image": {
							"full": "YasuoRKnockUpComboW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 288,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Way of the Wanderer",
					"description": "Yasuo's Critical Strike Chance is doubled. Additionally, Yasuo builds toward a shield whenever he is moving. The shield triggers when he takes damage from a champion or monster.",
					"image": {
						"full": "Yasuo_Passive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Yasuo",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1042",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2015",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3087",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yasuo",
						"title": "YasuoTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3086",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3006",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3046",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3033",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Yorick": {
				"id": "Yorick",
				"key": "83",
				"name": "Yorick",
				"title": "Shepherd of Souls",
				"image": {
					"full": "Yorick.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "83000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "83001",
						"num": 1,
						"name": "Undertaker Yorick",
						"chromas": false
					},
					{
						"id": "83002",
						"num": 2,
						"name": "Pentakill Yorick",
						"chromas": false
					},
					{
						"id": "83003",
						"num": 3,
						"name": "Arclight Yorick",
						"chromas": false
					}
				],
				"lore": "The last survivor of a long-forgotten religious order, Yorick is both blessed and cursed with power over the dead. Trapped on the Shadow Isles, his only companions are the rotting corpses and shrieking spirits that he gathers to him. Yorick's monstrous actions belie his noble purpose: to free his home from the curse of the Ruination.",
				"blurb": "The last survivor of a long-forgotten religious order, Yorick is both blessed and cursed with power over the dead. Trapped on the Shadow Isles, his only companions are the rotting corpses and shrieking spirits that he gathers to him. Yorick's monstrous...",
				"allytips": [
					"You do not need to cast Awakening to regain the ability to cast Last Rites.",
					"The Maiden will attempt to assist you in a fight, so choose your targets well.",
					"You can send the Maiden down a lane alone, be careful though, as she represents a large portion of your combat power."
				],
				"enemytips": [
					"You can cast Smite on Mist Walkers and the Maiden of the Mist to damage or kill them.",
					"Try to thin out Yorick's minions before you engage him, Mist Walkers will die from a basic attack or a single target spell.",
					"You can attack Dark Procession to break the wall down."
				],
				"tags": [
					"Fighter",
					"Tank"
				],
				"partype": "Mana",
				"info": {
					"attack": 6,
					"defense": 6,
					"magic": 4,
					"difficulty": 6
				},
				"stats": {
					"hp": 580,
					"hpperlevel": 100,
					"mp": 300,
					"mpperlevel": 40,
					"movespeed": 340,
					"armor": 39,
					"armorperlevel": 4,
					"spellblock": 32,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.8,
					"mpregen": 7.5,
					"mpregenperlevel": 0.75,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 62,
					"attackdamageperlevel": 5,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "YorickQ",
						"name": "Last Rites",
						"description": "Yorick deals bonus damage on his next attack and heals himself. If the target dies a grave will be dug.",
						"tooltip": "Yorick's next basic attack deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and restores {{ f1 }} Health (doubled when below half Health). Last Rites will leave a grave if it kills the target.<br /><br />When there are three or more graves nearby and Last Rites has been used, Yorick can cast Awakening to raise Mist Walkers from graves.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							25,
							25,
							25,
							25,
							25
						],
						"costBurn": "25",
						"effect": [
							null,
							[
								30,
								55,
								80,
								105,
								130
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"30/55/80/105/130",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							0,
							0,
							0,
							0,
							0
						],
						"rangeBurn": "0",
						"image": {
							"full": "YorickQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 336,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "YorickW",
						"name": "Dark Procession",
						"description": "Yorick summons a destructible wall at target location that will block enemy movement.",
						"tooltip": "Yorick summons a destructible wall of spirits with {{ e5 }} Health around target area for {{ e1 }} seconds. Allies can walk through the wall freely.",
						"leveltip": {
							"label": [
								"Health",
								"Cooldown"
							],
							"effect": [
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							20,
							18,
							16,
							14,
							12
						],
						"cooldownBurn": "20/18/16/14/12",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								18,
								18,
								18,
								18,
								18
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								0,
								0,
								1,
								1,
								2
							],
							[
								2,
								2,
								3,
								3,
								4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"4",
							"18",
							"0.75",
							"0/0/1/1/2",
							"2/2/3/3/4",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "YorickW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 384,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "YorickE",
						"name": "Mourning Mist",
						"description": "Yorick throws a globule of Black Mist that damages, slows and marks enemies.",
						"tooltip": "Yorick throws a globule of Black Mist that deals {{ e7 }}% of enemy's current Health as magic damage (minimum {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>), slows by {{ e3 }}% for {{ e6 }} seconds, and marks champions and monsters for {{ e2 }} seconds.<br /><br />Yorick and his minions are hasted by {{ e5 }}% while moving toward the mark.",
						"leveltip": {
							"label": [
								"Minimum Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							11,
							10,
							9,
							8
						],
						"cooldownBurn": "12/11/10/9/8",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								1400,
								1400,
								1400,
								1400,
								1400
							],
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								15,
								15,
								15,
								15,
								15
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"4",
							"30",
							"1400",
							"20",
							"2",
							"15",
							"300",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "YorickE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 432,
							"y": 96,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "YorickR",
						"name": "Eulogy of the Isles",
						"description": "Yorick summons the Maiden of the Mist that causes Yorick's attacks against the Maiden's target to deal bonus damage. The Maiden will also automatically raise Walkers from dead enemies.",
						"tooltip": "Yorick summons The Maiden of the Mist and {{ e1 }} Mist Walkers. The Maiden has {{ e3 }} <span class=\"colorFF3300\">(+{{ f1 }})</span> Health, deals {{ e4 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> magic damage, and raises Mist Walkers from nearby enemy deaths.<br /><br />When Yorick damages the Maiden's target he will deal {{ e5 }}% of their max Health as bonus magic damage ({{ e7 }} second cooldown).<br /><br /><span class=\"colorDDDD77\">If the Maiden is summoned inside a lane, she will start pushing the lane.</span>",
						"leveltip": {
							"label": [
								"Health",
								"Damage",
								"Mist Walkers",
								"Mark Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }}% ->{{ e5NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							160,
							130,
							100
						],
						"cooldownBurn": "160/130/100",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								2,
								3,
								4
							],
							[
								700,
								700,
								700
							],
							[
								700,
								1500,
								4000
							],
							[
								10,
								20,
								40
							],
							[
								5,
								7.5,
								10
							],
							[
								1,
								1,
								1
							],
							[
								2,
								2,
								2
							],
							[
								200,
								300,
								400
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2/3/4",
							"700",
							"700/1500/4000",
							"10/20/40",
							"5/7.5/10",
							"1",
							"2",
							"200/300/400",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "YorickR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 0,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Shepherd of Souls",
					"description": "<mainText>Yorick can raise Mist Walkers with his abilities. Enemies that die near Yorick will sometimes leave a grave.</mainText>",
					"image": {
						"full": "Yorick_P.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Yorick",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3101",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3004",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3025",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3512",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3748",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Yorick",
						"title": "YorickTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3044",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3078",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Zac": {
				"id": "Zac",
				"key": "154",
				"name": "Zac",
				"title": "the Secret Weapon",
				"image": {
					"full": "Zac.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "154000",
						"num": 0,
						"name": "default",
						"chromas": true
					},
					{
						"id": "154001",
						"num": 1,
						"name": "Special Weapon Zac",
						"chromas": false
					},
					{
						"id": "154002",
						"num": 2,
						"name": "Pool Party Zac",
						"chromas": false
					},
					{
						"id": "154006",
						"num": 6,
						"name": "SKT T1 Zac",
						"chromas": false
					}
				],
				"lore": "Zac is the product of a toxic spill that ran through a chemtech seam and pooled in an isolated cavern deep in Zaun's Sump. Despite such humble origins, Zac has grown from primordial ooze into a thinking being who dwells in the city's pipes, occasionally emerging to help those who cannot help themselves or to rebuild the broken infrastructure of Zaun.",
				"blurb": "Zac is the product of a toxic spill that ran through a chemtech seam and pooled in an isolated cavern deep in Zaun's Sump. Despite such humble origins, Zac has grown from primordial ooze into a thinking being who dwells in the city's pipes, occasionally...",
				"allytips": [
					"Picking up goo chunks is very important to staying alive.",
					"When Cell Division is ready, try to die in a position that makes it difficult for the enemy team to kill your bloblets.",
					"Charging Elastic Slingshot from the fog of war will give opponents less time to react."
				],
				"enemytips": [
					"Zac heals from the goo that separates from him. You can crush the goo pieces by stepping on them.",
					"Kill all of Zac's bloblets when he splits apart to stop him from reforming.",
					"Silences, stuns, roots and knockups will all interrupt Zac when he is charging Elastic Slingshot."
				],
				"tags": [
					"Tank",
					"Fighter"
				],
				"partype": "None",
				"info": {
					"attack": 3,
					"defense": 7,
					"magic": 7,
					"difficulty": 8
				},
				"stats": {
					"hp": 615,
					"hpperlevel": 95,
					"mp": 0,
					"mpperlevel": 0,
					"movespeed": 340,
					"armor": 33,
					"armorperlevel": 3.5,
					"spellblock": 32,
					"spellblockperlevel": 1.25,
					"attackrange": 175,
					"hpregen": 8,
					"hpregenperlevel": 0.5,
					"mpregen": 0,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 60,
					"attackdamageperlevel": 3.4,
					"attackspeedoffset": -0.02,
					"attackspeedperlevel": 1.6
				},
				"spells": [
					{
						"id": "ZacQ",
						"name": "Stretching Strikes",
						"description": "Zac stretches an arm, grabbing an enemy. Attacking a different enemy will cause him to throw both targets towards each other.",
						"tooltip": "Zac's arm stretches and grabs the first enemy it hits, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorCC3300\">(+{{ f2 }})</span> magic damage and briefly slowing them. Zac's next basic attack is replaced with a long range smack that repeats the initial magic damage and slow effect.<br /><br />If Zac grabs a different enemy with each attack he'll throw them towards each other, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorCC3300\">(+{{ f2 }})</span> magic damage in an area if they collide.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }}-> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							13,
							12,
							11,
							10,
							9
						],
						"cooldownBurn": "13/12/11/10/9",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								30,
								40,
								50,
								60,
								70
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								800,
								800,
								800,
								800,
								800
							],
							[
								-0.6,
								-0.6,
								-0.6,
								-0.6,
								-0.6
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								1000,
								1000,
								1000,
								1000,
								1000
							],
							[
								700,
								700,
								700,
								700,
								700
							],
							[
								300,
								300,
								300,
								300,
								300
							],
							[
								300,
								300,
								300,
								300,
								300
							]
						],
						"effectBurn": [
							null,
							"30/40/50/60/70",
							"8",
							"800",
							"-0.6",
							"0.5",
							"2.5",
							"1000",
							"700",
							"300",
							"300"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": "% of current Health",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "ZacQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 48,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e2 }}% of current Health"
					},
					{
						"id": "ZacW",
						"name": "Unstable Matter",
						"description": "Zac's body erupts, damaging nearby enemies.",
						"tooltip": "Zac's body erupts, dealing {{ e1 }} magic damage +{{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of the enemy's max health as magic damage to nearby enemies.<br /><br />Absorbing <span class=\"color3ca126\">Goo</span> reduces Unstable Matter's cooldown by {{ e4 }} second.<br /><br /><span class=\"size16 color8C8C8C\">Max health damage is capped at {{ e5 }} versus minions and monsters.</span></span>",
						"leveltip": {
							"label": [
								"Flat Damage",
								"Percent Max Health Damage"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }}% -> {{ e3NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							5,
							5,
							5,
							5
						],
						"cooldownBurn": "5",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								15,
								30,
								45,
								60,
								75
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								4,
								5,
								6,
								7,
								8
							],
							[
								1,
								1,
								1,
								1,
								1
							],
							[
								200,
								200,
								200,
								200,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"15/30/45/60/75",
							"4",
							"4/5/6/7/8",
							"1",
							"200",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.02,
								"key": "a1"
							}
						],
						"costType": "% of current Health",
						"maxammo": "-1",
						"range": [
							350,
							350,
							350,
							350,
							350
						],
						"rangeBurn": "350",
						"image": {
							"full": "ZacW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 96,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e2 }}% of current Health"
					},
					{
						"id": "ZacE",
						"name": "Elastic Slingshot",
						"description": "Zac attaches his arms to the ground and stretches back, launching himself forward.",
						"tooltip": "<span class=\"colorFF9900\">First cast:</span> Zac faces the cursor and charges up over {{ e4 }} seconds.<br /><br /><span class=\"colorFF9900\">Second cast:</span> Launches Zac towards a location, knocking up nearby enemies for {{ f2 }} to {{ f3 }} seconds (based on charge time) and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Zac spawns extra chunks of <span class=\"color3ca126\">Goo</span> for each enemy champion hit.<br /><br /><span class=\"size16 color8C8C8C\">Can be cancelled by moving, refunding half of the ability's cooldown and cost.</span>",
						"leveltip": {
							"label": [
								"Damage",
								"Range",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							21,
							18,
							15,
							12
						],
						"cooldownBurn": "24/21/18/15/12",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								60,
								110,
								160,
								210,
								260
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								1200,
								1350,
								1500,
								1650,
								1800
							],
							[
								0.9,
								1,
								1.1,
								1.2,
								1.3
							],
							[
								0.5,
								0.5,
								0.5,
								0.5,
								0.5
							],
							[
								500,
								500,
								500,
								500,
								500
							],
							[
								1350,
								1350,
								1350,
								1350,
								1350
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								265,
								265,
								265,
								265,
								265
							],
							[
								1,
								1,
								1,
								1,
								1
							]
						],
						"effectBurn": [
							null,
							"60/110/160/210/260",
							"4",
							"1200/1350/1500/1650/1800",
							"0.9/1/1.1/1.2/1.3",
							"0.5",
							"500",
							"1350",
							"0.6",
							"265",
							"1"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": "% of current Health",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "ZacE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 144,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e2 }}% of current Health"
					},
					{
						"id": "ZacR",
						"name": "Let's Bounce!",
						"description": "Zac flattens himself, making him immune to crowd control while slowing enemies standing on top of him. When he decides to bounce away, he will suck up any enemies standing on top of him, taking them for a ride.",
						"tooltip": "<span class=\"colorFF9900\">First cast: </span>Zac squishes himself down, making him immune to Crowd Control for up to {{ e5 }} seconds. Enemies standing on top of him are slowed by {{ e4 }}%.<br /><br /><span class=\"colorFF9900\">Second cast: </span>Charging for at least {{ f1 }} seconds before recasting causes Zac to scoop up enemies on top of him, carrying them towards a location. Upon landing nearby enemies take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are briefly slowed.<br /><br />Reactivating before Zac charges up knocks back nearby enemies instead.</span></span>",
						"leveltip": {
							"label": [
								"Damage",
								"Range",
								"Slow Percent",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e3 }} -> {{ e3NL }}",
								"{{ e4 }}% -> {{ e4NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							115,
							100
						],
						"cooldownBurn": "130/115/100",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								150,
								250,
								350
							],
							[
								1.1,
								1.1,
								1.1
							],
							[
								700,
								850,
								1000
							],
							[
								30,
								40,
								50
							],
							[
								2.5,
								2.5,
								2.5
							],
							[
								275,
								275,
								275
							],
							[
								300,
								300,
								300
							],
							[
								1,
								1,
								1
							],
							[
								0.25,
								0.25,
								0.25
							],
							[
								0.1,
								0.1,
								0.1
							]
						],
						"effectBurn": [
							null,
							"150/250/350",
							"1.1",
							"700/850/1000",
							"30/40/50",
							"2.5",
							"275",
							"300",
							"1",
							"0.25",
							"0.1"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							300,
							300,
							300
						],
						"rangeBurn": "300",
						"image": {
							"full": "ZacR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 192,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Cell Division",
					"description": "Each time Zac hits an enemy with an ability, he sheds a chunk of himself that can be reabsorbed to restore Health. Upon taking fatal damage, Zac splits into 4 bloblets that attempt to recombine. If any bloblets remain, he will revive with an amount of Health depending on the Health of the surviving bloblets. Each bloblet has a percentage of Zac's maximum Health, Armor and Magic Resistance. This ability has a 5 minute cooldown.",
					"image": {
						"full": "ZacPassive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Zac",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3067",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3211",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3711",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1409",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensivejungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situationaljungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3800",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2051",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1011",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3193",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3194",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3742",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3083",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zac",
						"title": "ZacTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "1054",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1041",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "earlyjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3751",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3068",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essentialjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1401",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3065",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3143",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3075",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2138",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Zed": {
				"id": "Zed",
				"key": "238",
				"name": "Zed",
				"title": "the Master of Shadows",
				"image": {
					"full": "Zed.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "238000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "238001",
						"num": 1,
						"name": "Shockblade Zed",
						"chromas": true
					},
					{
						"id": "238002",
						"num": 2,
						"name": "SKT T1 Zed",
						"chromas": false
					},
					{
						"id": "238003",
						"num": 3,
						"name": "PROJECT: Zed",
						"chromas": false
					},
					{
						"id": "238010",
						"num": 10,
						"name": "Championship Zed",
						"chromas": false
					},
					{
						"id": "238011",
						"num": 11,
						"name": "Death Sworn Zed",
						"chromas": false
					}
				],
				"lore": "Utterly ruthless and without mercy, Zed is the leader of the Order of Shadow, an organization he created with the intent of militarizing Ionia's martial arts traditions to drive out Noxian invaders. During the war, desperation led him to unlock the secret shadow form—a malevolent spirit magic as dangerous and corrupting as it is powerful. Zed has mastered all of these forbidden techniques to destroy anything he sees as a threat to his nation, or his new order.",
				"blurb": "Utterly ruthless and without mercy, Zed is the leader of the Order of Shadow, an organization he created with the intent of militarizing Ionia's martial arts traditions to drive out Noxian invaders. During the war, desperation led him to unlock the...",
				"allytips": [
					"Saving energy and spell cooldowns until you use your ultimate will maximize Death Mark's damage.",
					"Quickly double tapping Living Shadow will teleport Zed to his shadow immediately for rapid escapes.",
					"Placing a Living Shadow before using Death Mark can give Zed a safe escape from combat."
				],
				"enemytips": [
					"Zed receives bonus effect from Attack Damage items he purchases, so Armor is super effective against him.",
					"After Zed uses his Living Shadow, he is at his most vulnerable as his damage, slow, and mobility are both dependent upon it.",
					"Zed's Shadow Slash can only slow you if his shadow hits you with it. "
				],
				"tags": [
					"Assassin",
					"Fighter"
				],
				"partype": "Energy",
				"info": {
					"attack": 9,
					"defense": 2,
					"magic": 1,
					"difficulty": 7
				},
				"stats": {
					"hp": 584,
					"hpperlevel": 85,
					"mp": 200,
					"mpperlevel": 0,
					"movespeed": 345,
					"armor": 32,
					"armorperlevel": 3.5,
					"spellblock": 32.1,
					"spellblockperlevel": 1.25,
					"attackrange": 125,
					"hpregen": 7,
					"hpregenperlevel": 0.65,
					"mpregen": 50,
					"mpregenperlevel": 0,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 63,
					"attackdamageperlevel": 3.4,
					"attackspeedoffset": -0.04,
					"attackspeedperlevel": 2.1
				},
				"spells": [
					{
						"id": "ZedQ",
						"name": "Razor Shuriken",
						"description": "Zed and his shadow both throw their spinning blades forward, dealing damage to any targets they pass through.",
						"tooltip": "Zed and his shadows throw their shurikens, each dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to the first enemy they pass through, and {{ e3 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage to each additional enemy.<br /><br />Additional shurikens that hit the same enemy deal 25% less damage than previous shurikens.",
						"leveltip": {
							"label": [
								"Damage",
								"Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							6,
							6,
							6,
							6
						],
						"cooldownBurn": "6",
						"cost": [
							75,
							70,
							65,
							60,
							55
						],
						"costBurn": "75/70/65/60/55",
						"effect": [
							null,
							[
								80,
								115,
								150,
								185,
								220
							],
							[
								0.6,
								0.6,
								0.6,
								0.6,
								0.6
							],
							[
								45,
								66,
								87,
								108,
								129
							],
							[
								0.75,
								0.75,
								0.75,
								0.75,
								0.75
							],
							[
								925,
								925,
								925,
								925,
								925
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"80/115/150/185/220",
							"0.6",
							"45/66/87/108/129",
							"0.75",
							"925",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.9,
								"key": "a1"
							},
							{
								"link": "bonusattackdamage",
								"coeff": 0.54,
								"key": "a2"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "ZedQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 240,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "ZedW",
						"name": "Living Shadow",
						"description": "Zed's shadow dashes forward, remaining in place for 5 seconds, and mimicking his spell casts. Zed can reactivate to swap places with the shadow.",
						"tooltip": "<span class=\"colorFF9900\">Passive: </span>Whenever Zed and his shadows strike an enemy with the same ability, Zed gains {{ e3 }} energy. Energy can only be gained once per cast ability.<br /><br /><span class=\"colorFF9900\">Active: </span>Zed's shadow dashes forward, remaining in place for {{ e5 }} seconds. Reactivating Living Shadow will cause Zed to switch positions with this shadow.",
						"leveltip": {
							"label": [
								"Energy Return",
								"Cost",
								"Cooldown"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cost }} -> {{ costNL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							22,
							20,
							18,
							16,
							14
						],
						"cooldownBurn": "22/20/18/16/14",
						"cost": [
							40,
							35,
							30,
							25,
							20
						],
						"costBurn": "40/35/30/25/20",
						"effect": [
							null,
							[
								5.25,
								5.25,
								5.25,
								5.25,
								5.25
							],
							[
								0.2,
								0.2,
								0.2,
								0.2,
								0.2
							],
							[
								30,
								35,
								40,
								45,
								50
							],
							[
								5.25,
								5.25,
								5.25,
								5.25,
								5.25
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"5.25",
							"0.2",
							"30/35/40/45/50",
							"5.25",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							650,
							650,
							650,
							650,
							650
						],
						"rangeBurn": "650",
						"image": {
							"full": "ZedW.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 288,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "ZedE",
						"name": "Shadow Slash",
						"description": "Zed and his shadow spin their blades, creating a burst of shadow energy.  The shadow's spin slows.",
						"tooltip": "Zed and his shadows slash, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies.<br /><br />Each enemy champion hit by Zed's slash reduces Living Shadow's cooldown by {{ e4 }} seconds.<br /><br />Enemies hit by a Shadow's slash are slowed by {{ e2 }}% for 1.5 seconds. Enemies hit by multiple slashes take no additional damage but are slowed by {{ e3 }}% instead.",
						"leveltip": {
							"label": [
								"Damage",
								"Slow",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							5,
							4.5,
							4,
							3.5,
							3
						],
						"cooldownBurn": "5/4.5/4/3.5/3",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								70,
								95,
								120,
								145,
								170
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								30,
								37.5,
								45,
								52.5,
								60
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								315,
								315,
								315,
								315,
								315
							],
							[
								290,
								290,
								290,
								290,
								290
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"70/95/120/145/170",
							"20/25/30/35/40",
							"30/37.5/45/52.5/60",
							"2",
							"1.5",
							"315",
							"290",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "bonusattackdamage",
								"coeff": 0.8,
								"key": "a1"
							}
						],
						"costType": " Energy",
						"maxammo": "-1",
						"range": [
							290,
							290,
							290,
							290,
							290
						],
						"rangeBurn": "290",
						"image": {
							"full": "ZedE.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 336,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Energy"
					},
					{
						"id": "ZedR",
						"name": "Death Mark",
						"description": "Zed leaves a shadow behind and dashes to target Champion, marking them for death. After 3 seconds, the mark will trigger, dealing a percentage of the damage Zed has dealt while the mark was active. If the Champion dies under Death Mark, Zed can gain a portion of their attack damage.",
						"tooltip": "Zed becomes untargetable and dashes to an enemy champion, marking them. After 3 seconds, the mark triggers, dealing physical damage equal to <span class=\"colorFF8C00\">{{ a1 }}</span> + {{ e2 }}% of all damage dealt to the target by Zed while the mark was active.<br /><br />The dash leaves a shadow behind for {{ e4 }} seconds. Reactivating Death Mark causes Zed to switch positions with this shadow.<br /><br /><span class=\"colorFFFFFF\">Reaper of Shadows: </span>Zed reaps the shadow of the strongest foe slain under Death Mark, gaining <span class=\"colorFF8C00\">{{ f2 }}</span> attack damage. ({{ e0 }} + {{ e9 }}% of the victim's attack damage.)",
						"leveltip": {
							"label": [
								"Mark Detonation Damage",
								"Percent Attack Damage Stolen",
								"Cooldown"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ e9 }}% -> {{ e9NL }}%",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							90,
							60
						],
						"cooldownBurn": "120/90/60",
						"cost": [
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								1,
								1,
								1
							],
							[
								25,
								35,
								45
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								6,
								6,
								6
							],
							[
								6.5,
								6.5,
								6.5
							],
							[
								3,
								3,
								3
							],
							[
								7.5,
								7.5,
								7.5
							],
							[
								4,
								4,
								4
							],
							[
								5,
								10,
								15
							],
							[
								5,
								5,
								5
							]
						],
						"effectBurn": [
							null,
							"1",
							"25/35/45",
							"0.5",
							"6",
							"6.5",
							"3",
							"7.5",
							"4",
							"5/10/15",
							"5"
						],
						"vars": [
							{
								"link": "attackdamage",
								"coeff": 1,
								"key": "a1"
							}
						],
						"costType": "No Cost",
						"maxammo": "-1",
						"range": [
							625,
							625,
							625
						],
						"rangeBurn": "625",
						"image": {
							"full": "ZedR.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 384,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "No Cost"
					}
				],
				"passive": {
					"name": "Contempt for the Weak",
					"description": "Zed's basic attacks against targets below 50% Health deal 6-10% of the target's maximum Health as bonus Magic Damage. This effect can only occur once every 10 seconds on the same target.",
					"image": {
						"full": "shadowninja_P.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Zed",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3047",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1053",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1038",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "KagetoraFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3342",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3181",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2044",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3184",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3035",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3034",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3022",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3072",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1036",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3147",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zed",
						"title": "ZedTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3134",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3133",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3142",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3153",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3111",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3071",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3074",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3814",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3156",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3812",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3139",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2140",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Ziggs": {
				"id": "Ziggs",
				"key": "115",
				"name": "Ziggs",
				"title": "the Hexplosives Expert",
				"image": {
					"full": "Ziggs.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "115000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "115001",
						"num": 1,
						"name": "Mad Scientist Ziggs",
						"chromas": false
					},
					{
						"id": "115002",
						"num": 2,
						"name": "Major Ziggs",
						"chromas": false
					},
					{
						"id": "115003",
						"num": 3,
						"name": "Pool Party Ziggs",
						"chromas": false
					},
					{
						"id": "115004",
						"num": 4,
						"name": "Snow Day Ziggs",
						"chromas": false
					},
					{
						"id": "115005",
						"num": 5,
						"name": "Master Arcanist Ziggs",
						"chromas": false
					},
					{
						"id": "115006",
						"num": 6,
						"name": "Battle Boss Ziggs",
						"chromas": false
					}
				],
				"lore": "With a love of big bombs and short fuses, the yordle Ziggs is an explosive force of nature. As an inventor's assistant in Piltover, he was bored by his predictable life and befriended a mad, blue-haired bomber named Jinx. After a wild night on the town, Ziggs took her advice and moved to Zaun, where he now explores his fascinations more freely, terrorizing the chem-barons and regular citizens alike in his never ending quest to blow stuff up.",
				"blurb": "With a love of big bombs and short fuses, the yordle Ziggs is an explosive force of nature. As an inventor's assistant in Piltover, he was bored by his predictable life and befriended a mad, blue-haired bomber named Jinx. After a wild night on the town...",
				"allytips": [
					"Even if you're far from a fight you can still help from afar with Mega Inferno Bomb.",
					"Slowing your enemies with Hexplosive Minefield makes it easier to land other abilities.",
					"Knocking yourself over walls with Satchel Charge can be great when chasing after or escaping from enemies."
				],
				"enemytips": [
					"Don't step on Ziggs' mines! They'll slow you and make it much easier for him to hit you with his other abiltiies.",
					"Many of Ziggs' abilities have long cooldowns. Try catching him just after he's used his abilities.",
					"Ziggs' ultimate, Mega Inferno Bomb, deals more damage in the center of the explosion."
				],
				"tags": [
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 4,
					"magic": 9,
					"difficulty": 4
				},
				"stats": {
					"hp": 536,
					"hpperlevel": 92,
					"mp": 384,
					"mpperlevel": 47,
					"movespeed": 325,
					"armor": 21.544,
					"armorperlevel": 3.3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 6.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 54.208,
					"attackdamageperlevel": 3.1,
					"attackspeedoffset": -0.0473,
					"attackspeedperlevel": 2
				},
				"spells": [
					{
						"id": "ZiggsQ",
						"name": "Bouncing Bomb",
						"description": "Ziggs throws a bouncing bomb that deals magic damage.",
						"tooltip": "Ziggs throws a bouncing bomb that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							6,
							5.5,
							5,
							4.5,
							4
						],
						"cooldownBurn": "6/5.5/5/4.5/4",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								75,
								120,
								165,
								210,
								255
							],
							[
								850,
								850,
								850,
								850,
								850
							],
							[
								325,
								325,
								325,
								325,
								325
							],
							[
								225,
								225,
								225,
								225,
								225
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								240,
								240,
								240,
								240,
								240
							],
							[
								70,
								70,
								70,
								70,
								70
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/120/165/210/255",
							"850",
							"325",
							"225",
							"150",
							"240",
							"70",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.65,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "ZiggsQ.png",
							"sprite": "spell13.png",
							"group": "spell",
							"x": 432,
							"y": 144,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZiggsW",
						"name": "Satchel Charge",
						"description": "Ziggs flings an explosive charge that detonates after 4 seconds, or when this ability is activated again. The explosion deals magic damage to enemies, knocking them away. Ziggs is also knocked away, but takes no damage. Ziggs can use the Satchel to hexplode vulnerable enemy turrets.",
						"tooltip": "Ziggs flings an explosive charge that detonates after {{ e2 }} seconds, or when this ability is activated again. The explosion deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies, knocking them away. Ziggs is also knocked away, but takes no damage.<br /><br />Satchel Charge will <span class=\"colorD41919\">hexplode</span> structurally unsound towers below {{ f1*100 }}% of their Health.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Tower Destruction Threshold"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ f1*100 }}% -> {{ f2*100 }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							24,
							21,
							18,
							15,
							12
						],
						"cooldownBurn": "24/21/18/15/12",
						"cost": [
							65,
							65,
							65,
							65,
							65
						],
						"costBurn": "65",
						"effect": [
							null,
							[
								70,
								105,
								140,
								175,
								210
							],
							[
								4,
								4,
								4,
								4,
								4
							],
							[
								0.25,
								0.275,
								0.3,
								0.325,
								0.35
							],
							[
								600,
								600,
								600,
								600,
								600
							],
							[
								50,
								50,
								50,
								50,
								50
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								325,
								325,
								325,
								325,
								325
							],
							[
								775,
								775,
								775,
								775,
								775
							],
							[
								400,
								400,
								400,
								400,
								400
							],
							[
								6,
								6,
								6,
								6,
								6
							]
						],
						"effectBurn": [
							null,
							"70/105/140/175/210",
							"4",
							"0.25/0.275/0.3/0.325/0.35",
							"600",
							"50",
							"400",
							"325",
							"775",
							"400",
							"6"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.35,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1000,
							1000,
							1000,
							1000,
							1000
						],
						"rangeBurn": "1000",
						"image": {
							"full": "ZiggsW.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 0,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZiggsE",
						"name": "Hexplosive Minefield",
						"description": "Ziggs scatters proximity mines that detonate on enemy contact, dealing magic damage and slowing.",
						"tooltip": "Ziggs scatters proximity mines that detonate on enemy contact, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Enemies hit are slowed by {{ e2 }}% for {{ e4 }} seconds.<br /><br />Enemies triggering a mine take {{ e5 }}% damage from additional mines. Mines disarm automatically after {{ e3 }} seconds.",
						"leveltip": {
							"label": [
								"Mine Damage",
								"Slow",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e2 }}% -> {{ e2NL }}%",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							16,
							16,
							16,
							16
						],
						"cooldownBurn": "16",
						"cost": [
							70,
							80,
							90,
							100,
							110
						],
						"costBurn": "70/80/90/100/110",
						"effect": [
							null,
							[
								40,
								65,
								90,
								115,
								140
							],
							[
								20,
								25,
								30,
								35,
								40
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								40,
								40,
								40,
								40,
								40
							],
							[
								-0.2,
								-0.25,
								-0.3,
								-0.35,
								-0.4
							],
							[
								135,
								135,
								135,
								135,
								135
							],
							[
								150,
								150,
								150,
								150,
								150
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"40/65/90/115/140",
							"20/25/30/35/40",
							"10",
							"1.5",
							"40",
							"-0.2/-0.25/-0.3/-0.35/-0.4",
							"135",
							"150",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.3,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "ZiggsE.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 48,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZiggsR",
						"name": "Mega Inferno Bomb",
						"description": "Ziggs deploys his ultimate creation, the Mega Inferno Bomb, hurling it an enormous distance. Enemies in the primary blast zone take more damage than those farther away. ",
						"tooltip": "Ziggs deploys his ultimate creation, the Mega Inferno Bomb, hurling it an enormous distance. Enemies in the primary blast zone take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Enemies farther away take two-thirds damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							105,
							90
						],
						"cooldownBurn": "120/105/90",
						"cost": [
							100,
							100,
							100
						],
						"costBurn": "100",
						"effect": [
							null,
							[
								300,
								450,
								600
							],
							[
								66.6667,
								66.6667,
								66.6667
							],
							[
								525,
								525,
								525
							],
							[
								250,
								250,
								250
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"300/450/600",
							"66.67",
							"525",
							"250",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 1.1,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							5000,
							5000,
							5000
						],
						"rangeBurn": "5000",
						"image": {
							"full": "ZiggsR.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 96,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Short Fuse",
					"description": "Every 12 seconds, Ziggs' next basic attack deals bonus magic damage. This cooldown is reduced whenever Ziggs uses an ability.",
					"image": {
						"full": "ZiggsPassiveReady.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Ziggs",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3108",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3114",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1058",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Ziggs",
						"title": "ZiggsTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Zilean": {
				"id": "Zilean",
				"key": "26",
				"name": "Zilean",
				"title": "the Chronokeeper",
				"image": {
					"full": "Zilean.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "26000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "26001",
						"num": 1,
						"name": "Old Saint Zilean",
						"chromas": false
					},
					{
						"id": "26002",
						"num": 2,
						"name": "Groovy Zilean",
						"chromas": false
					},
					{
						"id": "26003",
						"num": 3,
						"name": "Shurima Desert Zilean",
						"chromas": false
					},
					{
						"id": "26004",
						"num": 4,
						"name": "Time Machine Zilean",
						"chromas": false
					},
					{
						"id": "26005",
						"num": 5,
						"name": "Blood Moon Zilean",
						"chromas": false
					}
				],
				"lore": "Once a powerful Icathian mage, Zilean became obsessed with the passage of time after witnessing his homeland's destruction by the Void. Unable to spare even a minute to grieve the catastrophic loss, he called upon ancient temporal magic to divine all possible outcomes. Having become functionally immortal, Zilean now drifts through the past, present, and future, bending and warping the flow of time around him, always searching for that elusive moment that will turn back the clock and undo Icathia's destruction.",
				"blurb": "Once a powerful Icathian mage, Zilean became obsessed with the passage of time after witnessing his homeland's destruction by the Void. Unable to spare even a minute to grieve the catastrophic loss, he called upon ancient temporal magic to divine all...",
				"allytips": [
					"You can combine the use of Time Bomb and Rewind to place two Time Bombs on a target quickly. Placing the second bomb will detonate the first and stun all nearby enemies.",
					"Time Warp is an effective way to enable allies to finish off enemies, or escape from a losing battle.",
					"Chronoshift is a powerful deterrent to attacking your carries, but casting Chronoshift too early in a fight can cause the enemy to switch targets too soon, making it less effective."
				],
				"enemytips": [
					"If you're able to match Zilean's speed, it can sometimes be beneficial to wait until his ultimate has faded before landing the killing blow.",
					"Zilean is fragile if a team focuses on him, but otherwise he's very difficult to kill. Commit to killing him as a team."
				],
				"tags": [
					"Support",
					"Mage"
				],
				"partype": "Mana",
				"info": {
					"attack": 2,
					"defense": 5,
					"magic": 8,
					"difficulty": 6
				},
				"stats": {
					"hp": 504,
					"hpperlevel": 82,
					"mp": 360.8,
					"mpperlevel": 60,
					"movespeed": 335,
					"armor": 24,
					"armorperlevel": 3.8,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 550,
					"hpregen": 5.5,
					"hpregenperlevel": 0.5,
					"mpregen": 8.5,
					"mpregenperlevel": 0.8,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 51.64,
					"attackdamageperlevel": 3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.13
				},
				"spells": [
					{
						"id": "ZileanQ",
						"name": "Time Bomb",
						"description": "Tosses a bomb to target area that sticks to units that come near it (prioritizes Champions). It detonates after 3 seconds, dealing area of effect damage. If a Time Bomb is detonated early by another Time Bomb, it also stuns enemies.",
						"tooltip": "Zilean tosses a time-delayed bomb to a location. The bomb sticks to the first unit which comes within a small area around it (prioritizes Champions). After {{ e2 }} seconds it detonates, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all surrounding enemies. <br /><br />Placing two bombs on a unit detonates the first bomb early, stunning all enemies in the blast for {{ e4 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Stun Duration",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e4 }} -> {{ e4NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							10,
							9.5,
							9,
							8.5,
							8
						],
						"cooldownBurn": "10/9.5/9/8.5/8",
						"cost": [
							60,
							65,
							70,
							75,
							80
						],
						"costBurn": "60/65/70/75/80",
						"effect": [
							null,
							[
								75,
								115,
								165,
								230,
								300
							],
							[
								3,
								3,
								3,
								3,
								3
							],
							[
								7,
								7,
								7,
								7,
								7
							],
							[
								1.1,
								1.2,
								1.3,
								1.4,
								1.5
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"75/115/165/230/300",
							"3",
							"7",
							"1.1/1.2/1.3/1.4/1.5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.9,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "ZileanQ.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 144,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZileanW",
						"name": "Rewind",
						"description": "Zilean can prepare himself for future confrontations, reducing the cooldowns of his other basic abilities. ",
						"tooltip": "Reduces Zilean's other basic spell cooldowns by {{ e2 }} seconds.",
						"leveltip": {
							"label": [
								"Cooldown"
							],
							"effect": [
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							14,
							12,
							10,
							8,
							6
						],
						"cooldownBurn": "14/12/10/8/6",
						"cost": [
							35,
							35,
							35,
							35,
							35
						],
						"costBurn": "35",
						"effect": [
							null,
							[
								20,
								30,
								40,
								50,
								60
							],
							[
								10,
								10,
								10,
								10,
								10
							],
							[
								35,
								35,
								35,
								35,
								35
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20/30/40/50/60",
							"10",
							"35",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							600,
							600,
							600,
							600,
							600
						],
						"rangeBurn": "600",
						"image": {
							"full": "ZileanW.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 192,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ e3 }} Mana"
					},
					{
						"id": "TimeWarp",
						"name": "Time Warp",
						"description": "Zilean bends time around any unit, decreasing an enemy's Movement Speed or increasing an ally's Movement Speed for a short time.",
						"tooltip": "Zilean increases an allied champion's Movement Speed, or slows an enemy champion, by {{ e2 }}% for {{ e1 }} seconds.",
						"leveltip": {
							"label": [
								"Speed"
							],
							"effect": [
								"{{ e2 }}% -> {{ e2NL }}%"
							]
						},
						"maxrank": 5,
						"cooldown": [
							15,
							15,
							15,
							15,
							15
						],
						"cooldownBurn": "15",
						"cost": [
							50,
							50,
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								2.5,
								2.5,
								2.5,
								2.5,
								2.5
							],
							[
								40,
								55,
								70,
								85,
								99
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								8,
								8,
								8,
								8,
								8
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"2.5",
							"40/55/70/85/99",
							"1.5",
							"8",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							550,
							550,
							550,
							550,
							550
						],
						"rangeBurn": "550",
						"image": {
							"full": "TimeWarp.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 240,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ChronoShift",
						"name": "Chronoshift",
						"description": "Zilean places a protective time rune on an allied champion, teleporting the champion back in time if they take lethal damage.",
						"tooltip": "Zilean marks himself or an allied champion with a protective time rune for {{ e2 }} seconds. If the target would take lethal damage, they are instead transported back in time, arriving with {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health.",
						"leveltip": {
							"label": [
								"Health Restored",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							120,
							90,
							60
						],
						"cooldownBurn": "120/90/60",
						"cost": [
							125,
							150,
							175
						],
						"costBurn": "125/150/175",
						"effect": [
							null,
							[
								600,
								850,
								1100
							],
							[
								5,
								5,
								5
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"600/850/1100",
							"5",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 2,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							900,
							900,
							900
						],
						"rangeBurn": "900",
						"image": {
							"full": "ChronoShift.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 288,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Time in a Bottle",
					"description": "Zilean stores time as <font color='#BB55EE'>Experience</font>. <br><br>When he has enough <font color='#BB55EE'>Experience</font> to finish an ally's level, he can right-click them to impart it. Zilean receives as much <font color='#BB55EE'>Experience</font> as he gives. Cannot be used in combat.",
					"image": {
						"full": "Zilean_Passive.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Zilean",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"requiredPerk": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 5,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3073",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3302",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3007",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot-mid",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanSRSupport",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot-support",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3070",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zilean",
						"title": "ZileanTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3158",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3170",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					}
				]
			},
			"Zoe": {
				"id": "Zoe",
				"key": "142",
				"name": "Zoe",
				"title": "the Aspect of Twilight",
				"image": {
					"full": "Zoe.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "142000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "142001",
						"num": 1,
						"name": "Cyber Pop Zoe",
						"chromas": false
					}
				],
				"lore": "As the embodiment of mischief, imagination, and change, Zoe acts as the cosmic messenger of Targon, heralding major events that reshape worlds. Her mere presence warps the arcane mathematics governing realities, sometimes causing cataclysms without conscious effort or malice. This perhaps explains the breezy nonchalance with which Zoe approaches her duties, giving her plenty of time to focus on playing games, tricking mortals, or otherwise amusing herself. An encounter with Zoe can be joyous and life affirming, but it is always more than it appears and often extremely dangerous.",
				"blurb": "As the embodiment of mischief, imagination, and change, Zoe acts as the cosmic messenger of Targon, heralding major events that reshape worlds. Her mere presence warps the arcane mathematics governing realities, sometimes causing cataclysms without...",
				"allytips": [
					"Paddle Star deals more damage the further it has flown. Casting it behind yourself before redirecting can deal tons of damage.",
					"Break Sleep with your biggest damage source, since enemies who are asleep take double damage.",
					"Sleepy Trouble Bubble travels further over walls. Find a hiding spot to set up for a long distance kill."
				],
				"enemytips": [
					"Zoe's Paddle Star deals more damage the further it has flown.",
					"Zoe must return to her starting point after casting Portal Jump, making her vulnerable to a counterattack.",
					"Sleepy Trouble Bubble travels further over walls. Stop Zoe from hiding in fog of war to prevent her from setting the spell up."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 1,
					"defense": 7,
					"magic": 8,
					"difficulty": 5
				},
				"stats": {
					"hp": 526,
					"hpperlevel": 92,
					"mp": 340,
					"mpperlevel": 50,
					"movespeed": 340,
					"armor": 20.8,
					"armorperlevel": 3.5,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 525,
					"hpregen": 6.5,
					"hpregenperlevel": 0.6,
					"mpregen": 6,
					"mpregenperlevel": 0.65,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 56,
					"attackdamageperlevel": 3.3,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.5
				},
				"spells": [
					{
						"id": "ZoeQ",
						"name": "Paddle Star!",
						"description": "Zoe fires a missile that she can redirect in flight. Deals more damage the longer it flies in a straight line.",
						"tooltip": "Fire a missile that deals increasing damage the further it travels -- {{ e1 }} <span class=\"color99FF99\">(+{{ f1 }})</span> to {{ f2 }} <span class=\"color99FF99\">(+{{ f1*2.5 }})</span> magic damage.<span class=\"size5\"><br /><br /><br /></span>Recast to redirect the missile to a new position near Zoe.<br /><br /><rules>Paddle Star applies More Sparkles to the first enemy hit, dealing an additional {{ f3 }} <span class=\"color99FF99\">(+{{ f4 }})</span> to {{ f3*2.5 }} <span class=\"color99FF99\">(+{{ f4*2.5 }})</span> magic damage.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							8.5,
							8,
							7.5,
							7,
							6.5
						],
						"cooldownBurn": "8.5/8/7.5/7/6.5",
						"cost": [
							50,
							55,
							60,
							65,
							70
						],
						"costBurn": "50/55/60/65/70",
						"effect": [
							null,
							[
								45,
								75,
								105,
								135,
								165
							],
							[
								1.5,
								1.5,
								1.5,
								1.5,
								1.5
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"45/75/105/135/165",
							"1.5",
							"0.4",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "ZoeQ.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 336,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZoeW",
						"name": "Spell Thief",
						"description": "Zoe can pick up the remnants of enemy summoner spell and active item casts and cast them once herself. Whenever she casts a summoner spell, she gains 3 missiles that fire at the nearest target.",
						"tooltip": "Enemy Summoner Spell and Active Item casts drop spell shards lasting 40 seconds. Some minions also drop a spell shard when Zoe kills them.<br /><br /><span class=\"colorFF9900\">Active: </span>Collecting a spell shard grants one cast of that spell.<br />                 ____________________________________________ <span class=\"size8\"><br /><br /></span></span><span class=\"colorFF9900\">Passive: </span>When Zoe casts a Summoner Spell or Spell Thief, she gains {{ e9 }}% movement speed for {{ e0 }} seconds and tosses up to 3 missiles at her attack target, dealing {{ e8 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage total. Each missile can apply More Sparkles!<br /><br /><rules>Movement speed bonus and missile damage improve with spell rank.</rules>",
						"leveltip": {
							"label": [
								"Damage",
								"Movement Speed",
								"Speed Duration"
							],
							"effect": [
								"{{ e8 }} -> {{ e8NL }}",
								"{{ e9 }}% -> {{ e9NL }}%",
								"{{ e0 }} -> {{ e0NL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						"cooldownBurn": "0.25",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								25,
								36.67,
								48.33,
								60,
								71.67
							],
							[
								3000,
								4500,
								6000,
								0,
								0
							],
							[
								0.1,
								0.1,
								0.1,
								0.1,
								0.1
							],
							[
								2500,
								2500,
								2500,
								2500,
								2500
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								20,
								50,
								80,
								110,
								140
							],
							[
								0.25,
								0.25,
								0.25,
								0.25,
								0.25
							],
							[
								70,
								115,
								160,
								205,
								250
							],
							[
								10,
								25,
								40,
								55,
								70
							],
							[
								2,
								2.5,
								3,
								3.5,
								4
							]
						],
						"effectBurn": [
							null,
							"25/36.67/48.33/60/71.67",
							"3000/4500/6000/0/0",
							"0.1",
							"2500",
							"60",
							"20/50/80/110/140",
							"0.25",
							"70/115/160/205/250",
							"10/25/40/55/70",
							"2/2.5/3/3.5/4"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							3000,
							4500,
							6000,
							3000,
							3000
						],
						"rangeBurn": "3000/4500/6000/3000/3000",
						"image": {
							"full": "ZoeW.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 384,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZoeE",
						"name": "Sleepy Trouble Bubble",
						"description": "Causes the target to become drowsy, then fall asleep. The first source of damage that breaks the sleep is doubled, up to a cap.",
						"tooltip": "Dropkick a bubble that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, lingering as a trap if it hits nothing. The bubble's range is extended when flying over a wall.<br /><br />After a delay, the victim falls asleep for 2 seconds. Attacks and spell hits break sleep but deal double damage, up to {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus true damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Bonus Damage Cap",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e6 }} -> {{ e6NL }}",
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 5,
						"cooldown": [
							16,
							15.5,
							15,
							14.5,
							14
						],
						"cooldownBurn": "16/15.5/15/14.5/14",
						"cost": [
							80,
							80,
							80,
							80,
							80
						],
						"costBurn": "80",
						"effect": [
							null,
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								0.1,
								0.15,
								0.2,
								0.25,
								0.3
							],
							[
								5,
								15,
								25,
								35,
								45
							],
							[
								5,
								5,
								5,
								5,
								5
							],
							[
								0.1,
								0.2,
								0.3,
								0.4,
								0.5
							],
							[
								60,
								100,
								140,
								180,
								220
							],
							[
								0.4,
								0.4,
								0.4,
								0.4,
								0.4
							],
							[
								1.4,
								1.4,
								1.4,
								1.4,
								1.4
							],
							[
								2.25,
								2.25,
								2.25,
								2.25,
								2.25
							],
							[
								1,
								1,
								1,
								1,
								1
							]
						],
						"effectBurn": [
							null,
							"60/100/140/180/220",
							"0.1/0.15/0.2/0.25/0.3",
							"5/15/25/35/45",
							"5",
							"0.1/0.2/0.3/0.4/0.5",
							"60/100/140/180/220",
							"0.4",
							"1.4",
							"2.25",
							"1"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.4,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "ZoeE.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 432,
							"y": 0,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZoeR",
						"name": "Portal Jump",
						"description": "Blink to a nearby position for 1 second. Then blink back.",
						"tooltip": "Blink to a nearby position for 1 second. Then blink back.<br /><br /><rules>Zoe may cast and attack, but not move, during this time. She can also see over walls.</rules>",
						"leveltip": {
							"label": [
								"Cooldown"
							],
							"effect": [
								"{{ cooldown }}s -> {{ cooldownNL }}s"
							]
						},
						"maxrank": 3,
						"cooldown": [
							11,
							8,
							5
						],
						"cooldownBurn": "11/8/5",
						"cost": [
							50,
							50,
							50
						],
						"costBurn": "50",
						"effect": [
							null,
							[
								-0.3,
								-0.4,
								-0.5
							],
							[
								1.5,
								2,
								2.5
							],
							[
								4,
								4,
								4
							],
							[
								0.5,
								0.5,
								0.5
							],
							[
								3,
								3,
								3
							],
							[
								100,
								200,
								300
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"-0.3/-0.4/-0.5",
							"1.5/2/2.5",
							"4",
							"0.5",
							"3",
							"100/200/300",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							575,
							575,
							575
						],
						"rangeBurn": "575",
						"image": {
							"full": "ZoeR.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 0,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "More Sparkles!",
					"description": "Zoe's next basic attack after casting a spell deals bonus magic damage.",
					"image": {
						"full": "Zoe_P.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Zoe",
						"title": "Beginner",
						"map": "SR",
						"mode": "INTRO",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": 4,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_starter",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": 5,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_advanced",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1028",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_movementspeed",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_legendaryitem",
								"recMath": true,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3010",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1026",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "beginner_morelegendaryitems",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeASC",
						"map": "CrystalScar",
						"mode": "ASCENSION",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeDM",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3152",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3174",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3105",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3069",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoePG",
						"map": "3",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 4,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3027",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeoffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegedefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3029",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3057",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zoe",
						"title": "ZoeTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3100",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			},
			"Zyra": {
				"id": "Zyra",
				"key": "143",
				"name": "Zyra",
				"title": "Rise of the Thorns",
				"image": {
					"full": "Zyra.png",
					"sprite": "champion4.png",
					"group": "champion",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				},
				"skins": [
					{
						"id": "143000",
						"num": 0,
						"name": "default",
						"chromas": false
					},
					{
						"id": "143001",
						"num": 1,
						"name": "Wildfire Zyra",
						"chromas": false
					},
					{
						"id": "143002",
						"num": 2,
						"name": "Haunted Zyra",
						"chromas": false
					},
					{
						"id": "143003",
						"num": 3,
						"name": "SKT T1 Zyra",
						"chromas": false
					},
					{
						"id": "143004",
						"num": 4,
						"name": "Dragon Sorceress Zyra",
						"chromas": false
					}
				],
				"lore": "Born in an ancient, sorcerous catastrophe, Zyra is the wrath of nature given form—an alluring hybrid of plant and human, kindling new life with every step. She views the many mortals of Valoran as little more than prey for her seeded progeny, and thinks nothing of slaying them with flurries of deadly spines. Though her true purpose has not been revealed, Zyra wanders the world, indulging her most primal urges to colonize, and strangle all other life from it.",
				"blurb": "Born in an ancient, sorcerous catastrophe, Zyra is the wrath of nature given form—an alluring hybrid of plant and human, kindling new life with every step. She views the many mortals of Valoran as little more than prey for her seeded progeny, and thinks...",
				"allytips": [
					"Placing a seed in your spell's path after you have cast it gives you the best chance of having a seed in the proper spot.",
					"Seeds grant vision to your team.",
					"Zyra is a great ambusher - look for opportunities to set a trap of seeds in brush, then lure enemies in."
				],
				"enemytips": [
					"Zyra's seeds can be destroyed by stepping on them. If she tries to grow them as you do, dodge back at the last moment. ",
					"Moving closer to Zyra can be a smart move if she places plants too far away from herself.",
					"Plants take fixed damage from attacks and effects, similar to wards. They also expire quickly on their own.",
					"Moving the fight to a different area will deprive Zyra of accumulated seeds.",
					"Seeds placed by Zyra's W are larger, a different color, and grant a small amount of vision to her team."
				],
				"tags": [
					"Mage",
					"Support"
				],
				"partype": "Mana",
				"info": {
					"attack": 4,
					"defense": 3,
					"magic": 8,
					"difficulty": 7
				},
				"stats": {
					"hp": 504,
					"hpperlevel": 79,
					"mp": 334,
					"mpperlevel": 50,
					"movespeed": 340,
					"armor": 29,
					"armorperlevel": 3,
					"spellblock": 30,
					"spellblockperlevel": 0.5,
					"attackrange": 575,
					"hpregen": 5.5,
					"hpregenperlevel": 0.5,
					"mpregen": 11.5,
					"mpregenperlevel": 0.4,
					"crit": 0,
					"critperlevel": 0,
					"attackdamage": 53.376,
					"attackdamageperlevel": 3.2,
					"attackspeedoffset": 0,
					"attackspeedperlevel": 2.11
				},
				"spells": [
					{
						"id": "ZyraQ",
						"name": "Deadly Spines",
						"description": "Thick vines spread through the ground and explode into spines, dealing magic damage to enemies within the area. If cast near a seed, Deadly Spines grows a Thorn Spitter plant, which fires at enemies from afar.",
						"tooltip": "Thick vines spread through the ground and explode into spines, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies within the area. <br /><br /><span class=\"colorDDDD77\">Garden of Thorns: </span>If Deadly Spines is cast near a seed, a Thorn Spitter grows, dealing {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage. A Thorn Spitter has 575 range and lasts {{ f2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							7,
							6.5,
							6,
							5.5,
							5
						],
						"cooldownBurn": "7/6.5/6/5.5/5",
						"cost": [
							70,
							70,
							70,
							70,
							70
						],
						"costBurn": "70",
						"effect": [
							null,
							[
								60,
								95,
								130,
								165,
								200
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/95/130/165/200",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.6,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							800,
							800,
							800,
							800,
							800
						],
						"rangeBurn": "800",
						"image": {
							"full": "ZyraQ.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 48,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZyraW",
						"name": "Rampant Growth",
						"description": "Zyra plants a seed, lasting up to 60 seconds. Deadly Spines and Grasping Roots cast near seeds will turn them into plants who fight for Zyra. Zyra can store multiple seeds at once, and killing enemies reduces Rampant Growth's recharge time.",
						"tooltip": "Plants a seed, lasting {{ e6 }} seconds. If an enemy Champion steps on a seed, it dies. Seeds spawned by Rampant Growth grant vision in a small area, and if stepped on they grant <span class=\"coloree91d7\">True Sight</span> of the enemy champion for {{ e3 }} seconds.<br /><br />Zyra stores a seed every <span class=\"colorFFFFFF\">{{ ammorechargetime }}</span> seconds (Max: 8 seeds planted). Each time she kills an enemy, Rampant Growth's recharge time is reduced by {{ e1 }}% ({{ e2 }}% for champion takedowns, large minion kills, and large monster kills).",
						"leveltip": {
							"label": [
								"Seed Recharge Rate"
							],
							"effect": [
								"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							0,
							0,
							0,
							0,
							0
						],
						"cooldownBurn": "0",
						"cost": [
							0,
							0,
							0,
							0,
							0
						],
						"costBurn": "0",
						"effect": [
							null,
							[
								20,
								20,
								20,
								20,
								20
							],
							[
								100,
								100,
								100,
								100,
								100
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								60,
								60,
								60,
								60,
								60
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								10,
								20,
								30,
								40,
								50
							],
							[
								0.4,
								0.8,
								1.2,
								1.6,
								2
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"20",
							"100",
							"2",
							"0",
							"0",
							"60",
							"0",
							"10/20/30/40/50",
							"0.4/0.8/1.2/1.6/2",
							"0"
						],
						"vars": [],
						"costType": "1 Seed",
						"maxammo": "2",
						"range": [
							850,
							850,
							850,
							850,
							850
						],
						"rangeBurn": "850",
						"image": {
							"full": "ZyraW.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 96,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "1 Seed"
					},
					{
						"id": "ZyraE",
						"name": "Grasping Roots",
						"description": "Zyra sends forth vines through the ground to ensnare her target, dealing damage and rooting enemies they come across. If cast near a seed, Grasping Roots grows a Vine Lasher, whose short range attacks reduce enemy Movement Speed.",
						"tooltip": "Sends forward vines dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and rooting enemies for {{ e5 }} second(s).<br /><br /><span class=\"colorDDDD77\">Garden of Thorns: </span>If Grasping Roots passes near a seed, a Vine Lasher grows dealing {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and slowing enemies by {{ e2 }}% for {{ e3 }} seconds. A Vine Lasher has 400 range and lasts {{ f2 }} seconds.",
						"leveltip": {
							"label": [
								"Damage",
								"Root Duration",
								"Mana Cost"
							],
							"effect": [
								"{{ e1 }} -> {{ e1NL }}",
								"{{ e5 }} -> {{ e5NL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 5,
						"cooldown": [
							12,
							12,
							12,
							12,
							12
						],
						"cooldownBurn": "12",
						"cost": [
							70,
							75,
							80,
							85,
							90
						],
						"costBurn": "70/75/80/85/90",
						"effect": [
							null,
							[
								60,
								105,
								150,
								195,
								240
							],
							[
								30,
								30,
								30,
								30,
								30
							],
							[
								2,
								2,
								2,
								2,
								2
							],
							[
								4,
								4,
								4,
								0,
								0
							],
							[
								0.75,
								1,
								1.25,
								1.5,
								1.75
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							],
							[
								0,
								0,
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"60/105/150/195/240",
							"30",
							"2",
							"4/4/4/0/0",
							"0.75/1/1.25/1.5/1.75",
							"0",
							"0",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.5,
								"key": "a1"
							},
							{
								"link": "spelldamage",
								"coeff": 0.15,
								"key": "a2"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							1100,
							1100,
							1100,
							1100,
							1100
						],
						"rangeBurn": "1100",
						"image": {
							"full": "ZyraE.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 144,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					},
					{
						"id": "ZyraR",
						"name": "Stranglethorns",
						"description": "Zyra summons a twisted thicket at her target location, dealing damage to enemies as it expands and knocking them airborne as it contracts.",
						"tooltip": "Summons the fury of nature, growing a twisted thicket at target location which deals {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in the area as it expands. After 2 seconds, the vines snap upward knocking enemies into the air for {{ e1 }} second.<br /><br /><span class=\"colorDDDD77\">Garden of Thorns: </span>Plants within the thicket are enraged, resetting their duration, gaining {{ e2 }}% Health and attacking in a flurry for 200% total damage.",
						"leveltip": {
							"label": [
								"Damage",
								"Cooldown",
								"Mana Cost"
							],
							"effect": [
								"{{ e3 }} -> {{ e3NL }}",
								"{{ cooldown }} -> {{ cooldownNL }}",
								"{{ cost }} -> {{ costNL }}"
							]
						},
						"maxrank": 3,
						"cooldown": [
							130,
							120,
							110
						],
						"cooldownBurn": "130/120/110",
						"cost": [
							100,
							120,
							140
						],
						"costBurn": "100/120/140",
						"effect": [
							null,
							[
								1,
								1,
								1
							],
							[
								50,
								50,
								50
							],
							[
								180,
								265,
								350
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								150,
								150,
								150
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							],
							[
								0,
								0,
								0
							]
						],
						"effectBurn": [
							null,
							"1",
							"50",
							"180/265/350",
							"0",
							"0",
							"0",
							"150",
							"0",
							"0",
							"0"
						],
						"vars": [
							{
								"link": "spelldamage",
								"coeff": 0.7,
								"key": "a1"
							}
						],
						"costType": " Mana",
						"maxammo": "-1",
						"range": [
							700,
							700,
							700
						],
						"rangeBurn": "700",
						"image": {
							"full": "ZyraR.png",
							"sprite": "spell14.png",
							"group": "spell",
							"x": 192,
							"y": 48,
							"w": 48,
							"h": 48
						},
						"resource": "{{ cost }} Mana"
					}
				],
				"passive": {
					"name": "Garden of Thorns",
					"description": "Seeds spawn around Zyra periodically, becoming faster with level and lasting 30 seconds. If an enemy Champion steps on a seed, it dies. <br><br>Zyra can cast spells near seeds to grow plants. Extra plants striking the same target deal reduced damage.",
					"image": {
						"full": "ZyraP.png",
						"sprite": "passive4.png",
						"group": "passive",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					}
				},
				"recommended": [
					{
						"champion": "Zyra",
						"title": "Beginner",
						"type": "riot",
						"map": "SR",
						"mode": "INTRO",
						"priority": false,
						"blocks": [
							{
								"type": "beginner_Starter",
								"maxSummonerLevel": 4,
								"items": [
									{
										"id": "1056",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Starter",
								"minSummonerLevel": 5,
								"items": [
									{
										"id": "1056",
										"count": 1
									},
									{
										"id": "2003",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_Advanced",
								"recMath": true,
								"items": [
									{
										"id": "1028",
										"count": 1
									},
									{
										"id": "1027",
										"count": 1
									},
									{
										"id": "3010",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MovementSpeed",
								"recMath": true,
								"items": [
									{
										"id": "1001",
										"count": 1
									},
									{
										"id": "3020",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_LegendaryItem",
								"recMath": true,
								"items": [
									{
										"id": "3010",
										"count": 1
									},
									{
										"id": "1026",
										"count": 1
									},
									{
										"id": "3027",
										"count": 1
									}
								]
							},
							{
								"type": "beginner_MoreLegendaryItems",
								"items": [
									{
										"id": "3151",
										"count": 1
									},
									{
										"id": "3174",
										"count": 1
									},
									{
										"id": "3116",
										"count": 1
									},
									{
										"id": "3089",
										"count": 1
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraARAM",
						"map": "HA",
						"mode": "ARAM",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraCS",
						"map": "CrystalScar",
						"mode": "ODIN",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraFIRSTBLOOD",
						"map": "HA",
						"mode": "FIRSTBLOOD",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2049",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3222",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3110",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2043",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraKINGPORO",
						"map": "HA",
						"mode": "KINGPORO",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "KingPoroSnax",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3680",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3681",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3682",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3683",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3112",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3285",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2033",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraSIEGE",
						"map": "SR",
						"mode": "SIEGE",
						"type": "riot",
						"customTag": "",
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "siegeOffense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3631",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3641",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3647",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3635",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "siegeDefense",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3634",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3640",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3643",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3636",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3642",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3050",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraSR",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot-support",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3303",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "startingjungle",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1039",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 3,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3098",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3706",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3113",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "SummonerSmite",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3117",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3092",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3916",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "SummonerSmite",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1402",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "aggressive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3905",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "protective",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3190",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraSRMid",
						"map": "SR",
						"mode": "CLASSIC",
						"type": "riot-mid",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2003",
										"count": 2,
										"hideCount": false
									},
									{
										"id": "3340",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "early",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3802",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3145",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "standard",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "situational",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3157",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3102",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3089",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2055",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					},
					{
						"champion": "Zyra",
						"title": "ZyraTT",
						"map": "TT",
						"mode": "CLASSIC",
						"type": "riot",
						"customTag": "",
						"sortrank": 0,
						"extensionPage": false,
						"customPanel": null,
						"blocks": [
							{
								"type": "starting",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "1056",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "1001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "2031",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "essential",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3020",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3030",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3151",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "offensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3135",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3090",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3165",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "defensive",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "3001",
										"count": 1,
										"hideCount": false
									},
									{
										"id": "3116",
										"count": 1,
										"hideCount": false
									}
								]
							},
							{
								"type": "consumables",
								"recMath": false,
								"recSteps": false,
								"minSummonerLevel": -1,
								"maxSummonerLevel": -1,
								"showIfSummonerSpell": "",
								"hideIfSummonerSpell": "",
								"appendAfterSection": "",
								"visibleWithAllOf": [
									""
								],
								"hiddenWithAnyOf": [
									""
								],
								"items": [
									{
										"id": "2003",
										"count": 1,
										"hideCount": true
									},
									{
										"id": "2139",
										"count": 1,
										"hideCount": true
									}
								]
							}
						]
					}
				]
			}
		},
		"keys": {
			"1": "Annie",
			"2": "Olaf",
			"3": "Galio",
			"4": "TwistedFate",
			"5": "XinZhao",
			"6": "Urgot",
			"7": "Leblanc",
			"8": "Vladimir",
			"9": "Fiddlesticks",
			"10": "Kayle",
			"11": "MasterYi",
			"12": "Alistar",
			"13": "Ryze",
			"14": "Sion",
			"15": "Sivir",
			"16": "Soraka",
			"17": "Teemo",
			"18": "Tristana",
			"19": "Warwick",
			"20": "Nunu",
			"21": "MissFortune",
			"22": "Ashe",
			"23": "Tryndamere",
			"24": "Jax",
			"25": "Morgana",
			"26": "Zilean",
			"27": "Singed",
			"28": "Evelynn",
			"29": "Twitch",
			"30": "Karthus",
			"31": "Chogath",
			"32": "Amumu",
			"33": "Rammus",
			"34": "Anivia",
			"35": "Shaco",
			"36": "DrMundo",
			"37": "Sona",
			"38": "Kassadin",
			"39": "Irelia",
			"40": "Janna",
			"41": "Gangplank",
			"42": "Corki",
			"43": "Karma",
			"44": "Taric",
			"45": "Veigar",
			"48": "Trundle",
			"50": "Swain",
			"51": "Caitlyn",
			"53": "Blitzcrank",
			"54": "Malphite",
			"55": "Katarina",
			"56": "Nocturne",
			"57": "Maokai",
			"58": "Renekton",
			"59": "JarvanIV",
			"60": "Elise",
			"61": "Orianna",
			"62": "MonkeyKing",
			"63": "Brand",
			"64": "LeeSin",
			"67": "Vayne",
			"68": "Rumble",
			"69": "Cassiopeia",
			"72": "Skarner",
			"74": "Heimerdinger",
			"75": "Nasus",
			"76": "Nidalee",
			"77": "Udyr",
			"78": "Poppy",
			"79": "Gragas",
			"80": "Pantheon",
			"81": "Ezreal",
			"82": "Mordekaiser",
			"83": "Yorick",
			"84": "Akali",
			"85": "Kennen",
			"86": "Garen",
			"89": "Leona",
			"90": "Malzahar",
			"91": "Talon",
			"92": "Riven",
			"96": "KogMaw",
			"98": "Shen",
			"99": "Lux",
			"101": "Xerath",
			"102": "Shyvana",
			"103": "Ahri",
			"104": "Graves",
			"105": "Fizz",
			"106": "Volibear",
			"107": "Rengar",
			"110": "Varus",
			"111": "Nautilus",
			"112": "Viktor",
			"113": "Sejuani",
			"114": "Fiora",
			"115": "Ziggs",
			"117": "Lulu",
			"119": "Draven",
			"120": "Hecarim",
			"121": "Khazix",
			"122": "Darius",
			"126": "Jayce",
			"127": "Lissandra",
			"131": "Diana",
			"133": "Quinn",
			"134": "Syndra",
			"136": "AurelionSol",
			"141": "Kayn",
			"142": "Zoe",
			"143": "Zyra",
			"150": "Gnar",
			"154": "Zac",
			"157": "Yasuo",
			"161": "Velkoz",
			"163": "Taliyah",
			"164": "Camille",
			"201": "Braum",
			"202": "Jhin",
			"203": "Kindred",
			"222": "Jinx",
			"223": "TahmKench",
			"236": "Lucian",
			"238": "Zed",
			"240": "Kled",
			"245": "Ekko",
			"254": "Vi",
			"266": "Aatrox",
			"267": "Nami",
			"268": "Azir",
			"412": "Thresh",
			"420": "Illaoi",
			"421": "RekSai",
			"427": "Ivern",
			"429": "Kalista",
			"432": "Bard",
			"497": "Rakan",
			"498": "Xayah",
			"516": "Ornn"
		}
	};

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77),
	    root = __webpack_require__(52);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1097),
	    hashDelete = __webpack_require__(1098),
	    hashGet = __webpack_require__(1099),
	    hashHas = __webpack_require__(1100),
	    hashSet = __webpack_require__(1101);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77),
	    root = __webpack_require__(52);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(77),
	    root = __webpack_require__(52);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1045 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1046 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1047 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(147),
	    eq = __webpack_require__(115);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(208),
	    arrayIncludes = __webpack_require__(464),
	    arrayIncludesWith = __webpack_require__(465),
	    arrayMap = __webpack_require__(145),
	    baseUnary = __webpack_require__(211),
	    cacheHas = __webpack_require__(212);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(471),
	    createBaseEach = __webpack_require__(1084);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(467),
	    isArray = __webpack_require__(47);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1053 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(469),
	    baseIsNaN = __webpack_require__(1058),
	    strictIndexOf = __webpack_require__(1132);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(209),
	    equalArrays = __webpack_require__(476),
	    equalByTag = __webpack_require__(1088),
	    equalObjects = __webpack_require__(1089),
	    getTag = __webpack_require__(1094),
	    isArray = __webpack_require__(47),
	    isBuffer = __webpack_require__(218),
	    isTypedArray = __webpack_require__(221);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(209),
	    baseIsEqual = __webpack_require__(148);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1058 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(219),
	    isMasked = __webpack_require__(1105),
	    isObject = __webpack_require__(59),
	    toSource = __webpack_require__(484);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isLength = __webpack_require__(220),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(215),
	    nativeKeys = __webpack_require__(1118);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59),
	    isPrototype = __webpack_require__(215),
	    nativeKeysIn = __webpack_require__(1119);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1051),
	    isArrayLike = __webpack_require__(78);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1057),
	    getMatchData = __webpack_require__(1091),
	    matchesStrictComparable = __webpack_require__(481);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(148),
	    get = __webpack_require__(1137),
	    hasIn = __webpack_require__(1138),
	    isKey = __webpack_require__(214),
	    isStrictComparable = __webpack_require__(480),
	    matchesStrictComparable = __webpack_require__(481),
	    toKey = __webpack_require__(114);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(209),
	    assignMergeValue = __webpack_require__(468),
	    baseFor = __webpack_require__(470),
	    baseMergeDeep = __webpack_require__(1067),
	    isObject = __webpack_require__(59),
	    keysIn = __webpack_require__(486);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(468),
	    cloneBuffer = __webpack_require__(1077),
	    cloneTypedArray = __webpack_require__(1078),
	    copyArray = __webpack_require__(474),
	    initCloneObject = __webpack_require__(1102),
	    isArguments = __webpack_require__(154),
	    isArray = __webpack_require__(47),
	    isArrayLikeObject = __webpack_require__(217),
	    isBuffer = __webpack_require__(218),
	    isFunction = __webpack_require__(219),
	    isObject = __webpack_require__(59),
	    isPlainObject = __webpack_require__(116),
	    isTypedArray = __webpack_require__(221),
	    toPlainObject = __webpack_require__(1150);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(145),
	    baseIteratee = __webpack_require__(149),
	    baseMap = __webpack_require__(1063),
	    baseSortBy = __webpack_require__(1072),
	    baseUnary = __webpack_require__(211),
	    compareMultiple = __webpack_require__(1080),
	    identity = __webpack_require__(153);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 1069 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(472);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1133),
	    defineProperty = __webpack_require__(475),
	    identity = __webpack_require__(153);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1072 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1073 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(113),
	    arrayMap = __webpack_require__(145),
	    isArray = __webpack_require__(47),
	    isSymbol = __webpack_require__(90);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(208),
	    arrayIncludes = __webpack_require__(464),
	    arrayIncludesWith = __webpack_require__(465),
	    cacheHas = __webpack_require__(212),
	    createSet = __webpack_require__(1087),
	    setToArray = __webpack_require__(216);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(463);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(52);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1076);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(90);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1079);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1048),
	    baseAssignValue = __webpack_require__(147);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(52);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(150),
	    isIterateeCall = __webpack_require__(479);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(78);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1085 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(149),
	    isArrayLike = __webpack_require__(78),
	    keys = __webpack_require__(155);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(462),
	    noop = __webpack_require__(1142),
	    setToArray = __webpack_require__(216);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(113),
	    Uint8Array = __webpack_require__(463),
	    eq = __webpack_require__(115),
	    equalArrays = __webpack_require__(476),
	    mapToArray = __webpack_require__(1116),
	    setToArray = __webpack_require__(216);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1090);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1052),
	    getSymbols = __webpack_require__(1093),
	    keys = __webpack_require__(155);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(480),
	    keys = __webpack_require__(155);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1092 */
[1639, 113],
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1046),
	    stubArray = __webpack_require__(1145);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1041),
	    Map = __webpack_require__(206),
	    Promise = __webpack_require__(1043),
	    Set = __webpack_require__(462),
	    WeakMap = __webpack_require__(1044),
	    baseGetTag = __webpack_require__(89),
	    toSource = __webpack_require__(484);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1095 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(473),
	    isArguments = __webpack_require__(154),
	    isArray = __webpack_require__(47),
	    isIndex = __webpack_require__(213),
	    isLength = __webpack_require__(220),
	    toKey = __webpack_require__(114);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1098 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(152);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1049),
	    getPrototype = __webpack_require__(478),
	    isPrototype = __webpack_require__(215);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(113),
	    isArguments = __webpack_require__(154),
	    isArray = __webpack_require__(47);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1104 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1082);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1106 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(146);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(146);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(146);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(146);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1042),
	    ListCache = __webpack_require__(144),
	    Map = __webpack_require__(206);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(151);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1116 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1140);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(482);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1119 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(477);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module)))

/***/ },
/* 1121 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1045);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1123 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1124 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1071),
	    shortOut = __webpack_require__(1126);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1126 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(144);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1128 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1129 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1130 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(144),
	    Map = __webpack_require__(206),
	    MapCache = __webpack_require__(207);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1132 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1133 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1050),
	    baseFlatten = __webpack_require__(210),
	    baseRest = __webpack_require__(150),
	    isArrayLikeObject = __webpack_require__(217);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1086),
	    findIndex = __webpack_require__(1136);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(469),
	    baseIteratee = __webpack_require__(149),
	    toInteger = __webpack_require__(1148);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(472);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1053),
	    hasPath = __webpack_require__(1096);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(148);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(207);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1066),
	    createAssigner = __webpack_require__(1083);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 1142 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1069),
	    basePropertyDeep = __webpack_require__(1070),
	    isKey = __webpack_require__(214),
	    toKey = __webpack_require__(114);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(210),
	    baseOrderBy = __webpack_require__(1068),
	    baseRest = __webpack_require__(150),
	    isIterateeCall = __webpack_require__(479);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 1145 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1146 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1149);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1147);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59),
	    isSymbol = __webpack_require__(90);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1081),
	    keysIn = __webpack_require__(486);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(210),
	    baseRest = __webpack_require__(150),
	    baseUniq = __webpack_require__(1075),
	    isArrayLikeObject = __webpack_require__(217);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 488,
		"./af.js": 488,
		"./ar": 495,
		"./ar-dz": 489,
		"./ar-dz.js": 489,
		"./ar-kw": 490,
		"./ar-kw.js": 490,
		"./ar-ly": 491,
		"./ar-ly.js": 491,
		"./ar-ma": 492,
		"./ar-ma.js": 492,
		"./ar-sa": 493,
		"./ar-sa.js": 493,
		"./ar-tn": 494,
		"./ar-tn.js": 494,
		"./ar.js": 495,
		"./az": 496,
		"./az.js": 496,
		"./be": 497,
		"./be.js": 497,
		"./bg": 498,
		"./bg.js": 498,
		"./bm": 499,
		"./bm.js": 499,
		"./bn": 500,
		"./bn.js": 500,
		"./bo": 501,
		"./bo.js": 501,
		"./br": 502,
		"./br.js": 502,
		"./bs": 503,
		"./bs.js": 503,
		"./ca": 504,
		"./ca.js": 504,
		"./cs": 505,
		"./cs.js": 505,
		"./cv": 506,
		"./cv.js": 506,
		"./cy": 507,
		"./cy.js": 507,
		"./da": 508,
		"./da.js": 508,
		"./de": 511,
		"./de-at": 509,
		"./de-at.js": 509,
		"./de-ch": 510,
		"./de-ch.js": 510,
		"./de.js": 511,
		"./dv": 512,
		"./dv.js": 512,
		"./el": 513,
		"./el.js": 513,
		"./en-au": 514,
		"./en-au.js": 514,
		"./en-ca": 515,
		"./en-ca.js": 515,
		"./en-gb": 516,
		"./en-gb.js": 516,
		"./en-ie": 517,
		"./en-ie.js": 517,
		"./en-nz": 518,
		"./en-nz.js": 518,
		"./eo": 519,
		"./eo.js": 519,
		"./es": 522,
		"./es-do": 520,
		"./es-do.js": 520,
		"./es-us": 521,
		"./es-us.js": 521,
		"./es.js": 522,
		"./et": 523,
		"./et.js": 523,
		"./eu": 524,
		"./eu.js": 524,
		"./fa": 525,
		"./fa.js": 525,
		"./fi": 526,
		"./fi.js": 526,
		"./fo": 527,
		"./fo.js": 527,
		"./fr": 530,
		"./fr-ca": 528,
		"./fr-ca.js": 528,
		"./fr-ch": 529,
		"./fr-ch.js": 529,
		"./fr.js": 530,
		"./fy": 531,
		"./fy.js": 531,
		"./gd": 532,
		"./gd.js": 532,
		"./gl": 533,
		"./gl.js": 533,
		"./gom-latn": 534,
		"./gom-latn.js": 534,
		"./gu": 535,
		"./gu.js": 535,
		"./he": 536,
		"./he.js": 536,
		"./hi": 537,
		"./hi.js": 537,
		"./hr": 538,
		"./hr.js": 538,
		"./hu": 539,
		"./hu.js": 539,
		"./hy-am": 540,
		"./hy-am.js": 540,
		"./id": 541,
		"./id.js": 541,
		"./is": 542,
		"./is.js": 542,
		"./it": 543,
		"./it.js": 543,
		"./ja": 544,
		"./ja.js": 544,
		"./jv": 545,
		"./jv.js": 545,
		"./ka": 546,
		"./ka.js": 546,
		"./kk": 547,
		"./kk.js": 547,
		"./km": 548,
		"./km.js": 548,
		"./kn": 549,
		"./kn.js": 549,
		"./ko": 550,
		"./ko.js": 550,
		"./ky": 551,
		"./ky.js": 551,
		"./lb": 552,
		"./lb.js": 552,
		"./lo": 553,
		"./lo.js": 553,
		"./lt": 554,
		"./lt.js": 554,
		"./lv": 555,
		"./lv.js": 555,
		"./me": 556,
		"./me.js": 556,
		"./mi": 557,
		"./mi.js": 557,
		"./mk": 558,
		"./mk.js": 558,
		"./ml": 559,
		"./ml.js": 559,
		"./mr": 560,
		"./mr.js": 560,
		"./ms": 562,
		"./ms-my": 561,
		"./ms-my.js": 561,
		"./ms.js": 562,
		"./mt": 563,
		"./mt.js": 563,
		"./my": 564,
		"./my.js": 564,
		"./nb": 565,
		"./nb.js": 565,
		"./ne": 566,
		"./ne.js": 566,
		"./nl": 568,
		"./nl-be": 567,
		"./nl-be.js": 567,
		"./nl.js": 568,
		"./nn": 569,
		"./nn.js": 569,
		"./pa-in": 570,
		"./pa-in.js": 570,
		"./pl": 571,
		"./pl.js": 571,
		"./pt": 573,
		"./pt-br": 572,
		"./pt-br.js": 572,
		"./pt.js": 573,
		"./ro": 574,
		"./ro.js": 574,
		"./ru": 575,
		"./ru.js": 575,
		"./sd": 576,
		"./sd.js": 576,
		"./se": 577,
		"./se.js": 577,
		"./si": 578,
		"./si.js": 578,
		"./sk": 579,
		"./sk.js": 579,
		"./sl": 580,
		"./sl.js": 580,
		"./sq": 581,
		"./sq.js": 581,
		"./sr": 583,
		"./sr-cyrl": 582,
		"./sr-cyrl.js": 582,
		"./sr.js": 583,
		"./ss": 584,
		"./ss.js": 584,
		"./sv": 585,
		"./sv.js": 585,
		"./sw": 586,
		"./sw.js": 586,
		"./ta": 587,
		"./ta.js": 587,
		"./te": 588,
		"./te.js": 588,
		"./tet": 589,
		"./tet.js": 589,
		"./th": 590,
		"./th.js": 590,
		"./tl-ph": 591,
		"./tl-ph.js": 591,
		"./tlh": 592,
		"./tlh.js": 592,
		"./tr": 593,
		"./tr.js": 593,
		"./tzl": 594,
		"./tzl.js": 594,
		"./tzm": 596,
		"./tzm-latn": 595,
		"./tzm-latn.js": 595,
		"./tzm.js": 596,
		"./uk": 597,
		"./uk.js": 597,
		"./ur": 598,
		"./ur.js": 598,
		"./uz": 600,
		"./uz-latn": 599,
		"./uz-latn.js": 599,
		"./uz.js": 600,
		"./vi": 601,
		"./vi.js": 601,
		"./x-pseudo": 602,
		"./x-pseudo.js": 602,
		"./yo": 603,
		"./yo.js": 603,
		"./zh-cn": 604,
		"./zh-cn.js": 604,
		"./zh-hk": 605,
		"./zh-hk.js": 605,
		"./zh-tw": 606,
		"./zh-tw.js": 606
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1152;


/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(607);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(607);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(223);
	var invariant = __webpack_require__(610);
	var ReactPropTypesSecret = __webpack_require__(609);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(223);
	var invariant = __webpack_require__(610);
	var warning = __webpack_require__(1158);
	var assign = __webpack_require__(1159);
	
	var ReactPropTypesSecret = __webpack_require__(609);
	var checkPropTypes = __webpack_require__(1155);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1158 */
[1642, 223],
/* 1159 */
30,
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1162);
	var objectAssign = __webpack_require__(1161);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1161 */
30,
/* 1162 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSAlert = __webpack_require__(720);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _TableHeaderColumn = __webpack_require__(613);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	var _TableHeader = __webpack_require__(1173);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _TableFooter = __webpack_require__(1172);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TableBody = __webpack_require__(1168);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _PaginationList = __webpack_require__(1183);
	
	var _PaginationList2 = _interopRequireDefault(_PaginationList);
	
	var _ToolBar = __webpack_require__(1187);
	
	var _ToolBar2 = _interopRequireDefault(_ToolBar);
	
	var _TableFilter = __webpack_require__(1171);
	
	var _TableFilter2 = _interopRequireDefault(_TableFilter);
	
	var _TableDataStore = __webpack_require__(1184);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _csv_export_util = __webpack_require__(1175);
	
	var _csv_export_util2 = _interopRequireDefault(_csv_export_util);
	
	var _Filter = __webpack_require__(1166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-alert: 0 */
	/* eslint max-len: 0 */
	
	
	var BootstrapTable = function (_Component) {
	  _inherits(BootstrapTable, _Component);
	
	  function BootstrapTable(props) {
	    _classCallCheck(this, BootstrapTable);
	
	    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));
	
	    _this.handleSort = function () {
	      return _this.__handleSort__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleExpandRow = function () {
	      return _this.__handleExpandRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handlePaginationData = function () {
	      return _this.__handlePaginationData__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleMouseLeave = function () {
	      return _this.__handleMouseLeave__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleMouseEnter = function () {
	      return _this.__handleMouseEnter__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowMouseOut = function () {
	      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowMouseOver = function () {
	      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleNavigateCell = function () {
	      return _this.__handleNavigateCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowClick = function () {
	      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowDoubleClick = function () {
	      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSelectAllRow = function () {
	      return _this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleShowOnlySelected = function () {
	      return _this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSelectRow = function () {
	      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleEditCell = function () {
	      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleAddRow = function () {
	      return _this.__handleAddRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.getPageByRowKey = function () {
	      return _this.__getPageByRowKey__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleDropRow = function () {
	      return _this.__handleDropRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleFilterData = function () {
	      return _this.__handleFilterData__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleExportCSV = function () {
	      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSearch = function () {
	      return _this.__handleSearch__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this._scrollTop = function () {
	      return _this.___scrollTop__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this._scrollHeader = function () {
	      return _this.___scrollHeader__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this._scrollFooter = function () {
	      return _this.___scrollFooter__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.isIE = false;
	    if (_util2.default.canUseDOM()) {
	      _this.isIE = document.documentMode;
	    }
	    _this.store = new _TableDataStore.TableDataStore(_this.props.data ? _this.props.data.slice() : []);
	    _this.isVerticalScroll = false;
	    _this.initTable(_this.props);
	
	    if (_this.props.selectRow && _this.props.selectRow.selected) {
	      var copy = _this.props.selectRow.selected.slice();
	      _this.store.setSelectedRowKey(copy);
	    }
	    var currPage = _Const2.default.PAGE_START_INDEX;
	    if (typeof _this.props.options.page !== 'undefined') {
	      currPage = _this.props.options.page;
	    } else if (typeof _this.props.options.pageStartIndex !== 'undefined') {
	      currPage = _this.props.options.pageStartIndex;
	    }
	
	    _this._adjustHeaderWidth = _this._adjustHeaderWidth.bind(_this);
	    _this._adjustHeight = _this._adjustHeight.bind(_this);
	    _this._adjustTable = _this._adjustTable.bind(_this);
	    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);
	
	    var expandedKeys = [];
	    if (_this.props.options.expandAllChilds !== null && _this.props.options.expandAllChilds !== undefined && _this.props.options.expandAllChilds) {
	      expandedKeys = _this.store.getAllRowkey();
	    } else if (_this.props.options.expanding !== undefined && _this.props.options.expanding !== null) {
	      expandedKeys = _this.props.options.expanding;
	    }
	
	    _this.state = {
	      data: _this.getTableData(),
	      currPage: currPage,
	      expanding: expandedKeys,
	      sizePerPage: _this.props.options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0],
	      selectedRowKeys: _this.store.getSelectedRowKeys(),
	      reset: false,
	      x: _this.props.keyBoardNav ? 0 : -1,
	      y: _this.props.keyBoardNav ? 0 : -1
	    };
	    return _this;
	  }
	
	  _createClass(BootstrapTable, [{
	    key: '___scrollFooter__REACT_HOT_LOADER__',
	    value: function ___scrollFooter__REACT_HOT_LOADER__() {
	      return this.___scrollFooter__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '___scrollHeader__REACT_HOT_LOADER__',
	    value: function ___scrollHeader__REACT_HOT_LOADER__() {
	      return this.___scrollHeader__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '___scrollTop__REACT_HOT_LOADER__',
	    value: function ___scrollTop__REACT_HOT_LOADER__() {
	      return this.___scrollTop__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSearch__REACT_HOT_LOADER__',
	    value: function __handleSearch__REACT_HOT_LOADER__() {
	      return this.__handleSearch__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleExportCSV__REACT_HOT_LOADER__',
	    value: function __handleExportCSV__REACT_HOT_LOADER__() {
	      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleFilterData__REACT_HOT_LOADER__',
	    value: function __handleFilterData__REACT_HOT_LOADER__() {
	      return this.__handleFilterData__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleDropRow__REACT_HOT_LOADER__',
	    value: function __handleDropRow__REACT_HOT_LOADER__() {
	      return this.__handleDropRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__getPageByRowKey__REACT_HOT_LOADER__',
	    value: function __getPageByRowKey__REACT_HOT_LOADER__() {
	      return this.__getPageByRowKey__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleAddRow__REACT_HOT_LOADER__',
	    value: function __handleAddRow__REACT_HOT_LOADER__() {
	      return this.__handleAddRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleEditCell__REACT_HOT_LOADER__',
	    value: function __handleEditCell__REACT_HOT_LOADER__() {
	      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSelectRow__REACT_HOT_LOADER__',
	    value: function __handleSelectRow__REACT_HOT_LOADER__() {
	      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
	    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
	      return this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
	    value: function __handleSelectAllRow__REACT_HOT_LOADER__() {
	      return this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
	    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
	      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowClick__REACT_HOT_LOADER__',
	    value: function __handleRowClick__REACT_HOT_LOADER__() {
	      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleNavigateCell__REACT_HOT_LOADER__',
	    value: function __handleNavigateCell__REACT_HOT_LOADER__() {
	      return this.__handleNavigateCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
	      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
	      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleMouseEnter__REACT_HOT_LOADER__',
	    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
	      return this.__handleMouseEnter__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleMouseLeave__REACT_HOT_LOADER__',
	    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
	      return this.__handleMouseLeave__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handlePaginationData__REACT_HOT_LOADER__',
	    value: function __handlePaginationData__REACT_HOT_LOADER__() {
	      return this.__handlePaginationData__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleExpandRow__REACT_HOT_LOADER__',
	    value: function __handleExpandRow__REACT_HOT_LOADER__() {
	      return this.__handleExpandRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSort__REACT_HOT_LOADER__',
	    value: function __handleSort__REACT_HOT_LOADER__() {
	      return this.__handleSort__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'initTable',
	    value: function initTable(props) {
	      var _this2 = this;
	
	      // If columns changed, clean removed columns that had filters
	      if (props.children !== this.props.children && this.filter) {
	        var nextDataFields = _react2.default.Children.map(props.children, function (column) {
	          return column.props.dataField;
	        });
	        _react2.default.Children.forEach(this.props.children, function (column) {
	          var _column$props = column.props,
	              dataField = _column$props.dataField,
	              filter = _column$props.filter;
	
	          if (filter && !nextDataFields.includes(dataField)) {
	            // Clear filter
	            _this2.filter.handleFilter(dataField, '', filter.type, filter);
	          }
	        });
	      }
	
	      var keyField = props.keyField;
	
	
	      var isKeyFieldDefined = typeof keyField === 'string' && keyField.length;
	      _react2.default.Children.forEach(props.children, function (column) {
	        if (column === null || column === undefined) {
	          // Skip null and undefined value
	          return;
	        }
	        if (column.props.isKey) {
	          if (keyField) {
	            throw new Error('Error. Multiple key column detected in TableHeaderColumn.');
	          }
	          keyField = column.props.dataField;
	        }
	        if (column.props.filter) {
	          // a column contains a filter
	          if (!_this2.filter) {
	            // first time create the filter on the BootstrapTable
	            _this2.filter = new _Filter.Filter();
	          }
	          // pass the filter to column with filter
	          column.props.filter.emitter = _this2.filter;
	        }
	      });
	
	      // if a column filter was created, add 'onFilterChange' listener
	      if (this.filter) {
	        this.filter.removeAllListeners('onFilterChange');
	        this.filter.on('onFilterChange', function (currentFilter) {
	          _this2.handleFilterData(currentFilter);
	        });
	      }
	
	      this.colInfos = this.getColumnsDescription(props).reduce(function (prev, curr) {
	        prev[curr.name] = curr;
	        return prev;
	      }, {});
	
	      if (!isKeyFieldDefined && !keyField) {
	        throw new Error('Error. No any key column defined in TableHeaderColumn.\n            Use \'isKey={true}\' to specify a unique column after version 0.5.4.');
	      }
	
	      this.store.setProps({
	        isPagination: props.pagination,
	        keyField: keyField,
	        colInfos: this.colInfos,
	        multiColumnSearch: props.multiColumnSearch,
	        strictSearch: props.strictSearch,
	        multiColumnSort: props.multiColumnSort,
	        remote: this.props.remote
	      });
	    }
	  }, {
	    key: 'getTableData',
	    value: function getTableData() {
	      var result = [];
	      var _props = this.props,
	          options = _props.options,
	          pagination = _props.pagination;
	
	      var sortName = options.defaultSortName || options.sortName;
	      var sortOrder = options.defaultSortOrder || options.sortOrder;
	      var searchText = options.defaultSearch;
	
	      if (sortName && sortOrder) {
	        this.store.setSortInfo(sortOrder, sortName);
	        if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
	          this.store.sort();
	        }
	      }
	
	      if (searchText) {
	        this.store.search(searchText);
	      }
	
	      if (pagination) {
	        var page = void 0;
	        var sizePerPage = void 0;
	        if (this.store.isChangedPage()) {
	          sizePerPage = this.state.sizePerPage;
	          page = this.state.currPage;
	        } else {
	          sizePerPage = options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0];
	          page = options.page || 1;
	        }
	        result = this.store.page(page, sizePerPage).get();
	      } else {
	        result = this.store.get();
	      }
	      return result;
	    }
	  }, {
	    key: 'getColumnsDescription',
	    value: function getColumnsDescription(_ref) {
	      var _this3 = this;
	
	      var children = _ref.children;
	
	      var rowCount = 0;
	      _react2.default.Children.forEach(children, function (column) {
	        if (column === null || column === undefined) {
	          // Skip null and undefined value
	          return;
	        }
	
	        if (Number(column.props.row) > rowCount) {
	          rowCount = Number(column.props.row);
	        }
	      });
	      return _react2.default.Children.map(children, function (column, i) {
	        if (column === null || column === undefined) {
	          // Return null for empty objects
	          return null;
	        }
	
	        var rowIndex = column.props.row ? Number(column.props.row) : 0;
	        var rowSpan = column.props.rowSpan ? Number(column.props.rowSpan) : 1;
	        if (rowSpan + rowIndex === rowCount + 1) {
	          var columnDescription = _this3.getColumnDescription(column);
	
	          columnDescription.index = i;
	          return columnDescription;
	        }
	      });
	    }
	  }, {
	    key: 'getColumnDescription',
	    value: function getColumnDescription(column) {
	      var columnDescription = {
	        name: column.props.dataField,
	        align: column.props.dataAlign,
	        sort: column.props.dataSort,
	        format: column.props.dataFormat,
	        formatExtraData: column.props.formatExtraData,
	        filterFormatted: column.props.filterFormatted,
	        filterValue: column.props.filterValue,
	        editable: column.props.editable,
	        customEditor: column.props.customEditor,
	        hidden: column.props.hidden,
	        hiddenOnInsert: column.props.hiddenOnInsert,
	        searchable: column.props.searchable,
	        className: column.props.columnClassName,
	        editClassName: column.props.editColumnClassName,
	        invalidEditColumnClassName: column.props.invalidEditColumnClassName,
	        columnTitle: column.props.columnTitle,
	        width: column.props.width,
	        text: column.props.headerText || column.props.children,
	        sortFunc: column.props.sortFunc,
	        sortFuncExtraData: column.props.sortFuncExtraData,
	        export: column.props.export,
	        expandable: column.props.expandable,
	        attrs: column.props.tdAttr,
	        editAttrs: column.props.editTdAttr,
	        style: column.props.tdStyle
	      };
	
	      if (column.type.name !== _TableHeaderColumn2.default.name && _react2.default.isValidElement(column.props.children)) {
	        columnDescription = _extends({}, columnDescription, this.getColumnDescription(_react2.default.Children.only(column.props.children)));
	      }
	
	      return columnDescription;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var _this4 = this;
	
	      var pageStartIndex = this.props.options.pageStartIndex;
	
	      this.store.clean();
	      this.body.setState({ currEditCell: null });
	      this.setState(function () {
	        return {
	          data: _this4.getTableData(),
	          currPage: _util2.default.getFirstPage(pageStartIndex),
	          expanding: [],
	          sizePerPage: _Const2.default.SIZE_PER_PAGE_LIST[0],
	          selectedRowKeys: [],
	          reset: true
	        };
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.initTable(nextProps);
	      var options = nextProps.options,
	          selectRow = nextProps.selectRow;
	      var replace = nextProps.replace;
	
	      replace = replace || this.props.replace;
	
	      if (!nextProps.data) {
	        return;
	      }
	      this.store.setData(nextProps.data.slice());
	
	      if (!replace) {
	        // from #481
	        var page = this.state.currPage;
	        if (this.props.options.page !== options.page) {
	          page = options.page;
	        }
	        // from #481
	        var sizePerPage = this.state.sizePerPage;
	        if (this.props.options.sizePerPage !== options.sizePerPage) {
	          sizePerPage = options.sizePerPage;
	        }
	
	        if (this.isRemoteDataSource()) {
	          var newState = { sizePerPage: sizePerPage, reset: false, currPage: page };
	          var data = nextProps.data.slice();
	          if (nextProps.pagination && !this.allowRemote(_Const2.default.REMOTE_PAGE)) {
	            data = this.store.page(page, sizePerPage).get();
	          }
	
	          if (this.store.isOnFilter) {
	            if (this.store.searchText) this.handleSearch(this.store.searchText);
	            if (this.store.filterObj) this.handleFilterData(this.store.filterObj);
	            newState.currPage = _util2.default.getFirstPage(nextProps.options.pageStartIndex);
	          } else {
	            if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
	              data = this.store.sort().get();
	            } else {
	              var currentOptions = this.props.options;
	
	              var sortName = options.sortName;
	              var sortOrder = options.sortOrder;
	              if (currentOptions.sortName !== sortName || currentOptions.sortOrder !== sortOrder) {
	                this.store.setSortInfo(sortOrder, options.sortName);
	              }
	            }
	            newState.data = data;
	          }
	          this.setState(function () {
	            return newState;
	          });
	        } else {
	          // #125
	          // remove !options.page for #709
	          if (page > Math.ceil(nextProps.data.length / sizePerPage)) {
	            page = 1;
	          }
	          var sortList = this.store.getSortInfo();
	          var sortField = options.sortName;
	          var _sortOrder = options.sortOrder;
	          if (sortField && _sortOrder) {
	            this.store.setSortInfo(_sortOrder, sortField);
	            this.store.sort();
	          } else if (sortList.length > 0) {
	            this.store.sort();
	          }
	          var _data = this.store.page(page, sizePerPage).get();
	          this.setState(function () {
	            return {
	              data: _data,
	              currPage: page,
	              sizePerPage: sizePerPage,
	              reset: false
	            };
	          });
	
	          if (this.store.isSearching && options.afterSearch) {
	            options.afterSearch(this.store.searchText, this.store.getDataIgnoringPagination());
	          }
	
	          if (this.store.isFiltering && options.afterColumnFilter) {
	            options.afterColumnFilter(this.store.filterObj, this.store.getDataIgnoringPagination());
	          }
	        }
	
	        // If setting the expanded rows is being handled externally
	        // then overwrite the current expanded rows.
	        if (this.props.options.expanding !== options.expanding) {
	          this.setState(function () {
	            return {
	              expanding: options.expanding || []
	            };
	          });
	        }
	
	        if (selectRow && selectRow.selected) {
	          // set default select rows to store.
	          var copy = selectRow.selected.slice();
	          this.store.setSelectedRowKey(copy);
	          this.setState(function () {
	            return {
	              selectedRowKeys: copy,
	              reset: false
	            };
	          });
	        }
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._adjustTable();
	      window.addEventListener('resize', this._adjustTable);
	      this.body.container.addEventListener('scroll', this._scrollHeader);
	      if (this.props.footer) {
	        this.body.container.addEventListener('scroll', this._scrollFooter);
	      }
	      if (this.props.scrollTop) {
	        this._scrollTop();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this._adjustTable);
	      if (this.body && this.body.container) {
	        this.body.container.removeEventListener('scroll', this._scrollHeader);
	        if (this.props.footer) {
	          this.body.container.removeEventListener('scroll', this._scrollFooter);
	        }
	      }
	      if (this.filter) {
	        this.filter.removeAllListeners('onFilterChange');
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._adjustTable();
	      if (this.props.options.afterTableComplete) {
	        this.props.options.afterTableComplete();
	      }
	    }
	
	    /**
	     * Returns true if in the current configuration,
	     * the datagrid should load its data remotely.
	     *
	     * @param  {Object}  [props] Optional. If not given, this.props will be used
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'isRemoteDataSource',
	    value: function isRemoteDataSource(props) {
	      var _ref2 = props || this.props,
	          remote = _ref2.remote;
	
	      return remote === true || _util2.default.isFunction(remote);
	    }
	
	    /**
	     * Returns true if this action can be handled remote store
	     * From #990, Sometimes, we need some actions as remote, some actions are handled by default
	     * so function will tell you the target action is can be handled as remote or not.
	     * @param  {String}  [action] Required.
	     * @param  {Object}  [props] Optional. If not given, this.props will be used
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'allowRemote',
	    value: function allowRemote(action, props) {
	      var _ref3 = props || this.props,
	          remote = _ref3.remote;
	
	      if (typeof remote === 'function') {
	        var remoteObj = remote(_Const2.default.REMOTE);
	        return remoteObj[action];
	      } else {
	        return remote;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var style = {
	        height: this.props.height,
	        maxHeight: this.props.maxHeight
	      };
	
	      var columns = this.getColumnsDescription(this.props);
	      var sortList = this.store.getSortInfo();
	      var pagination = this.renderPagination();
	      var toolBar = this.renderToolBar();
	      var tableFilter = this.renderTableFilter(columns);
	      var isSelectAll = this.isSelectAll();
	      var expandColumnOptions = this.props.expandColumnOptions;
	      if (typeof expandColumnOptions.expandColumnBeforeSelectColumn === 'undefined') {
	        expandColumnOptions.expandColumnBeforeSelectColumn = true;
	      }
	      var colGroups = _util2.default.renderColGroup(columns, this.props.selectRow, expandColumnOptions, this.props.version);
	      var tableFooter = this.renderTableFooter(this.props.footerData, this.state.data, columns, colGroups);
	      var sortIndicator = this.props.options.sortIndicator;
	      if (typeof this.props.options.sortIndicator === 'undefined') sortIndicator = true;
	
	      var _props$options$pagina = this.props.options.paginationPosition,
	          paginationPosition = _props$options$pagina === undefined ? _Const2.default.PAGINATION_POS_BOTTOM : _props$options$pagina;
	
	      var showPaginationOnTop = paginationPosition !== _Const2.default.PAGINATION_POS_BOTTOM;
	      var showPaginationOnBottom = paginationPosition !== _Const2.default.PAGINATION_POS_TOP;
	      var selectRow = _extends({}, this.props.selectRow);
	      if (this.props.cellEdit && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_NONE) {
	        selectRow.clickToSelect = false;
	      }
	
	      var _props$options$toolba = this.props.options.toolbarPosition,
	          toolbarPosition = _props$options$toolba === undefined ? _Const2.default.TOOLBAR_POS_TOP : _props$options$toolba;
	
	      var showToolbarOnTop = toolbarPosition !== _Const2.default.TOOLBAR_POS_BOTTOM;
	      var showToolbarOnBottom = toolbarPosition !== _Const2.default.TOOLBAR_POS_TOP;
	      var _props$options$hideRo = this.props.options.hideRowOnExpand,
	          hideRowOnExpand = _props$options$hideRo === undefined ? false : _props$options$hideRo;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('react-bs-table-container', this.props.className, this.props.containerClass),
	          style: this.props.containerStyle },
	        showToolbarOnTop ? toolBar : null,
	        showPaginationOnTop ? pagination : null,
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(node) {
	              return _this5.table = node;
	            },
	            className: (0, _classnames2.default)('react-bs-table', { 'react-bs-table-bordered': this.props.bordered }, this.props.tableContainerClass),
	            style: _extends({}, style, this.props.tableStyle),
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave },
	          _react2.default.createElement(
	            _TableHeader2.default,
	            {
	              ref: function ref(node) {
	                return _this5.header = node;
	              },
	              version: this.props.version,
	              colGroups: colGroups,
	              headerContainerClass: this.props.headerContainerClass,
	              tableHeaderClass: this.props.tableHeaderClass,
	              style: this.props.headerStyle,
	              rowSelectType: this.props.selectRow.mode,
	              customComponent: this.props.selectRow.customComponent,
	              hideSelectColumn: this.props.selectRow.hideSelectColumn,
	              sortList: sortList,
	              sortIndicator: sortIndicator,
	              onSort: this.handleSort,
	              onSelectAllRow: this.handleSelectAllRow,
	              bordered: this.props.bordered,
	              condensed: this.props.condensed,
	              isFiltered: this.filter ? true : false,
	              isSelectAll: isSelectAll,
	              reset: this.state.reset,
	              expandColumnVisible: expandColumnOptions.expandColumnVisible,
	              expandColumnComponent: expandColumnOptions.expandColumnComponent,
	              expandedColumnHeaderComponent: expandColumnOptions.expandedColumnHeaderComponent,
	              noAnyExpand: this.state.expanding.length === 0,
	              expandAll: this.props.options.expandAll,
	              toggleExpandAllChilds: this.toggleExpandAllChilds,
	              expandColumnBeforeSelectColumn: expandColumnOptions.expandColumnBeforeSelectColumn },
	            this.props.children
	          ),
	          _react2.default.createElement(_TableBody2.default, {
	            ref: function ref(node) {
	              return _this5.body = node;
	            },
	            bodyContainerClass: this.props.bodyContainerClass,
	            tableBodyClass: this.props.tableBodyClass,
	            style: _extends({}, style, this.props.bodyStyle),
	            data: this.state.data,
	            version: this.props.version,
	            expandComponent: this.props.expandComponent,
	            expandableRow: this.props.expandableRow,
	            expandRowBgColor: this.props.options.expandRowBgColor,
	            expandBy: this.props.options.expandBy || _Const2.default.EXPAND_BY_ROW,
	            expandBodyClass: this.props.options.expandBodyClass,
	            expandParentClass: this.props.options.expandParentClass,
	            columns: columns,
	            trClassName: this.props.trClassName,
	            trStyle: this.props.trStyle,
	            striped: this.props.striped,
	            bordered: this.props.bordered,
	            hover: this.props.hover,
	            keyField: this.store.getKeyField(),
	            condensed: this.props.condensed,
	            selectRow: selectRow,
	            expandColumnOptions: this.props.expandColumnOptions,
	            cellEdit: this.props.cellEdit,
	            selectedRowKeys: this.state.selectedRowKeys,
	            onRowClick: this.handleRowClick,
	            onRowDoubleClick: this.handleRowDoubleClick,
	            onRowMouseOver: this.handleRowMouseOver,
	            onRowMouseOut: this.handleRowMouseOut,
	            onSelectRow: this.handleSelectRow,
	            noDataText: this.props.options.noDataText,
	            withoutNoDataText: this.props.options.withoutNoDataText,
	            expanding: this.state.expanding,
	            onExpand: this.handleExpandRow,
	            onlyOneExpanding: this.props.options.onlyOneExpanding,
	            beforeShowError: this.props.options.beforeShowError,
	            keyBoardNav: this.props.keyBoardNav,
	            onNavigateCell: this.handleNavigateCell,
	            x: this.state.x,
	            y: this.state.y,
	            withoutTabIndex: this.props.withoutTabIndex,
	            hideRowOnExpand: hideRowOnExpand,
	            onEditCell: this.handleEditCell }),
	          tableFooter
	        ),
	        tableFilter,
	        showPaginationOnBottom ? pagination : null,
	        showToolbarOnBottom ? toolBar : null,
	        this.props.renderAlert ? _react2.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } }) : null
	      );
	    }
	  }, {
	    key: 'isSelectAll',
	    value: function isSelectAll() {
	      if (this.store.isEmpty()) return false;
	      var _props$selectRow = this.props.selectRow,
	          unselectable = _props$selectRow.unselectable,
	          onlyUnselectVisible = _props$selectRow.onlyUnselectVisible;
	
	      var keyField = this.store.getKeyField();
	      var allRowKeys = onlyUnselectVisible ? this.store.get().map(function (r) {
	        return r[keyField];
	      }) : this.store.getAllRowkey();
	      var defaultSelectRowKeys = this.store.getSelectedRowKeys();
	
	      if (onlyUnselectVisible) {
	        defaultSelectRowKeys = defaultSelectRowKeys.filter(function (x) {
	          return x !== allRowKeys;
	        });
	      }
	
	      if (defaultSelectRowKeys.length === 0) return false;
	      var match = 0;
	      var noFound = 0;
	      var unSelectableCnt = 0;
	      defaultSelectRowKeys.forEach(function (selected) {
	        if (allRowKeys.indexOf(selected) !== -1) match++;else noFound++;
	        if (unselectable && unselectable.indexOf(selected) !== -1) unSelectableCnt++;
	      });
	
	      if (noFound === defaultSelectRowKeys.length) return false;
	      if (match === allRowKeys.length) {
	        return true;
	      } else {
	        if (unselectable && match <= unSelectableCnt && unSelectableCnt === unselectable.length) return false;else return 'indeterminate';
	      }
	      // return (match === allRowKeys.length) ? true : 'indeterminate';
	    }
	  }, {
	    key: 'cleanSelected',
	    value: function cleanSelected() {
	      this.store.setSelectedRowKey([]);
	      this.setState(function () {
	        return {
	          selectedRowKeys: [],
	          reset: false
	        };
	      });
	    }
	  }, {
	    key: 'cleanSort',
	    value: function cleanSort() {
	      this.store.cleanSortInfo();
	      this.setState(function () {
	        return {
	          reset: false
	        };
	      });
	    }
	  }, {
	    key: '__handleSort__REACT_HOT_LOADER__',
	    value: function __handleSort__REACT_HOT_LOADER__(order, sortField) {
	      var _props2 = this.props,
	          sort = _props2.autoCollapse.sort,
	          options = _props2.options;
	
	      if (options.onSortChange) {
	        options.onSortChange(sortField, order, this.props);
	      }
	      this.store.setSortInfo(order, sortField);
	      if (this.allowRemote(_Const2.default.REMOTE_SORT)) {
	        if (sort) {
	          this.setState(function () {
	            return {
	              expanding: []
	            };
	          });
	        }
	        return;
	      }
	
	      var result = this.store.sort().get();
	      this.setState(function () {
	        var newState = {
	          data: result,
	          reset: false
	        };
	        if (sort) newState.expanding = [];
	        return newState;
	      });
	    }
	  }, {
	    key: '__handleExpandRow__REACT_HOT_LOADER__',
	    value: function __handleExpandRow__REACT_HOT_LOADER__(expanding, rowKey, isRowExpanding, event) {
	      var _this6 = this;
	
	      var onExpand = this.props.options.onExpand;
	
	      if (onExpand) {
	        onExpand(rowKey, !isRowExpanding, event);
	      }
	      this.setState(function () {
	        return { expanding: expanding, reset: false };
	      }, function () {
	        _this6._adjustHeaderWidth();
	      });
	    }
	  }, {
	    key: 'toggleExpandAllChilds',
	    value: function toggleExpandAllChilds() {
	      var _this7 = this;
	
	      var expanding = this.state.expanding;
	
	      if (expanding.length > 0) {
	        this.setState(function () {
	          return {
	            expanding: [],
	            reset: false
	          };
	        });
	      } else {
	        this.setState(function () {
	          return {
	            expanding: _this7.store.getAllRowkey(),
	            reset: false
	          };
	        });
	      }
	    }
	  }, {
	    key: '__handlePaginationData__REACT_HOT_LOADER__',
	    value: function __handlePaginationData__REACT_HOT_LOADER__(page, sizePerPage) {
	      var _props$options = this.props.options,
	          onPageChange = _props$options.onPageChange,
	          pageStartIndex = _props$options.pageStartIndex;
	
	      var emptyTable = this.store.isEmpty();
	      if (onPageChange) {
	        onPageChange(page, sizePerPage);
	      }
	
	      var state = {
	        sizePerPage: sizePerPage,
	        reset: false
	      };
	      if (!emptyTable) state.currPage = page;
	      this.setState(function () {
	        return state;
	      });
	
	      if (this.allowRemote(_Const2.default.REMOTE_PAGE) || emptyTable) {
	        return;
	      }
	
	      var result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, page), sizePerPage).get();
	      this.setState(function () {
	        return { data: result, reset: false };
	      });
	    }
	  }, {
	    key: '__handleMouseLeave__REACT_HOT_LOADER__',
	    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
	      if (this.props.options.onMouseLeave) {
	        this.props.options.onMouseLeave();
	      }
	    }
	  }, {
	    key: '__handleMouseEnter__REACT_HOT_LOADER__',
	    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
	      if (this.props.options.onMouseEnter) {
	        this.props.options.onMouseEnter();
	      }
	    }
	  }, {
	    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOut__REACT_HOT_LOADER__(row, event) {
	      if (this.props.options.onRowMouseOut) {
	        this.props.options.onRowMouseOut(row, event);
	      }
	    }
	  }, {
	    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOver__REACT_HOT_LOADER__(row, event) {
	      if (this.props.options.onRowMouseOver) {
	        this.props.options.onRowMouseOver(row, event);
	      }
	    }
	  }, {
	    key: '__handleNavigateCell__REACT_HOT_LOADER__',
	    value: function __handleNavigateCell__REACT_HOT_LOADER__(_ref4) {
	      var offSetX = _ref4.x,
	          offSetY = _ref4.y,
	          lastEditCell = _ref4.lastEditCell;
	      var pagination = this.props.pagination;
	      var _state = this.state,
	          x = _state.x,
	          y = _state.y,
	          currPage = _state.currPage;
	
	      x += offSetX;
	      y += offSetY;
	
	      var columns = this.store.getColInfos();
	      var visibleRowSize = this.state.data.length;
	      var visibleColumnSize = Object.keys(columns).filter(function (k) {
	        return !columns[k].hidden;
	      }).length;
	
	      if (y >= visibleRowSize) {
	        currPage++;
	        var lastPage = pagination ? this.pagination.getLastPage() : -1;
	        if (currPage <= lastPage) {
	          this.handlePaginationData(currPage, this.state.sizePerPage);
	        } else {
	          return;
	        }
	        y = 0;
	      } else if (y < 0) {
	        currPage--;
	        if (currPage > 0) {
	          this.handlePaginationData(currPage, this.state.sizePerPage);
	        } else {
	          return;
	        }
	        y = visibleRowSize - 1;
	      } else if (x >= visibleColumnSize) {
	        if (y + 1 === visibleRowSize) {
	          currPage++;
	          var _lastPage = pagination ? this.pagination.getLastPage() : -1;
	          if (currPage <= _lastPage) {
	            this.handlePaginationData(currPage, this.state.sizePerPage);
	          } else {
	            return;
	          }
	          y = 0;
	        } else {
	          y++;
	        }
	        x = lastEditCell ? 1 : 0;
	      } else if (x < 0) {
	        x = visibleColumnSize - 1;
	        if (y === 0) {
	          currPage--;
	          if (currPage > 0) {
	            this.handlePaginationData(currPage, this.state.sizePerPage);
	          } else {
	            return;
	          }
	          y = this.state.sizePerPage - 1;
	        } else {
	          y--;
	        }
	      }
	      this.setState(function () {
	        return {
	          x: x, y: y, currPage: currPage, reset: false
	        };
	      });
	    }
	  }, {
	    key: '__handleRowClick__REACT_HOT_LOADER__',
	    value: function __handleRowClick__REACT_HOT_LOADER__(row, rowIndex, columnIndex, event) {
	      var _props3 = this.props,
	          options = _props3.options,
	          keyBoardNav = _props3.keyBoardNav;
	
	      if (options.onRowClick) {
	        options.onRowClick(row, columnIndex, rowIndex, event);
	      }
	      if (keyBoardNav) {
	        var _ref5 = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav : {},
	            clickToNav = _ref5.clickToNav;
	
	        clickToNav = clickToNav === false ? clickToNav : true;
	        if (clickToNav) {
	          this.setState(function () {
	            return {
	              x: columnIndex,
	              y: rowIndex,
	              reset: false
	            };
	          });
	        }
	      }
	    }
	  }, {
	    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
	    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(row, event) {
	      if (this.props.options.onRowDoubleClick) {
	        this.props.options.onRowDoubleClick(row, event);
	      }
	    }
	  }, {
	    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
	    value: function __handleSelectAllRow__REACT_HOT_LOADER__(e) {
	      var isSelected = e.currentTarget.checked;
	      var keyField = this.store.getKeyField();
	      var _props$selectRow2 = this.props.selectRow,
	          onSelectAll = _props$selectRow2.onSelectAll,
	          unselectable = _props$selectRow2.unselectable,
	          selected = _props$selectRow2.selected,
	          onlyUnselectVisible = _props$selectRow2.onlyUnselectVisible;
	
	      var selectedRowKeys = onlyUnselectVisible ? this.state.selectedRowKeys : [];
	      var result = true;
	      var rows = this.store.get();
	
	      // onlyUnselectVisible default is false, #1276
	      if (!isSelected && !onlyUnselectVisible) {
	        rows = this.store.getRowByKey(this.state.selectedRowKeys);
	      }
	
	      if (unselectable && unselectable.length > 0) {
	        if (isSelected) {
	          rows = rows.filter(function (r) {
	            return unselectable.indexOf(r[keyField]) === -1 || selected && selected.indexOf(r[keyField]) !== -1;
	          });
	        } else {
	          rows = rows.filter(function (r) {
	            return unselectable.indexOf(r[keyField]) === -1;
	          });
	        }
	      }
	
	      if (onSelectAll) {
	        result = this.props.selectRow.onSelectAll(isSelected, rows);
	      }
	
	      if (typeof result == 'undefined' || result !== false) {
	        if (isSelected) {
	          if (Array.isArray(result)) {
	            selectedRowKeys = result;
	          } else {
	            var currentRowKeys = rows.map(function (r) {
	              return r[keyField];
	            });
	            // onlyUnselectVisible default is false, #1276
	            if (onlyUnselectVisible) {
	              selectedRowKeys = selectedRowKeys.concat(currentRowKeys);
	            } else {
	              selectedRowKeys = currentRowKeys;
	            }
	          }
	        } else {
	          if (unselectable && selected) {
	            selectedRowKeys = selected.filter(function (r) {
	              return unselectable.indexOf(r) > -1;
	            });
	          } else if (onlyUnselectVisible) {
	            var _currentRowKeys = rows.map(function (r) {
	              return r[keyField];
	            });
	            selectedRowKeys = selectedRowKeys.filter(function (k) {
	              return _currentRowKeys.indexOf(k) === -1;
	            });
	          }
	        }
	
	        this.store.setSelectedRowKey(selectedRowKeys);
	        this.setState(function () {
	          return { selectedRowKeys: selectedRowKeys, reset: false };
	        });
	      }
	    }
	  }, {
	    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
	    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
	      this.store.ignoreNonSelected();
	      var pageStartIndex = this.props.options.pageStartIndex;
	
	      var result = void 0;
	      if (this.props.pagination) {
	        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), this.state.sizePerPage).get();
	      } else {
	        result = this.store.get();
	      }
	      this.setState(function () {
	        return {
	          data: result,
	          reset: false,
	          currPage: _util2.default.getFirstPage(pageStartIndex)
	        };
	      });
	    }
	  }, {
	    key: '__handleSelectRow__REACT_HOT_LOADER__',
	    value: function __handleSelectRow__REACT_HOT_LOADER__(row, isSelected, e, rowIndex) {
	      var result = true;
	      var currSelected = this.store.getSelectedRowKeys();
	      var rowKey = row[this.store.getKeyField()];
	      var selectRow = this.props.selectRow;
	
	      if (selectRow.onSelect) {
	        result = selectRow.onSelect(row, isSelected, e, rowIndex);
	      }
	
	      if (typeof result === 'undefined' || result !== false) {
	        if (selectRow.mode === _Const2.default.ROW_SELECT_SINGLE) {
	          currSelected = isSelected ? [rowKey] : [];
	        } else {
	          if (isSelected) {
	            currSelected.push(rowKey);
	          } else {
	            currSelected = currSelected.filter(function (key) {
	              return rowKey !== key;
	            });
	          }
	        }
	
	        this.store.setSelectedRowKey(currSelected);
	        this.setState(function () {
	          return {
	            selectedRowKeys: currSelected,
	            reset: false
	          };
	        });
	      }
	    }
	  }, {
	    key: '__handleEditCell__REACT_HOT_LOADER__',
	    value: function __handleEditCell__REACT_HOT_LOADER__(newVal, rowIndex, colIndex) {
	      var _this8 = this;
	
	      var beforeSaveCell = this.props.cellEdit.beforeSaveCell;
	
	      var columns = this.getColumnsDescription(this.props);
	      var fieldName = columns[colIndex].name;
	
	      var invalid = function invalid() {
	        _this8.setState(function () {
	          return {
	            data: _this8.store.get(),
	            reset: false
	          };
	        });
	        return;
	      };
	
	      if (beforeSaveCell) {
	        var beforeSaveCellCB = function beforeSaveCellCB(result) {
	          _this8.body.cancelEditCell();
	          if (result || result === undefined) {
	            _this8.editCell(newVal, rowIndex, colIndex);
	          } else {
	            invalid();
	          }
	        };
	        var props = { rowIndex: rowIndex, colIndex: colIndex };
	        var isValid = beforeSaveCell(this.state.data[rowIndex], fieldName, newVal, beforeSaveCellCB, props);
	        if (isValid === false && typeof isValid !== 'undefined') {
	          return invalid();
	        } else if (isValid === _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
	          /* eslint consistent-return: 0 */
	          return isValid;
	        }
	      }
	      this.editCell(newVal, rowIndex, colIndex);
	    }
	  }, {
	    key: 'editCell',
	    value: function editCell(newVal, rowIndex, colIndex) {
	      var onCellEdit = this.props.options.onCellEdit;
	      var afterSaveCell = this.props.cellEdit.afterSaveCell;
	
	      var columns = this.getColumnsDescription(this.props);
	      var fieldName = columns[colIndex].name;
	      var props = { rowIndex: rowIndex, colIndex: colIndex };
	      if (onCellEdit) {
	        newVal = onCellEdit(this.state.data[rowIndex], fieldName, newVal);
	      }
	
	      if (this.allowRemote(_Const2.default.REMOTE_CELL_EDIT)) {
	        if (afterSaveCell) {
	          afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
	        }
	        return;
	      }
	
	      var result = this.store.edit(newVal, rowIndex, fieldName).get();
	      this.setState(function () {
	        return {
	          data: result,
	          reset: false
	        };
	      });
	
	      if (afterSaveCell) {
	        afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
	      }
	    }
	  }, {
	    key: 'handleAddRowAtBegin',
	    value: function handleAddRowAtBegin(newObj) {
	      try {
	        this.store.addAtBegin(newObj);
	      } catch (e) {
	        return e;
	      }
	      this._handleAfterAddingRow(newObj, true);
	    }
	  }, {
	    key: '__handleAddRow__REACT_HOT_LOADER__',
	    value: function __handleAddRow__REACT_HOT_LOADER__(newObj) {
	      var _this9 = this;
	
	      var isAsync = false;
	      var onAddRow = this.props.options.onAddRow;
	
	
	      var afterHandleAddRow = function afterHandleAddRow(errMsg) {
	        if (isAsync) {
	          _this9.toolbar.afterHandleSaveBtnClick(errMsg);
	        } else {
	          return errMsg;
	        }
	      };
	
	      var afterAddRowCB = function afterAddRowCB(errMsg) {
	        if (typeof errMsg !== 'undefined' && errMsg !== '') return afterHandleAddRow(errMsg);
	        if (_this9.allowRemote(_Const2.default.REMOTE_INSERT_ROW)) {
	          if (_this9.props.options.afterInsertRow) {
	            _this9.props.options.afterInsertRow(newObj);
	          }
	          return afterHandleAddRow();
	        }
	
	        try {
	          _this9.store.add(newObj);
	        } catch (e) {
	          return afterHandleAddRow(e.message);
	        }
	        _this9._handleAfterAddingRow(newObj, false);
	        return afterHandleAddRow();
	      };
	
	      if (onAddRow) {
	        var colInfos = this.store.getColInfos();
	        var errMsg = onAddRow(newObj, colInfos, afterAddRowCB);
	
	        if (errMsg !== '' && errMsg !== false) {
	          return errMsg;
	        } else if (typeof errMsg === 'undefined') {
	          return afterAddRowCB();
	        } else {
	          isAsync = true;
	          return !isAsync;
	        }
	      } else {
	        return afterAddRowCB();
	      }
	    }
	  }, {
	    key: 'getSizePerPage',
	    value: function getSizePerPage() {
	      return this.state.sizePerPage;
	    }
	  }, {
	    key: 'getCurrentPage',
	    value: function getCurrentPage() {
	      return this.state.currPage;
	    }
	  }, {
	    key: 'getTableDataIgnorePaging',
	    value: function getTableDataIgnorePaging() {
	      return this.store.getCurrentDisplayData();
	    }
	  }, {
	    key: '__getPageByRowKey__REACT_HOT_LOADER__',
	    value: function __getPageByRowKey__REACT_HOT_LOADER__(rowKey) {
	      var sizePerPage = this.state.sizePerPage;
	
	      var currentData = this.store.getCurrentDisplayData();
	      var keyField = this.store.getKeyField();
	      var result = currentData.findIndex(function (x) {
	        return x[keyField] === rowKey;
	      });
	      if (result > -1) {
	        return parseInt(result / sizePerPage, 10) + 1;
	      } else {
	        return result;
	      }
	    }
	  }, {
	    key: '__handleDropRow__REACT_HOT_LOADER__',
	    value: function __handleDropRow__REACT_HOT_LOADER__(rowKeys) {
	      var _this10 = this;
	
	      var dropRowKeys = rowKeys ? rowKeys : this.store.getSelectedRowKeys();
	      // add confirm before the delete action if that option is set.
	      if (dropRowKeys && dropRowKeys.length > 0) {
	        if (this.props.options.handleConfirmDeleteRow) {
	          this.props.options.handleConfirmDeleteRow(function () {
	            _this10.deleteRow(dropRowKeys);
	          }, dropRowKeys);
	        } else if (confirm('Are you sure you want to delete?')) {
	          this.deleteRow(dropRowKeys);
	        }
	      }
	    }
	  }, {
	    key: 'deleteRow',
	    value: function deleteRow(dropRowKeys) {
	      var _this11 = this;
	
	      var dropRow = this.store.getRowByKey(dropRowKeys);
	      var _props$options2 = this.props.options,
	          onDeleteRow = _props$options2.onDeleteRow,
	          afterDeleteRow = _props$options2.afterDeleteRow,
	          pageStartIndex = _props$options2.pageStartIndex;
	
	
	      if (onDeleteRow) {
	        onDeleteRow(dropRowKeys, dropRow);
	      }
	
	      this.store.setSelectedRowKey([]); // clear selected row key
	
	      if (this.allowRemote(_Const2.default.REMOTE_DROP_ROW)) {
	        if (afterDeleteRow) {
	          afterDeleteRow(dropRowKeys, dropRow);
	        }
	        return;
	      }
	
	      this.store.remove(dropRowKeys); // remove selected Row
	      var result = void 0;
	      if (this.props.pagination) {
	        // debugger;
	        var sizePerPage = this.state.sizePerPage;
	
	        var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
	        var currPage = this.state.currPage;
	
	        if (currPage > currLastPage) currPage = currLastPage;
	        // console.log(Util.getNormalizedPage(currPage));
	        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, currPage), sizePerPage).get();
	        this.setState(function () {
	          return {
	            data: result,
	            selectedRowKeys: _this11.store.getSelectedRowKeys(),
	            currPage: currPage,
	            reset: false
	          };
	        });
	      } else {
	        result = this.store.get();
	        this.setState(function () {
	          return {
	            data: result,
	            reset: false,
	            selectedRowKeys: _this11.store.getSelectedRowKeys()
	          };
	        });
	      }
	      if (afterDeleteRow) {
	        afterDeleteRow(dropRowKeys, dropRow);
	      }
	    }
	  }, {
	    key: '__handleFilterData__REACT_HOT_LOADER__',
	    value: function __handleFilterData__REACT_HOT_LOADER__(filterObj) {
	      var _props4 = this.props,
	          filter = _props4.autoCollapse.filter,
	          options = _props4.options;
	      var onFilterChange = options.onFilterChange,
	          pageStartIndex = options.pageStartIndex;
	
	      if (onFilterChange) {
	        var colInfos = this.store.getColInfos();
	        onFilterChange(filterObj, colInfos);
	      }
	
	      this.setState(function () {
	        var newState = {
	          currPage: _util2.default.getFirstPage(pageStartIndex),
	          reset: false
	        };
	        if (filter) newState.expanding = [];
	        return newState;
	      });
	
	      if (this.allowRemote(_Const2.default.REMOTE_FILTER)) {
	        if (this.props.options.afterColumnFilter) {
	          this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
	        }
	        return;
	      }
	
	      this.store.filter(filterObj);
	
	      var sortList = this.store.getSortInfo();
	
	      if (sortList.length > 0) {
	        this.store.sort();
	      }
	
	      var result = void 0;
	
	      if (this.props.pagination) {
	        var sizePerPage = this.state.sizePerPage;
	
	        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
	      } else {
	        result = this.store.get();
	      }
	      if (this.props.options.afterColumnFilter) {
	        this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
	      }
	      this.setState(function () {
	        return {
	          data: result,
	          reset: false
	        };
	      });
	    }
	  }, {
	    key: '__handleExportCSV__REACT_HOT_LOADER__',
	    value: function __handleExportCSV__REACT_HOT_LOADER__() {
	      var result = {};
	
	      var csvFileName = this.props.csvFileName;
	      var _props$options3 = this.props.options,
	          onExportToCSV = _props$options3.onExportToCSV,
	          exportCSVSeparator = _props$options3.exportCSVSeparator,
	          noAutoBOM = _props$options3.noAutoBOM,
	          excludeCSVHeader = _props$options3.excludeCSVHeader;
	
	      if (onExportToCSV) {
	        result = onExportToCSV();
	      } else {
	        result = this.store.getDataIgnoringPagination();
	      }
	      var separator = exportCSVSeparator || _Const2.default.DEFAULT_CSV_SEPARATOR;
	      var keys = [];
	      this.props.children.filter(function (_) {
	        return _ != null;
	      }).map(function (column) {
	        if (column.props.export === true || typeof column.props.export === 'undefined' && column.props.hidden === false) {
	          keys.push({
	            field: column.props.dataField,
	            type: column.props.csvFieldType,
	            format: column.props.csvFormat,
	            extraData: column.props.csvFormatExtraData,
	            header: column.props.csvHeader || column.props.dataField,
	            row: Number(column.props.row) || 0,
	            rowSpan: Number(column.props.rowSpan) || 1,
	            colSpan: Number(column.props.colSpan) || 1
	          });
	        }
	      });
	
	      if (_util2.default.isFunction(csvFileName)) {
	        csvFileName = csvFileName();
	      }
	
	      (0, _csv_export_util2.default)(result, keys, csvFileName, separator, noAutoBOM, excludeCSVHeader);
	    }
	  }, {
	    key: '__handleSearch__REACT_HOT_LOADER__',
	    value: function __handleSearch__REACT_HOT_LOADER__(searchText) {
	      // Set search field if this function being called outside
	      // but it's not necessary if calling fron inside.
	      if (this.toolbar) {
	        this.toolbar.setSearchInput(searchText);
	      }
	      var search = this.props.autoCollapse.search;
	      var _props$options4 = this.props.options,
	          onSearchChange = _props$options4.onSearchChange,
	          pageStartIndex = _props$options4.pageStartIndex;
	
	      if (onSearchChange) {
	        var colInfos = this.store.getColInfos();
	        onSearchChange(searchText, colInfos, this.props.multiColumnSearch);
	      }
	
	      this.setState(function () {
	        var newState = {
	          currPage: _util2.default.getFirstPage(pageStartIndex),
	          reset: false
	        };
	        if (search) newState.expanding = [];
	        return newState;
	      });
	
	      if (this.allowRemote(_Const2.default.REMOTE_SEARCH)) {
	        if (this.props.options.afterSearch) {
	          this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
	        }
	        return;
	      }
	
	      this.store.search(searchText);
	
	      var sortList = this.store.getSortInfo();
	
	      if (sortList.length > 0) {
	        this.store.sort();
	      }
	
	      var result = void 0;
	      if (this.props.pagination) {
	        var sizePerPage = this.state.sizePerPage;
	
	        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
	      } else {
	        result = this.store.get();
	      }
	      if (this.props.options.afterSearch) {
	        this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
	      }
	      this.setState(function () {
	        return {
	          data: result,
	          reset: false
	        };
	      });
	    }
	  }, {
	    key: 'renderPagination',
	    value: function renderPagination() {
	      var _this12 = this;
	
	      if (this.props.pagination) {
	        var dataSize = void 0;
	        if (this.allowRemote(_Const2.default.REMOTE_PAGE)) {
	          dataSize = this.props.fetchInfo.dataTotalSize;
	        } else {
	          dataSize = this.store.getDataNum();
	        }
	        var options = this.props.options;
	
	        var withFirstAndLast = options.withFirstAndLast === undefined ? true : options.withFirstAndLast;
	        if (Math.ceil(dataSize / this.state.sizePerPage) <= 1 && this.props.ignoreSinglePage) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'react-bs-table-pagination' },
	          _react2.default.createElement(_PaginationList2.default, {
	            ref: function ref(node) {
	              return _this12.pagination = node;
	            },
	            version: this.props.version,
	            withFirstAndLast: withFirstAndLast,
	            alwaysShowAllBtns: options.alwaysShowAllBtns,
	            currPage: this.state.currPage,
	            changePage: this.handlePaginationData,
	            sizePerPage: this.state.sizePerPage,
	            sizePerPageList: options.sizePerPageList || _Const2.default.SIZE_PER_PAGE_LIST,
	            pageStartIndex: options.pageStartIndex,
	            paginationShowsTotal: options.paginationShowsTotal,
	            paginationSize: options.paginationSize || _Const2.default.PAGINATION_SIZE,
	            dataSize: dataSize,
	            onSizePerPageList: options.onSizePerPageList,
	            prePage: options.prePage || _Const2.default.PRE_PAGE,
	            nextPage: options.nextPage || _Const2.default.NEXT_PAGE,
	            firstPage: options.firstPage || _Const2.default.FIRST_PAGE,
	            lastPage: options.lastPage || _Const2.default.LAST_PAGE,
	            prePageTitle: options.prePageTitle || _Const2.default.PRE_PAGE_TITLE,
	            nextPageTitle: options.nextPageTitle || _Const2.default.NEXT_PAGE_TITLE,
	            firstPageTitle: options.firstPageTitle || _Const2.default.FIRST_PAGE_TITLE,
	            lastPageTitle: options.lastPageTitle || _Const2.default.LAST_PAGE_TITLE,
	            hideSizePerPage: options.hideSizePerPage,
	            sizePerPageDropDown: options.sizePerPageDropDown,
	            hidePageListOnlyOnePage: options.hidePageListOnlyOnePage,
	            paginationPanel: options.paginationPanel,
	            keepSizePerPageState: options.keepSizePerPageState,
	            open: false })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderToolBar',
	    value: function renderToolBar() {
	      var _this13 = this;
	
	      var _props5 = this.props,
	          exportCSV = _props5.exportCSV,
	          selectRow = _props5.selectRow,
	          insertRow = _props5.insertRow,
	          deleteRow = _props5.deleteRow,
	          search = _props5.search,
	          children = _props5.children,
	          keyField = _props5.keyField;
	
	      var enableShowOnlySelected = selectRow && selectRow.showOnlySelected;
	      var print = typeof this.props.options.printToolBar === 'undefined' ? true : this.props.options.printToolBar;
	      if (enableShowOnlySelected || insertRow || deleteRow || search || exportCSV || this.props.options.searchPanel || this.props.options.btnGroup || this.props.options.toolBar) {
	        var columns = void 0;
	        if (Array.isArray(children)) {
	          columns = children.filter(function (_) {
	            return _ != null;
	          }).map(function (column, r) {
	            if (!column) return;
	            var props = column.props;
	
	            var isKey = props.isKey || keyField === props.dataField;
	            return {
	              isKey: isKey,
	              name: props.headerText || props.children,
	              field: props.dataField,
	              hiddenOnInsert: props.hiddenOnInsert,
	              keyValidator: props.keyValidator,
	              customInsertEditor: props.customInsertEditor,
	              // when you want same auto generate value and not allow edit, example ID field
	              autoValue: props.autoValue || false,
	              // for create editor, no params for column.editable() indicate that editor for new row
	              editable: props.editable && _util2.default.isFunction(props.editable === 'function') ? props.editable() : props.editable,
	              format: props.dataFormat ? function (value) {
	                return props.dataFormat(value, null, props.formatExtraData, r).replace(/<.*?>/g, '');
	              } : false
	            };
	          });
	        } else {
	          columns = [{
	            name: children.props.headerText || children.props.children,
	            field: children.props.dataField,
	            editable: children.props.editable,
	            customInsertEditor: children.props.customInsertEditor,
	            hiddenOnInsert: children.props.hiddenOnInsert,
	            keyValidator: children.props.keyValidator
	          }];
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'react-bs-table-tool-bar ' + (print ? '' : 'hidden-print') },
	          _react2.default.createElement(_ToolBar2.default, {
	            ref: function ref(node) {
	              return _this13.toolbar = node;
	            },
	            version: this.props.version,
	            defaultSearch: this.props.options.defaultSearch,
	            clearSearch: this.props.options.clearSearch,
	            searchPosition: this.props.options.searchPosition,
	            searchDelayTime: this.props.options.searchDelayTime,
	            enableInsert: insertRow,
	            enableDelete: deleteRow,
	            enableSearch: search,
	            enableExportCSV: exportCSV,
	            enableShowOnlySelected: enableShowOnlySelected,
	            columns: columns,
	            searchPlaceholder: this.props.searchPlaceholder,
	            exportCSVText: this.props.options.exportCSVText,
	            insertText: this.props.options.insertText,
	            deleteText: this.props.options.deleteText,
	            saveText: this.props.options.saveText,
	            closeText: this.props.options.closeText,
	            ignoreEditable: this.props.options.ignoreEditable,
	            onAddRow: this.handleAddRow,
	            onDropRow: this.handleDropRow,
	            onSearch: this.handleSearch,
	            onExportCSV: this.handleExportCSV,
	            onShowOnlySelected: this.handleShowOnlySelected,
	            insertModalHeader: this.props.options.insertModalHeader,
	            insertModalFooter: this.props.options.insertModalFooter,
	            insertModalBody: this.props.options.insertModalBody,
	            insertModal: this.props.options.insertModal,
	            insertBtn: this.props.options.insertBtn,
	            deleteBtn: this.props.options.deleteBtn,
	            showSelectedOnlyBtn: this.props.options.showSelectedOnlyBtn,
	            exportCSVBtn: this.props.options.exportCSVBtn,
	            clearSearchBtn: this.props.options.clearSearchBtn,
	            searchField: this.props.options.searchField,
	            searchPanel: this.props.options.searchPanel,
	            btnGroup: this.props.options.btnGroup,
	            toolBar: this.props.options.toolBar,
	            reset: this.state.reset,
	            isValidKey: this.store.isValidKey,
	            insertFailIndicator: this.props.options.insertFailIndicator || _Const2.default.INSERT_FAIL_INDICATOR })
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderTableFilter',
	    value: function renderTableFilter(columns) {
	      if (this.props.columnFilter) {
	        return _react2.default.createElement(_TableFilter2.default, { columns: columns,
	          rowSelectType: this.props.selectRow.mode,
	          onFilter: this.handleFilterData });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderTableFooter',
	    value: function renderTableFooter(footerData, footerFormatterReturnData, columns, colGroups) {
	      var _this14 = this;
	
	      if (this.props.footer) {
	        var hideSelectColumn = true;
	        var mode = this.props.selectRow.mode;
	
	        var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
	        if (isSelectRowDefined) {
	          hideSelectColumn = this.props.selectRow.hideSelectColumn;
	        }
	        return _react2.default.createElement(
	          _TableFooter2.default,
	          {
	            ref: function ref(node) {
	              return _this14.footer = node;
	            },
	            columns: columns,
	            colGroups: colGroups,
	            footerFormatterReturnData: footerFormatterReturnData,
	            tableFooterClass: this.props.tableFooterClass,
	            style: this.props.headerStyle,
	            hideSelectColumn: hideSelectColumn,
	            expandColumnVisible: this.props.expandColumnOptions.expandColumnVisible,
	            bordered: this.props.bordered,
	            condensed: this.props.condensed,
	            isFiltered: this.filter ? true : false,
	            showStickyColumn: this.props.showStickyColumn },
	          footerData
	        );
	      }
	      return null;
	    }
	  }, {
	    key: '___scrollTop__REACT_HOT_LOADER__',
	    value: function ___scrollTop__REACT_HOT_LOADER__() {
	      var scrollTop = this.props.scrollTop;
	
	      if (scrollTop === _Const2.default.SCROLL_TOP) {
	        this.body.container.scrollTop = 0;
	      } else if (scrollTop === _Const2.default.SCROLL_BOTTOM) {
	        this.body.container.scrollTop = this.body.container.scrollHeight;
	      } else if (typeof scrollTop === 'number' && !isNaN(scrollTop)) {
	        this.body.container.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: '___scrollHeader__REACT_HOT_LOADER__',
	    value: function ___scrollHeader__REACT_HOT_LOADER__(e) {
	      this.header.container.scrollLeft = e.currentTarget.scrollLeft;
	    }
	  }, {
	    key: '___scrollFooter__REACT_HOT_LOADER__',
	    value: function ___scrollFooter__REACT_HOT_LOADER__(e) {
	      if (this.props.footer) {
	        this.footer.container.scrollLeft = e.currentTarget.scrollLeft;
	      }
	    }
	  }, {
	    key: '_adjustTable',
	    value: function _adjustTable() {
	      this._adjustHeight();
	      if (!this.props.printable) {
	        this._adjustHeaderWidth();
	      }
	    }
	  }, {
	    key: '_adjustHeaderWidth',
	    value: function _adjustHeaderWidth() {
	      var header = this.header.getHeaderColGrouop();
	      var tbody = this.body.tbody;
	      var bodyHeader = this.body.getHeaderColGrouop();
	      var firstRow = tbody.childNodes[0];
	      var isScroll = tbody.parentNode.getBoundingClientRect().height > tbody.parentNode.parentNode.getBoundingClientRect().height;
	
	      var scrollBarWidth = isScroll ? _util2.default.getScrollBarWidth() : 0;
	      if (firstRow && this.store.getDataNum()) {
	        if (isScroll || this.isVerticalScroll !== isScroll) {
	          var cells = firstRow.childNodes;
	          for (var i = 0; i < cells.length; i++) {
	            var cell = cells[i];
	            var computedStyle = window.getComputedStyle(cell);
	            var width = parseFloat(computedStyle.width.replace('px', ''));
	            if (this.isIE) {
	              var paddingLeftWidth = parseFloat(computedStyle.paddingLeft.replace('px', ''));
	              var paddingRightWidth = parseFloat(computedStyle.paddingRight.replace('px', ''));
	              var borderRightWidth = parseFloat(computedStyle.borderRightWidth.replace('px', ''));
	              var borderLeftWidth = parseFloat(computedStyle.borderLeftWidth.replace('px', ''));
	              width = width + paddingLeftWidth + paddingRightWidth + borderRightWidth + borderLeftWidth;
	            }
	            var lastPadding = cells.length - 1 === i ? scrollBarWidth : 0;
	            if (width <= 0) {
	              width = 120;
	              cell.width = width + lastPadding + 'px';
	            }
	            var result = width + lastPadding + 'px';
	            header[i].style.width = result;
	            header[i].style.minWidth = result;
	            if (cells.length - 1 === i) {
	              bodyHeader[i].style.width = width + 'px';
	              bodyHeader[i].style.minWidth = width + 'px';
	            } else {
	              bodyHeader[i].style.width = result;
	              bodyHeader[i].style.minWidth = result;
	            }
	          }
	        }
	      } else {
	        for (var _i in bodyHeader) {
	          if (bodyHeader.hasOwnProperty(_i)) {
	            var child = bodyHeader[_i];
	            if (child.style) {
	              if (child.style.width) {
	                header[_i].style.width = child.style.width;
	              }
	              if (child.style.minWidth) {
	                header[_i].style.minWidth = child.style.minWidth;
	              }
	            }
	          }
	        }
	      }
	      this.isVerticalScroll = isScroll;
	    }
	  }, {
	    key: '_adjustHeight',
	    value: function _adjustHeight() {
	      var height = this.props.height;
	      var maxHeight = this.props.maxHeight;
	
	      if (typeof height === 'number' && !isNaN(height) || height.indexOf('%') === -1) {
	        this.body.container.style.height = parseFloat(height, 10) - this.header.container.offsetHeight + 'px';
	      }
	      if (maxHeight) {
	        maxHeight = typeof maxHeight === 'number' ? maxHeight : parseInt(maxHeight.replace('px', ''), 10);
	
	        this.body.container.style.maxHeight = maxHeight - this.header.container.offsetHeight + 'px';
	      }
	    }
	  }, {
	    key: '_handleAfterAddingRow',
	    value: function _handleAfterAddingRow(newObj, atTheBeginning) {
	      var result = void 0;
	      if (this.props.pagination) {
	        // if pagination is enabled and inserting row at the end,
	        // change page to the last page
	        // otherwise, change it to the first page
	        var sizePerPage = this.state.sizePerPage;
	
	
	        if (atTheBeginning) {
	          var pageStartIndex = this.props.options.pageStartIndex;
	
	          result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
	          this.setState(function () {
	            return {
	              data: result,
	              currPage: _util2.default.getFirstPage(pageStartIndex),
	              reset: false
	            };
	          });
	        } else {
	          var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
	          result = this.store.page(currLastPage, sizePerPage).get();
	          this.setState(function () {
	            return {
	              data: result,
	              currPage: currLastPage,
	              reset: false
	            };
	          });
	        }
	      } else {
	        result = this.store.get();
	        this.setState(function () {
	          return {
	            data: result,
	            reset: false
	          };
	        });
	      }
	
	      if (this.props.options.afterInsertRow) {
	        this.props.options.afterInsertRow(newObj);
	      }
	    }
	  }]);
	
	  return BootstrapTable;
	}(_react.Component);
	
	BootstrapTable.propTypes = {
	  keyField: _propTypes2.default.string,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	  version: _propTypes2.default.string, // bootstrap version
	  remote: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]), // remote data, default is false
	  replace: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	  scrollTop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  pagination: _propTypes2.default.bool,
	  printable: _propTypes2.default.bool,
	  withoutTabIndex: _propTypes2.default.bool,
	  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  searchPlaceholder: _propTypes2.default.string,
	  selectRow: _propTypes2.default.shape({
	    mode: _propTypes2.default.oneOf([_Const2.default.ROW_SELECT_NONE, _Const2.default.ROW_SELECT_SINGLE, _Const2.default.ROW_SELECT_MULTI]),
	    customComponent: _propTypes2.default.func,
	    bgColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    selected: _propTypes2.default.array,
	    onSelect: _propTypes2.default.func,
	    onSelectAll: _propTypes2.default.func,
	    clickToSelect: _propTypes2.default.bool,
	    hideSelectColumn: _propTypes2.default.bool,
	    clickToSelectAndEditCell: _propTypes2.default.bool,
	    clickToExpand: _propTypes2.default.bool,
	    showOnlySelected: _propTypes2.default.bool,
	    unselectable: _propTypes2.default.array,
	    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    onlyUnselectVisible: _propTypes2.default.bool
	  }),
	  cellEdit: _propTypes2.default.shape({
	    mode: _propTypes2.default.string,
	    blurToSave: _propTypes2.default.bool,
	    blurToEscape: _propTypes2.default.bool,
	    beforeSaveCell: _propTypes2.default.func,
	    afterSaveCell: _propTypes2.default.func,
	    nonEditableRows: _propTypes2.default.func
	  }),
	  insertRow: _propTypes2.default.bool,
	  deleteRow: _propTypes2.default.bool,
	  search: _propTypes2.default.bool,
	  multiColumnSearch: _propTypes2.default.bool,
	  strictSearch: _propTypes2.default.bool,
	  columnFilter: _propTypes2.default.bool,
	  trClassName: _propTypes2.default.any,
	  trStyle: _propTypes2.default.any,
	  tableStyle: _propTypes2.default.object,
	  containerStyle: _propTypes2.default.object,
	  headerStyle: _propTypes2.default.object,
	  bodyStyle: _propTypes2.default.object,
	  containerClass: _propTypes2.default.string,
	  tableContainerClass: _propTypes2.default.string,
	  headerContainerClass: _propTypes2.default.string,
	  bodyContainerClass: _propTypes2.default.string,
	  tableHeaderClass: _propTypes2.default.string,
	  tableBodyClass: _propTypes2.default.string,
	  tableFooterClass: _propTypes2.default.string,
	  options: _propTypes2.default.shape({
	    clearSearch: _propTypes2.default.bool,
	    sortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	    sortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	    defaultSortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	    defaultSortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	    sortIndicator: _propTypes2.default.bool,
	    afterTableComplete: _propTypes2.default.func,
	    afterDeleteRow: _propTypes2.default.func,
	    afterInsertRow: _propTypes2.default.func,
	    afterSearch: _propTypes2.default.func,
	    afterColumnFilter: _propTypes2.default.func,
	    onRowClick: _propTypes2.default.func,
	    onRowDoubleClick: _propTypes2.default.func,
	    page: _propTypes2.default.number,
	    pageStartIndex: _propTypes2.default.number,
	    paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	    sizePerPageList: _propTypes2.default.array,
	    sizePerPage: _propTypes2.default.number,
	    paginationSize: _propTypes2.default.number,
	    paginationPosition: _propTypes2.default.oneOf([_Const2.default.PAGINATION_POS_TOP, _Const2.default.PAGINATION_POS_BOTTOM, _Const2.default.PAGINATION_POS_BOTH]),
	    toolbarPosition: _propTypes2.default.oneOf([_Const2.default.TOOLBAR_POS_TOP, _Const2.default.TOOLBAR_POS_BOTTOM, _Const2.default.TOOLBAR_POS_BOTH]),
	    hideSizePerPage: _propTypes2.default.bool,
	    hidePageListOnlyOnePage: _propTypes2.default.bool,
	    alwaysShowAllBtns: _propTypes2.default.bool,
	    withFirstAndLast: _propTypes2.default.bool,
	    keepSizePerPageState: _propTypes2.default.bool,
	    onSortChange: _propTypes2.default.func,
	    onPageChange: _propTypes2.default.func,
	    onSizePerPageList: _propTypes2.default.func,
	    onFilterChange: _propTypes2.default.func,
	    onSearchChange: _propTypes2.default.func,
	    onAddRow: _propTypes2.default.func,
	    onExportToCSV: _propTypes2.default.func,
	    onCellEdit: _propTypes2.default.func,
	    noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    withoutNoDataText: _propTypes2.default.bool,
	    handleConfirmDeleteRow: _propTypes2.default.func,
	    prePage: _propTypes2.default.any,
	    nextPage: _propTypes2.default.any,
	    firstPage: _propTypes2.default.any,
	    lastPage: _propTypes2.default.any,
	    prePageTitle: _propTypes2.default.string,
	    nextPageTitle: _propTypes2.default.string,
	    firstPageTitle: _propTypes2.default.string,
	    lastPageTitle: _propTypes2.default.string,
	    searchDelayTime: _propTypes2.default.number,
	    excludeCSVHeader: _propTypes2.default.bool,
	    exportCSVText: _propTypes2.default.string,
	    exportCSVSeparator: _propTypes2.default.string,
	    insertText: _propTypes2.default.string,
	    deleteText: _propTypes2.default.string,
	    saveText: _propTypes2.default.string,
	    closeText: _propTypes2.default.string,
	    ignoreEditable: _propTypes2.default.bool,
	    defaultSearch: _propTypes2.default.string,
	    insertModalHeader: _propTypes2.default.func,
	    insertModalBody: _propTypes2.default.func,
	    insertModalFooter: _propTypes2.default.func,
	    insertModal: _propTypes2.default.func,
	    insertBtn: _propTypes2.default.func,
	    deleteBtn: _propTypes2.default.func,
	    showSelectedOnlyBtn: _propTypes2.default.func,
	    exportCSVBtn: _propTypes2.default.func,
	    clearSearchBtn: _propTypes2.default.func,
	    searchField: _propTypes2.default.func,
	    searchPanel: _propTypes2.default.func,
	    btnGroup: _propTypes2.default.func,
	    toolBar: _propTypes2.default.func,
	    sizePerPageDropDown: _propTypes2.default.func,
	    paginationPanel: _propTypes2.default.func,
	    searchPosition: _propTypes2.default.string,
	    expandRowBgColor: _propTypes2.default.string,
	    expandBy: _propTypes2.default.string,
	    expanding: _propTypes2.default.array,
	    onExpand: _propTypes2.default.func,
	    onlyOneExpanding: _propTypes2.default.bool,
	    expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	    beforeShowError: _propTypes2.default.func,
	    printToolBar: _propTypes2.default.bool,
	    insertFailIndicator: _propTypes2.default.string,
	    noAutoBOM: _propTypes2.default.bool,
	    expandAll: _propTypes2.default.bool,
	    hideRowOnExpand: _propTypes2.default.bool
	  }),
	  fetchInfo: _propTypes2.default.shape({
	    dataTotalSize: _propTypes2.default.number
	  }),
	  renderAlert: _propTypes2.default.bool,
	  exportCSV: _propTypes2.default.bool,
	  csvFileName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  ignoreSinglePage: _propTypes2.default.bool,
	  expandableRow: _propTypes2.default.func,
	  expandComponent: _propTypes2.default.func,
	  autoCollapse: _propTypes2.default.shape({
	    sort: _propTypes2.default.bool,
	    filter: _propTypes2.default.bool,
	    search: _propTypes2.default.bool
	  }),
	  expandColumnOptions: _propTypes2.default.shape({
	    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    expandColumnVisible: _propTypes2.default.bool,
	    expandColumnComponent: _propTypes2.default.func,
	    expandedColumnHeaderComponent: _propTypes2.default.func,
	    expandColumnBeforeSelectColumn: _propTypes2.default.bool
	  }),
	  footer: _propTypes2.default.bool
	};
	BootstrapTable.defaultProps = {
	  version: '3',
	  replace: false,
	  scrollTop: undefined,
	  expandComponent: undefined,
	  expandableRow: undefined,
	  expandColumnOptions: {
	    expandColumnVisible: false,
	    expandColumnComponent: undefined,
	    expandedColumnHeaderComponent: undefined,
	    expandColumnBeforeSelectColumn: true
	  },
	  height: '100%',
	  maxHeight: undefined,
	  striped: false,
	  bordered: true,
	  hover: false,
	  condensed: false,
	  pagination: false,
	  printable: false,
	  withoutTabIndex: false,
	  keyBoardNav: false,
	  searchPlaceholder: undefined,
	  selectRow: {
	    mode: _Const2.default.ROW_SELECT_NONE,
	    bgColor: _Const2.default.ROW_SELECT_BG_COLOR,
	    selected: [],
	    onSelect: undefined,
	    onSelectAll: undefined,
	    clickToSelect: false,
	    hideSelectColumn: false,
	    clickToSelectAndEditCell: false,
	    clickToExpand: false,
	    showOnlySelected: false,
	    unselectable: [],
	    customComponent: undefined,
	    onlyUnselectVisible: false
	  },
	  cellEdit: {
	    mode: _Const2.default.CELL_EDIT_NONE,
	    blurToSave: false,
	    blurToEscape: false,
	    beforeSaveCell: undefined,
	    afterSaveCell: undefined,
	    nonEditableRows: undefined
	  },
	  insertRow: false,
	  deleteRow: false,
	  search: false,
	  multiColumnSearch: false,
	  strictSearch: undefined,
	  multiColumnSort: 1,
	  columnFilter: false,
	  trClassName: '',
	  trStyle: undefined,
	  tableStyle: undefined,
	  containerStyle: undefined,
	  headerStyle: undefined,
	  bodyStyle: undefined,
	  containerClass: null,
	  tableContainerClass: null,
	  headerContainerClass: null,
	  bodyContainerClass: null,
	  tableHeaderClass: null,
	  tableBodyClass: null,
	  tableFooterClass: null,
	  options: {
	    clearSearch: false,
	    sortName: undefined,
	    sortOrder: undefined,
	    defaultSortName: undefined,
	    defaultSortOrder: undefined,
	    sortIndicator: true,
	    afterTableComplete: undefined,
	    afterDeleteRow: undefined,
	    afterInsertRow: undefined,
	    afterSearch: undefined,
	    afterColumnFilter: undefined,
	    onRowClick: undefined,
	    onRowDoubleClick: undefined,
	    onMouseLeave: undefined,
	    onMouseEnter: undefined,
	    onRowMouseOut: undefined,
	    onRowMouseOver: undefined,
	    page: undefined,
	    paginationShowsTotal: false,
	    sizePerPageList: _Const2.default.SIZE_PER_PAGE_LIST,
	    sizePerPage: undefined,
	    paginationSize: _Const2.default.PAGINATION_SIZE,
	    paginationPosition: _Const2.default.PAGINATION_POS_BOTTOM,
	    toolbarPosition: _Const2.default.TOOLBAR_POS_TOP,
	    hideSizePerPage: false,
	    hidePageListOnlyOnePage: false,
	    alwaysShowAllBtns: false,
	    withFirstAndLast: true,
	    keepSizePerPageState: false,
	    onSizePerPageList: undefined,
	    noDataText: undefined,
	    withoutNoDataText: false,
	    handleConfirmDeleteRow: undefined,
	    prePage: _Const2.default.PRE_PAGE,
	    nextPage: _Const2.default.NEXT_PAGE,
	    firstPage: _Const2.default.FIRST_PAGE,
	    lastPage: _Const2.default.LAST_PAGE,
	    prePageTitle: _Const2.default.PRE_PAGE_TITLE,
	    nextPageTitle: _Const2.default.NEXT_PAGE_TITLE,
	    firstPageTitle: _Const2.default.FIRST_PAGE_TITLE,
	    lastPageTitle: _Const2.default.LAST_PAGE_TITLE,
	    pageStartIndex: 1,
	    searchDelayTime: undefined,
	    excludeCSVHeader: false,
	    exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
	    exportCSVSeparator: _Const2.default.DEFAULT_CSV_SEPARATOR,
	    insertText: _Const2.default.INSERT_BTN_TEXT,
	    deleteText: _Const2.default.DELETE_BTN_TEXT,
	    saveText: _Const2.default.SAVE_BTN_TEXT,
	    closeText: _Const2.default.CLOSE_BTN_TEXT,
	    ignoreEditable: false,
	    defaultSearch: '',
	    insertModalHeader: undefined,
	    insertModalBody: undefined,
	    insertModalFooter: undefined,
	    insertModal: undefined,
	    insertBtn: undefined,
	    deleteBtn: undefined,
	    showSelectedOnlyBtn: undefined,
	    exportCSVBtn: undefined,
	    clearSearchBtn: undefined,
	    searchField: undefined,
	    searchPanel: undefined,
	    btnGroup: undefined,
	    toolBar: undefined,
	    sizePerPageDropDown: undefined,
	    paginationPanel: undefined,
	    searchPosition: 'right',
	    expandRowBgColor: undefined,
	    expandBy: _Const2.default.EXPAND_BY_ROW,
	    expanding: [],
	    onExpand: undefined,
	    onlyOneExpanding: false,
	    expandBodyClass: null,
	    expandParentClass: null,
	    beforeShowError: undefined,
	    printToolBar: true,
	    insertFailIndicator: _Const2.default.INSERT_FAIL_INDICATOR,
	    noAutoBOM: true,
	    expandAll: false,
	    hideRowOnExpand: false
	  },
	  fetchInfo: {
	    dataTotalSize: 0
	  },
	  renderAlert: true,
	  exportCSV: false,
	  csvFileName: 'spreadsheet.csv',
	  ignoreSinglePage: false,
	  autoCollapse: {
	    sort: _Const2.default.AUTO_COLLAPSE_WHEN_SORT,
	    filter: _Const2.default.AUTO_COLLAPSE_WHEN_FILTER,
	    search: _Const2.default.AUTO_COLLAPSE_WHEN_SEARCH
	  },
	  footer: false
	};
	
	var _default = BootstrapTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BootstrapTable, 'BootstrapTable', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');
	}();
	
	;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */
	/* eslint no-nested-ternary: 0 */
	
	
	var ExpandComponent = function (_Component) {
	  _inherits(ExpandComponent, _Component);
	
	  function ExpandComponent() {
	    _classCallCheck(this, ExpandComponent);
	
	    return _possibleConstructorReturn(this, (ExpandComponent.__proto__ || Object.getPrototypeOf(ExpandComponent)).apply(this, arguments));
	  }
	
	  _createClass(ExpandComponent, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      var trCss = {
	        style: {
	          backgroundColor: this.props.bgColor
	        },
	        className: (0, _classnames2.default)(className)
	      };
	      return _react2.default.createElement(
	        'tr',
	        _extends({ hidden: this.props.hidden, width: this.props.width }, trCss),
	        _react2.default.createElement(
	          'td',
	          { colSpan: this.props.colSpan },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ExpandComponent;
	}(_react.Component);
	
	var _default = ExpandComponent;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ExpandComponent, 'ExpandComponent', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');
	}();
	
	;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandRowHeaderColumn = function (_Component) {
	  _inherits(ExpandRowHeaderColumn, _Component);
	
	  function ExpandRowHeaderColumn(props) {
	    _classCallCheck(this, ExpandRowHeaderColumn);
	
	    var _this = _possibleConstructorReturn(this, (ExpandRowHeaderColumn.__proto__ || Object.getPrototypeOf(ExpandRowHeaderColumn)).call(this, props));
	
	    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpandRowHeaderColumn, [{
	    key: 'toggleExpandAllChilds',
	    value: function toggleExpandAllChilds() {
	      this.props.toggleExpandAllChilds();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
	          noAnyExpand = _props.noAnyExpand,
	          expandAll = _props.expandAll;
	
	      var expandedHeaderComponent = noAnyExpand ? _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' }) : _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' });
	      var ExpandedColumnHeaderComponent = expandedColumnHeaderComponent;
	
	      return _react2.default.createElement(
	        'th',
	        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
	          className: 'react-bs-table-expand-cell',
	          'data-is-only-head': false },
	        expandAll ? _react2.default.createElement(
	          'div',
	          { onClick: this.toggleExpandAllChilds },
	          expandedColumnHeaderComponent ? _react2.default.createElement(ExpandedColumnHeaderComponent, {
	            anyExpand: !noAnyExpand }) : expandedHeaderComponent
	        ) : null
	      );
	    }
	  }]);
	
	  return ExpandRowHeaderColumn;
	}(_react.Component);
	
	ExpandRowHeaderColumn.propTypes = {
	  expandedColumnHeaderComponent: _propTypes2.default.func,
	  rowCount: _propTypes2.default.number,
	  noAnyExpand: _propTypes2.default.bool,
	  expandAll: _propTypes2.default.bool,
	  toggleExpandAllChilds: _propTypes2.default.func
	};
	var _default = ExpandRowHeaderColumn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ExpandRowHeaderColumn, 'ExpandRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');
	}();
	
	;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Filter = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _events = __webpack_require__(1023);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filter = exports.Filter = function (_EventEmitter) {
	  _inherits(Filter, _EventEmitter);
	
	  function Filter(data) {
	    _classCallCheck(this, Filter);
	
	    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, data));
	
	    _this.currentFilter = {};
	    return _this;
	  }
	
	  _createClass(Filter, [{
	    key: 'handleFilter',
	    value: function handleFilter(dataField, value, type, filterObj) {
	      var filterType = type || _Const2.default.FILTER_TYPE.CUSTOM;
	
	      var props = {
	        cond: filterObj.condition // Only for select and text filter
	      };
	
	      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        // value of the filter is an object
	        var hasValue = true;
	        for (var prop in value) {
	          if (!value[prop] || value[prop] === '') {
	            hasValue = false;
	            break;
	          }
	        }
	        // if one of the object properties is undefined or empty, we remove the filter
	        if (hasValue) {
	          this.currentFilter[dataField] = { value: value, type: filterType, props: props };
	        } else {
	          delete this.currentFilter[dataField];
	        }
	      } else if (!value || value.trim() === '') {
	        delete this.currentFilter[dataField];
	      } else {
	        this.currentFilter[dataField] = { value: value.trim(), type: filterType, props: props };
	      }
	      this.emit('onFilterChange', this.currentFilter);
	    }
	  }]);
	
	  return Filter;
	}(_events.EventEmitter);
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Filter, 'Filter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Filter.js');
	}();
	
	;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectRowHeaderColumn = function (_Component) {
	  _inherits(SelectRowHeaderColumn, _Component);
	
	  function SelectRowHeaderColumn() {
	    _classCallCheck(this, SelectRowHeaderColumn);
	
	    return _possibleConstructorReturn(this, (SelectRowHeaderColumn.__proto__ || Object.getPrototypeOf(SelectRowHeaderColumn)).apply(this, arguments));
	  }
	
	  _createClass(SelectRowHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'th',
	        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
	          'data-is-only-head': false },
	        this.props.children
	      );
	    }
	  }]);
	
	  return SelectRowHeaderColumn;
	}(_react.Component);
	
	SelectRowHeaderColumn.propTypes = {
	  children: _propTypes2.default.node,
	  rowCount: _propTypes2.default.number
	};
	var _default = SelectRowHeaderColumn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SelectRowHeaderColumn, 'SelectRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');
	}();
	
	;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _TableRow = __webpack_require__(1174);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _TableColumn = __webpack_require__(1169);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	var _TableEditColumn = __webpack_require__(1170);
	
	var _TableEditColumn2 = _interopRequireDefault(_TableEditColumn);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ExpandComponent = __webpack_require__(1164);
	
	var _ExpandComponent2 = _interopRequireDefault(_ExpandComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableBody = function (_Component) {
	  _inherits(TableBody, _Component);
	
	  function TableBody(props) {
	    _classCallCheck(this, TableBody);
	
	    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));
	
	    _this.handleCellKeyDown = function () {
	      return _this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowMouseOut = function () {
	      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowMouseOver = function () {
	      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowClick = function () {
	      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRowDoubleClick = function () {
	      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSelectRow = function () {
	      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSelectRowColumChange = function () {
	      return _this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleClickCell = function () {
	      return _this.__handleClickCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleEditCell = function () {
	      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.nextEditableCell = function () {
	      return _this.__nextEditableCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleCompleteEditCell = function () {
	      return _this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.cancelEditCell = function () {
	      return _this.__cancelEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleClickonSelectColumn = function () {
	      return _this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.getHeaderColGrouop = function () {
	      return _this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      currEditCell: null
	    };
	    return _this;
	  }
	
	  _createClass(TableBody, [{
	    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
	    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
	      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
	    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__() {
	      return this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__cancelEditCell__REACT_HOT_LOADER__',
	    value: function __cancelEditCell__REACT_HOT_LOADER__() {
	      return this.__cancelEditCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
	    value: function __handleCompleteEditCell__REACT_HOT_LOADER__() {
	      return this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__nextEditableCell__REACT_HOT_LOADER__',
	    value: function __nextEditableCell__REACT_HOT_LOADER__() {
	      return this.__nextEditableCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleEditCell__REACT_HOT_LOADER__',
	    value: function __handleEditCell__REACT_HOT_LOADER__() {
	      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleClickCell__REACT_HOT_LOADER__',
	    value: function __handleClickCell__REACT_HOT_LOADER__() {
	      return this.__handleClickCell__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
	    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__() {
	      return this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSelectRow__REACT_HOT_LOADER__',
	    value: function __handleSelectRow__REACT_HOT_LOADER__() {
	      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
	    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
	      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowClick__REACT_HOT_LOADER__',
	    value: function __handleRowClick__REACT_HOT_LOADER__() {
	      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
	      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
	      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
	    value: function __handleCellKeyDown__REACT_HOT_LOADER__() {
	      return this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          cellEdit = _props.cellEdit,
	          beforeShowError = _props.beforeShowError,
	          x = _props.x,
	          y = _props.y,
	          keyBoardNav = _props.keyBoardNav,
	          trStyle = _props.trStyle,
	          version = _props.version;
	
	      var customTableClasses = {
	        'table-striped': this.props.striped,
	        'table-bordered': this.props.bordered,
	        'table-hover': this.props.hover
	      };
	      if (this.props.condensed) {
	        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
	      }
	      var tableClasses = (0, _classnames2.default)('table', customTableClasses, this.props.tableBodyClass);
	
	      var noneditableRows = cellEdit.nonEditableRows && cellEdit.nonEditableRows() || [];
	      var unselectable = this.props.selectRow.unselectable || [];
	      var isSelectRowDefined = _util2.default.isSelectRowDefined(this.props.selectRow.mode);
	      var tableHeader = _util2.default.renderColGroup(this.props.columns, this.props.selectRow, this.props.expandColumnOptions, version);
	      var inputType = this.props.selectRow.mode === _Const2.default.ROW_SELECT_SINGLE ? 'radio' : 'checkbox';
	      var CustomComponent = this.props.selectRow.customComponent;
	      var enableKeyBoardNav = keyBoardNav === true || (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object';
	      var customEditAndNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyleOnEditCell : null;
	      var customNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyle : null;
	      var ExpandColumnCustomComponent = this.props.expandColumnOptions.expandColumnComponent;
	      var expandColSpan = this.props.columns.filter(function (col) {
	        return col && !col.hidden;
	      }).length;
	      if (isSelectRowDefined && !this.props.selectRow.hideSelectColumn) {
	        expandColSpan += 1;
	      }
	      var tabIndex = 1;
	      if (this.props.expandColumnOptions.expandColumnVisible) {
	        expandColSpan += 1;
	      }
	
	      var tableRows = this.props.data.map(function (data, r) {
	        var tableColumns = this.props.columns.filter(function (_) {
	          return _ != null;
	        }).map(function (column, i) {
	          var fieldValue = data[column.name];
	          var isFocusCell = r === y && i === x;
	          if (column.name !== this.props.keyField && // Key field can't be edit
	          column.editable && // column is editable? default is true, user can set it false
	          column.editable.readOnly !== true && this.state.currEditCell !== null && this.state.currEditCell.rid === r && this.state.currEditCell.cid === i && noneditableRows.indexOf(data[this.props.keyField]) === -1) {
	            var editable = column.editable;
	            var format = column.format ? function (value) {
	              return column.format(value, data, column.formatExtraData, r).replace(/<.*?>/g, '');
	            } : false;
	            if (_util2.default.isFunction(column.editable)) {
	              editable = column.editable(fieldValue, data, r, i);
	            }
	
	            return _react2.default.createElement(_TableEditColumn2.default, {
	              completeEdit: this.handleCompleteEditCell
	              // add by bluespring for column editor customize
	              , editable: editable,
	              attrs: column.editAttrs,
	              customEditor: column.customEditor,
	              format: column.format ? format : false,
	              key: i,
	              blurToSave: cellEdit.blurToSave,
	              blurToEscape: cellEdit.blurToEscape,
	              onTab: this.handleEditCell,
	              rowIndex: r,
	              colIndex: i,
	              row: data,
	              fieldValue: fieldValue,
	              className: column.editClassName,
	              invalidColumnClassName: column.invalidEditColumnClassName,
	              beforeShowError: beforeShowError,
	              isFocus: isFocusCell,
	              customStyleWithNav: customEditAndNavStyle });
	          } else {
	            // add by bluespring for className customize
	            var formattedValue = void 0;
	            var columnChild = fieldValue && fieldValue.toString();
	            var columnTitle = null;
	            var tdClassName = column.className;
	            var tdStyles = column.style;
	            if (_util2.default.isFunction(column.className)) {
	              tdClassName = column.className(fieldValue, data, r, i);
	            }
	
	            if (_util2.default.isFunction(column.style)) {
	              tdStyles = column.style(fieldValue, data, r, i);
	            }
	
	            if (typeof column.format !== 'undefined') {
	              formattedValue = column.format(fieldValue, data, column.formatExtraData, r);
	              if (!_react2.default.isValidElement(formattedValue)) {
	                columnChild = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: formattedValue } });
	              } else {
	                columnChild = formattedValue;
	              }
	            }
	            if (_util2.default.isFunction(column.columnTitle)) {
	              columnTitle = column.columnTitle(fieldValue, data, r, i);
	            } else if (typeof column.columnTitle === 'string') {
	              columnTitle = column.columnTitle;
	            } else if (column.columnTitle) {
	              if (formattedValue) columnTitle = formattedValue.toString();else if (fieldValue) columnTitle = fieldValue.toString();
	            }
	            return _react2.default.createElement(
	              _TableColumn2.default,
	              { key: i,
	                cIndex: i,
	                rIndex: r,
	                dataAlign: column.align,
	                className: tdClassName,
	                columnTitle: columnTitle,
	                cellEdit: cellEdit,
	                hidden: column.hidden,
	                onEdit: this.handleEditCell,
	                width: column.width,
	                onClick: this.handleClickCell,
	                attrs: column.attrs,
	                style: tdStyles,
	                tabIndex: tabIndex++ + '',
	                isFocus: isFocusCell,
	                keyBoardNav: enableKeyBoardNav,
	                onKeyDown: this.handleCellKeyDown,
	                customNavStyle: customNavStyle,
	                row: data,
	                withoutTabIndex: this.props.withoutTabIndex },
	              columnChild
	            );
	          }
	        }, this);
	        var key = data[this.props.keyField];
	        var disable = unselectable.indexOf(key) !== -1;
	        var selected = this.props.selectedRowKeys.indexOf(key) !== -1;
	        var selectRowColumn = isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? this.renderSelectRowColumn(selected, inputType, disable, CustomComponent, r, data) : null;
	        var expandedRowColumn = this.renderExpandRowColumn(this.props.expandableRow && this.props.expandableRow(data), this.props.expanding.indexOf(key) > -1, ExpandColumnCustomComponent, r);
	        var haveExpandContent = this.props.expandableRow && this.props.expandableRow(data);
	        var isExpanding = haveExpandContent && this.props.expanding.indexOf(key) > -1;
	        var hideRowOnExpand = this.props.hideRowOnExpand;
	        // add by bluespring for className customize
	
	        var trClassName = this.props.trClassName;
	        if (_util2.default.isFunction(this.props.trClassName)) {
	          trClassName = this.props.trClassName(data, r);
	        }
	        if (isExpanding && this.props.expandParentClass) {
	          trClassName += _util2.default.isFunction(this.props.expandParentClass) ? ' ' + this.props.expandParentClass(data, r) : ' ' + this.props.expandParentClass;
	        }
	        var result = [_react2.default.createElement(
	          _TableRow2.default,
	          { isSelected: selected, key: key, className: trClassName,
	            index: r,
	            row: data,
	            selectRow: isSelectRowDefined ? this.props.selectRow : undefined,
	            enableCellEdit: cellEdit.mode !== _Const2.default.CELL_EDIT_NONE,
	            onRowClick: this.handleRowClick,
	            onRowDoubleClick: this.handleRowDoubleClick,
	            onRowMouseOver: this.handleRowMouseOver,
	            onRowMouseOut: this.handleRowMouseOut,
	            onSelectRow: this.handleSelectRow,
	            onExpandRow: this.handleClickCell,
	            unselectableRow: disable,
	            style: trStyle,
	            hidden: isExpanding && hideRowOnExpand,
	            dbClickToEdit: cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK },
	          this.props.expandColumnOptions.expandColumnVisible && this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
	          selectRowColumn,
	          this.props.expandColumnOptions.expandColumnVisible && !this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
	          tableColumns
	        )];
	
	        if (haveExpandContent) {
	          var expandBodyClass = _util2.default.isFunction(this.props.expandBodyClass) ? this.props.expandBodyClass(data, r, isExpanding) : this.props.expandBodyClass;
	          result.push(_react2.default.createElement(
	            _ExpandComponent2.default,
	            {
	              key: key + '-expand',
	              row: data,
	              className: expandBodyClass,
	              bgColor: this.props.expandRowBgColor || this.props.selectRow.bgColor || undefined,
	              hidden: !isExpanding,
	              colSpan: expandColSpan,
	              width: "100%" },
	            this.props.expandComponent(data)
	          ));
	        }
	        return result;
	      }, this);
	
	      if (tableRows.length === 0 && !this.props.withoutNoDataText) {
	        var colSpan = this.props.columns.filter(function (c) {
	          return !c.hidden;
	        }).length + (isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? 1 : 0) + (this.props.expandColumnOptions.expandColumnVisible ? 1 : 0);
	        tableRows = [_react2.default.createElement(
	          _TableRow2.default,
	          { key: '##table-empty##', style: trStyle },
	          _react2.default.createElement(
	            'td',
	            { 'data-toggle': 'collapse',
	              colSpan: colSpan,
	              className: 'react-bs-table-no-data' },
	            this.props.noDataText || _Const2.default.NO_DATA_TEXT
	          )
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(node) {
	            return _this2.container = node;
	          },
	          className: (0, _classnames2.default)('react-bs-container-body', this.props.bodyContainerClass),
	          style: this.props.style },
	        _react2.default.createElement(
	          'table',
	          { className: tableClasses },
	          _react2.default.cloneElement(tableHeader, { ref: function ref(node) {
	              return _this2.header = node;
	            } }),
	          _react2.default.createElement(
	            'tbody',
	            { ref: function ref(node) {
	                return _this2.tbody = node;
	              } },
	            tableRows
	          )
	        )
	      );
	    }
	  }, {
	    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
	    value: function __handleCellKeyDown__REACT_HOT_LOADER__(e, lastEditCell) {
	      e.preventDefault();
	      var _props2 = this.props,
	          keyBoardNav = _props2.keyBoardNav,
	          onNavigateCell = _props2.onNavigateCell,
	          cellEdit = _props2.cellEdit,
	          selectedRowKeys = _props2.selectedRowKeys;
	
	      var offset = void 0;
	      if (e.keyCode === 37) {
	        offset = { x: -1, y: 0 };
	      } else if (e.keyCode === 38) {
	        offset = { x: 0, y: -1 };
	      } else if (e.keyCode === 39 || e.keyCode === 9) {
	        offset = { x: 1, y: 0 };
	        if (e.keyCode === 9 && lastEditCell) {
	          offset = _extends({}, offset, {
	            lastEditCell: lastEditCell
	          });
	        }
	      } else if (e.keyCode === 40) {
	        offset = { x: 0, y: 1 };
	      } else if (e.keyCode === 13) {
	        var rowIndex = e.target.parentElement.rowIndex + 1;
	        var enterToEdit = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToEdit : false;
	        var enterToExpand = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToExpand : false;
	        var enterToSelect = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToSelect : false;
	
	        if (cellEdit && enterToEdit) {
	          this.handleEditCell(rowIndex, e.currentTarget.cellIndex, '', e);
	        }
	
	        if (enterToExpand) {
	          this.handleClickCell(e, this.props.y + 1, this.props.x);
	        }
	
	        if (enterToSelect) {
	          var isSelected = selectedRowKeys.indexOf(this.props.data[rowIndex - 1][this.props.keyField]) !== -1;
	          this.handleSelectRow(rowIndex, !isSelected, e);
	        }
	      }
	      if (offset && keyBoardNav) {
	        onNavigateCell(offset);
	      }
	    }
	  }, {
	    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOut__REACT_HOT_LOADER__(rowIndex, event) {
	      var targetRow = this.props.data[rowIndex];
	      this.props.onRowMouseOut(targetRow, event);
	    }
	  }, {
	    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
	    value: function __handleRowMouseOver__REACT_HOT_LOADER__(rowIndex, event) {
	      var targetRow = this.props.data[rowIndex];
	      this.props.onRowMouseOver(targetRow, event);
	    }
	  }, {
	    key: '__handleRowClick__REACT_HOT_LOADER__',
	    value: function __handleRowClick__REACT_HOT_LOADER__(rowIndex, cellIndex, event) {
	      var _props3 = this.props,
	          onRowClick = _props3.onRowClick,
	          selectRow = _props3.selectRow;
	
	      if (_util2.default.isSelectRowDefined(selectRow.mode)) cellIndex--;
	      if (this._isExpandColumnVisible()) cellIndex--;
	      onRowClick(this.props.data[rowIndex - 1], rowIndex - 1, cellIndex, event);
	    }
	  }, {
	    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
	    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(rowIndex, event) {
	      var onRowDoubleClick = this.props.onRowDoubleClick;
	
	      var targetRow = this.props.data[rowIndex];
	      onRowDoubleClick(targetRow, event);
	    }
	  }, {
	    key: '__handleSelectRow__REACT_HOT_LOADER__',
	    value: function __handleSelectRow__REACT_HOT_LOADER__(rowIndex, isSelected, e) {
	      var selectedRow = void 0;
	      var _props4 = this.props,
	          data = _props4.data,
	          onSelectRow = _props4.onSelectRow;
	
	      data.forEach(function (row, i) {
	        if (i === rowIndex - 1) {
	          selectedRow = row;
	          return false;
	        }
	      });
	      onSelectRow(selectedRow, isSelected, e, rowIndex - 1);
	    }
	  }, {
	    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
	    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__(e, rowIndex) {
	      if (!this.props.selectRow.clickToSelect || !this.props.selectRow.clickToSelectAndEditCell) {
	        this.handleSelectRow(rowIndex + 1, e.currentTarget.checked, e);
	      }
	    }
	  }, {
	    key: '__handleClickCell__REACT_HOT_LOADER__',
	    value: function __handleClickCell__REACT_HOT_LOADER__(event, rowIndex) {
	      var columnIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	      var _props5 = this.props,
	          columns = _props5.columns,
	          keyField = _props5.keyField,
	          expandBy = _props5.expandBy,
	          expandableRow = _props5.expandableRow,
	          _props5$selectRow = _props5.selectRow,
	          mode = _props5$selectRow.mode,
	          clickToExpand = _props5$selectRow.clickToExpand,
	          hideSelectColumn = _props5$selectRow.hideSelectColumn,
	          onlyOneExpanding = _props5.onlyOneExpanding;
	
	      var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
	      var selectRowAndExpand = isSelectRowDefined && !clickToExpand ? false : true;
	      columnIndex = isSelectRowDefined && !hideSelectColumn ? columnIndex - 1 : columnIndex;
	      columnIndex = this._isExpandColumnVisible() ? columnIndex - 1 : columnIndex;
	      if (expandableRow && selectRowAndExpand && (expandBy === _Const2.default.EXPAND_BY_ROW ||
	      /* Below will allow expanding trigger by clicking on selection column
	      if configure as expanding by column */
	      expandBy === _Const2.default.EXPAND_BY_COL && columnIndex < 0 || expandBy === _Const2.default.EXPAND_BY_COL && columns[columnIndex].expandable)) {
	        var expanding = this.props.expanding;
	        var rowKey = this.props.data[rowIndex - 1][keyField];
	        var isRowExpanding = expanding.indexOf(rowKey) > -1;
	
	        if (isRowExpanding) {
	          // collapse
	          expanding = expanding.filter(function (k) {
	            return k !== rowKey;
	          });
	        } else {
	          // expand
	          if (onlyOneExpanding) expanding = [rowKey];else expanding.push(rowKey);
	        }
	        this.props.onExpand(expanding, rowKey, isRowExpanding, event);
	      }
	    }
	  }, {
	    key: '__handleEditCell__REACT_HOT_LOADER__',
	    value: function __handleEditCell__REACT_HOT_LOADER__(rowIndex, columnIndex, action, e) {
	      var selectRow = this.props.selectRow;
	
	      var defineSelectRow = _util2.default.isSelectRowDefined(selectRow.mode);
	      var expandColumnVisible = this._isExpandColumnVisible();
	      if (defineSelectRow) {
	        columnIndex--;
	        if (selectRow.hideSelectColumn) columnIndex++;
	      }
	      if (expandColumnVisible) {
	        columnIndex--;
	      }
	      rowIndex--;
	
	      if (action === 'tab') {
	        if (defineSelectRow && !selectRow.hideSelectColumn) columnIndex++;
	        if (expandColumnVisible) columnIndex++;
	        this.handleCompleteEditCell(e.target.value, rowIndex, columnIndex - 1);
	        if (columnIndex >= this.props.columns.length) {
	          this.handleCellKeyDown(e, true);
	        } else {
	          this.handleCellKeyDown(e);
	        }
	
	        var _nextEditableCell = this.nextEditableCell(rowIndex, columnIndex),
	            nextRIndex = _nextEditableCell.nextRIndex,
	            nextCIndex = _nextEditableCell.nextCIndex;
	
	        rowIndex = nextRIndex;
	        columnIndex = nextCIndex;
	      }
	
	      var stateObj = {
	        currEditCell: {
	          rid: rowIndex,
	          cid: columnIndex
	        }
	      };
	
	      if (this.props.selectRow.clickToSelectAndEditCell && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
	        var selected = this.props.selectedRowKeys.indexOf(this.props.data[rowIndex][this.props.keyField]) !== -1;
	        this.handleSelectRow(rowIndex + 1, !selected, e);
	      }
	      this.setState(function () {
	        return stateObj;
	      });
	    }
	  }, {
	    key: '__nextEditableCell__REACT_HOT_LOADER__',
	    value: function __nextEditableCell__REACT_HOT_LOADER__(rIndex, cIndex) {
	      var keyField = this.props.keyField;
	
	      var nextRIndex = rIndex;
	      var nextCIndex = cIndex;
	      var row = void 0;
	      var column = void 0;
	      do {
	        if (nextCIndex >= this.props.columns.length) {
	          nextRIndex++;
	          nextCIndex = 0;
	        }
	        row = this.props.data[nextRIndex];
	        column = this.props.columns[nextCIndex];
	        if (!row) break;
	        var editable = column.editable;
	        if (_util2.default.isFunction(column.editable)) {
	          editable = column.editable(column, row, nextRIndex, nextCIndex);
	        }
	        if (editable && editable.readOnly !== true && !column.hidden && keyField !== column.name) {
	          break;
	        } else {
	          nextCIndex++;
	        }
	      } while (row);
	      return { nextRIndex: nextRIndex, nextCIndex: nextCIndex };
	    }
	  }, {
	    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
	    value: function __handleCompleteEditCell__REACT_HOT_LOADER__(newVal, rowIndex, columnIndex) {
	      if (newVal !== null) {
	        var result = this.props.onEditCell(newVal, rowIndex, columnIndex);
	        if (result !== _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
	          this.setState(function () {
	            return { currEditCell: null };
	          });
	        }
	      } else {
	        this.setState(function () {
	          return { currEditCell: null };
	        });
	      }
	    }
	  }, {
	    key: '__cancelEditCell__REACT_HOT_LOADER__',
	    value: function __cancelEditCell__REACT_HOT_LOADER__() {
	      this.setState(function () {
	        return { currEditCell: null };
	      });
	    }
	  }, {
	    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
	    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__(e, isSelect, rowIndex, row) {
	      e.stopPropagation();
	      if (e.target.tagName === 'TD' && (this.props.selectRow.clickToSelect || this.props.selectRow.clickToSelectAndEditCell)) {
	        var unselectable = this.props.selectRow.unselectable || [];
	        if (unselectable.indexOf(row[this.props.keyField]) === -1) {
	          this.handleSelectRow(rowIndex + 1, isSelect, e);
	          this.handleClickCell(e, rowIndex + 1);
	        }
	      }
	    }
	  }, {
	    key: 'renderSelectRowColumn',
	    value: function renderSelectRowColumn(selected, inputType, disabled) {
	      var CustomComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var _this3 = this;
	
	      var rowIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	      var row = arguments[5];
	
	      return _react2.default.createElement(
	        'td',
	        { onClick: function onClick(e) {
	            _this3.handleClickonSelectColumn(e, !selected, rowIndex, row);
	          }, style: { textAlign: 'center' } },
	        CustomComponent ? _react2.default.createElement(CustomComponent, { type: inputType, checked: selected, disabled: disabled,
	          rowIndex: rowIndex,
	          onChange: function onChange(e) {
	            return _this3.handleSelectRowColumChange(e, rowIndex);
	          } }) : _react2.default.createElement('input', { type: inputType, checked: selected, disabled: disabled,
	          onChange: function onChange(e) {
	            return _this3.handleSelectRowColumChange(e, rowIndex);
	          } })
	      );
	    }
	  }, {
	    key: 'renderExpandRowColumn',
	    value: function renderExpandRowColumn(isExpandableRow, isExpanded, CustomComponent) {
	      var _this4 = this;
	
	      var rowIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var content = null;
	      if (CustomComponent) {
	        content = _react2.default.createElement(CustomComponent, { isExpandableRow: isExpandableRow, isExpanded: isExpanded });
	      } else if (isExpandableRow) {
	        content = isExpanded ? _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' }) : _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' });
	      } else {
	        content = ' ';
	      }
	
	      return _react2.default.createElement(
	        'td',
	        {
	          className: 'react-bs-table-expand-cell',
	          onClick: function onClick(e) {
	            return _this4.handleClickCell(e, rowIndex + 1);
	          } },
	        content
	      );
	    }
	  }, {
	    key: '_isExpandColumnVisible',
	    value: function _isExpandColumnVisible() {
	      return this.props.expandColumnOptions.expandColumnVisible;
	    }
	  }, {
	    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
	    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
	      return this.header.childNodes;
	    }
	  }]);
	
	  return TableBody;
	}(_react.Component);
	
	TableBody.propTypes = {
	  version: _propTypes2.default.string,
	  data: _propTypes2.default.array,
	  columns: _propTypes2.default.array,
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  keyField: _propTypes2.default.string,
	  selectedRowKeys: _propTypes2.default.array,
	  onRowClick: _propTypes2.default.func,
	  onRowDoubleClick: _propTypes2.default.func,
	  onSelectRow: _propTypes2.default.func,
	  noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  withoutNoDataText: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  tableBodyClass: _propTypes2.default.string,
	  bodyContainerClass: _propTypes2.default.string,
	  expandableRow: _propTypes2.default.func,
	  expandComponent: _propTypes2.default.func,
	  expandRowBgColor: _propTypes2.default.string,
	  expandBy: _propTypes2.default.string,
	  expanding: _propTypes2.default.array,
	  onExpand: _propTypes2.default.func,
	  expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  onlyOneExpanding: _propTypes2.default.bool,
	  beforeShowError: _propTypes2.default.func,
	  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  onNavigateCell: _propTypes2.default.func,
	  withoutTabIndex: _propTypes2.default.bool,
	  hideRowOnExpand: _propTypes2.default.bool
	};
	var _default = TableBody;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableBody, 'TableBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');
	}();
	
	;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableColumn = function (_Component) {
	  _inherits(TableColumn, _Component);
	
	  function TableColumn(props) {
	    _classCallCheck(this, TableColumn);
	
	    var _this = _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call(this, props));
	
	    _this.handleCellEdit = function () {
	      return _this.__handleCellEdit__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleCellClick = function () {
	      return _this.__handleCellClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleKeyDown = function () {
	      return _this.__handleKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    return _this;
	  }
	  /* eslint no-unused-vars: [0, { "args": "after-used" }] */
	
	
	  _createClass(TableColumn, [{
	    key: '__handleKeyDown__REACT_HOT_LOADER__',
	    value: function __handleKeyDown__REACT_HOT_LOADER__() {
	      return this.__handleKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCellClick__REACT_HOT_LOADER__',
	    value: function __handleCellClick__REACT_HOT_LOADER__() {
	      return this.__handleCellClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCellEdit__REACT_HOT_LOADER__',
	    value: function __handleCellEdit__REACT_HOT_LOADER__() {
	      return this.__handleCellEdit__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var children = this.props.children;
	
	      var shouldUpdated = this.props.width !== nextProps.width || this.props.className !== nextProps.className || this.props.hidden !== nextProps.hidden || this.props.dataAlign !== nextProps.dataAlign || this.props.isFocus !== nextProps.isFocus || (typeof children === 'undefined' ? 'undefined' : _typeof(children)) !== _typeof(nextProps.children) || ('' + this.props.onEdit).toString() !== ('' + nextProps.onEdit).toString();
	
	      if (shouldUpdated) {
	        return shouldUpdated;
	      }
	
	      if ((typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object' && children !== null && children.props !== null) {
	        if (children.props.type === 'checkbox' || children.props.type === 'radio') {
	          shouldUpdated = shouldUpdated || children.props.type !== nextProps.children.props.type || children.props.checked !== nextProps.children.props.checked || children.props.disabled !== nextProps.children.props.disabled;
	        } else {
	          shouldUpdated = true;
	        }
	      } else {
	        shouldUpdated = shouldUpdated || children !== nextProps.children;
	      }
	
	      if (shouldUpdated) {
	        return shouldUpdated;
	      }
	
	      if (!(this.props.cellEdit && nextProps.cellEdit)) {
	        return false;
	      } else {
	        return shouldUpdated || this.props.cellEdit.mode !== nextProps.cellEdit.mode;
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dom = _reactDom2.default.findDOMNode(this);
	      if (this.props.isFocus) {
	        dom.focus();
	      } else {
	        dom.blur();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var dom = _reactDom2.default.findDOMNode(this);
	      if (this.props.isFocus) {
	        dom.focus();
	      } else {
	        dom.blur();
	      }
	    }
	  }, {
	    key: '__handleCellEdit__REACT_HOT_LOADER__',
	    value: function __handleCellEdit__REACT_HOT_LOADER__(e) {
	      try {
	        if (this.props.cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
	          if (document.selection && document.selection.empty) {
	            document.selection.empty();
	          } else if (window.getSelection) {
	            var sel = window.getSelection();
	            sel.removeAllRanges();
	          }
	        }
	      } catch (err) {} /* eslint no-empty: 0 */
	      this.props.onEdit(this.props.rIndex + 1, e.currentTarget.cellIndex, e);
	      if (this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
	        this.props.onClick(e, this.props.rIndex + 1, e.currentTarget.cellIndex);
	      }
	    }
	  }, {
	    key: '__handleCellClick__REACT_HOT_LOADER__',
	    value: function __handleCellClick__REACT_HOT_LOADER__(e) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          rIndex = _props.rIndex;
	
	      if (onClick) {
	        onClick(e, rIndex + 1, e.currentTarget.cellIndex);
	      }
	    }
	  }, {
	    key: '__handleKeyDown__REACT_HOT_LOADER__',
	    value: function __handleKeyDown__REACT_HOT_LOADER__(e) {
	      if (this.props.keyBoardNav) {
	        this.props.onKeyDown(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          columnTitle = _props2.columnTitle,
	          dataAlign = _props2.dataAlign,
	          hidden = _props2.hidden,
	          cellEdit = _props2.cellEdit,
	          attrs = _props2.attrs,
	          style = _props2.style,
	          isFocus = _props2.isFocus,
	          keyBoardNav = _props2.keyBoardNav,
	          tabIndex = _props2.tabIndex,
	          customNavStyle = _props2.customNavStyle,
	          withoutTabIndex = _props2.withoutTabIndex,
	          row = _props2.row;
	      var className = this.props.className;
	
	
	      var tdStyle = _extends({
	        textAlign: dataAlign,
	        display: hidden ? 'none' : null
	      }, style);
	
	      var opts = {};
	
	      if (cellEdit) {
	        if (cellEdit.mode === _Const2.default.CELL_EDIT_CLICK) {
	          opts.onClick = this.handleCellEdit;
	        } else if (cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
	          opts.onDoubleClick = this.handleCellEdit;
	        } else {
	          opts.onClick = this.handleCellClick;
	        }
	      }
	
	      if (keyBoardNav && isFocus) {
	        opts.onKeyDown = this.handleKeyDown;
	      }
	
	      if (isFocus) {
	        if (customNavStyle) {
	          var cusmtStyle = _util2.default.isFunction(customNavStyle) ? customNavStyle(children, row) : customNavStyle;
	          tdStyle = _extends({}, tdStyle, cusmtStyle);
	        } else {
	          className = className + ' default-focus-cell';
	        }
	      }
	
	      var attr = {};
	      if (!withoutTabIndex) attr.tabIndex = tabIndex;
	      return _react2.default.createElement(
	        'td',
	        _extends({}, attr, { style: tdStyle,
	          title: columnTitle,
	          className: className
	        }, opts, attrs),
	        typeof children === 'boolean' ? children.toString() : children
	      );
	    }
	  }]);
	
	  return TableColumn;
	}(_react.Component);
	
	TableColumn.propTypes = {
	  rIndex: _propTypes2.default.number,
	  dataAlign: _propTypes2.default.string,
	  hidden: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  columnTitle: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onClick: _propTypes2.default.func,
	  attrs: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isFocus: _propTypes2.default.bool,
	  onKeyDown: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.string,
	  withoutTabIndex: _propTypes2.default.bool,
	  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  customNavStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  row: _propTypes2.default.any /* only used on custom styling for navigation */
	};
	
	TableColumn.defaultProps = {
	  dataAlign: 'left',
	  withoutTabIndex: false,
	  hidden: false,
	  className: '',
	  isFocus: false,
	  keyBoardNav: false
	};
	var _default = TableColumn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableColumn, 'TableColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');
	}();
	
	;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Editor = __webpack_require__(611);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _Notification = __webpack_require__(612);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableEditColumn = function (_Component) {
	  _inherits(TableEditColumn, _Component);
	
	  function TableEditColumn(props) {
	    _classCallCheck(this, TableEditColumn);
	
	    var _this = _possibleConstructorReturn(this, (TableEditColumn.__proto__ || Object.getPrototypeOf(TableEditColumn)).call(this, props));
	
	    _this.handleKeyPress = function () {
	      return _this.__handleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleBlur = function () {
	      return _this.__handleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleCustomUpdate = function () {
	      return _this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.notifyToastr = function () {
	      return _this.__notifyToastr__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleClick = function () {
	      return _this.__handleClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.getInputRef = function () {
	      return _this.__getInputRef__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.getHandleKeyPress = function () {
	      return _this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.getHandleBlur = function () {
	      return _this.__getHandleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.timeouteClear = 0;
	    var _this$props = _this.props,
	        fieldValue = _this$props.fieldValue,
	        row = _this$props.row,
	        className = _this$props.className;
	
	    _this.focusInEditor = _this.focusInEditor.bind(_this);
	    _this.state = {
	      shakeEditor: false,
	      className: _util2.default.isFunction(className) ? className(fieldValue, row) : className
	    };
	    return _this;
	  }
	
	  _createClass(TableEditColumn, [{
	    key: '__getHandleBlur__REACT_HOT_LOADER__',
	    value: function __getHandleBlur__REACT_HOT_LOADER__() {
	      return this.__getHandleBlur__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
	    value: function __getHandleKeyPress__REACT_HOT_LOADER__() {
	      return this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__getInputRef__REACT_HOT_LOADER__',
	    value: function __getInputRef__REACT_HOT_LOADER__() {
	      return this.__getInputRef__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleClick__REACT_HOT_LOADER__',
	    value: function __handleClick__REACT_HOT_LOADER__() {
	      return this.__handleClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__notifyToastr__REACT_HOT_LOADER__',
	    value: function __notifyToastr__REACT_HOT_LOADER__() {
	      return this.__notifyToastr__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleCustomUpdate__REACT_HOT_LOADER__',
	    value: function __handleCustomUpdate__REACT_HOT_LOADER__() {
	      return this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleBlur__REACT_HOT_LOADER__',
	    value: function __handleBlur__REACT_HOT_LOADER__() {
	      return this.__handleBlur__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleKeyPress__REACT_HOT_LOADER__',
	    value: function __handleKeyPress__REACT_HOT_LOADER__() {
	      return this.__handleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'valueShortCircuit',
	    value: function valueShortCircuit(value) {
	      return value === null || typeof value === 'undefined' ? '' : value;
	    }
	  }, {
	    key: '__handleKeyPress__REACT_HOT_LOADER__',
	    value: function __handleKeyPress__REACT_HOT_LOADER__(e) {
	      if (e.keyCode === 13 || e.keyCode === 9) {
	        // Pressed ENTER or TAB
	        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;
	
	        if (e.keyCode === 9 && this.props.blurToSave || !this.validator(value)) {
	          return;
	        }
	
	        if (e.keyCode === 13) {
	          this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
	        } else {
	          this.props.onTab(this.props.rowIndex + 1, this.props.colIndex + 1, 'tab', e);
	          e.preventDefault();
	        }
	      } else if (e.keyCode === 27) {
	        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
	      } else if (e.type === 'click' && !this.props.blurToSave) {
	        // textarea click save button
	        var _value = e.target.parentElement.firstChild.value;
	        if (!this.validator(_value)) {
	          return;
	        }
	        this.props.completeEdit(_value, this.props.rowIndex, this.props.colIndex);
	      }
	    }
	  }, {
	    key: '__handleBlur__REACT_HOT_LOADER__',
	    value: function __handleBlur__REACT_HOT_LOADER__(e) {
	      e.stopPropagation();
	      if (this.props.blurToSave) {
	        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;
	        if (!this.validator(value)) {
	          return false;
	        }
	        this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
	      } else if (this.props.blurToEscape) {
	        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
	      }
	    }
	  }, {
	    key: '__handleCustomUpdate__REACT_HOT_LOADER__',
	
	
	    // modified by iuculanop
	    // BEGIN
	    value: function __handleCustomUpdate__REACT_HOT_LOADER__(value) {
	      if (!this.validator(value)) {
	        return;
	      }
	      this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
	    }
	  }, {
	    key: 'validator',
	    value: function validator(value) {
	      var ts = this;
	      var valid = true;
	      if (ts.props.editable.validator) {
	        var checkVal = ts.props.editable.validator(value, this.props.row);
	        var responseType = typeof checkVal === 'undefined' ? 'undefined' : _typeof(checkVal);
	        if (responseType !== 'object' && checkVal !== true) {
	          valid = false;
	          this.notifyToastr('error', checkVal, '');
	        } else if (responseType === 'object' && checkVal.isValid !== true) {
	          valid = false;
	          this.notifyToastr(checkVal.notification.type, checkVal.notification.msg, checkVal.notification.title);
	        }
	        if (!valid) {
	          // animate input
	          ts.clearTimeout();
	          var _props = this.props,
	              invalidColumnClassName = _props.invalidColumnClassName,
	              row = _props.row;
	
	          var className = _util2.default.isFunction(invalidColumnClassName) ? invalidColumnClassName(value, row) : invalidColumnClassName;
	          ts.setState({ shakeEditor: true, className: className });
	          ts.timeouteClear = setTimeout(function () {
	            ts.setState({ shakeEditor: false });
	          }, 300);
	          this.focusInEditor();
	          return valid;
	        }
	      }
	      return valid;
	    }
	    // END
	
	  }, {
	    key: '__notifyToastr__REACT_HOT_LOADER__',
	    value: function __notifyToastr__REACT_HOT_LOADER__(type, message, title) {
	      var toastr = true;
	      var beforeShowError = this.props.beforeShowError;
	
	      if (beforeShowError) {
	        toastr = beforeShowError(type, message, title);
	      }
	      if (toastr) {
	        (0, _Notification.notice)(type, message, title);
	      }
	    }
	  }, {
	    key: 'clearTimeout',
	    value: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeouteClear !== 0) {
	        clearTimeout(this.timeouteClear);
	        this.timeouteClear = 0;
	      }
	    })
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.focusInEditor();
	      var dom = _reactDom2.default.findDOMNode(this);
	      if (this.props.isFocus) {
	        dom.focus();
	      } else {
	        dom.blur();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var dom = _reactDom2.default.findDOMNode(this);
	      if (this.props.isFocus) {
	        dom.focus();
	      } else {
	        dom.blur();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: 'focusInEditor',
	    value: function focusInEditor() {
	      if (this.inputRef && _util2.default.isFunction(this.inputRef.focus)) {
	        this.inputRef.focus();
	      }
	    }
	  }, {
	    key: '__handleClick__REACT_HOT_LOADER__',
	    value: function __handleClick__REACT_HOT_LOADER__(e) {
	      if (e.target.tagName !== 'TD') {
	        e.stopPropagation();
	      }
	    }
	  }, {
	    key: '__getInputRef__REACT_HOT_LOADER__',
	    value: function __getInputRef__REACT_HOT_LOADER__(userRef) {
	      var _this2 = this;
	
	      return function (ref) {
	        _this2.inputRef = ref;
	        if (_util2.default.isFunction(userRef)) {
	          userRef(ref);
	        } else if (typeof userRef === 'string') {
	          throw new Error('Ref must be a function');
	        }
	      };
	    }
	  }, {
	    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
	    value: function __getHandleKeyPress__REACT_HOT_LOADER__(customHandler) {
	      var _this3 = this;
	
	      return function (e) {
	        _this3.handleKeyPress(e);
	        if (_util2.default.isFunction(customHandler)) {
	          customHandler(e);
	        }
	      };
	    }
	  }, {
	    key: '__getHandleBlur__REACT_HOT_LOADER__',
	    value: function __getHandleBlur__REACT_HOT_LOADER__(customHandler) {
	      var _this4 = this;
	
	      return function (e) {
	        _this4.handleBlur(e);
	        if (_util2.default.isFunction(customHandler)) {
	          customHandler(e);
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          editable = _props2.editable,
	          format = _props2.format,
	          customEditor = _props2.customEditor,
	          isFocus = _props2.isFocus,
	          customStyleWithNav = _props2.customStyleWithNav,
	          row = _props2.row,
	          attrs = _props2.attrs;
	      var shakeEditor = this.state.shakeEditor;
	
	      var attr = _extends({}, editable.attrs, {
	        ref: this.getInputRef(editable.attrs && editable.attrs.ref),
	        onKeyDown: this.getHandleKeyPress(editable.attrs && editable.attrs.onKeyDown),
	        onBlur: this.getHandleBlur(editable.attrs && editable.attrs.onBlur)
	      });
	      var style = { position: 'relative' };
	      var fieldValue = this.props.fieldValue;
	      var className = this.state.className;
	
	
	      if (editable.placeholder) {
	        attr.placeholder = editable.placeholder;
	        /* eslint-disable no-console */
	        console.warn('Setting editable.placeholder is deprecated. Use editable.attrs to set input attributes');
	        /* eslint-enable no-console */
	      }
	
	      var editorClass = (0, _classnames2.default)({ 'animated': shakeEditor, 'shake': shakeEditor });
	      fieldValue = fieldValue === 0 ? '0' : fieldValue;
	      var cellEditor = void 0;
	      if (customEditor) {
	        var customEditorProps = _extends({
	          row: row
	        }, attr, {
	          defaultValue: this.valueShortCircuit(fieldValue)
	        }, customEditor.customEditorParameters);
	        cellEditor = customEditor.getElement(this.handleCustomUpdate, customEditorProps);
	      } else {
	        cellEditor = (0, _Editor2.default)(editable, attr, format, editorClass, this.valueShortCircuit(fieldValue), null, row);
	      }
	
	      if (isFocus) {
	        if (customStyleWithNav) {
	          var customStyle = _util2.default.isFunction(customStyleWithNav) ? customStyleWithNav(fieldValue, row) : customStyleWithNav;
	          style = _extends({}, style, customStyle);
	        } else {
	          className = className + ' default-focus-cell';
	        }
	      }
	
	      return _react2.default.createElement(
	        'td',
	        _extends({}, attrs, {
	          style: style,
	          className: className,
	          onClick: this.handleClick }),
	        cellEditor
	      );
	    }
	  }, {
	    key: '_getCheckBoxValue',
	    value: function _getCheckBoxValue(e) {
	      var value = '';
	      var values = e.currentTarget.value.split(':');
	      value = e.currentTarget.checked ? values[0] : values[1];
	      return value;
	    }
	  }]);
	
	  return TableEditColumn;
	}(_react.Component);
	
	TableEditColumn.propTypes = {
	  completeEdit: _propTypes2.default.func,
	  rowIndex: _propTypes2.default.number,
	  colIndex: _propTypes2.default.number,
	  blurToSave: _propTypes2.default.bool,
	  blurToEscape: _propTypes2.default.bool,
	  editable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  format: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	  row: _propTypes2.default.any,
	  fieldValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.object]),
	  className: _propTypes2.default.any,
	  beforeShowError: _propTypes2.default.func,
	  isFocus: _propTypes2.default.bool,
	  attrs: _propTypes2.default.object,
	  customStyleWithNav: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
	};
	
	var _default = TableEditColumn;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableEditColumn, 'TableEditColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');
	}();
	
	;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableFilter = function (_Component) {
	  _inherits(TableFilter, _Component);
	
	  function TableFilter(props) {
	    _classCallCheck(this, TableFilter);
	
	    var _this = _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).call(this, props));
	
	    _this.handleKeyUp = function () {
	      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.filterObj = {};
	    return _this;
	  }
	
	  _createClass(TableFilter, [{
	    key: '__handleKeyUp__REACT_HOT_LOADER__',
	    value: function __handleKeyUp__REACT_HOT_LOADER__() {
	      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleKeyUp__REACT_HOT_LOADER__',
	    value: function __handleKeyUp__REACT_HOT_LOADER__(e) {
	      var _e$currentTarget = e.currentTarget,
	          value = _e$currentTarget.value,
	          name = _e$currentTarget.name;
	
	      if (value.trim() === '') {
	        delete this.filterObj[name];
	      } else {
	        this.filterObj[name] = value;
	      }
	      this.props.onFilter(this.filterObj);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          striped = _props.striped,
	          condensed = _props.condensed,
	          rowSelectType = _props.rowSelectType,
	          columns = _props.columns;
	
	      var tableClasses = (0, _classnames2.default)('table', {
	        'table-striped': striped,
	        'table-condensed': condensed
	      });
	      var selectRowHeader = null;
	
	      if (rowSelectType === _Const2.default.ROW_SELECT_SINGLE || rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
	        var style = {
	          width: 35,
	          paddingLeft: 0,
	          paddingRight: 0
	        };
	        selectRowHeader = _react2.default.createElement(
	          'th',
	          { style: style, key: -1 },
	          'Filter'
	        );
	      }
	
	      var filterField = columns.map(function (column) {
	        var hidden = column.hidden,
	            width = column.width,
	            name = column.name;
	
	        var thStyle = {
	          display: hidden ? 'none' : null,
	          width: width
	        };
	        return _react2.default.createElement(
	          'th',
	          { key: name, style: thStyle },
	          _react2.default.createElement(
	            'div',
	            { className: 'th-inner table-header-column' },
	            _react2.default.createElement('input', { size: '10', type: 'text',
	              placeholder: name, name: name, onKeyUp: this.handleKeyUp })
	          )
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        'table',
	        { className: tableClasses, style: { marginTop: 5 } },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            { style: { borderBottomStyle: 'hidden' } },
	            selectRowHeader,
	            filterField
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableFilter;
	}(_react.Component);
	
	TableFilter.propTypes = {
	  columns: _propTypes2.default.array,
	  rowSelectType: _propTypes2.default.string,
	  onFilter: _propTypes2.default.func
	};
	var _default = TableFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableFilter, 'TableFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');
	}();
	
	;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableFooter = function (_Component) {
	  _inherits(TableFooter, _Component);
	
	  function TableFooter() {
	    _classCallCheck(this, TableFooter);
	
	    return _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
	  }
	
	  _createClass(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          hideSelectColumn = _props.hideSelectColumn,
	          expandColumnVisible = _props.expandColumnVisible;
	
	      var containerClasses = (0, _classnames2.default)('react-bs-container-footer', 'table-footer-wrapper');
	      var tableClasses = (0, _classnames2.default)('table', 'table-hover', {
	        'table-bordered': this.props.bordered,
	        'table-condensed': this.props.condensed
	      }, this.props.tableFooterClass);
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(node) {
	            return _this2.container = node;
	          },
	          className: containerClasses,
	          style: this.props.style },
	        this.props.children.map(function (footerItem, footerItemIndex) {
	          return _react2.default.createElement(
	            'span',
	            { key: footerItemIndex },
	            _react2.default.createElement(
	              'table',
	              { className: tableClasses },
	              _react2.default.cloneElement(_this2.props.colGroups),
	              _react2.default.createElement(
	                'tfoot',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  { ref: function ref(node) {
	                      return _this2.footer = node;
	                    } },
	                  hideSelectColumn ? null : _this2.renderSelectionOrExpandCol(),
	                  !expandColumnVisible ? null : _this2.renderSelectionOrExpandCol(),
	                  _this2.props.columns.map(function (columnItem, colIndex) {
	                    if (!columnItem.hidden) {
	                      var footerObj = footerItem.filter(function (item) {
	                        return item.columnIndex === colIndex;
	                      });
	                      var footerData = void 0;
	                      var thAlignment = 'left';
	                      if (footerObj.length) {
	                        thAlignment = footerObj[0].align;
	                        if (footerObj[0].formatter) {
	                          footerData = footerObj[0].formatter(_this2.props.footerFormatterReturnData);
	                        } else {
	                          footerData = footerObj[0].label;
	                        }
	                      } else {
	                        footerData = '';
	                      }
	                      return _react2.default.createElement(
	                        'th',
	                        {
	                          key: colIndex,
	                          style: {
	                            minWidth: _this2.props.columns[colIndex].width + 'px',
	                            textAlign: thAlignment
	                          } },
	                        footerData
	                      );
	                    }
	                  })
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderSelectionOrExpandCol',
	    value: function renderSelectionOrExpandCol() {
	      return _react2.default.createElement('th', null);
	    }
	  }]);
	
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.propTypes = {
	  tableHeaderClass: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  hideSelectColumn: _propTypes2.default.bool,
	  expandColumnVisible: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  isFiltered: _propTypes2.default.bool,
	  sortIndicator: _propTypes2.default.bool
	};
	
	var _default = TableFooter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableFooter, 'TableFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');
	}();
	
	;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectRowHeaderColumn = __webpack_require__(1167);
	
	var _SelectRowHeaderColumn2 = _interopRequireDefault(_SelectRowHeaderColumn);
	
	var _ExpandRowHeaderColumn = __webpack_require__(1165);
	
	var _ExpandRowHeaderColumn2 = _interopRequireDefault(_ExpandRowHeaderColumn);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  _createClass(Checkbox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.update(this.props.checked);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.update(props.checked);
	    }
	  }, {
	    key: 'update',
	    value: function update(checked) {
	      _reactDom2.default.findDOMNode(this).indeterminate = checked === 'indeterminate';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('input', { className: 'react-bs-select-all',
	        type: 'checkbox',
	        checked: this.props.checked,
	        onChange: this.props.onChange });
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	function getSortOrder(sortList, field, enableSort) {
	  if (!enableSort) return undefined;
	  var result = sortList.filter(function (sortObj) {
	    return sortObj.sortField === field;
	  });
	  if (result.length > 0) {
	    return result[0].order;
	  } else {
	    return undefined;
	  }
	}
	
	var TableHeader = function (_Component2) {
	  _inherits(TableHeader, _Component2);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref, [this].concat(args))), _this2), _this2.getHeaderColGrouop = function () {
	      var _this3;
	
	      return (_this3 = _this2).__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this3, arguments);
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(TableHeader, [{
	    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
	    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
	      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          sortIndicator = _props.sortIndicator,
	          sortList = _props.sortList,
	          onSort = _props.onSort,
	          reset = _props.reset,
	          version = _props.version,
	          condensed = _props.condensed,
	          bordered = _props.bordered,
	          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
	          noAnyExpand = _props.noAnyExpand,
	          toggleExpandAllChilds = _props.toggleExpandAllChilds,
	          expandAll = _props.expandAll;
	
	      var containerClasses = (0, _classnames2.default)('react-bs-container-header', 'table-header-wrapper', this.props.headerContainerClass);
	      var customTableClasses = {
	        'table-bordered': bordered
	      };
	      if (condensed) {
	        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
	      }
	      var tableClasses = (0, _classnames2.default)('table', 'table-hover', customTableClasses, this.props.tableHeaderClass);
	
	      var rowCount = Math.max.apply(Math, _toConsumableArray(_react2.default.Children.map(this.props.children, function (elm) {
	        return elm && elm.props.row ? Number(elm.props.row) : 0;
	      })));
	
	      var rows = [];
	      var rowKey = 0;
	
	      rows[0] = [];
	      rows[0].push([this.props.expandColumnVisible && this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
	        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
	        noAnyExpand: noAnyExpand,
	        expandAll: expandAll,
	        toggleExpandAllChilds: toggleExpandAllChilds })], [this.renderSelectRowHeader(rowCount + 1, rowKey++)], [this.props.expandColumnVisible && !this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
	        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
	        noAnyExpand: noAnyExpand,
	        expandAll: expandAll,
	        toggleExpandAllChilds: toggleExpandAllChilds })]);
	
	      _react2.default.Children.forEach(this.props.children, function (elm) {
	        if (elm === null || elm === undefined) {
	          // Skip null or undefined elements.
	          return;
	        }
	        var _elm$props = elm.props,
	            dataField = _elm$props.dataField,
	            dataSort = _elm$props.dataSort;
	
	        var sort = getSortOrder(sortList, dataField, dataSort);
	        var rowIndex = elm.props.row ? Number(elm.props.row) : 0;
	        var rowSpan = elm.props.rowSpan ? Number(elm.props.rowSpan) : 1;
	        if (rows[rowIndex] === undefined) {
	          rows[rowIndex] = [];
	        }
	        if (rowSpan + rowIndex === rowCount + 1) {
	          rows[rowIndex].push(_react2.default.cloneElement(elm, { reset: reset, key: rowKey++, onSort: onSort, sort: sort, sortIndicator: sortIndicator, isOnlyHead: false, version: version }));
	        } else {
	          rows[rowIndex].push(_react2.default.cloneElement(elm, { key: rowKey++, isOnlyHead: true, version: version }));
	        }
	      });
	
	      var trs = rows.map(function (row, indexRow) {
	        return _react2.default.createElement(
	          'tr',
	          { key: indexRow },
	          row
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(node) {
	            return _this4.container = node;
	          },
	          className: containerClasses,
	          style: this.props.style },
	        _react2.default.createElement(
	          'table',
	          { className: tableClasses },
	          _react2.default.cloneElement(this.props.colGroups, { ref: function ref(node) {
	              return _this4.headerGrp = node;
	            } }),
	          _react2.default.createElement(
	            'thead',
	            { ref: function ref(node) {
	                return _this4.header = node;
	              } },
	            trs
	          )
	        )
	      );
	    }
	  }, {
	    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
	    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
	      return this.headerGrp.childNodes;
	    }
	  }, {
	    key: 'renderSelectRowHeader',
	    value: function renderSelectRowHeader(rowCount, rowKey) {
	      if (this.props.hideSelectColumn) {
	        return null;
	      } else if (this.props.customComponent) {
	        var CustomComponent = this.props.customComponent;
	        return _react2.default.createElement(
	          _SelectRowHeaderColumn2.default,
	          { key: rowKey, rowCount: rowCount },
	          _react2.default.createElement(CustomComponent, { type: 'checkbox', checked: this.props.isSelectAll,
	            indeterminate: this.props.isSelectAll === 'indeterminate', disabled: false,
	            onChange: this.props.onSelectAllRow, rowIndex: 'Header' })
	        );
	      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_SINGLE) {
	        return _react2.default.createElement(_SelectRowHeaderColumn2.default, { key: rowKey, rowCount: rowCount });
	      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
	        return _react2.default.createElement(
	          _SelectRowHeaderColumn2.default,
	          { key: rowKey, rowCount: rowCount },
	          _react2.default.createElement(Checkbox, {
	            onChange: this.props.onSelectAllRow,
	            checked: this.props.isSelectAll })
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.propTypes = {
	  headerContainerClass: _propTypes2.default.string,
	  tableHeaderClass: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  rowSelectType: _propTypes2.default.string,
	  onSort: _propTypes2.default.func,
	  onSelectAllRow: _propTypes2.default.func,
	  sortList: _propTypes2.default.array,
	  hideSelectColumn: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  isFiltered: _propTypes2.default.bool,
	  isSelectAll: _propTypes2.default.oneOf([true, 'indeterminate', false]),
	  sortIndicator: _propTypes2.default.bool,
	  customComponent: _propTypes2.default.func,
	  colGroups: _propTypes2.default.element,
	  reset: _propTypes2.default.bool,
	  expandColumnVisible: _propTypes2.default.bool,
	  expandColumnComponent: _propTypes2.default.func,
	  expandedColumnHeaderComponent: _propTypes2.default.func,
	  expandColumnBeforeSelectColumn: _propTypes2.default.bool,
	  version: _propTypes2.default.string,
	  noAnyExpand: _propTypes2.default.bool,
	  expandAll: _propTypes2.default.bool,
	  toggleExpandAllChilds: _propTypes2.default.func
	};
	
	var _default = TableHeader;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
	
	  __REACT_HOT_LOADER__.register(getSortOrder, 'getSortOrder', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
	
	  __REACT_HOT_LOADER__.register(TableHeader, 'TableHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
	}();
	
	;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */
	
	
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow(props) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));
	
	    _this.rowClick = function () {
	      return _this.__rowClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.expandRow = function () {
	      return _this.__expandRow__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.rowDoubleClick = function () {
	      return _this.__rowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.rowMouseOut = function () {
	      return _this.__rowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.rowMouseOver = function () {
	      return _this.__rowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.clickNum = 0;
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: '__rowMouseOver__REACT_HOT_LOADER__',
	    value: function __rowMouseOver__REACT_HOT_LOADER__() {
	      return this.__rowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__rowMouseOut__REACT_HOT_LOADER__',
	    value: function __rowMouseOut__REACT_HOT_LOADER__() {
	      return this.__rowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__rowDoubleClick__REACT_HOT_LOADER__',
	    value: function __rowDoubleClick__REACT_HOT_LOADER__() {
	      return this.__rowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__expandRow__REACT_HOT_LOADER__',
	    value: function __expandRow__REACT_HOT_LOADER__() {
	      return this.__expandRow__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__rowClick__REACT_HOT_LOADER__',
	    value: function __rowClick__REACT_HOT_LOADER__() {
	      return this.__rowClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__rowClick__REACT_HOT_LOADER__',
	    value: function __rowClick__REACT_HOT_LOADER__(e) {
	      var _this2 = this;
	
	      var rowIndex = this.props.index + 1;
	      var cellIndex = e.target.cellIndex;
	      if (this.props.onRowClick) this.props.onRowClick(rowIndex, cellIndex, e);
	      var _props = this.props,
	          selectRow = _props.selectRow,
	          unselectableRow = _props.unselectableRow,
	          isSelected = _props.isSelected,
	          onSelectRow = _props.onSelectRow,
	          onExpandRow = _props.onExpandRow,
	          dbClickToEdit = _props.dbClickToEdit;
	
	      if (selectRow) {
	        if (selectRow.clickToSelect && !unselectableRow) {
	          onSelectRow(rowIndex, !isSelected, e);
	        } else if (selectRow.clickToSelectAndEditCell && !unselectableRow) {
	          this.clickNum++;
	          /** if clickToSelectAndEditCell is enabled,
	           *  there should be a delay to prevent a selection changed when
	           *  user dblick to edit cell on same row but different cell
	          **/
	          setTimeout(function () {
	            if (_this2.clickNum === 1) {
	              onSelectRow(rowIndex, !isSelected, e);
	              onExpandRow(e, rowIndex, cellIndex);
	            }
	            _this2.clickNum = 0;
	          }, 200);
	        } else {
	          if (dbClickToEdit) {
	            this.expandRow(e, rowIndex, cellIndex);
	          }
	        }
	      }
	    }
	  }, {
	    key: '__expandRow__REACT_HOT_LOADER__',
	    value: function __expandRow__REACT_HOT_LOADER__(event, rowIndex, cellIndex) {
	      var _this3 = this;
	
	      this.clickNum++;
	      setTimeout(function () {
	        if (_this3.clickNum === 1) {
	          _this3.props.onExpandRow(event, rowIndex, cellIndex);
	        }
	        _this3.clickNum = 0;
	      }, 200);
	    }
	  }, {
	    key: '__rowDoubleClick__REACT_HOT_LOADER__',
	    value: function __rowDoubleClick__REACT_HOT_LOADER__(e) {
	      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'SELECT' && e.target.tagName !== 'TEXTAREA') {
	        if (this.props.onRowDoubleClick) {
	          this.props.onRowDoubleClick(this.props.index, e);
	        }
	      }
	    }
	  }, {
	    key: '__rowMouseOut__REACT_HOT_LOADER__',
	    value: function __rowMouseOut__REACT_HOT_LOADER__(e) {
	      var rowIndex = this.props.index;
	      if (this.props.onRowMouseOut) {
	        this.props.onRowMouseOut(rowIndex, e);
	      }
	    }
	  }, {
	    key: '__rowMouseOver__REACT_HOT_LOADER__',
	    value: function __rowMouseOver__REACT_HOT_LOADER__(e) {
	      var rowIndex = this.props.index;
	      if (this.props.onRowMouseOver) {
	        this.props.onRowMouseOver(rowIndex, e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.clickNum = 0;
	      var _props2 = this.props,
	          selectRow = _props2.selectRow,
	          row = _props2.row,
	          isSelected = _props2.isSelected,
	          className = _props2.className,
	          index = _props2.index,
	          hidden = _props2.hidden;
	      var style = this.props.style;
	
	      var backgroundColor = null;
	      var selectRowClass = null;
	
	      if (selectRow) {
	        backgroundColor = _util2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(row, isSelected) : isSelected ? selectRow.bgColor : null;
	
	        selectRowClass = _util2.default.isFunction(selectRow.className) ? selectRow.className(row, isSelected) : isSelected ? selectRow.className : null;
	      }
	
	      if (_util2.default.isFunction(style)) {
	        style = style(row, index);
	      } else {
	        style = _extends({}, style) || {};
	      }
	      // the bgcolor of row selection always overwrite the bgcolor defined by global.
	      if (style && backgroundColor && isSelected) {
	        style.backgroundColor = backgroundColor;
	      }
	      var trCss = {
	        style: _extends({}, style),
	        className: (0, _classnames2.default)(selectRowClass, className)
	      };
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({}, trCss, {
	          onMouseOver: this.rowMouseOver,
	          onMouseOut: this.rowMouseOut,
	          onClick: this.rowClick,
	          hidden: hidden,
	          onDoubleClick: this.rowDoubleClick }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.propTypes = {
	  index: _propTypes2.default.number,
	  row: _propTypes2.default.any,
	  style: _propTypes2.default.any,
	  isSelected: _propTypes2.default.bool,
	  enableCellEdit: _propTypes2.default.bool,
	  onRowClick: _propTypes2.default.func,
	  onRowDoubleClick: _propTypes2.default.func,
	  onSelectRow: _propTypes2.default.func,
	  onExpandRow: _propTypes2.default.func,
	  onRowMouseOut: _propTypes2.default.func,
	  onRowMouseOver: _propTypes2.default.func,
	  unselectableRow: _propTypes2.default.bool,
	  hidden: _propTypes2.default.bool
	};
	TableRow.defaultProps = {
	  onRowClick: undefined,
	  onRowDoubleClick: undefined,
	  hidden: false
	};
	var _default = TableRow;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableRow, 'TableRow', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');
	}();
	
	;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint block-scoped-var: 0 */
	/* eslint vars-on-top: 0 */
	/* eslint no-var: 0 */
	/* eslint no-unused-vars: 0 */
	if (_util2.default.canUseDOM()) {
	  var filesaver = __webpack_require__(1176);
	  var saveAs = filesaver.saveAs;
	}
	
	function toString(data, keys, separator, excludeCSVHeader) {
	  var dataString = '';
	  if (data.length === 0) return dataString;
	
	  var headCells = [];
	  var rowCount = 0;
	  keys.forEach(function (key) {
	    if (key.row > rowCount) {
	      rowCount = key.row;
	    }
	    // rowCount += (key.rowSpan + key.colSpan - 1);
	    for (var index = 0; index < key.colSpan; index++) {
	      headCells.push(key);
	    }
	  });
	
	  var firstRow = excludeCSVHeader ? 1 : 0;
	
	  var _loop = function _loop(i) {
	    dataString += headCells.map(function (x) {
	      if (x.row + (x.rowSpan - 1) === i) {
	        return '"' + x.header + '"';
	      }
	      if (x.row === i && x.rowSpan > 1) {
	        return '';
	      }
	    }).filter(function (key) {
	      return typeof key !== 'undefined';
	    }).join(separator) + '\n';
	  };
	
	  for (var i = firstRow; i <= rowCount; i++) {
	    _loop(i);
	  }
	
	  keys = keys.filter(function (key) {
	    return key.field !== undefined;
	  });
	
	  data.map(function (row) {
	    keys.map(function (col, i) {
	      var field = col.field,
	          format = col.format,
	          extraData = col.extraData,
	          type = col.type;
	
	      var value = typeof format !== 'undefined' ? format(row[field], row, extraData) : row[field];
	      value = type === _Const2.default.CSV_NUMBER_TYPE ? Number(value) : '"' + value + '"';
	      var cell = typeof value !== 'undefined' ? value : '';
	      dataString += cell;
	      if (i + 1 < keys.length) dataString += separator;
	    });
	
	    dataString += '\n';
	  });
	
	  return dataString;
	}
	
	var exportCSV = function exportCSV(data, keys, filename, separator, noAutoBOM, excludeCSVHeader) {
	  var dataString = toString(data, keys, separator, excludeCSVHeader);
	  if (typeof window !== 'undefined') {
	    noAutoBOM = noAutoBOM === undefined ? true : noAutoBOM;
	    saveAs(new Blob(['\uFEFF', dataString], { type: 'text/plain;charset=utf-8' }), filename, noAutoBOM);
	  }
	};
	
	var _default = exportCSV;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(saveAs, 'saveAs', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
	
	  __REACT_HOT_LOADER__.register(toString, 'toString', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
	
	  __REACT_HOT_LOADER__.register(exportCSV, 'exportCSV', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
	}();
	
	;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || function (view) {
		"use strict";
		// IE <10 is explicitly unsupported
	
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var doc = view.document
		// only get URL when necessary in case Blob.js hasn't overridden it yet
		,
		    get_URL = function get_URL() {
			return view.URL || view.webkitURL || view;
		},
		    save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"),
		    can_use_save_link = "download" in save_link,
		    click = function click(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		},
		    is_safari = /constructor/i.test(view.HTMLElement) || view.safari,
		    is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent),
		    throw_outside = function throw_outside(ex) {
			(view.setImmediate || view.setTimeout)(function () {
				throw ex;
			}, 0);
		},
		    force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		,
		    arbitrary_revoke_timeout = 1000 * 40 // in ms
		,
		    revoke = function revoke(file) {
			var revoker = function revoker() {
				if (typeof file === "string") {
					// file is an object URL
					get_URL().revokeObjectURL(file);
				} else {
					// file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		},
		    dispatch = function dispatch(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		},
		    auto_bom = function auto_bom(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
			}
			return blob;
		},
		    FileSaver = function FileSaver(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var filesaver = this,
			    type = blob.type,
			    force = type === force_saveable_type,
			    object_url,
			    dispatch_all = function dispatch_all() {
				dispatch(filesaver, "writestart progress write writeend".split(" "));
			}
			// on any filesys errors revert to saving with object URLs
			,
			    fs_error = function fs_error() {
				if ((is_chrome_ios || force && is_safari) && view.FileReader) {
					// Safari doesn't allow downloading of blob urls
					var reader = new FileReader();
					reader.onloadend = function () {
						var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
						var popup = view.open(url, '_blank');
						if (!popup) view.location.href = url;
						url = undefined; // release reference before dispatching
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
					};
					reader.readAsDataURL(blob);
					filesaver.readyState = filesaver.INIT;
					return;
				}
				// don't create more object URLs than needed
				if (!object_url) {
					object_url = get_URL().createObjectURL(blob);
				}
				if (force) {
					view.location.href = object_url;
				} else {
					var opened = view.open(object_url, "_blank");
					if (!opened) {
						// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
						view.location.href = object_url;
					}
				}
				filesaver.readyState = filesaver.DONE;
				dispatch_all();
				revoke(object_url);
			};
			filesaver.readyState = filesaver.INIT;
	
			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function () {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}
	
			fs_error();
		},
		    FS_proto = FileSaver.prototype,
		    saveAs = function saveAs(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		};
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function (blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function () {};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
	
		return saveAs;
	}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content);
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
		module.exports.saveAs = saveAs;
	} else if ("function" !== "undefined" && __webpack_require__(1632) !== null && __webpack_require__(767) !== null) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return saveAs;
		}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	;
	
	var _temp = function () {
		if (typeof __REACT_HOT_LOADER__ === 'undefined') {
			return;
		}
	
		__REACT_HOT_LOADER__.register(saveAs, "saveAs", "/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filesaver.js");
	}();
	
	;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint quotes: 0 */
	/* eslint max-len: 0 */
	
	
	var legalComparators = ['=', '>', '>=', '<', '<=', '!='];
	
	function dateParser(d) {
	  return d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2);
	}
	
	var DateFilter = function (_Component) {
	  _inherits(DateFilter, _Component);
	
	  function DateFilter(props) {
	    _classCallCheck(this, DateFilter);
	
	    var _this = _possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));
	
	    _this.dateComparators = _this.props.dateComparators || legalComparators;
	    _this.filter = _this.filter.bind(_this);
	    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateFilter, [{
	    key: 'setDefaultDate',
	    value: function setDefaultDate() {
	      var defaultDate = '';
	      var defaultValue = this.props.defaultValue;
	
	      if (defaultValue && defaultValue.date) {
	        // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
	        defaultDate = dateParser(new Date(defaultValue.date));
	      }
	      return defaultDate;
	    }
	  }, {
	    key: 'onChangeComparator',
	    value: function onChangeComparator(event) {
	      var date = this.inputDate.value;
	      var comparator = event.target.value;
	      if (date === '') {
	        return;
	      }
	      date = new Date(date);
	      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
	    }
	  }, {
	    key: 'getComparatorOptions',
	    value: function getComparatorOptions() {
	      var optionTags = [];
	      optionTags.push(_react2.default.createElement('option', { key: '-1' }));
	      for (var i = 0; i < this.dateComparators.length; i++) {
	        optionTags.push(_react2.default.createElement(
	          'option',
	          { key: i, value: this.dateComparators[i] },
	          this.dateComparators[i]
	        ));
	      }
	      return optionTags;
	    }
	  }, {
	    key: 'filter',
	    value: function filter(event) {
	      var comparator = this.dateFilterComparator.value;
	      var dateValue = event.target.value;
	      if (dateValue) {
	        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
	      } else {
	        this.props.filterHandler(null, _Const2.default.FILTER_TYPE.DATE);
	      }
	    }
	  }, {
	    key: 'cleanFiltered',
	    value: function cleanFiltered() {
	      var value = this.setDefaultDate();
	      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
	      this.setState(function () {
	        return { isPlaceholderSelected: value === '' };
	      });
	      this.dateFilterComparator.value = comparator;
	      this.inputDate.value = value;
	      this.props.filterHandler({ date: new Date(value), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter(filterDateObj) {
	      var date = filterDateObj.date,
	          comparator = filterDateObj.comparator;
	
	      this.setState(function () {
	        return { isPlaceholderSelected: date === '' };
	      });
	      this.dateFilterComparator.value = comparator;
	      this.inputDate.value = dateParser(date);
	      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var comparator = this.dateFilterComparator.value;
	      var dateValue = this.inputDate.value;
	      if (comparator && dateValue) {
	        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          _props$style = _props.style,
	          date = _props$style.date,
	          comparator = _props$style.comparator;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'filter date-filter' },
	        _react2.default.createElement(
	          'select',
	          { ref: function ref(n) {
	              return _this2.dateFilterComparator = n;
	            },
	            style: comparator,
	            className: 'date-filter-comparator form-control',
	            onChange: this.onChangeComparator,
	            defaultValue: defaultValue ? defaultValue.comparator : '' },
	          this.getComparatorOptions()
	        ),
	        _react2.default.createElement('input', { ref: function ref(n) {
	            return _this2.inputDate = n;
	          },
	          className: 'filter date-filter-input form-control',
	          style: date,
	          type: 'date',
	          onChange: this.filter,
	          defaultValue: this.setDefaultDate() })
	      );
	    }
	  }]);
	
	  return DateFilter;
	}(_react.Component);
	
	DateFilter.propTypes = {
	  filterHandler: _propTypes2.default.func.isRequired,
	  defaultValue: _propTypes2.default.shape({
	    date: _propTypes2.default.object,
	    comparator: _propTypes2.default.oneOf(legalComparators)
	  }),
	  style: _propTypes2.default.shape({
	    date: _propTypes2.default.oneOfType([_propTypes2.default.object]),
	    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
	  }),
	  /* eslint consistent-return: 0 */
	  dateComparators: function dateComparators(props, propName) {
	    if (!props[propName]) {
	      return;
	    }
	    for (var i = 0; i < props[propName].length; i++) {
	      var comparatorIsValid = false;
	      for (var j = 0; j < legalComparators.length; j++) {
	        if (legalComparators[j] === props[propName][i]) {
	          comparatorIsValid = true;
	          break;
	        }
	      }
	      if (!comparatorIsValid) {
	        return new Error('Date comparator provided is not supported.\n          Use only ' + legalComparators);
	      }
	    }
	  },
	  columnName: _propTypes2.default.any
	};
	
	DateFilter.defaultProps = {
	  style: {
	    date: null,
	    comparator: null
	  }
	};
	
	var _default = DateFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
	
	  __REACT_HOT_LOADER__.register(dateParser, 'dateParser', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
	
	  __REACT_HOT_LOADER__.register(DateFilter, 'DateFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
	}();
	
	;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var legalComparators = ['=', '>', '>=', '<', '<=', '!='];
	
	var NumberFilter = function (_Component) {
	  _inherits(NumberFilter, _Component);
	
	  function NumberFilter(props) {
	    _classCallCheck(this, NumberFilter);
	
	    var _this = _possibleConstructorReturn(this, (NumberFilter.__proto__ || Object.getPrototypeOf(NumberFilter)).call(this, props));
	
	    _this.numberComparators = _this.props.numberComparators || legalComparators;
	    _this.timeout = null;
	    _this.state = {
	      isPlaceholderSelected: _this.props.defaultValue === undefined || _this.props.defaultValue.number === undefined || _this.props.options && _this.props.options.indexOf(_this.props.defaultValue.number) === -1
	    };
	    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
	    _this.onChangeNumberSet = _this.onChangeNumberSet.bind(_this);
	    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
	    return _this;
	  }
	
	  _createClass(NumberFilter, [{
	    key: 'onChangeNumber',
	    value: function onChangeNumber(event) {
	      var _this2 = this;
	
	      var comparator = this.numberFilterComparator.value;
	      if (comparator === '') {
	        return;
	      }
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	      var filterValue = event.target.value;
	      this.timeout = setTimeout(function () {
	        _this2.props.filterHandler({ number: filterValue, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
	      }, this.props.delay);
	    }
	  }, {
	    key: 'onChangeNumberSet',
	    value: function onChangeNumberSet(event) {
	      var comparator = this.numberFilterComparator.value;
	      var value = event.target.value;
	
	      this.setState(function () {
	        return { isPlaceholderSelected: value === '' };
	      });
	      if (comparator === '') {
	        return;
	      }
	      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
	    }
	  }, {
	    key: 'onChangeComparator',
	    value: function onChangeComparator(event) {
	      var value = this.numberFilter.value;
	      var comparator = event.target.value;
	      if (value === '') {
	        return;
	      }
	      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
	    }
	  }, {
	    key: 'cleanFiltered',
	    value: function cleanFiltered() {
	      var value = this.props.defaultValue ? this.props.defaultValue.number : '';
	      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
	      this.setState(function () {
	        return { isPlaceholderSelected: value === '' };
	      });
	      this.numberFilterComparator.value = comparator;
	      this.numberFilter.value = value;
	      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter(filterObj) {
	      var number = filterObj.number,
	          comparator = filterObj.comparator;
	
	      this.setState(function () {
	        return { isPlaceholderSelected: number === '' };
	      });
	      this.numberFilterComparator.value = comparator;
	      this.numberFilter.value = number;
	      this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
	    }
	  }, {
	    key: 'getComparatorOptions',
	    value: function getComparatorOptions() {
	      var optionTags = [];
	      var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;
	
	      if (!withoutEmptyComparatorOption) {
	        optionTags.push(_react2.default.createElement('option', { key: '-1' }));
	      }
	      for (var i = 0; i < this.numberComparators.length; i++) {
	        optionTags.push(_react2.default.createElement(
	          'option',
	          { key: i, value: this.numberComparators[i] },
	          this.numberComparators[i]
	        ));
	      }
	      return optionTags;
	    }
	  }, {
	    key: 'getNumberOptions',
	    value: function getNumberOptions() {
	      var optionTags = [];
	      var _props = this.props,
	          options = _props.options,
	          withoutEmptyNumberOption = _props.withoutEmptyNumberOption;
	
	      if (!withoutEmptyNumberOption) {
	        optionTags.push(_react2.default.createElement(
	          'option',
	          { key: '-1', value: '' },
	          this.props.placeholder || 'Select ' + this.props.columnName + '...'
	        ));
	      }
	      for (var i = 0; i < options.length; i++) {
	        optionTags.push(_react2.default.createElement(
	          'option',
	          { key: i, value: options[i] },
	          options[i]
	        ));
	      }
	      return optionTags;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var comparator = this.numberFilterComparator.value;
	      var number = this.numberFilter.value;
	      if (comparator && number) {
	        this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var selectClass = (0, _classnames2.default)('select-filter', 'number-filter-input', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'filter number-filter' },
	        _react2.default.createElement(
	          'select',
	          { ref: function ref(n) {
	              return _this3.numberFilterComparator = n;
	            },
	            style: this.props.style.comparator,
	            className: 'number-filter-comparator form-control',
	            onChange: this.onChangeComparator,
	            defaultValue: this.props.defaultValue ? this.props.defaultValue.comparator : '' },
	          this.getComparatorOptions()
	        ),
	        this.props.options ? _react2.default.createElement(
	          'select',
	          { ref: function ref(n) {
	              return _this3.numberFilter = n;
	            },
	            className: selectClass,
	            onChange: this.onChangeNumberSet,
	            defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' },
	          this.getNumberOptions()
	        ) : _react2.default.createElement('input', { ref: function ref(n) {
	            return _this3.numberFilter = n;
	          },
	          type: 'number',
	          style: this.props.style.number,
	          className: 'number-filter-input form-control',
	          placeholder: this.props.placeholder || 'Enter ' + this.props.columnName + '...',
	          onChange: this.onChangeNumber,
	          defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' })
	      );
	    }
	  }]);
	
	  return NumberFilter;
	}(_react.Component);
	
	NumberFilter.propTypes = {
	  filterHandler: _propTypes2.default.func.isRequired,
	  options: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  defaultValue: _propTypes2.default.shape({
	    number: _propTypes2.default.number,
	    comparator: _propTypes2.default.oneOf(legalComparators)
	  }),
	  style: _propTypes2.default.shape({
	    number: _propTypes2.default.oneOfType([_propTypes2.default.object]),
	    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
	  }),
	  delay: _propTypes2.default.number,
	  /* eslint consistent-return: 0 */
	  numberComparators: function numberComparators(props, propName) {
	    if (!props[propName]) {
	      return;
	    }
	    for (var i = 0; i < props[propName].length; i++) {
	      var comparatorIsValid = false;
	      for (var j = 0; j < legalComparators.length; j++) {
	        if (legalComparators[j] === props[propName][i]) {
	          comparatorIsValid = true;
	          break;
	        }
	      }
	      if (!comparatorIsValid) {
	        return new Error('Number comparator provided is not supported.\n          Use only ' + legalComparators);
	      }
	    }
	  },
	  placeholder: _propTypes2.default.string,
	  columnName: _propTypes2.default.any,
	  withoutEmptyComparatorOption: _propTypes2.default.bool,
	  withoutEmptyNumberOption: _propTypes2.default.bool
	};
	
	NumberFilter.defaultProps = {
	  delay: _Const2.default.FILTER_DELAY,
	  withoutEmptyComparatorOption: false,
	  withoutEmptyNumberOption: false,
	  style: {
	    number: null,
	    comparator: null
	  }
	};
	
	var _default = NumberFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
	
	  __REACT_HOT_LOADER__.register(NumberFilter, 'NumberFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
	}();
	
	;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegexFilter = function (_Component) {
	  _inherits(RegexFilter, _Component);
	
	  function RegexFilter(props) {
	    _classCallCheck(this, RegexFilter);
	
	    var _this = _possibleConstructorReturn(this, (RegexFilter.__proto__ || Object.getPrototypeOf(RegexFilter)).call(this, props));
	
	    _this.filter = _this.filter.bind(_this);
	    _this.timeout = null;
	    return _this;
	  }
	
	  _createClass(RegexFilter, [{
	    key: 'filter',
	    value: function filter(event) {
	      var _this2 = this;
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	      var filterValue = event.target.value;
	      this.timeout = setTimeout(function () {
	        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.REGEX);
	      }, this.props.delay);
	    }
	  }, {
	    key: 'cleanFiltered',
	    value: function cleanFiltered() {
	      var value = this.props.defaultValue ? this.props.defaultValue : '';
	      this.inputText.value = value;
	      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter(filterRegx) {
	      this.inputText.value = filterRegx;
	      this.props.filterHandler(filterRegx, _Const2.default.FILTER_TYPE.REGEX);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var value = this.inputText.value;
	      if (value) {
	        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.REGEX);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          placeholder = _props.placeholder,
	          columnName = _props.columnName,
	          style = _props.style;
	
	      return _react2.default.createElement('input', { ref: function ref(n) {
	          return _this3.inputText = n;
	        },
	        className: 'filter text-filter form-control',
	        type: 'text',
	        style: style,
	        onChange: this.filter,
	        placeholder: placeholder || 'Enter Regex for ' + columnName + '...',
	        defaultValue: defaultValue ? defaultValue : '' });
	    }
	  }]);
	
	  return RegexFilter;
	}(_react.Component);
	
	RegexFilter.propTypes = {
	  filterHandler: _propTypes2.default.func.isRequired,
	  defaultValue: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	  placeholder: _propTypes2.default.string,
	  columnName: _propTypes2.default.any,
	  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
	};
	
	RegexFilter.defaultProps = {
	  delay: _Const2.default.FILTER_DELAY
	};
	
	var _default = RegexFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RegexFilter, 'RegexFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');
	}();
	
	;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function optionsEquals(options1, options2) {
	  var keys = Object.keys(options1);
	  for (var k in keys) {
	    if (options1[k] !== options2[k]) {
	      return false;
	    }
	  }
	  return Object.keys(options1).length === Object.keys(options2).length;
	}
	
	var SelectFilter = function (_Component) {
	  _inherits(SelectFilter, _Component);
	
	  function SelectFilter(props) {
	    _classCallCheck(this, SelectFilter);
	
	    var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));
	
	    _this.filter = _this.filter.bind(_this);
	    _this.state = {
	      isPlaceholderSelected: _this.props.defaultValue === undefined || !_this.props.options.hasOwnProperty(_this.props.defaultValue)
	    };
	    return _this;
	  }
	
	  _createClass(SelectFilter, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var currentSelectValue = this.selectInput.value;
	      var isPlaceholderSelected = !currentSelectValue || currentSelectValue === '';
	      this.setState(function () {
	        return {
	          isPlaceholderSelected: isPlaceholderSelected
	        };
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var needFilter = false;
	      if (this.props.defaultValue !== prevProps.defaultValue) {
	        needFilter = true;
	      } else if (!optionsEquals(this.props.options, prevProps.options)) {
	        needFilter = true;
	      }
	      if (needFilter) {
	        var value = this.selectInput.value;
	        if (value) {
	          this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
	        }
	      }
	    }
	  }, {
	    key: 'filter',
	    value: function filter(event) {
	      var value = event.target.value;
	
	      this.setState(function () {
	        return { isPlaceholderSelected: value === '' };
	      });
	      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
	    }
	  }, {
	    key: 'cleanFiltered',
	    value: function cleanFiltered() {
	      var value = this.props.defaultValue !== undefined ? this.props.defaultValue : '';
	      this.setState(function () {
	        return { isPlaceholderSelected: value === '' };
	      });
	      this.selectInput.value = value;
	      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter(filterOption) {
	      filterOption = filterOption + '';
	      this.setState(function () {
	        return { isPlaceholderSelected: filterOption === '' };
	      });
	      this.selectInput.value = filterOption;
	      this.props.filterHandler(filterOption, _Const2.default.FILTER_TYPE.SELECT);
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var optionTags = [];
	      var _props = this.props,
	          options = _props.options,
	          placeholder = _props.placeholder,
	          columnName = _props.columnName,
	          selectText = _props.selectText,
	          withoutEmptyOption = _props.withoutEmptyOption;
	
	      var selectTextValue = selectText !== undefined ? selectText : 'Select';
	      if (!withoutEmptyOption) {
	        optionTags.push(_react2.default.createElement(
	          'option',
	          { key: '-1', value: '' },
	          placeholder || selectTextValue + ' ' + columnName + '...'
	        ));
	      }
	      Object.keys(options).map(function (key) {
	        optionTags.push(_react2.default.createElement(
	          'option',
	          { key: key, value: key },
	          options[key] + ''
	        ));
	      });
	      return optionTags;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var value = this.selectInput.value;
	      if (value) {
	        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selectClass = (0, _classnames2.default)('filter', 'select-filter', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });
	
	      return _react2.default.createElement(
	        'select',
	        { ref: function ref(n) {
	            return _this2.selectInput = n;
	          },
	          style: this.props.style,
	          className: selectClass,
	          onChange: this.filter,
	          defaultValue: this.props.defaultValue !== undefined ? this.props.defaultValue : '' },
	        this.getOptions()
	      );
	    }
	  }]);
	
	  return SelectFilter;
	}(_react.Component);
	
	SelectFilter.propTypes = {
	  filterHandler: _propTypes2.default.func.isRequired,
	  options: _propTypes2.default.object.isRequired,
	  placeholder: _propTypes2.default.string,
	  columnName: _propTypes2.default.any,
	  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
	};
	
	var _default = SelectFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(optionsEquals, 'optionsEquals', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
	
	  __REACT_HOT_LOADER__.register(SelectFilter, 'SelectFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
	}();
	
	;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFilter = function (_Component) {
	  _inherits(TextFilter, _Component);
	
	  function TextFilter(props) {
	    _classCallCheck(this, TextFilter);
	
	    var _this = _possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));
	
	    _this.filter = _this.filter.bind(_this);
	    _this.timeout = null;
	    _this.state = {
	      value: _this.props.defaultValue || ''
	    };
	    return _this;
	  }
	
	  _createClass(TextFilter, [{
	    key: 'filter',
	    value: function filter(event) {
	      var _this2 = this;
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	      var filterValue = event.target.value;
	      this.setState(function () {
	        return { value: filterValue };
	      });
	      this.timeout = setTimeout(function () {
	        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.TEXT);
	      }, this.props.delay);
	    }
	  }, {
	    key: 'cleanFiltered',
	    value: function cleanFiltered() {
	      var value = this.props.defaultValue ? this.props.defaultValue : '';
	      this.setState(function () {
	        return { value: value };
	      });
	      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
	    }
	  }, {
	    key: 'applyFilter',
	    value: function applyFilter(filterText) {
	      this.setState(function () {
	        return { value: filterText };
	      });
	      this.props.filterHandler(filterText, _Const2.default.FILTER_TYPE.TEXT);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var defaultValue = this.inputText.value;
	      if (defaultValue) {
	        this.props.filterHandler(defaultValue, _Const2.default.FILTER_TYPE.TEXT);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.defaultValue !== this.props.defaultValue) {
	        this.applyFilter(nextProps.defaultValue || '');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          placeholder = _props.placeholder,
	          columnName = _props.columnName,
	          style = _props.style;
	
	      return _react2.default.createElement('input', { ref: function ref(n) {
	          return _this3.inputText = n;
	        },
	        className: 'filter text-filter form-control',
	        type: 'text',
	        style: style,
	        onChange: this.filter,
	        placeholder: placeholder || 'Enter ' + columnName + '...',
	        value: this.state.value });
	    }
	  }]);
	
	  return TextFilter;
	}(_react.Component);
	
	TextFilter.propTypes = {
	  filterHandler: _propTypes2.default.func.isRequired,
	  defaultValue: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	  placeholder: _propTypes2.default.string,
	  columnName: _propTypes2.default.any,
	  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
	};
	
	TextFilter.defaultProps = {
	  delay: _Const2.default.FILTER_DELAY
	};
	
	var _default = TextFilter;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TextFilter, 'TextFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');
	}();
	
	;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageButton = function (_Component) {
	  _inherits(PageButton, _Component);
	
	  function PageButton(props) {
	    _classCallCheck(this, PageButton);
	
	    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));
	
	    _this.pageBtnClick = function () {
	      return _this.__pageBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    return _this;
	  }
	
	  _createClass(PageButton, [{
	    key: '__pageBtnClick__REACT_HOT_LOADER__',
	    value: function __pageBtnClick__REACT_HOT_LOADER__() {
	      return this.__pageBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__pageBtnClick__REACT_HOT_LOADER__',
	    value: function __pageBtnClick__REACT_HOT_LOADER__(e) {
	      e.preventDefault();
	      this.props.changePage(this.props.pageNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)({
	        'active': this.props.active,
	        'disabled': this.props.disable,
	        'hidden': this.props.hidden,
	        'page-item': true
	      });
	      return _react2.default.createElement(
	        'li',
	        { className: classes, title: this.props.title },
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.pageBtnClick, className: 'page-link' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return PageButton;
	}(_react.Component);
	
	PageButton.propTypes = {
	  title: _propTypes2.default.string,
	  changePage: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  disable: _propTypes2.default.bool,
	  hidden: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  pageNumber: _propTypes2.default.number
	};
	
	var _default = PageButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PageButton, 'PageButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');
	}();
	
	;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PageButton = __webpack_require__(1182);
	
	var _PageButton2 = _interopRequireDefault(_PageButton);
	
	var _SizePerPageDropDown = __webpack_require__(614);
	
	var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _util = __webpack_require__(48);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginationList = function (_Component) {
	  _inherits(PaginationList, _Component);
	
	  function PaginationList(props) {
	    _classCallCheck(this, PaginationList);
	
	    var _this = _possibleConstructorReturn(this, (PaginationList.__proto__ || Object.getPrototypeOf(PaginationList)).call(this, props));
	
	    _this.changePage = function () {
	      return _this.__changePage__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.changeSizePerPage = function () {
	      return _this.__changeSizePerPage__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.toggleDropDown = function () {
	      return _this.__toggleDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeDropDown = function () {
	      return _this.__closeDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      open: _this.props.open
	    };
	    return _this;
	  }
	
	  _createClass(PaginationList, [{
	    key: '__closeDropDown__REACT_HOT_LOADER__',
	    value: function __closeDropDown__REACT_HOT_LOADER__() {
	      return this.__closeDropDown__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__toggleDropDown__REACT_HOT_LOADER__',
	    value: function __toggleDropDown__REACT_HOT_LOADER__() {
	      return this.__toggleDropDown__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__changeSizePerPage__REACT_HOT_LOADER__',
	    value: function __changeSizePerPage__REACT_HOT_LOADER__() {
	      return this.__changeSizePerPage__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__changePage__REACT_HOT_LOADER__',
	    value: function __changePage__REACT_HOT_LOADER__() {
	      return this.__changePage__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var keepSizePerPageState = this.props.keepSizePerPageState;
	
	      if (!keepSizePerPageState) {
	        this.closeDropDown();
	      }
	    }
	  }, {
	    key: '__changePage__REACT_HOT_LOADER__',
	    value: function __changePage__REACT_HOT_LOADER__(page) {
	      var _props = this.props,
	          pageStartIndex = _props.pageStartIndex,
	          prePage = _props.prePage,
	          currPage = _props.currPage,
	          nextPage = _props.nextPage,
	          lastPage = _props.lastPage,
	          firstPage = _props.firstPage,
	          sizePerPage = _props.sizePerPage,
	          keepSizePerPageState = _props.keepSizePerPageState;
	
	
	      if (page === prePage) {
	        page = currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
	      } else if (page === nextPage) {
	        page = currPage + 1 > this.lastPage ? this.lastPage : currPage + 1;
	      } else if (page === lastPage) {
	        page = this.lastPage;
	      } else if (page === firstPage) {
	        page = pageStartIndex;
	      } else {
	        page = parseInt(page, 10);
	      }
	
	      if (keepSizePerPageState) {
	        this.closeDropDown();
	      }
	
	      if (page !== currPage) {
	        this.props.changePage(page, sizePerPage);
	      }
	    }
	  }, {
	    key: '__changeSizePerPage__REACT_HOT_LOADER__',
	    value: function __changeSizePerPage__REACT_HOT_LOADER__(pageNum) {
	      var selectSize = typeof pageNum === 'string' ? parseInt(pageNum, 10) : pageNum;
	      var currPage = this.props.currPage;
	
	      if (selectSize !== this.props.sizePerPage) {
	        this.totalPages = Math.ceil(this.props.dataSize / selectSize);
	        this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
	        if (currPage > this.lastPage) currPage = this.lastPage;
	        this.props.changePage(currPage, selectSize);
	        if (this.props.onSizePerPageList) {
	          this.props.onSizePerPageList(selectSize);
	        }
	      }
	
	      this.closeDropDown();
	    }
	  }, {
	    key: '__toggleDropDown__REACT_HOT_LOADER__',
	    value: function __toggleDropDown__REACT_HOT_LOADER__() {
	      var _this2 = this;
	
	      this.setState(function () {
	        return {
	          open: !_this2.state.open
	        };
	      });
	    }
	  }, {
	    key: '__closeDropDown__REACT_HOT_LOADER__',
	    value: function __closeDropDown__REACT_HOT_LOADER__() {
	      this.setState(function () {
	        return {
	          open: false
	        };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          currPage = _props2.currPage,
	          dataSize = _props2.dataSize,
	          sizePerPage = _props2.sizePerPage,
	          sizePerPageList = _props2.sizePerPageList,
	          paginationShowsTotal = _props2.paginationShowsTotal,
	          pageStartIndex = _props2.pageStartIndex,
	          paginationPanel = _props2.paginationPanel,
	          hidePageListOnlyOnePage = _props2.hidePageListOnlyOnePage;
	
	      this.totalPages = Math.ceil(dataSize / sizePerPage);
	      this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
	      var pageBtns = this.makePage(_util2.default.isFunction(paginationPanel));
	      var dropdown = this.makeDropDown();
	
	      var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
	      var start = (currPage - pageStartIndex) * sizePerPage;
	      start = dataSize === 0 ? 0 : start + 1;
	      var to = Math.min(sizePerPage * (currPage + offset) - 1, dataSize);
	      if (to >= dataSize) to--;
	      var total = paginationShowsTotal ? _react2.default.createElement(
	        'span',
	        null,
	        'Showing rows ',
	        start,
	        ' to\xA0',
	        to + 1,
	        ' of\xA0',
	        dataSize
	      ) : null;
	
	      if (_util2.default.isFunction(paginationShowsTotal)) {
	        total = paginationShowsTotal(start, to + 1, dataSize);
	      }
	
	      var content = paginationPanel && paginationPanel({
	        currPage: currPage,
	        sizePerPage: sizePerPage,
	        sizePerPageList: sizePerPageList,
	        pageStartIndex: pageStartIndex,
	        totalPages: this.totalPages,
	        changePage: this.changePage,
	        toggleDropDown: this.toggleDropDown,
	        changeSizePerPage: this.changeSizePerPage,
	        components: {
	          totalText: total,
	          sizePerPageDropdown: dropdown,
	          pageList: pageBtns
	        }
	      });
	
	      var hidePageList = hidePageListOnlyOnePage && this.totalPages === 1 ? 'none' : 'block';
	      return _react2.default.createElement(
	        'div',
	        { className: 'row', style: { marginTop: 15 } },
	        content || [_react2.default.createElement(
	          'div',
	          { key: 'paging-left', className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
	          total,
	          sizePerPageList.length > 1 ? dropdown : null
	        ), _react2.default.createElement(
	          'div',
	          { key: 'paging-right', style: { display: hidePageList },
	            className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
	          pageBtns
	        )]
	      );
	    }
	  }, {
	    key: 'makeDropDown',
	    value: function makeDropDown() {
	      var _this3 = this;
	
	      var dropdown = void 0;
	      var dropdownProps = void 0;
	      var sizePerPageText = '';
	      var _props3 = this.props,
	          sizePerPageDropDown = _props3.sizePerPageDropDown,
	          hideSizePerPage = _props3.hideSizePerPage,
	          sizePerPage = _props3.sizePerPage,
	          sizePerPageList = _props3.sizePerPageList;
	
	      if (sizePerPageDropDown) {
	        dropdown = sizePerPageDropDown({
	          open: this.state.open,
	          hideSizePerPage: hideSizePerPage,
	          currSizePerPage: String(sizePerPage),
	          sizePerPageList: sizePerPageList,
	          toggleDropDown: this.toggleDropDown,
	          changeSizePerPage: this.changeSizePerPage,
	          onBlur: this.closeDropDown
	        });
	        if (dropdown.type.name === _SizePerPageDropDown2.default.name) {
	          dropdownProps = dropdown.props;
	        } else {
	          return dropdown;
	        }
	      }
	
	      if (dropdownProps || !dropdown) {
	        var isBootstrap4 = _util2.default.isBootstrap4(this.props.version);
	        var sizePerPageOptions = sizePerPageList.map(function (_sizePerPage) {
	          var pageText = _sizePerPage.text || _sizePerPage;
	          var pageNum = _sizePerPage.value || _sizePerPage;
	          if (sizePerPage === pageNum) sizePerPageText = pageText;
	          if (isBootstrap4) {
	            return _react2.default.createElement(
	              'a',
	              {
	                href: '#',
	                tabIndex: '-1',
	                key: pageText,
	                className: 'dropdown-item',
	                onMouseDown: function onMouseDown(e) {
	                  e.preventDefault();
	                  _this3.changeSizePerPage(pageNum);
	                } },
	              pageText
	            );
	          } else {
	            return _react2.default.createElement(
	              'li',
	              { key: pageText, role: 'presentation', className: 'dropdown-item' },
	              _react2.default.createElement(
	                'a',
	                { role: 'menuitem',
	                  tabIndex: '-1', href: '#',
	                  'data-page': pageNum,
	                  onMouseDown: function onMouseDown(e) {
	                    e.preventDefault();
	                    _this3.changeSizePerPage(pageNum);
	                  } },
	                pageText
	              )
	            );
	          }
	        });
	        dropdown = _react2.default.createElement(_SizePerPageDropDown2.default, _extends({
	          open: this.state.open,
	          hidden: hideSizePerPage,
	          currSizePerPage: String(sizePerPageText),
	          options: sizePerPageOptions,
	          onClick: this.toggleDropDown,
	          onBlur: this.closeDropDown,
	          isBootstrap4: isBootstrap4
	        }, dropdownProps));
	      }
	      return dropdown;
	    }
	  }, {
	    key: 'makePage',
	    value: function makePage() {
	      var _this4 = this;
	
	      var isCustomPagingPanel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var pages = this.getPages();
	      var isStart = function isStart(page, _ref) {
	        var currPage = _ref.currPage,
	            pageStartIndex = _ref.pageStartIndex,
	            firstPage = _ref.firstPage,
	            prePage = _ref.prePage;
	        return currPage === pageStartIndex && (page === firstPage || page === prePage);
	      };
	      var isEnd = function isEnd(page, _ref2) {
	        var currPage = _ref2.currPage,
	            nextPage = _ref2.nextPage,
	            lastPage = _ref2.lastPage;
	        return currPage === _this4.lastPage && (page === nextPage || page === lastPage);
	      };
	      var pageBtns = pages.filter(function (page) {
	        if (this.props.alwaysShowAllBtns) {
	          return true;
	        }
	        return isStart(page, this.props) || isEnd(page, this.props) ? false : true;
	      }, this).map(function (page, index) {
	        var isActive = page === this.props.currPage;
	        var isDisabled = isStart(page, this.props) || isEnd(page, this.props) ? true : false;
	        var title = page + '';
	        var pageNumber = page;
	
	        if (page === this.props.nextPage) {
	          title = this.props.nextPageTitle;
	          pageNumber = this.props.currPage + 1;
	        } else if (page === this.props.prePage) {
	          title = this.props.prePageTitle;
	          pageNumber = this.props.currPage - 1;
	        } else if (page === this.props.firstPage) {
	          title = this.props.firstPageTitle;
	          pageNumber = this.props.pageStartIndex;
	        } else if (page === this.props.lastPage) {
	          title = this.props.lastPageTitle;
	          pageNumber = this.getLastPage();
	        }
	
	        return _react2.default.createElement(
	          _PageButton2.default,
	          { key: index,
	            title: title,
	            changePage: this.changePage,
	            active: isActive,
	            disable: isDisabled,
	            pageNumber: pageNumber },
	          page
	        );
	      }, this);
	      var classname = (0, _classnames2.default)(isCustomPagingPanel ? null : 'react-bootstrap-table-page-btns-ul', 'pagination');
	      return _react2.default.createElement(
	        'ul',
	        { className: classname },
	        pageBtns
	      );
	    }
	  }, {
	    key: 'getLastPage',
	    value: function getLastPage() {
	      return this.lastPage;
	    }
	  }, {
	    key: 'getPages',
	    value: function getPages() {
	      var pages = void 0;
	      var endPage = this.totalPages;
	      if (endPage <= 0) return [];
	      var startPage = Math.max(this.props.currPage - Math.floor(this.props.paginationSize / 2), this.props.pageStartIndex);
	      endPage = startPage + this.props.paginationSize - 1;
	
	      if (endPage > this.lastPage) {
	        endPage = this.lastPage;
	        startPage = endPage - this.props.paginationSize + 1;
	      }
	
	      if (startPage !== this.props.pageStartIndex && this.totalPages > this.props.paginationSize && this.props.withFirstAndLast) {
	        pages = [this.props.firstPage, this.props.prePage];
	      } else if (this.totalPages > 1 || this.props.alwaysShowAllBtns) {
	        pages = [this.props.prePage];
	      } else {
	        pages = [];
	      }
	
	      for (var i = startPage; i <= endPage; i++) {
	        if (i >= this.props.pageStartIndex) pages.push(i);
	      }
	
	      if (endPage <= this.lastPage && pages.length > 1) {
	        pages.push(this.props.nextPage);
	      }
	      if (endPage !== this.lastPage && this.props.withFirstAndLast) {
	        pages.push(this.props.lastPage);
	      }
	
	      return pages;
	    }
	  }]);
	
	  return PaginationList;
	}(_react.Component);
	
	PaginationList.propTypes = {
	  currPage: _propTypes2.default.number,
	  sizePerPage: _propTypes2.default.number,
	  dataSize: _propTypes2.default.number,
	  changePage: _propTypes2.default.func,
	  sizePerPageList: _propTypes2.default.array,
	  paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	  paginationSize: _propTypes2.default.number,
	  onSizePerPageList: _propTypes2.default.func,
	  prePage: _propTypes2.default.any,
	  nextPage: _propTypes2.default.any,
	  firstPage: _propTypes2.default.any,
	  lastPage: _propTypes2.default.any,
	  pageStartIndex: _propTypes2.default.number,
	  hideSizePerPage: _propTypes2.default.bool,
	  alwaysShowAllBtns: _propTypes2.default.bool,
	  withFirstAndLast: _propTypes2.default.bool,
	  sizePerPageDropDown: _propTypes2.default.func,
	  paginationPanel: _propTypes2.default.func,
	  prePageTitle: _propTypes2.default.string,
	  nextPageTitle: _propTypes2.default.string,
	  firstPageTitle: _propTypes2.default.string,
	  lastPageTitle: _propTypes2.default.string,
	  hidePageListOnlyOnePage: _propTypes2.default.bool,
	  keepSizePerPageState: _propTypes2.default.bool
	};
	
	PaginationList.defaultProps = {
	  sizePerPage: _Const2.default.SIZE_PER_PAGE,
	  pageStartIndex: _Const2.default.PAGE_START_INDEX
	};
	
	var _default = PaginationList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PaginationList, 'PaginationList', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');
	}();
	
	;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableDataStore = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-nested-ternary: 0 */
	/* eslint guard-for-in: 0 */
	/* eslint no-console: 0 */
	/* eslint eqeqeq: 0 */
	/* eslint one-var: 0 */
	
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TableDataStore = function () {
	  function TableDataStore(data) {
	    var _this = this;
	
	    _classCallCheck(this, TableDataStore);
	
	    this.isValidKey = function () {
	      return _this.__isValidKey__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    this.data = data;
	    this.filteredData = null;
	    this.isOnFilter = false;
	    this.filterObj = null;
	    this.searchText = null;
	    this.sortList = [];
	    this.pageObj = {};
	    this.selected = [];
	    this.showOnlySelected = false;
	  }
	
	  _createClass(TableDataStore, [{
	    key: '__isValidKey__REACT_HOT_LOADER__',
	    value: function __isValidKey__REACT_HOT_LOADER__() {
	      return this.__isValidKey__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'setProps',
	    value: function setProps(props) {
	      this.keyField = props.keyField;
	      this.enablePagination = props.isPagination;
	      this.colInfos = props.colInfos;
	      this.remote = props.remote;
	      this.multiColumnSearch = props.multiColumnSearch;
	      // default behaviour if strictSearch prop is not provided: !multiColumnSearch
	      this.strictSearch = typeof props.strictSearch === 'undefined' ? !props.multiColumnSearch : props.strictSearch;
	      this.multiColumnSort = props.multiColumnSort;
	    }
	  }, {
	    key: 'clean',
	    value: function clean() {
	      this.filteredData = null;
	      this.isOnFilter = false;
	      this.filterObj = null;
	      this.searchText = null;
	      this.sortList = [];
	      this.pageObj = {};
	      this.selected = [];
	    }
	  }, {
	    key: 'isSearching',
	    value: function isSearching() {
	      return this.searchText !== null;
	    }
	  }, {
	    key: 'isFiltering',
	    value: function isFiltering() {
	      return this.filterObj !== null;
	    }
	  }, {
	    key: 'setData',
	    value: function setData(data) {
	      this.data = data;
	      if (this.remote) {
	        return;
	      }
	
	      this._refresh(true);
	    }
	  }, {
	    key: 'getColInfos',
	    value: function getColInfos() {
	      return this.colInfos;
	    }
	  }, {
	    key: 'getSortInfo',
	    value: function getSortInfo() {
	      return this.sortList;
	    }
	  }, {
	    key: 'setSortInfo',
	    value: function setSortInfo(order, sortField) {
	      if ((typeof order === 'undefined' ? 'undefined' : _typeof(order)) !== (typeof sortField === 'undefined' ? 'undefined' : _typeof(sortField))) {
	        throw new Error('The type of sort field and order should be both with String or Array');
	      }
	      if (Array.isArray(order) && Array.isArray(sortField)) {
	        if (order.length !== sortField.length) {
	          throw new Error('The length of sort fields and orders should be equivalent');
	        }
	        order = order.slice().reverse();
	        this.sortList = sortField.slice().reverse().map(function (field, i) {
	          return {
	            order: order[i],
	            sortField: field
	          };
	        });
	        this.sortList = this.sortList.slice(0, this.multiColumnSort);
	      } else {
	        var sortObj = {
	          order: order,
	          sortField: sortField
	        };
	
	        if (this.multiColumnSort > 1) {
	          var i = this.sortList.length - 1;
	          var sortFieldInHistory = false;
	
	          for (; i >= 0; i--) {
	            if (this.sortList[i].sortField === sortField) {
	              sortFieldInHistory = true;
	              break;
	            }
	          }
	
	          if (sortFieldInHistory) {
	            if (i > 0) {
	              this.sortList = this.sortList.slice(0, i);
	            } else {
	              this.sortList = this.sortList.slice(1);
	            }
	          }
	
	          this.sortList.unshift(sortObj);
	          this.sortList = this.sortList.slice(0, this.multiColumnSort);
	        } else {
	          this.sortList = [sortObj];
	        }
	      }
	    }
	  }, {
	    key: 'cleanSortInfo',
	    value: function cleanSortInfo() {
	      this.sortList = [];
	    }
	  }, {
	    key: 'setSelectedRowKey',
	    value: function setSelectedRowKey(selectedRowKeys) {
	      this.selected = selectedRowKeys;
	    }
	  }, {
	    key: 'getRowByKey',
	    value: function getRowByKey(keys) {
	      var _this2 = this;
	
	      // Bad Performance #1164
	      // return keys.map(key => {
	      //   const result = this.data.filter(d => d[this.keyField] === key);
	      //   if (result.length !== 0) return result[0];
	      // });
	      var result = [];
	      if (!keys || keys.length === 0) {
	        return result;
	      }
	
	      var _loop = function _loop(i) {
	        var d = _this2.data[i];
	        if (keys.indexOf(d[_this2.keyField]) > -1) {
	          keys = keys.filter(function (k) {
	            return k !== d[_this2.keyField];
	          });
	          result.push(d);
	        }
	      };
	
	      for (var i = 0; i < this.data.length; i++) {
	        _loop(i);
	      }
	      return result;
	    }
	  }, {
	    key: 'getSelectedRowKeys',
	    value: function getSelectedRowKeys() {
	      return this.selected;
	    }
	  }, {
	    key: 'getCurrentDisplayData',
	    value: function getCurrentDisplayData() {
	      if (this.isOnFilter) return this.filteredData;else return this.data;
	    }
	  }, {
	    key: '_refresh',
	    value: function _refresh(skipSorting) {
	      if (this.isOnFilter) {
	        if (this.filterObj !== null) this.filter(this.filterObj);
	        if (this.searchText !== null) this.search(this.searchText);
	      }
	      if (!skipSorting && this.sortList.length > 0) {
	        this.sort();
	      }
	    }
	  }, {
	    key: 'ignoreNonSelected',
	    value: function ignoreNonSelected() {
	      var _this3 = this;
	
	      this.showOnlySelected = !this.showOnlySelected;
	      if (this.showOnlySelected) {
	        this.isOnFilter = true;
	        this.filteredData = this.data.filter(function (row) {
	          var result = _this3.selected.find(function (x) {
	            return row[_this3.keyField] === x;
	          });
	          return typeof result !== 'undefined' ? true : false;
	        });
	      } else {
	        this.isOnFilter = false;
	      }
	    }
	  }, {
	    key: 'sort',
	    value: function sort() {
	      var currentDisplayData = this.getCurrentDisplayData();
	
	      currentDisplayData = this._sort(currentDisplayData);
	
	      return this;
	    }
	  }, {
	    key: 'page',
	    value: function page(_page, sizePerPage) {
	      this.pageObj.end = _page * sizePerPage - 1;
	      this.pageObj.start = this.pageObj.end - (sizePerPage - 1);
	      return this;
	    }
	  }, {
	    key: 'edit',
	    value: function edit(newVal, rowIndex, fieldName) {
	      var currentDisplayData = this.getCurrentDisplayData();
	      var rowKeyCache = void 0;
	      if (!this.enablePagination) {
	        currentDisplayData[rowIndex][fieldName] = newVal;
	        rowKeyCache = currentDisplayData[rowIndex][this.keyField];
	      } else {
	        currentDisplayData[this.pageObj.start + rowIndex][fieldName] = newVal;
	        rowKeyCache = currentDisplayData[this.pageObj.start + rowIndex][this.keyField];
	      }
	      if (this.isOnFilter) {
	        this.data.forEach(function (row) {
	          if (row[this.keyField] === rowKeyCache) {
	            row[fieldName] = newVal;
	          }
	        }, this);
	        if (this.filterObj !== null) this.filter(this.filterObj);
	        if (this.searchText !== null) this.search(this.searchText);
	      }
	      return this;
	    }
	  }, {
	    key: 'addAtBegin',
	    value: function addAtBegin(newObj) {
	      if (!newObj[this.keyField] || newObj[this.keyField].toString() === '') {
	        throw new Error(this.keyField + ' can\'t be empty value.');
	      }
	      var currentDisplayData = this.getCurrentDisplayData();
	      currentDisplayData.forEach(function (row) {
	        if (row[this.keyField].toString() === newObj[this.keyField].toString()) {
	          throw new Error(this.keyField + ' ' + newObj[this.keyField] + ' already exists');
	        }
	      }, this);
	      currentDisplayData.unshift(newObj);
	      if (this.isOnFilter) {
	        this.data.unshift(newObj);
	      }
	      this._refresh(false);
	    }
	  }, {
	    key: 'add',
	    value: function add(newObj) {
	      var e = this.isValidKey(newObj[this.keyField]);
	      if (e) throw new Error(e);
	
	      var currentDisplayData = this.getCurrentDisplayData();
	      currentDisplayData.push(newObj);
	      if (this.isOnFilter) {
	        this.data.push(newObj);
	      }
	      this._refresh(false);
	    }
	  }, {
	    key: '__isValidKey__REACT_HOT_LOADER__',
	    value: function __isValidKey__REACT_HOT_LOADER__(key) {
	      var _this4 = this;
	
	      if (key === null || key === undefined || key.toString() === '') {
	        return this.keyField + ' can\'t be empty value.';
	      }
	      var currentDisplayData = this.getCurrentDisplayData();
	      var exist = currentDisplayData.find(function (row) {
	        return row[_this4.keyField].toString() === key.toString();
	      });
	      if (exist) return this.keyField + ' ' + key + ' already exists';
	    }
	  }, {
	    key: 'remove',
	    value: function remove(rowKey) {
	      var _this5 = this;
	
	      var currentDisplayData = this.getCurrentDisplayData();
	      var result = currentDisplayData.filter(function (row) {
	        return rowKey.indexOf(row[_this5.keyField]) === -1;
	      });
	
	      if (this.isOnFilter) {
	        this.data = this.data.filter(function (row) {
	          return rowKey.indexOf(row[_this5.keyField]) === -1;
	        });
	        this.filteredData = result;
	      } else {
	        this.data = result;
	      }
	    }
	  }, {
	    key: 'filter',
	    value: function filter(filterObj) {
	      if (Object.keys(filterObj).length === 0) {
	        this.filteredData = null;
	        this.isOnFilter = false;
	        this.filterObj = null;
	        if (this.searchText) this._search(this.data);
	      } else {
	        var source = this.data;
	        this.filterObj = filterObj;
	        if (this.searchText) {
	          this._search(source);
	          source = this.filteredData;
	        }
	        this._filter(source);
	      }
	    }
	  }, {
	    key: 'filterNumber',
	    value: function filterNumber(targetVal, filterVal, comparator) {
	      var valid = true;
	      switch (comparator) {
	        case '=':
	          {
	            if (targetVal != filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '>':
	          {
	            if (targetVal <= filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '>=':
	          {
	            if (targetVal < filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '<':
	          {
	            if (targetVal >= filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '<=':
	          {
	            if (targetVal > filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '!=':
	          {
	            if (targetVal == filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        default:
	          {
	            console.error('Number comparator provided is not supported');
	            break;
	          }
	      }
	      return valid;
	    }
	  }, {
	    key: 'filterDate',
	    value: function filterDate(targetVal, filterVal, comparator) {
	      if (!targetVal) return false;
	
	      var filterDate = filterVal.getDate();
	      var filterMonth = filterVal.getMonth();
	      var filterYear = filterVal.getFullYear();
	
	      if ((typeof targetVal === 'undefined' ? 'undefined' : _typeof(targetVal)) !== 'object') {
	        targetVal = new Date(targetVal);
	      }
	
	      var targetDate = targetVal.getDate();
	      var targetMonth = targetVal.getMonth();
	      var targetYear = targetVal.getFullYear();
	
	      var valid = true;
	      switch (comparator) {
	        case '=':
	          {
	            if (filterDate !== targetDate || filterMonth !== targetMonth || filterYear !== targetYear) {
	              valid = false;
	            }
	            break;
	          }
	        case '>':
	          {
	            if (targetVal <= filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '>=':
	          {
	            if (targetYear < filterYear) {
	              valid = false;
	            } else if (targetYear === filterYear && targetMonth < filterMonth) {
	              valid = false;
	            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate < filterDate) {
	              valid = false;
	            }
	            break;
	          }
	        case '<':
	          {
	            if (targetVal >= filterVal) {
	              valid = false;
	            }
	            break;
	          }
	        case '<=':
	          {
	            if (targetYear > filterYear) {
	              valid = false;
	            } else if (targetYear === filterYear && targetMonth > filterMonth) {
	              valid = false;
	            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate > filterDate) {
	              valid = false;
	            }
	            break;
	          }
	        case '!=':
	          {
	            if (filterDate === targetDate && filterMonth === targetMonth && filterYear === targetYear) {
	              valid = false;
	            }
	            break;
	          }
	        default:
	          {
	            console.error('Date comparator provided is not supported');
	            break;
	          }
	      }
	      return valid;
	    }
	  }, {
	    key: 'filterRegex',
	    value: function filterRegex(targetVal, filterVal) {
	      try {
	        return new RegExp(filterVal, 'i').test(targetVal);
	      } catch (e) {
	        return true;
	      }
	    }
	  }, {
	    key: 'filterCustom',
	    value: function filterCustom(targetVal, filterVal, callbackInfo, cond) {
	      if (callbackInfo !== null && (typeof callbackInfo === 'undefined' ? 'undefined' : _typeof(callbackInfo)) === 'object') {
	        return callbackInfo.callback(targetVal, callbackInfo.callbackParameters);
	      }
	
	      return this.filterText(targetVal, filterVal, cond);
	    }
	  }, {
	    key: 'filterText',
	    value: function filterText() {
	      var targetVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var filterVal = arguments[1];
	      var cond = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Const2.default.FILTER_COND_LIKE;
	
	      targetVal = targetVal === null ? '' : targetVal.toString();
	      filterVal = filterVal.toString();
	      if (cond === _Const2.default.FILTER_COND_EQ) {
	        return targetVal === filterVal;
	      } else {
	        targetVal = targetVal.toLowerCase();
	        filterVal = filterVal.toLowerCase();
	        return !(targetVal.indexOf(filterVal) === -1);
	      }
	    }
	
	    /**
	     * Filter if targetVal is contained in filterVal.
	     */
	
	  }, {
	    key: 'filterArray',
	    value: function filterArray(targetVal, filterVal) {
	      // case insensitive
	      return filterVal.indexOf(targetVal) > -1;
	    }
	
	    /* General search function
	     * It will search for the text if the input includes that text;
	     */
	
	  }, {
	    key: 'search',
	    value: function search(searchText) {
	      if (searchText.trim() === '') {
	        this.filteredData = null;
	        this.isOnFilter = false;
	        this.searchText = null;
	        if (this.filterObj) this._filter(this.data);
	      } else {
	        var source = this.data;
	        this.searchText = searchText;
	        if (this.filterObj) {
	          this._filter(source);
	          source = this.filteredData;
	        }
	        this._search(source);
	      }
	    }
	  }, {
	    key: '_filter',
	    value: function _filter(source) {
	      var _this6 = this;
	
	      var filterObj = this.filterObj;
	      this.filteredData = source.filter(function (row, r) {
	        var valid = true;
	        var filterVal = void 0;
	        for (var key in filterObj) {
	          var targetVal = row[key];
	          if (targetVal === null || targetVal === undefined) {
	            targetVal = '';
	          }
	
	          switch (filterObj[key].type) {
	            case _Const2.default.FILTER_TYPE.NUMBER:
	              {
	                filterVal = filterObj[key].value.number;
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.CUSTOM:
	              {
	                filterVal = _typeof(filterObj[key].value) === 'object' ? undefined : typeof filterObj[key].value === 'string' ? filterObj[key].value.toLowerCase() : filterObj[key].value;
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.DATE:
	              {
	                filterVal = filterObj[key].value.date;
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.REGEX:
	              {
	                filterVal = filterObj[key].value;
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.ARRAY:
	              {
	                filterVal = filterObj[key].value;
	                if (!Array.isArray(filterVal)) {
	                  throw new Error('Value must be an Array');
	                }
	                break;
	              }
	            default:
	              {
	                filterVal = filterObj[key].value;
	                if (filterVal === undefined) {
	                  // Support old filter
	                  filterVal = filterObj[key];
	                }
	                break;
	              }
	          }
	          var format = void 0,
	              filterFormatted = void 0,
	              formatExtraData = void 0,
	              filterValue = void 0;
	          if (_this6.colInfos[key]) {
	            format = _this6.colInfos[key].format;
	            filterFormatted = _this6.colInfos[key].filterFormatted;
	            formatExtraData = _this6.colInfos[key].formatExtraData;
	            filterValue = _this6.colInfos[key].filterValue;
	            if (filterFormatted && format) {
	              targetVal = format(row[key], row, formatExtraData, r);
	            } else if (filterValue) {
	              targetVal = filterValue(row[key], row);
	            }
	          }
	
	          switch (filterObj[key].type) {
	            case _Const2.default.FILTER_TYPE.NUMBER:
	              {
	                valid = _this6.filterNumber(targetVal, filterVal, filterObj[key].value.comparator);
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.DATE:
	              {
	                valid = _this6.filterDate(targetVal, filterVal, filterObj[key].value.comparator);
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.REGEX:
	              {
	                valid = _this6.filterRegex(targetVal, filterVal);
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.CUSTOM:
	              {
	                var cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
	                valid = _this6.filterCustom(targetVal, filterVal, filterObj[key].value, cond);
	                break;
	              }
	            case _Const2.default.FILTER_TYPE.ARRAY:
	              {
	                valid = _this6.filterArray(targetVal, filterVal);
	                break;
	              }
	            default:
	              {
	                if (filterObj[key].type === _Const2.default.FILTER_TYPE.SELECT && filterFormatted && filterFormatted && format) {
	                  filterVal = format(filterVal, row, formatExtraData, r);
	                }
	                var _cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
	                valid = _this6.filterText(targetVal, filterVal, _cond);
	                break;
	              }
	          }
	          if (!valid) {
	            break;
	          }
	        }
	        return valid;
	      });
	      this.isOnFilter = true;
	    }
	
	    /*
	     * Four different sort modes, all case insensitive:
	     * (1) strictSearch && !multiColumnSearch
	     *     search text must be contained as provided in a single column
	     * (2) strictSearch && multiColumnSearch
	     *     conjunction (AND combination) of whitespace separated terms over multiple columns
	     * (3) !strictSearch && !multiColumnSearch
	     *     conjunction (AND combination) of whitespace separated terms in a single column
	     * (4) !strictSearch && multiColumnSearch
	     *     any of the whitespace separated terms must be contained in any column
	     */
	
	  }, {
	    key: '_search',
	    value: function _search(source) {
	      var _this7 = this;
	
	      var searchTextArray = void 0;
	      if (this.multiColumnSearch || !this.strictSearch) {
	        // ignore leading and trailing whitespaces
	        searchTextArray = this.searchText.trim().toLowerCase().split(/\s+/);
	      } else {
	        searchTextArray = [this.searchText.toLowerCase()];
	      }
	      var searchTermCount = searchTextArray.length;
	      var multipleTerms = searchTermCount > 1;
	      var nonStrictMultiCol = multipleTerms && !this.strictSearch && this.multiColumnSearch;
	      var nonStrictSingleCol = multipleTerms && !this.strictSearch && !this.multiColumnSearch;
	      this.filteredData = source.filter(function (row, r) {
	        var keys = Object.keys(row);
	        // only clone array if necessary
	        var searchTerms = multipleTerms ? searchTextArray.slice() : searchTextArray;
	        // for loops are ugly, but performance matters here.
	        // And you cant break from a forEach.
	        // http://jsperf.com/for-vs-foreach/66
	        for (var i = 0, keysLength = keys.length; i < keysLength; i++) {
	          var key = keys[i];
	          var colInfo = _this7.colInfos[key];
	          if (colInfo && colInfo.searchable) {
	            var format = colInfo.format,
	                filterFormatted = colInfo.filterFormatted,
	                filterValue = colInfo.filterValue,
	                formatExtraData = colInfo.formatExtraData;
	
	            var targetVal = void 0;
	            if (filterFormatted && format) {
	              targetVal = format(row[key], row, formatExtraData, r);
	            } else if (filterValue) {
	              targetVal = filterValue(row[key], row);
	            } else {
	              targetVal = row[key];
	            }
	            if (targetVal !== null && typeof targetVal !== 'undefined') {
	              targetVal = targetVal.toString().toLowerCase();
	              if (nonStrictSingleCol && searchTermCount > searchTerms.length) {
	                // reset search terms for single column search
	                searchTerms = searchTextArray.slice();
	              }
	              for (var j = searchTerms.length - 1; j > -1; j--) {
	                if (targetVal.indexOf(searchTerms[j]) !== -1) {
	                  if (nonStrictMultiCol || searchTerms.length === 1) {
	                    // match found: the last or only one
	                    return true;
	                  }
	                  // match found: but there are more search terms to check for
	                  searchTerms.splice(j, 1);
	                } else if (!_this7.multiColumnSearch) {
	                  // one of the search terms was not found in this column
	                  break;
	                }
	              }
	            }
	          }
	        }
	        return false;
	      });
	      this.isOnFilter = true;
	    }
	  }, {
	    key: '_sort',
	    value: function _sort(arr) {
	      var _this8 = this;
	
	      if (this.sortList.length === 0 || typeof this.sortList[0] === 'undefined') {
	        return arr;
	      }
	
	      arr.sort(function (a, b) {
	        var result = 0;
	
	        for (var i = 0; i < _this8.sortList.length; i++) {
	          var sortDetails = _this8.sortList[i];
	          var isDesc = sortDetails.order.toLowerCase() === _Const2.default.SORT_DESC;
	
	          var _colInfos$sortDetails = _this8.colInfos[sortDetails.sortField],
	              sortFunc = _colInfos$sortDetails.sortFunc,
	              sortFuncExtraData = _colInfos$sortDetails.sortFuncExtraData;
	
	
	          if (sortFunc) {
	            result = sortFunc(a, b, sortDetails.order, sortDetails.sortField, sortFuncExtraData);
	          } else {
	            var valueA = a[sortDetails.sortField] == null ? '' : a[sortDetails.sortField];
	            var valueB = b[sortDetails.sortField] == null ? '' : b[sortDetails.sortField];
	
	            if (isDesc) {
	              if (typeof valueB === 'string') {
	                result = valueB.localeCompare(valueA);
	              } else {
	                result = valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
	              }
	            } else {
	              if (typeof valueA === 'string') {
	                result = valueA.localeCompare(valueB);
	              } else {
	                result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
	              }
	            }
	          }
	
	          if (result !== 0) {
	            return result;
	          }
	        }
	
	        return result;
	      });
	
	      return arr;
	    }
	  }, {
	    key: 'getDataIgnoringPagination',
	    value: function getDataIgnoringPagination() {
	      return this.getCurrentDisplayData();
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      var _data = this.getCurrentDisplayData();
	
	      if (_data.length === 0) return _data;
	
	      var remote = typeof this.remote === 'function' ? this.remote(_Const2.default.REMOTE)[_Const2.default.REMOTE_PAGE] : this.remote;
	
	      if (remote || !this.enablePagination) {
	        return _data;
	      } else {
	        var result = [];
	        for (var i = this.pageObj.start; i <= this.pageObj.end; i++) {
	          result.push(_data[i]);
	          if (i + 1 === _data.length) break;
	        }
	        return result;
	      }
	    }
	  }, {
	    key: 'getKeyField',
	    value: function getKeyField() {
	      return this.keyField;
	    }
	  }, {
	    key: 'getDataNum',
	    value: function getDataNum() {
	      return this.getCurrentDisplayData().length;
	    }
	  }, {
	    key: 'isChangedPage',
	    value: function isChangedPage() {
	      return this.pageObj.start && this.pageObj.end ? true : false;
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return this.data.length === 0 || this.data === null || this.data === undefined;
	    }
	  }, {
	    key: 'getAllRowkey',
	    value: function getAllRowkey() {
	      var _this9 = this;
	
	      return this.data.map(function (row) {
	        return row[_this9.keyField];
	      });
	    }
	  }]);
	
	  return TableDataStore;
	}();
	
	exports.TableDataStore = TableDataStore;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TableDataStore, 'TableDataStore', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/store/TableDataStore.js');
	}();
	
	;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonGroup = function (_Component) {
	  _inherits(ButtonGroup, _Component);
	
	  function ButtonGroup() {
	    _classCallCheck(this, ButtonGroup);
	
	    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
	  }
	
	  _createClass(ButtonGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          sizeClass = _props.sizeClass,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['className', 'sizeClass', 'children']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: 'btn-group ' + sizeClass + ' ' + className, role: 'group' }, rest),
	        children
	      );
	    }
	  }]);
	
	  return ButtonGroup;
	}(_react.Component);
	
	ButtonGroup.propTypes = {
	  sizeClass: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	ButtonGroup.defaultProps = {
	  sizeClass: 'btn-group-sm',
	  className: ''
	};
	
	var _default = ButtonGroup;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ButtonGroup, 'ButtonGroup', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');
	}();
	
	;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InsertModalHeader = __webpack_require__(621);
	
	var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);
	
	var _InsertModalFooter = __webpack_require__(620);
	
	var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);
	
	var _InsertModalBody = __webpack_require__(619);
	
	var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */
	
	var defaultModalClassName = 'react-bs-table-insert-modal';
	
	var InsertModal = function (_Component) {
	  _inherits(InsertModal, _Component);
	
	  function InsertModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InsertModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModal.__proto__ || Object.getPrototypeOf(InsertModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function () {
	      var _this2;
	
	      return (_this2 = _this).__handleSave__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InsertModal, [{
	    key: '__handleSave__REACT_HOT_LOADER__',
	    value: function __handleSave__REACT_HOT_LOADER__() {
	      return this.__handleSave__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSave__REACT_HOT_LOADER__',
	    value: function __handleSave__REACT_HOT_LOADER__() {
	      if (this.body.getFieldValue) {
	        this.props.onSave(this.body.getFieldValue());
	      } else {
	        console.error('Custom InsertModalBody should implement getFieldValue function\n        and should return an object presented as the new row that user input.');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          headerComponent = _props.headerComponent,
	          footerComponent = _props.footerComponent,
	          bodyComponent = _props.bodyComponent;
	      var _props2 = this.props,
	          columns = _props2.columns,
	          validateState = _props2.validateState,
	          ignoreEditable = _props2.ignoreEditable,
	          onModalClose = _props2.onModalClose;
	
	      var bodyAttr = { columns: columns, validateState: validateState, ignoreEditable: ignoreEditable };
	
	      bodyComponent = bodyComponent && bodyComponent(columns, validateState, ignoreEditable);
	
	      headerComponent = headerComponent && headerComponent(onModalClose, this.handleSave);
	
	      footerComponent = footerComponent && footerComponent(onModalClose, this.handleSave);
	
	      if (bodyComponent) {
	        bodyComponent = _react2.default.cloneElement(bodyComponent, { ref: function ref(node) {
	            return _this3.body = node;
	          } });
	      }
	
	      if (headerComponent && headerComponent.type.name === _InsertModalHeader2.default.name) {
	        var eventProps = {};
	        if (!headerComponent.props.onModalClose) eventProps.onModalClose = onModalClose;
	        if (!headerComponent.props.onSave) eventProps.onSave = this.handleSave;
	        if (Object.keys(eventProps).length > 0) {
	          headerComponent = _react2.default.cloneElement(headerComponent, eventProps);
	        }
	      } else if (headerComponent && headerComponent.type.name !== _InsertModalHeader2.default.name) {
	        var className = headerComponent.props.className;
	
	        if (typeof className === 'undefined' || className.indexOf('modal-header') === -1) {
	          headerComponent = _react2.default.createElement(
	            'div',
	            { className: 'modal-header' },
	            headerComponent
	          );
	        }
	      }
	
	      if (footerComponent && footerComponent.type.name === _InsertModalFooter2.default.name) {
	        var _eventProps = {};
	        if (!footerComponent.props.onModalClose) _eventProps.onModalClose = onModalClose;
	        if (!footerComponent.props.onSave) _eventProps.onSave = this.handleSave;
	        if (Object.keys(_eventProps).length > 0) {
	          footerComponent = _react2.default.cloneElement(footerComponent, _eventProps);
	        }
	      } else if (footerComponent && footerComponent.type.name !== _InsertModalFooter2.default.name) {
	        var _className = footerComponent.props.className;
	
	        if (typeof _className === 'undefined' || _className.indexOf('modal-footer') === -1) {
	          footerComponent = _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            footerComponent
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-content ' + defaultModalClassName },
	        headerComponent || _react2.default.createElement(_InsertModalHeader2.default, {
	          version: this.props.version,
	          className: 'react-bs-table-inser-modal-header',
	          onModalClose: onModalClose }),
	        bodyComponent || _react2.default.createElement(_InsertModalBody2.default, _extends({ ref: function ref(node) {
	            return _this3.body = node;
	          } }, bodyAttr)),
	        footerComponent || _react2.default.createElement(_InsertModalFooter2.default, {
	          className: 'react-bs-table-inser-modal-footer',
	          onModalClose: onModalClose,
	          onSave: this.handleSave })
	      );
	    }
	  }]);
	
	  return InsertModal;
	}(_react.Component);
	
	var _default = InsertModal;
	exports.default = _default;
	
	InsertModal.propTypes = {
	  version: _propTypes2.default.string.isRequired,
	  columns: _propTypes2.default.array.isRequired,
	  validateState: _propTypes2.default.object.isRequired,
	  ignoreEditable: _propTypes2.default.bool,
	  headerComponent: _propTypes2.default.func,
	  bodyComponent: _propTypes2.default.func,
	  footerComponent: _propTypes2.default.func,
	  onModalClose: _propTypes2.default.func,
	  onSave: _propTypes2.default.func
	};
	
	InsertModal.defaultProps = {};
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(defaultModalClassName, 'defaultModalClassName', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
	
	  __REACT_HOT_LOADER__.register(InsertModal, 'InsertModal', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
	}();
	
	;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(1412);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _Const = __webpack_require__(28);
	
	var _Const2 = _interopRequireDefault(_Const);
	
	var _Notification = __webpack_require__(612);
	
	var _InsertModal = __webpack_require__(1186);
	
	var _InsertModal2 = _interopRequireDefault(_InsertModal);
	
	var _InsertButton = __webpack_require__(618);
	
	var _InsertButton2 = _interopRequireDefault(_InsertButton);
	
	var _DeleteButton = __webpack_require__(616);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _ExportCSVButton = __webpack_require__(617);
	
	var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);
	
	var _ShowSelectedOnlyButton = __webpack_require__(623);
	
	var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);
	
	var _SearchField = __webpack_require__(622);
	
	var _SearchField2 = _interopRequireDefault(_SearchField);
	
	var _ClearSearchButton = __webpack_require__(615);
	
	var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */
	
	// import classSet from 'classnames';
	
	// import editor from '../Editor';
	
	
	var ToolBar = function (_Component) {
	  _inherits(ToolBar, _Component);
	
	  function ToolBar(props) {
	    _classCallCheck(this, ToolBar);
	
	    var _this = _possibleConstructorReturn(this, (ToolBar.__proto__ || Object.getPrototypeOf(ToolBar)).call(this, props));
	
	    _this.displayCommonMessage = function () {
	      return _this.__displayCommonMessage__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSaveBtnClick = function () {
	      return _this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.afterHandleSaveBtnClick = function () {
	      return _this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleModalClose = function () {
	      return _this.__handleModalClose__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleModalOpen = function () {
	      return _this.__handleModalOpen__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleShowOnlyToggle = function () {
	      return _this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleDropRowBtnClick = function () {
	      return _this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleDebounce = function () {
	      return _this.__handleDebounce__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleKeyUp = function () {
	      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleExportCSV = function () {
	      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleClearBtnClick = function () {
	      return _this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.timeouteClear = 0;
	    _this.modalClassName;
	    _this.state = {
	      isInsertModalOpen: false,
	      validateState: null,
	      shakeEditor: false,
	      showSelected: false
	    };
	    return _this;
	  }
	
	  _createClass(ToolBar, [{
	    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
	    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
	      return this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleExportCSV__REACT_HOT_LOADER__',
	    value: function __handleExportCSV__REACT_HOT_LOADER__() {
	      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleKeyUp__REACT_HOT_LOADER__',
	    value: function __handleKeyUp__REACT_HOT_LOADER__() {
	      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleDebounce__REACT_HOT_LOADER__',
	    value: function __handleDebounce__REACT_HOT_LOADER__(func, wait, immediate) {
	      var _this2 = this,
	          _arguments = arguments;
	
	      var timeout = void 0;
	
	      return function () {
	        var later = function later() {
	          timeout = null;
	
	          if (!immediate) {
	            func.apply(_this2, _arguments);
	          }
	        };
	
	        var callNow = immediate && !timeout;
	
	        clearTimeout(timeout);
	
	        timeout = setTimeout(later, wait || 0);
	
	        if (callNow) {
	          func.appy(_this2, _arguments);
	        }
	      };
	    }
	  }, {
	    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
	    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
	      return this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
	    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
	      return this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleModalOpen__REACT_HOT_LOADER__',
	    value: function __handleModalOpen__REACT_HOT_LOADER__() {
	      return this.__handleModalOpen__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleModalClose__REACT_HOT_LOADER__',
	    value: function __handleModalClose__REACT_HOT_LOADER__() {
	      return this.__handleModalClose__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
	    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__() {
	      return this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
	    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
	      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__displayCommonMessage__REACT_HOT_LOADER__',
	    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
	      return this.__displayCommonMessage__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var delay = this.props.searchDelayTime ? this.props.searchDelayTime : 0;
	      this.debounceCallback = this.handleDebounce(function () {
	        _this3.seachInput && _this3.props.onSearch(_this3.seachInput.getValue());
	      }, delay);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.reset) {
	        this.setSearchInput('');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: 'setSearchInput',
	    value: function setSearchInput(text) {
	      if (this.seachInput && this.seachInput.value !== text) {
	        this.seachInput.value = text;
	      }
	    }
	  }, {
	    key: 'clearTimeout',
	    value: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeouteClear) {
	        clearTimeout(this.timeouteClear);
	        this.timeouteClear = 0;
	      }
	    })
	  }, {
	    key: '__displayCommonMessage__REACT_HOT_LOADER__',
	    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
	      (0, _Notification.notice)('error', this.props.insertFailIndicator, '');
	    }
	  }, {
	    key: 'validateNewRow',
	    value: function validateNewRow(newRow) {
	      var _this4 = this;
	
	      var validateState = {};
	      var isValid = true;
	      var tempMsg = void 0;
	      var responseType = void 0;
	
	      this.props.columns.forEach(function (column) {
	        if (column.isKey && column.keyValidator) {
	          // key validator for checking exist key
	          tempMsg = _this4.props.isValidKey(newRow[column.field]);
	          if (tempMsg) {
	            _this4.displayCommonMessage();
	            isValid = false;
	            validateState[column.field] = tempMsg;
	          }
	        } else if (column.editable && column.editable.validator) {
	          // process validate
	          tempMsg = column.editable.validator(newRow[column.field], newRow);
	          responseType = typeof tempMsg === 'undefined' ? 'undefined' : _typeof(tempMsg);
	          if (responseType !== 'object' && tempMsg !== true) {
	            _this4.displayCommonMessage();
	            isValid = false;
	            validateState[column.field] = tempMsg;
	          } else if (responseType === 'object' && tempMsg.isValid !== true) {
	            (0, _Notification.notice)(tempMsg.notification.type, tempMsg.notification.msg, tempMsg.notification.title);
	            isValid = false;
	            validateState[column.field] = tempMsg.notification.msg;
	          }
	        }
	      });
	
	      if (isValid) {
	        return true;
	      } else {
	        this.clearTimeout();
	        // show error in form and shake it
	        this.setState(function () {
	          return { validateState: validateState, shakeEditor: true };
	        });
	        this.timeouteClear = setTimeout(function () {
	          _this4.setState(function () {
	            return { shakeEditor: false };
	          });
	        }, 300);
	        return null;
	      }
	    }
	  }, {
	    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
	    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(newRow) {
	      if (!this.validateNewRow(newRow)) {
	        // validation fail
	        return;
	      }
	      var msg = this.props.onAddRow(newRow);
	      if (msg !== false) {
	        this.afterHandleSaveBtnClick(msg);
	      }
	    }
	  }, {
	    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
	    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__(msg) {
	      var _this5 = this;
	
	      if (msg) {
	        (0, _Notification.notice)('error', msg, '');
	        this.clearTimeout();
	        // shake form and hack prevent modal hide
	        this.setState(function () {
	          return {
	            shakeEditor: true,
	            validateState: 'this is hack for prevent bootstrap modal hide'
	          };
	        });
	        // clear animate class
	        this.timeouteClear = setTimeout(function () {
	          _this5.setState(function () {
	            return { shakeEditor: false };
	          });
	        }, 300);
	      } else {
	        // reset state and hide modal hide
	        this.setState(function () {
	          return {
	            validateState: null,
	            shakeEditor: false,
	            isInsertModalOpen: false
	          };
	        });
	      }
	    }
	  }, {
	    key: '__handleModalClose__REACT_HOT_LOADER__',
	    value: function __handleModalClose__REACT_HOT_LOADER__() {
	      this.setState(function () {
	        return { isInsertModalOpen: false };
	      });
	    }
	  }, {
	    key: '__handleModalOpen__REACT_HOT_LOADER__',
	    value: function __handleModalOpen__REACT_HOT_LOADER__() {
	      this.setState(function () {
	        return { isInsertModalOpen: true };
	      });
	    }
	  }, {
	    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
	    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
	      var _this6 = this;
	
	      this.setState(function () {
	        return {
	          showSelected: !_this6.state.showSelected
	        };
	      });
	      this.props.onShowOnlySelected();
	    }
	  }, {
	    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
	    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
	      this.props.onDropRow();
	    }
	  }, {
	    key: '__handleKeyUp__REACT_HOT_LOADER__',
	    value: function __handleKeyUp__REACT_HOT_LOADER__(event) {
	      event.persist();
	      this.debounceCallback(event);
	    }
	  }, {
	    key: '__handleExportCSV__REACT_HOT_LOADER__',
	    value: function __handleExportCSV__REACT_HOT_LOADER__() {
	      this.props.onExportCSV();
	    }
	  }, {
	    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
	    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
	      this.seachInput && this.seachInput.setValue('');
	      this.props.onSearch('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.modalClassName = 'bs-table-modal-sm' + ToolBar.modalSeq++;
	      var toolbar = null;
	      var btnGroup = null;
	      var insertBtn = null;
	      var deleteBtn = null;
	      var exportCSVBtn = null;
	      var showSelectedOnlyBtn = null;
	
	      if (this.props.enableInsert) {
	        if (this.props.insertBtn) {
	          insertBtn = this.renderCustomBtn(this.props.insertBtn, [this.handleModalOpen], _InsertButton2.default.name, 'onClick', this.handleModalOpen);
	        } else {
	          insertBtn = _react2.default.createElement(_InsertButton2.default, { btnText: this.props.insertText,
	            onClick: this.handleModalOpen });
	        }
	      }
	
	      if (this.props.enableDelete) {
	        if (this.props.deleteBtn) {
	          deleteBtn = this.renderCustomBtn(this.props.deleteBtn, [this.handleDropRowBtnClick], _DeleteButton2.default.name, 'onClick', this.handleDropRowBtnClick);
	        } else {
	          deleteBtn = _react2.default.createElement(_DeleteButton2.default, { btnText: this.props.deleteText,
	            onClick: this.handleDropRowBtnClick });
	        }
	      }
	
	      if (this.props.enableShowOnlySelected) {
	        if (this.props.showSelectedOnlyBtn) {
	          showSelectedOnlyBtn = this.renderCustomBtn(this.props.showSelectedOnlyBtn, [this.handleShowOnlyToggle, this.state.showSelected], _ShowSelectedOnlyButton2.default.name, 'onClick', this.handleShowOnlyToggle);
	        } else {
	          showSelectedOnlyBtn = _react2.default.createElement(_ShowSelectedOnlyButton2.default, { toggle: this.state.showSelected,
	            onClick: this.handleShowOnlyToggle });
	        }
	      }
	
	      if (this.props.enableExportCSV) {
	        if (this.props.exportCSVBtn) {
	          exportCSVBtn = this.renderCustomBtn(this.props.exportCSVBtn, [this.handleExportCSV], _ExportCSVButton2.default.name, 'onClick', this.handleExportCSV);
	        } else {
	          exportCSVBtn = _react2.default.createElement(_ExportCSVButton2.default, { btnText: this.props.exportCSVText,
	            onClick: this.handleExportCSV });
	        }
	      }
	
	      if (this.props.btnGroup) {
	        btnGroup = this.props.btnGroup({
	          exportCSVBtn: exportCSVBtn,
	          insertBtn: insertBtn,
	          deleteBtn: deleteBtn,
	          showSelectedOnlyBtn: showSelectedOnlyBtn
	        });
	      } else {
	        btnGroup = _react2.default.createElement(
	          'div',
	          { className: 'btn-group btn-group-sm', role: 'group' },
	          exportCSVBtn,
	          insertBtn,
	          deleteBtn,
	          showSelectedOnlyBtn
	        );
	      }
	
	      var _renderSearchPanel = this.renderSearchPanel(),
	          _renderSearchPanel2 = _slicedToArray(_renderSearchPanel, 3),
	          searchPanel = _renderSearchPanel2[0],
	          searchField = _renderSearchPanel2[1],
	          clearBtn = _renderSearchPanel2[2];
	
	      var modal = this.props.enableInsert ? this.renderInsertRowModal() : null;
	
	      if (this.props.toolBar) {
	        toolbar = this.props.toolBar({
	          components: {
	            exportCSVBtn: exportCSVBtn,
	            insertBtn: insertBtn,
	            deleteBtn: deleteBtn,
	            showSelectedOnlyBtn: showSelectedOnlyBtn,
	            searchPanel: searchPanel,
	            btnGroup: btnGroup,
	            searchField: searchField,
	            clearBtn: clearBtn
	          },
	          event: {
	            openInsertModal: this.handleModalOpen,
	            closeInsertModal: this.handleModalClose,
	            dropRow: this.handleDropRowBtnClick,
	            showOnlyToogle: this.handleShowOnlyToggle,
	            exportCSV: this.handleExportCSV,
	            search: this.props.onSearch
	          }
	        });
	      } else {
	        toolbar = [_react2.default.createElement(
	          'div',
	          { key: 'toolbar-left', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-8' },
	          this.props.searchPosition === 'left' ? searchPanel : btnGroup
	        ), _react2.default.createElement(
	          'div',
	          { key: 'toolbar-right', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-4' },
	          this.props.searchPosition === 'left' ? btnGroup : searchPanel
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        toolbar,
	        modal
	      );
	    }
	  }, {
	    key: 'renderSearchPanel',
	    value: function renderSearchPanel() {
	      var _this7 = this;
	
	      if (this.props.enableSearch) {
	        var classNames = 'form-group form-group-sm react-bs-table-search-form';
	        var clearBtn = null;
	        var searchField = null;
	        var searchPanel = null;
	        if (this.props.clearSearch) {
	          if (this.props.clearSearchBtn) {
	            clearBtn = this.renderCustomBtn(this.props.clearSearchBtn, [this.handleClearBtnClick], _ClearSearchButton2.default.name, 'onClick', this.handleClearBtnClick); /* eslint max-len: 0*/
	          } else {
	            clearBtn = _react2.default.createElement(_ClearSearchButton2.default, { onClick: this.handleClearBtnClick });
	          }
	          classNames += ' input-group input-group-sm';
	        }
	
	        if (this.props.searchField) {
	          searchField = this.props.searchField({
	            search: this.handleKeyUp,
	            defaultValue: this.props.defaultSearch,
	            placeholder: this.props.searchPlaceholder
	          });
	          if (searchField.type.name === _SearchField2.default.name) {
	            searchField = _react2.default.cloneElement(searchField, {
	              ref: function ref(node) {
	                return _this7.seachInput = node;
	              },
	              onKeyUp: this.handleKeyUp
	            });
	          } else {
	            searchField = _react2.default.cloneElement(searchField, {
	              ref: function ref(node) {
	                return _this7.seachInput = node;
	              }
	            });
	          }
	        } else {
	          searchField = _react2.default.createElement(_SearchField2.default, { ref: function ref(node) {
	              return _this7.seachInput = node;
	            },
	            defaultValue: this.props.defaultSearch,
	            placeholder: this.props.searchPlaceholder,
	            onKeyUp: this.handleKeyUp });
	        }
	        if (this.props.searchPanel) {
	          searchPanel = this.props.searchPanel({
	            searchField: searchField, clearBtn: clearBtn,
	            search: this.props.onSearch,
	            defaultValue: this.props.defaultSearch,
	            placeholder: this.props.searchPlaceholder,
	            clearBtnClick: this.handleClearBtnClick
	          });
	        } else {
	          searchPanel = _react2.default.createElement(
	            'div',
	            { className: classNames },
	            searchField,
	            _react2.default.createElement(
	              'span',
	              { className: 'input-group-btn' },
	              clearBtn
	            )
	          );
	        }
	        return [searchPanel, searchField, clearBtn];
	      } else {
	        return [];
	      }
	    }
	  }, {
	    key: 'renderInsertRowModal',
	    value: function renderInsertRowModal() {
	      var validateState = this.state.validateState || {};
	      var _props = this.props,
	          version = _props.version,
	          columns = _props.columns,
	          ignoreEditable = _props.ignoreEditable,
	          insertModalHeader = _props.insertModalHeader,
	          insertModalBody = _props.insertModalBody,
	          insertModalFooter = _props.insertModalFooter,
	          insertModal = _props.insertModal;
	
	
	      var modal = void 0;
	      modal = insertModal && insertModal(this.handleModalClose, this.handleSaveBtnClick, columns, validateState, ignoreEditable);
	
	      if (!modal) {
	        modal = _react2.default.createElement(_InsertModal2.default, {
	          version: version,
	          columns: columns,
	          validateState: validateState,
	          ignoreEditable: ignoreEditable,
	          onModalClose: this.handleModalClose,
	          onSave: this.handleSaveBtnClick,
	          headerComponent: insertModalHeader,
	          bodyComponent: insertModalBody,
	          footerComponent: insertModalFooter });
	      }
	
	      return _react2.default.createElement(
	        _reactModal2.default,
	        { className: 'react-bs-insert-modal modal-dialog',
	          isOpen: this.state.isInsertModalOpen,
	          ariaHideApp: false,
	          onRequestClose: this.handleModalClose,
	          contentLabel: 'Modal' },
	        modal
	      );
	    }
	  }, {
	    key: 'renderCustomBtn',
	    value: function renderCustomBtn(cb, params, componentName, eventName, event) {
	      var element = cb.apply(null, params);
	      if (element.type.name === componentName && !element.props[eventName]) {
	        var props = {};
	        props[eventName] = event;
	        element = _react2.default.cloneElement(element, props);
	      }
	      return element;
	    }
	  }]);
	
	  return ToolBar;
	}(_react.Component);
	
	ToolBar.modalSeq = 0;
	
	
	ToolBar.propTypes = {
	  version: _propTypes2.default.string,
	  onAddRow: _propTypes2.default.func,
	  onDropRow: _propTypes2.default.func,
	  onShowOnlySelected: _propTypes2.default.func,
	  enableInsert: _propTypes2.default.bool,
	  enableDelete: _propTypes2.default.bool,
	  enableSearch: _propTypes2.default.bool,
	  enableShowOnlySelected: _propTypes2.default.bool,
	  columns: _propTypes2.default.array,
	  searchPlaceholder: _propTypes2.default.string,
	  exportCSVText: _propTypes2.default.string,
	  insertText: _propTypes2.default.string,
	  deleteText: _propTypes2.default.string,
	  saveText: _propTypes2.default.string,
	  closeText: _propTypes2.default.string,
	  clearSearch: _propTypes2.default.bool,
	  ignoreEditable: _propTypes2.default.bool,
	  defaultSearch: _propTypes2.default.string,
	  insertModalHeader: _propTypes2.default.func,
	  insertModalBody: _propTypes2.default.func,
	  insertModalFooter: _propTypes2.default.func,
	  insertModal: _propTypes2.default.func,
	  insertBtn: _propTypes2.default.func,
	  deleteBtn: _propTypes2.default.func,
	  showSelectedOnlyBtn: _propTypes2.default.func,
	  exportCSVBtn: _propTypes2.default.func,
	  clearSearchBtn: _propTypes2.default.func,
	  searchField: _propTypes2.default.func,
	  searchPanel: _propTypes2.default.func,
	  btnGroup: _propTypes2.default.func,
	  toolBar: _propTypes2.default.func,
	  searchPosition: _propTypes2.default.string,
	  reset: _propTypes2.default.bool,
	  isValidKey: _propTypes2.default.func,
	  insertFailIndicator: _propTypes2.default.string
	};
	
	ToolBar.defaultProps = {
	  reset: false,
	  enableInsert: false,
	  enableDelete: false,
	  enableSearch: false,
	  enableShowOnlySelected: false,
	  clearSearch: false,
	  ignoreEditable: false,
	  exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
	  insertText: _Const2.default.INSERT_BTN_TEXT,
	  deleteText: _Const2.default.DELETE_BTN_TEXT,
	  saveText: _Const2.default.SAVE_BTN_TEXT,
	  closeText: _Const2.default.CLOSE_BTN_TEXT
	};
	
	var _default = ToolBar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ToolBar, 'ToolBar', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');
	}();
	
	;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(640);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(91);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(624);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(118);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(1194);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(626);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(225);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _capitalize = __webpack_require__(642);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(157);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(159);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(1251);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(247);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(664);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(1203);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(1204);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(225);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(1209);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(1210);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(91);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(629);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(226);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(226);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(164);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1302);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(96);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(662);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(1314);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(667);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(158);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(630);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(1222);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(631);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(632);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(633);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(159);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(157);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(159);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(167);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(628);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(636);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(1225);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(1226);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(1227);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(224);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(97);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(637);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(638);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(1249);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(638);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(33);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(639);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(91);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(224);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(165);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(91);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(118);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(157);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1240);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(159);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(627);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(227);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(228);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(641);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(165);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(167);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(634);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(635);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(227);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(228);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(53);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(165);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(166);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(39);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 1248 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(229);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(11);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(33);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(39);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1256), __esModule: true };

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1258), __esModule: true };

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1260), __esModule: true };

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1262), __esModule: true };

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1263), __esModule: true };

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(655);
	__webpack_require__(1286);
	module.exports = __webpack_require__(54).Array.from;


/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1288);
	module.exports = __webpack_require__(54).Object.assign;


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1289);
	var $Object = __webpack_require__(54).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1293);
	module.exports = __webpack_require__(54).Object.entries;


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1290);
	module.exports = __webpack_require__(54).Object.setPrototypeOf;


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1294);
	module.exports = __webpack_require__(54).Object.values;


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1292);
	__webpack_require__(1291);
	__webpack_require__(1295);
	__webpack_require__(1296);
	module.exports = __webpack_require__(54).Symbol;


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(655);
	__webpack_require__(1297);
	module.exports = __webpack_require__(244).f('iterator');


/***/ },
/* 1264 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 1265 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(82);
	var toLength = __webpack_require__(654);
	var toAbsoluteIndex = __webpack_require__(1284);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(230);
	var TAG = __webpack_require__(55)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(81);
	var createDesc = __webpack_require__(123);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(121);
	var gOPS = __webpack_require__(236);
	var pIE = __webpack_require__(122);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(71).document;
	module.exports = document && document.documentElement;


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(120);
	var ITERATOR = __webpack_require__(55)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(230);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(92);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(235);
	var descriptor = __webpack_require__(123);
	var setToStringTag = __webpack_require__(237);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(94)(IteratorPrototype, __webpack_require__(55)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(55)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 1276 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(160)('meta');
	var isObject = __webpack_require__(95);
	var has = __webpack_require__(80);
	var setDesc = __webpack_require__(81).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(119)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(121);
	var gOPS = __webpack_require__(236);
	var pIE = __webpack_require__(122);
	var toObject = __webpack_require__(241);
	var IObject = __webpack_require__(647);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(119)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(81);
	var anObject = __webpack_require__(92);
	var getKeys = __webpack_require__(121);
	
	module.exports = __webpack_require__(93) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(82);
	var gOPN = __webpack_require__(650).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(80);
	var toObject = __webpack_require__(241);
	var IE_PROTO = __webpack_require__(238)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(95);
	var anObject = __webpack_require__(92);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(231)(Function.call, __webpack_require__(649).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(240);
	var defined = __webpack_require__(232);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(240);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(1267);
	var ITERATOR = __webpack_require__(55)('iterator');
	var Iterators = __webpack_require__(120);
	module.exports = __webpack_require__(54).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(231);
	var $export = __webpack_require__(70);
	var toObject = __webpack_require__(241);
	var call = __webpack_require__(1273);
	var isArrayIter = __webpack_require__(1271);
	var toLength = __webpack_require__(654);
	var createProperty = __webpack_require__(1268);
	var getIterFn = __webpack_require__(1285);
	
	$export($export.S + $export.F * !__webpack_require__(1275)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1265);
	var step = __webpack_require__(1276);
	var Iterators = __webpack_require__(120);
	var toIObject = __webpack_require__(82);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(648)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(70);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1278) });


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(70);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(235) });


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(70);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1282).set });


/***/ },
/* 1291 */
/***/ function(module, exports) {



/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(71);
	var has = __webpack_require__(80);
	var DESCRIPTORS = __webpack_require__(93);
	var $export = __webpack_require__(70);
	var redefine = __webpack_require__(653);
	var META = __webpack_require__(1277).KEY;
	var $fails = __webpack_require__(119);
	var shared = __webpack_require__(239);
	var setToStringTag = __webpack_require__(237);
	var uid = __webpack_require__(160);
	var wks = __webpack_require__(55);
	var wksExt = __webpack_require__(244);
	var wksDefine = __webpack_require__(243);
	var enumKeys = __webpack_require__(1269);
	var isArray = __webpack_require__(1272);
	var anObject = __webpack_require__(92);
	var isObject = __webpack_require__(95);
	var toIObject = __webpack_require__(82);
	var toPrimitive = __webpack_require__(242);
	var createDesc = __webpack_require__(123);
	var _create = __webpack_require__(235);
	var gOPNExt = __webpack_require__(1280);
	var $GOPD = __webpack_require__(649);
	var $DP = __webpack_require__(81);
	var $keys = __webpack_require__(121);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(650).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(122).f = $propertyIsEnumerable;
	  __webpack_require__(236).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(234)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(94)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(70);
	var $entries = __webpack_require__(652)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(70);
	var $values = __webpack_require__(652)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(243)('asyncIterator');


/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(243)('observable');


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1287);
	var global = __webpack_require__(71);
	var hide = __webpack_require__(94);
	var Iterators = __webpack_require__(120);
	var TO_STRING_TAG = __webpack_require__(55)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(657);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	module.exports = exports['default'];

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
	var _addClass = __webpack_require__(1298);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1300);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _hasClass = __webpack_require__(657);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.addClass = _addClass2.default;
	exports.removeClass = _removeClass2.default;
	exports.hasClass = _hasClass2.default;
	exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ },
/* 1300 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterEvents;
	
	var _contains = __webpack_require__(97);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _querySelectorAll = __webpack_require__(1306);
	
	var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll2.default)(top, selector);
	
	    if (matches.some(function (match) {
	      return (0, _contains2.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listen = exports.filter = exports.off = exports.on = undefined;
	
	var _on = __webpack_require__(161);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(245);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _filter = __webpack_require__(1301);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _listen = __webpack_require__(1303);
	
	var _listen2 = _interopRequireDefault(_listen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.on = _on2.default;
	exports.off = _off2.default;
	exports.filter = _filter2.default;
	exports.listen = _listen2.default;
	exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _on = __webpack_require__(161);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(245);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listen = function listen() {};
	
	if (_inDOM2.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on2.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off2.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	exports.default = listen;
	module.exports = exports['default'];

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offsetParent;
	
	var _ownerDocument = __webpack_require__(96);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _style = __webpack_require__(163);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	module.exports = exports['default'];

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = position;
	
	var _offset = __webpack_require__(658);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(1304);
	
	var _offsetParent2 = _interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(659);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__(1307);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _style = __webpack_require__(163);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = { top: 0, left: 0 },
	      offset;
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	  if ((0, _style2.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
	    offset = (0, _offset2.default)(node);
	
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);
	
	    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
	  }
	
	  // Subtract parent offsets and node margins
	  return _extends({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 1306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	module.exports = exports['default'];

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(162);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = __webpack_require__(661);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _camelizeStyle2.default)(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1309 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeStyle;
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	module.exports = exports['default'];

/***/ },
/* 1310 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	module.exports = exports["default"];

/***/ },
/* 1311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	module.exports = exports["default"];

/***/ },
/* 1312 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenate;
	
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	module.exports = exports['default'];

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateStyleName;
	
	var _hyphenate = __webpack_require__(1312);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^ms-/; /**
	                         * Copyright 2013-2014, Facebook, Inc.
	                         * All rights reserved.
	                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	                         */
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
	}
	module.exports = exports['default'];

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(249);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(663);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(1315);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(124);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(666);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1318);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(72);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(656);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(97);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(248);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(163);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(1299);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(662);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(667);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(663);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1317);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(664);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(249);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(1319);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(248);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(124);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1318 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(658);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1305);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(659);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(124);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 1320 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(246);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1322);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(246);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 1323 */
[1643, 1324, 1325, 1326],
/* 1324 */
30,
/* 1325 */
267,
/* 1326 */
15,
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(98),
		DaysView = __webpack_require__(1328),
		MonthsView = __webpack_require__(1329),
		YearsView = __webpack_require__(1331),
		TimeView = __webpack_require__(1330)
		;
	
	var CalendarContainer = createClass({
		viewComponents: {
			days: DaysView,
			months: MonthsView,
			years: YearsView,
			time: TimeView
		},
	
		render: function() {
			return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
		}
	});
	
	module.exports = CalendarContainer;


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(98),
		moment = __webpack_require__(3),
		onClickOutside = __webpack_require__(101).default
		;
	
	var DateTimePickerDays = onClickOutside( createClass({
		render: function() {
			var footer = this.renderFooter(),
				date = this.props.viewDate,
				locale = date.localeData(),
				tableChildren
				;
	
			tableChildren = [
				React.createElement('thead', { key: 'th' }, [
					React.createElement('tr', { key: 'h' }, [
						React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
						React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
						React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
					]),
					React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
				]),
				React.createElement('tbody', { key: 'tb' }, this.renderDays())
			];
	
			if ( footer )
				tableChildren.push( footer );
	
			return React.createElement('div', { className: 'rdtDays' },
				React.createElement('table', {}, tableChildren )
			);
		},
	
		/**
		 * Get a list of the days of the week
		 * depending on the current locale
		 * @return {array} A list with the shortname of the days
		 */
		getDaysOfWeek: function( locale ) {
			var days = locale._weekdaysMin,
				first = locale.firstDayOfWeek(),
				dow = [],
				i = 0
				;
	
			days.forEach( function( day ) {
				dow[ (7 + ( i++ ) - first) % 7 ] = day;
			});
	
			return dow;
		},
	
		renderDays: function() {
			var date = this.props.viewDate,
				selected = this.props.selectedDate && this.props.selectedDate.clone(),
				prevMonth = date.clone().subtract( 1, 'months' ),
				currentYear = date.year(),
				currentMonth = date.month(),
				weeks = [],
				days = [],
				renderer = this.props.renderDay || this.renderDay,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, isDisabled, dayProps, currentDate
				;
	
			// Go to the last week of the previous month
			prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
			var lastDay = prevMonth.clone().add( 42, 'd' );
	
			while ( prevMonth.isBefore( lastDay ) ) {
				classes = 'rdtDay';
				currentDate = prevMonth.clone();
	
				if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
					classes += ' rdtOld';
				else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
					classes += ' rdtNew';
	
				if ( selected && prevMonth.isSame( selected, 'day' ) )
					classes += ' rdtActive';
	
				if ( prevMonth.isSame( moment(), 'day' ) )
					classes += ' rdtToday';
	
				isDisabled = !isValid( currentDate, selected );
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				dayProps = {
					key: prevMonth.format( 'M_D' ),
					'data-value': prevMonth.date(),
					className: classes
				};
	
				if ( !isDisabled )
					dayProps.onClick = this.updateSelectedDate;
	
				days.push( renderer( dayProps, currentDate, selected ) );
	
				if ( days.length === 7 ) {
					weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
					days = [];
				}
	
				prevMonth.add( 1, 'd' );
			}
	
			return weeks;
		},
	
		updateSelectedDate: function( event ) {
			this.props.updateSelectedDate( event, true );
		},
	
		renderDay: function( props, currentDate ) {
			return React.createElement('td',  props, currentDate.date() );
		},
	
		renderFooter: function() {
			if ( !this.props.timeFormat )
				return '';
	
			var date = this.props.selectedDate || this.props.viewDate;
	
			return React.createElement('tfoot', { key: 'tf'},
				React.createElement('tr', {},
					React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
				)
			);
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	module.exports = DateTimePickerDays;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(98),
		onClickOutside = __webpack_require__(101).default
		;
	
	var DateTimePickerMonths = onClickOutside( createClass({
		render: function() {
			return React.createElement('div', { className: 'rdtMonths' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
			]);
		},
	
		renderMonths: function() {
			var date = this.props.selectedDate,
				month = this.props.viewDate.month(),
				year = this.props.viewDate.year(),
				rows = [],
				i = 0,
				months = [],
				renderer = this.props.renderMonth || this.renderMonth,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
				// Date is irrelevant because we're only interested in month
				irrelevantDate = 1
				;
	
			while (i < 12) {
				classes = 'rdtMonth';
				currentMonth =
					this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });
	
				noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
				daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInMonth.find(function( d ) {
					var day = currentMonth.clone().set( 'date', d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( date && i === date.month() && year === date.year() )
					classes += ' rdtActive';
	
				props = {
					key: i,
					'data-value': i,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'months' ?
						this.updateSelectedMonth : this.props.setDate( 'month' ) );
	
				months.push( renderer( props, i, year, date && date.clone() ) );
	
				if ( months.length === 4 ) {
					rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
					months = [];
				}
	
				i++;
			}
	
			return rows;
		},
	
		updateSelectedMonth: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderMonth: function( props, month ) {
			var localMoment = this.props.viewDate;
			var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
			var strLength = 3;
			// Because some months are up to 5 characters long, we want to
			// use a fixed string length for consistency
			var monthStrFixedLength = monthStr.substring( 0, strLength );
			return React.createElement('td', props, capitalize( monthStrFixedLength ) );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	function capitalize( str ) {
		return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
	}
	
	module.exports = DateTimePickerMonths;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(98),
		assign = __webpack_require__(669),
		onClickOutside = __webpack_require__(101).default
		;
	
	var DateTimePickerTime = onClickOutside( createClass({
		getInitialState: function() {
			return this.calculateState( this.props );
		},
	
		calculateState: function( props ) {
			var date = props.selectedDate || props.viewDate,
				format = props.timeFormat,
				counters = []
				;
	
			if ( format.toLowerCase().indexOf('h') !== -1 ) {
				counters.push('hours');
				if ( format.indexOf('m') !== -1 ) {
					counters.push('minutes');
					if ( format.indexOf('s') !== -1 ) {
						counters.push('seconds');
					}
				}
			}
	
			var hours = date.format( 'H' );
			
			var daypart = false;
			if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
					daypart = ( hours >= 12 ) ? 'PM' : 'AM';
				} else {
					daypart = ( hours >= 12 ) ? 'pm' : 'am';
				}
			}
	
			return {
				hours: hours,
				minutes: date.format( 'mm' ),
				seconds: date.format( 'ss' ),
				milliseconds: date.format( 'SSS' ),
				daypart: daypart,
				counters: counters
			};
		},
	
		renderCounter: function( type ) {
			if ( type !== 'daypart' ) {
				var value = this.state[ type ];
				if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
					value = ( value - 1 ) % 12 + 1;
	
					if ( value === 0 ) {
						value = 12;
					}
				}
				return React.createElement('div', { key: type, className: 'rdtCounter' }, [
					React.createElement('span', { key: 'up', className: 'rdtBtn', onTouchStart: this.onStartClicking('increase', type), onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
					React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
					React.createElement('span', { key: 'do', className: 'rdtBtn', onTouchStart: this.onStartClicking('decrease', type), onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
				]);
			}
			return '';
		},
	
		renderDayPart: function() {
			return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onTouchStart: this.onStartClicking('toggleDayPart', 'hours'), onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onTouchStart: this.onStartClicking('toggleDayPart', 'hours'), onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		},
	
		render: function() {
			var me = this,
				counters = []
			;
	
			this.state.counters.forEach( function( c ) {
				if ( counters.length )
					counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
				counters.push( me.renderCounter( c ) );
			});
	
			if ( this.state.daypart !== false ) {
				counters.push( me.renderDayPart() );
			}
	
			if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
				counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
				counters.push(
					React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
						React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
						)
					);
			}
	
			return React.createElement('div', { className: 'rdtTime' },
				React.createElement('table', {}, [
					this.renderHeader(),
					React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
						React.createElement('div', { className: 'rdtCounters' }, counters )
					)))
				])
			);
		},
	
		componentWillMount: function() {
			var me = this;
			me.timeConstraints = {
				hours: {
					min: 0,
					max: 23,
					step: 1
				},
				minutes: {
					min: 0,
					max: 59,
					step: 1
				},
				seconds: {
					min: 0,
					max: 59,
					step: 1
				},
				milliseconds: {
					min: 0,
					max: 999,
					step: 1
				}
			};
			['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
				assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
			});
			this.setState( this.calculateState( this.props ) );
		},
	
		componentWillReceiveProps: function( nextProps ) {
			this.setState( this.calculateState( nextProps ) );
		},
	
		updateMilli: function( e ) {
			var milli = parseInt( e.target.value, 10 );
			if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
				this.props.setTime( 'milliseconds', milli );
				this.setState( { milliseconds: milli } );
			}
		},
	
		renderHeader: function() {
			if ( !this.props.dateFormat )
				return null;
	
			var date = this.props.selectedDate || this.props.viewDate;
			return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
				React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
			));
		},
	
		onStartClicking: function( action, type ) {
			var me = this;
	
			return function() {
				var update = {};
				update[ type ] = me[ action ]( type );
				me.setState( update );
	
				me.timer = setTimeout( function() {
					me.increaseTimer = setInterval( function() {
						update[ type ] = me[ action ]( type );
						me.setState( update );
					}, 70);
				}, 500);
	
				me.mouseUpListener = function() {
					clearTimeout( me.timer );
					clearInterval( me.increaseTimer );
					me.props.setTime( type, me.state[ type ] );
					document.body.removeEventListener( 'mouseup', me.mouseUpListener );
					document.body.removeEventListener( 'touchend', me.mouseUpListener );
				};
	
				document.body.addEventListener( 'mouseup', me.mouseUpListener );
				document.body.addEventListener( 'touchend', me.mouseUpListener );
			};
		},
	
		disableContextMenu: function( event ) {
			event.preventDefault();
			return false;
		},
	
		padValues: {
			hours: 1,
			minutes: 2,
			seconds: 2,
			milliseconds: 3
		},
	
		toggleDayPart: function( type ) { // type is always 'hours'
			var value = parseInt( this.state[ type ], 10) + 12;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		increase: function( type ) {
			var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		decrease: function( type ) {
			var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
			if ( value < this.timeConstraints[ type ].min )
				value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
			return this.pad( type, value );
		},
	
		pad: function( type, value ) {
			var str = value + '';
			while ( str.length < this.padValues[ type ] )
				str = '0' + str;
			return str;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	module.exports = DateTimePickerTime;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(98),
		onClickOutside = __webpack_require__(101).default
		;
	
	var DateTimePickerYears = onClickOutside( createClass({
		render: function() {
			var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;
	
			return React.createElement('div', { className: 'rdtYears' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
			]);
		},
	
		renderYears: function( year ) {
			var years = [],
				i = -1,
				rows = [],
				renderer = this.props.renderYear || this.renderYear,
				selectedDate = this.props.selectedDate,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
				// Month and date are irrelevant here because
				// we're only interested in the year
				irrelevantMonth = 0,
				irrelevantDate = 1
				;
	
			year--;
			while (i < 11) {
				classes = 'rdtYear';
				currentYear = this.props.viewDate.clone().set(
					{ year: year, month: irrelevantMonth, date: irrelevantDate } );
	
				// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
				// if ( i === -1 | i === 10 )
					// classes += ' rdtOld';
	
				noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
				daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInYear.find(function( d ) {
					var day = currentYear.clone().dayOfYear( d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( selectedDate && selectedDate.year() === year )
					classes += ' rdtActive';
	
				props = {
					key: year,
					'data-value': year,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'years' ?
						this.updateSelectedYear : this.props.setDate('year') );
	
				years.push( renderer( props, year, selectedDate && selectedDate.clone() ));
	
				if ( years.length === 4 ) {
					rows.push( React.createElement('tr', { key: i }, years ) );
					years = [];
				}
	
				year++;
				i++;
			}
	
			return rows;
		},
	
		updateSelectedYear: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderYear: function( props, year ) {
			return React.createElement('td',  props, year );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	
		handleClickOutside: function() {
			this.props.handleClickOutside();
		}
	}));
	
	module.exports = DateTimePickerYears;


/***/ },
/* 1332 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(29);
	
	var focusNode = __webpack_require__(697);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(126);
	var ExecutionEnvironment = __webpack_require__(36);
	var FallbackCompositionState = __webpack_require__(1340);
	var SyntheticCompositionEvent = __webpack_require__(1374);
	var SyntheticInputEvent = __webpack_require__(1377);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(670);
	var ExecutionEnvironment = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(43);
	
	var camelizeStyleName = __webpack_require__(1393);
	var dangerousStyleValue = __webpack_require__(1383);
	var hyphenateStyleName = __webpack_require__(1400);
	var memoizeStringOnly = __webpack_require__(1403);
	var warning = __webpack_require__(26);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(125);
	var EventPropagators = __webpack_require__(126);
	var ExecutionEnvironment = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(50);
	var SyntheticEvent = __webpack_require__(60);
	
	var inputValueTracking = __webpack_require__(692);
	var getEventTarget = __webpack_require__(262);
	var isEventSupported = __webpack_require__(264);
	var isTextInputElement = __webpack_require__(693);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var DOMLazyTree = __webpack_require__(99);
	var ExecutionEnvironment = __webpack_require__(36);
	
	var createNodesFromMarkup = __webpack_require__(1396);
	var emptyFunction = __webpack_require__(61);
	var invariant = __webpack_require__(15);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1338 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(126);
	var ReactDOMComponentTree = __webpack_require__(29);
	var SyntheticMouseEvent = __webpack_require__(169);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var PooledClass = __webpack_require__(83);
	
	var getTextContentAccessor = __webpack_require__(691);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(100);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(84);
	
	var instantiateReactComponent = __webpack_require__(263);
	var KeyEscapeUtils = __webpack_require__(254);
	var shouldUpdateReactComponent = __webpack_require__(265);
	var traverseAllChildren = __webpack_require__(695);
	var warning = __webpack_require__(26);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(729);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(250);
	var ReactDOMIDOperations = __webpack_require__(1349);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var React = __webpack_require__(85);
	var ReactComponentEnvironment = __webpack_require__(256);
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactErrorUtils = __webpack_require__(257);
	var ReactInstanceMap = __webpack_require__(127);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactNodeTypes = __webpack_require__(684);
	var ReactReconciler = __webpack_require__(84);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(267);
	var invariant = __webpack_require__(15);
	var shallowEqual = __webpack_require__(268);
	var shouldUpdateReactComponent = __webpack_require__(265);
	var warning = __webpack_require__(26);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactDefaultInjection = __webpack_require__(677);
	var ReactMount = __webpack_require__(683);
	var ReactReconciler = __webpack_require__(84);
	var ReactUpdates = __webpack_require__(50);
	var ReactVersion = __webpack_require__(686);
	
	var findDOMNode = __webpack_require__(1384);
	var getHostComponentFromComposite = __webpack_require__(690);
	var renderSubtreeIntoContainer = __webpack_require__(1391);
	var warning = __webpack_require__(26);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var AutoFocusUtils = __webpack_require__(1333);
	var CSSPropertyOperations = __webpack_require__(1335);
	var DOMLazyTree = __webpack_require__(99);
	var DOMNamespaces = __webpack_require__(251);
	var DOMProperty = __webpack_require__(100);
	var DOMPropertyOperations = __webpack_require__(672);
	var EventPluginHub = __webpack_require__(125);
	var EventPluginRegistry = __webpack_require__(252);
	var ReactBrowserEventEmitter = __webpack_require__(168);
	var ReactDOMComponentFlags = __webpack_require__(673);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactDOMInput = __webpack_require__(1350);
	var ReactDOMOption = __webpack_require__(1351);
	var ReactDOMSelect = __webpack_require__(675);
	var ReactDOMTextarea = __webpack_require__(1355);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMultiChild = __webpack_require__(1361);
	var ReactServerRenderingTransaction = __webpack_require__(685);
	
	var emptyFunction = __webpack_require__(61);
	var escapeTextContentForBrowser = __webpack_require__(171);
	var invariant = __webpack_require__(15);
	var isEventSupported = __webpack_require__(264);
	var shallowEqual = __webpack_require__(268);
	var inputValueTracking = __webpack_require__(692);
	var validateDOMNesting = __webpack_require__(266);
	var warning = __webpack_require__(26);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var DOMLazyTree = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(29);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1348 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(250);
	var ReactDOMComponentTree = __webpack_require__(29);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var DOMPropertyOperations = __webpack_require__(672);
	var LinkedValueUtils = __webpack_require__(255);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(50);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var React = __webpack_require__(85);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactDOMSelect = __webpack_require__(675);
	
	var warning = __webpack_require__(26);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var getNodeForCharacterOffset = __webpack_require__(1388);
	var getTextContentAccessor = __webpack_require__(691);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(677);
	var ReactServerRendering = __webpack_require__(1367);
	var ReactVersion = __webpack_require__(686);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var DOMChildrenOperations = __webpack_require__(250);
	var DOMLazyTree = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(29);
	
	var escapeTextContentForBrowser = __webpack_require__(171);
	var invariant = __webpack_require__(15);
	var validateDOMNesting = __webpack_require__(266);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21),
	    _assign = __webpack_require__(30);
	
	var LinkedValueUtils = __webpack_require__(255);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(50);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1357 */
730,
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(125);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var EventListener = __webpack_require__(696);
	var ExecutionEnvironment = __webpack_require__(36);
	var PooledClass = __webpack_require__(83);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(50);
	
	var getEventTarget = __webpack_require__(262);
	var getUnboundedScrollPosition = __webpack_require__(1398);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(100);
	var EventPluginHub = __webpack_require__(125);
	var EventPluginUtils = __webpack_require__(253);
	var ReactComponentEnvironment = __webpack_require__(256);
	var ReactEmptyComponent = __webpack_require__(678);
	var ReactBrowserEventEmitter = __webpack_require__(168);
	var ReactHostComponent = __webpack_require__(680);
	var ReactUpdates = __webpack_require__(50);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactComponentEnvironment = __webpack_require__(256);
	var ReactInstanceMap = __webpack_require__(127);
	var ReactInstrumentation = __webpack_require__(43);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(84);
	var ReactChildReconciler = __webpack_require__(1342);
	
	var emptyFunction = __webpack_require__(61);
	var flattenChildren = __webpack_require__(1385);
	var invariant = __webpack_require__(15);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1363 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(30);
	
	var CallbackQueue = __webpack_require__(671);
	var PooledClass = __webpack_require__(83);
	var ReactBrowserEventEmitter = __webpack_require__(168);
	var ReactInputSelection = __webpack_require__(681);
	var ReactInstrumentation = __webpack_require__(43);
	var Transaction = __webpack_require__(170);
	var ReactUpdateQueue = __webpack_require__(258);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1362);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1366 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var React = __webpack_require__(85);
	var ReactDOMContainerInfo = __webpack_require__(674);
	var ReactDefaultBatchingStrategy = __webpack_require__(676);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMarkupChecksum = __webpack_require__(682);
	var ReactReconciler = __webpack_require__(84);
	var ReactServerBatchingStrategy = __webpack_require__(1366);
	var ReactServerRenderingTransaction = __webpack_require__(685);
	var ReactUpdates = __webpack_require__(50);
	
	var emptyObject = __webpack_require__(267);
	var instantiateReactComponent = __webpack_require__(263);
	var invariant = __webpack_require__(15);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(258);
	
	var warning = __webpack_require__(26);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1369 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(126);
	var ExecutionEnvironment = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactInputSelection = __webpack_require__(681);
	var SyntheticEvent = __webpack_require__(60);
	
	var getActiveElement = __webpack_require__(698);
	var isTextInputElement = __webpack_require__(693);
	var shallowEqual = __webpack_require__(268);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var EventListener = __webpack_require__(696);
	var EventPropagators = __webpack_require__(126);
	var ReactDOMComponentTree = __webpack_require__(29);
	var SyntheticAnimationEvent = __webpack_require__(1372);
	var SyntheticClipboardEvent = __webpack_require__(1373);
	var SyntheticEvent = __webpack_require__(60);
	var SyntheticFocusEvent = __webpack_require__(1376);
	var SyntheticKeyboardEvent = __webpack_require__(1378);
	var SyntheticMouseEvent = __webpack_require__(169);
	var SyntheticDragEvent = __webpack_require__(1375);
	var SyntheticTouchEvent = __webpack_require__(1379);
	var SyntheticTransitionEvent = __webpack_require__(1380);
	var SyntheticUIEvent = __webpack_require__(128);
	var SyntheticWheelEvent = __webpack_require__(1381);
	
	var emptyFunction = __webpack_require__(61);
	var getEventCharCode = __webpack_require__(260);
	var invariant = __webpack_require__(15);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(60);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(60);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(60);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(169);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(128);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(60);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(128);
	
	var getEventCharCode = __webpack_require__(260);
	var getEventKey = __webpack_require__(1386);
	var getEventModifierState = __webpack_require__(261);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(128);
	
	var getEventModifierState = __webpack_require__(261);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(60);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(169);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1382 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(670);
	var warning = __webpack_require__(26);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(21);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(29);
	var ReactInstanceMap = __webpack_require__(127);
	
	var getHostComponentFromComposite = __webpack_require__(690);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(26);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(254);
	var traverseAllChildren = __webpack_require__(695);
	var warning = __webpack_require__(26);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(729);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(260);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1387 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1388 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(171);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(683);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1392 */
1007,
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1392);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1394 */
[1633, 1402],
/* 1395 */
[1634, 15],
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var createArrayFromMixed = __webpack_require__(1395);
	var getMarkupWrap = __webpack_require__(1397);
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1398 */
1013,
/* 1399 */
1015,
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1399);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1401 */
1016,
/* 1402 */
[1635, 1401],
/* 1403 */
1020,
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.GoogleLogin=t(require("react")):e.GoogleLogin=t(e.react)}(this,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=7)}([function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=n(6),c=n.n(s),a=n(2),u=(n.n(a),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),l=function(e){function t(e){o(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.signIn=n.signIn.bind(n),n.state={disabled:!0},n}return i(t,e),u(t,[{key:"componentDidMount",value:function(){var e=this,t=this.props,n=t.clientId,o=t.cookiePolicy,r=t.loginHint,i=t.hostedDomain,s=t.autoLoad,c=t.isSignedIn,a=t.fetchBasicProfile,u=t.redirectUri,l=t.discoveryDocs,f=t.onFailure,p=t.uxMode;!function(e,t,n,o){var r=e.getElementsByTagName(t)[0],i=r,s=r;s=e.createElement(t),s.id=n,s.src="//apis.google.com/js/client:platform.js",i.parentNode.insertBefore(s,i),s.onload=o}(document,"script","google-login",function(){var t={client_id:n,cookiepolicy:o,login_hint:r,hosted_domain:i,fetch_basic_profile:a,discoveryDocs:l,ux_mode:p,redirect_uri:u};window.gapi.load("auth2",function(){e.setState({disabled:!1}),window.gapi.auth2.getAuthInstance()||window.gapi.auth2.init(t).then(function(t){c&&t.isSignedIn.get()&&e._handleSigninSuccess(t.currentUser.get())},function(e){return f(e)}),s&&e.signIn()})})}},{key:"signIn",value:function(e){var t=this;if(e&&e.preventDefault(),!this.state.disabled){var n=window.gapi.auth2.getAuthInstance(),o=this.props,r=o.offline,i=o.redirectUri,s=o.onSuccess,c=o.onRequest,a=o.fetchBasicProfile,u=o.onFailure,l=o.prompt,f=o.scope,p=o.responseType,d={response_type:p,redirect_uri:i,fetch_basic_profile:a,prompt:l,scope:f};c(),r?n.grantOfflineAccess(d).then(function(e){return s(e)},function(e){return u(e)}):n.signIn(d).then(function(e){return t._handleSigninSuccess(e)},function(e){return u(e)})}}},{key:"_handleSigninSuccess",value:function(e){var t=e.getBasicProfile(),n=e.getAuthResponse();e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},this.props.onSuccess(e)}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.style,o=e.className,r=e.disabledStyle,i=e.buttonText,s=e.children,a=this.state.disabled||this.props.disabled,u={display:"inline-block",background:"#d14836",color:"#fff",width:190,paddingTop:10,paddingBottom:10,borderRadius:2,border:"1px solid transparent",fontSize:16,fontWeight:"bold",fontFamily:"Roboto"},l=function(){return n||(o&&!n?{}:u)}(),f=function(){return a?Object.assign({},l,r):l}();return c.a.createElement(t,{onClick:this.signIn,style:f,disabled:a,className:o},s||i)}}]),t}(s.Component);l.defaultProps={tag:"button",buttonText:"Login with Google",scope:"profile email",responseType:"permission",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},onRequest:function(){},offline:!1},t.default=l},function(e,t,n){"use strict";var o=n(4),r=n(5),i=n(3);e.exports=function(){function e(e,t,n,o,s,c){c!==i&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=o,n.PropTypes=n,n}},function(e,t,n){e.exports=n(1)()},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function o(e){return function(){return e}}var r=function(){};r.thatReturns=o,r.thatReturnsFalse=o(!1),r.thatReturnsTrue=o(!0),r.thatReturnsNull=o(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function o(e,t,n,o,i,s,c,a){if(r(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,o,i,s,c,a],f=0;u=new Error(t.replace(/%s/g,function(){return l[f++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var r=function(e){};e.exports=o},function(t,n){t.exports=e},function(e,t,n){e.exports=n(0)}])});
	//# sourceMappingURL=google-login.js.map

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(1405);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdDragHandle = function MdDragHandle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm6.6 25v-3.4h26.8v3.4h-26.8z m26.8-10v3.4h-26.8v-3.4h26.8z' })
	        )
	    );
	};
	
	exports.default = MdDragHandle;
	module.exports = exports['default'];

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(1408);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(699);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(700);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var isOpen = newProps.isOpen;
	      // Stop unnecessary renders if modal is remaining closed
	
	      if (!this.props.isOpen && !isOpen) return;
	
	      var currentParent = getParentElement(this.props.parentSelector);
	      var newParent = getParentElement(newProps.parentSelector);
	
	      if (newParent !== currentParent) {
	        currentParent.removeChild(this.node);
	        newParent.appendChild(this.node);
	      }
	
	      !isReact16 && this.renderPortal(newProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      if (newProps.portalClassName !== this.props.portalClassName) {
	        this.node.className = newProps.portalClassName;
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	exports.default = Modal;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(1410);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(1411);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(699);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(1409);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(700);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setFocusAfterRender = function (focus) {
	      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
	    };
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	      _this.moveFromContentToOverlay = null;
	    };
	
	    _this.handleOverlayOnMouseUp = function () {
	      if (_this.moveFromContentToOverlay === null) {
	        _this.shouldClose = false;
	      }
	      if (_this.props.shouldCloseOnOverlayClick) {
	        _this.shouldClose = true;
	      }
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.ariaAttributes = function (items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc["aria-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Focus needs to be set when mounting and already open
	      if (this.props.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (false) {
	        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (newProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	      // Focus only needs to be set once when the modal is being opened
	      if (!this.props.isOpen && newProps.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      } else if (this.props.isOpen && !newProps.isOpen) {
	        this.close();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.focusAfterRender) {
	        this.focusContent();
	        this.setFocusAfterRender(false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          onMouseUp: this.handleOverlayOnMouseUp,
	          "aria-modal": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.ariaAttributes(this.props.aria || {})),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  }
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(701);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(701);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prune, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(1407);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 1413 */
49,
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(704);
	
	var _warning = __webpack_require__(269);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(702);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1422);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1416);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1417);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1418);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1419);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(133);
	
	var _wrapMapToProps = __webpack_require__(703);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(703);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(705);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1420);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(269);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1421 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1422 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 1424 */
246,
/* 1425 */
[1637, 706, 1428, 1429],
/* 1426 */
477,
/* 1427 */
[1638, 1430],
/* 1428 */
[1639, 706],
/* 1429 */
1121,
/* 1430 */
482,
/* 1431 */
[1640, 1426],
/* 1432 */
79,
/* 1433 */
[1641, 1425, 1427, 1432],
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinkContainer = __webpack_require__(707);
	
	var _LinkContainer2 = _interopRequireDefault(_LinkContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Don't use a stateless function, to allow users to set a ref.
	/* eslint-disable react/prefer-stateless-function */
	var IndexLinkContainer = function (_React$Component) {
	  _inherits(IndexLinkContainer, _React$Component);
	
	  function IndexLinkContainer() {
	    _classCallCheck(this, IndexLinkContainer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexLinkContainer.prototype.render = function render() {
	    return _react2.default.createElement(_LinkContainer2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  };
	
	  return IndexLinkContainer;
	}(_react2.default.Component);
	/* eslint-enable react/prefer-stateless-function */
	
	
	exports.default = IndexLinkContainer;
	module.exports = exports['default'];

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(708);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(710);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(711);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(103);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(713);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(103);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _InternalPropTypes = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _InternalPropTypes = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _createTransitionManager2 = __webpack_require__(717);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(129);
	
	var _RouterContext = __webpack_require__(273);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _RouterUtils = __webpack_require__(714);
	
	var _routerWarning = __webpack_require__(103);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(270);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(273);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(103);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1033);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(716);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(102);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(270);
	
	var _PromiseUtils = __webpack_require__(712);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(102);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1034);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(716);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(102);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(142);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(715);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(717);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _RouterUtils = __webpack_require__(714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(270);
	
	var _PromiseUtils = __webpack_require__(712);
	
	var _PatternUtils = __webpack_require__(102);
	
	var _routerWarning = __webpack_require__(103);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(57);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1036);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(271);
	
	var _PropTypes = __webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(719), __webpack_require__(2), __webpack_require__(274), __webpack_require__(275), __webpack_require__(1455)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('./SAlertContent'), require('prop-types'), require('./s-alert-parts/s-alert-store'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-data-prep'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.SAlertContent, global.propTypes, global.sAlertStore, global.sAlertTools, global.sAlertDataPrep);
	        global.SAlert = mod.exports;
	    }
	})(this, function (exports, _react, _SAlertContent, _propTypes, _sAlertStore, _sAlertTools, _sAlertDataPrep) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);
	
	    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);
	
	    var _sAlertDataPrep2 = _interopRequireDefault(_sAlertDataPrep);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var _extends = Object.assign || function (target) {
	        for (var i = 1; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            for (var key in source) {
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	
	        return target;
	    };
	
	    var insertFunc = function insertFunc(msg, data, condition) {
	        var id = _sAlertTools2.default.randomId();
	        _sAlertStore2.default.dispatch({
	            type: 'INSERT',
	            data: _extends({}, data, {
	                id: id,
	                condition: condition,
	                message: msg
	            })
	        });
	        return id;
	    };
	
	    var SAlert = function (_React$Component) {
	        _inherits(SAlert, _React$Component);
	
	        function SAlert(props) {
	            _classCallCheck(this, SAlert);
	
	            var _this = _possibleConstructorReturn(this, (SAlert.__proto__ || Object.getPrototypeOf(SAlert)).call(this, props));
	
	            _this.state = {
	                dataRight: [],
	                dataLeft: [],
	                dataTop: [],
	                dataBottom: []
	            };
	            return _this;
	        }
	
	        _createClass(SAlert, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                var storeStateLeft = void 0;
	                var storeStateRight = void 0;
	                var storeStateTop = void 0;
	                var storeStateBottom = void 0;
	
	                var addToStoreRight = function addToStoreRight() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
	                            length = storeStateRight.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateRight[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
	                            }
	                            _this2.setState({ dataRight: storeStateRight });
	                        });
	                    });
	                };
	                this.unsubStoreRight = _sAlertStore2.default.subscribe(addToStoreRight);
	
	                var addToStoreLeft = function addToStoreLeft() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
	                            length = storeStateLeft.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateLeft[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
	                            }
	                            _this2.setState({ dataLeft: storeStateLeft });
	                        });
	                    });
	                };
	                this.unsubStoreLeft = _sAlertStore2.default.subscribe(addToStoreLeft);
	
	                var addToStoreTop = function addToStoreTop() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
	                            length = storeStateTop.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateTop[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
	                            }
	                            _this2.setState({ dataTop: storeStateTop });
	                        });
	                    });
	                };
	                this.unsubStoreTop = _sAlertStore2.default.subscribe(addToStoreTop);
	
	                var addToStoreBottom = function addToStoreBottom() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
	                            length = storeStateBottom.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateBottom[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
	                            }
	                            _this2.setState({ dataBottom: storeStateBottom });
	                        });
	                    });
	                };
	                this.unsubStoreBottom = _sAlertStore2.default.subscribe(addToStoreBottom);
	
	                // set up global config from global SAlert props
	                // only stuff needed for getAlertData
	                var globalConfig = {
	                    contentTemplate: this.props.contentTemplate,
	                    offset: this.props.offset,
	                    message: this.props.message,
	                    stack: this.props.stack,
	                    html: this.props.html,
	                    customFields: this.props.customFields,
	                    position: this.props.position || 'top-right',
	                    preserveContext: this.props.preserveContext || false
	                };
	                _sAlertTools2.default.setGlobalConfig(globalConfig);
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.unsubStoreTop();
	                this.unsubStoreBottom();
	                this.unsubStoreLeft();
	                this.unsubStoreRight();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this3 = this;
	
	                var mapFunc = function mapFunc(alert, index) {
	                    var customKey = 'alert-key-' + alert.id + '-' + alert.position;
	                    var id = alert.id;
	                    var condition = _sAlertTools2.default.returnFirstDefined(alert.condition, 'info');
	                    var message = _sAlertTools2.default.returnFirstDefined(alert.message, _this3.props.message, '');
	                    var position = _sAlertTools2.default.returnFirstDefined(alert.position, _this3.props.position, 'top-right');
	                    var offset = _sAlertTools2.default.returnFirstDefined(alert.offset, _this3.props.offset, 0);
	                    var effect = _sAlertTools2.default.returnFirstDefined(alert.effect, _this3.props.effect);
	                    var boxPosition = alert.boxPosition;
	                    var beep = _sAlertTools2.default.returnFirstDefined(alert.beep, _this3.props.beep, false);
	                    var timeout = _sAlertTools2.default.returnFirstDefined(alert.timeout, _this3.props.timeout, 5000);
	                    var html = _sAlertTools2.default.returnFirstDefined(alert.html, _this3.props.html);
	                    var onClose = _sAlertTools2.default.returnFirstDefined(alert.onClose, _this3.props.onClose);
	                    var onShow = _sAlertTools2.default.returnFirstDefined(alert.onShow, _this3.props.onShow);
	                    var customFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, _this3.props.customFields);
	                    var contentTemplate = _this3.props.contentTemplate;
	
	                    return _react2.default.createElement(_SAlertContent2.default, {
	                        key: customKey,
	                        id: id,
	                        customFields: customFields,
	                        condition: condition,
	                        message: message,
	                        position: position,
	                        effect: effect,
	                        boxPosition: boxPosition,
	                        beep: beep,
	                        timeout: timeout,
	                        html: html,
	                        onClose: onClose,
	                        onShow: onShow,
	                        contentTemplate: contentTemplate });
	                };
	                var sAlertElemsRight = this.state.dataRight.map(mapFunc);
	                var sAlertElemsLeft = this.state.dataLeft.map(mapFunc);
	                var sAlertElemsTop = this.state.dataTop.map(mapFunc);
	                var sAlertElemsBottom = this.state.dataBottom.map(mapFunc);
	                return _react2.default.createElement(
	                    'div',
	                    { className: 's-alert-wrapper' },
	                    sAlertElemsRight,
	                    sAlertElemsLeft,
	                    sAlertElemsTop,
	                    sAlertElemsBottom
	                );
	            }
	        }], [{
	            key: 'info',
	            value: function info(msg, data) {
	                return insertFunc(msg, data, 'info');
	            }
	        }, {
	            key: 'error',
	            value: function error(msg, data) {
	                return insertFunc(msg, data, 'error');
	            }
	        }, {
	            key: 'warning',
	            value: function warning(msg, data) {
	                return insertFunc(msg, data, 'warning');
	            }
	        }, {
	            key: 'success',
	            value: function success(msg, data) {
	                return insertFunc(msg, data, 'success');
	            }
	        }, {
	            key: 'close',
	            value: function close(id) {
	                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	            }
	        }, {
	            key: 'closeAll',
	            value: function closeAll() {
	                _sAlertStore2.default.dispatch({ type: 'REMOVEALL' });
	            }
	        }]);
	
	        return SAlert;
	    }(_react2.default.Component);
	
	    SAlert.propTypes = {
	        message: _propTypes2.default.string,
	        position: _propTypes2.default.string,
	        offset: _propTypes2.default.number,
	        stack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	        effect: _propTypes2.default.string,
	        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
	        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
	        html: _propTypes2.default.bool,
	        preserveContext: _propTypes2.default.bool,
	        onClose: _propTypes2.default.func,
	        onShow: _propTypes2.default.func,
	        customFields: _propTypes2.default.object,
	        contentTemplate: _propTypes2.default.func
	    };
	
	    exports.default = SAlert;
	});

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('prop-types'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.propTypes);
	        global.SAlertContentTmpl = mod.exports;
	    }
	})(this, function (exports, _react, _propTypes) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var SAlertContentTmpl = function (_React$Component) {
	        _inherits(SAlertContentTmpl, _React$Component);
	
	        function SAlertContentTmpl(props) {
	            _classCallCheck(this, SAlertContentTmpl);
	
	            return _possibleConstructorReturn(this, (SAlertContentTmpl.__proto__ || Object.getPrototypeOf(SAlertContentTmpl)).call(this, props));
	        }
	
	        _createClass(SAlertContentTmpl, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(
	                    'div',
	                    { className: this.props.classNames, id: this.props.id, style: this.props.styles },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 's-alert-box-inner' },
	                        this.props.message
	                    ),
	                    _react2.default.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose })
	                );
	            }
	        }]);
	
	        return SAlertContentTmpl;
	    }(_react2.default.Component);
	
	    SAlertContentTmpl.propTypes = {
	        id: _propTypes2.default.string.isRequired,
	        classNames: _propTypes2.default.string.isRequired,
	        condition: _propTypes2.default.string.isRequired,
	        styles: _propTypes2.default.object.isRequired,
	        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	        handleClose: _propTypes2.default.func.isRequired,
	        customFields: _propTypes2.default.object
	    };
	
	    exports.default = SAlertContentTmpl;
	});

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(20), __webpack_require__(719), __webpack_require__(274), __webpack_require__(275)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('react-dom'), require('../SAlertContent'), require('./s-alert-store'), require('./s-alert-tools'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.reactDom, global.SAlertContent, global.sAlertStore, global.sAlertTools);
	        global.sAlertDataPrep = mod.exports;
	    }
	})(this, function (exports, _react, _reactDom, _SAlertContent, _sAlertStore, _sAlertTools) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _reactDom2 = _interopRequireDefault(_reactDom);
	
	    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);
	
	    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);
	
	    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _extends = Object.assign || function (target) {
	        for (var i = 1; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            for (var key in source) {
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	
	        return target;
	    };
	
	    var getAlertData = function getAlertData(sAlertPosition, parentComponent) {
	        var positionTop = 0;
	        var positionBottom = 0;
	        var padding = 0;
	        var alerts = {};
	        var style = void 0;
	        var docElement = void 0;
	        var sAlertBoxHeight = void 0;
	        var positionTypeTop = void 0;
	        var positionTypeBottom = void 0;
	        var checkFirst = function checkFirst(type, objId) {
	            var collectionOfType = sAlertCollection.filter(function (obj) {
	                return obj.position === type || sAlertGlobalConfig.position === type;
	            });
	            return collectionOfType && collectionOfType[0].id === objId;
	        };
	        var positionFunc = function positionFunc(position, positionType, alert, docElement, sAlertBoxHeight, reactComponent) {
	            padding = aStack.spacing || parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))[positionType]);
	            if (checkFirst(aPosition, alert.id) && aOffset) {
	                position = 0;
	                position = position + parseInt(aOffset);
	            }
	            if (checkFirst(aPosition, alert.id) && aStack.spacing) {
	                position = position;
	            } else {
	                position = position + parseInt(padding);
	            }
	            style = positionType + ': ' + position + 'px;';
	            position = position + sAlertBoxHeight;
	            return position;
	        };
	
	        var sAlertGlobalConfig = _sAlertTools2.default.getGlobalConfig();
	        var aStack = void 0;
	        var aContentTemplate = void 0;
	        var aOffset = void 0;
	        var aMessage = void 0;
	        var aHtml = void 0;
	        var aCustomFields = void 0;
	        var aPosition = void 0;
	        var preserveContext = void 0;
	
	        var query = {};
	        if (sAlertPosition === 'left') {
	            query = function query(item) {
	                return item.position === 'top-left' || item.position === 'bottom-left' || !item.position && (sAlertGlobalConfig.position === 'top-left' || sAlertGlobalConfig.position === 'bottom-left');
	            };
	        }
	        if (sAlertPosition === 'right') {
	            query = function query(item) {
	                return item.position === 'top-right' || item.position === 'bottom-right' || !item.position && (sAlertGlobalConfig.position === 'top-right' || sAlertGlobalConfig.position === 'bottom-right');
	            };
	        }
	        if (sAlertPosition === 'full-top') {
	            query = function query(item) {
	                return item.position === 'top' || !item.position && sAlertGlobalConfig.position === 'top';
	            };
	        }
	        if (sAlertPosition === 'full-bottom') {
	            query = function query(item) {
	                return item.position === 'bottom' || !item.position && sAlertGlobalConfig.position === 'bottom';
	            };
	        }
	
	        var currentState = _sAlertStore2.default.getState();
	        var sAlertCollection = currentState.slice().filter(query);
	
	        return sAlertCollection.map(function (alert) {
	            aStack = sAlertGlobalConfig.stack;
	            aContentTemplate = sAlertGlobalConfig.contentTemplate;
	            aOffset = _sAlertTools2.default.returnFirstDefined(alert.offset, sAlertGlobalConfig.offset);
	            aMessage = _sAlertTools2.default.returnFirstDefined(alert.message, sAlertGlobalConfig.message);
	            aHtml = _sAlertTools2.default.returnFirstDefined(alert.html, sAlertGlobalConfig.html);
	            aCustomFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, sAlertGlobalConfig.customFields);
	            aPosition = _sAlertTools2.default.returnFirstDefined(alert.position, sAlertGlobalConfig.position);
	            preserveContext = _sAlertTools2.default.returnFirstDefined(alert.preserveContext, sAlertGlobalConfig.preserveContext);
	            positionTypeTop = aPosition && /top/g.test(aPosition);
	            positionTypeBottom = aPosition && /bottom/g.test(aPosition);
	
	            if (aStack) {
	                // checking alert box height - needed to calculate position
	                docElement = document.createElement('div');
	                docElement.classList.add('s-alert-box-height');
	
	                // mock element, needed for positions calculations
	                var reactElement = _react2.default.createElement(_SAlertContent2.default, {
	                    key: _sAlertTools2.default.randomId(),
	                    id: _sAlertTools2.default.randomId(),
	                    condition: alert.condition,
	                    message: aMessage,
	                    position: aPosition,
	                    effect: alert.effect,
	                    boxPosition: alert.boxPosition,
	                    beep: false,
	                    timeout: 'none',
	                    html: aHtml,
	                    contentTemplate: aContentTemplate,
	                    customFields: aCustomFields
	                });
	
	                var reactComponent = void 0;
	
	                if (preserveContext) {
	                    reactComponent = _reactDom2.default.unstable_renderSubtreeIntoContainer(parentComponent, reactElement, docElement);
	                } else {
	                    reactComponent = _reactDom2.default.render(reactElement, docElement);
	                }
	
	                document.body.appendChild(docElement);
	                sAlertBoxHeight = parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))['height']);
	                if (positionTypeTop) {
	                    positionTop = positionFunc(positionTop, 'top', alert, docElement, sAlertBoxHeight, reactComponent);
	                }
	                if (positionTypeBottom) {
	                    positionBottom = positionFunc(positionBottom, 'bottom', alert, docElement, sAlertBoxHeight, reactComponent);
	                }
	                var sAlertComputedStyle = getComputedStyle(_reactDom2.default.findDOMNode(reactComponent));
	                if (sAlertPosition === 'left') {
	                    style = style + 'left: ' + (aStack.spacing || parseInt(sAlertComputedStyle.left)) + 'px;';
	                }
	                if (sAlertPosition === 'right') {
	                    style = style + 'right: ' + (aStack.spacing || parseInt(sAlertComputedStyle.right)) + 'px;';
	                }
	                alerts = _extends({}, alert, { boxPosition: style });
	                _reactDom2.default.unmountComponentAtNode(docElement);
	                docElement.parentNode.removeChild(docElement);
	            } else if (aOffset && positionTypeTop) {
	                alerts = _extends({}, alert, { boxPosition: 'top: ' + parseInt(aOffset) + 'px;' });
	            } else if (aOffset && positionTypeBottom) {
	                alerts = _extends({}, alert, { boxPosition: 'bottom: ' + parseInt(aOffset) + 'px;' });
	            } else {
	                alerts = alert;
	            }
	            return alerts;
	        });
	    };
	
	    exports.default = getAlertData;
	});

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1154).enable();
	  window.Promise = __webpack_require__(1153);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1457);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(38);


/***/ },
/* 1457 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(721);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(722);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(174);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 1459 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 1460 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _find = __webpack_require__(1135);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _sortBy = __webpack_require__(1144);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Manager = function () {
	  function Manager() {
	    _classCallCheck(this, Manager);
	
	    this.refs = {};
	  }
	
	  _createClass(Manager, [{
	    key: 'add',
	    value: function add(collection, ref) {
	      if (!this.refs[collection]) {
	        this.refs[collection] = [];
	      }
	
	      this.refs[collection].push(ref);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(collection, ref) {
	      var index = this.getIndex(collection, ref);
	
	      if (index !== -1) {
	        this.refs[collection].splice(index, 1);
	      }
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive() {
	      return this.active;
	    }
	  }, {
	    key: 'getActive',
	    value: function getActive() {
	      var _this = this;
	
	      return (0, _find2.default)(this.refs[this.active.collection],
	      // eslint-disable-next-line eqeqeq
	      function (_ref) {
	        var node = _ref.node;
	        return node.sortableInfo.index == _this.active.index;
	      });
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(collection, ref) {
	      return this.refs[collection].indexOf(ref);
	    }
	  }, {
	    key: 'getOrderedRefs',
	    value: function getOrderedRefs() {
	      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
	
	      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
	        var node = _ref2.node;
	        return node.sortableInfo.index;
	      });
	    }
	  }]);
	
	  return Manager;
	}();
	
	exports.default = Manager;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _invariant = __webpack_require__(278);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Manager = __webpack_require__(1462);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _utils = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Container Component
	function sortableContainer(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _this.handleStart = function (e) {
	        var _this$props = _this.props,
	            distance = _this$props.distance,
	            shouldCancelStart = _this$props.shouldCancelStart;
	
	
	        if (e.button === 2 || shouldCancelStart(e)) {
	          return false;
	        }
	
	        _this._touched = true;
	        _this._pos = {
	          x: e.pageX,
	          y: e.pageY
	        };
	
	        var node = (0, _utils.closest)(e.target, function (el) {
	          return el.sortableInfo != null;
	        });
	
	        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
	          var useDragHandle = _this.props.useDragHandle;
	          var _node$sortableInfo = node.sortableInfo,
	              index = _node$sortableInfo.index,
	              collection = _node$sortableInfo.collection;
	
	
	          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
	            return el.sortableHandle != null;
	          })) return;
	
	          _this.manager.active = { index: index, collection: collection };
	
	          /*
	          * Fixes a bug in Firefox where the :active state of anchor tags
	          * prevent subsequent 'mousemove' events from being fired
	          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
	          */
	          if (e.target.tagName.toLowerCase() === 'a') {
	            e.preventDefault();
	          }
	
	          if (!distance) {
	            if (_this.props.pressDelay === 0) {
	              _this.handlePress(e);
	            } else {
	              _this.pressTimer = setTimeout(function () {
	                return _this.handlePress(e);
	              }, _this.props.pressDelay);
	            }
	          }
	        }
	      };
	
	      _this.nodeIsChild = function (node) {
	        return node.sortableInfo.manager === _this.manager;
	      };
	
	      _this.handleMove = function (e) {
	        var _this$props2 = _this.props,
	            distance = _this$props2.distance,
	            pressThreshold = _this$props2.pressThreshold;
	
	
	        if (!_this.state.sorting && _this._touched) {
	          _this._delta = {
	            x: _this._pos.x - e.pageX,
	            y: _this._pos.y - e.pageY
	          };
	          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);
	
	          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
	            clearTimeout(_this.cancelTimer);
	            _this.cancelTimer = setTimeout(_this.cancel, 0);
	          } else if (distance && delta >= distance && _this.manager.isActive()) {
	            _this.handlePress(e);
	          }
	        }
	      };
	
	      _this.handleEnd = function () {
	        var distance = _this.props.distance;
	
	
	        _this._touched = false;
	
	        if (!distance) {
	          _this.cancel();
	        }
	      };
	
	      _this.cancel = function () {
	        if (!_this.state.sorting) {
	          clearTimeout(_this.pressTimer);
	          _this.manager.active = null;
	        }
	      };
	
	      _this.handlePress = function (e) {
	        var active = _this.manager.getActive();
	
	        if (active) {
	          var _this$props3 = _this.props,
	              axis = _this$props3.axis,
	              getHelperDimensions = _this$props3.getHelperDimensions,
	              helperClass = _this$props3.helperClass,
	              hideSortableGhost = _this$props3.hideSortableGhost,
	              onSortStart = _this$props3.onSortStart,
	              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
	          var node = active.node,
	              collection = active.collection;
	          var index = node.sortableInfo.index;
	
	          var margin = (0, _utils.getElementMargin)(node);
	
	          var containerBoundingRect = _this.container.getBoundingClientRect();
	          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });
	
	          _this.node = node;
	          _this.margin = margin;
	          _this.width = dimensions.width;
	          _this.height = dimensions.height;
	          _this.marginOffset = {
	            x: _this.margin.left + _this.margin.right,
	            y: Math.max(_this.margin.top, _this.margin.bottom)
	          };
	          _this.boundingClientRect = node.getBoundingClientRect();
	          _this.containerBoundingRect = containerBoundingRect;
	          _this.index = index;
	          _this.newIndex = index;
	
	          _this.axis = {
	            x: axis.indexOf('x') >= 0,
	            y: axis.indexOf('y') >= 0
	          };
	          _this.offsetEdge = _this.getEdgeOffset(node);
	          _this.initialOffset = _this.getOffset(e);
	          _this.initialScroll = {
	            top: _this.scrollContainer.scrollTop,
	            left: _this.scrollContainer.scrollLeft
	          };
	
	          _this.initialWindowScroll = {
	            top: window.pageYOffset,
	            left: window.pageXOffset
	          };
	
	          var fields = node.querySelectorAll('input, textarea, select');
	          var clonedNode = node.cloneNode(true);
	          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array
	
	          clonedFields.forEach(function (field, index) {
	            if (field.type !== 'file' && fields[index]) {
	              field.value = fields[index].value;
	            }
	          });
	
	          _this.helper = _this.document.body.appendChild(clonedNode);
	
	          _this.helper.style.position = 'fixed';
	          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
	          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
	          _this.helper.style.width = _this.width + 'px';
	          _this.helper.style.height = _this.height + 'px';
	          _this.helper.style.boxSizing = 'border-box';
	          _this.helper.style.pointerEvents = 'none';
	
	          if (hideSortableGhost) {
	            _this.sortableGhost = node;
	            node.style.visibility = 'hidden';
	            node.style.opacity = 0;
	          }
	
	          _this.minTranslate = {};
	          _this.maxTranslate = {};
	          if (_this.axis.x) {
	            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
	            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
	          }
	          if (_this.axis.y) {
	            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
	            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
	          }
	
	          if (helperClass) {
	            var _this$helper$classLis;
	
	            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
	          }
	
	          _this.listenerNode = e.touches ? node : _this.contentWindow;
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
	          });
	
	          _this.setState({
	            sorting: true,
	            sortingIndex: index
	          });
	
	          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
	        }
	      };
	
	      _this.handleSortMove = function (e) {
	        var onSortMove = _this.props.onSortMove;
	
	        e.preventDefault(); // Prevent scrolling on mobile
	
	        _this.updatePosition(e);
	        _this.animateNodes();
	        _this.autoscroll();
	
	        if (onSortMove) onSortMove(e);
	      };
	
	      _this.handleSortEnd = function (e) {
	        var _this$props4 = _this.props,
	            hideSortableGhost = _this$props4.hideSortableGhost,
	            onSortEnd = _this$props4.onSortEnd;
	        var collection = _this.manager.active.collection;
	
	        // Remove the event listeners if the node is still in the DOM
	
	        if (_this.listenerNode) {
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
	          });
	        }
	
	        // Remove the helper from the DOM
	        _this.helper.parentNode.removeChild(_this.helper);
	
	        if (hideSortableGhost && _this.sortableGhost) {
	          _this.sortableGhost.style.visibility = '';
	          _this.sortableGhost.style.opacity = '';
	        }
	
	        var nodes = _this.manager.refs[collection];
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i];
	          var el = node.node;
	
	          // Clear the cached offsetTop / offsetLeft value
	          node.edgeOffset = null;
	
	          // Remove the transforms / transitions
	          el.style[_utils.vendorPrefix + 'Transform'] = '';
	          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
	        }
	
	        // Stop autoscroll
	        clearInterval(_this.autoscrollInterval);
	        _this.autoscrollInterval = null;
	
	        // Update state
	        _this.manager.active = null;
	
	        _this.setState({
	          sorting: false,
	          sortingIndex: null
	        });
	
	        if (typeof onSortEnd === 'function') {
	          onSortEnd({
	            oldIndex: _this.index,
	            newIndex: _this.newIndex,
	            collection: collection
	          }, e);
	        }
	
	        _this._touched = false;
	      };
	
	      _this.autoscroll = function () {
	        var translate = _this.translate;
	        var direction = {
	          x: 0,
	          y: 0
	        };
	        var speed = {
	          x: 1,
	          y: 1
	        };
	        var acceleration = {
	          x: 10,
	          y: 10
	        };
	
	        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
	          direction.y = 1; // Scroll Down
	          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
	        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
	          direction.x = 1; // Scroll Right
	          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
	        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
	          direction.y = -1; // Scroll Up
	          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
	        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
	          direction.x = -1; // Scroll Left
	          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
	        }
	
	        if (_this.autoscrollInterval) {
	          clearInterval(_this.autoscrollInterval);
	          _this.autoscrollInterval = null;
	          _this.isAutoScrolling = false;
	        }
	
	        if (direction.x !== 0 || direction.y !== 0) {
	          _this.autoscrollInterval = setInterval(function () {
	            _this.isAutoScrolling = true;
	            var offset = {
	              left: 1 * speed.x * direction.x,
	              top: 1 * speed.y * direction.y
	            };
	            _this.scrollContainer.scrollTop += offset.top;
	            _this.scrollContainer.scrollLeft += offset.left;
	            _this.translate.x += offset.left;
	            _this.translate.y += offset.top;
	            _this.animateNodes();
	          }, 5);
	        }
	      };
	
	      _this.manager = new _Manager2.default();
	      _this.events = {
	        start: _this.handleStart,
	        move: _this.handleMove,
	        end: _this.handleEnd
	      };
	
	      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return {
	          manager: this.manager
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        var _props = this.props,
	            getContainer = _props.getContainer,
	            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;
	
	        /*
	         *  Set our own default rather than using defaultProps because Jest
	         *  snapshots will serialize window, causing a RangeError
	         *  https://github.com/clauderic/react-sortable-hoc/issues/249
	         */
	
	        var contentWindow = this.props.contentWindow || window;
	
	        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
	        this.document = this.container.ownerDocument || document;
	        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
	        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
	
	        var _loop = function _loop(key) {
	          if (_this2.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this2.container.addEventListener(eventName, _this2.events[key], false);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop(key);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _this3 = this;
	
	        var _loop2 = function _loop2(key) {
	          if (_this3.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this3.container.removeEventListener(eventName, _this3.events[key]);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop2(key);
	        }
	      }
	    }, {
	      key: 'getEdgeOffset',
	      value: function getEdgeOffset(node) {
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };
	
	        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
	        if (node) {
	          var nodeOffset = {
	            top: offset.top + node.offsetTop,
	            left: offset.left + node.offsetLeft
	          };
	          if (node.parentNode !== this.container) {
	            return this.getEdgeOffset(node.parentNode, nodeOffset);
	          } else {
	            return nodeOffset;
	          }
	        }
	      }
	    }, {
	      key: 'getOffset',
	      value: function getOffset(e) {
	        return {
	          x: e.touches ? e.touches[0].pageX : e.pageX,
	          y: e.touches ? e.touches[0].pageY : e.pageY
	        };
	      }
	    }, {
	      key: 'getLockPixelOffsets',
	      value: function getLockPixelOffsets() {
	        var lockOffset = this.props.lockOffset;
	
	
	        if (!Array.isArray(lockOffset)) {
	          lockOffset = [lockOffset, lockOffset];
	        }
	
	        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);
	
	        var _lockOffset = lockOffset,
	            _lockOffset2 = _slicedToArray(_lockOffset, 2),
	            minLockOffset = _lockOffset2[0],
	            maxLockOffset = _lockOffset2[1];
	
	        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
	      }
	    }, {
	      key: 'getLockPixelOffset',
	      value: function getLockPixelOffset(lockOffset) {
	        var offsetX = lockOffset;
	        var offsetY = lockOffset;
	        var unit = 'px';
	
	        if (typeof lockOffset === 'string') {
	          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
	
	          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
	
	          offsetX = offsetY = parseFloat(lockOffset);
	          unit = match[1];
	        }
	
	        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
	
	        if (unit === '%') {
	          offsetX = offsetX * this.width / 100;
	          offsetY = offsetY * this.height / 100;
	        }
	
	        return {
	          x: offsetX,
	          y: offsetY
	        };
	      }
	    }, {
	      key: 'updatePosition',
	      value: function updatePosition(e) {
	        var _props2 = this.props,
	            lockAxis = _props2.lockAxis,
	            lockToContainerEdges = _props2.lockToContainerEdges;
	
	
	        var offset = this.getOffset(e);
	        var translate = {
	          x: offset.x - this.initialOffset.x,
	          y: offset.y - this.initialOffset.y
	        };
	        // Adjust for window scroll
	        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
	        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
	
	        this.translate = translate;
	
	        if (lockToContainerEdges) {
	          var _getLockPixelOffsets = this.getLockPixelOffsets(),
	              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
	              minLockOffset = _getLockPixelOffsets2[0],
	              maxLockOffset = _getLockPixelOffsets2[1];
	
	          var minOffset = {
	            x: this.width / 2 - minLockOffset.x,
	            y: this.height / 2 - minLockOffset.y
	          };
	          var maxOffset = {
	            x: this.width / 2 - maxLockOffset.x,
	            y: this.height / 2 - maxLockOffset.y
	          };
	
	          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
	          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
	        }
	
	        if (lockAxis === 'x') {
	          translate.y = 0;
	        } else if (lockAxis === 'y') {
	          translate.x = 0;
	        }
	
	        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
	      }
	    }, {
	      key: 'animateNodes',
	      value: function animateNodes() {
	        var _props3 = this.props,
	            transitionDuration = _props3.transitionDuration,
	            hideSortableGhost = _props3.hideSortableGhost;
	
	        var nodes = this.manager.getOrderedRefs();
	        var deltaScroll = {
	          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
	          top: this.scrollContainer.scrollTop - this.initialScroll.top
	        };
	        var sortingOffset = {
	          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
	          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
	        };
	        var scrollDifference = {
	          top: window.pageYOffset - this.initialWindowScroll.top,
	          left: window.pageXOffset - this.initialWindowScroll.left
	        };
	        this.newIndex = null;
	
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i].node;
	
	          var index = node.sortableInfo.index;
	          var width = node.offsetWidth;
	          var height = node.offsetHeight;
	          var offset = {
	            width: this.width > width ? width / 2 : this.width / 2,
	            height: this.height > height ? height / 2 : this.height / 2
	          };
	
	          var translate = {
	            x: 0,
	            y: 0
	          };
	          var edgeOffset = nodes[i].edgeOffset;
	
	          // If we haven't cached the node's offsetTop / offsetLeft value
	
	          if (!edgeOffset) {
	            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
	          }
	
	          // Get a reference to the next and previous node
	          var nextNode = i < nodes.length - 1 && nodes[i + 1];
	          var prevNode = i > 0 && nodes[i - 1];
	
	          // Also cache the next node's edge offset if needed.
	          // We need this for calculating the animation in a grid setup
	          if (nextNode && !nextNode.edgeOffset) {
	            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
	          }
	
	          // If the node is the one we're currently animating, skip it
	          if (index === this.index) {
	            if (hideSortableGhost) {
	              /*
	              * With windowing libraries such as `react-virtualized`, the sortableGhost
	              * node may change while scrolling down and then back up (or vice-versa),
	              * so we need to update the reference to the new node just to be safe.
	              */
	              this.sortableGhost = node;
	              node.style.visibility = 'hidden';
	              node.style.opacity = 0;
	            }
	            continue;
	          }
	
	          if (transitionDuration) {
	            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
	          }
	
	          if (this.axis.x) {
	            if (this.axis.y) {
	              // Calculations for a grid setup
	              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
	                // If the current node is to the left on the same row, or above the node that's being dragged
	                // then move it to the right
	                translate.x = this.width + this.marginOffset.x;
	                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
	                  // If it moves passed the right bounds, then animate it to the first position of the next row.
	                  // We just use the offset of the next node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
	                }
	                if (this.newIndex === null) {
	                  this.newIndex = index;
	                }
	              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
	                // If the current node is to the right on the same row, or below the node that's being dragged
	                // then move it to the left
	                translate.x = -(this.width + this.marginOffset.x);
	                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
	                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
	                  // We just use the offset of the previous node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
	                }
	                this.newIndex = index;
	              }
	            } else {
	              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
	                translate.x = -(this.width + this.marginOffset.x);
	                this.newIndex = index;
	              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
	                translate.x = this.width + this.marginOffset.x;
	                if (this.newIndex == null) {
	                  this.newIndex = index;
	                }
	              }
	            }
	          } else if (this.axis.y) {
	            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
	              translate.y = -(this.height + this.marginOffset.y);
	              this.newIndex = index;
	            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
	              translate.y = this.height + this.marginOffset.y;
	              if (this.newIndex == null) {
	                this.newIndex = index;
	              }
	            }
	          }
	          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
	        }
	
	        if (this.newIndex == null) {
	          this.newIndex = this.index;
	        }
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
	    axis: 'y',
	    transitionDuration: 300,
	    pressDelay: 0,
	    pressThreshold: 5,
	    distance: 0,
	    useWindowAsScrollContainer: false,
	    hideSortableGhost: true,
	    shouldCancelStart: function shouldCancelStart(e) {
	      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
	      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
	
	      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
	        return true; // Return true to cancel sorting
	      }
	    },
	    lockToContainerEdges: false,
	    lockOffset: '50%',
	    getHelperDimensions: function getHelperDimensions(_ref) {
	      var node = _ref.node;
	      return {
	        width: node.offsetWidth,
	        height: node.offsetHeight
	      };
	    }
	  }, _class.propTypes = {
	    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
	    distance: _propTypes2.default.number,
	    lockAxis: _propTypes2.default.string,
	    helperClass: _propTypes2.default.string,
	    transitionDuration: _propTypes2.default.number,
	    contentWindow: _propTypes2.default.any,
	    onSortStart: _propTypes2.default.func,
	    onSortMove: _propTypes2.default.func,
	    onSortEnd: _propTypes2.default.func,
	    shouldCancelStart: _propTypes2.default.func,
	    pressDelay: _propTypes2.default.number,
	    useDragHandle: _propTypes2.default.bool,
	    useWindowAsScrollContainer: _propTypes2.default.bool,
	    hideSortableGhost: _propTypes2.default.bool,
	    lockToContainerEdges: _propTypes2.default.bool,
	    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	    getContainer: _propTypes2.default.func,
	    getHelperDimensions: _propTypes2.default.func
	  }, _class.childContextTypes = {
	    manager: _propTypes2.default.object.isRequired
	  }, _temp;
	}

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(20);
	
	var _invariant = __webpack_require__(278);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableElement(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _props = this.props,
	            collection = _props.collection,
	            disabled = _props.disabled,
	            index = _props.index;
	
	
	        if (!disabled) {
	          this.setDraggable(collection, index);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.index !== nextProps.index && this.node) {
	          this.node.sortableInfo.index = nextProps.index;
	        }
	        if (this.props.disabled !== nextProps.disabled) {
	          var collection = nextProps.collection,
	              disabled = nextProps.disabled,
	              index = nextProps.index;
	
	          if (disabled) {
	            this.removeDraggable(collection);
	          } else {
	            this.setDraggable(collection, index);
	          }
	        } else if (this.props.collection !== nextProps.collection) {
	          this.removeDraggable(this.props.collection);
	          this.setDraggable(nextProps.collection, nextProps.index);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _props2 = this.props,
	            collection = _props2.collection,
	            disabled = _props2.disabled;
	
	
	        if (!disabled) this.removeDraggable(collection);
	      }
	    }, {
	      key: 'setDraggable',
	      value: function setDraggable(collection, index) {
	        var node = this.node = (0, _reactDom.findDOMNode)(this);
	
	        node.sortableInfo = {
	          index: index,
	          collection: collection,
	          manager: this.context.manager
	        };
	
	        this.ref = { node: node };
	        this.context.manager.add(collection, this.ref);
	      }
	    }, {
	      key: 'removeDraggable',
	      value: function removeDraggable(collection) {
	        this.context.manager.remove(collection, this.ref);
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
	    manager: _propTypes2.default.object.isRequired
	  }, _class.propTypes = {
	    index: _propTypes2.default.number.isRequired,
	    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    disabled: _propTypes2.default.bool
	  }, _class.defaultProps = {
	    collection: 0
	  }, _temp;
	}

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableHandle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _invariant = __webpack_require__(278);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableHandle(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var node = (0, _reactDom.findDOMNode)(this);
	        node.sortableHandle = true;
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
	}

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;
	
	var _utils = __webpack_require__(176);
	
	Object.defineProperty(exports, 'arrayMove', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayMove;
	  }
	});
	
	var _SortableContainer2 = __webpack_require__(1463);
	
	var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);
	
	var _SortableElement2 = __webpack_require__(1464);
	
	var _SortableElement3 = _interopRequireDefault(_SortableElement2);
	
	var _SortableHandle2 = __webpack_require__(1465);
	
	var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SortableContainer = _SortableContainer3.default;
	exports.SortableElement = _SortableElement3.default;
	exports.SortableHandle = _SortableHandle3.default;
	exports.sortableContainer = _SortableContainer3.default;
	exports.sortableElement = _SortableElement3.default;
	exports.sortableHandle = _SortableHandle3.default;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var callbacks = [];
	
	function addScript(src, cb) {
	  if (callbacks.length === 0) {
	    callbacks.push(cb);
	    var s = document.createElement('script');
	    s.setAttribute('src', src);
	    s.onload = function () {
	      return callbacks.forEach(function (cb) {
	        return cb();
	      });
	    };
	    document.body.appendChild(s);
	  } else {
	    callbacks.push(cb);
	  }
	}
	
	var TweetEmbed = function (_React$Component) {
	  _inherits(TweetEmbed, _React$Component);
	
	  function TweetEmbed() {
	    _classCallCheck(this, TweetEmbed);
	
	    return _possibleConstructorReturn(this, (TweetEmbed.__proto__ || Object.getPrototypeOf(TweetEmbed)).apply(this, arguments));
	  }
	
	  _createClass(TweetEmbed, [{
	    key: 'loadTweetForProps',
	    value: function loadTweetForProps(props) {
	      var _this2 = this;
	
	      var renderTweet = function renderTweet() {
	        window.twttr.ready().then(function (_ref) {
	          var widgets = _ref.widgets;
	
	          // Clear previously rendered tweet before rendering the updated tweet id
	          if (_this2._div) {
	            _this2._div.innerHTML = '';
	          }
	
	          var options = props.options,
	              onTweetLoadSuccess = props.onTweetLoadSuccess,
	              onTweetLoadError = props.onTweetLoadError;
	
	          widgets.createTweetEmbed(_this2.props.id, _this2._div, options).then(onTweetLoadSuccess).catch(onTweetLoadError);
	        });
	      };
	
	      if (!(window.twttr && window.twttr.ready)) {
	        var isLocal = window.location.protocol.indexOf('file') >= 0;
	        var protocol = isLocal ? this.props.protocol : '';
	
	        addScript(protocol + '//platform.twitter.com/widgets.js', renderTweet);
	      } else {
	        renderTweet();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadTweetForProps(this.props);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.id !== nextProps.id;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.loadTweetForProps(nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('div', {
	        className: this.props.className,
	        ref: function ref(c) {
	          _this3._div = c;
	        }
	      });
	    }
	  }]);
	
	  return TweetEmbed;
	}(_react2.default.Component);
	
	TweetEmbed.propTypes = {
	  id: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  protocol: _propTypes2.default.string,
	  onTweetLoadSuccess: _propTypes2.default.func,
	  onTweetLoadError: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	TweetEmbed.defaultProps = {
	  protocol: 'https:',
	  options: {},
	  className: null
	};
	
	exports.default = TweetEmbed;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isEqual = __webpack_require__(1139);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _youtubePlayer = __webpack_require__(1479);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Check whether a `props` change should result in the video being updated.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdateVideo(prevProps, props) {
	  // A changing video should always trigger an update
	  if (prevProps.videoId !== props.videoId) {
	    return true;
	  }
	
	  // Otherwise, a change in the start/end time playerVars also requires a player
	  // update.
	  var prevVars = prevProps.opts.playerVars || {};
	  var vars = props.opts.playerVars || {};
	
	  return prevVars.start !== vars.start || prevVars.end !== vars.end;
	}
	
	/**
	 * Neutralise API options that only require a video update, leaving only options
	 * that require a player reset. The results can then be compared to see if a
	 * player reset is necessary.
	 *
	 * @param {Object} opts
	 */
	function filterResetOptions(opts) {
	  return _extends({}, opts, {
	    playerVars: _extends({}, opts.playerVars, {
	      autoplay: 0,
	      start: 0,
	      end: 0
	    })
	  });
	}
	
	/**
	 * Check whether a `props` change should result in the player being reset.
	 * The player is reset when the `props.opts` change, except if the only change
	 * is in the `start` and `end` playerVars, because a video update can deal with
	 * those.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldResetPlayer(prevProps, props) {
	  return !(0, _isEqual2.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
	}
	
	/**
	 * Check whether a props change should result in an id or className update.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdatePlayer(prevProps, props) {
	  return prevProps.id === props.id || prevProps.className === props.className;
	}
	
	var YouTube = function (_React$Component) {
	  _inherits(YouTube, _React$Component);
	
	  function YouTube(props) {
	    _classCallCheck(this, YouTube);
	
	    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));
	
	    _this.onPlayerReady = function (event) {
	      return _this.props.onReady(event);
	    };
	
	    _this.onPlayerError = function (event) {
	      return _this.props.onError(event);
	    };
	
	    _this.onPlayerStateChange = function (event) {
	      _this.props.onStateChange(event);
	      switch (event.data) {
	
	        case YouTube.PlayerState.ENDED:
	          _this.props.onEnd(event);
	          break;
	
	        case YouTube.PlayerState.PLAYING:
	          _this.props.onPlay(event);
	          break;
	
	        case YouTube.PlayerState.PAUSED:
	          _this.props.onPause(event);
	          break;
	
	        default:
	          return;
	      }
	    };
	
	    _this.onPlayerPlaybackRateChange = function (event) {
	      return _this.props.onPlaybackRateChange(event);
	    };
	
	    _this.onPlayerPlaybackQualityChange = function (event) {
	      return _this.props.onPlaybackQualityChange(event);
	    };
	
	    _this.createPlayer = function () {
	      // do not attempt to create a player server-side, it won't work
	      if (typeof document === 'undefined') return;
	      // create player
	      var playerOpts = _extends({}, _this.props.opts, {
	        // preload the `videoId` video if one is already given
	        videoId: _this.props.videoId
	      });
	      _this.internalPlayer = (0, _youtubePlayer2.default)(_this.container, playerOpts);
	      // attach event handlers
	      _this.internalPlayer.on('ready', _this.onPlayerReady);
	      _this.internalPlayer.on('error', _this.onPlayerError);
	      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
	      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
	      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
	    };
	
	    _this.resetPlayer = function () {
	      return _this.internalPlayer.destroy().then(_this.createPlayer);
	    };
	
	    _this.updatePlayer = function () {
	      _this.internalPlayer.getIframe().then(function (iframe) {
	        iframe.setAttribute('id', _this.props.id);
	        iframe.setAttribute('class', _this.props.className);
	      });
	    };
	
	    _this.updateVideo = function () {
	      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
	        _this.internalPlayer.stopVideo();
	        return;
	      }
	
	      // set queueing options
	      var autoplay = false;
	      var opts = {
	        videoId: _this.props.videoId
	      };
	      if ('playerVars' in _this.props.opts) {
	        autoplay = _this.props.opts.playerVars.autoplay === 1;
	        if ('start' in _this.props.opts.playerVars) {
	          opts.startSeconds = _this.props.opts.playerVars.start;
	        }
	        if ('end' in _this.props.opts.playerVars) {
	          opts.endSeconds = _this.props.opts.playerVars.end;
	        }
	      }
	
	      // if autoplay is enabled loadVideoById
	      if (autoplay) {
	        _this.internalPlayer.loadVideoById(opts);
	        return;
	      }
	      // default behaviour just cues the video
	      _this.internalPlayer.cueVideoById(opts);
	    };
	
	    _this.refContainer = function (container) {
	      _this.container = container;
	    };
	
	    _this.container = null;
	    _this.internalPlayer = null;
	    return _this;
	  }
	
	  /**
	    * Expose PlayerState constants for convenience. These constants can also be
	    * accessed through the global YT object after the YouTube IFrame API is instantiated.
	    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	    */
	
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createPlayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (shouldUpdatePlayer(prevProps, this.props)) {
	        this.updatePlayer();
	      }
	
	      if (shouldResetPlayer(prevProps, this.props)) {
	        this.resetPlayer();
	      }
	
	      if (shouldUpdateVideo(prevProps, this.props)) {
	        this.updateVideo();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      /**
	       * Note: The `youtube-player` package that is used promisifies all Youtube
	       * Player API calls, which introduces a delay of a tick before it actually
	       * gets destroyed. Since React attempts to remove the element instantly
	       * this method isn't quick enough to reset the container element.
	       */
	      this.internalPlayer.destroy();
	    }
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onReady
	     *
	     * @param {Object} event
	     *   @param {Object} target - player object
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onError
	     *
	     * @param {Object} event
	     *   @param {Integer} data  - error type
	     *   @param {Object} target - player object
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	     *
	     * @param {Object} event
	     *   @param {Integer} data  - status change type
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
	     *
	     * @param {Object} event
	     *   @param {Float} data    - playback rate
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
	     *
	     * @param {Object} event
	     *   @param {String} data   - playback quality
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * Initialize the Youtube Player API on the container and attach event handlers
	     */
	
	
	    /**
	     * Shorthand for destroying and then re-creating the Youtube Player
	     */
	
	
	    /**
	     * Method to update the id and class of the Youtube Player iframe.
	     * React should update this automatically but since the Youtube Player API
	     * replaced the DIV that is mounted by React we need to do this manually.
	     */
	
	
	    /**
	     * Call Youtube Player API methods to update the currently playing video.
	     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
	     * Youtube Player API methods to update the video.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
	      );
	    }
	  }]);
	
	  return YouTube;
	}(_react2.default.Component);
	
	YouTube.propTypes = {
	  videoId: _propTypes2.default.string,
	
	  // custom ID for player element
	  id: _propTypes2.default.string,
	
	  // custom class name for player element
	  className: _propTypes2.default.string,
	
	  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	  opts: _propTypes2.default.object,
	
	  // event subscriptions
	  onReady: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onEnd: _propTypes2.default.func,
	  onStateChange: _propTypes2.default.func,
	  onPlaybackRateChange: _propTypes2.default.func,
	  onPlaybackQualityChange: _propTypes2.default.func
	};
	YouTube.defaultProps = {
	  opts: {},
	  onReady: function onReady() {},
	  onError: function onError() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onEnd: function onEnd() {},
	  onStateChange: function onStateChange() {},
	  onPlaybackRateChange: function onPlaybackRateChange() {},
	  onPlaybackQualityChange: function onPlaybackQualityChange() {}
	};
	YouTube.PlayerState = {
	  UNSTARTED: -1,
	  ENDED: 0,
	  PLAYING: 1,
	  PAUSED: 2,
	  BUFFERING: 3,
	  CUED: 5
	};
	exports.default = YouTube;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1470);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1472);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 1471 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 1472 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 1473 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	function Sister () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index != -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	}
	
	global.gajus = global.gajus || {};
	global.gajus.Sister = Sister;
	
	module.exports = Sister;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayerStates = __webpack_require__(1476);
	
	var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  pauseVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: false
	  },
	  playVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
	    stateChangeRequired: false
	  },
	  seekTo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: true,
	
	    // TRICKY: `seekTo` may not cause a state change if no buffering is
	    // required.
	    timeout: 3000
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(1469);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _functionNames = __webpack_require__(1478);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(1477);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _FunctionStateMap = __webpack_require__(1474);
	
	var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('youtube-player');
	
	var YouTubePlayer = {};
	
	/**
	 * Construct an object that defines an event handler for all of the YouTube
	 * player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	  var events = {};
	
	  var _loop = function _loop(eventName) {
	    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
	
	    events[onEventName] = function (event) {
	      debug('event "%s"', onEventName, event);
	
	      emitter.trigger(eventName, event);
	    };
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var eventName = _step.value;
	
	      _loop(eventName);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @todo See TRICKY below.
	 * @param playerAPIReady Promise that resolves when player is ready.
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions.
	 * @returns {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var functions = {};
	
	  var _loop2 = function _loop2(functionName) {
	    if (strictState && _FunctionStateMap2.default[functionName]) {
	      functions[functionName] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return playerAPIReady.then(function (player) {
	          var stateInfo = _FunctionStateMap2.default[functionName];
	          var playerState = player.getPlayerState();
	
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          var value = player[functionName].apply(player, args);
	
	          // TRICKY: For functions like `seekTo`, a change in state must be
	          // triggered given that the resulting state could match the initial
	          // state.
	          if (stateInfo.stateChangeRequired ||
	
	          // eslint-disable-next-line no-extra-parens
	          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
	            return new Promise(function (resolve) {
	              var onPlayerStateChange = function onPlayerStateChange() {
	                var playerStateAfterChange = player.getPlayerState();
	
	                var timeout = void 0;
	
	                if (typeof stateInfo.timeout === 'number') {
	                  timeout = setTimeout(function () {
	                    player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                    resolve();
	                  }, stateInfo.timeout);
	                }
	
	                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
	                  player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                  clearTimeout(timeout);
	
	                  resolve();
	                }
	              };
	
	              player.addEventListener('onStateChange', onPlayerStateChange);
	            }).then(function () {
	              return value;
	            });
	          }
	
	          return value;
	        });
	      };
	    } else {
	      functions[functionName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return playerAPIReady.then(function (player) {
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          return player[functionName].apply(player, args);
	        });
	      };
	    }
	  };
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var functionName = _step2.value;
	
	      _loop2(functionName);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return functions;
	};
	
	exports.default = YouTubePlayer;
	module.exports = exports['default'];

/***/ },
/* 1476 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BUFFERING: 3,
	  ENDED: 0,
	  PAUSED: 2,
	  PLAYING: 1,
	  UNSTARTED: -1,
	  VIDEO_CUED: 5
	};
	module.exports = exports["default"];

/***/ },
/* 1477 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * `volumeChange` is not officially supported but seems to work
	 * it emits an object: `{volume: 82.6923076923077, muted: false}`
	 */
	exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
	module.exports = exports['default'];

/***/ },
/* 1478 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
	module.exports = exports['default'];

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _sister = __webpack_require__(1473);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _loadYouTubeIframeApi = __webpack_require__(1480);
	
	var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
	
	var _YouTubePlayer = __webpack_require__(1475);
	
	var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef YT.Player
	 * @see https://developers.google.com/youtube/iframe_api_reference
	 * */
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 */
	var youtubeIframeAPI = void 0;
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param elementId Either An existing YT.Player instance,
	 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param options See `options` (Ignored when using an existing YT.Player instance).
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions. Default: `false`.
	 * See `FunctionStateMap.js` for supported functions and acceptable states.
	 */
	
	exports.default = function (maybeElementId) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var emitter = (0, _sister2.default)();
	
	  if (!youtubeIframeAPI) {
	    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
	  }
	
	  if (options.events) {
	    throw new Error('Event handlers cannot be overwritten.');
	  }
	
	  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
	    throw new Error('Element "' + maybeElementId + '" does not exist.');
	  }
	
	  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
	
	  var playerAPIReady = new Promise(function (resolve) {
	    if (typeof maybeElementId === 'string' || maybeElementId instanceof HTMLElement) {
	      // eslint-disable-next-line promise/catch-or-return
	      youtubeIframeAPI.then(function (YT) {
	        var player = new YT.Player(maybeElementId, options);
	
	        emitter.on('ready', function () {
	          resolve(player);
	        });
	
	        return null;
	      });
	    } else if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
	      var player = maybeElementId;
	
	      resolve(player);
	    } else {
	      throw new TypeError('Unexpected state.');
	    }
	  });
	
	  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
	
	  playerApi.on = emitter.on;
	  playerApi.off = emitter.off;
	
	  return playerApi;
	};
	
	module.exports = exports['default'];

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadScript = __webpack_require__(1471);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (emitter) {
	  /**
	   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	   * The promise is resolved with a reference to window.YT object.
	   */
	  var iframeAPIReady = new Promise(function (resolve) {
	    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
	      resolve(window.YT);
	
	      return;
	    }
	
	    var previous = window.onYouTubeIframeAPIReady;
	
	    // The API will call this function when page has finished downloading
	    // the JavaScript for the player API.
	    window.onYouTubeIframeAPIReady = function () {
	      if (previous) {
	        previous();
	      }
	
	      resolve(window.YT);
	    };
	  });
	
	  var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
	
	  (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
	    if (error) {
	      emitter.trigger('error', error);
	    }
	  });
	
	  return iframeAPIReady;
	};
	
	module.exports = exports['default'];

/***/ },
/* 1481 */
254,
/* 1482 */
[1644, 130, 105],
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1482);
	var ReactElement = __webpack_require__(104);
	
	var emptyFunction = __webpack_require__(733);
	var traverseAllChildren = __webpack_require__(1492);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(104);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(104),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(608);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1486 */
686,
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(728),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(104),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(731);
	var factory = __webpack_require__(1493);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1488 */
1387,
/* 1489 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(130);
	
	var ReactElement = __webpack_require__(104);
	
	var invariant = __webpack_require__(105);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(130);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var REACT_ELEMENT_TYPE = __webpack_require__(730);
	
	var getIteratorFn = __webpack_require__(1488);
	var invariant = __webpack_require__(105);
	var KeyEscapeUtils = __webpack_require__(1481);
	var warning = __webpack_require__(177);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1493 */
[1643, 178, 734, 105],
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _createFieldProps2 = __webpack_require__(737);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _onChangeValue = __webpack_require__(741);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	var _eventConsts = __webpack_require__(1558);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	var createConnectedField = function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ConnectedField);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      }, _this.isPristine = function () {
	        return _this.props.pristine;
	      }, _this.getValue = function () {
	        return _this.props.value;
	      }, _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        var defaultPrevented = false;
	        if (onChange) {
	          onChange(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	        }
	      }, _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	
	
	        var defaultPrevented = false;
	        if (onFocus) {
	          onFocus(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }));
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      }, _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	        if (onBlur) {
	          onBlur(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue));
	
	          // call post-blur callback
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue);
	          }
	        }
	      }, _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event);
	        }
	      }, _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	
	        var defaultPrevented = false;
	        if (onDrop) {
	          onDrop(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.ref;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            normalize = _props.normalize,
	            onBlur = _props.onBlur,
	            onChange = _props.onChange,
	            onFocus = _props.onFocus,
	            onDragStart = _props.onDragStart,
	            onDrop = _props.onDrop,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);
	
	        var _createFieldProps = (0, _createFieldProps3.default)(structure, name, _extends({}, rest, {
	          form: _reduxForm.form,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onDrop: this.handleDrop,
	          onDragStart: this.handleDragStart,
	          onFocus: this.handleFocus
	        })),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = this.saveRef;
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(222);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _redux = __webpack_require__(133);
	
	var _createFieldArrayProps = __webpack_require__(1505);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ConnectedFieldArray);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        // Update if the elements of the value array was updated.
	        var thisValue = this.props.value;
	        var nextValue = nextProps.value;
	
	        if (thisValue && nextValue) {
	          if (thisValue.length !== nextValue.length || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	            return !deepEqual(val, nextValue[index]);
	          })) {
	            return true;
	          }
	        }
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            validate = _props.validate,
	            warn = _props.warn,
	            rerenderOnEveryChange = _props.rerenderOnEveryChange,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);
	
	        var props = (0, _createFieldArrayProps2.default)(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object,
	    rerenderOnEveryChange: _propTypes2.default.bool
	  };
	
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _createFieldProps2 = __webpack_require__(737);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(741);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain2.default.getIn(syncErrors, name + '._error') || _plain2.default.getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields(props) {
	      _classCallCheck(this, ConnectedFields);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));
	
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse });
	
	        dispatch(_reduxForm.change(name, value));
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse });
	
	        // dispatch blur action
	        dispatch(_reduxForm.blur(name, value));
	
	        // call post-blur callback
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value);
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	      return _this;
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	          return !_this2.props._fields[nextName];
	        }))) {
	          // names has changed. The cached event handlers need to be updated
	          this.prepareEventHandlers(nextProps);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this3 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            _fields = _props._fields,
	            _reduxForm = _props._reduxForm,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var sectionPrefix = _reduxForm.sectionPrefix,
	            form = _reduxForm.form;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)(structure, name, _extends({}, connectedProps, rest, {
	            form: form,
	            onBlur: _this4.onBlurFns[name],
	            onChange: _this4.onChangeFns[name],
	            onFocus: _this4.onFocusFns[name]
	          })),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    _fields: _propTypes2.default.object.isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createField = __webpack_require__(1503);
	
	var _createField2 = _interopRequireDefault(_createField);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createField2.default)(_plain2.default);

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFieldArray = __webpack_require__(1504);
	
	var _createFieldArray2 = _interopRequireDefault(_createFieldArray);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFieldArray2.default)(_plain2.default);

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFields = __webpack_require__(1506);
	
	var _createFields2 = _interopRequireDefault(_createFields);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFields2.default)(_plain2.default);

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props, context) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('form', this.props);
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes2.default.func.isRequired
	};
	Form.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = Form;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _prefixName = __webpack_require__(131);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          component = _props.component,
	          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);
	
	      if (_react2.default.isValidElement(children)) {
	        return children;
	      }
	
	      return (0, _react.createElement)(component, _extends({}, rest, {
	        children: children
	      }));
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _propTypes2.default.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = FormSection;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(205);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	exports.default = asyncValidation;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(1494);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(744);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(131);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(structure) {
	  var ConnectedField = (0, _ConnectedField2.default)(structure);
	
	  var setIn = structure.setIn;
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      };
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = _this.context._reduxForm.getValues();
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      };
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _shallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'Field', function () {
	          return _this2.props.validate;
	        }, function () {
	          return _this2.props.warn;
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name || this.props.validate !== nextProps.validate || this.props.warn !== nextProps.warn) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'Field', function () {
	            return nextProps.validate;
	          }, function () {
	            return nextProps.warn;
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.ref.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: this.saveRef
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.ref.getWrappedInstance().isPristine();
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.ref && this.ref.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    normalize: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onDragStart: _propTypes2.default.func,
	    onDrop: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  Field.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(1495);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _prefixName = __webpack_require__(131);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	      if (result) {
	        return _defineProperty({}, key, result);
	      }
	    }
	  };
	};
	
	var createFieldArray = function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)(structure);
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      };
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'FieldArray', function () {
	          return wrapError(_this2.props.validate, '_error');
	        }, function () {
	          return wrapError(_this2.props.warn, '_warning');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.ref.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          _reduxForm: this.context._reduxForm,
	          ref: this.saveRef
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.ref.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.ref.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.ref.getWrappedInstance().value;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.func.isRequired,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ },
/* 1505 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
	  var getIn = _ref2.getIn;
	
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	
	exports.default = createFieldArrayProps;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(1496);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(744);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(131);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields2.default)(structure);
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _shallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register(name, 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          var context = this.context;
	          var _context$_reduxForm = context._reduxForm,
	              register = _context$_reduxForm.register,
	              unregister = _context$_reduxForm.unregister;
	          // unregister old name
	
	          this.props.names.forEach(function (name) {
	            return unregister((0, _prefixName2.default)(context, name));
	          });
	          // register new name
	          nextProps.names.forEach(function (name) {
	            return register((0, _prefixName2.default)(context, name), 'Field');
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        var context = this.context;
	
	        return this.props.names.map(function (name) {
	          return (0, _prefixName2.default)(context, name);
	        });
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    withRef: _propTypes2.default.bool
	  };
	  Fields.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _prefixName = __webpack_require__(131);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    var valuesMap = void 0;
	
	    if (typeof firstArg === 'string') {
	      valuesMap = [firstArg].concat(_toConsumableArray(rest)).map(function (k) {
	        return {
	          prop: k,
	          path: k
	        };
	      });
	    } else {
	      var config = firstArg;
	      valuesMap = Object.keys(config).map(function (k) {
	        return {
	          prop: k,
	          path: config[k]
	        };
	      });
	    }
	    if (!valuesMap.length) {
	      throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...})');
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = function (_React$Component) {
	        _inherits(FormValues, _React$Component);
	
	        function FormValues(props, context) {
	          _classCallCheck(this, FormValues);
	
	          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));
	
	          if (!context._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	          var getValues = context._reduxForm.getValues;
	
	          var formValuesSelector = function formValuesSelector(_) {
	            // Yes, we're only using connect() for listening to updates
	            var props = {};
	            var values = getValues();
	            valuesMap.forEach(function (_ref2) {
	              var prop = _ref2.prop,
	                  path = _ref2.path;
	              return props[prop] = getIn(values, (0, _prefixName2.default)(context, path));
	            });
	            return props;
	          };
	          _this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(Component);
	          return _this;
	        }
	
	        _createClass(FormValues, [{
	          key: 'render',
	          value: function render() {
	            return _react2.default.createElement(this.Component, this.props);
	          }
	        }]);
	
	        return FormValues;
	      }(_react2.default.Component);
	
	      FormValues.contextTypes = {
	        _reduxForm: _propTypes2.default.object
	      };
	      return FormValues;
	    };
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(279);
	
	var _deleteInWithCleanUp = __webpack_require__(1512);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	    var existing = _plain2.default.getIn(slice, field);
	    return existing || force ? setIn(state, key, _plain2.default.setIn(slice, field, _plain2.default.splice(existing, index, removeNum, value))) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT_ERRORS, function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    return deleteIn(state, 'asyncErrors.' + field);
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref15) {
	    var field = _ref15.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref16) {
	    var payload = _ref16.payload,
	        _ref16$meta = _ref16.meta,
	        keepDirty = _ref16$meta.keepDirty,
	        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    // persist old errors, they will get recalculated if the new form values are different from the old values
	    var error = getIn(state, 'error');
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	    var syncErrors = getIn(state, 'syncErrors');
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        forEach(keys(registeredFields), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name);
	
	            // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        });
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref17) {
	    var _ref17$payload = _ref17.payload,
	        name = _ref17$payload.name,
	        type = _ref17$payload.type;
	
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(state, key);
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({ name: name, type: type, count: 1 });
	    }
	    return setIn(state, key, field);
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref18) {
	    var field = _ref18.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref19) {
	    var payload = _ref19.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref20) {
	    var payload = _ref20.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = setIn(result, 'submitSucceeded', true);
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref21) {
	    var fields = _ref21.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref22) {
	    var fields = _ref22.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref23) {
	    var _ref23$payload = _ref23.payload,
	        name = _ref23$payload.name,
	        destroyOnUnmount = _ref23$payload.destroyOnUnmount;
	
	    var result = state;
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(result, key);
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	      result = deleteInWithCleanUp(result, 'syncErrors.' + name);
	      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
	      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
	      result = deleteInWithCleanUp(result, 'syncWarnings.' + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        syncErrors = _ref25$payload.syncErrors,
	        error = _ref25$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        syncWarnings = _ref26$payload.syncWarnings,
	        warning = _ref26$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
	
	      var form = action && action.meta && action.meta.form;
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function plugin(reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
	        return Object.keys(reducers).reduce(function (accumulator, key) {
	          var previousState = getIn(accumulator, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
	        }, _this(state, action));
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	exports.default = createReducer;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge4 = __webpack_require__(1141);
	
	var _merge5 = _interopRequireDefault(_merge4);
	
	var _mapValues2 = __webpack_require__(222);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _hoistNonReactStatics = __webpack_require__(1561);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPromise = __webpack_require__(205);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(27);
	
	var _redux = __webpack_require__(133);
	
	var _actions = __webpack_require__(736);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _asyncValidation = __webpack_require__(1502);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(738);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(739);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _silenceEvent = __webpack_require__(742);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(1514);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _generateValidator = __webpack_require__(1517);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _handleSubmit = __webpack_require__(1526);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _isValid = __webpack_require__(280);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _getDisplayName = __webpack_require__(1559);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	
	var arrayInsert = _actions2.default.arrayInsert,
	    arrayMove = _actions2.default.arrayMove,
	    arrayPop = _actions2.default.arrayPop,
	    arrayPush = _actions2.default.arrayPush,
	    arrayRemove = _actions2.default.arrayRemove,
	    arrayRemoveAll = _actions2.default.arrayRemoveAll,
	    arrayShift = _actions2.default.arrayShift,
	    arraySplice = _actions2.default.arraySplice,
	    arraySwap = _actions2.default.arraySwap,
	    arrayUnshift = _actions2.default.arrayUnshift,
	    blur = _actions2.default.blur,
	    change = _actions2.default.change,
	    focus = _actions2.default.focus,
	    formActions = _objectWithoutProperties(_actions2.default, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(_actions2.default)), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form() {
	          var _ref;
	
	          var _temp, _this, _ret;
	
	          _classCallCheck(this, Form);
	
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
	            return _this.props.values;
	          }, _this.isValid = function () {
	            return _this.props.valid;
	          }, _this.isPristine = function () {
	            return _this.props.pristine;
	          }, _this.register = function (name, type, getValidator, getWarner) {
	            _this.props.registerField(name, type);
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          }, _this.unregister = function (name) {
	            if (!_this.destroyed) {
	              if (_this.props.destroyOnUnmount || _this.props.forceUnregisterOnUnmount) {
	                _this.props.unregisterField(name);
	                delete _this.fieldValidators[name];
	                delete _this.fieldWarners[name];
	              } else {
	                _this.props.unregisterField(name, false);
	              }
	            }
	          }, _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	            var list = [];
	            if (!registeredFields) {
	              return list;
	            }
	            var keySeq = keys(registeredFields);
	            if (options && options.excludeFieldArray) {
	              keySeq = keySeq.filter(function (name) {
	                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
	              });
	            }
	            return fromJS(keySeq.reduce(function (acc, key) {
	              acc.push(key);
	              return acc;
	            }, list));
	          }, _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          }, _this.generateValidator = function () {
	            var validators = _this.getValidators();
	            return Object.keys(validators).length ? (0, _generateValidator2.default)(validators, structure) : undefined;
	          }, _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          }, _this.generateWarner = function () {
	            var warners = _this.getWarners();
	            return Object.keys(warners).length ? (0, _generateValidator2.default)(warners, structure) : undefined;
	          }, _this.asyncValidate = function (name, value) {
	            var _this$props = _this.props,
	                asyncBlurFields = _this$props.asyncBlurFields,
	                asyncErrors = _this$props.asyncErrors,
	                asyncValidate = _this$props.asyncValidate,
	                dispatch = _this$props.dispatch,
	                initialized = _this$props.initialized,
	                pristine = _this$props.pristine,
	                shouldAsyncValidate = _this$props.shouldAsyncValidate,
	                startAsyncValidation = _this$props.startAsyncValidation,
	                stopAsyncValidation = _this$props.stopAsyncValidation,
	                syncErrors = _this$props.syncErrors,
	                values = _this$props.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	              if ((isBlurredField || submitting) && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : 'blur',
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          }, _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          }, _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            throw error;
	          }, _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          }, _this.submit = function (submitOrEvent) {
	            var _this$props2 = _this.props,
	                onSubmit = _this$props2.onSubmit,
	                blur = _this$props2.blur,
	                change = _this$props2.change,
	                dispatch = _this$props2.dispatch;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), _extends({}, _this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _extends({}, _this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
	              });
	            }
	          }, _this.reset = function () {
	            return _this.props.reset();
	          }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister,
	                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	                  return _this2.innerOnSubmit = innerOnSubmit;
	                }
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  lastInitialValues: this.props.initialValues
	                });
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
	            var _props = this.props,
	                error = _props.error,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(lastSyncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'clearSubmitPromiseIfNeeded',
	          value: function clearSubmitPromiseIfNeeded(nextProps) {
	            var submitting = this.props.submitting;
	
	            if (this.submitPromise && submitting && !nextProps.submitting) {
	              delete this.submitPromise;
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                validate = _props3.validate,
	                values = _props3.values;
	
	            var fieldLevelValidate = this.generateValidator();
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(this.getValidators());
	              var shouldValidateResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              });
	
	              if (shouldValidateResult) {
	                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;
	
	                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);
	
	                this.lastFieldValidatorKeys = fieldValidatorKeys;
	                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _props4 = this.props,
	                warning = _props4.warning,
	                syncWarnings = _props4.syncWarnings,
	                updateSyncWarnings = _props4.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props5 = this.props,
	                shouldValidate = _props5.shouldValidate,
	                warn = _props5.warn,
	                values = _props5.values;
	
	            var fieldLevelWarn = this.generateWarner();
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(this.getWarners());
	              var shouldWarnResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              });
	
	              if (shouldWarnResult) {
	                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;
	
	                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);
	
	                this.lastFieldWarnerKeys = fieldWarnerKeys;
	                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.clearSubmitPromiseIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	            var onChange = nextProps.onChange,
	                values = nextProps.values,
	                dispatch = nextProps.dispatch;
	
	            if (onChange && !deepEqual(values, this.props.values)) {
	              onChange(values, dispatch, nextProps);
	            }
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!this.props.pure) return true;
	            var _config$immutableProp = config.immutableProps,
	                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
	
	            return Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              if (~immutableProps.indexOf(prop)) {
	                return _this3.props[prop] !== nextProps[prop];
	              }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            });
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props6 = this.props,
	                destroyOnUnmount = _props6.destroyOnUnmount,
	                destroy = _props6.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props7 = this.props,
	                anyTouched = _props7.anyTouched,
	                arrayInsert = _props7.arrayInsert,
	                arrayMove = _props7.arrayMove,
	                arrayPop = _props7.arrayPop,
	                arrayPush = _props7.arrayPush,
	                arrayRemove = _props7.arrayRemove,
	                arrayRemoveAll = _props7.arrayRemoveAll,
	                arrayShift = _props7.arrayShift,
	                arraySplice = _props7.arraySplice,
	                arraySwap = _props7.arraySwap,
	                arrayUnshift = _props7.arrayUnshift,
	                asyncErrors = _props7.asyncErrors,
	                asyncValidate = _props7.asyncValidate,
	                asyncValidating = _props7.asyncValidating,
	                blur = _props7.blur,
	                change = _props7.change,
	                clearSubmit = _props7.clearSubmit,
	                destroy = _props7.destroy,
	                destroyOnUnmount = _props7.destroyOnUnmount,
	                forceUnregisterOnUnmount = _props7.forceUnregisterOnUnmount,
	                dirty = _props7.dirty,
	                dispatch = _props7.dispatch,
	                enableReinitialize = _props7.enableReinitialize,
	                error = _props7.error,
	                focus = _props7.focus,
	                form = _props7.form,
	                getFormState = _props7.getFormState,
	                initialize = _props7.initialize,
	                initialized = _props7.initialized,
	                initialValues = _props7.initialValues,
	                invalid = _props7.invalid,
	                keepDirtyOnReinitialize = _props7.keepDirtyOnReinitialize,
	                pristine = _props7.pristine,
	                propNamespace = _props7.propNamespace,
	                registeredFields = _props7.registeredFields,
	                registerField = _props7.registerField,
	                reset = _props7.reset,
	                setSubmitFailed = _props7.setSubmitFailed,
	                setSubmitSucceeded = _props7.setSubmitSucceeded,
	                shouldAsyncValidate = _props7.shouldAsyncValidate,
	                shouldValidate = _props7.shouldValidate,
	                startAsyncValidation = _props7.startAsyncValidation,
	                startSubmit = _props7.startSubmit,
	                stopAsyncValidation = _props7.stopAsyncValidation,
	                stopSubmit = _props7.stopSubmit,
	                submitting = _props7.submitting,
	                submitFailed = _props7.submitFailed,
	                submitSucceeded = _props7.submitSucceeded,
	                touch = _props7.touch,
	                touchOnBlur = _props7.touchOnBlur,
	                touchOnChange = _props7.touchOnChange,
	                persistentSubmitErrors = _props7.persistentSubmitErrors,
	                syncErrors = _props7.syncErrors,
	                syncWarnings = _props7.syncWarnings,
	                unregisterField = _props7.unregisterField,
	                untouch = _props7.untouch,
	                updateSyncErrors = _props7.updateSyncErrors,
	                updateSyncWarnings = _props7.updateSyncWarnings,
	                valid = _props7.valid,
	                validExceptSubmit = _props7.validExceptSubmit,
	                values = _props7.values,
	                warning = _props7.warning,
	                rest = _objectWithoutProperties(_props7, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              clearSubmit: clearSubmit,
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _propTypes2.default.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes2.default.bool,
	        forceUnregisterOnUnmount: _propTypes2.default.bool,
	        form: _propTypes2.default.string.isRequired,
	        initialValues: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	        getFormState: _propTypes2.default.func,
	        onSubmitFail: _propTypes2.default.func,
	        onSubmitSuccess: _propTypes2.default.func,
	        propNamespace: _propTypes2.default.string,
	        validate: _propTypes2.default.func,
	        warn: _propTypes2.default.func,
	        touchOnBlur: _propTypes2.default.bool,
	        touchOnChange: _propTypes2.default.bool,
	        triggerSubmit: _propTypes2.default.bool,
	        persistentSubmitErrors: _propTypes2.default.bool,
	        registeredFields: _propTypes2.default.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || empty;
	        var syncWarnings = getIn(formState, 'syncWarnings') || empty;
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	      return function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.refs.wrapped.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            return this.refs.wrapped.getWrappedInstance().reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _props8 = this.props,
	                initialValues = _props8.initialValues,
	                rest = _objectWithoutProperties(_props8, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: 'wrapped',
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isValid();
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isPristine();
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().getValues();
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.refs.wrapped.getWrappedInstance().getFieldList();
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testing
	            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(27);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }
	    // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path) : state;
	    }
	
	    var result = state;
	    if (getIn(state, path) !== undefined) {
	      result = deleteIn(state, path);
	    }
	
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	}
	
	exports.default = createDeleteInWithCleanUp;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(740);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked || '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(742);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	exports.default = silenceEvents;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValueSelector = __webpack_require__(1507);
	
	var _createFormValueSelector2 = _interopRequireDefault(_createFormValueSelector);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValueSelector2.default)(_plain2.default);

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValues = __webpack_require__(1508);
	
	var _createFormValues2 = _interopRequireDefault(_createFormValues);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValues2.default)(_plain2.default);

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	
	var getError = function getError(value, values, props, validators) {
	  var array = toArray(validators);
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props);
	    if (error) {
	      return error;
	    }
	  }
	};
	
	var generateValidator = function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name]);
	      if (error) {
	        errors = _plain2.default.setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	};
	
	exports.default = generateValidator;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormAsyncErrors = __webpack_require__(1539);
	
	var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormAsyncErrors2.default)(_plain2.default);

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormInitialValues = __webpack_require__(1540);
	
	var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormInitialValues2.default)(_plain2.default);

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormMeta = __webpack_require__(1541);
	
	var _getFormMeta2 = _interopRequireDefault(_getFormMeta);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormMeta2.default)(_plain2.default);

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormNames = __webpack_require__(1542);
	
	var _getFormNames2 = _interopRequireDefault(_getFormNames);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormNames2.default)(_plain2.default);

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSubmitErrors = __webpack_require__(1543);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSubmitErrors2.default)(_plain2.default);

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncErrors = __webpack_require__(1544);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncErrors2.default)(_plain2.default);

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncWarnings = __webpack_require__(1545);
	
	var _getFormSyncWarnings2 = _interopRequireDefault(_getFormSyncWarnings);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncWarnings2.default)(_plain2.default);

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormValues = __webpack_require__(1546);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormValues2.default)(_plain2.default);

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(205);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(735);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid || persistentSubmitErrors) {
	    var doSubmit = function doSubmit() {
	      var result = void 0;
	      try {
	        result = submit(values, dispatch, props);
	      } catch (submitError) {
	        var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      }
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult, dispatch, props);
	          }
	          return submitResult;
	        }, function (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          stopSubmit(error);
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError, props);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        });
	      } else {
	        setSubmitSucceeded();
	        if (onSubmitSuccess) {
	          onSubmitSuccess(result, dispatch, props);
	        }
	      }
	      return result;
	    };
	
	    var asyncValidateResult = asyncValidate && asyncValidate();
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	        return doSubmit();
	      }).catch(function (asyncErrors) {
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return doSubmit();
	    }
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    if (onSubmitFail) {
	      onSubmitFail(syncErrors, dispatch, null, props);
	    }
	    return syncErrors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 1527 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitFailed = __webpack_require__(1547);
	
	var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitFailed2.default)(_plain2.default);

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitSucceeded = __webpack_require__(1548);
	
	var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitSucceeded2.default)(_plain2.default);

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isDirty = __webpack_require__(1549);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isDirty2.default)(_plain2.default);

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInvalid = __webpack_require__(1550);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isInvalid2.default)(_plain2.default);

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(743);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isPristine2.default)(_plain2.default);

/***/ },
/* 1533 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isSubmitting = __webpack_require__(1551);
	
	var _isSubmitting2 = _interopRequireDefault(_isSubmitting);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isSubmitting2.default)(_plain2.default);

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(280);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isValid2.default)(_plain2.default);

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var any = _propTypes2.default.any,
	    bool = _propTypes2.default.bool,
	    func = _propTypes2.default.func,
	    shape = _propTypes2.default.shape,
	    string = _propTypes2.default.string,
	    oneOfType = _propTypes2.default.oneOfType,
	    object = _propTypes2.default.object;
	var formPropTypes = exports.formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  form: string.isRequired, // the name of the form
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  initialValues: object, // the initialValues object passed to reduxForm
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  pure: bool.isRequired, // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  warning: any, // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  clearAsyncError: func.isRequired, // action to clear the async error of a field
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  submit: func.isRequired, // action to trigger a submission of the specified form
	  untouch: func.isRequired, // action to mark fields as untouched
	
	  // triggerSubmit
	  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	};
	
	var fieldInputPropTypes = exports.fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	
	var fieldMetaPropTypes = exports.fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: string,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	
	var fieldPropTypes = exports.fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired,
	  custom: object.isRequired
	};
	
	exports.default = formPropTypes;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReducer = __webpack_require__(1509);
	
	var _createReducer2 = _interopRequireDefault(_createReducer);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReducer2.default)(_plain2.default);

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReduxForm = __webpack_require__(1510);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReduxForm2.default)(_plain2.default);

/***/ },
/* 1539 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormAsyncErrors;

/***/ },
/* 1540 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.initial');
	    };
	  };
	};
	
	exports.default = createGetFormInitialValues;

/***/ },
/* 1541 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormMeta = function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.fields');
	    };
	  };
	};
	
	exports.default = createGetFormMeta;

/***/ },
/* 1542 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormNames = function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return keys(nonNullGetFormState(state));
	    };
	  };
	};
	
	exports.default = createGetFormNames;

/***/ },
/* 1543 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.submitErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ },
/* 1544 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.syncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ },
/* 1545 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.syncWarnings');
	    };
	  };
	};
	
	exports.default = createGetFormSyncWarnings;

/***/ },
/* 1546 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ },
/* 1547 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
	    };
	  };
	};
	
	exports.default = createHasSubmitFailed;

/***/ },
/* 1548 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
	    };
	  };
	};
	
	exports.default = createHasSubmitSucceeded;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(743);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	exports.default = createIsDirty;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(280);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	exports.default = createIsInvalid;

/***/ },
/* 1551 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsSubmitting = function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitting');
	    };
	  };
	};
	
	exports.default = createIsSubmitting;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(485);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) {
	    return !(obj === undefined && other === false || obj === false && other === undefined);
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
	      }
	      var firstIndex = Number(first);
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
	    }
	    var _firstIndex = Number(first);
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(_firstIndex, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ },
/* 1555 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	exports.default = keys;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(156);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      return _defineProperty({}, first, next);
	    }
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ },
/* 1557 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, true); // temporary placeholder
	      _copy2[index] = undefined; // set to undefined
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value); // removing and adding
	      return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum); // removing
	    return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ },
/* 1558 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';

/***/ },
/* 1559 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createValues = __webpack_require__(1511);
	
	var _createValues2 = _interopRequireDefault(_createValues);
	
	var _plain = __webpack_require__(18);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createValues2.default)(_plain2.default);

/***/ },
/* 1561 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = autoRehydrate;
	
	var _constants = __webpack_require__(132);
	
	var _isStatePlainEnough = __webpack_require__(1565);
	
	var _isStatePlainEnough2 = _interopRequireDefault(_isStatePlainEnough);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function autoRehydrate() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var stateReconciler = config.stateReconciler || defaultStateReconciler;
	
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var store = next(liftReducer(reducer), initialState, enhancer);
	      return _extends({}, store, {
	        replaceReducer: function replaceReducer(reducer) {
	          return store.replaceReducer(liftReducer(reducer));
	        }
	      });
	    };
	  };
	
	  function liftReducer(reducer) {
	    var rehydrated = false;
	    var preRehydrateActions = [];
	    return function (state, action) {
	      if (action.type !== _constants.REHYDRATE) {
	        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
	        return reducer(state, action);
	      } else {
	        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
	        rehydrated = true;
	
	        var inboundState = action.payload;
	        var reducedState = reducer(state, action);
	
	        return stateReconciler(state, inboundState, reducedState, config.log);
	      }
	    };
	  }
	}
	
	function logPreRehydrate(preRehydrateActions) {
	  var concernedActions = preRehydrateActions.slice(1);
	  if (concernedActions.length > 0) {
	    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
	  }
	}
	
	function defaultStateReconciler(state, inboundState, reducedState, log) {
	  var newState = _extends({}, reducedState);
	
	  Object.keys(inboundState).forEach(function (key) {
	    // if initialState does not have key, skip auto rehydration
	    if (!state.hasOwnProperty(key)) return;
	
	    // if initial state is an object but inbound state is null/undefined, skip
	    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
	      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
	      return;
	    }
	
	    // if reducer modifies substate, skip auto rehydration
	    if (state[key] !== reducedState[key]) {
	      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
	      newState[key] = reducedState[key];
	      return;
	    }
	
	    // otherwise take the inboundState
	    if ((0, _isStatePlainEnough2.default)(inboundState[key]) && (0, _isStatePlainEnough2.default)(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
	    else newState[key] = inboundState[key]; // hard set
	
	    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
	  });
	  return newState;
	}

/***/ },
/* 1563 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function createTransform(inbound, outbound) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var whitelist = config.whitelist || null;
	  var blacklist = config.blacklist || null;
	
	  function whitelistBlacklistCheck(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return true;
	    if (blacklist && blacklist.indexOf(key) !== -1) return true;
	    return false;
	  }
	
	  return {
	    in: function _in(state, key) {
	      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
	    },
	    out: function out(state, key) {
	      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
	    }
	  };
	}
	
	exports.default = createTransform;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = persistStore;
	
	var _constants = __webpack_require__(132);
	
	var _getStoredState = __webpack_require__(747);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var _createPersistor = __webpack_require__(745);
	
	var _createPersistor2 = _interopRequireDefault(_createPersistor);
	
	var _setImmediate = __webpack_require__(750);
	
	var _setImmediate2 = _interopRequireDefault(_setImmediate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function persistStore(store) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var onComplete = arguments[2];
	
	  // defaults
	  // @TODO remove shouldRestore
	  var shouldRestore = !config.skipRestore;
	  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');
	
	  var purgeKeys = null;
	
	  // create and pause persistor
	  var persistor = (0, _createPersistor2.default)(store, config);
	  persistor.pause();
	
	  // restore
	  if (shouldRestore) {
	    (0, _setImmediate2.default)(function () {
	      (0, _getStoredState2.default)(config, function (err, restoredState) {
	        if (err) {
	          complete(err);
	          return;
	        }
	        // do not persist state for purgeKeys
	        if (purgeKeys) {
	          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
	            return delete restoredState[key];
	          });
	        }
	        try {
	          store.dispatch(rehydrateAction(restoredState, err));
	        } finally {
	          complete(err, restoredState);
	        }
	      });
	    });
	  } else (0, _setImmediate2.default)(complete);
	
	  function complete(err, restoredState) {
	    persistor.resume();
	    onComplete && onComplete(err, restoredState);
	  }
	
	  return _extends({}, persistor, {
	    purge: function purge(keys) {
	      purgeKeys = keys || '*';
	      return persistor.purge(keys);
	    }
	  });
	}
	
	function rehydrateAction(payload) {
	  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  return {
	    type: _constants.REHYDRATE,
	    payload: payload,
	    error: error
	  };
	}

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isStatePlainEnough;
	
	var _isPlainObject = __webpack_require__(116);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isStatePlainEnough(a) {
	  // isPlainObject + duck type not immutable
	  if (!a) return false;
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
	  if (typeof a.asMutable === 'function') return false;
	  if (!(0, _isPlainObject2.default)(a)) return false;
	  return true;
	}

/***/ },
/* 1566 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 1567 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(751);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1569 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(752);
	
	var _isPlainObject = __webpack_require__(116);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(753);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1571 */
[1645, 1572],
/* 1572 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = configureStore;
	
	var _reduxDevtoolsInstrument = __webpack_require__(1587);
	
	var _reduxDevtoolsInstrument2 = _interopRequireDefault(_reduxDevtoolsInstrument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(next, subscriber, options) {
	  return (0, _reduxDevtoolsInstrument2.default)(subscriber, options)(next);
	}

/***/ },
/* 1574 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var defaultSocketOptions = exports.defaultSocketOptions = {
	  secure: true,
	  hostname: 'remotedev.io',
	  port: 443,
	  autoReconnect: true,
	  autoReconnectOptions: {
	    randomness: 30000
	  }
	};

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = devToolsEnhancer;
	exports.preEnhancer = preEnhancer;
	exports.composeWithDevTools = composeWithDevTools;
	
	var _jsan = __webpack_require__(754);
	
	var _socketclusterClient = __webpack_require__(1598);
	
	var _socketclusterClient2 = _interopRequireDefault(_socketclusterClient);
	
	var _configureStore = __webpack_require__(1573);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _constants = __webpack_require__(1574);
	
	var _rnHostDetect = __webpack_require__(1593);
	
	var _rnHostDetect2 = _interopRequireDefault(_rnHostDetect);
	
	var _remotedevUtils = __webpack_require__(1592);
	
	var _catchErrors = __webpack_require__(1590);
	
	var _catchErrors2 = _interopRequireDefault(_catchErrors);
	
	var _filters = __webpack_require__(1591);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instanceId = void 0;
	var instanceName = void 0;
	var suppressConnectErrors = void 0;
	var errorCounts = {};
	var socketOptions = void 0;
	var socket = void 0;
	var channel = void 0;
	var store = {};
	var lastAction = void 0;
	var filters = void 0;
	var isExcess = void 0;
	var isMonitored = void 0;
	var started = void 0;
	var startOn = void 0;
	var stopOn = void 0;
	var sendOn = void 0;
	var sendOnError = void 0;
	var sendTo = void 0;
	var lastErrorMsg = void 0;
	var locked = void 0;
	var paused = void 0;
	var actionCreators = void 0;
	var stateSanitizer = void 0;
	var actionSanitizer = void 0;
	
	function getLiftedState() {
	  return (0, _filters.filterStagedActions)(store.liftedStore.getState(), filters);
	}
	
	function send() {
	  if (!instanceId) instanceId = socket && socket.id || Math.random().toString(36).substr(2);
	  try {
	    fetch(sendTo, {
	      method: 'POST',
	      headers: {
	        'content-type': 'application/json'
	      },
	      body: JSON.stringify({
	        type: 'STATE',
	        id: instanceId,
	        name: instanceName,
	        payload: (0, _jsan.stringify)(getLiftedState())
	      })
	    }).catch(function (err) {
	      console.log(err);
	    });
	  } catch (err) {
	    console.log(err);
	  }
	}
	
	function relay(type, state, action, nextActionId) {
	  var message = {
	    type: type,
	    id: socket.id,
	    name: instanceName
	  };
	  if (state) {
	    message.payload = type === 'ERROR' ? state : (0, _jsan.stringify)((0, _filters.filterState)(state, type, filters, stateSanitizer, actionSanitizer, nextActionId));
	  }
	  if (type === 'ACTION') {
	    message.action = (0, _jsan.stringify)(!actionSanitizer ? action : actionSanitizer(action.action, nextActionId - 1));
	    message.isExcess = isExcess;
	    message.nextActionId = nextActionId;
	  } else if (action) {
	    message.action = action;
	  }
	  socket.emit(socket.id ? 'log' : 'log-noid', message);
	}
	
	function dispatchRemotely(action) {
	  try {
	    var result = (0, _remotedevUtils.evalAction)(action, actionCreators);
	    store.dispatch(result);
	  } catch (e) {
	    relay('ERROR', e.message);
	  }
	}
	
	function handleMessages(message) {
	  if (message.type === 'IMPORT' || message.type === 'SYNC' && socket.id && message.id !== socket.id) {
	    store.liftedStore.dispatch({
	      type: 'IMPORT_STATE', nextLiftedState: (0, _jsan.parse)(message.state)
	    });
	  } else if (message.type === 'UPDATE') {
	    relay('STATE', getLiftedState());
	  } else if (message.type === 'START') {
	    isMonitored = true;
	    if (typeof actionCreators === 'function') actionCreators = actionCreators();
	    relay('STATE', getLiftedState(), actionCreators);
	  } else if (message.type === 'STOP' || message.type === 'DISCONNECTED') {
	    isMonitored = false;
	    relay('STOP');
	  } else if (message.type === 'ACTION') {
	    dispatchRemotely(message.action);
	  } else if (message.type === 'DISPATCH') {
	    store.liftedStore.dispatch(message.action);
	  }
	}
	
	function async(fn) {
	  setTimeout(fn, 0);
	}
	
	function sendError(errorAction) {
	  // Prevent flooding
	  if (errorAction.message && errorAction.message === lastErrorMsg) return;
	  lastErrorMsg = errorAction.message;
	
	  async(function () {
	    store.dispatch(errorAction);
	    if (!started) send();
	  });
	}
	
	function str2array(str) {
	  return typeof str === 'string' ? [str] : str && str.length;
	}
	
	function init(options) {
	  instanceName = options.name;
	
	  var _ref = options.filters || {};
	
	  var blacklist = _ref.blacklist;
	  var whitelist = _ref.whitelist;
	
	  filters = (0, _filters.getLocalFilter)({
	    actionsBlacklist: blacklist || options.actionsBlacklist,
	    actionsWhitelist: whitelist || options.actionsWhitelist
	  });
	  if (options.port) {
	    socketOptions = {
	      port: options.port,
	      hostname: options.hostname || 'localhost',
	      secure: options.secure
	    };
	  } else socketOptions = _constants.defaultSocketOptions;
	
	  suppressConnectErrors = options.suppressConnectErrors !== undefined ? options.suppressConnectErrors : true;
	
	  startOn = str2array(options.startOn);
	  stopOn = str2array(options.stopOn);
	  sendOn = str2array(options.sendOn);
	  sendOnError = options.sendOnError;
	  if (sendOn || sendOnError) {
	    sendTo = options.sendTo || (socketOptions.secure ? 'https' : 'http') + '://' + socketOptions.hostname + ':' + socketOptions.port;
	    instanceId = options.id;
	  }
	  if (sendOnError === 1) (0, _catchErrors2.default)(sendError);
	
	  if (options.actionCreators) actionCreators = function actionCreators() {
	    return (0, _remotedevUtils.getActionsArray)(options.actionCreators);
	  };
	  stateSanitizer = options.stateSanitizer;
	  actionSanitizer = options.actionSanitizer;
	}
	
	function login() {
	  socket.emit('login', 'master', function (err, channelName) {
	    if (err) {
	      console.log(err);return;
	    }
	    channel = channelName;
	    socket.subscribe(channelName).watch(handleMessages);
	    socket.on(channelName, handleMessages);
	  });
	  started = true;
	  relay('START');
	}
	
	function stop(keepConnected) {
	  started = false;
	  isMonitored = false;
	  if (!socket) return;
	  socket.destroyChannel(channel);
	  if (keepConnected) {
	    socket.off(channel, handleMessages);
	  } else {
	    socket.off();
	    socket.disconnect();
	  }
	}
	
	function start() {
	  if (started || socket && socket.getState() === socket.CONNECTING) return;
	
	  socket = _socketclusterClient2.default.connect(socketOptions);
	
	  socket.on('error', function (err) {
	    // if we've already had this error before, increment it's counter, otherwise assign it '1' since we've had the error once.
	    errorCounts[err.name] = errorCounts.hasOwnProperty(err.name) ? errorCounts[err.name] + 1 : 1;
	
	    if (suppressConnectErrors) {
	      if (errorCounts[err.name] === 1) {
	        console.log('remote-redux-devtools: Socket connection errors are being suppressed. ' + '\n' + 'This can be disabled by setting suppressConnectErrors to \'false\'.');
	        console.log(err);
	      }
	    } else {
	      console.log(err);
	    }
	  });
	  socket.on('connect', function () {
	    console.log('connected to remotedev-server');
	    errorCounts = {}; // clear the errorCounts object, so that we'll log any new errors in the event of a disconnect
	    login();
	  });
	  socket.on('disconnect', function () {
	    stop(true);
	  });
	}
	
	function checkForReducerErrors() {
	  var liftedState = arguments.length <= 0 || arguments[0] === undefined ? store.liftedStore.getState() : arguments[0];
	
	  if (liftedState.computedStates[liftedState.currentStateIndex].error) {
	    if (started) relay('STATE', (0, _filters.filterStagedActions)(liftedState, filters));else send();
	    return true;
	  }
	  return false;
	}
	
	function monitorReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var action = arguments[1];
	
	  lastAction = action.type;
	  if (!started && sendOnError === 2 && store.liftedStore) async(checkForReducerErrors);else if (action.action) {
	    if (startOn && !started && startOn.indexOf(action.action.type) !== -1) async(start);else if (stopOn && started && stopOn.indexOf(action.action.type) !== -1) async(stop);else if (sendOn && !started && sendOn.indexOf(action.action.type) !== -1) async(send);
	  }
	  return state;
	}
	
	function handleChange(state, liftedState, maxAge) {
	  if (checkForReducerErrors(liftedState)) return;
	
	  if (lastAction === 'PERFORM_ACTION') {
	    var nextActionId = liftedState.nextActionId;
	    var liftedAction = liftedState.actionsById[nextActionId - 1];
	    if ((0, _filters.isFiltered)(liftedAction.action, filters)) return;
	    relay('ACTION', state, liftedAction, nextActionId);
	    if (!isExcess && maxAge) isExcess = liftedState.stagedActionIds.length >= maxAge;
	  } else {
	    if (lastAction === 'JUMP_TO_STATE') return;
	    if (lastAction === 'PAUSE_RECORDING') {
	      paused = liftedState.isPaused;
	    } else if (lastAction === 'LOCK_CHANGES') {
	      locked = liftedState.isLocked;
	    }
	    if (paused || locked) {
	      if (lastAction) lastAction = undefined;else return;
	    }
	    relay('STATE', (0, _filters.filterStagedActions)(liftedState, filters));
	  }
	}
	
	function devToolsEnhancer() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  init(_extends({}, options, {
	    hostname: (0, _rnHostDetect2.default)(options.hostname || 'localhost')
	  }));
	  var realtime = typeof options.realtime === 'undefined' ? ("production") === 'development' : options.realtime;
	  if (!realtime && !(startOn || sendOn || sendOnError)) return function (f) {
	    return f;
	  };
	
	  var maxAge = options.maxAge || 30;
	  return function (next) {
	    return function (reducer, initialState) {
	      store = (0, _configureStore2.default)(next, monitorReducer, {
	        maxAge: maxAge,
	        shouldCatchErrors: !!sendOnError,
	        shouldHotReload: options.shouldHotReload,
	        shouldRecordChanges: options.shouldRecordChanges,
	        shouldStartLocked: options.shouldStartLocked,
	        pauseActionType: options.pauseActionType || '@@PAUSED'
	      })(reducer, initialState);
	
	      if (realtime) start();
	      store.subscribe(function () {
	        if (isMonitored) handleChange(store.getState(), store.liftedStore.getState(), maxAge);
	      });
	      return store;
	    };
	  };
	}
	
	function preEnhancer(createStore) {
	  return function (reducer, preloadedState, enhancer) {
	    store = createStore(reducer, preloadedState, enhancer);
	    return _extends({}, store, {
	      dispatch: function dispatch(action) {
	        return locked ? action : store.dispatch(action);
	      }
	    });
	  };
	}
	
	devToolsEnhancer.updateStore = function (newStore) {
	  console.warn('devTools.updateStore is deprecated use composeWithDevTools instead: ' + 'https://github.com/zalmoxisus/remote-redux-devtools#use-devtools-compose-helper');
	  store = newStore;
	};
	
	var compose = function compose(options) {
	  return function () {
	    for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	      funcs[_key] = arguments[_key];
	    }
	
	    return function () {
	      return [preEnhancer].concat(funcs).reduceRight(function (composed, f) {
	        return f(composed);
	      }, devToolsEnhancer(options).apply(undefined, arguments));
	    };
	  };
	};
	
	function composeWithDevTools() {
	  if (arguments.length === 0) {
	    return devToolsEnhancer();
	  }
	  if (arguments.length === 1 && _typeof(arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
	    return compose(arguments.length <= 0 ? undefined : arguments[0]);
	  }
	  return compose({}).apply(undefined, arguments);
	}

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.composeWithDevTools = exports.default = undefined;
	
	var _devTools = __webpack_require__(1575);
	
	Object.defineProperty(exports, 'composeWithDevTools', {
	  enumerable: true,
	  get: function get() {
	    return _devTools.composeWithDevTools;
	  }
	});
	
	var _devTools2 = _interopRequireDefault(_devTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _devTools2.default;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)(module), (function() { return this; }())))

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(300).Buffer))

/***/ },
/* 1579 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1580 */
/***/ function(module, exports) {

	/* global window */
	var GetParams = function (func) {
		'use strict';
	
		if (typeof func !== 'function') {
			return [];
		}
	
		var patternComments = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
		var patternArguments = /([^\s,]+)/g;
	
		var funcString = func
			.toString()
			.replace(patternComments, '');
	
		var result = funcString
			.slice(
				funcString.indexOf('(') + 1,
				funcString.indexOf(')')
			)
			.match(patternArguments);
	
		if (result === null) {
			return [];
		}
	
		return result;
	};
	
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
		module.exports = GetParams;
	}
	
	if (typeof window !== 'undefined') {
		window.GetParams = GetParams;
	}


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	var pathGetter = __webpack_require__(756);
	var utils = __webpack_require__(1582);
	
	var WMap = typeof WeakMap !== 'undefined'?
	  WeakMap:
	  function() {
	    var keys = [];
	    var values = [];
	    return {
	      set: function(key, value) {
	        keys.push(key);
	        values.push(value);
	      },
	      get: function(key) {
	        for (var i = 0; i < keys.length; i++) {
	          if (keys[i] === key) {
	            return values[i];
	          }
	        }
	      }
	    }
	  };
	
	// Based on https://github.com/douglascrockford/JSON-js/blob/master/cycle.js
	
	exports.decycle = function decycle(object, options, replacer) {
	  'use strict';
	
	  var map = new WMap()
	
	  var hasCircular = Object.prototype.hasOwnProperty.call(options, 'circular');
	
	  return (function derez(_value, path, key) {
	
	    // The derez recurses through the object, producing the deep copy.
	
	    var i,        // The loop counter
	      name,       // Property name
	      nu;         // The new object or array
	
	    // typeof null === 'object', so go on if this value is really an object but not
	    // one of the weird builtin objects.
	
	    var value = replacer ? replacer(key || '', _value) : _value;
	
	    if (options.date && value instanceof Date) {
	      return {$jsan: 'd' + value.getTime()};
	    }
	    if (options.regex && value instanceof RegExp) {
	      return {$jsan: 'r' + utils.getRegexFlags(value) + ',' + value.source};
	    }
	    if (options['function'] && typeof value === 'function') {
	      return {$jsan: 'f' + utils.stringifyFunction(value, options['function'])}
	    }
	    if (options['nan'] && typeof value === 'number' && isNaN(value)) {
	      return {$jsan: 'n'}
	    }
	    if (options['infinity']) {
	      if (Number.POSITIVE_INFINITY === value) return {$jsan: 'i'}
	      if (Number.NEGATIVE_INFINITY === value) return {$jsan: 'y'}
	    }
	    if (options['undefined'] && value === undefined) {
	      return {$jsan: 'u'}
	    }
	    if (options['error'] && value instanceof Error) {
	      return {$jsan: 'e' + value.message}
	    }
	    if (options['symbol'] && typeof value === 'symbol') {
	      var symbolKey = Symbol.keyFor(value)
	      if (symbolKey !== undefined) {
	        return {$jsan: 'g' + symbolKey}
	      }
	
	      // 'Symbol(foo)'.slice(7, -1) === 'foo'
	      return {$jsan: 's' + value.toString().slice(7, -1)}
	    }
	
	    if (options['map'] && typeof Map === 'function' && value instanceof Map && typeof Array.from === 'function') {
	      return {$jsan: 'm' + JSON.stringify(decycle(Array.from(value), options, replacer))}
	    }
	
	    if (options['set'] && typeof Set === 'function' && value instanceof Set && typeof Array.from === 'function') {
	      return {$jsan: 'l' + JSON.stringify(decycle(Array.from(value), options, replacer))}
	    }
	
	    if (value && typeof value.toJSON === 'function') {
	      value = value.toJSON(key);
	    }
	
	    if (typeof value === 'object' && value !== null &&
	      !(value instanceof Boolean) &&
	      !(value instanceof Date)    &&
	      !(value instanceof Number)  &&
	      !(value instanceof RegExp)  &&
	      !(value instanceof String)  &&
	      !(typeof value === 'symbol')  &&
	      !(value instanceof Error)) {
	
	        // If the value is an object or array, look to see if we have already
	        // encountered it. If so, return a $ref/path object.
	
	      if (typeof value === 'object' && value !== null) {
	        var foundPath = map.get(value);
	        if (foundPath) {
	          if (hasCircular && path.indexOf(foundPath) === 0) {
	            return typeof options.circular === 'function'?
	              options.circular(value, path, foundPath):
	              options.circular;
	          }
	          return {$jsan: foundPath};
	        }
	        map.set(value, path);
	      }
	
	
	      // If it is an array, replicate the array.
	
	      if (Object.prototype.toString.apply(value) === '[object Array]') {
	          nu = [];
	          for (i = 0; i < value.length; i += 1) {
	              nu[i] = derez(value[i], path + '[' + i + ']', i);
	          }
	      } else {
	
	        // If it is an object, replicate the object.
	
	        nu = {};
	        for (name in value) {
	          if (Object.prototype.hasOwnProperty.call(value, name)) {
	            var nextPath = /^\w+$/.test(name) ?
	              '.' + name :
	              '[' + JSON.stringify(name) + ']';
	            nu[name] = name === '$jsan' ? [derez(value[name], path + nextPath)] : derez(value[name], path + nextPath, name);
	          }
	        }
	      }
	      return nu;
	    }
	    return value;
	  }(object, '$'));
	};
	
	
	exports.retrocycle = function retrocycle($) {
	  'use strict';
	
	
	  return (function rez(value) {
	
	    // The rez function walks recursively through the object looking for $jsan
	    // properties. When it finds one that has a value that is a path, then it
	    // replaces the $jsan object with a reference to the value that is found by
	    // the path.
	
	    var i, item, name, path;
	
	    if (value && typeof value === 'object') {
	      if (Object.prototype.toString.apply(value) === '[object Array]') {
	        for (i = 0; i < value.length; i += 1) {
	          item = value[i];
	          if (item && typeof item === 'object') {
	            if (item.$jsan) {
	              value[i] = utils.restore(item.$jsan, $);
	            } else {
	              rez(item);
	            }
	          }
	        }
	      } else {
	        for (name in value) {
	          // base case passed raw object
	          if(typeof value[name] === 'string' && name === '$jsan'){
	            return utils.restore(value.$jsan, $);
	            break;
	          }
	          else {
	            if (name === '$jsan') {
	              value[name] = value[name][0];
	            }
	            if (typeof value[name] === 'object') {
	              item = value[name];
	              if (item && typeof item === 'object') {
	                if (item.$jsan) {
	                  value[name] = utils.restore(item.$jsan, $);
	                } else {
	                  rez(item);
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	    return value;
	  }($));
	};


/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	var pathGetter = __webpack_require__(756);
	var jsan = __webpack_require__(755);
	
	exports.getRegexFlags = function getRegexFlags(regex) {
	  var flags = '';
	  if (regex.ignoreCase) flags += 'i';
	  if (regex.global) flags += 'g';
	  if (regex.multiline) flags += 'm';
	  return flags;
	};
	
	exports.stringifyFunction = function stringifyFunction(fn, customToString) {
	  if (typeof customToString === 'function') {
	    return customToString(fn);
	  }
	  var str = fn.toString();
	  var match = str.match(/^[^{]*{|^[^=]*=>/);
	  var start = match ? match[0] : '<function> ';
	  var end = str[str.length - 1] === '}' ? '}' : '';
	  return start.replace(/\r\n|\n/g, ' ').replace(/\s+/g, ' ') + ' /* ... */ ' + end;
	};
	
	exports.restore = function restore(obj, root) {
	  var type = obj[0];
	  var rest = obj.slice(1);
	  switch(type) {
	    case '$':
	      return pathGetter(root, obj);
	    case 'r':
	      var comma = rest.indexOf(',');
	      var flags = rest.slice(0, comma);
	      var source = rest.slice(comma + 1);
	      return RegExp(source, flags);
	    case 'd':
	      return new Date(+rest);
	    case 'f':
	      var fn = function() { throw new Error("can't run jsan parsed function") };
	      fn.toString = function() { return rest; };
	      return fn;
	    case 'u':
	      return undefined;
	    case 'e':
	      var error = new Error(rest);
	      error.stack = 'Stack is unavailable for jsan parsed errors';
	      return error;
	    case 's':
	      return Symbol(rest);
	    case 'g':
	      return Symbol.for(rest);
	    case 'm':
	      return new Map(jsan.parse(rest));
	    case 'l':
	      return new Set(jsan.parse(rest));
	    case 'n':
	      return NaN;
	    case 'i':
	      return Infinity;
	    case 'y':
	      return -Infinity;
	    default:
	      console.warn('unknown type', obj);
	      return obj;
	  }
	}


/***/ },
/* 1583 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Constants.
	 */
	
	var errorMessage;
	
	errorMessage = 'An argument without append, prepend, ' +
	    'or detach methods was given to `List';
	
	/**
	 * Creates a new List: A linked list is a bit like an Array, but
	 * knows nothing about how many items are in it, and knows only about its
	 * first (`head`) and last (`tail`) items. Each item (e.g. `head`, `tail`,
	 * &c.) knows which item comes before or after it (its more like the
	 * implementation of the DOM in JavaScript).
	 * @global
	 * @private
	 * @constructor
	 * @class Represents an instance of List.
	 */
	
	function List(/*items...*/) {
	    if (arguments.length) {
	        return List.from(arguments);
	    }
	}
	
	var ListPrototype;
	
	ListPrototype = List.prototype;
	
	/**
	 * Creates a new list from the arguments (each a list item) passed in.
	 * @name List.of
	 * @param {...ListItem} [items] - Zero or more items to attach.
	 * @returns {list} - A new instance of List.
	 */
	
	List.of = function (/*items...*/) {
	    return List.from.call(this, arguments);
	};
	
	/**
	 * Creates a new list from the given array-like object (each a list item)
	 * passed in.
	 * @name List.from
	 * @param {ListItem[]} [items] - The items to append.
	 * @returns {list} - A new instance of List.
	 */
	List.from = function (items) {
	    var list = new this(), length, iterator, item;
	
	    if (items && (length = items.length)) {
	        iterator = -1;
	
	        while (++iterator < length) {
	            item = items[iterator];
	
	            if (item !== null && item !== undefined) {
	                list.append(item);
	            }
	        }
	    }
	
	    return list;
	};
	
	/**
	 * List#head
	 * Default to `null`.
	 */
	ListPrototype.head = null;
	
	/**
	 * List#tail
	 * Default to `null`.
	 */
	ListPrototype.tail = null;
	
	/**
	 * Returns the list's items as an array. This does *not* detach the items.
	 * @name List#toArray
	 * @returns {ListItem[]} - An array of (still attached) ListItems.
	 */
	ListPrototype.toArray = function () {
	    var item = this.head,
	        result = [];
	
	    while (item) {
	        result.push(item);
	        item = item.next;
	    }
	
	    return result;
	};
	
	/**
	 * Prepends the given item to the list: Item will be the new first item
	 * (`head`).
	 * @name List#prepend
	 * @param {ListItem} item - The item to prepend.
	 * @returns {ListItem} - An instance of ListItem (the given item).
	 */
	ListPrototype.prepend = function (item) {
	    if (!item) {
	        return false;
	    }
	
	    if (!item.append || !item.prepend || !item.detach) {
	        throw new Error(errorMessage + '#prepend`.');
	    }
	
	    var self, head;
	
	    // Cache self.
	    self = this;
	
	    // If self has a first item, defer prepend to the first items prepend
	    // method, and return the result.
	    head = self.head;
	
	    if (head) {
	        return head.prepend(item);
	    }
	
	    // ...otherwise, there is no `head` (or `tail`) item yet.
	
	    // Detach the prependee.
	    item.detach();
	
	    // Set the prependees parent list to reference self.
	    item.list = self;
	
	    // Set self's first item to the prependee, and return the item.
	    self.head = item;
	
	    return item;
	};
	
	/**
	 * Appends the given item to the list: Item will be the new last item (`tail`)
	 * if the list had a first item, and its first item (`head`) otherwise.
	 * @name List#append
	 * @param {ListItem} item - The item to append.
	 * @returns {ListItem} - An instance of ListItem (the given item).
	 */
	
	ListPrototype.append = function (item) {
	    if (!item) {
	        return false;
	    }
	
	    if (!item.append || !item.prepend || !item.detach) {
	        throw new Error(errorMessage + '#append`.');
	    }
	
	    var self, head, tail;
	
	    // Cache self.
	    self = this;
	
	    // If self has a last item, defer appending to the last items append
	    // method, and return the result.
	    tail = self.tail;
	
	    if (tail) {
	        return tail.append(item);
	    }
	
	    // If self has a first item, defer appending to the first items append
	    // method, and return the result.
	    head = self.head;
	
	    if (head) {
	        return head.append(item);
	    }
	
	    // ...otherwise, there is no `tail` or `head` item yet.
	
	    // Detach the appendee.
	    item.detach();
	
	    // Set the appendees parent list to reference self.
	    item.list = self;
	
	    // Set self's first item to the appendee, and return the item.
	    self.head = item;
	
	    return item;
	};
	
	/**
	 * Creates a new ListItem: A linked list item is a bit like DOM node:
	 * It knows only about its "parent" (`list`), the item before it (`prev`),
	 * and the item after it (`next`).
	 * @global
	 * @private
	 * @constructor
	 * @class Represents an instance of ListItem.
	 */
	
	function ListItem() {}
	
	List.Item = ListItem;
	
	var ListItemPrototype = ListItem.prototype;
	
	ListItemPrototype.next = null;
	
	ListItemPrototype.prev = null;
	
	ListItemPrototype.list = null;
	
	/**
	 * Detaches the item operated on from its parent list.
	 * @name ListItem#detach
	 * @returns {ListItem} - The item operated on.
	 */
	ListItemPrototype.detach = function () {
	    // Cache self, the parent list, and the previous and next items.
	    var self = this,
	        list = self.list,
	        prev = self.prev,
	        next = self.next;
	
	    // If the item is already detached, return self.
	    if (!list) {
	        return self;
	    }
	
	    // If self is the last item in the parent list, link the lists last item
	    // to the previous item.
	    if (list.tail === self) {
	        list.tail = prev;
	    }
	
	    // If self is the first item in the parent list, link the lists first item
	    // to the next item.
	    if (list.head === self) {
	        list.head = next;
	    }
	
	    // If both the last and first items in the parent list are the same,
	    // remove the link to the last item.
	    if (list.tail === list.head) {
	        list.tail = null;
	    }
	
	    // If a previous item exists, link its next item to selfs next item.
	    if (prev) {
	        prev.next = next;
	    }
	
	    // If a next item exists, link its previous item to selfs previous item.
	    if (next) {
	        next.prev = prev;
	    }
	
	    // Remove links from self to both the next and previous items, and to the
	    // parent list.
	    self.prev = self.next = self.list = null;
	
	    // Return self.
	    return self;
	};
	
	/**
	 * Prepends the given item *before* the item operated on.
	 * @name ListItem#prepend
	 * @param {ListItem} item - The item to prepend.
	 * @returns {ListItem} - The item operated on, or false when that item is not
	 * attached.
	 */
	ListItemPrototype.prepend = function (item) {
	    if (!item || !item.append || !item.prepend || !item.detach) {
	        throw new Error(errorMessage + 'Item#prepend`.');
	    }
	
	    // Cache self, the parent list, and the previous item.
	    var self = this,
	        list = self.list,
	        prev = self.prev;
	
	    // If self is detached, return false.
	    if (!list) {
	        return false;
	    }
	
	    // Detach the prependee.
	    item.detach();
	
	    // If self has a previous item...
	    if (prev) {
	        // ...link the prependees previous item, to selfs previous item.
	        item.prev = prev;
	
	        // ...link the previous items next item, to self.
	        prev.next = item;
	    }
	
	    // Set the prependees next item to self.
	    item.next = self;
	
	    // Set the prependees parent list to selfs parent list.
	    item.list = list;
	
	    // Set the previous item of self to the prependee.
	    self.prev = item;
	
	    // If self is the first item in the parent list, link the lists first item
	    // to the prependee.
	    if (self === list.head) {
	        list.head = item;
	    }
	
	    // If the the parent list has no last item, link the lists last item to
	    // self.
	    if (!list.tail) {
	        list.tail = self;
	    }
	
	    // Return the prependee.
	    return item;
	};
	
	/**
	 * Appends the given item *after* the item operated on.
	 * @name ListItem#append
	 * @param {ListItem} item - The item to append.
	 * @returns {ListItem} - The item operated on, or false when that item is not
	 * attached.
	 */
	ListItemPrototype.append = function (item) {
	    // If item is falsey, return false.
	    if (!item || !item.append || !item.prepend || !item.detach) {
	        throw new Error(errorMessage + 'Item#append`.');
	    }
	
	    // Cache self, the parent list, and the next item.
	    var self = this,
	        list = self.list,
	        next = self.next;
	
	    // If self is detached, return false.
	    if (!list) {
	        return false;
	    }
	
	    // Detach the appendee.
	    item.detach();
	
	    // If self has a next item...
	    if (next) {
	        // ...link the appendees next item, to selfs next item.
	        item.next = next;
	
	        // ...link the next items previous item, to the appendee.
	        next.prev = item;
	    }
	
	    // Set the appendees previous item to self.
	    item.prev = self;
	
	    // Set the appendees parent list to selfs parent list.
	    item.list = list;
	
	    // Set the next item of self to the appendee.
	    self.next = item;
	
	    // If the the parent list has no last item or if self is the parent lists
	    // last item, link the lists last item to the appendee.
	    if (self === list.tail || !list.tail) {
	        list.tail = item;
	    }
	
	    // Return the appendee.
	    return item;
	};
	
	/**
	 * Expose `List`.
	 */
	
	module.exports = List;


/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1583);


/***/ },
/* 1585 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 1586 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.INIT_ACTION = exports.ActionCreators = exports.ActionTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.liftAction = liftAction;
	exports.liftReducerWith = liftReducerWith;
	exports.unliftState = unliftState;
	exports.unliftStore = unliftStore;
	exports.default = instrument;
	
	var _difference = __webpack_require__(1134);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _union = __webpack_require__(1151);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _isPlainObject = __webpack_require__(116);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1603);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = {
	  PERFORM_ACTION: 'PERFORM_ACTION',
	  RESET: 'RESET',
	  ROLLBACK: 'ROLLBACK',
	  COMMIT: 'COMMIT',
	  SWEEP: 'SWEEP',
	  TOGGLE_ACTION: 'TOGGLE_ACTION',
	  SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
	  JUMP_TO_STATE: 'JUMP_TO_STATE',
	  JUMP_TO_ACTION: 'JUMP_TO_ACTION',
	  REORDER_ACTION: 'REORDER_ACTION',
	  IMPORT_STATE: 'IMPORT_STATE',
	  LOCK_CHANGES: 'LOCK_CHANGES',
	  PAUSE_RECORDING: 'PAUSE_RECORDING'
	};
	
	/**
	 * Action creators to change the History state.
	 */
	var ActionCreators = exports.ActionCreators = {
	  performAction: function performAction(action) {
	    if (!(0, _isPlainObject2.default)(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now() };
	  },
	  reset: function reset() {
	    return { type: ActionTypes.RESET, timestamp: Date.now() };
	  },
	  rollback: function rollback() {
	    return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
	  },
	  commit: function commit() {
	    return { type: ActionTypes.COMMIT, timestamp: Date.now() };
	  },
	  sweep: function sweep() {
	    return { type: ActionTypes.SWEEP };
	  },
	  toggleAction: function toggleAction(id) {
	    return { type: ActionTypes.TOGGLE_ACTION, id: id };
	  },
	  setActionsActive: function setActionsActive(start, end) {
	    var active = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	    return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
	  },
	  reorderAction: function reorderAction(actionId, beforeActionId) {
	    return { type: ActionTypes.REORDER_ACTION, actionId: actionId, beforeActionId: beforeActionId };
	  },
	  jumpToState: function jumpToState(index) {
	    return { type: ActionTypes.JUMP_TO_STATE, index: index };
	  },
	  jumpToAction: function jumpToAction(actionId) {
	    return { type: ActionTypes.JUMP_TO_ACTION, actionId: actionId };
	  },
	  importState: function importState(nextLiftedState, noRecompute) {
	    return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState, noRecompute: noRecompute };
	  },
	  lockChanges: function lockChanges(status) {
	    return { type: ActionTypes.LOCK_CHANGES, status: status };
	  },
	  pauseRecording: function pauseRecording(status) {
	    return { type: ActionTypes.PAUSE_RECORDING, status: status };
	  }
	};
	
	var INIT_ACTION = exports.INIT_ACTION = { type: '@@INIT' };
	
	/**
	 * Computes the next entry with exceptions catching.
	 */
	function computeWithTryCatch(reducer, action, state) {
	  var nextState = state;
	  var nextError = void 0;
	  try {
	    nextState = reducer(state, action);
	  } catch (err) {
	    nextError = err.toString();
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof window.chrome !== 'undefined' || typeof window.process !== 'undefined' && window.process.type === 'renderer')) {
	      // In Chrome, rethrowing provides better source map support
	      setTimeout(function () {
	        throw err;
	      });
	    } else {
	      console.error(err);
	    }
	  }
	
	  return {
	    state: nextState,
	    error: nextError
	  };
	}
	
	/**
	 * Computes the next entry in the log by applying an action.
	 */
	function computeNextEntry(reducer, action, state, shouldCatchErrors) {
	  if (!shouldCatchErrors) {
	    return { state: reducer(state, action) };
	  }
	  return computeWithTryCatch(reducer, action, state);
	}
	
	/**
	 * Runs the reducer on invalidated actions to get a fresh computation log.
	 */
	function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, shouldCatchErrors) {
	  // Optimization: exit early and return the same reference
	  // if we know nothing could have changed.
	  if (!computedStates || minInvalidatedStateIndex === -1 || minInvalidatedStateIndex >= computedStates.length && computedStates.length === stagedActionIds.length) {
	    return computedStates;
	  }
	
	  var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
	  for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
	    var actionId = stagedActionIds[i];
	    var action = actionsById[actionId].action;
	
	    var previousEntry = nextComputedStates[i - 1];
	    var previousState = previousEntry ? previousEntry.state : committedState;
	
	    var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
	    var entry = void 0;
	    if (shouldSkip) {
	      entry = previousEntry;
	    } else {
	      if (shouldCatchErrors && previousEntry && previousEntry.error) {
	        entry = {
	          state: previousState,
	          error: 'Interrupted by an error up the chain'
	        };
	      } else {
	        entry = computeNextEntry(reducer, action, previousState, shouldCatchErrors);
	      }
	    }
	    nextComputedStates.push(entry);
	  }
	
	  return nextComputedStates;
	}
	
	/**
	 * Lifts an app's action into an action on the lifted store.
	 */
	function liftAction(action) {
	  return ActionCreators.performAction(action);
	}
	
	/**
	 * Creates a history state reducer from an app's reducer.
	 */
	function liftReducerWith(reducer, initialCommittedState, monitorReducer, options) {
	  var initialLiftedState = {
	    monitorState: monitorReducer(undefined, {}),
	    nextActionId: 1,
	    actionsById: { 0: liftAction(INIT_ACTION) },
	    stagedActionIds: [0],
	    skippedActionIds: [],
	    committedState: initialCommittedState,
	    currentStateIndex: 0,
	    computedStates: [],
	    isLocked: options.shouldStartLocked === true,
	    isPaused: options.shouldRecordChanges === false
	  };
	
	  /**
	   * Manages how the history actions modify the history state.
	   */
	  return function (liftedState, liftedAction) {
	    var _ref = liftedState || initialLiftedState;
	
	    var monitorState = _ref.monitorState;
	    var actionsById = _ref.actionsById;
	    var nextActionId = _ref.nextActionId;
	    var stagedActionIds = _ref.stagedActionIds;
	    var skippedActionIds = _ref.skippedActionIds;
	    var committedState = _ref.committedState;
	    var currentStateIndex = _ref.currentStateIndex;
	    var computedStates = _ref.computedStates;
	    var isLocked = _ref.isLocked;
	    var isPaused = _ref.isPaused;
	
	
	    if (!liftedState) {
	      // Prevent mutating initialLiftedState
	      actionsById = _extends({}, actionsById);
	    }
	
	    function commitExcessActions(n) {
	      // Auto-commits n-number of excess actions.
	      var excess = n;
	      var idsToDelete = stagedActionIds.slice(1, excess + 1);
	
	      for (var i = 0; i < idsToDelete.length; i++) {
	        if (computedStates[i + 1].error) {
	          // Stop if error is found. Commit actions up to error.
	          excess = i;
	          idsToDelete = stagedActionIds.slice(1, excess + 1);
	          break;
	        } else {
	          delete actionsById[idsToDelete[i]];
	        }
	      }
	
	      skippedActionIds = skippedActionIds.filter(function (id) {
	        return idsToDelete.indexOf(id) === -1;
	      });
	      stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
	      committedState = computedStates[excess].state;
	      computedStates = computedStates.slice(excess);
	      currentStateIndex = currentStateIndex > excess ? currentStateIndex - excess : 0;
	    }
	
	    function computePausedAction(shouldInit) {
	      var _extends2;
	
	      var computedState = void 0;
	      if (shouldInit) {
	        computedState = computedStates[currentStateIndex];
	        monitorState = monitorReducer(monitorState, liftedAction);
	      } else {
	        computedState = computeNextEntry(reducer, liftedAction.action, computedStates[currentStateIndex].state, false);
	      }
	      if (!options.pauseActionType || nextActionId === 1) {
	        return {
	          monitorState: monitorState,
	          actionsById: { 0: liftAction(INIT_ACTION) },
	          nextActionId: 1,
	          stagedActionIds: [0],
	          skippedActionIds: [],
	          committedState: computedState.state,
	          currentStateIndex: 0,
	          computedStates: [computedState],
	          isLocked: isLocked,
	          isPaused: true
	        };
	      }
	      if (shouldInit) {
	        if (currentStateIndex === stagedActionIds.length - 1) {
	          currentStateIndex++;
	        }
	        stagedActionIds = [].concat(stagedActionIds, [nextActionId]);
	        nextActionId++;
	      }
	      return {
	        monitorState: monitorState,
	        actionsById: _extends({}, actionsById, (_extends2 = {}, _extends2[nextActionId - 1] = liftAction({ type: options.pauseActionType }), _extends2)),
	        nextActionId: nextActionId,
	        stagedActionIds: stagedActionIds,
	        skippedActionIds: skippedActionIds,
	        committedState: committedState,
	        currentStateIndex: currentStateIndex,
	        computedStates: [].concat(computedStates.slice(0, stagedActionIds.length - 1), [computedState]),
	        isLocked: isLocked,
	        isPaused: true
	      };
	    }
	
	    // By default, agressively recompute every state whatever happens.
	    // This has O(n) performance, so we'll override this to a sensible
	    // value whenever we feel like we don't have to recompute the states.
	    var minInvalidatedStateIndex = 0;
	
	    if (liftedAction.type.indexOf('@@redux/INIT') === 0) {
	      if (options.shouldHotReload === false) {
	        actionsById = { 0: liftAction(INIT_ACTION) };
	        nextActionId = 1;
	        stagedActionIds = [0];
	        skippedActionIds = [];
	        committedState = computedStates.length === 0 ? initialCommittedState : computedStates[currentStateIndex].state;
	        currentStateIndex = 0;
	        computedStates = [];
	      }
	
	      // Recompute states on hot reload and init.
	      minInvalidatedStateIndex = 0;
	
	      if (options.maxAge && stagedActionIds.length > options.maxAge) {
	        // States must be recomputed before committing excess.
	        computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	
	        commitExcessActions(stagedActionIds.length - options.maxAge);
	
	        // Avoid double computation.
	        minInvalidatedStateIndex = Infinity;
	      }
	    } else {
	      switch (liftedAction.type) {
	        case ActionTypes.PERFORM_ACTION:
	          {
	            if (isLocked) return liftedState || initialLiftedState;
	            if (isPaused) return computePausedAction();
	
	            // Auto-commit as new actions come in.
	            if (options.maxAge && stagedActionIds.length === options.maxAge) {
	              commitExcessActions(1);
	            }
	
	            if (currentStateIndex === stagedActionIds.length - 1) {
	              currentStateIndex++;
	            }
	            var actionId = nextActionId++;
	            // Mutation! This is the hottest path, and we optimize on purpose.
	            // It is safe because we set a new key in a cache dictionary.
	            actionsById[actionId] = liftedAction;
	            stagedActionIds = [].concat(stagedActionIds, [actionId]);
	            // Optimization: we know that only the new action needs computing.
	            minInvalidatedStateIndex = stagedActionIds.length - 1;
	            break;
	          }
	        case ActionTypes.RESET:
	          {
	            // Get back to the state the store was created with.
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = initialCommittedState;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        case ActionTypes.COMMIT:
	          {
	            // Consider the last committed state the new starting point.
	            // Squash any staged actions into a single committed state.
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        case ActionTypes.ROLLBACK:
	          {
	            // Forget about any staged actions.
	            // Start again from the last committed state.
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        case ActionTypes.TOGGLE_ACTION:
	          {
	            var _ret = function () {
	              // Toggle whether an action with given ID is skipped.
	              // Being skipped means it is a no-op during the computation.
	              var actionId = liftedAction.id;
	
	              var index = skippedActionIds.indexOf(actionId);
	              if (index === -1) {
	                skippedActionIds = [actionId].concat(skippedActionIds);
	              } else {
	                skippedActionIds = skippedActionIds.filter(function (id) {
	                  return id !== actionId;
	                });
	              }
	              // Optimization: we know history before this action hasn't changed
	              minInvalidatedStateIndex = stagedActionIds.indexOf(actionId);
	              return 'break';
	            }();
	
	            if (_ret === 'break') break;
	          }
	        case ActionTypes.SET_ACTIONS_ACTIVE:
	          {
	            // Toggle whether an action with given ID is skipped.
	            // Being skipped means it is a no-op during the computation.
	            var start = liftedAction.start;
	            var end = liftedAction.end;
	            var active = liftedAction.active;
	
	            var actionIds = [];
	            for (var i = start; i < end; i++) {
	              actionIds.push(i);
	            }if (active) {
	              skippedActionIds = (0, _difference2.default)(skippedActionIds, actionIds);
	            } else {
	              skippedActionIds = (0, _union2.default)(skippedActionIds, actionIds);
	            }
	
	            // Optimization: we know history before this action hasn't changed
	            minInvalidatedStateIndex = stagedActionIds.indexOf(start);
	            break;
	          }
	        case ActionTypes.JUMP_TO_STATE:
	          {
	            // Without recomputing anything, move the pointer that tell us
	            // which state is considered the current one. Useful for sliders.
	            currentStateIndex = liftedAction.index;
	            // Optimization: we know the history has not changed.
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	        case ActionTypes.JUMP_TO_ACTION:
	          {
	            // Jumps to a corresponding state to a specific action.
	            // Useful when filtering actions.
	            var _index = stagedActionIds.indexOf(liftedAction.actionId);
	            if (_index !== -1) currentStateIndex = _index;
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	        case ActionTypes.SWEEP:
	          {
	            // Forget any actions that are currently being skipped.
	            stagedActionIds = (0, _difference2.default)(stagedActionIds, skippedActionIds);
	            skippedActionIds = [];
	            currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
	            break;
	          }
	        case ActionTypes.REORDER_ACTION:
	          {
	            // Recompute actions in a new order.
	            var _actionId = liftedAction.actionId;
	            var idx = stagedActionIds.indexOf(_actionId);
	            // do nothing in case the action is already removed or trying to move the first action
	            if (idx < 1) break;
	            var beforeActionId = liftedAction.beforeActionId;
	            var newIdx = stagedActionIds.indexOf(beforeActionId);
	            if (newIdx < 1) {
	              // move to the beginning or to the end
	              var count = stagedActionIds.length;
	              newIdx = beforeActionId > stagedActionIds[count - 1] ? count : 1;
	            }
	            var diff = idx - newIdx;
	
	            if (diff > 0) {
	              // move left
	              stagedActionIds = [].concat(stagedActionIds.slice(0, newIdx), [_actionId], stagedActionIds.slice(newIdx, idx), stagedActionIds.slice(idx + 1));
	              minInvalidatedStateIndex = newIdx;
	            } else if (diff < 0) {
	              // move right
	              stagedActionIds = [].concat(stagedActionIds.slice(0, idx), stagedActionIds.slice(idx + 1, newIdx), [_actionId], stagedActionIds.slice(newIdx));
	              minInvalidatedStateIndex = idx;
	            }
	            break;
	          }
	        case ActionTypes.IMPORT_STATE:
	          {
	            if (Array.isArray(liftedAction.nextLiftedState)) {
	              // recompute array of actions
	              actionsById = { 0: liftAction(INIT_ACTION) };
	              nextActionId = 1;
	              stagedActionIds = [0];
	              skippedActionIds = [];
	              currentStateIndex = liftedAction.nextLiftedState.length;
	              computedStates = [];
	              committedState = liftedAction.preloadedState;
	              minInvalidatedStateIndex = 0;
	              // iterate through actions
	              liftedAction.nextLiftedState.forEach(function (action) {
	                actionsById[nextActionId] = liftAction(action);
	                stagedActionIds.push(nextActionId);
	                nextActionId++;
	              });
	            } else {
	              var _liftedAction$nextLif = liftedAction.nextLiftedState;
	              // Completely replace everything.
	
	              monitorState = _liftedAction$nextLif.monitorState;
	              actionsById = _liftedAction$nextLif.actionsById;
	              nextActionId = _liftedAction$nextLif.nextActionId;
	              stagedActionIds = _liftedAction$nextLif.stagedActionIds;
	              skippedActionIds = _liftedAction$nextLif.skippedActionIds;
	              committedState = _liftedAction$nextLif.committedState;
	              currentStateIndex = _liftedAction$nextLif.currentStateIndex;
	              computedStates = _liftedAction$nextLif.computedStates;
	
	
	              if (liftedAction.noRecompute) {
	                minInvalidatedStateIndex = Infinity;
	              }
	            }
	
	            break;
	          }
	        case ActionTypes.LOCK_CHANGES:
	          {
	            isLocked = liftedAction.status;
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	        case ActionTypes.PAUSE_RECORDING:
	          {
	            isPaused = liftedAction.status;
	            if (isPaused) {
	              return computePausedAction(true);
	            }
	            // Commit when unpausing
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        default:
	          {
	            // If the action is not recognized, it's a monitor action.
	            // Optimization: a monitor action can't change history.
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	      }
	    }
	
	    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	    monitorState = monitorReducer(monitorState, liftedAction);
	    return {
	      monitorState: monitorState,
	      actionsById: actionsById,
	      nextActionId: nextActionId,
	      stagedActionIds: stagedActionIds,
	      skippedActionIds: skippedActionIds,
	      committedState: committedState,
	      currentStateIndex: currentStateIndex,
	      computedStates: computedStates,
	      isLocked: isLocked,
	      isPaused: isPaused
	    };
	  };
	}
	
	/**
	 * Provides an app's view into the state of the lifted store.
	 */
	function unliftState(liftedState) {
	  var computedStates = liftedState.computedStates;
	  var currentStateIndex = liftedState.currentStateIndex;
	  var state = computedStates[currentStateIndex].state;
	
	  return state;
	}
	
	/**
	 * Provides an app's view into the lifted store.
	 */
	function unliftStore(liftedStore, liftReducer) {
	  var _extends3;
	
	  var lastDefinedState = void 0;
	
	  function getState() {
	    var state = unliftState(liftedStore.getState());
	    if (state !== undefined) {
	      lastDefinedState = state;
	    }
	    return lastDefinedState;
	  }
	
	  return _extends({}, liftedStore, (_extends3 = {
	
	    liftedStore: liftedStore,
	
	    dispatch: function dispatch(action) {
	      liftedStore.dispatch(liftAction(action));
	      return action;
	    },
	
	
	    getState: getState,
	
	    replaceReducer: function replaceReducer(nextReducer) {
	      liftedStore.replaceReducer(liftReducer(nextReducer));
	    }
	  }, _extends3[_symbolObservable2.default] = function () {
	    return _extends({}, liftedStore[_symbolObservable2.default](), {
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = liftedStore.subscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    });
	  }, _extends3));
	}
	
	/**
	 * Redux instrumentation store enhancer.
	 */
	function instrument() {
	  var monitorReducer = arguments.length <= 0 || arguments[0] === undefined ? function () {
	    return null;
	  } : arguments[0];
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  /* eslint-disable no-eq-null */
	  if (options.maxAge != null && options.maxAge < 2) {
	    /* eslint-enable */
	    throw new Error('DevTools.instrument({ maxAge }) option, if specified, ' + 'may not be less than 2.');
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	
	      function liftReducer(r) {
	        if (typeof r !== 'function') {
	          if (r && typeof r.default === 'function') {
	            throw new Error('Expected the reducer to be a function. ' + 'Instead got an object with a "default" field. ' + 'Did you pass a module instead of the default export? ' + 'Try passing require(...).default instead.');
	          }
	          throw new Error('Expected the reducer to be a function.');
	        }
	        return liftReducerWith(r, initialState, monitorReducer, options);
	      }
	
	      var liftedStore = createStore(liftReducer(reducer), enhancer);
	      if (liftedStore.liftedStore) {
	        throw new Error('DevTools instrumentation should not be applied more than once. ' + 'Check your store configuration.');
	      }
	
	      return unliftStore(liftedStore, liftReducer);
	    };
	  };
	}

/***/ },
/* 1588 */
/***/ function(module, exports) {

	function mark(data, type, transformMethod) {
	  return {
	    data: transformMethod ? data[transformMethod]() : data,
	    __serializedType__: type
	  };
	}
	
	function extract(data, type) {
	  return {
	    data: Object.assign({}, data),
	    __serializedType__: type
	  };
	}
	
	function refer(data, type, isArray, refs) {
	  var r = mark(data, type, isArray);
	  if (!refs) return r;
	  for (var i = 0; i < refs.length; i++) {
	    var ref = refs[i];
	    if (typeof ref === 'function' && data instanceof ref) {
	      r.__serializedRef__ = i;
	      return r;
	    }
	  }
	  return r;
	}
	
	module.exports = {
	  mark: mark,
	  extract: extract,
	  refer: refer
	};


/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	var helpers = __webpack_require__(1588);
	var mark = helpers.mark;
	var extract = helpers.extract;
	var refer = helpers.refer;
	
	module.exports = function serialize(Immutable, refs) {
	  return {
	    replacer: function(key, value) {
	      if (value instanceof Immutable.Record) return refer(value, 'ImmutableRecord', 'toObject', refs);
	      if (value instanceof Immutable.Range) return extract(value, 'ImmutableRange');
	      if (value instanceof Immutable.Repeat) return extract(value, 'ImmutableRepeat');
	      if (Immutable.OrderedMap.isOrderedMap(value)) return mark(value, 'ImmutableOrderedMap', 'toObject');
	      if (Immutable.Map.isMap(value)) return mark(value, 'ImmutableMap', 'toObject');
	      if (Immutable.List.isList(value)) return mark(value, 'ImmutableList', 'toArray');
	      if (Immutable.OrderedSet.isOrderedSet(value)) return mark(value, 'ImmutableOrderedSet', 'toArray');
	      if (Immutable.Set.isSet(value)) return mark(value, 'ImmutableSet', 'toArray');
	      if (Immutable.Seq.isSeq(value)) return mark(value, 'ImmutableSeq', 'toArray');
	      if (Immutable.Stack.isStack(value)) return mark(value, 'ImmutableStack', 'toArray');
	      return value;
	    },
	
	    reviver: function(key, value) {
	      if (typeof value === 'object' && value !== null && '__serializedType__'  in value) {
	        var data = value.data;
	        switch (value.__serializedType__) {
	          case 'ImmutableMap': return Immutable.Map(data);
	          case 'ImmutableOrderedMap': return Immutable.OrderedMap(data);
	          case 'ImmutableList': return Immutable.List(data);
	          case 'ImmutableRange': return Immutable.Range(data._start, data._end, data._step);
	          case 'ImmutableRepeat': return Immutable.Repeat(data._value, data.size);
	          case 'ImmutableSet': return Immutable.Set(data);
	          case 'ImmutableOrderedSet': return Immutable.OrderedSet(data);
	          case 'ImmutableSeq': return Immutable.Seq(data);
	          case 'ImmutableStack': return Immutable.Stack(data);
	          case 'ImmutableRecord':
	            return (refs && refs[value.__serializedRef__] || Immutable.Map)(data);
	          default: return data;
	        }
	      }
	      return value;
	    }
	  }   
	};


/***/ },
/* 1590 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = catchErrors;
	var ERROR = '@@remotedev/ERROR';
	
	function catchErrors(sendError) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && _typeof(window.onerror) === 'object') {
	    window.onerror = function (message, url, lineNo, columnNo, error) {
	      var errorAction = { type: ERROR, message: message, url: url, lineNo: lineNo, columnNo: columnNo };
	      if (error && error.stack) errorAction.stack = error.stack;
	      sendError(errorAction);
	      return false;
	    };
	  } else if (typeof global !== 'undefined' && global.ErrorUtils) {
	    global.ErrorUtils.setGlobalHandler(function (error, isFatal) {
	      sendError({ type: ERROR, error: error, isFatal: isFatal });
	    });
	  }
	
	  if ((typeof console === 'undefined' ? 'undefined' : _typeof(console)) === 'object' && typeof console.error === 'function' && !console.beforeRemotedev) {
	    console.beforeRemotedev = console.error.bind(console);
	    console.error = function () {
	      var errorAction = { type: ERROR };
	      var error = arguments[0];
	      errorAction.message = error.message ? error.message : error;
	      if (error.sourceURL) {
	        errorAction = _extends({}, errorAction, { sourceURL: error.sourceURL, line: error.line, column: error.column
	        });
	      }
	      if (error.stack) errorAction.stack = error.stack;
	      sendError(errorAction);
	      console.beforeRemotedev.apply(null, arguments);
	    };
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FilterState = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.arrToRegex = arrToRegex;
	exports.getLocalFilter = getLocalFilter;
	exports.isFiltered = isFiltered;
	exports.filterStagedActions = filterStagedActions;
	exports.filterState = filterState;
	
	var _mapValues = __webpack_require__(222);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterState = exports.FilterState = {
	  DO_NOT_FILTER: 'DO_NOT_FILTER',
	  BLACKLIST_SPECIFIC: 'BLACKLIST_SPECIFIC',
	  WHITELIST_SPECIFIC: 'WHITELIST_SPECIFIC'
	};
	
	function arrToRegex(v) {
	  return typeof v === 'string' ? v : v.join('|');
	}
	
	function filterActions(actionsById, actionsFilter) {
	  if (!actionsFilter) return actionsById;
	  return (0, _mapValues2.default)(actionsById, function (action, id) {
	    return _extends({}, action, { action: actionsFilter(action.action, id) });
	  });
	}
	
	function filterStates(computedStates, statesFilter) {
	  if (!statesFilter) return computedStates;
	  return computedStates.map(function (state, idx) {
	    return _extends({}, state, { state: statesFilter(state.state, idx) });
	  });
	}
	
	function getLocalFilter(config) {
	  if (config.actionsBlacklist || config.actionsWhitelist) {
	    return {
	      whitelist: config.actionsWhitelist && config.actionsWhitelist.join('|'),
	      blacklist: config.actionsBlacklist && config.actionsBlacklist.join('|')
	    };
	  }
	  return undefined;
	}
	
	function getDevToolsOptions() {
	  return typeof window !== 'undefined' && window.devToolsOptions || {};
	}
	
	function isFiltered(action, localFilter) {
	  var _ref = action.action || action;
	
	  var type = _ref.type;
	
	  var opts = getDevToolsOptions();
	  if (!localFilter && opts.filter && opts.filter === FilterState.DO_NOT_FILTER || type && typeof type.match !== 'function') return false;
	
	  var _ref2 = localFilter || opts;
	
	  var whitelist = _ref2.whitelist;
	  var blacklist = _ref2.blacklist;
	
	  return whitelist && !type.match(whitelist) || blacklist && type.match(blacklist);
	}
	
	function filterStagedActions(state, filters) {
	  if (!filters) return state;
	
	  var filteredStagedActionIds = [];
	  var filteredComputedStates = [];
	
	  state.stagedActionIds.forEach(function (id, idx) {
	    if (!isFiltered(state.actionsById[id], filters)) {
	      filteredStagedActionIds.push(id);
	      filteredComputedStates.push(state.computedStates[idx]);
	    }
	  });
	
	  return _extends({}, state, {
	    stagedActionIds: filteredStagedActionIds,
	    computedStates: filteredComputedStates
	  });
	}
	
	function filterState(state, type, localFilter, stateSanitizer, actionSanitizer, nextActionId, predicate) {
	  if (type === 'ACTION') return !stateSanitizer ? state : stateSanitizer(state, nextActionId - 1);else if (type !== 'STATE') return state;
	
	  var _getDevToolsOptions = getDevToolsOptions();
	
	  var filter = _getDevToolsOptions.filter;
	
	  if (predicate || localFilter || filter && filter !== FilterState.DO_NOT_FILTER) {
	    var _ret = function () {
	      var filteredStagedActionIds = [];
	      var filteredComputedStates = [];
	      var sanitizedActionsById = actionSanitizer && {};
	      var actionsById = state.actionsById;
	      var computedStates = state.computedStates;
	
	
	      state.stagedActionIds.forEach(function (id, idx) {
	        var liftedAction = actionsById[id];
	        var currAction = liftedAction.action;
	        var liftedState = computedStates[idx];
	        var currState = liftedState.state;
	        if (idx) {
	          if (predicate && !predicate(currState, currAction)) return;
	          if (isFiltered(currAction, localFilter)) return;
	        }
	
	        filteredStagedActionIds.push(id);
	        filteredComputedStates.push(stateSanitizer ? _extends({}, liftedState, { state: stateSanitizer(currState, idx) }) : liftedState);
	        if (actionSanitizer) {
	          sanitizedActionsById[id] = _extends({}, liftedAction, { action: actionSanitizer(currAction, id)
	          });
	        }
	      });
	
	      return {
	        v: _extends({}, state, {
	          actionsById: sanitizedActionsById || actionsById,
	          stagedActionIds: filteredStagedActionIds,
	          computedStates: filteredComputedStates
	        })
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  if (!stateSanitizer && !actionSanitizer) return state;
	  return _extends({}, state, {
	    actionsById: filterActions(state.actionsById, actionSanitizer),
	    computedStates: filterStates(state.computedStates, stateSanitizer)
	  });
	}

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.generateId = generateId;
	exports.getMethods = getMethods;
	exports.getActionsArray = getActionsArray;
	exports.evalAction = evalAction;
	exports.evalMethod = evalMethod;
	exports.stringify = stringify;
	exports.getSeralizeParameter = getSeralizeParameter;
	
	var _getParams = __webpack_require__(1580);
	
	var _getParams2 = _interopRequireDefault(_getParams);
	
	var _jsan = __webpack_require__(754);
	
	var _jsan2 = _interopRequireDefault(_jsan);
	
	var _shortid = __webpack_require__(1606);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _serialize = __webpack_require__(1589);
	
	var _serialize2 = _interopRequireDefault(_serialize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateId(id) {
	  return id || _shortid2.default.generate();
	}
	
	function flatTree(obj) {
	  var namespace = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	  var functions = [];
	  Object.keys(obj).forEach(function (key) {
	    var prop = obj[key];
	    if (typeof prop === 'function') {
	      functions.push({
	        name: namespace + (key || prop.name || 'anonymous'),
	        func: prop,
	        args: (0, _getParams2.default)(prop)
	      });
	    } else if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
	      functions = functions.concat(flatTree(prop, namespace + key + '.'));
	    }
	  });
	  return functions;
	}
	
	function getMethods(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') return undefined;
	  var functions = void 0;
	  var m = void 0;
	  if (obj.__proto__) m = obj.__proto__.__proto__;
	  if (!m) m = obj;
	
	  Object.getOwnPropertyNames(m).forEach(function (key) {
	    var propDescriptor = Object.getOwnPropertyDescriptor(m, key);
	    if (!propDescriptor || 'get' in propDescriptor || 'set' in propDescriptor) return;
	    var prop = m[key];
	    if (typeof prop === 'function' && key !== 'constructor') {
	      if (!functions) functions = [];
	      functions.push({
	        name: key || prop.name || 'anonymous',
	        args: (0, _getParams2.default)(prop)
	      });
	    }
	  });
	  return functions;
	}
	
	function getActionsArray(actionCreators) {
	  if (Array.isArray(actionCreators)) return actionCreators;
	  return flatTree(actionCreators);
	}
	
	/* eslint-disable no-new-func */
	var interpretArg = function interpretArg(arg) {
	  return new Function('return ' + arg)();
	};
	
	function evalArgs(inArgs, restArgs) {
	  var args = inArgs.map(interpretArg);
	  if (!restArgs) return args;
	  var rest = interpretArg(restArgs);
	  if (Array.isArray(rest)) return args.concat.apply(args, rest);
	  throw new Error('rest must be an array');
	}
	
	function evalAction(action, actionCreators) {
	  if (typeof action === 'string') {
	    return new Function('return ' + action)();
	  }
	
	  var actionCreator = actionCreators[action.selected].func;
	  var args = evalArgs(action.args, action.rest);
	  return actionCreator.apply(undefined, args);
	}
	
	function evalMethod(action, obj) {
	  if (typeof action === 'string') {
	    return new Function('return ' + action).call(obj);
	  }
	
	  var args = evalArgs(action.args, action.rest);
	  return new Function('args', 'return this.' + action.name + '(args)').apply(obj, args);
	}
	/* eslint-enable */
	
	function tryCatchStringify(obj) {
	  try {
	    return JSON.stringify(obj);
	  } catch (err) {
	    /* eslint-disable no-console */
	    if (false) console.log('Failed to stringify', err);
	    /* eslint-enable no-console */
	    return _jsan2.default.stringify(obj, null, null, { circular: '[CIRCULAR]' });
	  }
	}
	
	function stringify(obj, serialize) {
	  if (typeof serialize === 'undefined') {
	    return tryCatchStringify(obj);
	  }
	  if (serialize === true) {
	    return _jsan2.default.stringify(obj, function (key, value) {
	      if (value && typeof value.toJS === 'function') return value.toJS();
	      return value;
	    }, null, true);
	  }
	  return _jsan2.default.stringify(obj, serialize.replacer, null, serialize.options);
	}
	
	function getSeralizeParameter(config, param) {
	  var serialize = config.serialize;
	  if (serialize) {
	    if (serialize === true) return { options: true };
	    if (serialize.immutable) {
	      return {
	        replacer: (0, _serialize2.default)(serialize.immutable, serialize.refs).replacer,
	        options: serialize.options || true
	      };
	    }
	    if (!serialize.replacer) return { options: serialize.options };
	    return { replacer: serialize.replacer, options: serialize.options || true };
	  }
	
	  var value = config[param];
	  if (typeof value === 'undefined') return undefined;
	  console.warn('`' + param + '` parameter for Redux DevTools Extension is deprecated. Use `serialize` parameter instead: https://github.com/zalmoxisus/redux-devtools-extension/releases/tag/v2.12.1'); // eslint-disable-line
	
	  if (typeof serializeState === 'boolean') return { options: value };
	  if (typeof serializeState === 'function') return { replacer: value };
	  return value;
	}

/***/ },
/* 1593 */
/***/ function(module, exports) {

	'use strict'
	
	/*
	 * It only for Debug Remotely mode for Android
	 * When __DEV__ === false, we can't use window.require('NativeModules')
	 */
	function getByRemoteConfig(hostname) {
	  var remoteModuleConfig = typeof window !== 'undefined' &&
	    window.__fbBatchedBridgeConfig &&
	    window.__fbBatchedBridgeConfig.remoteModuleConfig
	  if (
	    !Array.isArray(remoteModuleConfig) ||
	    hostname !== 'localhost' && hostname !== '127.0.0.1'
	  ) return hostname
	
	  var constants = (
	    remoteModuleConfig.find(getConstants) || []
	  )[1]
	  if (constants) {
	    var serverHost = constants.ServerHost || hostname
	    return serverHost.split(':')[0]
	  }
	  return hostname
	}
	
	function getConstants(config) {
	  return config && (config[0] === 'AndroidConstants' || config[0] === 'PlatformConstants')
	}
	
	/*
	 * Get React Native server IP if hostname is `localhost`
	 * On Android emulator, the IP of host is `10.0.2.2` (Genymotion: 10.0.3.2)
	 */
	module.exports = function (hostname) {
	  if (
	    typeof __fbBatchedBridge !== 'object' ||  // Not on react-native
	    hostname !== 'localhost' && hostname !== '127.0.0.1'
	  ) {
	    return hostname
	  }
	  hostname = getByRemoteConfig(hostname)
	  var originalWarn = console.warn
	  console.warn = function() {
	    if (arguments[0] && arguments[0].indexOf('Requiring module \'NativeModules\' by name') > -1) return
	    return originalWarn.apply(console, arguments)
	  }
	
	  var NativeModules
	  var PlatformConstants
	  var AndroidConstants
	  if (typeof window === 'undefined' || !window.__DEV__ || typeof window.require !== 'function') {
	    return hostname
	  }
	  NativeModules = window.require('NativeModules')
	  console.warn = originalWarn
	  if (
	    !NativeModules ||
	    (!NativeModules.PlatformConstants && !NativeModules.AndroidConstants)
	  ) {
	    return hostname
	  }
	  PlatformConstants = NativeModules.PlatformConstants
	  AndroidConstants = NativeModules.AndroidConstants
	
	  var serverHost = (PlatformConstants ?
	    PlatformConstants.ServerHost :
	    AndroidConstants.ServerHost
	  ) || hostname
	  return serverHost.split(':')[0]
	}


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	var SCEmitter = __webpack_require__(179).SCEmitter;
	
	var SCChannel = function (name, client, options) {
	  var self = this;
	
	  SCEmitter.call(this);
	
	  this.PENDING = 'pending';
	  this.SUBSCRIBED = 'subscribed';
	  this.UNSUBSCRIBED = 'unsubscribed';
	
	  this.name = name;
	  this.state = this.UNSUBSCRIBED;
	  this.client = client;
	
	  this.options = options || {};
	  this.setOptions(this.options);
	};
	
	SCChannel.prototype = Object.create(SCEmitter.prototype);
	
	SCChannel.prototype.setOptions = function (options) {
	  if (!options) {
	    options = {};
	  }
	  this.waitForAuth = options.waitForAuth || false;
	  if (options.data !== undefined) {
	    this.data = options.data;
	  }
	};
	
	SCChannel.prototype.getState = function () {
	  return this.state;
	};
	
	SCChannel.prototype.subscribe = function (options) {
	  this.client.subscribe(this.name, options);
	};
	
	SCChannel.prototype.unsubscribe = function () {
	  this.client.unsubscribe(this.name);
	};
	
	SCChannel.prototype.isSubscribed = function (includePending) {
	  return this.client.isSubscribed(this.name, includePending);
	};
	
	SCChannel.prototype.publish = function (data, callback) {
	  this.client.publish(this.name, data, callback);
	};
	
	SCChannel.prototype.watch = function (handler) {
	  this.client.watch(this.name, handler);
	};
	
	SCChannel.prototype.unwatch = function (handler) {
	  this.client.unwatch(this.name, handler);
	};
	
	SCChannel.prototype.watchers = function () {
	  return this.client.watchers(this.name);
	};
	
	SCChannel.prototype.destroy = function () {
	  this.client.destroyChannel(this.name);
	};
	
	module.exports.SCChannel = SCChannel;


/***/ },
/* 1595 */
/***/ function(module, exports) {

	module.exports.create = (function () {
	  function F() {};
	
	  return function (o) {
	    if (arguments.length != 1) {
	      throw new Error('Object.create implementation only accepts one parameter.');
	    }
	    F.prototype = o;
	    return new F();
	  }
	})();

/***/ },
/* 1596 */
/***/ function(module, exports) {

	// Based on https://github.com/dscape/cycle/blob/master/cycle.js
	
	module.exports = function decycle(object) {
	// Make a deep copy of an object or array, assuring that there is at most
	// one instance of each object or array in the resulting structure. The
	// duplicate references (which might be forming cycles) are replaced with
	// an object of the form
	//      {$ref: PATH}
	// where the PATH is a JSONPath string that locates the first occurance.
	// So,
	//      var a = [];
	//      a[0] = a;
	//      return JSON.stringify(JSON.decycle(a));
	// produces the string '[{"$ref":"$"}]'.
	
	// JSONPath is used to locate the unique object. $ indicates the top level of
	// the object or array. [NUMBER] or [STRING] indicates a child member or
	// property.
	
	    var objects = [],   // Keep a reference to each unique object or array
	        paths = [];     // Keep the path to each unique object or array
	
	    return (function derez(value, path) {
	
	// The derez recurses through the object, producing the deep copy.
	
	        var i,          // The loop counter
	            name,       // Property name
	            nu;         // The new object or array
	
	// typeof null === 'object', so go on if this value is really an object but not
	// one of the weird builtin objects.
	
	        if (typeof value === 'object' && value !== null &&
	                !(value instanceof Boolean) &&
	                !(value instanceof Date)    &&
	                !(value instanceof Number)  &&
	                !(value instanceof RegExp)  &&
	                !(value instanceof String)) {
	
	// If the value is an object or array, look to see if we have already
	// encountered it. If so, return a $ref/path object. This is a hard way,
	// linear search that will get slower as the number of unique objects grows.
	
	            for (i = 0; i < objects.length; i += 1) {
	                if (objects[i] === value) {
	                    return {$ref: paths[i]};
	                }
	            }
	
	// Otherwise, accumulate the unique value and its path.
	
	            objects.push(value);
	            paths.push(path);
	
	// If it is an array, replicate the array.
	
	            if (Object.prototype.toString.apply(value) === '[object Array]') {
	                nu = [];
	                for (i = 0; i < value.length; i += 1) {
	                    nu[i] = derez(value[i], path + '[' + i + ']');
	                }
	            } else {
	
	// If it is an object, replicate the object.
	
	                nu = {};
	                for (name in value) {
	                    if (Object.prototype.hasOwnProperty.call(value, name)) {
	                        nu[name] = derez(value[name],
	                            path + '[' + JSON.stringify(name) + ']');
	                    }
	                }
	            }
	            return nu;
	        }
	        return value;
	    }(object, '$'));
	};


/***/ },
/* 1597 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	var validJSONStartRegex = /^[ \n\r\t]*[{\[]/;
	
	var arrayBufferToBase64 = function (arraybuffer) {
	  var bytes = new Uint8Array(arraybuffer);
	  var len = bytes.length;
	  var base64 = '';
	
	  for (var i = 0; i < len; i += 3) {
	    base64 += base64Chars[bytes[i] >> 2];
	    base64 += base64Chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	    base64 += base64Chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	    base64 += base64Chars[bytes[i + 2] & 63];
	  }
	
	  if ((len % 3) === 2) {
	    base64 = base64.substring(0, base64.length - 1) + '=';
	  } else if (len % 3 === 1) {
	    base64 = base64.substring(0, base64.length - 2) + '==';
	  }
	
	  return base64;
	};
	
	var binaryToBase64Replacer = function (key, value) {
	  if (global.ArrayBuffer && value instanceof global.ArrayBuffer) {
	    return {
	      base64: true,
	      data: arrayBufferToBase64(value)
	    };
	  } else if (global.Buffer) {
	    if (value instanceof global.Buffer){
	      return {
	        base64: true,
	        data: value.toString('base64')
	      };
	    }
	    // Some versions of Node.js convert Buffers to Objects before they are passed to
	    // the replacer function - Because of this, we need to rehydrate Buffers
	    // before we can convert them to base64 strings.
	    if (value && value.type === 'Buffer' && Array.isArray(value.data)) {
	      var rehydratedBuffer;
	      if (global.Buffer.from) {
	        rehydratedBuffer = global.Buffer.from(value.data);
	      } else {
	        rehydratedBuffer = new global.Buffer(value.data);
	      }
	      return {
	        base64: true,
	        data: rehydratedBuffer.toString('base64')
	      };
	    }
	  }
	  return value;
	};
	
	// Decode the data which was transmitted over the wire to a JavaScript Object in a format which SC understands.
	// See encode function below for more details.
	module.exports.decode = function (input) {
	  if (input == null) {
	   return null;
	  }
	  // Leave ping or pong message as is
	  if (input === '#1' || input === '#2') {
	    return input;
	  }
	  var message = input.toString();
	
	  // Performance optimization to detect invalid JSON packet sooner.
	  if (!validJSONStartRegex.test(message)) {
	    return message;
	  }
	
	  try {
	    return JSON.parse(message);
	  } catch (err) {}
	  return message;
	};
	
	// Encode a raw JavaScript object (which is in the SC protocol format) into a format for
	// transfering it over the wire. In this case, we just convert it into a simple JSON string.
	// If you want to create your own custom codec, you can encode the object into any format
	// (e.g. binary ArrayBuffer or string with any kind of compression) so long as your decode
	// function is able to rehydrate that object back into its original JavaScript Object format
	// (which adheres to the SC protocol).
	// See https://github.com/SocketCluster/socketcluster/blob/master/socketcluster-protocol.md
	// for details about the SC protocol.
	module.exports.encode = function (object) {
	  // Leave ping or pong message as is
	  if (object === '#1' || object === '#2') {
	    return object;
	  }
	  return JSON.stringify(object, binaryToBase64Replacer);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	var SCSocket = __webpack_require__(759);
	var SCSocketCreator = __webpack_require__(1600);
	
	module.exports.SCSocketCreator = SCSocketCreator;
	module.exports.SCSocket = SCSocket;
	
	module.exports.SCEmitter = __webpack_require__(179).SCEmitter;
	
	module.exports.connect = function (options) {
	  return SCSocketCreator.connect(options);
	};
	
	module.exports.destroy = function (options) {
	  return SCSocketCreator.destroy(options);
	};
	
	module.exports.connections = SCSocketCreator.connections;
	
	module.exports.version = '5.5.2';


/***/ },
/* 1599 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var AuthEngine = function () {
	  this._internalStorage = {};
	};
	
	AuthEngine.prototype._isLocalStorageEnabled = function () {
	  var err;
	  try {
	    // Some browsers will throw an error here if localStorage is disabled.
	    global.localStorage;
	    
	    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
	    // throw QuotaExceededError. We're going to detect this and avoid hard to debug edge cases.
	    global.localStorage.setItem('__scLocalStorageTest', 1);
	    global.localStorage.removeItem('__scLocalStorageTest');
	  } catch (e) {
	    err = e;
	  }
	  return !err;
	};
	
	AuthEngine.prototype.saveToken = function (name, token, options, callback) {
	  if (this._isLocalStorageEnabled() && global.localStorage) {
	    global.localStorage.setItem(name, token);
	  } else {
	    this._internalStorage[name] = token;
	  }
	  callback && callback(null, token);
	};
	
	AuthEngine.prototype.removeToken = function (name, callback) {
	  var token;
	
	  this.loadToken(name, function (err, authToken) {
	    token = authToken;
	  });
	
	  if (this._isLocalStorageEnabled() && global.localStorage) {
	    global.localStorage.removeItem(name);
	  }
	  delete this._internalStorage[name];
	
	  callback && callback(null, token);
	};
	
	AuthEngine.prototype.loadToken = function (name, callback) {
	  var token;
	
	  if (this._isLocalStorageEnabled() && global.localStorage) {
	    token = global.localStorage.getItem(name);
	  } else {
	    token = this._internalStorage[name] || null;
	  }
	  callback(null, token);
	};
	
	module.exports.AuthEngine = AuthEngine;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SCSocket = __webpack_require__(759);
	var scErrors = __webpack_require__(180);
	var InvalidArgumentsError = scErrors.InvalidArgumentsError;
	
	var _connections = {};
	
	function getMultiplexId(options) {
	  var protocolPrefix = options.secure ? 'https://' : 'http://';
	  var queryString = '';
	  if (options.query) {
	    if (typeof options.query == 'string') {
	      queryString = options.query;
	    } else {
	      var queryArray = [];
	      var queryMap = options.query;
	      for (var key in queryMap) {
	        if (queryMap.hasOwnProperty(key)) {
	          queryArray.push(key + '=' + queryMap[key]);
	        }
	      }
	      if (queryArray.length) {
	        queryString = '?' + queryArray.join('&');
	      }
	    }
	  }
	  var host;
	  if (options.host) {
	    host = options.host;
	  } else {
	    host = options.hostname + ':' + options.port;
	  }
	  return protocolPrefix + host + options.path + queryString;
	}
	
	function isUrlSecure() {
	  return global.location && location.protocol == 'https:';
	}
	
	function getPort(options, isSecureDefault) {
	  var isSecure = options.secure == null ? isSecureDefault : options.secure;
	  return options.port || (global.location && location.port ? location.port : isSecure ? 443 : 80);
	}
	
	function connect(options) {
	  var self = this;
	
	  options = options || {};
	
	  if (options.host && options.port) {
	    throw new InvalidArgumentsError('The host option should already include the' +
	      ' port number in the format hostname:port - Because of this, the host and port options' +
	      ' cannot be specified together; use the hostname option instead');
	  }
	
	  var isSecureDefault = isUrlSecure();
	
	  var opts = {
	    port: getPort(options, isSecureDefault),
	    hostname: global.location && location.hostname,
	    path: '/socketcluster/',
	    secure: isSecureDefault,
	    autoConnect: true,
	    autoReconnect: true,
	    autoProcessSubscriptions: true,
	    connectTimeout: 20000,
	    ackTimeout: 10000,
	    timestampRequests: false,
	    timestampParam: 't',
	    authEngine: null,
	    authTokenName: 'socketCluster.authToken',
	    binaryType: 'arraybuffer',
	    multiplex: true,
	    cloneData: false
	  };
	  for (var i in options) {
	    if (options.hasOwnProperty(i)) {
	      opts[i] = options[i];
	    }
	  }
	  var multiplexId = getMultiplexId(opts);
	  if (opts.multiplex === false) {
	    return new SCSocket(opts);
	  }
	  if (_connections[multiplexId]) {
	    _connections[multiplexId].connect();
	  } else {
	    _connections[multiplexId] = new SCSocket(opts);
	  }
	  return _connections[multiplexId];
	}
	
	function destroy(options) {
	  var self = this;
	
	  options = options || {};
	  var isSecureDefault = isUrlSecure();
	
	  var opts = {
	    port: getPort(options, isSecureDefault),
	    hostname: global.location && location.hostname,
	    path: '/socketcluster/',
	    secure: isSecureDefault
	  };
	  for (var i in options) {
	    if (options.hasOwnProperty(i)) {
	      opts[i] = options[i];
	    }
	  }
	  var multiplexId = getMultiplexId(opts);
	  var socket = _connections[multiplexId];
	  if (socket) {
	    socket.disconnect();
	  }
	  delete _connections[multiplexId];
	}
	
	module.exports = {
	  connect: connect,
	  destroy: destroy,
	  connections: _connections
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SCEmitter = __webpack_require__(179).SCEmitter;
	var Response = __webpack_require__(758).Response;
	var querystring = __webpack_require__(757);
	var WebSocket;
	var createWebSocket;
	
	if (global.WebSocket) {
	  WebSocket = global.WebSocket;
	  createWebSocket = function (uri, options) {
	    return new WebSocket(uri);
	  };
	} else {
	  WebSocket = __webpack_require__(1602);
	  createWebSocket = function (uri, options) {
	    return new WebSocket(uri, null, options);
	  };
	}
	
	var scErrors = __webpack_require__(180);
	var TimeoutError = scErrors.TimeoutError;
	
	
	var SCTransport = function (authEngine, codecEngine, options) {
	  this.state = this.CLOSED;
	  this.auth = authEngine;
	  this.codec = codecEngine;
	  this.options = options;
	  this.connectTimeout = options.connectTimeout;
	  this.pingTimeout = options.ackTimeout;
	  this.callIdGenerator = options.callIdGenerator;
	
	  this._pingTimeoutTicker = null;
	  this._callbackMap = {};
	
	  this.open();
	};
	
	SCTransport.prototype = Object.create(SCEmitter.prototype);
	
	SCTransport.CONNECTING = SCTransport.prototype.CONNECTING = 'connecting';
	SCTransport.OPEN = SCTransport.prototype.OPEN = 'open';
	SCTransport.CLOSED = SCTransport.prototype.CLOSED = 'closed';
	
	SCTransport.prototype.uri = function () {
	  var query = this.options.query || {};
	  var schema = this.options.secure ? 'wss' : 'ws';
	
	  if (this.options.timestampRequests) {
	    query[this.options.timestampParam] = (new Date()).getTime();
	  }
	
	  query = querystring.encode(query);
	
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var host;
	  if (this.options.host) {
	    host = this.options.host;
	  } else {
	    var port = '';
	
	    if (this.options.port && ((schema == 'wss' && this.options.port != 443)
	      || (schema == 'ws' && this.options.port != 80))) {
	      port = ':' + this.options.port;
	    }
	    host = this.options.hostname + port;
	  }
	
	  return schema + '://' + host + this.options.path + query;
	};
	
	SCTransport.prototype.open = function () {
	  var self = this;
	
	  this.state = this.CONNECTING;
	  var uri = this.uri();
	
	  var wsSocket = createWebSocket(uri, this.options);
	  wsSocket.binaryType = this.options.binaryType;
	  this.socket = wsSocket;
	
	  wsSocket.onopen = function () {
	    self._onOpen();
	  };
	
	  wsSocket.onclose = function (event) {
	    var code;
	    if (event.code == null) {
	      // This is to handle an edge case in React Native whereby
	      // event.code is undefined when the mobile device is locked.
	      // TODO: This is not perfect since this condition could also apply to
	      // an abnormal close (no close control frame) which would be a 1006.
	      code = 1005;
	    } else {
	      code = event.code;
	    }
	    self._onClose(code, event.reason);
	  };
	
	  wsSocket.onmessage = function (message, flags) {
	    self._onMessage(message.data);
	  };
	
	  wsSocket.onerror = function (error) {
	    // The onclose event will be called automatically after the onerror event
	    // if the socket is connected - Otherwise, if it's in the middle of
	    // connecting, we want to close it manually with a 1006 - This is necessary
	    // to prevent inconsistent behavior when running the client in Node.js
	    // vs in a browser.
	
	    if (self.state === self.CONNECTING) {
	      self._onClose(1006);
	    }
	  };
	
	  this._connectTimeoutRef = setTimeout(function () {
	    self._onClose(4007);
	    self.socket.close(4007);
	  }, this.connectTimeout);
	};
	
	SCTransport.prototype._onOpen = function () {
	  var self = this;
	
	  clearTimeout(this._connectTimeoutRef);
	  this._resetPingTimeout();
	
	  this._handshake(function (err, status) {
	    if (err) {
	      self._onError(err);
	      self._onClose(4003);
	      self.socket.close(4003);
	    } else {
	      self.state = self.OPEN;
	      SCEmitter.prototype.emit.call(self, 'open', status);
	      self._resetPingTimeout();
	    }
	  });
	};
	
	SCTransport.prototype._handshake = function (callback) {
	  var self = this;
	  this.auth.loadToken(this.options.authTokenName, function (err, token) {
	    if (err) {
	      callback(err);
	    } else {
	      // Don't wait for this.state to be 'open'.
	      // The underlying WebSocket (this.socket) is already open.
	      var options = {
	        force: true
	      };
	      self.emit('#handshake', {
	        authToken: token
	      }, options, function (err, status) {
	        if (status) {
	          // Add the token which was used as part of authentication attempt
	          // to the status object.
	          status.authToken = token;
	          if (status.authError) {
	            status.authError = scErrors.hydrateError(status.authError);
	          }
	        }
	        callback(err, status);
	      });
	    }
	  });
	};
	
	SCTransport.prototype._onClose = function (code, data) {
	  delete this.socket.onopen;
	  delete this.socket.onclose;
	  delete this.socket.onmessage;
	  delete this.socket.onerror;
	
	  clearTimeout(this._connectTimeoutRef);
	
	  if (this.state == this.OPEN) {
	    this.state = this.CLOSED;
	    SCEmitter.prototype.emit.call(this, 'close', code, data);
	
	  } else if (this.state == this.CONNECTING) {
	    this.state = this.CLOSED;
	    SCEmitter.prototype.emit.call(this, 'openAbort', code, data);
	  }
	};
	
	SCTransport.prototype._onMessage = function (message) {
	  SCEmitter.prototype.emit.call(this, 'event', 'message', message);
	
	  var obj = this.decode(message);
	
	  // If ping
	  if (obj == '#1') {
	    this._resetPingTimeout();
	    if (this.socket.readyState == this.socket.OPEN) {
	      this.sendObject('#2');
	    }
	  } else {
	    var event = obj.event;
	
	    if (event) {
	      var response = new Response(this, obj.cid);
	      SCEmitter.prototype.emit.call(this, 'event', event, obj.data, response);
	    } else if (obj.rid != null) {
	
	      var eventObject = this._callbackMap[obj.rid];
	      if (eventObject) {
	        clearTimeout(eventObject.timeout);
	        delete this._callbackMap[obj.rid];
	
	        if (eventObject.callback) {
	          var rehydratedError = scErrors.hydrateError(obj.error);
	          eventObject.callback(rehydratedError, obj.data);
	        }
	      }
	    } else {
	      SCEmitter.prototype.emit.call(this, 'event', 'raw', obj);
	    }
	  }
	};
	
	SCTransport.prototype._onError = function (err) {
	  SCEmitter.prototype.emit.call(this, 'error', err);
	};
	
	SCTransport.prototype._resetPingTimeout = function () {
	  var self = this;
	
	  var now = (new Date()).getTime();
	  clearTimeout(this._pingTimeoutTicker);
	
	  this._pingTimeoutTicker = setTimeout(function () {
	    self._onClose(4000);
	    self.socket.close(4000);
	  }, this.pingTimeout);
	};
	
	SCTransport.prototype.getBytesReceived = function () {
	  return this.socket.bytesReceived;
	};
	
	SCTransport.prototype.close = function (code, data) {
	  code = code || 1000;
	
	  if (this.state == this.OPEN) {
	    var packet = {
	      code: code,
	      data: data
	    };
	    this.emit('#disconnect', packet);
	
	    this._onClose(code, data);
	    this.socket.close(code);
	
	  } else if (this.state == this.CONNECTING) {
	    this._onClose(code, data);
	    this.socket.close(code);
	  }
	};
	
	SCTransport.prototype.emitObject = function (eventObject) {
	  var simpleEventObject = {
	    event: eventObject.event,
	    data: eventObject.data
	  };
	
	  if (eventObject.callback) {
	    simpleEventObject.cid = eventObject.cid = this.callIdGenerator();
	    this._callbackMap[eventObject.cid] = eventObject;
	  }
	
	  this.sendObject(simpleEventObject);
	  return eventObject.cid || null;
	};
	
	SCTransport.prototype._handleEventAckTimeout = function (eventObject) {
	  var errorMessage = "Event response for '" + eventObject.event + "' timed out";
	  var error = new TimeoutError(errorMessage);
	
	  if (eventObject.cid) {
	    delete this._callbackMap[eventObject.cid];
	  }
	  var callback = eventObject.callback;
	  delete eventObject.callback;
	  callback.call(eventObject, error, eventObject);
	};
	
	// The last two optional arguments (a and b) can be options and/or callback
	SCTransport.prototype.emit = function (event, data, a, b) {
	  var self = this;
	
	  var callback, options;
	
	  if (b) {
	    options = a;
	    callback = b;
	  } else {
	    if (a instanceof Function) {
	      options = {};
	      callback = a;
	    } else {
	      options = a;
	    }
	  }
	
	  var eventObject = {
	    event: event,
	    data: data,
	    callback: callback
	  };
	
	  if (callback && !options.noTimeout) {
	    eventObject.timeout = setTimeout(function () {
	      self._handleEventAckTimeout(eventObject);
	    }, this.options.ackTimeout);
	  }
	
	  var cid = null;
	  if (this.state == this.OPEN || options.force) {
	    cid = this.emitObject(eventObject);
	  }
	  return cid;
	};
	
	SCTransport.prototype.cancelPendingResponse = function (cid) {
	  delete this._callbackMap[cid];
	};
	
	SCTransport.prototype.decode = function (message) {
	  return this.codec.decode(message);
	};
	
	SCTransport.prototype.encode = function (object) {
	  return this.codec.encode(object);
	};
	
	SCTransport.prototype.send = function (data) {
	  if (this.socket.readyState != this.socket.OPEN) {
	    this._onClose(1005);
	  } else {
	    this.socket.send(data);
	  }
	};
	
	SCTransport.prototype.serializeObject = function (object) {
	  var str, formatError;
	  try {
	    str = this.encode(object);
	  } catch (err) {
	    formatError = err;
	    this._onError(formatError);
	  }
	  if (!formatError) {
	    return str;
	  }
	  return null;
	};
	
	SCTransport.prototype.sendObject = function (object) {
	  var str = this.serializeObject(object);
	  if (str != null) {
	    this.send(str);
	  }
	};
	
	module.exports.SCTransport = SCTransport;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1602 */
/***/ function(module, exports) {

	var global;
	if (typeof WorkerGlobalScope !== 'undefined') {
	  global = self;
	} else {
	  global = typeof window != 'undefined' && window || (function() { return this; })();
	}
	
	var WebSocket = global.WebSocket || global.MozWebSocket;
	
	/**
	 * WebSocket constructor.
	 *
	 * The third `opts` options object gets ignored in web browsers, since it's
	 * non-standard, and throws a TypeError if passed to the constructor.
	 * See: https://github.com/einaros/ws/issues/227
	 *
	 * @param {String} uri
	 * @param {Array} protocols (optional)
	 * @param {Object} opts (optional)
	 * @api public
	 */
	
	function ws(uri, protocols, opts) {
	  var instance;
	  if (protocols) {
	    instance = new WebSocket(uri, protocols);
	  } else {
	    instance = new WebSocket(uri);
	  }
	  return instance;
	}
	
	if (WebSocket) ws.prototype = WebSocket.prototype;
	
	module.exports = WebSocket ? ws : null;


/***/ },
/* 1603 */
[1645, 1604],
/* 1604 */
1572,
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(117)))

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(1609);


/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var encode = __webpack_require__(760);
	var alphabet = __webpack_require__(181);
	
	// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
	// This number should be updated every year or so to keep the generated id short.
	// To regenerate `new Date() - 0` and bump the version. Always bump the version!
	var REDUCE_TIME = 1459707606518;
	
	// don't change unless we change the algos or REDUCE_TIME
	// must be an integer and less than 16
	var version = 6;
	
	// Counter is used when shortid is called multiple times in one second.
	var counter;
	
	// Remember the last time shortid was called in case counter is needed.
	var previousSeconds;
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function build(clusterWorkerId) {
	
	    var str = '';
	
	    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);
	
	    if (seconds === previousSeconds) {
	        counter++;
	    } else {
	        counter = 0;
	        previousSeconds = seconds;
	    }
	
	    str = str + encode(alphabet.lookup, version);
	    str = str + encode(alphabet.lookup, clusterWorkerId);
	    if (counter > 0) {
	        str = str + encode(alphabet.lookup, counter);
	    }
	    str = str + encode(alphabet.lookup, seconds);
	
	    return str;
	}
	
	module.exports = build;


/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(181);
	
	/**
	 * Decode the id to get the version and worker
	 * Mainly for debugging and testing.
	 * @param id - the shortid-generated id.
	 */
	function decode(id) {
	    var characters = alphabet.shuffled();
	    return {
	        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
	        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
	    };
	}
	
	module.exports = decode;


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(181);
	var encode = __webpack_require__(760);
	var decode = __webpack_require__(1608);
	var build = __webpack_require__(1607);
	var isValid = __webpack_require__(1610);
	
	// if you are using cluster or multiple servers use this to make each instance
	// has a unique value for worker
	// Note: I don't know if this is automatically set when using third
	// party cluster solutions such as pm2.
	var clusterWorkerId = __webpack_require__(1613) || 0;
	
	/**
	 * Set the seed.
	 * Highly recommended if you don't want people to try to figure out your id schema.
	 * exposed as shortid.seed(int)
	 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
	 */
	function seed(seedValue) {
	    alphabet.seed(seedValue);
	    return module.exports;
	}
	
	/**
	 * Set the cluster worker or machine id
	 * exposed as shortid.worker(int)
	 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
	 * returns shortid module so it can be chained.
	 */
	function worker(workerId) {
	    clusterWorkerId = workerId;
	    return module.exports;
	}
	
	/**
	 *
	 * sets new characters to use in the alphabet
	 * returns the shuffled alphabet
	 */
	function characters(newCharacters) {
	    if (newCharacters !== undefined) {
	        alphabet.characters(newCharacters);
	    }
	
	    return alphabet.shuffled();
	}
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function generate() {
	  return build(clusterWorkerId);
	}
	
	// Export all other functions as properties of the generate function
	module.exports = generate;
	module.exports.generate = generate;
	module.exports.seed = seed;
	module.exports.worker = worker;
	module.exports.characters = characters;
	module.exports.decode = decode;
	module.exports.isValid = isValid;


/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(181);
	
	function isShortId(id) {
	    if (!id || typeof id !== 'string' || id.length < 6 ) {
	        return false;
	    }
	
	    var characters = alphabet.characters();
	    var len = id.length;
	    for(var i = 0; i < len;i++) {
	        if (characters.indexOf(id[i]) === -1) {
	            return false;
	        }
	    }
	    return true;
	}
	
	module.exports = isShortId;


/***/ },
/* 1611 */
/***/ function(module, exports) {

	'use strict';
	
	var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
	
	function randomByte() {
	    if (!crypto || !crypto.getRandomValues) {
	        return Math.floor(Math.random() * 256) & 0x30;
	    }
	    var dest = new Uint8Array(1);
	    crypto.getRandomValues(dest);
	    return dest[0] & 0x30;
	}
	
	module.exports = randomByte;


/***/ },
/* 1612 */
/***/ function(module, exports) {

	'use strict';
	
	// Found this seed-based random generator somewhere
	// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
	
	var seed = 1;
	
	/**
	 * return a random number based on a seed
	 * @param seed
	 * @returns {number}
	 */
	function getNextValue() {
	    seed = (seed * 9301 + 49297) % 233280;
	    return seed/(233280.0);
	}
	
	function setSeed(_seed_) {
	    seed = _seed_;
	}
	
	module.exports = {
	    nextValue: getNextValue,
	    seed: setSeed
	};


/***/ },
/* 1613 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 0;


/***/ },
/* 1614 */
/***/ function(module, exports) {

	/*
	The MIT License (MIT)
	
	Copyright (c) 2016 Gene Diaz
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = ["،","آض","آمينَ","آه","آهاً","آي","أ","أب","أجل","أجمع","أخ","أخذ","أصبح","أضحى","أقبل","أقل","أكثر","ألا","أم","أما","أمامك","أمامكَ","أمسى","أمّا","أن","أنا","أنت","أنتم","أنتما","أنتن","أنتِ","أنشأ","أنّى","أو","أوشك","أولئك","أولئكم","أولاء","أولالك","أوّهْ","أي","أيا","أين","أينما","أيّ","أَنَّ","أََيُّ","أُفٍّ","إذ","إذا","إذاً","إذما","إذن","إلى","إليكم","إليكما","إليكنّ","إليكَ","إلَيْكَ","إلّا","إمّا","إن","إنّما","إي","إياك","إياكم","إياكما","إياكن","إيانا","إياه","إياها","إياهم","إياهما","إياهن","إياي","إيهٍ","إِنَّ","ا","ابتدأ","اثر","اجل","احد","اخرى","اخلولق","اذا","اربعة","ارتدّ","استحال","اطار","اعادة","اعلنت","اف","اكثر","اكد","الألاء","الألى","الا","الاخيرة","الان","الاول","الاولى","التى","التي","الثاني","الثانية","الذاتي","الذى","الذي","الذين","السابق","الف","اللائي","اللاتي","اللتان","اللتيا","اللتين","اللذان","اللذين","اللواتي","الماضي","المقبل","الوقت","الى","اليوم","اما","امام","امس","ان","انبرى","انقلب","انه","انها","او","اول","اي","ايار","ايام","ايضا","ب","بات","باسم","بان","بخٍ","برس","بسبب","بسّ","بشكل","بضع","بطآن","بعد","بعض","بك","بكم","بكما","بكن","بل","بلى","بما","بماذا","بمن","بن","بنا","به","بها","بي","بيد","بين","بَسْ","بَلْهَ","بِئْسَ","تانِ","تانِك","تبدّل","تجاه","تحوّل","تلقاء","تلك","تلكم","تلكما","تم","تينك","تَيْنِ","تِه","تِي","ثلاثة","ثم","ثمّ","ثمّة","ثُمَّ","جعل","جلل","جميع","جير","حار","حاشا","حاليا","حاي","حتى","حرى","حسب","حم","حوالى","حول","حيث","حيثما","حين","حيَّ","حَبَّذَا","حَتَّى","حَذارِ","خلا","خلال","دون","دونك","ذا","ذات","ذاك","ذانك","ذانِ","ذلك","ذلكم","ذلكما","ذلكن","ذو","ذوا","ذواتا","ذواتي","ذيت","ذينك","ذَيْنِ","ذِه","ذِي","راح","رجع","رويدك","ريث","رُبَّ","زيارة","سبحان","سرعان","سنة","سنوات","سوف","سوى","سَاءَ","سَاءَمَا","شبه","شخصا","شرع","شَتَّانَ","صار","صباح","صفر","صهٍ","صهْ","ضد","ضمن","طاق","طالما","طفق","طَق","ظلّ","عاد","عام","عاما","عامة","عدا","عدة","عدد","عدم","عسى","عشر","عشرة","علق","على","عليك","عليه","عليها","علًّ","عن","عند","عندما","عوض","عين","عَدَسْ","عَمَّا","غدا","غير","ـ","ف","فان","فلان","فو","فى","في","فيم","فيما","فيه","فيها","قال","قام","قبل","قد","قطّ","قلما","قوة","كأنّما","كأين","كأيّ","كأيّن","كاد","كان","كانت","كذا","كذلك","كرب","كل","كلا","كلاهما","كلتا","كلم","كليكما","كليهما","كلّما","كلَّا","كم","كما","كي","كيت","كيف","كيفما","كَأَنَّ","كِخ","لئن","لا","لات","لاسيما","لدن","لدى","لعمر","لقاء","لك","لكم","لكما","لكن","لكنَّما","لكي","لكيلا","للامم","لم","لما","لمّا","لن","لنا","له","لها","لو","لوكالة","لولا","لوما","لي","لَسْتَ","لَسْتُ","لَسْتُم","لَسْتُمَا","لَسْتُنَّ","لَسْتِ","لَسْنَ","لَعَلَّ","لَكِنَّ","لَيْتَ","لَيْسَ","لَيْسَا","لَيْسَتَا","لَيْسَتْ","لَيْسُوا","لَِسْنَا","ما","ماانفك","مابرح","مادام","ماذا","مازال","مافتئ","مايو","متى","مثل","مذ","مساء","مع","معاذ","مقابل","مكانكم","مكانكما","مكانكنّ","مكانَك","مليار","مليون","مما","ممن","من","منذ","منها","مه","مهما","مَنْ","مِن","نحن","نحو","نعم","نفس","نفسه","نهاية","نَخْ","نِعِمّا","نِعْمَ","ها","هاؤم","هاكَ","هاهنا","هبّ","هذا","هذه","هكذا","هل","هلمَّ","هلّا","هم","هما","هن","هنا","هناك","هنالك","هو","هي","هيا","هيت","هيّا","هَؤلاء","هَاتانِ","هَاتَيْنِ","هَاتِه","هَاتِي","هَجْ","هَذا","هَذانِ","هَذَيْنِ","هَذِه","هَذِي","هَيْهَاتَ","و","و6","وا","واحد","واضاف","واضافت","واكد","وان","واهاً","واوضح","وراءَك","وفي","وقال","وقالت","وقد","وقف","وكان","وكانت","ولا","ولم","ومن","وهو","وهي","ويكأنّ","وَيْ","وُشْكَانََ","يكون","يمكن","يوم","ّأيّان"]
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1615 */
/***/ function(module, exports) {

	/*
	The MIT License (MIT)
	
	Copyright (c) 2016 Gene Diaz
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = ["অতএব","অথচ","অথবা","অনুযায়ী","অনেক","অনেকে","অনেকেই","অন্তত","অন্য","অবধি","অবশ্য","অর্থাত","আই","আগামী","আগে","আগেই","আছে","আজ","আদ্যভাগে","আপনার","আপনি","আবার","আমরা","আমাকে","আমাদের","আমার","আমি","আর","আরও","ই","ইত্যাদি","ইহা","উচিত","উত্তর","উনি","উপর","উপরে","এ","এঁদের","এঁরা","এই","একই","একটি","একবার","একে","এক্","এখন","এখনও","এখানে","এখানেই","এটা","এটাই","এটি","এত","এতটাই","এতে","এদের","এব","এবং","এবার","এমন","এমনকী","এমনি","এর","এরা","এল","এস","এসে","ঐ","ও","ওঁদের","ওঁর","ওঁরা","ওই","ওকে","ওখানে","ওদের","ওর","ওরা","কখনও","কত","কবে","কমনে","কয়েক","কয়েকটি","করছে","করছেন","করতে","করবে","করবেন","করলে","করলেন","করা","করাই","করায়","করার","করি","করিতে","করিয়া","করিয়ে","করে","করেই","করেছিলেন","করেছে","করেছেন","করেন","কাউকে","কাছ","কাছে","কাজ","কাজে","কারও","কারণ","কি","কিংবা","কিছু","কিছুই","কিন্তু","কী","কে","কেউ","কেউই","কেখা","কেন","কোটি","কোন","কোনও","কোনো","ক্ষেত্রে","কয়েক","খুব","গিয়ে","গিয়েছে","গিয়ে","গুলি","গেছে","গেল","গেলে","গোটা","চলে","চান","চায়","চার","চালু","চেয়ে","চেষ্টা","ছাড়া","ছাড়াও","ছিল","ছিলেন","জন","জনকে","জনের","জন্য","জন্যওজে","জানতে","জানা","জানানো","জানায়","জানিয়ে","জানিয়েছে","জে","জ্নজন","টি","ঠিক","তখন","তত","তথা","তবু","তবে","তা","তাঁকে","তাঁদের","তাঁর","তাঁরা","তাঁাহারা","তাই","তাও","তাকে","তাতে","তাদের","তার","তারপর","তারা","তারৈ","তাহলে","তাহা","তাহাতে","তাহার","তিনঐ","তিনি","তিনিও","তুমি","তুলে","তেমন","তো","তোমার","থাকবে","থাকবেন","থাকা","থাকায়","থাকে","থাকেন","থেকে","থেকেই","থেকেও","দিকে","দিতে","দিন","দিয়ে","দিয়েছে","দিয়েছেন","দিলেন","দু","দুই","দুটি","দুটো","দেওয়া","দেওয়ার","দেওয়া","দেখতে","দেখা","দেখে","দেন","দেয়","দ্বারা","ধরা","ধরে","ধামার","নতুন","নয়","না","নাই","নাকি","নাগাদ","নানা","নিজে","নিজেই","নিজেদের","নিজের","নিতে","নিয়ে","নিয়ে","নেই","নেওয়া","নেওয়ার","নেওয়া","নয়","পক্ষে","পর","পরে","পরেই","পরেও","পর্যন্ত","পাওয়া","পাচ","পারি","পারে","পারেন","পি","পেয়ে","পেয়্র্","প্রতি","প্রথম","প্রভৃতি","প্রযন্ত","প্রাথমিক","প্রায়","প্রায়","ফলে","ফিরে","ফের","বক্তব্য","বদলে","বন","বরং","বলতে","বলল","বললেন","বলা","বলে","বলেছেন","বলেন","বসে","বহু","বা","বাদে","বার","বি","বিনা","বিভিন্ন","বিশেষ","বিষয়টি","বেশ","বেশি","ব্যবহার","ব্যাপারে","ভাবে","ভাবেই","মতো","মতোই","মধ্যভাগে","মধ্যে","মধ্যেই","মধ্যেও","মনে","মাত্র","মাধ্যমে","মোট","মোটেই","যখন","যত","যতটা","যথেষ্ট","যদি","যদিও","যা","যাঁর","যাঁরা","যাওয়া","যাওয়ার","যাওয়া","যাকে","যাচ্ছে","যাতে","যাদের","যান","যাবে","যায়","যার","যারা","যিনি","যে","যেখানে","যেতে","যেন","যেমন","র","রকম","রয়েছে","রাখা","রেখে","লক্ষ","শুধু","শুরু","সঙ্গে","সঙ্গেও","সব","সবার","সমস্ত","সম্প্রতি","সহ","সহিত","সাধারণ","সামনে","সি","সুতরাং","সে","সেই","সেখান","সেখানে","সেটা","সেটাই","সেটাও","সেটি","স্পষ্ট","স্বয়ং","হইতে","হইবে","হইয়া","হওয়া","হওয়ায়","হওয়ার","হচ্ছে","হত","হতে","হতেই","হন","হবে","হবেন","হয়","হয়তো","হয়নি","হয়ে","হয়েই","হয়েছিল","হয়েছে","হয়েছেন","হল","হলে","হলেই","হলেও","হলো","হাজার","হিসাবে","হৈলে","হোক","হয়"]
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1616 */
/***/ function(module, exports) {

	/*
	Creative Commons – Attribution / ShareAlike 3.0 license
	http://creativecommons.org/licenses/by-sa/3.0/
	
	List based on frequently used words in subtitles in 2012.
	
	Thanks to
	opensubtitles.org
	https://invokeit.wordpress.com/frequency-word-lists/#comment-9707
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'er', 'jeg', 'det', 'du', 'ikke', 'i', 'at', 'en', 'og', 'har',
	  'vi', 'til', 'på', 'hvad', 'med', 'mig', 'så', 'for', 'de', 'dig',
	  'der', 'den', 'han', 'kan', 'af', 'vil', 'var', 'her', 'et', 'skal',
	  'ved', 'nu', 'men', 'om', 'ja', 'som', 'nej', 'min', 'noget', 'ham',
	  'hun', 'bare', 'kom', 'være', 'din', 'hvor', 'dem', 'ud', 'os', 'hvis',
	  'må', 'se', 'godt', 'have', 'fra', 'ville', 'okay', 'lige', 'op', 'alle',
	  'lad', 'hvorfor', 'sig', 'hvordan', 'få', 'kunne', 'eller', 'hvem', 'man', 'bliver',
	  'havde', 'da', 'ingen', 'efter', 'når', 'alt', 'jo', 'to', 'mit', 'ind',
	  'hej', 'aldrig', 'lidt', 'nogen', 'over', 'også', 'mand', 'far', 'skulle', 'selv',
	  'får', 'hans', 'ser', 'vores', 'jer', 'sådan', 'dit', 'kun', 'deres', 'ned',
	  'mine', 'komme', 'tage', 'denne', 'sige', 'dette', 'blive', 'helt', 'fordi',
	  'end', 'tag', 'før', 'fik', 'dine',
	  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1617 */
/***/ function(module, exports) {

	/*
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'a', 'ab', 'aber', 'ach', 'acht', 'achte', 'achten', 'achter', 'achtes', 'ag', 'alle', 'allein', 'allem', 'allen', 'aller', 'allerdings', 'alles', 'allgemeinen', 'als', 'also', 'am', 'an', 'ander', 'andere', 'anderem', 'anderen', 'anderer', 'anderes', 'anderm', 'andern', 'anderr', 'anders', 'au', 'auch', 'auf', 'aus', 'ausser', 'ausserdem', 'außer', 'außerdem', 'b', 'bald', 'bei', 'beide', 'beiden', 'beim', 'beispiel', 'bekannt', 'bereits', 'besonders', 'besser', 'besten', 'bin', 'bis', 'bisher', 'bist', 'c', 'd', 'd.h', 'da', 'dabei', 'dadurch', 'dafür', 'dagegen', 'daher', 'dahin', 'dahinter', 'damals', 'damit', 'danach', 'daneben', 'dank', 'dann', 'daran', 'darauf', 'daraus', 'darf', 'darfst', 'darin', 'darum', 'darunter', 'darüber', 'das', 'dasein', 'daselbst', 'dass', 'dasselbe', 'davon', 'davor', 'dazu', 'dazwischen', 'daß', 'dein', 'deine', 'deinem', 'deinen', 'deiner', 'deines', 'dem', 'dementsprechend', 'demgegenüber', 'demgemäss', 'demgemäß', 'demselben', 'demzufolge', 'den', 'denen', 'denn', 'denselben', 'der', 'deren', 'derer', 'derjenige', 'derjenigen', 'dermassen', 'dermaßen', 'derselbe', 'derselben', 'des', 'deshalb', 'desselben', 'dessen', 'deswegen', 'dich', 'die', 'diejenige', 'diejenigen', 'dies', 'diese', 'dieselbe', 'dieselben', 'diesem', 'diesen', 'dieser', 'dieses', 'dir', 'doch', 'dort', 'drei', 'drin', 'dritte', 'dritten', 'dritter', 'drittes', 'du', 'durch', 'durchaus', 'durfte', 'durften', 'dürfen', 'dürft', 'e', 'eben', 'ebenso', 'ehrlich', 'ei', 'ei, ', 'eigen', 'eigene', 'eigenen', 'eigener', 'eigenes', 'ein', 'einander', 'eine', 'einem', 'einen', 'einer', 'eines', 'einig', 'einige', 'einigem', 'einigen', 'einiger', 'einiges', 'einmal', 'eins', 'elf', 'en', 'ende', 'endlich', 'entweder', 'er', 'ernst', 'erst', 'erste', 'ersten', 'erster', 'erstes', 'es', 'etwa', 'etwas', 'euch', 'euer', 'eure', 'eurem', 'euren', 'eurer', 'eures', 'f', 'folgende', 'früher', 'fünf', 'fünfte', 'fünften', 'fünfter', 'fünftes', 'für', 'g', 'gab', 'ganz', 'ganze', 'ganzen', 'ganzer', 'ganzes', 'gar', 'gedurft', 'gegen', 'gegenüber', 'gehabt', 'gehen', 'geht', 'gekannt', 'gekonnt', 'gemacht', 'gemocht', 'gemusst', 'genug', 'gerade', 'gern', 'gesagt', 'geschweige', 'gewesen', 'gewollt', 'geworden', 'gibt', 'ging', 'gleich', 'gott', 'gross', 'grosse', 'grossen', 'grosser', 'grosses', 'groß', 'große', 'großen', 'großer', 'großes', 'gut', 'gute', 'guter', 'gutes', 'h', 'hab', 'habe', 'haben', 'habt', 'hast', 'hat', 'hatte', 'hatten', 'hattest', 'hattet', 'heisst', 'her', 'heute', 'hier', 'hin', 'hinter', 'hoch', 'hätte', 'hätten', 'i', 'ich', 'ihm', 'ihn', 'ihnen', 'ihr', 'ihre', 'ihrem', 'ihren', 'ihrer', 'ihres', 'im', 'immer', 'in', 'indem', 'infolgedessen', 'ins', 'irgend', 'ist', 'j', 'ja', 'jahr', 'jahre', 'jahren', 'je', 'jede', 'jedem', 'jeden', 'jeder', 'jedermann', 'jedermanns', 'jedes', 'jedoch', 'jemand', 'jemandem', 'jemanden', 'jene', 'jenem', 'jenen', 'jener', 'jenes', 'jetzt', 'k', 'kam', 'kann', 'kannst', 'kaum', 'kein', 'keine', 'keinem', 'keinen', 'keiner', 'keines', 'kleine', 'kleinen', 'kleiner', 'kleines', 'kommen', 'kommt', 'konnte', 'konnten', 'kurz', 'können', 'könnt', 'könnte', 'l', 'lang', 'lange', 'leicht', 'leide', 'lieber', 'los', 'm', 'machen', 'macht', 'machte', 'mag', 'magst', 'mahn', 'mal', 'man', 'manche', 'manchem', 'manchen', 'mancher', 'manches', 'mann', 'mehr', 'mein', 'meine', 'meinem', 'meinen', 'meiner', 'meines', 'mensch', 'menschen', 'mich', 'mir', 'mit', 'mittel', 'mochte', 'mochten', 'morgen', 'muss', 'musst', 'musste', 'mussten', 'muß', 'mußt', 'möchte', 'mögen', 'möglich', 'mögt', 'müssen', 'müsst', 'müßt', 'n', 'na', 'nach', 'nachdem', 'nahm', 'natürlich', 'neben', 'nein', 'neue', 'neuen', 'neun', 'neunte', 'neunten', 'neunter', 'neuntes', 'nicht', 'nichts', 'nie', 'niemand', 'niemandem', 'niemanden', 'noch', 'nun', 'nur', 'o', 'ob', 'oben', 'oder', 'offen', 'oft', 'ohne', 'ordnung', 'p', 'q', 'r', 'recht', 'rechte', 'rechten', 'rechter', 'rechtes', 'richtig', 'rund', 's', 'sa', 'sache', 'sagt', 'sagte', 'sah', 'satt', 'schlecht', 'schluss', 'schon', 'sechs', 'sechste', 'sechsten', 'sechster', 'sechstes', 'sehr', 'sei', 'seid', 'seien', 'sein', 'seine', 'seinem', 'seinen', 'seiner', 'seines', 'seit', 'seitdem', 'selbst', 'sich', 'sie', 'sieben', 'siebente', 'siebenten', 'siebenter', 'siebentes', 'sind', 'so', 'solang', 'solche', 'solchem', 'solchen', 'solcher', 'solches', 'soll', 'sollen', 'sollst', 'sollt', 'sollte', 'sollten', 'sondern', 'sonst', 'soweit', 'sowie', 'später', 'startseite', 'statt', 'steht', 'suche', 't', 'tag', 'tage', 'tagen', 'tat', 'teil', 'tel', 'tritt', 'trotzdem', 'tun', 'u', 'uhr', 'um', 'und', 'und?', 'uns', 'unse', 'unsem', 'unsen', 'unser', 'unsere', 'unserer', 'unses', 'unter', 'v', 'vergangenen', 'viel', 'viele', 'vielem', 'vielen', 'vielleicht', 'vier', 'vierte', 'vierten', 'vierter', 'viertes', 'vom', 'von', 'vor', 'w', 'wahr?', 'wann', 'war', 'waren', 'warst', 'wart', 'warum', 'was', 'weg', 'wegen', 'weil', 'weit', 'weiter', 'weitere', 'weiteren', 'weiteres', 'welche', 'welchem', 'welchen', 'welcher', 'welches', 'wem', 'wen', 'wenig', 'wenige', 'weniger', 'weniges', 'wenigstens', 'wenn', 'wer', 'werde', 'werden', 'werdet', 'weshalb', 'wessen', 'wie', 'wieder', 'wieso', 'will', 'willst', 'wir', 'wird', 'wirklich', 'wirst', 'wissen', 'wo', 'woher', 'wohin', 'wohl', 'wollen', 'wollt', 'wollte', 'wollten', 'worden', 'wurde', 'wurden', 'während', 'währenddem', 'währenddessen', 'wäre', 'würde', 'würden', 'x', 'y', 'z', 'z.b', 'zehn', 'zehnte', 'zehnten', 'zehnter', 'zehntes', 'zeit', 'zu', 'zuerst', 'zugleich', 'zum', 'zunächst', 'zur', 'zurück', 'zusammen', 'zwanzig', 'zwar', 'zwei', 'zweite', 'zweiten', 'zweiter', 'zweites', 'zwischen', 'zwölf', 'über', 'überhaupt', 'übrigens'
	]
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1618 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, David Przybilla, Chris Umbel
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'a', 'un', 'el', 'ella', 'y', 'sobre', 'de', 'la', 'que', 'en',
	  'los', 'del', 'se', 'las', 'por', 'un', 'para', 'con', 'no',
	  'una', 'su', 'al', 'lo', 'como', 'más', 'pero', 'sus', 'le',
	  'ya', 'o', 'porque', 'cuando', 'muy', 'sin', 'sobre', 'también',
	  'me', 'hasta', 'donde', 'quien', 'desde', 'nos', 'durante', 'uno',
	  'ni', 'contra', 'ese', 'eso', 'mí', 'qué', 'otro', 'él', 'cual',
	  'poco', 'mi', 'tú', 'te', 'ti', 'sí',
	  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1619 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, Chris Umbel
	Farsi Stop Words by Fardin Koochaki <me@fardinak.com>
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  // Words
	  'از', 'با', 'یه', 'برای', 'و', 'باید', 'شاید',
	
	  // Symbols
	  '؟', '!', '٪', '.', '،', '؛', ':', ';', ',',
	
	  // Numbers
	  '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'
	]
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1620 */
/***/ function(module, exports) {

	/*
	 Copyright (c) 2014, Ismaël Héry
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in
	 all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 THE SOFTWARE.
	 */
	
	// A list of commonly used french words that have little meaning and can be excluded
	// from analysis.
	
	var words = ['être', 'avoir', 'faire',
	  'a',
	  'au',
	  'aux',
	  'avec',
	  'ce',
	  'ces',
	  'dans',
	  'de',
	  'des',
	  'du',
	  'elle',
	  'en',
	  'et',
	  'eux',
	  'il',
	  'je',
	  'la',
	  'le',
	  'leur',
	  'lui',
	  'ma',
	  'mais',
	  'me',
	  'même',
	  'mes',
	  'moi',
	  'mon',
	  'ne',
	  'nos',
	  'notre',
	  'nous',
	  'on',
	  'ou',
	  'où',
	  'par',
	  'pas',
	  'pour',
	  'qu',
	  'que',
	  'qui',
	  'sa',
	  'se',
	  'ses',
	  'son',
	  'sur',
	  'ta',
	  'te',
	  'tes',
	  'toi',
	  'ton',
	  'tu',
	  'un',
	  'une',
	  'vos',
	  'votre',
	  'vous',
	  'c',
	  'd',
	  'j',
	  'l',
	  'à',
	  'm',
	  'n',
	  's',
	  't',
	  'y',
	  'été',
	  'étée',
	  'étées',
	  'étés',
	  'étant',
	  'suis',
	  'es',
	  'est',
	  'sommes',
	  'êtes',
	  'sont',
	  'serai',
	  'seras',
	  'sera',
	  'serons',
	  'serez',
	  'seront',
	  'serais',
	  'serait',
	  'serions',
	  'seriez',
	  'seraient',
	  'étais',
	  'était',
	  'étions',
	  'étiez',
	  'étaient',
	  'fus',
	  'fut',
	  'fûmes',
	  'fûtes',
	  'furent',
	  'sois',
	  'soit',
	  'soyons',
	  'soyez',
	  'soient',
	  'fusse',
	  'fusses',
	  'fût',
	  'fussions',
	  'fussiez',
	  'fussent',
	  'ayant',
	  'eu',
	  'eue',
	  'eues',
	  'eus',
	  'ai',
	  'as',
	  'avons',
	  'avez',
	  'ont',
	  'aurai',
	  'auras',
	  'aura',
	  'aurons',
	  'aurez',
	  'auront',
	  'aurais',
	  'aurait',
	  'aurions',
	  'auriez',
	  'auraient',
	  'avais',
	  'avait',
	  'avions',
	  'aviez',
	  'avaient',
	  'eut',
	  'eûmes',
	  'eûtes',
	  'eurent',
	  'aie',
	  'aies',
	  'ait',
	  'ayons',
	  'ayez',
	  'aient',
	  'eusse',
	  'eusses',
	  'eût',
	  'eussions',
	  'eussiez',
	  'eussent',
	  'ceci',
	  'cela',
	  'cet',
	  'cette',
	  'ici',
	  'ils',
	  'les',
	  'leurs',
	  'quel',
	  'quels',
	  'quelle',
	  'quelles',
	  'sans',
	  'soi'
	]
	
	exports.words = words


/***/ },
/* 1621 */
/***/ function(module, exports) {

	/*
	The MIT License (MIT)
	
	Copyright (c) 2016 Gene Diaz
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	
	Originates from: https://github.com/stopwords-iso/stopwords-hi/
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'अंदर','अत','अदि','अप','अपना','अपनि','अपनी','अपने','अभि','अभी','आदि','आप','इंहिं',
	  'इंहें','इंहों','इतयादि','इत्यादि','इन','इनका','इन्हीं','इन्हें','इन्हों','इस','इसका','इसकि',
	  'इसकी','इसके','इसमें','इसि','इसी','इसे','उंहिं','उंहें','उंहों','उन','उनका','उनकि','उनकी',
	  'उनके','उनको','उन्हीं','उन्हें','उन्हों','उस','उसके','उसि','उसी','उसे','एक','एवं','एस',
	  'एसे','ऐसे','ओर','और','कइ','कई','कर','करता','करते','करना','करने','करें','कहते',
	  'कहा','का','काफि','काफ़ी','कि','किंहें','किंहों','कितना','किन्हें','किन्हों','किया','किर','किस',
	  'किसि','किसी','किसे','की','कुछ','कुल','के','को','कोइ','कोई','कोन','कोनसा','कौन',
	  'कौनसा','गया','घर','जब','जहाँ','जहां','जा','जिंहें','जिंहों','जितना','जिधर','जिन','जिन्हें',
	  'जिन्हों','जिस','जिसे','जीधर','जेसा','जेसे','जैसा','जैसे','जो','तक','तब','तरह','तिंहें',
	  'तिंहों','तिन','तिन्हें','तिन्हों','तिस','तिसे','तो','था','थि','थी','थे','दबारा','दवारा','दिया',
	  'दुसरा','दुसरे','दूसरे','दो','द्वारा','न','नहिं','नहीं','ना','निचे','निहायत','नीचे','ने','पर',
	  'पहले','पुरा','पूरा','पे','फिर','बनि','बनी','बहि','बही','बहुत','बाद','बाला','बिलकुल',
	  'भि','भितर','भी','भीतर','मगर','मानो','मे','में','यदि','यह','यहाँ','यहां','यहि','यही',
	  'या','यिह','ये','रखें','रवासा','रहा','रहे','ऱ्वासा','लिए','लिये','लेकिन','व','वगेरह','वरग',
	  'वर्ग','वह','वहाँ','वहां','वहिं','वहीं','वाले','वुह','वे','वग़ैरह','संग','सकता','सकते','सबसे',
	  'सभि','सभी','साथ','साबुत','साभ','सारा','से','सो','हि','ही','हुअ','हुआ','हुइ','हुई',
	  'हुए','हे','हें','है','हैं','हो','होता','होति','होती','होते','होना','होने']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1622 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, David Przybilla, Chris Umbel
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'ad', 'al', 'allo', 'ai', 'agli', 'all', 'agl', 'alla', 'alle', 'con', 'col', 'coi', 'da', 'dal', 'dallo',
	  'dai', 'dagli', 'dall', 'dagl', 'dalla', 'dalle', 'di', 'del', 'dello', 'dei', 'degli', 'dell', 'degl',
	  'della', 'delle', 'in', 'nel', 'nello', 'nei', 'negli', 'nell', 'negl', 'nella', 'nelle', 'su', 'sul',
	  'sullo', 'sui', 'sugli', 'sull', 'sugl', 'sulla', 'sulle', 'per', 'tra', 'contro', 'io', 'tu', 'lui',
	  'lei', 'noi', 'voi', 'loro', 'mio', 'mia', 'miei', 'mie', 'tuo', 'tua', 'tuoi', 'tue', 'suo', 'sua', 'suoi',
	  'sue', 'nostro', 'nostra', 'nostri', 'nostre', 'vostro', 'vostra', 'vostri', 'vostre', 'mi', 'ti', 'ci',
	  'vi', 'lo', 'la', 'li', 'le', 'gli', 'ne', 'il', 'un', 'uno', 'una', 'ma', 'ed', 'se', 'perché', 'anche', 'come',
	  'dov', 'dove', 'che', 'chi', 'cui', 'non', 'più', 'quale', 'quanto', 'quanti', 'quanta', 'quante', 'quello',
	  'quelli', 'quella', 'quelle', 'questo', 'questi', 'questa', 'queste', 'si', 'tutto', 'tutti', 'a', 'c', 'e',
	  'i', 'l', 'o', 'ho', 'hai', 'ha', 'abbiamo', 'avete', 'hanno', 'abbia', 'abbiate', 'abbiano', 'avrò', 'avrai',
	  'avrà', 'avremo', 'avrete', 'avranno', 'avrei', 'avresti', 'avrebbe', 'avremmo', 'avreste', 'avrebbero',
	  'avevo', 'avevi', 'aveva', 'avevamo', 'avevate', 'avevano', 'ebbi', 'avesti', 'ebbe', 'avemmo', 'aveste',
	  'ebbero', 'avessi', 'avesse', 'avessimo', 'avessero', 'avendo', 'avuto', 'avuta', 'avuti', 'avute', 'sono',
	  'sei', 'è', 'siamo', 'siete', 'sia', 'siate', 'siano', 'sarò', 'sarai', 'sarà', 'saremo', 'sarete', 'saranno',
	  'sarei', 'saresti', 'sarebbe', 'saremmo', 'sareste', 'sarebbero', 'ero', 'eri', 'era', 'eravamo', 'eravate',
	  'erano', 'fui', 'fosti', 'fu', 'fummo', 'foste', 'furono', 'fossi', 'fosse', 'fossimo', 'fossero', 'essendo',
	  'faccio', 'fai', 'facciamo', 'fanno', 'faccia', 'facciate', 'facciano', 'farò', 'farai', 'farà', 'faremo',
	  'farete', 'faranno', 'farei', 'faresti', 'farebbe', 'faremmo', 'fareste', 'farebbero', 'facevo', 'facevi',
	  'faceva', 'facevamo', 'facevate', 'facevano', 'feci', 'facesti', 'fece', 'facemmo', 'faceste', 'fecero',
	  'facessi', 'facesse', 'facessimo', 'facessero', 'facendo', 'sto', 'stai', 'sta', 'stiamo', 'stanno', 'stia',
	  'stiate', 'stiano', 'starò', 'starai', 'starà', 'staremo', 'starete', 'staranno', 'starei', 'staresti',
	  'starebbe', 'staremmo', 'stareste', 'starebbero', 'stavo', 'stavi', 'stava', 'stavamo', 'stavate', 'stavano',
	  'stetti', 'stesti', 'stette', 'stemmo', 'steste', 'stettero', 'stessi', 'stesse', 'stessimo', 'stessero', 'stando',
	  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1623 */
/***/ function(module, exports) {

	// Original copyright:
	/*
	 Licensed to the Apache Software Foundation (ASF) under one or more
	 contributor license agreements.  See the NOTICE file distributed with
	 this work for additional information regarding copyright ownership.
	 The ASF licenses this file to You under the Apache License, Version 2.0
	 the "License"); you may not use this file except in compliance with
	 the License.  You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	
	// This version:
	/*
	Copyright (c) 2012, Guillaume Marty
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	// Original location:
	// http://svn.apache.org/repos/asf/lucene/dev/trunk/lucene/analysis/kuromoji/src/resources/org/apache/lucene/analysis/ja/stopwords.txt
	var words = ['の', 'に', 'は', 'を', 'た', 'が', 'で', 'て', 'と', 'し', 'れ', 'さ',
	  'ある', 'いる', 'も', 'する', 'から', 'な', 'こと', 'として', 'い', 'や', 'れる',
	  'など', 'なっ', 'ない', 'この', 'ため', 'その', 'あっ', 'よう', 'また', 'もの',
	  'という', 'あり', 'まで', 'られ', 'なる', 'へ', 'か', 'だ', 'これ', 'によって',
	  'により', 'おり', 'より', 'による', 'ず', 'なり', 'られる', 'において', 'ば', 'なかっ',
	  'なく', 'しかし', 'について', 'せ', 'だっ', 'その後', 'できる', 'それ', 'う', 'ので',
	  'なお', 'のみ', 'でき', 'き', 'つ', 'における', 'および', 'いう', 'さらに', 'でも',
	  'ら', 'たり', 'その他', 'に関する', 'たち', 'ます', 'ん', 'なら', 'に対して', '特に',
	  'せる', '及び', 'これら', 'とき', 'では', 'にて', 'ほか', 'ながら', 'うち', 'そして',
	  'とともに', 'ただし', 'かつて', 'それぞれ', 'または', 'お', 'ほど', 'ものの', 'に対する',
	  'ほとんど', 'と共に', 'といった', 'です', 'とも', 'ところ', 'ここ']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1624 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, Chris Umbel, Martijn de Boer, Damien van Holten
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	// This dutch wordlist has been parsed from a list created by Damien van Holten
	// source: http://www.damienvanholten.com/blog/dutch-stop-words/
	var words = [
	  'aan', 'af', 'al', 'alles', 'als', 'altijd', 'andere', 'ben', 'bij', 'daar',
	  'dan', 'dat', 'de', 'der', 'deze', 'die', 'dit', 'doch', 'doen', 'door', 'dus',
	  'een', 'eens', 'en', 'er', 'ge', 'geen', 'geweest', 'haar', 'had', 'heb',
	  'hebben', 'heeft', 'hem', 'het', 'hier', 'hij', 'hoe', 'hun', 'iemand', 'iets',
	  'ik', 'in', 'is', 'ja', 'je ', 'kan', 'kon', 'kunnen', 'maar', 'me', 'meer',
	  'men', 'met', 'mij', 'mijn', 'moet', 'na', 'naar', 'niet', 'niets', 'nog', 'nu',
	  'of', 'om', 'omdat', 'ons', 'ook', 'op', 'over', 'reeds', 'te', 'tegen', 'toch',
	  'toen', 'tot', 'u', 'uit', 'uw', 'van', 'veel', 'voor', 'want', 'waren', 'was',
	  'wat', 'we', 'wel', 'werd', 'wezen', 'wie', 'wij', 'wil', 'worden', 'zal', 'ze',
	  'zei', 'zelf', 'zich', 'zij', 'zijn', 'zo', 'zonder', 'zou',
	  'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
	  'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '$', '1',
	  '2', '3', '4', '5', '6', '7', '8', '9', '0', '_', '-']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1625 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Kristoffer Brabrand
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'og', 'i', 'jeg', 'det', 'at', 'en', 'et', 'den', 'til', 'er', 'som',
	  'på', 'de', 'med', 'han', 'av', 'ikke', 'der', 'så', 'var', 'meg',
	  'seg', 'men', 'ett', 'har', 'om', 'vi', 'min', 'mitt', 'ha', 'hadde',
	  'hun', 'nå', 'over', 'da', 'ved', 'fra', 'du', 'ut', 'sin', 'dem',
	  'oss', 'opp', 'man', 'kan', 'hans', 'hvor', 'eller', 'hva', 'skal',
	  'selv', 'sjøl', 'her', 'alle', 'vil', 'bli', 'ble', 'blitt', 'kunne',
	  'inn', 'når', 'kom', 'noen', 'noe', 'ville', 'dere', 'som',
	  'deres', 'kun', 'ja', 'etter', 'ned', 'skulle', 'denne', 'for', 'deg',
	  'si', 'sine', 'sitt', 'mot', 'å', 'meget', 'hvorfor', 'dette', 'disse',
	  'uten', 'hvordan', 'ingen', 'din', 'ditt', 'blir', 'samme', 'hvilken',
	  'hvilke', 'sånn', 'inni', 'mellom', 'vår', 'hver', 'hvem', 'vors',
	  'hvis', 'både', 'bare', 'enn', 'fordi', 'før', 'mange', 'også', 'slik',
	  'vært', 'være', 'begge', 'siden', 'henne', 'hennar', 'hennes',
	  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1626 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2013, Paweł Łaskarzewski
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	// list based on: http://pl.wikipedia.org/wiki/Wikipedia:Stopwords
	var words = [
	  'a', 'aby', 'ach', 'acz', 'aczkolwiek', 'aj', 'albo', 'ale', 'ależ', 'ani',
	  'aż', 'bardziej', 'bardzo', 'bo', 'bowiem', 'by', 'byli', 'bynajmniej',
	  'być', 'był', 'była', 'było', 'były', 'będzie', 'będą', 'cali', 'cała',
	  'cały', 'ci', 'cię', 'ciebie', 'co', 'cokolwiek', 'coś', 'czasami',
	  'czasem', 'czemu', 'czy', 'czyli', 'daleko', 'dla', 'dlaczego', 'dlatego',
	  'do', 'dobrze', 'dokąd', 'dość', 'dużo', 'dwa', 'dwaj', 'dwie', 'dwoje',
	  'dziś', 'dzisiaj', 'gdy', 'gdyby', 'gdyż', 'gdzie', 'gdziekolwiek',
	  'gdzieś', 'i', 'ich', 'ile', 'im', 'inna', 'inne', 'inny', 'innych', 'iż',
	  'ja', 'ją', 'jak', 'jakaś', 'jakby', 'jaki', 'jakichś', 'jakie', 'jakiś',
	  'jakiż', 'jakkolwiek', 'jako', 'jakoś', 'je', 'jeden', 'jedna', 'jedno',
	  'jednak', 'jednakże', 'jego', 'jej', 'jemu', 'jest', 'jestem', 'jeszcze',
	  'jeśli', 'jeżeli', 'już', 'ją', 'każdy', 'kiedy', 'kilka', 'kimś', 'kto',
	  'ktokolwiek', 'ktoś', 'która', 'które', 'którego', 'której', 'który',
	  'których', 'którym', 'którzy', 'ku', 'lat', 'lecz', 'lub', 'ma', 'mają',
	  'mało', 'mam', 'mi', 'mimo', 'między', 'mną', 'mnie', 'mogą', 'moi', 'moim',
	  'moja', 'moje', 'może', 'możliwe', 'można', 'mój', 'mu', 'musi', 'my', 'na',
	  'nad', 'nam', 'nami', 'nas', 'nasi', 'nasz', 'nasza', 'nasze', 'naszego',
	  'naszych', 'natomiast', 'natychmiast', 'nawet', 'nią', 'nic', 'nich', 'nie',
	  'niech', 'niego', 'niej', 'niemu', 'nigdy', 'nim', 'nimi', 'niż', 'no', 'o',
	  'obok', 'od', 'około', 'on', 'ona', 'one', 'oni', 'ono', 'oraz', 'oto',
	  'owszem', 'pan', 'pana', 'pani', 'po', 'pod', 'podczas', 'pomimo', 'ponad',
	  'ponieważ', 'powinien', 'powinna', 'powinni', 'powinno', 'poza', 'prawie',
	  'przecież', 'przed', 'przede', 'przedtem', 'przez', 'przy', 'roku',
	  'również', 'sam', 'sama', 'są', 'się', 'skąd', 'sobie', 'sobą', 'sposób',
	  'swoje', 'ta', 'tak', 'taka', 'taki', 'takie', 'także', 'tam', 'te', 'tego',
	  'tej', 'temu', 'ten', 'teraz', 'też', 'to', 'tobą', 'tobie', 'toteż',
	  'trzeba', 'tu', 'tutaj', 'twoi', 'twoim', 'twoja', 'twoje', 'twym', 'twój',
	  'ty', 'tych', 'tylko', 'tym', 'u', 'w', 'wam', 'wami', 'was', 'wasz', 'zaś',
	  'wasza', 'wasze', 'we', 'według', 'wiele', 'wielu', 'więc', 'więcej', 'tę',
	  'wszyscy', 'wszystkich', 'wszystkie', 'wszystkim', 'wszystko', 'wtedy',
	  'wy', 'właśnie', 'z', 'za', 'zapewne', 'zawsze', 'ze', 'zł', 'znowu',
	  'znów', 'został', 'żaden', 'żadna', 'żadne', 'żadnych', 'że', 'żeby',
	  '$', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1627 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, Luís Rodrigues
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'a',
	  'à',
	  'ao',
	  'aos',
	  'aquela',
	  'aquelas',
	  'aquele',
	  'aqueles',
	  'aquilo',
	  'as',
	  'às',
	  'até',
	  'com',
	  'como',
	  'da',
	  'das',
	  'de',
	  'dela',
	  'delas',
	  'dele',
	  'deles',
	  'depois',
	  'do',
	  'dos',
	  'e',
	  'ela',
	  'elas',
	  'ele',
	  'eles',
	  'em',
	  'entre',
	  'essa',
	  'essas',
	  'esse',
	  'esses',
	  'esta',
	  'estas',
	  'este',
	  'estes',
	  'eu',
	  'isso',
	  'isto',
	  'já',
	  'lhe',
	  'lhes',
	  'mais',
	  'mas',
	  'me',
	  'mesmo',
	  'meu',
	  'meus',
	  'minha',
	  'minhas',
	  'muito',
	  'muitos',
	  'na',
	  'não',
	  'nas',
	  'nem',
	  'no',
	  'nos',
	  'nós',
	  'nossa',
	  'nossas',
	  'nosso',
	  'nossos',
	  'num',
	  'nuns',
	  'numa',
	  'numas',
	  'o',
	  'os',
	  'ou',
	  'para',
	  'pela',
	  'pelas',
	  'pelo',
	  'pelos',
	  'por',
	  'quais',
	  'qual',
	  'quando',
	  'que',
	  'quem',
	  'se',
	  'sem',
	  'seu',
	  'seus',
	  'só',
	  'sua',
	  'suas',
	  'também',
	  'te',
	  'teu',
	  'teus',
	  'tu',
	  'tua',
	  'tuas',
	  'um',
	  'uma',
	  'umas',
	  'você',
	  'vocês',
	  'vos',
	  'vosso',
	  'vossos',
	  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_'
	]
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1628 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, Polyakov Vladimir, Chris Umbel
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'о', 'после', 'все', 'также', 'и', 'другие', 'все', 'как', 'во', 'быть',
	  'потому', 'был', 'до', 'являюсь', 'между', 'все', 'но', 'от', 'иди', 'могу',
	  'подойди', 'мог', 'делал', 'делаю', 'каждый', 'для', 'откуда', 'иметь', 'имел',
	  'он', 'имеет', 'её', 'здесь', 'его', 'как', 'если', 'в', 'оно', 'за',
	  'делать', 'много', 'я', 'может быть', 'более', 'самый', 'должен',
	  'мой', 'никогда', 'сейчас', 'из', 'на', 'только', 'или', 'другой', 'другая',
	  'другое', 'наше', 'вне', 'конец', 'сказал', 'сказала', 'также', 'видел', 'c',
	  'немного', 'все еще', 'так', 'затем', 'тот', 'их', 'там', 'этот', 'они', 'те',
	  'через', 'тоже', 'под', 'над', 'очень', 'был', 'путь', 'мы', 'хорошо',
	  'что', 'где', 'который', 'пока', 'кто', 'с кем', 'хотел бы', 'ты', 'твои',
	  'а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н',
	  'o', 'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ы', 'ь',
	  'э', 'ю', 'я', '$', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1629 */
/***/ function(module, exports) {

	/*
	Creative Commons – Attribution / ShareAlike 3.0 license
	http://creativecommons.org/licenses/by-sa/3.0/
	
	List based on frequently used words in subtitles in 2012.
	
	Thanks to
	opensubtitles.org
	https://invokeit.wordpress.com/frequency-word-lists/#comment-9707
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  'jag', 'det', 'är', 'du', 'inte', 'att', 'en', 'och', 'har', 'vi',
	  'på', 'i', 'för', 'han', 'vad', 'med', 'mig', 'som', 'här', 'om',
	  'dig', 'var', 'den', 'så', 'till', 'kan', 'de', 'ni', 'ska', 'ett',
	  'men', 'av', 'vill', 'nu', 'ja', 'nej', 'bara', 'hon', 'hur', 'min',
	  'där', 'honom', 'kom', 'din', 'då', 'när', 'ha', 'er', 'ta', 'ut',
	  'får', 'man', 'vara', 'oss', 'dem', 'eller', 'varför', 'alla', 'från', 'upp',
	  'igen', 'sa', 'hade', 'allt', 'in', 'sig', 'ingen', 'henne', 'vem', 'mitt',
	  'nåt', 'blir', 'än', 'bli', 'ju', 'två', 'tar', 'hans', 'ditt', 'mina',
	  'åt', 'väl', 'också', 'nån', 'låt', 'detta', 'va', 'dina', 'dom', 'blev',
	  'inga', 'sin', 'just', 'många', 'vart', 'vilken', 'ur', 'ens', 'sitt', 'e',
	  'jo', 'era', 'deras', 'fem', 'sex', 'denna', 'vilket', 'fyra', 'vårt', 'emot',
	  'tio', 'ert', 'sju', 'åtta', 'nånting', 'ned', 'ers', 'nio', 'mej',
	  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1630 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2011, David Przybilla, Chris Umbel
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	// a list of commonly used words that have little meaning and can be excluded
	// from analysis.
	var words = [
	  '的', '地', '得', '和', '跟',
	  '与', '及', '向', '并', '等',
	  '更', '已', '含', '做', '我',
	  '你', '他', '她', '们', '某',
	  '该', '各', '每', '这', '那',
	  '哪', '什', '么', '谁', '年',
	  '月', '日', '时', '分', '秒',
	  '几', '多', '来', '在', '就',
	  '又', '很', '呢', '吧', '吗',
	  '了', '嘛', '哇', '儿', '哼',
	  '啊', '嗯', '是', '着', '都',
	  '不', '说', '也', '看', '把',
	  '还', '个', '有', '小', '到',
	  '一', '为', '中', '于', '对',
	  '会', '之', '第', '此', '或',
	  '共', '按', '请'
	]
	
	// tell the world about the noise words.
	exports.words = words


/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.12
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.12',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            var margedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    margedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    margedRegexes[i] = regexes[i];
	                }
	            }
	            return margedRegexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
	        },
	        trim : function (str) {
	          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function () {
	
	            var result, i = 0, j, k, p, q, matches, match, args = arguments;
	
	            // loop through all regexes maps
	            while (i < args.length && !matches) {
	
	                var regex = args[i],       // even sequence (0,2,4,..)
	                    props = args[i + 1];   // odd sequence (1,3,5,..)
	
	                // construct object barebones
	                if (typeof result === UNDEF_TYPE) {
	                    result = {};
	                    for (p in props) {
	                        if (props.hasOwnProperty(p)){
	                            q = props[p];
	                            if (typeof q === OBJ_TYPE) {
	                                result[q[0]] = undefined;
	                            } else {
	                                result[q] = undefined;
	                            }
	                        }
	                    }
	                }
	
	                // try matching uastring with regexes
	                j = k = 0;
	                while (j < regex.length && !matches) {
	                    matches = regex[j++].exec(this.getUA());
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        result[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        result[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                result[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            return result;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	            ], [NAME, VERSION], [
	
	            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
	            ], [[NAME, 'Opera Mini'], VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
	            ], [[NAME, 'WeChat'], VERSION], [
	
	            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [
	
	            /android.+samsungbrowser\/([\w\.]+)/i,
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            /(qqbrowser)[\/\s]?([\w\.]+)/i
	                                                                                // QQBrowser
	            ], [NAME, VERSION], [
	
	            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	            /juc.+(ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(hp).+(tablet)/i,                                                  // HP Tablet
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /(nexus\s6p)/i                                                      // Huawei Nexus 6P
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
	
	            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s6)/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /smart-tv.+(samsung)/i
	            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	
	            /android.+a000(1)\s+build/i                                         // OnePlus
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            /\s(tablet)[;\/]/i,                                                 // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL]
	
	            /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(R1001)/i                                                          // Oppo R1001
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /(X9006)/i                                                          // Oppo Find 7a
	            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R2001)/i                                                          // Oppo YOYO R2001
	            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R815)/i                                                           // Oppo Clover R815
	            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	             /(U707)/i                                                          // Oppo Find Way S
	            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(haiku)\s(\w+)/i                                                  // Haiku
	            ], [NAME, VERSION],[
	
	            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
	            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	
	    var UAParser = function (uastring, extensions) {
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var browser = mapper.rgx.apply(this, rgxmap.browser);
	            browser.major = util.major(browser.version);
	            return browser;
	        };
	        this.getCPU = function () {
	            return mapper.rgx.apply(this, rgxmap.cpu);
	        };
	        this.getDevice = function () {
	            return mapper.rgx.apply(this, rgxmap.device);
	        };
	        this.getEngine = function () {
	            return mapper.rgx.apply(this, rgxmap.engine);
	        };
	        this.getOS = function () {
	            return mapper.rgx.apply(this, rgxmap.os);
	        };
	        this.getResult = function() {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(767)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window.jQuery || window.Zepto;
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function() {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 1632 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(__webpack_module_template_argument_0__);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(__webpack_module_template_argument_0__);
	
	var emptyObject = __webpack_require__(__webpack_module_template_argument_1__);
	var _invariant = __webpack_require__(__webpack_module_template_argument_2__);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(63)(module)))

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.9913776d.js